/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://x0.ifengimg.com/fe/live/mobilevideo/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = __webpack_require__(1);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _slicedToArray2 = __webpack_require__(68);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _stringify = __webpack_require__(77);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(79);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _fComponent = __webpack_require__(103);
	
	var _fComponent2 = _interopRequireDefault(_fComponent);
	
	var _fComponentGift = __webpack_require__(110);
	
	var _fComponentGift2 = _interopRequireDefault(_fComponentGift);
	
	var _fCompenontDianzan = __webpack_require__(186);
	
	var _fCompenontDianzan2 = _interopRequireDefault(_fCompenontDianzan);
	
	var _shoppingCart = __webpack_require__(390);
	
	var _shoppingCart2 = _interopRequireDefault(_shoppingCart);
	
	var _fComponentPagelist = __webpack_require__(395);
	
	var _fComponentPagelist2 = _interopRequireDefault(_fComponentPagelist);
	
	var _fCompenontTab = __webpack_require__(501);
	
	var _fCompenontTab2 = _interopRequireDefault(_fCompenontTab);
	
	var _onlypic = __webpack_require__(507);
	
	var _onlypic2 = _interopRequireDefault(_onlypic);
	
	var _noVideo = __webpack_require__(514);
	
	var _noVideo2 = _interopRequireDefault(_noVideo);
	
	var _notice = __webpack_require__(521);
	
	var _notice2 = _interopRequireDefault(_notice);
	
	var _fComponentAd = __webpack_require__(526);
	
	var _fComponentAd2 = _interopRequireDefault(_fComponentAd);
	
	var _adMoney = __webpack_require__(545);
	
	var _adMoney2 = _interopRequireDefault(_adMoney);
	
	var _adTop = __webpack_require__(551);
	
	var _adTop2 = _interopRequireDefault(_adTop);
	
	var _addCoinTip = __webpack_require__(556);
	
	var _addCoinTip2 = _interopRequireDefault(_addCoinTip);
	
	var _fComponent3 = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by dreamc_t on 2017/4/25.
	 */
	__webpack_require__(561);
	__webpack_require__(568);
	// 加入宽屏适配样式
	__webpack_require__(575);
	
	var LiveVideo = __webpack_require__(432).liveVideo;
	var RecodeVideo = __webpack_require__(432).recodeVideo;
	var ChartList = __webpack_require__(577).ChartList;
	var DataCenter = __webpack_require__(577).DataCenter;
	var Input = __webpack_require__(577).Input;
	var Message = __webpack_require__(604);
	var ScrollView = __webpack_require__(577).ScrollView;
	var Info = __webpack_require__(608);
	var MiniInput = __webpack_require__(613);
	var Util = __webpack_require__(404);
	var weixinShare = __webpack_require__(630);
	var copy = __webpack_require__(631);
	
	
	var Related = __webpack_require__(633);
	var EventData = __webpack_require__(640);
	var SportMatch = __webpack_require__(651);
	
	var pull = __webpack_require__(668).pull;
	var callNewsAPP = __webpack_require__(668).callNewsAPP;
	
	var Event = __webpack_require__(104);
	var eventCenter = new Event();
	
	var userType = 'spectator';
	var userStatus = 1; // 0是实名，1是未实名
	var userAvatar = '';
	var userName = '';
	
	var ua = navigator.userAgent;
	var weixin = ua.match(/MicroMessenger/gi);
	var qq = ua.match(/QQ\/([\d\.]+)/);
	var qz = ua.indexOf('Qzone/') !== -1;
	var c_from_app = '';
	
	window.adVideoIsEnd = false; // 广告未结束
	var isIos = navigator.userAgent.match(/iphone|ipod/gi);
	// 检测页面激活，仅针对iOS
	var testActive = function testActive() {
	    if (isIos) {
	        var tt = setInterval(function () {
	            if (!document.hidden) {
	                // 跳转后回来了
	                eventCenter.trigger('page_active');
	                clearInterval(tt);
	            }
	        }, 1000);
	    }
	};
	
	// 检测触发active事件时，iOS是否真的被激活
	var testOnActive = function testOnActive() {
	    if (isIos) {
	        if (!document.hidden) {
	            eventCenter.trigger('page_active');
	        } else {
	            return false;
	        }
	    } else {
	        eventCenter.trigger('page_active');
	    }
	};
	
	var createAd = function createAd(uid, ztname, hasVideo) {
	    // debugger;
	    _promise2.default.resolve($.ajax({
	        url: adParams.adUrl,
	        type: 'get',
	        dataType: 'json',
	        data: {
	            ztname: ztname,
	            uid: uid
	        },
	        context: this
	    })).then(function (data) {
	        var adVideo = null;
	        var adMoney = null;
	        var adTop = null;
	        // debugger;
	        if (hasVideo) {
	            // 如果页面有前贴片广告
	            if (!data[0].adPositionId) {
	                adVideoIsEnd = true;
	            }
	            adVideo = new _fComponentAd2.default(data);
	        } else {
	            adVideoIsEnd = true;
	        }
	        if (data[3].adPositionId) {
	            adTop = new _adTop2.default(data[3], adParams.topCount);
	        }
	
	        if (data[4].adPositionId) {
	            adMoney = new _adMoney2.default(data[4], adParams.moneyShowCount, adParams.moneyHideCount);
	        }
	
	        return {
	            adVideo: adVideo,
	            adMoney: adMoney,
	            adTop: adTop
	        };
	    }).then(function (_ref) {
	        var adVideo = _ref.adVideo,
	            adMoney = _ref.adMoney,
	            adTop = _ref.adTop;
	
	        if (hasVideo && adVideo) {
	            // 如果有前贴片广告
	            // debugger
	
	            // '#adinfo#ainfo=10018600:100186003610:piclive_104314$first=yes'
	            adVideo.on('adinfo', function (_ref2) {
	                var ainfo = _ref2.ainfo;
	
	                // debugger;
	                var sessionString = '#adinfo#ainfo=' + ainfo + ':piclive_' + __urlParams.liveid + '$first=yes';
	                _fComponent2.default.stat && _fComponent2.default.stat(sessionString, true);
	            });
	
	            // '#adclick#loc=10018600$id=100186003610$ch=piclive_104314'
	            adVideo.on('adclick', function (_ref3) {
	                var loc = _ref3.loc,
	                    id = _ref3.id;
	
	                // debugger;
	                var sessionString = '#adclick#loc=' + loc + '$id=' + id + '$ch=piclive_' + __urlParams.liveid;
	                console.log(sessionString);
	                _fComponent2.default.stat && _fComponent2.default.stat(sessionString, true);
	            });
	            // 前贴片广告跳转
	            adVideo.on('href_ad', function (url) {
	                url && openUrl(url);
	            });
	            // 角标广告跳转
	            adVideo.on('href_c', function (url) {
	                url && eventCenter.trigger('video_pause');
	                url && openUrl(url);
	            });
	            // 暂停广告跳转
	            adVideo.on('href_p', function (url) {
	                url && openUrl(url);
	            });
	            // 前贴片广告结束
	            adVideo.on('ended', function () {
	                // debugger;
	                if (adVideo.can === 'yes') {
	                    adVideo.destory();
	                }
	
	                eventCenter.trigger('adEnd');
	            });
	
	            // 广告暂停后点击广告外内容触发
	            adVideo.on('afterAdPause', function () {
	                adVideo.pauseHide();
	                eventCenter.trigger('afterAdPause');
	            });
	            // 显示暂停广告
	            eventCenter.on('pauseAd', function () {
	                // debugger
	                if (adVideoIsEnd) {
	                    adVideo.pauseShow();
	                }
	            });
	
	            eventCenter.on('cornerAd', function () {
	                adVideo.cornerShow();
	            });
	            // 前贴片广告开始播放，清掉定时器
	            adVideo.on('ad_video_start', function () {
	                adVideo.clearTimer();
	            });
	
	            adVideo.on('exit', function () {
	                _fComponent2.default.close && _fComponent2.default.close();
	            });
	
	            // 页面被激活后继续播放前贴片广告
	            eventCenter.on('page_active', function () {
	                // debugger
	                if (!adVideoIsEnd) {
	                    if (!adVideo.start_play) {
	                        // 如果广告未开始播放
	                        adVideo.setTimer(); // 继续开启5S定时器
	                    } else {
	                        _fComponent2.default.playVideo(adVideo, adVideo.playIndex);
	                    }
	                }
	                if (adMoney) {
	                    if (!adMoney.hasShow) {
	                        // 如果未出现
	                        adMoney.showCountDown(); // 红包广告继续出现时的倒计时
	                    } else if (!adMoney.hasHide) {
	                        // 如果未隐藏
	                        adMoney.hideCountDown(); // 红包广告继续隐藏时的倒计时
	                    }
	                }
	            });
	
	            eventCenter.on('playAd', function () {
	                adVideo.pauseHide();
	            });
	
	            // 页面跳出后
	            eventCenter.on('page_exit', function () {
	                if (!adVideoIsEnd) {
	                    // 前贴片未结束
	                    if (!adVideo.start_play && adVideo.adTimeout) {
	                        // 未开始播放，但已开始倒计时
	                        adVideo.clearTimer(); // 停止前贴片5秒倒计时
	                    }
	                    adVideo.pause();
	                }
	                if (adMoney) {
	                    if (adMoney.show_timer) {
	                        // 如果未出现
	                        // adMoney.clearShowCountDown();// 红包广告停止计时
	                    } else if (adMoney.hide_timer) {
	                        // 如果未隐藏
	                        // adMoney.clearHideCountDown();// 红包广告停止计时
	                    }
	                }
	            });
	
	            if (adVideoIsEnd) {
	                eventCenter.trigger('adEnd');
	            }
	
	            if (_fComponent2.default.isApp) {
	                _fComponent2.default.playVideo(adVideo);
	            } else {
	                adVideo.play();
	            }
	        }
	
	        var openUrl = function openUrl(url) {
	            if (hasVideo) {
	                // 如果有视频广告
	                // 如果视频广告未播完
	                if (!adVideoIsEnd) {
	                    if (!adVideo.cross3 && isIos) {
	                        // 如果播放未超过3秒就跳转，就先把播放时间设置为3S
	                        adVideo.skip(adVideo.playIndex);
	                    }
	
	                    adVideo.pause().then(function () {
	                        _fComponent2.default.openWeb(url, true);
	                        testActive();
	                    });
	                } else {
	                    // 视频广告已播完，要让正在播的视频暂停
	                    // eventCenter.trigger('video_pause');
	                    _fComponent2.default.openWeb(url, true);
	                    testActive();
	                }
	            } else {
	                _fComponent2.default.openWeb(url, true);
	                testActive();
	            }
	            eventCenter.trigger('page_exit'); // 提示iOS页面跳出
	        };
	
	        /* 点击顶通广告跳转*/
	        if (adTop) {
	            adTop.on('toggle', function () {
	                eventCenter.trigger('info_toggle');
	            });
	            adTop.on('top_ad', function (url) {
	                url && openUrl(url);
	            });
	
	            // '#adinfo#ainfo=10018600:100186003610:piclive_104314$first=yes'
	            adTop.on('adinfo', function (_ref4) {
	                var ainfo = _ref4.ainfo;
	
	                var sessionString = '#adinfo#ainfo=' + ainfo + ':piclive_' + __urlParams.liveid + '$first=yes';
	                _fComponent2.default.stat && _fComponent2.default.stat(sessionString, true);
	            });
	
	            // '#adclick#loc=10018600$id=100186003610$ch=piclive_104314'
	            adTop.on('adclick', function (_ref5) {
	                var loc = _ref5.loc,
	                    id = _ref5.id;
	
	                // debugger;
	                var sessionString = '#adclick#loc=' + loc + '$id=' + id + '$ch=piclive_' + __urlParams.liveid;
	                _fComponent2.default.stat && _fComponent2.default.stat(sessionString, true);
	            });
	
	            adTop.sendStatToApp();
	        }
	
	        /* 点击红包跳转*/
	        if (adMoney) {
	            adMoney.on('money_ad', function (url) {
	                url && openUrl(url);
	            });
	
	            // '#adinfo#ainfo=10018600:100186003610:piclive_104314$first=yes'
	            adMoney.on('adinfo', function (_ref6) {
	                var ainfo = _ref6.ainfo;
	
	                // debugger;
	                var sessionString = '#adinfo#ainfo=' + ainfo + ':piclive_' + __urlParams.liveid + '$first=yes';
	                _fComponent2.default.stat && _fComponent2.default.stat(sessionString, true);
	            });
	
	            // '#adclick#loc=10018600$id=100186003610$ch=piclive_104314'
	            adMoney.on('adclick', function (_ref7) {
	                var loc = _ref7.loc,
	                    id = _ref7.id;
	
	                // debugger;
	                var sessionString = '#adclick#loc=' + loc + '$id=' + id + '$ch=piclive_' + __urlParams.liveid;
	                _fComponent2.default.stat && _fComponent2.default.stat(sessionString, true);
	            });
	
	            adMoney.sendStatToApp();
	        }
	
	        function pull_login() {
	            if (hasVideo && !adVideoIsEnd) {
	                adVideo.pause().then(function () {
	                    grounds.userLogin();
	                    testActive();
	                });
	            } else {
	                grounds.userLogin();
	                testActive();
	            }
	
	            eventCenter.trigger('page_exit');
	        }
	
	        eventCenter.on('pull_login', function () {
	            pull_login();
	        });
	    }).catch(function (err) {
	        console.log('err:' + err);
	        eventCenter.trigger('adEnd'); // 广告资源请求失败，触发广告end
	        return false;
	    });
	};
	
	var createMessage = function createMessage(options) {
	    var message = new Message(options);
	
	    message.event.on('open', function () {
	        eventCenter.trigger('message_open');
	    });
	
	    message.event.on('close', function () {
	        eventCenter.trigger('message_close');
	    });
	
	    message.event.on('begin', function () {
	        eventCenter.trigger('message_begin');
	    });
	
	    message.event.on('onerror500', function (e) {
	        $.ajax({
	            url: 'https://data.zhibo.ifeng.com/508df9aec9e2a/data/zbj_count.js',
	            type: 'get',
	            dataType: 'jsonp',
	            cache: true,
	            jsonpCallback: 'onlineCallback'
	        }).done(function (res) {
	            if (res.code === 0) {
	                $('.c-visite .num').html(_formatCount(res.data[__urlParams.liveid] || 0));
	            }
	        });
	    });
	
	    eventCenter.on('dataCenter_send', function (data) {
	        message.getUser().then(function (msg) {
	            data.forEach(function (item) {
	                (0, _assign2.default)(item, {
	                    __type: 'danma',
	                    nickname: msg.nickname,
	                    avatar: msg.avatar
	                });
	            });
	            eventCenter.trigger('message_danma_preview', data);
	        });
	    });
	
	    eventCenter.on('page_destory', function () {
	        message.close(false);
	    });
	
	    eventCenter.on('page_active', function () {
	        message.trytoConnect();
	    });
	
	    return message;
	};
	
	var createNoVideo = function createNoVideo(info, isLive, native) {
	    var noVideo = new _noVideo2.default(info, isLive, native);
	
	    return noVideo;
	};
	
	var createOnlyInfo = function createOnlyInfo(info, message, native) {
	    var onlyInfo = new _onlypic2.default(info, message, native);
	    return onlyInfo;
	};
	
	var createNotice = function createNotice(info, native, liveid) {
	    var notice = new _notice2.default(info, native, liveid);
	    return notice;
	};
	
	var createInfo = function createInfo(info, message, noCount, native) {
	    var info = new Info(info, message, noCount, native);
	    if (noCount) {} else {}
	    info.on('toggle', function () {
	        eventCenter.trigger('info_toggle');
	    });
	    info.on('login', function () {
	        if (adVideoIsEnd) {
	            // 广告已结束
	            eventCenter.trigger('pull_login_noAds');
	        } else {
	            eventCenter.trigger('pull_login');
	        }
	    });
	
	    return info;
	};
	
	/*
	免流处理
	    正常地址
	    原访问域名：https://vics.ifeng.com
	    订购用户所访问的域名：https://ifvcisifengproxy.iread.wo.com.cn
	    防盗链地址
	    http://ips.ifeng.com/video19.ifeng.com/video09/
	    http://ifipsifengproxy.iread.wo.com.cn/ifvideo19ifengproxy.iread.wo.com.cn
	*/
	var replaceRes = function replaceRes(url) {
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cucc';
	
	    if (!url) {
	        return;
	    }
	    // url = 'http://zb.ios.ifeng.com/live/0tkdfRNK0_G/index.m3u8';
	    // url = url.replace(/^(http|https):/, '');
	    var temp = url.split('/');
	    // 目前以下两个域名不支持https
	    if (!(temp[2] === 'ksvod.live.ifeng.com' || temp[2] === 'vod-ali.ifeng.com')) {
	        temp[0] = '';
	    }
	
	    // 区分电信或者联通免流
	    // 联通免流
	    if (type === 'cucc') {
	        temp[2] = 'if' + temp[2].replace(/(\.com|\.cn)$/, '').replace(/(\.|-)/g, '') + 'proxy.iread.wo.com.cn';
	    }
	    // 电信免流
	    if (type === 'ctcc') {
	        temp[2] = 'if' + temp[2].replace(/(\.com|\.cn)$/, '').replace(/(\.|-)/g, '') + 'proxy.pt10.cn';
	    }
	
	    // 防盗链，两层替换
	    if (url.indexOf('ips.ifeng.com') > -1) {
	        temp[3] = 'if' + temp[3].replace(/(\.com|\.cn)$/, '').replace(/(\.|-)/g, '') + 'proxy.iread.wo.com.cn';
	    }
	    return temp.join('/');
	};
	var freeFlowHandle = function freeFlowHandle(list) {
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cucc';
	
	    for (var i = 0; i < list.length; i++) {
	        var item = list[i];
	        if (item.mp4) {
	            item.mp4 = replaceRes(item.mp4, type);
	        }
	        if (item.m3u8) {
	            item.m3u8 = replaceRes(item.m3u8, type);
	        }
	    }
	    return list;
	};
	
	// 创建一个视频播放器（直播或者回看）
	var createVideo = function createVideo(config, clientOptions) {
	    var _this2 = this;
	
	    var options = config.compenonts.video;
	    var info = config.info;
	    var list = options.list;
	    if (clientOptions.isFree + '' === 'true' || clientOptions.isFree + '' === 'true_cucc') {
	        list = freeFlowHandle(options.list, 'cucc');
	    }
	    if (clientOptions.isFree + '' === 'true_ctcc') {
	        list = freeFlowHandle(options.list, 'ctcc');
	    }
	    if (list.length === 0) {
	        return;
	    }
	    list[0].isSelected = true;
	    var video = list[0];
	    var autoplay = false;
	
	    if (clientOptions.isWifi && clientOptions.isApp) {
	        autoplay = true;
	    }
	
	    if (!options) {
	        return null;
	    }
	
	    var c_video = void 0;
	
	    if (options.isLive) {
	        c_video = new LiveVideo({
	            title: info.title,
	            src: video.m3u8,
	            poster: video.poster,
	            start_time: info.start_date,
	            start_date: info.start_date,
	            end_date: info.end_date,
	            list: list,
	            channelName: info.channelName,
	            channelIcon: info.channelIcon,
	            autoplay: autoplay
	        });
	    } else {
	        c_video = new RecodeVideo({
	            title: info.title,
	            channelName: info.channelName,
	            channelIcon: info.channelIcon,
	            autoplay: autoplay,
	            start_time: info.start_date,
	            start_date: info.start_date,
	            end_date: info.end_date,
	            list: list,
	            src: video.mp4 + '?' + (0, _fComponent3.AntiTheft)({
	                videoinfo: video,
	                gid: (0, _fComponent3.createUid)(),
	                version: 'vHTML5Player_v2.0.0'
	            })
	        });
	    }
	
	    if (_fComponent2.default.isApp) {
	        // debugger;
	        if (!adVideoIsEnd) {
	            c_video.hide();
	        } else {
	            // debugger;
	            // c_video.show();
	            // c_video.load();
	            // c_video.play();
	        }
	    }
	
	    if (!options.isLive) {
	        var rangeMax = -1;
	        // 如果是回看视频，则需要定义timeupdate事件来获取点播视频的弹幕数据进行显示。
	        c_video.on('timeupdate', function (offset) {
	            offset = Math.floor(offset);
	            // todo 做一个当前加载过最大弹幕数。
	            if (rangeMax < offset) {
	                // 通知当前播放的最大时长
	                eventCenter.trigger('video_timeupdate_rage', rangeMax, offset);
	            }
	
	            // 通知当前的播放时刻
	            eventCenter.trigger('video_timeupdate', offset);
	
	            // 记录下来获取数据的最大秒数。
	            if (rangeMax < offset) {
	                rangeMax = offset;
	            }
	        });
	        c_video.on('hideCount', function () {
	            c_video.cutdown.hide();
	        });
	        c_video.on('switchBarrage', function (id) {
	            // 通知当前视频播放模式切换
	            eventCenter.trigger('video_switchBarrage', id);
	        });
	    }
	
	    c_video.on('shrinkOpen', function () {
	        eventCenter.trigger('shrink', { direct: 'up' });
	    });
	
	    // 如果不是直播，也不是点播，并且还没到直播时间，才显示倒计时
	    var nowTime = new Date().valueOf();
	
	    if (info.start_date > nowTime) {
	        // if (Native.isApp) {
	        //     Native.playVideo(c_video);
	        // } else {
	        //     c_video.play();
	        // }
	        c_video.cutdown.show();
	        c_video.cutdown.begin();
	    } else {
	        if (_fComponent2.default.isApp) {
	            _fComponent2.default.playVideo(c_video);
	        } else {
	            c_video.play();
	        }
	    }
	
	    c_video.on('controlShow', function () {
	        var dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
	        if (Math.abs(dge) === 90) {
	            // 通知控制条显示
	            eventCenter.trigger('video_controlShow');
	        }
	    });
	
	    c_video.on('controlHide', function () {
	        var dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
	        if (Math.abs(dge) === 90) {
	            // 通知控制条隐藏
	            eventCenter.trigger('video_controlHide');
	        }
	    });
	
	    c_video.on('zoom', function (state) {
	        if (state === 'zoomout') {
	            if (_fComponent2.default.isApp) {
	                _fComponent2.default.rotate(1);
	            } else {
	                alert('请解除“屏幕旋转”锁定，横屏观看');
	            }
	        } else {
	            if (_fComponent2.default.isApp) {
	                _fComponent2.default.rotate(0);
	            } else {
	                alert('请将手机竖置');
	            }
	        }
	    });
	
	    eventCenter.on('afterAdPause', function () {
	        c_video.afterAdPause();
	    });
	
	    eventCenter.on('spread', function () {
	        // debugger
	        c_video.spread();
	    });
	
	    eventCenter.on('fold', function () {
	        c_video.fold();
	    });
	
	    c_video.on('exit', function () {
	        // 是否为横屏状态
	        var zoomState = $(document.body).hasClass('horizontal');
	        if (_this2.clientOptions.isApp) {
	            if (!zoomState) {
	                _fComponent2.default.exitMaximization();
	                _fComponent2.default.close();
	            } else {
	                _fComponent2.default.rotate(0);
	            }
	        } else {
	            if (!zoomState) {
	                window.location.href = '//izhibo.ifeng.com/home.html';
	            } else {
	                alert('请将手机竖置');
	            }
	        }
	    });
	
	    c_video.on('cutdownEnd', function () {
	        if (_fComponent2.default.isApp) {
	            _fComponent2.default.playVideo(c_video);
	        } else {
	            c_video.play();
	        }
	    });
	
	    // 显示暂停广告
	    c_video.on('pauseAd', function () {
	        eventCenter.trigger('pauseAd');
	    });
	
	    c_video.on('error', function (msg) {
	        var _video = c_video.core.el;
	        var _error = _video.error || {};
	        console.log('msg================>' + (0, _stringify2.default)(_error));
	        // if (window.__catchErrorMessage && typeof window.__catchErrorMessage == 'function') {
	        //     window.__catchErrorMessage('zhibo_video_error', {
	        //         code: _error.code || -1,
	        //         message: _error.message || ''
	        //     });
	        // }
	    });
	
	    // 隐藏暂停广告
	    c_video.on('playAd', function () {
	        eventCenter.trigger('playAd');
	    });
	
	    // 页面跳出后
	    eventCenter.on('page_exit', function () {
	        if (adVideoIsEnd) {
	            // 无前贴片
	            c_video.pause();
	            eventCenter.trigger('pauseAd');
	        }
	    });
	
	    // 页面跳转后视频暂停
	    eventCenter.on('video_pause', function () {
	        c_video.pause();
	        eventCenter.trigger('pauseAd');
	    });
	
	    eventCenter.on('page_active', function () {
	        if (options.isLive && adVideoIsEnd) {
	            setTimeout(function () {
	                c_video.load();
	                c_video.play();
	            }, 1000);
	        }
	    });
	
	    eventCenter.on('adEnd', function () {
	        // debugger
	        c_video.show();
	        c_video.load();
	        c_video.play();
	        adVideoIsEnd = true; // 广告已结束
	        eventCenter.trigger('cornerAd');
	    });
	
	    var isFirst = true;
	    eventCenter.on('networkchange', function (msg) {
	        if (msg === 'none') {
	            c_video.network.show('offnet');
	        } else if (isFirst && msg !== 'wifi') {
	            isFirst = false;
	            adVideoIsEnd = true;
	            c_video.pause();
	            if (grounds && grounds.getDeviceInfo().getProid() === 'videoapp') {
	                c_video.network.show('notWifi_videoapp');
	            } else {
	                c_video.network.show('');
	            }
	        } else {
	            c_video.network.hide();
	        }
	    });
	
	    eventCenter.on('freeflow', function (msg) {
	        var url_origin = options.isLive ? options.list[0].m3u8 : options.list[0].mp4;
	        if (c_video) {
	            var url_cur = c_video.getAttribute('src');
	            // alert('url_cur--url_origin-' + url_cur + '---' + url_origin)
	            if (msg + '' === 'true' || msg + '' === 'true_cucc') {
	                // 免流，如已是,则不做处理
	                if (url_cur === url_origin) {
	                    url_cur = replaceRes(url_origin, 'cucc');
	                }
	                // alert('true--url_cur-' + url_cur)
	            } else if (msg + '' === 'true_ctcc') {
	                // 免流，如已是,则不做处理
	                if (url_cur === url_origin) {
	                    url_cur = replaceRes(url_origin, 'ctcc');
	                }
	            } else {
	                // 不免流，如是免流，则回滚到原地址
	                if (url_cur !== url_origin) {
	                    url_cur = url_origin;
	                }
	                // alert('false-url_cur-' + url_cur)
	            }
	            c_video.setAttribute('src', url_cur);
	        }
	    });
	
	    return c_video;
	};
	
	// 创建一个弹幕数据中心（直播或者点播）
	var createDataCenter = function createDataCenter(config, message) {
	    var options = config.compenonts.video;
	    var barrage = config.compenonts.barrage;
	    var title = config.info.title;
	    if (options.list.length > 0) {
	        barrage.id = options.list[0].liveVideoId;
	    }
	
	    var dataCenter = void 0;
	
	    if (options.isLive || options.list.length === 0) {
	        dataCenter = new DataCenter.Live(__urlParams.liveid, message, title);
	    } else {
	        dataCenter = new DataCenter.Playback(barrage, message, title);
	    }
	
	    // 如果是直播，在获取到数据的时候，将数据插入的弹幕列表和弹幕屏幕上
	    dataCenter.on('data', function (type, msg) {
	        msg = formatData(type, msg);
	        // 通知数据获取
	        eventCenter.trigger('dataCenter_data', msg);
	    });
	
	    if (options.isLive) {} else {
	        // 弹幕列表需要获取到播放到当前最大时间的数据。
	        dataCenter.on('dataMax', function (type, msg) {
	            msg = formatData(type, msg);
	            // 通知最大数据获取
	            eventCenter.trigger('dataCenter_dataMax', msg);
	        });
	    }
	
	    // 在发送完弹幕以后，将弹幕回显在弹幕和列表中。
	    dataCenter.on('send', function (data) {
	        eventCenter.trigger('dataCenter_send', data);
	    });
	
	    eventCenter.on('video_timeupdate_rage', function (rangeMax, offset) {
	        dataCenter.getRange(rangeMax, offset);
	    });
	
	    eventCenter.on('video_timeupdate', function (offset) {
	        // alert('video_timeupdate');
	        dataCenter.getData(offset);
	    });
	
	    eventCenter.on('video_switchBarrage', function (id) {
	        dataCenter.reqData(id);
	    });
	
	    eventCenter.on('input_message', function (data, offset) {
	        dataCenter.sendData(data, offset, 101);
	    });
	
	    eventCenter.on('atPerson', function (msg) {
	        dataCenter.sendData(msg, 0, 102);
	    });
	
	    eventCenter.on('message_begin', function () {});
	
	    eventCenter.on('message_open', function () {
	        eventCenter.trigger('dataCenter_data', [{
	            avatar: config.info.hosts[0].avatar,
	            __type: 'system',
	            content: '通讯连接成功'
	        }]);
	    });
	
	    eventCenter.on('message_close', function () {
	        eventCenter.trigger('dataCenter_data', [{
	            avatar: config.info.hosts[0].avatar,
	            __type: 'system',
	            content: '糟糕，连接丢失，正在努力恢复通讯...'
	        }]);
	    });
	
	    return dataCenter;
	};
	
	var createChartList = function createChartList() {
	    var chartList = new ChartList();
	    // console.log(chartList)
	    // chartList.on('atPerson', function(id){
	
	    //     // var nickname = '';
	    //     // var avatar = '';
	    //     // if (Native.isApp) {
	    //     //     nickname = Native.getUserInfo().getNickname() || '';
	    //     //     avatar = Native.getUserInfo().getUserImage() || '';
	    //     // }
	    //     // const data = {
	    //     //     size: 18,
	    //     //     color: '0Xffffff',
	    //     //     val: `${nickname}@${id}   `,
	    //     // };
	    //     // data.nickname = nickname;
	    //     // data.avatar = avatar;
	    //     const value = `@${id}  `;
	
	    //     // var offset = 0;
	
	    //     // if (typeof this.c_video !== 'undefined') {
	    //     //     // 这个地方跟video耦合了，不过现在还没想到其他办法解耦，先用条件语句处理一下。
	    //     //     offset = Math.round(this.c_video.getCurrentTime());
	    //     // }
	    //     // console.log('----------------this is @', data)
	
	    //     eventCenter.trigger('input_text', value)
	    //     // eventCenter.trigger('atPerson', data)
	    // })
	
	    eventCenter.on('info_toggle', function () {
	        chartList.resize();
	    });
	
	    eventCenter.on('dataCenter_data', function (msg) {
	        // console.log('notice---------', msg)
	        if (chartList.isStop) {
	            eventCenter.trigger('notice', 'chart');
	        }
	        chartList.add(msg);
	    });
	
	    eventCenter.on('video_switchBarrage', function () {
	        chartList.clear();
	    });
	
	    eventCenter.on('dataCenter_dataMax', function (msg) {
	        if (chartList.isStop) {
	            eventCenter.trigger('notice', 'chart');
	        }
	        chartList.add(msg);
	    });
	
	    eventCenter.on('message_danma_preview', function (data) {
	        chartList.add(data);
	    });
	
	    eventCenter.on('input_inputshow', function () {
	        chartList.stop();
	    });
	
	    eventCenter.on('input_inputhide', function () {
	        setTimeout(function () {
	            chartList.play();
	        }, 1000);
	    });
	
	    eventCenter.on('orientationchange_h', function () {
	        chartList.stop();
	        setTimeout(function () {
	            chartList.resize();
	        }, 1000);
	
	        // 避免某些安卓机型布局过慢导致第一个resize时机不正确
	        setTimeout(function () {
	            chartList.resize();
	        }, 3000);
	    });
	
	    eventCenter.on('changeTab', function (type) {
	        if (type !== 'chart') {
	            chartList.stop();
	        } else {
	            chartList.hideMore();
	            chartList.resize();
	            chartList.play();
	        }
	    });
	
	    eventCenter.on('orientationchange_v', function () {
	        chartList.hideMore();
	        setTimeout(function () {
	            chartList.resize();
	            chartList.play();
	        }, 1000);
	    });
	
	    eventCenter.on('fold', function () {
	        setTimeout(function () {
	            chartList.resize();
	        }, 500);
	    });
	
	    eventCenter.on('spread', function () {
	        setTimeout(function () {
	            chartList.resize();
	        }, 500);
	    });
	
	    return chartList;
	};
	
	var createInput = function createInput() {
	    var _this3 = this;
	
	    var input = new Input({});
	
	    input.on('message', function (data, commandid) {
	        var nickname = '';
	        var avatar = '';
	        if (_fComponent2.default.isApp) {
	            nickname = _fComponent2.default.getUserInfo().getNickname() || '';
	            avatar = _fComponent2.default.getUserInfo().getUserImage() || '';
	        }
	        data.nickname = nickname;
	        data.avatar = avatar;
	        var offset = 0;
	
	        if (typeof _this3.c_video !== 'undefined') {
	            // 这个地方跟video耦合了，不过现在还没想到其他办法解耦，先用条件语句处理一下。
	            offset = Math.round(_this3.c_video.getCurrentTime());
	        }
	
	        eventCenter.trigger('input_message', data, offset, commandid);
	        input.hide();
	    });
	
	    input.on('inputshow', function () {
	        $('.p-wrap').addClass('blur');
	        // 输入框显示通知
	        eventCenter.trigger('input_inputshow');
	    });
	
	    input.on('inputhide', function () {
	        $('.p-wrap').removeClass('blur');
	        // 输入框隐藏通知
	        eventCenter.trigger('input_inputhide');
	    });
	
	    input.on('text', function (value) {
	        // 通知输入框文字变化
	        eventCenter.trigger('input_text', value);
	    });
	
	    eventCenter.on('input_message_from_client', function (data) {
	        input.trigger('message', input.getMessageFromClient(data));
	    });
	
	    eventCenter.on('input_hide', function () {
	        input.hide();
	    });
	
	    eventCenter.on('input_show', function () {
	        input.show();
	    });
	
	    return input;
	};
	
	var createScrollView = function createScrollView() {
	    var scrollview = new ScrollView();
	
	    eventCenter.on('video_switchBarrage', function () {
	        scrollview.reset();
	        scrollview.hide();
	        scrollview.pause();
	    });
	
	    eventCenter.on('dataCenter_data', function (msg) {
	        scrollview.add(msg);
	    });
	
	    eventCenter.on('message_danma_preview', function (data) {
	        scrollview.add(data);
	    });
	
	    eventCenter.on('miniInput_unclear', function () {
	        scrollview.show();
	        scrollview.play();
	    });
	
	    eventCenter.on('miniInput_clear', function () {
	        scrollview.hide();
	        scrollview.pause();
	    });
	
	    eventCenter.on('orientationchange_h', function () {
	        scrollview.removeData(4);
	        scrollview.show();
	        scrollview.play();
	    });
	
	    eventCenter.on('orientationchange_v', function () {
	        scrollview.hide();
	        scrollview.pause();
	    });
	
	    return scrollview;
	};
	var getCollectSta = function getCollectSta() {
	    var _this = this;
	    /** 获取收藏状态
	      方法名:isCollected
	      参数:json:(可扩充的)
	            documentId:文章直播id（唯一标示）
	          callback(bool):
	                true:已收藏
	                false:未收藏
	      例如:
	        window.grounds.isCollected(JSON.stringify({'documentId':'sub_69472811'}),'isCollectedCallBack')
	      */
	    window.isCollectedCallBack = function (val) {
	        if (val) {
	            _this.c_miniInput.isCollected();
	        }
	    };
	    var configInfo = this.config.info;
	    if (this.clientOptions.isApp && typeof window.grounds.isCollected === 'function') {
	        window.grounds.isCollected((0, _stringify2.default)({
	            documentId: configInfo.liveid
	        }), 'isCollectedCallBack');
	    }
	};
	
	var formatUrl = function formatUrl(url) {
	    if (!url) return;
	
	    url = url.trim();
	
	    if (url.indexOf('http:') === 0) {
	        return url.replace('http:', 'https:');
	    } else if (url.indexOf('https:') === 0) {
	        return url.replace('https:', 'https:');
	    } else if (url.indexOf('/') === 0) {
	        return url.indexOf('//') === 0 ? 'https:' + url : 'https:/' + url;
	    } else {
	        return 'https://' + url;
	    }
	};
	
	var createCollect = function createCollect(sta) {
	    // console.log('collect_config--', this.config);
	    var _this = this;
	    window.collectCallBack = function (res) {
	        var tip = sta ? '收藏' : '取消收藏';
	        if (res = 'success') {
	            _this.c_miniInput.collect(sta);
	        } else {
	            alert(tip + '失败');
	        }
	    };
	    // collectCallBack('success')
	    var configInfo = this.config.info;
	    var link_url = window.location.href.indexOf('?') > -1 ? window.location.href + '&webkit=1' : window.location.href + '?webkit=1';
	    var collectThumb = formatUrl(configInfo.thumb);
	    var _params = {
	        documentId: configInfo.liveid,
	        title: configInfo.title,
	        thumbnail: collectThumb,
	        links: [{
	            type: 'web',
	            url: link_url
	        }]
	    };
	    if (this.clientOptions.isApp && typeof window.grounds.collect === 'function') {
	        window.grounds.collect((0, _stringify2.default)(_params), sta, 'collectCallBack');
	    }
	};
	
	var pullapp = function pullapp() {
	    if (c_from_app === 'videoapp') {
	        pull({
	            apiUrl: '//api.iclient.ifeng.com/wakeupiOS/video/ifengplayer?type=liveroom&id=' + __urlParams.liveid + '&kind=sf',
	            protocolUrl: 'ifengVideoPlayer://liveroom/' + __urlParams.liveid + '/sf',
	            downloadUrl: '//api.3g.ifeng.com/ifengvideo_tg12'
	        });
	    } else {
	        var deepLink = 'comifengnewsclient://call?remind=1&type=web&id=' + encodeURIComponent(window.location.href + '&webkit=1');
	        copy(deepLink);
	        callNewsAPP({
	            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042', // 应用宝地址
	            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641', // 广告下载地址
	            domainApi: 'https://api.iclient.ifeng.com/'
	        }, {
	            type: 'web', // 拉起类型
	            kind: 'share01', // 拉起统计
	            ref: encodeURIComponent(location.href + '&webkit=1'), // 端内地址
	            id: encodeURIComponent(location.href + '&webkit=1') // 端内地址
	        });
	    }
	};
	
	var createMiniInput = function createMiniInput() {
	    var _this4 = this;
	
	    var desc = '我要说两句';
	    if (__urlParams.liveid == '131498') {
	        desc = '发布网络述年评论';
	    }
	    var miniInput = new MiniInput({ desc: desc });
	    // 检测是否已收藏
	    miniInput.on('check_isCollected', function () {
	        getCollectSta.bind(_this4)();
	    });
	
	    // 当点击底部的聊天区域的时候，弹出输入弹幕的组件。
	    miniInput.on('click', function (e) {
	        if ($('body').hasClass('horizontal')) {
	            if (_fComponent2.default.isApp) {
	                _fComponent2.default.rotate(0);
	            }
	            $('body').addClass('vertical').removeClass('horizontal');
	            eventCenter.trigger('orientationchange_v');
	        }
	        _this4.showInput();
	    });
	
	    miniInput.on('clear', function () {
	        eventCenter.trigger('miniInput_clear');
	    });
	
	    miniInput.on('unclear', function () {
	        eventCenter.trigger('miniInput_unclear');
	    });
	
	    miniInput.on('gift', function () {
	        if (!_this4.clientOptions.isApp && !__urlParams.__debugger) {
	            var _val = '打开凤凰新闻，参与精彩互动';
	
	            if (_fComponent2.default.isApp) {
	                if (_fComponent2.default.getAppName() == 'videoapp') {
	                    _val = '打开凤凰视频，参与精彩互动';
	                }
	            }
	
	            if (confirm(_val)) {
	                pullapp();
	            }
	        } else {
	            eventCenter.trigger('miniInput_gift');
	        }
	    });
	    miniInput.on('collect', function (sta) {
	        if (!_this4.clientOptions.isApp && !__urlParams.__debugger) {
	            var _val = '打开凤凰新闻，参与精彩互动';
	
	            if (_fComponent2.default.isApp) {
	                if (_fComponent2.default.getAppName() === 'videoapp') {
	                    _val = '打开凤凰视频，参与精彩互动';
	                }
	            }
	
	            if (confirm(_val)) {
	                pullapp();
	            }
	        } else {
	            // 这里收藏是否需要登录还需跟产品沟通，暂时不加登录逻辑，跟客户端统一
	            // this.c_message
	            //     .getUser()
	            //     .then(msg => {
	            //             // debugger
	            //             if (msg.type == 'guest') {
	            //                 eventCenter.trigger('input_hide');
	            //                 if (this.clientOptions.isApp) {
	            //                     grounds.userLogin();
	            //                 } else {
	            //                     window.location.href =
	            //                         '//id.ifeng.com/muser/login?cb=' + encodeURIComponent(window.location.href.split('#')[0]);
	            //                 }
	            //             } else {
	            //                 createCollect.bind(this)(sta);
	            //             }
	            //         }
	            //     )
	            //     .catch(e => { console.log(e); })
	
	            createCollect.bind(_this4)(sta);
	        }
	    });
	    miniInput.on('exit', function () {
	        if (_this4.clientOptions.isApp) {
	            _fComponent2.default.exitMaximization();
	            _fComponent2.default.close();
	        } else {
	            window.location.href = '//izhibo.ifeng.com/home.html';
	        }
	    });
	    var headTitle = config.info.isPolitics ? '直播：' : '风直播：';
	    var shareimgUrl = config.info.sharepic;
	    if (__urlParams.liveid == '129626') {
	        shareimgUrl = 'http://x0.ifengimg.com/cmpp/2019/1001/9825bcffbc0ae0asize15_w74_h82.png';
	    }
	    miniInput.on('share', function () {
	        if (_fComponent2.default.isApp) {
	            _fComponent2.default.openShare(window.location.protocol + '//' + window.location.host + window.location.pathname + '?liveid=' + __urlParams.liveid + '&c_from_app=' + c_from_app, _this4.config.info.title, _this4.config.info.intro, shareimgUrl, __urlParams.liveid);
	        }
	    });
	
	    eventCenter.on('video_controlShow', function () {
	        miniInput.hide();
	    });
	
	    eventCenter.on('video_controlHide', function () {
	        miniInput.show();
	    });
	
	    eventCenter.on('input_inputshow', function () {
	        miniInput.hide();
	    });
	
	    eventCenter.on('input_inputhide', function () {
	        miniInput.show();
	    });
	
	    eventCenter.on('input_text', function (value) {
	        miniInput.text(value);
	    });
	
	    eventCenter.on('orientationchange_h', function (value) {
	        if (_this4.c_video && !_this4.c_video.control.isHide) {
	            miniInput.hide();
	        }
	        miniInput.unclear();
	    });
	
	    eventCenter.on('orientationchange_v', function (value) {
	        console.log('shu');
	        miniInput.show();
	    });
	
	    return miniInput;
	};
	
	var createZan = function createZan(dianzan_config) {
	    var _this5 = this;
	
	    var zan = new _fCompenontDianzan2.default(dianzan_config);
	
	    eventCenter.on('video_controlShow', function () {
	        zan.hide();
	    });
	
	    eventCenter.on('video_controlHide', function () {
	        zan.show();
	    });
	
	    eventCenter.on('input_inputshow', function () {
	        zan.hide();
	    });
	
	    eventCenter.on('input_inputhide', function () {
	        // 延迟出现点赞，避免闪烁。
	        setTimeout(function () {
	            zan.show();
	        }, 500);
	    });
	
	    eventCenter.on('orientationchange_h', function () {
	        if (_this5.c_video && !_this5.c_video.control.isHide) {
	            zan.hide();
	        }
	    });
	
	    eventCenter.on('orientationchange_v', function () {
	        zan.show();
	    });
	
	    return zan;
	};
	
	var createPresent = function createPresent(present_config) {
	    var present = new _fComponentGift2.default(present_config);
	
	    present.event.on('present-login', function () {
	        if (_fComponent2.default.isApp) {
	            if ($('body').hasClass('horizontal')) {
	                _fComponent2.default.rotate(0);
	                $('body').addClass('vertical').removeClass('horizontal');
	                eventCenter.trigger('orientationchange_v');
	            }
	            _fComponent2.default.userLogin();
	        } else {
	            window.location.href = '//id.ifeng.com/muser/login?cb=' + encodeURIComponent(window.location.href);
	        }
	    });
	    eventCenter.on('present-user-coin', function (value) {
	        present.updateCoin(value);
	    });
	    eventCenter.on('miniInput_gift', function () {
	        present.enter();
	    });
	
	    eventCenter.on('orientationchange_h', function () {
	        present.hide();
	        present.switchOrientation('horizontal');
	    });
	
	    eventCenter.on('orientationchange_v', function () {
	        present.hide();
	        present.switchOrientation('vertical');
	    });
	
	    return present;
	};
	
	var createLivepage = function createLivepage(datamodel, native) {
	    var livePage = new _fComponentPagelist2.default(datamodel, native);
	
	    eventCenter.on('changeTab', function (type) {
	        if (type !== 'livepage') {
	            livePage.pause(); // isnotice = true 开启提醒
	        }
	    });
	
	    livePage.on('newMessage', function () {
	        eventCenter.trigger('notice', 'livepage');
	    });
	
	    livePage.on('shrink', function (params) {
	        eventCenter.trigger('shrink', params);
	    });
	
	    return livePage;
	};
	var createSportMatch = function createSportMatch(config, message, container) {
	    return new SportMatch(config.info, message, container);
	};
	var createEventData = function createEventData(config) {
	    var _this6 = this;
	
	    eventCenter.on('changeTab', function (type) {
	        if (type !== 'eventData') {
	            // 取消定时
	            _this6.c_eventData && _this6.c_eventData.timerForEvent && _this6.c_eventData.endPolling(_this6.c_eventData.timerForEvent);
	        } else {
	            _this6.c_eventData.renderTo(document.querySelector('.c-slider__item--active'));
	        }
	    });
	    return new EventData(config.info);
	};
	var createRelated = function createRelated(config, native) {
	    var _this7 = this;
	
	    eventCenter.on('changeTab', function (type) {
	        if (type === 'related') {
	            _this7.relatedTimer = setInterval(function () {
	                if (document.getElementById('slider_related')) {
	                    _this7.c_related.renderTo(document.getElementById('slider_related'));
	                    clearInterval(_this7.relatedTimer);
	                }
	            }, 0);
	        }
	    });
	    return new Related(config, native);
	};
	
	var createTab = function createTab(pagelist, chart, eventData, related, isfold) {
	    var tab = new _fCompenontTab2.default();
	    if (pagelist) {
	        tab.add('图文直播', pagelist, 'livepage');
	    }
	    if (chart) {
	        tab.add('热聊', chart, 'chart');
	    }
	    if (eventData) {
	        tab.add('数据', null, 'eventData');
	    }
	    if (related) {
	        tab.add('相关', null, 'related');
	    }
	
	    if (isfold) {
	        tab.foldShow();
	    } else {
	        tab.foldHide();
	    }
	    tab.on('change', function (type) {
	        // 切换标签时通知其他组件开启提醒模式
	        eventCenter.trigger('changeTab', type);
	    });
	    eventCenter.on('notice', function (type) {
	        // 有新消息提醒时给对应标题添加标记
	        tab.notice(type);
	    });
	    eventCenter.on('shrink', function (params) {
	        // 收缩方向
	        var direct = params && params.direct || 'down';
	        console.log('tab direction: ' + direct);
	        if (direct === 'down') {
	            tab.trigger('shrink', direct);
	            eventCenter.trigger('fold');
	        } else {
	            var topDistance = params && params.topDistance || 0;
	            if (topDistance === 0) {
	                tab.trigger('shrink', direct);
	                eventCenter.trigger('spread');
	            }
	        }
	    });
	
	    if (pagelist || chart || related) {
	        tab.active(0);
	    }
	    // eventCenter.trigger('changeTab',0);
	
	    tab.on('fold', function () {
	        eventCenter.trigger('fold');
	    });
	
	    tab.on('spread', function () {
	        eventCenter.trigger('spread');
	    });
	
	    eventCenter.on('orientationchange_h', function () {
	        tab.spread();
	    });
	
	    return tab;
	};
	
	var Page = function Page(config, clientOptions) {
	    this.config = config;
	    this.clientOptions = clientOptions;
	    this.init();
	};
	
	Page.prototype.init = function () {
	    this.initState();
	    this.initCompenonts();
	    this.initEvent();
	    this.render();
	    this.afterRender();
	};
	
	Page.prototype.initState = function () {
	    var ua = navigator.userAgent;
	    var weixin = ua.match(/MicroMessenger/gi);
	    if (weixin) {
	        $('body').addClass('weixin');
	    }
	    // 夜间模式
	    if (_fComponent2.default.isApp) {
	        var checkMode = _fComponent2.default.getShowMode();
	        if (checkMode === 'night') {
	            $('body').addClass('skin-dark');
	            mode = 'night';
	        } else {
	            mode = 'day';
	        }
	    }
	};
	
	Page.prototype.initCompenonts = function () {
	    var _this8 = this;
	
	    if (_fComponent2.default.isApp) {
	        this.config.info.loginid = _fComponent2.default.getUserInfo().getGuid();
	        this.config.info.followid = 'zhibo_' + this.config.info.columnId;
	        this.config.info.token = _fComponent2.default.getUserInfo().getToken(); // 获取token
	    }
	    this.config.info.requestUrl = interfaceUrl.relatedUrl;
	    this.config.info.liveid = __urlParams.liveid;
	    this.config.info.followUrl = interfaceUrl.follow;
	    this.config.info.queryFollow = interfaceUrl.queryFollow;
	    this.config.info.mode = mode;
	    var config = this.config;
	    var clientOptions = this.clientOptions;
	    var nickname = '';
	    var avatar = '';
	    if (_fComponent2.default.isApp) {
	        nickname = _fComponent2.default.getUserInfo().getNickname() || '';
	        avatar = _fComponent2.default.getUserInfo().getUserImage() || '';
	    }
	    var url = __urlParams.ws || this.config.info.ws;
	    var praiseType = config.info && config.info.praiseType || '2';
	
	    this.c_message = createMessage.bind(this)({
	        url: url,
	        roomid: __urlParams.liveid,
	        source: 'live',
	        deviceid: this.clientOptions.deviceid,
	        version: '1.0.0',
	        app: 'h5',
	        nickname: nickname,
	        avatar: avatar,
	        praise_type: praiseType,
	        deviceid_real: this.clientOptions.deviceid_real,
	        os: this.clientOptions.os,
	        gv: this.clientOptions.gv,
	        proid: this.clientOptions.proid,
	        uid: this.clientOptions.deviceid,
	        token: this.clientOptions.token
	    });
	
	    window.message = this.c_message;
	
	    if (window.showShoppingCart) {
	        var c_cart = new _shoppingCart2.default($('body'), { url: window.shoppingUrl });
	        $('body').addClass('showShopCart');
	
	        eventCenter.on('video_controlShow', function () {
	            c_cart.hide();
	        });
	
	        eventCenter.on('video_controlHide', function () {
	            c_cart.show();
	        });
	
	        eventCenter.on('input_inputshow', function () {
	            c_cart.hide();
	        });
	
	        eventCenter.on('input_inputhide', function () {
	            // 延迟出现点赞，避免闪烁。
	            setTimeout(function () {
	                c_cart.show();
	            }, 500);
	        });
	
	        eventCenter.on('orientationchange_h', function () {
	            if (_this8.c_video && !_this8.c_video.control.isHide) {
	                c_cart.hide();
	            }
	        });
	
	        eventCenter.on('orientationchange_v', function () {
	            c_cart.show();
	        });
	    }
	
	    var changeDianZanMode = function changeDianZanMode(praiseType) {
	        if (praiseType === '1') {
	            $('body').removeClass('candleDianzan').removeClass('heartDianZan').removeClass('ratDianZan').addClass('noDianZan');
	        } else if (praiseType === '3') {
	            $('body').removeClass('candleDianzan').removeClass('heartDianZan').removeClass('ratDianZan').addClass('candleDianzan');
	        } else if (__urlParams.liveid == '131498') {
	            $('body').removeClass('candleDianzan').removeClass('heartDianZan').removeClass('ratDianZan').addClass('ratDianZan');
	        } else {
	            $('body').removeClass('candleDianzan').removeClass('heartDianZan').removeClass('ratDianZan').addClass('heartDianZan');
	        }
	    };
	
	    changeDianZanMode(praiseType);
	    window.changeDianZanMode = changeDianZanMode;
	    var dianzan_config = (0, _assign2.default)({}, config.compenonts.dianzan, {
	        message: this.c_message,
	        clientOptions: this.clientOptions
	    });
	    if (config && config.compenonts && config.compenonts.present.presentInfo && config.compenonts.present.presentInfo.length) {
	        var mapPresentId = {
	            1: 1,
	            2: 21,
	            3: 22,
	            4: 23,
	            21: 21,
	            22: 22,
	            23: 23
	        };
	        var mapPresentPrice = {
	            1: 1,
	            2: 2,
	            3: 3,
	            20: 1,
	            30: 2,
	            40: 3
	        };
	        var _presentInfo = [];
	        for (var i = 0; i < config.compenonts.present.presentInfo.length; i++) {
	            var item = config.compenonts.present.presentInfo[i];
	            _presentInfo.push(item);
	            _presentInfo[i].id = mapPresentId[item.id];
	            if (item.price) {
	                _presentInfo[i].price = mapPresentPrice[item.price];
	            }
	        }
	        config.compenonts.present.presentInfo = _presentInfo;
	    }
	    var present_config = (0, _assign2.default)({}, config.compenonts.present, {
	        message: this.c_message,
	        clientOptions: this.clientOptions
	    });
	
	    // let collect_config = Object.assign({}, { message: this.c_message });
	
	    this.c_dataCenter = createDataCenter.bind(this)(config, this.c_message);
	    if (config.info.isComment == 0) {
	        this.c_chartList = null;
	        this.c_scrollview = null;
	    } else {
	        this.c_chartList = createChartList.bind(this)();
	        this.c_scrollview = createScrollView.bind(this)();
	    }
	    this.c_miniInput = createMiniInput.bind(this)();
	    this.c_input = createInput.bind(this)();
	
	    if (praiseType !== '1') {
	        // 点赞类型不为1时，加载点赞组件
	        this.c_zan = createZan.bind(this)(dianzan_config);
	    }
	    this.c_present = createPresent.bind(this)(present_config);
	    if (_fComponent2.default.isApp && _fComponent2.default.getDeviceInfo().getProid() == 'videoapp') {
	        this.c_present = null;
	    }
	
	    // this.c_collect = createCollect.bind(this)(collect_config);
	
	    if (config.info.isMatch == 1) {
	        this.c_sportMatch = createSportMatch.bind(this)(config, this.c_message, document.querySelector('.l-notice'));
	        this.c_eventData = createEventData.bind(this)(config);
	    } else {
	        this.c_sportMatch = null;
	        this.c_eventData = null;
	    }
	    if (config.info.isRelated == 0) {
	        this.c_related = null;
	    } else {
	        this.c_related = createRelated.bind(this)(config, _fComponent2.default);
	    }
	    var start_date = config.info.start_date;
	
	    this.remainTime = Math.floor((new Date(start_date).valueOf() - new Date().valueOf()) / 1000);
	
	    if (this.remainTime > 0) {
	        this.c_notice = createNotice(config.info, _fComponent2.default, __urlParams.liveid);
	    }
	    // debugger;
	    if (config.info.hasPage && config.compenonts.video.list.length == 0) {
	        // 如果有图文直播没有视频直播
	        // debugger;
	        if (_fComponent2.default.isApp && status == 0) {
	            if (this.remainTime < 0) {
	                // 非预告状态
	                createAd.bind(this)(getUid(), __urlParams.liveid, false); // 顶通广告+红包广告， false表示无视频广告
	                adVideoIsEnd = true;
	            } else {
	                adVideoIsEnd = true; // 预告状态没有前贴片，直播里的视频保证能播
	            }
	        } else {
	            adVideoIsEnd = true; // 预告状态没有前贴片，直播里的视频保证能播
	        }
	        this.c_livepage = createLivepage.bind(this)(dataModel, _fComponent2.default);
	        this.c_tab = createTab.bind(this)(this.c_livepage, this.c_chartList, this.c_eventData, this.c_related, true);
	        this.c_noVideo = createNoVideo.bind(this)(config.info, config.compenonts.video.isLive, _fComponent2.default);
	    } else {
	        // 有视频直播
	        if (_fComponent2.default.isApp && status == 0) {
	            // debugger
	            // if (Native.isApp && status == 0) {
	            // if (Native.isApp && this.clientOptions.isWifi && status == 0) {
	            // debugger;
	            if (this.remainTime < 0) {
	                // 非预告状态
	                createAd.bind(this)(getUid(), __urlParams.liveid, true); // 顶通广告+红包广告， true表示有视频广告
	                adVideoIsEnd = false;
	            } else {
	                createAd.bind(this)(getUid(), __urlParams.liveid, false); // 顶通广告+红包广告， false表示无视频广告
	                adVideoIsEnd = true; // 预告状态没有前贴片，直播里的视频保证能播
	            }
	        } else {
	            adVideoIsEnd = true; // h5页没有前贴片，直播里的视频保证能播
	        }
	        this.c_video = createVideo.bind(this)(config, clientOptions);
	        this.c_onlyInfo = createOnlyInfo.bind(this)(config.info, this.c_message, _fComponent2.default);
	        if (config.info.hasPage) {
	            // 有图文直播
	            this.c_livepage = createLivepage.bind(this)(dataModel, _fComponent2.default);
	            this.c_tab = createTab.bind(this)(this.c_livepage, this.c_chartList, this.c_eventData, this.c_related);
	        } else {
	            // 没有图文直播
	            this.c_tab = createTab.bind(this)(null, this.c_chartList, this.c_eventData, this.c_related);
	        }
	    }
	    this.c_info = createInfo.bind(this)(config.info, this.c_message, config.compenonts.video.isLive, _fComponent2.default); // 非直播中时不显示参与人数
	};
	
	Page.prototype.initEvent = function () {
	    var self = this;
	
	    $('.js_openApp').on('touchend', function () {
	        pullapp();
	        return false;
	    });
	
	    $('.js_openAppClose').on('touchend', function () {
	        $('.bottom_app_container').fadeOut();
	        return false;
	    });
	
	    var changeScrollviewsState = function changeScrollviewsState() {
	        var dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
	        if (Math.abs(dge) === 90) {
	            $('body').addClass('horizontal').removeClass('vertical');
	            eventCenter.trigger('orientationchange_h');
	        } else {
	            $('body').addClass('vertical').removeClass('horizontal');
	            eventCenter.trigger('orientationchange_v');
	        }
	    };
	
	    changeScrollviewsState();
	    window.addEventListener('orientationchange', function () {
	        changeScrollviewsState();
	    });
	
	    //   $(window).on("resize", () => {
	    //     if (window.innerWidth > 550) {
	    //       document.body.classList.remove("wideScreen");
	    //       document.body.classList.add("wideScreen");
	    //     } else {
	    //       document.body.classList.remove("wideScreen");
	    //     }
	    //   });
	
	    _fComponent2.default.on('exit', function () {
	        eventCenter.trigger('page_exit');
	    });
	
	    _fComponent2.default.on('slip', function (state) {
	        if (state == 'out') {
	            self.c_video.pause();
	        } else if (state == 'in') {
	            // self.c_video.load();
	            self.c_video.play();
	        }
	    });
	
	    _fComponent2.default.on('active', function () {
	        if (typeof navigator.onLine !== 'undefined' && navigator.onLine === false) {
	            eventCenter.trigger('networkchange', 'none');
	        }
	        testOnActive();
	    });
	
	    _fComponent2.default.on('destory', function () {
	        eventCenter.trigger('page_destory');
	    });
	
	    eventCenter.on('fold', function () {
	        $('.l-video').addClass('shrinkin_anim');
	        $('.l-video').removeClass('shrinkout').addClass('shrinkin');
	        $('.l-onlyInfo').show();
	        $('.l-head').removeClass('large').addClass('small');
	        $('.l-info').hide();
	        setTimeout(function () {
	            $('.l-video').removeClass('shrinkin_anim');
	        }, 400);
	    });
	
	    eventCenter.on('spread', function () {
	        $('.l-video').addClass('shrinkin_anim');
	        $('.l-onlyInfo').hide();
	        $('.l-video').removeClass('shrinkin').addClass('shrinkout');
	        $('.l-head').removeClass('small').addClass('large');
	        $('.l-info').show();
	        setTimeout(function () {
	            $('.l-video').removeClass('shrinkin_anim');
	        }, 400);
	    });
	
	    _fComponent2.default.on('networkchange', function (msg) {
	        eventCenter.trigger('networkchange', msg);
	    });
	
	    _fComponent2.default.on('freeflow', function (msg) {
	        eventCenter.trigger('freeflow', msg);
	    });
	
	    $('.l-noVideo').on('touchstart', function () {
	        return false;
	    });
	    $('.l-onlyInfo').on('touchstart', function () {
	        return false;
	    });
	
	    // 无广告状态下拉起登录
	    eventCenter.on('pull_login_noAds', function () {
	        if (self.c_video) {
	            self.c_video.pause();
	        }
	        eventCenter.trigger('page_exit');
	        if (grounds && grounds.userLogin) {
	            grounds.userLogin();
	        }
	        testActive();
	    });
	};
	
	Page.prototype.showInput = function () {
	    if (!this.clientOptions.isApp && !__urlParams.__debugger) {
	        if (confirm('打开凤凰新闻，参与精彩互动')) {
	            pullapp();
	        }
	        return;
	    }
	
	    // 因为checkSid在验证sid合法性的时候，会进行一次异步请求，这样会导致输入框获取不到焦点，
	    // 这里将逻辑改成将输入框从认证回调中拿到外面，保证输入框能够正常获得焦点。
	
	    window.inputFromClient = function (data) {
	        var _data = JSON.parse(data);
	        var text = _data.text.trim();
	        if (!text == '') {
	            eventCenter.trigger('input_message_from_client', text);
	        }
	    };
	
	    window.inputFromClientByMaster = function (data) {
	        // {text:"", picurl:{url:""}, audiourl:{url:""}
	        // url = null 就是没有上传，上传成功了就是url地址, 失败就是‘error’
	        var _JSON$parse = JSON.parse(data),
	            text = _JSON$parse.text,
	            picurl = _JSON$parse.picurl,
	            audiourl = _JSON$parse.audiourl;
	
	        if (picurl.url == 'error') {
	            alert('图片上传失败');
	            return;
	        }
	
	        if (audiourl.url == 'error') {
	            alert('音频上传失败');
	
	            return;
	        }
	
	        if (text == '' && (picurl.url == '' || picurl.url == 'null') && (audiourl.url == '' || audiourl.url == 'null')) {
	            return;
	        }
	
	        var _Native$getTokenAndTi = _fComponent2.default.getTokenAndTimestamp(__urlParams.liveid),
	            token = _Native$getTokenAndTi.token,
	            time = _Native$getTokenAndTi.time;
	
	        var params = {
	            lr_id: __urlParams.liveid,
	            uid: _fComponent2.default.getUserInfo().getGuid(),
	            host_name: userName,
	            host_avatar: userAvatar,
	            token: token,
	            time: time,
	            content: text
	        };
	
	        if (picurl.url !== '' && picurl.url !== 'null') {
	            params.img = [{ o_src: picurl.url }];
	        }
	
	        if (audiourl.url !== '' && audiourl.url !== 'null') {
	            params.audio = [{
	                duration: audiourl.dur || 0,
	                src: audiourl.url
	            }];
	        }
	
	        addSourceToServer(params).then(function (res) {
	            if (res.code == 0) {
	                alert('成功提交信息');
	            } else {
	                alert('提交信息失败');
	            }
	        });
	    };
	
	    var _inputCallbackName = 'inputFromClient';
	
	    // debugger
	    this.c_message.getUser().then(function (msg) {
	        // debugger
	        if (msg.type == 'guest') {
	            eventCenter.trigger('input_hide');
	            if (this.clientOptions.isApp) {
	                grounds.userLogin();
	            } else {
	                window.location.href = '//id.ifeng.com/muser/login?cb=' + encodeURIComponent(window.location.href.split('#')[0]);
	            }
	        } else {
	            if (userStatus == 1) {
	                // window.location.href = '//id.ifeng.com/muser/bind?cb=' + window.location.href;
	                if (this.clientOptions.isApp) {
	                    if (grounds.userBind) {
	                        if (grounds.getDeviceInfo().getProid() == 'videoapp') {
	                            window.location.href = '//id.ifeng.com/muser/bind?cb=' + encodeURIComponent(window.location.href.split('#')[0]);
	                        } else {
	                            grounds.userBind();
	                        }
	                    } else {
	                        window.location.href = '//id.ifeng.com/muser/bind?cb=' + encodeURIComponent(window.location.href.split('#')[0]);
	                    }
	                } else {
	                    window.location.href = '//id.ifeng.com/muser/bind?cb=' + encodeURIComponent(window.location.href.split('#')[0]);
	                }
	                return;
	            }
	
	            var _params = { limit: 200, author: 'false' };
	
	            if (userType == 'master') {
	                _params.author = 'true';
	                _inputCallbackName = 'inputFromClientByMaster';
	            }
	
	            if (this.clientOptions.isApp && typeof window.grounds.input === 'function') {
	                window.grounds.input((0, _stringify2.default)(_params), _inputCallbackName);
	            }
	        }
	    }.bind(this)).catch(function () {});
	
	    if (this.clientOptions.isApp && typeof window.grounds.input === 'function') {} else {
	        eventCenter.trigger('input_show');
	    }
	};
	
	Page.prototype.render = function () {
	    if (this.c_onlyInfo) {
	        this.c_onlyInfo.renderTo(document.querySelector('.l-onlyInfo'));
	    }
	    if (this.c_notice && _fComponent2.default.isApp) {
	        this.c_notice.renderTo(document.querySelector('.l-notice'));
	    }
	    if (this.c_video) {
	        this.c_video.renderTo(document.querySelector('.l-video'));
	    }
	    if (this.c_info) {
	        this.c_info.renderTo(document.querySelector('.l-info'));
	    }
	    if (this.c_noVideo) {
	        this.c_noVideo.renderTo(document.querySelector('.l-noVideo'));
	        $('.l-head').hide();
	        $('.l-noVideo').show();
	    }
	    this.c_miniInput.renderTo(document.querySelector('.l-bottom'));
	    this.c_input.renderTo(document.querySelector('body'));
	    if (this.c_scrollview) {
	        this.c_scrollview.renderTo(document.querySelector('.l-scrollview'));
	    }
	    if (this.c_sportMatch) {
	        this.c_sportMatch.renderTo(document.querySelector('.l-notice'));
	    }
	    this.c_tab.renderTo(document.querySelector('.l-tab'));
	};
	
	// 渲染完成后，做一系列组件的操作
	Page.prototype.afterRender = function () {
	    var _this9 = this;
	
	    var isLive = this.config.compenonts.video.isLive;
	    this.c_present && this.c_present.setVerticalEffectTop($('.top_app_container').height() + $('.l-video').height() + 10 + 'px');
	
	    if (!this.clientOptions.isApp) {
	        this.c_miniInput.hideShare();
	    } else {
	        this.c_miniInput.checkIsCollected();
	        if (config.info.isComment == 0) {
	            this.c_miniInput.hideInputAndGift();
	            this.c_miniInput.showBackAndShare();
	        }
	    }
	    if (_fComponent2.default.isApp && _fComponent2.default.getDeviceInfo().getProid() == 'videoapp') {
	        if (this.c_miniInput) {
	            this.c_miniInput.hideGift();
	        }
	    } else {
	        beginTime();
	    }
	
	    this.c_miniInput.hideCollect();
	
	    if (_fComponent2.default.isApp && _fComponent2.default.getDeviceInfo().getProid() === 'ifengnews') {
	        this.c_miniInput.showCollect();
	    }
	
	    // 如果是直播，弹幕轮询接收开启
	    if (isLive) {
	        this.c_dataCenter.start();
	    }
	
	    setTimeout(function () {
	        _this9.c_info.introHide();
	    }, 3000);
	
	    // 重新设置弹幕列表的尺寸。
	    if (this.c_chartList && this.c_chartList.resize) {
	        this.c_chartList.resize();
	    }
	};
	
	/* 计时加金币begin：每个直播观看满2分钟可获得3金币，每个直播每天只能获得一次金币，每天最多可以有2个直播获得金币。*/
	window.timeAddCoinCallback = function (res) {
	    var resObj = JSON.parse(decodeURIComponent(res));
	    if (resObj.code != 200) {
	        return;
	    }
	    var current_point = resObj && resObj.data && resObj.data.current_point;
	    var addCoinTip = new _addCoinTip2.default({ point: resObj.data.op_code });
	    eventCenter.trigger('present-user-coin', current_point);
	};
	
	var beginTime = function beginTime() {
	    setTimeout(function () {
	        if (window.grounds && window.grounds.requestBridge) {
	            var guid = window.grounds.getUserInfo().getGuid();
	            var deviceid = window.grounds.getDeviceInfo().getDeviceId();
	            window.grounds.requestBridge(("http://10.21.6.102:8997/") + 'api_user_livecredit/addbyviewlive', (0, _stringify2.default)({
	                guid: guid,
	                deviceid: deviceid,
	                liveid: __urlParams.liveid
	            }), '', 'post', true, 'timeAddCoinCallback');
	        }
	    }, 120000); // 120000
	};
	/* 计时加金币end */
	
	var getUserStatus = function getUserStatus() {
	    // debugger
	    var sid = Util.cookie.getByEncode('sid');
	
	    if (_fComponent2.default.isApp) {
	        sid = grounds.getUserInfo().getToken();
	    }
	
	    if (sid) {
	        $.ajax({
	            url: '//id.ifeng.com/api/checklogin',
	            type: 'get',
	            dataType: 'jsonp',
	            data: {
	                sid: sid
	            }
	        }).done(function (msg) {
	            if (msg.code == 1 && msg.data && Number(msg.data.realNameStatus) == 0) {
	                userStatus = 0;
	            } else {
	                userStatus = 1;
	            }
	        });
	    } else {
	        userStatus = 1;
	    }
	};
	
	var getCurrentUserType = function getCurrentUserType(page) {
	    var _this = this;
	    $.ajax({
	        url: interfaceUrl.getlrinfo2,
	        type: 'get',
	        dataType: 'jsonp',
	        cache: true,
	        jsonpCallback: 'lrinfoCallback',
	        data: { lr_id: __urlParams.liveid }
	    }).done(function (res) {
	        try {
	            // page.c_miniInput.hideBackAndShare();
	            // page.c_miniInput.showInput();
	            var hosts = res.content.extra.o_hosts;
	            var guid = _fComponent2.default.getUserInfo().getGuid();
	            // page.c_miniInput.showInput();
	            if (hosts && hosts.length) {
	                var _host = hosts.filter(function (host) {
	                    return host.id == guid;
	                });
	                if (_host.length > 0) {
	                    userType = 'master';
	                    userAvatar = _host[0].avatar;
	                    userName = _host[0].name;
	                    // debugger
	                    page.c_miniInput.hideBackAndShare();
	                    page.c_miniInput.showInput();
	                }
	            }
	        } catch (err) {
	            console.log(err);
	        }
	    }).fail(function (err) {
	        console.log(err);
	    });
	};
	
	// 根据id获取礼物
	var getGift = function getGift(id) {
	    var gifts = config.compenonts.present.presentInfo.map(function (item) {
	        // 兼容历史数据
	        var idsObj = {
	            2: 21,
	            3: 22,
	            4: 23
	        }; // 新旧id映射
	        item.id = idsObj[item.id] || item.id;
	        return item;
	    });
	    for (var i = 0, iLen = gifts.length; i < iLen; i++) {
	        if (gifts[i].id == id) {
	            return gifts[i];
	        }
	    }
	    return {};
	};
	
	var formatData = function formatData(type, datas) {
	    switch (type) {
	        case 'gift':
	            datas.forEach(function (item) {
	                var gift = getGift(item.gift.id);
	                item.gift.desc = gift.name;
	                item.gift.src = gift.pic;
	            });
	            break;
	        case 'online':
	            datas.forEach(function (item) {
	                item.avatar = config.info.hosts[0].avatar;
	            });
	            break;
	        default:
	    }
	    return datas;
	};
	
	// 创建一个userid
	function getRandomUid() {
	    var date = new Date().getTime(),
	        uid = '',
	        fn = '',
	        sn = '';
	
	    fn = (Math.random() * 2147483648 | 0).toString(36);
	    sn = Math.round(Math.random() * 10000);
	    uid = date + '_' + fn + sn;
	    return uid;
	}
	
	var getUid = function getUid() {
	    var uid = Util.cookie.getByEncode('userid');
	    if (!uid) {
	        uid = getRandomUid();
	    }
	    Util.cookie.setByEncode('userid', uid, {
	        domain: '.ifeng.com',
	        path: '/',
	        expires: 60 * 24 * 360
	    });
	    return uid;
	};
	
	var initState = function initState() {
	    if (_fComponent2.default.isApp) {
	        var pageType = 'vlive';
	        var type = 'vliving';
	        if (config.info.preset != 'video') {
	            pageType = 'piclive';
	            type = 'picliving';
	        }
	        _fComponent2.default.pageStat(pageType + '_' + __urlParams.liveid, __urlParams.ref || '', pageType, 'liveimg');
	        var liveId = __urlParams.liveid;
	        var title = config.info.title;
	        _fComponent2.default.storeReadHistory({ liveId: liveId, title: title, type: type });
	    }
	
	    if (_fComponent2.default.isApp) {
	        _fComponent2.default.maximization();
	    }
	
	    return new _promise2.default(function (resolve, reject) {
	        /**  deviceInfo data **/
	        // av: "5.5.4"
	        // deviceid: "990006203081418"
	        // df: "androidphone"
	        // gv: "5.5.4"
	        // os: "android_22"
	        // proid: "ifengnews"
	        // publishid: "5286"
	        // screen: "1080x1920"
	        // uid: "990006203081418"
	        // vt: "5"
	        if (_fComponent2.default.isApp) {
	            // log('grounds begin ->', new Date().valueOf());
	            _promise2.default.all([_fComponent2.default.deviceInfo, _fComponent2.default.network, _fComponent2.default.freeflow]).then(function (_ref8) {
	                var _ref9 = (0, _slicedToArray3.default)(_ref8, 3),
	                    deviceInfo = _ref9[0],
	                    msg = _ref9[1],
	                    freeflow = _ref9[2];
	
	                resolve({
	                    isWifi: msg == 'wifi',
	                    deviceid: deviceInfo.deviceid,
	                    deviceInfo: deviceInfo,
	                    isApp: true,
	                    isFree: freeflow,
	                    deviceid_real: _fComponent2.default.getDeviceInfo().getDeviceId(),
	                    os: deviceInfo.os,
	                    gv: deviceInfo.gv,
	                    proid: deviceInfo.proid,
	                    uid: deviceInfo.deviceid,
	                    guid: _fComponent2.default.getGuid(),
	                    token: _fComponent2.default.getUserInfo().getToken() || ''
	                });
	            });
	            setTimeout(function () {
	                resolve({
	                    isApp: true,
	                    isWifi: false,
	                    deviceid: getUid(),
	                    isFree: false,
	                    deviceid_real: _fComponent2.default.getDeviceInfo().getDeviceId(),
	                    os: _fComponent2.default.getDeviceInfo().getOs(),
	                    gv: _fComponent2.default.getDeviceInfo().getGv(),
	                    proid: _fComponent2.default.getDeviceInfo().getProid(),
	                    uid: _fComponent2.default.getDeviceInfo().getDeviceId(),
	                    guid: _fComponent2.default.getGuid(),
	                    token: _fComponent2.default.getUserInfo().getToken() || ''
	                });
	            }, 1000);
	        } else {
	            resolve({
	                isApp: false,
	                isWifi: false,
	                deviceid: getUid()
	            });
	        }
	    });
	};
	
	var initSpecialScreenState = function initSpecialScreenState() {
	    if (_fComponent2.default.isApp) {
	        var diggingScreenTop = _fComponent2.default.getStatusBarHeight();
	        if (diggingScreenTop) {
	            $('.p-wrap').addClass('diggingCamera');
	            var diggingStyles = document.createElement('style');
	            diggingStyles.type = 'text/css';
	            diggingStyles.innerHTML = '.vertical .diggingCamera { padding-top: ' + diggingScreenTop + 'px; }';
	            document.getElementsByTagName('head').item(0).appendChild(diggingStyles);
	        }
	    }
	};
	
	var __init = function __init() {
	    if (typeof config === 'undefined') {
	        window.setTimeout(__init, 300);
	    } else {
	        initState().then(function (clientOptions) {
	            // if(typeof config == 'undefined') {
	            //     console.log(defaultConfig)
	            //     let config = defaultConfig;
	            // }
	            // status为4 为下线的状态
	            // 国庆期间关闭评论弹幕和点赞
	            // config.info.isComment = 0;
	            // config.info.praiseType = '1';
	
	            // config.info.hasPage = false;
	            if (config.info.status === 4) {
	                var jumpUrl = '/404.html';
	                if (document.referrer) {
	                    jumpUrl += '? =' + encodeURIComponent(document.referrer);
	                }
	                window.location.href = jumpUrl;
	            }
	            if (_fComponent2.default.isApp) {
	                getUserStatus();
	                initSpecialScreenState();
	            }
	            var _page = new Page(config, clientOptions);
	            // debugger;
	            if (_fComponent2.default.isApp) {
	                _fComponent2.default.loadFinish();
	                getCurrentUserType(_page);
	            }
	            initShareInfo();
	        }).catch(function (e) {
	            console.log(e);
	            // if(window.__catchErrorMessage && typeof window.__catchErrorMessage == 'function') {
	            //     window.__catchErrorMessage('zhibo_error', e.stack);
	            // }
	        });
	    }
	};
	var __getVideoInfo = function __getVideoInfo(options) {
	    if (options.from && options.from === 'ugc') {
	        // console.log('getVideoInfo:ugc');
	        // 请求ugc 的视频接口 // ugc 赵璐/于老师
	        var msg = options.uid + '@' + options.liveVideoId;
	        return $.ajax({
	            url: '//api.cmpp.v.ifeng.com/index.php/live/video',
	            dataType: 'jsonp',
	            data: {
	                msg: msg,
	                rt: 'js',
	                param: 'playermsg'
	            }
	        });
	    } else if (options.from && options.from === 'pmop') {
	        // console.log('getVideoInfo:pmop');
	        return 0; // 金山，不处理
	    } else {
	        // console.log('getVideoInfo:mengshuai');
	        // 姣艳/孟帅
	        var id = options.liveVideoId.split('-')[0]; // 防止间隔号-导致请求报错
	        return $.ajax({
	            url: '//tv.ifeng.com/h6/' + id + '__callback' + id + '_/video.json',
	            type: 'get',
	            jsonpCallback: 'callback' + id,
	            dataType: 'jsonp'
	        });
	    }
	};
	var __antiTheftChain = function __antiTheftChain(data) {
	    var settings = data; // Object.assign(gloableSettings, data);
	    var _obj = {
	        videoinfo: settings,
	        __gid: window.createGid(),
	        version: 'izhiboHTML5Player_v1.0.0',
	        from: 'izhibo_h5'
	    };
	    // 生成防盗链
	    var antiTheftUrl = antiTheft(_obj);
	    return antiTheftUrl;
	};
	var __antiTheftChainGet = function __antiTheftChainGet() {
	    var promises = [];
	
	    var video = config.compenonts.video;
	    var info = config.info;
	    // let from = config.info.from;
	    if (!video.isLive) {
	        var _ret = function () {
	            // 回放
	            var videos = video.list;
	            var listIndex = []; // 不排除多个视频中，其中一个视频地址不是约定的视频地址，所以要记录索引值
	
	            var _loop = function _loop(i) {
	                var src = videos[i].mp4; // Mp4地址
	                if (src && src.indexOf('.mp4') > -1) {
	                    // 约定的视频地址，则根据截取的id，获取视频信息
	                    var id = videos[i].liveVideoId.split('-')[0];
	                    var promise = _promise2.default.resolve().then(function () {
	                        return __getVideoInfo(videos[i]);
	                    });
	                    listIndex.push(i);
	                    promises.push(promise);
	                } else {
	                    // 非约定的视频地址，忽略，不处理
	                    return 'continue';
	                }
	            };
	
	            for (var i = 0; i < videos.length; i++) {
	                var _ret2 = _loop(i);
	
	                if (_ret2 === 'continue') continue;
	            }
	            return {
	                v: _promise2.default.all(promises).then(function (result) {
	                    // listIndex 与 result 是同等长度的数组
	                    for (var i = 0; i < listIndex.length; i++) {
	                        var index = listIndex[i];
	                        var data = result[i];
	                        var videoUrl = videos[index].mp4;
	                        if (data) {
	                            // 不是金山
	                            data.vid = videos[index].liveVideoId;
	                            videoUrl += __antiTheftChain(data) ? '?' + __antiTheftChain(data) : '';
	                        }
	                        // 根据存储的视频索引，替换视频地址
	                        videos[index].mp4 = videoUrl;
	                    }
	                    // console.log('resetVideoSrc===', data);
	                    return _promise2.default.resolve();
	                })
	            };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	    }
	    return _promise2.default.resolve();
	};
	
	_promise2.default.resolve().then(__antiTheftChainGet).then(__init);
	
	function addSourceToServer(_ref10) {
	    var lr_id = _ref10.lr_id,
	        uid = _ref10.uid,
	        host_name = _ref10.host_name,
	        host_avatar = _ref10.host_avatar,
	        token = _ref10.token,
	        time = _ref10.time,
	        content = _ref10.content,
	        img = _ref10.img,
	        audio = _ref10.audio;
	
	    var data = {
	        lr_id: lr_id,
	        uid: uid,
	        host_name: host_name,
	        host_avatar: host_avatar,
	        token: token,
	        time: time
	    };
	
	    if (content) {
	        data.content = content;
	    }
	
	    if (img && img.length) {
	        data.img = img;
	    }
	
	    if (audio && audio.length) {
	        data.audio = audio;
	    }
	
	    return _promise2.default.resolve($.ajax({
	        url: interfaceUrl.addSource,
	        type: 'get',
	        dataType: 'jsonp',
	        data: data
	    }));
	}
	
	function initShareInfo() {
	    if (_fComponent2.default.isApp) {
	        c_from_app = _fComponent2.default.getAppName();
	    } else {
	        c_from_app = __urlParams.c_from_app;
	    }
	
	    var headTitle = config.info.isPolitics ? '直播：' : '风直播：';
	
	    var shareimgUrl = config.info.sharepic;
	
	    if (__urlParams.liveid == '129626') {
	        shareimgUrl = 'http://x0.ifengimg.com/cmpp/2019/1001/9825bcffbc0ae0asize15_w74_h82.png';
	    }
	
	    if (weixin) {
	        weixinShare({
	            sharetitle: config.info.title,
	            sharelink: window.location.protocol + '//' + window.location.host + window.location.pathname + '?liveid=' + __urlParams.liveid + '&c_from_app=' + c_from_app,
	            shareimgUrl: shareimgUrl,
	            sharedesc: config.info.intro
	        });
	    }
	    // console.log('qqshare--', setShareInfo, headTitle + config.info.title, shareimgUrl);
	    if (qq || qz) {
	        setShareInfo({
	            title: config.info.title,
	            summary: config.info.intro,
	            pic: shareimgUrl,
	            url: window.location.protocol + '//' + window.location.host + window.location.pathname + '?liveid=' + __urlParams.liveid + '&c_from_app=' + c_from_app
	        });
	    }
	    if (__urlParams.liveid == '119513') {
	        document.title = config.info.title;
	
	        var newNode = document.createElement('img');
	        newNode.setAttribute('src', '//p1.ifengimg.com/a/2018/0717/001566787246779size8_w74_h82.jpg');
	        document.getElementById('pageslt').insertBefore(newNode, null);
	    }
	}
	
	beforeLoad(__urlParams.liveid);
	
	// 查看新系统是否存在对应直播间
	function beforeLoad(liveid) {
	    var newLink = "";
	    try {
	        $.ajax({
	            url: "http://console.zhibo.ifeng.com/web/getInfoForFenglive?id=" + liveid,
	            type: "get",
	            async: false,
	            success: function success(data) {
	                if (data.err == 0 && data.data.url) {
	                    newLink = data.data.url;
	                }
	            }
	        });
	    } catch (e) {}
	    if (newLink) {
	        window.location.href = newLink;
	    }
	}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(2);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(53);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(3), __esModule: true };

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4);
	__webpack_require__(48);
	module.exports = __webpack_require__(52).f('iterator');


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(5)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(8)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(6);
	var defined = __webpack_require__(7);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(9);
	var $export = __webpack_require__(10);
	var redefine = __webpack_require__(26);
	var hide = __webpack_require__(15);
	var Iterators = __webpack_require__(27);
	var $iterCreate = __webpack_require__(28);
	var setToStringTag = __webpack_require__(44);
	var getPrototypeOf = __webpack_require__(46);
	var ITERATOR = __webpack_require__(45)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(11);
	var core = __webpack_require__(12);
	var ctx = __webpack_require__(13);
	var hide = __webpack_require__(15);
	var has = __webpack_require__(25);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(14);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(16);
	var createDesc = __webpack_require__(24);
	module.exports = __webpack_require__(20) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(17);
	var IE8_DOM_DEFINE = __webpack_require__(19);
	var toPrimitive = __webpack_require__(23);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(20) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(20) && !__webpack_require__(21)(function () {
	  return Object.defineProperty(__webpack_require__(22)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(21)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	var document = __webpack_require__(11).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(18);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(15);


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(29);
	var descriptor = __webpack_require__(24);
	var setToStringTag = __webpack_require__(44);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(15)(IteratorPrototype, __webpack_require__(45)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(17);
	var dPs = __webpack_require__(30);
	var enumBugKeys = __webpack_require__(42);
	var IE_PROTO = __webpack_require__(39)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(22)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(43).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(16);
	var anObject = __webpack_require__(17);
	var getKeys = __webpack_require__(31);
	
	module.exports = __webpack_require__(20) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(32);
	var enumBugKeys = __webpack_require__(42);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(25);
	var toIObject = __webpack_require__(33);
	var arrayIndexOf = __webpack_require__(36)(false);
	var IE_PROTO = __webpack_require__(39)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(34);
	var defined = __webpack_require__(7);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(35);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(33);
	var toLength = __webpack_require__(37);
	var toAbsoluteIndex = __webpack_require__(38);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(6);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(6);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(40)('keys');
	var uid = __webpack_require__(41);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(12);
	var global = __webpack_require__(11);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(9) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(11).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(16).f;
	var has = __webpack_require__(25);
	var TAG = __webpack_require__(45)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(40)('wks');
	var uid = __webpack_require__(41);
	var Symbol = __webpack_require__(11).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(25);
	var toObject = __webpack_require__(47);
	var IE_PROTO = __webpack_require__(39)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(7);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49);
	var global = __webpack_require__(11);
	var hide = __webpack_require__(15);
	var Iterators = __webpack_require__(27);
	var TO_STRING_TAG = __webpack_require__(45)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(50);
	var step = __webpack_require__(51);
	var Iterators = __webpack_require__(27);
	var toIObject = __webpack_require__(33);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(8)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(45);


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(54), __esModule: true };

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(55);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	module.exports = __webpack_require__(12).Symbol;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(11);
	var has = __webpack_require__(25);
	var DESCRIPTORS = __webpack_require__(20);
	var $export = __webpack_require__(10);
	var redefine = __webpack_require__(26);
	var META = __webpack_require__(56).KEY;
	var $fails = __webpack_require__(21);
	var shared = __webpack_require__(40);
	var setToStringTag = __webpack_require__(44);
	var uid = __webpack_require__(41);
	var wks = __webpack_require__(45);
	var wksExt = __webpack_require__(52);
	var wksDefine = __webpack_require__(57);
	var enumKeys = __webpack_require__(58);
	var isArray = __webpack_require__(61);
	var anObject = __webpack_require__(17);
	var isObject = __webpack_require__(18);
	var toIObject = __webpack_require__(33);
	var toPrimitive = __webpack_require__(23);
	var createDesc = __webpack_require__(24);
	var _create = __webpack_require__(29);
	var gOPNExt = __webpack_require__(62);
	var $GOPD = __webpack_require__(64);
	var $DP = __webpack_require__(16);
	var $keys = __webpack_require__(31);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(63).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(60).f = $propertyIsEnumerable;
	  __webpack_require__(59).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(9)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(15)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(41)('meta');
	var isObject = __webpack_require__(18);
	var has = __webpack_require__(25);
	var setDesc = __webpack_require__(16).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(21)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(11);
	var core = __webpack_require__(12);
	var LIBRARY = __webpack_require__(9);
	var wksExt = __webpack_require__(52);
	var defineProperty = __webpack_require__(16).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(31);
	var gOPS = __webpack_require__(59);
	var pIE = __webpack_require__(60);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(35);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(33);
	var gOPN = __webpack_require__(63).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(32);
	var hiddenKeys = __webpack_require__(42).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(60);
	var createDesc = __webpack_require__(24);
	var toIObject = __webpack_require__(33);
	var toPrimitive = __webpack_require__(23);
	var has = __webpack_require__(25);
	var IE8_DOM_DEFINE = __webpack_require__(19);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(20) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 65 */
/***/ (function(module, exports) {



/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(57)('asyncIterator');


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(57)('observable');


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(69);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(73);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(70), __esModule: true };

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(48);
	__webpack_require__(4);
	module.exports = __webpack_require__(71);


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(72);
	var ITERATOR = __webpack_require__(45)('iterator');
	var Iterators = __webpack_require__(27);
	module.exports = __webpack_require__(12).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(35);
	var TAG = __webpack_require__(45)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(74), __esModule: true };

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(48);
	__webpack_require__(4);
	module.exports = __webpack_require__(75);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(17);
	var get = __webpack_require__(76);
	module.exports = __webpack_require__(12).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(72);
	var ITERATOR = __webpack_require__(45)('iterator');
	var Iterators = __webpack_require__(27);
	module.exports = __webpack_require__(12).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(78), __esModule: true };

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(12);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(80), __esModule: true };

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(81);
	module.exports = __webpack_require__(12).Object.assign;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(10);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(82) });


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(31);
	var gOPS = __webpack_require__(59);
	var pIE = __webpack_require__(60);
	var toObject = __webpack_require__(47);
	var IObject = __webpack_require__(34);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(21)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(84), __esModule: true };

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(65);
	__webpack_require__(4);
	__webpack_require__(48);
	__webpack_require__(85);
	__webpack_require__(101);
	__webpack_require__(102);
	module.exports = __webpack_require__(12).Promise;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(9);
	var global = __webpack_require__(11);
	var ctx = __webpack_require__(13);
	var classof = __webpack_require__(72);
	var $export = __webpack_require__(10);
	var isObject = __webpack_require__(18);
	var aFunction = __webpack_require__(14);
	var anInstance = __webpack_require__(86);
	var forOf = __webpack_require__(87);
	var speciesConstructor = __webpack_require__(90);
	var task = __webpack_require__(91).set;
	var microtask = __webpack_require__(93)();
	var newPromiseCapabilityModule = __webpack_require__(94);
	var perform = __webpack_require__(95);
	var userAgent = __webpack_require__(96);
	var promiseResolve = __webpack_require__(97);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(45)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(98)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(44)($Promise, PROMISE);
	__webpack_require__(99)(PROMISE);
	Wrapper = __webpack_require__(12)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(100)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(13);
	var call = __webpack_require__(88);
	var isArrayIter = __webpack_require__(89);
	var anObject = __webpack_require__(17);
	var toLength = __webpack_require__(37);
	var getIterFn = __webpack_require__(76);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(17);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(27);
	var ITERATOR = __webpack_require__(45)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(17);
	var aFunction = __webpack_require__(14);
	var SPECIES = __webpack_require__(45)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(13);
	var invoke = __webpack_require__(92);
	var html = __webpack_require__(43);
	var cel = __webpack_require__(22);
	var global = __webpack_require__(11);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(35)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(11);
	var macrotask = __webpack_require__(91).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(35)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(14);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(11);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(17);
	var isObject = __webpack_require__(18);
	var newPromiseCapability = __webpack_require__(94);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(15);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var core = __webpack_require__(12);
	var dP = __webpack_require__(16);
	var DESCRIPTORS = __webpack_require__(20);
	var SPECIES = __webpack_require__(45)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(45)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(10);
	var core = __webpack_require__(12);
	var global = __webpack_require__(11);
	var speciesConstructor = __webpack_require__(90);
	var promiseResolve = __webpack_require__(97);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(10);
	var newPromiseCapability = __webpack_require__(94);
	var perform = __webpack_require__(95);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(77);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(79);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Events = __webpack_require__(104);
	var md5 = __webpack_require__(109);
	// console.log(md5)
	var Native = {
	    isApp: typeof grounds !== 'undefined'
	};
	
	var __index = 0;
	var creatFun = function creatFun(callback) {
	    var funName = '__grounds_' + Number(Math.floor(Math.random() * 10000000000)).toString(36) + __index++;
	    window[funName] = function (msg) {
	        callback(msg);
	    };
	    return funName;
	};
	
	var __Native = {
	    intercall: function intercall(appCommand, callback) {
	        var funName = creatFun(callback);
	        grounds[appCommand](funName);
	    },
	
	    on: function on(appCommand, callback) {
	        var funName = creatFun(callback);
	        grounds.on(appCommand, funName);
	    }
	};
	
	var formatUrl = function formatUrl(url, params) {
	    var urls = url.split('#');
	    if (urls[0].indexOf('?') >= 0) {
	        urls[0] = urls[0] + '&' + params;
	    } else {
	        urls[0] = urls[0] + '?' + params;
	    }
	
	    if (urls.length > 1) {
	        return urls[0] + '#' + urls[1];
	    } else {
	        return urls[0];
	    }
	};
	
	if (Native.isApp) {
	    (0, _assign2.default)(Native, {
	        // App.on('networkchange', callback), 回调字符串, 值为, wifi, 2g, 3g, 4g, none, 其它情况算未知
	        // 获取用户的上网环境
	        network: new _promise2.default(function (resolve, reject) {
	            __Native.on('networkchange', function (msg) {
	                console.log(msg);
	                resolve(msg);
	                setTimeout(function () {
	                    Native.trigger('networkchange', msg);
	                }, 300);
	            });
	        }),
	        // 获取用户的设备信息
	        deviceInfo: new _promise2.default(function (resolve, reject) {
	            __Native.intercall('deviceInfo', function (msg) {
	                console.log(msg);
	                resolve(msg);
	            });
	        }),
	        freeflow: new _promise2.default(function (resolve, reject) {
	            __Native.on('freeflow', function (msg) {
	                console.log(msg);
	                Native.trigger('freeflow', msg);
	                resolve(msg);
	            });
	        }),
	        // 拉起客户端登录界面
	        userLogin: function userLogin() {
	            grounds.userLogin();
	        },
	        // 最大化webview（仅ios有）
	        maximization: function maximization() {
	            if (typeof grounds.maximization !== 'undefined') {
	                grounds.maximization();
	            }
	        },
	        // 退出最大化webview（仅ios有）
	        exitMaximization: function exitMaximization() {
	            if (typeof grounds.exitMaximization !== 'undefined') {
	                grounds.exitMaximization();
	            }
	        },
	        // 旋转webview
	        // type 1 旋转到横屏 0 旋转到竖屏
	        rotate: function rotate(type) {
	            grounds.rotate(type);
	        },
	        // 关闭
	        close: function close() {
	            grounds.close();
	        },
	        // 获取用户信息
	        getUserInfo: function getUserInfo() {
	            return grounds.getUserInfo();
	        },
	
	        // 获取用户信息
	        getDeviceInfo: function getDeviceInfo() {
	            return grounds.getDeviceInfo();
	        },
	        // 调用客户端的分享功能
	        // url, title, intro, pic, liveid
	        openShare: function openShare() {
	            var _grounds;
	
	            (_grounds = grounds).openShare.apply(_grounds, arguments);
	        },
	        openNative: function openNative(id) {
	            grounds.dispatch('text_live', id, '', '', '');
	        },
	        openH5: function openH5(id, mode, ref) {
	            grounds.dispatch('web', window.location.protocol + '//izhibo.ifeng.com/live.html?liveid=' + id + '&mode=' + mode + '&webkit=1&isFull=1&immersion=true&ref=' + ref, '', '', '');
	        },
	        openWeb: function openWeb(url, sta) {
	            var paramStr = sta ? '' : 'webkit=1&isFull=0';
	            url = formatUrl(url, paramStr);
	            grounds.dispatch('web', url, '', '', '');
	        },
	        // 调用客户端的设置提醒功能
	        // id, 直播间liveid
	        // timeStamp, 需要弹出提醒的时间
	        // title, 提示文字
	        // type, 拉起直播间类型 h5_live（h5直播） | text_live（原生直播）
	        setAlarmClock: function setAlarmClock() {
	            var _grounds2;
	
	            (_grounds2 = grounds).setAlarmClock.apply(_grounds2, arguments);
	        },
	        sendlorder: function sendlorder(id) {
	            grounds.actionStat('{"type":"lorder","id":"live_sub_' + id + '"');
	        },
	        // 取消提醒，id为直播间liveid
	        cancelAlarmClock: function cancelAlarmClock(id) {
	            grounds.cancelAlarmClock(id);
	        },
	        sendUnlorder: function sendUnlorder(id) {
	            grounds.actionStat('{"type":"lunorder","id":"live_sub_' + id + '"');
	        },
	        // 查询是否开启提醒
	        isTiming: function isTiming(ids) {
	            return new _promise2.default(function (resolve, reject) {
	                var liveids = ids.split(',');
	                var funName = creatFun(function (msg) {
	                    var checks = msg.split(',');
	                    var result = [];
	                    for (var i = 0, iLen = checks.length; i < iLen; i++) {
	                        if (checks[i] == 1) {
	                            result.push(liveids[i]);
	                        }
	                    }
	                    resolve(result);
	                });
	                grounds.isTiming(ids, funName);
	            });
	        },
	
	        stat: function stat(string, state) {
	            grounds.stat(string, state);
	        },
	
	        /**
	         * 上报pv的接口
	         * id: 当前页面id
	         * ref: 表明页面是从哪里进入的，就直播频道来说，可以通过地址栏中ref参数获取，如果没有ref参数，就传空，
	         * type: 页面类型，根据上方文档进行发送。
	         */
	        pageStat: function pageStat(id) {
	            var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	            var type = arguments[2];
	            var showtype = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	            grounds.pageStat((0, _stringify2.default)({ id: id, ref: ref, type: type, showtype: showtype }));
	        },
	
	        /**
	         * 上报行为滚屏
	         * type: upscreen，行为类型
	         * id: 为当前页面id，规则见上方文档
	         * psnum: 滚动的屏幕数（以scrolltop的高度除以屏幕高度，不满一屏的按一屏算）
	         */
	        actionStat: function actionStat(_ref) {
	            var type = _ref.type,
	                id = _ref.id;
	            var extend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            grounds.actionStat((0, _stringify2.default)((0, _assign2.default)({ type: type, id: id }, extend)));
	        },
	
	        /**
	         * 上报曝光数据
	         * id: 为当前数据对应的页面的id （如果曝光的是直播里面中的直播，则为 piclive process=live | vlive process=video + liveid）
	         * rnum: 数据所在位置，除精选外，其他列表都从1_1开始，依次为2_1，3_1，轮播图为1_1 1_2 1_3
	         * reftype: 'editor'
	         * ch: 为曝光数据所在的当前页面的id
	         * src: 为曝光数据为直播时，src为所在的栏目，曝光数据是栏目时，src是什么呢，channel如何？
	         */
	        expose: function expose(id, rumn, reftype, ch) {
	            var src = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
	
	            grounds.expose((0, _stringify2.default)({ id: id, rumn: rumn, reftype: reftype, ch: ch, src: src }));
	        },
	        getShowMode: function getShowMode() {
	            return grounds.getShowMode();
	        },
	
	        /**
	         * 通过native回调js的方法来实现在安卓下面视频的主动播放。
	         * video可以是h5的video，也可以是一个有play方法的组件实例。
	         */
	        playVideo: function playVideo(video, index) {
	            __Native.intercall('deviceInfo', function () {
	                video.play(index);
	            });
	        },
	
	        getAppName: function getAppName() {
	            return grounds.getDeviceInfo().getProid();
	        },
	
	        loadFinish: function loadFinish() {
	            if (grounds.loadFinish) {
	                grounds.loadFinish();
	            }
	        },
	
	        syncSubscribe: function syncSubscribe(_ref2) {
	            var followid = _ref2.followid,
	                type = _ref2.type,
	                isSubscribe = _ref2.isSubscribe;
	
	            if (grounds.syncSubscribe && typeof grounds.syncSubscribe === 'function') {
	                return grounds.syncSubscribe(followid, type, isSubscribe);
	            } else {
	                return false;
	            }
	        },
	
	        getGuid: function getGuid() {
	            return grounds.getUserInfo().getGuid();
	        },
	
	        getTokenAndTimestamp: function getTokenAndTimestamp(liveId) {
	            // "{时间前3位}{直播间id}_{用户guid}{时间后6位}"
	            var guid = grounds.getUserInfo().getGuid();
	            var timeStamp = Date.now() + '';
	            var t3 = timeStamp.substr(0, 3) + '';
	            var t6 = timeStamp.substr(4, 6) + '';
	
	            var md5_string = t3 + liveId + '_' + guid + t6;
	
	            var token = md5(md5(md5(md5_string)));
	            var time = t3 + '' + t6;
	
	            return { token: token, time: time };
	        },
	
	        storeReadHistory: function storeReadHistory(liveInfo) {
	            if (grounds.storeReadHistory && typeof grounds.storeReadHistory === 'function') {
	                grounds.storeReadHistory((0, _stringify2.default)(liveInfo));
	            }
	        },
	
	        getStatusBarHeight: function getStatusBarHeight() {
	            if (grounds && grounds.getStatusBarHeight && typeof grounds.getStatusBarHeight === 'function') {
	                return grounds.getStatusBarHeight() / window.devicePixelRatio;
	            }
	
	            return 0;
	        }
	    });
	
	    // 监听webview被挂起（一般是app被放到后台的情况下）
	    __Native.on('exit', function () {
	        Native.trigger('exit');
	    });
	
	    // 监听webview被激活
	    __Native.on('active', function () {
	        Native.trigger('active');
	    });
	
	    // 监听webview被销毁
	    __Native.on('destory', function () {
	        Native.trigger('destory');
	    });
	
	    // 监听webview划入划出
	    if (grounds.slip) {
	        __Native.intercall('slip', function (state) {
	            console.log(2222222222, state);
	            Native.trigger('slip', state);
	        });
	    }
	}
	
	Events.mixTo(Native);
	
	exports.default = Native;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(105);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Events
	// -----------------
	// Thanks to:
	//  - https://github.com/documentcloud/backbone/blob/master/backbone.js
	//  - https://github.com/joyent/node/blob/master/lib/events.js
	
	
	// Regular expression used to split event strings
	var eventSplitter = /\s+/;
	
	// A module that can be mixed in to *any object* in order to provide it
	// with custom events. You may bind with `on` or remove with `off` callback
	// functions to an event; `trigger`-ing an event fires all callbacks in
	// succession.
	//
	//     var object = new Events();
	//     object.on('expand', function(){ alert('expanded'); });
	//     object.trigger('expand');
	//
	function Events() {}
	
	// Bind one or more space separated events, `events`, to a `callback`
	// function. Passing `"all"` will bind the callback to all events fired.
	Events.prototype.on = function (events, callback, context) {
	  var cache, event, list, namespace, a;
	  if (!callback) return this;
	
	  cache = this.__events || (this.__events = {});
	  events = events.split(eventSplitter);
	
	  while (event = events.shift()) {
	    a = event.split(':');
	    event = a[0];
	    namespace = a[1] || '';
	    list = cache[event] || (cache[event] = []);
	    list.push(callback, context, namespace);
	  }
	
	  return this;
	};
	
	Events.prototype.once = function (events, callback, context) {
	  var that = this;
	  var cb = function cb() {
	    that.off(events, cb);
	    callback.apply(this, arguments);
	  };
	  this.on(events, cb, context);
	};
	
	// Remove one or many callbacks. If `context` is null, removes all callbacks
	// with that function. If `callback` is null, removes all callbacks for the
	// event. If `events` is null, removes all bound callbacks for all events.
	Events.prototype.off = function (events, callback, context) {
	  var cache, event, list, i, namespace, a;
	
	  // No events, or removing *all* events.
	  if (!(cache = this.__events)) return this;
	  if (!(events || callback || context)) {
	    delete this.__events;
	    return this;
	  }
	
	  events = events ? events.split(eventSplitter) : keys(cache);
	
	  // Loop through the callback list, splicing where appropriate.
	  while (event = events.shift()) {
	    a = event.split(':');
	    namespace = a[1] || '';
	    event = a[0];
	    list = cache[event];
	    if (!list) continue;
	
	    if (!(callback || context || namespace !== '')) {
	      delete cache[event];
	      continue;
	    }
	
	    for (i = list.length - 3; i >= 0; i -= 3) {
	      if (!(callback && list[i] !== callback || context && list[i + 1] !== context || namespace !== '' && list[i + 2] !== namespace)) {
	        list.splice(i, 3);
	      }
	    }
	  }
	
	  return this;
	};
	
	// Trigger one or many events, firing all bound callbacks. Callbacks are
	// passed the same arguments as `trigger` is, apart from the event name
	// (unless you're listening on `"all"`, which will cause your callback to
	// receive the true name of the event as the first argument).
	Events.prototype.trigger = function (events) {
	  var cache,
	      event,
	      all,
	      list,
	      i,
	      len,
	      rest = [],
	      args,
	      returned = true;
	  if (!(cache = this.__events)) return this;
	
	  events = events.split(eventSplitter);
	
	  // Fill up `rest` with the callback arguments.  Since we're only copying
	  // the tail of `arguments`, a loop is much faster than Array#slice.
	  for (i = 1, len = arguments.length; i < len; i++) {
	    rest[i - 1] = arguments[i];
	  }
	
	  // For each event, walk through the list of callbacks twice, first to
	  // trigger the event, then to trigger any `"all"` callbacks.
	  while (event = events.shift()) {
	    // Copy callback lists to prevent modification.
	    if (all = cache.all) all = all.slice();
	    if (list = cache[event]) list = list.slice();
	
	    // Execute event callbacks.
	    returned = triggerEvents(list, rest, this) && returned;
	
	    // Execute "all" callbacks.
	    returned = triggerEvents(all, [event].concat(rest), this) && returned;
	  }
	
	  return returned;
	};
	
	Events.prototype.emit = Events.prototype.trigger;
	
	// Mix `Events` to object instance or Class function.
	Events.mixTo = function (receiver) {
	  receiver = isFunction(receiver) ? receiver.prototype : receiver;
	  var proto = Events.prototype;
	
	  for (var p in proto) {
	    if (proto.hasOwnProperty(p)) {
	      receiver[p] = proto[p];
	    }
	  }
	};
	
	// Helpers
	// -------
	
	var keys = _keys2.default;
	
	if (!keys) {
	  keys = function keys(o) {
	    var result = [];
	
	    for (var name in o) {
	      if (o.hasOwnProperty(name)) {
	        result.push(name);
	      }
	    }
	    return result;
	  };
	}
	
	// Execute callbacks
	function triggerEvents(list, args, context) {
	  var pass = true;
	
	  if (list) {
	    var i = 0,
	        l = list.length,
	        a1 = args[0],
	        a2 = args[1],
	        a3 = args[2];
	    // call is faster than apply, optimize less than 3 argu
	    // http://blog.csdn.net/zhengyinhui100/article/details/7837127
	    switch (args.length) {
	      case 0:
	        for (; i < l; i += 3) {
	          pass = list[i].call(list[i + 1] || context) !== false && pass;
	        }break;
	      case 1:
	        for (; i < l; i += 3) {
	          pass = list[i].call(list[i + 1] || context, a1) !== false && pass;
	        }break;
	      case 2:
	        for (; i < l; i += 3) {
	          pass = list[i].call(list[i + 1] || context, a1, a2) !== false && pass;
	        }break;
	      case 3:
	        for (; i < l; i += 3) {
	          pass = list[i].call(list[i + 1] || context, a1, a2, a3) !== false && pass;
	        }break;
	      default:
	        for (; i < l; i += 3) {
	          pass = list[i].apply(list[i + 1] || context, args) !== false && pass;
	        }break;
	    }
	  }
	  // trigger will return false if one of the callbacks return false
	  return pass;
	}
	
	function isFunction(func) {
	  return Object.prototype.toString.call(func) === '[object Function]';
	}
	
	module.exports = Events;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(106), __esModule: true };

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(107);
	module.exports = __webpack_require__(12).Object.keys;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(47);
	var $keys = __webpack_require__(31);
	
	__webpack_require__(108)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(10);
	var core = __webpack_require__(12);
	var fails = __webpack_require__(21);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(1);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	!function (n) {
	  "use strict";
	  function t(n, t) {
	    var r = (65535 & n) + (65535 & t),
	        e = (n >> 16) + (t >> 16) + (r >> 16);return e << 16 | 65535 & r;
	  }function r(n, t) {
	    return n << t | n >>> 32 - t;
	  }function e(n, e, o, u, c, f) {
	    return t(r(t(t(e, n), t(u, f)), c), o);
	  }function o(n, t, r, o, u, c, f) {
	    return e(t & r | ~t & o, n, t, u, c, f);
	  }function u(n, t, r, o, u, c, f) {
	    return e(t & o | r & ~o, n, t, u, c, f);
	  }function c(n, t, r, o, u, c, f) {
	    return e(t ^ r ^ o, n, t, u, c, f);
	  }function f(n, t, r, o, u, c, f) {
	    return e(r ^ (t | ~o), n, t, u, c, f);
	  }function i(n, r) {
	    n[r >> 5] |= 128 << r % 32, n[(r + 64 >>> 9 << 4) + 14] = r;var e,
	        i,
	        a,
	        h,
	        d,
	        l = 1732584193,
	        g = -271733879,
	        v = -1732584194,
	        m = 271733878;for (e = 0; e < n.length; e += 16) {
	      i = l, a = g, h = v, d = m, l = o(l, g, v, m, n[e], 7, -680876936), m = o(m, l, g, v, n[e + 1], 12, -389564586), v = o(v, m, l, g, n[e + 2], 17, 606105819), g = o(g, v, m, l, n[e + 3], 22, -1044525330), l = o(l, g, v, m, n[e + 4], 7, -176418897), m = o(m, l, g, v, n[e + 5], 12, 1200080426), v = o(v, m, l, g, n[e + 6], 17, -1473231341), g = o(g, v, m, l, n[e + 7], 22, -45705983), l = o(l, g, v, m, n[e + 8], 7, 1770035416), m = o(m, l, g, v, n[e + 9], 12, -1958414417), v = o(v, m, l, g, n[e + 10], 17, -42063), g = o(g, v, m, l, n[e + 11], 22, -1990404162), l = o(l, g, v, m, n[e + 12], 7, 1804603682), m = o(m, l, g, v, n[e + 13], 12, -40341101), v = o(v, m, l, g, n[e + 14], 17, -1502002290), g = o(g, v, m, l, n[e + 15], 22, 1236535329), l = u(l, g, v, m, n[e + 1], 5, -165796510), m = u(m, l, g, v, n[e + 6], 9, -1069501632), v = u(v, m, l, g, n[e + 11], 14, 643717713), g = u(g, v, m, l, n[e], 20, -373897302), l = u(l, g, v, m, n[e + 5], 5, -701558691), m = u(m, l, g, v, n[e + 10], 9, 38016083), v = u(v, m, l, g, n[e + 15], 14, -660478335), g = u(g, v, m, l, n[e + 4], 20, -405537848), l = u(l, g, v, m, n[e + 9], 5, 568446438), m = u(m, l, g, v, n[e + 14], 9, -1019803690), v = u(v, m, l, g, n[e + 3], 14, -187363961), g = u(g, v, m, l, n[e + 8], 20, 1163531501), l = u(l, g, v, m, n[e + 13], 5, -1444681467), m = u(m, l, g, v, n[e + 2], 9, -51403784), v = u(v, m, l, g, n[e + 7], 14, 1735328473), g = u(g, v, m, l, n[e + 12], 20, -1926607734), l = c(l, g, v, m, n[e + 5], 4, -378558), m = c(m, l, g, v, n[e + 8], 11, -2022574463), v = c(v, m, l, g, n[e + 11], 16, 1839030562), g = c(g, v, m, l, n[e + 14], 23, -35309556), l = c(l, g, v, m, n[e + 1], 4, -1530992060), m = c(m, l, g, v, n[e + 4], 11, 1272893353), v = c(v, m, l, g, n[e + 7], 16, -155497632), g = c(g, v, m, l, n[e + 10], 23, -1094730640), l = c(l, g, v, m, n[e + 13], 4, 681279174), m = c(m, l, g, v, n[e], 11, -358537222), v = c(v, m, l, g, n[e + 3], 16, -722521979), g = c(g, v, m, l, n[e + 6], 23, 76029189), l = c(l, g, v, m, n[e + 9], 4, -640364487), m = c(m, l, g, v, n[e + 12], 11, -421815835), v = c(v, m, l, g, n[e + 15], 16, 530742520), g = c(g, v, m, l, n[e + 2], 23, -995338651), l = f(l, g, v, m, n[e], 6, -198630844), m = f(m, l, g, v, n[e + 7], 10, 1126891415), v = f(v, m, l, g, n[e + 14], 15, -1416354905), g = f(g, v, m, l, n[e + 5], 21, -57434055), l = f(l, g, v, m, n[e + 12], 6, 1700485571), m = f(m, l, g, v, n[e + 3], 10, -1894986606), v = f(v, m, l, g, n[e + 10], 15, -1051523), g = f(g, v, m, l, n[e + 1], 21, -2054922799), l = f(l, g, v, m, n[e + 8], 6, 1873313359), m = f(m, l, g, v, n[e + 15], 10, -30611744), v = f(v, m, l, g, n[e + 6], 15, -1560198380), g = f(g, v, m, l, n[e + 13], 21, 1309151649), l = f(l, g, v, m, n[e + 4], 6, -145523070), m = f(m, l, g, v, n[e + 11], 10, -1120210379), v = f(v, m, l, g, n[e + 2], 15, 718787259), g = f(g, v, m, l, n[e + 9], 21, -343485551), l = t(l, i), g = t(g, a), v = t(v, h), m = t(m, d);
	    }return [l, g, v, m];
	  }function a(n) {
	    var t,
	        r = "",
	        e = 32 * n.length;for (t = 0; t < e; t += 8) {
	      r += String.fromCharCode(n[t >> 5] >>> t % 32 & 255);
	    }return r;
	  }function h(n) {
	    var t,
	        r = [];for (r[(n.length >> 2) - 1] = void 0, t = 0; t < r.length; t += 1) {
	      r[t] = 0;
	    }var e = 8 * n.length;for (t = 0; t < e; t += 8) {
	      r[t >> 5] |= (255 & n.charCodeAt(t / 8)) << t % 32;
	    }return r;
	  }function d(n) {
	    return a(i(h(n), 8 * n.length));
	  }function l(n, t) {
	    var r,
	        e,
	        o = h(n),
	        u = [],
	        c = [];for (u[15] = c[15] = void 0, o.length > 16 && (o = i(o, 8 * n.length)), r = 0; r < 16; r += 1) {
	      u[r] = 909522486 ^ o[r], c[r] = 1549556828 ^ o[r];
	    }return e = i(u.concat(h(t)), 512 + 8 * t.length), a(i(c.concat(e), 640));
	  }function g(n) {
	    var t,
	        r,
	        e = "0123456789abcdef",
	        o = "";for (r = 0; r < n.length; r += 1) {
	      t = n.charCodeAt(r), o += e.charAt(t >>> 4 & 15) + e.charAt(15 & t);
	    }return o;
	  }function v(n) {
	    return unescape(encodeURIComponent(n));
	  }function m(n) {
	    return d(v(n));
	  }function p(n) {
	    return g(m(n));
	  }function s(n, t) {
	    return l(v(n), v(t));
	  }function C(n, t) {
	    return g(s(n, t));
	  }function A(n, t, r) {
	    return t ? r ? s(t, n) : C(t, n) : r ? m(n) : p(n);
	  } true ? !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return A;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof module === "undefined" ? "undefined" : (0, _typeof3.default)(module)) && module.exports ? module.exports = A : n.md5 = A;
	}(undefined);

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ui = __webpack_require__(111);
	
	var _ui2 = _interopRequireDefault(_ui);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ui2.default;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _queue = __webpack_require__(117);
	
	var _queue2 = _interopRequireDefault(_queue);
	
	var _present = __webpack_require__(118);
	
	var _present2 = _interopRequireDefault(_present);
	
	var _eventBus = __webpack_require__(119);
	
	var _eventBus2 = _interopRequireDefault(_eventBus);
	
	var _verticalPresent = __webpack_require__(120);
	
	var _verticalPresent2 = _interopRequireDefault(_verticalPresent);
	
	var _horizontalPresent = __webpack_require__(145);
	
	var _horizontalPresent2 = _interopRequireDefault(_horizontalPresent);
	
	var _effect2 = __webpack_require__(149);
	
	var _effect3 = _interopRequireDefault(_effect2);
	
	var _goldEgg = __webpack_require__(170);
	
	var _goldEgg2 = _interopRequireDefault(_goldEgg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import horizontalEffect from './horizontalEffect';
	// console.log(verticalPresent)
	
	// import horizontalEffect from './horizontalEffect/horizontalEffect';
	var PresentUI = function () {
	    function PresentUI(_ref) {
	        var message = _ref.message,
	            clientOptions = _ref.clientOptions,
	            _ref$presentInfo = _ref.presentInfo,
	            presentInfo = _ref$presentInfo === undefined ? [] : _ref$presentInfo,
	            _ref$queue_config = _ref.queue_config,
	            queue_config = _ref$queue_config === undefined ? {} : _ref$queue_config,
	            _ref$present_config = _ref.present_config,
	            present_config = _ref$present_config === undefined ? {} : _ref$present_config,
	            _ref$effect_config = _ref.effect_config,
	            effect_config = _ref$effect_config === undefined ? {} : _ref$effect_config,
	            _ref$goldEgg_config = _ref.goldEgg_config,
	            goldEgg_config = _ref$goldEgg_config === undefined ? {} : _ref$goldEgg_config,
	            _ref$orientation = _ref.orientation,
	            orientation = _ref$orientation === undefined ? 'vertical' : _ref$orientation;
	        (0, _classCallCheck3.default)(this, PresentUI);
	
	        this.message = message;
	        this.clientOptions = clientOptions;
	
	        this.presentInfo = presentInfo;
	        this.queue_config = queue_config;
	        this.present_config = present_config;
	        this.effect_config = effect_config;
	        this.goldEgg_config = goldEgg_config;
	
	        this.presentDatas = {};
	        this.presentFactory = {};
	        this.orientation = orientation;
	        this.event = _eventBus2.default;
	
	        if (!this.presentInfo.length) {
	            console.log('礼物信息错误');
	            return;
	        } else {
	            this.init();
	            this.initCustomEvent();
	        }
	    }
	
	    (0, _createClass3.default)(PresentUI, [{
	        key: 'init',
	        value: function init() {
	            this.queue = new _queue2.default(this.queue_config);
	            this.present = new _present2.default(this.present_config, this.message);
	
	            this.factory = {
	                present: {
	                    vertical: new _verticalPresent2.default(this.presentInfo, this.clientOptions),
	                    horizontal: new _horizontalPresent2.default(this.presentInfo, this.clientOptions)
	                },
	                effect: new _effect3.default(this.presentInfo),
	                goldEgg: new _goldEgg2.default({ orientation: this.orientation })
	            };
	        }
	    }, {
	        key: 'initCustomEvent',
	        value: function initCustomEvent() {
	            var _this2 = this;
	
	            this.event.on('receive-presentDatas', this.notifyReceivePresentDatas.bind(this));
	            this.present.isLogin().then(function (type) {
	                return _this2.event.trigger('isLogin', type);
	            });
	        }
	    }, {
	        key: 'notifyReceivePresentDatas',
	        value: function notifyReceivePresentDatas(datas) {
	
	            var _this = this;
	            if (this.presentDatas && this.queue.remainQueueLength > 0) {
	
	                var _fun = function _fun() {
	                    return _this.runTask(datas[0]).catch(function (err) {
	                        return console.log(err);
	                    });
	                };
	
	                this.queue.add(_fun);
	            }
	        }
	    }, {
	        key: 'runTask',
	        value: function runTask(data) {
	            var _this = this;
	            if (data && data.comboid) {
	                return this.dispatchTask(data).then(function (_ref2) {
	                    var newData = _ref2.newData,
	                        oldData = _ref2.oldData;
	
	                    _this.present.removePresentData(newData);
	                }).then(function () {
	                    if (_this.present.getPresentDatas()[0]) {
	                        return _this.runTask(_this.present.getPresentDatas()[0]);
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'dispatchTask',
	        value: function dispatchTask(newData) {
	            var _this3 = this;
	
	            // 1.开始运行动画
	            // 2.运行之后查询是否还有连击
	            // 3.有连击继续运行
	            // 4.没有就查询当前presentDatas是否还有排队
	            // 5.没有就获取新的数据
	            var _this = this;
	            return new _promise2.default(function (resolve, reject) {
	                var new_comboId = newData.comboid;
	                var oldData = _this3.presentDatas[new_comboId];
	
	                // 如果传来的数据没有comboid，认为数据错误，直接reject
	                if (!new_comboId) {
	                    reject('数据错误');
	                }
	
	                // 如果当前comboid第一次运行或老数据comboid不存在，则直接开始动画效果
	                if (!oldData || !oldData.comboid) {
	                    // console.log(4444)
	                    _this3.presentDatas[new_comboId] = newData;
	                    return _this3.startAnimate(newData).then(function (_ref3) {
	                        var newData = _ref3.newData,
	                            oldData = _ref3.oldData;
	
	                        _this.presentDatas[new_comboId] = newData;
	                        resolve({ newData: newData, oldData: oldData });
	                    });
	                }
	
	                // 如果老数据存在，且新数据combo数大于老数据combo数
	                if (parseInt(newData.combo) > parseInt(oldData.combo)) {
	                    // console.log(5555)
	                    _this3.presentDatas[new_comboId] = newData;
	                    return _this3.startAnimate(newData, oldData).then(function (_ref4) {
	                        var newData = _ref4.newData,
	                            oldData = _ref4.oldData;
	
	                        _this.presentDatas[new_comboId] = newData;
	                        resolve({ newData: newData, oldData: oldData });
	                    });
	                } else {
	                    resolve(oldData);
	                }
	            });
	        }
	    }, {
	        key: 'startAnimate',
	        value: function startAnimate(newData, oldData) {
	            var _this4 = this;
	
	            var _effect = this.factory.effect;
	
	            if (!_effect) {
	                return;
	            }
	
	            var _iteratorProcess = function _iteratorProcess(_ref5) {
	                var newData = _ref5.newData,
	                    oldData = _ref5.oldData;
	
	                var _isExistComboData = _this4.present.getPresentDataByComboid(newData.comboid);
	                if (parseInt(_isExistComboData.combo) > parseInt(newData.combo)) {
	                    console.log(888888);
	                    return _effect.process.bind(_effect)({ newData: _isExistComboData, oldData: newData }).then(_iteratorProcess);
	                } else {
	                    //删除当前已动画完数据
	                    return { newData: newData };
	                }
	            };
	            return _promise2.default.resolve({ newData: newData, oldData: oldData }).then(_effect.start.bind(_effect)).then(_effect.enter.bind(_effect))
	            // .then(({newData, oldData}) => {
	            //     return new Promise(resolve => {
	            //         setTimeout(() => resolve({newData, oldData}), 300000)
	            //     })
	            // })
	            .then(_effect.process.bind(_effect)).then(_iteratorProcess).then(_effect.leave.bind(_effect)).then(_effect.end.bind(_effect)).then(function (_ref6) {
	                var newData = _ref6.newData,
	                    oldData = _ref6.oldData;
	
	                // console.log(newData,oldData)
	
	                return { newData: newData, oldData: oldData };
	            });
	        }
	    }, {
	        key: 'switchOrientation',
	        value: function switchOrientation(orientation) {
	            if (orientation == 'horizontal') {
	                this.orientation = 'horizontal';
	            } else if (orientation == 'vertical') {
	                this.orientation = 'vertical';
	            }
	
	            this.event.trigger('orientation', orientation);
	        }
	    }, {
	        key: 'updateCoin',
	        value: function updateCoin(value) {
	            var orientation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.orientation;
	
	            if (this.factory.present[orientation]) {
	                this.factory.present[orientation].updateCoin(value);
	            }
	        }
	    }, {
	        key: 'enter',
	        value: function enter() {
	            var orientation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.orientation;
	
	            if (this.factory.present[orientation]) {
	                this.factory.present[orientation].enter();
	            }
	        }
	    }, {
	        key: 'leave',
	        value: function leave() {
	            var orientation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.orientation;
	
	            if (this.factory.present[orientation]) {
	                this.factory.present[orientation].leave();
	            }
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            var orientation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.orientation;
	
	            if (this.factory.present[orientation]) {
	                this.factory.present[orientation].hide();
	            }
	        }
	    }, {
	        key: 'setVerticalEffectTop',
	        value: function setVerticalEffectTop(top) {
	            this.factory.effect.setVerticalEffectTop(top);
	        }
	    }]);
	    return PresentUI;
	}();
	// import verticalEffect from './verticalEffect/verticalEffect';
	
	
	exports.default = PresentUI;

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(114);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(115), __esModule: true };

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(116);
	var $Object = __webpack_require__(12).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(20), 'Object', { defineProperty: __webpack_require__(16).f });


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Queue = function () {
	    function Queue(_ref) {
	        var _ref$maxPending = _ref.maxPending,
	            maxPending = _ref$maxPending === undefined ? Infinity : _ref$maxPending,
	            _ref$maxQueue = _ref.maxQueue,
	            maxQueue = _ref$maxQueue === undefined ? Infinity : _ref$maxQueue;
	        (0, _classCallCheck3.default)(this, Queue);
	
	        this.promise = window ? window.Promise : _promise2.default;
	        this.pending = 0;
	        this.queue = [];
	        this.maxPending = maxPending;
	        this.maxQueue = maxQueue;
	        this.state = 'start';
	    }
	
	    (0, _createClass3.default)(Queue, [{
	        key: 'add',
	        value: function add(promise) {
	
	            // return new Promise((resolve, reject) => {
	
	            if (this.queue.length >= this.maxQueue) {
	                console.log('Queue limit');
	                return;
	            }
	
	            this.queue.push(promise);
	
	            this._runQueue();
	            // })
	        }
	    }, {
	        key: 'play',
	        value: function play() {
	            this.state = 'start';
	            this._runQueue();
	        }
	    }, {
	        key: 'pause',
	        value: function pause() {
	            this.state = 'stop';
	        }
	    }, {
	        key: '_runQueue',
	        value: function _runQueue() {
	            var _this = this;
	
	            if (this.pending >= this.maxPending) {
	                return false;
	            }
	
	            if (this.state == 'stop') {
	                return false;
	            }
	
	            var _pendingPromise = this.queue.shift();
	
	            if (!_pendingPromise) {
	                return false;
	            }
	
	            try {
	                this.pending++;
	                this.resolve(_pendingPromise()).then(function (value) {
	                    _this.pending--;
	                    _this._runQueue();
	                }, function (err) {
	                    _this.pending--;
	                    _this._runQueue();
	                });
	            } catch (err) {
	                this.pending--;
	                this._runQueue();
	            }
	
	            return true;
	        }
	    }, {
	        key: 'resolve',
	        value: function resolve(value) {
	            return this.promise.resolve(value);
	        }
	    }, {
	        key: 'promiseContext',
	        set: function set(promiseContext) {
	            this.promise = promiseContext;
	        }
	    }, {
	        key: 'pendingLength',
	        get: function get() {
	            return this.pending;
	        }
	    }, {
	        key: 'queueLength',
	        get: function get() {
	            return this.queue.length;
	        }
	    }, {
	        key: 'currentQueue',
	        get: function get() {
	            return this.queue;
	        }
	    }, {
	        key: 'remainQueueLength',
	        get: function get() {
	
	            if (this.maxQueue == 0) return 0;else {
	                var _len = this.maxQueue - this.queue.length - this.pending;
	                return _len < 0 ? 0 : _len;
	            }
	        }
	    }]);
	    return Queue;
	}();
	
	exports.default = Queue;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _eventBus = __webpack_require__(119);
	
	var _eventBus2 = _interopRequireDefault(_eventBus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Present = function () {
	    function Present() {
	        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var message = arguments[1];
	        (0, _classCallCheck3.default)(this, Present);
	
	        this.presentDatas = [];
	        this.message = message || {};
	        this.init(config);
	    }
	
	    (0, _createClass3.default)(Present, [{
	        key: 'init',
	        value: function init(config) {
	            // this.message = config.message;
	            // this.receivePresentDatasFromMessageCenter();
	            this.event = _eventBus2.default;
	            this.initCustomEvent();
	        }
	    }, {
	        key: 'initCustomEvent',
	        value: function initCustomEvent() {
	            this.receiveUserBalanceFromMessageCenter();
	            this.receiveSilverDateFromMessageCenter();
	            this.receivePresentDatasFromMessageCenter();
	
	            this.event.on('send-present', this.boardcastPresentDataToMessageCenter.bind(this));
	            this.event.on('send-goldEggData', this.boardcastSliverDataToMessageCenter.bind(this));
	        }
	
	        //[{ "id": 0, "type": "rose", "giftName": "玫瑰", "level": 1, "serial": 1, "personName": "aaa" }]
	        //广播礼物数据到消息中心
	
	    }, {
	        key: 'boardcastPresentDataToMessageCenter',
	        value: function boardcastPresentDataToMessageCenter(presentData) {
	            var _this = this;
	
	            var _resHandle = function _resHandle(fn) {
	                return function (res) {
	                    if (res.code != 1) {
	                        return;
	                    }
	                    console.log('\u63A5\u53D7res.data');
	                    if (fn) return fn(res.data);else return;
	                };
	            };
	
	            this.message.send('gift', 102, presentData).then(_resHandle()).catch(function (error) {
	                return console.log(error);
	            });
	        }
	
	        // 从消息中心接受礼物数据
	
	    }, {
	        key: 'receivePresentDatasFromMessageCenter',
	        value: function receivePresentDatasFromMessageCenter() {
	            var _this2 = this;
	
	            var _this = this;
	            var _resHandle = function _resHandle(res) {
	                if (res.code != 1) {
	                    console.log(res.message);
	                    return;
	                }
	                // console.log(res.data)
	                _this2._addPresentData(res.data);
	                _this2.event.trigger('receive-presentDatas', _this2.presentDatas);
	            };
	            this.message.on('gift:list', 204, _resHandle);
	        }
	
	        // 注册当前用户发送礼物事件
	        // registerCurrentUserSendPresentData(fn) {
	        //     let _resHandle = function(fn) {
	        //         return (res) => {
	        //             if (res.code != 1) {
	        //                 return;
	        //             }
	        //             console.log(res.data)
	        //             // this._addPresentData(res.data)
	        //             // return fn(res.data);
	        //         }
	        //     }
	        //     this.message.on('gift:list', 203, _resHandle(fn));
	        // }
	
	        // 广播金蛋数据到消息中心
	
	    }, {
	        key: 'boardcastSliverDataToMessageCenter',
	        value: function boardcastSliverDataToMessageCenter(sliverData) {
	            var _this = this;
	            return this.message.send('gift', 101, sliverData).then(function (data) {
	                console.log(data);
	                return data;
	            }).catch(function (error) {
	                return console.log(error);
	            });
	        }
	
	        // 从消息中心接受金蛋数据
	
	    }, {
	        key: 'receiveSilverDateFromMessageCenter',
	        value: function receiveSilverDateFromMessageCenter() {
	            var _this3 = this;
	
	            console.log(2222);
	            var _this = this;
	            var _resHandle = function _resHandle(res) {
	                if (res.code != 1) {
	                    console.log(res.message);
	                    return;
	                }
	                console.log(res.data);
	                // _this.boardcastSliverDataToMessageCenter({id:res.data.id})
	                _this3.event.trigger('recieve-goldEggData', res.data);
	            };
	
	            this.message.on('gift:sliver', 202, _resHandle);
	        }
	
	        // 从消息中心获取用户余额信息
	
	    }, {
	        key: 'receiveUserBalanceFromMessageCenter',
	        value: function receiveUserBalanceFromMessageCenter(fn) {
	            var _this = this;
	            var _resHandle = function _resHandle(res) {
	                if (res.code != 1) {
	                    console.log(res.message);
	                    return;
	                }
	                console.log('203======>', res.data);
	                _this.event.trigger('present-user-balance', res.data);
	            };
	
	            this.message.on('gift:user', 201, _resHandle);
	            this.message.on('gift:balance', 203, _resHandle);
	        }
	
	        // 添加礼物数据
	
	    }, {
	        key: '_addPresentData',
	        value: function _addPresentData() {
	            var datas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            if (!datas.length) return;
	
	            var _data = zipArray(this.presentDatas, datas.map(unzipObject));
	            // console.log(_data[0])
	            this.presentDatas = _data;
	            // console.log(this.presentDatas)
	        }
	
	        // 通过comboid获得礼物数据
	
	    }, {
	        key: 'getPresentDataByComboid',
	        value: function getPresentDataByComboid(comboid) {
	
	            if (!comboid) return;
	
	            if (this.presentDatas.length) {
	                var _data = this.presentDatas.filter(function (d) {
	                    return d.comboid === comboid;
	                });
	                if (_data.length) {
	                    return _data[0];
	                } else {
	                    return {};
	                }
	            }
	
	            return {};
	        }
	    }, {
	        key: 'getPresentDatas',
	        value: function getPresentDatas() {
	            return this.presentDatas;
	        }
	    }, {
	        key: 'removePresentData',
	        value: function removePresentData(data) {
	            var _index = null;
	            // console.log(`removebefore=====>${this.presentDatas.length}`);
	            // console.log(data,this.presentDatas[0])
	            for (var i = 0; i < this.presentDatas.length; i++) {
	                var _comboid = this.presentDatas[i].comboid;
	                var _combo = this.presentDatas[i].combo;
	                // console.log(this.presentDatas[i])
	                if (_comboid == data.comboid && _combo == data.combo) {
	
	                    this.presentDatas.splice(i, 1);
	                    i--;
	                }
	            }
	
	            // console.log(`removeafter=====>${this.presentDatas.length}`);
	        }
	    }, {
	        key: 'isLogin',
	        value: function isLogin() {
	            return this.message.getUser().then(function (res) {
	                if (res.type == 'user') {
	                    return 'user';
	                } else if (res.type == 'guest') {
	                    return 'guest';
	                }
	            });
	        }
	    }]);
	    return Present;
	}();
	
	exports.default = Present;
	
	// 格式化礼物数据
	
	function unzipObject() {
	    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    // console.log(JSON.stringify(obj))
	    if (obj.gift && obj.gift.comboid) {
	        return {
	            id: obj.gift.id,
	            comboid: obj.gift.comboid,
	            combo: obj.gift.combo,
	            nickname: obj.user.nickname,
	            avatar: obj.user.avatar
	        };
	    }
	
	    return {};
	}
	
	// 合并接收到的礼物数据到当前礼物数据池
	function zipArray() {
	    var map = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var map1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    // console.log(map1)
	    // let map = map;
	    // let map1 = map1;
	    if (!map.length) {
	        if (map1.length) {
	            return map1;
	        } else {
	            return [];
	        }
	    }
	
	    for (var i = 0; i < map.length; i++) {
	        var _m = map[i];
	        if (_m && _m.comboid) {
	
	            for (var j = 0; j < map1.length; j++) {
	                var _m1 = map1[j];
	                if (_m1 && _m1.comboid) {
	
	                    if (_m.comboid === _m1.comboid) {
	                        if (_m1.combo > _m.combo) {
	                            map[i] = _m1;
	                        }
	
	                        map1.splice(j, 1);
	                        j--;
	                    }
	                } else {
	                    map1.splice(j, 1);
	                    j--;
	                }
	            }
	        }
	    }
	    // console.log(map,map1)
	    if (map1.length) {
	        return map.concat(map1);
	    }
	
	    return map;
	}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fCore = __webpack_require__(104);
	
	var _fCore2 = _interopRequireDefault(_fCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = new _fCore2.default();

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(105);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(121);
	
	var _verticalPresent = __webpack_require__(127);
	
	var _verticalPresent2 = _interopRequireDefault(_verticalPresent);
	
	var _eventBus = __webpack_require__(119);
	
	var _eventBus2 = _interopRequireDefault(_eventBus);
	
	var _fComponent = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import animate from './animate';
	
	var verticalPresent = function () {
	    function verticalPresent(presentInfo, clientOptions) {
	        (0, _classCallCheck3.default)(this, verticalPresent);
	
	        this.presentInfo = presentInfo;
	        this.clientOptions = clientOptions;
	
	        this.boxDom = null; // 总容器
	        this.containerDom = null; // 礼物容器
	        this.btn = null; // 发送按钮
	
	        this.coinDom = null;
	        this.userCoin = '0';
	        this.oneSecLimit;
	
	        this.width = document.documentElement.clientWidth;
	        this.height = document.documentElement.clientHeight;
	
	        this.containerHeight = null;
	        this.event = _eventBus2.default;
	
	        this.countdownTimer = {};
	        this.sendBtnTime = null;
	
	        this.currentPresentId = null;
	
	        this.userType = 'guest';
	        this.init();
	    }
	
	    (0, _createClass3.default)(verticalPresent, [{
	        key: 'init',
	        value: function init(presentInfo) {
	
	            if (!presentInfo && !this.presentInfo) {
	                console.log('礼物信息错误');
	                return;
	            }
	
	            presentInfo && (this.presentInfo = presentInfo);
	
	            this.initDom(this.presentInfo);
	            this.initEvent();
	            this.initCustomEvent();
	        }
	    }, {
	        key: 'initDom',
	        value: function initDom(presentInfo) {
	
	            if (!presentInfo.length) {
	                console.log('礼物信息格式错误，需要为Array');
	                return;
	            }
	
	            this.boxDom = $(this.renderVerticalPresentTpl());
	            this.containerDom = this.boxDom.find('.container');
	            this.barDom = this.boxDom.find('.bar');
	            this.btnDom = this.boxDom.find('.btn');
	            this.coinDom = this.boxDom.find('.num');
	
	            $('body').append(this.boxDom);
	
	            var _this = this;
	
	            this.barDom.on('touchend', '.money', function () {
	                if (_this.userType == 'guest' || typeof _this.clientOptions.guid == 'undefined') {
	                    _this.event.trigger('present-login');
	                    return false;
	                } else {
	                    var param = {
	                        guid: _this.clientOptions.guid,
	                        token: _this.clientOptions.token,
	                        deviceid: _this.clientOptions.deviceid_real,
	                        os: _this.clientOptions.os
	                    };
	                    var paramStr = '?os=' + _this.clientOptions.os;
	                    (0, _keys2.default)(param).forEach(function (key, index) {
	                        paramStr += '&' + key + '=' + param[key];
	                    });
	                    window.ground.dispatch("web", "https://user.iclient.ifeng.com/user_tasks/credit" + paramStr); // 跳转金币任务页
	                }
	            });
	
	            this.containerHeight = this.containerDom.height();
	
	            (0, _fComponent.Transform)(this.containerDom[0]);
	            (0, _fComponent.Transform)(this.btnDom[0]);
	        }
	    }, {
	        key: 'renderVerticalPresentTpl',
	        value: function renderVerticalPresentTpl() {
	            return this.renderVerticalPresent(this.formatPresentInfo(this.presentInfo, this.userCoin));
	        }
	    }, {
	        key: 'formatPresentInfo',
	        value: function formatPresentInfo(presentInfo, userCoin) {
	            return { data: presentInfo, coin: userCoin };
	        }
	    }, {
	        key: 'initEvent',
	        value: function initEvent(presentInfo) {
	            // this.bindEnterEvent();
	            this.bindLeaveEvent();
	            this.bindBtnEvent();
	            this.bindSelectPresentEvent();
	            this.initCountdownPresent();
	        }
	    }, {
	        key: 'bindSelectPresentEvent',
	        value: function bindSelectPresentEvent() {
	            var _this = this;
	            this.containerDom.on('touchend', '.item', function () {
	
	                var _id = $(this).data('id');
	                var _present = _this.presentInfo.filter(function (_p) {
	                    return _p.id == _id;
	                });
	
	                if (_this.userType == 'guest' || typeof _this.clientOptions.guid == 'undefined') {
	                    if (_present[0].type != 'countdown') {
	                        _this.currentPresentId = _id;
	                        $(this).siblings().find('.item-icon').removeClass('select');
	                        $(this).find('.item-icon').addClass('select');
	                    } else if (_present[0].type == 'countdown') {
	                        if ($(this).find('.item-info span').text() == 0) {
	                            _this.currentPresentId = _id;
	                            $(this).siblings().find('.item-icon').removeClass('select');
	                            $(this).find('.item-icon').addClass('select');
	                        } else {
	                            _this.currentPresentId = null;
	                            $(this).siblings().find('.item-icon').removeClass('select');
	                        }
	                    }
	                    _this.btnDom.removeClass('forbid');
	                    return false;
	                }
	
	                if (!_present.length) {
	                    return false;
	                } else {
	                    if (_present[0].type != 'countdown') {
	                        _this.currentPresentId = _id;
	                        $(this).siblings().find('.item-icon').removeClass('select');
	                        $(this).find('.item-icon').addClass('select');
	
	                        if (_present[0].price <= _this.userCoin) {
	                            _this.btnDom.removeClass('forbid');
	                        } else {
	                            _this.btnDom.addClass('forbid');
	                        }
	                    } else if (_present[0].type == 'countdown') {
	                        if ($(this).find('.item-info span').text() == 0) {
	                            _this.currentPresentId = _id;
	                            $(this).siblings().find('.item-icon').removeClass('select');
	                            $(this).find('.item-icon').addClass('select');
	                            _this.btnDom.removeClass('forbid');
	                        } else {
	                            _this.currentPresentId = null;
	                            $(this).siblings().find('.item-icon').removeClass('select');
	                            _this.btnDom.addClass('forbid');
	                        }
	                    }
	                }
	
	                return false;
	            });
	        }
	    }, {
	        key: 'bindBtnEvent',
	        value: function bindBtnEvent() {
	            this.btnDom.on('touchstart', this.btnAnimateStart.bind(this));
	            this.btnDom.on('touchmove', this.btnAnimateStart.bind(this));
	            this.btnDom.on('touchend', this.sendPresentInfo.bind(this));
	        }
	    }, {
	        key: 'bindLeaveEvent',
	        value: function bindLeaveEvent() {
	            this.containerDom.on('touchend', function () {
	                return false;
	            });
	            // this.barDom.on('touchend', () => false);
	            this.boxDom.on('touchend', this.leave.bind(this));
	        }
	    }, {
	        key: 'initCustomEvent',
	        value: function initCustomEvent() {
	            this.event.on('isLogin', this.login.bind(this));
	            this.event.on('present-user-balance', this.updateUserCoin.bind(this));
	            this.event.on('countdown', this.countdownStart.bind(this));
	        }
	    }, {
	        key: 'login',
	        value: function login(type) {
	            console.log(type);
	            if (type == 'user') {
	                this.userType = 'user';
	                this.btnDom.addClass('forbid');
	            } else if (type == 'guest') {
	                this.userType = 'guest';
	                this.btnDom.removeClass('forbid');
	            }
	        }
	    }, {
	        key: 'initCountdownPresent',
	        value: function initCountdownPresent() {
	            var _this2 = this;
	
	            this.presentInfo.filter(function (_p) {
	                return _p.type == 'countdown';
	            }).forEach(function (_p) {
	                _this2.countdownStart(_p.id);
	            });
	        }
	    }, {
	        key: 'formatCoin',
	        value: function formatCoin(value) {
	            return (value + '').split('.')[0];
	        }
	    }, {
	        key: 'updateCoin',
	        value: function updateCoin(value) {
	            this.userCoin = this.formatCoin(value);
	            this.coinDom && this.coinDom.text(this.userCoin);
	        }
	    }, {
	        key: 'updateUserCoin',
	        value: function updateUserCoin(obj) {
	            var _balance = obj.balance;
	            this.userCoin = this.formatCoin(_balance.sliver);
	            this.coinDom.text(this.userCoin);
	        }
	
	        // 处理送礼物1s延迟
	
	    }, {
	        key: 'handleOneSecLimit',
	        value: function handleOneSecLimit() {
	            var _this3 = this;
	
	            this.oneSecLimit = true;
	            this.btnDom.addClass('forbid');
	            setTimeout(function () {
	                _this3.btnDom.removeClass('forbid');
	                _this3.oneSecLimit = false;
	            }, 1000);
	        }
	    }, {
	        key: 'sendPresentInfo',
	        value: function sendPresentInfo() {
	            var _this4 = this;
	
	            if (this.userType == 'guest' || typeof this.clientOptions.guid == 'undefined') {
	                this.btnAnimateEnd();
	                this.event.trigger('present-login');
	                return false;
	            }
	
	            var _present = this.presentInfo.filter(function (_p) {
	                return _p.id == _this4.currentPresentId;
	            });
	            if (_present.length) {
	                if (this.sendBtnTime) {
	                    this.sendBtnTime = Date.now();
	                } else if (Date.now() - this.sendBtnTime > 500) {
	                    this.btnAnimateEnd();
	                }
	                if (_present[0].type == 'countdown') {
	                    // console.log(`sendCountdown`)
	                    this.containerDom.find('.item-icon').removeClass('select');
	                    this.btnDom.removeClass('forbid');
	                    this.event.trigger('countdown', this.currentPresentId);
	                    this.event.trigger('send-present', { id: this.currentPresentId, count: 1 });
	                    this.currentPresentId = null;
	                    this.btnAnimateEnd();
	                } else {
	                    if (this.btnDom.hasClass('forbid') || this.oneSecLimit) {
	                        return false;
	                    }
	                    if (this.userCoin === '0') {
	                        this.btnDom.addClass('forbid');
	                        return false;
	                    }
	                    this.event.trigger('send-present', { id: this.currentPresentId, count: 1 });
	
	                    this.handleOneSecLimit();
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: 'btnAnimateStart',
	        value: function btnAnimateStart() {
	            if (this.btnDom.hasClass('forbid')) {
	                return false;
	            }
	            this.btnDom[0].scaleX = this.btnDom[0].scaleY = 0.8;
	        }
	    }, {
	        key: 'btnAnimateEnd',
	        value: function btnAnimateEnd() {
	            var __thisbtn = this.btnDom;
	            __thisbtn[0].scaleX = this.btnDom[0].scaleY = 1;
	            // this.btnDom.animate({scaleX:1,scaleY:1}, 300);
	        }
	    }, {
	        key: 'countdownStart',
	        value: function countdownStart(present_id) {
	            var _this5 = this;
	
	            var _present = this.presentInfo.filter(function (_p) {
	                return _p.id == present_id;
	            });
	
	            if (_present.length && _present[0].type == 'countdown') {
	                // console.log(`countdownStart`)
	                var _time = _present[0].countdown;
	                var _item = this.containerDom.find('[data-id=' + present_id + '] .item-info span');
	
	                clearInterval(this.countdownTimer.present_id);
	                this.countdownTimer.present_id = null;
	
	                this.countdownTimer.present_id = setInterval(function () {
	                    if (_time <= 0) {
	                        _item.text('0');
	                        clearInterval(_this5.countdownTimer.present_id);
	                    }
	                    _item.text(_time);
	                    _time--;
	                }, 1000);
	            }
	
	            return false;
	        }
	    }, {
	        key: 'enter',
	        value: function enter() {
	            this.containerDom[0].translateY = this.containerHeight;
	            this.boxDom.show();
	            this.containerDom.animate({ translateY: 0 }, 200);
	        }
	    }, {
	        key: 'leave',
	        value: function leave() {
	            var _this6 = this;
	
	            this.containerDom.animate({ translateY: this.containerHeight }, 200, function () {
	                // this.containerDom[0].translateY = 0;
	                _this6.boxDom.hide();
	            });
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.boxDom.hide();
	        }
	    }, {
	        key: 'renderVerticalPresent',
	        value: function renderVerticalPresent(presentInfo) {
	            return (0, _verticalPresent2.default)(presentInfo);
	        }
	    }]);
	    return verticalPresent;
	}();
	
	exports.default = verticalPresent;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div id=\"vertical_present_box\" class=\"vertical_present_box\">\n    <div class=\"select_box\">\n        <div class=\"container\">\n        ")
	    ;  for(var i = 0; i < data.length; i++) {
	    ; __append("\n            <div class=\"item bdr-r\" data-id=\"")
	    ; __append(escape(data[i].id))
	    ; __append("\">\n                <span class=\"item-icon\"></span>\n                <div class=\"item-img\" style=\"background-image: url(")
	    ; __append(escape(data[i].pic))
	    ; __append(")\">\n                    <!-- <img src=\"../images/1.png\"> -->\n                </div>\n                <div class=\"item-name\">")
	    ; __append(escape(data[i].name))
	    ; __append("</div>\n                <div class=\"item-info\">\n                ")
	    ;  if(data[i].type == 'countdown') { 
	    ; __append("\n                    <span>")
	    ; __append(escape(data[i].countdown))
	    ; __append("</span>秒\n                ")
	    ;  } else { 
	    ; __append("\n                    <span>")
	    ; __append(escape(data[i].price))
	    ; __append("</span>币\n                ")
	    ;  } 
	    ; __append("\n                </div>\n            </div>\n        ")
	    ;  } 
	    ; __append("\n        </div>\n        <div class=\"bar\">\n            <div class=\"money\">\n                余额: <span class=\"num\">")
	    ; __append(escape(coin))
	    ; __append("</span>金币\n                <span class=\"icon\"></span>\n            </div>\n            <div class=\"btn js_btn\">发送</div>\n        </div>\n    </div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createUid = exports.AntiTheft = exports.RAF = exports.Tween = exports.Transform = undefined;
	
	var _css3transform = __webpack_require__(129);
	
	var _css3transform2 = _interopRequireDefault(_css3transform);
	
	var _Tween = __webpack_require__(130);
	
	var _Tween2 = _interopRequireDefault(_Tween);
	
	var _requestAnimationFrame = __webpack_require__(132);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _antiTheft = __webpack_require__(133);
	
	var _antiTheft2 = _interopRequireDefault(_antiTheft);
	
	var _gid = __webpack_require__(144);
	
	var _gid2 = _interopRequireDefault(_gid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Transform = _css3transform2.default;
	exports.Tween = _Tween2.default;
	exports.RAF = _requestAnimationFrame2.default;
	exports.AntiTheft = _antiTheft2.default;
	exports.createUid = _gid2.default;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	/* transformjs 1.1.6
	 * By dntzhang
	 * Github: https://github.com/AlloyTeam/AlloyTouch/tree/master/transformjs
	 */
	; (function () {
	
	    var DEG_TO_RAD =  0.017453292519943295;
	
	    var Matrix3D = function (n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
	        this.elements = window.Float32Array ? new Float32Array(16) : [];
	        var te = this.elements;
	        te[0] = (n11 !== undefined) ? n11 : 1; te[4] = n12 || 0; te[8] = n13 || 0; te[12] = n14 || 0;
	        te[1] = n21 || 0; te[5] = (n22 !== undefined) ? n22 : 1; te[9] = n23 || 0; te[13] = n24 || 0;
	        te[2] = n31 || 0; te[6] = n32 || 0; te[10] = (n33 !== undefined) ? n33 : 1; te[14] = n34 || 0;
	        te[3] = n41 || 0; te[7] = n42 || 0; te[11] = n43 || 0; te[15] = (n44 !== undefined) ? n44 : 1;
	    };
	
	
	    Matrix3D.prototype = {
	        set: function (n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
	            var te = this.elements;
	            te[0] = n11; te[4] = n12; te[8] = n13; te[12] = n14;
	            te[1] = n21; te[5] = n22; te[9] = n23; te[13] = n24;
	            te[2] = n31; te[6] = n32; te[10] = n33; te[14] = n34;
	            te[3] = n41; te[7] = n42; te[11] = n43; te[15] = n44;
	            return this;
	        },
	        identity: function () {
	            this.set(
	                1, 0, 0, 0,
	                0, 1, 0, 0,
	                0, 0, 1, 0,
	                0, 0, 0, 1
	            );
	            return this;
	        },
	        multiplyMatrices: function (a, be) {
	
	            var ae = a.elements;
	            var te = this.elements;
	            var a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
	            var a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
	            var a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
	            var a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
	
	            var b11 = be[0], b12 = be[1], b13 = be[2], b14 = be[3];
	            var b21 = be[4], b22 = be[5], b23 = be[6], b24 = be[7];
	            var b31 = be[8], b32 = be[9], b33 = be[10], b34 = be[11];
	            var b41 = be[12], b42 = be[13], b43 = be[14], b44 = be[15];
	
	            te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
	            te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
	            te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
	            te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
	
	            te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
	            te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
	            te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
	            te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
	
	            te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
	            te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
	            te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
	            te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
	
	            te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
	            te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
	            te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
	            te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
	
	            return this;
	
	        },
	        // 解决角度为90的整数倍导致Math.cos得到极小的数，其实是0。导致不渲染
	        _rounded: function (value, i) {
	            i = Math.pow(10, i || 15);
	            // default
	            return Math.round(value * i) / i;
	        },
	        _arrayWrap: function (arr) {
	            return window.Float32Array ? new Float32Array(arr) : arr;
	        },
	        appendTransform: function (x, y, z, scaleX, scaleY, scaleZ, rotateX, rotateY, rotateZ, skewX, skewY, originX, originY, originZ) {
	
	            var rx = rotateX * DEG_TO_RAD;
	            var cosx = this._rounded(Math.cos(rx));
	            var sinx = this._rounded(Math.sin(rx));
	            var ry = rotateY * DEG_TO_RAD;
	            var cosy = this._rounded(Math.cos(ry));
	            var siny = this._rounded(Math.sin(ry));
	            var rz = rotateZ * DEG_TO_RAD;
	            var cosz = this._rounded(Math.cos(rz * -1));
	            var sinz = this._rounded(Math.sin(rz * -1));
	
	            this.multiplyMatrices(this, this._arrayWrap([
	                1, 0, 0, x,
	                0, cosx, sinx, y,
	                0, -sinx, cosx, z,
	                0, 0, 0, 1
	            ]));
	
	            this.multiplyMatrices(this, this._arrayWrap([
	                cosy, 0, siny, 0,
	                0, 1, 0, 0,
	                -siny, 0, cosy, 0,
	                0, 0, 0, 1
	            ]));
	
	            this.multiplyMatrices(this, this._arrayWrap([
	                cosz * scaleX, sinz * scaleY, 0, 0,
	                -sinz * scaleX, cosz * scaleY, 0, 0,
	                0, 0, 1 * scaleZ, 0,
	                0, 0, 0, 1
	            ]));
	
	            if (skewX || skewY) {
	                this.multiplyMatrices(this, this._arrayWrap([
	                    this._rounded(Math.cos(skewX * DEG_TO_RAD)), this._rounded(Math.sin(skewX * DEG_TO_RAD)), 0, 0,
	                    -1 * this._rounded(Math.sin(skewY * DEG_TO_RAD)), this._rounded(Math.cos(skewY * DEG_TO_RAD)), 0, 0,
	                    0, 0, 1, 0,
	                    0, 0, 0, 1
	                ]));
	            }
	
	
	            if (originX || originY || originZ) {
	                this.elements[12] -= originX * this.elements[0] + originY * this.elements[4] + originZ * this.elements[8];
	                this.elements[13] -= originX * this.elements[1] + originY * this.elements[5] + originZ * this.elements[9];
	                this.elements[14] -= originX * this.elements[2] + originY * this.elements[6] + originZ * this.elements[10];
	            }
	            return this;
	        }
	    };
	
	    var Matrix2D = function(a, b, c, d, tx, ty) {
	        this.a = a == null ? 1 : a;
	        this.b = b || 0;
	        this.c = c || 0;
	        this.d = d == null ? 1 : d;
	        this.tx = tx || 0;
	        this.ty = ty || 0;
	        return this;
	    };
	
	    Matrix2D.prototype = {
	        identity : function() {
	            this.a = this.d = 1;
	            this.b = this.c = this.tx = this.ty = 0;
	            return this;
	        },
	        appendTransform : function(x, y, scaleX, scaleY, rotation, skewX, skewY, originX, originY) {
	            if (rotation % 360) {
	                var r = rotation * DEG_TO_RAD;
	                var cos = Math.cos(r);
	                var sin = Math.sin(r);
	            } else {
	                cos = 1;
	                sin = 0;
	            }
	            if (skewX || skewY) {
	                skewX *= DEG_TO_RAD;
	                skewY *= DEG_TO_RAD;
	                this.append(Math.cos(skewY), Math.sin(skewY), -Math.sin(skewX), Math.cos(skewX), x, y);
	                this.append(cos * scaleX, sin * scaleX, -sin * scaleY, cos * scaleY, 0, 0);
	            } else {
	                this.append(cos * scaleX, sin * scaleX, -sin * scaleY, cos * scaleY, x, y);
	            }
	            if (originX || originY) {
	                this.tx -= originX * this.a + originY * this.c;
	                this.ty -= originX * this.b + originY * this.d;
	            }
	            return this;
	        },
	        append : function(a, b, c, d, tx, ty) {
	            var a1 = this.a;
	            var b1 = this.b;
	            var c1 = this.c;
	            var d1 = this.d;
	            this.a = a * a1 + b * c1;
	            this.b = a * b1 + b * d1;
	            this.c = c * a1 + d * c1;
	            this.d = c * b1 + d * d1;
	            this.tx = tx * a1 + ty * c1 + this.tx;
	            this.ty = tx * b1 + ty * d1 + this.ty;
	            return this;
	        },
	        initialize : function(a, b, c, d, tx, ty) {
	            this.a = a;
	            this.b = b;
	            this.c = c;
	            this.d = d;
	            this.tx = tx;
	            this.ty = ty;
	            return this;
	        },
	        setValues : function(a, b, c, d, tx, ty) {
	            this.a = a == null ? 1 : a;
	            this.b = b || 0;
	            this.c = c || 0;
	            this.d = d == null ? 1 : d;
	            this.tx = tx || 0;
	            this.ty = ty || 0;
	            return this;
	        },
	        copy : function(matrix) {
	            return this.setValues(matrix.a, matrix.b, matrix.c, matrix.d, matrix.tx, matrix.ty);
	        }
	    };
	
	    function observe(target, props, callback) {
	        for (var i = 0, len = props.length; i < len; i++) {
	            var prop = props[i];
	            watch(target, prop, callback);
	        }
	    }
	
	    function watch(target, prop, callback) {
	        Object.defineProperty(target, prop, {
	            get: function () {
	                return this["_" + prop];
	            },
	            set: function (value) {
	                this["_" + prop] = value;
	                callback();
	            }
	        });
	    }
	
	    function isElement(o) {
	        return (
	            typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
	            o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string"
	        );
	    }
	
	    function Transform(obj, notPerspective) {
	        if(obj.___mixCSS3Transform) return;
	        var observeProps = ["translateX", "translateY", "translateZ", "scaleX", "scaleY", "scaleZ", "rotateX", "rotateY", "rotateZ", "skewX", "skewY", "originX", "originY", "originZ"],
	            objIsElement = isElement(obj);
	        if (!notPerspective) {
	            observeProps.push("perspective");
	        }
	        obj.___mixCSS3Transform = true
	        observe(
	            obj,
	            observeProps,
	            function () {
	                var mtx = obj.matrix3d.identity().appendTransform(obj.translateX, obj.translateY, obj.translateZ, obj.scaleX, obj.scaleY, obj.scaleZ, obj.rotateX, obj.rotateY, obj.rotateZ, obj.skewX, obj.skewY, obj.originX, obj.originY, obj.originZ);
	                var transform = (notPerspective ? "" : "perspective(" + obj.perspective + "px) ") + "matrix3d(" + Array.prototype.slice.call(mtx.elements).join(",") + ")";
	                if (objIsElement) {
	                    obj.style.transform = obj.style.msTransform = obj.style.OTransform = obj.style.MozTransform = obj.style.webkitTransform = transform;
	                } else {
	                    obj.transform = transform;
	                }
	            });
	
	        obj.matrix3d = new Matrix3D();
	        if (!notPerspective) {
	            obj.perspective = 500;
	        }
	        obj.scaleX = obj.scaleY = obj.scaleZ = 1;
	        //由于image自带了x\y\z，所有加上translate前缀
	        obj.translateX = obj.translateY = obj.translateZ = obj.rotateX = obj.rotateY = obj.rotateZ = obj.skewX = obj.skewY = obj.originX = obj.originY = obj.originZ = 0;
	    }
	
	    Transform.getMatrix3D = function (option) {
	        var defaultOption = {
	            translateX: 0,
	            translateY: 0,
	            translateZ: 0,
	            rotateX: 0,
	            rotateY: 0,
	            rotateZ: 0,
	            skewX: 0,
	            skewY: 0,
	            originX: 0,
	            originY: 0,
	            originZ: 0,
	            scaleX: 1,
	            scaleY: 1,
	            scaleZ: 1
	        };
	        for (var key in option) {
	            if (option.hasOwnProperty(key)) {
	                defaultOption[key] = option[key];
	            }
	        }
	        return new Matrix3D().identity().appendTransform(defaultOption.translateX, defaultOption.translateY, defaultOption.translateZ, defaultOption.scaleX, defaultOption.scaleY, defaultOption.scaleZ, defaultOption.rotateX, defaultOption.rotateY, defaultOption.rotateZ, defaultOption.skewX, defaultOption.skewY, defaultOption.originX, defaultOption.originY, defaultOption.originZ).elements;
	
	    }
	
	    Transform.getMatrix2D = function(option){
	        var defaultOption = {
	            translateX: 0,
	            translateY: 0,
	            rotation: 0,
	            skewX: 0,
	            skewY: 0,
	            originX: 0,
	            originY: 0,
	            scaleX: 1,
	            scaleY: 1
	        };
	        for (var key in option) {
	            if (option.hasOwnProperty(key)) {
	                defaultOption[key] = option[key];
	            }
	        }
	        return new Matrix2D().identity().appendTransform(defaultOption.translateX, defaultOption.translateY, defaultOption.scaleX, defaultOption.scaleY, defaultOption.rotation, defaultOption.skewX, defaultOption.skewY, defaultOption.originX, defaultOption.originY);
	    }
	
	    if (true) {
	        module.exports = Transform;
	    }else {
	        window.Transform = Transform;
	    }
	})();

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var _typeof2 = __webpack_require__(1);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Tween.js - Licensed under the MIT license
	 * https://github.com/tweenjs/tween.js
	 * ----------------------------------------------
	 *
	 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
	 * Thank you all, you're awesome!
	 */
	
	var TWEEN = TWEEN || function () {
	
		var _tweens = [];
	
		return {
	
			getAll: function getAll() {
	
				return _tweens;
			},
	
			removeAll: function removeAll() {
	
				_tweens = [];
			},
	
			add: function add(tween) {
	
				_tweens.push(tween);
			},
	
			remove: function remove(tween) {
	
				var i = _tweens.indexOf(tween);
	
				if (i !== -1) {
					_tweens.splice(i, 1);
				}
			},
	
			update: function update(time, preserve) {
	
				if (_tweens.length === 0) {
					return false;
				}
	
				var i = 0;
	
				time = time !== undefined ? time : TWEEN.now();
	
				while (i < _tweens.length) {
	
					if (_tweens[i].update(time) || preserve) {
						i++;
					} else {
						_tweens.splice(i, 1);
					}
				}
	
				return true;
			}
		};
	}();
	
	// Include a performance.now polyfill.
	// In node.js, use process.hrtime.
	if (typeof window === 'undefined' && typeof process !== 'undefined') {
		TWEEN.now = function () {
			var time = process.hrtime();
	
			// Convert [seconds, nanoseconds] to milliseconds.
			return time[0] * 1000 + time[1] / 1000000;
		};
	}
	// In a browser, use window.performance.now if it is available.
	else if (typeof window !== 'undefined' && window.performance !== undefined && window.performance.now !== undefined) {
			// This must be bound, because directly assigning this function
			// leads to an invocation exception in Chrome.
			TWEEN.now = window.performance.now.bind(window.performance);
		}
		// Use Date.now if it is available.
		else if (Date.now !== undefined) {
				TWEEN.now = Date.now;
			}
			// Otherwise, use 'new Date().getTime()'.
			else {
					TWEEN.now = function () {
						return new Date().getTime();
					};
				}
	
	TWEEN.Tween = function (object) {
	
		var _object = object;
		var _valuesStart = {};
		var _valuesEnd = {};
		var _valuesStartRepeat = {};
		var _duration = 1000;
		var _repeat = 0;
		var _repeatDelayTime;
		var _yoyo = false;
		var _isPlaying = false;
		var _reversed = false;
		var _delayTime = 0;
		var _startTime = null;
		var _easingFunction = TWEEN.Easing.Linear.None;
		var _interpolationFunction = TWEEN.Interpolation.Linear;
		var _chainedTweens = [];
		var _onStartCallback = null;
		var _onStartCallbackFired = false;
		var _onUpdateCallback = null;
		var _onCompleteCallback = null;
		var _onStopCallback = null;
	
		this.to = function (properties, duration) {
	
			_valuesEnd = properties;
	
			if (duration !== undefined) {
				_duration = duration;
			}
	
			return this;
		};
	
		this.start = function (time) {
	
			TWEEN.add(this);
	
			_isPlaying = true;
	
			_onStartCallbackFired = false;
	
			_startTime = time !== undefined ? time : TWEEN.now();
			_startTime += _delayTime;
	
			for (var property in _valuesEnd) {
	
				// Check if an Array was provided as property value
				if (_valuesEnd[property] instanceof Array) {
	
					if (_valuesEnd[property].length === 0) {
						continue;
					}
	
					// Create a local copy of the Array with the start value at the front
					_valuesEnd[property] = [_object[property]].concat(_valuesEnd[property]);
				}
	
				// If `to()` specifies a property that doesn't exist in the source object,
				// we should not set that property in the object
				if (_object[property] === undefined) {
					continue;
				}
	
				// Save the starting value.
				_valuesStart[property] = _object[property];
	
				if (_valuesStart[property] instanceof Array === false) {
					_valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
				}
	
				_valuesStartRepeat[property] = _valuesStart[property] || 0;
			}
	
			return this;
		};
	
		this.stop = function () {
	
			if (!_isPlaying) {
				return this;
			}
	
			TWEEN.remove(this);
			_isPlaying = false;
	
			if (_onStopCallback !== null) {
				_onStopCallback.call(_object, _object);
			}
	
			this.stopChainedTweens();
			return this;
		};
	
		this.end = function () {
	
			this.update(_startTime + _duration);
			return this;
		};
	
		this.stopChainedTweens = function () {
	
			for (var i = 0, numChainedTweens = _chainedTweens.length; i < numChainedTweens; i++) {
				_chainedTweens[i].stop();
			}
		};
	
		this.delay = function (amount) {
	
			_delayTime = amount;
			return this;
		};
	
		this.repeat = function (times) {
	
			_repeat = times;
			return this;
		};
	
		this.repeatDelay = function (amount) {
	
			_repeatDelayTime = amount;
			return this;
		};
	
		this.yoyo = function (yoyo) {
	
			_yoyo = yoyo;
			return this;
		};
	
		this.easing = function (easing) {
	
			_easingFunction = easing;
			return this;
		};
	
		this.interpolation = function (interpolation) {
	
			_interpolationFunction = interpolation;
			return this;
		};
	
		this.chain = function () {
	
			_chainedTweens = arguments;
			return this;
		};
	
		this.onStart = function (callback) {
	
			_onStartCallback = callback;
			return this;
		};
	
		this.onUpdate = function (callback) {
	
			_onUpdateCallback = callback;
			return this;
		};
	
		this.onComplete = function (callback) {
	
			_onCompleteCallback = callback;
			return this;
		};
	
		this.onStop = function (callback) {
	
			_onStopCallback = callback;
			return this;
		};
	
		this.update = function (time) {
	
			var property;
			var elapsed;
			var value;
	
			if (time < _startTime) {
				return true;
			}
	
			if (_onStartCallbackFired === false) {
	
				if (_onStartCallback !== null) {
					_onStartCallback.call(_object, _object);
				}
	
				_onStartCallbackFired = true;
			}
	
			elapsed = (time - _startTime) / _duration;
			elapsed = elapsed > 1 ? 1 : elapsed;
	
			value = _easingFunction(elapsed);
	
			for (property in _valuesEnd) {
	
				// Don't update properties that do not exist in the source object
				if (_valuesStart[property] === undefined) {
					continue;
				}
	
				var start = _valuesStart[property] || 0;
				var end = _valuesEnd[property];
	
				if (end instanceof Array) {
	
					_object[property] = _interpolationFunction(end, value);
				} else {
	
					// Parses relative end values with start as base (e.g.: +10, -3)
					if (typeof end === 'string') {
	
						if (end.charAt(0) === '+' || end.charAt(0) === '-') {
							end = start + parseFloat(end);
						} else {
							end = parseFloat(end);
						}
					}
	
					// Protect against non numeric properties.
					if (typeof end === 'number') {
						_object[property] = start + (end - start) * value;
					}
				}
			}
	
			if (_onUpdateCallback !== null) {
				_onUpdateCallback.call(_object, value);
			}
	
			if (elapsed === 1) {
	
				if (_repeat > 0) {
	
					if (isFinite(_repeat)) {
						_repeat--;
					}
	
					// Reassign starting values, restart by making startTime = now
					for (property in _valuesStartRepeat) {
	
						if (typeof _valuesEnd[property] === 'string') {
							_valuesStartRepeat[property] = _valuesStartRepeat[property] + parseFloat(_valuesEnd[property]);
						}
	
						if (_yoyo) {
							var tmp = _valuesStartRepeat[property];
	
							_valuesStartRepeat[property] = _valuesEnd[property];
							_valuesEnd[property] = tmp;
						}
	
						_valuesStart[property] = _valuesStartRepeat[property];
					}
	
					if (_yoyo) {
						_reversed = !_reversed;
					}
	
					if (_repeatDelayTime !== undefined) {
						_startTime = time + _repeatDelayTime;
					} else {
						_startTime = time + _delayTime;
					}
	
					return true;
				} else {
	
					if (_onCompleteCallback !== null) {
	
						_onCompleteCallback.call(_object, _object);
					}
	
					for (var i = 0, numChainedTweens = _chainedTweens.length; i < numChainedTweens; i++) {
						// Make the chained tweens start exactly at the time they should,
						// even if the `update()` method was called way past the duration of the tween
						_chainedTweens[i].start(_startTime + _duration);
					}
	
					return false;
				}
			}
	
			return true;
		};
	};
	
	TWEEN.Easing = {
	
		Linear: {
	
			None: function None(k) {
	
				return k;
			}
	
		},
	
		Quadratic: {
	
			In: function In(k) {
	
				return k * k;
			},
	
			Out: function Out(k) {
	
				return k * (2 - k);
			},
	
			InOut: function InOut(k) {
	
				if ((k *= 2) < 1) {
					return 0.5 * k * k;
				}
	
				return -0.5 * (--k * (k - 2) - 1);
			}
	
		},
	
		Cubic: {
	
			In: function In(k) {
	
				return k * k * k;
			},
	
			Out: function Out(k) {
	
				return --k * k * k + 1;
			},
	
			InOut: function InOut(k) {
	
				if ((k *= 2) < 1) {
					return 0.5 * k * k * k;
				}
	
				return 0.5 * ((k -= 2) * k * k + 2);
			}
	
		},
	
		Quartic: {
	
			In: function In(k) {
	
				return k * k * k * k;
			},
	
			Out: function Out(k) {
	
				return 1 - --k * k * k * k;
			},
	
			InOut: function InOut(k) {
	
				if ((k *= 2) < 1) {
					return 0.5 * k * k * k * k;
				}
	
				return -0.5 * ((k -= 2) * k * k * k - 2);
			}
	
		},
	
		Quintic: {
	
			In: function In(k) {
	
				return k * k * k * k * k;
			},
	
			Out: function Out(k) {
	
				return --k * k * k * k * k + 1;
			},
	
			InOut: function InOut(k) {
	
				if ((k *= 2) < 1) {
					return 0.5 * k * k * k * k * k;
				}
	
				return 0.5 * ((k -= 2) * k * k * k * k + 2);
			}
	
		},
	
		Sinusoidal: {
	
			In: function In(k) {
	
				return 1 - Math.cos(k * Math.PI / 2);
			},
	
			Out: function Out(k) {
	
				return Math.sin(k * Math.PI / 2);
			},
	
			InOut: function InOut(k) {
	
				return 0.5 * (1 - Math.cos(Math.PI * k));
			}
	
		},
	
		Exponential: {
	
			In: function In(k) {
	
				return k === 0 ? 0 : Math.pow(1024, k - 1);
			},
	
			Out: function Out(k) {
	
				return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
			},
	
			InOut: function InOut(k) {
	
				if (k === 0) {
					return 0;
				}
	
				if (k === 1) {
					return 1;
				}
	
				if ((k *= 2) < 1) {
					return 0.5 * Math.pow(1024, k - 1);
				}
	
				return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
			}
	
		},
	
		Circular: {
	
			In: function In(k) {
	
				return 1 - Math.sqrt(1 - k * k);
			},
	
			Out: function Out(k) {
	
				return Math.sqrt(1 - --k * k);
			},
	
			InOut: function InOut(k) {
	
				if ((k *= 2) < 1) {
					return -0.5 * (Math.sqrt(1 - k * k) - 1);
				}
	
				return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
			}
	
		},
	
		Elastic: {
	
			In: function In(k) {
	
				if (k === 0) {
					return 0;
				}
	
				if (k === 1) {
					return 1;
				}
	
				return -Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
			},
	
			Out: function Out(k) {
	
				if (k === 0) {
					return 0;
				}
	
				if (k === 1) {
					return 1;
				}
	
				return Math.pow(2, -10 * k) * Math.sin((k - 0.1) * 5 * Math.PI) + 1;
			},
	
			InOut: function InOut(k) {
	
				if (k === 0) {
					return 0;
				}
	
				if (k === 1) {
					return 1;
				}
	
				k *= 2;
	
				if (k < 1) {
					return -0.5 * Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
				}
	
				return 0.5 * Math.pow(2, -10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI) + 1;
			}
	
		},
	
		Back: {
	
			In: function In(k) {
	
				var s = 1.70158;
	
				return k * k * ((s + 1) * k - s);
			},
	
			Out: function Out(k) {
	
				var s = 1.70158;
	
				return --k * k * ((s + 1) * k + s) + 1;
			},
	
			InOut: function InOut(k) {
	
				var s = 1.70158 * 1.525;
	
				if ((k *= 2) < 1) {
					return 0.5 * (k * k * ((s + 1) * k - s));
				}
	
				return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
			}
	
		},
	
		Bounce: {
	
			In: function In(k) {
	
				return 1 - TWEEN.Easing.Bounce.Out(1 - k);
			},
	
			Out: function Out(k) {
	
				if (k < 1 / 2.75) {
					return 7.5625 * k * k;
				} else if (k < 2 / 2.75) {
					return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
				} else if (k < 2.5 / 2.75) {
					return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
				} else {
					return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
				}
			},
	
			InOut: function InOut(k) {
	
				if (k < 0.5) {
					return TWEEN.Easing.Bounce.In(k * 2) * 0.5;
				}
	
				return TWEEN.Easing.Bounce.Out(k * 2 - 1) * 0.5 + 0.5;
			}
	
		}
	
	};
	
	TWEEN.Interpolation = {
	
		Linear: function Linear(v, k) {
	
			var m = v.length - 1;
			var f = m * k;
			var i = Math.floor(f);
			var fn = TWEEN.Interpolation.Utils.Linear;
	
			if (k < 0) {
				return fn(v[0], v[1], f);
			}
	
			if (k > 1) {
				return fn(v[m], v[m - 1], m - f);
			}
	
			return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);
		},
	
		Bezier: function Bezier(v, k) {
	
			var b = 0;
			var n = v.length - 1;
			var pw = Math.pow;
			var bn = TWEEN.Interpolation.Utils.Bernstein;
	
			for (var i = 0; i <= n; i++) {
				b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
			}
	
			return b;
		},
	
		CatmullRom: function CatmullRom(v, k) {
	
			var m = v.length - 1;
			var f = m * k;
			var i = Math.floor(f);
			var fn = TWEEN.Interpolation.Utils.CatmullRom;
	
			if (v[0] === v[m]) {
	
				if (k < 0) {
					i = Math.floor(f = m * (1 + k));
				}
	
				return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);
			} else {
	
				if (k < 0) {
					return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
				}
	
				if (k > 1) {
					return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
				}
	
				return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);
			}
		},
	
		Utils: {
	
			Linear: function Linear(p0, p1, t) {
	
				return (p1 - p0) * t + p0;
			},
	
			Bernstein: function Bernstein(n, i) {
	
				var fc = TWEEN.Interpolation.Utils.Factorial;
	
				return fc(n) / fc(i) / fc(n - i);
			},
	
			Factorial: function () {
	
				var a = [1];
	
				return function (n) {
	
					var s = 1;
	
					if (a[n]) {
						return a[n];
					}
	
					for (var i = n; i > 1; i--) {
						s *= i;
					}
	
					a[n] = s;
					return s;
				};
			}(),
	
			CatmullRom: function CatmullRom(p0, p1, p2, p3, t) {
	
				var v0 = (p2 - p0) * 0.5;
				var v1 = (p3 - p1) * 0.5;
				var t2 = t * t;
				var t3 = t * t2;
	
				return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
			}
	
		}
	
	};
	
	// UMD (Universal Module Definition)
	(function (root) {
	
		if (true) {
	
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return TWEEN;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && (typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object') {
	
			// Node.js
			module.exports = TWEEN;
		} else if (root !== undefined) {
	
			// Global variable
			root.TWEEN = TWEEN;
		}
	})(undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(131)))

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 132 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	    var lastTime = 0;
	    var vendors = ['webkit', 'moz'];
	    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	    }
	
	    if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback) {
	        var currTime = new Date().getTime();
	        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	        var id = window.setTimeout(function () {
	            callback(currTime + timeToCall);
	        }, timeToCall);
	        lastTime = currTime + timeToCall;
	        return id;
	    };
	
	    if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
	        clearTimeout(id);
	    };
	})();

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _sign = __webpack_require__(134);
	
	var _sign2 = _interopRequireDefault(_sign);
	
	var _formatParams2 = __webpack_require__(139);
	
	var _formatParams3 = _interopRequireDefault(_formatParams2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var antiTheft = function antiTheft(_ref) {
	    var videoinfo = _ref.videoinfo,
	        _gid = _ref._gid,
	        version = _ref.version;
	
	    var videoUrl = '';
	    var sver = '';
	    // const start = '';
	    // const end = '';
	
	    var _formatParams = (0, _formatParams3.default)(videoinfo, _gid, version),
	        vid = _formatParams.vid,
	        uid = _formatParams.uid,
	        from = _formatParams.from,
	        pver = _formatParams.pver,
	        se = _formatParams.se,
	        cat = _formatParams.cat,
	        ptype = _formatParams.ptype,
	        platform = _formatParams.platform,
	        sourceType = _formatParams.sourceType,
	        dt = _formatParams.dt,
	        gid = _formatParams.gid;
	
	    var _genSign = (0, _sign2.default)({ gid: gid, pver: pver, sver: sver, tm: Date.now(), uid: uid, vid: vid }),
	        sign = _genSign.sign,
	        tm = _genSign.tm;
	
	    var paramArr = [];
	
	    paramArr.push('vid=' + vid);
	    paramArr.push('uid=' + uid);
	    paramArr.push('from=' + from);
	    paramArr.push('pver=' + pver);
	    paramArr.push('sver=' + sver);
	    paramArr.push('se=' + se);
	    paramArr.push('cat=' + cat);
	    paramArr.push('ptype=' + ptype);
	    paramArr.push('platform=' + platform);
	    paramArr.push('sourceType=' + sourceType);
	    paramArr.push('dt=' + dt);
	    paramArr.push('gid=' + gid);
	    paramArr.push('sign=' + sign);
	    // paramArr.push(`start=${start}`);
	    // paramArr.push(`end=${end}`);
	    paramArr.push('tm=' + tm);
	
	    videoUrl = paramArr.join('&');
	
	    return videoUrl;
	};
	
	exports.default = antiTheft;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _md = __webpack_require__(135);
	
	var _md2 = _interopRequireDefault(_md);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var salt = 'ifeng';
	/**
	 * 防盗链sign计算函数
	 * @param {Object} info
	 * @param {string} info.gid - 视频Id
	 * @param {string} info.pver - 播放器版本
	 * @param {string} info.sver - APP版本
	 * @param {string} info.tm - 时间戳
	 * @param {string} info.uid - 用户id
	 * @param {string} info.vid - 视频请求唯一ID
	 * @return {object}
	 */
	var genSign = function genSign(_ref) {
	  var _ref$gid = _ref.gid,
	      gid = _ref$gid === undefined ? '' : _ref$gid,
	      _ref$pver = _ref.pver,
	      pver = _ref$pver === undefined ? '' : _ref$pver,
	      _ref$sver = _ref.sver,
	      sver = _ref$sver === undefined ? '' : _ref$sver,
	      _ref$tm = _ref.tm,
	      tm = _ref$tm === undefined ? Date.now() : _ref$tm,
	      _ref$uid = _ref.uid,
	      uid = _ref$uid === undefined ? '' : _ref$uid,
	      _ref$vid = _ref.vid,
	      vid = _ref$vid === undefined ? '' : _ref$vid;
	
	  var paramArr = [];
	
	  paramArr.push('gid=' + gid);
	  paramArr.push('pver=' + pver);
	  paramArr.push('sver=' + sver);
	  paramArr.push('tm=' + tm);
	  paramArr.push('uid=' + uid);
	  paramArr.push('vid=' + vid);
	
	  var md5String = paramArr.join('&') + salt;
	
	  var sign = (0, _md2.default)(md5String);
	
	  return { sign: sign, tm: tm };
	};
	
	exports.default = genSign;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	(function(){
	  var crypt = __webpack_require__(136),
	      utf8 = __webpack_require__(137).utf8,
	      isBuffer = __webpack_require__(138),
	      bin = __webpack_require__(137).bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message))
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if (message === undefined || message === null)
	      throw new Error('Illegal argument ' + message);
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();


/***/ }),
/* 136 */
/***/ (function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _uid = __webpack_require__(140);
	
	var _uid2 = _interopRequireDefault(_uid);
	
	var _gid = __webpack_require__(141);
	
	var _gid2 = _interopRequireDefault(_gid);
	
	var _utilPc = __webpack_require__(142);
	
	var _utilPc2 = _interopRequireDefault(_utilPc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pcVideoUtil = new _utilPc2.default();
	
	/* eslint-disable */
	/**
	 * 格式化视频防盗链相关机制
	 * @param {object} videoinfo
	 * @param {string} gid
	 * @return {object}
	 */
	function formatParams(videoinfo) {
	    var gid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _gid2.default)();
	    var version = arguments[2];
	
	    var uid = '';
	    var liveVideoId = videoinfo.liveVideoId,
	        categoryId = videoinfo.categoryId,
	        createdate = videoinfo.createdate,
	        columnName = videoinfo.columnName;
	
	
	    if (pcVideoUtil.playerGetCookie('userid') === '') {
	        uid = (0, _uid2.default)();
	        pcVideoUtil.playerSetCookie('userid', uid, {
	            domain: '.ifeng.com',
	            path: '/',
	            expires: 60 * 24 * 360
	        });
	    } else {
	        uid = pcVideoUtil.playerGetCookie('userid');
	    }
	
	    var cat = typeof categoryId !== 'undefined' ? categoryId : '';
	    var dt = new Date(createdate).getTime();
	    var from = 'izhibo_h5';
	    var pver = version || 'vHTML5Player_v2.0.0';
	    var platform = 'pc';
	    var sourceType = 'h5';
	    var ptype = '';
	
	    if (cat != '') {
	        ptype = cat.split('-')[0];
	        // if (ptype == '154') {
	        //     from = 'v_Doc';
	        // } else if (ptype == '171') {
	        //     from = 'v_Biz';
	        // } else {
	        //     from = 'v_Free';
	        // }
	    }
	
	    return {
	        vid: liveVideoId,
	        uid: uid,
	        from: from,
	        pver: pver,
	        se: encodeURIComponent(columnName),
	        cat: cat,
	        ptype: ptype,
	        platform: platform,
	        dt: dt,
	        gid: gid,
	        sourceType: sourceType
	    };
	}
	
	exports.default = formatParams;

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* eslint-disable */
	/**
	 * 返回uid
	 * @return {string} uid字符串
	 */
	function getRandomUid() {
	    var tn = new Date().getTime() + (Math.round((1 << 12) * Math.random()) << 24);
	    var sn = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZXX';
	    var uuid = '';
	
	    var fn1 = sn.charAt(parseInt(tn & 63));
	
	    tn >>= 6;
	    var fn2 = sn.charAt(parseInt(tn & 63));
	
	    tn >>= 6;
	    var fn3 = sn.charAt(parseInt(tn & 63));
	
	    tn >>= 6;
	    var fn4 = sn.charAt(parseInt(tn & 63));
	
	    tn >>= 6;
	    var fn5 = sn.charAt(parseInt(tn & 63));
	
	    tn >>= 6;
	    var fn6 = sn.charAt(parseInt(tn & 63));
	
	    uuid += fn6 + fn5 + fn4 + fn3 + fn2 + fn1;
	
	    return uuid;
	}
	
	exports.default = getRandomUid;

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* eslint-disable */
	/**
	 * 返回gid 视频请求唯一id
	 * @return {string}
	 */
	function createGid() {
	    var key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
	    // 28
	    var ramStr = parseInt(Math.random() * 268435455).toString(2);
	    // 44
	    var mtimeStr = new Date().getTime().toString(2);
	
	    while (ramStr.length < 28) {
	        ramStr = '0' + ramStr;
	    }
	
	    while (mtimeStr.length < 44) {
	        mtimeStr = '0' + mtimeStr;
	    }
	
	    var binaryStr = ramStr + mtimeStr;
	
	    var outStr = '';
	
	    for (var i = 0; i < 12; i++) {
	        outStr += key.charAt(parseInt(binaryStr.substr(i * 6, 6), 2));
	    }
	
	    return outStr;
	}
	
	exports.default = createGid;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bowser = __webpack_require__(143);
	/* eslint-disable */
	/**
	 * PCUtil
	 */
	
	var PCVideoutil = function () {
	    function PCVideoutil() {
	        (0, _classCallCheck3.default)(this, PCVideoutil);
	    }
	
	    (0, _createClass3.default)(PCVideoutil, [{
	        key: 'showTextMenu',
	        value: function showTextMenu(e) {
	            // 自定义右键菜单样式
	            var clickX = e.clientX;
	
	            var clickY = e.clientY;
	            var videoMenu = document.getElementById('js_video_menu');
	
	            videoMenu.style.display = 'block';
	            videoMenu.style.left = clickX - videoboxLeft + 'px'; // eslint-disable-line
	            videoMenu.style.top = clickY - this.getEleOffsetTop(box) + 'px'; // eslint-disable-line
	            e.stopPropagation();
	            e.preventDefault();
	        }
	    }, {
	        key: 'hideTextMenu',
	        value: function hideTextMenu() {
	            // 隐藏右键后的自定义菜单
	            var videoMenu = document.getElementById('js_video_menu');
	
	            videoMenu.style.display = 'none';
	        }
	    }, {
	        key: 'hasClass',
	        value: function hasClass(ele, classname) {
	            // 检测某个元素是否含有该类名
	            return ele.className.indexOf(classname);
	        }
	    }, {
	        key: 'removeClass',
	        value: function removeClass(ele, classname) {
	            // 移除类名
	            if (this.hasClass(ele, classname) > -1) {
	                var reg = new RegExp('(\\s|^)' + classname + '(\\s|$)');
	
	                ele.className = ele.className.replace(reg, ' ');
	            }
	        }
	    }, {
	        key: 'addClass',
	        value: function addClass(ele, classname) {
	            // 添加类名
	            if (this.hasClass(ele, classname) < 0) {
	                ele.className += ' ' + classname;
	            }
	        }
	    }, {
	        key: 'getStyle',
	        value: function getStyle(ele) {
	            // 获取元素现在的sytle
	            var cur = ele.currentStyle ? ele.currentStyle : document.defaultView.getComputedStyle(ele, null);
	
	            return cur;
	        }
	    }, {
	        key: 'delNodes',
	        value: function delNodes(ele) {
	            // 获取后代，删除无用node
	            var ele_child = ele.childNodes;
	
	            for (var i = 0; i < ele_child.length; i++) {
	                if (ele_child[i].nodeName === '#text' && !/\s/.test(ele_child.nodeValue)) {
	                    ele.removeChild(ele_child[i]);
	                }
	            }
	
	            return ele;
	        }
	    }, {
	        key: 'removeElement',
	        value: function removeElement() {
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            // 删除元素
	            for (var i = 0, ilen = args.length; i < ilen; i++) {
	                var _parentElement = args[i].parentNode;
	
	                if (_parentElement) _parentElement.removeChild(args[i]);
	            }
	        }
	    }, {
	        key: 'moretime',
	        value: function moretime(time) {
	            var seconds = Math.round(time % 60) < 10 ? '0' + Math.round(time % 60) : Math.round(time % 60);
	            var minutes = parseInt(time / 60 % 60) < 10 ? '0' + parseInt(time / 60 % 60) : parseInt(time / 60 % 60);
	            var hours = parseInt(time / 3600 % 24);
	            var goodhours = hours < 10 ? '0' + hours : hours;
	
	            if (hours === 0) {
	                return minutes + ':' + seconds;
	            } else {
	                return goodhours + ':' + minutes + ':' + seconds;
	            }
	        }
	    }, {
	        key: 'formatTime',
	        value: function formatTime(_time) {
	            // 格式化时间
	            var second = _time / 1;
	
	            var temp = [];
	
	            var s = 0;
	
	            if (second === 0) {
	                return '00:00';
	            }
	            while (second !== 0) {
	                s = second % 60;
	                if (s < 10) {
	                    s = '0' + s;
	                }
	                temp.unshift(s);
	                second = Math.floor(second / 60);
	            }
	            if (temp.length < 2) {
	                temp.unshift('00');
	            }
	
	            return temp.join(':');
	        }
	    }, {
	        key: 'formatNum',
	        value: function formatNum(num) {
	            // 格式化数字
	            var _num = num;
	
	            if (num < 100) {
	                if (num < 10) {
	                    _num = '00' + num;
	                } else {
	                    _num = '0' + num;
	                }
	            }
	
	            return _num;
	        }
	    }, {
	        key: 'getEleOffsetLeft',
	        value: function getEleOffsetLeft(obj) {
	            // 获取元素相对于浏览器窗口最左边的距离
	            var l = obj.offsetLeft;
	
	            while (obj.offsetParent != null) {
	                obj = obj.offsetParent;
	                l += obj.offsetLeft;
	            }
	
	            return l;
	        }
	    }, {
	        key: 'getEleOffsetTop',
	        value: function getEleOffsetTop(obj) {
	            // 获取元素相对于浏览器窗口最顶部的距离
	            var l = obj.offsetTop;
	
	            while (obj.offsetParent != null) {
	                obj = obj.offsetParent;
	                l += obj.offsetTop;
	            }
	
	            return l;
	        }
	    }, {
	        key: 'bind',
	        value: function bind(ele, type, fn) {
	            // 给元素绑定相应事件
	            if (typeof type === 'string') {
	                if (ele.addEventListener) {
	                    ele.addEventListener(type, fn, false);
	                } else if (ele.attachEvent) {
	                    ele.attachEvent('on' + type, fn);
	                } else {
	                    ele['on' + type] = fn;
	                }
	            } else {
	                for (var i in type) {
	                    if (ele.addEventListener) {
	                        ele.addEventListener(type, fn, false);
	                    } else if (ele.attachEvent) {
	                        ele.attachEvent('on' + type[i], fn);
	                    } else {
	                        ele['on' + type[i]] = fn;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'removeHandler',
	        value: function removeHandler(element, type, handler) {
	            if (element.removeEventListener) {
	                element.removeEventListener(type, handler, false);
	            } else if (element.detachEvent) {
	                element.detachEvent('on' + type, handler);
	            } else {
	                element['on' + type] = null;
	            }
	        }
	    }, {
	        key: 'extend',
	        value: function extend() {
	            var result = {};
	
	            for (var i = 0, iLen = arguments.length; i < iLen; i++) {
	                var o = arguments[i]; // eslint-disable-line
	
	                for (var key in o) {
	                    result[key] = o[key];
	                }
	            }
	
	            return result;
	        }
	    }, {
	        key: 'playerSetCookie',
	        value: function playerSetCookie(name, value, path, domain, expires, secure) {
	            // 设置cookie
	            var doFn = encodeURIComponent;
	            var cStrArr = [];
	
	            cStrArr.push(name + '=' + doFn(value));
	            if (expires) {
	                var date = new Date();
	
	                date.setTime(date.getTime() + expires * 1000 * 60);
	                cStrArr.push('; expires=' + date.toGMTString());
	            }
	            cStrArr.push(path ? '; path=' + path : '');
	            cStrArr.push(domain ? '; domain=' + domain : '');
	            cStrArr.push(secure ? '; secure' : '');
	            document.cookie = cStrArr.join('');
	        }
	    }, {
	        key: 'playerGetAll',
	        value: function playerGetAll() {
	            var cookieArr = [];
	
	            if (document.cookie !== '') {
	                var cStrArr = document.cookie.split(';');
	
	                for (var i = 0, l = cStrArr.length; i < l; i++) {
	                    var cStr = cStrArr[i];
	                    var index = cStr.indexOf('=');
	                    var name = cStr.substring(0, index).replace(/[ ]/g, '');
	                    var value = cStr.substring(index + 1);
	                    var cookie = {};
	
	                    cookie.name = name;
	                    cookie.value = value;
	                    cookieArr.push(cookie);
	                }
	            }
	
	            return cookieArr;
	        }
	    }, {
	        key: 'playerGetCookie',
	        value: function playerGetCookie(name) {
	            // 获取cookie
	            var cookieArr = this.playerGetAll();
	
	            for (var i = 0, l = cookieArr.length; i < l; i++) {
	                var cookie = cookieArr[i];
	
	                if (cookie.name === name) {
	                    var doFn = decodeURIComponent;
	
	                    return doFn(cookie.value);
	                }
	            }
	
	            return '';
	        }
	    }, {
	        key: 'showFlashPlayer',
	        value: function showFlashPlayer() {
	            // 显示flash播放器，隐藏video播放器，用于两者间的转换
	            document.getElementById('playercontainer').style.display = 'none';
	            document.getElementById('vPlayer_box').style.display = 'block';
	            document.getElementById('playercontainer').parentNode.removeChild(document.getElementById('playercontainer'));
	        }
	    }, {
	        key: 'ifIE',
	        value: function ifIE() {
	            // 判断是否为ie浏览器
	            var ieFlag = !!(!!window.ActiveXObject || 'ActiveXObject' in window);
	
	            return ieFlag;
	        }
	    }, {
	        key: 'ifFlash',
	        value: function ifFlash() {
	            // 判断是否为flash播放器，用于flash和video的切换
	            var flashFlag = this.playerGetCookie('ifFlag');
	
	            return flashFlag;
	        }
	    }, {
	        key: 'getOS',
	        value: function getOS() {
	            var sUserAgent = navigator.userAgent;
	
	            var _platform = navigator.platform;
	
	            var isWin = _platform === 'Win32' || _platform === 'Windows';
	
	            var isMac = _platform === 'Mac68K' || _platform === 'MacPPC' || _platform === 'Macintosh' || _platform === 'MacIntel';
	
	            if (isMac) return 'Mac';
	            var isUnix = _platform === 'X11' && !isWin && !isMac;
	
	            if (isUnix) return 'Unix';
	            var isLinux = String(_platform).indexOf('Linux') > -1;
	
	            if (isLinux) return 'Linux';
	            if (isWin) {
	                var isWin2K = sUserAgent.indexOf('Windows') > -1 || sUserAgent.indexOf('Windows 2000') > -1;
	
	                if (isWin2K) return 'Win2000';
	                var isWinXP = sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1;
	
	                if (isWinXP) return 'WinXP';
	                var isWin2003 = sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1;
	
	                if (isWin2003) return 'Win2003';
	                var isWinVista = sUserAgent.indexOf('Windows NT 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1;
	
	                if (isWinVista) return 'WinVista';
	                var isWin7 = sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1;
	
	                if (isWin7) return 'Win7';
	            }
	
	            return 'other';
	        }
	    }, {
	        key: 'getBrowser',
	        value: function getBrowser() {
	            var browser = bowser.getParser(window.navigator.userAgent);
	            var browserInfo = browser.getBrowser();
	
	            return {
	                type: browserInfo.name || '',
	                version: browserInfo.version || ''
	            };
	            // const explorer = window.navigator.userAgent.toLowerCase();
	            // let ver = '';
	
	            // if (explorer.indexOf('msie') >= 0) {
	            //     // ie
	            //     ver = (explorer.match(/msie ([\d.]+)/) && explorer.match(/msie ([\d.]+)/)[1]) || 'unknown';
	
	            //     return {
	            //         type: 'IE',
	            //         version: ver,
	            //     };
	            // } else if (explorer.indexOf('firefox') >= 0) {
	            //     // firefox
	            //     ver = (explorer.match(/firefox\/([\d.]+)/) && explorer.match(/firefox\/([\d.]+)/)[1]) || 'unknown';
	
	            //     return {
	            //         type: 'Firefox',
	            //         version: ver,
	            //     };
	            // } else if (explorer.indexOf('chrome') >= 0) {
	            //     // chrome
	            //     ver = (explorer.match(/chrome\/([\d.]+)/) && explorer.match(/chrome\/([\d.]+)/)[1]) || 'unknown';
	
	            //     return {
	            //         type: 'Chrome',
	            //         version: ver,
	            //     };
	            // } else if (explorer.indexOf('opera') >= 0) {
	            //     // opera
	            //     ver = (explorer.match(/opera.([\d.]+)/) && explorer.match(/opera.([\d.]+)/)[1]) || 'unknown';
	
	            //     return {
	            //         type: 'Opera',
	            //         version: ver,
	            //     };
	            // } else if (explorer.indexOf('safari') >= 0) {
	            //     // safari
	            //     ver = (explorer.match(/version\/([\d.]+)/) && explorer.match(/version\/([\d.]+)/)[1]) || 'unknown';
	
	            //     return {
	            //         type: 'Safari',
	            //         version: ver,
	            //     };
	            // } else {
	            //     return {
	            //         type: '',
	            //         version: ver, // eslint-disable-line
	            //     };
	            // }
	        }
	    }, {
	        key: 'getResolution',
	        value: function getResolution() {
	            return {
	                screenW: screen.width,
	                screenH: screen.height
	            };
	        }
	    }, {
	        key: 'getCookie',
	        value: function getCookie(name) {
	            var cStrArr = document.cookie.split(';');
	
	            for (var i = 0, l = cStrArr.length; i < l; i++) {
	                var cStr = cStrArr[i];
	                var index = cStr.indexOf('=');
	                var cname = cStr.substring(0, index).replace(/[ ]/g, '');
	                var value = cStr.substring(index + 1);
	
	                if (cname === name) {
	                    return decodeURIComponent(value);
	                }
	            }
	
	            return '';
	        }
	    }, {
	        key: 'setCookie',
	        value: function setCookie(name, value) {
	            var cStrArr = [];
	
	            cStrArr.push(name + '=' + encodeURIComponent(value));
	            var date = new Date();
	
	            date.setTime(date.getTime() + 24 * 60 * 1000 * 60 * 7);
	            cStrArr.push('; expires=' + date.toGMTString());
	            cStrArr.push('; path=/');
	            cStrArr.push('; domain=.ifeng.com');
	
	            document.cookie = cStrArr.join('');
	        }
	    }, {
	        key: 'getRandomUid',
	        value: function getRandomUid() {
	            var date = new Date().getTime();
	
	            var uid = '';
	
	            var fn = '';
	
	            var sn = '';
	
	            fn = (Math.random() * 2147483648 | 0).toString(36);
	            sn = Math.round(Math.random() * 10000);
	            uid = date + '_' + fn + sn;
	
	            return uid;
	        }
	    }, {
	        key: 'getCurrentViedoInfo',
	        value: function getCurrentViedoInfo() {
	            var result = videoinfo; // eslint-disable-line
	            var o = {};
	
	            o.img = encodeURIComponent(result.videoLargePoster);
	            o.title = encodeURIComponent(result.name);
	            o.url = encodeURIComponent(result.url);
	            o.guid = result.guid;
	
	            return o;
	        }
	    }, {
	        key: 'shareVideo',
	        value: function shareVideo(sTag, type) {
	            var info = this.getCurrentViedoInfo();
	            var _tp = new Date().getTime();
	            var url = '';
	            var appkey = '';
	            var site = '';
	
	            switch (sTag) {
	                case 'sinateew':
	                    // 这个请求是405。。
	                    // ifeng.util.getScript('//api.t.sina.com.cn/friendships/create/1806128454.xml?source=168486312');
	                    url = '//v.t.sina.com.cn/share/share.php?appkey=168486312&url=' + info.url + encodeURIComponent('?tp=' + _tp + '#_share=sina') + '&title=' + info.title + '&source=ifeng&sourceUrl=//v.ifeng.com/&content=utf8&ralateUid=1806128454&pic=' + info.img;
	
	                    window.open(url, '', 'toolbar=0,status=0,resizable=1,width=440,height=430,left=\n                     ' + (screen.width - 440) / 2 + ',top=\n                     ' + (screen.height - 430) / 2);
	                    break;
	
	                case 'qqzone':
	                    window.open('//sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + info.url + encodeURIComponent('?tp=' + _tp + '#_share=qqZone'));
	                    break;
	
	                case 'qqteew':
	                    appkey = encodeURIComponent('f8ca1cd768da4529ab190fae9f1bf21d');
	                    site = '//v.ifeng.com';
	                    // //connect.qq.com/widget/shareqq/index.html?title=&url=&desc=&pics=&site=&callback=?userId=0
	                    // //connect.qq.com/intro/sharetoqq/index.html?title='实拍台军拒统利器宣传片 毫不避讳台独姿态'&url=/v.ifeng.com/test/wx_test.shtml&desc=按发送方师傅上发生地方&pics=&site=ddd
	                    url = '//connect.qq.com/widget/shareqq/index.html?title=' + info.title + '&url=' + info.url + encodeURIComponent('?tp=' + _tp + '#_share=qq') + '&appkey=' + appkey + '&site=' + site + '&pic=' + info.img;
	                    window.open(url);
	                    break;
	                case 'renren':
	                    url = '//share.renren.com/share/buttonshare.do?link=' + info.url + encodeURIComponent('?tp=' + _tp + '#_share=' + type) + '&title=' + info.title;
	                    window.open(url);
	                    break;
	
	                case 'ifengteew':
	                    url = '//t.ifeng.com/interface.php?_c=share&_a=share&sourceUrl=\'}' + info.url + encodeURIComponent('?tp=' + _tp + '#_share=' + type) + '&title=' + info.title + '&pic=' + info.img + '&source=' + encodeURIComponent('凤凰视频') + '&type=1';
	                    window.open(url, '', 'toolbar=0,status=0,resizable=1,width=640,height=481,left=\n                     ' + (screen.width - 440) / 2 + ',top=\n                     ' + (screen.height - 480) / 2);
	
	                    break;
	
	                case 'kaixin':
	                    url = '//www.kaixin001.com/repaste/share.php?rurl=' + info.url + encodeURIComponent('?tp=' + _tp + '#_share=' + type) + '&rtitle=' + info.title;
	                    window.open(url);
	                    break;
	
	                case 'sohuteew':
	                    url = '//t.sohu.com/third/post.jsp?url=' + info.url + encodeURIComponent('?tp=' + _tp + '#_share=' + type) + '&title=' + info.title + '&content=utf-8&pic=' + info.img;
	                    window.open(url, '', 'toolbar=0,status=0,resizable=1,width=660,height=470,left=\n                     ' + (screen.width - 660) / 2 + ',top=\n                     ' + (screen.height - 470) / 2);
	                    break;
	
	                case '163':
	                    url = '//t.163.com/article/user/checkLogin.do?link=//www.ifeng.com&source=' + encodeURIComponent('凤凰网') + '&info=' + info.title + info.url + encodeURIComponent('?tp=' + _tp + '#_share=' + type) + '&' + new Date().getTime();
	                    window.open(url, '', 'height=330,width=550,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no,top=\n                     ' + (screen.height - 280) / 2 + ',left=\n                     ' + (screen.width - 550) / 2);
	                    break;
	
	                case 'feixin':
	                    url = '//space.fetion.com.cn/api/share?Source=' + encodeURIComponent('凤凰视频') + '&Title=' + info.title + '&url=' + info.url + encodeURIComponent('?tp=' + _tp + '#_share=' + type) + '&IsEditTitle=false';
	                    window.open(url);
	                    break;
	
	                // 对网址有验证，所以内网地址通不过
	                case '51com':
	                    url = '//share.51.com/share/out_share_video.php?from=' + encodeURIComponent('凤凰视频') + '&title=' + info.title + '&vaddr=' + info.url + encodeURIComponent('?tp=' + _tp + '#_share=' + type) + '&IsEditTitle=false&charset=utf-8';
	                    window.open(url);
	                    break;
	
	                // 对网址有验证，所以内网地址通不过
	                case 'baiduI':
	                    url = '//tieba.baidu.com/i/app/open_share_api?link=' + info.url + encodeURIComponent('?tp=' + _tp + '#_share=' + type);
	                    window.open(url);
	                    break;
	
	                case 'weixin':
	                    url = '//v.ifeng.com/weixin.shtml?title=' + info.title + '&link=' + info.url;
	                    window.open(url, '分享到微信', 'height=984,width=850,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no,top=\n                     ' + (screen.height - 280) / 2 + ',left=\n                     ' + (screen.width - 550) / 2);
	                    break;
	
	                default:
	                    break;
	            }
	        }
	    }, {
	        key: 'sendStatisticInfoC',
	        value: function sendStatisticInfoC(type) {
	            var statistic = {};
	
	            statistic.datatype = 'share';
	            statistic.value = type;
	
	            var userid = null;
	
	            var info = '';
	
	            if (this.getCookie('userid') === '') {
	                userid = this.getRandomUid();
	                this.setCookie('userid', userid);
	            } else {
	                userid = this.getCookie('userid');
	            }
	
	            statistic.ref = window.location.host;
	
	            var sid = this.getCookie('sid');
	
	            statistic.sid = sid;
	
	            if (typeof videoinfo !== 'undefined') {
	                var categoryPath = videoinfo.categoryPath; // eslint-disable-line
	
	                if (categoryPath) {
	                    info = '//v.ifeng.com/' + categoryPath + '/,,,';
	                } else {
	                    info = '//v.ifeng.com/,,,';
	                }
	            }
	            statistic.ci = info;
	            statistic.pt = 'vtype=player';
	            statistic.time = new Date().getTime();
	            statistic.uri = window.location.href;
	
	            this.sendStatisticInfoM(statistic);
	
	            return statistic;
	        }
	    }, {
	        key: 'sendStatisticInfoM',
	        value: function sendStatisticInfoM(param) {
	            var statisticUrl = '//stadig.ifeng.com/actsta.js';
	
	            // eslint-disable-next-line
	            $.ajax({
	                url: statisticUrl,
	                data: param,
	                cache: true,
	                dataType: 'script'
	            });
	        }
	    }]);
	    return PCVideoutil;
	}();
	
	exports.default = PCVideoutil;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.bowser=t():e.bowser=t()}(this,function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=86)}({17:function(e,t,r){var n,i,s;i=[t],void 0===(s="function"==typeof(n=function(r){"use strict";function n(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var i=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e)}return t=e,i=[{key:"getFirstMatch",value:function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""}},{key:"getSecondMatch",value:function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""}},{key:"matchAndReturnConst",value:function(e,t,r){if(e.test(t))return r}},{key:"getWindowsVersionName",value:function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}}},{key:"getAndroidVersionName",value:function(e){var t=e.split(".").splice(0,2).map(function(e){return parseInt(e,10)||0});if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":void 0}},{key:"getVersionPrecision",value:function(e){return e.split(".").length}},{key:"compareVersions",value:function(t,r){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=e.getVersionPrecision(t),s=e.getVersionPrecision(r),a=Math.max(i,s),o=0,u=e.map([t,r],function(t){var r=a-e.getVersionPrecision(t),n=t+new Array(r+1).join(".0");return e.map(n.split("."),function(e){return new Array(20-e.length).join("0")+e}).reverse()});for(n&&(o=a-Math.min(i,s)),a-=1;a>=o;){if(u[0][a]>u[1][a])return 1;if(u[0][a]===u[1][a]){if(a===o)return 0;a-=1}else if(u[0][a]<u[1][a])return-1}}},{key:"map",value:function(e,t){var r,n=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)n.push(t(e[r]));return n}}],(r=null)&&n(t.prototype,r),i&&n(t,i),e;var t,r,i}();r.default=i,e.exports=t.default})?n.apply(t,i):n)||(e.exports=s)},86:function(e,t,r){var n,i,s;i=[t,r(87)],void 0===(s="function"==typeof(n=function(r,n){"use strict";function i(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var s;Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0,n=(s=n)&&s.__esModule?s:{default:s};var a=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e)}return t=e,s=[{key:"getParser",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if("string"!=typeof e)throw new Error("UserAgent should be a string");return new n.default(e,t)}},{key:"parse",value:function(e){return new n.default(e).getResult()}}],(r=null)&&i(t.prototype,r),s&&i(t,s),e;var t,r,s}();r.default=a,e.exports=t.default})?n.apply(t,i):n)||(e.exports=s)},87:function(e,t,r){var n,i,s;i=[t,r(88),r(89),r(90),r(91),r(17)],void 0===(s="function"==typeof(n=function(r,n,i,s,a,o){"use strict";function u(e){return e&&e.__esModule?e:{default:e}}function c(e){return(c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function d(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0,n=u(n),i=u(i),s=u(s),a=u(a),o=u(o);var f=function(){function e(t){var r=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),null==t||""===t)throw new Error("UserAgent parameter can't be empty");this._ua=t,this.parsedResult={},!0!==r&&this.parse()}return t=e,(r=[{key:"getUA",value:function(){return this._ua}},{key:"test",value:function(e){return e.test(this._ua)}},{key:"parseBrowser",value:function(){var e=this;this.parsedResult.browser={};var t=n.default.find(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some(function(t){return e.test(t)});throw new Error("Browser's test function is not valid")});return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser}},{key:"getBrowser",value:function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()}},{key:"getBrowserName",value:function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""}},{key:"getBrowserVersion",value:function(){return this.getBrowser().version}},{key:"getOS",value:function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()}},{key:"parseOS",value:function(){var e=this;this.parsedResult.os={};var t=i.default.find(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some(function(t){return e.test(t)});throw new Error("Browser's test function is not valid")});return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os}},{key:"getOSName",value:function(e){var t=this.getOS(),r=t.name;return e?String(r).toLowerCase()||"":r||""}},{key:"getOSVersion",value:function(){return this.getOS().version}},{key:"getPlatform",value:function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()}},{key:"getPlatformType",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=this.getPlatform(),r=t.type;return e?String(r).toLowerCase()||"":r||""}},{key:"parsePlatform",value:function(){var e=this;this.parsedResult.platform={};var t=s.default.find(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some(function(t){return e.test(t)});throw new Error("Browser's test function is not valid")});return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform}},{key:"getEngine",value:function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()}},{key:"getEngineName",value:function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""}},{key:"parseEngine",value:function(){var e=this;this.parsedResult.engine={};var t=a.default.find(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some(function(t){return e.test(t)});throw new Error("Browser's test function is not valid")});return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine}},{key:"parse",value:function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this}},{key:"getResult",value:function(){return Object.assign({},this.parsedResult)}},{key:"satisfies",value:function(e){var t=this,r={},n=0,i={},s=0,a=Object.keys(e);if(a.forEach(function(t){var a=e[t];"string"==typeof a?(i[t]=a,s+=1):"object"===c(a)&&(r[t]=a,n+=1)}),n>0){var o=Object.keys(r),u=o.find(function(e){return t.isOS(e)});if(u){var d=this.satisfies(r[u]);if(void 0!==d)return d}var f=o.find(function(e){return t.isPlatform(e)});if(f){var l=this.satisfies(r[f]);if(void 0!==l)return l}}if(s>0){var v=Object.keys(i),p=v.find(function(e){return t.isBrowser(e)});if(void 0!==p)return this.compareVersion(i[p])}}},{key:"isBrowser",value:function(e){return this.getBrowserName(!0)===String(e).toLowerCase()}},{key:"compareVersion",value:function(e){var t=[0],r=e,n=!1,i=this.getBrowserVersion();if("string"==typeof i)return">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(n=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(n=!0,r=e.substr(1)),t.indexOf(o.default.compareVersions(i,r,n))>-1}},{key:"isOS",value:function(e){return this.getOSName(!0)===String(e).toLowerCase()}},{key:"isPlatform",value:function(e){return this.getPlatformType(!0)===String(e).toLowerCase()}},{key:"isEngine",value:function(e){return this.getEngineName(!0)===String(e).toLowerCase()}},{key:"is",value:function(e){return this.isBrowser(e)||this.isOS(e)||this.isPlatform(e)}},{key:"some",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];return t.some(function(t){return e.is(t)})}}])&&d(t.prototype,r),u&&d(t,u),e;var t,r,u}();r.default=f,e.exports=t.default})?n.apply(t,i):n)||(e.exports=s)},88:function(e,t,r){var n,i,s;i=[t,r(17)],void 0===(s="function"==typeof(n=function(r,n){"use strict";var i;Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0,n=(i=n)&&i.__esModule?i:{default:i};var s=/version\/(\d+(\.?_?\d+)+)/i,a=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=n.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:opera)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=n.default.getFirstMatch(/(?:opr|opios)[\s\/](\S+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=n.default.getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=n.default.getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=n.default.getFirstMatch(/(?:swing)[\s\/](\d+(?:\.\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:coast)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:ucbrowser)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:Maxthon|mxios)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:epiphany)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:puffin)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:sleipnir)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:k-meleon)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=n.default.getFirstMatch(/(?:micromessenger)[\s\/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=n.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=n.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=n.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=n.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=n.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=n.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=n.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=n.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=n.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=n.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=n.default.getFirstMatch(/(?:qupzilla)[\s\/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=n.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=n.default.getFirstMatch(/(?:chromium)[\s\/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){return{name:n.default.getFirstMatch(/^(.*)\/(.*) /,e),version:n.default.getSecondMatch(/^(.*)\/(.*) /,e)}}}];r.default=a,e.exports=t.default})?n.apply(t,i):n)||(e.exports=s)},89:function(e,t,r){var n,i,s;i=[t,r(17)],void 0===(s="function"==typeof(n=function(r,n){"use strict";var i;Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0,n=(i=n)&&i.__esModule?i:{default:i};var s=[{test:[/windows phone/i],describe:function(e){var t=n.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:"Windows Phone",version:t}}},{test:[/windows/i],describe:function(e){var t=n.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=n.default.getWindowsVersionName(t);return{name:"Windows",version:t,versionName:r}}},{test:[/macintosh/i],describe:function(e){var t=n.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,".");return{name:"macOS",version:t}}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=n.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:"iOS",version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=n.default.getFirstMatch(/android[\s\/-](\d+(\.\d+)*)/i,e),r=n.default.getAndroidVersionName(t),i={name:"Android",version:t};return r&&(i.versionName=r),i}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=n.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:"WebOS"};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=n.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||n.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||n.default.getFirstMatch(/\bbb(\d+)/i,e);return{name:"BlackBerry",version:t}}},{test:[/bada/i],describe:function(e){var t=n.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return{name:"Bada",version:t}}},{test:[/tizen/i],describe:function(e){var t=n.default.getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i,e);return{name:"Tizen",version:t}}},{test:[/linux/i],describe:function(){return{name:"Linux"}}},{test:[/CrOS/],describe:function(){return{name:"Chrome OS"}}},{test:[/PlayStation 4/],describe:function(e){var t=n.default.getFirstMatch(/PlayStation 4[\/\s](\d+(\.\d+)*)/i,e);return{name:"PlayStation 4",version:t}}}];r.default=s,e.exports=t.default})?n.apply(t,i):n)||(e.exports=s)},90:function(e,t,r){var n,i,s;i=[t,r(17)],void 0===(s="function"==typeof(n=function(r,n){"use strict";var i;Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0,n=(i=n)&&i.__esModule?i:{default:i};var s={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"},a=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=n.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:s.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:s.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:s.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:s.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:s.tablet,vendor:"Amazon"}}},{test:[/tablet/i],describe:function(){return{type:s.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=n.default.getFirstMatch(/(ipod|iphone)/i,e);return{type:s.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:s.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:s.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:s.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:s.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:s.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:s.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:s.mobile}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:s.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:s.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:s.desktop}}},{test:function(e){return"playstation 4"===e.getOSName(!0)},describe:function(){return{type:s.tv}}}];r.default=a,e.exports=t.default})?n.apply(t,i):n)||(e.exports=s)},91:function(e,t,r){var n,i,s;i=[t,r(17)],void 0===(s="function"==typeof(n=function(r,n){"use strict";var i;Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0,n=(i=n)&&i.__esModule?i:{default:i};var s=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){var t=n.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:"EdgeHTML",version:t}}},{test:[/trident/i],describe:function(e){var t={name:"Trident"},r=n.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:"Presto"},r=n.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:"Gecko"},r=n.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:"Blink"}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:"WebKit"},r=n.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];r.default=s,e.exports=t.default})?n.apply(t,i):n)||(e.exports=s)}})});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createUid = function createUid() {
	  var key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
	  /**
	   * 28位
	   */
	  var ramStr = parseInt(Math.random() * 268435455).toString(2);
	
	  /* eslint-disable */
	  /**
	   * 44位
	   */
	  var mtimeStr = new Date().getTime().toString(2);
	
	  while (ramStr.length < 28) {
	    ramStr = '0' + ramStr;
	  }while (mtimeStr.length < 44) {
	    mtimeStr = '0' + mtimeStr;
	  }var binaryStr = ramStr + mtimeStr;
	
	  var outStr = '';
	
	  for (var i = 0; i < 12; i++) {
	    outStr += key.charAt(parseInt(binaryStr.substr(i * 6, 6), 2));
	  }
	
	  return outStr;
	};
	
	exports.default = createUid;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(105);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(146);
	
	var _horizontalPresent = __webpack_require__(148);
	
	var _horizontalPresent2 = _interopRequireDefault(_horizontalPresent);
	
	var _eventBus = __webpack_require__(119);
	
	var _eventBus2 = _interopRequireDefault(_eventBus);
	
	var _fComponent = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import animate from './animate';
	
	var horizontalPresent = function () {
	    function horizontalPresent(presentInfo, clientOptions) {
	        (0, _classCallCheck3.default)(this, horizontalPresent);
	
	        this.presentInfo = presentInfo;
	        this.clientOptions = clientOptions;
	        // console.log(presentInfo)
	
	        this.boxDom = null; // 总容器
	        this.containerDom = null; // 礼物容器
	        this.selectDom = null;
	        this.btn = null; // 发送按钮
	
	        this.coinDom = null;
	        this.userCoin = '0.00';
	        this.oneSecLimit = false;
	
	        this.width = document.documentElement.clientWidth;
	        this.height = document.documentElement.clientHeight;
	
	        this.selectWidth = null;
	        this.event = _eventBus2.default;
	
	        this.countdownTimer = {};
	        this.sendBtnTime = null;
	
	        this.currentPresentId = null;
	
	        this.userType = 'guest';
	        this.init();
	    }
	
	    (0, _createClass3.default)(horizontalPresent, [{
	        key: 'init',
	        value: function init(presentInfo) {
	
	            if (!presentInfo && !this.presentInfo) {
	                console.log('礼物信息错误');
	                return;
	            }
	
	            presentInfo && (this.presentInfo = presentInfo);
	
	            this.initDom(this.presentInfo);
	            this.initEvent();
	            this.initCustomEvent();
	        }
	    }, {
	        key: 'initDom',
	        value: function initDom(presentInfo) {
	
	            if (!presentInfo.length) {
	                console.log('礼物信息格式错误，需要为Array');
	                return;
	            }
	
	            this.boxDom = $(this.renderhorizontalPresentTpl());
	            this.selectDom = this.boxDom.find('.select_box');
	            this.containerDom = this.boxDom.find('.container');
	            this.barDom = this.boxDom.find('.bar');
	            this.btnDom = this.boxDom.find('.btn');
	            this.coinDom = this.boxDom.find('.num');
	
	            $('body').append(this.boxDom);
	
	            var _this = this;
	
	            this.barDom.on('touchend', '.money', function () {
	                if (_this.userType == 'guest' || typeof _this.clientOptions.guid == 'undefined') {
	                    _this.event.trigger('present-login');
	                    return false;
	                } else {
	                    var param = {
	                        guid: _this.clientOptions.guid,
	                        token: _this.clientOptions.token,
	                        deviceid: _this.clientOptions.deviceid_real,
	                        os: _this.clientOptions.os
	                    };
	                    var paramStr = '?os=' + _this.clientOptions.os;
	                    (0, _keys2.default)(param).forEach(function (key, index) {
	                        paramStr += '&' + key + '=' + param[key];
	                    });
	                    window.ground.dispatch("web", "https://user.iclient.ifeng.com/user_tasks/credit" + paramStr); // 跳转金币任务页
	                }
	            });
	
	            (0, _fComponent.Transform)(this.selectDom[0]);
	            (0, _fComponent.Transform)(this.btnDom[0]);
	        }
	    }, {
	        key: 'renderhorizontalPresentTpl',
	        value: function renderhorizontalPresentTpl() {
	            return this.renderhorizontalPresent(this.formatPresentInfo(this.presentInfo, this.userCoin));
	        }
	    }, {
	        key: 'getSelectWidth',
	        value: function getSelectWidth() {
	            if (this.selectWidth) {
	                return this.selectWidth;
	            } else {
	                this.selectWidth = this.selectDom.width();
	                return this.selectWidth;
	            }
	        }
	    }, {
	        key: 'formatPresentInfo',
	        value: function formatPresentInfo(presentInfo, userCoin) {
	            return { data: presentInfo, coin: userCoin };
	        }
	    }, {
	        key: 'initEvent',
	        value: function initEvent(presentInfo) {
	            // this.bindEnterEvent();
	            this.bindLeaveEvent();
	            this.bindBtnEvent();
	            this.bindSelectPresentEvent();
	            this.initCountdownPresent();
	        }
	    }, {
	        key: 'bindSelectPresentEvent',
	        value: function bindSelectPresentEvent() {
	            var _this = this;
	            this.containerDom.on('touchend', '.item', function () {
	
	                var _id = $(this).data('id');
	                var _present = _this.presentInfo.filter(function (_p) {
	                    return _p.id == _id;
	                });
	
	                if (_this.userType == 'guest' || typeof _this.clientOptions.guid == 'undefined') {
	                    if (_present[0].type != 'countdown') {
	                        _this.currentPresentId = _id;
	                        $(this).siblings().find('.item-icon').removeClass('select');
	                        $(this).find('.item-icon').addClass('select');
	                    } else if (_present[0].type == 'countdown') {
	                        if ($(this).find('.item-info span').text() == 0) {
	                            _this.currentPresentId = _id;
	                            $(this).siblings().find('.item-icon').removeClass('select');
	                            $(this).find('.item-icon').addClass('select');
	                        } else {
	                            _this.currentPresentId = null;
	                            $(this).siblings().find('.item-icon').removeClass('select');
	                        }
	                    }
	                    _this.btnDom.removeClass('forbid');
	                    return false;
	                }
	
	                if (!_present.length) {
	                    return false;
	                } else {
	                    // console.log($(this))
	                    if (_present[0].type != 'countdown') {
	                        _this.currentPresentId = _id;
	                        $(this).siblings().find('.item-icon').removeClass('select');
	                        $(this).find('.item-icon').addClass('select');
	
	                        if (_present[0].price <= _this.userCoin) {
	                            _this.btnDom.removeClass('forbid');
	                        } else {
	                            _this.btnDom.addClass('forbid');
	                        }
	                    } else if (_present[0].type == 'countdown') {
	                        if ($(this).find('.item-info span').text() == 0) {
	                            _this.currentPresentId = _id;
	                            $(this).siblings().find('.item-icon').removeClass('select');
	                            $(this).find('.item-icon').addClass('select');
	                            _this.btnDom.removeClass('forbid');
	                        } else {
	                            _this.currentPresentId = null;
	                            $(this).siblings().find('.item-icon').removeClass('select');
	                            _this.btnDom.addClass('forbid');
	                        }
	                    }
	                }
	
	                return false;
	            });
	        }
	    }, {
	        key: 'bindBtnEvent',
	        value: function bindBtnEvent() {
	            this.btnDom.on('touchstart', this.btnAnimateStart.bind(this));
	            this.btnDom.on('touchmove', this.btnAnimateStart.bind(this));
	            this.barDom.on('touchend', this.sendPresentInfo.bind(this));
	        }
	    }, {
	        key: 'bindLeaveEvent',
	        value: function bindLeaveEvent() {
	            this.selectDom.on('touchend', function () {
	                return false;
	            });
	            this.containerDom.on('touchend', function () {
	                return false;
	            });
	            // this.barDom.on('touchend', () => false);
	            this.boxDom.on('touchend', this.leave.bind(this));
	            // this.boxDom.on('touchend', function(e){
	            //     console.log(this)
	            // });
	        }
	    }, {
	        key: 'initCustomEvent',
	        value: function initCustomEvent() {
	            this.event.on('isLogin', this.login.bind(this));
	            this.event.on('present-user-balance', this.updateUserCoin.bind(this));
	            this.event.on('countdown', this.countdownStart.bind(this));
	        }
	    }, {
	        key: 'login',
	        value: function login(type) {
	            console.log(type);
	            if (type == 'user') {
	                this.userType = 'user';
	                this.btnDom.addClass('forbid');
	            } else if (type == 'guest') {
	                this.userType = 'guest';
	                this.btnDom.removeClass('forbid');
	            }
	        }
	    }, {
	        key: 'initCountdownPresent',
	        value: function initCountdownPresent() {
	            var _this2 = this;
	
	            this.presentInfo.filter(function (_p) {
	                return _p.type == 'countdown';
	            }).forEach(function (_p) {
	                _this2.countdownStart(_p.id);
	            });
	        }
	    }, {
	        key: 'formatCoin',
	        value: function formatCoin(value) {
	            return (value + '').split('.')[0];
	        }
	    }, {
	        key: 'updateCoin',
	        value: function updateCoin(value) {
	            this.userCoin = this.formatCoin(value);
	            this.coinDom && this.coinDom.text(this.userCoin);
	        }
	    }, {
	        key: 'updateUserCoin',
	        value: function updateUserCoin(obj) {
	            var _balance = obj.balance;
	            this.userCoin = this.formatCoin(_balance.sliver);
	            this.coinDom.text(this.userCoin);
	        }
	
	        // 处理送礼物1s延迟
	
	    }, {
	        key: 'handleOneSecLimit',
	        value: function handleOneSecLimit() {
	            var _this3 = this;
	
	            this.oneSecLimit = true;
	            this.btnDom.addClass('forbid');
	            setTimeout(function () {
	                _this3.btnDom.removeClass('forbid');
	                _this3.oneSecLimit = false;
	            }, 1000);
	        }
	    }, {
	        key: 'sendPresentInfo',
	        value: function sendPresentInfo() {
	            var _this4 = this;
	
	            if (this.userType == 'guest' || typeof this.clientOptions.guid == 'undefined') {
	                this.btnAnimateEnd();
	                this.event.trigger('present-login');
	                return false;
	            }
	            var _present = this.presentInfo.filter(function (_p) {
	                return _p.id == _this4.currentPresentId;
	            });
	            if (_present.length) {
	                if (this.sendBtnTime) {
	                    this.sendBtnTime = Date.now();
	                } else if (Date.now() - this.sendBtnTime > 500) {
	                    this.btnAnimateEnd();
	                }
	                if (_present.length) {
	                    if (_present[0].type == 'countdown') {
	                        // console.log(`sendCountdown`)
	                        this.containerDom.find('.item-icon').removeClass('select');
	                        this.btnDom.removeClass('forbid');
	                        this.event.trigger('countdown', this.currentPresentId);
	                        this.event.trigger('send-present', { id: this.currentPresentId, count: 1 });
	                        this.currentPresentId = null;
	                    } else {
	                        if (this.btnDom.hasClass('forbid') || this.oneSecLimit) {
	                            return false;
	                        }
	
	                        if (this.userCoin === '0') {
	                            this.btnDom.addClass('forbid');
	                            return false;
	                        }
	
	                        this.event.trigger('send-present', { id: this.currentPresentId, count: 1 });
	                        this.handleOneSecLimit();
	                    }
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: 'btnAnimateStart',
	        value: function btnAnimateStart() {
	            if (this.btnDom.hasClass('forbid')) {
	                return false;
	            }
	            this.btnDom[0].scaleX = this.btnDom[0].scaleY = 0.8;
	            // this.btnDom.addClass('forbid');
	            // setTimeout(()=>{
	            //     this.btnDom.removeClass('forbid');
	            // }, 1000);
	        }
	    }, {
	        key: 'btnAnimateEnd',
	        value: function btnAnimateEnd() {
	            this.btnDom[0].scaleX = this.btnDom[0].scaleY = 1;
	            // this.btnDom.animate({scaleX:1,scaleY:1}, 300);
	        }
	    }, {
	        key: 'countdownStart',
	        value: function countdownStart(present_id) {
	            var _this5 = this;
	
	            var _present = this.presentInfo.filter(function (_p) {
	                return _p.id == present_id;
	            });
	
	            if (_present.length && _present[0].type == 'countdown') {
	                // console.log(`countdownStart`)
	                var _time = _present[0].countdown;
	                var _item = this.containerDom.find('[data-id=' + present_id + '] .item-info span');
	
	                clearInterval(this.countdownTimer.present_id);
	                this.countdownTimer.present_id = null;
	
	                this.countdownTimer.present_id = setInterval(function () {
	                    if (_time <= 0) {
	                        _item.text('0');
	                        clearInterval(_this5.countdownTimer.present_id);
	                    }
	                    _item.text(_time);
	                    _time--;
	                }, 1000);
	            }
	
	            return false;
	        }
	    }, {
	        key: 'enter',
	        value: function enter() {
	            this.boxDom.show();
	            this.selectDom[0].translateX = this.getSelectWidth();
	            this.selectDom.animate({ translateX: 0 }, 500);
	        }
	    }, {
	        key: 'leave',
	        value: function leave() {
	            var _this6 = this;
	
	            this.selectDom.animate({ translateX: this.getSelectWidth() }, 500, function () {
	                // this.containerDom[0].translateY = 0;
	                _this6.boxDom.hide();
	            });
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.boxDom.hide();
	        }
	    }, {
	        key: 'renderhorizontalPresent',
	        value: function renderhorizontalPresent(presentInfo) {
	            return (0, _horizontalPresent2.default)(presentInfo);
	        }
	    }]);
	    return horizontalPresent;
	}();
	
	exports.default = horizontalPresent;

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */,
/* 148 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div id=\"horizontal_present_box\" class=\"horizontal_present_box\">\n    <div class=\"select_box\">\n        <div class=\"container\">\n        ")
	    ;  for(var i = 0; i < data.length; i++) {
	    ; __append("\n            <div class=\"item\" data-id=\"")
	    ; __append(escape(data[i].id))
	    ; __append("\">\n                <span class=\"item-icon\"></span>\n                <div class=\"item-img\" style=\"background-image: url(")
	    ; __append(escape(data[i].pic))
	    ; __append(")\">\n                    <!-- <img src=\"../images/1.png\"> -->\n                </div>\n                <div class=\"item-name\">")
	    ; __append(escape(data[i].name))
	    ; __append("</div>\n                <div class=\"item-info\">\n                ")
	    ;  if(data[i].type == 'countdown') { 
	    ; __append("\n                    <span>")
	    ; __append(escape(data[i].countdown))
	    ; __append("</span>秒\n                ")
	    ;  } else { 
	    ; __append("\n                    <span>")
	    ; __append(escape(data[i].price))
	    ; __append("</span>币\n                ")
	    ;  } 
	    ; __append("\n                </div>\n            </div>\n        ")
	    ;  } 
	    ; __append("\n        </div>\n        <div class=\"bar\">\n            <div class=\"money\">\n                余额: <span class=\"num\">")
	    ; __append(escape(coin))
	    ; __append("</span>金币\n                <span class=\"icon\"></span>\n            </div>\n            <div class=\"btn js_btn\">发送</div>\n        </div>\n    </div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(150);
	
	__webpack_require__(164);
	
	var _effect = __webpack_require__(167);
	
	var _effect2 = _interopRequireDefault(_effect);
	
	var _effectContentBox = __webpack_require__(168);
	
	var _effectContentBox2 = _interopRequireDefault(_effectContentBox);
	
	var _effectComboBox = __webpack_require__(169);
	
	var _effectComboBox2 = _interopRequireDefault(_effectComboBox);
	
	var _fComponent = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var horizontalEffect = function () {
	    function horizontalEffect(presentInfo) {
	        (0, _classCallCheck3.default)(this, horizontalEffect);
	
	        this.presentInfo = presentInfo;
	        this.width = document.documentElement.clientWidth;
	        this.height = document.documentElement.clientHeight;
	
	        this.containerDom = null; // 总容器
	        this.contentBoxDom = null; // 内容容器
	        this.comboBoxDom = null; // combo容器
	        this.contentBox = null; // 内容
	        this.comboBox = null; // combo
	
	        this.init();
	    }
	
	    (0, _createClass3.default)(horizontalEffect, [{
	        key: 'init',
	        value: function init() {
	            this.initDom();
	            (0, _fComponent.Transform)(this.containerDom[0]);
	            (0, _fComponent.Transform)(this.comboBoxDom[0]);
	        }
	    }, {
	        key: 'renderhorizontalEffect',
	        value: function renderhorizontalEffect() {
	            return (0, _effect2.default)();
	        }
	    }, {
	        key: 'renderContentBox',
	        value: function renderContentBox(data) {
	            return (0, _effectContentBox2.default)(data);
	        }
	    }, {
	        key: 'renderComboBox',
	        value: function renderComboBox(data) {
	            return (0, _effectComboBox2.default)(data);
	        }
	    }, {
	        key: 'initDom',
	        value: function initDom(data) {
	            this.containerDom = $(this.renderhorizontalEffect());
	            this.contentBoxDom = this.containerDom.find('.content-box');
	            this.comboBoxDom = this.containerDom.find('.combo-box');
	            $('body').append(this.containerDom);
	        }
	    }, {
	        key: 'emptyDom',
	        value: function emptyDom() {
	            this.contentBoxDom.empty();
	            this.comboBoxDom.empty();
	        }
	    }, {
	        key: 'tween',
	        value: function tween() {
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return new (Function.prototype.bind.apply(animate, [null].concat(args)))();
	        }
	    }, {
	        key: 'getCombo',
	        value: function getCombo(data) {
	            if (!data || !data.combo) {
	                return [1];
	            }
	
	            var _combo = (data.combo + '').split('');
	            console.log('combo-----', _combo);
	            return _combo;
	        }
	    }, {
	        key: 'getContent',
	        value: function getContent(data) {
	            return {
	                avatar: data.avatar,
	                nickname: data.nickname,
	                presentName: this.getPresentInfo(data.id).name || '',
	                presentImg: this.getPresentInfo(data.id).pic || ''
	            };
	        }
	    }, {
	        key: 'getPresentInfo',
	        value: function getPresentInfo(id) {
	            var _d = this.presentInfo.filter(function (present) {
	                return present.id == id;
	            });
	
	            return _d[0] || {};
	        }
	
	        // 初始化内容
	
	    }, {
	        key: 'start',
	        value: function start(_ref) {
	            var newData = _ref.newData,
	                oldData = _ref.oldData;
	
	            var _this = this;
	            return new _promise2.default(function (resolve, reject) {
	                // console.log(_this.getContent(newData))
	                _this.contentBox = _this.renderContentBox(_this.getContent(newData));
	                _this.contentBoxDom.html(_this.contentBox);
	
	                var _d = null;
	                if (oldData && oldData.combo) {
	                    _d = oldData.combo + 1;
	                }
	                // _this.comboBox = _this.renderComboBox({data : _this.getCombo({combo: _d || 1})});
	                // _this.comboBoxDom.html(_this.comboBox);
	
	                _this.containerDom[0].translateX = -1 * _this.width;
	                _this.containerDom[0].translateY = 0;
	
	                resolve({ newData: newData, oldData: oldData });
	            });
	        }
	
	        // 开始进入可视区
	
	    }, {
	        key: 'enter',
	        value: function enter(_ref2) {
	            var newData = _ref2.newData,
	                oldData = _ref2.oldData;
	
	            var _this = this;
	            return new _promise2.default(function (resolve, reject) {
	                _this.containerDom.show().css('opacity', 1).animate({ translateX: 0 }, 1000, function () {
	                    // console.log(newData, oldData)
	                    resolve({ newData: newData, oldData: oldData });
	                });
	            });
	        }
	    }, {
	        key: 'process',
	        value: function process(_ref3) {
	            var newData = _ref3.newData,
	                oldData = _ref3.oldData;
	
	            var _this = this;
	            return new _promise2.default(function (resolve, reject) {
	                // console.log(newData, oldData)
	                var _s = 0;
	                var _d = parseInt(newData.combo);
	
	                oldData && oldData.combo && (_s = parseInt(oldData.combo));
	
	                return _this.runCombo(_s, _d).then(function () {
	                    return resolve({ newData: newData, oldData: oldData });
	                });
	            });
	        }
	    }, {
	        key: 'runCombo',
	        value: function runCombo(start, end) {
	            // console.log(start,end)
	            var _this = this;
	            return new _promise2.default(function (resolve, reject) {
	
	                if (start == end) {
	                    resolve(true);
	                } else {
	                    console.log(start, end);
	                    var _fun = function _fun() {
	                        if (start == end) {
	                            resolve(true);
	                        } else {
	
	                            return _this.runCombo(start + 1, end).then(resolve);
	                        }
	                    };
	
	                    _this.comboBox = _this.renderComboBox({ data: _this.getCombo({ combo: start + 1 }) });
	                    _this.comboBoxDom.html(_this.comboBox);
	
	                    _this.comboBoxDom[0].scaleX = _this.comboBoxDom[0].scaleY = _this.comboBoxDom[0].scaleZ = 1.5;
	                    _this.comboBoxDom.css('opacity', 1).animate({
	                        scaleX: 1,
	                        scaleY: 1,
	                        scaleZ: 1
	                    }, 200, 'linear', _fun);
	                }
	            });
	        }
	    }, {
	        key: 'leave',
	        value: function leave(_ref4) {
	            var newData = _ref4.newData,
	                oldData = _ref4.oldData;
	
	            var _this = this;
	            return new _promise2.default(function (resolve, reject) {
	                _this.containerDom.animate({ translateY: -100, 'opacity': 0 }, 500, function () {
	                    resolve({ newData: newData, oldData: oldData });
	                });
	            });
	        }
	    }, {
	        key: 'end',
	        value: function end(_ref5) {
	            var newData = _ref5.newData,
	                oldData = _ref5.oldData;
	
	            var _this = this;
	            return new _promise2.default(function (resolve, reject) {
	                _this.emptyDom();
	                _this.comboBoxDom.css('opacity', 0);
	                _this.containerDom.hide();
	                resolve({ newData: newData, oldData: oldData });
	            });
	        }
	    }, {
	        key: 'setVerticalEffectTop',
	        value: function setVerticalEffectTop(top) {
	            var cssRule = '\n            .vertical .effect-box.verticalTop{\n                top: ' + top + '\n            }\n        ';
	
	            this.insertCSS(cssRule);
	            this.containerDom.addClass('verticalTop');
	        }
	    }, {
	        key: 'insertCSS',
	        value: function insertCSS(rule) {
	            var style = document.createElement("style");
	            style.innerHTML = rule;
	            document.head.appendChild(style);
	
	            return;
	        }
	    }]);
	    return horizontalEffect;
	}();
	
	exports.default = horizontalEffect;

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"effect-box\" style=\"display: none\">\n    <div class=\"content-box\">\n    </div>\n    <div class=\"combo-box\">\n    </div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"content\">\n    <div class=\"user\">\n        <div class=\"avater\" style=\"background-image: url(")
	    ; __append(escape(avatar))
	    ; __append(")\"></div>\n        <div class=\"name\">")
	    ; __append(escape(nickname))
	    ; __append("</div>\n    </div>\n    <div class=\"gift-name\">送出<span>")
	    ; __append(escape(presentName))
	    ; __append("</span></div>\n</div>\n<div class=\"gift-img\" style=\"background-image: url(")
	    ; __append(escape(presentImg))
	    ; __append(")\"></div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"num num-x\"></div>\n")
	    ;  for(var i = 0; i < data.length; i++) {
	    ; __append("\n    <div class=\"num num-")
	    ; __append(escape(data[i]))
	    ; __append("\"></div>\n")
	    ;  } 
	    ; __append("   ")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(171);
	
	__webpack_require__(181);
	
	var _goldEgg = __webpack_require__(183);
	
	var _goldEgg2 = _interopRequireDefault(_goldEgg);
	
	var _goldEggSuccess = __webpack_require__(184);
	
	var _goldEggSuccess2 = _interopRequireDefault(_goldEggSuccess);
	
	var _goldEggFail = __webpack_require__(185);
	
	var _goldEggFail2 = _interopRequireDefault(_goldEggFail);
	
	var _eventBus = __webpack_require__(119);
	
	var _eventBus2 = _interopRequireDefault(_eventBus);
	
	var _fComponent = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var goldEgg = function () {
	    function goldEgg(_ref) {
	        var _ref$orientation = _ref.orientation,
	            orientation = _ref$orientation === undefined ? 'vertical' : _ref$orientation;
	        (0, _classCallCheck3.default)(this, goldEgg);
	
	        this.orientation = orientation;
	
	        this.boxDom = null; // 总容器
	        this.eggBoxDom = null; // 蛋容器
	        this.selectDom = null;
	        this.btn = null; // 发送按钮
	        this.successDom = null; // 成功窗口容器
	        this.failDom = null; // 失败窗口容器
	        this.currentEggData = { // 当前金蛋信息
	            id: null,
	            price: 0,
	            countdown: null
	        };
	
	        this.state = 'hide';
	        this.Timer = null;
	
	        this.width = document.documentElement.clientWidth;
	        this.height = document.documentElement.clientHeight;
	        this.boxDomHeight = null;
	        this.event = _eventBus2.default;
	        this.init();
	    }
	
	    (0, _createClass3.default)(goldEgg, [{
	        key: 'init',
	        value: function init(presentInfo) {
	            this.initDom();
	            this.initEvent();
	            this.initCustomEvent();
	        }
	    }, {
	        key: 'initDom',
	        value: function initDom(presentInfo) {
	
	            this.boxDom = $(this.renderGoldEggTpl());
	            this.moneyDom = this.boxDom.find('.money');
	            this.sprinkleDom = this.boxDom.find('.money-sprinkle');
	            this.eggBoxDom = this.boxDom.find('.egg-box');
	            this.eggUpDom = this.boxDom.find('.egg-up');
	            this.btnDom = this.boxDom.find('.btn');
	            this.successDom = $(this.renderGoldEggSuccessTpl());
	            this.failDom = $(this.renderGoldEggFailTpl());
	
	            $('body').append(this.boxDom);
	            $('body').append(this.successDom);
	            $('body').append(this.failDom);
	
	            this.boxDomHeight = this.boxDom.height();
	            this.eggDomWidth = this.eggBoxDom.width();
	            this.eggDomHeight = this.eggBoxDom.height();
	
	            // Transform(this.boxDom[0]);
	            // Transform(this.eggBoxDom[0]);
	        }
	    }, {
	        key: 'renderGoldEggTpl',
	        value: function renderGoldEggTpl() {
	            return (0, _goldEgg2.default)();
	        }
	    }, {
	        key: 'renderGoldEggSuccessTpl',
	        value: function renderGoldEggSuccessTpl() {
	            return (0, _goldEggSuccess2.default)();
	        }
	    }, {
	        key: 'renderGoldEggFailTpl',
	        value: function renderGoldEggFailTpl() {
	            return (0, _goldEggFail2.default)();
	        }
	    }, {
	        key: 'initEvent',
	        value: function initEvent() {
	            this.bindBtnEvent();
	            this.bindHideEvent();
	        }
	    }, {
	        key: 'initCustomEvent',
	        value: function initCustomEvent() {
	            this.event.on('orientation', this.setOrientation.bind(this));
	            this.event.on('recieve-goldEggData', this.receiveGoldEggData.bind(this));
	        }
	    }, {
	        key: 'setOrientation',
	        value: function setOrientation(orientation) {
	            this.orientation = orientation;
	        }
	    }, {
	        key: 'receiveGoldEggData',
	        value: function receiveGoldEggData(data) {
	            console.log(data);
	            if (!data || !data.id) {
	                return;
	            }
	
	            this.currentEggData = data;
	            this.enter();
	        }
	    }, {
	        key: 'bindBtnEvent',
	        value: function bindBtnEvent() {
	            var _this2 = this;
	
	            this.boxDom.on('touchend', function () {
	                clearTimeout(_this2.Timer);
	                _this2.Timer = null;
	                _this2.showResult();
	                _this2.event.trigger('send-goldEggData', { id: _this2.currentEggData.id });
	                return false;
	            });
	        }
	    }, {
	        key: 'hideDom',
	        value: function hideDom() {
	            this.boxDom.hide();
	            this.successDom.hide();
	            this.failDom.hide();
	            return false;
	        }
	    }, {
	        key: 'bindHideEvent',
	        value: function bindHideEvent() {
	            this.successDom.on('touchend', this.hideDom.bind(this));
	            this.failDom.on('touchend', this.hideDom.bind(this));
	        }
	    }, {
	        key: 'showResult',
	        value: function showResult() {
	            var _this3 = this;
	
	            var _this = this;
	            this.showMoney().then(function () {
	                if (_this3.currentEggData.price > 0) {
	                    return _this3.successResult();
	                } else {
	                    return _this3.failResult();
	                }
	            }).then(function () {
	                setTimeout(function () {
	                    _this3.end();
	                }, 5000);
	            }).catch(function (err) {
	                return console.log(err);
	            });
	        }
	    }, {
	        key: 'successResult',
	        value: function successResult() {
	            var _this4 = this;
	
	            return new _promise2.default(function (resolve, reject) {
	                _this4.successDom.find('.js_num').text(_this4.currentEggData.price);
	                _this4.successDom.show().addClass('animated zoomIn');
	                setTimeout(function () {
	                    _this4.successDom.removeClass('animated zoomIn');
	                    resolve(1);
	                }, 1000);
	            });
	        }
	    }, {
	        key: 'failResult',
	        value: function failResult() {
	            var _this5 = this;
	
	            return new _promise2.default(function (resolve, reject) {
	                _this5.failDom.show().addClass('animated zoomIn');
	                setTimeout(function () {
	                    _this5.failDom.removeClass('animated zoomIn');
	                    resolve(1);
	                }, 1000);
	            });
	        }
	    }, {
	        key: 'end',
	        value: function end() {
	            this.boxDom.hide();
	            this.successDom.hide();
	            this.failDom.hide();
	            this.eggUpDom.css({ opacity: 1 });
	            this.sprinkleDom.css({ opacity: 0 });
	        }
	    }, {
	        key: 'showMoney',
	        value: function showMoney() {
	            var _this6 = this;
	
	            return new _promise2.default(function (resolve, reject) {
	                _this6.eggUpDom.animate({ opacity: 0 }, 500, function () {
	                    _this6.sprinkleDom.show().animate({ opacity: 1 }, 500, resolve);
	                });
	            });
	        }
	    }, {
	        key: 'countDown',
	        value: function countDown(seconds) {
	            var _this7 = this;
	
	            this.Timer = null;
	            this.Timer = setTimeout(function () {
	                _this7.boxDom.hide();
	                clearTimeout(_this7.Timer);
	                _this7.Timer = null;
	            }, seconds * 1000);
	        }
	    }, {
	        key: 'rotateEgg',
	        value: function rotateEgg() {
	            var _this8 = this;
	
	            this.eggBoxDom.addClass('animated wobble');
	            setTimeout(function () {
	                _this8.eggBoxDom.removeClass('animated wobble');
	            }, 1000);
	        }
	    }, {
	        key: 'enter',
	        value: function enter() {
	            var _this9 = this;
	
	            var orientation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.orientation;
	
	
	            this.resetStatus();
	
	            this.boxDom.removeClass('animated slideInDown');
	
	            // this.boxDom.show().animate({translateY: this.height / 2 + this.boxDomHeight}, 500, this.rotateEgg.bind(this));
	            if (orientation == 'vertical') {
	                this.boxDom.show().addClass('animated slideInDown slideIn');
	            } else if (orientation == 'horizontal') {
	                this.boxDom.show().addClass('animated slideInDown slideIn');
	            }
	
	            setTimeout(function () {
	                _this9.boxDom.removeClass('animated slideInDown');
	            }, 1000);
	
	            this.countDown(this.currentEggData.countdown);
	        }
	    }, {
	        key: 'leave',
	        value: function leave() {
	            var orientation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.orientation;
	
	            if (orientation == 'vertical') {} else if (orientation == 'horizontal') {}
	        }
	    }, {
	        key: 'resetStatus',
	        value: function resetStatus() {
	            this.boxDom[0].translateY = 0;
	            this.eggUpDom.css({ 'opacity': 1 }).show();
	            this.sprinkleDom.css({ 'opacity': 0 }).hide();
	        }
	    }]);
	    return goldEgg;
	}();
	
	exports.default = goldEgg;

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */,
/* 183 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"goldEgg-box\">\n    <div class=\"container-box\">\n        <div class=\"egg-box wobble\">\n            <div class=\"money-sprinkle\"></div>\n            <div class=\"egg-up\"></div>\n            <div class=\"egg-under\"></div>\n        </div>\n        <div class=\"money\"></div>\n    </div>\n    <div class=\"btn\">砸金蛋，抢金币</div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"goldEgg-result-box success\">\n    <div class=\"top\"></div>\n    <div class=\"money\"></div>\n    <div class=\"content\">\n        <div class=\"coin\">恭喜您获得金币<span class=\"js_num\">0</span>枚</div>\n        <div class=\"info\">已存入您的账户，可以任性送礼物了</div>\n    </div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"goldEgg-result-box fail\">\n    <div class=\"top\"></div>\n    <div class=\"money\"></div>\n    <div class=\"content\">\n        <div class=\"coin\">金币会有的</div>\n        <div class=\"info\">请看我漂亮的坚持</div>\n    </div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _zan = __webpack_require__(187);
	
	var _zan2 = _interopRequireDefault(_zan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _zan2.default;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(188);
	
	__webpack_require__(194);
	
	var _zan = __webpack_require__(196);
	
	var _zan2 = _interopRequireDefault(_zan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import {Transform, RAF} from 'f.component.util';
	__webpack_require__(197);
	
	
	console.log(PIXI);
	
	var DianZan = function () {
	    function DianZan(_ref) {
	        var message = _ref.message,
	            _ref$dianzan_config = _ref.dianzan_config,
	            dianzan_config = _ref$dianzan_config === undefined ? {} : _ref$dianzan_config;
	        (0, _classCallCheck3.default)(this, DianZan);
	
	        this.message = message;
	        this.config = dianzan_config;
	        this.init();
	    }
	
	    (0, _createClass3.default)(DianZan, [{
	        key: 'init',
	        value: function init() {
	            console.log('config', config);
	            this.state = true; // canvas状态
	            this.timer = null;
	            this.heartsContainer = []; // 管理容器
	
	            this.initCallback = this.config.initCallback || function () {};
	            this.speed = this.config.speed || 0.008;
	            this.t = this.config.t || 0;
	            this.originX = this.config.originX || 300;
	            this.originY = this.config.originY || 500;
	            this.heartX = this.config.heartX || 50;
	            this.heartY = this.config.heartY || 20;
	            this.speedLoop = this.config.speedLoop || 600;
	            this.praiseType = config.info && config.info.praiseType || '2';
	
	            this.initDom();
	            this.initCanvas(this.config); // 初始化canvas
	            this.initEvent();
	            this.loadResources(this.setup); // 加载资源
	            this.initCustomEvent();
	        }
	    }, {
	        key: 'initDom',
	        value: function initDom() {
	            this.boxDom = $((0, _zan2.default)());
	            this.container = this.boxDom.find('#zan-canvas')[0];
	            this.btnDom = this.boxDom.find('.btn');
	            $('body').append(this.boxDom);
	        }
	    }, {
	        key: 'initCanvas',
	        value: function initCanvas(options) {
	            var DPR = 1;
	            var WIDTH = parseInt(document.documentElement.clientWidth / DPR);
	            var HEIGHT = parseInt(document.documentElement.clientHeight / DPR);
	
	            this.scale = parseFloat(WIDTH / 750);
	            this.width = (options.width || 400) * this.scale;
	            this.height = (options.height || 600) * this.scale;
	
	            this.stage = new PIXI.Container();
	            this.renderer = PIXI.autoDetectRenderer(this.width, this.height, {
	                antialias: true,
	                view: this.container,
	                transparent: true
	            });
	        }
	    }, {
	        key: 'initEvent',
	        value: function initEvent() {
	            // 点赞需求
	            // this.loopZan();
	            // this.btnDom.on('touchend', this.loopZanSpeed.bind(this))
	            this.btnDom.on('touchend', this.zan.bind(this));
	            this.btnDom.on('touchend', this.sendToMessageCenter.bind(this));
	        }
	    }, {
	        key: 'start',
	        value: function start(time, sta) {
	            var _this = this;
	            clearInterval(this.timer);
	            this.timer = interval(function () {
	                _this.initHeart('heart' + _this.random(0, 5), _this.genCoord());
	            }, time);
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            clearInterval(this.timer);
	        }
	    }, {
	        key: 'loopZanSpeed',
	        value: function loopZanSpeed() {
	            var _this = this;
	            this.speedLoop = 200;
	            clearTimeout(this.loopZanSpeedTimer);
	            this.loopZanSpeedTimer = setTimeout(function () {
	                _this.speedLoop = 600;
	            }, 2000);
	        }
	    }, {
	        key: 'loopZan',
	        value: function loopZan() {
	            // console.log('time--', this.speedLoop);
	            var _this = this;
	            clearTimeout(this.loopTimer);
	            this.loopTimer = setTimeout(function () {
	                _this.initHeart('heart' + _this.random(0, 5), _this.genCoord());
	                _this.loopZan();
	            }, this.speedLoop);
	        }
	    }, {
	        key: 'zan',
	        value: function zan(fn) {
	            this.initHeart('heart' + this.random(0, 5), this.genCoord());
	            fn && typeof fn === 'function' && fn();
	            return false;
	        }
	    }, {
	        key: 'initCustomEvent',
	        value: function initCustomEvent() {
	            this.receiveFromMessageCenter();
	        }
	    }, {
	        key: 'receiveFromMessageCenter',
	        value: function receiveFromMessageCenter() {
	            this.message.on('praise:zan', 201, this.zan.bind(this));
	        }
	    }, {
	        key: 'sendToMessageCenter',
	        value: function sendToMessageCenter() {
	            this.message.send('praise', 101);
	        }
	    }, {
	        key: 'loadResources',
	        value: function loadResources(callback) {
	            var _this = this;
	            // console.log(dataJson)
	            // var texture = PIXI.Texture.fromImage(data.meta.image);
	            var data = {};
	            if (this.praiseType === '2') {
	                if (document.body.classList.contains('wideScreen')) {
	                    data = __webpack_require__(386);
	                } else {
	                    data = __webpack_require__(387);
	                }
	            } else if (this.praiseType === '3') {
	                data = __webpack_require__(388);
	            }
	            if (__urlParams.liveid == '131498') {
	                data = __webpack_require__(389);
	            }
	
	            var baseTexture = new PIXI.BaseTexture.from(data.meta.image, null, 1);
	            var spritesheet = new PIXI.Spritesheet(baseTexture, data);
	            spritesheet.parse(function (textures) {
	                // finished preparing spritesheet textures
	                callback.bind(_this)();
	            });
	            // PIXI.loader
	            //     .add(dataJson)
	            //     // .on("progress", loadProgressHandler)
	            //     .load(callback.bind(_this));
	        }
	    }, {
	        key: 'setup',
	        value: function setup() {
	            var _this = this;
	
	            this.updateCanvas();
	            this.initCallback();
	        }
	    }, {
	        key: 'genCoord',
	        value: function genCoord() {
	            var _originX = this.originX,
	                _originY = this.originY,
	                _heartX = this.heartX,
	                _heartY = this.heartY;
	
	            var _l = Math.random() > 0.5 ? 1 : -1;
	
	            var start = { x: _originX, y: _originY };
	            var c1 = {
	                x: _originX + _l * this.random(_heartX, 2 * _heartX),
	                y: (_originY - _heartY) * this.random(5, 7) / 10
	            };
	            var c2 = {
	                x: _originX - _l * this.random(_heartX, 2 * _heartX),
	                y: (_originY - _heartY) * this.random(2, 4) / 10
	            };
	            var end = { x: _originX + this.random(-_heartX, _heartX), y: _heartY };
	            // console.log([start, c1, c2, end])
	            return [start, c1, c2, end];
	        }
	    }, {
	        key: 'updateCanvas',
	        value: function updateCanvas() {
	            var _this = this;
	            var _position = null;
	            if (!this.state) {
	                return;
	            }
	
	            for (var i = 0; i < this.heartsContainer.length; i++) {
	                if (this.heartsContainer[i].t > 1) {
	                    this.heartsContainer[i].destroy();
	                    this.heartsContainer.splice(i, 1);
	                    i--;
	                } else {
	                    _position = this.heartsContainer[i].bezierCurveTo(this.heartsContainer[i].t);
	                    this.heartsContainer[i].position.x = _position[0] * this.scale;
	                    this.heartsContainer[i].position.y = _position[1] * this.scale;
	                    this.heartsContainer[i].t += this.speed;
	                    this.heartsContainer[i].alpha = 1 - this.heartsContainer[i].t;
	                }
	            }
	
	            this.renderer.render(this.stage);
	
	            requestAnimationFrame(this.updateCanvas.bind(this));
	        }
	    }, {
	        key: 'initHeart',
	        value: function initHeart(name, data) {
	            var _heart = new PIXI.Sprite(new PIXI.Texture.fromFrame(name + '.png'));
	            _heart.t = 0;
	            _heart.bezierCurveTo = this.bezierCurveTo(data[0], data[1], data[2], data[3]);
	            _heart.anchor.set(0.5);
	            _heart.scale.set(this.scale);
	            // 放置在画面中间靠下的位置
	            _heart.position.set(data[0].x, data[0].y);
	
	            this.heartsContainer.push(_heart);
	            this.stage.addChild(_heart);
	        }
	    }, {
	        key: 'bezierCurveTo',
	        value: function bezierCurveTo(s, c1, c2, e, t) {
	            var cx1 = 3 * (c1.x - s.x);
	            var bx1 = 3 * (c2.x - c1.x) - cx1;
	            var ax1 = e.x - s.x - cx1 - bx1;
	
	            var cy1 = 3 * (c1.y - s.y);
	            var by1 = 3 * (c2.y - c1.y) - cy1;
	            var ay1 = e.y - s.y - cy1 - by1;
	
	            return function (t) {
	                var _x = ax1 * (t * t * t) + bx1 * (t * t) + cx1 * t + s.x;
	                var _y = ay1 * (t * t * t) + by1 * (t * t) + cy1 * t + s.y;
	
	                return [_x, _y];
	            };
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.btnDom.animate({ opacity: '1' });
	            this.boxDom.show();
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.btnDom.animate({ opacity: '0' });
	            this.boxDom.hide();
	        }
	    }, {
	        key: 'random',
	        value: function random(n, m) {
	            return Math.floor(Math.random() * (m - n + 1) + n);
	        }
	    }]);
	    return DianZan;
	}();
	
	function interval(func, wait) {
	    var interv = function interv() {
	        func.call(null);
	        setTimeout(interv, wait);
	    };
	    setTimeout(interv, wait);
	}
	
	exports.default = DianZan;

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */,
/* 196 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"zan-box\">\n    <div class=\"btn\">\n        <div class=\"icon\"></div>\n    </div>\n    <canvas id=\"zan-canvas\" class=\"zan-canvas\"></canvas>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	exports.loader = exports.prepare = exports.particles = exports.mesh = exports.loaders = exports.interaction = exports.filters = exports.extras = exports.extract = exports.accessibility = undefined;
	
	var _polyfill = __webpack_require__(198);
	
	Object.keys(_polyfill).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _polyfill[key];
	        }
	    });
	});
	
	var _core = __webpack_require__(204);
	
	Object.keys(_core).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _core[key];
	        }
	    });
	});
	
	var _deprecation = __webpack_require__(322);
	
	var _deprecation2 = _interopRequireDefault(_deprecation);
	
	var _accessibility = __webpack_require__(323);
	
	var accessibility = _interopRequireWildcard(_accessibility);
	
	var _extract = __webpack_require__(326);
	
	var extract = _interopRequireWildcard(_extract);
	
	var _extras = __webpack_require__(329);
	
	var extras = _interopRequireWildcard(_extras);
	
	var _filters = __webpack_require__(337);
	
	var filters = _interopRequireWildcard(_filters);
	
	var _interaction = __webpack_require__(349);
	
	var interaction = _interopRequireWildcard(_interaction);
	
	var _loaders = __webpack_require__(355);
	
	var loaders = _interopRequireWildcard(_loaders);
	
	var _mesh = __webpack_require__(368);
	
	var mesh = _interopRequireWildcard(_mesh);
	
	var _particles = __webpack_require__(375);
	
	var particles = _interopRequireWildcard(_particles);
	
	var _prepare = __webpack_require__(380);
	
	var prepare = _interopRequireWildcard(_prepare);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// export core
	_core.utils.mixins.performMixins();
	
	/**
	 * Alias for {@link PIXI.loaders.shared}.
	 * @name loader
	 * @memberof PIXI
	 * @type {PIXI.loader.Loader}
	 */
	
	
	// handle mixins now, after all code has been added, including deprecation
	
	
	// export libs
	// import polyfills. Done as an export to make sure polyfills are imported first
	var loader = loaders.shared || null;
	
	exports.accessibility = accessibility;
	exports.extract = extract;
	exports.extras = extras;
	exports.filters = filters;
	exports.interaction = interaction;
	exports.loaders = loaders;
	exports.mesh = mesh;
	exports.particles = particles;
	exports.prepare = prepare;
	exports.loader = loader;
	
	// Apply the deprecations
	
	if (typeof _deprecation2.default === 'function') {
	    (0, _deprecation2.default)(exports);
	}
	
	// Always export PixiJS globally.
	global.PIXI = exports; // eslint-disable-line
	//# sourceMappingURL=index.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(199);
	
	__webpack_require__(201);
	
	__webpack_require__(202);
	
	__webpack_require__(203);
	
	if (!window.ArrayBuffer) {
	    window.ArrayBuffer = Array;
	}
	
	if (!window.Float32Array) {
	    window.Float32Array = Array;
	}
	
	if (!window.Uint32Array) {
	    window.Uint32Array = Array;
	}
	
	if (!window.Uint16Array) {
	    window.Uint16Array = Array;
	}
	//# sourceMappingURL=index.js.map

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectAssign = __webpack_require__(200);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!Object.assign) {
	    Object.assign = _objectAssign2.default;
	} // References:
	// https://github.com/sindresorhus/object-assign
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	//# sourceMappingURL=Object.assign.js.map

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// References:
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// https://gist.github.com/1579671
	// http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
	// https://gist.github.com/timhall/4078614
	// https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/requestAnimationFrame
	
	// Expected to be used with Browserfiy
	// Browserify automatically detects the use of `global` and passes the
	// correct reference of `global`, `self`, and finally `window`
	
	var ONE_FRAME_TIME = 16;
	
	// Date.now
	if (!(Date.now && Date.prototype.getTime)) {
	    Date.now = function now() {
	        return new Date().getTime();
	    };
	}
	
	// performance.now
	if (!(global.performance && global.performance.now)) {
	    var startTime = Date.now();
	
	    if (!global.performance) {
	        global.performance = {};
	    }
	
	    global.performance.now = function () {
	        return Date.now() - startTime;
	    };
	}
	
	// requestAnimationFrame
	var lastTime = Date.now();
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	
	for (var x = 0; x < vendors.length && !global.requestAnimationFrame; ++x) {
	    var p = vendors[x];
	
	    global.requestAnimationFrame = global[p + 'RequestAnimationFrame'];
	    global.cancelAnimationFrame = global[p + 'CancelAnimationFrame'] || global[p + 'CancelRequestAnimationFrame'];
	}
	
	if (!global.requestAnimationFrame) {
	    global.requestAnimationFrame = function (callback) {
	        if (typeof callback !== 'function') {
	            throw new TypeError(callback + 'is not a function');
	        }
	
	        var currentTime = Date.now();
	        var delay = ONE_FRAME_TIME + lastTime - currentTime;
	
	        if (delay < 0) {
	            delay = 0;
	        }
	
	        lastTime = currentTime;
	
	        return setTimeout(function () {
	            lastTime = Date.now();
	            callback(performance.now());
	        }, delay);
	    };
	}
	
	if (!global.cancelAnimationFrame) {
	    global.cancelAnimationFrame = function (id) {
	        return clearTimeout(id);
	    };
	}
	//# sourceMappingURL=requestAnimationFrame.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	"use strict";
	
	// References:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
	
	if (!Math.sign) {
	    Math.sign = function mathSign(x) {
	        x = Number(x);
	
	        if (x === 0 || isNaN(x)) {
	            return x;
	        }
	
	        return x > 0 ? 1 : -1;
	    };
	}
	//# sourceMappingURL=Math.sign.js.map

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	'use strict';
	
	// References:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
	
	if (!Number.isInteger) {
	    Number.isInteger = function numberIsInteger(value) {
	        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	    };
	}
	//# sourceMappingURL=Number.isInteger.js.map

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.autoDetectRenderer = exports.Application = exports.Filter = exports.SpriteMaskFilter = exports.Quad = exports.RenderTarget = exports.ObjectRenderer = exports.WebGLManager = exports.Shader = exports.CanvasRenderTarget = exports.TextureUvs = exports.VideoBaseTexture = exports.BaseRenderTexture = exports.RenderTexture = exports.BaseTexture = exports.TextureMatrix = exports.Texture = exports.Spritesheet = exports.CanvasGraphicsRenderer = exports.GraphicsRenderer = exports.GraphicsData = exports.Graphics = exports.TextMetrics = exports.TextStyle = exports.Text = exports.SpriteRenderer = exports.CanvasTinter = exports.CanvasSpriteRenderer = exports.Sprite = exports.TransformBase = exports.TransformStatic = exports.Transform = exports.Container = exports.DisplayObject = exports.Bounds = exports.glCore = exports.WebGLRenderer = exports.CanvasRenderer = exports.ticker = exports.utils = exports.settings = undefined;
	
	var _const = __webpack_require__(205);
	
	Object.keys(_const).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _const[key];
	    }
	  });
	});
	
	var _math = __webpack_require__(206);
	
	Object.keys(_math).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _math[key];
	    }
	  });
	});
	
	var _pixiGlCore = __webpack_require__(216);
	
	Object.defineProperty(exports, 'glCore', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_pixiGlCore).default;
	  }
	});
	
	var _Bounds = __webpack_require__(233);
	
	Object.defineProperty(exports, 'Bounds', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bounds).default;
	  }
	});
	
	var _DisplayObject = __webpack_require__(234);
	
	Object.defineProperty(exports, 'DisplayObject', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DisplayObject).default;
	  }
	});
	
	var _Container = __webpack_require__(243);
	
	Object.defineProperty(exports, 'Container', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Container).default;
	  }
	});
	
	var _Transform = __webpack_require__(242);
	
	Object.defineProperty(exports, 'Transform', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Transform).default;
	  }
	});
	
	var _TransformStatic = __webpack_require__(240);
	
	Object.defineProperty(exports, 'TransformStatic', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TransformStatic).default;
	  }
	});
	
	var _TransformBase = __webpack_require__(241);
	
	Object.defineProperty(exports, 'TransformBase', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TransformBase).default;
	  }
	});
	
	var _Sprite = __webpack_require__(250);
	
	Object.defineProperty(exports, 'Sprite', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sprite).default;
	  }
	});
	
	var _CanvasSpriteRenderer = __webpack_require__(267);
	
	Object.defineProperty(exports, 'CanvasSpriteRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasSpriteRenderer).default;
	  }
	});
	
	var _CanvasTinter = __webpack_require__(276);
	
	Object.defineProperty(exports, 'CanvasTinter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasTinter).default;
	  }
	});
	
	var _SpriteRenderer = __webpack_require__(277);
	
	Object.defineProperty(exports, 'SpriteRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SpriteRenderer).default;
	  }
	});
	
	var _Text = __webpack_require__(303);
	
	Object.defineProperty(exports, 'Text', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Text).default;
	  }
	});
	
	var _TextStyle = __webpack_require__(304);
	
	Object.defineProperty(exports, 'TextStyle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextStyle).default;
	  }
	});
	
	var _TextMetrics = __webpack_require__(305);
	
	Object.defineProperty(exports, 'TextMetrics', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextMetrics).default;
	  }
	});
	
	var _Graphics = __webpack_require__(307);
	
	Object.defineProperty(exports, 'Graphics', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Graphics).default;
	  }
	});
	
	var _GraphicsData = __webpack_require__(308);
	
	Object.defineProperty(exports, 'GraphicsData', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GraphicsData).default;
	  }
	});
	
	var _GraphicsRenderer = __webpack_require__(310);
	
	Object.defineProperty(exports, 'GraphicsRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GraphicsRenderer).default;
	  }
	});
	
	var _CanvasGraphicsRenderer = __webpack_require__(318);
	
	Object.defineProperty(exports, 'CanvasGraphicsRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasGraphicsRenderer).default;
	  }
	});
	
	var _Spritesheet = __webpack_require__(319);
	
	Object.defineProperty(exports, 'Spritesheet', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Spritesheet).default;
	  }
	});
	
	var _Texture = __webpack_require__(251);
	
	Object.defineProperty(exports, 'Texture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Texture).default;
	  }
	});
	
	var _TextureMatrix = __webpack_require__(286);
	
	Object.defineProperty(exports, 'TextureMatrix', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextureMatrix).default;
	  }
	});
	
	var _BaseTexture = __webpack_require__(252);
	
	Object.defineProperty(exports, 'BaseTexture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BaseTexture).default;
	  }
	});
	
	var _RenderTexture = __webpack_require__(270);
	
	Object.defineProperty(exports, 'RenderTexture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RenderTexture).default;
	  }
	});
	
	var _BaseRenderTexture = __webpack_require__(271);
	
	Object.defineProperty(exports, 'BaseRenderTexture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BaseRenderTexture).default;
	  }
	});
	
	var _VideoBaseTexture = __webpack_require__(262);
	
	Object.defineProperty(exports, 'VideoBaseTexture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoBaseTexture).default;
	  }
	});
	
	var _TextureUvs = __webpack_require__(266);
	
	Object.defineProperty(exports, 'TextureUvs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextureUvs).default;
	  }
	});
	
	var _CanvasRenderTarget = __webpack_require__(273);
	
	Object.defineProperty(exports, 'CanvasRenderTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasRenderTarget).default;
	  }
	});
	
	var _Shader = __webpack_require__(292);
	
	Object.defineProperty(exports, 'Shader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Shader).default;
	  }
	});
	
	var _WebGLManager = __webpack_require__(279);
	
	Object.defineProperty(exports, 'WebGLManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebGLManager).default;
	  }
	});
	
	var _ObjectRenderer = __webpack_require__(278);
	
	Object.defineProperty(exports, 'ObjectRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ObjectRenderer).default;
	  }
	});
	
	var _RenderTarget = __webpack_require__(289);
	
	Object.defineProperty(exports, 'RenderTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RenderTarget).default;
	  }
	});
	
	var _Quad = __webpack_require__(290);
	
	Object.defineProperty(exports, 'Quad', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Quad).default;
	  }
	});
	
	var _SpriteMaskFilter = __webpack_require__(282);
	
	Object.defineProperty(exports, 'SpriteMaskFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SpriteMaskFilter).default;
	  }
	});
	
	var _Filter = __webpack_require__(283);
	
	Object.defineProperty(exports, 'Filter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Filter).default;
	  }
	});
	
	var _Application = __webpack_require__(320);
	
	Object.defineProperty(exports, 'Application', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Application).default;
	  }
	});
	
	var _autoDetectRenderer = __webpack_require__(321);
	
	Object.defineProperty(exports, 'autoDetectRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _autoDetectRenderer.autoDetectRenderer;
	  }
	});
	
	var _utils = __webpack_require__(244);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _ticker = __webpack_require__(263);
	
	var ticker = _interopRequireWildcard(_ticker);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _CanvasRenderer = __webpack_require__(268);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _WebGLRenderer = __webpack_require__(280);
	
	var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.settings = _settings2.default;
	exports.utils = utils;
	exports.ticker = ticker;
	exports.CanvasRenderer = _CanvasRenderer2.default;
	exports.WebGLRenderer = _WebGLRenderer2.default; /**
	                                                  * @namespace PIXI
	                                                  */
	//# sourceMappingURL=index.js.map

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * String of the current PIXI version.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name VERSION
	 * @type {string}
	 */
	var VERSION = exports.VERSION = '4.8.1';
	
	/**
	 * Two Pi.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @type {number}
	 */
	var PI_2 = exports.PI_2 = Math.PI * 2;
	
	/**
	 * Conversion factor for converting radians to degrees.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @type {number}
	 */
	var RAD_TO_DEG = exports.RAD_TO_DEG = 180 / Math.PI;
	
	/**
	 * Conversion factor for converting degrees to radians.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @type {number}
	 */
	var DEG_TO_RAD = exports.DEG_TO_RAD = Math.PI / 180;
	
	/**
	 * Constant to identify the Renderer Type.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name RENDERER_TYPE
	 * @type {object}
	 * @property {number} UNKNOWN - Unknown render type.
	 * @property {number} WEBGL - WebGL render type.
	 * @property {number} CANVAS - Canvas render type.
	 */
	var RENDERER_TYPE = exports.RENDERER_TYPE = {
	  UNKNOWN: 0,
	  WEBGL: 1,
	  CANVAS: 2
	};
	
	/**
	 * Various blend modes supported by PIXI.
	 *
	 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
	 * Anything else will silently act like NORMAL.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name BLEND_MODES
	 * @type {object}
	 * @property {number} NORMAL
	 * @property {number} ADD
	 * @property {number} MULTIPLY
	 * @property {number} SCREEN
	 * @property {number} OVERLAY
	 * @property {number} DARKEN
	 * @property {number} LIGHTEN
	 * @property {number} COLOR_DODGE
	 * @property {number} COLOR_BURN
	 * @property {number} HARD_LIGHT
	 * @property {number} SOFT_LIGHT
	 * @property {number} DIFFERENCE
	 * @property {number} EXCLUSION
	 * @property {number} HUE
	 * @property {number} SATURATION
	 * @property {number} COLOR
	 * @property {number} LUMINOSITY
	 */
	var BLEND_MODES = exports.BLEND_MODES = {
	  NORMAL: 0,
	  ADD: 1,
	  MULTIPLY: 2,
	  SCREEN: 3,
	  OVERLAY: 4,
	  DARKEN: 5,
	  LIGHTEN: 6,
	  COLOR_DODGE: 7,
	  COLOR_BURN: 8,
	  HARD_LIGHT: 9,
	  SOFT_LIGHT: 10,
	  DIFFERENCE: 11,
	  EXCLUSION: 12,
	  HUE: 13,
	  SATURATION: 14,
	  COLOR: 15,
	  LUMINOSITY: 16,
	  NORMAL_NPM: 17,
	  ADD_NPM: 18,
	  SCREEN_NPM: 19
	};
	
	/**
	 * Various webgl draw modes. These can be used to specify which GL drawMode to use
	 * under certain situations and renderers.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name DRAW_MODES
	 * @type {object}
	 * @property {number} POINTS
	 * @property {number} LINES
	 * @property {number} LINE_LOOP
	 * @property {number} LINE_STRIP
	 * @property {number} TRIANGLES
	 * @property {number} TRIANGLE_STRIP
	 * @property {number} TRIANGLE_FAN
	 */
	var DRAW_MODES = exports.DRAW_MODES = {
	  POINTS: 0,
	  LINES: 1,
	  LINE_LOOP: 2,
	  LINE_STRIP: 3,
	  TRIANGLES: 4,
	  TRIANGLE_STRIP: 5,
	  TRIANGLE_FAN: 6
	};
	
	/**
	 * The scale modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
	 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name SCALE_MODES
	 * @type {object}
	 * @property {number} LINEAR Smooth scaling
	 * @property {number} NEAREST Pixelating scaling
	 */
	var SCALE_MODES = exports.SCALE_MODES = {
	  LINEAR: 0,
	  NEAREST: 1
	};
	
	/**
	 * The wrap modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
	 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
	 * If the texture is non power of two then clamp will be used regardless as webGL can
	 * only use REPEAT if the texture is po2.
	 *
	 * This property only affects WebGL.
	 *
	 * @static
	 * @constant
	 * @name WRAP_MODES
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} CLAMP - The textures uvs are clamped
	 * @property {number} REPEAT - The texture uvs tile and repeat
	 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
	 */
	var WRAP_MODES = exports.WRAP_MODES = {
	  CLAMP: 0,
	  REPEAT: 1,
	  MIRRORED_REPEAT: 2
	};
	
	/**
	 * The gc modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
	 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
	 * used for a specified period of time they will be removed from the GPU. They will of course
	 * be uploaded again when they are required. This is a silent behind the scenes process that
	 * should ensure that the GPU does not  get filled up.
	 *
	 * Handy for mobile devices!
	 * This property only affects WebGL.
	 *
	 * @static
	 * @constant
	 * @name GC_MODES
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} AUTO - Garbage collection will happen periodically automatically
	 * @property {number} MANUAL - Garbage collection will need to be called manually
	 */
	var GC_MODES = exports.GC_MODES = {
	  AUTO: 0,
	  MANUAL: 1
	};
	
	/**
	 * Regexp for image type by extension.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @type {RegExp|string}
	 * @example `image.png`
	 */
	var URL_FILE_EXTENSION = exports.URL_FILE_EXTENSION = /\.(\w{3,4})(?:$|\?|#)/i;
	
	/**
	 * Regexp for data URI.
	 * Based on: {@link https://github.com/ragingwind/data-uri-regex}
	 *
	 * @static
	 * @constant
	 * @name DATA_URI
	 * @memberof PIXI
	 * @type {RegExp|string}
	 * @example data:image/png;base64
	 */
	var DATA_URI = exports.DATA_URI = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
	
	/**
	 * Regexp for SVG size.
	 *
	 * @static
	 * @constant
	 * @name SVG_SIZE
	 * @memberof PIXI
	 * @type {RegExp|string}
	 * @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
	 */
	var SVG_SIZE = exports.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i; // eslint-disable-line max-len
	
	/**
	 * Constants that identify shapes, mainly to prevent `instanceof` calls.
	 *
	 * @static
	 * @constant
	 * @name SHAPES
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} POLY Polygon
	 * @property {number} RECT Rectangle
	 * @property {number} CIRC Circle
	 * @property {number} ELIP Ellipse
	 * @property {number} RREC Rounded Rectangle
	 */
	var SHAPES = exports.SHAPES = {
	  POLY: 0,
	  RECT: 1,
	  CIRC: 2,
	  ELIP: 3,
	  RREC: 4
	};
	
	/**
	 * Constants that specify float precision in shaders.
	 *
	 * @static
	 * @constant
	 * @name PRECISION
	 * @memberof PIXI
	 * @type {object}
	 * @property {string} LOW='lowp'
	 * @property {string} MEDIUM='mediump'
	 * @property {string} HIGH='highp'
	 */
	var PRECISION = exports.PRECISION = {
	  LOW: 'lowp',
	  MEDIUM: 'mediump',
	  HIGH: 'highp'
	};
	
	/**
	 * Constants that specify the transform type.
	 *
	 * @static
	 * @constant
	 * @name TRANSFORM_MODE
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} STATIC
	 * @property {number} DYNAMIC
	 */
	var TRANSFORM_MODE = exports.TRANSFORM_MODE = {
	  STATIC: 0,
	  DYNAMIC: 1
	};
	
	/**
	 * Constants that define the type of gradient on text.
	 *
	 * @static
	 * @constant
	 * @name TEXT_GRADIENT
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} LINEAR_VERTICAL Vertical gradient
	 * @property {number} LINEAR_HORIZONTAL Linear gradient
	 */
	var TEXT_GRADIENT = exports.TEXT_GRADIENT = {
	  LINEAR_VERTICAL: 0,
	  LINEAR_HORIZONTAL: 1
	};
	
	/**
	 * Represents the update priorities used by internal PIXI classes when registered with
	 * the {@link PIXI.ticker.Ticker} object. Higher priority items are updated first and lower
	 * priority items, such as render, should go later.
	 *
	 * @static
	 * @constant
	 * @name UPDATE_PRIORITY
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} INTERACTION=50 Highest priority, used for {@link PIXI.interaction.InteractionManager}
	 * @property {number} HIGH=25 High priority updating, {@link PIXI.VideoBaseTexture} and {@link PIXI.extras.AnimatedSprite}
	 * @property {number} NORMAL=0 Default priority for ticker events, see {@link PIXI.ticker.Ticker#add}.
	 * @property {number} LOW=-25 Low priority used for {@link PIXI.Application} rendering.
	 * @property {number} UTILITY=-50 Lowest priority used for {@link PIXI.prepare.BasePrepare} utility.
	 */
	var UPDATE_PRIORITY = exports.UPDATE_PRIORITY = {
	  INTERACTION: 50,
	  HIGH: 25,
	  NORMAL: 0,
	  LOW: -25,
	  UTILITY: -50
	};
	//# sourceMappingURL=const.js.map

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Point = __webpack_require__(207);
	
	Object.defineProperty(exports, 'Point', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Point).default;
	  }
	});
	
	var _ObservablePoint = __webpack_require__(208);
	
	Object.defineProperty(exports, 'ObservablePoint', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ObservablePoint).default;
	  }
	});
	
	var _Matrix = __webpack_require__(209);
	
	Object.defineProperty(exports, 'Matrix', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Matrix).default;
	  }
	});
	
	var _GroupD = __webpack_require__(210);
	
	Object.defineProperty(exports, 'GroupD8', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroupD).default;
	  }
	});
	
	var _Circle = __webpack_require__(211);
	
	Object.defineProperty(exports, 'Circle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Circle).default;
	  }
	});
	
	var _Ellipse = __webpack_require__(213);
	
	Object.defineProperty(exports, 'Ellipse', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Ellipse).default;
	  }
	});
	
	var _Polygon = __webpack_require__(214);
	
	Object.defineProperty(exports, 'Polygon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Polygon).default;
	  }
	});
	
	var _Rectangle = __webpack_require__(212);
	
	Object.defineProperty(exports, 'Rectangle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rectangle).default;
	  }
	});
	
	var _RoundedRectangle = __webpack_require__(215);
	
	Object.defineProperty(exports, 'RoundedRectangle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RoundedRectangle).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The Point object represents a location in a two-dimensional coordinate system, where x represents
	 * the horizontal axis and y represents the vertical axis.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Point = function () {
	  /**
	   * @param {number} [x=0] - position of the point on the x axis
	   * @param {number} [y=0] - position of the point on the y axis
	   */
	  function Point() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    _classCallCheck(this, Point);
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y;
	  }
	
	  /**
	   * Creates a clone of this point
	   *
	   * @return {PIXI.Point} a copy of the point
	   */
	
	
	  Point.prototype.clone = function clone() {
	    return new Point(this.x, this.y);
	  };
	
	  /**
	   * Copies x and y from the given point
	   *
	   * @param {PIXI.Point} p - The point to copy.
	   */
	
	
	  Point.prototype.copy = function copy(p) {
	    this.set(p.x, p.y);
	  };
	
	  /**
	   * Returns true if the given point is equal to this point
	   *
	   * @param {PIXI.Point} p - The point to check
	   * @returns {boolean} Whether the given point equal to this point
	   */
	
	
	  Point.prototype.equals = function equals(p) {
	    return p.x === this.x && p.y === this.y;
	  };
	
	  /**
	   * Sets the point to a new x and y position.
	   * If y is omitted, both x and y will be set to x.
	   *
	   * @param {number} [x=0] - position of the point on the x axis
	   * @param {number} [y=0] - position of the point on the y axis
	   */
	
	
	  Point.prototype.set = function set(x, y) {
	    this.x = x || 0;
	    this.y = y || (y !== 0 ? this.x : 0);
	  };
	
	  return Point;
	}();
	
	exports.default = Point;
	//# sourceMappingURL=Point.js.map

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The Point object represents a location in a two-dimensional coordinate system, where x represents
	 * the horizontal axis and y represents the vertical axis.
	 * An observable point is a point that triggers a callback when the point's position is changed.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var ObservablePoint = function () {
	    /**
	     * @param {Function} cb - callback when changed
	     * @param {object} scope - owner of callback
	     * @param {number} [x=0] - position of the point on the x axis
	     * @param {number} [y=0] - position of the point on the y axis
	     */
	    function ObservablePoint(cb, scope) {
	        var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	        _classCallCheck(this, ObservablePoint);
	
	        this._x = x;
	        this._y = y;
	
	        this.cb = cb;
	        this.scope = scope;
	    }
	
	    /**
	     * Sets the point to a new x and y position.
	     * If y is omitted, both x and y will be set to x.
	     *
	     * @param {number} [x=0] - position of the point on the x axis
	     * @param {number} [y=0] - position of the point on the y axis
	     */
	
	
	    ObservablePoint.prototype.set = function set(x, y) {
	        var _x = x || 0;
	        var _y = y || (y !== 0 ? _x : 0);
	
	        if (this._x !== _x || this._y !== _y) {
	            this._x = _x;
	            this._y = _y;
	            this.cb.call(this.scope);
	        }
	    };
	
	    /**
	     * Copies the data from another point
	     *
	     * @param {PIXI.Point|PIXI.ObservablePoint} point - point to copy from
	     */
	
	
	    ObservablePoint.prototype.copy = function copy(point) {
	        if (this._x !== point.x || this._y !== point.y) {
	            this._x = point.x;
	            this._y = point.y;
	            this.cb.call(this.scope);
	        }
	    };
	
	    /**
	     * The position of the displayObject on the x axis relative to the local coordinates of the parent.
	     *
	     * @member {number}
	     */
	
	
	    _createClass(ObservablePoint, [{
	        key: "x",
	        get: function get() {
	            return this._x;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._x !== value) {
	                this._x = value;
	                this.cb.call(this.scope);
	            }
	        }
	
	        /**
	         * The position of the displayObject on the x axis relative to the local coordinates of the parent.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: "y",
	        get: function get() {
	            return this._y;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._y !== value) {
	                this._y = value;
	                this.cb.call(this.scope);
	            }
	        }
	    }]);
	
	    return ObservablePoint;
	}();
	
	exports.default = ObservablePoint;
	//# sourceMappingURL=ObservablePoint.js.map

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Point = __webpack_require__(207);
	
	var _Point2 = _interopRequireDefault(_Point);
	
	var _const = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The PixiJS Matrix class as an object, which makes it a lot faster,
	 * here is a representation of it :
	 * | a | c | tx|
	 * | b | d | ty|
	 * | 0 | 0 | 1 |
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Matrix = function () {
	    /**
	     * @param {number} [a=1] - x scale
	     * @param {number} [b=0] - x skew
	     * @param {number} [c=0] - y skew
	     * @param {number} [d=1] - y scale
	     * @param {number} [tx=0] - x translation
	     * @param {number} [ty=0] - y translation
	     */
	    function Matrix() {
	        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	        var tx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	        var ty = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	        _classCallCheck(this, Matrix);
	
	        /**
	         * @member {number}
	         * @default 1
	         */
	        this.a = a;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.b = b;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.c = c;
	
	        /**
	         * @member {number}
	         * @default 1
	         */
	        this.d = d;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.tx = tx;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.ty = ty;
	
	        this.array = null;
	    }
	
	    /**
	     * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
	     *
	     * a = array[0]
	     * b = array[1]
	     * c = array[3]
	     * d = array[4]
	     * tx = array[2]
	     * ty = array[5]
	     *
	     * @param {number[]} array - The array that the matrix will be populated from.
	     */
	
	
	    Matrix.prototype.fromArray = function fromArray(array) {
	        this.a = array[0];
	        this.b = array[1];
	        this.c = array[3];
	        this.d = array[4];
	        this.tx = array[2];
	        this.ty = array[5];
	    };
	
	    /**
	     * sets the matrix properties
	     *
	     * @param {number} a - Matrix component
	     * @param {number} b - Matrix component
	     * @param {number} c - Matrix component
	     * @param {number} d - Matrix component
	     * @param {number} tx - Matrix component
	     * @param {number} ty - Matrix component
	     *
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.set = function set(a, b, c, d, tx, ty) {
	        this.a = a;
	        this.b = b;
	        this.c = c;
	        this.d = d;
	        this.tx = tx;
	        this.ty = ty;
	
	        return this;
	    };
	
	    /**
	     * Creates an array from the current Matrix object.
	     *
	     * @param {boolean} transpose - Whether we need to transpose the matrix or not
	     * @param {Float32Array} [out=new Float32Array(9)] - If provided the array will be assigned to out
	     * @return {number[]} the newly created array which contains the matrix
	     */
	
	
	    Matrix.prototype.toArray = function toArray(transpose, out) {
	        if (!this.array) {
	            this.array = new Float32Array(9);
	        }
	
	        var array = out || this.array;
	
	        if (transpose) {
	            array[0] = this.a;
	            array[1] = this.b;
	            array[2] = 0;
	            array[3] = this.c;
	            array[4] = this.d;
	            array[5] = 0;
	            array[6] = this.tx;
	            array[7] = this.ty;
	            array[8] = 1;
	        } else {
	            array[0] = this.a;
	            array[1] = this.c;
	            array[2] = this.tx;
	            array[3] = this.b;
	            array[4] = this.d;
	            array[5] = this.ty;
	            array[6] = 0;
	            array[7] = 0;
	            array[8] = 1;
	        }
	
	        return array;
	    };
	
	    /**
	     * Get a new position with the current transformation applied.
	     * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
	     *
	     * @param {PIXI.Point} pos - The origin
	     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
	     * @return {PIXI.Point} The new point, transformed through this matrix
	     */
	
	
	    Matrix.prototype.apply = function apply(pos, newPos) {
	        newPos = newPos || new _Point2.default();
	
	        var x = pos.x;
	        var y = pos.y;
	
	        newPos.x = this.a * x + this.c * y + this.tx;
	        newPos.y = this.b * x + this.d * y + this.ty;
	
	        return newPos;
	    };
	
	    /**
	     * Get a new position with the inverse of the current transformation applied.
	     * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
	     *
	     * @param {PIXI.Point} pos - The origin
	     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
	     * @return {PIXI.Point} The new point, inverse-transformed through this matrix
	     */
	
	
	    Matrix.prototype.applyInverse = function applyInverse(pos, newPos) {
	        newPos = newPos || new _Point2.default();
	
	        var id = 1 / (this.a * this.d + this.c * -this.b);
	
	        var x = pos.x;
	        var y = pos.y;
	
	        newPos.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id;
	        newPos.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id;
	
	        return newPos;
	    };
	
	    /**
	     * Translates the matrix on the x and y.
	     *
	     * @param {number} x How much to translate x by
	     * @param {number} y How much to translate y by
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.translate = function translate(x, y) {
	        this.tx += x;
	        this.ty += y;
	
	        return this;
	    };
	
	    /**
	     * Applies a scale transformation to the matrix.
	     *
	     * @param {number} x The amount to scale horizontally
	     * @param {number} y The amount to scale vertically
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.scale = function scale(x, y) {
	        this.a *= x;
	        this.d *= y;
	        this.c *= x;
	        this.b *= y;
	        this.tx *= x;
	        this.ty *= y;
	
	        return this;
	    };
	
	    /**
	     * Applies a rotation transformation to the matrix.
	     *
	     * @param {number} angle - The angle in radians.
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.rotate = function rotate(angle) {
	        var cos = Math.cos(angle);
	        var sin = Math.sin(angle);
	
	        var a1 = this.a;
	        var c1 = this.c;
	        var tx1 = this.tx;
	
	        this.a = a1 * cos - this.b * sin;
	        this.b = a1 * sin + this.b * cos;
	        this.c = c1 * cos - this.d * sin;
	        this.d = c1 * sin + this.d * cos;
	        this.tx = tx1 * cos - this.ty * sin;
	        this.ty = tx1 * sin + this.ty * cos;
	
	        return this;
	    };
	
	    /**
	     * Appends the given Matrix to this Matrix.
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to append.
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.append = function append(matrix) {
	        var a1 = this.a;
	        var b1 = this.b;
	        var c1 = this.c;
	        var d1 = this.d;
	
	        this.a = matrix.a * a1 + matrix.b * c1;
	        this.b = matrix.a * b1 + matrix.b * d1;
	        this.c = matrix.c * a1 + matrix.d * c1;
	        this.d = matrix.c * b1 + matrix.d * d1;
	
	        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
	        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
	
	        return this;
	    };
	
	    /**
	     * Sets the matrix based on all the available properties
	     *
	     * @param {number} x - Position on the x axis
	     * @param {number} y - Position on the y axis
	     * @param {number} pivotX - Pivot on the x axis
	     * @param {number} pivotY - Pivot on the y axis
	     * @param {number} scaleX - Scale on the x axis
	     * @param {number} scaleY - Scale on the y axis
	     * @param {number} rotation - Rotation in radians
	     * @param {number} skewX - Skew on the x axis
	     * @param {number} skewY - Skew on the y axis
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.setTransform = function setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
	        this.a = Math.cos(rotation + skewY) * scaleX;
	        this.b = Math.sin(rotation + skewY) * scaleX;
	        this.c = -Math.sin(rotation - skewX) * scaleY;
	        this.d = Math.cos(rotation - skewX) * scaleY;
	
	        this.tx = x - (pivotX * this.a + pivotY * this.c);
	        this.ty = y - (pivotX * this.b + pivotY * this.d);
	
	        return this;
	    };
	
	    /**
	     * Prepends the given Matrix to this Matrix.
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to prepend
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.prepend = function prepend(matrix) {
	        var tx1 = this.tx;
	
	        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
	            var a1 = this.a;
	            var c1 = this.c;
	
	            this.a = a1 * matrix.a + this.b * matrix.c;
	            this.b = a1 * matrix.b + this.b * matrix.d;
	            this.c = c1 * matrix.a + this.d * matrix.c;
	            this.d = c1 * matrix.b + this.d * matrix.d;
	        }
	
	        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
	        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
	
	        return this;
	    };
	
	    /**
	     * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
	     *
	     * @param {PIXI.Transform|PIXI.TransformStatic} transform - The transform to apply the properties to.
	     * @return {PIXI.Transform|PIXI.TransformStatic} The transform with the newly applied properties
	     */
	
	
	    Matrix.prototype.decompose = function decompose(transform) {
	        // sort out rotation / skew..
	        var a = this.a;
	        var b = this.b;
	        var c = this.c;
	        var d = this.d;
	
	        var skewX = -Math.atan2(-c, d);
	        var skewY = Math.atan2(b, a);
	
	        var delta = Math.abs(skewX + skewY);
	
	        if (delta < 0.00001 || Math.abs(_const.PI_2 - delta) < 0.00001) {
	            transform.rotation = skewY;
	
	            if (a < 0 && d >= 0) {
	                transform.rotation += transform.rotation <= 0 ? Math.PI : -Math.PI;
	            }
	
	            transform.skew.x = transform.skew.y = 0;
	        } else {
	            transform.rotation = 0;
	            transform.skew.x = skewX;
	            transform.skew.y = skewY;
	        }
	
	        // next set scale
	        transform.scale.x = Math.sqrt(a * a + b * b);
	        transform.scale.y = Math.sqrt(c * c + d * d);
	
	        // next set position
	        transform.position.x = this.tx;
	        transform.position.y = this.ty;
	
	        return transform;
	    };
	
	    /**
	     * Inverts this matrix
	     *
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.invert = function invert() {
	        var a1 = this.a;
	        var b1 = this.b;
	        var c1 = this.c;
	        var d1 = this.d;
	        var tx1 = this.tx;
	        var n = a1 * d1 - b1 * c1;
	
	        this.a = d1 / n;
	        this.b = -b1 / n;
	        this.c = -c1 / n;
	        this.d = a1 / n;
	        this.tx = (c1 * this.ty - d1 * tx1) / n;
	        this.ty = -(a1 * this.ty - b1 * tx1) / n;
	
	        return this;
	    };
	
	    /**
	     * Resets this Matix to an identity (default) matrix.
	     *
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.identity = function identity() {
	        this.a = 1;
	        this.b = 0;
	        this.c = 0;
	        this.d = 1;
	        this.tx = 0;
	        this.ty = 0;
	
	        return this;
	    };
	
	    /**
	     * Creates a new Matrix object with the same values as this one.
	     *
	     * @return {PIXI.Matrix} A copy of this matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.clone = function clone() {
	        var matrix = new Matrix();
	
	        matrix.a = this.a;
	        matrix.b = this.b;
	        matrix.c = this.c;
	        matrix.d = this.d;
	        matrix.tx = this.tx;
	        matrix.ty = this.ty;
	
	        return matrix;
	    };
	
	    /**
	     * Changes the values of the given matrix to be the same as the ones in this matrix
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to copy from.
	     * @return {PIXI.Matrix} The matrix given in parameter with its values updated.
	     */
	
	
	    Matrix.prototype.copy = function copy(matrix) {
	        matrix.a = this.a;
	        matrix.b = this.b;
	        matrix.c = this.c;
	        matrix.d = this.d;
	        matrix.tx = this.tx;
	        matrix.ty = this.ty;
	
	        return matrix;
	    };
	
	    /**
	     * A default (identity) matrix
	     *
	     * @static
	     * @const
	     */
	
	
	    _createClass(Matrix, null, [{
	        key: 'IDENTITY',
	        get: function get() {
	            return new Matrix();
	        }
	
	        /**
	         * A temp matrix
	         *
	         * @static
	         * @const
	         */
	
	    }, {
	        key: 'TEMP_MATRIX',
	        get: function get() {
	            return new Matrix();
	        }
	    }]);
	
	    return Matrix;
	}();
	
	exports.default = Matrix;
	//# sourceMappingURL=Matrix.js.map

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Matrix = __webpack_require__(209);
	
	var _Matrix2 = _interopRequireDefault(_Matrix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ux = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1]; // Your friendly neighbour https://en.wikipedia.org/wiki/Dihedral_group of order 16
	
	var uy = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1];
	var vx = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1];
	var vy = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1];
	var tempMatrices = [];
	
	var mul = [];
	
	function signum(x) {
	    if (x < 0) {
	        return -1;
	    }
	    if (x > 0) {
	        return 1;
	    }
	
	    return 0;
	}
	
	function init() {
	    for (var i = 0; i < 16; i++) {
	        var row = [];
	
	        mul.push(row);
	
	        for (var j = 0; j < 16; j++) {
	            var _ux = signum(ux[i] * ux[j] + vx[i] * uy[j]);
	            var _uy = signum(uy[i] * ux[j] + vy[i] * uy[j]);
	            var _vx = signum(ux[i] * vx[j] + vx[i] * vy[j]);
	            var _vy = signum(uy[i] * vx[j] + vy[i] * vy[j]);
	
	            for (var k = 0; k < 16; k++) {
	                if (ux[k] === _ux && uy[k] === _uy && vx[k] === _vx && vy[k] === _vy) {
	                    row.push(k);
	                    break;
	                }
	            }
	        }
	    }
	
	    for (var _i = 0; _i < 16; _i++) {
	        var mat = new _Matrix2.default();
	
	        mat.set(ux[_i], uy[_i], vx[_i], vy[_i], 0, 0);
	        tempMatrices.push(mat);
	    }
	}
	
	init();
	
	/**
	 * Implements Dihedral Group D_8, see [group D4]{@link http://mathworld.wolfram.com/DihedralGroupD4.html},
	 * D8 is the same but with diagonals. Used for texture rotations.
	 *
	 * Vector xX(i), xY(i) is U-axis of sprite with rotation i
	 * Vector yY(i), yY(i) is V-axis of sprite with rotation i
	 * Rotations: 0 grad (0), 90 grad (2), 180 grad (4), 270 grad (6)
	 * Mirrors: vertical (8), main diagonal (10), horizontal (12), reverse diagonal (14)
	 * This is the small part of gameofbombs.com portal system. It works.
	 *
	 * @author Ivan @ivanpopelyshev
	 * @class
	 * @memberof PIXI
	 */
	var GroupD8 = {
	    E: 0,
	    SE: 1,
	    S: 2,
	    SW: 3,
	    W: 4,
	    NW: 5,
	    N: 6,
	    NE: 7,
	    MIRROR_VERTICAL: 8,
	    MIRROR_HORIZONTAL: 12,
	    uX: function uX(ind) {
	        return ux[ind];
	    },
	    uY: function uY(ind) {
	        return uy[ind];
	    },
	    vX: function vX(ind) {
	        return vx[ind];
	    },
	    vY: function vY(ind) {
	        return vy[ind];
	    },
	    inv: function inv(rotation) {
	        if (rotation & 8) {
	            return rotation & 15;
	        }
	
	        return -rotation & 7;
	    },
	    add: function add(rotationSecond, rotationFirst) {
	        return mul[rotationSecond][rotationFirst];
	    },
	    sub: function sub(rotationSecond, rotationFirst) {
	        return mul[rotationSecond][GroupD8.inv(rotationFirst)];
	    },
	
	    /**
	     * Adds 180 degrees to rotation. Commutative operation.
	     *
	     * @memberof PIXI.GroupD8
	     * @param {number} rotation - The number to rotate.
	     * @returns {number} rotated number
	     */
	    rotate180: function rotate180(rotation) {
	        return rotation ^ 4;
	    },
	
	    /**
	     * Direction of main vector can be horizontal, vertical or diagonal.
	     * Some objects work with vertical directions different.
	     *
	     * @memberof PIXI.GroupD8
	     * @param {number} rotation - The number to check.
	     * @returns {boolean} Whether or not the direction is vertical
	     */
	    isVertical: function isVertical(rotation) {
	        return (rotation & 3) === 2;
	    },
	
	    /**
	     * @memberof PIXI.GroupD8
	     * @param {number} dx - TODO
	     * @param {number} dy - TODO
	     *
	     * @return {number} TODO
	     */
	    byDirection: function byDirection(dx, dy) {
	        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
	            if (dy >= 0) {
	                return GroupD8.S;
	            }
	
	            return GroupD8.N;
	        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
	            if (dx > 0) {
	                return GroupD8.E;
	            }
	
	            return GroupD8.W;
	        } else if (dy > 0) {
	            if (dx > 0) {
	                return GroupD8.SE;
	            }
	
	            return GroupD8.SW;
	        } else if (dx > 0) {
	            return GroupD8.NE;
	        }
	
	        return GroupD8.NW;
	    },
	
	    /**
	     * Helps sprite to compensate texture packer rotation.
	     *
	     * @memberof PIXI.GroupD8
	     * @param {PIXI.Matrix} matrix - sprite world matrix
	     * @param {number} rotation - The rotation factor to use.
	     * @param {number} tx - sprite anchoring
	     * @param {number} ty - sprite anchoring
	     */
	    matrixAppendRotationInv: function matrixAppendRotationInv(matrix, rotation) {
	        var tx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var ty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	        // Packer used "rotation", we use "inv(rotation)"
	        var mat = tempMatrices[GroupD8.inv(rotation)];
	
	        mat.tx = tx;
	        mat.ty = ty;
	        matrix.append(mat);
	    }
	};
	
	exports.default = GroupD8;
	//# sourceMappingURL=GroupD8.js.map

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Rectangle = __webpack_require__(212);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _const = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The Circle object can be used to specify a hit area for displayObjects
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Circle = function () {
	  /**
	   * @param {number} [x=0] - The X coordinate of the center of this circle
	   * @param {number} [y=0] - The Y coordinate of the center of this circle
	   * @param {number} [radius=0] - The radius of the circle
	   */
	  function Circle() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    _classCallCheck(this, Circle);
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.radius = radius;
	
	    /**
	     * The type of the object, mainly used to avoid `instanceof` checks
	     *
	     * @member {number}
	     * @readOnly
	     * @default PIXI.SHAPES.CIRC
	     * @see PIXI.SHAPES
	     */
	    this.type = _const.SHAPES.CIRC;
	  }
	
	  /**
	   * Creates a clone of this Circle instance
	   *
	   * @return {PIXI.Circle} a copy of the Circle
	   */
	
	
	  Circle.prototype.clone = function clone() {
	    return new Circle(this.x, this.y, this.radius);
	  };
	
	  /**
	   * Checks whether the x and y coordinates given are contained within this circle
	   *
	   * @param {number} x - The X coordinate of the point to test
	   * @param {number} y - The Y coordinate of the point to test
	   * @return {boolean} Whether the x/y coordinates are within this Circle
	   */
	
	
	  Circle.prototype.contains = function contains(x, y) {
	    if (this.radius <= 0) {
	      return false;
	    }
	
	    var r2 = this.radius * this.radius;
	    var dx = this.x - x;
	    var dy = this.y - y;
	
	    dx *= dx;
	    dy *= dy;
	
	    return dx + dy <= r2;
	  };
	
	  /**
	  * Returns the framing rectangle of the circle as a Rectangle object
	  *
	  * @return {PIXI.Rectangle} the framing rectangle
	  */
	
	
	  Circle.prototype.getBounds = function getBounds() {
	    return new _Rectangle2.default(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
	  };
	
	  return Circle;
	}();
	
	exports.default = Circle;
	//# sourceMappingURL=Circle.js.map

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _const = __webpack_require__(205);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Rectangle object is an area defined by its position, as indicated by its top-left corner
	 * point (x, y) and by its width and its height.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Rectangle = function () {
	    /**
	     * @param {number} [x=0] - The X coordinate of the upper-left corner of the rectangle
	     * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rectangle
	     * @param {number} [width=0] - The overall width of this rectangle
	     * @param {number} [height=0] - The overall height of this rectangle
	     */
	    function Rectangle() {
	        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	        _classCallCheck(this, Rectangle);
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.x = Number(x);
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.y = Number(y);
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.width = Number(width);
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.height = Number(height);
	
	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readOnly
	         * @default PIXI.SHAPES.RECT
	         * @see PIXI.SHAPES
	         */
	        this.type = _const.SHAPES.RECT;
	    }
	
	    /**
	     * returns the left edge of the rectangle
	     *
	     * @member {number}
	     */
	
	
	    /**
	     * Creates a clone of this Rectangle
	     *
	     * @return {PIXI.Rectangle} a copy of the rectangle
	     */
	    Rectangle.prototype.clone = function clone() {
	        return new Rectangle(this.x, this.y, this.width, this.height);
	    };
	
	    /**
	     * Copies another rectangle to this one.
	     *
	     * @param {PIXI.Rectangle} rectangle - The rectangle to copy.
	     * @return {PIXI.Rectangle} Returns itself.
	     */
	
	
	    Rectangle.prototype.copy = function copy(rectangle) {
	        this.x = rectangle.x;
	        this.y = rectangle.y;
	        this.width = rectangle.width;
	        this.height = rectangle.height;
	
	        return this;
	    };
	
	    /**
	     * Checks whether the x and y coordinates given are contained within this Rectangle
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coordinates are within this Rectangle
	     */
	
	
	    Rectangle.prototype.contains = function contains(x, y) {
	        if (this.width <= 0 || this.height <= 0) {
	            return false;
	        }
	
	        if (x >= this.x && x < this.x + this.width) {
	            if (y >= this.y && y < this.y + this.height) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	
	    /**
	     * Pads the rectangle making it grow in all directions.
	     *
	     * @param {number} paddingX - The horizontal padding amount.
	     * @param {number} [paddingY] - The vertical padding amount.
	     */
	
	
	    Rectangle.prototype.pad = function pad(paddingX, paddingY) {
	        paddingX = paddingX || 0;
	        paddingY = paddingY || (paddingY !== 0 ? paddingX : 0);
	
	        this.x -= paddingX;
	        this.y -= paddingY;
	
	        this.width += paddingX * 2;
	        this.height += paddingY * 2;
	    };
	
	    /**
	     * Fits this rectangle around the passed one.
	     *
	     * @param {PIXI.Rectangle} rectangle - The rectangle to fit.
	     */
	
	
	    Rectangle.prototype.fit = function fit(rectangle) {
	        if (this.x < rectangle.x) {
	            this.width += this.x;
	            if (this.width < 0) {
	                this.width = 0;
	            }
	
	            this.x = rectangle.x;
	        }
	
	        if (this.y < rectangle.y) {
	            this.height += this.y;
	            if (this.height < 0) {
	                this.height = 0;
	            }
	            this.y = rectangle.y;
	        }
	
	        if (this.x + this.width > rectangle.x + rectangle.width) {
	            this.width = rectangle.width - this.x;
	            if (this.width < 0) {
	                this.width = 0;
	            }
	        }
	
	        if (this.y + this.height > rectangle.y + rectangle.height) {
	            this.height = rectangle.height - this.y;
	            if (this.height < 0) {
	                this.height = 0;
	            }
	        }
	    };
	
	    /**
	     * Enlarges this rectangle to include the passed rectangle.
	     *
	     * @param {PIXI.Rectangle} rectangle - The rectangle to include.
	     */
	
	
	    Rectangle.prototype.enlarge = function enlarge(rectangle) {
	        var x1 = Math.min(this.x, rectangle.x);
	        var x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
	        var y1 = Math.min(this.y, rectangle.y);
	        var y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
	
	        this.x = x1;
	        this.width = x2 - x1;
	        this.y = y1;
	        this.height = y2 - y1;
	    };
	
	    _createClass(Rectangle, [{
	        key: 'left',
	        get: function get() {
	            return this.x;
	        }
	
	        /**
	         * returns the right edge of the rectangle
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'right',
	        get: function get() {
	            return this.x + this.width;
	        }
	
	        /**
	         * returns the top edge of the rectangle
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'top',
	        get: function get() {
	            return this.y;
	        }
	
	        /**
	         * returns the bottom edge of the rectangle
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'bottom',
	        get: function get() {
	            return this.y + this.height;
	        }
	
	        /**
	         * A constant empty rectangle.
	         *
	         * @static
	         * @constant
	         */
	
	    }], [{
	        key: 'EMPTY',
	        get: function get() {
	            return new Rectangle(0, 0, 0, 0);
	        }
	    }]);
	
	    return Rectangle;
	}();
	
	exports.default = Rectangle;
	//# sourceMappingURL=Rectangle.js.map

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Rectangle = __webpack_require__(212);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _const = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The Ellipse object can be used to specify a hit area for displayObjects
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Ellipse = function () {
	  /**
	   * @param {number} [x=0] - The X coordinate of the center of this circle
	   * @param {number} [y=0] - The Y coordinate of the center of this circle
	   * @param {number} [width=0] - The half width of this ellipse
	   * @param {number} [height=0] - The half height of this ellipse
	   */
	  function Ellipse() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	    _classCallCheck(this, Ellipse);
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.width = width;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.height = height;
	
	    /**
	     * The type of the object, mainly used to avoid `instanceof` checks
	     *
	     * @member {number}
	     * @readOnly
	     * @default PIXI.SHAPES.ELIP
	     * @see PIXI.SHAPES
	     */
	    this.type = _const.SHAPES.ELIP;
	  }
	
	  /**
	   * Creates a clone of this Ellipse instance
	   *
	   * @return {PIXI.Ellipse} a copy of the ellipse
	   */
	
	
	  Ellipse.prototype.clone = function clone() {
	    return new Ellipse(this.x, this.y, this.width, this.height);
	  };
	
	  /**
	   * Checks whether the x and y coordinates given are contained within this ellipse
	   *
	   * @param {number} x - The X coordinate of the point to test
	   * @param {number} y - The Y coordinate of the point to test
	   * @return {boolean} Whether the x/y coords are within this ellipse
	   */
	
	
	  Ellipse.prototype.contains = function contains(x, y) {
	    if (this.width <= 0 || this.height <= 0) {
	      return false;
	    }
	
	    // normalize the coords to an ellipse with center 0,0
	    var normx = (x - this.x) / this.width;
	    var normy = (y - this.y) / this.height;
	
	    normx *= normx;
	    normy *= normy;
	
	    return normx + normy <= 1;
	  };
	
	  /**
	   * Returns the framing rectangle of the ellipse as a Rectangle object
	   *
	   * @return {PIXI.Rectangle} the framing rectangle
	   */
	
	
	  Ellipse.prototype.getBounds = function getBounds() {
	    return new _Rectangle2.default(this.x - this.width, this.y - this.height, this.width, this.height);
	  };
	
	  return Ellipse;
	}();
	
	exports.default = Ellipse;
	//# sourceMappingURL=Ellipse.js.map

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Point = __webpack_require__(207);
	
	var _Point2 = _interopRequireDefault(_Point);
	
	var _const = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @class
	 * @memberof PIXI
	 */
	var Polygon = function () {
	    /**
	     * @param {PIXI.Point[]|number[]} points - This can be an array of Points
	     *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
	     *  the arguments passed can be all the points of the polygon e.g.
	     *  `new PIXI.Polygon(new PIXI.Point(), new PIXI.Point(), ...)`, or the arguments passed can be flat
	     *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
	     */
	    function Polygon() {
	        for (var _len = arguments.length, points = Array(_len), _key = 0; _key < _len; _key++) {
	            points[_key] = arguments[_key];
	        }
	
	        _classCallCheck(this, Polygon);
	
	        if (Array.isArray(points[0])) {
	            points = points[0];
	        }
	
	        // if this is an array of points, convert it to a flat array of numbers
	        if (points[0] instanceof _Point2.default) {
	            var p = [];
	
	            for (var i = 0, il = points.length; i < il; i++) {
	                p.push(points[i].x, points[i].y);
	            }
	
	            points = p;
	        }
	
	        this.closed = true;
	
	        /**
	         * An array of the points of this polygon
	         *
	         * @member {number[]}
	         */
	        this.points = points;
	
	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readOnly
	         * @default PIXI.SHAPES.POLY
	         * @see PIXI.SHAPES
	         */
	        this.type = _const.SHAPES.POLY;
	    }
	
	    /**
	     * Creates a clone of this polygon
	     *
	     * @return {PIXI.Polygon} a copy of the polygon
	     */
	
	
	    Polygon.prototype.clone = function clone() {
	        return new Polygon(this.points.slice());
	    };
	
	    /**
	     * Closes the polygon, adding points if necessary.
	     *
	     */
	
	
	    Polygon.prototype.close = function close() {
	        var points = this.points;
	
	        // close the poly if the value is true!
	        if (points[0] !== points[points.length - 2] || points[1] !== points[points.length - 1]) {
	            points.push(points[0], points[1]);
	        }
	    };
	
	    /**
	     * Checks whether the x and y coordinates passed to this function are contained within this polygon
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coordinates are within this polygon
	     */
	
	
	    Polygon.prototype.contains = function contains(x, y) {
	        var inside = false;
	
	        // use some raycasting to test hits
	        // https://github.com/substack/point-in-polygon/blob/master/index.js
	        var length = this.points.length / 2;
	
	        for (var i = 0, j = length - 1; i < length; j = i++) {
	            var xi = this.points[i * 2];
	            var yi = this.points[i * 2 + 1];
	            var xj = this.points[j * 2];
	            var yj = this.points[j * 2 + 1];
	            var intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
	
	            if (intersect) {
	                inside = !inside;
	            }
	        }
	
	        return inside;
	    };
	
	    return Polygon;
	}();
	
	exports.default = Polygon;
	//# sourceMappingURL=Polygon.js.map

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _const = __webpack_require__(205);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The Rounded Rectangle object is an area that has nice rounded corners, as indicated by its
	 * top-left corner point (x, y) and by its width and its height and its radius.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var RoundedRectangle = function () {
	    /**
	     * @param {number} [x=0] - The X coordinate of the upper-left corner of the rounded rectangle
	     * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rounded rectangle
	     * @param {number} [width=0] - The overall width of this rounded rectangle
	     * @param {number} [height=0] - The overall height of this rounded rectangle
	     * @param {number} [radius=20] - Controls the radius of the rounded corners
	     */
	    function RoundedRectangle() {
	        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	        var radius = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 20;
	
	        _classCallCheck(this, RoundedRectangle);
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.x = x;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.y = y;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.width = width;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.height = height;
	
	        /**
	         * @member {number}
	         * @default 20
	         */
	        this.radius = radius;
	
	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readonly
	         * @default PIXI.SHAPES.RREC
	         * @see PIXI.SHAPES
	         */
	        this.type = _const.SHAPES.RREC;
	    }
	
	    /**
	     * Creates a clone of this Rounded Rectangle
	     *
	     * @return {PIXI.RoundedRectangle} a copy of the rounded rectangle
	     */
	
	
	    RoundedRectangle.prototype.clone = function clone() {
	        return new RoundedRectangle(this.x, this.y, this.width, this.height, this.radius);
	    };
	
	    /**
	     * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coordinates are within this Rounded Rectangle
	     */
	
	
	    RoundedRectangle.prototype.contains = function contains(x, y) {
	        if (this.width <= 0 || this.height <= 0) {
	            return false;
	        }
	        if (x >= this.x && x <= this.x + this.width) {
	            if (y >= this.y && y <= this.y + this.height) {
	                if (y >= this.y + this.radius && y <= this.y + this.height - this.radius || x >= this.x + this.radius && x <= this.x + this.width - this.radius) {
	                    return true;
	                }
	                var dx = x - (this.x + this.radius);
	                var dy = y - (this.y + this.radius);
	                var radius2 = this.radius * this.radius;
	
	                if (dx * dx + dy * dy <= radius2) {
	                    return true;
	                }
	                dx = x - (this.x + this.width - this.radius);
	                if (dx * dx + dy * dy <= radius2) {
	                    return true;
	                }
	                dy = y - (this.y + this.height - this.radius);
	                if (dx * dx + dy * dy <= radius2) {
	                    return true;
	                }
	                dx = x - (this.x + this.radius);
	                if (dx * dx + dy * dy <= radius2) {
	                    return true;
	                }
	            }
	        }
	
	        return false;
	    };
	
	    return RoundedRectangle;
	}();
	
	exports.default = RoundedRectangle;
	//# sourceMappingURL=RoundedRectangle.js.map

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	var gl = {
	    createContext:          __webpack_require__(217),
	    setVertexAttribArrays:  __webpack_require__(218),
	    GLBuffer:               __webpack_require__(219),
	    GLFramebuffer:          __webpack_require__(220),
	    GLShader:               __webpack_require__(222),
	    GLTexture:              __webpack_require__(221),
	    VertexArrayObject:      __webpack_require__(231),
	    shader:                 __webpack_require__(232)
	};
	
	// Export for Node-compatible environments
	if (typeof module !== 'undefined' && module.exports)
	{
	    // Export the module
	    module.exports = gl;
	}
	
	// Add to the browser window pixi.gl
	if (typeof window !== 'undefined')
	{
	    // add the window object
	    window.PIXI = window.PIXI || {};
	    window.PIXI.glCore = gl;
	}


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	
	/**
	 * Helper class to create a webGL Context
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param canvas {HTMLCanvasElement} the canvas element that we will get the context from
	 * @param options {Object} An options object that gets passed in to the canvas element containing the context attributes,
	 *                         see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext for the options available
	 * @return {WebGLRenderingContext} the WebGL context
	 */
	var createContext = function(canvas, options)
	{
	    var gl = canvas.getContext('webgl', options) || 
	         canvas.getContext('experimental-webgl', options);
	
	    if (!gl)
	    {
	        // fail, not able to get a context
	        throw new Error('This browser does not support webGL. Try using the canvas renderer');
	    }
	
	    return gl;
	};
	
	module.exports = createContext;


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	// var GL_MAP = {};
	
	/**
	 * @param gl {WebGLRenderingContext} The current WebGL context
	 * @param attribs {*}
	 * @param state {*}
	 */
	var setVertexAttribArrays = function (gl, attribs, state)
	{
	    var i;
	    if(state)
	    {
	        var tempAttribState = state.tempAttribState,
	            attribState = state.attribState;
	
	        for (i = 0; i < tempAttribState.length; i++)
	        {
	            tempAttribState[i] = false;
	        }
	
	        // set the new attribs
	        for (i = 0; i < attribs.length; i++)
	        {
	            tempAttribState[attribs[i].attribute.location] = true;
	        }
	
	        for (i = 0; i < attribState.length; i++)
	        {
	            if (attribState[i] !== tempAttribState[i])
	            {
	                attribState[i] = tempAttribState[i];
	
	                if (state.attribState[i])
	                {
	                    gl.enableVertexAttribArray(i);
	                }
	                else
	                {
	                    gl.disableVertexAttribArray(i);
	                }
	            }
	        }
	
	    }
	    else
	    {
	        for (i = 0; i < attribs.length; i++)
	        {
	            var attrib = attribs[i];
	            gl.enableVertexAttribArray(attrib.attribute.location);
	        }
	    }
	};
	
	module.exports = setVertexAttribArrays;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

	var EMPTY_ARRAY_BUFFER = new ArrayBuffer(0);
	
	/**
	 * Helper class to create a webGL buffer
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param type {gl.ARRAY_BUFFER | gl.ELEMENT_ARRAY_BUFFER} @mat
	 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
	 * @param drawType {gl.STATIC_DRAW|gl.DYNAMIC_DRAW|gl.STREAM_DRAW}
	 */
	var Buffer = function(gl, type, data, drawType)
	{
	
		/**
	     * The current WebGL rendering context
	     *
	     * @member {WebGLRenderingContext}
	     */
		this.gl = gl;
	
		/**
	     * The WebGL buffer, created upon instantiation
	     *
	     * @member {WebGLBuffer}
	     */
		this.buffer = gl.createBuffer();
	
		/**
	     * The type of the buffer
	     *
	     * @member {gl.ARRAY_BUFFER|gl.ELEMENT_ARRAY_BUFFER}
	     */
		this.type = type || gl.ARRAY_BUFFER;
	
		/**
	     * The draw type of the buffer
	     *
	     * @member {gl.STATIC_DRAW|gl.DYNAMIC_DRAW|gl.STREAM_DRAW}
	     */
		this.drawType = drawType || gl.STATIC_DRAW;
	
		/**
	     * The data in the buffer, as a typed array
	     *
	     * @member {ArrayBuffer| SharedArrayBuffer|ArrayBufferView}
	     */
		this.data = EMPTY_ARRAY_BUFFER;
	
		if(data)
		{
			this.upload(data);
		}
	
		this._updateID = 0;
	};
	
	/**
	 * Uploads the buffer to the GPU
	 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data to upload
	 * @param offset {Number} if only a subset of the data should be uploaded, this is the amount of data to subtract
	 * @param dontBind {Boolean} whether to bind the buffer before uploading it
	 */
	Buffer.prototype.upload = function(data, offset, dontBind)
	{
		// todo - needed?
		if(!dontBind) this.bind();
	
		var gl = this.gl;
	
		data = data || this.data;
		offset = offset || 0;
	
		if(this.data.byteLength >= data.byteLength)
		{
			gl.bufferSubData(this.type, offset, data);
		}
		else
		{
			gl.bufferData(this.type, data, this.drawType);
		}
	
		this.data = data;
	};
	/**
	 * Binds the buffer
	 *
	 */
	Buffer.prototype.bind = function()
	{
		var gl = this.gl;
		gl.bindBuffer(this.type, this.buffer);
	};
	
	Buffer.createVertexBuffer = function(gl, data, drawType)
	{
		return new Buffer(gl, gl.ARRAY_BUFFER, data, drawType);
	};
	
	Buffer.createIndexBuffer = function(gl, data, drawType)
	{
		return new Buffer(gl, gl.ELEMENT_ARRAY_BUFFER, data, drawType);
	};
	
	Buffer.create = function(gl, type, data, drawType)
	{
		return new Buffer(gl, type, data, drawType);
	};
	
	/**
	 * Destroys the buffer
	 *
	 */
	Buffer.prototype.destroy = function(){
		this.gl.deleteBuffer(this.buffer);
	};
	
	module.exports = Buffer;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	
	var Texture = __webpack_require__(221);
	
	/**
	 * Helper class to create a webGL Framebuffer
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param width {Number} the width of the drawing area of the frame buffer
	 * @param height {Number} the height of the drawing area of the frame buffer
	 */
	var Framebuffer = function(gl, width, height)
	{
	    /**
	     * The current WebGL rendering context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	    /**
	     * The frame buffer
	     *
	     * @member {WebGLFramebuffer}
	     */
	    this.framebuffer = gl.createFramebuffer();
	
	    /**
	     * The stencil buffer
	     *
	     * @member {WebGLRenderbuffer}
	     */
	    this.stencil = null;
	
	    /**
	     * The stencil buffer
	     *
	     * @member {PIXI.glCore.GLTexture}
	     */
	    this.texture = null;
	
	    /**
	     * The width of the drawing area of the buffer
	     *
	     * @member {Number}
	     */
	    this.width = width || 100;
	    /**
	     * The height of the drawing area of the buffer
	     *
	     * @member {Number}
	     */
	    this.height = height || 100;
	};
	
	/**
	 * Adds a texture to the frame buffer
	 * @param texture {PIXI.glCore.GLTexture}
	 */
	Framebuffer.prototype.enableTexture = function(texture)
	{
	    var gl = this.gl;
	
	    this.texture = texture || new Texture(gl);
	
	    this.texture.bind();
	
	    //gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,  this.width, this.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
	
	    this.bind();
	
	    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture.texture, 0);
	};
	
	/**
	 * Initialises the stencil buffer
	 */
	Framebuffer.prototype.enableStencil = function()
	{
	    if(this.stencil)return;
	
	    var gl = this.gl;
	
	    this.stencil = gl.createRenderbuffer();
	
	    gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencil);
	
	    // TODO.. this is depth AND stencil?
	    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, this.stencil);
	    gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL,  this.width  , this.height );
	
	
	};
	
	/**
	 * Erases the drawing area and fills it with a colour
	 * @param  r {Number} the red value of the clearing colour
	 * @param  g {Number} the green value of the clearing colour
	 * @param  b {Number} the blue value of the clearing colour
	 * @param  a {Number} the alpha value of the clearing colour
	 */
	Framebuffer.prototype.clear = function( r, g, b, a )
	{
	    this.bind();
	
	    var gl = this.gl;
	
	    gl.clearColor(r, g, b, a);
	    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	};
	
	/**
	 * Binds the frame buffer to the WebGL context
	 */
	Framebuffer.prototype.bind = function()
	{
	    var gl = this.gl;
	    gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer );
	};
	
	/**
	 * Unbinds the frame buffer to the WebGL context
	 */
	Framebuffer.prototype.unbind = function()
	{
	    var gl = this.gl;
	    gl.bindFramebuffer(gl.FRAMEBUFFER, null );
	};
	/**
	 * Resizes the drawing area of the buffer to the given width and height
	 * @param  width  {Number} the new width
	 * @param  height {Number} the new height
	 */
	Framebuffer.prototype.resize = function(width, height)
	{
	    var gl = this.gl;
	
	    this.width = width;
	    this.height = height;
	
	    if ( this.texture )
	    {
	        this.texture.uploadData(null, width, height);
	    }
	
	    if ( this.stencil )
	    {
	        // update the stencil buffer width and height
	        gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencil);
	        gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, width, height);
	    }
	};
	
	/**
	 * Destroys this buffer
	 */
	Framebuffer.prototype.destroy = function()
	{
	    var gl = this.gl;
	
	    //TODO
	    if(this.texture)
	    {
	        this.texture.destroy();
	    }
	
	    gl.deleteFramebuffer(this.framebuffer);
	
	    this.gl = null;
	
	    this.stencil = null;
	    this.texture = null;
	};
	
	/**
	 * Creates a frame buffer with a texture containing the given data
	 * @static
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param width {Number} the width of the drawing area of the frame buffer
	 * @param height {Number} the height of the drawing area of the frame buffer
	 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
	 */
	Framebuffer.createRGBA = function(gl, width, height, data)
	{
	    var texture = Texture.fromData(gl, null, width, height);
	    texture.enableNearestScaling();
	    texture.enableWrapClamp();
	
	    //now create the framebuffer object and attach the texture to it.
	    var fbo = new Framebuffer(gl, width, height);
	    fbo.enableTexture(texture);
	    //fbo.enableStencil(); // get this back on soon!
	
	    //fbo.enableStencil(); // get this back on soon!
	
	    fbo.unbind();
	
	    return fbo;
	};
	
	/**
	 * Creates a frame buffer with a texture containing the given data
	 * @static
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param width {Number} the width of the drawing area of the frame buffer
	 * @param height {Number} the height of the drawing area of the frame buffer
	 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
	 */
	Framebuffer.createFloat32 = function(gl, width, height, data)
	{
	    // create a new texture..
	    var texture = new Texture.fromData(gl, data, width, height);
	    texture.enableNearestScaling();
	    texture.enableWrapClamp();
	
	    //now create the framebuffer object and attach the texture to it.
	    var fbo = new Framebuffer(gl, width, height);
	    fbo.enableTexture(texture);
	
	    fbo.unbind();
	
	    return fbo;
	};
	
	module.exports = Framebuffer;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

	
	/**
	 * Helper class to create a WebGL Texture
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext} The current WebGL context
	 * @param width {number} the width of the texture
	 * @param height {number} the height of the texture
	 * @param format {number} the pixel format of the texture. defaults to gl.RGBA
	 * @param type {number} the gl type of the texture. defaults to gl.UNSIGNED_BYTE
	 */
	var Texture = function(gl, width, height, format, type)
	{
		/**
		 * The current WebGL rendering context
		 *
		 * @member {WebGLRenderingContext}
		 */
		this.gl = gl;
	
	
		/**
		 * The WebGL texture
		 *
		 * @member {WebGLTexture}
		 */
		this.texture = gl.createTexture();
	
		/**
		 * If mipmapping was used for this texture, enable and disable with enableMipmap()
		 *
		 * @member {Boolean}
		 */
		// some settings..
		this.mipmap = false;
	
	
		/**
		 * Set to true to enable pre-multiplied alpha
		 *
		 * @member {Boolean}
		 */
		this.premultiplyAlpha = false;
	
		/**
		 * The width of texture
		 *
		 * @member {Number}
		 */
		this.width = width || -1;
		/**
		 * The height of texture
		 *
		 * @member {Number}
		 */
		this.height = height || -1;
	
		/**
		 * The pixel format of the texture. defaults to gl.RGBA
		 *
		 * @member {Number}
		 */
		this.format = format || gl.RGBA;
	
		/**
		 * The gl type of the texture. defaults to gl.UNSIGNED_BYTE
		 *
		 * @member {Number}
		 */
		this.type = type || gl.UNSIGNED_BYTE;
	
	
	};
	
	/**
	 * Uploads this texture to the GPU
	 * @param source {HTMLImageElement|ImageData|HTMLVideoElement} the source image of the texture
	 */
	Texture.prototype.upload = function(source)
	{
		this.bind();
	
		var gl = this.gl;
	
	
		gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);
	
		var newWidth = source.videoWidth || source.width;
		var newHeight = source.videoHeight || source.height;
	
		if(newHeight !== this.height || newWidth !== this.width)
		{
			gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.format, this.type, source);
		}
		else
		{
	    	gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, this.format, this.type, source);
		}
	
		// if the source is a video, we need to use the videoWidth / videoHeight properties as width / height will be incorrect.
		this.width = newWidth;
		this.height = newHeight;
	
	};
	
	var FLOATING_POINT_AVAILABLE = false;
	
	/**
	 * Use a data source and uploads this texture to the GPU
	 * @param data {TypedArray} the data to upload to the texture
	 * @param width {number} the new width of the texture
	 * @param height {number} the new height of the texture
	 */
	Texture.prototype.uploadData = function(data, width, height)
	{
		this.bind();
	
		var gl = this.gl;
	
	
		if(data instanceof Float32Array)
		{
			if(!FLOATING_POINT_AVAILABLE)
			{
				var ext = gl.getExtension("OES_texture_float");
	
				if(ext)
				{
					FLOATING_POINT_AVAILABLE = true;
				}
				else
				{
					throw new Error('floating point textures not available');
				}
			}
	
			this.type = gl.FLOAT;
		}
		else
		{
			// TODO support for other types
			this.type = this.type || gl.UNSIGNED_BYTE;
		}
	
		// what type of data?
		gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);
	
	
		if(width !== this.width || height !== this.height)
		{
			gl.texImage2D(gl.TEXTURE_2D, 0, this.format,  width, height, 0, this.format, this.type, data || null);
		}
		else
		{
			gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, width, height, this.format, this.type, data || null);
		}
	
		this.width = width;
		this.height = height;
	
	
	//	texSubImage2D
	};
	
	/**
	 * Binds the texture
	 * @param  location
	 */
	Texture.prototype.bind = function(location)
	{
		var gl = this.gl;
	
		if(location !== undefined)
		{
			gl.activeTexture(gl.TEXTURE0 + location);
		}
	
		gl.bindTexture(gl.TEXTURE_2D, this.texture);
	};
	
	/**
	 * Unbinds the texture
	 */
	Texture.prototype.unbind = function()
	{
		var gl = this.gl;
		gl.bindTexture(gl.TEXTURE_2D, null);
	};
	
	/**
	 * @param linear {Boolean} if we want to use linear filtering or nearest neighbour interpolation
	 */
	Texture.prototype.minFilter = function( linear )
	{
		var gl = this.gl;
	
		this.bind();
	
		if(this.mipmap)
		{
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, linear ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
		}
		else
		{
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, linear ? gl.LINEAR : gl.NEAREST);
		}
	};
	
	/**
	 * @param linear {Boolean} if we want to use linear filtering or nearest neighbour interpolation
	 */
	Texture.prototype.magFilter = function( linear )
	{
		var gl = this.gl;
	
		this.bind();
	
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, linear ? gl.LINEAR : gl.NEAREST);
	};
	
	/**
	 * Enables mipmapping
	 */
	Texture.prototype.enableMipmap = function()
	{
		var gl = this.gl;
	
		this.bind();
	
		this.mipmap = true;
	
		gl.generateMipmap(gl.TEXTURE_2D);
	};
	
	/**
	 * Enables linear filtering
	 */
	Texture.prototype.enableLinearScaling = function()
	{
		this.minFilter(true);
		this.magFilter(true);
	};
	
	/**
	 * Enables nearest neighbour interpolation
	 */
	Texture.prototype.enableNearestScaling = function()
	{
		this.minFilter(false);
		this.magFilter(false);
	};
	
	/**
	 * Enables clamping on the texture so WebGL will not repeat it
	 */
	Texture.prototype.enableWrapClamp = function()
	{
		var gl = this.gl;
	
		this.bind();
	
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	};
	
	/**
	 * Enable tiling on the texture
	 */
	Texture.prototype.enableWrapRepeat = function()
	{
		var gl = this.gl;
	
		this.bind();
	
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
	};
	
	Texture.prototype.enableWrapMirrorRepeat = function()
	{
		var gl = this.gl;
	
		this.bind();
	
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.MIRRORED_REPEAT);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.MIRRORED_REPEAT);
	};
	
	
	/**
	 * Destroys this texture
	 */
	Texture.prototype.destroy = function()
	{
		var gl = this.gl;
		//TODO
		gl.deleteTexture(this.texture);
	};
	
	/**
	 * @static
	 * @param gl {WebGLRenderingContext} The current WebGL context
	 * @param source {HTMLImageElement|ImageData} the source image of the texture
	 * @param premultiplyAlpha {Boolean} If we want to use pre-multiplied alpha
	 */
	Texture.fromSource = function(gl, source, premultiplyAlpha)
	{
		var texture = new Texture(gl);
		texture.premultiplyAlpha = premultiplyAlpha || false;
		texture.upload(source);
	
		return texture;
	};
	
	/**
	 * @static
	 * @param gl {WebGLRenderingContext} The current WebGL context
	 * @param data {TypedArray} the data to upload to the texture
	 * @param width {number} the new width of the texture
	 * @param height {number} the new height of the texture
	 */
	Texture.fromData = function(gl, data, width, height)
	{
		//console.log(data, width, height);
		var texture = new Texture(gl);
		texture.uploadData(data, width, height);
	
		return texture;
	};
	
	
	module.exports = Texture;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	
	var compileProgram = __webpack_require__(223),
		extractAttributes = __webpack_require__(224),
		extractUniforms = __webpack_require__(227),
		setPrecision = __webpack_require__(229),
		generateUniformAccessObject = __webpack_require__(230);
	
	/**
	 * Helper class to create a webGL Shader
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext}
	 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
	 * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
	 * @param precision {string} The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
	 * @param attributeLocations {object} A key value pair showing which location eact attribute should sit eg {position:0, uvs:1}
	 */
	var Shader = function(gl, vertexSrc, fragmentSrc, precision, attributeLocations)
	{
		/**
		 * The current WebGL rendering context
		 *
		 * @member {WebGLRenderingContext}
		 */
		this.gl = gl;
	
		if(precision)
		{
			vertexSrc = setPrecision(vertexSrc, precision);
			fragmentSrc = setPrecision(fragmentSrc, precision);
		}
	
		/**
		 * The shader program
		 *
		 * @member {WebGLProgram}
		 */
		// First compile the program..
		this.program = compileProgram(gl, vertexSrc, fragmentSrc, attributeLocations);
	
		/**
		 * The attributes of the shader as an object containing the following properties
		 * {
		 * 	type,
		 * 	size,
		 * 	location,
		 * 	pointer
		 * }
		 * @member {Object}
		 */
		// next extract the attributes
		this.attributes = extractAttributes(gl, this.program);
	
	    this.uniformData = extractUniforms(gl, this.program);
	
		/**
		 * The uniforms of the shader as an object containing the following properties
		 * {
		 * 	gl,
		 * 	data
		 * }
		 * @member {Object}
		 */
		this.uniforms = generateUniformAccessObject( gl, this.uniformData );
	
	};
	/**
	 * Uses this shader
	 * 
	 * @return {PIXI.glCore.GLShader} Returns itself.
	 */
	Shader.prototype.bind = function()
	{
		this.gl.useProgram(this.program);
		return this;
	};
	
	/**
	 * Destroys this shader
	 * TODO
	 */
	Shader.prototype.destroy = function()
	{
		this.attributes = null;
		this.uniformData = null;
		this.uniforms = null;
	
		var gl = this.gl;
		gl.deleteProgram(this.program);
	};
	
	
	module.exports = Shader;


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	
	/**
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
	 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
	 * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
	 * @param attributeLocations {Object} An attribute location map that lets you manually set the attribute locations
	 * @return {WebGLProgram} the shader program
	 */
	var compileProgram = function(gl, vertexSrc, fragmentSrc, attributeLocations)
	{
	    var glVertShader = compileShader(gl, gl.VERTEX_SHADER, vertexSrc);
	    var glFragShader = compileShader(gl, gl.FRAGMENT_SHADER, fragmentSrc);
	
	    var program = gl.createProgram();
	
	    gl.attachShader(program, glVertShader);
	    gl.attachShader(program, glFragShader);
	
	    // optionally, set the attributes manually for the program rather than letting WebGL decide..
	    if(attributeLocations)
	    {
	        for(var i in attributeLocations)
	        {
	            gl.bindAttribLocation(program, attributeLocations[i], i);
	        }
	    }
	
	
	    gl.linkProgram(program);
	
	    // if linking fails, then log and cleanup
	    if (!gl.getProgramParameter(program, gl.LINK_STATUS))
	    {
	        console.error('Pixi.js Error: Could not initialize shader.');
	        console.error('gl.VALIDATE_STATUS', gl.getProgramParameter(program, gl.VALIDATE_STATUS));
	        console.error('gl.getError()', gl.getError());
	
	        // if there is a program info log, log it
	        if (gl.getProgramInfoLog(program) !== '')
	        {
	            console.warn('Pixi.js Warning: gl.getProgramInfoLog()', gl.getProgramInfoLog(program));
	        }
	
	        gl.deleteProgram(program);
	        program = null;
	    }
	
	    // clean up some shaders
	    gl.deleteShader(glVertShader);
	    gl.deleteShader(glFragShader);
	
	    return program;
	};
	
	/**
	 * @private
	 * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
	 * @param type {Number} the type, can be either VERTEX_SHADER or FRAGMENT_SHADER
	 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
	 * @return {WebGLShader} the shader
	 */
	var compileShader = function (gl, type, src)
	{
	    var shader = gl.createShader(type);
	
	    gl.shaderSource(shader, src);
	    gl.compileShader(shader);
	
	    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS))
	    {
	        console.log(gl.getShaderInfoLog(shader));
	        return null;
	    }
	
	    return shader;
	};
	
	module.exports = compileProgram;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	
	var mapType = __webpack_require__(225);
	var mapSize = __webpack_require__(226);
	
	/**
	 * Extracts the attributes
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param program {WebGLProgram} The shader program to get the attributes from
	 * @return attributes {Object}
	 */
	var extractAttributes = function(gl, program)
	{
	    var attributes = {};
	
	    var totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
	
	    for (var i = 0; i < totalAttributes; i++)
	    {
	        var attribData = gl.getActiveAttrib(program, i);
	        var type = mapType(gl, attribData.type);
	
	        attributes[attribData.name] = {
	            type:type,
	            size:mapSize(type),
	            location:gl.getAttribLocation(program, attribData.name),
	            //TODO - make an attribute object
	            pointer: pointer
	        };
	    }
	
	    return attributes;
	};
	
	var pointer = function(type, normalized, stride, start){
	    // console.log(this.location)
	    gl.vertexAttribPointer(this.location,this.size, type || gl.FLOAT, normalized || false, stride || 0, start || 0);
	};
	
	module.exports = extractAttributes;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

	
	
	var mapType = function(gl, type) 
	{
	    if(!GL_TABLE) 
	    {
	        var typeNames = Object.keys(GL_TO_GLSL_TYPES);
	
	        GL_TABLE = {};
	
	        for(var i = 0; i < typeNames.length; ++i) 
	        {
	            var tn = typeNames[i];
	            GL_TABLE[ gl[tn] ] = GL_TO_GLSL_TYPES[tn];
	        }
	    }
	
	  return GL_TABLE[type];
	};
	
	var GL_TABLE = null;
	
	var GL_TO_GLSL_TYPES = {
	  'FLOAT':       'float',
	  'FLOAT_VEC2':  'vec2',
	  'FLOAT_VEC3':  'vec3',
	  'FLOAT_VEC4':  'vec4',
	
	  'INT':         'int',
	  'INT_VEC2':    'ivec2',
	  'INT_VEC3':    'ivec3',
	  'INT_VEC4':    'ivec4',
	  
	  'BOOL':        'bool',
	  'BOOL_VEC2':   'bvec2',
	  'BOOL_VEC3':   'bvec3',
	  'BOOL_VEC4':   'bvec4',
	  
	  'FLOAT_MAT2':  'mat2',
	  'FLOAT_MAT3':  'mat3',
	  'FLOAT_MAT4':  'mat4',
	  
	  'SAMPLER_2D':  'sampler2D'  
	};
	
	module.exports = mapType;


/***/ }),
/* 226 */
/***/ (function(module, exports) {

	/**
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param type {String}
	 * @return {Number}
	 */
	var mapSize = function(type) 
	{ 
	    return GLSL_TO_SIZE[type];
	};
	
	
	var GLSL_TO_SIZE = {
	    'float':    1,
	    'vec2':     2,
	    'vec3':     3,
	    'vec4':     4,
	
	    'int':      1,
	    'ivec2':    2,
	    'ivec3':    3,
	    'ivec4':    4,
	
	    'bool':     1,
	    'bvec2':    2,
	    'bvec3':    3,
	    'bvec4':    4,
	
	    'mat2':     4,
	    'mat3':     9,
	    'mat4':     16,
	
	    'sampler2D':  1
	};
	
	module.exports = mapSize;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var mapType = __webpack_require__(225);
	var defaultValue = __webpack_require__(228);
	
	/**
	 * Extracts the uniforms
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param program {WebGLProgram} The shader program to get the uniforms from
	 * @return uniforms {Object}
	 */
	var extractUniforms = function(gl, program)
	{
		var uniforms = {};
	
	    var totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
	
	    for (var i = 0; i < totalUniforms; i++)
	    {
	    	var uniformData = gl.getActiveUniform(program, i);
	    	var name = uniformData.name.replace(/\[.*?\]/, "");
	        var type = mapType(gl, uniformData.type );
	
	    	uniforms[name] = {
	    		type:type,
	    		size:uniformData.size,
	    		location:gl.getUniformLocation(program, name),
	    		value:defaultValue(type, uniformData.size)
	    	};
	    }
	
		return uniforms;
	};
	
	module.exports = extractUniforms;


/***/ }),
/* 228 */
/***/ (function(module, exports) {

	/**
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param type {String} Type of value
	 * @param size {Number}
	 */
	var defaultValue = function(type, size) 
	{
	    switch (type)
	    {
	        case 'float':
	            return 0;
	
	        case 'vec2': 
	            return new Float32Array(2 * size);
	
	        case 'vec3':
	            return new Float32Array(3 * size);
	
	        case 'vec4':     
	            return new Float32Array(4 * size);
	            
	        case 'int':
	        case 'sampler2D':
	            return 0;
	
	        case 'ivec2':   
	            return new Int32Array(2 * size);
	
	        case 'ivec3':
	            return new Int32Array(3 * size);
	
	        case 'ivec4': 
	            return new Int32Array(4 * size);
	
	        case 'bool':     
	            return false;
	
	        case 'bvec2':
	
	            return booleanArray( 2 * size);
	
	        case 'bvec3':
	            return booleanArray(3 * size);
	
	        case 'bvec4':
	            return booleanArray(4 * size);
	
	        case 'mat2':
	            return new Float32Array([1, 0,
	                                     0, 1]);
	
	        case 'mat3': 
	            return new Float32Array([1, 0, 0,
	                                     0, 1, 0,
	                                     0, 0, 1]);
	
	        case 'mat4':
	            return new Float32Array([1, 0, 0, 0,
	                                     0, 1, 0, 0,
	                                     0, 0, 1, 0,
	                                     0, 0, 0, 1]);
	    }
	};
	
	var booleanArray = function(size)
	{
	    var array = new Array(size);
	
	    for (var i = 0; i < array.length; i++) 
	    {
	        array[i] = false;
	    }
	
	    return array;
	};
	
	module.exports = defaultValue;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	/**
	 * Sets the float precision on the shader. If the precision is already present this function will do nothing
	 * @param {string} src       the shader source
	 * @param {string} precision The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
	 *
	 * @return {string} modified shader source
	 */
	var setPrecision = function(src, precision)
	{
	    if(src.substring(0, 9) !== 'precision')
	    {
	        return 'precision ' + precision + ' float;\n' + src;
	    }
	
	    return src;
	};
	
	module.exports = setPrecision;


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	/**
	 * Extracts the attributes
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param uniforms {Array} @mat ?
	 * @return attributes {Object}
	 */
	var generateUniformAccessObject = function(gl, uniformData)
	{
	    // this is the object we will be sending back.
	    // an object hierachy will be created for structs
	    var uniforms = {data:{}};
	
	    uniforms.gl = gl;
	
	    var uniformKeys= Object.keys(uniformData);
	
	    for (var i = 0; i < uniformKeys.length; i++)
	    {
	        var fullName = uniformKeys[i];
	
	        var nameTokens = fullName.split('.');
	        var name = nameTokens[nameTokens.length - 1];
	
	
	        var uniformGroup = getUniformGroup(nameTokens, uniforms);
	
	        var uniform =  uniformData[fullName];
	        uniformGroup.data[name] = uniform;
	
	        uniformGroup.gl = gl;
	
	        Object.defineProperty(uniformGroup, name, {
	            get: generateGetter(name),
	            set: generateSetter(name, uniform)
	        });
	    }
	
	    return uniforms;
	};
	
	var generateGetter = function(name)
	{
	    return function() {
	        return this.data[name].value;
	    };
	};
	
	var GLSL_SINGLE_SETTERS = {
	    float: function setSingleFloat(gl, location, value) { gl.uniform1f(location, value); },
	    vec2: function setSingleVec2(gl, location, value) { gl.uniform2f(location, value[0], value[1]); },
	    vec3: function setSingleVec3(gl, location, value) { gl.uniform3f(location, value[0], value[1], value[2]); },
	    vec4: function setSingleVec4(gl, location, value) { gl.uniform4f(location, value[0], value[1], value[2], value[3]); },
	
	    int: function setSingleInt(gl, location, value) { gl.uniform1i(location, value); },
	    ivec2: function setSingleIvec2(gl, location, value) { gl.uniform2i(location, value[0], value[1]); },
	    ivec3: function setSingleIvec3(gl, location, value) { gl.uniform3i(location, value[0], value[1], value[2]); },
	    ivec4: function setSingleIvec4(gl, location, value) { gl.uniform4i(location, value[0], value[1], value[2], value[3]); },
	
	    bool: function setSingleBool(gl, location, value) { gl.uniform1i(location, value); },
	    bvec2: function setSingleBvec2(gl, location, value) { gl.uniform2i(location, value[0], value[1]); },
	    bvec3: function setSingleBvec3(gl, location, value) { gl.uniform3i(location, value[0], value[1], value[2]); },
	    bvec4: function setSingleBvec4(gl, location, value) { gl.uniform4i(location, value[0], value[1], value[2], value[3]); },
	
	    mat2: function setSingleMat2(gl, location, value) { gl.uniformMatrix2fv(location, false, value); },
	    mat3: function setSingleMat3(gl, location, value) { gl.uniformMatrix3fv(location, false, value); },
	    mat4: function setSingleMat4(gl, location, value) { gl.uniformMatrix4fv(location, false, value); },
	
	    sampler2D: function setSingleSampler2D(gl, location, value) { gl.uniform1i(location, value); },
	};
	
	var GLSL_ARRAY_SETTERS = {
	    float: function setFloatArray(gl, location, value) { gl.uniform1fv(location, value); },
	    vec2: function setVec2Array(gl, location, value) { gl.uniform2fv(location, value); },
	    vec3: function setVec3Array(gl, location, value) { gl.uniform3fv(location, value); },
	    vec4: function setVec4Array(gl, location, value) { gl.uniform4fv(location, value); },
	    int: function setIntArray(gl, location, value) { gl.uniform1iv(location, value); },
	    ivec2: function setIvec2Array(gl, location, value) { gl.uniform2iv(location, value); },
	    ivec3: function setIvec3Array(gl, location, value) { gl.uniform3iv(location, value); },
	    ivec4: function setIvec4Array(gl, location, value) { gl.uniform4iv(location, value); },
	    bool: function setBoolArray(gl, location, value) { gl.uniform1iv(location, value); },
	    bvec2: function setBvec2Array(gl, location, value) { gl.uniform2iv(location, value); },
	    bvec3: function setBvec3Array(gl, location, value) { gl.uniform3iv(location, value); },
	    bvec4: function setBvec4Array(gl, location, value) { gl.uniform4iv(location, value); },
	    sampler2D: function setSampler2DArray(gl, location, value) { gl.uniform1iv(location, value); },
	};
	
	function generateSetter(name, uniform)
	{
	    return function(value) {
	        this.data[name].value = value;
	        var location = this.data[name].location;
	        if (uniform.size === 1)
	        {
	            GLSL_SINGLE_SETTERS[uniform.type](this.gl, location, value);
	        }
	        else
	        {
	            // glslSetArray(gl, location, type, value) {
	            GLSL_ARRAY_SETTERS[uniform.type](this.gl, location, value);
	        }
	    };
	}
	
	function getUniformGroup(nameTokens, uniform)
	{
	    var cur = uniform;
	
	    for (var i = 0; i < nameTokens.length - 1; i++)
	    {
	        var o = cur[nameTokens[i]] || {data:{}};
	        cur[nameTokens[i]] = o;
	        cur = o;
	    }
	
	    return cur;
	}
	
	
	module.exports = generateUniformAccessObject;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	
	// state object//
	var setVertexAttribArrays = __webpack_require__( 218 );
	
	/**
	 * Helper class to work with WebGL VertexArrayObjects (vaos)
	 * Only works if WebGL extensions are enabled (they usually are)
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 */
	function VertexArrayObject(gl, state)
	{
	    this.nativeVaoExtension = null;
	
	    if(!VertexArrayObject.FORCE_NATIVE)
	    {
	        this.nativeVaoExtension = gl.getExtension('OES_vertex_array_object') ||
	                                  gl.getExtension('MOZ_OES_vertex_array_object') ||
	                                  gl.getExtension('WEBKIT_OES_vertex_array_object');
	    }
	
	    this.nativeState = state;
	
	    if(this.nativeVaoExtension)
	    {
	        this.nativeVao = this.nativeVaoExtension.createVertexArrayOES();
	
	        var maxAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
	
	        // VAO - overwrite the state..
	        this.nativeState = {
	            tempAttribState: new Array(maxAttribs),
	            attribState: new Array(maxAttribs)
	        };
	    }
	
	    /**
	     * The current WebGL rendering context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	    /**
	     * An array of attributes
	     *
	     * @member {Array}
	     */
	    this.attributes = [];
	
	    /**
	     * @member {PIXI.glCore.GLBuffer}
	     */
	    this.indexBuffer = null;
	
	    /**
	     * A boolean flag
	     *
	     * @member {Boolean}
	     */
	    this.dirty = false;
	}
	
	VertexArrayObject.prototype.constructor = VertexArrayObject;
	module.exports = VertexArrayObject;
	
	/**
	* Some devices behave a bit funny when using the newer extensions (im looking at you ipad 2!)
	* If you find on older devices that things have gone a bit weird then set this to true.
	*/
	/**
	 * Lets the VAO know if you should use the WebGL extension or the native methods.
	 * Some devices behave a bit funny when using the newer extensions (im looking at you ipad 2!)
	 * If you find on older devices that things have gone a bit weird then set this to true.
	 * @static
	 * @property {Boolean} FORCE_NATIVE
	 */
	VertexArrayObject.FORCE_NATIVE = false;
	
	/**
	 * Binds the buffer
	 */
	VertexArrayObject.prototype.bind = function()
	{
	    if(this.nativeVao)
	    {
	        this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao);
	
	        if(this.dirty)
	        {
	            this.dirty = false;
	            this.activate();
	            return this;
	        }
	        if (this.indexBuffer)
	        {
	            this.indexBuffer.bind();
	        }
	    }
	    else
	    {
	        this.activate();
	    }
	
	    return this;
	};
	
	/**
	 * Unbinds the buffer
	 */
	VertexArrayObject.prototype.unbind = function()
	{
	    if(this.nativeVao)
	    {
	        this.nativeVaoExtension.bindVertexArrayOES(null);
	    }
	
	    return this;
	};
	
	/**
	 * Uses this vao
	 */
	VertexArrayObject.prototype.activate = function()
	{
	
	    var gl = this.gl;
	    var lastBuffer = null;
	
	    for (var i = 0; i < this.attributes.length; i++)
	    {
	        var attrib = this.attributes[i];
	
	        if(lastBuffer !== attrib.buffer)
	        {
	            attrib.buffer.bind();
	            lastBuffer = attrib.buffer;
	        }
	
	        gl.vertexAttribPointer(attrib.attribute.location,
	                               attrib.attribute.size,
	                               attrib.type || gl.FLOAT,
	                               attrib.normalized || false,
	                               attrib.stride || 0,
	                               attrib.start || 0);
	    }
	
	    setVertexAttribArrays(gl, this.attributes, this.nativeState);
	
	    if(this.indexBuffer)
	    {
	        this.indexBuffer.bind();
	    }
	
	    return this;
	};
	
	/**
	 *
	 * @param buffer     {PIXI.gl.GLBuffer}
	 * @param attribute  {*}
	 * @param type       {String}
	 * @param normalized {Boolean}
	 * @param stride     {Number}
	 * @param start      {Number}
	 */
	VertexArrayObject.prototype.addAttribute = function(buffer, attribute, type, normalized, stride, start)
	{
	    this.attributes.push({
	        buffer:     buffer,
	        attribute:  attribute,
	
	        location:   attribute.location,
	        type:       type || this.gl.FLOAT,
	        normalized: normalized || false,
	        stride:     stride || 0,
	        start:      start || 0
	    });
	
	    this.dirty = true;
	
	    return this;
	};
	
	/**
	 *
	 * @param buffer   {PIXI.gl.GLBuffer}
	 */
	VertexArrayObject.prototype.addIndex = function(buffer/*, options*/)
	{
	    this.indexBuffer = buffer;
	
	    this.dirty = true;
	
	    return this;
	};
	
	/**
	 * Unbinds this vao and disables it
	 */
	VertexArrayObject.prototype.clear = function()
	{
	    // var gl = this.gl;
	
	    // TODO - should this function unbind after clear?
	    // for now, no but lets see what happens in the real world!
	    if(this.nativeVao)
	    {
	        this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao);
	    }
	
	    this.attributes.length = 0;
	    this.indexBuffer = null;
	
	    return this;
	};
	
	/**
	 * @param type  {Number}
	 * @param size  {Number}
	 * @param start {Number}
	 */
	VertexArrayObject.prototype.draw = function(type, size, start)
	{
	    var gl = this.gl;
	
	    if(this.indexBuffer)
	    {
	        gl.drawElements(type, size || this.indexBuffer.data.length, gl.UNSIGNED_SHORT, (start || 0) * 2 );
	    }
	    else
	    {
	        // TODO need a better way to calculate size..
	        gl.drawArrays(type, start, size || this.getSize());
	    }
	
	    return this;
	};
	
	/**
	 * Destroy this vao
	 */
	VertexArrayObject.prototype.destroy = function()
	{
	    // lose references
	    this.gl = null;
	    this.indexBuffer = null;
	    this.attributes = null;
	    this.nativeState = null;
	
	    if(this.nativeVao)
	    {
	        this.nativeVaoExtension.deleteVertexArrayOES(this.nativeVao);
	    }
	
	    this.nativeVaoExtension = null;
	    this.nativeVao = null;
	};
	
	VertexArrayObject.prototype.getSize = function()
	{
	    var attrib = this.attributes[0];
	    return attrib.buffer.data.length / (( attrib.stride/4 ) || attrib.attribute.size);
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	    compileProgram: __webpack_require__(223),
	    defaultValue: __webpack_require__(228),
	    extractAttributes: __webpack_require__(224),
	    extractUniforms: __webpack_require__(227),
	    generateUniformAccessObject: __webpack_require__(230),
	    setPrecision: __webpack_require__(229),
	    mapSize: __webpack_require__(226),
	    mapType: __webpack_require__(225)
	};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _math = __webpack_require__(206);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * 'Builder' pattern for bounds rectangles
	 * Axis-Aligned Bounding Box
	 * It is not a shape! Its mutable thing, no 'EMPTY' or that kind of problems
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Bounds = function () {
	    /**
	     *
	     */
	    function Bounds() {
	        _classCallCheck(this, Bounds);
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.minX = Infinity;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.minY = Infinity;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.maxX = -Infinity;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.maxY = -Infinity;
	
	        this.rect = null;
	    }
	
	    /**
	     * Checks if bounds are empty.
	     *
	     * @return {boolean} True if empty.
	     */
	
	
	    Bounds.prototype.isEmpty = function isEmpty() {
	        return this.minX > this.maxX || this.minY > this.maxY;
	    };
	
	    /**
	     * Clears the bounds and resets.
	     *
	     */
	
	
	    Bounds.prototype.clear = function clear() {
	        this.updateID++;
	
	        this.minX = Infinity;
	        this.minY = Infinity;
	        this.maxX = -Infinity;
	        this.maxY = -Infinity;
	    };
	
	    /**
	     * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
	     * It is not guaranteed that it will return tempRect
	     *
	     * @param {PIXI.Rectangle} rect - temporary object will be used if AABB is not empty
	     * @returns {PIXI.Rectangle} A rectangle of the bounds
	     */
	
	
	    Bounds.prototype.getRectangle = function getRectangle(rect) {
	        if (this.minX > this.maxX || this.minY > this.maxY) {
	            return _math.Rectangle.EMPTY;
	        }
	
	        rect = rect || new _math.Rectangle(0, 0, 1, 1);
	
	        rect.x = this.minX;
	        rect.y = this.minY;
	        rect.width = this.maxX - this.minX;
	        rect.height = this.maxY - this.minY;
	
	        return rect;
	    };
	
	    /**
	     * This function should be inlined when its possible.
	     *
	     * @param {PIXI.Point} point - The point to add.
	     */
	
	
	    Bounds.prototype.addPoint = function addPoint(point) {
	        this.minX = Math.min(this.minX, point.x);
	        this.maxX = Math.max(this.maxX, point.x);
	        this.minY = Math.min(this.minY, point.y);
	        this.maxY = Math.max(this.maxY, point.y);
	    };
	
	    /**
	     * Adds a quad, not transformed
	     *
	     * @param {Float32Array} vertices - The verts to add.
	     */
	
	
	    Bounds.prototype.addQuad = function addQuad(vertices) {
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;
	
	        var x = vertices[0];
	        var y = vertices[1];
	
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        x = vertices[2];
	        y = vertices[3];
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        x = vertices[4];
	        y = vertices[5];
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        x = vertices[6];
	        y = vertices[7];
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        this.minX = minX;
	        this.minY = minY;
	        this.maxX = maxX;
	        this.maxY = maxY;
	    };
	
	    /**
	     * Adds sprite frame, transformed.
	     *
	     * @param {PIXI.TransformBase} transform - TODO
	     * @param {number} x0 - TODO
	     * @param {number} y0 - TODO
	     * @param {number} x1 - TODO
	     * @param {number} y1 - TODO
	     */
	
	
	    Bounds.prototype.addFrame = function addFrame(transform, x0, y0, x1, y1) {
	        var matrix = transform.worldTransform;
	        var a = matrix.a;
	        var b = matrix.b;
	        var c = matrix.c;
	        var d = matrix.d;
	        var tx = matrix.tx;
	        var ty = matrix.ty;
	
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;
	
	        var x = a * x0 + c * y0 + tx;
	        var y = b * x0 + d * y0 + ty;
	
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        x = a * x1 + c * y0 + tx;
	        y = b * x1 + d * y0 + ty;
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        x = a * x0 + c * y1 + tx;
	        y = b * x0 + d * y1 + ty;
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        x = a * x1 + c * y1 + tx;
	        y = b * x1 + d * y1 + ty;
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        this.minX = minX;
	        this.minY = minY;
	        this.maxX = maxX;
	        this.maxY = maxY;
	    };
	
	    /**
	     * Add an array of vertices
	     *
	     * @param {PIXI.TransformBase} transform - TODO
	     * @param {Float32Array} vertices - TODO
	     * @param {number} beginOffset - TODO
	     * @param {number} endOffset - TODO
	     */
	
	
	    Bounds.prototype.addVertices = function addVertices(transform, vertices, beginOffset, endOffset) {
	        var matrix = transform.worldTransform;
	        var a = matrix.a;
	        var b = matrix.b;
	        var c = matrix.c;
	        var d = matrix.d;
	        var tx = matrix.tx;
	        var ty = matrix.ty;
	
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;
	
	        for (var i = beginOffset; i < endOffset; i += 2) {
	            var rawX = vertices[i];
	            var rawY = vertices[i + 1];
	            var x = a * rawX + c * rawY + tx;
	            var y = d * rawY + b * rawX + ty;
	
	            minX = x < minX ? x : minX;
	            minY = y < minY ? y : minY;
	            maxX = x > maxX ? x : maxX;
	            maxY = y > maxY ? y : maxY;
	        }
	
	        this.minX = minX;
	        this.minY = minY;
	        this.maxX = maxX;
	        this.maxY = maxY;
	    };
	
	    /**
	     * Adds other Bounds
	     *
	     * @param {PIXI.Bounds} bounds - TODO
	     */
	
	
	    Bounds.prototype.addBounds = function addBounds(bounds) {
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;
	
	        this.minX = bounds.minX < minX ? bounds.minX : minX;
	        this.minY = bounds.minY < minY ? bounds.minY : minY;
	        this.maxX = bounds.maxX > maxX ? bounds.maxX : maxX;
	        this.maxY = bounds.maxY > maxY ? bounds.maxY : maxY;
	    };
	
	    /**
	     * Adds other Bounds, masked with Bounds
	     *
	     * @param {PIXI.Bounds} bounds - TODO
	     * @param {PIXI.Bounds} mask - TODO
	     */
	
	
	    Bounds.prototype.addBoundsMask = function addBoundsMask(bounds, mask) {
	        var _minX = bounds.minX > mask.minX ? bounds.minX : mask.minX;
	        var _minY = bounds.minY > mask.minY ? bounds.minY : mask.minY;
	        var _maxX = bounds.maxX < mask.maxX ? bounds.maxX : mask.maxX;
	        var _maxY = bounds.maxY < mask.maxY ? bounds.maxY : mask.maxY;
	
	        if (_minX <= _maxX && _minY <= _maxY) {
	            var minX = this.minX;
	            var minY = this.minY;
	            var maxX = this.maxX;
	            var maxY = this.maxY;
	
	            this.minX = _minX < minX ? _minX : minX;
	            this.minY = _minY < minY ? _minY : minY;
	            this.maxX = _maxX > maxX ? _maxX : maxX;
	            this.maxY = _maxY > maxY ? _maxY : maxY;
	        }
	    };
	
	    /**
	     * Adds other Bounds, masked with Rectangle
	     *
	     * @param {PIXI.Bounds} bounds - TODO
	     * @param {PIXI.Rectangle} area - TODO
	     */
	
	
	    Bounds.prototype.addBoundsArea = function addBoundsArea(bounds, area) {
	        var _minX = bounds.minX > area.x ? bounds.minX : area.x;
	        var _minY = bounds.minY > area.y ? bounds.minY : area.y;
	        var _maxX = bounds.maxX < area.x + area.width ? bounds.maxX : area.x + area.width;
	        var _maxY = bounds.maxY < area.y + area.height ? bounds.maxY : area.y + area.height;
	
	        if (_minX <= _maxX && _minY <= _maxY) {
	            var minX = this.minX;
	            var minY = this.minY;
	            var maxX = this.maxX;
	            var maxY = this.maxY;
	
	            this.minX = _minX < minX ? _minX : minX;
	            this.minY = _minY < minY ? _minY : minY;
	            this.maxX = _maxX > maxX ? _maxX : maxX;
	            this.maxY = _maxY > maxY ? _maxY : maxY;
	        }
	    };
	
	    return Bounds;
	}();
	
	exports.default = Bounds;
	//# sourceMappingURL=Bounds.js.map

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventemitter = __webpack_require__(235);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _const = __webpack_require__(205);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _TransformStatic = __webpack_require__(240);
	
	var _TransformStatic2 = _interopRequireDefault(_TransformStatic);
	
	var _Transform = __webpack_require__(242);
	
	var _Transform2 = _interopRequireDefault(_Transform);
	
	var _Bounds = __webpack_require__(233);
	
	var _Bounds2 = _interopRequireDefault(_Bounds);
	
	var _math = __webpack_require__(206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// _tempDisplayObjectParent = new DisplayObject();
	
	/**
	 * The base class for all objects that are rendered on the screen.
	 * This is an abstract class and should not be used on its own rather it should be extended.
	 *
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI
	 */
	var DisplayObject = function (_EventEmitter) {
	    _inherits(DisplayObject, _EventEmitter);
	
	    /**
	     *
	     */
	    function DisplayObject() {
	        _classCallCheck(this, DisplayObject);
	
	        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	        var TransformClass = _settings2.default.TRANSFORM_MODE === _const.TRANSFORM_MODE.STATIC ? _TransformStatic2.default : _Transform2.default;
	
	        _this.tempDisplayObjectParent = null;
	
	        // TODO: need to create Transform from factory
	        /**
	         * World transform and local transform of this object.
	         * This will become read-only later, please do not assign anything there unless you know what are you doing
	         *
	         * @member {PIXI.TransformBase}
	         */
	        _this.transform = new TransformClass();
	
	        /**
	         * The opacity of the object.
	         *
	         * @member {number}
	         */
	        _this.alpha = 1;
	
	        /**
	         * The visibility of the object. If false the object will not be drawn, and
	         * the updateTransform function will not be called.
	         *
	         * Only affects recursive calls from parent. You can ask for bounds or call updateTransform manually
	         *
	         * @member {boolean}
	         */
	        _this.visible = true;
	
	        /**
	         * Can this object be rendered, if false the object will not be drawn but the updateTransform
	         * methods will still be called.
	         *
	         * Only affects recursive calls from parent. You can ask for bounds manually
	         *
	         * @member {boolean}
	         */
	        _this.renderable = true;
	
	        /**
	         * The display object container that contains this display object.
	         *
	         * @member {PIXI.Container}
	         * @readonly
	         */
	        _this.parent = null;
	
	        /**
	         * The multiplied alpha of the displayObject
	         *
	         * @member {number}
	         * @readonly
	         */
	        _this.worldAlpha = 1;
	
	        /**
	         * The area the filter is applied to. This is used as more of an optimisation
	         * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle
	         *
	         * Also works as an interaction mask
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this.filterArea = null;
	
	        _this._filters = null;
	        _this._enabledFilters = null;
	
	        /**
	         * The bounds object, this is used to calculate and store the bounds of the displayObject
	         *
	         * @member {PIXI.Rectangle}
	         * @private
	         */
	        _this._bounds = new _Bounds2.default();
	        _this._boundsID = 0;
	        _this._lastBoundsID = -1;
	        _this._boundsRect = null;
	        _this._localBoundsRect = null;
	
	        /**
	         * The original, cached mask of the object
	         *
	         * @member {PIXI.Graphics|PIXI.Sprite}
	         * @private
	         */
	        _this._mask = null;
	
	        /**
	         * If the object has been destroyed via destroy(). If true, it should not be used.
	         *
	         * @member {boolean}
	         * @private
	         * @readonly
	         */
	        _this._destroyed = false;
	
	        /**
	         * Fired when this DisplayObject is added to a Container.
	         *
	         * @event PIXI.DisplayObject#added
	         * @param {PIXI.Container} container - The container added to.
	         */
	
	        /**
	         * Fired when this DisplayObject is removed from a Container.
	         *
	         * @event PIXI.DisplayObject#removed
	         * @param {PIXI.Container} container - The container removed from.
	         */
	        return _this;
	    }
	
	    /**
	     * @private
	     * @member {PIXI.DisplayObject}
	     */
	
	
	    /**
	     * Updates the object transform for rendering
	     *
	     * TODO - Optimization pass!
	     */
	    DisplayObject.prototype.updateTransform = function updateTransform() {
	        this.transform.updateTransform(this.parent.transform);
	        // multiply the alphas..
	        this.worldAlpha = this.alpha * this.parent.worldAlpha;
	
	        this._bounds.updateID++;
	    };
	
	    /**
	     * recursively updates transform of all objects from the root to this one
	     * internal function for toLocal()
	     */
	
	
	    DisplayObject.prototype._recursivePostUpdateTransform = function _recursivePostUpdateTransform() {
	        if (this.parent) {
	            this.parent._recursivePostUpdateTransform();
	            this.transform.updateTransform(this.parent.transform);
	        } else {
	            this.transform.updateTransform(this._tempDisplayObjectParent.transform);
	        }
	    };
	
	    /**
	     * Retrieves the bounds of the displayObject as a rectangle object.
	     *
	     * @param {boolean} skipUpdate - setting to true will stop the transforms of the scene graph from
	     *  being updated. This means the calculation returned MAY be out of date BUT will give you a
	     *  nice performance boost
	     * @param {PIXI.Rectangle} rect - Optional rectangle to store the result of the bounds calculation
	     * @return {PIXI.Rectangle} the rectangular bounding area
	     */
	
	
	    DisplayObject.prototype.getBounds = function getBounds(skipUpdate, rect) {
	        if (!skipUpdate) {
	            if (!this.parent) {
	                this.parent = this._tempDisplayObjectParent;
	                this.updateTransform();
	                this.parent = null;
	            } else {
	                this._recursivePostUpdateTransform();
	                this.updateTransform();
	            }
	        }
	
	        if (this._boundsID !== this._lastBoundsID) {
	            this.calculateBounds();
	        }
	
	        if (!rect) {
	            if (!this._boundsRect) {
	                this._boundsRect = new _math.Rectangle();
	            }
	
	            rect = this._boundsRect;
	        }
	
	        return this._bounds.getRectangle(rect);
	    };
	
	    /**
	     * Retrieves the local bounds of the displayObject as a rectangle object
	     *
	     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation
	     * @return {PIXI.Rectangle} the rectangular bounding area
	     */
	
	
	    DisplayObject.prototype.getLocalBounds = function getLocalBounds(rect) {
	        var transformRef = this.transform;
	        var parentRef = this.parent;
	
	        this.parent = null;
	        this.transform = this._tempDisplayObjectParent.transform;
	
	        if (!rect) {
	            if (!this._localBoundsRect) {
	                this._localBoundsRect = new _math.Rectangle();
	            }
	
	            rect = this._localBoundsRect;
	        }
	
	        var bounds = this.getBounds(false, rect);
	
	        this.parent = parentRef;
	        this.transform = transformRef;
	
	        return bounds;
	    };
	
	    /**
	     * Calculates the global position of the display object
	     *
	     * @param {PIXI.Point} position - The world origin to calculate from
	     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
	     *  (otherwise will create a new Point)
	     * @param {boolean} [skipUpdate=false] - Should we skip the update transform.
	     * @return {PIXI.Point} A point object representing the position of this object
	     */
	
	
	    DisplayObject.prototype.toGlobal = function toGlobal(position, point) {
	        var skipUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        if (!skipUpdate) {
	            this._recursivePostUpdateTransform();
	
	            // this parent check is for just in case the item is a root object.
	            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
	            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
	            if (!this.parent) {
	                this.parent = this._tempDisplayObjectParent;
	                this.displayObjectUpdateTransform();
	                this.parent = null;
	            } else {
	                this.displayObjectUpdateTransform();
	            }
	        }
	
	        // don't need to update the lot
	        return this.worldTransform.apply(position, point);
	    };
	
	    /**
	     * Calculates the local position of the display object relative to another point
	     *
	     * @param {PIXI.Point} position - The world origin to calculate from
	     * @param {PIXI.DisplayObject} [from] - The DisplayObject to calculate the global position from
	     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
	     *  (otherwise will create a new Point)
	     * @param {boolean} [skipUpdate=false] - Should we skip the update transform
	     * @return {PIXI.Point} A point object representing the position of this object
	     */
	
	
	    DisplayObject.prototype.toLocal = function toLocal(position, from, point, skipUpdate) {
	        if (from) {
	            position = from.toGlobal(position, point, skipUpdate);
	        }
	
	        if (!skipUpdate) {
	            this._recursivePostUpdateTransform();
	
	            // this parent check is for just in case the item is a root object.
	            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
	            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
	            if (!this.parent) {
	                this.parent = this._tempDisplayObjectParent;
	                this.displayObjectUpdateTransform();
	                this.parent = null;
	            } else {
	                this.displayObjectUpdateTransform();
	            }
	        }
	
	        // simply apply the matrix..
	        return this.worldTransform.applyInverse(position, point);
	    };
	
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    DisplayObject.prototype.renderWebGL = function renderWebGL(renderer) // eslint-disable-line no-unused-vars
	    {}
	    // OVERWRITE;
	
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */
	    ;
	
	    DisplayObject.prototype.renderCanvas = function renderCanvas(renderer) // eslint-disable-line no-unused-vars
	    {}
	    // OVERWRITE;
	
	
	    /**
	     * Set the parent Container of this DisplayObject
	     *
	     * @param {PIXI.Container} container - The Container to add this DisplayObject to
	     * @return {PIXI.Container} The Container that this DisplayObject was added to
	     */
	    ;
	
	    DisplayObject.prototype.setParent = function setParent(container) {
	        if (!container || !container.addChild) {
	            throw new Error('setParent: Argument must be a Container');
	        }
	
	        container.addChild(this);
	
	        return container;
	    };
	
	    /**
	     * Convenience function to set the position, scale, skew and pivot at once.
	     *
	     * @param {number} [x=0] - The X position
	     * @param {number} [y=0] - The Y position
	     * @param {number} [scaleX=1] - The X scale value
	     * @param {number} [scaleY=1] - The Y scale value
	     * @param {number} [rotation=0] - The rotation
	     * @param {number} [skewX=0] - The X skew value
	     * @param {number} [skewY=0] - The Y skew value
	     * @param {number} [pivotX=0] - The X pivot value
	     * @param {number} [pivotY=0] - The Y pivot value
	     * @return {PIXI.DisplayObject} The DisplayObject instance
	     */
	
	
	    DisplayObject.prototype.setTransform = function setTransform() {
	        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var scaleX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	        var scaleY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	        var rotation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	        var skewX = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	        var skewY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	        var pivotX = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
	        var pivotY = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
	
	        this.position.x = x;
	        this.position.y = y;
	        this.scale.x = !scaleX ? 1 : scaleX;
	        this.scale.y = !scaleY ? 1 : scaleY;
	        this.rotation = rotation;
	        this.skew.x = skewX;
	        this.skew.y = skewY;
	        this.pivot.x = pivotX;
	        this.pivot.y = pivotY;
	
	        return this;
	    };
	
	    /**
	     * Base destroy method for generic display objects. This will automatically
	     * remove the display object from its parent Container as well as remove
	     * all current event listeners and internal references. Do not use a DisplayObject
	     * after calling `destroy`.
	     *
	     */
	
	
	    DisplayObject.prototype.destroy = function destroy() {
	        this.removeAllListeners();
	        if (this.parent) {
	            this.parent.removeChild(this);
	        }
	        this.transform = null;
	
	        this.parent = null;
	
	        this._bounds = null;
	        this._currentBounds = null;
	        this._mask = null;
	
	        this.filterArea = null;
	
	        this.interactive = false;
	        this.interactiveChildren = false;
	
	        this._destroyed = true;
	    };
	
	    /**
	     * The position of the displayObject on the x axis relative to the local coordinates of the parent.
	     * An alias to position.x
	     *
	     * @member {number}
	     */
	
	
	    _createClass(DisplayObject, [{
	        key: '_tempDisplayObjectParent',
	        get: function get() {
	            if (this.tempDisplayObjectParent === null) {
	                this.tempDisplayObjectParent = new DisplayObject();
	            }
	
	            return this.tempDisplayObjectParent;
	        }
	    }, {
	        key: 'x',
	        get: function get() {
	            return this.position.x;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.position.x = value;
	        }
	
	        /**
	         * The position of the displayObject on the y axis relative to the local coordinates of the parent.
	         * An alias to position.y
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'y',
	        get: function get() {
	            return this.position.y;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.position.y = value;
	        }
	
	        /**
	         * Current transform of the object based on world (parent) factors
	         *
	         * @member {PIXI.Matrix}
	         * @readonly
	         */
	
	    }, {
	        key: 'worldTransform',
	        get: function get() {
	            return this.transform.worldTransform;
	        }
	
	        /**
	         * Current transform of the object based on local factors: position, scale, other stuff
	         *
	         * @member {PIXI.Matrix}
	         * @readonly
	         */
	
	    }, {
	        key: 'localTransform',
	        get: function get() {
	            return this.transform.localTransform;
	        }
	
	        /**
	         * The coordinate of the object relative to the local coordinates of the parent.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.Point|PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'position',
	        get: function get() {
	            return this.transform.position;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.position.copy(value);
	        }
	
	        /**
	         * The scale factor of the object.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.Point|PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'scale',
	        get: function get() {
	            return this.transform.scale;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.scale.copy(value);
	        }
	
	        /**
	         * The pivot point of the displayObject that it rotates around
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.Point|PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'pivot',
	        get: function get() {
	            return this.transform.pivot;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.pivot.copy(value);
	        }
	
	        /**
	         * The skew factor for the object in radians.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'skew',
	        get: function get() {
	            return this.transform.skew;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.skew.copy(value);
	        }
	
	        /**
	         * The rotation of the object in radians.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'rotation',
	        get: function get() {
	            return this.transform.rotation;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.rotation = value;
	        }
	
	        /**
	         * Indicates if the object is globally visible.
	         *
	         * @member {boolean}
	         * @readonly
	         */
	
	    }, {
	        key: 'worldVisible',
	        get: function get() {
	            var item = this;
	
	            do {
	                if (!item.visible) {
	                    return false;
	                }
	
	                item = item.parent;
	            } while (item);
	
	            return true;
	        }
	
	        /**
	         * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
	         * object to the shape of the mask applied to it. In PIXI a regular mask must be a
	         * PIXI.Graphics or a PIXI.Sprite object. This allows for much faster masking in canvas as it
	         * utilises shape clipping. To remove a mask, set this property to null.
	         *
	         * @todo For the moment, PIXI.CanvasRenderer doesn't support PIXI.Sprite as mask.
	         *
	         * @member {PIXI.Graphics|PIXI.Sprite}
	         */
	
	    }, {
	        key: 'mask',
	        get: function get() {
	            return this._mask;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._mask) {
	                this._mask.renderable = true;
	                this._mask.isMask = false;
	            }
	
	            this._mask = value;
	
	            if (this._mask) {
	                this._mask.renderable = false;
	                this._mask.isMask = true;
	            }
	        }
	
	        /**
	         * Sets the filters for the displayObject.
	         * * IMPORTANT: This is a webGL only feature and will be ignored by the canvas renderer.
	         * To remove filters simply set this property to 'null'
	         *
	         * @member {PIXI.Filter[]}
	         */
	
	    }, {
	        key: 'filters',
	        get: function get() {
	            return this._filters && this._filters.slice();
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._filters = value && value.slice();
	        }
	    }]);
	
	    return DisplayObject;
	}(_eventemitter2.default);
	
	// performance increase to avoid using call.. (10x faster)
	
	
	exports.default = DisplayObject;
	DisplayObject.prototype.displayObjectUpdateTransform = DisplayObject.prototype.updateTransform;
	//# sourceMappingURL=DisplayObject.js.map

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @api private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {Mixed} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Boolean} exists Only check if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {Mixed} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	         listeners.fn === fn
	      && (!once || listeners.once)
	      && (!context || listeners.context === context)
	    ) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	           listeners[i].fn !== fn
	        || (once && !listeners[i].once)
	        || (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {String|Symbol} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _maxRecommendedTextures = __webpack_require__(237);
	
	var _maxRecommendedTextures2 = _interopRequireDefault(_maxRecommendedTextures);
	
	var _canUploadSameBuffer = __webpack_require__(239);
	
	var _canUploadSameBuffer2 = _interopRequireDefault(_canUploadSameBuffer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * User's customizable globals for overriding the default PIXI settings, such
	 * as a renderer's default resolution, framerate, float percision, etc.
	 * @example
	 * // Use the native window resolution as the default resolution
	 * // will support high-density displays when rendering
	 * PIXI.settings.RESOLUTION = window.devicePixelRatio.
	 *
	 * // Disable interpolation when scaling, will make texture be pixelated
	 * PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
	 * @namespace PIXI.settings
	 */
	exports.default = {
	
	  /**
	   * Target frames per millisecond.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 0.06
	   */
	  TARGET_FPMS: 0.06,
	
	  /**
	   * If set to true WebGL will attempt make textures mimpaped by default.
	   * Mipmapping will only succeed if the base texture uploaded has power of two dimensions.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {boolean}
	   * @default true
	   */
	  MIPMAP_TEXTURES: true,
	
	  /**
	   * Default resolution / device pixel ratio of the renderer.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 1
	   */
	  RESOLUTION: 1,
	
	  /**
	   * Default filter resolution.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 1
	   */
	  FILTER_RESOLUTION: 1,
	
	  /**
	   * The maximum textures that this device supports.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 32
	   */
	  SPRITE_MAX_TEXTURES: (0, _maxRecommendedTextures2.default)(32),
	
	  // TODO: maybe change to SPRITE.BATCH_SIZE: 2000
	  // TODO: maybe add PARTICLE.BATCH_SIZE: 15000
	
	  /**
	   * The default sprite batch size.
	   *
	   * The default aims to balance desktop and mobile devices.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 4096
	   */
	  SPRITE_BATCH_SIZE: 4096,
	
	  /**
	   * The prefix that denotes a URL is for a retina asset.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {RegExp}
	   * @example `@2x`
	   * @default /@([0-9\.]+)x/
	   */
	  RETINA_PREFIX: /@([0-9\.]+)x/,
	
	  /**
	   * The default render options if none are supplied to {@link PIXI.WebGLRenderer}
	   * or {@link PIXI.CanvasRenderer}.
	   *
	   * @static
	   * @constant
	   * @memberof PIXI.settings
	   * @type {object}
	   * @property {HTMLCanvasElement} view=null
	   * @property {number} resolution=1
	   * @property {boolean} antialias=false
	   * @property {boolean} forceFXAA=false
	   * @property {boolean} autoResize=false
	   * @property {boolean} transparent=false
	   * @property {number} backgroundColor=0x000000
	   * @property {boolean} clearBeforeRender=true
	   * @property {boolean} preserveDrawingBuffer=false
	   * @property {boolean} roundPixels=false
	   * @property {number} width=800
	   * @property {number} height=600
	   * @property {boolean} legacy=false
	   */
	  RENDER_OPTIONS: {
	    view: null,
	    antialias: false,
	    forceFXAA: false,
	    autoResize: false,
	    transparent: false,
	    backgroundColor: 0x000000,
	    clearBeforeRender: true,
	    preserveDrawingBuffer: false,
	    roundPixels: false,
	    width: 800,
	    height: 600,
	    legacy: false
	  },
	
	  /**
	   * Default transform type.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.TRANSFORM_MODE}
	   * @default PIXI.TRANSFORM_MODE.STATIC
	   */
	  TRANSFORM_MODE: 0,
	
	  /**
	   * Default Garbage Collection mode.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.GC_MODES}
	   * @default PIXI.GC_MODES.AUTO
	   */
	  GC_MODE: 0,
	
	  /**
	   * Default Garbage Collection max idle.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 3600
	   */
	  GC_MAX_IDLE: 60 * 60,
	
	  /**
	   * Default Garbage Collection maximum check count.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 600
	   */
	  GC_MAX_CHECK_COUNT: 60 * 10,
	
	  /**
	   * Default wrap modes that are supported by pixi.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.WRAP_MODES}
	   * @default PIXI.WRAP_MODES.CLAMP
	   */
	  WRAP_MODE: 0,
	
	  /**
	   * The scale modes that are supported by pixi.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.SCALE_MODES}
	   * @default PIXI.SCALE_MODES.LINEAR
	   */
	  SCALE_MODE: 0,
	
	  /**
	   * Default specify float precision in vertex shader.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.PRECISION}
	   * @default PIXI.PRECISION.HIGH
	   */
	  PRECISION_VERTEX: 'highp',
	
	  /**
	   * Default specify float precision in fragment shader.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.PRECISION}
	   * @default PIXI.PRECISION.MEDIUM
	   */
	  PRECISION_FRAGMENT: 'mediump',
	
	  /**
	   * Can we upload the same buffer in a single frame?
	   *
	   * @static
	   * @constant
	   * @memberof PIXI.settings
	   * @type {boolean}
	   */
	  CAN_UPLOAD_SAME_BUFFER: (0, _canUploadSameBuffer2.default)(),
	
	  /**
	   * Default Mesh `canvasPadding`.
	   *
	   * @see PIXI.mesh.Mesh#canvasPadding
	   * @static
	   * @constant
	   * @memberof PIXI.settings
	   * @type {number}
	   */
	  MESH_CANVAS_PADDING: 0
	};
	//# sourceMappingURL=settings.js.map

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = maxRecommendedTextures;
	
	var _ismobilejs = __webpack_require__(238);
	
	var _ismobilejs2 = _interopRequireDefault(_ismobilejs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function maxRecommendedTextures(max) {
	    if (_ismobilejs2.default.tablet || _ismobilejs2.default.phone) {
	        // check if the res is iphone 6 or higher..
	        return 4;
	    }
	
	    // desktop should be ok
	    return max;
	}
	//# sourceMappingURL=maxRecommendedTextures.js.map

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * isMobile.js v0.4.1
	 *
	 * A simple library to detect Apple phones and tablets,
	 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
	 * and any kind of seven inch device, via user agent sniffing.
	 *
	 * @author: Kai Mallea (kmallea@gmail.com)
	 *
	 * @license: http://creativecommons.org/publicdomain/zero/1.0/
	 */
	(function (global) {
	
	    var apple_phone         = /iPhone/i,
	        apple_ipod          = /iPod/i,
	        apple_tablet        = /iPad/i,
	        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
	        android_tablet      = /Android/i,
	        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
	        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
	        windows_phone       = /Windows Phone/i,
	        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
	        other_blackberry    = /BlackBerry/i,
	        other_blackberry_10 = /BB10/i,
	        other_opera         = /Opera Mini/i,
	        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
	        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
	        seven_inch = new RegExp(
	            '(?:' +         // Non-capturing group
	
	            'Nexus 7' +     // Nexus 7
	
	            '|' +           // OR
	
	            'BNTV250' +     // B&N Nook Tablet 7 inch
	
	            '|' +           // OR
	
	            'Kindle Fire' + // Kindle Fire
	
	            '|' +           // OR
	
	            'Silk' +        // Kindle Fire, Silk Accelerated
	
	            '|' +           // OR
	
	            'GT-P1000' +    // Galaxy Tab 7 inch
	
	            ')',            // End non-capturing group
	
	            'i');           // Case-insensitive matching
	
	    var match = function(regex, userAgent) {
	        return regex.test(userAgent);
	    };
	
	    var IsMobileClass = function(userAgent) {
	        var ua = userAgent || navigator.userAgent;
	
	        // Facebook mobile app's integrated browser adds a bunch of strings that
	        // match everything. Strip it out if it exists.
	        var tmp = ua.split('[FBAN');
	        if (typeof tmp[1] !== 'undefined') {
	            ua = tmp[0];
	        }
	
	        // Twitter mobile app's integrated browser on iPad adds a "Twitter for
	        // iPhone" string. Same probable happens on other tablet platforms.
	        // This will confuse detection so strip it out if it exists.
	        tmp = ua.split('Twitter');
	        if (typeof tmp[1] !== 'undefined') {
	            ua = tmp[0];
	        }
	
	        this.apple = {
	            phone:  match(apple_phone, ua),
	            ipod:   match(apple_ipod, ua),
	            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
	            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
	        };
	        this.amazon = {
	            phone:  match(amazon_phone, ua),
	            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
	            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
	        };
	        this.android = {
	            phone:  match(amazon_phone, ua) || match(android_phone, ua),
	            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
	            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
	        };
	        this.windows = {
	            phone:  match(windows_phone, ua),
	            tablet: match(windows_tablet, ua),
	            device: match(windows_phone, ua) || match(windows_tablet, ua)
	        };
	        this.other = {
	            blackberry:   match(other_blackberry, ua),
	            blackberry10: match(other_blackberry_10, ua),
	            opera:        match(other_opera, ua),
	            firefox:      match(other_firefox, ua),
	            chrome:       match(other_chrome, ua),
	            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
	        };
	        this.seven_inch = match(seven_inch, ua);
	        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;
	
	        // excludes 'other' devices and ipods, targeting touchscreen phones
	        this.phone = this.apple.phone || this.android.phone || this.windows.phone;
	
	        // excludes 7 inch devices, classifying as phone or tablet is left to the user
	        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;
	
	        if (typeof window === 'undefined') {
	            return this;
	        }
	    };
	
	    var instantiate = function() {
	        var IM = new IsMobileClass();
	        IM.Class = IsMobileClass;
	        return IM;
	    };
	
	    if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
	        //node
	        module.exports = IsMobileClass;
	    } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
	        //browserify
	        module.exports = instantiate();
	    } else if (true) {
	        //AMD
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (global.isMobile = instantiate()), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        global.isMobile = instantiate();
	    }
	
	})(this);


/***/ }),
/* 239 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = canUploadSameBuffer;
	function canUploadSameBuffer() {
		// Uploading the same buffer multiple times in a single frame can cause perf issues.
		// Apparent on IOS so only check for that at the moment
		// this check may become more complex if this issue pops up elsewhere.
		var ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
	
		return !ios;
	}
	//# sourceMappingURL=canUploadSameBuffer.js.map

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _math = __webpack_require__(206);
	
	var _TransformBase2 = __webpack_require__(241);
	
	var _TransformBase3 = _interopRequireDefault(_TransformBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Transform that takes care about its versions
	 *
	 * @class
	 * @extends PIXI.TransformBase
	 * @memberof PIXI
	 */
	var TransformStatic = function (_TransformBase) {
	    _inherits(TransformStatic, _TransformBase);
	
	    /**
	     *
	     */
	    function TransformStatic() {
	        _classCallCheck(this, TransformStatic);
	
	        /**
	        * The coordinate of the object relative to the local coordinates of the parent.
	        *
	        * @member {PIXI.ObservablePoint}
	        */
	        var _this = _possibleConstructorReturn(this, _TransformBase.call(this));
	
	        _this.position = new _math.ObservablePoint(_this.onChange, _this, 0, 0);
	
	        /**
	         * The scale factor of the object.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        _this.scale = new _math.ObservablePoint(_this.onChange, _this, 1, 1);
	
	        /**
	         * The pivot point of the displayObject that it rotates around
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        _this.pivot = new _math.ObservablePoint(_this.onChange, _this, 0, 0);
	
	        /**
	         * The skew amount, on the x and y axis.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        _this.skew = new _math.ObservablePoint(_this.updateSkew, _this, 0, 0);
	
	        _this._rotation = 0;
	
	        _this._cx = 1; // cos rotation + skewY;
	        _this._sx = 0; // sin rotation + skewY;
	        _this._cy = 0; // cos rotation + Math.PI/2 - skewX;
	        _this._sy = 1; // sin rotation + Math.PI/2 - skewX;
	
	        _this._localID = 0;
	        _this._currentLocalID = 0;
	        return _this;
	    }
	
	    /**
	     * Called when a value changes.
	     *
	     * @private
	     */
	
	
	    TransformStatic.prototype.onChange = function onChange() {
	        this._localID++;
	    };
	
	    /**
	     * Called when skew or rotation changes
	     *
	     * @private
	     */
	
	
	    TransformStatic.prototype.updateSkew = function updateSkew() {
	        this._cx = Math.cos(this._rotation + this.skew._y);
	        this._sx = Math.sin(this._rotation + this.skew._y);
	        this._cy = -Math.sin(this._rotation - this.skew._x); // cos, added PI/2
	        this._sy = Math.cos(this._rotation - this.skew._x); // sin, added PI/2
	
	        this._localID++;
	    };
	
	    /**
	     * Updates only local matrix
	     */
	
	
	    TransformStatic.prototype.updateLocalTransform = function updateLocalTransform() {
	        var lt = this.localTransform;
	
	        if (this._localID !== this._currentLocalID) {
	            // get the matrix values of the displayobject based on its transform properties..
	            lt.a = this._cx * this.scale._x;
	            lt.b = this._sx * this.scale._x;
	            lt.c = this._cy * this.scale._y;
	            lt.d = this._sy * this.scale._y;
	
	            lt.tx = this.position._x - (this.pivot._x * lt.a + this.pivot._y * lt.c);
	            lt.ty = this.position._y - (this.pivot._x * lt.b + this.pivot._y * lt.d);
	            this._currentLocalID = this._localID;
	
	            // force an update..
	            this._parentID = -1;
	        }
	    };
	
	    /**
	     * Updates the values of the object and applies the parent's transform.
	     *
	     * @param {PIXI.Transform} parentTransform - The transform of the parent of this object
	     */
	
	
	    TransformStatic.prototype.updateTransform = function updateTransform(parentTransform) {
	        var lt = this.localTransform;
	
	        if (this._localID !== this._currentLocalID) {
	            // get the matrix values of the displayobject based on its transform properties..
	            lt.a = this._cx * this.scale._x;
	            lt.b = this._sx * this.scale._x;
	            lt.c = this._cy * this.scale._y;
	            lt.d = this._sy * this.scale._y;
	
	            lt.tx = this.position._x - (this.pivot._x * lt.a + this.pivot._y * lt.c);
	            lt.ty = this.position._y - (this.pivot._x * lt.b + this.pivot._y * lt.d);
	            this._currentLocalID = this._localID;
	
	            // force an update..
	            this._parentID = -1;
	        }
	
	        if (this._parentID !== parentTransform._worldID) {
	            // concat the parent matrix with the objects transform.
	            var pt = parentTransform.worldTransform;
	            var wt = this.worldTransform;
	
	            wt.a = lt.a * pt.a + lt.b * pt.c;
	            wt.b = lt.a * pt.b + lt.b * pt.d;
	            wt.c = lt.c * pt.a + lt.d * pt.c;
	            wt.d = lt.c * pt.b + lt.d * pt.d;
	            wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
	            wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;
	
	            this._parentID = parentTransform._worldID;
	
	            // update the id of the transform..
	            this._worldID++;
	        }
	    };
	
	    /**
	     * Decomposes a matrix and sets the transforms properties based on it.
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to decompose
	     */
	
	
	    TransformStatic.prototype.setFromMatrix = function setFromMatrix(matrix) {
	        matrix.decompose(this);
	        this._localID++;
	    };
	
	    /**
	     * The rotation of the object in radians.
	     *
	     * @member {number}
	     */
	
	
	    _createClass(TransformStatic, [{
	        key: 'rotation',
	        get: function get() {
	            return this._rotation;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._rotation = value;
	            this.updateSkew();
	        }
	    }]);
	
	    return TransformStatic;
	}(_TransformBase3.default);
	
	exports.default = TransformStatic;
	//# sourceMappingURL=TransformStatic.js.map

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _math = __webpack_require__(206);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Generic class to deal with traditional 2D matrix transforms
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TransformBase = function () {
	  /**
	   *
	   */
	  function TransformBase() {
	    _classCallCheck(this, TransformBase);
	
	    /**
	     * The global matrix transform. It can be swapped temporarily by some functions like getLocalBounds()
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.worldTransform = new _math.Matrix();
	
	    /**
	     * The local matrix transform
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.localTransform = new _math.Matrix();
	
	    this._worldID = 0;
	    this._parentID = 0;
	  }
	
	  /**
	   * TransformBase does not have decomposition, so this function wont do anything
	   */
	
	
	  TransformBase.prototype.updateLocalTransform = function updateLocalTransform() {}
	  // empty
	
	
	  /**
	   * Updates the values of the object and applies the parent's transform.
	   *
	   * @param {PIXI.TransformBase} parentTransform - The transform of the parent of this object
	   */
	  ;
	
	  TransformBase.prototype.updateTransform = function updateTransform(parentTransform) {
	    var pt = parentTransform.worldTransform;
	    var wt = this.worldTransform;
	    var lt = this.localTransform;
	
	    // concat the parent matrix with the objects transform.
	    wt.a = lt.a * pt.a + lt.b * pt.c;
	    wt.b = lt.a * pt.b + lt.b * pt.d;
	    wt.c = lt.c * pt.a + lt.d * pt.c;
	    wt.d = lt.c * pt.b + lt.d * pt.d;
	    wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
	    wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;
	
	    this._worldID++;
	  };
	
	  return TransformBase;
	}();
	
	/**
	 * Updates the values of the object and applies the parent's transform.
	 * @param  parentTransform {PIXI.Transform} The transform of the parent of this object
	 *
	 */
	
	
	exports.default = TransformBase;
	TransformBase.prototype.updateWorldTransform = TransformBase.prototype.updateTransform;
	
	TransformBase.IDENTITY = new TransformBase();
	//# sourceMappingURL=TransformBase.js.map

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _math = __webpack_require__(206);
	
	var _TransformBase2 = __webpack_require__(241);
	
	var _TransformBase3 = _interopRequireDefault(_TransformBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Generic class to deal with traditional 2D matrix transforms
	 * local transformation is calculated from position,scale,skew and rotation
	 *
	 * @class
	 * @extends PIXI.TransformBase
	 * @memberof PIXI
	 */
	var Transform = function (_TransformBase) {
	  _inherits(Transform, _TransformBase);
	
	  /**
	   *
	   */
	  function Transform() {
	    _classCallCheck(this, Transform);
	
	    /**
	    * The coordinate of the object relative to the local coordinates of the parent.
	    *
	    * @member {PIXI.Point}
	    */
	    var _this = _possibleConstructorReturn(this, _TransformBase.call(this));
	
	    _this.position = new _math.Point(0, 0);
	
	    /**
	     * The scale factor of the object.
	     *
	     * @member {PIXI.Point}
	     */
	    _this.scale = new _math.Point(1, 1);
	
	    /**
	     * The skew amount, on the x and y axis.
	     *
	     * @member {PIXI.ObservablePoint}
	     */
	    _this.skew = new _math.ObservablePoint(_this.updateSkew, _this, 0, 0);
	
	    /**
	     * The pivot point of the displayObject that it rotates around
	     *
	     * @member {PIXI.Point}
	     */
	    _this.pivot = new _math.Point(0, 0);
	
	    /**
	     * The rotation value of the object, in radians
	     *
	     * @member {Number}
	     * @private
	     */
	    _this._rotation = 0;
	
	    _this._cx = 1; // cos rotation + skewY;
	    _this._sx = 0; // sin rotation + skewY;
	    _this._cy = 0; // cos rotation + Math.PI/2 - skewX;
	    _this._sy = 1; // sin rotation + Math.PI/2 - skewX;
	    return _this;
	  }
	
	  /**
	   * Updates the skew values when the skew or rotation changes.
	   *
	   * @private
	   */
	
	
	  Transform.prototype.updateSkew = function updateSkew() {
	    this._cx = Math.cos(this._rotation + this.skew._y);
	    this._sx = Math.sin(this._rotation + this.skew._y);
	    this._cy = -Math.sin(this._rotation - this.skew._x); // cos, added PI/2
	    this._sy = Math.cos(this._rotation - this.skew._x); // sin, added PI/2
	  };
	
	  /**
	   * Updates only local matrix
	   */
	
	
	  Transform.prototype.updateLocalTransform = function updateLocalTransform() {
	    var lt = this.localTransform;
	
	    lt.a = this._cx * this.scale.x;
	    lt.b = this._sx * this.scale.x;
	    lt.c = this._cy * this.scale.y;
	    lt.d = this._sy * this.scale.y;
	
	    lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
	    lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
	  };
	
	  /**
	   * Updates the values of the object and applies the parent's transform.
	   *
	   * @param {PIXI.Transform} parentTransform - The transform of the parent of this object
	   */
	
	
	  Transform.prototype.updateTransform = function updateTransform(parentTransform) {
	    var lt = this.localTransform;
	
	    lt.a = this._cx * this.scale.x;
	    lt.b = this._sx * this.scale.x;
	    lt.c = this._cy * this.scale.y;
	    lt.d = this._sy * this.scale.y;
	
	    lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
	    lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
	
	    // concat the parent matrix with the objects transform.
	    var pt = parentTransform.worldTransform;
	    var wt = this.worldTransform;
	
	    wt.a = lt.a * pt.a + lt.b * pt.c;
	    wt.b = lt.a * pt.b + lt.b * pt.d;
	    wt.c = lt.c * pt.a + lt.d * pt.c;
	    wt.d = lt.c * pt.b + lt.d * pt.d;
	    wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
	    wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;
	
	    this._worldID++;
	  };
	
	  /**
	   * Decomposes a matrix and sets the transforms properties based on it.
	   *
	   * @param {PIXI.Matrix} matrix - The matrix to decompose
	   */
	
	
	  Transform.prototype.setFromMatrix = function setFromMatrix(matrix) {
	    matrix.decompose(this);
	  };
	
	  /**
	   * The rotation of the object in radians.
	   *
	   * @member {number}
	   */
	
	
	  _createClass(Transform, [{
	    key: 'rotation',
	    get: function get() {
	      return this._rotation;
	    },
	    set: function set(value) // eslint-disable-line require-jsdoc
	    {
	      this._rotation = value;
	      this.updateSkew();
	    }
	  }]);
	
	  return Transform;
	}(_TransformBase3.default);
	
	exports.default = Transform;
	//# sourceMappingURL=Transform.js.map

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(244);
	
	var _DisplayObject2 = __webpack_require__(234);
	
	var _DisplayObject3 = _interopRequireDefault(_DisplayObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A Container represents a collection of display objects.
	 * It is the base class of all display objects that act as a container for other objects.
	 *
	 *```js
	 * let container = new PIXI.Container();
	 * container.addChild(sprite);
	 * ```
	 *
	 * @class
	 * @extends PIXI.DisplayObject
	 * @memberof PIXI
	 */
	var Container = function (_DisplayObject) {
	    _inherits(Container, _DisplayObject);
	
	    /**
	     *
	     */
	    function Container() {
	        _classCallCheck(this, Container);
	
	        /**
	         * The array of children of this container.
	         *
	         * @member {PIXI.DisplayObject[]}
	         * @readonly
	         */
	        var _this = _possibleConstructorReturn(this, _DisplayObject.call(this));
	
	        _this.children = [];
	        return _this;
	    }
	
	    /**
	     * Overridable method that can be used by Container subclasses whenever the children array is modified
	     *
	     * @private
	     */
	
	
	    Container.prototype.onChildrenChange = function onChildrenChange() {}
	    /* empty */
	
	
	    /**
	     * Adds one or more children to the container.
	     *
	     * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
	     *
	     * @param {...PIXI.DisplayObject} child - The DisplayObject(s) to add to the container
	     * @return {PIXI.DisplayObject} The first child that was added.
	     */
	    ;
	
	    Container.prototype.addChild = function addChild(child) {
	        var argumentsLength = arguments.length;
	
	        // if there is only one argument we can bypass looping through the them
	        if (argumentsLength > 1) {
	            // loop through the arguments property and add all children
	            // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
	            for (var i = 0; i < argumentsLength; i++) {
	                this.addChild(arguments[i]);
	            }
	        } else {
	            // if the child has a parent then lets remove it as PixiJS objects can only exist in one place
	            if (child.parent) {
	                child.parent.removeChild(child);
	            }
	
	            child.parent = this;
	            // ensure child transform will be recalculated
	            child.transform._parentID = -1;
	
	            this.children.push(child);
	
	            // ensure bounds will be recalculated
	            this._boundsID++;
	
	            // TODO - lets either do all callbacks or all events.. not both!
	            this.onChildrenChange(this.children.length - 1);
	            child.emit('added', this);
	        }
	
	        return child;
	    };
	
	    /**
	     * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown
	     *
	     * @param {PIXI.DisplayObject} child - The child to add
	     * @param {number} index - The index to place the child in
	     * @return {PIXI.DisplayObject} The child that was added.
	     */
	
	
	    Container.prototype.addChildAt = function addChildAt(child, index) {
	        if (index < 0 || index > this.children.length) {
	            throw new Error(child + 'addChildAt: The index ' + index + ' supplied is out of bounds ' + this.children.length);
	        }
	
	        if (child.parent) {
	            child.parent.removeChild(child);
	        }
	
	        child.parent = this;
	        // ensure child transform will be recalculated
	        child.transform._parentID = -1;
	
	        this.children.splice(index, 0, child);
	
	        // ensure bounds will be recalculated
	        this._boundsID++;
	
	        // TODO - lets either do all callbacks or all events.. not both!
	        this.onChildrenChange(index);
	        child.emit('added', this);
	
	        return child;
	    };
	
	    /**
	     * Swaps the position of 2 Display Objects within this container.
	     *
	     * @param {PIXI.DisplayObject} child - First display object to swap
	     * @param {PIXI.DisplayObject} child2 - Second display object to swap
	     */
	
	
	    Container.prototype.swapChildren = function swapChildren(child, child2) {
	        if (child === child2) {
	            return;
	        }
	
	        var index1 = this.getChildIndex(child);
	        var index2 = this.getChildIndex(child2);
	
	        this.children[index1] = child2;
	        this.children[index2] = child;
	        this.onChildrenChange(index1 < index2 ? index1 : index2);
	    };
	
	    /**
	     * Returns the index position of a child DisplayObject instance
	     *
	     * @param {PIXI.DisplayObject} child - The DisplayObject instance to identify
	     * @return {number} The index position of the child display object to identify
	     */
	
	
	    Container.prototype.getChildIndex = function getChildIndex(child) {
	        var index = this.children.indexOf(child);
	
	        if (index === -1) {
	            throw new Error('The supplied DisplayObject must be a child of the caller');
	        }
	
	        return index;
	    };
	
	    /**
	     * Changes the position of an existing child in the display object container
	     *
	     * @param {PIXI.DisplayObject} child - The child DisplayObject instance for which you want to change the index number
	     * @param {number} index - The resulting index number for the child display object
	     */
	
	
	    Container.prototype.setChildIndex = function setChildIndex(child, index) {
	        if (index < 0 || index >= this.children.length) {
	            throw new Error('The index ' + index + ' supplied is out of bounds ' + this.children.length);
	        }
	
	        var currentIndex = this.getChildIndex(child);
	
	        (0, _utils.removeItems)(this.children, currentIndex, 1); // remove from old position
	        this.children.splice(index, 0, child); // add at new position
	
	        this.onChildrenChange(index);
	    };
	
	    /**
	     * Returns the child at the specified index
	     *
	     * @param {number} index - The index to get the child at
	     * @return {PIXI.DisplayObject} The child at the given index, if any.
	     */
	
	
	    Container.prototype.getChildAt = function getChildAt(index) {
	        if (index < 0 || index >= this.children.length) {
	            throw new Error('getChildAt: Index (' + index + ') does not exist.');
	        }
	
	        return this.children[index];
	    };
	
	    /**
	     * Removes one or more children from the container.
	     *
	     * @param {...PIXI.DisplayObject} child - The DisplayObject(s) to remove
	     * @return {PIXI.DisplayObject} The first child that was removed.
	     */
	
	
	    Container.prototype.removeChild = function removeChild(child) {
	        var argumentsLength = arguments.length;
	
	        // if there is only one argument we can bypass looping through the them
	        if (argumentsLength > 1) {
	            // loop through the arguments property and add all children
	            // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
	            for (var i = 0; i < argumentsLength; i++) {
	                this.removeChild(arguments[i]);
	            }
	        } else {
	            var index = this.children.indexOf(child);
	
	            if (index === -1) return null;
	
	            child.parent = null;
	            // ensure child transform will be recalculated
	            child.transform._parentID = -1;
	            (0, _utils.removeItems)(this.children, index, 1);
	
	            // ensure bounds will be recalculated
	            this._boundsID++;
	
	            // TODO - lets either do all callbacks or all events.. not both!
	            this.onChildrenChange(index);
	            child.emit('removed', this);
	        }
	
	        return child;
	    };
	
	    /**
	     * Removes a child from the specified index position.
	     *
	     * @param {number} index - The index to get the child from
	     * @return {PIXI.DisplayObject} The child that was removed.
	     */
	
	
	    Container.prototype.removeChildAt = function removeChildAt(index) {
	        var child = this.getChildAt(index);
	
	        // ensure child transform will be recalculated..
	        child.parent = null;
	        child.transform._parentID = -1;
	        (0, _utils.removeItems)(this.children, index, 1);
	
	        // ensure bounds will be recalculated
	        this._boundsID++;
	
	        // TODO - lets either do all callbacks or all events.. not both!
	        this.onChildrenChange(index);
	        child.emit('removed', this);
	
	        return child;
	    };
	
	    /**
	     * Removes all children from this container that are within the begin and end indexes.
	     *
	     * @param {number} [beginIndex=0] - The beginning position.
	     * @param {number} [endIndex=this.children.length] - The ending position. Default value is size of the container.
	     * @returns {DisplayObject[]} List of removed children
	     */
	
	
	    Container.prototype.removeChildren = function removeChildren() {
	        var beginIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var endIndex = arguments[1];
	
	        var begin = beginIndex;
	        var end = typeof endIndex === 'number' ? endIndex : this.children.length;
	        var range = end - begin;
	        var removed = void 0;
	
	        if (range > 0 && range <= end) {
	            removed = this.children.splice(begin, range);
	
	            for (var i = 0; i < removed.length; ++i) {
	                removed[i].parent = null;
	                if (removed[i].transform) {
	                    removed[i].transform._parentID = -1;
	                }
	            }
	
	            this._boundsID++;
	
	            this.onChildrenChange(beginIndex);
	
	            for (var _i = 0; _i < removed.length; ++_i) {
	                removed[_i].emit('removed', this);
	            }
	
	            return removed;
	        } else if (range === 0 && this.children.length === 0) {
	            return [];
	        }
	
	        throw new RangeError('removeChildren: numeric values are outside the acceptable range.');
	    };
	
	    /**
	     * Updates the transform on all children of this container for rendering
	     */
	
	
	    Container.prototype.updateTransform = function updateTransform() {
	        this._boundsID++;
	
	        this.transform.updateTransform(this.parent.transform);
	
	        // TODO: check render flags, how to process stuff here
	        this.worldAlpha = this.alpha * this.parent.worldAlpha;
	
	        for (var i = 0, j = this.children.length; i < j; ++i) {
	            var child = this.children[i];
	
	            if (child.visible) {
	                child.updateTransform();
	            }
	        }
	    };
	
	    /**
	     * Recalculates the bounds of the container.
	     *
	     */
	
	
	    Container.prototype.calculateBounds = function calculateBounds() {
	        this._bounds.clear();
	
	        this._calculateBounds();
	
	        for (var i = 0; i < this.children.length; i++) {
	            var child = this.children[i];
	
	            if (!child.visible || !child.renderable) {
	                continue;
	            }
	
	            child.calculateBounds();
	
	            // TODO: filter+mask, need to mask both somehow
	            if (child._mask) {
	                child._mask.calculateBounds();
	                this._bounds.addBoundsMask(child._bounds, child._mask._bounds);
	            } else if (child.filterArea) {
	                this._bounds.addBoundsArea(child._bounds, child.filterArea);
	            } else {
	                this._bounds.addBounds(child._bounds);
	            }
	        }
	
	        this._lastBoundsID = this._boundsID;
	    };
	
	    /**
	     * Recalculates the bounds of the object. Override this to
	     * calculate the bounds of the specific object (not including children).
	     *
	     */
	
	
	    Container.prototype._calculateBounds = function _calculateBounds() {}
	    // FILL IN//
	
	
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	    ;
	
	    Container.prototype.renderWebGL = function renderWebGL(renderer) {
	        // if the object is not visible or the alpha is 0 then no need to render this element
	        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	            return;
	        }
	
	        // do a quick check to see if this element has a mask or a filter.
	        if (this._mask || this._filters) {
	            this.renderAdvancedWebGL(renderer);
	        } else {
	            this._renderWebGL(renderer);
	
	            // simple render children!
	            for (var i = 0, j = this.children.length; i < j; ++i) {
	                this.children[i].renderWebGL(renderer);
	            }
	        }
	    };
	
	    /**
	     * Render the object using the WebGL renderer and advanced features.
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    Container.prototype.renderAdvancedWebGL = function renderAdvancedWebGL(renderer) {
	        renderer.flush();
	
	        var filters = this._filters;
	        var mask = this._mask;
	
	        // push filter first as we need to ensure the stencil buffer is correct for any masking
	        if (filters) {
	            if (!this._enabledFilters) {
	                this._enabledFilters = [];
	            }
	
	            this._enabledFilters.length = 0;
	
	            for (var i = 0; i < filters.length; i++) {
	                if (filters[i].enabled) {
	                    this._enabledFilters.push(filters[i]);
	                }
	            }
	
	            if (this._enabledFilters.length) {
	                renderer.filterManager.pushFilter(this, this._enabledFilters);
	            }
	        }
	
	        if (mask) {
	            renderer.maskManager.pushMask(this, this._mask);
	        }
	
	        // add this object to the batch, only rendered if it has a texture.
	        this._renderWebGL(renderer);
	
	        // now loop through the children and make sure they get rendered
	        for (var _i2 = 0, j = this.children.length; _i2 < j; _i2++) {
	            this.children[_i2].renderWebGL(renderer);
	        }
	
	        renderer.flush();
	
	        if (mask) {
	            renderer.maskManager.popMask(this, this._mask);
	        }
	
	        if (filters && this._enabledFilters && this._enabledFilters.length) {
	            renderer.filterManager.popFilter();
	        }
	    };
	
	    /**
	     * To be overridden by the subclasses.
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    Container.prototype._renderWebGL = function _renderWebGL(renderer) // eslint-disable-line no-unused-vars
	    {}
	    // this is where content itself gets rendered...
	
	
	    /**
	     * To be overridden by the subclass
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */
	    ;
	
	    Container.prototype._renderCanvas = function _renderCanvas(renderer) // eslint-disable-line no-unused-vars
	    {}
	    // this is where content itself gets rendered...
	
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */
	    ;
	
	    Container.prototype.renderCanvas = function renderCanvas(renderer) {
	        // if not visible or the alpha is 0 then no need to render this
	        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	            return;
	        }
	
	        if (this._mask) {
	            renderer.maskManager.pushMask(this._mask);
	        }
	
	        this._renderCanvas(renderer);
	        for (var i = 0, j = this.children.length; i < j; ++i) {
	            this.children[i].renderCanvas(renderer);
	        }
	
	        if (this._mask) {
	            renderer.maskManager.popMask(renderer);
	        }
	    };
	
	    /**
	     * Removes all internal references and listeners as well as removes children from the display list.
	     * Do not use a Container after calling `destroy`.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *  method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */
	
	
	    Container.prototype.destroy = function destroy(options) {
	        _DisplayObject.prototype.destroy.call(this);
	
	        var destroyChildren = typeof options === 'boolean' ? options : options && options.children;
	
	        var oldChildren = this.removeChildren(0, this.children.length);
	
	        if (destroyChildren) {
	            for (var i = 0; i < oldChildren.length; ++i) {
	                oldChildren[i].destroy(options);
	            }
	        }
	    };
	
	    /**
	     * The width of the Container, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     */
	
	
	    _createClass(Container, [{
	        key: 'width',
	        get: function get() {
	            return this.scale.x * this.getLocalBounds().width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            var width = this.getLocalBounds().width;
	
	            if (width !== 0) {
	                this.scale.x = value / width;
	            } else {
	                this.scale.x = 1;
	            }
	
	            this._width = value;
	        }
	
	        /**
	         * The height of the Container, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'height',
	        get: function get() {
	            return this.scale.y * this.getLocalBounds().height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            var height = this.getLocalBounds().height;
	
	            if (height !== 0) {
	                this.scale.y = value / height;
	            } else {
	                this.scale.y = 1;
	            }
	
	            this._height = value;
	        }
	    }]);
	
	    return Container;
	}(_DisplayObject3.default);
	
	// performance increase to avoid using call.. (10x faster)
	
	
	exports.default = Container;
	Container.prototype.containerUpdateTransform = Container.prototype.updateTransform;
	//# sourceMappingURL=Container.js.map

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.premultiplyBlendMode = exports.BaseTextureCache = exports.TextureCache = exports.earcut = exports.mixins = exports.pluginTarget = exports.EventEmitter = exports.removeItems = exports.isMobile = undefined;
	exports.uid = uid;
	exports.hex2rgb = hex2rgb;
	exports.hex2string = hex2string;
	exports.rgb2hex = rgb2hex;
	exports.getResolutionOfUrl = getResolutionOfUrl;
	exports.decomposeDataUri = decomposeDataUri;
	exports.getUrlFileExtension = getUrlFileExtension;
	exports.getSvgSize = getSvgSize;
	exports.skipHello = skipHello;
	exports.sayHello = sayHello;
	exports.isWebGLSupported = isWebGLSupported;
	exports.sign = sign;
	exports.destroyTextureCache = destroyTextureCache;
	exports.clearTextureCache = clearTextureCache;
	exports.correctBlendMode = correctBlendMode;
	exports.premultiplyTint = premultiplyTint;
	exports.premultiplyRgba = premultiplyRgba;
	exports.premultiplyTintToRgba = premultiplyTintToRgba;
	
	var _const = __webpack_require__(205);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _eventemitter = __webpack_require__(235);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _pluginTarget = __webpack_require__(245);
	
	var _pluginTarget2 = _interopRequireDefault(_pluginTarget);
	
	var _mixin = __webpack_require__(246);
	
	var mixins = _interopRequireWildcard(_mixin);
	
	var _ismobilejs = __webpack_require__(238);
	
	var isMobile = _interopRequireWildcard(_ismobilejs);
	
	var _removeArrayItems = __webpack_require__(247);
	
	var _removeArrayItems2 = _interopRequireDefault(_removeArrayItems);
	
	var _mapPremultipliedBlendModes = __webpack_require__(248);
	
	var _mapPremultipliedBlendModes2 = _interopRequireDefault(_mapPremultipliedBlendModes);
	
	var _earcut = __webpack_require__(249);
	
	var _earcut2 = _interopRequireDefault(_earcut);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nextUid = 0;
	var saidHello = false;
	
	/**
	 * Generalized convenience utilities for PIXI.
	 * @example
	 * // Extend PIXI's internal Event Emitter.
	 * class MyEmitter extends PIXI.utils.EventEmitter {
	 *   constructor() {
	 *      super();
	 *      console.log("Emitter created!");
	 *   }
	 * }
	 *
	 * // Get info on current device
	 * console.log(PIXI.utils.isMobile);
	 *
	 * // Convert hex color to string
	 * console.log(PIXI.utils.hex2string(0xff00ff)); // returns: "#ff00ff"
	 * @namespace PIXI.utils
	 */
	exports.isMobile = isMobile;
	exports.removeItems = _removeArrayItems2.default;
	exports.EventEmitter = _eventemitter2.default;
	exports.pluginTarget = _pluginTarget2.default;
	exports.mixins = mixins;
	exports.earcut = _earcut2.default;
	
	/**
	 * Gets the next unique identifier
	 *
	 * @memberof PIXI.utils
	 * @function uid
	 * @return {number} The next unique identifier to use.
	 */
	
	function uid() {
	    return ++nextUid;
	}
	
	/**
	 * Converts a hex color number to an [R, G, B] array
	 *
	 * @memberof PIXI.utils
	 * @function hex2rgb
	 * @param {number} hex - The number to convert
	 * @param  {number[]} [out=[]] If supplied, this array will be used rather than returning a new one
	 * @return {number[]} An array representing the [R, G, B] of the color.
	 */
	function hex2rgb(hex, out) {
	    out = out || [];
	
	    out[0] = (hex >> 16 & 0xFF) / 255;
	    out[1] = (hex >> 8 & 0xFF) / 255;
	    out[2] = (hex & 0xFF) / 255;
	
	    return out;
	}
	
	/**
	 * Converts a hex color number to a string.
	 *
	 * @memberof PIXI.utils
	 * @function hex2string
	 * @param {number} hex - Number in hex
	 * @return {string} The string color.
	 */
	function hex2string(hex) {
	    hex = hex.toString(16);
	    hex = '000000'.substr(0, 6 - hex.length) + hex;
	
	    return '#' + hex;
	}
	
	/**
	 * Converts a color as an [R, G, B] array to a hex number
	 *
	 * @memberof PIXI.utils
	 * @function rgb2hex
	 * @param {number[]} rgb - rgb array
	 * @return {number} The color number
	 */
	function rgb2hex(rgb) {
	    return (rgb[0] * 255 << 16) + (rgb[1] * 255 << 8) + (rgb[2] * 255 | 0);
	}
	
	/**
	 * get the resolution / device pixel ratio of an asset by looking for the prefix
	 * used by spritesheets and image urls
	 *
	 * @memberof PIXI.utils
	 * @function getResolutionOfUrl
	 * @param {string} url - the image path
	 * @param {number} [defaultValue=1] - the defaultValue if no filename prefix is set.
	 * @return {number} resolution / device pixel ratio of an asset
	 */
	function getResolutionOfUrl(url, defaultValue) {
	    var resolution = _settings2.default.RETINA_PREFIX.exec(url);
	
	    if (resolution) {
	        return parseFloat(resolution[1]);
	    }
	
	    return defaultValue !== undefined ? defaultValue : 1;
	}
	
	/**
	 * Typedef for decomposeDataUri return object.
	 *
	 * @typedef {object} PIXI.utils~DecomposedDataUri
	 * @property {mediaType} Media type, eg. `image`
	 * @property {subType} Sub type, eg. `png`
	 * @property {encoding} Data encoding, eg. `base64`
	 * @property {data} The actual data
	 */
	
	/**
	 * Split a data URI into components. Returns undefined if
	 * parameter `dataUri` is not a valid data URI.
	 *
	 * @memberof PIXI.utils
	 * @function decomposeDataUri
	 * @param {string} dataUri - the data URI to check
	 * @return {PIXI.utils~DecomposedDataUri|undefined} The decomposed data uri or undefined
	 */
	function decomposeDataUri(dataUri) {
	    var dataUriMatch = _const.DATA_URI.exec(dataUri);
	
	    if (dataUriMatch) {
	        return {
	            mediaType: dataUriMatch[1] ? dataUriMatch[1].toLowerCase() : undefined,
	            subType: dataUriMatch[2] ? dataUriMatch[2].toLowerCase() : undefined,
	            charset: dataUriMatch[3] ? dataUriMatch[3].toLowerCase() : undefined,
	            encoding: dataUriMatch[4] ? dataUriMatch[4].toLowerCase() : undefined,
	            data: dataUriMatch[5]
	        };
	    }
	
	    return undefined;
	}
	
	/**
	 * Get type of the image by regexp for extension. Returns undefined for unknown extensions.
	 *
	 * @memberof PIXI.utils
	 * @function getUrlFileExtension
	 * @param {string} url - the image path
	 * @return {string|undefined} image extension
	 */
	function getUrlFileExtension(url) {
	    var extension = _const.URL_FILE_EXTENSION.exec(url);
	
	    if (extension) {
	        return extension[1].toLowerCase();
	    }
	
	    return undefined;
	}
	
	/**
	 * Typedef for Size object.
	 *
	 * @typedef {object} PIXI.utils~Size
	 * @property {width} Width component
	 * @property {height} Height component
	 */
	
	/**
	 * Get size from an svg string using regexp.
	 *
	 * @memberof PIXI.utils
	 * @function getSvgSize
	 * @param {string} svgString - a serialized svg element
	 * @return {PIXI.utils~Size|undefined} image extension
	 */
	function getSvgSize(svgString) {
	    var sizeMatch = _const.SVG_SIZE.exec(svgString);
	    var size = {};
	
	    if (sizeMatch) {
	        size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3]));
	        size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]));
	    }
	
	    return size;
	}
	
	/**
	 * Skips the hello message of renderers that are created after this is run.
	 *
	 * @function skipHello
	 * @memberof PIXI.utils
	 */
	function skipHello() {
	    saidHello = true;
	}
	
	/**
	 * Logs out the version and renderer information for this running instance of PIXI.
	 * If you don't want to see this message you can run `PIXI.utils.skipHello()` before
	 * creating your renderer. Keep in mind that doing that will forever makes you a jerk face.
	 *
	 * @static
	 * @function sayHello
	 * @memberof PIXI.utils
	 * @param {string} type - The string renderer type to log.
	 */
	function sayHello(type) {
	    if (saidHello) {
	        return;
	    }
	
	    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
	        var args = ['\n %c %c %c PixiJS ' + _const.VERSION + ' - \u2730 ' + type + ' \u2730  %c  %c  http://www.pixijs.com/  %c %c \u2665%c\u2665%c\u2665 \n\n', 'background: #ff66a5; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'color: #ff66a5; background: #030307; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'background: #ffc3dc; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;'];
	
	        window.console.log.apply(console, args);
	    } else if (window.console) {
	        window.console.log('PixiJS ' + _const.VERSION + ' - ' + type + ' - http://www.pixijs.com/');
	    }
	
	    saidHello = true;
	}
	
	/**
	 * Helper for checking for webgl support
	 *
	 * @memberof PIXI.utils
	 * @function isWebGLSupported
	 * @return {boolean} is webgl supported
	 */
	function isWebGLSupported() {
	    var contextOptions = { stencil: true, failIfMajorPerformanceCaveat: true };
	
	    try {
	        if (!window.WebGLRenderingContext) {
	            return false;
	        }
	
	        var canvas = document.createElement('canvas');
	        var gl = canvas.getContext('webgl', contextOptions) || canvas.getContext('experimental-webgl', contextOptions);
	
	        var success = !!(gl && gl.getContextAttributes().stencil);
	
	        if (gl) {
	            var loseContext = gl.getExtension('WEBGL_lose_context');
	
	            if (loseContext) {
	                loseContext.loseContext();
	            }
	        }
	
	        gl = null;
	
	        return success;
	    } catch (e) {
	        return false;
	    }
	}
	
	/**
	 * Returns sign of number
	 *
	 * @memberof PIXI.utils
	 * @function sign
	 * @param {number} n - the number to check the sign of
	 * @returns {number} 0 if `n` is 0, -1 if `n` is negative, 1 if `n` is positive
	 */
	function sign(n) {
	    if (n === 0) return 0;
	
	    return n < 0 ? -1 : 1;
	}
	
	/**
	 * @todo Describe property usage
	 *
	 * @memberof PIXI.utils
	 * @private
	 */
	var TextureCache = exports.TextureCache = Object.create(null);
	
	/**
	 * @todo Describe property usage
	 *
	 * @memberof PIXI.utils
	 * @private
	 */
	var BaseTextureCache = exports.BaseTextureCache = Object.create(null);
	
	/**
	 * Destroys all texture in the cache
	 *
	 * @memberof PIXI.utils
	 * @function destroyTextureCache
	 */
	function destroyTextureCache() {
	    var key = void 0;
	
	    for (key in TextureCache) {
	        TextureCache[key].destroy();
	    }
	    for (key in BaseTextureCache) {
	        BaseTextureCache[key].destroy();
	    }
	}
	
	/**
	 * Removes all textures from cache, but does not destroy them
	 *
	 * @memberof PIXI.utils
	 * @function clearTextureCache
	 */
	function clearTextureCache() {
	    var key = void 0;
	
	    for (key in TextureCache) {
	        delete TextureCache[key];
	    }
	    for (key in BaseTextureCache) {
	        delete BaseTextureCache[key];
	    }
	}
	
	/**
	 * maps premultiply flag and blendMode to adjusted blendMode
	 * @memberof PIXI.utils
	 * @const premultiplyBlendMode
	 * @type {Array<number[]>}
	 */
	var premultiplyBlendMode = exports.premultiplyBlendMode = (0, _mapPremultipliedBlendModes2.default)();
	
	/**
	 * changes blendMode according to texture format
	 *
	 * @memberof PIXI.utils
	 * @function correctBlendMode
	 * @param {number} blendMode supposed blend mode
	 * @param {boolean} premultiplied  whether source is premultiplied
	 * @returns {number} true blend mode for this texture
	 */
	function correctBlendMode(blendMode, premultiplied) {
	    return premultiplyBlendMode[premultiplied ? 1 : 0][blendMode];
	}
	
	/**
	 * premultiplies tint
	 *
	 * @memberof PIXI.utils
	 * @param {number} tint integet RGB
	 * @param {number} alpha floating point alpha (0.0-1.0)
	 * @returns {number} tint multiplied by alpha
	 */
	function premultiplyTint(tint, alpha) {
	    if (alpha === 1.0) {
	        return (alpha * 255 << 24) + tint;
	    }
	    if (alpha === 0.0) {
	        return 0;
	    }
	    var R = tint >> 16 & 0xFF;
	    var G = tint >> 8 & 0xFF;
	    var B = tint & 0xFF;
	
	    R = R * alpha + 0.5 | 0;
	    G = G * alpha + 0.5 | 0;
	    B = B * alpha + 0.5 | 0;
	
	    return (alpha * 255 << 24) + (R << 16) + (G << 8) + B;
	}
	
	/**
	 * combines rgb and alpha to out array
	 *
	 * @memberof PIXI.utils
	 * @param {Float32Array|number[]} rgb input rgb
	 * @param {number} alpha alpha param
	 * @param {Float32Array} [out] output
	 * @param {boolean} [premultiply=true] do premultiply it
	 * @returns {Float32Array} vec4 rgba
	 */
	function premultiplyRgba(rgb, alpha, out, premultiply) {
	    out = out || new Float32Array(4);
	    if (premultiply || premultiply === undefined) {
	        out[0] = rgb[0] * alpha;
	        out[1] = rgb[1] * alpha;
	        out[2] = rgb[2] * alpha;
	    } else {
	        out[0] = rgb[0];
	        out[1] = rgb[1];
	        out[2] = rgb[2];
	    }
	    out[3] = alpha;
	
	    return out;
	}
	
	/**
	 * converts integer tint and float alpha to vec4 form, premultiplies by default
	 *
	 * @memberof PIXI.utils
	 * @param {number} tint input tint
	 * @param {number} alpha alpha param
	 * @param {Float32Array} [out] output
	 * @param {boolean} [premultiply=true] do premultiply it
	 * @returns {Float32Array} vec4 rgba
	 */
	function premultiplyTintToRgba(tint, alpha, out, premultiply) {
	    out = out || new Float32Array(4);
	    out[0] = (tint >> 16 & 0xFF) / 255.0;
	    out[1] = (tint >> 8 & 0xFF) / 255.0;
	    out[2] = (tint & 0xFF) / 255.0;
	    if (premultiply || premultiply === undefined) {
	        out[0] *= alpha;
	        out[1] *= alpha;
	        out[2] *= alpha;
	    }
	    out[3] = alpha;
	
	    return out;
	}
	//# sourceMappingURL=index.js.map

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 * Mixins functionality to make an object have "plugins".
	 *
	 * @example
	 *      function MyObject() {}
	 *
	 *      pluginTarget.mixin(MyObject);
	 *
	 * @mixin
	 * @memberof PIXI.utils
	 * @param {object} obj - The object to mix into.
	 */
	function pluginTarget(obj) {
	    obj.__plugins = {};
	
	    /**
	     * Adds a plugin to an object
	     *
	     * @param {string} pluginName - The events that should be listed.
	     * @param {Function} ctor - The constructor function for the plugin.
	     */
	    obj.registerPlugin = function registerPlugin(pluginName, ctor) {
	        obj.__plugins[pluginName] = ctor;
	    };
	
	    /**
	     * Instantiates all the plugins of this object
	     *
	     */
	    obj.prototype.initPlugins = function initPlugins() {
	        this.plugins = this.plugins || {};
	
	        for (var o in obj.__plugins) {
	            this.plugins[o] = new obj.__plugins[o](this);
	        }
	    };
	
	    /**
	     * Removes all the plugins of this object
	     *
	     */
	    obj.prototype.destroyPlugins = function destroyPlugins() {
	        for (var o in this.plugins) {
	            this.plugins[o].destroy();
	            this.plugins[o] = null;
	        }
	
	        this.plugins = null;
	    };
	}
	
	exports.default = {
	    /**
	     * Mixes in the properties of the pluginTarget into another object
	     *
	     * @param {object} obj - The obj to mix into
	     */
	    mixin: function mixin(obj) {
	        pluginTarget(obj);
	    }
	};
	//# sourceMappingURL=pluginTarget.js.map

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.mixin = mixin;
	exports.delayMixin = delayMixin;
	exports.performMixins = performMixins;
	/**
	 * Mixes all enumerable properties and methods from a source object to a target object.
	 *
	 * @memberof PIXI.utils.mixins
	 * @function mixin
	 * @param {object} target The prototype or instance that properties and methods should be added to.
	 * @param {object} source The source of properties and methods to mix in.
	 */
	function mixin(target, source) {
	    if (!target || !source) return;
	    // in ES8/ES2017, this would be really easy:
	    // Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	
	    // get all the enumerable property keys
	    var keys = Object.keys(source);
	
	    // loop through properties
	    for (var i = 0; i < keys.length; ++i) {
	        var propertyName = keys[i];
	
	        // Set the property using the property descriptor - this works for accessors and normal value properties
	        Object.defineProperty(target, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
	    }
	}
	
	var mixins = [];
	
	/**
	 * Queues a mixin to be handled towards the end of the initialization of PIXI, so that deprecation
	 * can take effect.
	 *
	 * @memberof PIXI.utils.mixins
	 * @function delayMixin
	 * @private
	 * @param {object} target The prototype or instance that properties and methods should be added to.
	 * @param {object} source The source of properties and methods to mix in.
	 */
	function delayMixin(target, source) {
	    mixins.push(target, source);
	}
	
	/**
	 * Handles all mixins queued via delayMixin().
	 *
	 * @memberof PIXI.utils.mixins
	 * @function performMixins
	 * @private
	 */
	function performMixins() {
	    for (var i = 0; i < mixins.length; i += 2) {
	        mixin(mixins[i], mixins[i + 1]);
	    }
	    mixins.length = 0;
	}
	//# sourceMappingURL=mixin.js.map

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	'use strict'
	
	/**
	 * Remove a range of items from an array
	 *
	 * @function removeItems
	 * @param {Array<*>} arr The target array
	 * @param {number} startIdx The index to begin removing from (inclusive)
	 * @param {number} removeCount How many items to remove
	 */
	module.exports = function removeItems(arr, startIdx, removeCount)
	{
	  var i, length = arr.length
	
	  if (startIdx >= length || removeCount === 0) {
	    return
	  }
	
	  removeCount = (startIdx + removeCount > length ? length - startIdx : removeCount)
	
	  var len = length - removeCount
	
	  for (i = startIdx; i < len; ++i) {
	    arr[i] = arr[i + removeCount]
	  }
	
	  arr.length = len
	}


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = mapPremultipliedBlendModes;
	
	var _const = __webpack_require__(205);
	
	/**
	 * Corrects PixiJS blend, takes premultiplied alpha into account
	 *
	 * @memberof PIXI
	 * @function mapPremultipliedBlendModes
	 * @private
	 * @param {Array<number[]>} [array] - The array to output into.
	 * @return {Array<number[]>} Mapped modes.
	 */
	
	function mapPremultipliedBlendModes() {
	    var pm = [];
	    var npm = [];
	
	    for (var i = 0; i < 32; i++) {
	        pm[i] = i;
	        npm[i] = i;
	    }
	
	    pm[_const.BLEND_MODES.NORMAL_NPM] = _const.BLEND_MODES.NORMAL;
	    pm[_const.BLEND_MODES.ADD_NPM] = _const.BLEND_MODES.ADD;
	    pm[_const.BLEND_MODES.SCREEN_NPM] = _const.BLEND_MODES.SCREEN;
	
	    npm[_const.BLEND_MODES.NORMAL] = _const.BLEND_MODES.NORMAL_NPM;
	    npm[_const.BLEND_MODES.ADD] = _const.BLEND_MODES.ADD_NPM;
	    npm[_const.BLEND_MODES.SCREEN] = _const.BLEND_MODES.SCREEN_NPM;
	
	    var array = [];
	
	    array.push(npm);
	    array.push(pm);
	
	    return array;
	}
	//# sourceMappingURL=mapPremultipliedBlendModes.js.map

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = earcut;
	module.exports.default = earcut;
	
	function earcut(data, holeIndices, dim) {
	
	    dim = dim || 2;
	
	    var hasHoles = holeIndices && holeIndices.length,
	        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
	        outerNode = linkedList(data, 0, outerLen, dim, true),
	        triangles = [];
	
	    if (!outerNode) return triangles;
	
	    var minX, minY, maxX, maxY, x, y, invSize;
	
	    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
	
	    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
	    if (data.length > 80 * dim) {
	        minX = maxX = data[0];
	        minY = maxY = data[1];
	
	        for (var i = dim; i < outerLen; i += dim) {
	            x = data[i];
	            y = data[i + 1];
	            if (x < minX) minX = x;
	            if (y < minY) minY = y;
	            if (x > maxX) maxX = x;
	            if (y > maxY) maxY = y;
	        }
	
	        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
	        invSize = Math.max(maxX - minX, maxY - minY);
	        invSize = invSize !== 0 ? 1 / invSize : 0;
	    }
	
	    earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
	
	    return triangles;
	}
	
	// create a circular doubly linked list from polygon points in the specified winding order
	function linkedList(data, start, end, dim, clockwise) {
	    var i, last;
	
	    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
	        for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
	    } else {
	        for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
	    }
	
	    if (last && equals(last, last.next)) {
	        removeNode(last);
	        last = last.next;
	    }
	
	    return last;
	}
	
	// eliminate colinear or duplicate points
	function filterPoints(start, end) {
	    if (!start) return start;
	    if (!end) end = start;
	
	    var p = start,
	        again;
	    do {
	        again = false;
	
	        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
	            removeNode(p);
	            p = end = p.prev;
	            if (p === p.next) break;
	            again = true;
	
	        } else {
	            p = p.next;
	        }
	    } while (again || p !== end);
	
	    return end;
	}
	
	// main ear slicing loop which triangulates a polygon (given as a linked list)
	function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
	    if (!ear) return;
	
	    // interlink polygon nodes in z-order
	    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
	
	    var stop = ear,
	        prev, next;
	
	    // iterate through ears, slicing them one by one
	    while (ear.prev !== ear.next) {
	        prev = ear.prev;
	        next = ear.next;
	
	        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
	            // cut off the triangle
	            triangles.push(prev.i / dim);
	            triangles.push(ear.i / dim);
	            triangles.push(next.i / dim);
	
	            removeNode(ear);
	
	            // skipping the next vertice leads to less sliver triangles
	            ear = next.next;
	            stop = next.next;
	
	            continue;
	        }
	
	        ear = next;
	
	        // if we looped through the whole remaining polygon and can't find any more ears
	        if (ear === stop) {
	            // try filtering points and slicing again
	            if (!pass) {
	                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
	
	            // if this didn't work, try curing all small self-intersections locally
	            } else if (pass === 1) {
	                ear = cureLocalIntersections(ear, triangles, dim);
	                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
	
	            // as a last resort, try splitting the remaining polygon into two
	            } else if (pass === 2) {
	                splitEarcut(ear, triangles, dim, minX, minY, invSize);
	            }
	
	            break;
	        }
	    }
	}
	
	// check whether a polygon node forms a valid ear with adjacent nodes
	function isEar(ear) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // now make sure we don't have other points inside the potential ear
	    var p = ear.next.next;
	
	    while (p !== ear.prev) {
	        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.next;
	    }
	
	    return true;
	}
	
	function isEarHashed(ear, minX, minY, invSize) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // triangle bbox; min & max are calculated like this for speed
	    var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
	        minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
	        maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
	        maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);
	
	    // z-order range for the current triangle bbox;
	    var minZ = zOrder(minTX, minTY, minX, minY, invSize),
	        maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
	
	    var p = ear.prevZ,
	        n = ear.nextZ;
	
	    // look for points inside the triangle in both directions
	    while (p && p.z >= minZ && n && n.z <= maxZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.prevZ;
	
	        if (n !== ear.prev && n !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
	            area(n.prev, n, n.next) >= 0) return false;
	        n = n.nextZ;
	    }
	
	    // look for remaining points in decreasing z-order
	    while (p && p.z >= minZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.prevZ;
	    }
	
	    // look for remaining points in increasing z-order
	    while (n && n.z <= maxZ) {
	        if (n !== ear.prev && n !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
	            area(n.prev, n, n.next) >= 0) return false;
	        n = n.nextZ;
	    }
	
	    return true;
	}
	
	// go through all polygon nodes and cure small local self-intersections
	function cureLocalIntersections(start, triangles, dim) {
	    var p = start;
	    do {
	        var a = p.prev,
	            b = p.next.next;
	
	        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
	
	            triangles.push(a.i / dim);
	            triangles.push(p.i / dim);
	            triangles.push(b.i / dim);
	
	            // remove two nodes involved
	            removeNode(p);
	            removeNode(p.next);
	
	            p = start = b;
	        }
	        p = p.next;
	    } while (p !== start);
	
	    return p;
	}
	
	// try splitting polygon into two and triangulate them independently
	function splitEarcut(start, triangles, dim, minX, minY, invSize) {
	    // look for a valid diagonal that divides the polygon into two
	    var a = start;
	    do {
	        var b = a.next.next;
	        while (b !== a.prev) {
	            if (a.i !== b.i && isValidDiagonal(a, b)) {
	                // split the polygon in two by the diagonal
	                var c = splitPolygon(a, b);
	
	                // filter colinear points around the cuts
	                a = filterPoints(a, a.next);
	                c = filterPoints(c, c.next);
	
	                // run earcut on each half
	                earcutLinked(a, triangles, dim, minX, minY, invSize);
	                earcutLinked(c, triangles, dim, minX, minY, invSize);
	                return;
	            }
	            b = b.next;
	        }
	        a = a.next;
	    } while (a !== start);
	}
	
	// link every hole into the outer loop, producing a single-ring polygon without holes
	function eliminateHoles(data, holeIndices, outerNode, dim) {
	    var queue = [],
	        i, len, start, end, list;
	
	    for (i = 0, len = holeIndices.length; i < len; i++) {
	        start = holeIndices[i] * dim;
	        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	        list = linkedList(data, start, end, dim, false);
	        if (list === list.next) list.steiner = true;
	        queue.push(getLeftmost(list));
	    }
	
	    queue.sort(compareX);
	
	    // process holes from left to right
	    for (i = 0; i < queue.length; i++) {
	        eliminateHole(queue[i], outerNode);
	        outerNode = filterPoints(outerNode, outerNode.next);
	    }
	
	    return outerNode;
	}
	
	function compareX(a, b) {
	    return a.x - b.x;
	}
	
	// find a bridge between vertices that connects hole with an outer ring and and link it
	function eliminateHole(hole, outerNode) {
	    outerNode = findHoleBridge(hole, outerNode);
	    if (outerNode) {
	        var b = splitPolygon(outerNode, hole);
	        filterPoints(b, b.next);
	    }
	}
	
	// David Eberly's algorithm for finding a bridge between hole and outer polygon
	function findHoleBridge(hole, outerNode) {
	    var p = outerNode,
	        hx = hole.x,
	        hy = hole.y,
	        qx = -Infinity,
	        m;
	
	    // find a segment intersected by a ray from the hole's leftmost point to the left;
	    // segment's endpoint with lesser x will be potential connection point
	    do {
	        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
	            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
	            if (x <= hx && x > qx) {
	                qx = x;
	                if (x === hx) {
	                    if (hy === p.y) return p;
	                    if (hy === p.next.y) return p.next;
	                }
	                m = p.x < p.next.x ? p : p.next;
	            }
	        }
	        p = p.next;
	    } while (p !== outerNode);
	
	    if (!m) return null;
	
	    if (hx === qx) return m.prev; // hole touches outer segment; pick lower endpoint
	
	    // look for points inside the triangle of hole point, segment intersection and endpoint;
	    // if there are no points found, we have a valid connection;
	    // otherwise choose the point of the minimum angle with the ray as connection point
	
	    var stop = m,
	        mx = m.x,
	        my = m.y,
	        tanMin = Infinity,
	        tan;
	
	    p = m.next;
	
	    while (p !== stop) {
	        if (hx >= p.x && p.x >= mx && hx !== p.x &&
	                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
	
	            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
	
	            if ((tan < tanMin || (tan === tanMin && p.x > m.x)) && locallyInside(p, hole)) {
	                m = p;
	                tanMin = tan;
	            }
	        }
	
	        p = p.next;
	    }
	
	    return m;
	}
	
	// interlink polygon nodes in z-order
	function indexCurve(start, minX, minY, invSize) {
	    var p = start;
	    do {
	        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
	        p.prevZ = p.prev;
	        p.nextZ = p.next;
	        p = p.next;
	    } while (p !== start);
	
	    p.prevZ.nextZ = null;
	    p.prevZ = null;
	
	    sortLinked(p);
	}
	
	// Simon Tatham's linked list merge sort algorithm
	// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
	function sortLinked(list) {
	    var i, p, q, e, tail, numMerges, pSize, qSize,
	        inSize = 1;
	
	    do {
	        p = list;
	        list = null;
	        tail = null;
	        numMerges = 0;
	
	        while (p) {
	            numMerges++;
	            q = p;
	            pSize = 0;
	            for (i = 0; i < inSize; i++) {
	                pSize++;
	                q = q.nextZ;
	                if (!q) break;
	            }
	            qSize = inSize;
	
	            while (pSize > 0 || (qSize > 0 && q)) {
	
	                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
	                    e = p;
	                    p = p.nextZ;
	                    pSize--;
	                } else {
	                    e = q;
	                    q = q.nextZ;
	                    qSize--;
	                }
	
	                if (tail) tail.nextZ = e;
	                else list = e;
	
	                e.prevZ = tail;
	                tail = e;
	            }
	
	            p = q;
	        }
	
	        tail.nextZ = null;
	        inSize *= 2;
	
	    } while (numMerges > 1);
	
	    return list;
	}
	
	// z-order of a point given coords and inverse of the longer side of data bbox
	function zOrder(x, y, minX, minY, invSize) {
	    // coords are transformed into non-negative 15-bit integer range
	    x = 32767 * (x - minX) * invSize;
	    y = 32767 * (y - minY) * invSize;
	
	    x = (x | (x << 8)) & 0x00FF00FF;
	    x = (x | (x << 4)) & 0x0F0F0F0F;
	    x = (x | (x << 2)) & 0x33333333;
	    x = (x | (x << 1)) & 0x55555555;
	
	    y = (y | (y << 8)) & 0x00FF00FF;
	    y = (y | (y << 4)) & 0x0F0F0F0F;
	    y = (y | (y << 2)) & 0x33333333;
	    y = (y | (y << 1)) & 0x55555555;
	
	    return x | (y << 1);
	}
	
	// find the leftmost node of a polygon ring
	function getLeftmost(start) {
	    var p = start,
	        leftmost = start;
	    do {
	        if (p.x < leftmost.x) leftmost = p;
	        p = p.next;
	    } while (p !== start);
	
	    return leftmost;
	}
	
	// check if a point lies within a convex triangle
	function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
	    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
	           (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
	           (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
	}
	
	// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
	function isValidDiagonal(a, b) {
	    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) &&
	           locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b);
	}
	
	// signed area of a triangle
	function area(p, q, r) {
	    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
	}
	
	// check if two points are equal
	function equals(p1, p2) {
	    return p1.x === p2.x && p1.y === p2.y;
	}
	
	// check if two segments intersect
	function intersects(p1, q1, p2, q2) {
	    if ((equals(p1, q1) && equals(p2, q2)) ||
	        (equals(p1, q2) && equals(p2, q1))) return true;
	    return area(p1, q1, p2) > 0 !== area(p1, q1, q2) > 0 &&
	           area(p2, q2, p1) > 0 !== area(p2, q2, q1) > 0;
	}
	
	// check if a polygon diagonal intersects any polygon segments
	function intersectsPolygon(a, b) {
	    var p = a;
	    do {
	        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
	                intersects(p, p.next, a, b)) return true;
	        p = p.next;
	    } while (p !== a);
	
	    return false;
	}
	
	// check if a polygon diagonal is locally inside the polygon
	function locallyInside(a, b) {
	    return area(a.prev, a, a.next) < 0 ?
	        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
	        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
	}
	
	// check if the middle point of a polygon diagonal is inside the polygon
	function middleInside(a, b) {
	    var p = a,
	        inside = false,
	        px = (a.x + b.x) / 2,
	        py = (a.y + b.y) / 2;
	    do {
	        if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
	                (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
	            inside = !inside;
	        p = p.next;
	    } while (p !== a);
	
	    return inside;
	}
	
	// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
	// if one belongs to the outer ring and another to a hole, it merges it into a single ring
	function splitPolygon(a, b) {
	    var a2 = new Node(a.i, a.x, a.y),
	        b2 = new Node(b.i, b.x, b.y),
	        an = a.next,
	        bp = b.prev;
	
	    a.next = b;
	    b.prev = a;
	
	    a2.next = an;
	    an.prev = a2;
	
	    b2.next = a2;
	    a2.prev = b2;
	
	    bp.next = b2;
	    b2.prev = bp;
	
	    return b2;
	}
	
	// create a node and optionally link it with previous one (in a circular doubly linked list)
	function insertNode(i, x, y, last) {
	    var p = new Node(i, x, y);
	
	    if (!last) {
	        p.prev = p;
	        p.next = p;
	
	    } else {
	        p.next = last.next;
	        p.prev = last;
	        last.next.prev = p;
	        last.next = p;
	    }
	    return p;
	}
	
	function removeNode(p) {
	    p.next.prev = p.prev;
	    p.prev.next = p.next;
	
	    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
	    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
	}
	
	function Node(i, x, y) {
	    // vertice index in coordinates array
	    this.i = i;
	
	    // vertex coordinates
	    this.x = x;
	    this.y = y;
	
	    // previous and next vertice nodes in a polygon ring
	    this.prev = null;
	    this.next = null;
	
	    // z-order curve value
	    this.z = null;
	
	    // previous and next nodes in z-order
	    this.prevZ = null;
	    this.nextZ = null;
	
	    // indicates whether this is a steiner point
	    this.steiner = false;
	}
	
	// return a percentage difference between the polygon area and its triangulation area;
	// used to verify correctness of triangulation
	earcut.deviation = function (data, holeIndices, dim, triangles) {
	    var hasHoles = holeIndices && holeIndices.length;
	    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
	
	    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
	    if (hasHoles) {
	        for (var i = 0, len = holeIndices.length; i < len; i++) {
	            var start = holeIndices[i] * dim;
	            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	            polygonArea -= Math.abs(signedArea(data, start, end, dim));
	        }
	    }
	
	    var trianglesArea = 0;
	    for (i = 0; i < triangles.length; i += 3) {
	        var a = triangles[i] * dim;
	        var b = triangles[i + 1] * dim;
	        var c = triangles[i + 2] * dim;
	        trianglesArea += Math.abs(
	            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
	            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
	    }
	
	    return polygonArea === 0 && trianglesArea === 0 ? 0 :
	        Math.abs((trianglesArea - polygonArea) / polygonArea);
	};
	
	function signedArea(data, start, end, dim) {
	    var sum = 0;
	    for (var i = start, j = end - dim; i < end; i += dim) {
	        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
	        j = i;
	    }
	    return sum;
	}
	
	// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
	earcut.flatten = function (data) {
	    var dim = data[0][0].length,
	        result = {vertices: [], holes: [], dimensions: dim},
	        holeIndex = 0;
	
	    for (var i = 0; i < data.length; i++) {
	        for (var j = 0; j < data[i].length; j++) {
	            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
	        }
	        if (i > 0) {
	            holeIndex += data[i - 1].length;
	            result.holes.push(holeIndex);
	        }
	    }
	    return result;
	};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _math = __webpack_require__(206);
	
	var _utils = __webpack_require__(244);
	
	var _const = __webpack_require__(205);
	
	var _Texture = __webpack_require__(251);
	
	var _Texture2 = _interopRequireDefault(_Texture);
	
	var _Container2 = __webpack_require__(243);
	
	var _Container3 = _interopRequireDefault(_Container2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tempPoint = new _math.Point();
	
	/**
	 * The Sprite object is the base for all textured objects that are rendered to the screen
	 *
	 * A sprite can be created directly from an image like this:
	 *
	 * ```js
	 * let sprite = new PIXI.Sprite.fromImage('assets/image.png');
	 * ```
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 */
	
	var Sprite = function (_Container) {
	    _inherits(Sprite, _Container);
	
	    /**
	     * @param {PIXI.Texture} texture - The texture for this sprite
	     */
	    function Sprite(texture) {
	        _classCallCheck(this, Sprite);
	
	        /**
	         * The anchor sets the origin point of the texture.
	         * The default is 0,0 this means the texture's origin is the top left
	         * Setting the anchor to 0.5,0.5 means the texture's origin is centered
	         * Setting the anchor to 1,1 would mean the texture's origin point will be the bottom right corner
	         *
	         * @member {PIXI.ObservablePoint}
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _Container.call(this));
	
	        _this._anchor = new _math.ObservablePoint(_this._onAnchorUpdate, _this);
	
	        /**
	         * The texture that the sprite is using
	         *
	         * @private
	         * @member {PIXI.Texture}
	         */
	        _this._texture = null;
	
	        /**
	         * The width of the sprite (this is initially set by the texture)
	         *
	         * @private
	         * @member {number}
	         */
	        _this._width = 0;
	
	        /**
	         * The height of the sprite (this is initially set by the texture)
	         *
	         * @private
	         * @member {number}
	         */
	        _this._height = 0;
	
	        /**
	         * The tint applied to the sprite. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @private
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this._tint = null;
	        _this._tintRGB = null;
	        _this.tint = 0xFFFFFF;
	
	        /**
	         * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = _const.BLEND_MODES.NORMAL;
	
	        /**
	         * The shader that will be used to render the sprite. Set to null to remove a current shader.
	         *
	         * @member {PIXI.Filter|PIXI.Shader}
	         */
	        _this.shader = null;
	
	        /**
	         * An internal cached value of the tint.
	         *
	         * @private
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this.cachedTint = 0xFFFFFF;
	
	        // call texture setter
	        _this.texture = texture || _Texture2.default.EMPTY;
	
	        /**
	         * this is used to store the vertex data of the sprite (basically a quad)
	         *
	         * @private
	         * @member {Float32Array}
	         */
	        _this.vertexData = new Float32Array(8);
	
	        /**
	         * This is used to calculate the bounds of the object IF it is a trimmed sprite
	         *
	         * @private
	         * @member {Float32Array}
	         */
	        _this.vertexTrimmedData = null;
	
	        _this._transformID = -1;
	        _this._textureID = -1;
	
	        _this._transformTrimmedID = -1;
	        _this._textureTrimmedID = -1;
	
	        /**
	         * Plugin that is responsible for rendering this element.
	         * Allows to customize the rendering process without overriding '_renderWebGL' & '_renderCanvas' methods.
	         *
	         * @member {string}
	         * @default 'sprite'
	         */
	        _this.pluginName = 'sprite';
	        return _this;
	    }
	
	    /**
	     * When the texture is updated, this event will fire to update the scale and frame
	     *
	     * @private
	     */
	
	
	    Sprite.prototype._onTextureUpdate = function _onTextureUpdate() {
	        this._textureID = -1;
	        this._textureTrimmedID = -1;
	        this.cachedTint = 0xFFFFFF;
	
	        // so if _width is 0 then width was not set..
	        if (this._width) {
	            this.scale.x = (0, _utils.sign)(this.scale.x) * this._width / this._texture.orig.width;
	        }
	
	        if (this._height) {
	            this.scale.y = (0, _utils.sign)(this.scale.y) * this._height / this._texture.orig.height;
	        }
	    };
	
	    /**
	     * Called when the anchor position updates.
	     *
	     * @private
	     */
	
	
	    Sprite.prototype._onAnchorUpdate = function _onAnchorUpdate() {
	        this._transformID = -1;
	        this._transformTrimmedID = -1;
	    };
	
	    /**
	     * calculates worldTransform * vertices, store it in vertexData
	     */
	
	
	    Sprite.prototype.calculateVertices = function calculateVertices() {
	        if (this._transformID === this.transform._worldID && this._textureID === this._texture._updateID) {
	            return;
	        }
	
	        this._transformID = this.transform._worldID;
	        this._textureID = this._texture._updateID;
	
	        // set the vertex data
	
	        var texture = this._texture;
	        var wt = this.transform.worldTransform;
	        var a = wt.a;
	        var b = wt.b;
	        var c = wt.c;
	        var d = wt.d;
	        var tx = wt.tx;
	        var ty = wt.ty;
	        var vertexData = this.vertexData;
	        var trim = texture.trim;
	        var orig = texture.orig;
	        var anchor = this._anchor;
	
	        var w0 = 0;
	        var w1 = 0;
	        var h0 = 0;
	        var h1 = 0;
	
	        if (trim) {
	            // if the sprite is trimmed and is not a tilingsprite then we need to add the extra
	            // space before transforming the sprite coords.
	            w1 = trim.x - anchor._x * orig.width;
	            w0 = w1 + trim.width;
	
	            h1 = trim.y - anchor._y * orig.height;
	            h0 = h1 + trim.height;
	        } else {
	            w1 = -anchor._x * orig.width;
	            w0 = w1 + orig.width;
	
	            h1 = -anchor._y * orig.height;
	            h0 = h1 + orig.height;
	        }
	
	        // xy
	        vertexData[0] = a * w1 + c * h1 + tx;
	        vertexData[1] = d * h1 + b * w1 + ty;
	
	        // xy
	        vertexData[2] = a * w0 + c * h1 + tx;
	        vertexData[3] = d * h1 + b * w0 + ty;
	
	        // xy
	        vertexData[4] = a * w0 + c * h0 + tx;
	        vertexData[5] = d * h0 + b * w0 + ty;
	
	        // xy
	        vertexData[6] = a * w1 + c * h0 + tx;
	        vertexData[7] = d * h0 + b * w1 + ty;
	    };
	
	    /**
	     * calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData
	     * This is used to ensure that the true width and height of a trimmed texture is respected
	     */
	
	
	    Sprite.prototype.calculateTrimmedVertices = function calculateTrimmedVertices() {
	        if (!this.vertexTrimmedData) {
	            this.vertexTrimmedData = new Float32Array(8);
	        } else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID) {
	            return;
	        }
	
	        this._transformTrimmedID = this.transform._worldID;
	        this._textureTrimmedID = this._texture._updateID;
	
	        // lets do some special trim code!
	        var texture = this._texture;
	        var vertexData = this.vertexTrimmedData;
	        var orig = texture.orig;
	        var anchor = this._anchor;
	
	        // lets calculate the new untrimmed bounds..
	        var wt = this.transform.worldTransform;
	        var a = wt.a;
	        var b = wt.b;
	        var c = wt.c;
	        var d = wt.d;
	        var tx = wt.tx;
	        var ty = wt.ty;
	
	        var w1 = -anchor._x * orig.width;
	        var w0 = w1 + orig.width;
	
	        var h1 = -anchor._y * orig.height;
	        var h0 = h1 + orig.height;
	
	        // xy
	        vertexData[0] = a * w1 + c * h1 + tx;
	        vertexData[1] = d * h1 + b * w1 + ty;
	
	        // xy
	        vertexData[2] = a * w0 + c * h1 + tx;
	        vertexData[3] = d * h1 + b * w0 + ty;
	
	        // xy
	        vertexData[4] = a * w0 + c * h0 + tx;
	        vertexData[5] = d * h0 + b * w0 + ty;
	
	        // xy
	        vertexData[6] = a * w1 + c * h0 + tx;
	        vertexData[7] = d * h0 + b * w1 + ty;
	    };
	
	    /**
	    *
	    * Renders the object using the WebGL renderer
	    *
	    * @private
	    * @param {PIXI.WebGLRenderer} renderer - The webgl renderer to use.
	    */
	
	
	    Sprite.prototype._renderWebGL = function _renderWebGL(renderer) {
	        this.calculateVertices();
	
	        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
	        renderer.plugins[this.pluginName].render(this);
	    };
	
	    /**
	    * Renders the object using the Canvas renderer
	    *
	    * @private
	    * @param {PIXI.CanvasRenderer} renderer - The renderer
	    */
	
	
	    Sprite.prototype._renderCanvas = function _renderCanvas(renderer) {
	        renderer.plugins[this.pluginName].render(this);
	    };
	
	    /**
	     * Updates the bounds of the sprite.
	     *
	     * @private
	     */
	
	
	    Sprite.prototype._calculateBounds = function _calculateBounds() {
	        var trim = this._texture.trim;
	        var orig = this._texture.orig;
	
	        // First lets check to see if the current texture has a trim..
	        if (!trim || trim.width === orig.width && trim.height === orig.height) {
	            // no trim! lets use the usual calculations..
	            this.calculateVertices();
	            this._bounds.addQuad(this.vertexData);
	        } else {
	            // lets calculate a special trimmed bounds...
	            this.calculateTrimmedVertices();
	            this._bounds.addQuad(this.vertexTrimmedData);
	        }
	    };
	
	    /**
	     * Gets the local bounds of the sprite object.
	     *
	     * @param {PIXI.Rectangle} rect - The output rectangle.
	     * @return {PIXI.Rectangle} The bounds.
	     */
	
	
	    Sprite.prototype.getLocalBounds = function getLocalBounds(rect) {
	        // we can do a fast local bounds if the sprite has no children!
	        if (this.children.length === 0) {
	            this._bounds.minX = this._texture.orig.width * -this._anchor._x;
	            this._bounds.minY = this._texture.orig.height * -this._anchor._y;
	            this._bounds.maxX = this._texture.orig.width * (1 - this._anchor._x);
	            this._bounds.maxY = this._texture.orig.height * (1 - this._anchor._y);
	
	            if (!rect) {
	                if (!this._localBoundsRect) {
	                    this._localBoundsRect = new _math.Rectangle();
	                }
	
	                rect = this._localBoundsRect;
	            }
	
	            return this._bounds.getRectangle(rect);
	        }
	
	        return _Container.prototype.getLocalBounds.call(this, rect);
	    };
	
	    /**
	     * Tests if a point is inside this sprite
	     *
	     * @param {PIXI.Point} point - the point to test
	     * @return {boolean} the result of the test
	     */
	
	
	    Sprite.prototype.containsPoint = function containsPoint(point) {
	        this.worldTransform.applyInverse(point, tempPoint);
	
	        var width = this._texture.orig.width;
	        var height = this._texture.orig.height;
	        var x1 = -width * this.anchor.x;
	        var y1 = 0;
	
	        if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
	            y1 = -height * this.anchor.y;
	
	            if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	
	    /**
	     * Destroys this sprite and optionally its texture and children
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *      method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
	     */
	
	
	    Sprite.prototype.destroy = function destroy(options) {
	        _Container.prototype.destroy.call(this, options);
	
	        this._texture.off('update', this._onTextureUpdate, this);
	
	        this._anchor = null;
	
	        var destroyTexture = typeof options === 'boolean' ? options : options && options.texture;
	
	        if (destroyTexture) {
	            var destroyBaseTexture = typeof options === 'boolean' ? options : options && options.baseTexture;
	
	            this._texture.destroy(!!destroyBaseTexture);
	        }
	
	        this._texture = null;
	        this.shader = null;
	    };
	
	    // some helper functions..
	
	    /**
	     * Helper function that creates a new sprite based on the source you provide.
	     * The source can be - frame id, image url, video url, canvas element, video element, base texture
	     *
	     * @static
	     * @param {number|string|PIXI.BaseTexture|HTMLCanvasElement|HTMLVideoElement} source Source to create texture from
	     * @return {PIXI.Sprite} The newly created sprite
	     */
	
	
	    Sprite.from = function from(source) {
	        return new Sprite(_Texture2.default.from(source));
	    };
	
	    /**
	     * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
	     * The frame ids are created when a Texture packer file has been loaded
	     *
	     * @static
	     * @param {string} frameId - The frame Id of the texture in the cache
	     * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the frameId
	     */
	
	
	    Sprite.fromFrame = function fromFrame(frameId) {
	        var texture = _utils.TextureCache[frameId];
	
	        if (!texture) {
	            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
	        }
	
	        return new Sprite(texture);
	    };
	
	    /**
	     * Helper function that creates a sprite that will contain a texture based on an image url
	     * If the image is not in the texture cache it will be loaded
	     *
	     * @static
	     * @param {string} imageId - The image url of the texture
	     * @param {boolean} [crossorigin=(auto)] - if you want to specify the cross-origin parameter
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - if you want to specify the scale mode,
	     *  see {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the image id
	     */
	
	
	    Sprite.fromImage = function fromImage(imageId, crossorigin, scaleMode) {
	        return new Sprite(_Texture2.default.fromImage(imageId, crossorigin, scaleMode));
	    };
	
	    /**
	     * The width of the sprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     */
	
	
	    _createClass(Sprite, [{
	        key: 'width',
	        get: function get() {
	            return Math.abs(this.scale.x) * this._texture.orig.width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            var s = (0, _utils.sign)(this.scale.x) || 1;
	
	            this.scale.x = s * value / this._texture.orig.width;
	            this._width = value;
	        }
	
	        /**
	         * The height of the sprite, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'height',
	        get: function get() {
	            return Math.abs(this.scale.y) * this._texture.orig.height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            var s = (0, _utils.sign)(this.scale.y) || 1;
	
	            this.scale.y = s * value / this._texture.orig.height;
	            this._height = value;
	        }
	
	        /**
	         * The anchor sets the origin point of the texture.
	         * The default is 0,0 this means the texture's origin is the top left
	         * Setting the anchor to 0.5,0.5 means the texture's origin is centered
	         * Setting the anchor to 1,1 would mean the texture's origin point will be the bottom right corner
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'anchor',
	        get: function get() {
	            return this._anchor;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._anchor.copy(value);
	        }
	
	        /**
	         * The tint applied to the sprite. This is a hex value.
	         * A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	
	    }, {
	        key: 'tint',
	        get: function get() {
	            return this._tint;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._tint = value;
	            this._tintRGB = (value >> 16) + (value & 0xff00) + ((value & 0xff) << 16);
	        }
	
	        /**
	         * The texture that the sprite is using
	         *
	         * @member {PIXI.Texture}
	         */
	
	    }, {
	        key: 'texture',
	        get: function get() {
	            return this._texture;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._texture === value) {
	                return;
	            }
	
	            this._texture = value;
	            this.cachedTint = 0xFFFFFF;
	
	            this._textureID = -1;
	            this._textureTrimmedID = -1;
	
	            if (value) {
	                // wait for the texture to load
	                if (value.baseTexture.hasLoaded) {
	                    this._onTextureUpdate();
	                } else {
	                    value.once('update', this._onTextureUpdate, this);
	                }
	            }
	        }
	    }]);
	
	    return Sprite;
	}(_Container3.default);
	
	exports.default = Sprite;
	//# sourceMappingURL=Sprite.js.map

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseTexture = __webpack_require__(252);
	
	var _BaseTexture2 = _interopRequireDefault(_BaseTexture);
	
	var _VideoBaseTexture = __webpack_require__(262);
	
	var _VideoBaseTexture2 = _interopRequireDefault(_VideoBaseTexture);
	
	var _TextureUvs = __webpack_require__(266);
	
	var _TextureUvs2 = _interopRequireDefault(_TextureUvs);
	
	var _eventemitter = __webpack_require__(235);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _math = __webpack_require__(206);
	
	var _utils = __webpack_require__(244);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A texture stores the information that represents an image or part of an image. It cannot be added
	 * to the display list directly. Instead use it as the texture for a Sprite. If no frame is provided
	 * then the whole image is used.
	 *
	 * You can directly create a texture from an image and then reuse it multiple times like this :
	 *
	 * ```js
	 * let texture = PIXI.Texture.fromImage('assets/image.png');
	 * let sprite1 = new PIXI.Sprite(texture);
	 * let sprite2 = new PIXI.Sprite(texture);
	 * ```
	 *
	 * Textures made from SVGs, loaded or not, cannot be used before the file finishes processing.
	 * You can check for this by checking the sprite's _textureID property.
	 * ```js
	 * var texture = PIXI.Texture.fromImage('assets/image.svg');
	 * var sprite1 = new PIXI.Sprite(texture);
	 * //sprite1._textureID should not be undefined if the texture has finished processing the SVG file
	 * ```
	 * You can use a ticker or rAF to ensure your sprites load the finished textures after processing. See issue #3068.
	 *
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI
	 */
	var Texture = function (_EventEmitter) {
	    _inherits(Texture, _EventEmitter);
	
	    /**
	     * @param {PIXI.BaseTexture} baseTexture - The base texture source to create the texture from
	     * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
	     * @param {PIXI.Rectangle} [orig] - The area of original texture
	     * @param {PIXI.Rectangle} [trim] - Trimmed rectangle of original texture
	     * @param {number} [rotate] - indicates how the texture was rotated by texture packer. See {@link PIXI.GroupD8}
	     */
	    function Texture(baseTexture, frame, orig, trim, rotate) {
	        _classCallCheck(this, Texture);
	
	        /**
	         * Does this Texture have any frame data assigned to it?
	         *
	         * @member {boolean}
	         */
	        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	        _this.noFrame = false;
	
	        if (!frame) {
	            _this.noFrame = true;
	            frame = new _math.Rectangle(0, 0, 1, 1);
	        }
	
	        if (baseTexture instanceof Texture) {
	            baseTexture = baseTexture.baseTexture;
	        }
	
	        /**
	         * The base texture that this texture uses.
	         *
	         * @member {PIXI.BaseTexture}
	         */
	        _this.baseTexture = baseTexture;
	
	        /**
	         * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
	         * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this._frame = frame;
	
	        /**
	         * This is the trimmed area of original texture, before it was put in atlas
	         * Please call `_updateUvs()` after you change coordinates of `trim` manually.
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this.trim = trim;
	
	        /**
	         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
	         *
	         * @member {boolean}
	         */
	        _this.valid = false;
	
	        /**
	         * This will let a renderer know that a texture has been updated (used mainly for webGL uv updates)
	         *
	         * @member {boolean}
	         */
	        _this.requiresUpdate = false;
	
	        /**
	         * The WebGL UV data cache.
	         *
	         * @member {PIXI.TextureUvs}
	         * @private
	         */
	        _this._uvs = null;
	
	        /**
	         * This is the area of original texture, before it was put in atlas
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this.orig = orig || frame; // new Rectangle(0, 0, 1, 1);
	
	        _this._rotate = Number(rotate || 0);
	
	        if (rotate === true) {
	            // this is old texturepacker legacy, some games/libraries are passing "true" for rotated textures
	            _this._rotate = 2;
	        } else if (_this._rotate % 2 !== 0) {
	            throw new Error('attempt to use diamond-shaped UVs. If you are sure, set rotation manually');
	        }
	
	        if (baseTexture.hasLoaded) {
	            if (_this.noFrame) {
	                frame = new _math.Rectangle(0, 0, baseTexture.width, baseTexture.height);
	
	                // if there is no frame we should monitor for any base texture changes..
	                baseTexture.on('update', _this.onBaseTextureUpdated, _this);
	            }
	            _this.frame = frame;
	        } else {
	            baseTexture.once('loaded', _this.onBaseTextureLoaded, _this);
	        }
	
	        /**
	         * Fired when the texture is updated. This happens if the frame or the baseTexture is updated.
	         *
	         * @event PIXI.Texture#update
	         * @protected
	         * @param {PIXI.Texture} texture - Instance of texture being updated.
	         */
	
	        _this._updateID = 0;
	
	        /**
	         * Contains data for uvs. May contain clamp settings and some matrices.
	         * Its a bit heavy, so by default that object is not created.
	         * @type {PIXI.TextureMatrix}
	         * @default null
	         */
	        _this.transform = null;
	
	        /**
	         * The ids under which this Texture has been added to the texture cache. This is
	         * automatically set as long as Texture.addToCache is used, but may not be set if a
	         * Texture is added directly to the TextureCache array.
	         *
	         * @member {string[]}
	         */
	        _this.textureCacheIds = [];
	        return _this;
	    }
	
	    /**
	     * Updates this texture on the gpu.
	     *
	     */
	
	
	    Texture.prototype.update = function update() {
	        this.baseTexture.update();
	    };
	
	    /**
	     * Called when the base texture is loaded
	     *
	     * @private
	     * @param {PIXI.BaseTexture} baseTexture - The base texture.
	     */
	
	
	    Texture.prototype.onBaseTextureLoaded = function onBaseTextureLoaded(baseTexture) {
	        this._updateID++;
	
	        // TODO this code looks confusing.. boo to abusing getters and setters!
	        if (this.noFrame) {
	            this.frame = new _math.Rectangle(0, 0, baseTexture.width, baseTexture.height);
	        } else {
	            this.frame = this._frame;
	        }
	
	        this.baseTexture.on('update', this.onBaseTextureUpdated, this);
	        this.emit('update', this);
	    };
	
	    /**
	     * Called when the base texture is updated
	     *
	     * @private
	     * @param {PIXI.BaseTexture} baseTexture - The base texture.
	     */
	
	
	    Texture.prototype.onBaseTextureUpdated = function onBaseTextureUpdated(baseTexture) {
	        this._updateID++;
	
	        this._frame.width = baseTexture.width;
	        this._frame.height = baseTexture.height;
	
	        this.emit('update', this);
	    };
	
	    /**
	     * Destroys this texture
	     *
	     * @param {boolean} [destroyBase=false] Whether to destroy the base texture as well
	     */
	
	
	    Texture.prototype.destroy = function destroy(destroyBase) {
	        if (this.baseTexture) {
	            if (destroyBase) {
	                // delete the texture if it exists in the texture cache..
	                // this only needs to be removed if the base texture is actually destroyed too..
	                if (_utils.TextureCache[this.baseTexture.imageUrl]) {
	                    Texture.removeFromCache(this.baseTexture.imageUrl);
	                }
	
	                this.baseTexture.destroy();
	            }
	
	            this.baseTexture.off('update', this.onBaseTextureUpdated, this);
	            this.baseTexture.off('loaded', this.onBaseTextureLoaded, this);
	
	            this.baseTexture = null;
	        }
	
	        this._frame = null;
	        this._uvs = null;
	        this.trim = null;
	        this.orig = null;
	
	        this.valid = false;
	
	        Texture.removeFromCache(this);
	        this.textureCacheIds = null;
	    };
	
	    /**
	     * Creates a new texture object that acts the same as this one.
	     *
	     * @return {PIXI.Texture} The new texture
	     */
	
	
	    Texture.prototype.clone = function clone() {
	        return new Texture(this.baseTexture, this.frame, this.orig, this.trim, this.rotate);
	    };
	
	    /**
	     * Updates the internal WebGL UV cache. Use it after you change `frame` or `trim` of the texture.
	     */
	
	
	    Texture.prototype._updateUvs = function _updateUvs() {
	        if (!this._uvs) {
	            this._uvs = new _TextureUvs2.default();
	        }
	
	        this._uvs.set(this._frame, this.baseTexture, this.rotate);
	
	        this._updateID++;
	    };
	
	    /**
	     * Helper function that creates a Texture object from the given image url.
	     * If the image is not in the texture cache it will be  created and loaded.
	     *
	     * @static
	     * @param {string} imageUrl - The image url of the texture
	     * @param {boolean} [crossorigin] - Whether requests should be treated as crossorigin
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with SVG images.
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    Texture.fromImage = function fromImage(imageUrl, crossorigin, scaleMode, sourceScale) {
	        var texture = _utils.TextureCache[imageUrl];
	
	        if (!texture) {
	            texture = new Texture(_BaseTexture2.default.fromImage(imageUrl, crossorigin, scaleMode, sourceScale));
	            Texture.addToCache(texture, imageUrl);
	        }
	
	        return texture;
	    };
	
	    /**
	     * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
	     * The frame ids are created when a Texture packer file has been loaded
	     *
	     * @static
	     * @param {string} frameId - The frame Id of the texture in the cache
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    Texture.fromFrame = function fromFrame(frameId) {
	        var texture = _utils.TextureCache[frameId];
	
	        if (!texture) {
	            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
	        }
	
	        return texture;
	    };
	
	    /**
	     * Helper function that creates a new Texture based on the given canvas element.
	     *
	     * @static
	     * @param {HTMLCanvasElement} canvas - The canvas element source of the texture
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {string} [origin='canvas'] - A string origin of who created the base texture
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    Texture.fromCanvas = function fromCanvas(canvas, scaleMode) {
	        var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'canvas';
	
	        return new Texture(_BaseTexture2.default.fromCanvas(canvas, scaleMode, origin));
	    };
	
	    /**
	     * Helper function that creates a new Texture based on the given video element.
	     *
	     * @static
	     * @param {HTMLVideoElement|string} video - The URL or actual element of the video
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    Texture.fromVideo = function fromVideo(video, scaleMode) {
	        if (typeof video === 'string') {
	            return Texture.fromVideoUrl(video, scaleMode);
	        }
	
	        return new Texture(_VideoBaseTexture2.default.fromVideo(video, scaleMode));
	    };
	
	    /**
	     * Helper function that creates a new Texture based on the video url.
	     *
	     * @static
	     * @param {string} videoUrl - URL of the video
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    Texture.fromVideoUrl = function fromVideoUrl(videoUrl, scaleMode) {
	        return new Texture(_VideoBaseTexture2.default.fromUrl(videoUrl, scaleMode));
	    };
	
	    /**
	     * Helper function that creates a new Texture based on the source you provide.
	     * The source can be - frame id, image url, video url, canvas element, video element, base texture
	     *
	     * @static
	     * @param {number|string|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|PIXI.BaseTexture}
	     *        source - Source to create texture from
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    Texture.from = function from(source) {
	        // TODO auto detect cross origin..
	        // TODO pass in scale mode?
	        if (typeof source === 'string') {
	            var texture = _utils.TextureCache[source];
	
	            if (!texture) {
	                // check if its a video..
	                var isVideo = source.match(/\.(mp4|webm|ogg|h264|avi|mov)$/) !== null;
	
	                if (isVideo) {
	                    return Texture.fromVideoUrl(source);
	                }
	
	                return Texture.fromImage(source);
	            }
	
	            return texture;
	        } else if (source instanceof HTMLImageElement) {
	            return new Texture(_BaseTexture2.default.from(source));
	        } else if (source instanceof HTMLCanvasElement) {
	            return Texture.fromCanvas(source, _settings2.default.SCALE_MODE, 'HTMLCanvasElement');
	        } else if (source instanceof HTMLVideoElement) {
	            return Texture.fromVideo(source);
	        } else if (source instanceof _BaseTexture2.default) {
	            return new Texture(source);
	        }
	
	        // lets assume its a texture!
	        return source;
	    };
	
	    /**
	     * Create a texture from a source and add to the cache.
	     *
	     * @static
	     * @param {HTMLImageElement|HTMLCanvasElement} source - The input source.
	     * @param {String} imageUrl - File name of texture, for cache and resolving resolution.
	     * @param {String} [name] - Human readible name for the texture cache. If no name is
	     *        specified, only `imageUrl` will be used as the cache ID.
	     * @return {PIXI.Texture} Output texture
	     */
	
	
	    Texture.fromLoader = function fromLoader(source, imageUrl, name) {
	        var baseTexture = new _BaseTexture2.default(source, undefined, (0, _utils.getResolutionOfUrl)(imageUrl));
	        var texture = new Texture(baseTexture);
	
	        baseTexture.imageUrl = imageUrl;
	
	        // No name, use imageUrl instead
	        if (!name) {
	            name = imageUrl;
	        }
	
	        // lets also add the frame to pixi's global cache for fromFrame and fromImage fucntions
	        _BaseTexture2.default.addToCache(texture.baseTexture, name);
	        Texture.addToCache(texture, name);
	
	        // also add references by url if they are different.
	        if (name !== imageUrl) {
	            _BaseTexture2.default.addToCache(texture.baseTexture, imageUrl);
	            Texture.addToCache(texture, imageUrl);
	        }
	
	        return texture;
	    };
	
	    /**
	     * Adds a Texture to the global TextureCache. This cache is shared across the whole PIXI object.
	     *
	     * @static
	     * @param {PIXI.Texture} texture - The Texture to add to the cache.
	     * @param {string} id - The id that the Texture will be stored against.
	     */
	
	
	    Texture.addToCache = function addToCache(texture, id) {
	        if (id) {
	            if (texture.textureCacheIds.indexOf(id) === -1) {
	                texture.textureCacheIds.push(id);
	            }
	
	            // @if DEBUG
	            /* eslint-disable no-console */
	            if (_utils.TextureCache[id]) {
	                console.warn('Texture added to the cache with an id [' + id + '] that already had an entry');
	            }
	            /* eslint-enable no-console */
	            // @endif
	
	            _utils.TextureCache[id] = texture;
	        }
	    };
	
	    /**
	     * Remove a Texture from the global TextureCache.
	     *
	     * @static
	     * @param {string|PIXI.Texture} texture - id of a Texture to be removed, or a Texture instance itself
	     * @return {PIXI.Texture|null} The Texture that was removed
	     */
	
	
	    Texture.removeFromCache = function removeFromCache(texture) {
	        if (typeof texture === 'string') {
	            var textureFromCache = _utils.TextureCache[texture];
	
	            if (textureFromCache) {
	                var index = textureFromCache.textureCacheIds.indexOf(texture);
	
	                if (index > -1) {
	                    textureFromCache.textureCacheIds.splice(index, 1);
	                }
	
	                delete _utils.TextureCache[texture];
	
	                return textureFromCache;
	            }
	        } else if (texture && texture.textureCacheIds) {
	            for (var i = 0; i < texture.textureCacheIds.length; ++i) {
	                // Check that texture matches the one being passed in before deleting it from the cache.
	                if (_utils.TextureCache[texture.textureCacheIds[i]] === texture) {
	                    delete _utils.TextureCache[texture.textureCacheIds[i]];
	                }
	            }
	
	            texture.textureCacheIds.length = 0;
	
	            return texture;
	        }
	
	        return null;
	    };
	
	    /**
	     * The frame specifies the region of the base texture that this texture uses.
	     * Please call `_updateUvs()` after you change coordinates of `frame` manually.
	     *
	     * @member {PIXI.Rectangle}
	     */
	
	
	    _createClass(Texture, [{
	        key: 'frame',
	        get: function get() {
	            return this._frame;
	        },
	        set: function set(frame) // eslint-disable-line require-jsdoc
	        {
	            this._frame = frame;
	
	            this.noFrame = false;
	
	            var x = frame.x,
	                y = frame.y,
	                width = frame.width,
	                height = frame.height;
	
	            var xNotFit = x + width > this.baseTexture.width;
	            var yNotFit = y + height > this.baseTexture.height;
	
	            if (xNotFit || yNotFit) {
	                var relationship = xNotFit && yNotFit ? 'and' : 'or';
	                var errorX = 'X: ' + x + ' + ' + width + ' = ' + (x + width) + ' > ' + this.baseTexture.width;
	                var errorY = 'Y: ' + y + ' + ' + height + ' = ' + (y + height) + ' > ' + this.baseTexture.height;
	
	                throw new Error('Texture Error: frame does not fit inside the base Texture dimensions: ' + (errorX + ' ' + relationship + ' ' + errorY));
	            }
	
	            // this.valid = width && height && this.baseTexture.source && this.baseTexture.hasLoaded;
	            this.valid = width && height && this.baseTexture.hasLoaded;
	
	            if (!this.trim && !this.rotate) {
	                this.orig = frame;
	            }
	
	            if (this.valid) {
	                this._updateUvs();
	            }
	        }
	
	        /**
	         * Indicates whether the texture is rotated inside the atlas
	         * set to 2 to compensate for texture packer rotation
	         * set to 6 to compensate for spine packer rotation
	         * can be used to rotate or mirror sprites
	         * See {@link PIXI.GroupD8} for explanation
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'rotate',
	        get: function get() {
	            return this._rotate;
	        },
	        set: function set(rotate) // eslint-disable-line require-jsdoc
	        {
	            this._rotate = rotate;
	            if (this.valid) {
	                this._updateUvs();
	            }
	        }
	
	        /**
	         * The width of the Texture in pixels.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'width',
	        get: function get() {
	            return this.orig.width;
	        }
	
	        /**
	         * The height of the Texture in pixels.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'height',
	        get: function get() {
	            return this.orig.height;
	        }
	    }]);
	
	    return Texture;
	}(_eventemitter2.default);
	
	exports.default = Texture;
	
	
	function createWhiteTexture() {
	    var canvas = document.createElement('canvas');
	
	    canvas.width = 10;
	    canvas.height = 10;
	
	    var context = canvas.getContext('2d');
	
	    context.fillStyle = 'white';
	    context.fillRect(0, 0, 10, 10);
	
	    return new Texture(new _BaseTexture2.default(canvas));
	}
	
	function removeAllHandlers(tex) {
	    tex.destroy = function _emptyDestroy() {/* empty */};
	    tex.on = function _emptyOn() {/* empty */};
	    tex.once = function _emptyOnce() {/* empty */};
	    tex.emit = function _emptyEmit() {/* empty */};
	}
	
	/**
	 * An empty texture, used often to not have to create multiple empty textures.
	 * Can not be destroyed.
	 *
	 * @static
	 * @constant
	 */
	Texture.EMPTY = new Texture(new _BaseTexture2.default());
	removeAllHandlers(Texture.EMPTY);
	removeAllHandlers(Texture.EMPTY.baseTexture);
	
	/**
	 * A white texture of 10x10 size, used for graphics and other things
	 * Can not be destroyed.
	 *
	 * @static
	 * @constant
	 */
	Texture.WHITE = createWhiteTexture();
	removeAllHandlers(Texture.WHITE);
	removeAllHandlers(Texture.WHITE.baseTexture);
	//# sourceMappingURL=Texture.js.map

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(244);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _eventemitter = __webpack_require__(235);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _determineCrossOrigin = __webpack_require__(253);
	
	var _determineCrossOrigin2 = _interopRequireDefault(_determineCrossOrigin);
	
	var _bitTwiddle = __webpack_require__(261);
	
	var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A texture stores the information that represents an image. All textures have a base texture.
	 *
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI
	 */
	var BaseTexture = function (_EventEmitter) {
	    _inherits(BaseTexture, _EventEmitter);
	
	    /**
	     * @param {HTMLImageElement|HTMLCanvasElement} [source] - the source object of the texture.
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture
	     */
	    function BaseTexture(source, scaleMode, resolution) {
	        _classCallCheck(this, BaseTexture);
	
	        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	        _this.uid = (0, _utils.uid)();
	
	        _this.touched = 0;
	
	        /**
	         * The resolution / device pixel ratio of the texture
	         *
	         * @member {number}
	         * @default 1
	         */
	        _this.resolution = resolution || _settings2.default.RESOLUTION;
	
	        /**
	         * The width of the base texture set when the image has loaded
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.width = 100;
	
	        /**
	         * The height of the base texture set when the image has loaded
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.height = 100;
	
	        // TODO docs
	        // used to store the actual dimensions of the source
	        /**
	         * Used to store the actual width of the source of this texture
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.realWidth = 100;
	        /**
	         * Used to store the actual height of the source of this texture
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.realHeight = 100;
	
	        /**
	         * The scale mode to apply when scaling this texture
	         *
	         * @member {number}
	         * @default PIXI.settings.SCALE_MODE
	         * @see PIXI.SCALE_MODES
	         */
	        _this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;
	
	        /**
	         * Set to true once the base texture has successfully loaded.
	         *
	         * This is never true if the underlying source fails to load or has no texture data.
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.hasLoaded = false;
	
	        /**
	         * Set to true if the source is currently loading.
	         *
	         * If an Image source is loading the 'loaded' or 'error' event will be
	         * dispatched when the operation ends. An underyling source that is
	         * immediately-available bypasses loading entirely.
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.isLoading = false;
	
	        /**
	         * The image source that is used to create the texture.
	         *
	         * TODO: Make this a setter that calls loadSource();
	         *
	         * @readonly
	         * @member {HTMLImageElement|HTMLCanvasElement}
	         */
	        _this.source = null; // set in loadSource, if at all
	
	        /**
	         * The image source that is used to create the texture. This is used to
	         * store the original Svg source when it is replaced with a canvas element.
	         *
	         * TODO: Currently not in use but could be used when re-scaling svg.
	         *
	         * @readonly
	         * @member {Image}
	         */
	        _this.origSource = null; // set in loadSvg, if at all
	
	        /**
	         * Type of image defined in source, eg. `png` or `svg`
	         *
	         * @readonly
	         * @member {string}
	         */
	        _this.imageType = null; // set in updateImageType
	
	        /**
	         * Scale for source image. Used with Svg images to scale them before rasterization.
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.sourceScale = 1.0;
	
	        /**
	         * Controls if RGB channels should be pre-multiplied by Alpha  (WebGL only)
	         * All blend modes, and shaders written for default value. Change it on your own risk.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.premultipliedAlpha = true;
	
	        /**
	         * The image url of the texture
	         *
	         * @member {string}
	         */
	        _this.imageUrl = null;
	
	        /**
	         * Whether or not the texture is a power of two, try to use power of two textures as much
	         * as you can
	         *
	         * @private
	         * @member {boolean}
	         */
	        _this.isPowerOfTwo = false;
	
	        // used for webGL
	
	        /**
	         *
	         * Set this to true if a mipmap of this texture needs to be generated. This value needs
	         * to be set before the texture is used
	         * Also the texture must be a power of two size to work
	         *
	         * @member {boolean}
	         * @see PIXI.MIPMAP_TEXTURES
	         */
	        _this.mipmap = _settings2.default.MIPMAP_TEXTURES;
	
	        /**
	         *
	         * WebGL Texture wrap mode
	         *
	         * @member {number}
	         * @see PIXI.WRAP_MODES
	         */
	        _this.wrapMode = _settings2.default.WRAP_MODE;
	
	        /**
	         * A map of renderer IDs to webgl textures
	         *
	         * @private
	         * @member {object<number, WebGLTexture>}
	         */
	        _this._glTextures = {};
	
	        _this._enabled = 0;
	        _this._virtalBoundId = -1;
	
	        /**
	         * If the object has been destroyed via destroy(). If true, it should not be used.
	         *
	         * @member {boolean}
	         * @private
	         * @readonly
	         */
	        _this._destroyed = false;
	
	        /**
	         * The ids under which this BaseTexture has been added to the base texture cache. This is
	         * automatically set as long as BaseTexture.addToCache is used, but may not be set if a
	         * BaseTexture is added directly to the BaseTextureCache array.
	         *
	         * @member {string[]}
	         */
	        _this.textureCacheIds = [];
	
	        // if no source passed don't try to load
	        if (source) {
	            _this.loadSource(source);
	        }
	
	        /**
	         * Fired when a not-immediately-available source finishes loading.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#loaded
	         * @param {PIXI.BaseTexture} baseTexture - Resource loaded.
	         */
	
	        /**
	         * Fired when a not-immediately-available source fails to load.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#error
	         * @param {PIXI.BaseTexture} baseTexture - Resource errored.
	         */
	
	        /**
	         * Fired when BaseTexture is updated.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#update
	         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being updated.
	         */
	
	        /**
	         * Fired when BaseTexture is destroyed.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#dispose
	         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being destroyed.
	         */
	        return _this;
	    }
	
	    /**
	     * Updates the texture on all the webgl renderers, this also assumes the src has changed.
	     *
	     * @fires PIXI.BaseTexture#update
	     */
	
	
	    BaseTexture.prototype.update = function update() {
	        // Svg size is handled during load
	        if (this.imageType !== 'svg') {
	            this.realWidth = this.source.naturalWidth || this.source.videoWidth || this.source.width;
	            this.realHeight = this.source.naturalHeight || this.source.videoHeight || this.source.height;
	
	            this._updateDimensions();
	        }
	
	        this.emit('update', this);
	    };
	
	    /**
	     * Update dimensions from real values
	     */
	
	
	    BaseTexture.prototype._updateDimensions = function _updateDimensions() {
	        this.width = this.realWidth / this.resolution;
	        this.height = this.realHeight / this.resolution;
	
	        this.isPowerOfTwo = _bitTwiddle2.default.isPow2(this.realWidth) && _bitTwiddle2.default.isPow2(this.realHeight);
	    };
	
	    /**
	     * Load a source.
	     *
	     * If the source is not-immediately-available, such as an image that needs to be
	     * downloaded, then the 'loaded' or 'error' event will be dispatched in the future
	     * and `hasLoaded` will remain false after this call.
	     *
	     * The logic state after calling `loadSource` directly or indirectly (eg. `fromImage`, `new BaseTexture`) is:
	     *
	     *     if (texture.hasLoaded) {
	     *        // texture ready for use
	     *     } else if (texture.isLoading) {
	     *        // listen to 'loaded' and/or 'error' events on texture
	     *     } else {
	     *        // not loading, not going to load UNLESS the source is reloaded
	     *        // (it may still make sense to listen to the events)
	     *     }
	     *
	     * @protected
	     * @param {HTMLImageElement|HTMLCanvasElement} source - the source object of the texture.
	     */
	
	
	    BaseTexture.prototype.loadSource = function loadSource(source) {
	        var wasLoading = this.isLoading;
	
	        this.hasLoaded = false;
	        this.isLoading = false;
	
	        if (wasLoading && this.source) {
	            this.source.onload = null;
	            this.source.onerror = null;
	        }
	
	        var firstSourceLoaded = !this.source;
	
	        this.source = source;
	
	        // Apply source if loaded. Otherwise setup appropriate loading monitors.
	        if ((source.src && source.complete || source.getContext) && source.width && source.height) {
	            this._updateImageType();
	
	            if (this.imageType === 'svg') {
	                this._loadSvgSource();
	            } else {
	                this._sourceLoaded();
	            }
	
	            if (firstSourceLoaded) {
	                // send loaded event if previous source was null and we have been passed a pre-loaded IMG element
	                this.emit('loaded', this);
	            }
	        } else if (!source.getContext) {
	            // Image fail / not ready
	            this.isLoading = true;
	
	            var scope = this;
	
	            source.onload = function () {
	                scope._updateImageType();
	                source.onload = null;
	                source.onerror = null;
	
	                if (!scope.isLoading) {
	                    return;
	                }
	
	                scope.isLoading = false;
	                scope._sourceLoaded();
	
	                if (scope.imageType === 'svg') {
	                    scope._loadSvgSource();
	
	                    return;
	                }
	
	                scope.emit('loaded', scope);
	            };
	
	            source.onerror = function () {
	                source.onload = null;
	                source.onerror = null;
	
	                if (!scope.isLoading) {
	                    return;
	                }
	
	                scope.isLoading = false;
	                scope.emit('error', scope);
	            };
	
	            // Per http://www.w3.org/TR/html5/embedded-content-0.html#the-img-element
	            //   "The value of `complete` can thus change while a script is executing."
	            // So complete needs to be re-checked after the callbacks have been added..
	            // NOTE: complete will be true if the image has no src so best to check if the src is set.
	            if (source.complete && source.src) {
	                // ..and if we're complete now, no need for callbacks
	                source.onload = null;
	                source.onerror = null;
	
	                if (scope.imageType === 'svg') {
	                    scope._loadSvgSource();
	
	                    return;
	                }
	
	                this.isLoading = false;
	
	                if (source.width && source.height) {
	                    this._sourceLoaded();
	
	                    // If any previous subscribers possible
	                    if (wasLoading) {
	                        this.emit('loaded', this);
	                    }
	                }
	                // If any previous subscribers possible
	                else if (wasLoading) {
	                        this.emit('error', this);
	                    }
	            }
	        }
	    };
	
	    /**
	     * Updates type of the source image.
	     */
	
	
	    BaseTexture.prototype._updateImageType = function _updateImageType() {
	        if (!this.imageUrl) {
	            return;
	        }
	
	        var dataUri = (0, _utils.decomposeDataUri)(this.imageUrl);
	        var imageType = void 0;
	
	        if (dataUri && dataUri.mediaType === 'image') {
	            // Check for subType validity
	            var firstSubType = dataUri.subType.split('+')[0];
	
	            imageType = (0, _utils.getUrlFileExtension)('.' + firstSubType);
	
	            if (!imageType) {
	                throw new Error('Invalid image type in data URI.');
	            }
	        } else {
	            imageType = (0, _utils.getUrlFileExtension)(this.imageUrl);
	
	            if (!imageType) {
	                imageType = 'png';
	            }
	        }
	
	        this.imageType = imageType;
	    };
	
	    /**
	     * Checks if `source` is an SVG image and whether it's loaded via a URL or a data URI. Then calls
	     * `_loadSvgSourceUsingDataUri` or `_loadSvgSourceUsingXhr`.
	     */
	
	
	    BaseTexture.prototype._loadSvgSource = function _loadSvgSource() {
	        if (this.imageType !== 'svg') {
	            // Do nothing if source is not svg
	            return;
	        }
	
	        var dataUri = (0, _utils.decomposeDataUri)(this.imageUrl);
	
	        if (dataUri) {
	            this._loadSvgSourceUsingDataUri(dataUri);
	        } else {
	            // We got an URL, so we need to do an XHR to check the svg size
	            this._loadSvgSourceUsingXhr();
	        }
	    };
	
	    /**
	     * Reads an SVG string from data URI and then calls `_loadSvgSourceUsingString`.
	     *
	     * @param {string} dataUri - The data uri to load from.
	     */
	
	
	    BaseTexture.prototype._loadSvgSourceUsingDataUri = function _loadSvgSourceUsingDataUri(dataUri) {
	        var svgString = void 0;
	
	        if (dataUri.encoding === 'base64') {
	            if (!atob) {
	                throw new Error('Your browser doesn\'t support base64 conversions.');
	            }
	            svgString = atob(dataUri.data);
	        } else {
	            svgString = dataUri.data;
	        }
	
	        this._loadSvgSourceUsingString(svgString);
	    };
	
	    /**
	     * Loads an SVG string from `imageUrl` using XHR and then calls `_loadSvgSourceUsingString`.
	     */
	
	
	    BaseTexture.prototype._loadSvgSourceUsingXhr = function _loadSvgSourceUsingXhr() {
	        var _this2 = this;
	
	        var svgXhr = new XMLHttpRequest();
	
	        // This throws error on IE, so SVG Document can't be used
	        // svgXhr.responseType = 'document';
	
	        // This is not needed since we load the svg as string (breaks IE too)
	        // but overrideMimeType() can be used to force the response to be parsed as XML
	        // svgXhr.overrideMimeType('image/svg+xml');
	
	        svgXhr.onload = function () {
	            if (svgXhr.readyState !== svgXhr.DONE || svgXhr.status !== 200) {
	                throw new Error('Failed to load SVG using XHR.');
	            }
	
	            _this2._loadSvgSourceUsingString(svgXhr.response);
	        };
	
	        svgXhr.onerror = function () {
	            return _this2.emit('error', _this2);
	        };
	
	        svgXhr.open('GET', this.imageUrl, true);
	        svgXhr.send();
	    };
	
	    /**
	     * Loads texture using an SVG string. The original SVG Image is stored as `origSource` and the
	     * created canvas is the new `source`. The SVG is scaled using `sourceScale`. Called by
	     * `_loadSvgSourceUsingXhr` or `_loadSvgSourceUsingDataUri`.
	     *
	     * @param  {string} svgString SVG source as string
	     *
	     * @fires PIXI.BaseTexture#loaded
	     */
	
	
	    BaseTexture.prototype._loadSvgSourceUsingString = function _loadSvgSourceUsingString(svgString) {
	        var svgSize = (0, _utils.getSvgSize)(svgString);
	
	        var svgWidth = svgSize.width;
	        var svgHeight = svgSize.height;
	
	        if (!svgWidth || !svgHeight) {
	            throw new Error('The SVG image must have width and height defined (in pixels), canvas API needs them.');
	        }
	
	        // Scale realWidth and realHeight
	        this.realWidth = Math.round(svgWidth * this.sourceScale);
	        this.realHeight = Math.round(svgHeight * this.sourceScale);
	
	        this._updateDimensions();
	
	        // Create a canvas element
	        var canvas = document.createElement('canvas');
	
	        canvas.width = this.realWidth;
	        canvas.height = this.realHeight;
	        canvas._pixiId = 'canvas_' + (0, _utils.uid)();
	
	        // Draw the Svg to the canvas
	        canvas.getContext('2d').drawImage(this.source, 0, 0, svgWidth, svgHeight, 0, 0, this.realWidth, this.realHeight);
	
	        // Replace the original source image with the canvas
	        this.origSource = this.source;
	        this.source = canvas;
	
	        // Add also the canvas in cache (destroy clears by `imageUrl` and `source._pixiId`)
	        BaseTexture.addToCache(this, canvas._pixiId);
	
	        this.isLoading = false;
	        this._sourceLoaded();
	        this.emit('loaded', this);
	    };
	
	    /**
	     * Used internally to update the width, height, and some other tracking vars once
	     * a source has successfully loaded.
	     *
	     * @private
	     */
	
	
	    BaseTexture.prototype._sourceLoaded = function _sourceLoaded() {
	        this.hasLoaded = true;
	        this.update();
	    };
	
	    /**
	     * Destroys this base texture
	     *
	     */
	
	
	    BaseTexture.prototype.destroy = function destroy() {
	        if (this.imageUrl) {
	            delete _utils.TextureCache[this.imageUrl];
	
	            this.imageUrl = null;
	
	            if (!navigator.isCocoonJS) {
	                this.source.src = '';
	            }
	        }
	
	        this.source = null;
	
	        this.dispose();
	
	        BaseTexture.removeFromCache(this);
	        this.textureCacheIds = null;
	
	        this._destroyed = true;
	    };
	
	    /**
	     * Frees the texture from WebGL memory without destroying this texture object.
	     * This means you can still use the texture later which will upload it to GPU
	     * memory again.
	     *
	     * @fires PIXI.BaseTexture#dispose
	     */
	
	
	    BaseTexture.prototype.dispose = function dispose() {
	        this.emit('dispose', this);
	    };
	
	    /**
	     * Changes the source image of the texture.
	     * The original source must be an Image element.
	     *
	     * @param {string} newSrc - the path of the image
	     */
	
	
	    BaseTexture.prototype.updateSourceImage = function updateSourceImage(newSrc) {
	        this.source.src = newSrc;
	
	        this.loadSource(this.source);
	    };
	
	    /**
	     * Helper function that creates a base texture from the given image url.
	     * If the image is not in the base texture cache it will be created and loaded.
	     *
	     * @static
	     * @param {string} imageUrl - The image url of the texture
	     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with Svg images.
	     * @return {PIXI.BaseTexture} The new base texture.
	     */
	
	
	    BaseTexture.fromImage = function fromImage(imageUrl, crossorigin, scaleMode, sourceScale) {
	        var baseTexture = _utils.BaseTextureCache[imageUrl];
	
	        if (!baseTexture) {
	            // new Image() breaks tex loading in some versions of Chrome.
	            // See https://code.google.com/p/chromium/issues/detail?id=238071
	            var image = new Image(); // document.createElement('img');
	
	            if (crossorigin === undefined && imageUrl.indexOf('data:') !== 0) {
	                image.crossOrigin = (0, _determineCrossOrigin2.default)(imageUrl);
	            } else if (crossorigin) {
	                image.crossOrigin = typeof crossorigin === 'string' ? crossorigin : 'anonymous';
	            }
	
	            baseTexture = new BaseTexture(image, scaleMode);
	            baseTexture.imageUrl = imageUrl;
	
	            if (sourceScale) {
	                baseTexture.sourceScale = sourceScale;
	            }
	
	            // if there is an @2x at the end of the url we are going to assume its a highres image
	            baseTexture.resolution = (0, _utils.getResolutionOfUrl)(imageUrl);
	
	            image.src = imageUrl; // Setting this triggers load
	
	            BaseTexture.addToCache(baseTexture, imageUrl);
	        }
	
	        return baseTexture;
	    };
	
	    /**
	     * Helper function that creates a base texture from the given canvas element.
	     *
	     * @static
	     * @param {HTMLCanvasElement} canvas - The canvas element source of the texture
	     * @param {number} scaleMode - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {string} [origin='canvas'] - A string origin of who created the base texture
	     * @return {PIXI.BaseTexture} The new base texture.
	     */
	
	
	    BaseTexture.fromCanvas = function fromCanvas(canvas, scaleMode) {
	        var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'canvas';
	
	        if (!canvas._pixiId) {
	            canvas._pixiId = origin + '_' + (0, _utils.uid)();
	        }
	
	        var baseTexture = _utils.BaseTextureCache[canvas._pixiId];
	
	        if (!baseTexture) {
	            baseTexture = new BaseTexture(canvas, scaleMode);
	            BaseTexture.addToCache(baseTexture, canvas._pixiId);
	        }
	
	        return baseTexture;
	    };
	
	    /**
	     * Helper function that creates a base texture based on the source you provide.
	     * The source can be - image url, image element, canvas element. If the
	     * source is an image url or an image element and not in the base texture
	     * cache, it will be created and loaded.
	     *
	     * @static
	     * @param {string|HTMLImageElement|HTMLCanvasElement} source - The source to create base texture from.
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with Svg images.
	     * @return {PIXI.BaseTexture} The new base texture.
	     */
	
	
	    BaseTexture.from = function from(source, scaleMode, sourceScale) {
	        if (typeof source === 'string') {
	            return BaseTexture.fromImage(source, undefined, scaleMode, sourceScale);
	        } else if (source instanceof HTMLImageElement) {
	            var imageUrl = source.src;
	            var baseTexture = _utils.BaseTextureCache[imageUrl];
	
	            if (!baseTexture) {
	                baseTexture = new BaseTexture(source, scaleMode);
	                baseTexture.imageUrl = imageUrl;
	
	                if (sourceScale) {
	                    baseTexture.sourceScale = sourceScale;
	                }
	
	                // if there is an @2x at the end of the url we are going to assume its a highres image
	                baseTexture.resolution = (0, _utils.getResolutionOfUrl)(imageUrl);
	
	                BaseTexture.addToCache(baseTexture, imageUrl);
	            }
	
	            return baseTexture;
	        } else if (source instanceof HTMLCanvasElement) {
	            return BaseTexture.fromCanvas(source, scaleMode);
	        }
	
	        // lets assume its a base texture!
	        return source;
	    };
	
	    /**
	     * Adds a BaseTexture to the global BaseTextureCache. This cache is shared across the whole PIXI object.
	     *
	     * @static
	     * @param {PIXI.BaseTexture} baseTexture - The BaseTexture to add to the cache.
	     * @param {string} id - The id that the BaseTexture will be stored against.
	     */
	
	
	    BaseTexture.addToCache = function addToCache(baseTexture, id) {
	        if (id) {
	            if (baseTexture.textureCacheIds.indexOf(id) === -1) {
	                baseTexture.textureCacheIds.push(id);
	            }
	
	            // @if DEBUG
	            /* eslint-disable no-console */
	            if (_utils.BaseTextureCache[id]) {
	                console.warn('BaseTexture added to the cache with an id [' + id + '] that already had an entry');
	            }
	            /* eslint-enable no-console */
	            // @endif
	
	            _utils.BaseTextureCache[id] = baseTexture;
	        }
	    };
	
	    /**
	     * Remove a BaseTexture from the global BaseTextureCache.
	     *
	     * @static
	     * @param {string|PIXI.BaseTexture} baseTexture - id of a BaseTexture to be removed, or a BaseTexture instance itself.
	     * @return {PIXI.BaseTexture|null} The BaseTexture that was removed.
	     */
	
	
	    BaseTexture.removeFromCache = function removeFromCache(baseTexture) {
	        if (typeof baseTexture === 'string') {
	            var baseTextureFromCache = _utils.BaseTextureCache[baseTexture];
	
	            if (baseTextureFromCache) {
	                var index = baseTextureFromCache.textureCacheIds.indexOf(baseTexture);
	
	                if (index > -1) {
	                    baseTextureFromCache.textureCacheIds.splice(index, 1);
	                }
	
	                delete _utils.BaseTextureCache[baseTexture];
	
	                return baseTextureFromCache;
	            }
	        } else if (baseTexture && baseTexture.textureCacheIds) {
	            for (var i = 0; i < baseTexture.textureCacheIds.length; ++i) {
	                delete _utils.BaseTextureCache[baseTexture.textureCacheIds[i]];
	            }
	
	            baseTexture.textureCacheIds.length = 0;
	
	            return baseTexture;
	        }
	
	        return null;
	    };
	
	    return BaseTexture;
	}(_eventemitter2.default);
	
	exports.default = BaseTexture;
	//# sourceMappingURL=BaseTexture.js.map

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = determineCrossOrigin;
	
	var _url2 = __webpack_require__(254);
	
	var _url3 = _interopRequireDefault(_url2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tempAnchor = void 0;
	
	/**
	 * Sets the `crossOrigin` property for this resource based on if the url
	 * for this resource is cross-origin. If crossOrigin was manually set, this
	 * function does nothing.
	 * Nipped from the resource loader!
	 *
	 * @ignore
	 * @param {string} url - The url to test.
	 * @param {object} [loc=window.location] - The location object to test against.
	 * @return {string} The crossOrigin value to use (or empty string for none).
	 */
	function determineCrossOrigin(url) {
	    var loc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;
	
	    // data: and javascript: urls are considered same-origin
	    if (url.indexOf('data:') === 0) {
	        return '';
	    }
	
	    // default is window.location
	    loc = loc || window.location;
	
	    if (!tempAnchor) {
	        tempAnchor = document.createElement('a');
	    }
	
	    // let the browser determine the full href for the url of this resource and then
	    // parse with the node url lib, we can't use the properties of the anchor element
	    // because they don't work in IE9 :(
	    tempAnchor.href = url;
	    url = _url3.default.parse(tempAnchor.href);
	
	    var samePort = !url.port && loc.port === '' || url.port === loc.port;
	
	    // if cross origin
	    if (url.hostname !== loc.hostname || !samePort || url.protocol !== loc.protocol) {
	        return 'anonymous';
	    }
	
	    return '';
	}
	//# sourceMappingURL=determineCrossOrigin.js.map

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(255);
	var util = __webpack_require__(257);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(258);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(256)(module), (function() { return this; }())))

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 257 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(259);
	exports.encode = exports.stringify = __webpack_require__(260);


/***/ }),
/* 259 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	/**
	 * Bit twiddling hacks for JavaScript.
	 *
	 * Author: Mikola Lysenko
	 *
	 * Ported from Stanford bit twiddling hack library:
	 *    http://graphics.stanford.edu/~seander/bithacks.html
	 */
	
	"use strict"; "use restrict";
	
	//Number of bits in an integer
	var INT_BITS = 32;
	
	//Constants
	exports.INT_BITS  = INT_BITS;
	exports.INT_MAX   =  0x7fffffff;
	exports.INT_MIN   = -1<<(INT_BITS-1);
	
	//Returns -1, 0, +1 depending on sign of x
	exports.sign = function(v) {
	  return (v > 0) - (v < 0);
	}
	
	//Computes absolute value of integer
	exports.abs = function(v) {
	  var mask = v >> (INT_BITS-1);
	  return (v ^ mask) - mask;
	}
	
	//Computes minimum of integers x and y
	exports.min = function(x, y) {
	  return y ^ ((x ^ y) & -(x < y));
	}
	
	//Computes maximum of integers x and y
	exports.max = function(x, y) {
	  return x ^ ((x ^ y) & -(x < y));
	}
	
	//Checks if a number is a power of two
	exports.isPow2 = function(v) {
	  return !(v & (v-1)) && (!!v);
	}
	
	//Computes log base 2 of v
	exports.log2 = function(v) {
	  var r, shift;
	  r =     (v > 0xFFFF) << 4; v >>>= r;
	  shift = (v > 0xFF  ) << 3; v >>>= shift; r |= shift;
	  shift = (v > 0xF   ) << 2; v >>>= shift; r |= shift;
	  shift = (v > 0x3   ) << 1; v >>>= shift; r |= shift;
	  return r | (v >> 1);
	}
	
	//Computes log base 10 of v
	exports.log10 = function(v) {
	  return  (v >= 1000000000) ? 9 : (v >= 100000000) ? 8 : (v >= 10000000) ? 7 :
	          (v >= 1000000) ? 6 : (v >= 100000) ? 5 : (v >= 10000) ? 4 :
	          (v >= 1000) ? 3 : (v >= 100) ? 2 : (v >= 10) ? 1 : 0;
	}
	
	//Counts number of bits
	exports.popCount = function(v) {
	  v = v - ((v >>> 1) & 0x55555555);
	  v = (v & 0x33333333) + ((v >>> 2) & 0x33333333);
	  return ((v + (v >>> 4) & 0xF0F0F0F) * 0x1010101) >>> 24;
	}
	
	//Counts number of trailing zeros
	function countTrailingZeros(v) {
	  var c = 32;
	  v &= -v;
	  if (v) c--;
	  if (v & 0x0000FFFF) c -= 16;
	  if (v & 0x00FF00FF) c -= 8;
	  if (v & 0x0F0F0F0F) c -= 4;
	  if (v & 0x33333333) c -= 2;
	  if (v & 0x55555555) c -= 1;
	  return c;
	}
	exports.countTrailingZeros = countTrailingZeros;
	
	//Rounds to next power of 2
	exports.nextPow2 = function(v) {
	  v += v === 0;
	  --v;
	  v |= v >>> 1;
	  v |= v >>> 2;
	  v |= v >>> 4;
	  v |= v >>> 8;
	  v |= v >>> 16;
	  return v + 1;
	}
	
	//Rounds down to previous power of 2
	exports.prevPow2 = function(v) {
	  v |= v >>> 1;
	  v |= v >>> 2;
	  v |= v >>> 4;
	  v |= v >>> 8;
	  v |= v >>> 16;
	  return v - (v>>>1);
	}
	
	//Computes parity of word
	exports.parity = function(v) {
	  v ^= v >>> 16;
	  v ^= v >>> 8;
	  v ^= v >>> 4;
	  v &= 0xf;
	  return (0x6996 >>> v) & 1;
	}
	
	var REVERSE_TABLE = new Array(256);
	
	(function(tab) {
	  for(var i=0; i<256; ++i) {
	    var v = i, r = i, s = 7;
	    for (v >>>= 1; v; v >>>= 1) {
	      r <<= 1;
	      r |= v & 1;
	      --s;
	    }
	    tab[i] = (r << s) & 0xff;
	  }
	})(REVERSE_TABLE);
	
	//Reverse bits in a 32 bit word
	exports.reverse = function(v) {
	  return  (REVERSE_TABLE[ v         & 0xff] << 24) |
	          (REVERSE_TABLE[(v >>> 8)  & 0xff] << 16) |
	          (REVERSE_TABLE[(v >>> 16) & 0xff] << 8)  |
	           REVERSE_TABLE[(v >>> 24) & 0xff];
	}
	
	//Interleave bits of 2 coordinates with 16 bits.  Useful for fast quadtree codes
	exports.interleave2 = function(x, y) {
	  x &= 0xFFFF;
	  x = (x | (x << 8)) & 0x00FF00FF;
	  x = (x | (x << 4)) & 0x0F0F0F0F;
	  x = (x | (x << 2)) & 0x33333333;
	  x = (x | (x << 1)) & 0x55555555;
	
	  y &= 0xFFFF;
	  y = (y | (y << 8)) & 0x00FF00FF;
	  y = (y | (y << 4)) & 0x0F0F0F0F;
	  y = (y | (y << 2)) & 0x33333333;
	  y = (y | (y << 1)) & 0x55555555;
	
	  return x | (y << 1);
	}
	
	//Extracts the nth interleaved component
	exports.deinterleave2 = function(v, n) {
	  v = (v >>> n) & 0x55555555;
	  v = (v | (v >>> 1))  & 0x33333333;
	  v = (v | (v >>> 2))  & 0x0F0F0F0F;
	  v = (v | (v >>> 4))  & 0x00FF00FF;
	  v = (v | (v >>> 16)) & 0x000FFFF;
	  return (v << 16) >> 16;
	}
	
	
	//Interleave bits of 3 coordinates, each with 10 bits.  Useful for fast octree codes
	exports.interleave3 = function(x, y, z) {
	  x &= 0x3FF;
	  x  = (x | (x<<16)) & 4278190335;
	  x  = (x | (x<<8))  & 251719695;
	  x  = (x | (x<<4))  & 3272356035;
	  x  = (x | (x<<2))  & 1227133513;
	
	  y &= 0x3FF;
	  y  = (y | (y<<16)) & 4278190335;
	  y  = (y | (y<<8))  & 251719695;
	  y  = (y | (y<<4))  & 3272356035;
	  y  = (y | (y<<2))  & 1227133513;
	  x |= (y << 1);
	  
	  z &= 0x3FF;
	  z  = (z | (z<<16)) & 4278190335;
	  z  = (z | (z<<8))  & 251719695;
	  z  = (z | (z<<4))  & 3272356035;
	  z  = (z | (z<<2))  & 1227133513;
	  
	  return x | (z << 2);
	}
	
	//Extracts nth interleaved component of a 3-tuple
	exports.deinterleave3 = function(v, n) {
	  v = (v >>> n)       & 1227133513;
	  v = (v | (v>>>2))   & 3272356035;
	  v = (v | (v>>>4))   & 251719695;
	  v = (v | (v>>>8))   & 4278190335;
	  v = (v | (v>>>16))  & 0x3FF;
	  return (v<<22)>>22;
	}
	
	//Computes next combination in colexicographic order (this is mistakenly called nextPermutation on the bit twiddling hacks page)
	exports.nextCombination = function(v) {
	  var t = v | (v - 1);
	  return (t + 1) | (((~t & -~t) - 1) >>> (countTrailingZeros(v) + 1));
	}
	


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseTexture2 = __webpack_require__(252);
	
	var _BaseTexture3 = _interopRequireDefault(_BaseTexture2);
	
	var _utils = __webpack_require__(244);
	
	var _ticker = __webpack_require__(263);
	
	var _const = __webpack_require__(205);
	
	var _determineCrossOrigin = __webpack_require__(253);
	
	var _determineCrossOrigin2 = _interopRequireDefault(_determineCrossOrigin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A texture of a [playing] Video.
	 *
	 * Video base textures mimic PixiJS BaseTexture.from.... method in their creation process.
	 *
	 * This can be used in several ways, such as:
	 *
	 * ```js
	 * let texture = PIXI.VideoBaseTexture.fromUrl('http://mydomain.com/video.mp4');
	 *
	 * let texture = PIXI.VideoBaseTexture.fromUrl({ src: 'http://mydomain.com/video.mp4', mime: 'video/mp4' });
	 *
	 * let texture = PIXI.VideoBaseTexture.fromUrls(['/video.webm', '/video.mp4']);
	 *
	 * let texture = PIXI.VideoBaseTexture.fromUrls([
	 *     { src: '/video.webm', mime: 'video/webm' },
	 *     { src: '/video.mp4', mime: 'video/mp4' }
	 * ]);
	 * ```
	 *
	 * See the ["deus" demo](http://www.goodboydigital.com/pixijs/examples/deus/).
	 *
	 * @class
	 * @extends PIXI.BaseTexture
	 * @memberof PIXI
	 */
	var VideoBaseTexture = function (_BaseTexture) {
	    _inherits(VideoBaseTexture, _BaseTexture);
	
	    /**
	     * @param {HTMLVideoElement} source - Video source
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     */
	    function VideoBaseTexture(source, scaleMode) {
	        _classCallCheck(this, VideoBaseTexture);
	
	        if (!source) {
	            throw new Error('No video source element specified.');
	        }
	
	        // hook in here to check if video is already available.
	        // BaseTexture looks for a source.complete boolean, plus width & height.
	
	        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) {
	            source.complete = true;
	        }
	
	        var _this = _possibleConstructorReturn(this, _BaseTexture.call(this, source, scaleMode));
	
	        _this.width = source.videoWidth;
	        _this.height = source.videoHeight;
	
	        _this._autoUpdate = true;
	        _this._isAutoUpdating = false;
	
	        /**
	         * When set to true will automatically play videos used by this texture once
	         * they are loaded. If false, it will not modify the playing state.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.autoPlay = true;
	
	        _this.update = _this.update.bind(_this);
	        _this._onCanPlay = _this._onCanPlay.bind(_this);
	
	        source.addEventListener('play', _this._onPlayStart.bind(_this));
	        source.addEventListener('pause', _this._onPlayStop.bind(_this));
	        _this.hasLoaded = false;
	        _this.__loaded = false;
	
	        if (!_this._isSourceReady()) {
	            source.addEventListener('canplay', _this._onCanPlay);
	            source.addEventListener('canplaythrough', _this._onCanPlay);
	        } else {
	            _this._onCanPlay();
	        }
	        return _this;
	    }
	
	    /**
	     * Returns true if the underlying source is playing.
	     *
	     * @private
	     * @return {boolean} True if playing.
	     */
	
	
	    VideoBaseTexture.prototype._isSourcePlaying = function _isSourcePlaying() {
	        var source = this.source;
	
	        return source.currentTime > 0 && source.paused === false && source.ended === false && source.readyState > 2;
	    };
	
	    /**
	     * Returns true if the underlying source is ready for playing.
	     *
	     * @private
	     * @return {boolean} True if ready.
	     */
	
	
	    VideoBaseTexture.prototype._isSourceReady = function _isSourceReady() {
	        return this.source.readyState === 3 || this.source.readyState === 4;
	    };
	
	    /**
	     * Runs the update loop when the video is ready to play
	     *
	     * @private
	     */
	
	
	    VideoBaseTexture.prototype._onPlayStart = function _onPlayStart() {
	        // Just in case the video has not received its can play even yet..
	        if (!this.hasLoaded) {
	            this._onCanPlay();
	        }
	
	        if (!this._isAutoUpdating && this.autoUpdate) {
	            _ticker.shared.add(this.update, this, _const.UPDATE_PRIORITY.HIGH);
	            this._isAutoUpdating = true;
	        }
	    };
	
	    /**
	     * Fired when a pause event is triggered, stops the update loop
	     *
	     * @private
	     */
	
	
	    VideoBaseTexture.prototype._onPlayStop = function _onPlayStop() {
	        if (this._isAutoUpdating) {
	            _ticker.shared.remove(this.update, this);
	            this._isAutoUpdating = false;
	        }
	    };
	
	    /**
	     * Fired when the video is loaded and ready to play
	     *
	     * @private
	     */
	
	
	    VideoBaseTexture.prototype._onCanPlay = function _onCanPlay() {
	        this.hasLoaded = true;
	
	        if (this.source) {
	            this.source.removeEventListener('canplay', this._onCanPlay);
	            this.source.removeEventListener('canplaythrough', this._onCanPlay);
	
	            this.width = this.source.videoWidth;
	            this.height = this.source.videoHeight;
	
	            // prevent multiple loaded dispatches..
	            if (!this.__loaded) {
	                this.__loaded = true;
	                this.emit('loaded', this);
	            }
	
	            if (this._isSourcePlaying()) {
	                this._onPlayStart();
	            } else if (this.autoPlay) {
	                this.source.play();
	            }
	        }
	    };
	
	    /**
	     * Destroys this texture
	     *
	     */
	
	
	    VideoBaseTexture.prototype.destroy = function destroy() {
	        if (this._isAutoUpdating) {
	            _ticker.shared.remove(this.update, this);
	        }
	
	        if (this.source && this.source._pixiId) {
	            _BaseTexture3.default.removeFromCache(this.source._pixiId);
	            delete this.source._pixiId;
	
	            this.source.pause();
	            this.source.src = '';
	            this.source.load();
	        }
	
	        _BaseTexture.prototype.destroy.call(this);
	    };
	
	    /**
	     * Mimic PixiJS BaseTexture.from.... method.
	     *
	     * @static
	     * @param {HTMLVideoElement} video - Video to create texture from
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.VideoBaseTexture} Newly created VideoBaseTexture
	     */
	
	
	    VideoBaseTexture.fromVideo = function fromVideo(video, scaleMode) {
	        if (!video._pixiId) {
	            video._pixiId = 'video_' + (0, _utils.uid)();
	        }
	
	        var baseTexture = _utils.BaseTextureCache[video._pixiId];
	
	        if (!baseTexture) {
	            baseTexture = new VideoBaseTexture(video, scaleMode);
	            _BaseTexture3.default.addToCache(baseTexture, video._pixiId);
	        }
	
	        return baseTexture;
	    };
	
	    /**
	     * Helper function that creates a new BaseTexture based on the given video element.
	     * This BaseTexture can then be used to create a texture
	     *
	     * @static
	     * @param {string|object|string[]|object[]} videoSrc - The URL(s) for the video.
	     * @param {string} [videoSrc.src] - One of the source urls for the video
	     * @param {string} [videoSrc.mime] - The mimetype of the video (e.g. 'video/mp4'). If not specified
	     *  the url's extension will be used as the second part of the mime type.
	     * @param {number} scaleMode - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
	     * @return {PIXI.VideoBaseTexture} Newly created VideoBaseTexture
	     */
	
	
	    VideoBaseTexture.fromUrl = function fromUrl(videoSrc, scaleMode, crossorigin) {
	        var video = document.createElement('video');
	
	        video.setAttribute('webkit-playsinline', '');
	        video.setAttribute('playsinline', '');
	
	        var url = Array.isArray(videoSrc) ? videoSrc[0].src || videoSrc[0] : videoSrc.src || videoSrc;
	
	        if (crossorigin === undefined && url.indexOf('data:') !== 0) {
	            video.crossOrigin = (0, _determineCrossOrigin2.default)(url);
	        } else if (crossorigin) {
	            video.crossOrigin = typeof crossorigin === 'string' ? crossorigin : 'anonymous';
	        }
	
	        // array of objects or strings
	        if (Array.isArray(videoSrc)) {
	            for (var i = 0; i < videoSrc.length; ++i) {
	                video.appendChild(createSource(videoSrc[i].src || videoSrc[i], videoSrc[i].mime));
	            }
	        }
	        // single object or string
	        else {
	                video.appendChild(createSource(url, videoSrc.mime));
	            }
	
	        video.load();
	
	        return VideoBaseTexture.fromVideo(video, scaleMode);
	    };
	
	    /**
	     * Should the base texture automatically update itself, set to true by default
	     *
	     * @member {boolean}
	     */
	
	
	    _createClass(VideoBaseTexture, [{
	        key: 'autoUpdate',
	        get: function get() {
	            return this._autoUpdate;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (value !== this._autoUpdate) {
	                this._autoUpdate = value;
	
	                if (!this._autoUpdate && this._isAutoUpdating) {
	                    _ticker.shared.remove(this.update, this);
	                    this._isAutoUpdating = false;
	                } else if (this._autoUpdate && !this._isAutoUpdating) {
	                    _ticker.shared.add(this.update, this, _const.UPDATE_PRIORITY.HIGH);
	                    this._isAutoUpdating = true;
	                }
	            }
	        }
	    }]);
	
	    return VideoBaseTexture;
	}(_BaseTexture3.default);
	
	exports.default = VideoBaseTexture;
	
	
	VideoBaseTexture.fromUrls = VideoBaseTexture.fromUrl;
	
	function createSource(path, type) {
	    if (!type) {
	        type = 'video/' + path.substr(path.lastIndexOf('.') + 1);
	    }
	
	    var source = document.createElement('source');
	
	    source.src = path;
	    source.type = type;
	
	    return source;
	}
	//# sourceMappingURL=VideoBaseTexture.js.map

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Ticker = exports.shared = undefined;
	
	var _Ticker = __webpack_require__(264);
	
	var _Ticker2 = _interopRequireDefault(_Ticker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The shared ticker instance used by {@link PIXI.extras.AnimatedSprite}.
	 * and by {@link PIXI.interaction.InteractionManager}.
	 * The property {@link PIXI.ticker.Ticker#autoStart} is set to `true`
	 * for this instance. Please follow the examples for usage, including
	 * how to opt-out of auto-starting the shared ticker.
	 *
	 * @example
	 * let ticker = PIXI.ticker.shared;
	 * // Set this to prevent starting this ticker when listeners are added.
	 * // By default this is true only for the PIXI.ticker.shared instance.
	 * ticker.autoStart = false;
	 * // FYI, call this to ensure the ticker is stopped. It should be stopped
	 * // if you have not attempted to render anything yet.
	 * ticker.stop();
	 * // Call this when you are ready for a running shared ticker.
	 * ticker.start();
	 *
	 * @example
	 * // You may use the shared ticker to render...
	 * let renderer = PIXI.autoDetectRenderer(800, 600);
	 * let stage = new PIXI.Container();
	 * let interactionManager = PIXI.interaction.InteractionManager(renderer);
	 * document.body.appendChild(renderer.view);
	 * ticker.add(function (time) {
	 *     renderer.render(stage);
	 * });
	 *
	 * @example
	 * // Or you can just update it manually.
	 * ticker.autoStart = false;
	 * ticker.stop();
	 * function animate(time) {
	 *     ticker.update(time);
	 *     renderer.render(stage);
	 *     requestAnimationFrame(animate);
	 * }
	 * animate(performance.now());
	 *
	 * @type {PIXI.ticker.Ticker}
	 * @memberof PIXI.ticker
	 */
	var shared = new _Ticker2.default();
	
	shared.autoStart = true;
	shared.destroy = function () {
	  // protect destroying shared ticker
	  // this is used by other internal systems
	  // like AnimatedSprite and InteractionManager
	};
	
	/**
	 * This namespace contains an API for interacting with PIXI's internal global update loop.
	 *
	 * This ticker is used for rendering, {@link PIXI.extras.AnimatedSprite AnimatedSprite},
	 * {@link PIXI.interaction.InteractionManager InteractionManager} and many other time-based PIXI systems.
	 * @example
	 * const ticker = new PIXI.ticker.Ticker();
	 * ticker.stop();
	 * ticker.add((deltaTime) => {
	 *   // do something every frame
	 * });
	 * ticker.start();
	 * @namespace PIXI.ticker
	 */
	exports.shared = shared;
	exports.Ticker = _Ticker2.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _const = __webpack_require__(205);
	
	var _TickerListener = __webpack_require__(265);
	
	var _TickerListener2 = _interopRequireDefault(_TickerListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * A Ticker class that runs an update loop that other objects listen to.
	 * This class is composed around listeners
	 * meant for execution on the next requested animation frame.
	 * Animation frames are requested only when necessary,
	 * e.g. When the ticker is started and the emitter has listeners.
	 *
	 * @class
	 * @memberof PIXI.ticker
	 */
	var Ticker = function () {
	    /**
	     *
	     */
	    function Ticker() {
	        var _this = this;
	
	        _classCallCheck(this, Ticker);
	
	        /**
	         * The first listener. All new listeners added are chained on this.
	         * @private
	         * @type {TickerListener}
	         */
	        this._head = new _TickerListener2.default(null, null, Infinity);
	
	        /**
	         * Internal current frame request ID
	         * @private
	         */
	        this._requestId = null;
	
	        /**
	         * Internal value managed by minFPS property setter and getter.
	         * This is the maximum allowed milliseconds between updates.
	         * @private
	         */
	        this._maxElapsedMS = 100;
	
	        /**
	         * Whether or not this ticker should invoke the method
	         * {@link PIXI.ticker.Ticker#start} automatically
	         * when a listener is added.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        this.autoStart = false;
	
	        /**
	         * Scalar time value from last frame to this frame.
	         * This value is capped by setting {@link PIXI.ticker.Ticker#minFPS}
	         * and is scaled with {@link PIXI.ticker.Ticker#speed}.
	         * **Note:** The cap may be exceeded by scaling.
	         *
	         * @member {number}
	         * @default 1
	         */
	        this.deltaTime = 1;
	
	        /**
	         * Time elapsed in milliseconds from last frame to this frame.
	         * Opposed to what the scalar {@link PIXI.ticker.Ticker#deltaTime}
	         * is based, this value is neither capped nor scaled.
	         * If the platform supports DOMHighResTimeStamp,
	         * this value will have a precision of 1 µs.
	         * Defaults to target frame time
	         *
	         * @member {number}
	         * @default 16.66
	         */
	        this.elapsedMS = 1 / _settings2.default.TARGET_FPMS;
	
	        /**
	         * The last time {@link PIXI.ticker.Ticker#update} was invoked.
	         * This value is also reset internally outside of invoking
	         * update, but only when a new animation frame is requested.
	         * If the platform supports DOMHighResTimeStamp,
	         * this value will have a precision of 1 µs.
	         *
	         * @member {number}
	         * @default -1
	         */
	        this.lastTime = -1;
	
	        /**
	         * Factor of current {@link PIXI.ticker.Ticker#deltaTime}.
	         * @example
	         * // Scales ticker.deltaTime to what would be
	         * // the equivalent of approximately 120 FPS
	         * ticker.speed = 2;
	         *
	         * @member {number}
	         * @default 1
	         */
	        this.speed = 1;
	
	        /**
	         * Whether or not this ticker has been started.
	         * `true` if {@link PIXI.ticker.Ticker#start} has been called.
	         * `false` if {@link PIXI.ticker.Ticker#stop} has been called.
	         * While `false`, this value may change to `true` in the
	         * event of {@link PIXI.ticker.Ticker#autoStart} being `true`
	         * and a listener is added.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        this.started = false;
	
	        /**
	         * Internal tick method bound to ticker instance.
	         * This is because in early 2015, Function.bind
	         * is still 60% slower in high performance scenarios.
	         * Also separating frame requests from update method
	         * so listeners may be called at any time and with
	         * any animation API, just invoke ticker.update(time).
	         *
	         * @private
	         * @param {number} time - Time since last tick.
	         */
	        this._tick = function (time) {
	            _this._requestId = null;
	
	            if (_this.started) {
	                // Invoke listeners now
	                _this.update(time);
	                // Listener side effects may have modified ticker state.
	                if (_this.started && _this._requestId === null && _this._head.next) {
	                    _this._requestId = requestAnimationFrame(_this._tick);
	                }
	            }
	        };
	    }
	
	    /**
	     * Conditionally requests a new animation frame.
	     * If a frame has not already been requested, and if the internal
	     * emitter has listeners, a new frame is requested.
	     *
	     * @private
	     */
	
	
	    Ticker.prototype._requestIfNeeded = function _requestIfNeeded() {
	        if (this._requestId === null && this._head.next) {
	            // ensure callbacks get correct delta
	            this.lastTime = performance.now();
	            this._requestId = requestAnimationFrame(this._tick);
	        }
	    };
	
	    /**
	     * Conditionally cancels a pending animation frame.
	     *
	     * @private
	     */
	
	
	    Ticker.prototype._cancelIfNeeded = function _cancelIfNeeded() {
	        if (this._requestId !== null) {
	            cancelAnimationFrame(this._requestId);
	            this._requestId = null;
	        }
	    };
	
	    /**
	     * Conditionally requests a new animation frame.
	     * If the ticker has been started it checks if a frame has not already
	     * been requested, and if the internal emitter has listeners. If these
	     * conditions are met, a new frame is requested. If the ticker has not
	     * been started, but autoStart is `true`, then the ticker starts now,
	     * and continues with the previous conditions to request a new frame.
	     *
	     * @private
	     */
	
	
	    Ticker.prototype._startIfPossible = function _startIfPossible() {
	        if (this.started) {
	            this._requestIfNeeded();
	        } else if (this.autoStart) {
	            this.start();
	        }
	    };
	
	    /**
	     * Register a handler for tick events. Calls continuously unless
	     * it is removed or the ticker is stopped.
	     *
	     * @param {Function} fn - The listener function to be added for updates
	     * @param {Function} [context] - The listener context
	     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
	     * @returns {PIXI.ticker.Ticker} This instance of a ticker
	     */
	
	
	    Ticker.prototype.add = function add(fn, context) {
	        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _const.UPDATE_PRIORITY.NORMAL;
	
	        return this._addListener(new _TickerListener2.default(fn, context, priority));
	    };
	
	    /**
	     * Add a handler for the tick event which is only execute once.
	     *
	     * @param {Function} fn - The listener function to be added for one update
	     * @param {Function} [context] - The listener context
	     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
	     * @returns {PIXI.ticker.Ticker} This instance of a ticker
	     */
	
	
	    Ticker.prototype.addOnce = function addOnce(fn, context) {
	        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _const.UPDATE_PRIORITY.NORMAL;
	
	        return this._addListener(new _TickerListener2.default(fn, context, priority, true));
	    };
	
	    /**
	     * Internally adds the event handler so that it can be sorted by priority.
	     * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
	     * before the rendering.
	     *
	     * @private
	     * @param {TickerListener} listener - Current listener being added.
	     * @returns {PIXI.ticker.Ticker} This instance of a ticker
	     */
	
	
	    Ticker.prototype._addListener = function _addListener(listener) {
	        // For attaching to head
	        var current = this._head.next;
	        var previous = this._head;
	
	        // Add the first item
	        if (!current) {
	            listener.connect(previous);
	        } else {
	            // Go from highest to lowest priority
	            while (current) {
	                if (listener.priority > current.priority) {
	                    listener.connect(previous);
	                    break;
	                }
	                previous = current;
	                current = current.next;
	            }
	
	            // Not yet connected
	            if (!listener.previous) {
	                listener.connect(previous);
	            }
	        }
	
	        this._startIfPossible();
	
	        return this;
	    };
	
	    /**
	     * Removes any handlers matching the function and context parameters.
	     * If no handlers are left after removing, then it cancels the animation frame.
	     *
	     * @param {Function} fn - The listener function to be removed
	     * @param {Function} [context] - The listener context to be removed
	     * @returns {PIXI.ticker.Ticker} This instance of a ticker
	     */
	
	
	    Ticker.prototype.remove = function remove(fn, context) {
	        var listener = this._head.next;
	
	        while (listener) {
	            // We found a match, lets remove it
	            // no break to delete all possible matches
	            // incase a listener was added 2+ times
	            if (listener.match(fn, context)) {
	                listener = listener.destroy();
	            } else {
	                listener = listener.next;
	            }
	        }
	
	        if (!this._head.next) {
	            this._cancelIfNeeded();
	        }
	
	        return this;
	    };
	
	    /**
	     * Starts the ticker. If the ticker has listeners
	     * a new animation frame is requested at this point.
	     */
	
	
	    Ticker.prototype.start = function start() {
	        if (!this.started) {
	            this.started = true;
	            this._requestIfNeeded();
	        }
	    };
	
	    /**
	     * Stops the ticker. If the ticker has requested
	     * an animation frame it is canceled at this point.
	     */
	
	
	    Ticker.prototype.stop = function stop() {
	        if (this.started) {
	            this.started = false;
	            this._cancelIfNeeded();
	        }
	    };
	
	    /**
	     * Destroy the ticker and don't use after this. Calling
	     * this method removes all references to internal events.
	     */
	
	
	    Ticker.prototype.destroy = function destroy() {
	        this.stop();
	
	        var listener = this._head.next;
	
	        while (listener) {
	            listener = listener.destroy(true);
	        }
	
	        this._head.destroy();
	        this._head = null;
	    };
	
	    /**
	     * Triggers an update. An update entails setting the
	     * current {@link PIXI.ticker.Ticker#elapsedMS},
	     * the current {@link PIXI.ticker.Ticker#deltaTime},
	     * invoking all listeners with current deltaTime,
	     * and then finally setting {@link PIXI.ticker.Ticker#lastTime}
	     * with the value of currentTime that was provided.
	     * This method will be called automatically by animation
	     * frame callbacks if the ticker instance has been started
	     * and listeners are added.
	     *
	     * @param {number} [currentTime=performance.now()] - the current time of execution
	     */
	
	
	    Ticker.prototype.update = function update() {
	        var currentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
	
	        var elapsedMS = void 0;
	
	        // If the difference in time is zero or negative, we ignore most of the work done here.
	        // If there is no valid difference, then should be no reason to let anyone know about it.
	        // A zero delta, is exactly that, nothing should update.
	        //
	        // The difference in time can be negative, and no this does not mean time traveling.
	        // This can be the result of a race condition between when an animation frame is requested
	        // on the current JavaScript engine event loop, and when the ticker's start method is invoked
	        // (which invokes the internal _requestIfNeeded method). If a frame is requested before
	        // _requestIfNeeded is invoked, then the callback for the animation frame the ticker requests,
	        // can receive a time argument that can be less than the lastTime value that was set within
	        // _requestIfNeeded. This difference is in microseconds, but this is enough to cause problems.
	        //
	        // This check covers this browser engine timing issue, as well as if consumers pass an invalid
	        // currentTime value. This may happen if consumers opt-out of the autoStart, and update themselves.
	
	        if (currentTime > this.lastTime) {
	            // Save uncapped elapsedMS for measurement
	            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
	
	            // cap the milliseconds elapsed used for deltaTime
	            if (elapsedMS > this._maxElapsedMS) {
	                elapsedMS = this._maxElapsedMS;
	            }
	
	            this.deltaTime = elapsedMS * _settings2.default.TARGET_FPMS * this.speed;
	
	            // Cache a local reference, in-case ticker is destroyed
	            // during the emit, we can still check for head.next
	            var head = this._head;
	
	            // Invoke listeners added to internal emitter
	            var listener = head.next;
	
	            while (listener) {
	                listener = listener.emit(this.deltaTime);
	            }
	
	            if (!head.next) {
	                this._cancelIfNeeded();
	            }
	        } else {
	            this.deltaTime = this.elapsedMS = 0;
	        }
	
	        this.lastTime = currentTime;
	    };
	
	    /**
	     * The frames per second at which this ticker is running.
	     * The default is approximately 60 in most modern browsers.
	     * **Note:** This does not factor in the value of
	     * {@link PIXI.ticker.Ticker#speed}, which is specific
	     * to scaling {@link PIXI.ticker.Ticker#deltaTime}.
	     *
	     * @member {number}
	     * @readonly
	     */
	
	
	    _createClass(Ticker, [{
	        key: 'FPS',
	        get: function get() {
	            return 1000 / this.elapsedMS;
	        }
	
	        /**
	         * Manages the maximum amount of milliseconds allowed to
	         * elapse between invoking {@link PIXI.ticker.Ticker#update}.
	         * This value is used to cap {@link PIXI.ticker.Ticker#deltaTime},
	         * but does not effect the measured value of {@link PIXI.ticker.Ticker#FPS}.
	         * When setting this property it is clamped to a value between
	         * `0` and `PIXI.settings.TARGET_FPMS * 1000`.
	         *
	         * @member {number}
	         * @default 10
	         */
	
	    }, {
	        key: 'minFPS',
	        get: function get() {
	            return 1000 / this._maxElapsedMS;
	        },
	        set: function set(fps) // eslint-disable-line require-jsdoc
	        {
	            // Clamp: 0 to TARGET_FPMS
	            var minFPMS = Math.min(Math.max(0, fps) / 1000, _settings2.default.TARGET_FPMS);
	
	            this._maxElapsedMS = 1 / minFPMS;
	        }
	    }]);
	
	    return Ticker;
	}();
	
	exports.default = Ticker;
	//# sourceMappingURL=Ticker.js.map

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Internal class for handling the priority sorting of ticker handlers.
	 *
	 * @private
	 * @class
	 * @memberof PIXI.ticker
	 */
	var TickerListener = function () {
	    /**
	     * Constructor
	     *
	     * @param {Function} fn - The listener function to be added for one update
	     * @param {Function} [context=null] - The listener context
	     * @param {number} [priority=0] - The priority for emitting
	     * @param {boolean} [once=false] - If the handler should fire once
	     */
	    function TickerListener(fn) {
	        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        _classCallCheck(this, TickerListener);
	
	        /**
	         * The handler function to execute.
	         * @member {Function}
	         */
	        this.fn = fn;
	
	        /**
	         * The calling to execute.
	         * @member {Function}
	         */
	        this.context = context;
	
	        /**
	         * The current priority.
	         * @member {number}
	         */
	        this.priority = priority;
	
	        /**
	         * If this should only execute once.
	         * @member {boolean}
	         */
	        this.once = once;
	
	        /**
	         * The next item in chain.
	         * @member {TickerListener}
	         */
	        this.next = null;
	
	        /**
	         * The previous item in chain.
	         * @member {TickerListener}
	         */
	        this.previous = null;
	
	        /**
	         * `true` if this listener has been destroyed already.
	         * @member {boolean}
	         * @private
	         */
	        this._destroyed = false;
	    }
	
	    /**
	     * Simple compare function to figure out if a function and context match.
	     *
	     * @param {Function} fn - The listener function to be added for one update
	     * @param {Function} context - The listener context
	     * @return {boolean} `true` if the listener match the arguments
	     */
	
	
	    TickerListener.prototype.match = function match(fn, context) {
	        context = context || null;
	
	        return this.fn === fn && this.context === context;
	    };
	
	    /**
	     * Emit by calling the current function.
	     * @param {number} deltaTime - time since the last emit.
	     * @return {TickerListener} Next ticker
	     */
	
	
	    TickerListener.prototype.emit = function emit(deltaTime) {
	        if (this.fn) {
	            if (this.context) {
	                this.fn.call(this.context, deltaTime);
	            } else {
	                this.fn(deltaTime);
	            }
	        }
	
	        var redirect = this.next;
	
	        if (this.once) {
	            this.destroy(true);
	        }
	
	        // Soft-destroying should remove
	        // the next reference
	        if (this._destroyed) {
	            this.next = null;
	        }
	
	        return redirect;
	    };
	
	    /**
	     * Connect to the list.
	     * @param {TickerListener} previous - Input node, previous listener
	     */
	
	
	    TickerListener.prototype.connect = function connect(previous) {
	        this.previous = previous;
	        if (previous.next) {
	            previous.next.previous = this;
	        }
	        this.next = previous.next;
	        previous.next = this;
	    };
	
	    /**
	     * Destroy and don't use after this.
	     * @param {boolean} [hard = false] `true` to remove the `next` reference, this
	     *        is considered a hard destroy. Soft destroy maintains the next reference.
	     * @return {TickerListener} The listener to redirect while emitting or removing.
	     */
	
	
	    TickerListener.prototype.destroy = function destroy() {
	        var hard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        this._destroyed = true;
	        this.fn = null;
	        this.context = null;
	
	        // Disconnect, hook up next and previous
	        if (this.previous) {
	            this.previous.next = this.next;
	        }
	
	        if (this.next) {
	            this.next.previous = this.previous;
	        }
	
	        // Redirect to the next item
	        var redirect = this.next;
	
	        // Remove references
	        this.next = hard ? null : redirect;
	        this.previous = null;
	
	        return redirect;
	    };
	
	    return TickerListener;
	}();
	
	exports.default = TickerListener;
	//# sourceMappingURL=TickerListener.js.map

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GroupD = __webpack_require__(210);
	
	var _GroupD2 = _interopRequireDefault(_GroupD);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * A standard object to store the Uvs of a texture
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var TextureUvs = function () {
	    /**
	     *
	     */
	    function TextureUvs() {
	        _classCallCheck(this, TextureUvs);
	
	        this.x0 = 0;
	        this.y0 = 0;
	
	        this.x1 = 1;
	        this.y1 = 0;
	
	        this.x2 = 1;
	        this.y2 = 1;
	
	        this.x3 = 0;
	        this.y3 = 1;
	
	        this.uvsUint32 = new Uint32Array(4);
	    }
	
	    /**
	     * Sets the texture Uvs based on the given frame information.
	     *
	     * @private
	     * @param {PIXI.Rectangle} frame - The frame of the texture
	     * @param {PIXI.Rectangle} baseFrame - The base frame of the texture
	     * @param {number} rotate - Rotation of frame, see {@link PIXI.GroupD8}
	     */
	
	
	    TextureUvs.prototype.set = function set(frame, baseFrame, rotate) {
	        var tw = baseFrame.width;
	        var th = baseFrame.height;
	
	        if (rotate) {
	            // width and height div 2 div baseFrame size
	            var w2 = frame.width / 2 / tw;
	            var h2 = frame.height / 2 / th;
	
	            // coordinates of center
	            var cX = frame.x / tw + w2;
	            var cY = frame.y / th + h2;
	
	            rotate = _GroupD2.default.add(rotate, _GroupD2.default.NW); // NW is top-left corner
	            this.x0 = cX + w2 * _GroupD2.default.uX(rotate);
	            this.y0 = cY + h2 * _GroupD2.default.uY(rotate);
	
	            rotate = _GroupD2.default.add(rotate, 2); // rotate 90 degrees clockwise
	            this.x1 = cX + w2 * _GroupD2.default.uX(rotate);
	            this.y1 = cY + h2 * _GroupD2.default.uY(rotate);
	
	            rotate = _GroupD2.default.add(rotate, 2);
	            this.x2 = cX + w2 * _GroupD2.default.uX(rotate);
	            this.y2 = cY + h2 * _GroupD2.default.uY(rotate);
	
	            rotate = _GroupD2.default.add(rotate, 2);
	            this.x3 = cX + w2 * _GroupD2.default.uX(rotate);
	            this.y3 = cY + h2 * _GroupD2.default.uY(rotate);
	        } else {
	            this.x0 = frame.x / tw;
	            this.y0 = frame.y / th;
	
	            this.x1 = (frame.x + frame.width) / tw;
	            this.y1 = frame.y / th;
	
	            this.x2 = (frame.x + frame.width) / tw;
	            this.y2 = (frame.y + frame.height) / th;
	
	            this.x3 = frame.x / tw;
	            this.y3 = (frame.y + frame.height) / th;
	        }
	
	        this.uvsUint32[0] = (this.y0 * 65535 & 0xFFFF) << 16 | this.x0 * 65535 & 0xFFFF;
	        this.uvsUint32[1] = (this.y1 * 65535 & 0xFFFF) << 16 | this.x1 * 65535 & 0xFFFF;
	        this.uvsUint32[2] = (this.y2 * 65535 & 0xFFFF) << 16 | this.x2 * 65535 & 0xFFFF;
	        this.uvsUint32[3] = (this.y3 * 65535 & 0xFFFF) << 16 | this.x3 * 65535 & 0xFFFF;
	    };
	
	    return TextureUvs;
	}();
	
	exports.default = TextureUvs;
	//# sourceMappingURL=TextureUvs.js.map

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CanvasRenderer = __webpack_require__(268);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _const = __webpack_require__(205);
	
	var _math = __webpack_require__(206);
	
	var _CanvasTinter = __webpack_require__(276);
	
	var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var canvasRenderWorldTransform = new _math.Matrix();
	
	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
	 * share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's CanvasSpriteRenderer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/CanvasSpriteRenderer.java
	 */
	
	/**
	 * Renderer dedicated to drawing and batching sprites.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	
	var CanvasSpriteRenderer = function () {
	    /**
	     * @param {PIXI.WebGLRenderer} renderer -The renderer sprite this batch works for.
	     */
	    function CanvasSpriteRenderer(renderer) {
	        _classCallCheck(this, CanvasSpriteRenderer);
	
	        this.renderer = renderer;
	    }
	
	    /**
	     * Renders the sprite object.
	     *
	     * @param {PIXI.Sprite} sprite - the sprite to render when using this spritebatch
	     */
	
	
	    CanvasSpriteRenderer.prototype.render = function render(sprite) {
	        var texture = sprite._texture;
	        var renderer = this.renderer;
	
	        var width = texture._frame.width;
	        var height = texture._frame.height;
	
	        var wt = sprite.transform.worldTransform;
	        var dx = 0;
	        var dy = 0;
	
	        if (texture.orig.width <= 0 || texture.orig.height <= 0 || !texture.baseTexture.source) {
	            return;
	        }
	
	        renderer.setBlendMode(sprite.blendMode);
	
	        //  Ignore null sources
	        if (texture.valid) {
	            renderer.context.globalAlpha = sprite.worldAlpha;
	
	            // If smoothingEnabled is supported and we need to change the smoothing property for sprite texture
	            var smoothingEnabled = texture.baseTexture.scaleMode === _const.SCALE_MODES.LINEAR;
	
	            if (renderer.smoothProperty && renderer.context[renderer.smoothProperty] !== smoothingEnabled) {
	                renderer.context[renderer.smoothProperty] = smoothingEnabled;
	            }
	
	            if (texture.trim) {
	                dx = texture.trim.width / 2 + texture.trim.x - sprite.anchor.x * texture.orig.width;
	                dy = texture.trim.height / 2 + texture.trim.y - sprite.anchor.y * texture.orig.height;
	            } else {
	                dx = (0.5 - sprite.anchor.x) * texture.orig.width;
	                dy = (0.5 - sprite.anchor.y) * texture.orig.height;
	            }
	
	            if (texture.rotate) {
	                wt.copy(canvasRenderWorldTransform);
	                wt = canvasRenderWorldTransform;
	                _math.GroupD8.matrixAppendRotationInv(wt, texture.rotate, dx, dy);
	                // the anchor has already been applied above, so lets set it to zero
	                dx = 0;
	                dy = 0;
	            }
	
	            dx -= width / 2;
	            dy -= height / 2;
	
	            // Allow for pixel rounding
	            if (renderer.roundPixels) {
	                renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution | 0, wt.ty * renderer.resolution | 0);
	
	                dx = dx | 0;
	                dy = dy | 0;
	            } else {
	                renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution, wt.ty * renderer.resolution);
	            }
	
	            var resolution = texture.baseTexture.resolution;
	
	            if (sprite.tint !== 0xFFFFFF) {
	                if (sprite.cachedTint !== sprite.tint || sprite.tintedTexture.tintId !== sprite._texture._updateID) {
	                    sprite.cachedTint = sprite.tint;
	
	                    // TODO clean up caching - how to clean up the caches?
	                    sprite.tintedTexture = _CanvasTinter2.default.getTintedTexture(sprite, sprite.tint);
	                }
	
	                renderer.context.drawImage(sprite.tintedTexture, 0, 0, width * resolution, height * resolution, dx * renderer.resolution, dy * renderer.resolution, width * renderer.resolution, height * renderer.resolution);
	            } else {
	                renderer.context.drawImage(texture.baseTexture.source, texture._frame.x * resolution, texture._frame.y * resolution, width * resolution, height * resolution, dx * renderer.resolution, dy * renderer.resolution, width * renderer.resolution, height * renderer.resolution);
	            }
	        }
	    };
	
	    /**
	     * destroy the sprite object.
	     *
	     */
	
	
	    CanvasSpriteRenderer.prototype.destroy = function destroy() {
	        this.renderer = null;
	    };
	
	    return CanvasSpriteRenderer;
	}();
	
	exports.default = CanvasSpriteRenderer;
	
	
	_CanvasRenderer2.default.registerPlugin('sprite', CanvasSpriteRenderer);
	//# sourceMappingURL=CanvasSpriteRenderer.js.map

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SystemRenderer2 = __webpack_require__(269);
	
	var _SystemRenderer3 = _interopRequireDefault(_SystemRenderer2);
	
	var _CanvasMaskManager = __webpack_require__(272);
	
	var _CanvasMaskManager2 = _interopRequireDefault(_CanvasMaskManager);
	
	var _CanvasRenderTarget = __webpack_require__(273);
	
	var _CanvasRenderTarget2 = _interopRequireDefault(_CanvasRenderTarget);
	
	var _mapCanvasBlendModesToPixi = __webpack_require__(274);
	
	var _mapCanvasBlendModesToPixi2 = _interopRequireDefault(_mapCanvasBlendModesToPixi);
	
	var _utils = __webpack_require__(244);
	
	var _const = __webpack_require__(205);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The CanvasRenderer draws the scene and all its content onto a 2d canvas. This renderer should
	 * be used for browsers that do not support WebGL. Don't forget to add the CanvasRenderer.view to
	 * your DOM or you will not see anything :)
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.SystemRenderer
	 */
	var CanvasRenderer = function (_SystemRenderer) {
	    _inherits(CanvasRenderer, _SystemRenderer);
	
	    // eslint-disable-next-line valid-jsdoc
	    /**
	     * @param {object} [options] - The optional renderer parameters
	     * @param {number} [options.width=800] - the width of the screen
	     * @param {number} [options.height=600] - the height of the screen
	     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	     * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
	     * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
	     *  resolution of the renderer retina would be 2.
	     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
	     *  enable this if you need to call toDataUrl on the webgl context.
	     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	     *      not before the new render pass.
	     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	     *  (shown if not transparent).
	     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
	     *  stopping pixel interpolation.
	     */
	    function CanvasRenderer(options, arg2, arg3) {
	        _classCallCheck(this, CanvasRenderer);
	
	        var _this = _possibleConstructorReturn(this, _SystemRenderer.call(this, 'Canvas', options, arg2, arg3));
	
	        _this.type = _const.RENDERER_TYPE.CANVAS;
	
	        /**
	         * The root canvas 2d context that everything is drawn with.
	         *
	         * @member {CanvasRenderingContext2D}
	         */
	        _this.rootContext = _this.view.getContext('2d', { alpha: _this.transparent });
	
	        /**
	         * The currently active canvas 2d context (could change with renderTextures)
	         *
	         * @member {CanvasRenderingContext2D}
	         */
	        _this.context = _this.rootContext;
	
	        /**
	         * Boolean flag controlling canvas refresh.
	         *
	         * @member {boolean}
	         */
	        _this.refresh = true;
	
	        /**
	         * Instance of a CanvasMaskManager, handles masking when using the canvas renderer.
	         *
	         * @member {PIXI.CanvasMaskManager}
	         */
	        _this.maskManager = new _CanvasMaskManager2.default(_this);
	
	        /**
	         * The canvas property used to set the canvas smoothing property.
	         *
	         * @member {string}
	         */
	        _this.smoothProperty = 'imageSmoothingEnabled';
	
	        if (!_this.rootContext.imageSmoothingEnabled) {
	            if (_this.rootContext.webkitImageSmoothingEnabled) {
	                _this.smoothProperty = 'webkitImageSmoothingEnabled';
	            } else if (_this.rootContext.mozImageSmoothingEnabled) {
	                _this.smoothProperty = 'mozImageSmoothingEnabled';
	            } else if (_this.rootContext.oImageSmoothingEnabled) {
	                _this.smoothProperty = 'oImageSmoothingEnabled';
	            } else if (_this.rootContext.msImageSmoothingEnabled) {
	                _this.smoothProperty = 'msImageSmoothingEnabled';
	            }
	        }
	
	        _this.initPlugins();
	
	        _this.blendModes = (0, _mapCanvasBlendModesToPixi2.default)();
	        _this._activeBlendMode = null;
	
	        _this.renderingToScreen = false;
	
	        _this.resize(_this.options.width, _this.options.height);
	
	        /**
	         * Fired after rendering finishes.
	         *
	         * @event PIXI.CanvasRenderer#postrender
	         */
	
	        /**
	         * Fired before rendering starts.
	         *
	         * @event PIXI.CanvasRenderer#prerender
	         */
	        return _this;
	    }
	
	    /**
	     * Renders the object to this canvas view
	     *
	     * @param {PIXI.DisplayObject} displayObject - The object to be rendered
	     * @param {PIXI.RenderTexture} [renderTexture] - A render texture to be rendered to.
	     *  If unset, it will render to the root context.
	     * @param {boolean} [clear=false] - Whether to clear the canvas before drawing
	     * @param {PIXI.Transform} [transform] - A transformation to be applied
	     * @param {boolean} [skipUpdateTransform=false] - Whether to skip the update transform
	     */
	
	
	    CanvasRenderer.prototype.render = function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
	        if (!this.view) {
	            return;
	        }
	
	        // can be handy to know!
	        this.renderingToScreen = !renderTexture;
	
	        this.emit('prerender');
	
	        var rootResolution = this.resolution;
	
	        if (renderTexture) {
	            renderTexture = renderTexture.baseTexture || renderTexture;
	
	            if (!renderTexture._canvasRenderTarget) {
	                renderTexture._canvasRenderTarget = new _CanvasRenderTarget2.default(renderTexture.width, renderTexture.height, renderTexture.resolution);
	                renderTexture.source = renderTexture._canvasRenderTarget.canvas;
	                renderTexture.valid = true;
	            }
	
	            this.context = renderTexture._canvasRenderTarget.context;
	            this.resolution = renderTexture._canvasRenderTarget.resolution;
	        } else {
	            this.context = this.rootContext;
	        }
	
	        var context = this.context;
	
	        if (!renderTexture) {
	            this._lastObjectRendered = displayObject;
	        }
	
	        if (!skipUpdateTransform) {
	            // update the scene graph
	            var cacheParent = displayObject.parent;
	            var tempWt = this._tempDisplayObjectParent.transform.worldTransform;
	
	            if (transform) {
	                transform.copy(tempWt);
	
	                // lets not forget to flag the parent transform as dirty...
	                this._tempDisplayObjectParent.transform._worldID = -1;
	            } else {
	                tempWt.identity();
	            }
	
	            displayObject.parent = this._tempDisplayObjectParent;
	
	            displayObject.updateTransform();
	            displayObject.parent = cacheParent;
	            // displayObject.hitArea = //TODO add a temp hit area
	        }
	
	        context.save();
	        context.setTransform(1, 0, 0, 1, 0, 0);
	        context.globalAlpha = 1;
	        this._activeBlendMode = _const.BLEND_MODES.NORMAL;
	        context.globalCompositeOperation = this.blendModes[_const.BLEND_MODES.NORMAL];
	
	        if (navigator.isCocoonJS && this.view.screencanvas) {
	            context.fillStyle = 'black';
	            context.clear();
	        }
	
	        if (clear !== undefined ? clear : this.clearBeforeRender) {
	            if (this.renderingToScreen) {
	                if (this.transparent) {
	                    context.clearRect(0, 0, this.width, this.height);
	                } else {
	                    context.fillStyle = this._backgroundColorString;
	                    context.fillRect(0, 0, this.width, this.height);
	                }
	            } // else {
	            // TODO: implement background for CanvasRenderTarget or RenderTexture?
	            // }
	        }
	
	        // TODO RENDER TARGET STUFF HERE..
	        var tempContext = this.context;
	
	        this.context = context;
	        displayObject.renderCanvas(this);
	        this.context = tempContext;
	
	        context.restore();
	
	        this.resolution = rootResolution;
	
	        this.emit('postrender');
	    };
	
	    /**
	     * Clear the canvas of renderer.
	     *
	     * @param {string} [clearColor] - Clear the canvas with this color, except the canvas is transparent.
	     */
	
	
	    CanvasRenderer.prototype.clear = function clear(clearColor) {
	        var context = this.context;
	
	        clearColor = clearColor || this._backgroundColorString;
	
	        if (!this.transparent && clearColor) {
	            context.fillStyle = clearColor;
	            context.fillRect(0, 0, this.width, this.height);
	        } else {
	            context.clearRect(0, 0, this.width, this.height);
	        }
	    };
	
	    /**
	     * Sets the blend mode of the renderer.
	     *
	     * @param {number} blendMode - See {@link PIXI.BLEND_MODES} for valid values.
	     */
	
	
	    CanvasRenderer.prototype.setBlendMode = function setBlendMode(blendMode) {
	        if (this._activeBlendMode === blendMode) {
	            return;
	        }
	
	        this._activeBlendMode = blendMode;
	        this.context.globalCompositeOperation = this.blendModes[blendMode];
	    };
	
	    /**
	     * Removes everything from the renderer and optionally removes the Canvas DOM element.
	     *
	     * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
	     */
	
	
	    CanvasRenderer.prototype.destroy = function destroy(removeView) {
	        this.destroyPlugins();
	
	        // call the base destroy
	        _SystemRenderer.prototype.destroy.call(this, removeView);
	
	        this.context = null;
	
	        this.refresh = true;
	
	        this.maskManager.destroy();
	        this.maskManager = null;
	
	        this.smoothProperty = null;
	    };
	
	    /**
	     * Resizes the canvas view to the specified width and height.
	     *
	     * @extends PIXI.SystemRenderer#resize
	     *
	     * @param {number} screenWidth - the new width of the screen
	     * @param {number} screenHeight - the new height of the screen
	     */
	
	
	    CanvasRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
	        _SystemRenderer.prototype.resize.call(this, screenWidth, screenHeight);
	
	        // reset the scale mode.. oddly this seems to be reset when the canvas is resized.
	        // surely a browser bug?? Let PixiJS fix that for you..
	        if (this.smoothProperty) {
	            this.rootContext[this.smoothProperty] = _settings2.default.SCALE_MODE === _const.SCALE_MODES.LINEAR;
	        }
	    };
	
	    /**
	     * Checks if blend mode has changed.
	     */
	
	
	    CanvasRenderer.prototype.invalidateBlendMode = function invalidateBlendMode() {
	        this._activeBlendMode = this.blendModes.indexOf(this.context.globalCompositeOperation);
	    };
	
	    return CanvasRenderer;
	}(_SystemRenderer3.default);
	
	/**
	 * Collection of installed plugins. These are included by default in PIXI, but can be excluded
	 * by creating a custom build. Consult the README for more information about creating custom
	 * builds and excluding plugins.
	 * @name PIXI.CanvasRenderer#plugins
	 * @type {object}
	 * @readonly
	 * @property {PIXI.accessibility.AccessibilityManager} accessibility Support tabbing interactive elements.
	 * @property {PIXI.extract.CanvasExtract} extract Extract image data from renderer.
	 * @property {PIXI.interaction.InteractionManager} interaction Handles mouse, touch and pointer events.
	 * @property {PIXI.prepare.CanvasPrepare} prepare Pre-render display objects.
	 */
	
	/**
	 * Adds a plugin to the renderer.
	 *
	 * @method PIXI.CanvasRenderer#registerPlugin
	 * @param {string} pluginName - The name of the plugin.
	 * @param {Function} ctor - The constructor function or class for the plugin.
	 */
	
	exports.default = CanvasRenderer;
	_utils.pluginTarget.mixin(CanvasRenderer);
	//# sourceMappingURL=CanvasRenderer.js.map

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(244);
	
	var _math = __webpack_require__(206);
	
	var _const = __webpack_require__(205);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _Container = __webpack_require__(243);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _RenderTexture = __webpack_require__(270);
	
	var _RenderTexture2 = _interopRequireDefault(_RenderTexture);
	
	var _eventemitter = __webpack_require__(235);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tempMatrix = new _math.Matrix();
	
	/**
	 * The SystemRenderer is the base for a PixiJS Renderer. It is extended by the {@link PIXI.CanvasRenderer}
	 * and {@link PIXI.WebGLRenderer} which can be used for rendering a PixiJS scene.
	 *
	 * @abstract
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI
	 */
	
	var SystemRenderer = function (_EventEmitter) {
	  _inherits(SystemRenderer, _EventEmitter);
	
	  // eslint-disable-next-line valid-jsdoc
	  /**
	   * @param {string} system - The name of the system this renderer is for.
	   * @param {object} [options] - The optional renderer parameters
	   * @param {number} [options.width=800] - the width of the screen
	   * @param {number} [options.height=600] - the height of the screen
	   * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	   * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	   * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
	   * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
	   * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
	   *  resolution of the renderer retina would be 2.
	   * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
	   *  enable this if you need to call toDataUrl on the webgl context.
	   * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	   *      not before the new render pass.
	   * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	   *  (shown if not transparent).
	   * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
	   *  stopping pixel interpolation.
	   */
	  function SystemRenderer(system, options, arg2, arg3) {
	    _classCallCheck(this, SystemRenderer);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    (0, _utils.sayHello)(system);
	
	    // Support for constructor(system, screenWidth, screenHeight, options)
	    if (typeof options === 'number') {
	      options = Object.assign({
	        width: options,
	        height: arg2 || _settings2.default.RENDER_OPTIONS.height
	      }, arg3);
	    }
	
	    // Add the default render options
	    options = Object.assign({}, _settings2.default.RENDER_OPTIONS, options);
	
	    /**
	     * The supplied constructor options.
	     *
	     * @member {Object}
	     * @readOnly
	     */
	    _this.options = options;
	
	    /**
	     * The type of the renderer.
	     *
	     * @member {number}
	     * @default PIXI.RENDERER_TYPE.UNKNOWN
	     * @see PIXI.RENDERER_TYPE
	     */
	    _this.type = _const.RENDERER_TYPE.UNKNOWN;
	
	    /**
	     * Measurements of the screen. (0, 0, screenWidth, screenHeight)
	     *
	     * Its safe to use as filterArea or hitArea for whole stage
	     *
	     * @member {PIXI.Rectangle}
	     */
	    _this.screen = new _math.Rectangle(0, 0, options.width, options.height);
	
	    /**
	     * The canvas element that everything is drawn to
	     *
	     * @member {HTMLCanvasElement}
	     */
	    _this.view = options.view || document.createElement('canvas');
	
	    /**
	     * The resolution / device pixel ratio of the renderer
	     *
	     * @member {number}
	     * @default 1
	     */
	    _this.resolution = options.resolution || _settings2.default.RESOLUTION;
	
	    /**
	     * Whether the render view is transparent
	     *
	     * @member {boolean}
	     */
	    _this.transparent = options.transparent;
	
	    /**
	     * Whether css dimensions of canvas view should be resized to screen dimensions automatically
	     *
	     * @member {boolean}
	     */
	    _this.autoResize = options.autoResize || false;
	
	    /**
	     * Tracks the blend modes useful for this renderer.
	     *
	     * @member {object<string, mixed>}
	     */
	    _this.blendModes = null;
	
	    /**
	     * The value of the preserveDrawingBuffer flag affects whether or not the contents of
	     * the stencil buffer is retained after rendering.
	     *
	     * @member {boolean}
	     */
	    _this.preserveDrawingBuffer = options.preserveDrawingBuffer;
	
	    /**
	     * This sets if the CanvasRenderer will clear the canvas or not before the new render pass.
	     * If the scene is NOT transparent PixiJS will use a canvas sized fillRect operation every
	     * frame to set the canvas background color. If the scene is transparent PixiJS will use clearRect
	     * to clear the canvas every frame. Disable this by setting this to false. For example if
	     * your game has a canvas filling background image you often don't need this set.
	     *
	     * @member {boolean}
	     * @default
	     */
	    _this.clearBeforeRender = options.clearBeforeRender;
	
	    /**
	     * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
	     * Handy for crisp pixel art and speed on legacy devices.
	     *
	     * @member {boolean}
	     */
	    _this.roundPixels = options.roundPixels;
	
	    /**
	     * The background color as a number.
	     *
	     * @member {number}
	     * @private
	     */
	    _this._backgroundColor = 0x000000;
	
	    /**
	     * The background color as an [R, G, B] array.
	     *
	     * @member {number[]}
	     * @private
	     */
	    _this._backgroundColorRgba = [0, 0, 0, 0];
	
	    /**
	     * The background color as a string.
	     *
	     * @member {string}
	     * @private
	     */
	    _this._backgroundColorString = '#000000';
	
	    _this.backgroundColor = options.backgroundColor || _this._backgroundColor; // run bg color setter
	
	    /**
	     * This temporary display object used as the parent of the currently being rendered item
	     *
	     * @member {PIXI.DisplayObject}
	     * @private
	     */
	    _this._tempDisplayObjectParent = new _Container2.default();
	
	    /**
	     * The last root object that the renderer tried to render.
	     *
	     * @member {PIXI.DisplayObject}
	     * @private
	     */
	    _this._lastObjectRendered = _this._tempDisplayObjectParent;
	    return _this;
	  }
	
	  /**
	   * Same as view.width, actual number of pixels in the canvas by horizontal
	   *
	   * @member {number}
	   * @readonly
	   * @default 800
	   */
	
	
	  /**
	   * Resizes the screen and canvas to the specified width and height
	   * Canvas dimensions are multiplied by resolution
	   *
	   * @param {number} screenWidth - the new width of the screen
	   * @param {number} screenHeight - the new height of the screen
	   */
	  SystemRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
	    this.screen.width = screenWidth;
	    this.screen.height = screenHeight;
	
	    this.view.width = screenWidth * this.resolution;
	    this.view.height = screenHeight * this.resolution;
	
	    if (this.autoResize) {
	      this.view.style.width = screenWidth + 'px';
	      this.view.style.height = screenHeight + 'px';
	    }
	  };
	
	  /**
	   * Useful function that returns a texture of the display object that can then be used to create sprites
	   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
	   *
	   * @param {PIXI.DisplayObject} displayObject - The displayObject the object will be generated from
	   * @param {number} scaleMode - Should be one of the scaleMode consts
	   * @param {number} resolution - The resolution / device pixel ratio of the texture being generated
	   * @param {PIXI.Rectangle} [region] - The region of the displayObject, that shall be rendered,
	   *        if no region is specified, defaults to the local bounds of the displayObject.
	   * @return {PIXI.Texture} a texture of the graphics object
	   */
	
	
	  SystemRenderer.prototype.generateTexture = function generateTexture(displayObject, scaleMode, resolution, region) {
	    region = region || displayObject.getLocalBounds();
	
	    var renderTexture = _RenderTexture2.default.create(region.width | 0, region.height | 0, scaleMode, resolution);
	
	    tempMatrix.tx = -region.x;
	    tempMatrix.ty = -region.y;
	
	    this.render(displayObject, renderTexture, false, tempMatrix, true);
	
	    return renderTexture;
	  };
	
	  /**
	   * Removes everything from the renderer and optionally removes the Canvas DOM element.
	   *
	   * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
	   */
	
	
	  SystemRenderer.prototype.destroy = function destroy(removeView) {
	    if (removeView && this.view.parentNode) {
	      this.view.parentNode.removeChild(this.view);
	    }
	
	    this.type = _const.RENDERER_TYPE.UNKNOWN;
	
	    this.view = null;
	
	    this.screen = null;
	
	    this.resolution = 0;
	
	    this.transparent = false;
	
	    this.autoResize = false;
	
	    this.blendModes = null;
	
	    this.options = null;
	
	    this.preserveDrawingBuffer = false;
	    this.clearBeforeRender = false;
	
	    this.roundPixels = false;
	
	    this._backgroundColor = 0;
	    this._backgroundColorRgba = null;
	    this._backgroundColorString = null;
	
	    this._tempDisplayObjectParent = null;
	    this._lastObjectRendered = null;
	  };
	
	  /**
	   * The background color to fill if not transparent
	   *
	   * @member {number}
	   */
	
	
	  _createClass(SystemRenderer, [{
	    key: 'width',
	    get: function get() {
	      return this.view.width;
	    }
	
	    /**
	     * Same as view.height, actual number of pixels in the canvas by vertical
	     *
	     * @member {number}
	     * @readonly
	     * @default 600
	     */
	
	  }, {
	    key: 'height',
	    get: function get() {
	      return this.view.height;
	    }
	  }, {
	    key: 'backgroundColor',
	    get: function get() {
	      return this._backgroundColor;
	    },
	    set: function set(value) // eslint-disable-line require-jsdoc
	    {
	      this._backgroundColor = value;
	      this._backgroundColorString = (0, _utils.hex2string)(value);
	      (0, _utils.hex2rgb)(value, this._backgroundColorRgba);
	    }
	  }]);
	
	  return SystemRenderer;
	}(_eventemitter2.default);
	
	exports.default = SystemRenderer;
	//# sourceMappingURL=SystemRenderer.js.map

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BaseRenderTexture = __webpack_require__(271);
	
	var _BaseRenderTexture2 = _interopRequireDefault(_BaseRenderTexture);
	
	var _Texture2 = __webpack_require__(251);
	
	var _Texture3 = _interopRequireDefault(_Texture2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A RenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
	 *
	 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a RenderTexture should be preloaded
	 * otherwise black rectangles will be drawn instead.
	 *
	 * A RenderTexture takes a snapshot of any Display Object given to its render method. For example:
	 *
	 * ```js
	 * let renderer = PIXI.autoDetectRenderer(1024, 1024, { view: canvas, ratio: 1 });
	 * let renderTexture = PIXI.RenderTexture.create(800, 600);
	 * let sprite = PIXI.Sprite.fromImage("spinObj_01.png");
	 *
	 * sprite.position.x = 800/2;
	 * sprite.position.y = 600/2;
	 * sprite.anchor.x = 0.5;
	 * sprite.anchor.y = 0.5;
	 *
	 * renderer.render(sprite, renderTexture);
	 * ```
	 *
	 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
	 * you can clear the transform
	 *
	 * ```js
	 *
	 * sprite.setTransform()
	 *
	 * let renderTexture = new PIXI.RenderTexture.create(100, 100);
	 *
	 * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
	 * ```
	 *
	 * @class
	 * @extends PIXI.Texture
	 * @memberof PIXI
	 */
	var RenderTexture = function (_Texture) {
	    _inherits(RenderTexture, _Texture);
	
	    /**
	     * @param {PIXI.BaseRenderTexture} baseRenderTexture - The renderer used for this RenderTexture
	     * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
	     */
	    function RenderTexture(baseRenderTexture, frame) {
	        _classCallCheck(this, RenderTexture);
	
	        // support for legacy..
	        var _legacyRenderer = null;
	
	        if (!(baseRenderTexture instanceof _BaseRenderTexture2.default)) {
	            /* eslint-disable prefer-rest-params, no-console */
	            var width = arguments[1];
	            var height = arguments[2];
	            var scaleMode = arguments[3];
	            var resolution = arguments[4];
	
	            // we have an old render texture..
	            console.warn('Please use RenderTexture.create(' + width + ', ' + height + ') instead of the ctor directly.');
	            _legacyRenderer = arguments[0];
	            /* eslint-enable prefer-rest-params, no-console */
	
	            frame = null;
	            baseRenderTexture = new _BaseRenderTexture2.default(width, height, scaleMode, resolution);
	        }
	
	        /**
	         * The base texture object that this texture uses
	         *
	         * @member {BaseTexture}
	         */
	
	        var _this = _possibleConstructorReturn(this, _Texture.call(this, baseRenderTexture, frame));
	
	        _this.legacyRenderer = _legacyRenderer;
	
	        /**
	         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
	         *
	         * @member {boolean}
	         */
	        _this.valid = true;
	
	        _this._updateUvs();
	        return _this;
	    }
	
	    /**
	     * Resizes the RenderTexture.
	     *
	     * @param {number} width - The width to resize to.
	     * @param {number} height - The height to resize to.
	     * @param {boolean} doNotResizeBaseTexture - Should the baseTexture.width and height values be resized as well?
	     */
	
	
	    RenderTexture.prototype.resize = function resize(width, height, doNotResizeBaseTexture) {
	        width = Math.ceil(width);
	        height = Math.ceil(height);
	
	        // TODO - could be not required..
	        this.valid = width > 0 && height > 0;
	
	        this._frame.width = this.orig.width = width;
	        this._frame.height = this.orig.height = height;
	
	        if (!doNotResizeBaseTexture) {
	            this.baseTexture.resize(width, height);
	        }
	
	        this._updateUvs();
	    };
	
	    /**
	     * A short hand way of creating a render texture.
	     *
	     * @param {number} [width=100] - The width of the render texture
	     * @param {number} [height=100] - The height of the render texture
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture being generated
	     * @return {PIXI.RenderTexture} The new render texture
	     */
	
	
	    RenderTexture.create = function create(width, height, scaleMode, resolution) {
	        return new RenderTexture(new _BaseRenderTexture2.default(width, height, scaleMode, resolution));
	    };
	
	    return RenderTexture;
	}(_Texture3.default);
	
	exports.default = RenderTexture;
	//# sourceMappingURL=RenderTexture.js.map

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BaseTexture2 = __webpack_require__(252);
	
	var _BaseTexture3 = _interopRequireDefault(_BaseTexture2);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A BaseRenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
	 *
	 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a BaseRenderTexture should be preloaded
	 * otherwise black rectangles will be drawn instead.
	 *
	 * A BaseRenderTexture takes a snapshot of any Display Object given to its render method. The position
	 * and rotation of the given Display Objects is ignored. For example:
	 *
	 * ```js
	 * let renderer = PIXI.autoDetectRenderer(1024, 1024, { view: canvas, ratio: 1 });
	 * let baseRenderTexture = new PIXI.BaseRenderTexture(renderer, 800, 600);
	 * let sprite = PIXI.Sprite.fromImage("spinObj_01.png");
	 *
	 * sprite.position.x = 800/2;
	 * sprite.position.y = 600/2;
	 * sprite.anchor.x = 0.5;
	 * sprite.anchor.y = 0.5;
	 *
	 * baseRenderTexture.render(sprite);
	 * ```
	 *
	 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
	 * you can clear the transform
	 *
	 * ```js
	 *
	 * sprite.setTransform()
	 *
	 * let baseRenderTexture = new PIXI.BaseRenderTexture(100, 100);
	 * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
	 *
	 * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
	 * ```
	 *
	 * @class
	 * @extends PIXI.BaseTexture
	 * @memberof PIXI
	 */
	var BaseRenderTexture = function (_BaseTexture) {
	  _inherits(BaseRenderTexture, _BaseTexture);
	
	  /**
	   * @param {number} [width=100] - The width of the base render texture
	   * @param {number} [height=100] - The height of the base render texture
	   * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	   * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture being generated
	   */
	  function BaseRenderTexture() {
	    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
	    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	    var scaleMode = arguments[2];
	    var resolution = arguments[3];
	
	    _classCallCheck(this, BaseRenderTexture);
	
	    var _this = _possibleConstructorReturn(this, _BaseTexture.call(this, null, scaleMode));
	
	    _this.resolution = resolution || _settings2.default.RESOLUTION;
	
	    _this.width = Math.ceil(width);
	    _this.height = Math.ceil(height);
	
	    _this.realWidth = _this.width * _this.resolution;
	    _this.realHeight = _this.height * _this.resolution;
	
	    _this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;
	    _this.hasLoaded = true;
	
	    /**
	     * A map of renderer IDs to webgl renderTargets
	     *
	     * @private
	     * @member {object<number, WebGLTexture>}
	     */
	    _this._glRenderTargets = {};
	
	    /**
	     * A reference to the canvas render target (we only need one as this can be shared across renderers)
	     *
	     * @private
	     * @member {object<number, WebGLTexture>}
	     */
	    _this._canvasRenderTarget = null;
	
	    /**
	     * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
	     *
	     * @member {boolean}
	     */
	    _this.valid = false;
	    return _this;
	  }
	
	  /**
	   * Resizes the BaseRenderTexture.
	   *
	   * @param {number} width - The width to resize to.
	   * @param {number} height - The height to resize to.
	   */
	
	
	  BaseRenderTexture.prototype.resize = function resize(width, height) {
	    width = Math.ceil(width);
	    height = Math.ceil(height);
	
	    if (width === this.width && height === this.height) {
	      return;
	    }
	
	    this.valid = width > 0 && height > 0;
	
	    this.width = width;
	    this.height = height;
	
	    this.realWidth = this.width * this.resolution;
	    this.realHeight = this.height * this.resolution;
	
	    if (!this.valid) {
	      return;
	    }
	
	    this.emit('update', this);
	  };
	
	  /**
	   * Destroys this texture
	   *
	   */
	
	
	  BaseRenderTexture.prototype.destroy = function destroy() {
	    _BaseTexture.prototype.destroy.call(this, true);
	    this.renderer = null;
	  };
	
	  return BaseRenderTexture;
	}(_BaseTexture3.default);
	
	exports.default = BaseRenderTexture;
	//# sourceMappingURL=BaseRenderTexture.js.map

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _const = __webpack_require__(205);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * A set of functions used to handle masking.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CanvasMaskManager = function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
	     */
	    function CanvasMaskManager(renderer) {
	        _classCallCheck(this, CanvasMaskManager);
	
	        this.renderer = renderer;
	    }
	
	    /**
	     * This method adds it to the current stack of masks.
	     *
	     * @param {object} maskData - the maskData that will be pushed
	     */
	
	
	    CanvasMaskManager.prototype.pushMask = function pushMask(maskData) {
	        var renderer = this.renderer;
	
	        renderer.context.save();
	
	        var cacheAlpha = maskData.alpha;
	        var transform = maskData.transform.worldTransform;
	        var resolution = renderer.resolution;
	
	        renderer.context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);
	
	        // TODO suport sprite alpha masks??
	        // lots of effort required. If demand is great enough..
	        if (!maskData._texture) {
	            this.renderGraphicsShape(maskData);
	            renderer.context.clip();
	        }
	
	        maskData.worldAlpha = cacheAlpha;
	    };
	
	    /**
	     * Renders a PIXI.Graphics shape.
	     *
	     * @param {PIXI.Graphics} graphics - The object to render.
	     */
	
	
	    CanvasMaskManager.prototype.renderGraphicsShape = function renderGraphicsShape(graphics) {
	        var context = this.renderer.context;
	        var len = graphics.graphicsData.length;
	
	        if (len === 0) {
	            return;
	        }
	
	        context.beginPath();
	
	        for (var i = 0; i < len; i++) {
	            var data = graphics.graphicsData[i];
	            var shape = data.shape;
	
	            if (data.type === _const.SHAPES.POLY) {
	                var points = shape.points;
	
	                context.moveTo(points[0], points[1]);
	
	                for (var j = 1; j < points.length / 2; j++) {
	                    context.lineTo(points[j * 2], points[j * 2 + 1]);
	                }
	
	                // if the first and last point are the same close the path - much neater :)
	                if (points[0] === points[points.length - 2] && points[1] === points[points.length - 1]) {
	                    context.closePath();
	                }
	            } else if (data.type === _const.SHAPES.RECT) {
	                context.rect(shape.x, shape.y, shape.width, shape.height);
	                context.closePath();
	            } else if (data.type === _const.SHAPES.CIRC) {
	                // TODO - need to be Undefined!
	                context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
	                context.closePath();
	            } else if (data.type === _const.SHAPES.ELIP) {
	                // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
	
	                var w = shape.width * 2;
	                var h = shape.height * 2;
	
	                var x = shape.x - w / 2;
	                var y = shape.y - h / 2;
	
	                var kappa = 0.5522848;
	                var ox = w / 2 * kappa; // control point offset horizontal
	                var oy = h / 2 * kappa; // control point offset vertical
	                var xe = x + w; // x-end
	                var ye = y + h; // y-end
	                var xm = x + w / 2; // x-middle
	                var ym = y + h / 2; // y-middle
	
	                context.moveTo(x, ym);
	                context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
	                context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
	                context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	                context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
	                context.closePath();
	            } else if (data.type === _const.SHAPES.RREC) {
	                var rx = shape.x;
	                var ry = shape.y;
	                var width = shape.width;
	                var height = shape.height;
	                var radius = shape.radius;
	
	                var maxRadius = Math.min(width, height) / 2 | 0;
	
	                radius = radius > maxRadius ? maxRadius : radius;
	
	                context.moveTo(rx, ry + radius);
	                context.lineTo(rx, ry + height - radius);
	                context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
	                context.lineTo(rx + width - radius, ry + height);
	                context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
	                context.lineTo(rx + width, ry + radius);
	                context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
	                context.lineTo(rx + radius, ry);
	                context.quadraticCurveTo(rx, ry, rx, ry + radius);
	                context.closePath();
	            }
	        }
	    };
	
	    /**
	     * Restores the current drawing context to the state it was before the mask was applied.
	     *
	     * @param {PIXI.CanvasRenderer} renderer - The renderer context to use.
	     */
	
	
	    CanvasMaskManager.prototype.popMask = function popMask(renderer) {
	        renderer.context.restore();
	        renderer.invalidateBlendMode();
	    };
	
	    /**
	     * Destroys this canvas mask manager.
	     *
	     */
	
	
	    CanvasMaskManager.prototype.destroy = function destroy() {
	        /* empty */
	    };
	
	    return CanvasMaskManager;
	}();
	
	exports.default = CanvasMaskManager;
	//# sourceMappingURL=CanvasMaskManager.js.map

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Creates a Canvas element of the given size.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CanvasRenderTarget = function () {
	  /**
	   * @param {number} width - the width for the newly created canvas
	   * @param {number} height - the height for the newly created canvas
	   * @param {number} [resolution=1] - The resolution / device pixel ratio of the canvas
	   */
	  function CanvasRenderTarget(width, height, resolution) {
	    _classCallCheck(this, CanvasRenderTarget);
	
	    /**
	     * The Canvas object that belongs to this CanvasRenderTarget.
	     *
	     * @member {HTMLCanvasElement}
	     */
	    this.canvas = document.createElement('canvas');
	
	    /**
	     * A CanvasRenderingContext2D object representing a two-dimensional rendering context.
	     *
	     * @member {CanvasRenderingContext2D}
	     */
	    this.context = this.canvas.getContext('2d');
	
	    this.resolution = resolution || _settings2.default.RESOLUTION;
	
	    this.resize(width, height);
	  }
	
	  /**
	   * Clears the canvas that was created by the CanvasRenderTarget class.
	   *
	   * @private
	   */
	
	
	  CanvasRenderTarget.prototype.clear = function clear() {
	    this.context.setTransform(1, 0, 0, 1, 0, 0);
	    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	  };
	
	  /**
	   * Resizes the canvas to the specified width and height.
	   *
	   * @param {number} width - the new width of the canvas
	   * @param {number} height - the new height of the canvas
	   */
	
	
	  CanvasRenderTarget.prototype.resize = function resize(width, height) {
	    this.canvas.width = width * this.resolution;
	    this.canvas.height = height * this.resolution;
	  };
	
	  /**
	   * Destroys this canvas.
	   *
	   */
	
	
	  CanvasRenderTarget.prototype.destroy = function destroy() {
	    this.context = null;
	    this.canvas = null;
	  };
	
	  /**
	   * The width of the canvas buffer in pixels.
	   *
	   * @member {number}
	   */
	
	
	  _createClass(CanvasRenderTarget, [{
	    key: 'width',
	    get: function get() {
	      return this.canvas.width;
	    },
	    set: function set(val) // eslint-disable-line require-jsdoc
	    {
	      this.canvas.width = val;
	    }
	
	    /**
	     * The height of the canvas buffer in pixels.
	     *
	     * @member {number}
	     */
	
	  }, {
	    key: 'height',
	    get: function get() {
	      return this.canvas.height;
	    },
	    set: function set(val) // eslint-disable-line require-jsdoc
	    {
	      this.canvas.height = val;
	    }
	  }]);
	
	  return CanvasRenderTarget;
	}();
	
	exports.default = CanvasRenderTarget;
	//# sourceMappingURL=CanvasRenderTarget.js.map

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = mapCanvasBlendModesToPixi;
	
	var _const = __webpack_require__(205);
	
	var _canUseNewCanvasBlendModes = __webpack_require__(275);
	
	var _canUseNewCanvasBlendModes2 = _interopRequireDefault(_canUseNewCanvasBlendModes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Maps blend combinations to Canvas.
	 *
	 * @memberof PIXI
	 * @function mapCanvasBlendModesToPixi
	 * @private
	 * @param {string[]} [array=[]] - The array to output into.
	 * @return {string[]} Mapped modes.
	 */
	function mapCanvasBlendModesToPixi() {
	    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    if ((0, _canUseNewCanvasBlendModes2.default)()) {
	        array[_const.BLEND_MODES.NORMAL] = 'source-over';
	        array[_const.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
	        array[_const.BLEND_MODES.MULTIPLY] = 'multiply';
	        array[_const.BLEND_MODES.SCREEN] = 'screen';
	        array[_const.BLEND_MODES.OVERLAY] = 'overlay';
	        array[_const.BLEND_MODES.DARKEN] = 'darken';
	        array[_const.BLEND_MODES.LIGHTEN] = 'lighten';
	        array[_const.BLEND_MODES.COLOR_DODGE] = 'color-dodge';
	        array[_const.BLEND_MODES.COLOR_BURN] = 'color-burn';
	        array[_const.BLEND_MODES.HARD_LIGHT] = 'hard-light';
	        array[_const.BLEND_MODES.SOFT_LIGHT] = 'soft-light';
	        array[_const.BLEND_MODES.DIFFERENCE] = 'difference';
	        array[_const.BLEND_MODES.EXCLUSION] = 'exclusion';
	        array[_const.BLEND_MODES.HUE] = 'hue';
	        array[_const.BLEND_MODES.SATURATION] = 'saturate';
	        array[_const.BLEND_MODES.COLOR] = 'color';
	        array[_const.BLEND_MODES.LUMINOSITY] = 'luminosity';
	    } else {
	        // this means that the browser does not support the cool new blend modes in canvas 'cough' ie 'cough'
	        array[_const.BLEND_MODES.NORMAL] = 'source-over';
	        array[_const.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
	        array[_const.BLEND_MODES.MULTIPLY] = 'source-over';
	        array[_const.BLEND_MODES.SCREEN] = 'source-over';
	        array[_const.BLEND_MODES.OVERLAY] = 'source-over';
	        array[_const.BLEND_MODES.DARKEN] = 'source-over';
	        array[_const.BLEND_MODES.LIGHTEN] = 'source-over';
	        array[_const.BLEND_MODES.COLOR_DODGE] = 'source-over';
	        array[_const.BLEND_MODES.COLOR_BURN] = 'source-over';
	        array[_const.BLEND_MODES.HARD_LIGHT] = 'source-over';
	        array[_const.BLEND_MODES.SOFT_LIGHT] = 'source-over';
	        array[_const.BLEND_MODES.DIFFERENCE] = 'source-over';
	        array[_const.BLEND_MODES.EXCLUSION] = 'source-over';
	        array[_const.BLEND_MODES.HUE] = 'source-over';
	        array[_const.BLEND_MODES.SATURATION] = 'source-over';
	        array[_const.BLEND_MODES.COLOR] = 'source-over';
	        array[_const.BLEND_MODES.LUMINOSITY] = 'source-over';
	    }
	    // not-premultiplied, only for webgl
	    array[_const.BLEND_MODES.NORMAL_NPM] = array[_const.BLEND_MODES.NORMAL];
	    array[_const.BLEND_MODES.ADD_NPM] = array[_const.BLEND_MODES.ADD];
	    array[_const.BLEND_MODES.SCREEN_NPM] = array[_const.BLEND_MODES.SCREEN];
	
	    return array;
	}
	//# sourceMappingURL=mapCanvasBlendModesToPixi.js.map

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = canUseNewCanvasBlendModes;
	/**
	 * Creates a little colored canvas
	 *
	 * @ignore
	 * @param {string} color - The color to make the canvas
	 * @return {canvas} a small canvas element
	 */
	function createColoredCanvas(color) {
	    var canvas = document.createElement('canvas');
	
	    canvas.width = 6;
	    canvas.height = 1;
	
	    var context = canvas.getContext('2d');
	
	    context.fillStyle = color;
	    context.fillRect(0, 0, 6, 1);
	
	    return canvas;
	}
	
	/**
	 * Checks whether the Canvas BlendModes are supported by the current browser
	 *
	 * @return {boolean} whether they are supported
	 */
	function canUseNewCanvasBlendModes() {
	    if (typeof document === 'undefined') {
	        return false;
	    }
	
	    var magenta = createColoredCanvas('#ff00ff');
	    var yellow = createColoredCanvas('#ffff00');
	
	    var canvas = document.createElement('canvas');
	
	    canvas.width = 6;
	    canvas.height = 1;
	
	    var context = canvas.getContext('2d');
	
	    context.globalCompositeOperation = 'multiply';
	    context.drawImage(magenta, 0, 0);
	    context.drawImage(yellow, 2, 0);
	
	    var imageData = context.getImageData(2, 0, 1, 1);
	
	    if (!imageData) {
	        return false;
	    }
	
	    var data = imageData.data;
	
	    return data[0] === 255 && data[1] === 0 && data[2] === 0;
	}
	//# sourceMappingURL=canUseNewCanvasBlendModes.js.map

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(244);
	
	var _canUseNewCanvasBlendModes = __webpack_require__(275);
	
	var _canUseNewCanvasBlendModes2 = _interopRequireDefault(_canUseNewCanvasBlendModes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Utility methods for Sprite/Texture tinting.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CanvasTinter = {
	    /**
	     * Basically this method just needs a sprite and a color and tints the sprite with the given color.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {PIXI.Sprite} sprite - the sprite to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @return {HTMLCanvasElement} The tinted canvas
	     */
	    getTintedTexture: function getTintedTexture(sprite, color) {
	        var texture = sprite._texture;
	
	        color = CanvasTinter.roundColor(color);
	
	        var stringColor = '#' + ('00000' + (color | 0).toString(16)).substr(-6);
	
	        texture.tintCache = texture.tintCache || {};
	
	        var cachedTexture = texture.tintCache[stringColor];
	
	        var canvas = void 0;
	
	        if (cachedTexture) {
	            if (cachedTexture.tintId === texture._updateID) {
	                return texture.tintCache[stringColor];
	            }
	
	            canvas = texture.tintCache[stringColor];
	        } else {
	            canvas = CanvasTinter.canvas || document.createElement('canvas');
	        }
	
	        CanvasTinter.tintMethod(texture, color, canvas);
	
	        canvas.tintId = texture._updateID;
	
	        if (CanvasTinter.convertTintToImage) {
	            // is this better?
	            var tintImage = new Image();
	
	            tintImage.src = canvas.toDataURL();
	
	            texture.tintCache[stringColor] = tintImage;
	        } else {
	            texture.tintCache[stringColor] = canvas;
	            // if we are not converting the texture to an image then we need to lose the reference to the canvas
	            CanvasTinter.canvas = null;
	        }
	
	        return canvas;
	    },
	
	    /**
	     * Tint a texture using the 'multiply' operation.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {PIXI.Texture} texture - the texture to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @param {HTMLCanvasElement} canvas - the current canvas
	     */
	    tintWithMultiply: function tintWithMultiply(texture, color, canvas) {
	        var context = canvas.getContext('2d');
	        var crop = texture._frame.clone();
	        var resolution = texture.baseTexture.resolution;
	
	        crop.x *= resolution;
	        crop.y *= resolution;
	        crop.width *= resolution;
	        crop.height *= resolution;
	
	        canvas.width = Math.ceil(crop.width);
	        canvas.height = Math.ceil(crop.height);
	
	        context.save();
	        context.fillStyle = '#' + ('00000' + (color | 0).toString(16)).substr(-6);
	
	        context.fillRect(0, 0, crop.width, crop.height);
	
	        context.globalCompositeOperation = 'multiply';
	
	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	
	        context.globalCompositeOperation = 'destination-atop';
	
	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	        context.restore();
	    },
	
	    /**
	     * Tint a texture using the 'overlay' operation.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {PIXI.Texture} texture - the texture to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @param {HTMLCanvasElement} canvas - the current canvas
	     */
	    tintWithOverlay: function tintWithOverlay(texture, color, canvas) {
	        var context = canvas.getContext('2d');
	        var crop = texture._frame.clone();
	        var resolution = texture.baseTexture.resolution;
	
	        crop.x *= resolution;
	        crop.y *= resolution;
	        crop.width *= resolution;
	        crop.height *= resolution;
	
	        canvas.width = Math.ceil(crop.width);
	        canvas.height = Math.ceil(crop.height);
	
	        context.save();
	        context.globalCompositeOperation = 'copy';
	        context.fillStyle = '#' + ('00000' + (color | 0).toString(16)).substr(-6);
	        context.fillRect(0, 0, crop.width, crop.height);
	
	        context.globalCompositeOperation = 'destination-atop';
	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	
	        // context.globalCompositeOperation = 'copy';
	        context.restore();
	    },
	
	
	    /**
	     * Tint a texture pixel per pixel.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {PIXI.Texture} texture - the texture to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @param {HTMLCanvasElement} canvas - the current canvas
	     */
	    tintWithPerPixel: function tintWithPerPixel(texture, color, canvas) {
	        var context = canvas.getContext('2d');
	        var crop = texture._frame.clone();
	        var resolution = texture.baseTexture.resolution;
	
	        crop.x *= resolution;
	        crop.y *= resolution;
	        crop.width *= resolution;
	        crop.height *= resolution;
	
	        canvas.width = Math.ceil(crop.width);
	        canvas.height = Math.ceil(crop.height);
	
	        context.save();
	        context.globalCompositeOperation = 'copy';
	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	        context.restore();
	
	        var rgbValues = (0, _utils.hex2rgb)(color);
	        var r = rgbValues[0];
	        var g = rgbValues[1];
	        var b = rgbValues[2];
	
	        var pixelData = context.getImageData(0, 0, crop.width, crop.height);
	
	        var pixels = pixelData.data;
	
	        for (var i = 0; i < pixels.length; i += 4) {
	            pixels[i + 0] *= r;
	            pixels[i + 1] *= g;
	            pixels[i + 2] *= b;
	        }
	
	        context.putImageData(pixelData, 0, 0);
	    },
	
	    /**
	     * Rounds the specified color according to the CanvasTinter.cacheStepsPerColorChannel.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {number} color - the color to round, should be a hex color
	     * @return {number} The rounded color.
	     */
	    roundColor: function roundColor(color) {
	        var step = CanvasTinter.cacheStepsPerColorChannel;
	
	        var rgbValues = (0, _utils.hex2rgb)(color);
	
	        rgbValues[0] = Math.min(255, rgbValues[0] / step * step);
	        rgbValues[1] = Math.min(255, rgbValues[1] / step * step);
	        rgbValues[2] = Math.min(255, rgbValues[2] / step * step);
	
	        return (0, _utils.rgb2hex)(rgbValues);
	    },
	
	    /**
	     * Number of steps which will be used as a cap when rounding colors.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @type {number}
	     */
	    cacheStepsPerColorChannel: 8,
	
	    /**
	     * Tint cache boolean flag.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @type {boolean}
	     */
	    convertTintToImage: false,
	
	    /**
	     * Whether or not the Canvas BlendModes are supported, consequently the ability to tint using the multiply method.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @type {boolean}
	     */
	    canUseMultiply: (0, _canUseNewCanvasBlendModes2.default)(),
	
	    /**
	     * The tinting method that will be used.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @type {tintMethodFunctionType}
	     */
	    tintMethod: 0
	};
	
	CanvasTinter.tintMethod = CanvasTinter.canUseMultiply ? CanvasTinter.tintWithMultiply : CanvasTinter.tintWithPerPixel;
	
	/**
	 * The tintMethod type.
	 *
	 * @memberof PIXI.CanvasTinter
	 * @callback tintMethodFunctionType
	 * @param texture {PIXI.Texture} the texture to tint
	 * @param color {number} the color to use to tint the sprite with
	 * @param canvas {HTMLCanvasElement} the current canvas
	 */
	
	exports.default = CanvasTinter;
	//# sourceMappingURL=CanvasTinter.js.map

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ObjectRenderer2 = __webpack_require__(278);
	
	var _ObjectRenderer3 = _interopRequireDefault(_ObjectRenderer2);
	
	var _WebGLRenderer = __webpack_require__(280);
	
	var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);
	
	var _createIndicesForQuads = __webpack_require__(291);
	
	var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);
	
	var _generateMultiTextureShader = __webpack_require__(300);
	
	var _generateMultiTextureShader2 = _interopRequireDefault(_generateMultiTextureShader);
	
	var _checkMaxIfStatmentsInShader = __webpack_require__(301);
	
	var _checkMaxIfStatmentsInShader2 = _interopRequireDefault(_checkMaxIfStatmentsInShader);
	
	var _BatchBuffer = __webpack_require__(302);
	
	var _BatchBuffer2 = _interopRequireDefault(_BatchBuffer);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _utils = __webpack_require__(244);
	
	var _pixiGlCore = __webpack_require__(216);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	var _bitTwiddle = __webpack_require__(261);
	
	var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TICK = 0;
	var TEXTURE_TICK = 0;
	
	/**
	 * Renderer dedicated to drawing and batching sprites.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 * @extends PIXI.ObjectRenderer
	 */
	
	var SpriteRenderer = function (_ObjectRenderer) {
	    _inherits(SpriteRenderer, _ObjectRenderer);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this sprite batch works for.
	     */
	    function SpriteRenderer(renderer) {
	        _classCallCheck(this, SpriteRenderer);
	
	        /**
	         * Number of values sent in the vertex buffer.
	         * aVertexPosition(2), aTextureCoord(1), aColor(1), aTextureId(1) = 5
	         *
	         * @member {number}
	         */
	        var _this = _possibleConstructorReturn(this, _ObjectRenderer.call(this, renderer));
	
	        _this.vertSize = 5;
	
	        /**
	         * The size of the vertex information in bytes.
	         *
	         * @member {number}
	         */
	        _this.vertByteSize = _this.vertSize * 4;
	
	        /**
	         * The number of images in the SpriteRenderer before it flushes.
	         *
	         * @member {number}
	         */
	        _this.size = _settings2.default.SPRITE_BATCH_SIZE; // 2000 is a nice balance between mobile / desktop
	
	        // the total number of bytes in our batch
	        // let numVerts = this.size * 4 * this.vertByteSize;
	
	        _this.buffers = [];
	        for (var i = 1; i <= _bitTwiddle2.default.nextPow2(_this.size); i *= 2) {
	            _this.buffers.push(new _BatchBuffer2.default(i * 4 * _this.vertByteSize));
	        }
	
	        /**
	         * Holds the indices of the geometry (quads) to draw
	         *
	         * @member {Uint16Array}
	         */
	        _this.indices = (0, _createIndicesForQuads2.default)(_this.size);
	
	        /**
	         * The default shaders that is used if a sprite doesn't have a more specific one.
	         * there is a shader for each number of textures that can be rendererd.
	         * These shaders will also be generated on the fly as required.
	         * @member {PIXI.Shader[]}
	         */
	        _this.shader = null;
	
	        _this.currentIndex = 0;
	        _this.groups = [];
	
	        for (var k = 0; k < _this.size; k++) {
	            _this.groups[k] = { textures: [], textureCount: 0, ids: [], size: 0, start: 0, blend: 0 };
	        }
	
	        _this.sprites = [];
	
	        _this.vertexBuffers = [];
	        _this.vaos = [];
	
	        _this.vaoMax = 2;
	        _this.vertexCount = 0;
	
	        _this.renderer.on('prerender', _this.onPrerender, _this);
	        return _this;
	    }
	
	    /**
	     * Sets up the renderer context and necessary buffers.
	     *
	     * @private
	     */
	
	
	    SpriteRenderer.prototype.onContextChange = function onContextChange() {
	        var gl = this.renderer.gl;
	
	        if (this.renderer.legacy) {
	            this.MAX_TEXTURES = 1;
	        } else {
	            // step 1: first check max textures the GPU can handle.
	            this.MAX_TEXTURES = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), _settings2.default.SPRITE_MAX_TEXTURES);
	
	            // step 2: check the maximum number of if statements the shader can have too..
	            this.MAX_TEXTURES = (0, _checkMaxIfStatmentsInShader2.default)(this.MAX_TEXTURES, gl);
	        }
	
	        this.shader = (0, _generateMultiTextureShader2.default)(gl, this.MAX_TEXTURES);
	
	        // create a couple of buffers
	        this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);
	
	        // we use the second shader as the first one depending on your browser may omit aTextureId
	        // as it is not used by the shader so is optimized out.
	
	        this.renderer.bindVao(null);
	
	        var attrs = this.shader.attributes;
	
	        for (var i = 0; i < this.vaoMax; i++) {
	            /* eslint-disable max-len */
	            var vertexBuffer = this.vertexBuffers[i] = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, null, gl.STREAM_DRAW);
	            /* eslint-enable max-len */
	
	            // build the vao object that will render..
	            var vao = this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(vertexBuffer, attrs.aVertexPosition, gl.FLOAT, false, this.vertByteSize, 0).addAttribute(vertexBuffer, attrs.aTextureCoord, gl.UNSIGNED_SHORT, true, this.vertByteSize, 2 * 4).addAttribute(vertexBuffer, attrs.aColor, gl.UNSIGNED_BYTE, true, this.vertByteSize, 3 * 4);
	
	            if (attrs.aTextureId) {
	                vao.addAttribute(vertexBuffer, attrs.aTextureId, gl.FLOAT, false, this.vertByteSize, 4 * 4);
	            }
	
	            this.vaos[i] = vao;
	        }
	
	        this.vao = this.vaos[0];
	        this.currentBlendMode = 99999;
	
	        this.boundTextures = new Array(this.MAX_TEXTURES);
	    };
	
	    /**
	     * Called before the renderer starts rendering.
	     *
	     */
	
	
	    SpriteRenderer.prototype.onPrerender = function onPrerender() {
	        this.vertexCount = 0;
	    };
	
	    /**
	     * Renders the sprite object.
	     *
	     * @param {PIXI.Sprite} sprite - the sprite to render when using this spritebatch
	     */
	
	
	    SpriteRenderer.prototype.render = function render(sprite) {
	        // TODO set blend modes..
	        // check texture..
	        if (this.currentIndex >= this.size) {
	            this.flush();
	        }
	
	        // get the uvs for the texture
	
	        // if the uvs have not updated then no point rendering just yet!
	        if (!sprite._texture._uvs) {
	            return;
	        }
	
	        // push a texture.
	        // increment the batchsize
	        this.sprites[this.currentIndex++] = sprite;
	    };
	
	    /**
	     * Renders the content and empties the current batch.
	     *
	     */
	
	
	    SpriteRenderer.prototype.flush = function flush() {
	        if (this.currentIndex === 0) {
	            return;
	        }
	
	        var gl = this.renderer.gl;
	        var MAX_TEXTURES = this.MAX_TEXTURES;
	
	        var np2 = _bitTwiddle2.default.nextPow2(this.currentIndex);
	        var log2 = _bitTwiddle2.default.log2(np2);
	        var buffer = this.buffers[log2];
	
	        var sprites = this.sprites;
	        var groups = this.groups;
	
	        var float32View = buffer.float32View;
	        var uint32View = buffer.uint32View;
	
	        var boundTextures = this.boundTextures;
	        var rendererBoundTextures = this.renderer.boundTextures;
	        var touch = this.renderer.textureGC.count;
	
	        var index = 0;
	        var nextTexture = void 0;
	        var currentTexture = void 0;
	        var groupCount = 1;
	        var textureCount = 0;
	        var currentGroup = groups[0];
	        var vertexData = void 0;
	        var uvs = void 0;
	        var blendMode = _utils.premultiplyBlendMode[sprites[0]._texture.baseTexture.premultipliedAlpha ? 1 : 0][sprites[0].blendMode];
	
	        currentGroup.textureCount = 0;
	        currentGroup.start = 0;
	        currentGroup.blend = blendMode;
	
	        TICK++;
	
	        var i = void 0;
	
	        // copy textures..
	        for (i = 0; i < MAX_TEXTURES; ++i) {
	            var bt = rendererBoundTextures[i];
	
	            if (bt._enabled === TICK) {
	                boundTextures[i] = this.renderer.emptyTextures[i];
	                continue;
	            }
	
	            boundTextures[i] = bt;
	            bt._virtalBoundId = i;
	            bt._enabled = TICK;
	        }
	        TICK++;
	
	        for (i = 0; i < this.currentIndex; ++i) {
	            // upload the sprite elemetns...
	            // they have all ready been calculated so we just need to push them into the buffer.
	            var sprite = sprites[i];
	
	            sprites[i] = null;
	
	            nextTexture = sprite._texture.baseTexture;
	
	            var spriteBlendMode = _utils.premultiplyBlendMode[Number(nextTexture.premultipliedAlpha)][sprite.blendMode];
	
	            if (blendMode !== spriteBlendMode) {
	                // finish a group..
	                blendMode = spriteBlendMode;
	
	                // force the batch to break!
	                currentTexture = null;
	                textureCount = MAX_TEXTURES;
	                TICK++;
	            }
	
	            if (currentTexture !== nextTexture) {
	                currentTexture = nextTexture;
	
	                if (nextTexture._enabled !== TICK) {
	                    if (textureCount === MAX_TEXTURES) {
	                        TICK++;
	
	                        currentGroup.size = i - currentGroup.start;
	
	                        textureCount = 0;
	
	                        currentGroup = groups[groupCount++];
	                        currentGroup.blend = blendMode;
	                        currentGroup.textureCount = 0;
	                        currentGroup.start = i;
	                    }
	
	                    nextTexture.touched = touch;
	
	                    if (nextTexture._virtalBoundId === -1) {
	                        for (var j = 0; j < MAX_TEXTURES; ++j) {
	                            var tIndex = (j + TEXTURE_TICK) % MAX_TEXTURES;
	
	                            var t = boundTextures[tIndex];
	
	                            if (t._enabled !== TICK) {
	                                TEXTURE_TICK++;
	
	                                t._virtalBoundId = -1;
	
	                                nextTexture._virtalBoundId = tIndex;
	
	                                boundTextures[tIndex] = nextTexture;
	                                break;
	                            }
	                        }
	                    }
	
	                    nextTexture._enabled = TICK;
	
	                    currentGroup.textureCount++;
	                    currentGroup.ids[textureCount] = nextTexture._virtalBoundId;
	                    currentGroup.textures[textureCount++] = nextTexture;
	                }
	            }
	
	            vertexData = sprite.vertexData;
	
	            // TODO this sum does not need to be set each frame..
	            uvs = sprite._texture._uvs.uvsUint32;
	
	            if (this.renderer.roundPixels) {
	                var resolution = this.renderer.resolution;
	
	                // xy
	                float32View[index] = (vertexData[0] * resolution | 0) / resolution;
	                float32View[index + 1] = (vertexData[1] * resolution | 0) / resolution;
	
	                // xy
	                float32View[index + 5] = (vertexData[2] * resolution | 0) / resolution;
	                float32View[index + 6] = (vertexData[3] * resolution | 0) / resolution;
	
	                // xy
	                float32View[index + 10] = (vertexData[4] * resolution | 0) / resolution;
	                float32View[index + 11] = (vertexData[5] * resolution | 0) / resolution;
	
	                // xy
	                float32View[index + 15] = (vertexData[6] * resolution | 0) / resolution;
	                float32View[index + 16] = (vertexData[7] * resolution | 0) / resolution;
	            } else {
	                // xy
	                float32View[index] = vertexData[0];
	                float32View[index + 1] = vertexData[1];
	
	                // xy
	                float32View[index + 5] = vertexData[2];
	                float32View[index + 6] = vertexData[3];
	
	                // xy
	                float32View[index + 10] = vertexData[4];
	                float32View[index + 11] = vertexData[5];
	
	                // xy
	                float32View[index + 15] = vertexData[6];
	                float32View[index + 16] = vertexData[7];
	            }
	
	            uint32View[index + 2] = uvs[0];
	            uint32View[index + 7] = uvs[1];
	            uint32View[index + 12] = uvs[2];
	            uint32View[index + 17] = uvs[3];
	            /* eslint-disable max-len */
	            var alpha = Math.min(sprite.worldAlpha, 1.0);
	            // we dont call extra function if alpha is 1.0, that's faster
	            var argb = alpha < 1.0 && nextTexture.premultipliedAlpha ? (0, _utils.premultiplyTint)(sprite._tintRGB, alpha) : sprite._tintRGB + (alpha * 255 << 24);
	
	            uint32View[index + 3] = uint32View[index + 8] = uint32View[index + 13] = uint32View[index + 18] = argb;
	            float32View[index + 4] = float32View[index + 9] = float32View[index + 14] = float32View[index + 19] = nextTexture._virtalBoundId;
	            /* eslint-enable max-len */
	
	            index += 20;
	        }
	
	        currentGroup.size = i - currentGroup.start;
	
	        if (!_settings2.default.CAN_UPLOAD_SAME_BUFFER) {
	            // this is still needed for IOS performance..
	            // it really does not like uploading to the same buffer in a single frame!
	            if (this.vaoMax <= this.vertexCount) {
	                this.vaoMax++;
	
	                var attrs = this.shader.attributes;
	
	                /* eslint-disable max-len */
	                var vertexBuffer = this.vertexBuffers[this.vertexCount] = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, null, gl.STREAM_DRAW);
	                /* eslint-enable max-len */
	
	                // build the vao object that will render..
	                var vao = this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(vertexBuffer, attrs.aVertexPosition, gl.FLOAT, false, this.vertByteSize, 0).addAttribute(vertexBuffer, attrs.aTextureCoord, gl.UNSIGNED_SHORT, true, this.vertByteSize, 2 * 4).addAttribute(vertexBuffer, attrs.aColor, gl.UNSIGNED_BYTE, true, this.vertByteSize, 3 * 4);
	
	                if (attrs.aTextureId) {
	                    vao.addAttribute(vertexBuffer, attrs.aTextureId, gl.FLOAT, false, this.vertByteSize, 4 * 4);
	                }
	
	                this.vaos[this.vertexCount] = vao;
	            }
	
	            this.renderer.bindVao(this.vaos[this.vertexCount]);
	
	            this.vertexBuffers[this.vertexCount].upload(buffer.vertices, 0, false);
	
	            this.vertexCount++;
	        } else {
	            // lets use the faster option, always use buffer number 0
	            this.vertexBuffers[this.vertexCount].upload(buffer.vertices, 0, true);
	        }
	
	        for (i = 0; i < MAX_TEXTURES; ++i) {
	            rendererBoundTextures[i]._virtalBoundId = -1;
	        }
	
	        // render the groups..
	        for (i = 0; i < groupCount; ++i) {
	            var group = groups[i];
	            var groupTextureCount = group.textureCount;
	
	            for (var _j = 0; _j < groupTextureCount; _j++) {
	                currentTexture = group.textures[_j];
	
	                // reset virtual ids..
	                // lets do a quick check..
	                if (rendererBoundTextures[group.ids[_j]] !== currentTexture) {
	                    this.renderer.bindTexture(currentTexture, group.ids[_j], true);
	                }
	
	                // reset the virtualId..
	                currentTexture._virtalBoundId = -1;
	            }
	
	            // set the blend mode..
	            this.renderer.state.setBlendMode(group.blend);
	
	            gl.drawElements(gl.TRIANGLES, group.size * 6, gl.UNSIGNED_SHORT, group.start * 6 * 2);
	        }
	
	        // reset elements for the next flush
	        this.currentIndex = 0;
	    };
	
	    /**
	     * Starts a new sprite batch.
	     */
	
	
	    SpriteRenderer.prototype.start = function start() {
	        this.renderer.bindShader(this.shader);
	
	        if (_settings2.default.CAN_UPLOAD_SAME_BUFFER) {
	            // bind buffer #0, we don't need others
	            this.renderer.bindVao(this.vaos[this.vertexCount]);
	
	            this.vertexBuffers[this.vertexCount].bind();
	        }
	    };
	
	    /**
	     * Stops and flushes the current batch.
	     *
	     */
	
	
	    SpriteRenderer.prototype.stop = function stop() {
	        this.flush();
	    };
	
	    /**
	     * Destroys the SpriteRenderer.
	     *
	     */
	
	
	    SpriteRenderer.prototype.destroy = function destroy() {
	        for (var i = 0; i < this.vaoMax; i++) {
	            if (this.vertexBuffers[i]) {
	                this.vertexBuffers[i].destroy();
	            }
	            if (this.vaos[i]) {
	                this.vaos[i].destroy();
	            }
	        }
	
	        if (this.indexBuffer) {
	            this.indexBuffer.destroy();
	        }
	
	        this.renderer.off('prerender', this.onPrerender, this);
	
	        _ObjectRenderer.prototype.destroy.call(this);
	
	        if (this.shader) {
	            this.shader.destroy();
	            this.shader = null;
	        }
	
	        this.vertexBuffers = null;
	        this.vaos = null;
	        this.indexBuffer = null;
	        this.indices = null;
	
	        this.sprites = null;
	
	        for (var _i = 0; _i < this.buffers.length; ++_i) {
	            this.buffers[_i].destroy();
	        }
	    };
	
	    return SpriteRenderer;
	}(_ObjectRenderer3.default);
	
	exports.default = SpriteRenderer;
	
	
	_WebGLRenderer2.default.registerPlugin('sprite', SpriteRenderer);
	//# sourceMappingURL=SpriteRenderer.js.map

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebGLManager2 = __webpack_require__(279);
	
	var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Base for a common object renderer that can be used as a system renderer plugin.
	 *
	 * @class
	 * @extends PIXI.WebGLManager
	 * @memberof PIXI
	 */
	var ObjectRenderer = function (_WebGLManager) {
	  _inherits(ObjectRenderer, _WebGLManager);
	
	  function ObjectRenderer() {
	    _classCallCheck(this, ObjectRenderer);
	
	    return _possibleConstructorReturn(this, _WebGLManager.apply(this, arguments));
	  }
	
	  /**
	   * Starts the renderer and sets the shader
	   *
	   */
	  ObjectRenderer.prototype.start = function start() {}
	  // set the shader..
	
	
	  /**
	   * Stops the renderer
	   *
	   */
	  ;
	
	  ObjectRenderer.prototype.stop = function stop() {
	    this.flush();
	  };
	
	  /**
	   * Stub method for rendering content and emptying the current batch.
	   *
	   */
	
	
	  ObjectRenderer.prototype.flush = function flush() {}
	  // flush!
	
	
	  /**
	   * Renders an object
	   *
	   * @param {PIXI.DisplayObject} object - The object to render.
	   */
	  ;
	
	  ObjectRenderer.prototype.render = function render(object) // eslint-disable-line no-unused-vars
	  {
	    // render the object
	  };
	
	  return ObjectRenderer;
	}(_WebGLManager3.default);
	
	exports.default = ObjectRenderer;
	//# sourceMappingURL=ObjectRenderer.js.map

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @class
	 * @memberof PIXI
	 */
	var WebGLManager = function () {
	  /**
	   * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	   */
	  function WebGLManager(renderer) {
	    _classCallCheck(this, WebGLManager);
	
	    /**
	     * The renderer this manager works for.
	     *
	     * @member {PIXI.WebGLRenderer}
	     */
	    this.renderer = renderer;
	
	    this.renderer.on('context', this.onContextChange, this);
	  }
	
	  /**
	   * Generic method called when there is a WebGL context change.
	   *
	   */
	
	
	  WebGLManager.prototype.onContextChange = function onContextChange() {}
	  // do some codes init!
	
	
	  /**
	   * Generic destroy methods to be overridden by the subclass
	   *
	   */
	  ;
	
	  WebGLManager.prototype.destroy = function destroy() {
	    this.renderer.off('context', this.onContextChange, this);
	
	    this.renderer = null;
	  };
	
	  return WebGLManager;
	}();
	
	exports.default = WebGLManager;
	//# sourceMappingURL=WebGLManager.js.map

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SystemRenderer2 = __webpack_require__(269);
	
	var _SystemRenderer3 = _interopRequireDefault(_SystemRenderer2);
	
	var _MaskManager = __webpack_require__(281);
	
	var _MaskManager2 = _interopRequireDefault(_MaskManager);
	
	var _StencilManager = __webpack_require__(287);
	
	var _StencilManager2 = _interopRequireDefault(_StencilManager);
	
	var _FilterManager = __webpack_require__(288);
	
	var _FilterManager2 = _interopRequireDefault(_FilterManager);
	
	var _RenderTarget = __webpack_require__(289);
	
	var _RenderTarget2 = _interopRequireDefault(_RenderTarget);
	
	var _ObjectRenderer = __webpack_require__(278);
	
	var _ObjectRenderer2 = _interopRequireDefault(_ObjectRenderer);
	
	var _TextureManager = __webpack_require__(294);
	
	var _TextureManager2 = _interopRequireDefault(_TextureManager);
	
	var _BaseTexture = __webpack_require__(252);
	
	var _BaseTexture2 = _interopRequireDefault(_BaseTexture);
	
	var _TextureGarbageCollector = __webpack_require__(295);
	
	var _TextureGarbageCollector2 = _interopRequireDefault(_TextureGarbageCollector);
	
	var _WebGLState = __webpack_require__(296);
	
	var _WebGLState2 = _interopRequireDefault(_WebGLState);
	
	var _mapWebGLDrawModesToPixi = __webpack_require__(298);
	
	var _mapWebGLDrawModesToPixi2 = _interopRequireDefault(_mapWebGLDrawModesToPixi);
	
	var _validateContext = __webpack_require__(299);
	
	var _validateContext2 = _interopRequireDefault(_validateContext);
	
	var _utils = __webpack_require__(244);
	
	var _pixiGlCore = __webpack_require__(216);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	var _const = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTEXT_UID = 0;
	
	/**
	 * The WebGLRenderer draws the scene and all its content onto a webGL enabled canvas. This renderer
	 * should be used for browsers that support webGL. This Render works by automatically managing webGLBatchs.
	 * So no need for Sprite Batches or Sprite Clouds.
	 * Don't forget to add the view to your DOM or you will not see anything :)
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.SystemRenderer
	 */
	
	var WebGLRenderer = function (_SystemRenderer) {
	    _inherits(WebGLRenderer, _SystemRenderer);
	
	    // eslint-disable-next-line valid-jsdoc
	    /**
	     *
	     * @param {object} [options] - The optional renderer parameters
	     * @param {number} [options.width=800] - the width of the screen
	     * @param {number} [options.height=600] - the height of the screen
	     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	     * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
	     * @param {boolean} [options.antialias=false] - sets antialias. If not available natively then FXAA
	     *  antialiasing is used
	     * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
	     *  FXAA is faster, but may not always look as great
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer.
	     *  The resolution of the renderer retina would be 2.
	     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear
	     *  the canvas or not before the new render pass. If you wish to set this to false, you *must* set
	     *  preserveDrawingBuffer to `true`.
	     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
	     *  enable this if you need to call toDataUrl on the webgl context.
	     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when
	     *  rendering, stopping pixel interpolation.
	     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	     *  (shown if not transparent).
	     * @param {boolean} [options.legacy=false] - If true PixiJS will aim to ensure compatibility
	     *  with older / less advanced devices. If you experiance unexplained flickering try setting this to true.
	     * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
	     *  for devices with dual graphics card
	     */
	    function WebGLRenderer(options, arg2, arg3) {
	        _classCallCheck(this, WebGLRenderer);
	
	        var _this = _possibleConstructorReturn(this, _SystemRenderer.call(this, 'WebGL', options, arg2, arg3));
	
	        _this.legacy = _this.options.legacy;
	
	        if (_this.legacy) {
	            _pixiGlCore2.default.VertexArrayObject.FORCE_NATIVE = true;
	        }
	
	        /**
	         * The type of this renderer as a standardised const
	         *
	         * @member {number}
	         * @see PIXI.RENDERER_TYPE
	         */
	        _this.type = _const.RENDERER_TYPE.WEBGL;
	
	        _this.handleContextLost = _this.handleContextLost.bind(_this);
	        _this.handleContextRestored = _this.handleContextRestored.bind(_this);
	
	        _this.view.addEventListener('webglcontextlost', _this.handleContextLost, false);
	        _this.view.addEventListener('webglcontextrestored', _this.handleContextRestored, false);
	
	        /**
	         * The options passed in to create a new webgl context.
	         *
	         * @member {object}
	         * @private
	         */
	        _this._contextOptions = {
	            alpha: _this.transparent,
	            antialias: _this.options.antialias,
	            premultipliedAlpha: _this.transparent && _this.transparent !== 'notMultiplied',
	            stencil: true,
	            preserveDrawingBuffer: _this.options.preserveDrawingBuffer,
	            powerPreference: _this.options.powerPreference
	        };
	
	        _this._backgroundColorRgba[3] = _this.transparent ? 0 : 1;
	
	        /**
	         * Manages the masks using the stencil buffer.
	         *
	         * @member {PIXI.MaskManager}
	         */
	        _this.maskManager = new _MaskManager2.default(_this);
	
	        /**
	         * Manages the stencil buffer.
	         *
	         * @member {PIXI.StencilManager}
	         */
	        _this.stencilManager = new _StencilManager2.default(_this);
	
	        /**
	         * An empty renderer.
	         *
	         * @member {PIXI.ObjectRenderer}
	         */
	        _this.emptyRenderer = new _ObjectRenderer2.default(_this);
	
	        /**
	         * The currently active ObjectRenderer.
	         *
	         * @member {PIXI.ObjectRenderer}
	         */
	        _this.currentRenderer = _this.emptyRenderer;
	
	        /**
	         * Manages textures
	         * @member {PIXI.TextureManager}
	         */
	        _this.textureManager = null;
	
	        /**
	         * Manages the filters.
	         *
	         * @member {PIXI.FilterManager}
	         */
	        _this.filterManager = null;
	
	        _this.initPlugins();
	
	        /**
	         * The current WebGL rendering context, it is created here
	         *
	         * @member {WebGLRenderingContext}
	         */
	        // initialize the context so it is ready for the managers.
	        if (_this.options.context) {
	            // checks to see if a context is valid..
	            (0, _validateContext2.default)(_this.options.context);
	        }
	
	        _this.gl = _this.options.context || _pixiGlCore2.default.createContext(_this.view, _this._contextOptions);
	
	        _this.CONTEXT_UID = CONTEXT_UID++;
	
	        /**
	         * The currently active ObjectRenderer.
	         *
	         * @member {PIXI.WebGLState}
	         */
	        _this.state = new _WebGLState2.default(_this.gl);
	
	        _this.renderingToScreen = true;
	
	        /**
	         * Holds the current state of textures bound to the GPU.
	         * @type {Array}
	         */
	        _this.boundTextures = null;
	
	        /**
	         * Holds the current shader
	         *
	         * @member {PIXI.Shader}
	         */
	        _this._activeShader = null;
	
	        _this._activeVao = null;
	
	        /**
	         * Holds the current render target
	         *
	         * @member {PIXI.RenderTarget}
	         */
	        _this._activeRenderTarget = null;
	
	        _this._initContext();
	
	        // map some webGL blend and drawmodes..
	        _this.drawModes = (0, _mapWebGLDrawModesToPixi2.default)(_this.gl);
	
	        _this._nextTextureLocation = 0;
	
	        _this.setBlendMode(0);
	
	        /**
	         * Fired after rendering finishes.
	         *
	         * @event PIXI.WebGLRenderer#postrender
	         */
	
	        /**
	         * Fired before rendering starts.
	         *
	         * @event PIXI.WebGLRenderer#prerender
	         */
	
	        /**
	         * Fired when the WebGL context is set.
	         *
	         * @event PIXI.WebGLRenderer#context
	         * @param {WebGLRenderingContext} gl - WebGL context.
	         */
	        return _this;
	    }
	
	    /**
	     * Creates the WebGL context
	     *
	     * @private
	     */
	
	
	    WebGLRenderer.prototype._initContext = function _initContext() {
	        var gl = this.gl;
	
	        // restore a context if it was previously lost
	        if (gl.isContextLost() && gl.getExtension('WEBGL_lose_context')) {
	            gl.getExtension('WEBGL_lose_context').restoreContext();
	        }
	
	        var maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
	
	        this._activeShader = null;
	        this._activeVao = null;
	
	        this.boundTextures = new Array(maxTextures);
	        this.emptyTextures = new Array(maxTextures);
	
	        // create a texture manager...
	        this.textureManager = new _TextureManager2.default(this);
	        this.filterManager = new _FilterManager2.default(this);
	        this.textureGC = new _TextureGarbageCollector2.default(this);
	
	        this.state.resetToDefault();
	
	        this.rootRenderTarget = new _RenderTarget2.default(gl, this.width, this.height, null, this.resolution, true);
	        this.rootRenderTarget.clearColor = this._backgroundColorRgba;
	
	        this.bindRenderTarget(this.rootRenderTarget);
	
	        // now lets fill up the textures with empty ones!
	        var emptyGLTexture = new _pixiGlCore2.default.GLTexture.fromData(gl, null, 1, 1);
	
	        var tempObj = { _glTextures: {} };
	
	        tempObj._glTextures[this.CONTEXT_UID] = {};
	
	        for (var i = 0; i < maxTextures; i++) {
	            var empty = new _BaseTexture2.default();
	
	            empty._glTextures[this.CONTEXT_UID] = emptyGLTexture;
	
	            this.boundTextures[i] = tempObj;
	            this.emptyTextures[i] = empty;
	            this.bindTexture(null, i);
	        }
	
	        this.emit('context', gl);
	
	        // setup the width/height properties and gl viewport
	        this.resize(this.screen.width, this.screen.height);
	    };
	
	    /**
	     * Renders the object to its webGL view
	     *
	     * @param {PIXI.DisplayObject} displayObject - the object to be rendered
	     * @param {PIXI.RenderTexture} renderTexture - The render texture to render to.
	     * @param {boolean} [clear] - Should the canvas be cleared before the new render
	     * @param {PIXI.Transform} [transform] - A transform to apply to the render texture before rendering.
	     * @param {boolean} [skipUpdateTransform] - Should we skip the update transform pass?
	     */
	
	
	    WebGLRenderer.prototype.render = function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
	        // can be handy to know!
	        this.renderingToScreen = !renderTexture;
	
	        this.emit('prerender');
	
	        // no point rendering if our context has been blown up!
	        if (!this.gl || this.gl.isContextLost()) {
	            return;
	        }
	
	        this._nextTextureLocation = 0;
	
	        if (!renderTexture) {
	            this._lastObjectRendered = displayObject;
	        }
	
	        if (!skipUpdateTransform) {
	            // update the scene graph
	            var cacheParent = displayObject.parent;
	
	            displayObject.parent = this._tempDisplayObjectParent;
	            displayObject.updateTransform();
	            displayObject.parent = cacheParent;
	            // displayObject.hitArea = //TODO add a temp hit area
	        }
	
	        this.bindRenderTexture(renderTexture, transform);
	
	        this.currentRenderer.start();
	
	        if (clear !== undefined ? clear : this.clearBeforeRender) {
	            this._activeRenderTarget.clear();
	        }
	
	        displayObject.renderWebGL(this);
	
	        // apply transform..
	        this.currentRenderer.flush();
	
	        // this.setObjectRenderer(this.emptyRenderer);
	
	        this.textureGC.update();
	
	        this.emit('postrender');
	    };
	
	    /**
	     * Changes the current renderer to the one given in parameter
	     *
	     * @param {PIXI.ObjectRenderer} objectRenderer - The object renderer to use.
	     */
	
	
	    WebGLRenderer.prototype.setObjectRenderer = function setObjectRenderer(objectRenderer) {
	        if (this.currentRenderer === objectRenderer) {
	            return;
	        }
	
	        this.currentRenderer.stop();
	        this.currentRenderer = objectRenderer;
	        this.currentRenderer.start();
	    };
	
	    /**
	     * This should be called if you wish to do some custom rendering
	     * It will basically render anything that may be batched up such as sprites
	     *
	     */
	
	
	    WebGLRenderer.prototype.flush = function flush() {
	        this.setObjectRenderer(this.emptyRenderer);
	    };
	
	    /**
	     * Resizes the webGL view to the specified width and height.
	     *
	     * @param {number} screenWidth - the new width of the screen
	     * @param {number} screenHeight - the new height of the screen
	     */
	
	
	    WebGLRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
	        //  if(width * this.resolution === this.width && height * this.resolution === this.height)return;
	
	        _SystemRenderer3.default.prototype.resize.call(this, screenWidth, screenHeight);
	
	        this.rootRenderTarget.resize(screenWidth, screenHeight);
	
	        if (this._activeRenderTarget === this.rootRenderTarget) {
	            this.rootRenderTarget.activate();
	
	            if (this._activeShader) {
	                this._activeShader.uniforms.projectionMatrix = this.rootRenderTarget.projectionMatrix.toArray(true);
	            }
	        }
	    };
	
	    /**
	     * Resizes the webGL view to the specified width and height.
	     *
	     * @param {number} blendMode - the desired blend mode
	     */
	
	
	    WebGLRenderer.prototype.setBlendMode = function setBlendMode(blendMode) {
	        this.state.setBlendMode(blendMode);
	    };
	
	    /**
	     * Erases the active render target and fills the drawing area with a colour
	     *
	     * @param {number} [clearColor] - The colour
	     */
	
	
	    WebGLRenderer.prototype.clear = function clear(clearColor) {
	        this._activeRenderTarget.clear(clearColor);
	    };
	
	    /**
	     * Sets the transform of the active render target to the given matrix
	     *
	     * @param {PIXI.Matrix} matrix - The transformation matrix
	     */
	
	
	    WebGLRenderer.prototype.setTransform = function setTransform(matrix) {
	        this._activeRenderTarget.transform = matrix;
	    };
	
	    /**
	     * Erases the render texture and fills the drawing area with a colour
	     *
	     * @param {PIXI.RenderTexture} renderTexture - The render texture to clear
	     * @param {number} [clearColor] - The colour
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */
	
	
	    WebGLRenderer.prototype.clearRenderTexture = function clearRenderTexture(renderTexture, clearColor) {
	        var baseTexture = renderTexture.baseTexture;
	        var renderTarget = baseTexture._glRenderTargets[this.CONTEXT_UID];
	
	        if (renderTarget) {
	            renderTarget.clear(clearColor);
	        }
	
	        return this;
	    };
	
	    /**
	     * Binds a render texture for rendering
	     *
	     * @param {PIXI.RenderTexture} renderTexture - The render texture to render
	     * @param {PIXI.Transform} transform - The transform to be applied to the render texture
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */
	
	
	    WebGLRenderer.prototype.bindRenderTexture = function bindRenderTexture(renderTexture, transform) {
	        var renderTarget = void 0;
	
	        if (renderTexture) {
	            var baseTexture = renderTexture.baseTexture;
	
	            if (!baseTexture._glRenderTargets[this.CONTEXT_UID]) {
	                // bind the current texture
	                this.textureManager.updateTexture(baseTexture, 0);
	            }
	
	            this.unbindTexture(baseTexture);
	
	            renderTarget = baseTexture._glRenderTargets[this.CONTEXT_UID];
	            renderTarget.setFrame(renderTexture.frame);
	        } else {
	            renderTarget = this.rootRenderTarget;
	        }
	
	        renderTarget.transform = transform;
	        this.bindRenderTarget(renderTarget);
	
	        return this;
	    };
	
	    /**
	     * Changes the current render target to the one given in parameter
	     *
	     * @param {PIXI.RenderTarget} renderTarget - the new render target
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */
	
	
	    WebGLRenderer.prototype.bindRenderTarget = function bindRenderTarget(renderTarget) {
	        if (renderTarget !== this._activeRenderTarget) {
	            this._activeRenderTarget = renderTarget;
	            renderTarget.activate();
	
	            if (this._activeShader) {
	                this._activeShader.uniforms.projectionMatrix = renderTarget.projectionMatrix.toArray(true);
	            }
	
	            this.stencilManager.setMaskStack(renderTarget.stencilMaskStack);
	        }
	
	        return this;
	    };
	
	    /**
	     * Changes the current shader to the one given in parameter
	     *
	     * @param {PIXI.Shader} shader - the new shader
	     * @param {boolean} [autoProject=true] - Whether automatically set the projection matrix
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */
	
	
	    WebGLRenderer.prototype.bindShader = function bindShader(shader, autoProject) {
	        // TODO cache
	        if (this._activeShader !== shader) {
	            this._activeShader = shader;
	            shader.bind();
	
	            // `autoProject` normally would be a default parameter set to true
	            // but because of how Babel transpiles default parameters
	            // it hinders the performance of this method.
	            if (autoProject !== false) {
	                // automatically set the projection matrix
	                shader.uniforms.projectionMatrix = this._activeRenderTarget.projectionMatrix.toArray(true);
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Binds the texture. This will return the location of the bound texture.
	     * It may not be the same as the one you pass in. This is due to optimisation that prevents
	     * needless binding of textures. For example if the texture is already bound it will return the
	     * current location of the texture instead of the one provided. To bypass this use force location
	     *
	     * @param {PIXI.Texture} texture - the new texture
	     * @param {number} location - the suggested texture location
	     * @param {boolean} forceLocation - force the location
	     * @return {number} bound texture location
	     */
	
	
	    WebGLRenderer.prototype.bindTexture = function bindTexture(texture, location, forceLocation) {
	        texture = texture || this.emptyTextures[location];
	        texture = texture.baseTexture || texture;
	        texture.touched = this.textureGC.count;
	
	        if (!forceLocation) {
	            // TODO - maybe look into adding boundIds.. save us the loop?
	            for (var i = 0; i < this.boundTextures.length; i++) {
	                if (this.boundTextures[i] === texture) {
	                    return i;
	                }
	            }
	
	            if (location === undefined) {
	                this._nextTextureLocation++;
	                this._nextTextureLocation %= this.boundTextures.length;
	                location = this.boundTextures.length - this._nextTextureLocation - 1;
	            }
	        } else {
	            location = location || 0;
	        }
	
	        var gl = this.gl;
	        var glTexture = texture._glTextures[this.CONTEXT_UID];
	
	        if (!glTexture) {
	            // this will also bind the texture..
	            this.textureManager.updateTexture(texture, location);
	        } else {
	            // bind the current texture
	            this.boundTextures[location] = texture;
	            gl.activeTexture(gl.TEXTURE0 + location);
	            gl.bindTexture(gl.TEXTURE_2D, glTexture.texture);
	        }
	
	        return location;
	    };
	
	    /**
	    * unbinds the texture ...
	    *
	    * @param {PIXI.Texture} texture - the texture to unbind
	    * @return {PIXI.WebGLRenderer} Returns itself.
	    */
	
	
	    WebGLRenderer.prototype.unbindTexture = function unbindTexture(texture) {
	        var gl = this.gl;
	
	        texture = texture.baseTexture || texture;
	
	        for (var i = 0; i < this.boundTextures.length; i++) {
	            if (this.boundTextures[i] === texture) {
	                this.boundTextures[i] = this.emptyTextures[i];
	
	                gl.activeTexture(gl.TEXTURE0 + i);
	                gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[i]._glTextures[this.CONTEXT_UID].texture);
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Creates a new VAO from this renderer's context and state.
	     *
	     * @return {VertexArrayObject} The new VAO.
	     */
	
	
	    WebGLRenderer.prototype.createVao = function createVao() {
	        return new _pixiGlCore2.default.VertexArrayObject(this.gl, this.state.attribState);
	    };
	
	    /**
	     * Changes the current Vao to the one given in parameter
	     *
	     * @param {PIXI.VertexArrayObject} vao - the new Vao
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */
	
	
	    WebGLRenderer.prototype.bindVao = function bindVao(vao) {
	        if (this._activeVao === vao) {
	            return this;
	        }
	
	        if (vao) {
	            vao.bind();
	        } else if (this._activeVao) {
	            // TODO this should always be true i think?
	            this._activeVao.unbind();
	        }
	
	        this._activeVao = vao;
	
	        return this;
	    };
	
	    /**
	     * Resets the WebGL state so you can render things however you fancy!
	     *
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */
	
	
	    WebGLRenderer.prototype.reset = function reset() {
	        this.setObjectRenderer(this.emptyRenderer);
	
	        this.bindVao(null);
	        this._activeShader = null;
	        this._activeRenderTarget = this.rootRenderTarget;
	
	        for (var i = 0; i < this.boundTextures.length; i++) {
	            this.boundTextures[i] = this.emptyTextures[i];
	        }
	
	        // bind the main frame buffer (the screen);
	        this.rootRenderTarget.activate();
	
	        this.state.resetToDefault();
	
	        return this;
	    };
	
	    /**
	     * Handles a lost webgl context
	     *
	     * @private
	     * @param {WebGLContextEvent} event - The context lost event.
	     */
	
	
	    WebGLRenderer.prototype.handleContextLost = function handleContextLost(event) {
	        event.preventDefault();
	    };
	
	    /**
	     * Handles a restored webgl context
	     *
	     * @private
	     */
	
	
	    WebGLRenderer.prototype.handleContextRestored = function handleContextRestored() {
	        this.textureManager.removeAll();
	        this.filterManager.destroy(true);
	        this._initContext();
	    };
	
	    /**
	     * Removes everything from the renderer (event listeners, spritebatch, etc...)
	     *
	     * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
	     *  See: https://github.com/pixijs/pixi.js/issues/2233
	     */
	
	
	    WebGLRenderer.prototype.destroy = function destroy(removeView) {
	        this.destroyPlugins();
	
	        // remove listeners
	        this.view.removeEventListener('webglcontextlost', this.handleContextLost);
	        this.view.removeEventListener('webglcontextrestored', this.handleContextRestored);
	
	        this.textureManager.destroy();
	
	        // call base destroy
	        _SystemRenderer.prototype.destroy.call(this, removeView);
	
	        this.uid = 0;
	
	        // destroy the managers
	        this.maskManager.destroy();
	        this.stencilManager.destroy();
	        this.filterManager.destroy();
	
	        this.maskManager = null;
	        this.filterManager = null;
	        this.textureManager = null;
	        this.currentRenderer = null;
	
	        this.handleContextLost = null;
	        this.handleContextRestored = null;
	
	        this._contextOptions = null;
	        this.gl.useProgram(null);
	
	        if (this.gl.getExtension('WEBGL_lose_context')) {
	            this.gl.getExtension('WEBGL_lose_context').loseContext();
	        }
	
	        this.gl = null;
	
	        // this = null;
	    };
	
	    return WebGLRenderer;
	}(_SystemRenderer3.default);
	
	/**
	 * Collection of installed plugins. These are included by default in PIXI, but can be excluded
	 * by creating a custom build. Consult the README for more information about creating custom
	 * builds and excluding plugins.
	 * @name PIXI.WebGLRenderer#plugins
	 * @type {object}
	 * @readonly
	 * @property {PIXI.accessibility.AccessibilityManager} accessibility Support tabbing interactive elements.
	 * @property {PIXI.extract.WebGLExtract} extract Extract image data from renderer.
	 * @property {PIXI.interaction.InteractionManager} interaction Handles mouse, touch and pointer events.
	 * @property {PIXI.prepare.WebGLPrepare} prepare Pre-render display objects.
	 */
	
	/**
	 * Adds a plugin to the renderer.
	 *
	 * @method PIXI.WebGLRenderer#registerPlugin
	 * @param {string} pluginName - The name of the plugin.
	 * @param {Function} ctor - The constructor function or class for the plugin.
	 */
	
	exports.default = WebGLRenderer;
	_utils.pluginTarget.mixin(WebGLRenderer);
	//# sourceMappingURL=WebGLRenderer.js.map

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebGLManager2 = __webpack_require__(279);
	
	var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);
	
	var _SpriteMaskFilter = __webpack_require__(282);
	
	var _SpriteMaskFilter2 = _interopRequireDefault(_SpriteMaskFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @class
	 * @extends PIXI.WebGLManager
	 * @memberof PIXI
	 */
	var MaskManager = function (_WebGLManager) {
	    _inherits(MaskManager, _WebGLManager);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	     */
	    function MaskManager(renderer) {
	        _classCallCheck(this, MaskManager);
	
	        // TODO - we don't need both!
	        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));
	
	        _this.scissor = false;
	        _this.scissorData = null;
	        _this.scissorRenderTarget = null;
	
	        _this.enableScissor = true;
	
	        _this.alphaMaskPool = [];
	        _this.alphaMaskIndex = 0;
	        return _this;
	    }
	
	    /**
	     * Applies the Mask and adds it to the current filter stack.
	     *
	     * @param {PIXI.DisplayObject} target - Display Object to push the mask to
	     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
	     */
	
	
	    MaskManager.prototype.pushMask = function pushMask(target, maskData) {
	        // TODO the root check means scissor rect will not
	        // be used on render textures more info here:
	        // https://github.com/pixijs/pixi.js/pull/3545
	
	        if (maskData.texture) {
	            this.pushSpriteMask(target, maskData);
	        } else if (this.enableScissor && !this.scissor && this.renderer._activeRenderTarget.root && !this.renderer.stencilManager.stencilMaskStack.length && maskData.isFastRect()) {
	            var matrix = maskData.worldTransform;
	
	            var rot = Math.atan2(matrix.b, matrix.a);
	
	            // use the nearest degree!
	            rot = Math.round(rot * (180 / Math.PI));
	
	            if (rot % 90) {
	                this.pushStencilMask(maskData);
	            } else {
	                this.pushScissorMask(target, maskData);
	            }
	        } else {
	            this.pushStencilMask(maskData);
	        }
	    };
	
	    /**
	     * Removes the last mask from the mask stack and doesn't return it.
	     *
	     * @param {PIXI.DisplayObject} target - Display Object to pop the mask from
	     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
	     */
	
	
	    MaskManager.prototype.popMask = function popMask(target, maskData) {
	        if (maskData.texture) {
	            this.popSpriteMask(target, maskData);
	        } else if (this.enableScissor && !this.renderer.stencilManager.stencilMaskStack.length) {
	            this.popScissorMask(target, maskData);
	        } else {
	            this.popStencilMask(target, maskData);
	        }
	    };
	
	    /**
	     * Applies the Mask and adds it to the current filter stack.
	     *
	     * @param {PIXI.RenderTarget} target - Display Object to push the sprite mask to
	     * @param {PIXI.Sprite} maskData - Sprite to be used as the mask
	     */
	
	
	    MaskManager.prototype.pushSpriteMask = function pushSpriteMask(target, maskData) {
	        var alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex];
	
	        if (!alphaMaskFilter) {
	            alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex] = [new _SpriteMaskFilter2.default(maskData)];
	        }
	
	        alphaMaskFilter[0].resolution = this.renderer.resolution;
	        alphaMaskFilter[0].maskSprite = maskData;
	
	        // TODO - may cause issues!
	        target.filterArea = maskData.getBounds(true);
	
	        this.renderer.filterManager.pushFilter(target, alphaMaskFilter);
	
	        this.alphaMaskIndex++;
	    };
	
	    /**
	     * Removes the last filter from the filter stack and doesn't return it.
	     *
	     */
	
	
	    MaskManager.prototype.popSpriteMask = function popSpriteMask() {
	        this.renderer.filterManager.popFilter();
	        this.alphaMaskIndex--;
	    };
	
	    /**
	     * Applies the Mask and adds it to the current filter stack.
	     *
	     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
	     */
	
	
	    MaskManager.prototype.pushStencilMask = function pushStencilMask(maskData) {
	        this.renderer.currentRenderer.stop();
	        this.renderer.stencilManager.pushStencil(maskData);
	    };
	
	    /**
	     * Removes the last filter from the filter stack and doesn't return it.
	     *
	     */
	
	
	    MaskManager.prototype.popStencilMask = function popStencilMask() {
	        this.renderer.currentRenderer.stop();
	        this.renderer.stencilManager.popStencil();
	    };
	
	    /**
	     *
	     * @param {PIXI.DisplayObject} target - Display Object to push the mask to
	     * @param {PIXI.Graphics} maskData - The masking data.
	     */
	
	
	    MaskManager.prototype.pushScissorMask = function pushScissorMask(target, maskData) {
	        maskData.renderable = true;
	
	        var renderTarget = this.renderer._activeRenderTarget;
	
	        var bounds = maskData.getBounds();
	
	        bounds.fit(renderTarget.size);
	        maskData.renderable = false;
	
	        this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST);
	
	        var resolution = this.renderer.resolution;
	
	        this.renderer.gl.scissor(bounds.x * resolution, (renderTarget.root ? renderTarget.size.height - bounds.y - bounds.height : bounds.y) * resolution, bounds.width * resolution, bounds.height * resolution);
	
	        this.scissorRenderTarget = renderTarget;
	        this.scissorData = maskData;
	        this.scissor = true;
	    };
	
	    /**
	     *
	     *
	     */
	
	
	    MaskManager.prototype.popScissorMask = function popScissorMask() {
	        this.scissorRenderTarget = null;
	        this.scissorData = null;
	        this.scissor = false;
	
	        // must be scissor!
	        var gl = this.renderer.gl;
	
	        gl.disable(gl.SCISSOR_TEST);
	    };
	
	    return MaskManager;
	}(_WebGLManager3.default);
	
	exports.default = MaskManager;
	//# sourceMappingURL=MaskManager.js.map

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Filter2 = __webpack_require__(283);
	
	var _Filter3 = _interopRequireDefault(_Filter2);
	
	var _math = __webpack_require__(206);
	
	var _path = __webpack_require__(285);
	
	var _TextureMatrix = __webpack_require__(286);
	
	var _TextureMatrix2 = _interopRequireDefault(_TextureMatrix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The SpriteMaskFilter class
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI
	 */
	var SpriteMaskFilter = function (_Filter) {
	    _inherits(SpriteMaskFilter, _Filter);
	
	    /**
	     * @param {PIXI.Sprite} sprite - the target sprite
	     */
	    function SpriteMaskFilter(sprite) {
	        _classCallCheck(this, SpriteMaskFilter);
	
	        var maskMatrix = new _math.Matrix();
	
	        var _this = _possibleConstructorReturn(this, _Filter.call(this, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 otherMatrix;\n\nvarying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n}\n', 'varying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform sampler2D mask;\nuniform float alpha;\nuniform vec4 maskClamp;\n\nvoid main(void)\n{\n    float clip = step(3.5,\n        step(maskClamp.x, vMaskCoord.x) +\n        step(maskClamp.y, vMaskCoord.y) +\n        step(vMaskCoord.x, maskClamp.z) +\n        step(vMaskCoord.y, maskClamp.w));\n\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    vec4 masky = texture2D(mask, vMaskCoord);\n\n    original *= (masky.r * masky.a * alpha * clip);\n\n    gl_FragColor = original;\n}\n'));
	
	        sprite.renderable = false;
	
	        _this.maskSprite = sprite;
	        _this.maskMatrix = maskMatrix;
	        return _this;
	    }
	
	    /**
	     * Applies the filter
	     *
	     * @param {PIXI.FilterManager} filterManager - The renderer to retrieve the filter from
	     * @param {PIXI.RenderTarget} input - The input render target.
	     * @param {PIXI.RenderTarget} output - The target to output to.
	     */
	
	
	    SpriteMaskFilter.prototype.apply = function apply(filterManager, input, output) {
	        var maskSprite = this.maskSprite;
	        var tex = this.maskSprite.texture;
	
	        if (!tex.valid) {
	            return;
	        }
	        if (!tex.transform) {
	            // margin = 0.0, let it bleed a bit, shader code becomes easier
	            // assuming that atlas textures were made with 1-pixel padding
	            tex.transform = new _TextureMatrix2.default(tex, 0.0);
	        }
	        tex.transform.update();
	
	        this.uniforms.mask = tex;
	        this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite).prepend(tex.transform.mapCoord);
	        this.uniforms.alpha = maskSprite.worldAlpha;
	        this.uniforms.maskClamp = tex.transform.uClampFrame;
	
	        filterManager.applyFilter(this, input, output);
	    };
	
	    return SpriteMaskFilter;
	}(_Filter3.default);
	
	exports.default = SpriteMaskFilter;
	//# sourceMappingURL=SpriteMaskFilter.js.map

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extractUniformsFromSrc = __webpack_require__(284);
	
	var _extractUniformsFromSrc2 = _interopRequireDefault(_extractUniformsFromSrc);
	
	var _utils = __webpack_require__(244);
	
	var _const = __webpack_require__(205);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SOURCE_KEY_MAP = {};
	
	// let math = require('../../../math');
	/**
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.Shader
	 */
	
	var Filter = function () {
	  /**
	   * @param {string} [vertexSrc] - The source of the vertex shader.
	   * @param {string} [fragmentSrc] - The source of the fragment shader.
	   * @param {object} [uniforms] - Custom uniforms to use to augment the built-in ones.
	   */
	  function Filter(vertexSrc, fragmentSrc, uniforms) {
	    _classCallCheck(this, Filter);
	
	    /**
	     * The vertex shader.
	     *
	     * @member {string}
	     */
	    this.vertexSrc = vertexSrc || Filter.defaultVertexSrc;
	
	    /**
	     * The fragment shader.
	     *
	     * @member {string}
	     */
	    this.fragmentSrc = fragmentSrc || Filter.defaultFragmentSrc;
	
	    this._blendMode = _const.BLEND_MODES.NORMAL;
	
	    this.uniformData = uniforms || (0, _extractUniformsFromSrc2.default)(this.vertexSrc, this.fragmentSrc, 'projectionMatrix|uSampler');
	
	    /**
	     * An object containing the current values of custom uniforms.
	     * @example <caption>Updating the value of a custom uniform</caption>
	     * filter.uniforms.time = performance.now();
	     *
	     * @member {object}
	     */
	    this.uniforms = {};
	
	    for (var i in this.uniformData) {
	      this.uniforms[i] = this.uniformData[i].value;
	      if (this.uniformData[i].type) {
	        this.uniformData[i].type = this.uniformData[i].type.toLowerCase();
	      }
	    }
	
	    // this is where we store shader references..
	    // TODO we could cache this!
	    this.glShaders = {};
	
	    // used for cacheing.. sure there is a better way!
	    if (!SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc]) {
	      SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc] = (0, _utils.uid)();
	    }
	
	    this.glShaderKey = SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc];
	
	    /**
	     * The padding of the filter. Some filters require extra space to breath such as a blur.
	     * Increasing this will add extra width and height to the bounds of the object that the
	     * filter is applied to.
	     *
	     * @member {number}
	     */
	    this.padding = 4;
	
	    /**
	     * The resolution of the filter. Setting this to be lower will lower the quality but
	     * increase the performance of the filter.
	     *
	     * @member {number}
	     */
	    this.resolution = _settings2.default.FILTER_RESOLUTION;
	
	    /**
	     * If enabled is true the filter is applied, if false it will not.
	     *
	     * @member {boolean}
	     */
	    this.enabled = true;
	
	    /**
	     * If enabled, PixiJS will fit the filter area into boundaries for better performance.
	     * Switch it off if it does not work for specific shader.
	     *
	     * @member {boolean}
	     */
	    this.autoFit = true;
	  }
	
	  /**
	   * Applies the filter
	   *
	   * @param {PIXI.FilterManager} filterManager - The renderer to retrieve the filter from
	   * @param {PIXI.RenderTarget} input - The input render target.
	   * @param {PIXI.RenderTarget} output - The target to output to.
	   * @param {boolean} clear - Should the output be cleared before rendering to it
	   * @param {object} [currentState] - It's current state of filter.
	   *        There are some useful properties in the currentState :
	   *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
	   */
	
	
	  Filter.prototype.apply = function apply(filterManager, input, output, clear, currentState) // eslint-disable-line no-unused-vars
	  {
	    // --- //
	    //  this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(tempMatrix, window.panda );
	
	    // do as you please!
	
	    filterManager.applyFilter(this, input, output, clear);
	
	    // or just do a regular render..
	  };
	
	  /**
	   * Sets the blendmode of the filter
	   *
	   * @member {number}
	   * @default PIXI.BLEND_MODES.NORMAL
	   */
	
	
	  _createClass(Filter, [{
	    key: 'blendMode',
	    get: function get() {
	      return this._blendMode;
	    },
	    set: function set(value) // eslint-disable-line require-jsdoc
	    {
	      this._blendMode = value;
	    }
	
	    /**
	     * The default vertex shader source
	     *
	     * @static
	     * @constant
	     */
	
	  }], [{
	    key: 'defaultVertexSrc',
	    get: function get() {
	      return ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'uniform mat3 projectionMatrix;', 'uniform mat3 filterMatrix;', 'varying vec2 vTextureCoord;', 'varying vec2 vFilterCoord;', 'void main(void){', '   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);', '   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;', '   vTextureCoord = aTextureCoord ;', '}'].join('\n');
	    }
	
	    /**
	     * The default fragment shader source
	     *
	     * @static
	     * @constant
	     */
	
	  }, {
	    key: 'defaultFragmentSrc',
	    get: function get() {
	      return ['varying vec2 vTextureCoord;', 'varying vec2 vFilterCoord;', 'uniform sampler2D uSampler;', 'uniform sampler2D filterSampler;', 'void main(void){', '   vec4 masky = texture2D(filterSampler, vFilterCoord);', '   vec4 sample = texture2D(uSampler, vTextureCoord);', '   vec4 color;', '   if(mod(vFilterCoord.x, 1.0) > 0.5)', '   {', '     color = vec4(1.0, 0.0, 0.0, 1.0);', '   }', '   else', '   {', '     color = vec4(0.0, 1.0, 0.0, 1.0);', '   }',
	      // '   gl_FragColor = vec4(mod(vFilterCoord.x, 1.5), vFilterCoord.y,0.0,1.0);',
	      '   gl_FragColor = mix(sample, masky, 0.5);', '   gl_FragColor *= sample.a;', '}'].join('\n');
	    }
	  }]);
	
	  return Filter;
	}();
	
	exports.default = Filter;
	//# sourceMappingURL=Filter.js.map

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = extractUniformsFromSrc;
	
	var _pixiGlCore = __webpack_require__(216);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultValue = _pixiGlCore2.default.shader.defaultValue;
	
	function extractUniformsFromSrc(vertexSrc, fragmentSrc, mask) {
	    var vertUniforms = extractUniformsFromString(vertexSrc, mask);
	    var fragUniforms = extractUniformsFromString(fragmentSrc, mask);
	
	    return Object.assign(vertUniforms, fragUniforms);
	}
	
	function extractUniformsFromString(string) {
	    var maskRegex = new RegExp('^(projectionMatrix|uSampler|filterArea|filterClamp)$');
	
	    var uniforms = {};
	    var nameSplit = void 0;
	
	    // clean the lines a little - remove extra spaces / tabs etc
	    // then split along ';'
	    var lines = string.replace(/\s+/g, ' ').split(/\s*;\s*/);
	
	    // loop through..
	    for (var i = 0; i < lines.length; i++) {
	        var line = lines[i].trim();
	
	        if (line.indexOf('uniform') > -1) {
	            var splitLine = line.split(' ');
	            var type = splitLine[1];
	
	            var name = splitLine[2];
	            var size = 1;
	
	            if (name.indexOf('[') > -1) {
	                // array!
	                nameSplit = name.split(/\[|]/);
	                name = nameSplit[0];
	                size *= Number(nameSplit[1]);
	            }
	
	            if (!name.match(maskRegex)) {
	                uniforms[name] = {
	                    value: defaultValue(type, size),
	                    name: name,
	                    type: type
	                };
	            }
	        }
	    }
	
	    return uniforms;
	}
	//# sourceMappingURL=extractUniformsFromSrc.js.map

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(131)))

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Matrix = __webpack_require__(209);
	
	var _Matrix2 = _interopRequireDefault(_Matrix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var tempMat = new _Matrix2.default();
	
	/**
	 * Class controls uv transform and frame clamp for texture
	 * Can be used in Texture "transform" field, or separately, you can use different clamp settings on the same texture.
	 * If you want to add support for texture region of certain feature or filter, that's what you're looking for.
	 *
	 * @see PIXI.Texture
	 * @see PIXI.mesh.Mesh
	 * @see PIXI.extras.TilingSprite
	 * @class
	 * @memberof PIXI
	 */
	
	var TextureMatrix = function () {
	    /**
	     *
	     * @param {PIXI.Texture} texture observed texture
	     * @param {number} [clampMargin] Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
	     * @constructor
	     */
	    function TextureMatrix(texture, clampMargin) {
	        _classCallCheck(this, TextureMatrix);
	
	        this._texture = texture;
	
	        this.mapCoord = new _Matrix2.default();
	
	        this.uClampFrame = new Float32Array(4);
	
	        this.uClampOffset = new Float32Array(2);
	
	        this._lastTextureID = -1;
	
	        /**
	         * Changes frame clamping
	         * Works with TilingSprite and Mesh
	         * Change to 1.5 if you texture has repeated right and bottom lines, that leads to smoother borders
	         *
	         * @default 0
	         * @member {number}
	         */
	        this.clampOffset = 0;
	
	        /**
	         * Changes frame clamping
	         * Works with TilingSprite and Mesh
	         * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
	         *
	         * @default 0.5
	         * @member {number}
	         */
	        this.clampMargin = typeof clampMargin === 'undefined' ? 0.5 : clampMargin;
	    }
	
	    /**
	     * texture property
	     * @member {PIXI.Texture}
	     */
	
	
	    /**
	     * Multiplies uvs array to transform
	     * @param {Float32Array} uvs mesh uvs
	     * @param {Float32Array} [out=uvs] output
	     * @returns {Float32Array} output
	     */
	    TextureMatrix.prototype.multiplyUvs = function multiplyUvs(uvs, out) {
	        if (out === undefined) {
	            out = uvs;
	        }
	
	        var mat = this.mapCoord;
	
	        for (var i = 0; i < uvs.length; i += 2) {
	            var x = uvs[i];
	            var y = uvs[i + 1];
	
	            out[i] = x * mat.a + y * mat.c + mat.tx;
	            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
	        }
	
	        return out;
	    };
	
	    /**
	     * updates matrices if texture was changed
	     * @param {boolean} forceUpdate if true, matrices will be updated any case
	     * @returns {boolean} whether or not it was updated
	     */
	
	
	    TextureMatrix.prototype.update = function update(forceUpdate) {
	        var tex = this._texture;
	
	        if (!tex || !tex.valid) {
	            return false;
	        }
	
	        if (!forceUpdate && this._lastTextureID === tex._updateID) {
	            return false;
	        }
	
	        this._lastTextureID = tex._updateID;
	
	        var uvs = tex._uvs;
	
	        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
	
	        var orig = tex.orig;
	        var trim = tex.trim;
	
	        if (trim) {
	            tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
	            this.mapCoord.append(tempMat);
	        }
	
	        var texBase = tex.baseTexture;
	        var frame = this.uClampFrame;
	        var margin = this.clampMargin / texBase.resolution;
	        var offset = this.clampOffset;
	
	        frame[0] = (tex._frame.x + margin + offset) / texBase.width;
	        frame[1] = (tex._frame.y + margin + offset) / texBase.height;
	        frame[2] = (tex._frame.x + tex._frame.width - margin + offset) / texBase.width;
	        frame[3] = (tex._frame.y + tex._frame.height - margin + offset) / texBase.height;
	        this.uClampOffset[0] = offset / texBase.realWidth;
	        this.uClampOffset[1] = offset / texBase.realHeight;
	
	        return true;
	    };
	
	    _createClass(TextureMatrix, [{
	        key: 'texture',
	        get: function get() {
	            return this._texture;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._texture = value;
	            this._lastTextureID = -1;
	        }
	    }]);
	
	    return TextureMatrix;
	}();
	
	exports.default = TextureMatrix;
	//# sourceMappingURL=TextureMatrix.js.map

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebGLManager2 = __webpack_require__(279);
	
	var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @class
	 * @extends PIXI.WebGLManager
	 * @memberof PIXI
	 */
	var StencilManager = function (_WebGLManager) {
	    _inherits(StencilManager, _WebGLManager);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	     */
	    function StencilManager(renderer) {
	        _classCallCheck(this, StencilManager);
	
	        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));
	
	        _this.stencilMaskStack = null;
	        return _this;
	    }
	
	    /**
	     * Changes the mask stack that is used by this manager.
	     *
	     * @param {PIXI.Graphics[]} stencilMaskStack - The mask stack
	     */
	
	
	    StencilManager.prototype.setMaskStack = function setMaskStack(stencilMaskStack) {
	        this.stencilMaskStack = stencilMaskStack;
	
	        var gl = this.renderer.gl;
	
	        if (stencilMaskStack.length === 0) {
	            gl.disable(gl.STENCIL_TEST);
	        } else {
	            gl.enable(gl.STENCIL_TEST);
	        }
	    };
	
	    /**
	     * Applies the Mask and adds it to the current stencil stack. @alvin
	     *
	     * @param {PIXI.Graphics} graphics - The mask
	     */
	
	
	    StencilManager.prototype.pushStencil = function pushStencil(graphics) {
	        this.renderer.setObjectRenderer(this.renderer.plugins.graphics);
	
	        this.renderer._activeRenderTarget.attachStencilBuffer();
	
	        var gl = this.renderer.gl;
	        var prevMaskCount = this.stencilMaskStack.length;
	
	        if (prevMaskCount === 0) {
	            gl.enable(gl.STENCIL_TEST);
	        }
	
	        this.stencilMaskStack.push(graphics);
	
	        // Increment the refference stencil value where the new mask overlaps with the old ones.
	        gl.colorMask(false, false, false, false);
	        gl.stencilFunc(gl.EQUAL, prevMaskCount, this._getBitwiseMask());
	        gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
	        this.renderer.plugins.graphics.render(graphics);
	
	        this._useCurrent();
	    };
	
	    /**
	     * Removes the last mask from the stencil stack. @alvin
	     */
	
	
	    StencilManager.prototype.popStencil = function popStencil() {
	        this.renderer.setObjectRenderer(this.renderer.plugins.graphics);
	
	        var gl = this.renderer.gl;
	        var graphics = this.stencilMaskStack.pop();
	
	        if (this.stencilMaskStack.length === 0) {
	            // the stack is empty!
	            gl.disable(gl.STENCIL_TEST);
	            gl.clear(gl.STENCIL_BUFFER_BIT);
	            gl.clearStencil(0);
	        } else {
	            // Decrement the refference stencil value where the popped mask overlaps with the other ones
	            gl.colorMask(false, false, false, false);
	            gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
	            this.renderer.plugins.graphics.render(graphics);
	
	            this._useCurrent();
	        }
	    };
	
	    /**
	     * Setup renderer to use the current stencil data.
	     */
	
	
	    StencilManager.prototype._useCurrent = function _useCurrent() {
	        var gl = this.renderer.gl;
	
	        gl.colorMask(true, true, true, true);
	        gl.stencilFunc(gl.EQUAL, this.stencilMaskStack.length, this._getBitwiseMask());
	        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
	    };
	
	    /**
	     * Fill 1s equal to the number of acitve stencil masks.
	     *
	     * @return {number} The bitwise mask.
	     */
	
	
	    StencilManager.prototype._getBitwiseMask = function _getBitwiseMask() {
	        return (1 << this.stencilMaskStack.length) - 1;
	    };
	
	    /**
	     * Destroys the mask stack.
	     *
	     */
	
	
	    StencilManager.prototype.destroy = function destroy() {
	        _WebGLManager3.default.prototype.destroy.call(this);
	
	        this.stencilMaskStack.stencilStack = null;
	    };
	
	    return StencilManager;
	}(_WebGLManager3.default);
	
	exports.default = StencilManager;
	//# sourceMappingURL=StencilManager.js.map

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebGLManager2 = __webpack_require__(279);
	
	var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);
	
	var _RenderTarget = __webpack_require__(289);
	
	var _RenderTarget2 = _interopRequireDefault(_RenderTarget);
	
	var _Quad = __webpack_require__(290);
	
	var _Quad2 = _interopRequireDefault(_Quad);
	
	var _math = __webpack_require__(206);
	
	var _Shader = __webpack_require__(292);
	
	var _Shader2 = _interopRequireDefault(_Shader);
	
	var _filterTransforms = __webpack_require__(293);
	
	var filterTransforms = _interopRequireWildcard(_filterTransforms);
	
	var _bitTwiddle = __webpack_require__(261);
	
	var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @ignore
	 * @class
	 */
	var FilterState = function () {
	    /**
	     *
	     */
	    function FilterState() {
	        _classCallCheck(this, FilterState);
	
	        this.renderTarget = null;
	        this.target = null;
	        this.resolution = 1;
	
	        // those three objects are used only for root
	        // re-assigned for everything else
	        this.sourceFrame = new _math.Rectangle();
	        this.destinationFrame = new _math.Rectangle();
	        this.filters = [];
	    }
	
	    /**
	     * clears the state
	     */
	
	
	    FilterState.prototype.clear = function clear() {
	        this.filters = null;
	        this.target = null;
	        this.renderTarget = null;
	    };
	
	    return FilterState;
	}();
	
	var screenKey = 'screen';
	
	/**
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.WebGLManager
	 */
	
	var FilterManager = function (_WebGLManager) {
	    _inherits(FilterManager, _WebGLManager);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	     */
	    function FilterManager(renderer) {
	        _classCallCheck(this, FilterManager);
	
	        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));
	
	        _this.gl = _this.renderer.gl;
	        // know about sprites!
	        _this.quad = new _Quad2.default(_this.gl, renderer.state.attribState);
	
	        _this.shaderCache = {};
	        // todo add default!
	        _this.pool = {};
	
	        _this.filterData = null;
	
	        _this.managedFilters = [];
	
	        _this.renderer.on('prerender', _this.onPrerender, _this);
	
	        _this._screenWidth = renderer.view.width;
	        _this._screenHeight = renderer.view.height;
	        return _this;
	    }
	
	    /**
	     * Adds a new filter to the manager.
	     *
	     * @param {PIXI.DisplayObject} target - The target of the filter to render.
	     * @param {PIXI.Filter[]} filters - The filters to apply.
	     */
	
	
	    FilterManager.prototype.pushFilter = function pushFilter(target, filters) {
	        var renderer = this.renderer;
	
	        var filterData = this.filterData;
	
	        if (!filterData) {
	            filterData = this.renderer._activeRenderTarget.filterStack;
	
	            // add new stack
	            var filterState = new FilterState();
	
	            filterState.sourceFrame = filterState.destinationFrame = this.renderer._activeRenderTarget.size;
	            filterState.renderTarget = renderer._activeRenderTarget;
	
	            this.renderer._activeRenderTarget.filterData = filterData = {
	                index: 0,
	                stack: [filterState]
	            };
	
	            this.filterData = filterData;
	        }
	
	        // get the current filter state..
	        var currentState = filterData.stack[++filterData.index];
	        var renderTargetFrame = filterData.stack[0].destinationFrame;
	
	        if (!currentState) {
	            currentState = filterData.stack[filterData.index] = new FilterState();
	        }
	
	        var fullScreen = target.filterArea && target.filterArea.x === 0 && target.filterArea.y === 0 && target.filterArea.width === renderer.screen.width && target.filterArea.height === renderer.screen.height;
	
	        // for now we go off the filter of the first resolution..
	        var resolution = filters[0].resolution;
	        var padding = filters[0].padding | 0;
	        var targetBounds = fullScreen ? renderer.screen : target.filterArea || target.getBounds(true);
	        var sourceFrame = currentState.sourceFrame;
	        var destinationFrame = currentState.destinationFrame;
	
	        sourceFrame.x = (targetBounds.x * resolution | 0) / resolution;
	        sourceFrame.y = (targetBounds.y * resolution | 0) / resolution;
	        sourceFrame.width = (targetBounds.width * resolution | 0) / resolution;
	        sourceFrame.height = (targetBounds.height * resolution | 0) / resolution;
	
	        if (!fullScreen) {
	            if (filterData.stack[0].renderTarget.transform) {//
	
	                // TODO we should fit the rect around the transform..
	            } else if (filters[0].autoFit) {
	                sourceFrame.fit(renderTargetFrame);
	            }
	
	            // lets apply the padding After we fit the element to the screen.
	            // this should stop the strange side effects that can occur when cropping to the edges
	            sourceFrame.pad(padding);
	        }
	
	        destinationFrame.width = sourceFrame.width;
	        destinationFrame.height = sourceFrame.height;
	
	        // lets play the padding after we fit the element to the screen.
	        // this should stop the strange side effects that can occur when cropping to the edges
	
	        var renderTarget = this.getPotRenderTarget(renderer.gl, sourceFrame.width, sourceFrame.height, resolution);
	
	        currentState.target = target;
	        currentState.filters = filters;
	        currentState.resolution = resolution;
	        currentState.renderTarget = renderTarget;
	
	        // bind the render target to draw the shape in the top corner..
	
	        renderTarget.setFrame(destinationFrame, sourceFrame);
	
	        // bind the render target
	        renderer.bindRenderTarget(renderTarget);
	        renderTarget.clear();
	    };
	
	    /**
	     * Pops off the filter and applies it.
	     *
	     */
	
	
	    FilterManager.prototype.popFilter = function popFilter() {
	        var filterData = this.filterData;
	
	        var lastState = filterData.stack[filterData.index - 1];
	        var currentState = filterData.stack[filterData.index];
	
	        this.quad.map(currentState.renderTarget.size, currentState.sourceFrame).upload();
	
	        var filters = currentState.filters;
	
	        if (filters.length === 1) {
	            filters[0].apply(this, currentState.renderTarget, lastState.renderTarget, false, currentState);
	            this.freePotRenderTarget(currentState.renderTarget);
	        } else {
	            var flip = currentState.renderTarget;
	            var flop = this.getPotRenderTarget(this.renderer.gl, currentState.sourceFrame.width, currentState.sourceFrame.height, currentState.resolution);
	
	            flop.setFrame(currentState.destinationFrame, currentState.sourceFrame);
	
	            // finally lets clear the render target before drawing to it..
	            flop.clear();
	
	            var i = 0;
	
	            for (i = 0; i < filters.length - 1; ++i) {
	                filters[i].apply(this, flip, flop, true, currentState);
	
	                var t = flip;
	
	                flip = flop;
	                flop = t;
	            }
	
	            filters[i].apply(this, flip, lastState.renderTarget, false, currentState);
	
	            this.freePotRenderTarget(flip);
	            this.freePotRenderTarget(flop);
	        }
	
	        currentState.clear();
	        filterData.index--;
	
	        if (filterData.index === 0) {
	            this.filterData = null;
	        }
	    };
	
	    /**
	     * Draws a filter.
	     *
	     * @param {PIXI.Filter} filter - The filter to draw.
	     * @param {PIXI.RenderTarget} input - The input render target.
	     * @param {PIXI.RenderTarget} output - The target to output to.
	     * @param {boolean} clear - Should the output be cleared before rendering to it
	     */
	
	
	    FilterManager.prototype.applyFilter = function applyFilter(filter, input, output, clear) {
	        var renderer = this.renderer;
	        var gl = renderer.gl;
	
	        var shader = filter.glShaders[renderer.CONTEXT_UID];
	
	        // cacheing..
	        if (!shader) {
	            if (filter.glShaderKey) {
	                shader = this.shaderCache[filter.glShaderKey];
	
	                if (!shader) {
	                    shader = new _Shader2.default(this.gl, filter.vertexSrc, filter.fragmentSrc);
	
	                    filter.glShaders[renderer.CONTEXT_UID] = this.shaderCache[filter.glShaderKey] = shader;
	                    this.managedFilters.push(filter);
	                }
	            } else {
	                shader = filter.glShaders[renderer.CONTEXT_UID] = new _Shader2.default(this.gl, filter.vertexSrc, filter.fragmentSrc);
	                this.managedFilters.push(filter);
	            }
	
	            // TODO - this only needs to be done once?
	            renderer.bindVao(null);
	
	            this.quad.initVao(shader);
	        }
	
	        renderer.bindVao(this.quad.vao);
	
	        renderer.bindRenderTarget(output);
	
	        if (clear) {
	            gl.disable(gl.SCISSOR_TEST);
	            renderer.clear(); // [1, 1, 1, 1]);
	            gl.enable(gl.SCISSOR_TEST);
	        }
	
	        // in case the render target is being masked using a scissor rect
	        if (output === renderer.maskManager.scissorRenderTarget) {
	            renderer.maskManager.pushScissorMask(null, renderer.maskManager.scissorData);
	        }
	
	        renderer.bindShader(shader);
	
	        // free unit 0 for us, doesn't matter what was there
	        // don't try to restore it, because syncUniforms can upload it to another slot
	        // and it'll be a problem
	        var tex = this.renderer.emptyTextures[0];
	
	        this.renderer.boundTextures[0] = tex;
	        // this syncs the PixiJS filters  uniforms with glsl uniforms
	        this.syncUniforms(shader, filter);
	
	        renderer.state.setBlendMode(filter.blendMode);
	
	        gl.activeTexture(gl.TEXTURE0);
	        gl.bindTexture(gl.TEXTURE_2D, input.texture.texture);
	
	        this.quad.vao.draw(this.renderer.gl.TRIANGLES, 6, 0);
	
	        gl.bindTexture(gl.TEXTURE_2D, tex._glTextures[this.renderer.CONTEXT_UID].texture);
	    };
	
	    /**
	     * Uploads the uniforms of the filter.
	     *
	     * @param {GLShader} shader - The underlying gl shader.
	     * @param {PIXI.Filter} filter - The filter we are synchronizing.
	     */
	
	
	    FilterManager.prototype.syncUniforms = function syncUniforms(shader, filter) {
	        var uniformData = filter.uniformData;
	        var uniforms = filter.uniforms;
	
	        // 0 is reserved for the PixiJS texture so we start at 1!
	        var textureCount = 1;
	        var currentState = void 0;
	
	        // filterArea and filterClamp that are handled by FilterManager directly
	        // they must not appear in uniformData
	
	        if (shader.uniforms.filterArea) {
	            currentState = this.filterData.stack[this.filterData.index];
	
	            var filterArea = shader.uniforms.filterArea;
	
	            filterArea[0] = currentState.renderTarget.size.width;
	            filterArea[1] = currentState.renderTarget.size.height;
	            filterArea[2] = currentState.sourceFrame.x;
	            filterArea[3] = currentState.sourceFrame.y;
	
	            shader.uniforms.filterArea = filterArea;
	        }
	
	        // use this to clamp displaced texture coords so they belong to filterArea
	        // see displacementFilter fragment shader for an example
	        if (shader.uniforms.filterClamp) {
	            currentState = currentState || this.filterData.stack[this.filterData.index];
	
	            var filterClamp = shader.uniforms.filterClamp;
	
	            filterClamp[0] = 0;
	            filterClamp[1] = 0;
	            filterClamp[2] = (currentState.sourceFrame.width - 1) / currentState.renderTarget.size.width;
	            filterClamp[3] = (currentState.sourceFrame.height - 1) / currentState.renderTarget.size.height;
	
	            shader.uniforms.filterClamp = filterClamp;
	        }
	
	        // TODO Cacheing layer..
	        for (var i in uniformData) {
	            var type = uniformData[i].type;
	
	            if (type === 'sampler2d' && uniforms[i] !== 0) {
	                if (uniforms[i].baseTexture) {
	                    shader.uniforms[i] = this.renderer.bindTexture(uniforms[i].baseTexture, textureCount);
	                } else {
	                    shader.uniforms[i] = textureCount;
	
	                    // TODO
	                    // this is helpful as renderTargets can also be set.
	                    // Although thinking about it, we could probably
	                    // make the filter texture cache return a RenderTexture
	                    // rather than a renderTarget
	                    var gl = this.renderer.gl;
	
	                    this.renderer.boundTextures[textureCount] = this.renderer.emptyTextures[textureCount];
	                    gl.activeTexture(gl.TEXTURE0 + textureCount);
	
	                    uniforms[i].texture.bind();
	                }
	
	                textureCount++;
	            } else if (type === 'mat3') {
	                // check if its PixiJS matrix..
	                if (uniforms[i].a !== undefined) {
	                    shader.uniforms[i] = uniforms[i].toArray(true);
	                } else {
	                    shader.uniforms[i] = uniforms[i];
	                }
	            } else if (type === 'vec2') {
	                // check if its a point..
	                if (uniforms[i].x !== undefined) {
	                    var val = shader.uniforms[i] || new Float32Array(2);
	
	                    val[0] = uniforms[i].x;
	                    val[1] = uniforms[i].y;
	                    shader.uniforms[i] = val;
	                } else {
	                    shader.uniforms[i] = uniforms[i];
	                }
	            } else if (type === 'float') {
	                if (shader.uniforms.data[i].value !== uniformData[i]) {
	                    shader.uniforms[i] = uniforms[i];
	                }
	            } else {
	                shader.uniforms[i] = uniforms[i];
	            }
	        }
	    };
	
	    /**
	     * Gets a render target from the pool, or creates a new one.
	     *
	     * @param {boolean} clear - Should we clear the render texture when we get it?
	     * @param {number} resolution - The resolution of the target.
	     * @return {PIXI.RenderTarget} The new render target
	     */
	
	
	    FilterManager.prototype.getRenderTarget = function getRenderTarget(clear, resolution) {
	        var currentState = this.filterData.stack[this.filterData.index];
	        var renderTarget = this.getPotRenderTarget(this.renderer.gl, currentState.sourceFrame.width, currentState.sourceFrame.height, resolution || currentState.resolution);
	
	        renderTarget.setFrame(currentState.destinationFrame, currentState.sourceFrame);
	
	        return renderTarget;
	    };
	
	    /**
	     * Returns a render target to the pool.
	     *
	     * @param {PIXI.RenderTarget} renderTarget - The render target to return.
	     */
	
	
	    FilterManager.prototype.returnRenderTarget = function returnRenderTarget(renderTarget) {
	        this.freePotRenderTarget(renderTarget);
	    };
	
	    /**
	     * Calculates the mapped matrix.
	     *
	     * TODO playing around here.. this is temporary - (will end up in the shader)
	     * this returns a matrix that will normalise map filter cords in the filter to screen space
	     *
	     * @param {PIXI.Matrix} outputMatrix - the matrix to output to.
	     * @return {PIXI.Matrix} The mapped matrix.
	     */
	
	
	    FilterManager.prototype.calculateScreenSpaceMatrix = function calculateScreenSpaceMatrix(outputMatrix) {
	        var currentState = this.filterData.stack[this.filterData.index];
	
	        return filterTransforms.calculateScreenSpaceMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size);
	    };
	
	    /**
	     * Multiply vTextureCoord to this matrix to achieve (0,0,1,1) for filterArea
	     *
	     * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
	     * @return {PIXI.Matrix} The mapped matrix.
	     */
	
	
	    FilterManager.prototype.calculateNormalizedScreenSpaceMatrix = function calculateNormalizedScreenSpaceMatrix(outputMatrix) {
	        var currentState = this.filterData.stack[this.filterData.index];
	
	        return filterTransforms.calculateNormalizedScreenSpaceMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size, currentState.destinationFrame);
	    };
	
	    /**
	     * This will map the filter coord so that a texture can be used based on the transform of a sprite
	     *
	     * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
	     * @param {PIXI.Sprite} sprite - The sprite to map to.
	     * @return {PIXI.Matrix} The mapped matrix.
	     */
	
	
	    FilterManager.prototype.calculateSpriteMatrix = function calculateSpriteMatrix(outputMatrix, sprite) {
	        var currentState = this.filterData.stack[this.filterData.index];
	
	        return filterTransforms.calculateSpriteMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size, sprite);
	    };
	
	    /**
	     * Destroys this Filter Manager.
	     *
	     * @param {boolean} [contextLost=false] context was lost, do not free shaders
	     *
	     */
	
	
	    FilterManager.prototype.destroy = function destroy() {
	        var contextLost = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var renderer = this.renderer;
	        var filters = this.managedFilters;
	
	        renderer.off('prerender', this.onPrerender, this);
	
	        for (var i = 0; i < filters.length; i++) {
	            if (!contextLost) {
	                filters[i].glShaders[renderer.CONTEXT_UID].destroy();
	            }
	            delete filters[i].glShaders[renderer.CONTEXT_UID];
	        }
	
	        this.shaderCache = {};
	        if (!contextLost) {
	            this.emptyPool();
	        } else {
	            this.pool = {};
	        }
	    };
	
	    /**
	     * Gets a Power-of-Two render texture.
	     *
	     * TODO move to a seperate class could be on renderer?
	     * also - could cause issue with multiple contexts?
	     *
	     * @private
	     * @param {WebGLRenderingContext} gl - The webgl rendering context
	     * @param {number} minWidth - The minimum width of the render target.
	     * @param {number} minHeight - The minimum height of the render target.
	     * @param {number} resolution - The resolution of the render target.
	     * @return {PIXI.RenderTarget} The new render target.
	     */
	
	
	    FilterManager.prototype.getPotRenderTarget = function getPotRenderTarget(gl, minWidth, minHeight, resolution) {
	        var key = screenKey;
	
	        minWidth *= resolution;
	        minHeight *= resolution;
	
	        if (minWidth !== this._screenWidth || minHeight !== this._screenHeight) {
	            // TODO you could return a bigger texture if there is not one in the pool?
	            minWidth = _bitTwiddle2.default.nextPow2(minWidth);
	            minHeight = _bitTwiddle2.default.nextPow2(minHeight);
	            key = (minWidth & 0xFFFF) << 16 | minHeight & 0xFFFF;
	        }
	
	        if (!this.pool[key]) {
	            this.pool[key] = [];
	        }
	
	        var renderTarget = this.pool[key].pop();
	
	        // creating render target will cause texture to be bound!
	        if (!renderTarget) {
	            // temporary bypass cache..
	            var tex = this.renderer.boundTextures[0];
	
	            gl.activeTexture(gl.TEXTURE0);
	
	            // internally - this will cause a texture to be bound..
	            renderTarget = new _RenderTarget2.default(gl, minWidth, minHeight, null, 1);
	
	            // set the current one back
	            gl.bindTexture(gl.TEXTURE_2D, tex._glTextures[this.renderer.CONTEXT_UID].texture);
	        }
	
	        // manually tweak the resolution...
	        // this will not modify the size of the frame buffer, just its resolution.
	        renderTarget.resolution = resolution;
	        renderTarget.defaultFrame.width = renderTarget.size.width = minWidth / resolution;
	        renderTarget.defaultFrame.height = renderTarget.size.height = minHeight / resolution;
	        renderTarget.filterPoolKey = key;
	
	        return renderTarget;
	    };
	
	    /**
	     * Empties the texture pool.
	     *
	     */
	
	
	    FilterManager.prototype.emptyPool = function emptyPool() {
	        for (var i in this.pool) {
	            var textures = this.pool[i];
	
	            if (textures) {
	                for (var j = 0; j < textures.length; j++) {
	                    textures[j].destroy(true);
	                }
	            }
	        }
	
	        this.pool = {};
	    };
	
	    /**
	     * Frees a render target back into the pool.
	     *
	     * @param {PIXI.RenderTarget} renderTarget - The renderTarget to free
	     */
	
	
	    FilterManager.prototype.freePotRenderTarget = function freePotRenderTarget(renderTarget) {
	        this.pool[renderTarget.filterPoolKey].push(renderTarget);
	    };
	
	    /**
	     * Called before the renderer starts rendering.
	     *
	     */
	
	
	    FilterManager.prototype.onPrerender = function onPrerender() {
	        if (this._screenWidth !== this.renderer.view.width || this._screenHeight !== this.renderer.view.height) {
	            this._screenWidth = this.renderer.view.width;
	            this._screenHeight = this.renderer.view.height;
	
	            var textures = this.pool[screenKey];
	
	            if (textures) {
	                for (var j = 0; j < textures.length; j++) {
	                    textures[j].destroy(true);
	                }
	            }
	            this.pool[screenKey] = [];
	        }
	    };
	
	    return FilterManager;
	}(_WebGLManager3.default);
	
	exports.default = FilterManager;
	//# sourceMappingURL=FilterManager.js.map

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _math = __webpack_require__(206);
	
	var _const = __webpack_require__(205);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _pixiGlCore = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @class
	 * @memberof PIXI
	 */
	var RenderTarget = function () {
	  /**
	   * @param {WebGLRenderingContext} gl - The current WebGL drawing context
	   * @param {number} [width=0] - the horizontal range of the filter
	   * @param {number} [height=0] - the vertical range of the filter
	   * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	   * @param {number} [resolution=1] - The current resolution / device pixel ratio
	   * @param {boolean} [root=false] - Whether this object is the root element or not
	   */
	  function RenderTarget(gl, width, height, scaleMode, resolution, root) {
	    _classCallCheck(this, RenderTarget);
	
	    // TODO Resolution could go here ( eg low res blurs )
	
	    /**
	     * The current WebGL drawing context.
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	    // next time to create a frame buffer and texture
	
	    /**
	     * A frame buffer
	     *
	     * @member {PIXI.glCore.GLFramebuffer}
	     */
	    this.frameBuffer = null;
	
	    /**
	     * The texture
	     *
	     * @member {PIXI.glCore.GLTexture}
	     */
	    this.texture = null;
	
	    /**
	     * The background colour of this render target, as an array of [r,g,b,a] values
	     *
	     * @member {number[]}
	     */
	    this.clearColor = [0, 0, 0, 0];
	
	    /**
	     * The size of the object as a rectangle
	     *
	     * @member {PIXI.Rectangle}
	     */
	    this.size = new _math.Rectangle(0, 0, 1, 1);
	
	    /**
	     * The current resolution / device pixel ratio
	     *
	     * @member {number}
	     * @default 1
	     */
	    this.resolution = resolution || _settings2.default.RESOLUTION;
	
	    /**
	     * The projection matrix
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.projectionMatrix = new _math.Matrix();
	
	    /**
	     * The object's transform
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.transform = null;
	
	    /**
	     * The frame.
	     *
	     * @member {PIXI.Rectangle}
	     */
	    this.frame = null;
	
	    /**
	     * The stencil buffer stores masking data for the render target
	     *
	     * @member {glCore.GLBuffer}
	     */
	    this.defaultFrame = new _math.Rectangle();
	    this.destinationFrame = null;
	    this.sourceFrame = null;
	
	    /**
	     * The stencil buffer stores masking data for the render target
	     *
	     * @member {glCore.GLBuffer}
	     */
	    this.stencilBuffer = null;
	
	    /**
	     * The data structure for the stencil masks
	     *
	     * @member {PIXI.Graphics[]}
	     */
	    this.stencilMaskStack = [];
	
	    /**
	     * Stores filter data for the render target
	     *
	     * @member {object[]}
	     */
	    this.filterData = null;
	
	    /**
	     * The key for pooled texture of FilterSystem
	     * @private
	     * @member {string}
	     */
	    this.filterPoolKey = '';
	
	    /**
	     * The scale mode.
	     *
	     * @member {number}
	     * @default PIXI.settings.SCALE_MODE
	     * @see PIXI.SCALE_MODES
	     */
	    this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;
	
	    /**
	     * Whether this object is the root element or not
	     *
	     * @member {boolean}
	     */
	    this.root = root;
	
	    if (!this.root) {
	      this.frameBuffer = _pixiGlCore.GLFramebuffer.createRGBA(gl, 100, 100);
	
	      if (this.scaleMode === _const.SCALE_MODES.NEAREST) {
	        this.frameBuffer.texture.enableNearestScaling();
	      } else {
	        this.frameBuffer.texture.enableLinearScaling();
	      }
	      /*
	          A frame buffer needs a target to render to..
	          create a texture and bind it attach it to the framebuffer..
	       */
	
	      // this is used by the base texture
	      this.texture = this.frameBuffer.texture;
	    } else {
	      // make it a null framebuffer..
	      this.frameBuffer = new _pixiGlCore.GLFramebuffer(gl, 100, 100);
	      this.frameBuffer.framebuffer = null;
	    }
	
	    this.setFrame();
	
	    this.resize(width, height);
	  }
	
	  /**
	   * Clears the filter texture.
	   *
	   * @param {number[]} [clearColor=this.clearColor] - Array of [r,g,b,a] to clear the framebuffer
	   */
	
	
	  RenderTarget.prototype.clear = function clear(clearColor) {
	    var cc = clearColor || this.clearColor;
	
	    this.frameBuffer.clear(cc[0], cc[1], cc[2], cc[3]); // r,g,b,a);
	  };
	
	  /**
	   * Binds the stencil buffer.
	   *
	   */
	
	
	  RenderTarget.prototype.attachStencilBuffer = function attachStencilBuffer() {
	    // TODO check if stencil is done?
	    /**
	     * The stencil buffer is used for masking in pixi
	     * lets create one and then add attach it to the framebuffer..
	     */
	    if (!this.root) {
	      this.frameBuffer.enableStencil();
	    }
	  };
	
	  /**
	   * Sets the frame of the render target.
	   *
	   * @param {Rectangle} destinationFrame - The destination frame.
	   * @param {Rectangle} sourceFrame - The source frame.
	   */
	
	
	  RenderTarget.prototype.setFrame = function setFrame(destinationFrame, sourceFrame) {
	    this.destinationFrame = destinationFrame || this.destinationFrame || this.defaultFrame;
	    this.sourceFrame = sourceFrame || this.sourceFrame || this.destinationFrame;
	  };
	
	  /**
	   * Binds the buffers and initialises the viewport.
	   *
	   */
	
	
	  RenderTarget.prototype.activate = function activate() {
	    // TOOD refactor usage of frame..
	    var gl = this.gl;
	
	    // make sure the texture is unbound!
	    this.frameBuffer.bind();
	
	    this.calculateProjection(this.destinationFrame, this.sourceFrame);
	
	    if (this.transform) {
	      this.projectionMatrix.append(this.transform);
	    }
	
	    // TODO add a check as them may be the same!
	    if (this.destinationFrame !== this.sourceFrame) {
	      gl.enable(gl.SCISSOR_TEST);
	      gl.scissor(this.destinationFrame.x | 0, this.destinationFrame.y | 0, this.destinationFrame.width * this.resolution | 0, this.destinationFrame.height * this.resolution | 0);
	    } else {
	      gl.disable(gl.SCISSOR_TEST);
	    }
	
	    // TODO - does not need to be updated all the time??
	    gl.viewport(this.destinationFrame.x | 0, this.destinationFrame.y | 0, this.destinationFrame.width * this.resolution | 0, this.destinationFrame.height * this.resolution | 0);
	  };
	
	  /**
	   * Updates the projection matrix based on a projection frame (which is a rectangle)
	   *
	   * @param {Rectangle} destinationFrame - The destination frame.
	   * @param {Rectangle} sourceFrame - The source frame.
	   */
	
	
	  RenderTarget.prototype.calculateProjection = function calculateProjection(destinationFrame, sourceFrame) {
	    var pm = this.projectionMatrix;
	
	    sourceFrame = sourceFrame || destinationFrame;
	
	    pm.identity();
	
	    // TODO: make dest scale source
	    if (!this.root) {
	      pm.a = 1 / destinationFrame.width * 2;
	      pm.d = 1 / destinationFrame.height * 2;
	
	      pm.tx = -1 - sourceFrame.x * pm.a;
	      pm.ty = -1 - sourceFrame.y * pm.d;
	    } else {
	      pm.a = 1 / destinationFrame.width * 2;
	      pm.d = -1 / destinationFrame.height * 2;
	
	      pm.tx = -1 - sourceFrame.x * pm.a;
	      pm.ty = 1 - sourceFrame.y * pm.d;
	    }
	  };
	
	  /**
	   * Resizes the texture to the specified width and height
	   *
	   * @param {number} width - the new width of the texture
	   * @param {number} height - the new height of the texture
	   */
	
	
	  RenderTarget.prototype.resize = function resize(width, height) {
	    width = width | 0;
	    height = height | 0;
	
	    if (this.size.width === width && this.size.height === height) {
	      return;
	    }
	
	    this.size.width = width;
	    this.size.height = height;
	
	    this.defaultFrame.width = width;
	    this.defaultFrame.height = height;
	
	    this.frameBuffer.resize(width * this.resolution, height * this.resolution);
	
	    var projectionFrame = this.frame || this.size;
	
	    this.calculateProjection(projectionFrame);
	  };
	
	  /**
	   * Destroys the render target.
	   *
	   */
	
	
	  RenderTarget.prototype.destroy = function destroy() {
	    this.frameBuffer.destroy();
	
	    this.frameBuffer = null;
	    this.texture = null;
	  };
	
	  return RenderTarget;
	}();
	
	exports.default = RenderTarget;
	//# sourceMappingURL=RenderTarget.js.map

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pixiGlCore = __webpack_require__(216);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	var _createIndicesForQuads = __webpack_require__(291);
	
	var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Helper class to create a quad
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Quad = function () {
	  /**
	   * @param {WebGLRenderingContext} gl - The gl context for this quad to use.
	   * @param {object} state - TODO: Description
	   */
	  function Quad(gl, state) {
	    _classCallCheck(this, Quad);
	
	    /**
	     * the current WebGL drawing context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	    /**
	     * An array of vertices
	     *
	     * @member {Float32Array}
	     */
	    this.vertices = new Float32Array([-1, -1, 1, -1, 1, 1, -1, 1]);
	
	    /**
	     * The Uvs of the quad
	     *
	     * @member {Float32Array}
	     */
	    this.uvs = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);
	
	    this.interleaved = new Float32Array(8 * 2);
	
	    for (var i = 0; i < 4; i++) {
	      this.interleaved[i * 4] = this.vertices[i * 2];
	      this.interleaved[i * 4 + 1] = this.vertices[i * 2 + 1];
	      this.interleaved[i * 4 + 2] = this.uvs[i * 2];
	      this.interleaved[i * 4 + 3] = this.uvs[i * 2 + 1];
	    }
	
	    /**
	     * An array containing the indices of the vertices
	     *
	     * @member {Uint16Array}
	     */
	    this.indices = (0, _createIndicesForQuads2.default)(1);
	
	    /**
	     * The vertex buffer
	     *
	     * @member {glCore.GLBuffer}
	     */
	    this.vertexBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, this.interleaved, gl.STATIC_DRAW);
	
	    /**
	     * The index buffer
	     *
	     * @member {glCore.GLBuffer}
	     */
	    this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);
	
	    /**
	     * The vertex array object
	     *
	     * @member {glCore.VertexArrayObject}
	     */
	    this.vao = new _pixiGlCore2.default.VertexArrayObject(gl, state);
	  }
	
	  /**
	   * Initialises the vaos and uses the shader.
	   *
	   * @param {PIXI.Shader} shader - the shader to use
	   */
	
	
	  Quad.prototype.initVao = function initVao(shader) {
	    this.vao.clear().addIndex(this.indexBuffer).addAttribute(this.vertexBuffer, shader.attributes.aVertexPosition, this.gl.FLOAT, false, 4 * 4, 0).addAttribute(this.vertexBuffer, shader.attributes.aTextureCoord, this.gl.FLOAT, false, 4 * 4, 2 * 4);
	  };
	
	  /**
	   * Maps two Rectangle to the quad.
	   *
	   * @param {PIXI.Rectangle} targetTextureFrame - the first rectangle
	   * @param {PIXI.Rectangle} destinationFrame - the second rectangle
	   * @return {PIXI.Quad} Returns itself.
	   */
	
	
	  Quad.prototype.map = function map(targetTextureFrame, destinationFrame) {
	    var x = 0; // destinationFrame.x / targetTextureFrame.width;
	    var y = 0; // destinationFrame.y / targetTextureFrame.height;
	
	    this.uvs[0] = x;
	    this.uvs[1] = y;
	
	    this.uvs[2] = x + destinationFrame.width / targetTextureFrame.width;
	    this.uvs[3] = y;
	
	    this.uvs[4] = x + destinationFrame.width / targetTextureFrame.width;
	    this.uvs[5] = y + destinationFrame.height / targetTextureFrame.height;
	
	    this.uvs[6] = x;
	    this.uvs[7] = y + destinationFrame.height / targetTextureFrame.height;
	
	    x = destinationFrame.x;
	    y = destinationFrame.y;
	
	    this.vertices[0] = x;
	    this.vertices[1] = y;
	
	    this.vertices[2] = x + destinationFrame.width;
	    this.vertices[3] = y;
	
	    this.vertices[4] = x + destinationFrame.width;
	    this.vertices[5] = y + destinationFrame.height;
	
	    this.vertices[6] = x;
	    this.vertices[7] = y + destinationFrame.height;
	
	    return this;
	  };
	
	  /**
	   * Binds the buffer and uploads the data
	   *
	   * @return {PIXI.Quad} Returns itself.
	   */
	
	
	  Quad.prototype.upload = function upload() {
	    for (var i = 0; i < 4; i++) {
	      this.interleaved[i * 4] = this.vertices[i * 2];
	      this.interleaved[i * 4 + 1] = this.vertices[i * 2 + 1];
	      this.interleaved[i * 4 + 2] = this.uvs[i * 2];
	      this.interleaved[i * 4 + 3] = this.uvs[i * 2 + 1];
	    }
	
	    this.vertexBuffer.upload(this.interleaved);
	
	    return this;
	  };
	
	  /**
	   * Removes this quad from WebGL
	   */
	
	
	  Quad.prototype.destroy = function destroy() {
	    var gl = this.gl;
	
	    gl.deleteBuffer(this.vertexBuffer);
	    gl.deleteBuffer(this.indexBuffer);
	  };
	
	  return Quad;
	}();
	
	exports.default = Quad;
	//# sourceMappingURL=Quad.js.map

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = createIndicesForQuads;
	/**
	 * Generic Mask Stack data structure
	 *
	 * @memberof PIXI
	 * @function createIndicesForQuads
	 * @private
	 * @param {number} size - Number of quads
	 * @return {Uint16Array} indices
	 */
	function createIndicesForQuads(size) {
	    // the total number of indices in our array, there are 6 points per quad.
	
	    var totalIndices = size * 6;
	
	    var indices = new Uint16Array(totalIndices);
	
	    // fill the indices with the quads to draw
	    for (var i = 0, j = 0; i < totalIndices; i += 6, j += 4) {
	        indices[i + 0] = j + 0;
	        indices[i + 1] = j + 1;
	        indices[i + 2] = j + 2;
	        indices[i + 3] = j + 0;
	        indices[i + 4] = j + 2;
	        indices[i + 5] = j + 3;
	    }
	
	    return indices;
	}
	//# sourceMappingURL=createIndicesForQuads.js.map

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pixiGlCore = __webpack_require__(216);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function checkPrecision(src, def) {
	    if (src instanceof Array) {
	        if (src[0].substring(0, 9) !== 'precision') {
	            var copy = src.slice(0);
	
	            copy.unshift('precision ' + def + ' float;');
	
	            return copy;
	        }
	    } else if (src.trim().substring(0, 9) !== 'precision') {
	        return 'precision ' + def + ' float;\n' + src;
	    }
	
	    return src;
	}
	
	/**
	 * Wrapper class, webGL Shader for Pixi.
	 * Adds precision string if vertexSrc or fragmentSrc have no mention of it.
	 *
	 * @class
	 * @extends GLShader
	 * @memberof PIXI
	 */
	
	var Shader = function (_GLShader) {
	    _inherits(Shader, _GLShader);
	
	    /**
	     *
	     * @param {WebGLRenderingContext} gl - The current WebGL rendering context
	     * @param {string|string[]} vertexSrc - The vertex shader source as an array of strings.
	     * @param {string|string[]} fragmentSrc - The fragment shader source as an array of strings.
	     * @param {object} [attributeLocations] - A key value pair showing which location eact attribute should sit.
	                       e.g. {position:0, uvs:1}.
	     * @param {string} [precision] - The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
	     */
	    function Shader(gl, vertexSrc, fragmentSrc, attributeLocations, precision) {
	        _classCallCheck(this, Shader);
	
	        return _possibleConstructorReturn(this, _GLShader.call(this, gl, checkPrecision(vertexSrc, precision || _settings2.default.PRECISION_VERTEX), checkPrecision(fragmentSrc, precision || _settings2.default.PRECISION_FRAGMENT), undefined, attributeLocations));
	    }
	
	    return Shader;
	}(_pixiGlCore.GLShader);
	
	exports.default = Shader;
	//# sourceMappingURL=Shader.js.map

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.calculateScreenSpaceMatrix = calculateScreenSpaceMatrix;
	exports.calculateNormalizedScreenSpaceMatrix = calculateNormalizedScreenSpaceMatrix;
	exports.calculateSpriteMatrix = calculateSpriteMatrix;
	
	var _math = __webpack_require__(206);
	
	/**
	 * Calculates the mapped matrix
	 * @param filterArea {Rectangle} The filter area
	 * @param sprite {Sprite} the target sprite
	 * @param outputMatrix {Matrix} @alvin
	 * @private
	 */
	// TODO playing around here.. this is temporary - (will end up in the shader)
	// this returns a matrix that will normalise map filter cords in the filter to screen space
	function calculateScreenSpaceMatrix(outputMatrix, filterArea, textureSize) {
	    // let worldTransform = sprite.worldTransform.copy(Matrix.TEMP_MATRIX),
	    // let texture = {width:1136, height:700};//sprite._texture.baseTexture;
	
	    // TODO unwrap?
	    var mappedMatrix = outputMatrix.identity();
	
	    mappedMatrix.translate(filterArea.x / textureSize.width, filterArea.y / textureSize.height);
	
	    mappedMatrix.scale(textureSize.width, textureSize.height);
	
	    return mappedMatrix;
	}
	
	function calculateNormalizedScreenSpaceMatrix(outputMatrix, filterArea, textureSize) {
	    var mappedMatrix = outputMatrix.identity();
	
	    mappedMatrix.translate(filterArea.x / textureSize.width, filterArea.y / textureSize.height);
	
	    var translateScaleX = textureSize.width / filterArea.width;
	    var translateScaleY = textureSize.height / filterArea.height;
	
	    mappedMatrix.scale(translateScaleX, translateScaleY);
	
	    return mappedMatrix;
	}
	
	// this will map the filter coord so that a texture can be used based on the transform of a sprite
	function calculateSpriteMatrix(outputMatrix, filterArea, textureSize, sprite) {
	    var orig = sprite._texture.orig;
	    var mappedMatrix = outputMatrix.set(textureSize.width, 0, 0, textureSize.height, filterArea.x, filterArea.y);
	    var worldTransform = sprite.worldTransform.copy(_math.Matrix.TEMP_MATRIX);
	
	    worldTransform.invert();
	    mappedMatrix.prepend(worldTransform);
	    mappedMatrix.scale(1.0 / orig.width, 1.0 / orig.height);
	    mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y);
	
	    return mappedMatrix;
	}
	//# sourceMappingURL=filterTransforms.js.map

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pixiGlCore = __webpack_require__(216);
	
	var _const = __webpack_require__(205);
	
	var _RenderTarget = __webpack_require__(289);
	
	var _RenderTarget2 = _interopRequireDefault(_RenderTarget);
	
	var _utils = __webpack_require__(244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Helper class to create a webGL Texture
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TextureManager = function () {
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     */
	    function TextureManager(renderer) {
	        _classCallCheck(this, TextureManager);
	
	        /**
	         * A reference to the current renderer
	         *
	         * @member {PIXI.WebGLRenderer}
	         */
	        this.renderer = renderer;
	
	        /**
	         * The current WebGL rendering context
	         *
	         * @member {WebGLRenderingContext}
	         */
	        this.gl = renderer.gl;
	
	        /**
	         * Track textures in the renderer so we can no longer listen to them on destruction.
	         *
	         * @member {Array<*>}
	         * @private
	         */
	        this._managedTextures = [];
	    }
	
	    /**
	     * Binds a texture.
	     *
	     */
	
	
	    TextureManager.prototype.bindTexture = function bindTexture() {}
	    // empty
	
	
	    /**
	     * Gets a texture.
	     *
	     */
	    ;
	
	    TextureManager.prototype.getTexture = function getTexture() {}
	    // empty
	
	
	    /**
	     * Updates and/or Creates a WebGL texture for the renderer's context.
	     *
	     * @param {PIXI.BaseTexture|PIXI.Texture} texture - the texture to update
	     * @param {number} location - the location the texture will be bound to.
	     * @return {GLTexture} The gl texture.
	     */
	    ;
	
	    TextureManager.prototype.updateTexture = function updateTexture(texture, location) {
	        // assume it good!
	        // texture = texture.baseTexture || texture;
	
	        var gl = this.gl;
	
	        var isRenderTexture = !!texture._glRenderTargets;
	
	        if (!texture.hasLoaded) {
	            return null;
	        }
	
	        var boundTextures = this.renderer.boundTextures;
	
	        // if the location is undefined then this may have been called by n event.
	        // this being the case the texture may already be bound to a slot. As a texture can only be bound once
	        // we need to find its current location if it exists.
	        if (location === undefined) {
	            location = 0;
	
	            // TODO maybe we can use texture bound ids later on...
	            // check if texture is already bound..
	            for (var i = 0; i < boundTextures.length; ++i) {
	                if (boundTextures[i] === texture) {
	                    location = i;
	                    break;
	                }
	            }
	        }
	
	        boundTextures[location] = texture;
	
	        gl.activeTexture(gl.TEXTURE0 + location);
	
	        var glTexture = texture._glTextures[this.renderer.CONTEXT_UID];
	
	        if (!glTexture) {
	            if (isRenderTexture) {
	                var renderTarget = new _RenderTarget2.default(this.gl, texture.width, texture.height, texture.scaleMode, texture.resolution);
	
	                renderTarget.resize(texture.width, texture.height);
	                texture._glRenderTargets[this.renderer.CONTEXT_UID] = renderTarget;
	                glTexture = renderTarget.texture;
	            } else {
	                glTexture = new _pixiGlCore.GLTexture(this.gl, null, null, null, null);
	                glTexture.bind(location);
	                glTexture.premultiplyAlpha = true;
	                glTexture.upload(texture.source);
	            }
	
	            texture._glTextures[this.renderer.CONTEXT_UID] = glTexture;
	
	            texture.on('update', this.updateTexture, this);
	            texture.on('dispose', this.destroyTexture, this);
	
	            this._managedTextures.push(texture);
	
	            if (texture.isPowerOfTwo) {
	                if (texture.mipmap) {
	                    glTexture.enableMipmap();
	                }
	
	                if (texture.wrapMode === _const.WRAP_MODES.CLAMP) {
	                    glTexture.enableWrapClamp();
	                } else if (texture.wrapMode === _const.WRAP_MODES.REPEAT) {
	                    glTexture.enableWrapRepeat();
	                } else {
	                    glTexture.enableWrapMirrorRepeat();
	                }
	            } else {
	                glTexture.enableWrapClamp();
	            }
	
	            if (texture.scaleMode === _const.SCALE_MODES.NEAREST) {
	                glTexture.enableNearestScaling();
	            } else {
	                glTexture.enableLinearScaling();
	            }
	        }
	        // the texture already exists so we only need to update it..
	        else if (isRenderTexture) {
	                texture._glRenderTargets[this.renderer.CONTEXT_UID].resize(texture.width, texture.height);
	            } else {
	                glTexture.upload(texture.source);
	            }
	
	        return glTexture;
	    };
	
	    /**
	     * Deletes the texture from WebGL
	     *
	     * @param {PIXI.BaseTexture|PIXI.Texture} texture - the texture to destroy
	     * @param {boolean} [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
	     */
	
	
	    TextureManager.prototype.destroyTexture = function destroyTexture(texture, skipRemove) {
	        texture = texture.baseTexture || texture;
	
	        if (!texture.hasLoaded) {
	            return;
	        }
	
	        var uid = this.renderer.CONTEXT_UID;
	        var glTextures = texture._glTextures;
	        var glRenderTargets = texture._glRenderTargets;
	
	        if (glTextures[uid]) {
	            this.renderer.unbindTexture(texture);
	
	            glTextures[uid].destroy();
	            texture.off('update', this.updateTexture, this);
	            texture.off('dispose', this.destroyTexture, this);
	
	            delete glTextures[uid];
	
	            if (!skipRemove) {
	                var i = this._managedTextures.indexOf(texture);
	
	                if (i !== -1) {
	                    (0, _utils.removeItems)(this._managedTextures, i, 1);
	                }
	            }
	        }
	
	        if (glRenderTargets && glRenderTargets[uid]) {
	            glRenderTargets[uid].destroy();
	            delete glRenderTargets[uid];
	        }
	    };
	
	    /**
	     * Deletes all the textures from WebGL
	     */
	
	
	    TextureManager.prototype.removeAll = function removeAll() {
	        // empty all the old gl textures as they are useless now
	        for (var i = 0; i < this._managedTextures.length; ++i) {
	            var texture = this._managedTextures[i];
	
	            if (texture._glTextures[this.renderer.CONTEXT_UID]) {
	                delete texture._glTextures[this.renderer.CONTEXT_UID];
	            }
	        }
	    };
	
	    /**
	     * Destroys this manager and removes all its textures
	     */
	
	
	    TextureManager.prototype.destroy = function destroy() {
	        // destroy managed textures
	        for (var i = 0; i < this._managedTextures.length; ++i) {
	            var texture = this._managedTextures[i];
	
	            this.destroyTexture(texture, true);
	
	            texture.off('update', this.updateTexture, this);
	            texture.off('dispose', this.destroyTexture, this);
	        }
	
	        this._managedTextures = null;
	    };
	
	    return TextureManager;
	}();
	
	exports.default = TextureManager;
	//# sourceMappingURL=TextureManager.js.map

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _const = __webpack_require__(205);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * TextureGarbageCollector. This class manages the GPU and ensures that it does not get clogged
	 * up with textures that are no longer being used.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TextureGarbageCollector = function () {
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	     */
	    function TextureGarbageCollector(renderer) {
	        _classCallCheck(this, TextureGarbageCollector);
	
	        this.renderer = renderer;
	
	        this.count = 0;
	        this.checkCount = 0;
	        this.maxIdle = _settings2.default.GC_MAX_IDLE;
	        this.checkCountMax = _settings2.default.GC_MAX_CHECK_COUNT;
	        this.mode = _settings2.default.GC_MODE;
	    }
	
	    /**
	     * Checks to see when the last time a texture was used
	     * if the texture has not been used for a specified amount of time it will be removed from the GPU
	     */
	
	
	    TextureGarbageCollector.prototype.update = function update() {
	        this.count++;
	
	        if (this.mode === _const.GC_MODES.MANUAL) {
	            return;
	        }
	
	        this.checkCount++;
	
	        if (this.checkCount > this.checkCountMax) {
	            this.checkCount = 0;
	
	            this.run();
	        }
	    };
	
	    /**
	     * Checks to see when the last time a texture was used
	     * if the texture has not been used for a specified amount of time it will be removed from the GPU
	     */
	
	
	    TextureGarbageCollector.prototype.run = function run() {
	        var tm = this.renderer.textureManager;
	        var managedTextures = tm._managedTextures;
	        var wasRemoved = false;
	
	        for (var i = 0; i < managedTextures.length; i++) {
	            var texture = managedTextures[i];
	
	            // only supports non generated textures at the moment!
	            if (!texture._glRenderTargets && this.count - texture.touched > this.maxIdle) {
	                tm.destroyTexture(texture, true);
	                managedTextures[i] = null;
	                wasRemoved = true;
	            }
	        }
	
	        if (wasRemoved) {
	            var j = 0;
	
	            for (var _i = 0; _i < managedTextures.length; _i++) {
	                if (managedTextures[_i] !== null) {
	                    managedTextures[j++] = managedTextures[_i];
	                }
	            }
	
	            managedTextures.length = j;
	        }
	    };
	
	    /**
	     * Removes all the textures within the specified displayObject and its children from the GPU
	     *
	     * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
	     */
	
	
	    TextureGarbageCollector.prototype.unload = function unload(displayObject) {
	        var tm = this.renderer.textureManager;
	
	        // only destroy non generated textures
	        if (displayObject._texture && displayObject._texture._glRenderTargets) {
	            tm.destroyTexture(displayObject._texture, true);
	        }
	
	        for (var i = displayObject.children.length - 1; i >= 0; i--) {
	            this.unload(displayObject.children[i]);
	        }
	    };
	
	    return TextureGarbageCollector;
	}();
	
	exports.default = TextureGarbageCollector;
	//# sourceMappingURL=TextureGarbageCollector.js.map

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _mapWebGLBlendModesToPixi = __webpack_require__(297);
	
	var _mapWebGLBlendModesToPixi2 = _interopRequireDefault(_mapWebGLBlendModesToPixi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BLEND = 0;
	var DEPTH_TEST = 1;
	var FRONT_FACE = 2;
	var CULL_FACE = 3;
	var BLEND_FUNC = 4;
	
	/**
	 * A WebGL state machines
	 *
	 * @memberof PIXI
	 * @class
	 */
	
	var WebGLState = function () {
	    /**
	     * @param {WebGLRenderingContext} gl - The current WebGL rendering context
	     */
	    function WebGLState(gl) {
	        _classCallCheck(this, WebGLState);
	
	        /**
	         * The current active state
	         *
	         * @member {Uint8Array}
	         */
	        this.activeState = new Uint8Array(16);
	
	        /**
	         * The default state
	         *
	         * @member {Uint8Array}
	         */
	        this.defaultState = new Uint8Array(16);
	
	        // default blend mode..
	        this.defaultState[0] = 1;
	
	        /**
	         * The current state index in the stack
	         *
	         * @member {number}
	         * @private
	         */
	        this.stackIndex = 0;
	
	        /**
	         * The stack holding all the different states
	         *
	         * @member {Array<*>}
	         * @private
	         */
	        this.stack = [];
	
	        /**
	         * The current WebGL rendering context
	         *
	         * @member {WebGLRenderingContext}
	         */
	        this.gl = gl;
	
	        this.maxAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
	
	        this.attribState = {
	            tempAttribState: new Array(this.maxAttribs),
	            attribState: new Array(this.maxAttribs)
	        };
	
	        this.blendModes = (0, _mapWebGLBlendModesToPixi2.default)(gl);
	
	        // check we have vao..
	        this.nativeVaoExtension = gl.getExtension('OES_vertex_array_object') || gl.getExtension('MOZ_OES_vertex_array_object') || gl.getExtension('WEBKIT_OES_vertex_array_object');
	    }
	
	    /**
	     * Pushes a new active state
	     */
	
	
	    WebGLState.prototype.push = function push() {
	        // next state..
	        var state = this.stack[this.stackIndex];
	
	        if (!state) {
	            state = this.stack[this.stackIndex] = new Uint8Array(16);
	        }
	
	        ++this.stackIndex;
	
	        // copy state..
	        // set active state so we can force overrides of gl state
	        for (var i = 0; i < this.activeState.length; i++) {
	            state[i] = this.activeState[i];
	        }
	    };
	
	    /**
	     * Pops a state out
	     */
	
	
	    WebGLState.prototype.pop = function pop() {
	        var state = this.stack[--this.stackIndex];
	
	        this.setState(state);
	    };
	
	    /**
	     * Sets the current state
	     *
	     * @param {*} state - The state to set.
	     */
	
	
	    WebGLState.prototype.setState = function setState(state) {
	        this.setBlend(state[BLEND]);
	        this.setDepthTest(state[DEPTH_TEST]);
	        this.setFrontFace(state[FRONT_FACE]);
	        this.setCullFace(state[CULL_FACE]);
	        this.setBlendMode(state[BLEND_FUNC]);
	    };
	
	    /**
	     * Enables or disabled blending.
	     *
	     * @param {boolean} value - Turn on or off webgl blending.
	     */
	
	
	    WebGLState.prototype.setBlend = function setBlend(value) {
	        value = value ? 1 : 0;
	
	        if (this.activeState[BLEND] === value) {
	            return;
	        }
	
	        this.activeState[BLEND] = value;
	        this.gl[value ? 'enable' : 'disable'](this.gl.BLEND);
	    };
	
	    /**
	     * Sets the blend mode.
	     *
	     * @param {number} value - The blend mode to set to.
	     */
	
	
	    WebGLState.prototype.setBlendMode = function setBlendMode(value) {
	        if (value === this.activeState[BLEND_FUNC]) {
	            return;
	        }
	
	        this.activeState[BLEND_FUNC] = value;
	
	        var mode = this.blendModes[value];
	
	        if (mode.length === 2) {
	            this.gl.blendFunc(mode[0], mode[1]);
	        } else {
	            this.gl.blendFuncSeparate(mode[0], mode[1], mode[2], mode[3]);
	        }
	    };
	
	    /**
	     * Sets whether to enable or disable depth test.
	     *
	     * @param {boolean} value - Turn on or off webgl depth testing.
	     */
	
	
	    WebGLState.prototype.setDepthTest = function setDepthTest(value) {
	        value = value ? 1 : 0;
	
	        if (this.activeState[DEPTH_TEST] === value) {
	            return;
	        }
	
	        this.activeState[DEPTH_TEST] = value;
	        this.gl[value ? 'enable' : 'disable'](this.gl.DEPTH_TEST);
	    };
	
	    /**
	     * Sets whether to enable or disable cull face.
	     *
	     * @param {boolean} value - Turn on or off webgl cull face.
	     */
	
	
	    WebGLState.prototype.setCullFace = function setCullFace(value) {
	        value = value ? 1 : 0;
	
	        if (this.activeState[CULL_FACE] === value) {
	            return;
	        }
	
	        this.activeState[CULL_FACE] = value;
	        this.gl[value ? 'enable' : 'disable'](this.gl.CULL_FACE);
	    };
	
	    /**
	     * Sets the gl front face.
	     *
	     * @param {boolean} value - true is clockwise and false is counter-clockwise
	     */
	
	
	    WebGLState.prototype.setFrontFace = function setFrontFace(value) {
	        value = value ? 1 : 0;
	
	        if (this.activeState[FRONT_FACE] === value) {
	            return;
	        }
	
	        this.activeState[FRONT_FACE] = value;
	        this.gl.frontFace(this.gl[value ? 'CW' : 'CCW']);
	    };
	
	    /**
	     * Disables all the vaos in use
	     *
	     */
	
	
	    WebGLState.prototype.resetAttributes = function resetAttributes() {
	        for (var i = 0; i < this.attribState.tempAttribState.length; i++) {
	            this.attribState.tempAttribState[i] = 0;
	        }
	
	        for (var _i = 0; _i < this.attribState.attribState.length; _i++) {
	            this.attribState.attribState[_i] = 0;
	        }
	
	        // im going to assume one is always active for performance reasons.
	        for (var _i2 = 1; _i2 < this.maxAttribs; _i2++) {
	            this.gl.disableVertexAttribArray(_i2);
	        }
	    };
	
	    // used
	    /**
	     * Resets all the logic and disables the vaos
	     */
	
	
	    WebGLState.prototype.resetToDefault = function resetToDefault() {
	        // unbind any VAO if they exist..
	        if (this.nativeVaoExtension) {
	            this.nativeVaoExtension.bindVertexArrayOES(null);
	        }
	
	        // reset all attributes..
	        this.resetAttributes();
	
	        // set active state so we can force overrides of gl state
	        for (var i = 0; i < this.activeState.length; ++i) {
	            this.activeState[i] = 32;
	        }
	
	        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
	
	        this.setState(this.defaultState);
	    };
	
	    return WebGLState;
	}();
	
	exports.default = WebGLState;
	//# sourceMappingURL=WebGLState.js.map

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = mapWebGLBlendModesToPixi;
	
	var _const = __webpack_require__(205);
	
	/**
	 * Maps gl blend combinations to WebGL.
	 *
	 * @memberof PIXI
	 * @function mapWebGLBlendModesToPixi
	 * @private
	 * @param {WebGLRenderingContext} gl - The rendering context.
	 * @param {string[]} [array=[]] - The array to output into.
	 * @return {string[]} Mapped modes.
	 */
	function mapWebGLBlendModesToPixi(gl) {
	    var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    // TODO - premultiply alpha would be different.
	    // add a boolean for that!
	    array[_const.BLEND_MODES.NORMAL] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.ADD] = [gl.ONE, gl.DST_ALPHA];
	    array[_const.BLEND_MODES.MULTIPLY] = [gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.SCREEN] = [gl.ONE, gl.ONE_MINUS_SRC_COLOR];
	    array[_const.BLEND_MODES.OVERLAY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.DARKEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.LIGHTEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.COLOR_DODGE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.COLOR_BURN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.HARD_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.SOFT_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.DIFFERENCE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.EXCLUSION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.HUE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.SATURATION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.COLOR] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.LUMINOSITY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	
	    // not-premultiplied blend modes
	    array[_const.BLEND_MODES.NORMAL_NPM] = [gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.ADD_NPM] = [gl.SRC_ALPHA, gl.DST_ALPHA, gl.ONE, gl.DST_ALPHA];
	    array[_const.BLEND_MODES.SCREEN_NPM] = [gl.SRC_ALPHA, gl.ONE_MINUS_SRC_COLOR, gl.ONE, gl.ONE_MINUS_SRC_COLOR];
	
	    return array;
	}
	//# sourceMappingURL=mapWebGLBlendModesToPixi.js.map

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = mapWebGLDrawModesToPixi;
	
	var _const = __webpack_require__(205);
	
	/**
	 * Generic Mask Stack data structure.
	 *
	 * @memberof PIXI
	 * @function mapWebGLDrawModesToPixi
	 * @private
	 * @param {WebGLRenderingContext} gl - The current WebGL drawing context
	 * @param {object} [object={}] - The object to map into
	 * @return {object} The mapped draw modes.
	 */
	function mapWebGLDrawModesToPixi(gl) {
	  var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  object[_const.DRAW_MODES.POINTS] = gl.POINTS;
	  object[_const.DRAW_MODES.LINES] = gl.LINES;
	  object[_const.DRAW_MODES.LINE_LOOP] = gl.LINE_LOOP;
	  object[_const.DRAW_MODES.LINE_STRIP] = gl.LINE_STRIP;
	  object[_const.DRAW_MODES.TRIANGLES] = gl.TRIANGLES;
	  object[_const.DRAW_MODES.TRIANGLE_STRIP] = gl.TRIANGLE_STRIP;
	  object[_const.DRAW_MODES.TRIANGLE_FAN] = gl.TRIANGLE_FAN;
	
	  return object;
	}
	//# sourceMappingURL=mapWebGLDrawModesToPixi.js.map

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = validateContext;
	function validateContext(gl) {
	    var attributes = gl.getContextAttributes();
	
	    // this is going to be fairly simple for now.. but at least we have room to grow!
	    if (!attributes.stencil) {
	        /* eslint-disable no-console */
	        console.warn('Provided WebGL context does not have a stencil buffer, masks may not render correctly');
	        /* eslint-enable no-console */
	    }
	}
	//# sourceMappingURL=validateContext.js.map

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = generateMultiTextureShader;
	
	var _Shader = __webpack_require__(292);
	
	var _Shader2 = _interopRequireDefault(_Shader);
	
	var _path = __webpack_require__(285);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fragTemplate = ['varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'varying float vTextureId;', 'uniform sampler2D uSamplers[%count%];', 'void main(void){', 'vec4 color;', 'float textureId = floor(vTextureId+0.5);', '%forloop%', 'gl_FragColor = color * vColor;', '}'].join('\n');
	
	function generateMultiTextureShader(gl, maxTextures) {
	    var vertexSrc = 'precision highp float;\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\nattribute float aTextureId;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\n\nvoid main(void){\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vTextureId = aTextureId;\n    vColor = aColor;\n}\n';
	    var fragmentSrc = fragTemplate;
	
	    fragmentSrc = fragmentSrc.replace(/%count%/gi, maxTextures);
	    fragmentSrc = fragmentSrc.replace(/%forloop%/gi, generateSampleSrc(maxTextures));
	
	    var shader = new _Shader2.default(gl, vertexSrc, fragmentSrc);
	
	    var sampleValues = [];
	
	    for (var i = 0; i < maxTextures; i++) {
	        sampleValues[i] = i;
	    }
	
	    shader.bind();
	    shader.uniforms.uSamplers = sampleValues;
	
	    return shader;
	}
	
	function generateSampleSrc(maxTextures) {
	    var src = '';
	
	    src += '\n';
	    src += '\n';
	
	    for (var i = 0; i < maxTextures; i++) {
	        if (i > 0) {
	            src += '\nelse ';
	        }
	
	        if (i < maxTextures - 1) {
	            src += 'if(textureId == ' + i + '.0)';
	        }
	
	        src += '\n{';
	        src += '\n\tcolor = texture2D(uSamplers[' + i + '], vTextureCoord);';
	        src += '\n}';
	    }
	
	    src += '\n';
	    src += '\n';
	
	    return src;
	}
	//# sourceMappingURL=generateMultiTextureShader.js.map

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = checkMaxIfStatmentsInShader;
	
	var _pixiGlCore = __webpack_require__(216);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fragTemplate = ['precision mediump float;', 'void main(void){', 'float test = 0.1;', '%forloop%', 'gl_FragColor = vec4(0.0);', '}'].join('\n');
	
	function checkMaxIfStatmentsInShader(maxIfs, gl) {
	    var createTempContext = !gl;
	
	    // @if DEBUG
	    if (maxIfs === 0) {
	        throw new Error('Invalid value of `0` passed to `checkMaxIfStatementsInShader`');
	    }
	    // @endif
	
	    if (createTempContext) {
	        var tinyCanvas = document.createElement('canvas');
	
	        tinyCanvas.width = 1;
	        tinyCanvas.height = 1;
	
	        gl = _pixiGlCore2.default.createContext(tinyCanvas);
	    }
	
	    var shader = gl.createShader(gl.FRAGMENT_SHADER);
	
	    while (true) // eslint-disable-line no-constant-condition
	    {
	        var fragmentSrc = fragTemplate.replace(/%forloop%/gi, generateIfTestSrc(maxIfs));
	
	        gl.shaderSource(shader, fragmentSrc);
	        gl.compileShader(shader);
	
	        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
	            maxIfs = maxIfs / 2 | 0;
	        } else {
	            // valid!
	            break;
	        }
	    }
	
	    if (createTempContext) {
	        // get rid of context
	        if (gl.getExtension('WEBGL_lose_context')) {
	            gl.getExtension('WEBGL_lose_context').loseContext();
	        }
	    }
	
	    return maxIfs;
	}
	
	function generateIfTestSrc(maxIfs) {
	    var src = '';
	
	    for (var i = 0; i < maxIfs; ++i) {
	        if (i > 0) {
	            src += '\nelse ';
	        }
	
	        if (i < maxIfs - 1) {
	            src += 'if(test == ' + i + '.0){}';
	        }
	    }
	
	    return src;
	}
	//# sourceMappingURL=checkMaxIfStatmentsInShader.js.map

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @class
	 * @memberof PIXI
	 */
	var Buffer = function () {
	  /**
	   * @param {number} size - The size of the buffer in bytes.
	   */
	  function Buffer(size) {
	    _classCallCheck(this, Buffer);
	
	    this.vertices = new ArrayBuffer(size);
	
	    /**
	     * View on the vertices as a Float32Array for positions
	     *
	     * @member {Float32Array}
	     */
	    this.float32View = new Float32Array(this.vertices);
	
	    /**
	     * View on the vertices as a Uint32Array for uvs
	     *
	     * @member {Float32Array}
	     */
	    this.uint32View = new Uint32Array(this.vertices);
	  }
	
	  /**
	   * Destroys the buffer.
	   *
	   */
	
	
	  Buffer.prototype.destroy = function destroy() {
	    this.vertices = null;
	    this.positions = null;
	    this.uvs = null;
	    this.colors = null;
	  };
	
	  return Buffer;
	}();
	
	exports.default = Buffer;
	//# sourceMappingURL=BatchBuffer.js.map

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Sprite2 = __webpack_require__(250);
	
	var _Sprite3 = _interopRequireDefault(_Sprite2);
	
	var _Texture = __webpack_require__(251);
	
	var _Texture2 = _interopRequireDefault(_Texture);
	
	var _math = __webpack_require__(206);
	
	var _utils = __webpack_require__(244);
	
	var _const = __webpack_require__(205);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _TextStyle = __webpack_require__(304);
	
	var _TextStyle2 = _interopRequireDefault(_TextStyle);
	
	var _TextMetrics = __webpack_require__(305);
	
	var _TextMetrics2 = _interopRequireDefault(_TextMetrics);
	
	var _trimCanvas = __webpack_require__(306);
	
	var _trimCanvas2 = _interopRequireDefault(_trimCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint max-depth: [2, 8] */
	
	
	var defaultDestroyOptions = {
	    texture: true,
	    children: false,
	    baseTexture: true
	};
	
	/**
	 * A Text Object will create a line or multiple lines of text. To split a line you can use '\n' in your text string,
	 * or add a wordWrap property set to true and and wordWrapWidth property with a value in the style object.
	 *
	 * A Text can be created directly from a string and a style object
	 *
	 * ```js
	 * let text = new PIXI.Text('This is a PixiJS text',{fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'});
	 * ```
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI
	 */
	
	var Text = function (_Sprite) {
	    _inherits(Text, _Sprite);
	
	    /**
	     * @param {string} text - The string that you would like the text to display
	     * @param {object|PIXI.TextStyle} [style] - The style parameters
	     * @param {HTMLCanvasElement} [canvas] - The canvas element for drawing text
	     */
	    function Text(text, style, canvas) {
	        _classCallCheck(this, Text);
	
	        canvas = canvas || document.createElement('canvas');
	
	        canvas.width = 3;
	        canvas.height = 3;
	
	        var texture = _Texture2.default.fromCanvas(canvas, _settings2.default.SCALE_MODE, 'text');
	
	        texture.orig = new _math.Rectangle();
	        texture.trim = new _math.Rectangle();
	
	        // base texture is already automatically added to the cache, now adding the actual texture
	        var _this = _possibleConstructorReturn(this, _Sprite.call(this, texture));
	
	        _Texture2.default.addToCache(_this._texture, _this._texture.baseTexture.textureCacheIds[0]);
	
	        /**
	         * The canvas element that everything is drawn to
	         *
	         * @member {HTMLCanvasElement}
	         */
	        _this.canvas = canvas;
	
	        /**
	         * The canvas 2d context that everything is drawn with
	         * @member {CanvasRenderingContext2D}
	         */
	        _this.context = _this.canvas.getContext('2d');
	
	        /**
	         * The resolution / device pixel ratio of the canvas. This is set automatically by the renderer.
	         * @member {number}
	         * @default 1
	         */
	        _this.resolution = _settings2.default.RESOLUTION;
	
	        /**
	         * Private tracker for the current text.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._text = null;
	
	        /**
	         * Private tracker for the current style.
	         *
	         * @member {object}
	         * @private
	         */
	        _this._style = null;
	        /**
	         * Private listener to track style changes.
	         *
	         * @member {Function}
	         * @private
	         */
	        _this._styleListener = null;
	
	        /**
	         * Private tracker for the current font.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._font = '';
	
	        _this.text = text;
	        _this.style = style;
	
	        _this.localStyleID = -1;
	        return _this;
	    }
	
	    /**
	     * Renders text and updates it when needed.
	     *
	     * @private
	     * @param {boolean} respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
	     */
	
	
	    Text.prototype.updateText = function updateText(respectDirty) {
	        var style = this._style;
	
	        // check if style has changed..
	        if (this.localStyleID !== style.styleID) {
	            this.dirty = true;
	            this.localStyleID = style.styleID;
	        }
	
	        if (!this.dirty && respectDirty) {
	            return;
	        }
	
	        this._font = this._style.toFontString();
	
	        var context = this.context;
	        var measured = _TextMetrics2.default.measureText(this._text, this._style, this._style.wordWrap, this.canvas);
	        var width = measured.width;
	        var height = measured.height;
	        var lines = measured.lines;
	        var lineHeight = measured.lineHeight;
	        var lineWidths = measured.lineWidths;
	        var maxLineWidth = measured.maxLineWidth;
	        var fontProperties = measured.fontProperties;
	
	        this.canvas.width = Math.ceil((Math.max(1, width) + style.padding * 2) * this.resolution);
	        this.canvas.height = Math.ceil((Math.max(1, height) + style.padding * 2) * this.resolution);
	
	        context.scale(this.resolution, this.resolution);
	
	        context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	
	        context.font = this._font;
	        context.strokeStyle = style.stroke;
	        context.lineWidth = style.strokeThickness;
	        context.textBaseline = style.textBaseline;
	        context.lineJoin = style.lineJoin;
	        context.miterLimit = style.miterLimit;
	
	        var linePositionX = void 0;
	        var linePositionY = void 0;
	
	        if (style.dropShadow) {
	            context.fillStyle = style.dropShadowColor;
	            context.globalAlpha = style.dropShadowAlpha;
	            context.shadowBlur = style.dropShadowBlur;
	
	            if (style.dropShadowBlur > 0) {
	                context.shadowColor = style.dropShadowColor;
	            }
	
	            var xShadowOffset = Math.cos(style.dropShadowAngle) * style.dropShadowDistance;
	            var yShadowOffset = Math.sin(style.dropShadowAngle) * style.dropShadowDistance;
	
	            for (var i = 0; i < lines.length; i++) {
	                linePositionX = style.strokeThickness / 2;
	                linePositionY = style.strokeThickness / 2 + i * lineHeight + fontProperties.ascent;
	
	                if (style.align === 'right') {
	                    linePositionX += maxLineWidth - lineWidths[i];
	                } else if (style.align === 'center') {
	                    linePositionX += (maxLineWidth - lineWidths[i]) / 2;
	                }
	
	                if (style.fill) {
	                    this.drawLetterSpacing(lines[i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding);
	
	                    if (style.stroke && style.strokeThickness) {
	                        context.strokeStyle = style.dropShadowColor;
	                        this.drawLetterSpacing(lines[i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding, true);
	                        context.strokeStyle = style.stroke;
	                    }
	                }
	            }
	        }
	
	        // reset the shadow blur and alpha that was set by the drop shadow, for the regular text
	        context.shadowBlur = 0;
	        context.globalAlpha = 1;
	
	        // set canvas text styles
	        context.fillStyle = this._generateFillStyle(style, lines);
	
	        // draw lines line by line
	        for (var _i = 0; _i < lines.length; _i++) {
	            linePositionX = style.strokeThickness / 2;
	            linePositionY = style.strokeThickness / 2 + _i * lineHeight + fontProperties.ascent;
	
	            if (style.align === 'right') {
	                linePositionX += maxLineWidth - lineWidths[_i];
	            } else if (style.align === 'center') {
	                linePositionX += (maxLineWidth - lineWidths[_i]) / 2;
	            }
	
	            if (style.stroke && style.strokeThickness) {
	                this.drawLetterSpacing(lines[_i], linePositionX + style.padding, linePositionY + style.padding, true);
	            }
	
	            if (style.fill) {
	                this.drawLetterSpacing(lines[_i], linePositionX + style.padding, linePositionY + style.padding);
	            }
	        }
	
	        this.updateTexture();
	    };
	
	    /**
	     * Render the text with letter-spacing.
	     * @param {string} text - The text to draw
	     * @param {number} x - Horizontal position to draw the text
	     * @param {number} y - Vertical position to draw the text
	     * @param {boolean} [isStroke=false] - Is this drawing for the outside stroke of the
	     *  text? If not, it's for the inside fill
	     * @private
	     */
	
	
	    Text.prototype.drawLetterSpacing = function drawLetterSpacing(text, x, y) {
	        var isStroke = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        var style = this._style;
	
	        // letterSpacing of 0 means normal
	        var letterSpacing = style.letterSpacing;
	
	        if (letterSpacing === 0) {
	            if (isStroke) {
	                this.context.strokeText(text, x, y);
	            } else {
	                this.context.fillText(text, x, y);
	            }
	
	            return;
	        }
	
	        var characters = String.prototype.split.call(text, '');
	        var currentPosition = x;
	        var index = 0;
	        var current = '';
	
	        while (index < text.length) {
	            current = characters[index++];
	            if (isStroke) {
	                this.context.strokeText(current, currentPosition, y);
	            } else {
	                this.context.fillText(current, currentPosition, y);
	            }
	            currentPosition += this.context.measureText(current).width + letterSpacing;
	        }
	    };
	
	    /**
	     * Updates texture size based on canvas size
	     *
	     * @private
	     */
	
	
	    Text.prototype.updateTexture = function updateTexture() {
	        var canvas = this.canvas;
	
	        if (this._style.trim) {
	            var trimmed = (0, _trimCanvas2.default)(canvas);
	
	            canvas.width = trimmed.width;
	            canvas.height = trimmed.height;
	            this.context.putImageData(trimmed.data, 0, 0);
	        }
	
	        var texture = this._texture;
	        var style = this._style;
	        var padding = style.trim ? 0 : style.padding;
	        var baseTexture = texture.baseTexture;
	
	        baseTexture.hasLoaded = true;
	        baseTexture.resolution = this.resolution;
	
	        baseTexture.realWidth = canvas.width;
	        baseTexture.realHeight = canvas.height;
	        baseTexture.width = canvas.width / this.resolution;
	        baseTexture.height = canvas.height / this.resolution;
	
	        texture.trim.width = texture._frame.width = canvas.width / this.resolution;
	        texture.trim.height = texture._frame.height = canvas.height / this.resolution;
	        texture.trim.x = -padding;
	        texture.trim.y = -padding;
	
	        texture.orig.width = texture._frame.width - padding * 2;
	        texture.orig.height = texture._frame.height - padding * 2;
	
	        // call sprite onTextureUpdate to update scale if _width or _height were set
	        this._onTextureUpdate();
	
	        baseTexture.emit('update', baseTexture);
	
	        this.dirty = false;
	    };
	
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    Text.prototype.renderWebGL = function renderWebGL(renderer) {
	        if (this.resolution !== renderer.resolution) {
	            this.resolution = renderer.resolution;
	            this.dirty = true;
	        }
	
	        this.updateText(true);
	
	        _Sprite.prototype.renderWebGL.call(this, renderer);
	    };
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */
	
	
	    Text.prototype._renderCanvas = function _renderCanvas(renderer) {
	        if (this.resolution !== renderer.resolution) {
	            this.resolution = renderer.resolution;
	            this.dirty = true;
	        }
	
	        this.updateText(true);
	
	        _Sprite.prototype._renderCanvas.call(this, renderer);
	    };
	
	    /**
	     * Gets the local bounds of the text object.
	     *
	     * @param {Rectangle} rect - The output rectangle.
	     * @return {Rectangle} The bounds.
	     */
	
	
	    Text.prototype.getLocalBounds = function getLocalBounds(rect) {
	        this.updateText(true);
	
	        return _Sprite.prototype.getLocalBounds.call(this, rect);
	    };
	
	    /**
	     * calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account.
	     */
	
	
	    Text.prototype._calculateBounds = function _calculateBounds() {
	        this.updateText(true);
	        this.calculateVertices();
	        // if we have already done this on THIS frame.
	        this._bounds.addQuad(this.vertexData);
	    };
	
	    /**
	     * Method to be called upon a TextStyle change.
	     * @private
	     */
	
	
	    Text.prototype._onStyleChange = function _onStyleChange() {
	        this.dirty = true;
	    };
	
	    /**
	     * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
	     *
	     * @private
	     * @param {object} style - The style.
	     * @param {string[]} lines - The lines of text.
	     * @return {string|number|CanvasGradient} The fill style
	     */
	
	
	    Text.prototype._generateFillStyle = function _generateFillStyle(style, lines) {
	        if (!Array.isArray(style.fill)) {
	            return style.fill;
	        }
	
	        // cocoon on canvas+ cannot generate textures, so use the first colour instead
	        if (navigator.isCocoonJS) {
	            return style.fill[0];
	        }
	
	        // the gradient will be evenly spaced out according to how large the array is.
	        // ['#FF0000', '#00FF00', '#0000FF'] would created stops at 0.25, 0.5 and 0.75
	        var gradient = void 0;
	        var totalIterations = void 0;
	        var currentIteration = void 0;
	        var stop = void 0;
	
	        var width = this.canvas.width / this.resolution;
	        var height = this.canvas.height / this.resolution;
	
	        // make a copy of the style settings, so we can manipulate them later
	        var fill = style.fill.slice();
	        var fillGradientStops = style.fillGradientStops.slice();
	
	        // wanting to evenly distribute the fills. So an array of 4 colours should give fills of 0.25, 0.5 and 0.75
	        if (!fillGradientStops.length) {
	            var lengthPlus1 = fill.length + 1;
	
	            for (var i = 1; i < lengthPlus1; ++i) {
	                fillGradientStops.push(i / lengthPlus1);
	            }
	        }
	
	        // stop the bleeding of the last gradient on the line above to the top gradient of the this line
	        // by hard defining the first gradient colour at point 0, and last gradient colour at point 1
	        fill.unshift(style.fill[0]);
	        fillGradientStops.unshift(0);
	
	        fill.push(style.fill[style.fill.length - 1]);
	        fillGradientStops.push(1);
	
	        if (style.fillGradientType === _const.TEXT_GRADIENT.LINEAR_VERTICAL) {
	            // start the gradient at the top center of the canvas, and end at the bottom middle of the canvas
	            gradient = this.context.createLinearGradient(width / 2, 0, width / 2, height);
	
	            // we need to repeat the gradient so that each individual line of text has the same vertical gradient effect
	            // ['#FF0000', '#00FF00', '#0000FF'] over 2 lines would create stops at 0.125, 0.25, 0.375, 0.625, 0.75, 0.875
	            totalIterations = (fill.length + 1) * lines.length;
	            currentIteration = 0;
	            for (var _i2 = 0; _i2 < lines.length; _i2++) {
	                currentIteration += 1;
	                for (var j = 0; j < fill.length; j++) {
	                    if (typeof fillGradientStops[j] === 'number') {
	                        stop = fillGradientStops[j] / lines.length + _i2 / lines.length;
	                    } else {
	                        stop = currentIteration / totalIterations;
	                    }
	                    gradient.addColorStop(stop, fill[j]);
	                    currentIteration++;
	                }
	            }
	        } else {
	            // start the gradient at the center left of the canvas, and end at the center right of the canvas
	            gradient = this.context.createLinearGradient(0, height / 2, width, height / 2);
	
	            // can just evenly space out the gradients in this case, as multiple lines makes no difference
	            // to an even left to right gradient
	            totalIterations = fill.length + 1;
	            currentIteration = 1;
	
	            for (var _i3 = 0; _i3 < fill.length; _i3++) {
	                if (typeof fillGradientStops[_i3] === 'number') {
	                    stop = fillGradientStops[_i3];
	                } else {
	                    stop = currentIteration / totalIterations;
	                }
	                gradient.addColorStop(stop, fill[_i3]);
	                currentIteration++;
	            }
	        }
	
	        return gradient;
	    };
	
	    /**
	     * Destroys this text object.
	     * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
	     * the majority of the time the texture will not be shared with any other Sprites.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their
	     *  destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
	     */
	
	
	    Text.prototype.destroy = function destroy(options) {
	        if (typeof options === 'boolean') {
	            options = { children: options };
	        }
	
	        options = Object.assign({}, defaultDestroyOptions, options);
	
	        _Sprite.prototype.destroy.call(this, options);
	
	        // make sure to reset the the context and canvas.. dont want this hanging around in memory!
	        this.context = null;
	        this.canvas = null;
	
	        this._style = null;
	    };
	
	    /**
	     * The width of the Text, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     */
	
	
	    _createClass(Text, [{
	        key: 'width',
	        get: function get() {
	            this.updateText(true);
	
	            return Math.abs(this.scale.x) * this._texture.orig.width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.updateText(true);
	
	            var s = (0, _utils.sign)(this.scale.x) || 1;
	
	            this.scale.x = s * value / this._texture.orig.width;
	            this._width = value;
	        }
	
	        /**
	         * The height of the Text, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'height',
	        get: function get() {
	            this.updateText(true);
	
	            return Math.abs(this.scale.y) * this._texture.orig.height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.updateText(true);
	
	            var s = (0, _utils.sign)(this.scale.y) || 1;
	
	            this.scale.y = s * value / this._texture.orig.height;
	            this._height = value;
	        }
	
	        /**
	         * Set the style of the text. Set up an event listener to listen for changes on the style
	         * object and mark the text as dirty.
	         *
	         * @member {object|PIXI.TextStyle}
	         */
	
	    }, {
	        key: 'style',
	        get: function get() {
	            return this._style;
	        },
	        set: function set(style) // eslint-disable-line require-jsdoc
	        {
	            style = style || {};
	
	            if (style instanceof _TextStyle2.default) {
	                this._style = style;
	            } else {
	                this._style = new _TextStyle2.default(style);
	            }
	
	            this.localStyleID = -1;
	            this.dirty = true;
	        }
	
	        /**
	         * Set the copy for the text object. To split a line you can use '\n'.
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'text',
	        get: function get() {
	            return this._text;
	        },
	        set: function set(text) // eslint-disable-line require-jsdoc
	        {
	            text = String(text === '' || text === null || text === undefined ? ' ' : text);
	
	            if (this._text === text) {
	                return;
	            }
	            this._text = text;
	            this.dirty = true;
	        }
	    }]);
	
	    return Text;
	}(_Sprite3.default);
	
	exports.default = Text;
	//# sourceMappingURL=Text.js.map

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // disabling eslint for now, going to rewrite this in v5
	/* eslint-disable */
	
	var _const = __webpack_require__(205);
	
	var _utils = __webpack_require__(244);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultStyle = {
	    align: 'left',
	    breakWords: false,
	    dropShadow: false,
	    dropShadowAlpha: 1,
	    dropShadowAngle: Math.PI / 6,
	    dropShadowBlur: 0,
	    dropShadowColor: 'black',
	    dropShadowDistance: 5,
	    fill: 'black',
	    fillGradientType: _const.TEXT_GRADIENT.LINEAR_VERTICAL,
	    fillGradientStops: [],
	    fontFamily: 'Arial',
	    fontSize: 26,
	    fontStyle: 'normal',
	    fontVariant: 'normal',
	    fontWeight: 'normal',
	    letterSpacing: 0,
	    lineHeight: 0,
	    lineJoin: 'miter',
	    miterLimit: 10,
	    padding: 0,
	    stroke: 'black',
	    strokeThickness: 0,
	    textBaseline: 'alphabetic',
	    trim: false,
	    whiteSpace: 'pre',
	    wordWrap: false,
	    wordWrapWidth: 100,
	    leading: 0
	};
	
	/**
	 * A TextStyle Object decorates a Text Object. It can be shared between
	 * multiple Text objects. Changing the style will update all text objects using it.
	 *
	 * @class
	 * @memberof PIXI
	 */
	
	var TextStyle = function () {
	    /**
	     * @param {object} [style] - The style parameters
	     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'),
	     *  does not affect single line text
	     * @param {boolean} [style.breakWords=false] - Indicates if lines can be wrapped within words, it
	     *  needs wordWrap to be set to true
	     * @param {boolean} [style.dropShadow=false] - Set a drop shadow for the text
	     * @param {number} [style.dropShadowAlpha=1] - Set alpha for the drop shadow
	     * @param {number} [style.dropShadowAngle=Math.PI/6] - Set a angle of the drop shadow
	     * @param {number} [style.dropShadowBlur=0] - Set a shadow blur radius
	     * @param {string|number} [style.dropShadowColor='black'] - A fill style to be used on the dropshadow e.g 'red', '#00FF00'
	     * @param {number} [style.dropShadowDistance=5] - Set a distance of the drop shadow
	     * @param {string|string[]|number|number[]|CanvasGradient|CanvasPattern} [style.fill='black'] - A canvas
	     *  fillstyle that will be used on the text e.g 'red', '#00FF00'. Can be an array to create a gradient
	     *  eg ['#000000','#FFFFFF']
	     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
	     * @param {number} [style.fillGradientType=PIXI.TEXT_GRADIENT.LINEAR_VERTICAL] - If fill is an array of colours
	     *  to create a gradient, this can change the type/direction of the gradient. See {@link PIXI.TEXT_GRADIENT}
	     * @param {number[]} [style.fillGradientStops] - If fill is an array of colours to create a gradient, this array can set
	     * the stop points (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
	     * @param {string|string[]} [style.fontFamily='Arial'] - The font family
	     * @param {number|string} [style.fontSize=26] - The font size (as a number it converts to px, but as a string,
	     *  equivalents are '26px','20pt','160%' or '1.6em')
	     * @param {string} [style.fontStyle='normal'] - The font style ('normal', 'italic' or 'oblique')
	     * @param {string} [style.fontVariant='normal'] - The font variant ('normal' or 'small-caps')
	     * @param {string} [style.fontWeight='normal'] - The font weight ('normal', 'bold', 'bolder', 'lighter' and '100',
	     *  '200', '300', '400', '500', '600', '700', 800' or '900')
	     * @param {number} [style.leading=0] - The space between lines
	     * @param {number} [style.letterSpacing=0] - The amount of spacing between letters, default is 0
	     * @param {number} [style.lineHeight] - The line height, a number that represents the vertical space that a letter uses
	     * @param {string} [style.lineJoin='miter'] - The lineJoin property sets the type of corner created, it can resolve
	     *      spiked text issues. Possible values "miter" (creates a sharp corner), "round" (creates a round corner) or "bevel"
	     *      (creates a squared corner).
	     * @param {number} [style.miterLimit=10] - The miter limit to use when using the 'miter' lineJoin mode. This can reduce
	     *      or increase the spikiness of rendered text.
	     * @param {number} [style.padding=0] - Occasionally some fonts are cropped. Adding some padding will prevent this from
	     *     happening by adding padding to all sides of the text.
	     * @param {string|number} [style.stroke='black'] - A canvas fillstyle that will be used on the text stroke
	     *  e.g 'blue', '#FCFF00'
	     * @param {number} [style.strokeThickness=0] - A number that represents the thickness of the stroke.
	     *  Default is 0 (no stroke)
	     * @param {boolean} [style.trim=false] - Trim transparent borders
	     * @param {string} [style.textBaseline='alphabetic'] - The baseline of the text that is rendered.
	     * @param {boolean} [style.whiteSpace='pre'] - Determines whether newlines & spaces are collapsed or preserved "normal"
	     *      (collapse, collapse), "pre" (preserve, preserve) | "pre-line" (preserve, collapse). It needs wordWrap to be set to true
	     * @param {boolean} [style.wordWrap=false] - Indicates if word wrap should be used
	     * @param {number} [style.wordWrapWidth=100] - The width at which text will wrap, it needs wordWrap to be set to true
	     */
	    function TextStyle(style) {
	        _classCallCheck(this, TextStyle);
	
	        this.styleID = 0;
	
	        this.reset();
	
	        deepCopyProperties(this, style, style);
	    }
	
	    /**
	     * Creates a new TextStyle object with the same values as this one.
	     * Note that the only the properties of the object are cloned.
	     *
	     * @return {PIXI.TextStyle} New cloned TextStyle object
	     */
	
	
	    TextStyle.prototype.clone = function clone() {
	        var clonedProperties = {};
	
	        deepCopyProperties(clonedProperties, this, defaultStyle);
	
	        return new TextStyle(clonedProperties);
	    };
	
	    /**
	     * Resets all properties to the defaults specified in TextStyle.prototype._default
	     */
	
	
	    TextStyle.prototype.reset = function reset() {
	        deepCopyProperties(this, defaultStyle, defaultStyle);
	    };
	
	    /**
	     * Alignment for multiline text ('left', 'center' or 'right'), does not affect single line text
	     *
	     * @member {string}
	     */
	
	
	    /**
	     * Generates a font style string to use for `TextMetrics.measureFont()`.
	     *
	     * @return {string} Font style string, for passing to `TextMetrics.measureFont()`
	     */
	    TextStyle.prototype.toFontString = function toFontString() {
	        // build canvas api font setting from individual components. Convert a numeric this.fontSize to px
	        var fontSizeString = typeof this.fontSize === 'number' ? this.fontSize + 'px' : this.fontSize;
	
	        // Clean-up fontFamily property by quoting each font name
	        // this will support font names with spaces
	        var fontFamilies = this.fontFamily;
	
	        if (!Array.isArray(this.fontFamily)) {
	            fontFamilies = this.fontFamily.split(',');
	        }
	
	        for (var i = fontFamilies.length - 1; i >= 0; i--) {
	            // Trim any extra white-space
	            var fontFamily = fontFamilies[i].trim();
	
	            // Check if font already contains strings
	            if (!/([\"\'])[^\'\"]+\1/.test(fontFamily)) {
	                fontFamily = '"' + fontFamily + '"';
	            }
	            fontFamilies[i] = fontFamily;
	        }
	
	        return this.fontStyle + ' ' + this.fontVariant + ' ' + this.fontWeight + ' ' + fontSizeString + ' ' + fontFamilies.join(',');
	    };
	
	    _createClass(TextStyle, [{
	        key: 'align',
	        get: function get() {
	            return this._align;
	        },
	        set: function set(align) // eslint-disable-line require-jsdoc
	        {
	            if (this._align !== align) {
	                this._align = align;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Indicates if lines can be wrapped within words, it needs wordWrap to be set to true
	         *
	         * @member {boolean}
	         */
	
	    }, {
	        key: 'breakWords',
	        get: function get() {
	            return this._breakWords;
	        },
	        set: function set(breakWords) // eslint-disable-line require-jsdoc
	        {
	            if (this._breakWords !== breakWords) {
	                this._breakWords = breakWords;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Set a drop shadow for the text
	         *
	         * @member {boolean}
	         */
	
	    }, {
	        key: 'dropShadow',
	        get: function get() {
	            return this._dropShadow;
	        },
	        set: function set(dropShadow) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadow !== dropShadow) {
	                this._dropShadow = dropShadow;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Set alpha for the drop shadow
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'dropShadowAlpha',
	        get: function get() {
	            return this._dropShadowAlpha;
	        },
	        set: function set(dropShadowAlpha) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadowAlpha !== dropShadowAlpha) {
	                this._dropShadowAlpha = dropShadowAlpha;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Set a angle of the drop shadow
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'dropShadowAngle',
	        get: function get() {
	            return this._dropShadowAngle;
	        },
	        set: function set(dropShadowAngle) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadowAngle !== dropShadowAngle) {
	                this._dropShadowAngle = dropShadowAngle;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Set a shadow blur radius
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'dropShadowBlur',
	        get: function get() {
	            return this._dropShadowBlur;
	        },
	        set: function set(dropShadowBlur) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadowBlur !== dropShadowBlur) {
	                this._dropShadowBlur = dropShadowBlur;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * A fill style to be used on the dropshadow e.g 'red', '#00FF00'
	         *
	         * @member {string|number}
	         */
	
	    }, {
	        key: 'dropShadowColor',
	        get: function get() {
	            return this._dropShadowColor;
	        },
	        set: function set(dropShadowColor) // eslint-disable-line require-jsdoc
	        {
	            var outputColor = getColor(dropShadowColor);
	            if (this._dropShadowColor !== outputColor) {
	                this._dropShadowColor = outputColor;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Set a distance of the drop shadow
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'dropShadowDistance',
	        get: function get() {
	            return this._dropShadowDistance;
	        },
	        set: function set(dropShadowDistance) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadowDistance !== dropShadowDistance) {
	                this._dropShadowDistance = dropShadowDistance;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * A canvas fillstyle that will be used on the text e.g 'red', '#00FF00'.
	         * Can be an array to create a gradient eg ['#000000','#FFFFFF']
	         * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
	         *
	         * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
	         */
	
	    }, {
	        key: 'fill',
	        get: function get() {
	            return this._fill;
	        },
	        set: function set(fill) // eslint-disable-line require-jsdoc
	        {
	            var outputColor = getColor(fill);
	            if (this._fill !== outputColor) {
	                this._fill = outputColor;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
	         * See {@link PIXI.TEXT_GRADIENT}
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'fillGradientType',
	        get: function get() {
	            return this._fillGradientType;
	        },
	        set: function set(fillGradientType) // eslint-disable-line require-jsdoc
	        {
	            if (this._fillGradientType !== fillGradientType) {
	                this._fillGradientType = fillGradientType;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * If fill is an array of colours to create a gradient, this array can set the stop points
	         * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
	         *
	         * @member {number[]}
	         */
	
	    }, {
	        key: 'fillGradientStops',
	        get: function get() {
	            return this._fillGradientStops;
	        },
	        set: function set(fillGradientStops) // eslint-disable-line require-jsdoc
	        {
	            if (!areArraysEqual(this._fillGradientStops, fillGradientStops)) {
	                this._fillGradientStops = fillGradientStops;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The font family
	         *
	         * @member {string|string[]}
	         */
	
	    }, {
	        key: 'fontFamily',
	        get: function get() {
	            return this._fontFamily;
	        },
	        set: function set(fontFamily) // eslint-disable-line require-jsdoc
	        {
	            if (this.fontFamily !== fontFamily) {
	                this._fontFamily = fontFamily;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The font size
	         * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
	         *
	         * @member {number|string}
	         */
	
	    }, {
	        key: 'fontSize',
	        get: function get() {
	            return this._fontSize;
	        },
	        set: function set(fontSize) // eslint-disable-line require-jsdoc
	        {
	            if (this._fontSize !== fontSize) {
	                this._fontSize = fontSize;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The font style
	         * ('normal', 'italic' or 'oblique')
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'fontStyle',
	        get: function get() {
	            return this._fontStyle;
	        },
	        set: function set(fontStyle) // eslint-disable-line require-jsdoc
	        {
	            if (this._fontStyle !== fontStyle) {
	                this._fontStyle = fontStyle;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The font variant
	         * ('normal' or 'small-caps')
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'fontVariant',
	        get: function get() {
	            return this._fontVariant;
	        },
	        set: function set(fontVariant) // eslint-disable-line require-jsdoc
	        {
	            if (this._fontVariant !== fontVariant) {
	                this._fontVariant = fontVariant;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The font weight
	         * ('normal', 'bold', 'bolder', 'lighter' and '100', '200', '300', '400', '500', '600', '700', 800' or '900')
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'fontWeight',
	        get: function get() {
	            return this._fontWeight;
	        },
	        set: function set(fontWeight) // eslint-disable-line require-jsdoc
	        {
	            if (this._fontWeight !== fontWeight) {
	                this._fontWeight = fontWeight;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The amount of spacing between letters, default is 0
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'letterSpacing',
	        get: function get() {
	            return this._letterSpacing;
	        },
	        set: function set(letterSpacing) // eslint-disable-line require-jsdoc
	        {
	            if (this._letterSpacing !== letterSpacing) {
	                this._letterSpacing = letterSpacing;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The line height, a number that represents the vertical space that a letter uses
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'lineHeight',
	        get: function get() {
	            return this._lineHeight;
	        },
	        set: function set(lineHeight) // eslint-disable-line require-jsdoc
	        {
	            if (this._lineHeight !== lineHeight) {
	                this._lineHeight = lineHeight;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The space between lines
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'leading',
	        get: function get() {
	            return this._leading;
	        },
	        set: function set(leading) // eslint-disable-line require-jsdoc
	        {
	            if (this._leading !== leading) {
	                this._leading = leading;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
	         * Default is 'miter' (creates a sharp corner).
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'lineJoin',
	        get: function get() {
	            return this._lineJoin;
	        },
	        set: function set(lineJoin) // eslint-disable-line require-jsdoc
	        {
	            if (this._lineJoin !== lineJoin) {
	                this._lineJoin = lineJoin;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The miter limit to use when using the 'miter' lineJoin mode
	         * This can reduce or increase the spikiness of rendered text.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'miterLimit',
	        get: function get() {
	            return this._miterLimit;
	        },
	        set: function set(miterLimit) // eslint-disable-line require-jsdoc
	        {
	            if (this._miterLimit !== miterLimit) {
	                this._miterLimit = miterLimit;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
	         * by adding padding to all sides of the text.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'padding',
	        get: function get() {
	            return this._padding;
	        },
	        set: function set(padding) // eslint-disable-line require-jsdoc
	        {
	            if (this._padding !== padding) {
	                this._padding = padding;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * A canvas fillstyle that will be used on the text stroke
	         * e.g 'blue', '#FCFF00'
	         *
	         * @member {string|number}
	         */
	
	    }, {
	        key: 'stroke',
	        get: function get() {
	            return this._stroke;
	        },
	        set: function set(stroke) // eslint-disable-line require-jsdoc
	        {
	            var outputColor = getColor(stroke);
	            if (this._stroke !== outputColor) {
	                this._stroke = outputColor;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * A number that represents the thickness of the stroke.
	         * Default is 0 (no stroke)
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'strokeThickness',
	        get: function get() {
	            return this._strokeThickness;
	        },
	        set: function set(strokeThickness) // eslint-disable-line require-jsdoc
	        {
	            if (this._strokeThickness !== strokeThickness) {
	                this._strokeThickness = strokeThickness;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The baseline of the text that is rendered.
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'textBaseline',
	        get: function get() {
	            return this._textBaseline;
	        },
	        set: function set(textBaseline) // eslint-disable-line require-jsdoc
	        {
	            if (this._textBaseline !== textBaseline) {
	                this._textBaseline = textBaseline;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Trim transparent borders
	         *
	         * @member {boolean}
	         */
	
	    }, {
	        key: 'trim',
	        get: function get() {
	            return this._trim;
	        },
	        set: function set(trim) // eslint-disable-line require-jsdoc
	        {
	            if (this._trim !== trim) {
	                this._trim = trim;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * How newlines and spaces should be handled.
	         * Default is 'pre' (preserve, preserve).
	         *
	         *  value       | New lines     |   Spaces
	         *  ---         | ---           |   ---
	         * 'normal'     | Collapse      |   Collapse
	         * 'pre'        | Preserve      |   Preserve
	         * 'pre-line'   | Preserve      |   Collapse
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'whiteSpace',
	        get: function get() {
	            return this._whiteSpace;
	        },
	        set: function set(whiteSpace) // eslint-disable-line require-jsdoc
	        {
	            if (this._whiteSpace !== whiteSpace) {
	                this._whiteSpace = whiteSpace;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Indicates if word wrap should be used
	         *
	         * @member {boolean}
	         */
	
	    }, {
	        key: 'wordWrap',
	        get: function get() {
	            return this._wordWrap;
	        },
	        set: function set(wordWrap) // eslint-disable-line require-jsdoc
	        {
	            if (this._wordWrap !== wordWrap) {
	                this._wordWrap = wordWrap;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The width at which text will wrap, it needs wordWrap to be set to true
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'wordWrapWidth',
	        get: function get() {
	            return this._wordWrapWidth;
	        },
	        set: function set(wordWrapWidth) // eslint-disable-line require-jsdoc
	        {
	            if (this._wordWrapWidth !== wordWrapWidth) {
	                this._wordWrapWidth = wordWrapWidth;
	                this.styleID++;
	            }
	        }
	    }]);
	
	    return TextStyle;
	}();
	
	/**
	 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
	 * @private
	 * @param {number|number[]} color
	 * @return {string} The color as a string.
	 */
	
	
	exports.default = TextStyle;
	function getSingleColor(color) {
	    if (typeof color === 'number') {
	        return (0, _utils.hex2string)(color);
	    } else if (typeof color === 'string') {
	        if (color.indexOf('0x') === 0) {
	            color = color.replace('0x', '#');
	        }
	    }
	
	    return color;
	}
	
	/**
	 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
	 * This version can also convert array of colors
	 * @private
	 * @param {number|number[]} color
	 * @return {string} The color as a string.
	 */
	function getColor(color) {
	    if (!Array.isArray(color)) {
	        return getSingleColor(color);
	    } else {
	        for (var i = 0; i < color.length; ++i) {
	            color[i] = getSingleColor(color[i]);
	        }
	
	        return color;
	    }
	}
	
	/**
	 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
	 * This version can also convert array of colors
	 * @private
	 * @param {Array} array1 First array to compare
	 * @param {Array} array2 Second array to compare
	 * @return {boolean} Do the arrays contain the same values in the same order
	 */
	function areArraysEqual(array1, array2) {
	    if (!Array.isArray(array1) || !Array.isArray(array2)) {
	        return false;
	    }
	
	    if (array1.length !== array2.length) {
	        return false;
	    }
	
	    for (var i = 0; i < array1.length; ++i) {
	        if (array1[i] !== array2[i]) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	/**
	 * Utility function to ensure that object properties are copied by value, and not by reference
	 * @private
	 * @param {Object} target Target object to copy properties into
	 * @param {Object} source Source object for the proporties to copy
	 * @param {string} propertyObj Object containing properties names we want to loop over
	 */
	function deepCopyProperties(target, source, propertyObj) {
	    for (var prop in propertyObj) {
	        if (Array.isArray(source[prop])) {
	            target[prop] = source[prop].slice();
	        } else {
	            target[prop] = source[prop];
	        }
	    }
	}
	//# sourceMappingURL=TextStyle.js.map

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The TextMetrics object represents the measurement of a block of text with a specified style.
	 *
	 * ```js
	 * let style = new PIXI.TextStyle({fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'})
	 * let textMetrics = PIXI.TextMetrics.measureText('Your text', style)
	 * ```
	 *
	 * @class
	 * @memberOf PIXI
	 */
	var TextMetrics = function () {
	    /**
	     * @param {string} text - the text that was measured
	     * @param {PIXI.TextStyle} style - the style that was measured
	     * @param {number} width - the measured width of the text
	     * @param {number} height - the measured height of the text
	     * @param {array} lines - an array of the lines of text broken by new lines and wrapping if specified in style
	     * @param {array} lineWidths - an array of the line widths for each line matched to `lines`
	     * @param {number} lineHeight - the measured line height for this style
	     * @param {number} maxLineWidth - the maximum line width for all measured lines
	     * @param {Object} fontProperties - the font properties object from TextMetrics.measureFont
	     */
	    function TextMetrics(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties) {
	        _classCallCheck(this, TextMetrics);
	
	        this.text = text;
	        this.style = style;
	        this.width = width;
	        this.height = height;
	        this.lines = lines;
	        this.lineWidths = lineWidths;
	        this.lineHeight = lineHeight;
	        this.maxLineWidth = maxLineWidth;
	        this.fontProperties = fontProperties;
	    }
	
	    /**
	     * Measures the supplied string of text and returns a Rectangle.
	     *
	     * @param {string} text - the text to measure.
	     * @param {PIXI.TextStyle} style - the text style to use for measuring
	     * @param {boolean} [wordWrap] - optional override for if word-wrap should be applied to the text.
	     * @param {HTMLCanvasElement} [canvas] - optional specification of the canvas to use for measuring.
	     * @return {PIXI.TextMetrics} measured width and height of the text.
	     */
	
	
	    TextMetrics.measureText = function measureText(text, style, wordWrap) {
	        var canvas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : TextMetrics._canvas;
	
	        wordWrap = wordWrap || style.wordWrap;
	        var font = style.toFontString();
	        var fontProperties = TextMetrics.measureFont(font);
	        var context = canvas.getContext('2d');
	
	        context.font = font;
	
	        var outputText = wordWrap ? TextMetrics.wordWrap(text, style, canvas) : text;
	        var lines = outputText.split(/(?:\r\n|\r|\n)/);
	        var lineWidths = new Array(lines.length);
	        var maxLineWidth = 0;
	
	        for (var i = 0; i < lines.length; i++) {
	            var lineWidth = context.measureText(lines[i]).width + (lines[i].length - 1) * style.letterSpacing;
	
	            lineWidths[i] = lineWidth;
	            maxLineWidth = Math.max(maxLineWidth, lineWidth);
	        }
	        var width = maxLineWidth + style.strokeThickness;
	
	        if (style.dropShadow) {
	            width += style.dropShadowDistance;
	        }
	
	        var lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;
	        var height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness) + (lines.length - 1) * (lineHeight + style.leading);
	
	        if (style.dropShadow) {
	            height += style.dropShadowDistance;
	        }
	
	        return new TextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
	    };
	
	    /**
	     * Applies newlines to a string to have it optimally fit into the horizontal
	     * bounds set by the Text object's wordWrapWidth property.
	     *
	     * @private
	     * @param {string} text - String to apply word wrapping to
	     * @param {PIXI.TextStyle} style - the style to use when wrapping
	     * @param {HTMLCanvasElement} [canvas] - optional specification of the canvas to use for measuring.
	     * @return {string} New string with new lines applied where required
	     */
	
	
	    TextMetrics.wordWrap = function wordWrap(text, style) {
	        var canvas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TextMetrics._canvas;
	
	        var context = canvas.getContext('2d');
	
	        var width = 0;
	        var line = '';
	        var lines = '';
	
	        var cache = {};
	        var letterSpacing = style.letterSpacing,
	            whiteSpace = style.whiteSpace;
	
	        // How to handle whitespaces
	
	        var collapseSpaces = TextMetrics.collapseSpaces(whiteSpace);
	        var collapseNewlines = TextMetrics.collapseNewlines(whiteSpace);
	
	        // whether or not spaces may be added to the beginning of lines
	        var canPrependSpaces = !collapseSpaces;
	
	        // There is letterSpacing after every char except the last one
	        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!
	        // so for convenience the above needs to be compared to width + 1 extra letterSpace
	        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!_
	        // ________________________________________________
	        // And then the final space is simply no appended to each line
	        var wordWrapWidth = style.wordWrapWidth + letterSpacing;
	
	        // break text into words, spaces and newline chars
	        var tokens = TextMetrics.tokenize(text);
	
	        for (var i = 0; i < tokens.length; i++) {
	            // get the word, space or newlineChar
	            var token = tokens[i];
	
	            // if word is a new line
	            if (TextMetrics.isNewline(token)) {
	                // keep the new line
	                if (!collapseNewlines) {
	                    lines += TextMetrics.addLine(line);
	                    canPrependSpaces = !collapseSpaces;
	                    line = '';
	                    width = 0;
	                    continue;
	                }
	
	                // if we should collapse new lines
	                // we simply convert it into a space
	                token = ' ';
	            }
	
	            // if we should collapse repeated whitespaces
	            if (collapseSpaces) {
	                // check both this and the last tokens for spaces
	                var currIsBreakingSpace = TextMetrics.isBreakingSpace(token);
	                var lastIsBreakingSpace = TextMetrics.isBreakingSpace(line[line.length - 1]);
	
	                if (currIsBreakingSpace && lastIsBreakingSpace) {
	                    continue;
	                }
	            }
	
	            // get word width from cache if possible
	            var tokenWidth = TextMetrics.getFromCache(token, letterSpacing, cache, context);
	
	            // word is longer than desired bounds
	            if (tokenWidth > wordWrapWidth) {
	                // if we are not already at the beginning of a line
	                if (line !== '') {
	                    // start newlines for overflow words
	                    lines += TextMetrics.addLine(line);
	                    line = '';
	                    width = 0;
	                }
	
	                // break large word over multiple lines
	                if (TextMetrics.canBreakWords(token, style.breakWords)) {
	                    // break word into characters
	                    var characters = token.split('');
	
	                    // loop the characters
	                    for (var j = 0; j < characters.length; j++) {
	                        var char = characters[j];
	
	                        var k = 1;
	                        // we are not at the end of the token
	
	                        while (characters[j + k]) {
	                            var nextChar = characters[j + k];
	                            var lastChar = char[char.length - 1];
	
	                            // should not split chars
	                            if (!TextMetrics.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) {
	                                // combine chars & move forward one
	                                char += nextChar;
	                            } else {
	                                break;
	                            }
	
	                            k++;
	                        }
	
	                        j += char.length - 1;
	
	                        var characterWidth = TextMetrics.getFromCache(char, letterSpacing, cache, context);
	
	                        if (characterWidth + width > wordWrapWidth) {
	                            lines += TextMetrics.addLine(line);
	                            canPrependSpaces = false;
	                            line = '';
	                            width = 0;
	                        }
	
	                        line += char;
	                        width += characterWidth;
	                    }
	                }
	
	                // run word out of the bounds
	                else {
	                        // if there are words in this line already
	                        // finish that line and start a new one
	                        if (line.length > 0) {
	                            lines += TextMetrics.addLine(line);
	                            line = '';
	                            width = 0;
	                        }
	
	                        var isLastToken = i === tokens.length - 1;
	
	                        // give it its own line if it's not the end
	                        lines += TextMetrics.addLine(token, !isLastToken);
	                        canPrependSpaces = false;
	                        line = '';
	                        width = 0;
	                    }
	            }
	
	            // word could fit
	            else {
	                    // word won't fit because of existing words
	                    // start a new line
	                    if (tokenWidth + width > wordWrapWidth) {
	                        // if its a space we don't want it
	                        canPrependSpaces = false;
	
	                        // add a new line
	                        lines += TextMetrics.addLine(line);
	
	                        // start a new line
	                        line = '';
	                        width = 0;
	                    }
	
	                    // don't add spaces to the beginning of lines
	                    if (line.length > 0 || !TextMetrics.isBreakingSpace(token) || canPrependSpaces) {
	                        // add the word to the current line
	                        line += token;
	
	                        // update width counter
	                        width += tokenWidth;
	                    }
	                }
	        }
	
	        lines += TextMetrics.addLine(line, false);
	
	        return lines;
	    };
	
	    /**
	     * Convienience function for logging each line added during the wordWrap
	     * method
	     *
	     * @private
	     * @param  {string}   line        - The line of text to add
	     * @param  {boolean}  newLine     - Add new line character to end
	     * @return {string}   A formatted line
	     */
	
	
	    TextMetrics.addLine = function addLine(line) {
	        var newLine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        line = TextMetrics.trimRight(line);
	
	        line = newLine ? line + '\n' : line;
	
	        return line;
	    };
	
	    /**
	     * Gets & sets the widths of calculated characters in a cache object
	     *
	     * @private
	     * @param  {string}                    key            The key
	     * @param  {number}                    letterSpacing  The letter spacing
	     * @param  {object}                    cache          The cache
	     * @param  {CanvasRenderingContext2D}  context        The canvas context
	     * @return {number}                    The from cache.
	     */
	
	
	    TextMetrics.getFromCache = function getFromCache(key, letterSpacing, cache, context) {
	        var width = cache[key];
	
	        if (width === undefined) {
	            var spacing = key.length * letterSpacing;
	
	            width = context.measureText(key).width + spacing;
	            cache[key] = width;
	        }
	
	        return width;
	    };
	
	    /**
	     * Determines whether we should collapse breaking spaces
	     *
	     * @private
	     * @param  {string}   whiteSpace  The TextStyle property whiteSpace
	     * @return {boolean}  should collapse
	     */
	
	
	    TextMetrics.collapseSpaces = function collapseSpaces(whiteSpace) {
	        return whiteSpace === 'normal' || whiteSpace === 'pre-line';
	    };
	
	    /**
	     * Determines whether we should collapse newLine chars
	     *
	     * @private
	     * @param  {string}   whiteSpace  The white space
	     * @return {boolean}  should collapse
	     */
	
	
	    TextMetrics.collapseNewlines = function collapseNewlines(whiteSpace) {
	        return whiteSpace === 'normal';
	    };
	
	    /**
	     * trims breaking whitespaces from string
	     *
	     * @private
	     * @param  {string}  text  The text
	     * @return {string}  trimmed string
	     */
	
	
	    TextMetrics.trimRight = function trimRight(text) {
	        if (typeof text !== 'string') {
	            return '';
	        }
	
	        for (var i = text.length - 1; i >= 0; i--) {
	            var char = text[i];
	
	            if (!TextMetrics.isBreakingSpace(char)) {
	                break;
	            }
	
	            text = text.slice(0, -1);
	        }
	
	        return text;
	    };
	
	    /**
	     * Determines if char is a newline.
	     *
	     * @private
	     * @param  {string}  char  The character
	     * @return {boolean}  True if newline, False otherwise.
	     */
	
	
	    TextMetrics.isNewline = function isNewline(char) {
	        if (typeof char !== 'string') {
	            return false;
	        }
	
	        return TextMetrics._newlines.indexOf(char.charCodeAt(0)) >= 0;
	    };
	
	    /**
	     * Determines if char is a breaking whitespace.
	     *
	     * @private
	     * @param  {string}  char  The character
	     * @return {boolean}  True if whitespace, False otherwise.
	     */
	
	
	    TextMetrics.isBreakingSpace = function isBreakingSpace(char) {
	        if (typeof char !== 'string') {
	            return false;
	        }
	
	        return TextMetrics._breakingSpaces.indexOf(char.charCodeAt(0)) >= 0;
	    };
	
	    /**
	     * Splits a string into words, breaking-spaces and newLine characters
	     *
	     * @private
	     * @param  {string}  text       The text
	     * @return {array}  A tokenized array
	     */
	
	
	    TextMetrics.tokenize = function tokenize(text) {
	        var tokens = [];
	        var token = '';
	
	        if (typeof text !== 'string') {
	            return tokens;
	        }
	
	        for (var i = 0; i < text.length; i++) {
	            var char = text[i];
	
	            if (TextMetrics.isBreakingSpace(char) || TextMetrics.isNewline(char)) {
	                if (token !== '') {
	                    tokens.push(token);
	                    token = '';
	                }
	
	                tokens.push(char);
	
	                continue;
	            }
	
	            token += char;
	        }
	
	        if (token !== '') {
	            tokens.push(token);
	        }
	
	        return tokens;
	    };
	
	    /**
	     * This method exists to be easily overridden
	     * It allows one to customise which words should break
	     * Examples are if the token is CJK or numbers.
	     * It must return a boolean.
	     *
	     * @private
	     * @param  {string}  token       The token
	     * @param  {boolean}  breakWords  The style attr break words
	     * @return {boolean} whether to break word or not
	     */
	
	
	    TextMetrics.canBreakWords = function canBreakWords(token, breakWords) {
	        return breakWords;
	    };
	
	    /**
	     * This method exists to be easily overridden
	     * It allows one to determine whether a pair of characters
	     * should be broken by newlines
	     * For example certain characters in CJK langs or numbers.
	     * It must return a boolean.
	     *
	     * @private
	     * @param  {string}  char      The character
	     * @param  {string}  nextChar  The next character
	     * @param  {string}  token     The token/word the characters are from
	     * @param  {number}  index     The index in the token of the char
	     * @param  {boolean}  breakWords  The style attr break words
	     * @return {boolean} whether to break word or not
	     */
	
	
	    TextMetrics.canBreakChars = function canBreakChars(char, nextChar, token, index, breakWords) // eslint-disable-line no-unused-vars
	    {
	        return true;
	    };
	
	    /**
	     * Calculates the ascent, descent and fontSize of a given font-style
	     *
	     * @static
	     * @param {string} font - String representing the style of the font
	     * @return {PIXI.TextMetrics~FontMetrics} Font properties object
	     */
	
	
	    TextMetrics.measureFont = function measureFont(font) {
	        // as this method is used for preparing assets, don't recalculate things if we don't need to
	        if (TextMetrics._fonts[font]) {
	            return TextMetrics._fonts[font];
	        }
	
	        var properties = {};
	
	        var canvas = TextMetrics._canvas;
	        var context = TextMetrics._context;
	
	        context.font = font;
	
	        var metricsString = TextMetrics.METRICS_STRING + TextMetrics.BASELINE_SYMBOL;
	        var width = Math.ceil(context.measureText(metricsString).width);
	        var baseline = Math.ceil(context.measureText(TextMetrics.BASELINE_SYMBOL).width);
	        var height = 2 * baseline;
	
	        baseline = baseline * TextMetrics.BASELINE_MULTIPLIER | 0;
	
	        canvas.width = width;
	        canvas.height = height;
	
	        context.fillStyle = '#f00';
	        context.fillRect(0, 0, width, height);
	
	        context.font = font;
	
	        context.textBaseline = 'alphabetic';
	        context.fillStyle = '#000';
	        context.fillText(metricsString, 0, baseline);
	
	        var imagedata = context.getImageData(0, 0, width, height).data;
	        var pixels = imagedata.length;
	        var line = width * 4;
	
	        var i = 0;
	        var idx = 0;
	        var stop = false;
	
	        // ascent. scan from top to bottom until we find a non red pixel
	        for (i = 0; i < baseline; ++i) {
	            for (var j = 0; j < line; j += 4) {
	                if (imagedata[idx + j] !== 255) {
	                    stop = true;
	                    break;
	                }
	            }
	            if (!stop) {
	                idx += line;
	            } else {
	                break;
	            }
	        }
	
	        properties.ascent = baseline - i;
	
	        idx = pixels - line;
	        stop = false;
	
	        // descent. scan from bottom to top until we find a non red pixel
	        for (i = height; i > baseline; --i) {
	            for (var _j = 0; _j < line; _j += 4) {
	                if (imagedata[idx + _j] !== 255) {
	                    stop = true;
	                    break;
	                }
	            }
	
	            if (!stop) {
	                idx -= line;
	            } else {
	                break;
	            }
	        }
	
	        properties.descent = i - baseline;
	        properties.fontSize = properties.ascent + properties.descent;
	
	        TextMetrics._fonts[font] = properties;
	
	        return properties;
	    };
	
	    /**
	     * Clear font metrics in metrics cache.
	     *
	     * @static
	     * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
	     */
	
	
	    TextMetrics.clearMetrics = function clearMetrics() {
	        var font = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	        if (font) {
	            delete TextMetrics._fonts[font];
	        } else {
	            TextMetrics._fonts = {};
	        }
	    };
	
	    return TextMetrics;
	}();
	
	/**
	 * Internal return object for {@link PIXI.TextMetrics.measureFont `TextMetrics.measureFont`}.
	 * @class FontMetrics
	 * @memberof PIXI.TextMetrics~
	 * @property {number} ascent - The ascent distance
	 * @property {number} descent - The descent distance
	 * @property {number} fontSize - Font size from ascent to descent
	 */
	
	exports.default = TextMetrics;
	var canvas = document.createElement('canvas');
	
	canvas.width = canvas.height = 10;
	
	/**
	 * Cached canvas element for measuring text
	 * @memberof PIXI.TextMetrics
	 * @type {HTMLCanvasElement}
	 * @private
	 */
	TextMetrics._canvas = canvas;
	
	/**
	 * Cache for context to use.
	 * @memberof PIXI.TextMetrics
	 * @type {CanvasRenderingContext2D}
	 * @private
	 */
	TextMetrics._context = canvas.getContext('2d');
	
	/**
	 * Cache of PIXI.TextMetrics~FontMetrics objects.
	 * @memberof PIXI.TextMetrics
	 * @type {Object}
	 * @private
	 */
	TextMetrics._fonts = {};
	
	/**
	 * String used for calculate font metrics.
	 * @static
	 * @memberof PIXI.TextMetrics
	 * @name METRICS_STRING
	 * @type {string}
	 * @default |Éq
	 */
	TextMetrics.METRICS_STRING = '|Éq';
	
	/**
	 * Baseline symbol for calculate font metrics.
	 * @static
	 * @memberof PIXI.TextMetrics
	 * @name BASELINE_SYMBOL
	 * @type {string}
	 * @default M
	 */
	TextMetrics.BASELINE_SYMBOL = 'M';
	
	/**
	 * Baseline multiplier for calculate font metrics.
	 * @static
	 * @memberof PIXI.TextMetrics
	 * @name BASELINE_MULTIPLIER
	 * @type {number}
	 * @default 1.4
	 */
	TextMetrics.BASELINE_MULTIPLIER = 1.4;
	
	/**
	 * Cache of new line chars.
	 * @memberof PIXI.TextMetrics
	 * @type {number[]}
	 * @private
	 */
	TextMetrics._newlines = [0x000A, // line feed
	0x000D];
	
	/**
	 * Cache of breaking spaces.
	 * @memberof PIXI.TextMetrics
	 * @type {number[]}
	 * @private
	 */
	TextMetrics._breakingSpaces = [0x0009, // character tabulation
	0x0020, // space
	0x2000, // en quad
	0x2001, // em quad
	0x2002, // en space
	0x2003, // em space
	0x2004, // three-per-em space
	0x2005, // four-per-em space
	0x2006, // six-per-em space
	0x2008, // punctuation space
	0x2009, // thin space
	0x200A, // hair space
	0x205F, // medium mathematical space
	0x3000];
	//# sourceMappingURL=TextMetrics.js.map

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = trimCanvas;
	/**
	 * Trim transparent borders from a canvas
	 *
	 * @memberof PIXI
	 * @function trimCanvas
	 * @private
	 * @param {HTMLCanvasElement} canvas - the canvas to trim
	 * @returns {object} Trim data
	 */
	function trimCanvas(canvas) {
	    // https://gist.github.com/remy/784508
	
	    var width = canvas.width;
	    var height = canvas.height;
	
	    var context = canvas.getContext('2d');
	    var imageData = context.getImageData(0, 0, width, height);
	    var pixels = imageData.data;
	    var len = pixels.length;
	
	    var bound = {
	        top: null,
	        left: null,
	        right: null,
	        bottom: null
	    };
	    var i = void 0;
	    var x = void 0;
	    var y = void 0;
	
	    for (i = 0; i < len; i += 4) {
	        if (pixels[i + 3] !== 0) {
	            x = i / 4 % width;
	            y = ~~(i / 4 / width);
	
	            if (bound.top === null) {
	                bound.top = y;
	            }
	
	            if (bound.left === null) {
	                bound.left = x;
	            } else if (x < bound.left) {
	                bound.left = x;
	            }
	
	            if (bound.right === null) {
	                bound.right = x + 1;
	            } else if (bound.right < x) {
	                bound.right = x + 1;
	            }
	
	            if (bound.bottom === null) {
	                bound.bottom = y;
	            } else if (bound.bottom < y) {
	                bound.bottom = y;
	            }
	        }
	    }
	
	    width = bound.right - bound.left;
	    height = bound.bottom - bound.top + 1;
	
	    var data = context.getImageData(bound.left, bound.top, width, height);
	
	    return {
	        height: height,
	        width: width,
	        data: data
	    };
	}
	//# sourceMappingURL=trimCanvas.js.map

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Container2 = __webpack_require__(243);
	
	var _Container3 = _interopRequireDefault(_Container2);
	
	var _RenderTexture = __webpack_require__(270);
	
	var _RenderTexture2 = _interopRequireDefault(_RenderTexture);
	
	var _Texture = __webpack_require__(251);
	
	var _Texture2 = _interopRequireDefault(_Texture);
	
	var _GraphicsData = __webpack_require__(308);
	
	var _GraphicsData2 = _interopRequireDefault(_GraphicsData);
	
	var _Sprite = __webpack_require__(250);
	
	var _Sprite2 = _interopRequireDefault(_Sprite);
	
	var _math = __webpack_require__(206);
	
	var _utils = __webpack_require__(244);
	
	var _const = __webpack_require__(205);
	
	var _Bounds = __webpack_require__(233);
	
	var _Bounds2 = _interopRequireDefault(_Bounds);
	
	var _bezierCurveTo2 = __webpack_require__(309);
	
	var _bezierCurveTo3 = _interopRequireDefault(_bezierCurveTo2);
	
	var _CanvasRenderer = __webpack_require__(268);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var canvasRenderer = void 0;
	var tempMatrix = new _math.Matrix();
	var tempPoint = new _math.Point();
	var tempColor1 = new Float32Array(4);
	var tempColor2 = new Float32Array(4);
	
	/**
	 * The Graphics class contains methods used to draw primitive shapes such as lines, circles and
	 * rectangles to the display, and to color and fill them.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 */
	
	var Graphics = function (_Container) {
	    _inherits(Graphics, _Container);
	
	    /**
	     *
	     * @param {boolean} [nativeLines=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
	     */
	    function Graphics() {
	        var nativeLines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        _classCallCheck(this, Graphics);
	
	        /**
	         * The alpha value used when filling the Graphics object.
	         *
	         * @member {number}
	         * @default 1
	         */
	        var _this = _possibleConstructorReturn(this, _Container.call(this));
	
	        _this.fillAlpha = 1;
	
	        /**
	         * The width (thickness) of any lines drawn.
	         *
	         * @member {number}
	         * @default 0
	         */
	        _this.lineWidth = 0;
	
	        /**
	         * If true the lines will be draw using LINES instead of TRIANGLE_STRIP
	         *
	         * @member {boolean}
	         */
	        _this.nativeLines = nativeLines;
	
	        /**
	         * The color of any lines drawn.
	         *
	         * @member {string}
	         * @default 0
	         */
	        _this.lineColor = 0;
	
	        /**
	         * The alignment of any lines drawn (0.5 = middle, 1 = outter, 0 = inner).
	         *
	         * @member {number}
	         * @default 0
	         */
	        _this.lineAlignment = 0.5;
	
	        /**
	         * Graphics data
	         *
	         * @member {PIXI.GraphicsData[]}
	         * @private
	         */
	        _this.graphicsData = [];
	
	        /**
	         * The tint applied to the graphic shape. This is a hex value. Apply a value of 0xFFFFFF to
	         * reset the tint.
	         *
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this.tint = 0xFFFFFF;
	
	        /**
	         * The previous tint applied to the graphic shape. Used to compare to the current tint and
	         * check if theres change.
	         *
	         * @member {number}
	         * @private
	         * @default 0xFFFFFF
	         */
	        _this._prevTint = 0xFFFFFF;
	
	        /**
	         * The blend mode to be applied to the graphic shape. Apply a value of
	         * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL;
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = _const.BLEND_MODES.NORMAL;
	
	        /**
	         * Current path
	         *
	         * @member {PIXI.GraphicsData}
	         * @private
	         */
	        _this.currentPath = null;
	
	        /**
	         * Array containing some WebGL-related properties used by the WebGL renderer.
	         *
	         * @member {object<number, object>}
	         * @private
	         */
	        // TODO - _webgl should use a prototype object, not a random undocumented object...
	        _this._webGL = {};
	
	        /**
	         * Whether this shape is being used as a mask.
	         *
	         * @member {boolean}
	         */
	        _this.isMask = false;
	
	        /**
	         * The bounds' padding used for bounds calculation.
	         *
	         * @member {number}
	         */
	        _this.boundsPadding = 0;
	
	        /**
	         * A cache of the local bounds to prevent recalculation.
	         *
	         * @member {PIXI.Rectangle}
	         * @private
	         */
	        _this._localBounds = new _Bounds2.default();
	
	        /**
	         * Used to detect if the graphics object has changed. If this is set to true then the graphics
	         * object will be recalculated.
	         *
	         * @member {boolean}
	         * @private
	         */
	        _this.dirty = 0;
	
	        /**
	         * Used to detect if we need to do a fast rect check using the id compare method
	         * @type {Number}
	         */
	        _this.fastRectDirty = -1;
	
	        /**
	         * Used to detect if we clear the graphics webGL data
	         * @type {Number}
	         */
	        _this.clearDirty = 0;
	
	        /**
	         * Used to detect if we we need to recalculate local bounds
	         * @type {Number}
	         */
	        _this.boundsDirty = -1;
	
	        /**
	         * Used to detect if the cached sprite object needs to be updated.
	         *
	         * @member {boolean}
	         * @private
	         */
	        _this.cachedSpriteDirty = false;
	
	        _this._spriteRect = null;
	        _this._fastRect = false;
	
	        /**
	         * When cacheAsBitmap is set to true the graphics object will be rendered as if it was a sprite.
	         * This is useful if your graphics element does not change often, as it will speed up the rendering
	         * of the object in exchange for taking up texture memory. It is also useful if you need the graphics
	         * object to be anti-aliased, because it will be rendered using canvas. This is not recommended if
	         * you are constantly redrawing the graphics element.
	         *
	         * @name cacheAsBitmap
	         * @member {boolean}
	         * @memberof PIXI.Graphics#
	         * @default false
	         */
	        return _this;
	    }
	
	    /**
	     * Creates a new Graphics object with the same values as this one.
	     * Note that the only the properties of the object are cloned, not its transform (position,scale,etc)
	     *
	     * @return {PIXI.Graphics} A clone of the graphics object
	     */
	
	
	    Graphics.prototype.clone = function clone() {
	        var clone = new Graphics();
	
	        clone.renderable = this.renderable;
	        clone.fillAlpha = this.fillAlpha;
	        clone.lineWidth = this.lineWidth;
	        clone.lineColor = this.lineColor;
	        clone.lineAlignment = this.lineAlignment;
	        clone.tint = this.tint;
	        clone.blendMode = this.blendMode;
	        clone.isMask = this.isMask;
	        clone.boundsPadding = this.boundsPadding;
	        clone.dirty = 0;
	        clone.cachedSpriteDirty = this.cachedSpriteDirty;
	
	        // copy graphics data
	        for (var i = 0; i < this.graphicsData.length; ++i) {
	            clone.graphicsData.push(this.graphicsData[i].clone());
	        }
	
	        clone.currentPath = clone.graphicsData[clone.graphicsData.length - 1];
	
	        clone.updateLocalBounds();
	
	        return clone;
	    };
	
	    /**
	     * Calculate length of quadratic curve
	     * @see {@link http://www.malczak.linuxpl.com/blog/quadratic-bezier-curve-length/}
	     * for the detailed explanation of math behind this.
	     *
	     * @private
	     * @param {number} fromX - x-coordinate of curve start point
	     * @param {number} fromY - y-coordinate of curve start point
	     * @param {number} cpX - x-coordinate of curve control point
	     * @param {number} cpY - y-coordinate of curve control point
	     * @param {number} toX - x-coordinate of curve end point
	     * @param {number} toY - y-coordinate of curve end point
	     * @return {number} Length of quadratic curve
	     */
	
	
	    Graphics.prototype._quadraticCurveLength = function _quadraticCurveLength(fromX, fromY, cpX, cpY, toX, toY) {
	        var ax = fromX - (2.0 * cpX + toX);
	        var ay = fromY - (2.0 * cpY + toY);
	        var bx = 2.0 * ((cpX - 2.0) * fromX);
	        var by = 2.0 * ((cpY - 2.0) * fromY);
	        var a = 4.0 * (ax * ax + ay * ay);
	        var b = 4.0 * (ax * bx + ay * by);
	        var c = bx * bx + by * by;
	
	        var s = 2.0 * Math.sqrt(a + b + c);
	        var a2 = Math.sqrt(a);
	        var a32 = 2.0 * a * a2;
	        var c2 = 2.0 * Math.sqrt(c);
	        var ba = b / a2;
	
	        return (a32 * s + a2 * b * (s - c2) + (4.0 * c * a - b * b) * Math.log((2.0 * a2 + ba + s) / (ba + c2))) / (4.0 * a32);
	    };
	
	    /**
	     * Calculate length of bezier curve.
	     * Analytical solution is impossible, since it involves an integral that does not integrate in general.
	     * Therefore numerical solution is used.
	     *
	     * @private
	     * @param {number} fromX - Starting point x
	     * @param {number} fromY - Starting point y
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} cpX2 - Second Control point x
	     * @param {number} cpY2 - Second Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @return {number} Length of bezier curve
	     */
	
	
	    Graphics.prototype._bezierCurveLength = function _bezierCurveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY) {
	        var n = 10;
	        var result = 0.0;
	        var t = 0.0;
	        var t2 = 0.0;
	        var t3 = 0.0;
	        var nt = 0.0;
	        var nt2 = 0.0;
	        var nt3 = 0.0;
	        var x = 0.0;
	        var y = 0.0;
	        var dx = 0.0;
	        var dy = 0.0;
	        var prevX = fromX;
	        var prevY = fromY;
	
	        for (var i = 1; i <= n; ++i) {
	            t = i / n;
	            t2 = t * t;
	            t3 = t2 * t;
	            nt = 1.0 - t;
	            nt2 = nt * nt;
	            nt3 = nt2 * nt;
	
	            x = nt3 * fromX + 3.0 * nt2 * t * cpX + 3.0 * nt * t2 * cpX2 + t3 * toX;
	            y = nt3 * fromY + 3.0 * nt2 * t * cpY + 3 * nt * t2 * cpY2 + t3 * toY;
	            dx = prevX - x;
	            dy = prevY - y;
	            prevX = x;
	            prevY = y;
	
	            result += Math.sqrt(dx * dx + dy * dy);
	        }
	
	        return result;
	    };
	
	    /**
	     * Calculate number of segments for the curve based on its length to ensure its smoothness.
	     *
	     * @private
	     * @param {number} length - length of curve
	     * @return {number} Number of segments
	     */
	
	
	    Graphics.prototype._segmentsCount = function _segmentsCount(length) {
	        var result = Math.ceil(length / Graphics.CURVES.maxLength);
	
	        if (result < Graphics.CURVES.minSegments) {
	            result = Graphics.CURVES.minSegments;
	        } else if (result > Graphics.CURVES.maxSegments) {
	            result = Graphics.CURVES.maxSegments;
	        }
	
	        return result;
	    };
	
	    /**
	     * Specifies the line style used for subsequent calls to Graphics methods such as the lineTo()
	     * method or the drawCircle() method.
	     *
	     * @param {number} [lineWidth=0] - width of the line to draw, will update the objects stored style
	     * @param {number} [color=0] - color of the line to draw, will update the objects stored style
	     * @param {number} [alpha=1] - alpha of the line to draw, will update the objects stored style
	     * @param {number} [alignment=1] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outter)
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.lineStyle = function lineStyle() {
	        var lineWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var alpha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	        var alignment = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
	
	        this.lineWidth = lineWidth;
	        this.lineColor = color;
	        this.lineAlpha = alpha;
	        this.lineAlignment = alignment;
	
	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length) {
	                // halfway through a line? start a new one!
	                var shape = new _math.Polygon(this.currentPath.shape.points.slice(-2));
	
	                shape.closed = false;
	
	                this.drawShape(shape);
	            } else {
	                // otherwise its empty so lets just set the line properties
	                this.currentPath.lineWidth = this.lineWidth;
	                this.currentPath.lineColor = this.lineColor;
	                this.currentPath.lineAlpha = this.lineAlpha;
	                this.currentPath.lineAlignment = this.lineAlignment;
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Moves the current drawing position to x, y.
	     *
	     * @param {number} x - the X coordinate to move to
	     * @param {number} y - the Y coordinate to move to
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.moveTo = function moveTo(x, y) {
	        var shape = new _math.Polygon([x, y]);
	
	        shape.closed = false;
	        this.drawShape(shape);
	
	        return this;
	    };
	
	    /**
	     * Draws a line using the current line style from the current drawing position to (x, y);
	     * The current drawing position is then set to (x, y).
	     *
	     * @param {number} x - the X coordinate to draw to
	     * @param {number} y - the Y coordinate to draw to
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.lineTo = function lineTo(x, y) {
	        this.currentPath.shape.points.push(x, y);
	        this.dirty++;
	
	        return this;
	    };
	
	    /**
	     * Calculate the points for a quadratic bezier curve and then draws it.
	     * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
	     *
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.quadraticCurveTo = function quadraticCurveTo(cpX, cpY, toX, toY) {
	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length === 0) {
	                this.currentPath.shape.points = [0, 0];
	            }
	        } else {
	            this.moveTo(0, 0);
	        }
	
	        var points = this.currentPath.shape.points;
	        var xa = 0;
	        var ya = 0;
	
	        if (points.length === 0) {
	            this.moveTo(0, 0);
	        }
	
	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];
	        var n = Graphics.CURVES.adaptive ? this._segmentsCount(this._quadraticCurveLength(fromX, fromY, cpX, cpY, toX, toY)) : 20;
	
	        for (var i = 1; i <= n; ++i) {
	            var j = i / n;
	
	            xa = fromX + (cpX - fromX) * j;
	            ya = fromY + (cpY - fromY) * j;
	
	            points.push(xa + (cpX + (toX - cpX) * j - xa) * j, ya + (cpY + (toY - cpY) * j - ya) * j);
	        }
	
	        this.dirty++;
	
	        return this;
	    };
	
	    /**
	     * Calculate the points for a bezier curve and then draws it.
	     *
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} cpX2 - Second Control point x
	     * @param {number} cpY2 - Second Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.bezierCurveTo = function bezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY) {
	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length === 0) {
	                this.currentPath.shape.points = [0, 0];
	            }
	        } else {
	            this.moveTo(0, 0);
	        }
	
	        var points = this.currentPath.shape.points;
	
	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];
	
	        points.length -= 2;
	
	        var n = Graphics.CURVES.adaptive ? this._segmentsCount(this._bezierCurveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY)) : 20;
	
	        (0, _bezierCurveTo3.default)(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY, n, points);
	
	        this.dirty++;
	
	        return this;
	    };
	
	    /**
	     * The arcTo() method creates an arc/curve between two tangents on the canvas.
	     *
	     * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
	     *
	     * @param {number} x1 - The x-coordinate of the beginning of the arc
	     * @param {number} y1 - The y-coordinate of the beginning of the arc
	     * @param {number} x2 - The x-coordinate of the end of the arc
	     * @param {number} y2 - The y-coordinate of the end of the arc
	     * @param {number} radius - The radius of the arc
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.arcTo = function arcTo(x1, y1, x2, y2, radius) {
	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length === 0) {
	                this.currentPath.shape.points.push(x1, y1);
	            }
	        } else {
	            this.moveTo(x1, y1);
	        }
	
	        var points = this.currentPath.shape.points;
	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];
	        var a1 = fromY - y1;
	        var b1 = fromX - x1;
	        var a2 = y2 - y1;
	        var b2 = x2 - x1;
	        var mm = Math.abs(a1 * b2 - b1 * a2);
	
	        if (mm < 1.0e-8 || radius === 0) {
	            if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) {
	                points.push(x1, y1);
	            }
	        } else {
	            var dd = a1 * a1 + b1 * b1;
	            var cc = a2 * a2 + b2 * b2;
	            var tt = a1 * a2 + b1 * b2;
	            var k1 = radius * Math.sqrt(dd) / mm;
	            var k2 = radius * Math.sqrt(cc) / mm;
	            var j1 = k1 * tt / dd;
	            var j2 = k2 * tt / cc;
	            var cx = k1 * b2 + k2 * b1;
	            var cy = k1 * a2 + k2 * a1;
	            var px = b1 * (k2 + j1);
	            var py = a1 * (k2 + j1);
	            var qx = b2 * (k1 + j2);
	            var qy = a2 * (k1 + j2);
	            var startAngle = Math.atan2(py - cy, px - cx);
	            var endAngle = Math.atan2(qy - cy, qx - cx);
	
	            this.arc(cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
	        }
	
	        this.dirty++;
	
	        return this;
	    };
	
	    /**
	     * The arc method creates an arc/curve (used to create circles, or parts of circles).
	     *
	     * @param {number} cx - The x-coordinate of the center of the circle
	     * @param {number} cy - The y-coordinate of the center of the circle
	     * @param {number} radius - The radius of the circle
	     * @param {number} startAngle - The starting angle, in radians (0 is at the 3 o'clock position
	     *  of the arc's circle)
	     * @param {number} endAngle - The ending angle, in radians
	     * @param {boolean} [anticlockwise=false] - Specifies whether the drawing should be
	     *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
	     *  indicates counter-clockwise.
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.arc = function arc(cx, cy, radius, startAngle, endAngle) {
	        var anticlockwise = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	        if (startAngle === endAngle) {
	            return this;
	        }
	
	        if (!anticlockwise && endAngle <= startAngle) {
	            endAngle += _const.PI_2;
	        } else if (anticlockwise && startAngle <= endAngle) {
	            startAngle += _const.PI_2;
	        }
	
	        var sweep = endAngle - startAngle;
	        var segs = Graphics.CURVES.adaptive ? this._segmentsCount(Math.abs(sweep) * radius) : Math.ceil(Math.abs(sweep) / _const.PI_2) * 40;
	
	        if (sweep === 0) {
	            return this;
	        }
	
	        var startX = cx + Math.cos(startAngle) * radius;
	        var startY = cy + Math.sin(startAngle) * radius;
	
	        // If the currentPath exists, take its points. Otherwise call `moveTo` to start a path.
	        var points = this.currentPath ? this.currentPath.shape.points : null;
	
	        if (points) {
	            if (points[points.length - 2] !== startX || points[points.length - 1] !== startY) {
	                points.push(startX, startY);
	            }
	        } else {
	            this.moveTo(startX, startY);
	            points = this.currentPath.shape.points;
	        }
	
	        var theta = sweep / (segs * 2);
	        var theta2 = theta * 2;
	
	        var cTheta = Math.cos(theta);
	        var sTheta = Math.sin(theta);
	
	        var segMinus = segs - 1;
	
	        var remainder = segMinus % 1 / segMinus;
	
	        for (var i = 0; i <= segMinus; ++i) {
	            var real = i + remainder * i;
	
	            var angle = theta + startAngle + theta2 * real;
	
	            var c = Math.cos(angle);
	            var s = -Math.sin(angle);
	
	            points.push((cTheta * c + sTheta * s) * radius + cx, (cTheta * -s + sTheta * c) * radius + cy);
	        }
	
	        this.dirty++;
	
	        return this;
	    };
	
	    /**
	     * Specifies a simple one-color fill that subsequent calls to other Graphics methods
	     * (such as lineTo() or drawCircle()) use when drawing.
	     *
	     * @param {number} [color=0] - the color of the fill
	     * @param {number} [alpha=1] - the alpha of the fill
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.beginFill = function beginFill() {
	        var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	        this.filling = true;
	        this.fillColor = color;
	        this.fillAlpha = alpha;
	
	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length <= 2) {
	                this.currentPath.fill = this.filling;
	                this.currentPath.fillColor = this.fillColor;
	                this.currentPath.fillAlpha = this.fillAlpha;
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
	     *
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.endFill = function endFill() {
	        this.filling = false;
	        this.fillColor = null;
	        this.fillAlpha = 1;
	
	        return this;
	    };
	
	    /**
	     *
	     * @param {number} x - The X coord of the top-left of the rectangle
	     * @param {number} y - The Y coord of the top-left of the rectangle
	     * @param {number} width - The width of the rectangle
	     * @param {number} height - The height of the rectangle
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.drawRect = function drawRect(x, y, width, height) {
	        this.drawShape(new _math.Rectangle(x, y, width, height));
	
	        return this;
	    };
	
	    /**
	     *
	     * @param {number} x - The X coord of the top-left of the rectangle
	     * @param {number} y - The Y coord of the top-left of the rectangle
	     * @param {number} width - The width of the rectangle
	     * @param {number} height - The height of the rectangle
	     * @param {number} radius - Radius of the rectangle corners
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.drawRoundedRect = function drawRoundedRect(x, y, width, height, radius) {
	        this.drawShape(new _math.RoundedRectangle(x, y, width, height, radius));
	
	        return this;
	    };
	
	    /**
	     * Draws a circle.
	     *
	     * @param {number} x - The X coordinate of the center of the circle
	     * @param {number} y - The Y coordinate of the center of the circle
	     * @param {number} radius - The radius of the circle
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.drawCircle = function drawCircle(x, y, radius) {
	        this.drawShape(new _math.Circle(x, y, radius));
	
	        return this;
	    };
	
	    /**
	     * Draws an ellipse.
	     *
	     * @param {number} x - The X coordinate of the center of the ellipse
	     * @param {number} y - The Y coordinate of the center of the ellipse
	     * @param {number} width - The half width of the ellipse
	     * @param {number} height - The half height of the ellipse
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.drawEllipse = function drawEllipse(x, y, width, height) {
	        this.drawShape(new _math.Ellipse(x, y, width, height));
	
	        return this;
	    };
	
	    /**
	     * Draws a polygon using the given path.
	     *
	     * @param {number[]|PIXI.Point[]|PIXI.Polygon} path - The path data used to construct the polygon.
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.drawPolygon = function drawPolygon(path) {
	        // prevents an argument assignment deopt
	        // see section 3.1: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
	        var points = path;
	
	        var closed = true;
	
	        if (points instanceof _math.Polygon) {
	            closed = points.closed;
	            points = points.points;
	        }
	
	        if (!Array.isArray(points)) {
	            // prevents an argument leak deopt
	            // see section 3.2: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
	            points = new Array(arguments.length);
	
	            for (var i = 0; i < points.length; ++i) {
	                points[i] = arguments[i]; // eslint-disable-line prefer-rest-params
	            }
	        }
	
	        var shape = new _math.Polygon(points);
	
	        shape.closed = closed;
	
	        this.drawShape(shape);
	
	        return this;
	    };
	
	    /**
	     * Draw a star shape with an abitrary number of points.
	     *
	     * @param {number} x - Center X position of the star
	     * @param {number} y - Center Y position of the star
	     * @param {number} points - The number of points of the star, must be > 1
	     * @param {number} radius - The outer radius of the star
	     * @param {number} [innerRadius] - The inner radius between points, default half `radius`
	     * @param {number} [rotation=0] - The rotation of the star in radians, where 0 is vertical
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.drawStar = function drawStar(x, y, points, radius, innerRadius) {
	        var rotation = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	        innerRadius = innerRadius || radius / 2;
	
	        var startAngle = -1 * Math.PI / 2 + rotation;
	        var len = points * 2;
	        var delta = _const.PI_2 / len;
	        var polygon = [];
	
	        for (var i = 0; i < len; i++) {
	            var r = i % 2 ? innerRadius : radius;
	            var angle = i * delta + startAngle;
	
	            polygon.push(x + r * Math.cos(angle), y + r * Math.sin(angle));
	        }
	
	        return this.drawPolygon(polygon);
	    };
	
	    /**
	     * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
	     *
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.clear = function clear() {
	        if (this.lineWidth || this.filling || this.graphicsData.length > 0) {
	            this.lineWidth = 0;
	            this.lineAlignment = 0.5;
	
	            this.filling = false;
	
	            this.boundsDirty = -1;
	            this.dirty++;
	            this.clearDirty++;
	            this.graphicsData.length = 0;
	        }
	
	        this.currentPath = null;
	        this._spriteRect = null;
	
	        return this;
	    };
	
	    /**
	     * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
	     * masked with gl.scissor.
	     *
	     * @returns {boolean} True if only 1 rect.
	     */
	
	
	    Graphics.prototype.isFastRect = function isFastRect() {
	        return this.graphicsData.length === 1 && this.graphicsData[0].shape.type === _const.SHAPES.RECT && !this.graphicsData[0].lineWidth;
	    };
	
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    Graphics.prototype._renderWebGL = function _renderWebGL(renderer) {
	        // if the sprite is not visible or the alpha is 0 then no need to render this element
	        if (this.dirty !== this.fastRectDirty) {
	            this.fastRectDirty = this.dirty;
	            this._fastRect = this.isFastRect();
	        }
	
	        // TODO this check can be moved to dirty?
	        if (this._fastRect) {
	            this._renderSpriteRect(renderer);
	        } else {
	            renderer.setObjectRenderer(renderer.plugins.graphics);
	            renderer.plugins.graphics.render(this);
	        }
	    };
	
	    /**
	     * Renders a sprite rectangle.
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    Graphics.prototype._renderSpriteRect = function _renderSpriteRect(renderer) {
	        var rect = this.graphicsData[0].shape;
	
	        if (!this._spriteRect) {
	            this._spriteRect = new _Sprite2.default(new _Texture2.default(_Texture2.default.WHITE));
	        }
	
	        var sprite = this._spriteRect;
	
	        if (this.tint === 0xffffff) {
	            sprite.tint = this.graphicsData[0].fillColor;
	        } else {
	            var t1 = tempColor1;
	            var t2 = tempColor2;
	
	            (0, _utils.hex2rgb)(this.graphicsData[0].fillColor, t1);
	            (0, _utils.hex2rgb)(this.tint, t2);
	
	            t1[0] *= t2[0];
	            t1[1] *= t2[1];
	            t1[2] *= t2[2];
	
	            sprite.tint = (0, _utils.rgb2hex)(t1);
	        }
	        sprite.alpha = this.graphicsData[0].fillAlpha;
	        sprite.worldAlpha = this.worldAlpha * sprite.alpha;
	        sprite.blendMode = this.blendMode;
	
	        sprite._texture._frame.width = rect.width;
	        sprite._texture._frame.height = rect.height;
	
	        sprite.transform.worldTransform = this.transform.worldTransform;
	
	        sprite.anchor.set(-rect.x / rect.width, -rect.y / rect.height);
	        sprite._onAnchorUpdate();
	
	        sprite._renderWebGL(renderer);
	    };
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */
	
	
	    Graphics.prototype._renderCanvas = function _renderCanvas(renderer) {
	        if (this.isMask === true) {
	            return;
	        }
	
	        renderer.plugins.graphics.render(this);
	    };
	
	    /**
	     * Retrieves the bounds of the graphic shape as a rectangle object
	     *
	     * @private
	     */
	
	
	    Graphics.prototype._calculateBounds = function _calculateBounds() {
	        if (this.boundsDirty !== this.dirty) {
	            this.boundsDirty = this.dirty;
	            this.updateLocalBounds();
	
	            this.cachedSpriteDirty = true;
	        }
	
	        var lb = this._localBounds;
	
	        this._bounds.addFrame(this.transform, lb.minX, lb.minY, lb.maxX, lb.maxY);
	    };
	
	    /**
	     * Tests if a point is inside this graphics object
	     *
	     * @param {PIXI.Point} point - the point to test
	     * @return {boolean} the result of the test
	     */
	
	
	    Graphics.prototype.containsPoint = function containsPoint(point) {
	        this.worldTransform.applyInverse(point, tempPoint);
	
	        var graphicsData = this.graphicsData;
	
	        for (var i = 0; i < graphicsData.length; ++i) {
	            var data = graphicsData[i];
	
	            if (!data.fill) {
	                continue;
	            }
	
	            // only deal with fills..
	            if (data.shape) {
	                if (data.shape.contains(tempPoint.x, tempPoint.y)) {
	                    if (data.holes) {
	                        for (var _i = 0; _i < data.holes.length; _i++) {
	                            var hole = data.holes[_i];
	
	                            if (hole.contains(tempPoint.x, tempPoint.y)) {
	                                return false;
	                            }
	                        }
	                    }
	
	                    return true;
	                }
	            }
	        }
	
	        return false;
	    };
	
	    /**
	     * Update the bounds of the object
	     *
	     */
	
	
	    Graphics.prototype.updateLocalBounds = function updateLocalBounds() {
	        var minX = Infinity;
	        var maxX = -Infinity;
	
	        var minY = Infinity;
	        var maxY = -Infinity;
	
	        if (this.graphicsData.length) {
	            var shape = 0;
	            var x = 0;
	            var y = 0;
	            var w = 0;
	            var h = 0;
	
	            for (var i = 0; i < this.graphicsData.length; i++) {
	                var data = this.graphicsData[i];
	                var type = data.type;
	                var lineWidth = data.lineWidth;
	
	                shape = data.shape;
	
	                if (type === _const.SHAPES.RECT || type === _const.SHAPES.RREC) {
	                    x = shape.x - lineWidth / 2;
	                    y = shape.y - lineWidth / 2;
	                    w = shape.width + lineWidth;
	                    h = shape.height + lineWidth;
	
	                    minX = x < minX ? x : minX;
	                    maxX = x + w > maxX ? x + w : maxX;
	
	                    minY = y < minY ? y : minY;
	                    maxY = y + h > maxY ? y + h : maxY;
	                } else if (type === _const.SHAPES.CIRC) {
	                    x = shape.x;
	                    y = shape.y;
	                    w = shape.radius + lineWidth / 2;
	                    h = shape.radius + lineWidth / 2;
	
	                    minX = x - w < minX ? x - w : minX;
	                    maxX = x + w > maxX ? x + w : maxX;
	
	                    minY = y - h < minY ? y - h : minY;
	                    maxY = y + h > maxY ? y + h : maxY;
	                } else if (type === _const.SHAPES.ELIP) {
	                    x = shape.x;
	                    y = shape.y;
	                    w = shape.width + lineWidth / 2;
	                    h = shape.height + lineWidth / 2;
	
	                    minX = x - w < minX ? x - w : minX;
	                    maxX = x + w > maxX ? x + w : maxX;
	
	                    minY = y - h < minY ? y - h : minY;
	                    maxY = y + h > maxY ? y + h : maxY;
	                } else {
	                    // POLY
	                    var points = shape.points;
	                    var x2 = 0;
	                    var y2 = 0;
	                    var dx = 0;
	                    var dy = 0;
	                    var rw = 0;
	                    var rh = 0;
	                    var cx = 0;
	                    var cy = 0;
	
	                    for (var j = 0; j + 2 < points.length; j += 2) {
	                        x = points[j];
	                        y = points[j + 1];
	                        x2 = points[j + 2];
	                        y2 = points[j + 3];
	                        dx = Math.abs(x2 - x);
	                        dy = Math.abs(y2 - y);
	                        h = lineWidth;
	                        w = Math.sqrt(dx * dx + dy * dy);
	
	                        if (w < 1e-9) {
	                            continue;
	                        }
	
	                        rw = (h / w * dy + dx) / 2;
	                        rh = (h / w * dx + dy) / 2;
	                        cx = (x2 + x) / 2;
	                        cy = (y2 + y) / 2;
	
	                        minX = cx - rw < minX ? cx - rw : minX;
	                        maxX = cx + rw > maxX ? cx + rw : maxX;
	
	                        minY = cy - rh < minY ? cy - rh : minY;
	                        maxY = cy + rh > maxY ? cy + rh : maxY;
	                    }
	                }
	            }
	        } else {
	            minX = 0;
	            maxX = 0;
	            minY = 0;
	            maxY = 0;
	        }
	
	        var padding = this.boundsPadding;
	
	        this._localBounds.minX = minX - padding;
	        this._localBounds.maxX = maxX + padding;
	
	        this._localBounds.minY = minY - padding;
	        this._localBounds.maxY = maxY + padding;
	    };
	
	    /**
	     * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
	     *
	     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
	     * @return {PIXI.GraphicsData} The generated GraphicsData object.
	     */
	
	
	    Graphics.prototype.drawShape = function drawShape(shape) {
	        if (this.currentPath) {
	            // check current path!
	            if (this.currentPath.shape.points.length <= 2) {
	                this.graphicsData.pop();
	            }
	        }
	
	        this.currentPath = null;
	
	        var data = new _GraphicsData2.default(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.filling, this.nativeLines, shape, this.lineAlignment);
	
	        this.graphicsData.push(data);
	
	        if (data.type === _const.SHAPES.POLY) {
	            data.shape.closed = data.shape.closed || this.filling;
	            this.currentPath = data;
	        }
	
	        this.dirty++;
	
	        return data;
	    };
	
	    /**
	     * Generates a canvas texture.
	     *
	     * @param {number} scaleMode - The scale mode of the texture.
	     * @param {number} resolution - The resolution of the texture.
	     * @return {PIXI.Texture} The new texture.
	     */
	
	
	    Graphics.prototype.generateCanvasTexture = function generateCanvasTexture(scaleMode) {
	        var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	        var bounds = this.getLocalBounds();
	
	        var canvasBuffer = _RenderTexture2.default.create(bounds.width, bounds.height, scaleMode, resolution);
	
	        if (!canvasRenderer) {
	            canvasRenderer = new _CanvasRenderer2.default();
	        }
	
	        this.transform.updateLocalTransform();
	        this.transform.localTransform.copy(tempMatrix);
	
	        tempMatrix.invert();
	
	        tempMatrix.tx -= bounds.x;
	        tempMatrix.ty -= bounds.y;
	
	        canvasRenderer.render(this, canvasBuffer, true, tempMatrix);
	
	        var texture = _Texture2.default.fromCanvas(canvasBuffer.baseTexture._canvasRenderTarget.canvas, scaleMode, 'graphics');
	
	        texture.baseTexture.resolution = resolution;
	        texture.baseTexture.update();
	
	        return texture;
	    };
	
	    /**
	     * Closes the current path.
	     *
	     * @return {PIXI.Graphics} Returns itself.
	     */
	
	
	    Graphics.prototype.closePath = function closePath() {
	        // ok so close path assumes next one is a hole!
	        var currentPath = this.currentPath;
	
	        if (currentPath && currentPath.shape) {
	            currentPath.shape.close();
	        }
	
	        return this;
	    };
	
	    /**
	     * Adds a hole in the current path.
	     *
	     * @return {PIXI.Graphics} Returns itself.
	     */
	
	
	    Graphics.prototype.addHole = function addHole() {
	        // this is a hole!
	        var hole = this.graphicsData.pop();
	
	        this.currentPath = this.graphicsData[this.graphicsData.length - 1];
	
	        this.currentPath.addHole(hole.shape);
	        this.currentPath = null;
	
	        return this;
	    };
	
	    /**
	     * Destroys the Graphics object.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
	     *  options have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have
	     *  their destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */
	
	
	    Graphics.prototype.destroy = function destroy(options) {
	        _Container.prototype.destroy.call(this, options);
	
	        // destroy each of the GraphicsData objects
	        for (var i = 0; i < this.graphicsData.length; ++i) {
	            this.graphicsData[i].destroy();
	        }
	
	        // for each webgl data entry, destroy the WebGLGraphicsData
	        for (var id in this._webGL) {
	            for (var j = 0; j < this._webGL[id].data.length; ++j) {
	                this._webGL[id].data[j].destroy();
	            }
	        }
	
	        if (this._spriteRect) {
	            this._spriteRect.destroy();
	        }
	
	        this.graphicsData = null;
	
	        this.currentPath = null;
	        this._webGL = null;
	        this._localBounds = null;
	    };
	
	    return Graphics;
	}(_Container3.default);
	
	exports.default = Graphics;
	
	
	Graphics._SPRITE_TEXTURE = null;
	
	/**
	 * Graphics curves resolution settings. If `adaptive` flag is set to `true`,
	 * the resolution is calculated based on the curve's length to ensure better visual quality.
	 * Adaptive draw works with `bezierCurveTo` and `quadraticCurveTo`.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI.Graphics
	 * @name CURVES
	 * @type {object}
	 * @property {boolean} adaptive=false - flag indicating if the resolution should be adaptive
	 * @property {number} maxLength=10 - maximal length of a single segment of the curve (if adaptive = false, ignored)
	 * @property {number} minSegments=8 - minimal number of segments in the curve (if adaptive = false, ignored)
	 * @property {number} maxSegments=2048 - maximal number of segments in the curve (if adaptive = false, ignored)
	 */
	Graphics.CURVES = {
	    adaptive: false,
	    maxLength: 10,
	    minSegments: 8,
	    maxSegments: 2048
	};
	//# sourceMappingURL=Graphics.js.map

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * A GraphicsData object.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var GraphicsData = function () {
	  /**
	   *
	   * @param {number} lineWidth - the width of the line to draw
	   * @param {number} lineColor - the color of the line to draw
	   * @param {number} lineAlpha - the alpha of the line to draw
	   * @param {number} fillColor - the color of the fill
	   * @param {number} fillAlpha - the alpha of the fill
	   * @param {boolean} fill - whether or not the shape is filled with a colour
	   * @param {boolean} nativeLines - the method for drawing lines
	   * @param {PIXI.Circle|PIXI.Rectangle|PIXI.Ellipse|PIXI.Polygon} shape - The shape object to draw.
	   * @param {number} lineAlignment - the alignment of the line.
	   */
	  function GraphicsData(lineWidth, lineColor, lineAlpha, fillColor, fillAlpha, fill, nativeLines, shape, lineAlignment) {
	    _classCallCheck(this, GraphicsData);
	
	    /**
	     * the width of the line to draw
	     * @member {number}
	     */
	    this.lineWidth = lineWidth;
	
	    /**
	     * The alignment of any lines drawn (0.5 = middle, 1 = outter, 0 = inner).
	     *
	     * @member {number}
	     * @default 0
	     */
	    this.lineAlignment = lineAlignment;
	
	    /**
	     * if true the liens will be draw using LINES instead of TRIANGLE_STRIP
	     * @member {boolean}
	     */
	    this.nativeLines = nativeLines;
	
	    /**
	     * the color of the line to draw
	     * @member {number}
	     */
	    this.lineColor = lineColor;
	
	    /**
	     * the alpha of the line to draw
	     * @member {number}
	     */
	    this.lineAlpha = lineAlpha;
	
	    /**
	     * cached tint of the line to draw
	     * @member {number}
	     * @private
	     */
	    this._lineTint = lineColor;
	
	    /**
	     * the color of the fill
	     * @member {number}
	     */
	    this.fillColor = fillColor;
	
	    /**
	     * the alpha of the fill
	     * @member {number}
	     */
	    this.fillAlpha = fillAlpha;
	
	    /**
	     * cached tint of the fill
	     * @member {number}
	     * @private
	     */
	    this._fillTint = fillColor;
	
	    /**
	     * whether or not the shape is filled with a colour
	     * @member {boolean}
	     */
	    this.fill = fill;
	
	    this.holes = [];
	
	    /**
	     * The shape object to draw.
	     * @member {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle}
	     */
	    this.shape = shape;
	
	    /**
	     * The type of the shape, see the Const.Shapes file for all the existing types,
	     * @member {number}
	     */
	    this.type = shape.type;
	  }
	
	  /**
	   * Creates a new GraphicsData object with the same values as this one.
	   *
	   * @return {PIXI.GraphicsData} Cloned GraphicsData object
	   */
	
	
	  GraphicsData.prototype.clone = function clone() {
	    return new GraphicsData(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.fill, this.nativeLines, this.shape);
	  };
	
	  /**
	   * Adds a hole to the shape.
	   *
	   * @param {PIXI.Rectangle|PIXI.Circle} shape - The shape of the hole.
	   */
	
	
	  GraphicsData.prototype.addHole = function addHole(shape) {
	    this.holes.push(shape);
	  };
	
	  /**
	   * Destroys the Graphics data.
	   */
	
	
	  GraphicsData.prototype.destroy = function destroy() {
	    this.shape = null;
	    this.holes = null;
	  };
	
	  return GraphicsData;
	}();
	
	exports.default = GraphicsData;
	//# sourceMappingURL=GraphicsData.js.map

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = bezierCurveTo;
	/**
	 * Calculate the points for a bezier curve and then draws it.
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @param {number} fromX - Starting point x
	 * @param {number} fromY - Starting point y
	 * @param {number} cpX - Control point x
	 * @param {number} cpY - Control point y
	 * @param {number} cpX2 - Second Control point x
	 * @param {number} cpY2 - Second Control point y
	 * @param {number} toX - Destination point x
	 * @param {number} toY - Destination point y
	 * @param {number} n - Number of segments approximating the bezier curve
	 * @param {number[]} [path=[]] - Path array to push points into
	 * @return {number[]} Array of points of the curve
	 */
	function bezierCurveTo(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY, n) {
	    var path = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : [];
	
	    var dt = 0;
	    var dt2 = 0;
	    var dt3 = 0;
	    var t2 = 0;
	    var t3 = 0;
	
	    path.push(fromX, fromY);
	
	    for (var i = 1, j = 0; i <= n; ++i) {
	        j = i / n;
	
	        dt = 1 - j;
	        dt2 = dt * dt;
	        dt3 = dt2 * dt;
	
	        t2 = j * j;
	        t3 = t2 * j;
	
	        path.push(dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX, dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
	    }
	
	    return path;
	}
	//# sourceMappingURL=bezierCurveTo.js.map

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(244);
	
	var _const = __webpack_require__(205);
	
	var _ObjectRenderer2 = __webpack_require__(278);
	
	var _ObjectRenderer3 = _interopRequireDefault(_ObjectRenderer2);
	
	var _WebGLRenderer = __webpack_require__(280);
	
	var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);
	
	var _WebGLGraphicsData = __webpack_require__(311);
	
	var _WebGLGraphicsData2 = _interopRequireDefault(_WebGLGraphicsData);
	
	var _PrimitiveShader = __webpack_require__(312);
	
	var _PrimitiveShader2 = _interopRequireDefault(_PrimitiveShader);
	
	var _buildPoly = __webpack_require__(313);
	
	var _buildPoly2 = _interopRequireDefault(_buildPoly);
	
	var _buildRectangle = __webpack_require__(315);
	
	var _buildRectangle2 = _interopRequireDefault(_buildRectangle);
	
	var _buildRoundedRectangle = __webpack_require__(316);
	
	var _buildRoundedRectangle2 = _interopRequireDefault(_buildRoundedRectangle);
	
	var _buildCircle = __webpack_require__(317);
	
	var _buildCircle2 = _interopRequireDefault(_buildCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Renders the graphics object.
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.ObjectRenderer
	 */
	var GraphicsRenderer = function (_ObjectRenderer) {
	    _inherits(GraphicsRenderer, _ObjectRenderer);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this object renderer works for.
	     */
	    function GraphicsRenderer(renderer) {
	        _classCallCheck(this, GraphicsRenderer);
	
	        var _this = _possibleConstructorReturn(this, _ObjectRenderer.call(this, renderer));
	
	        _this.graphicsDataPool = [];
	
	        _this.primitiveShader = null;
	
	        _this.gl = renderer.gl;
	
	        // easy access!
	        _this.CONTEXT_UID = 0;
	        return _this;
	    }
	
	    /**
	     * Called when there is a WebGL context change
	     *
	     * @private
	     *
	     */
	
	
	    GraphicsRenderer.prototype.onContextChange = function onContextChange() {
	        this.gl = this.renderer.gl;
	        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
	        this.primitiveShader = new _PrimitiveShader2.default(this.gl);
	    };
	
	    /**
	     * Destroys this renderer.
	     *
	     */
	
	
	    GraphicsRenderer.prototype.destroy = function destroy() {
	        _ObjectRenderer3.default.prototype.destroy.call(this);
	
	        for (var i = 0; i < this.graphicsDataPool.length; ++i) {
	            this.graphicsDataPool[i].destroy();
	        }
	
	        this.graphicsDataPool = null;
	    };
	
	    /**
	     * Renders a graphics object.
	     *
	     * @param {PIXI.Graphics} graphics - The graphics object to render.
	     */
	
	
	    GraphicsRenderer.prototype.render = function render(graphics) {
	        var renderer = this.renderer;
	        var gl = renderer.gl;
	
	        var webGLData = void 0;
	        var webGL = graphics._webGL[this.CONTEXT_UID];
	
	        if (!webGL || graphics.dirty !== webGL.dirty) {
	            this.updateGraphics(graphics);
	
	            webGL = graphics._webGL[this.CONTEXT_UID];
	        }
	
	        // This  could be speeded up for sure!
	        var shader = this.primitiveShader;
	
	        renderer.bindShader(shader);
	        renderer.state.setBlendMode(graphics.blendMode);
	
	        for (var i = 0, n = webGL.data.length; i < n; i++) {
	            webGLData = webGL.data[i];
	            var shaderTemp = webGLData.shader;
	
	            renderer.bindShader(shaderTemp);
	            shaderTemp.uniforms.translationMatrix = graphics.transform.worldTransform.toArray(true);
	            shaderTemp.uniforms.tint = (0, _utils.hex2rgb)(graphics.tint);
	            shaderTemp.uniforms.alpha = graphics.worldAlpha;
	
	            renderer.bindVao(webGLData.vao);
	
	            if (webGLData.nativeLines) {
	                gl.drawArrays(gl.LINES, 0, webGLData.points.length / 6);
	            } else {
	                webGLData.vao.draw(gl.TRIANGLE_STRIP, webGLData.indices.length);
	            }
	        }
	    };
	
	    /**
	     * Updates the graphics object
	     *
	     * @private
	     * @param {PIXI.Graphics} graphics - The graphics object to update
	     */
	
	
	    GraphicsRenderer.prototype.updateGraphics = function updateGraphics(graphics) {
	        var gl = this.renderer.gl;
	
	        // get the contexts graphics object
	        var webGL = graphics._webGL[this.CONTEXT_UID];
	
	        // if the graphics object does not exist in the webGL context time to create it!
	        if (!webGL) {
	            webGL = graphics._webGL[this.CONTEXT_UID] = { lastIndex: 0, data: [], gl: gl, clearDirty: -1, dirty: -1 };
	        }
	
	        // flag the graphics as not dirty as we are about to update it...
	        webGL.dirty = graphics.dirty;
	
	        // if the user cleared the graphics object we will need to clear every object
	        if (graphics.clearDirty !== webGL.clearDirty) {
	            webGL.clearDirty = graphics.clearDirty;
	
	            // loop through and return all the webGLDatas to the object pool so than can be reused later on
	            for (var i = 0; i < webGL.data.length; i++) {
	                this.graphicsDataPool.push(webGL.data[i]);
	            }
	
	            // clear the array and reset the index..
	            webGL.data.length = 0;
	            webGL.lastIndex = 0;
	        }
	
	        var webGLData = void 0;
	        var webGLDataNativeLines = void 0;
	
	        // loop through the graphics datas and construct each one..
	        // if the object is a complex fill then the new stencil buffer technique will be used
	        // other wise graphics objects will be pushed into a batch..
	        for (var _i = webGL.lastIndex; _i < graphics.graphicsData.length; _i++) {
	            var data = graphics.graphicsData[_i];
	
	            // TODO - this can be simplified
	            webGLData = this.getWebGLData(webGL, 0);
	
	            if (data.nativeLines && data.lineWidth) {
	                webGLDataNativeLines = this.getWebGLData(webGL, 0, true);
	                webGL.lastIndex++;
	            }
	
	            if (data.type === _const.SHAPES.POLY) {
	                (0, _buildPoly2.default)(data, webGLData, webGLDataNativeLines);
	            }
	            if (data.type === _const.SHAPES.RECT) {
	                (0, _buildRectangle2.default)(data, webGLData, webGLDataNativeLines);
	            } else if (data.type === _const.SHAPES.CIRC || data.type === _const.SHAPES.ELIP) {
	                (0, _buildCircle2.default)(data, webGLData, webGLDataNativeLines);
	            } else if (data.type === _const.SHAPES.RREC) {
	                (0, _buildRoundedRectangle2.default)(data, webGLData, webGLDataNativeLines);
	            }
	
	            webGL.lastIndex++;
	        }
	
	        this.renderer.bindVao(null);
	
	        // upload all the dirty data...
	        for (var _i2 = 0; _i2 < webGL.data.length; _i2++) {
	            webGLData = webGL.data[_i2];
	
	            if (webGLData.dirty) {
	                webGLData.upload();
	            }
	        }
	    };
	
	    /**
	     *
	     * @private
	     * @param {WebGLRenderingContext} gl - the current WebGL drawing context
	     * @param {number} type - TODO @Alvin
	     * @param {number} nativeLines - indicate whether the webGLData use for nativeLines.
	     * @return {*} TODO
	     */
	
	
	    GraphicsRenderer.prototype.getWebGLData = function getWebGLData(gl, type, nativeLines) {
	        var webGLData = gl.data[gl.data.length - 1];
	
	        if (!webGLData || webGLData.nativeLines !== nativeLines || webGLData.points.length > 320000) {
	            webGLData = this.graphicsDataPool.pop() || new _WebGLGraphicsData2.default(this.renderer.gl, this.primitiveShader, this.renderer.state.attribsState);
	            webGLData.nativeLines = nativeLines;
	            webGLData.reset(type);
	            gl.data.push(webGLData);
	        }
	
	        webGLData.dirty = true;
	
	        return webGLData;
	    };
	
	    return GraphicsRenderer;
	}(_ObjectRenderer3.default);
	
	exports.default = GraphicsRenderer;
	
	
	_WebGLRenderer2.default.registerPlugin('graphics', GraphicsRenderer);
	//# sourceMappingURL=GraphicsRenderer.js.map

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pixiGlCore = __webpack_require__(216);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * An object containing WebGL specific properties to be used by the WebGL renderer
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var WebGLGraphicsData = function () {
	  /**
	   * @param {WebGLRenderingContext} gl - The current WebGL drawing context
	   * @param {PIXI.Shader} shader - The shader
	   * @param {object} attribsState - The state for the VAO
	   */
	  function WebGLGraphicsData(gl, shader, attribsState) {
	    _classCallCheck(this, WebGLGraphicsData);
	
	    /**
	     * The current WebGL drawing context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	    // TODO does this need to be split before uploading??
	    /**
	     * An array of color components (r,g,b)
	     * @member {number[]}
	     */
	    this.color = [0, 0, 0]; // color split!
	
	    /**
	     * An array of points to draw
	     * @member {PIXI.Point[]}
	     */
	    this.points = [];
	
	    /**
	     * The indices of the vertices
	     * @member {number[]}
	     */
	    this.indices = [];
	    /**
	     * The main buffer
	     * @member {WebGLBuffer}
	     */
	    this.buffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl);
	
	    /**
	     * The index buffer
	     * @member {WebGLBuffer}
	     */
	    this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl);
	
	    /**
	     * Whether this graphics is dirty or not
	     * @member {boolean}
	     */
	    this.dirty = true;
	
	    /**
	     * Whether this graphics is nativeLines or not
	     * @member {boolean}
	     */
	    this.nativeLines = false;
	
	    this.glPoints = null;
	    this.glIndices = null;
	
	    /**
	     *
	     * @member {PIXI.Shader}
	     */
	    this.shader = shader;
	
	    this.vao = new _pixiGlCore2.default.VertexArrayObject(gl, attribsState).addIndex(this.indexBuffer).addAttribute(this.buffer, shader.attributes.aVertexPosition, gl.FLOAT, false, 4 * 6, 0).addAttribute(this.buffer, shader.attributes.aColor, gl.FLOAT, false, 4 * 6, 2 * 4);
	  }
	
	  /**
	   * Resets the vertices and the indices
	   */
	
	
	  WebGLGraphicsData.prototype.reset = function reset() {
	    this.points.length = 0;
	    this.indices.length = 0;
	  };
	
	  /**
	   * Binds the buffers and uploads the data
	   */
	
	
	  WebGLGraphicsData.prototype.upload = function upload() {
	    this.glPoints = new Float32Array(this.points);
	    this.buffer.upload(this.glPoints);
	
	    this.glIndices = new Uint16Array(this.indices);
	    this.indexBuffer.upload(this.glIndices);
	
	    this.dirty = false;
	  };
	
	  /**
	   * Empties all the data
	   */
	
	
	  WebGLGraphicsData.prototype.destroy = function destroy() {
	    this.color = null;
	    this.points = null;
	    this.indices = null;
	
	    this.vao.destroy();
	    this.buffer.destroy();
	    this.indexBuffer.destroy();
	
	    this.gl = null;
	
	    this.buffer = null;
	    this.indexBuffer = null;
	
	    this.glPoints = null;
	    this.glIndices = null;
	  };
	
	  return WebGLGraphicsData;
	}();
	
	exports.default = WebGLGraphicsData;
	//# sourceMappingURL=WebGLGraphicsData.js.map

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Shader2 = __webpack_require__(292);
	
	var _Shader3 = _interopRequireDefault(_Shader2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This shader is used to draw simple primitive shapes for {@link PIXI.Graphics}.
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.Shader
	 */
	var PrimitiveShader = function (_Shader) {
	    _inherits(PrimitiveShader, _Shader);
	
	    /**
	     * @param {WebGLRenderingContext} gl - The webgl shader manager this shader works for.
	     */
	    function PrimitiveShader(gl) {
	        _classCallCheck(this, PrimitiveShader);
	
	        return _possibleConstructorReturn(this, _Shader.call(this, gl,
	        // vertex shader
	        ['attribute vec2 aVertexPosition;', 'attribute vec4 aColor;', 'uniform mat3 translationMatrix;', 'uniform mat3 projectionMatrix;', 'uniform float alpha;', 'uniform vec3 tint;', 'varying vec4 vColor;', 'void main(void){', '   gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);', '   vColor = aColor * vec4(tint * alpha, alpha);', '}'].join('\n'),
	        // fragment shader
	        ['varying vec4 vColor;', 'void main(void){', '   gl_FragColor = vColor;', '}'].join('\n')));
	    }
	
	    return PrimitiveShader;
	}(_Shader3.default);
	
	exports.default = PrimitiveShader;
	//# sourceMappingURL=PrimitiveShader.js.map

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = buildPoly;
	
	var _buildLine = __webpack_require__(314);
	
	var _buildLine2 = _interopRequireDefault(_buildLine);
	
	var _utils = __webpack_require__(244);
	
	var _earcut = __webpack_require__(249);
	
	var _earcut2 = _interopRequireDefault(_earcut);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Builds a polygon to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildPoly(graphicsData, webGLData, webGLDataNativeLines) {
	    graphicsData.points = graphicsData.shape.points.slice();
	
	    var points = graphicsData.points;
	
	    if (graphicsData.fill && points.length >= 6) {
	        var holeArray = [];
	        // Process holes..
	        var holes = graphicsData.holes;
	
	        for (var i = 0; i < holes.length; i++) {
	            var hole = holes[i];
	
	            holeArray.push(points.length / 2);
	
	            points = points.concat(hole.points);
	        }
	
	        // get first and last point.. figure out the middle!
	        var verts = webGLData.points;
	        var indices = webGLData.indices;
	
	        var length = points.length / 2;
	
	        // sort color
	        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;
	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;
	
	        var triangles = (0, _earcut2.default)(points, holeArray, 2);
	
	        if (!triangles) {
	            return;
	        }
	
	        var vertPos = verts.length / 6;
	
	        for (var _i = 0; _i < triangles.length; _i += 3) {
	            indices.push(triangles[_i] + vertPos);
	            indices.push(triangles[_i] + vertPos);
	            indices.push(triangles[_i + 1] + vertPos);
	            indices.push(triangles[_i + 2] + vertPos);
	            indices.push(triangles[_i + 2] + vertPos);
	        }
	
	        for (var _i2 = 0; _i2 < length; _i2++) {
	            verts.push(points[_i2 * 2], points[_i2 * 2 + 1], r, g, b, alpha);
	        }
	    }
	
	    if (graphicsData.lineWidth > 0) {
	        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);
	    }
	}
	//# sourceMappingURL=buildPoly.js.map

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (graphicsData, webGLData, webGLDataNativeLines) {
	    if (graphicsData.nativeLines) {
	        buildNativeLine(graphicsData, webGLDataNativeLines);
	    } else {
	        buildLine(graphicsData, webGLData);
	    }
	};
	
	var _math = __webpack_require__(206);
	
	var _utils = __webpack_require__(244);
	
	/**
	 * Builds a line to draw using the poligon method.
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 */
	function buildLine(graphicsData, webGLData) {
	    // TODO OPTIMISE!
	    var points = graphicsData.points;
	
	    if (points.length === 0) {
	        return;
	    }
	    // if the line width is an odd number add 0.5 to align to a whole pixel
	    // commenting this out fixes #711 and #1620
	    // if (graphicsData.lineWidth%2)
	    // {
	    //     for (i = 0; i < points.length; i++)
	    //     {
	    //         points[i] += 0.5;
	    //     }
	    // }
	
	    // get first and last point.. figure out the middle!
	    var firstPoint = new _math.Point(points[0], points[1]);
	    var lastPoint = new _math.Point(points[points.length - 2], points[points.length - 1]);
	
	    // if the first point is the last point - gonna have issues :)
	    if (firstPoint.x === lastPoint.x && firstPoint.y === lastPoint.y) {
	        // need to clone as we are going to slightly modify the shape..
	        points = points.slice();
	
	        points.pop();
	        points.pop();
	
	        lastPoint = new _math.Point(points[points.length - 2], points[points.length - 1]);
	
	        var midPointX = lastPoint.x + (firstPoint.x - lastPoint.x) * 0.5;
	        var midPointY = lastPoint.y + (firstPoint.y - lastPoint.y) * 0.5;
	
	        points.unshift(midPointX, midPointY);
	        points.push(midPointX, midPointY);
	    }
	
	    var verts = webGLData.points;
	    var indices = webGLData.indices;
	    var length = points.length / 2;
	    var indexCount = points.length;
	    var indexStart = verts.length / 6;
	
	    // DRAW the Line
	    var width = graphicsData.lineWidth / 2;
	
	    // sort color
	    var color = (0, _utils.hex2rgb)(graphicsData.lineColor);
	    var alpha = graphicsData.lineAlpha;
	    var r = color[0] * alpha;
	    var g = color[1] * alpha;
	    var b = color[2] * alpha;
	
	    var p1x = points[0];
	    var p1y = points[1];
	    var p2x = points[2];
	    var p2y = points[3];
	    var p3x = 0;
	    var p3y = 0;
	
	    var perpx = -(p1y - p2y);
	    var perpy = p1x - p2x;
	    var perp2x = 0;
	    var perp2y = 0;
	    var perp3x = 0;
	    var perp3y = 0;
	
	    var dist = Math.sqrt(perpx * perpx + perpy * perpy);
	
	    perpx /= dist;
	    perpy /= dist;
	    perpx *= width;
	    perpy *= width;
	
	    var ratio = graphicsData.lineAlignment; // 0.5;
	    var r1 = (1 - ratio) * 2;
	    var r2 = ratio * 2;
	
	    // start
	    verts.push(p1x - perpx * r1, p1y - perpy * r1, r, g, b, alpha);
	
	    verts.push(p1x + perpx * r2, p1y + perpy * r2, r, g, b, alpha);
	
	    for (var i = 1; i < length - 1; ++i) {
	        p1x = points[(i - 1) * 2];
	        p1y = points[(i - 1) * 2 + 1];
	
	        p2x = points[i * 2];
	        p2y = points[i * 2 + 1];
	
	        p3x = points[(i + 1) * 2];
	        p3y = points[(i + 1) * 2 + 1];
	
	        perpx = -(p1y - p2y);
	        perpy = p1x - p2x;
	
	        dist = Math.sqrt(perpx * perpx + perpy * perpy);
	        perpx /= dist;
	        perpy /= dist;
	        perpx *= width;
	        perpy *= width;
	
	        perp2x = -(p2y - p3y);
	        perp2y = p2x - p3x;
	
	        dist = Math.sqrt(perp2x * perp2x + perp2y * perp2y);
	        perp2x /= dist;
	        perp2y /= dist;
	        perp2x *= width;
	        perp2y *= width;
	
	        var a1 = -perpy + p1y - (-perpy + p2y);
	        var b1 = -perpx + p2x - (-perpx + p1x);
	        var c1 = (-perpx + p1x) * (-perpy + p2y) - (-perpx + p2x) * (-perpy + p1y);
	        var a2 = -perp2y + p3y - (-perp2y + p2y);
	        var b2 = -perp2x + p2x - (-perp2x + p3x);
	        var c2 = (-perp2x + p3x) * (-perp2y + p2y) - (-perp2x + p2x) * (-perp2y + p3y);
	
	        var denom = a1 * b2 - a2 * b1;
	
	        if (Math.abs(denom) < 0.1) {
	            denom += 10.1;
	            verts.push(p2x - perpx * r1, p2y - perpy * r1, r, g, b, alpha);
	
	            verts.push(p2x + perpx * r2, p2y + perpy * r2, r, g, b, alpha);
	
	            continue;
	        }
	
	        var px = (b1 * c2 - b2 * c1) / denom;
	        var py = (a2 * c1 - a1 * c2) / denom;
	        var pdist = (px - p2x) * (px - p2x) + (py - p2y) * (py - p2y);
	
	        if (pdist > 196 * width * width) {
	            perp3x = perpx - perp2x;
	            perp3y = perpy - perp2y;
	
	            dist = Math.sqrt(perp3x * perp3x + perp3y * perp3y);
	            perp3x /= dist;
	            perp3y /= dist;
	            perp3x *= width;
	            perp3y *= width;
	
	            verts.push(p2x - perp3x * r1, p2y - perp3y * r1);
	            verts.push(r, g, b, alpha);
	
	            verts.push(p2x + perp3x * r2, p2y + perp3y * r2);
	            verts.push(r, g, b, alpha);
	
	            verts.push(p2x - perp3x * r2 * r1, p2y - perp3y * r1);
	            verts.push(r, g, b, alpha);
	
	            indexCount++;
	        } else {
	            verts.push(p2x + (px - p2x) * r1, p2y + (py - p2y) * r1);
	            verts.push(r, g, b, alpha);
	
	            verts.push(p2x - (px - p2x) * r2, p2y - (py - p2y) * r2);
	            verts.push(r, g, b, alpha);
	        }
	    }
	
	    p1x = points[(length - 2) * 2];
	    p1y = points[(length - 2) * 2 + 1];
	
	    p2x = points[(length - 1) * 2];
	    p2y = points[(length - 1) * 2 + 1];
	
	    perpx = -(p1y - p2y);
	    perpy = p1x - p2x;
	
	    dist = Math.sqrt(perpx * perpx + perpy * perpy);
	    perpx /= dist;
	    perpy /= dist;
	    perpx *= width;
	    perpy *= width;
	
	    verts.push(p2x - perpx * r1, p2y - perpy * r1);
	    verts.push(r, g, b, alpha);
	
	    verts.push(p2x + perpx * r2, p2y + perpy * r2);
	    verts.push(r, g, b, alpha);
	
	    indices.push(indexStart);
	
	    for (var _i = 0; _i < indexCount; ++_i) {
	        indices.push(indexStart++);
	    }
	
	    indices.push(indexStart - 1);
	}
	
	/**
	 * Builds a line to draw using the gl.drawArrays(gl.LINES) method
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 */
	
	
	/**
	 * Builds a line to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildNativeLine(graphicsData, webGLData) {
	    var i = 0;
	    var points = graphicsData.points;
	
	    if (points.length === 0) return;
	
	    var verts = webGLData.points;
	    var length = points.length / 2;
	
	    // sort color
	    var color = (0, _utils.hex2rgb)(graphicsData.lineColor);
	    var alpha = graphicsData.lineAlpha;
	    var r = color[0] * alpha;
	    var g = color[1] * alpha;
	    var b = color[2] * alpha;
	
	    for (i = 1; i < length; i++) {
	        var p1x = points[(i - 1) * 2];
	        var p1y = points[(i - 1) * 2 + 1];
	
	        var p2x = points[i * 2];
	        var p2y = points[i * 2 + 1];
	
	        verts.push(p1x, p1y);
	        verts.push(r, g, b, alpha);
	
	        verts.push(p2x, p2y);
	        verts.push(r, g, b, alpha);
	    }
	}
	//# sourceMappingURL=buildLine.js.map

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = buildRectangle;
	
	var _buildLine = __webpack_require__(314);
	
	var _buildLine2 = _interopRequireDefault(_buildLine);
	
	var _utils = __webpack_require__(244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Builds a rectangle to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildRectangle(graphicsData, webGLData, webGLDataNativeLines) {
	    // --- //
	    // need to convert points to a nice regular data
	    //
	    var rectData = graphicsData.shape;
	    var x = rectData.x;
	    var y = rectData.y;
	    var width = rectData.width;
	    var height = rectData.height;
	
	    if (graphicsData.fill) {
	        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;
	
	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;
	
	        var verts = webGLData.points;
	        var indices = webGLData.indices;
	
	        var vertPos = verts.length / 6;
	
	        // start
	        verts.push(x, y);
	        verts.push(r, g, b, alpha);
	
	        verts.push(x + width, y);
	        verts.push(r, g, b, alpha);
	
	        verts.push(x, y + height);
	        verts.push(r, g, b, alpha);
	
	        verts.push(x + width, y + height);
	        verts.push(r, g, b, alpha);
	
	        // insert 2 dead triangles..
	        indices.push(vertPos, vertPos, vertPos + 1, vertPos + 2, vertPos + 3, vertPos + 3);
	    }
	
	    if (graphicsData.lineWidth) {
	        var tempPoints = graphicsData.points;
	
	        graphicsData.points = [x, y, x + width, y, x + width, y + height, x, y + height, x, y];
	
	        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);
	
	        graphicsData.points = tempPoints;
	    }
	}
	//# sourceMappingURL=buildRectangle.js.map

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = buildRoundedRectangle;
	
	var _earcut = __webpack_require__(249);
	
	var _earcut2 = _interopRequireDefault(_earcut);
	
	var _buildLine = __webpack_require__(314);
	
	var _buildLine2 = _interopRequireDefault(_buildLine);
	
	var _utils = __webpack_require__(244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Builds a rounded rectangle to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildRoundedRectangle(graphicsData, webGLData, webGLDataNativeLines) {
	    var rrectData = graphicsData.shape;
	    var x = rrectData.x;
	    var y = rrectData.y;
	    var width = rrectData.width;
	    var height = rrectData.height;
	
	    var radius = rrectData.radius;
	
	    var recPoints = [];
	
	    recPoints.push(x, y + radius);
	    quadraticBezierCurve(x, y + height - radius, x, y + height, x + radius, y + height, recPoints);
	    quadraticBezierCurve(x + width - radius, y + height, x + width, y + height, x + width, y + height - radius, recPoints);
	    quadraticBezierCurve(x + width, y + radius, x + width, y, x + width - radius, y, recPoints);
	    quadraticBezierCurve(x + radius, y, x, y, x, y + radius + 0.0000000001, recPoints);
	
	    // this tiny number deals with the issue that occurs when points overlap and earcut fails to triangulate the item.
	    // TODO - fix this properly, this is not very elegant.. but it works for now.
	
	    if (graphicsData.fill) {
	        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;
	
	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;
	
	        var verts = webGLData.points;
	        var indices = webGLData.indices;
	
	        var vecPos = verts.length / 6;
	
	        var triangles = (0, _earcut2.default)(recPoints, null, 2);
	
	        for (var i = 0, j = triangles.length; i < j; i += 3) {
	            indices.push(triangles[i] + vecPos);
	            indices.push(triangles[i] + vecPos);
	            indices.push(triangles[i + 1] + vecPos);
	            indices.push(triangles[i + 2] + vecPos);
	            indices.push(triangles[i + 2] + vecPos);
	        }
	
	        for (var _i = 0, _j = recPoints.length; _i < _j; _i++) {
	            verts.push(recPoints[_i], recPoints[++_i], r, g, b, alpha);
	        }
	    }
	
	    if (graphicsData.lineWidth) {
	        var tempPoints = graphicsData.points;
	
	        graphicsData.points = recPoints;
	
	        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);
	
	        graphicsData.points = tempPoints;
	    }
	}
	
	/**
	 * Calculate a single point for a quadratic bezier curve.
	 * Utility function used by quadraticBezierCurve.
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {number} n1 - first number
	 * @param {number} n2 - second number
	 * @param {number} perc - percentage
	 * @return {number} the result
	 *
	 */
	function getPt(n1, n2, perc) {
	    var diff = n2 - n1;
	
	    return n1 + diff * perc;
	}
	
	/**
	 * Calculate the points for a quadratic bezier curve. (helper function..)
	 * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {number} fromX - Origin point x
	 * @param {number} fromY - Origin point x
	 * @param {number} cpX - Control point x
	 * @param {number} cpY - Control point y
	 * @param {number} toX - Destination point x
	 * @param {number} toY - Destination point y
	 * @param {number[]} [out=[]] - The output array to add points into. If not passed, a new array is created.
	 * @return {number[]} an array of points
	 */
	function quadraticBezierCurve(fromX, fromY, cpX, cpY, toX, toY) {
	    var out = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
	
	    var n = 20;
	    var points = out;
	
	    var xa = 0;
	    var ya = 0;
	    var xb = 0;
	    var yb = 0;
	    var x = 0;
	    var y = 0;
	
	    for (var i = 0, j = 0; i <= n; ++i) {
	        j = i / n;
	
	        // The Green Line
	        xa = getPt(fromX, cpX, j);
	        ya = getPt(fromY, cpY, j);
	        xb = getPt(cpX, toX, j);
	        yb = getPt(cpY, toY, j);
	
	        // The Black Dot
	        x = getPt(xa, xb, j);
	        y = getPt(ya, yb, j);
	
	        points.push(x, y);
	    }
	
	    return points;
	}
	//# sourceMappingURL=buildRoundedRectangle.js.map

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = buildCircle;
	
	var _buildLine = __webpack_require__(314);
	
	var _buildLine2 = _interopRequireDefault(_buildLine);
	
	var _const = __webpack_require__(205);
	
	var _utils = __webpack_require__(244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Builds a circle to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object to draw
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildCircle(graphicsData, webGLData, webGLDataNativeLines) {
	    // need to convert points to a nice regular data
	    var circleData = graphicsData.shape;
	    var x = circleData.x;
	    var y = circleData.y;
	    var width = void 0;
	    var height = void 0;
	
	    // TODO - bit hacky??
	    if (graphicsData.type === _const.SHAPES.CIRC) {
	        width = circleData.radius;
	        height = circleData.radius;
	    } else {
	        width = circleData.width;
	        height = circleData.height;
	    }
	
	    if (width === 0 || height === 0) {
	        return;
	    }
	
	    var totalSegs = Math.floor(30 * Math.sqrt(circleData.radius)) || Math.floor(15 * Math.sqrt(circleData.width + circleData.height));
	
	    var seg = Math.PI * 2 / totalSegs;
	
	    if (graphicsData.fill) {
	        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;
	
	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;
	
	        var verts = webGLData.points;
	        var indices = webGLData.indices;
	
	        var vecPos = verts.length / 6;
	
	        indices.push(vecPos);
	
	        for (var i = 0; i < totalSegs + 1; i++) {
	            verts.push(x, y, r, g, b, alpha);
	
	            verts.push(x + Math.sin(seg * i) * width, y + Math.cos(seg * i) * height, r, g, b, alpha);
	
	            indices.push(vecPos++, vecPos++);
	        }
	
	        indices.push(vecPos - 1);
	    }
	
	    if (graphicsData.lineWidth) {
	        var tempPoints = graphicsData.points;
	
	        graphicsData.points = [];
	
	        for (var _i = 0; _i < totalSegs + 1; _i++) {
	            graphicsData.points.push(x + Math.sin(seg * -_i) * width, y + Math.cos(seg * -_i) * height);
	        }
	
	        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);
	
	        graphicsData.points = tempPoints;
	    }
	}
	//# sourceMappingURL=buildCircle.js.map

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CanvasRenderer = __webpack_require__(268);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _const = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they
	 * now share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's CanvasGraphicsRenderer:
	 * https://github.com/libgdx/libgdx/blob/1.0.0/gdx/src/com/badlogic/gdx/graphics/glutils/ShapeRenderer.java
	 */
	
	/**
	 * Renderer dedicated to drawing and batching graphics objects.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var CanvasGraphicsRenderer = function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - The current PIXI renderer.
	     */
	    function CanvasGraphicsRenderer(renderer) {
	        _classCallCheck(this, CanvasGraphicsRenderer);
	
	        this.renderer = renderer;
	    }
	
	    /**
	     * Renders a Graphics object to a canvas.
	     *
	     * @param {PIXI.Graphics} graphics - the actual graphics object to render
	     */
	
	
	    CanvasGraphicsRenderer.prototype.render = function render(graphics) {
	        var renderer = this.renderer;
	        var context = renderer.context;
	        var worldAlpha = graphics.worldAlpha;
	        var transform = graphics.transform.worldTransform;
	        var resolution = renderer.resolution;
	
	        // if the tint has changed, set the graphics object to dirty.
	        if (this._prevTint !== this.tint) {
	            this.dirty = true;
	        }
	
	        context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);
	
	        if (graphics.dirty) {
	            this.updateGraphicsTint(graphics);
	            graphics.dirty = false;
	        }
	
	        renderer.setBlendMode(graphics.blendMode);
	
	        for (var i = 0; i < graphics.graphicsData.length; i++) {
	            var data = graphics.graphicsData[i];
	            var shape = data.shape;
	
	            var fillColor = data._fillTint;
	            var lineColor = data._lineTint;
	
	            context.lineWidth = data.lineWidth;
	
	            if (data.type === _const.SHAPES.POLY) {
	                context.beginPath();
	
	                this.renderPolygon(shape.points, shape.closed, context);
	
	                for (var j = 0; j < data.holes.length; j++) {
	                    this.renderPolygon(data.holes[j].points, true, context);
	                }
	
	                if (data.fill) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fill();
	                }
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.stroke();
	                }
	            } else if (data.type === _const.SHAPES.RECT) {
	                if (data.fillColor || data.fillColor === 0) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fillRect(shape.x, shape.y, shape.width, shape.height);
	                }
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.strokeRect(shape.x, shape.y, shape.width, shape.height);
	                }
	            } else if (data.type === _const.SHAPES.CIRC) {
	                // TODO - need to be Undefined!
	                context.beginPath();
	                context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
	                context.closePath();
	
	                if (data.fill) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fill();
	                }
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.stroke();
	                }
	            } else if (data.type === _const.SHAPES.ELIP) {
	                // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
	
	                var w = shape.width * 2;
	                var h = shape.height * 2;
	
	                var x = shape.x - w / 2;
	                var y = shape.y - h / 2;
	
	                context.beginPath();
	
	                var kappa = 0.5522848;
	                var ox = w / 2 * kappa; // control point offset horizontal
	                var oy = h / 2 * kappa; // control point offset vertical
	                var xe = x + w; // x-end
	                var ye = y + h; // y-end
	                var xm = x + w / 2; // x-middle
	                var ym = y + h / 2; // y-middle
	
	                context.moveTo(x, ym);
	                context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
	                context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
	                context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	                context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
	
	                context.closePath();
	
	                if (data.fill) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fill();
	                }
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.stroke();
	                }
	            } else if (data.type === _const.SHAPES.RREC) {
	                var rx = shape.x;
	                var ry = shape.y;
	                var width = shape.width;
	                var height = shape.height;
	                var radius = shape.radius;
	
	                var maxRadius = Math.min(width, height) / 2 | 0;
	
	                radius = radius > maxRadius ? maxRadius : radius;
	
	                context.beginPath();
	                context.moveTo(rx, ry + radius);
	                context.lineTo(rx, ry + height - radius);
	                context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
	                context.lineTo(rx + width - radius, ry + height);
	                context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
	                context.lineTo(rx + width, ry + radius);
	                context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
	                context.lineTo(rx + radius, ry);
	                context.quadraticCurveTo(rx, ry, rx, ry + radius);
	                context.closePath();
	
	                if (data.fillColor || data.fillColor === 0) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fill();
	                }
	
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.stroke();
	                }
	            }
	        }
	    };
	
	    /**
	     * Updates the tint of a graphics object
	     *
	     * @private
	     * @param {PIXI.Graphics} graphics - the graphics that will have its tint updated
	     */
	
	
	    CanvasGraphicsRenderer.prototype.updateGraphicsTint = function updateGraphicsTint(graphics) {
	        graphics._prevTint = graphics.tint;
	
	        var tintR = (graphics.tint >> 16 & 0xFF) / 255;
	        var tintG = (graphics.tint >> 8 & 0xFF) / 255;
	        var tintB = (graphics.tint & 0xFF) / 255;
	
	        for (var i = 0; i < graphics.graphicsData.length; ++i) {
	            var data = graphics.graphicsData[i];
	
	            var fillColor = data.fillColor | 0;
	            var lineColor = data.lineColor | 0;
	
	            // super inline, cos optimization :)
	            data._fillTint = ((fillColor >> 16 & 0xFF) / 255 * tintR * 255 << 16) + ((fillColor >> 8 & 0xFF) / 255 * tintG * 255 << 8) + (fillColor & 0xFF) / 255 * tintB * 255;
	
	            data._lineTint = ((lineColor >> 16 & 0xFF) / 255 * tintR * 255 << 16) + ((lineColor >> 8 & 0xFF) / 255 * tintG * 255 << 8) + (lineColor & 0xFF) / 255 * tintB * 255;
	        }
	    };
	
	    /**
	     * Renders a polygon.
	     *
	     * @param {PIXI.Point[]} points - The points to render
	     * @param {boolean} close - Should the polygon be closed
	     * @param {CanvasRenderingContext2D} context - The rendering context to use
	     */
	
	
	    CanvasGraphicsRenderer.prototype.renderPolygon = function renderPolygon(points, close, context) {
	        context.moveTo(points[0], points[1]);
	
	        for (var j = 1; j < points.length / 2; ++j) {
	            context.lineTo(points[j * 2], points[j * 2 + 1]);
	        }
	
	        if (close) {
	            context.closePath();
	        }
	    };
	
	    /**
	     * destroy graphics object
	     *
	     */
	
	
	    CanvasGraphicsRenderer.prototype.destroy = function destroy() {
	        this.renderer = null;
	    };
	
	    return CanvasGraphicsRenderer;
	}();
	
	exports.default = CanvasGraphicsRenderer;
	
	
	_CanvasRenderer2.default.registerPlugin('graphics', CanvasGraphicsRenderer);
	//# sourceMappingURL=CanvasGraphicsRenderer.js.map

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ = __webpack_require__(204);
	
	var _utils = __webpack_require__(244);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Utility class for maintaining reference to a collection
	 * of Textures on a single Spritesheet.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Spritesheet = function () {
	    _createClass(Spritesheet, null, [{
	        key: 'BATCH_SIZE',
	
	        /**
	         * The maximum number of Textures to build per process.
	         *
	         * @type {number}
	         * @default 1000
	         */
	        get: function get() {
	            return 1000;
	        }
	
	        /**
	         * @param {PIXI.BaseTexture} baseTexture Reference to the source BaseTexture object.
	         * @param {Object} data - Spritesheet image data.
	         * @param {string} [resolutionFilename] - The filename to consider when determining
	         *        the resolution of the spritesheet. If not provided, the imageUrl will
	         *        be used on the BaseTexture.
	         */
	
	    }]);
	
	    function Spritesheet(baseTexture, data) {
	        var resolutionFilename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	        _classCallCheck(this, Spritesheet);
	
	        /**
	         * Reference to ths source texture
	         * @type {PIXI.BaseTexture}
	         */
	        this.baseTexture = baseTexture;
	
	        /**
	         * Map of spritesheet textures.
	         * @type {Object}
	         */
	        this.textures = {};
	
	        /**
	         * Reference to the original JSON data.
	         * @type {Object}
	         */
	        this.data = data;
	
	        /**
	         * The resolution of the spritesheet.
	         * @type {number}
	         */
	        this.resolution = this._updateResolution(resolutionFilename || this.baseTexture.imageUrl);
	
	        /**
	         * Map of spritesheet frames.
	         * @type {Object}
	         * @private
	         */
	        this._frames = this.data.frames;
	
	        /**
	         * Collection of frame names.
	         * @type {string[]}
	         * @private
	         */
	        this._frameKeys = Object.keys(this._frames);
	
	        /**
	         * Current batch index being processed.
	         * @type {number}
	         * @private
	         */
	        this._batchIndex = 0;
	
	        /**
	         * Callback when parse is completed.
	         * @type {Function}
	         * @private
	         */
	        this._callback = null;
	    }
	
	    /**
	     * Generate the resolution from the filename or fallback
	     * to the meta.scale field of the JSON data.
	     *
	     * @private
	     * @param {string} resolutionFilename - The filename to use for resolving
	     *        the default resolution.
	     * @return {number} Resolution to use for spritesheet.
	     */
	
	
	    Spritesheet.prototype._updateResolution = function _updateResolution(resolutionFilename) {
	        var scale = this.data.meta.scale;
	
	        // Use a defaultValue of `null` to check if a url-based resolution is set
	        var resolution = (0, _utils.getResolutionOfUrl)(resolutionFilename, null);
	
	        // No resolution found via URL
	        if (resolution === null) {
	            // Use the scale value or default to 1
	            resolution = scale !== undefined ? parseFloat(scale) : 1;
	        }
	
	        // For non-1 resolutions, update baseTexture
	        if (resolution !== 1) {
	            this.baseTexture.resolution = resolution;
	            this.baseTexture.update();
	        }
	
	        return resolution;
	    };
	
	    /**
	     * Parser spritesheet from loaded data. This is done asynchronously
	     * to prevent creating too many Texture within a single process.
	     *
	     * @param {Function} callback - Callback when complete returns
	     *        a map of the Textures for this spritesheet.
	     */
	
	
	    Spritesheet.prototype.parse = function parse(callback) {
	        this._batchIndex = 0;
	        this._callback = callback;
	
	        if (this._frameKeys.length <= Spritesheet.BATCH_SIZE) {
	            this._processFrames(0);
	            this._parseComplete();
	        } else {
	            this._nextBatch();
	        }
	    };
	
	    /**
	     * Process a batch of frames
	     *
	     * @private
	     * @param {number} initialFrameIndex - The index of frame to start.
	     */
	
	
	    Spritesheet.prototype._processFrames = function _processFrames(initialFrameIndex) {
	        var frameIndex = initialFrameIndex;
	        var maxFrames = Spritesheet.BATCH_SIZE;
	        var sourceScale = this.baseTexture.sourceScale;
	
	        while (frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length) {
	            var i = this._frameKeys[frameIndex];
	            var data = this._frames[i];
	            var rect = data.frame;
	
	            if (rect) {
	                var frame = null;
	                var trim = null;
	                var sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
	
	                var orig = new _.Rectangle(0, 0, Math.floor(sourceSize.w * sourceScale) / this.resolution, Math.floor(sourceSize.h * sourceScale) / this.resolution);
	
	                if (data.rotated) {
	                    frame = new _.Rectangle(Math.floor(rect.x * sourceScale) / this.resolution, Math.floor(rect.y * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution);
	                } else {
	                    frame = new _.Rectangle(Math.floor(rect.x * sourceScale) / this.resolution, Math.floor(rect.y * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution);
	                }
	
	                //  Check to see if the sprite is trimmed
	                if (data.trimmed !== false && data.spriteSourceSize) {
	                    trim = new _.Rectangle(Math.floor(data.spriteSourceSize.x * sourceScale) / this.resolution, Math.floor(data.spriteSourceSize.y * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution);
	                }
	
	                this.textures[i] = new _.Texture(this.baseTexture, frame, orig, trim, data.rotated ? 2 : 0);
	
	                // lets also add the frame to pixi's global cache for fromFrame and fromImage functions
	                _.Texture.addToCache(this.textures[i], i);
	            }
	
	            frameIndex++;
	        }
	    };
	
	    /**
	     * The parse has completed.
	     *
	     * @private
	     */
	
	
	    Spritesheet.prototype._parseComplete = function _parseComplete() {
	        var callback = this._callback;
	
	        this._callback = null;
	        this._batchIndex = 0;
	        callback.call(this, this.textures);
	    };
	
	    /**
	     * Begin the next batch of textures.
	     *
	     * @private
	     */
	
	
	    Spritesheet.prototype._nextBatch = function _nextBatch() {
	        var _this = this;
	
	        this._processFrames(this._batchIndex * Spritesheet.BATCH_SIZE);
	        this._batchIndex++;
	        setTimeout(function () {
	            if (_this._batchIndex * Spritesheet.BATCH_SIZE < _this._frameKeys.length) {
	                _this._nextBatch();
	            } else {
	                _this._parseComplete();
	            }
	        }, 0);
	    };
	
	    /**
	     * Destroy Spritesheet and don't use after this.
	     *
	     * @param {boolean} [destroyBase=false] Whether to destroy the base texture as well
	     */
	
	
	    Spritesheet.prototype.destroy = function destroy() {
	        var destroyBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        for (var i in this.textures) {
	            this.textures[i].destroy();
	        }
	        this._frames = null;
	        this._frameKeys = null;
	        this.data = null;
	        this.textures = null;
	        if (destroyBase) {
	            this.baseTexture.destroy();
	        }
	        this.baseTexture = null;
	    };
	
	    return Spritesheet;
	}();
	
	exports.default = Spritesheet;
	//# sourceMappingURL=Spritesheet.js.map

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _autoDetectRenderer = __webpack_require__(321);
	
	var _Container = __webpack_require__(243);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _ticker = __webpack_require__(263);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _const = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Convenience class to create a new PIXI application.
	 * This class automatically creates the renderer, ticker
	 * and root container.
	 *
	 * @example
	 * // Create the application
	 * const app = new PIXI.Application();
	 *
	 * // Add the view to the DOM
	 * document.body.appendChild(app.view);
	 *
	 * // ex, add display objects
	 * app.stage.addChild(PIXI.Sprite.fromImage('something.png'));
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Application = function () {
	    // eslint-disable-next-line valid-jsdoc
	    /**
	     * @param {object} [options] - The optional renderer parameters
	     * @param {boolean} [options.autoStart=true] - automatically starts the rendering after the construction.
	     *     Note that setting this parameter to false does NOT stop the shared ticker even if you set
	     *     options.sharedTicker to true in case that it is already started. Stop it by your own.
	     * @param {number} [options.width=800] - the width of the renderers view
	     * @param {number} [options.height=600] - the height of the renderers view
	     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	     * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
	     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
	     *  need to call toDataUrl on the webgl context
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2
	     * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present
	     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	     *  (shown if not transparent).
	     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	     *   not before the new render pass.
	     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
	     *  stopping pixel interpolation.
	     * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
	     *  FXAA is faster, but may not always look as great **webgl only**
	     * @param {boolean} [options.legacy=false] - `true` to ensure compatibility with older / less advanced devices.
	     *  If you experience unexplained flickering try setting this to true. **webgl only**
	     * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
	     *  for devices with dual graphics card **webgl only**
	     * @param {boolean} [options.sharedTicker=false] - `true` to use PIXI.ticker.shared, `false` to create new ticker.
	     * @param {boolean} [options.sharedLoader=false] - `true` to use PIXI.loaders.shared, `false` to create new Loader.
	     */
	    function Application(options, arg2, arg3, arg4, arg5) {
	        _classCallCheck(this, Application);
	
	        // Support for constructor(width, height, options, noWebGL, useSharedTicker)
	        if (typeof options === 'number') {
	            options = Object.assign({
	                width: options,
	                height: arg2 || _settings2.default.RENDER_OPTIONS.height,
	                forceCanvas: !!arg4,
	                sharedTicker: !!arg5
	            }, arg3);
	        }
	
	        /**
	         * The default options, so we mixin functionality later.
	         * @member {object}
	         * @protected
	         */
	        this._options = options = Object.assign({
	            autoStart: true,
	            sharedTicker: false,
	            forceCanvas: false,
	            sharedLoader: false
	        }, options);
	
	        /**
	         * WebGL renderer if available, otherwise CanvasRenderer
	         * @member {PIXI.WebGLRenderer|PIXI.CanvasRenderer}
	         */
	        this.renderer = (0, _autoDetectRenderer.autoDetectRenderer)(options);
	
	        /**
	         * The root display container that's rendered.
	         * @member {PIXI.Container}
	         */
	        this.stage = new _Container2.default();
	
	        /**
	         * Internal reference to the ticker
	         * @member {PIXI.ticker.Ticker}
	         * @private
	         */
	        this._ticker = null;
	
	        /**
	         * Ticker for doing render updates.
	         * @member {PIXI.ticker.Ticker}
	         * @default PIXI.ticker.shared
	         */
	        this.ticker = options.sharedTicker ? _ticker.shared : new _ticker.Ticker();
	
	        // Start the rendering
	        if (options.autoStart) {
	            this.start();
	        }
	    }
	
	    /**
	     * Render the current stage.
	     */
	    Application.prototype.render = function render() {
	        this.renderer.render(this.stage);
	    };
	
	    /**
	     * Convenience method for stopping the render.
	     */
	
	
	    Application.prototype.stop = function stop() {
	        this._ticker.stop();
	    };
	
	    /**
	     * Convenience method for starting the render.
	     */
	
	
	    Application.prototype.start = function start() {
	        this._ticker.start();
	    };
	
	    /**
	     * Reference to the renderer's canvas element.
	     * @member {HTMLCanvasElement}
	     * @readonly
	     */
	
	
	    /**
	     * Destroy and don't use after this.
	     * @param {Boolean} [removeView=false] Automatically remove canvas from DOM.
	     * @param {object|boolean} [stageOptions] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [stageOptions.children=false] - if set to true, all the children will have their destroy
	     *  method called as well. 'stageOptions' will be passed on to those calls.
	     * @param {boolean} [stageOptions.texture=false] - Only used for child Sprites if stageOptions.children is set
	     *  to true. Should it destroy the texture of the child sprite
	     * @param {boolean} [stageOptions.baseTexture=false] - Only used for child Sprites if stageOptions.children is set
	     *  to true. Should it destroy the base texture of the child sprite
	     */
	    Application.prototype.destroy = function destroy(removeView, stageOptions) {
	        if (this._ticker) {
	            var oldTicker = this._ticker;
	
	            this.ticker = null;
	            oldTicker.destroy();
	        }
	
	        this.stage.destroy(stageOptions);
	        this.stage = null;
	
	        this.renderer.destroy(removeView);
	        this.renderer = null;
	
	        this._options = null;
	    };
	
	    _createClass(Application, [{
	        key: 'ticker',
	        set: function set(ticker) // eslint-disable-line require-jsdoc
	        {
	            if (this._ticker) {
	                this._ticker.remove(this.render, this);
	            }
	            this._ticker = ticker;
	            if (ticker) {
	                ticker.add(this.render, this, _const.UPDATE_PRIORITY.LOW);
	            }
	        },
	        get: function get() // eslint-disable-line require-jsdoc
	        {
	            return this._ticker;
	        }
	    }, {
	        key: 'view',
	        get: function get() {
	            return this.renderer.view;
	        }
	
	        /**
	         * Reference to the renderer's screen rectangle. Its safe to use as filterArea or hitArea for whole screen
	         * @member {PIXI.Rectangle}
	         * @readonly
	         */
	
	    }, {
	        key: 'screen',
	        get: function get() {
	            return this.renderer.screen;
	        }
	    }]);
	
	    return Application;
	}();
	
	exports.default = Application;
	//# sourceMappingURL=Application.js.map

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.autoDetectRenderer = autoDetectRenderer;
	
	var _utils = __webpack_require__(244);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _CanvasRenderer = __webpack_require__(268);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _WebGLRenderer = __webpack_require__(280);
	
	var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// eslint-disable-next-line valid-jsdoc
	/**
	 * This helper function will automatically detect which renderer you should be using.
	 * WebGL is the preferred renderer as it is a lot faster. If webGL is not supported by
	 * the browser then this function will return a canvas renderer
	 *
	 * @memberof PIXI
	 * @function autoDetectRenderer
	 * @param {object} [options] - The optional renderer parameters
	 * @param {number} [options.width=800] - the width of the renderers view
	 * @param {number} [options.height=600] - the height of the renderers view
	 * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	 * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	 * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
	 * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
	 *  need to call toDataUrl on the webgl context
	 * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	 *  (shown if not transparent).
	 * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	 *   not before the new render pass.
	 * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2
	 * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present
	 * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
	 *  stopping pixel interpolation.
	 * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
	 *  FXAA is faster, but may not always look as great **webgl only**
	 * @param {boolean} [options.legacy=false] - `true` to ensure compatibility with older / less advanced devices.
	 *  If you experience unexplained flickering try setting this to true. **webgl only**
	 * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
	 *  for devices with dual graphics card **webgl only**
	 * @return {PIXI.WebGLRenderer|PIXI.CanvasRenderer} Returns WebGL renderer if available, otherwise CanvasRenderer
	 */
	function autoDetectRenderer(options, arg1, arg2, arg3) {
	    // Backward-compatible support for noWebGL option
	    var forceCanvas = options && options.forceCanvas;
	
	    if (arg3 !== undefined) {
	        forceCanvas = arg3;
	    }
	
	    if (!forceCanvas && utils.isWebGLSupported()) {
	        return new _WebGLRenderer2.default(options, arg1, arg2);
	    }
	
	    return new _CanvasRenderer2.default(options, arg1, arg2);
	}
	//# sourceMappingURL=autoDetectRenderer.js.map

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = deprecation;
	// provide method to give a stack track for warnings
	// useful for tracking-down where deprecated methods/properties/classes
	// are being used within the code
	
	// A map of warning messages already fired
	var warnings = {};
	
	// provide method to give a stack track for warnings
	// useful for tracking-down where deprecated methods/properties/classes
	// are being used within the code
	function warn(msg) {
	    // Ignore duplicat
	    if (warnings[msg]) {
	        return;
	    }
	
	    /* eslint-disable no-console */
	    var stack = new Error().stack;
	
	    // Handle IE < 10 and Safari < 6
	    if (typeof stack === 'undefined') {
	        console.warn('Deprecation Warning: ', msg);
	    } else {
	        // chop off the stack trace which includes pixi.js internal calls
	        stack = stack.split('\n').splice(3).join('\n');
	
	        if (console.groupCollapsed) {
	            console.groupCollapsed('%cDeprecation Warning: %c%s', 'color:#614108;background:#fffbe6', 'font-weight:normal;color:#614108;background:#fffbe6', msg);
	            console.warn(stack);
	            console.groupEnd();
	        } else {
	            console.warn('Deprecation Warning: ', msg);
	            console.warn(stack);
	        }
	    }
	    /* eslint-enable no-console */
	
	    warnings[msg] = true;
	}
	
	function deprecation(core) {
	    var mesh = core.mesh,
	        particles = core.particles,
	        extras = core.extras,
	        filters = core.filters,
	        prepare = core.prepare,
	        loaders = core.loaders,
	        interaction = core.interaction;
	
	
	    Object.defineProperties(core, {
	
	        /**
	         * @class
	         * @private
	         * @name SpriteBatch
	         * @memberof PIXI
	         * @see PIXI.ParticleContainer
	         * @throws {ReferenceError} SpriteBatch does not exist any more, please use the new ParticleContainer instead.
	         * @deprecated since version 3.0.0
	         */
	        SpriteBatch: {
	            get: function get() {
	                throw new ReferenceError('SpriteBatch does not exist any more, ' + 'please use the new ParticleContainer instead.');
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name AssetLoader
	         * @memberof PIXI
	         * @see PIXI.loaders.Loader
	         * @throws {ReferenceError} The loader system was overhauled in PixiJS v3,
	         * please see the new PIXI.loaders.Loader class.
	         * @deprecated since version 3.0.0
	         */
	        AssetLoader: {
	            get: function get() {
	                throw new ReferenceError('The loader system was overhauled in PixiJS v3, ' + 'please see the new PIXI.loaders.Loader class.');
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name Stage
	         * @memberof PIXI
	         * @see PIXI.Container
	         * @deprecated since version 3.0.0
	         */
	        Stage: {
	            get: function get() {
	                warn('You do not need to use a PIXI Stage any more, you can simply render any container.');
	
	                return core.Container;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name DisplayObjectContainer
	         * @memberof PIXI
	         * @see PIXI.Container
	         * @deprecated since version 3.0.0
	         */
	        DisplayObjectContainer: {
	            get: function get() {
	                warn('DisplayObjectContainer has been shortened to Container, please use Container from now on.');
	
	                return core.Container;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name Strip
	         * @memberof PIXI
	         * @see PIXI.mesh.Mesh
	         * @deprecated since version 3.0.0
	         */
	        Strip: {
	            get: function get() {
	                warn('The Strip class has been renamed to Mesh and moved to mesh.Mesh, please use mesh.Mesh from now on.');
	
	                return mesh.Mesh;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name Rope
	         * @memberof PIXI
	         * @see PIXI.mesh.Rope
	         * @deprecated since version 3.0.0
	         */
	        Rope: {
	            get: function get() {
	                warn('The Rope class has been moved to mesh.Rope, please use mesh.Rope from now on.');
	
	                return mesh.Rope;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name ParticleContainer
	         * @memberof PIXI
	         * @see PIXI.particles.ParticleContainer
	         * @deprecated since version 4.0.0
	         */
	        ParticleContainer: {
	            get: function get() {
	                warn('The ParticleContainer class has been moved to particles.ParticleContainer, ' + 'please use particles.ParticleContainer from now on.');
	
	                return particles.ParticleContainer;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name MovieClip
	         * @memberof PIXI
	         * @see PIXI.extras.MovieClip
	         * @deprecated since version 3.0.0
	         */
	        MovieClip: {
	            get: function get() {
	                warn('The MovieClip class has been moved to extras.AnimatedSprite, please use extras.AnimatedSprite.');
	
	                return extras.AnimatedSprite;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name TilingSprite
	         * @memberof PIXI
	         * @see PIXI.extras.TilingSprite
	         * @deprecated since version 3.0.0
	         */
	        TilingSprite: {
	            get: function get() {
	                warn('The TilingSprite class has been moved to extras.TilingSprite, ' + 'please use extras.TilingSprite from now on.');
	
	                return extras.TilingSprite;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name BitmapText
	         * @memberof PIXI
	         * @see PIXI.extras.BitmapText
	         * @deprecated since version 3.0.0
	         */
	        BitmapText: {
	            get: function get() {
	                warn('The BitmapText class has been moved to extras.BitmapText, ' + 'please use extras.BitmapText from now on.');
	
	                return extras.BitmapText;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name blendModes
	         * @memberof PIXI
	         * @see PIXI.BLEND_MODES
	         * @deprecated since version 3.0.0
	         */
	        blendModes: {
	            get: function get() {
	                warn('The blendModes has been moved to BLEND_MODES, please use BLEND_MODES from now on.');
	
	                return core.BLEND_MODES;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name scaleModes
	         * @memberof PIXI
	         * @see PIXI.SCALE_MODES
	         * @deprecated since version 3.0.0
	         */
	        scaleModes: {
	            get: function get() {
	                warn('The scaleModes has been moved to SCALE_MODES, please use SCALE_MODES from now on.');
	
	                return core.SCALE_MODES;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name BaseTextureCache
	         * @memberof PIXI
	         * @see PIXI.utils.BaseTextureCache
	         * @deprecated since version 3.0.0
	         */
	        BaseTextureCache: {
	            get: function get() {
	                warn('The BaseTextureCache class has been moved to utils.BaseTextureCache, ' + 'please use utils.BaseTextureCache from now on.');
	
	                return core.utils.BaseTextureCache;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name TextureCache
	         * @memberof PIXI
	         * @see PIXI.utils.TextureCache
	         * @deprecated since version 3.0.0
	         */
	        TextureCache: {
	            get: function get() {
	                warn('The TextureCache class has been moved to utils.TextureCache, ' + 'please use utils.TextureCache from now on.');
	
	                return core.utils.TextureCache;
	            }
	        },
	
	        /**
	         * @namespace
	         * @private
	         * @name math
	         * @memberof PIXI
	         * @see PIXI
	         * @deprecated since version 3.0.6
	         */
	        math: {
	            get: function get() {
	                warn('The math namespace is deprecated, please access members already accessible on PIXI.');
	
	                return core;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name PIXI.AbstractFilter
	         * @see PIXI.Filter
	         * @deprecated since version 3.0.6
	         */
	        AbstractFilter: {
	            get: function get() {
	                warn('AstractFilter has been renamed to Filter, please use PIXI.Filter');
	
	                return core.Filter;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name PIXI.TransformManual
	         * @see PIXI.TransformBase
	         * @deprecated since version 4.0.0
	         */
	        TransformManual: {
	            get: function get() {
	                warn('TransformManual has been renamed to TransformBase, please update your pixi-spine');
	
	                return core.TransformBase;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.TARGET_FPMS
	         * @see PIXI.settings.TARGET_FPMS
	         * @deprecated since version 4.2.0
	         */
	        TARGET_FPMS: {
	            get: function get() {
	                warn('PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS');
	
	                return core.settings.TARGET_FPMS;
	            },
	            set: function set(value) {
	                warn('PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS');
	
	                core.settings.TARGET_FPMS = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.FILTER_RESOLUTION
	         * @see PIXI.settings.FILTER_RESOLUTION
	         * @deprecated since version 4.2.0
	         */
	        FILTER_RESOLUTION: {
	            get: function get() {
	                warn('PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION');
	
	                return core.settings.FILTER_RESOLUTION;
	            },
	            set: function set(value) {
	                warn('PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION');
	
	                core.settings.FILTER_RESOLUTION = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.RESOLUTION
	         * @see PIXI.settings.RESOLUTION
	         * @deprecated since version 4.2.0
	         */
	        RESOLUTION: {
	            get: function get() {
	                warn('PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION');
	
	                return core.settings.RESOLUTION;
	            },
	            set: function set(value) {
	                warn('PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION');
	
	                core.settings.RESOLUTION = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.MIPMAP_TEXTURES
	         * @see PIXI.settings.MIPMAP_TEXTURES
	         * @deprecated since version 4.2.0
	         */
	        MIPMAP_TEXTURES: {
	            get: function get() {
	                warn('PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES');
	
	                return core.settings.MIPMAP_TEXTURES;
	            },
	            set: function set(value) {
	                warn('PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES');
	
	                core.settings.MIPMAP_TEXTURES = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.SPRITE_BATCH_SIZE
	         * @see PIXI.settings.SPRITE_BATCH_SIZE
	         * @deprecated since version 4.2.0
	         */
	        SPRITE_BATCH_SIZE: {
	            get: function get() {
	                warn('PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE');
	
	                return core.settings.SPRITE_BATCH_SIZE;
	            },
	            set: function set(value) {
	                warn('PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE');
	
	                core.settings.SPRITE_BATCH_SIZE = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.SPRITE_MAX_TEXTURES
	         * @see PIXI.settings.SPRITE_MAX_TEXTURES
	         * @deprecated since version 4.2.0
	         */
	        SPRITE_MAX_TEXTURES: {
	            get: function get() {
	                warn('PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES');
	
	                return core.settings.SPRITE_MAX_TEXTURES;
	            },
	            set: function set(value) {
	                warn('PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES');
	
	                core.settings.SPRITE_MAX_TEXTURES = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.RETINA_PREFIX
	         * @see PIXI.settings.RETINA_PREFIX
	         * @deprecated since version 4.2.0
	         */
	        RETINA_PREFIX: {
	            get: function get() {
	                warn('PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX');
	
	                return core.settings.RETINA_PREFIX;
	            },
	            set: function set(value) {
	                warn('PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX');
	
	                core.settings.RETINA_PREFIX = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.DEFAULT_RENDER_OPTIONS
	         * @see PIXI.settings.RENDER_OPTIONS
	         * @deprecated since version 4.2.0
	         */
	        DEFAULT_RENDER_OPTIONS: {
	            get: function get() {
	                warn('PIXI.DEFAULT_RENDER_OPTIONS has been deprecated, please use PIXI.settings.DEFAULT_RENDER_OPTIONS');
	
	                return core.settings.RENDER_OPTIONS;
	            }
	        }
	    });
	
	    // Move the default properties to settings
	    var defaults = [{ parent: 'TRANSFORM_MODE', target: 'TRANSFORM_MODE' }, { parent: 'GC_MODES', target: 'GC_MODE' }, { parent: 'WRAP_MODES', target: 'WRAP_MODE' }, { parent: 'SCALE_MODES', target: 'SCALE_MODE' }, { parent: 'PRECISION', target: 'PRECISION_FRAGMENT' }];
	
	    var _loop = function _loop(i) {
	        var deprecation = defaults[i];
	
	        Object.defineProperty(core[deprecation.parent], 'DEFAULT', {
	            get: function get() {
	                warn('PIXI.' + deprecation.parent + '.DEFAULT has been deprecated, ' + ('please use PIXI.settings.' + deprecation.target));
	
	                return core.settings[deprecation.target];
	            },
	            set: function set(value) {
	                warn('PIXI.' + deprecation.parent + '.DEFAULT has been deprecated, ' + ('please use PIXI.settings.' + deprecation.target));
	
	                core.settings[deprecation.target] = value;
	            }
	        });
	    };
	
	    for (var i = 0; i < defaults.length; i++) {
	        _loop(i);
	    }
	
	    Object.defineProperties(core.settings, {
	
	        /**
	         * @static
	         * @name PRECISION
	         * @memberof PIXI.settings
	         * @see PIXI.PRECISION
	         * @deprecated since version 4.4.0
	         */
	        PRECISION: {
	            get: function get() {
	                warn('PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT');
	
	                return core.settings.PRECISION_FRAGMENT;
	            },
	            set: function set(value) {
	                warn('PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT');
	
	                core.settings.PRECISION_FRAGMENT = value;
	            }
	        }
	    });
	
	    if (extras.AnimatedSprite) {
	        Object.defineProperties(extras, {
	
	            /**
	             * @class
	             * @name MovieClip
	             * @memberof PIXI.extras
	             * @see PIXI.extras.AnimatedSprite
	             * @deprecated since version 4.2.0
	             */
	            MovieClip: {
	                get: function get() {
	                    warn('The MovieClip class has been renamed to AnimatedSprite, please use AnimatedSprite from now on.');
	
	                    return extras.AnimatedSprite;
	                }
	            }
	        });
	    }
	
	    if (extras) {
	        Object.defineProperties(extras, {
	            /**
	             * @class
	             * @name TextureTransform
	             * @memberof PIXI.extras
	             * @see PIXI.TextureMatrix
	             * @deprecated since version 4.6.0
	             */
	            TextureTransform: {
	                get: function get() {
	                    warn('The TextureTransform class has been renamed to TextureMatrix, ' + 'please use PIXI.TextureMatrix from now on.');
	
	                    return core.TextureMatrix;
	                }
	            }
	        });
	    }
	
	    core.DisplayObject.prototype.generateTexture = function generateTexture(renderer, scaleMode, resolution) {
	        warn('generateTexture has moved to the renderer, please use renderer.generateTexture(displayObject)');
	
	        return renderer.generateTexture(this, scaleMode, resolution);
	    };
	
	    core.Graphics.prototype.generateTexture = function generateTexture(scaleMode, resolution) {
	        warn('graphics generate texture has moved to the renderer. ' + 'Or to render a graphics to a texture using canvas please use generateCanvasTexture');
	
	        return this.generateCanvasTexture(scaleMode, resolution);
	    };
	
	    /**
	     * @method
	     * @name PIXI.GroupD8.isSwapWidthHeight
	     * @see PIXI.GroupD8.isVertical
	     * @param {number} rotation - The number to check.
	     * @returns {boolean} Whether or not the direction is vertical
	     * @deprecated since version 4.6.0
	     */
	    core.GroupD8.isSwapWidthHeight = function isSwapWidthHeight(rotation) {
	        warn('GroupD8.isSwapWidthHeight was renamed to GroupD8.isVertical');
	
	        return core.GroupD8.isVertical(rotation);
	    };
	
	    core.RenderTexture.prototype.render = function render(displayObject, matrix, clear, updateTransform) {
	        this.legacyRenderer.render(displayObject, this, clear, matrix, !updateTransform);
	        warn('RenderTexture.render is now deprecated, please use renderer.render(displayObject, renderTexture)');
	    };
	
	    core.RenderTexture.prototype.getImage = function getImage(target) {
	        warn('RenderTexture.getImage is now deprecated, please use renderer.extract.image(target)');
	
	        return this.legacyRenderer.extract.image(target);
	    };
	
	    core.RenderTexture.prototype.getBase64 = function getBase64(target) {
	        warn('RenderTexture.getBase64 is now deprecated, please use renderer.extract.base64(target)');
	
	        return this.legacyRenderer.extract.base64(target);
	    };
	
	    core.RenderTexture.prototype.getCanvas = function getCanvas(target) {
	        warn('RenderTexture.getCanvas is now deprecated, please use renderer.extract.canvas(target)');
	
	        return this.legacyRenderer.extract.canvas(target);
	    };
	
	    core.RenderTexture.prototype.getPixels = function getPixels(target) {
	        warn('RenderTexture.getPixels is now deprecated, please use renderer.extract.pixels(target)');
	
	        return this.legacyRenderer.pixels(target);
	    };
	
	    /**
	     * @method
	     * @private
	     * @name PIXI.Sprite#setTexture
	     * @see PIXI.Sprite#texture
	     * @deprecated since version 3.0.0
	     * @param {PIXI.Texture} texture - The texture to set to.
	     */
	    core.Sprite.prototype.setTexture = function setTexture(texture) {
	        this.texture = texture;
	        warn('setTexture is now deprecated, please use the texture property, e.g : sprite.texture = texture;');
	    };
	
	    if (extras.BitmapText) {
	        /**
	         * @method
	         * @name PIXI.extras.BitmapText#setText
	         * @see PIXI.extras.BitmapText#text
	         * @deprecated since version 3.0.0
	         * @param {string} text - The text to set to.
	         */
	        extras.BitmapText.prototype.setText = function setText(text) {
	            this.text = text;
	            warn('setText is now deprecated, please use the text property, e.g : myBitmapText.text = \'my text\';');
	        };
	    }
	
	    /**
	     * @method
	     * @name PIXI.Text#setText
	     * @see PIXI.Text#text
	     * @deprecated since version 3.0.0
	     * @param {string} text - The text to set to.
	     */
	    core.Text.prototype.setText = function setText(text) {
	        this.text = text;
	        warn('setText is now deprecated, please use the text property, e.g : myText.text = \'my text\';');
	    };
	
	    /**
	     * Calculates the ascent, descent and fontSize of a given fontStyle
	     *
	     * @name PIXI.Text.calculateFontProperties
	     * @see PIXI.TextMetrics.measureFont
	     * @deprecated since version 4.5.0
	     * @param {string} font - String representing the style of the font
	     * @return {Object} Font properties object
	     */
	    core.Text.calculateFontProperties = function calculateFontProperties(font) {
	        warn('Text.calculateFontProperties is now deprecated, please use the TextMetrics.measureFont');
	
	        return core.TextMetrics.measureFont(font);
	    };
	
	    Object.defineProperties(core.Text, {
	        fontPropertiesCache: {
	            get: function get() {
	                warn('Text.fontPropertiesCache is deprecated');
	
	                return core.TextMetrics._fonts;
	            }
	        },
	        fontPropertiesCanvas: {
	            get: function get() {
	                warn('Text.fontPropertiesCanvas is deprecated');
	
	                return core.TextMetrics._canvas;
	            }
	        },
	        fontPropertiesContext: {
	            get: function get() {
	                warn('Text.fontPropertiesContext is deprecated');
	
	                return core.TextMetrics._context;
	            }
	        }
	    });
	
	    /**
	     * @method
	     * @name PIXI.Text#setStyle
	     * @see PIXI.Text#style
	     * @deprecated since version 3.0.0
	     * @param {*} style - The style to set to.
	     */
	    core.Text.prototype.setStyle = function setStyle(style) {
	        this.style = style;
	        warn('setStyle is now deprecated, please use the style property, e.g : myText.style = style;');
	    };
	
	    /**
	     * @method
	     * @name PIXI.Text#determineFontProperties
	     * @see PIXI.Text#measureFontProperties
	     * @deprecated since version 4.2.0
	     * @private
	     * @param {string} fontStyle - String representing the style of the font
	     * @return {Object} Font properties object
	     */
	    core.Text.prototype.determineFontProperties = function determineFontProperties(fontStyle) {
	        warn('determineFontProperties is now deprecated, please use TextMetrics.measureFont method');
	
	        return core.TextMetrics.measureFont(fontStyle);
	    };
	
	    /**
	     * @method
	     * @name PIXI.Text.getFontStyle
	     * @see PIXI.TextMetrics.getFontStyle
	     * @deprecated since version 4.5.0
	     * @param {PIXI.TextStyle} style - The style to use.
	     * @return {string} Font string
	     */
	    core.Text.getFontStyle = function getFontStyle(style) {
	        warn('getFontStyle is now deprecated, please use TextStyle.toFontString() instead');
	
	        style = style || {};
	
	        if (!(style instanceof core.TextStyle)) {
	            style = new core.TextStyle(style);
	        }
	
	        return style.toFontString();
	    };
	
	    Object.defineProperties(core.TextStyle.prototype, {
	        /**
	         * Set all properties of a font as a single string
	         *
	         * @name PIXI.TextStyle#font
	         * @deprecated since version 4.0.0
	         */
	        font: {
	            get: function get() {
	                warn('text style property \'font\' is now deprecated, please use the ' + '\'fontFamily\', \'fontSize\', \'fontStyle\', \'fontVariant\' and \'fontWeight\' properties from now on');
	
	                var fontSizeString = typeof this._fontSize === 'number' ? this._fontSize + 'px' : this._fontSize;
	
	                return this._fontStyle + ' ' + this._fontVariant + ' ' + this._fontWeight + ' ' + fontSizeString + ' ' + this._fontFamily;
	            },
	            set: function set(font) {
	                warn('text style property \'font\' is now deprecated, please use the ' + '\'fontFamily\',\'fontSize\',fontStyle\',\'fontVariant\' and \'fontWeight\' properties from now on');
	
	                // can work out fontStyle from search of whole string
	                if (font.indexOf('italic') > 1) {
	                    this._fontStyle = 'italic';
	                } else if (font.indexOf('oblique') > -1) {
	                    this._fontStyle = 'oblique';
	                } else {
	                    this._fontStyle = 'normal';
	                }
	
	                // can work out fontVariant from search of whole string
	                if (font.indexOf('small-caps') > -1) {
	                    this._fontVariant = 'small-caps';
	                } else {
	                    this._fontVariant = 'normal';
	                }
	
	                // fontWeight and fontFamily are tricker to find, but it's easier to find the fontSize due to it's units
	                var splits = font.split(' ');
	                var fontSizeIndex = -1;
	
	                this._fontSize = 26;
	                for (var i = 0; i < splits.length; ++i) {
	                    if (splits[i].match(/(px|pt|em|%)/)) {
	                        fontSizeIndex = i;
	                        this._fontSize = splits[i];
	                        break;
	                    }
	                }
	
	                // we can now search for fontWeight as we know it must occur before the fontSize
	                this._fontWeight = 'normal';
	                for (var _i = 0; _i < fontSizeIndex; ++_i) {
	                    if (splits[_i].match(/(bold|bolder|lighter|100|200|300|400|500|600|700|800|900)/)) {
	                        this._fontWeight = splits[_i];
	                        break;
	                    }
	                }
	
	                // and finally join everything together after the fontSize in case the font family has multiple words
	                if (fontSizeIndex > -1 && fontSizeIndex < splits.length - 1) {
	                    this._fontFamily = '';
	                    for (var _i2 = fontSizeIndex + 1; _i2 < splits.length; ++_i2) {
	                        this._fontFamily += splits[_i2] + ' ';
	                    }
	
	                    this._fontFamily = this._fontFamily.slice(0, -1);
	                } else {
	                    this._fontFamily = 'Arial';
	                }
	
	                this.styleID++;
	            }
	        }
	    });
	
	    /**
	     * @method
	     * @name PIXI.Texture#setFrame
	     * @see PIXI.Texture#setFrame
	     * @deprecated since version 3.0.0
	     * @param {PIXI.Rectangle} frame - The frame to set.
	     */
	    core.Texture.prototype.setFrame = function setFrame(frame) {
	        this.frame = frame;
	        warn('setFrame is now deprecated, please use the frame property, e.g: myTexture.frame = frame;');
	    };
	
	    /**
	     * @static
	     * @function
	     * @name PIXI.Texture.addTextureToCache
	     * @see PIXI.Texture.addToCache
	     * @deprecated since 4.5.0
	     * @param {PIXI.Texture} texture - The Texture to add to the cache.
	     * @param {string} id - The id that the texture will be stored against.
	     */
	    core.Texture.addTextureToCache = function addTextureToCache(texture, id) {
	        core.Texture.addToCache(texture, id);
	        warn('Texture.addTextureToCache is deprecated, please use Texture.addToCache from now on.');
	    };
	
	    /**
	     * @static
	     * @function
	     * @name PIXI.Texture.removeTextureFromCache
	     * @see PIXI.Texture.removeFromCache
	     * @deprecated since 4.5.0
	     * @param {string} id - The id of the texture to be removed
	     * @return {PIXI.Texture|null} The texture that was removed
	     */
	    core.Texture.removeTextureFromCache = function removeTextureFromCache(id) {
	        warn('Texture.removeTextureFromCache is deprecated, please use Texture.removeFromCache from now on. ' + 'Be aware that Texture.removeFromCache does not automatically its BaseTexture from the BaseTextureCache. ' + 'For that, use BaseTexture.removeFromCache');
	
	        core.BaseTexture.removeFromCache(id);
	
	        return core.Texture.removeFromCache(id);
	    };
	
	    Object.defineProperties(filters, {
	
	        /**
	         * @class
	         * @private
	         * @name PIXI.filters.AbstractFilter
	         * @see PIXI.AbstractFilter
	         * @deprecated since version 3.0.6
	         */
	        AbstractFilter: {
	            get: function get() {
	                warn('AstractFilter has been renamed to Filter, please use PIXI.Filter');
	
	                return core.AbstractFilter;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name PIXI.filters.SpriteMaskFilter
	         * @see PIXI.SpriteMaskFilter
	         * @deprecated since version 3.0.6
	         */
	        SpriteMaskFilter: {
	            get: function get() {
	                warn('filters.SpriteMaskFilter is an undocumented alias, please use SpriteMaskFilter from now on.');
	
	                return core.SpriteMaskFilter;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name PIXI.filters.VoidFilter
	         * @see PIXI.filters.AlphaFilter
	         * @deprecated since version 4.5.7
	         */
	        VoidFilter: {
	            get: function get() {
	                warn('VoidFilter has been renamed to AlphaFilter, please use PIXI.filters.AlphaFilter');
	
	                return filters.AlphaFilter;
	            }
	        }
	    });
	
	    /**
	     * @method
	     * @name PIXI.utils.uuid
	     * @see PIXI.utils.uid
	     * @deprecated since version 3.0.6
	     * @return {number} The uid
	     */
	    core.utils.uuid = function () {
	        warn('utils.uuid() is deprecated, please use utils.uid() from now on.');
	
	        return core.utils.uid();
	    };
	
	    /**
	     * @method
	     * @name PIXI.utils.canUseNewCanvasBlendModes
	     * @see PIXI.CanvasTinter
	     * @deprecated
	     * @return {boolean} Can use blend modes.
	     */
	    core.utils.canUseNewCanvasBlendModes = function () {
	        warn('utils.canUseNewCanvasBlendModes() is deprecated, please use CanvasTinter.canUseMultiply from now on');
	
	        return core.CanvasTinter.canUseMultiply;
	    };
	
	    var saidHello = true;
	
	    /**
	     * @name PIXI.utils._saidHello
	     * @type {boolean}
	     * @see PIXI.utils.skipHello
	     * @deprecated since 4.1.0
	     */
	    Object.defineProperty(core.utils, '_saidHello', {
	        set: function set(bool) {
	            if (bool) {
	                warn('PIXI.utils._saidHello is deprecated, please use PIXI.utils.skipHello()');
	                this.skipHello();
	            }
	            saidHello = bool;
	        },
	        get: function get() {
	            return saidHello;
	        }
	    });
	
	    if (prepare.BasePrepare) {
	        /**
	         * @method
	         * @name PIXI.prepare.BasePrepare#register
	         * @see PIXI.prepare.BasePrepare#registerFindHook
	         * @deprecated since version 4.4.2
	         * @param {Function} [addHook] - Function call that takes two parameters: `item:*, queue:Array`
	         *        function must return `true` if it was able to add item to the queue.
	         * @param {Function} [uploadHook] - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
	         *        function must return `true` if it was able to handle upload of item.
	         * @return {PIXI.BasePrepare} Instance of plugin for chaining.
	         */
	        prepare.BasePrepare.prototype.register = function register(addHook, uploadHook) {
	            warn('renderer.plugins.prepare.register is now deprecated, ' + 'please use renderer.plugins.prepare.registerFindHook & renderer.plugins.prepare.registerUploadHook');
	
	            if (addHook) {
	                this.registerFindHook(addHook);
	            }
	
	            if (uploadHook) {
	                this.registerUploadHook(uploadHook);
	            }
	
	            return this;
	        };
	    }
	
	    if (prepare.canvas) {
	        /**
	         * The number of graphics or textures to upload to the GPU.
	         *
	         * @name PIXI.prepare.canvas.UPLOADS_PER_FRAME
	         * @static
	         * @type {number}
	         * @see PIXI.prepare.BasePrepare.limiter
	         * @deprecated since 4.2.0
	         */
	        Object.defineProperty(prepare.canvas, 'UPLOADS_PER_FRAME', {
	            set: function set() {
	                warn('PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please set ' + 'renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer');
	                // because we don't have a reference to the renderer, we can't actually set
	                // the uploads per frame, so we'll have to stick with the warning.
	            },
	            get: function get() {
	                warn('PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please use ' + 'renderer.plugins.prepare.limiter');
	
	                return NaN;
	            }
	        });
	    }
	
	    if (prepare.webgl) {
	        /**
	         * The number of graphics or textures to upload to the GPU.
	         *
	         * @name PIXI.prepare.webgl.UPLOADS_PER_FRAME
	         * @static
	         * @type {number}
	         * @see PIXI.prepare.BasePrepare.limiter
	         * @deprecated since 4.2.0
	         */
	        Object.defineProperty(prepare.webgl, 'UPLOADS_PER_FRAME', {
	            set: function set() {
	                warn('PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please set ' + 'renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer');
	                // because we don't have a reference to the renderer, we can't actually set
	                // the uploads per frame, so we'll have to stick with the warning.
	            },
	            get: function get() {
	                warn('PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please use ' + 'renderer.plugins.prepare.limiter');
	
	                return NaN;
	            }
	        });
	    }
	
	    if (loaders.Loader) {
	        var Resource = loaders.Resource;
	        var Loader = loaders.Loader;
	
	        Object.defineProperties(Resource.prototype, {
	            isJson: {
	                get: function get() {
	                    warn('The isJson property is deprecated, please use `resource.type === Resource.TYPE.JSON`.');
	
	                    return this.type === Resource.TYPE.JSON;
	                }
	            },
	            isXml: {
	                get: function get() {
	                    warn('The isXml property is deprecated, please use `resource.type === Resource.TYPE.XML`.');
	
	                    return this.type === Resource.TYPE.XML;
	                }
	            },
	            isImage: {
	                get: function get() {
	                    warn('The isImage property is deprecated, please use `resource.type === Resource.TYPE.IMAGE`.');
	
	                    return this.type === Resource.TYPE.IMAGE;
	                }
	            },
	            isAudio: {
	                get: function get() {
	                    warn('The isAudio property is deprecated, please use `resource.type === Resource.TYPE.AUDIO`.');
	
	                    return this.type === Resource.TYPE.AUDIO;
	                }
	            },
	            isVideo: {
	                get: function get() {
	                    warn('The isVideo property is deprecated, please use `resource.type === Resource.TYPE.VIDEO`.');
	
	                    return this.type === Resource.TYPE.VIDEO;
	                }
	            }
	        });
	
	        Object.defineProperties(Loader.prototype, {
	            before: {
	                get: function get() {
	                    warn('The before() method is deprecated, please use pre().');
	
	                    return this.pre;
	                }
	            },
	            after: {
	                get: function get() {
	                    warn('The after() method is deprecated, please use use().');
	
	                    return this.use;
	                }
	            }
	        });
	    }
	
	    if (interaction.interactiveTarget) {
	        /**
	         * @name PIXI.interaction.interactiveTarget#defaultCursor
	         * @static
	         * @type {number}
	         * @see PIXI.interaction.interactiveTarget#cursor
	         * @deprecated since 4.3.0
	         */
	        Object.defineProperty(interaction.interactiveTarget, 'defaultCursor', {
	            set: function set(value) {
	                warn('Property defaultCursor has been replaced with \'cursor\'. ');
	                this.cursor = value;
	            },
	            get: function get() {
	                warn('Property defaultCursor has been replaced with \'cursor\'. ');
	
	                return this.cursor;
	            }
	        });
	    }
	
	    if (interaction.InteractionManager) {
	        /**
	         * @name PIXI.interaction.InteractionManager#defaultCursorStyle
	         * @static
	         * @type {string}
	         * @see PIXI.interaction.InteractionManager#cursorStyles
	         * @deprecated since 4.3.0
	         */
	        Object.defineProperty(interaction.InteractionManager, 'defaultCursorStyle', {
	            set: function set(value) {
	                warn('Property defaultCursorStyle has been replaced with \'cursorStyles.default\'. ');
	                this.cursorStyles.default = value;
	            },
	            get: function get() {
	                warn('Property defaultCursorStyle has been replaced with \'cursorStyles.default\'. ');
	
	                return this.cursorStyles.default;
	            }
	        });
	
	        /**
	         * @name PIXI.interaction.InteractionManager#currentCursorStyle
	         * @static
	         * @type {string}
	         * @see PIXI.interaction.InteractionManager#cursorStyles
	         * @deprecated since 4.3.0
	         */
	        Object.defineProperty(interaction.InteractionManager, 'currentCursorStyle', {
	            set: function set(value) {
	                warn('Property currentCursorStyle has been removed.' + 'See the currentCursorMode property, which works differently.');
	                this.currentCursorMode = value;
	            },
	            get: function get() {
	                warn('Property currentCursorStyle has been removed.' + 'See the currentCursorMode property, which works differently.');
	
	                return this.currentCursorMode;
	            }
	        });
	    }
	}
	//# sourceMappingURL=deprecation.js.map

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _accessibleTarget = __webpack_require__(324);
	
	Object.defineProperty(exports, 'accessibleTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_accessibleTarget).default;
	  }
	});
	
	var _AccessibilityManager = __webpack_require__(325);
	
	Object.defineProperty(exports, 'AccessibilityManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccessibilityManager).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 * Default property values of accessible objects
	 * used by {@link PIXI.accessibility.AccessibilityManager}.
	 *
	 * @function accessibleTarget
	 * @memberof PIXI.accessibility
	 * @example
	 *      function MyObject() {}
	 *
	 *      Object.assign(
	 *          MyObject.prototype,
	 *          PIXI.accessibility.accessibleTarget
	 *      );
	 */
	exports.default = {
	  /**
	   *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
	   *   shadow div with attributes set
	   *
	   * @member {boolean}
	   */
	  accessible: false,
	
	  /**
	   * Sets the title attribute of the shadow div
	   * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
	   *
	   * @member {string}
	   */
	  accessibleTitle: null,
	
	  /**
	   * Sets the aria-label attribute of the shadow div
	   *
	   * @member {string}
	   */
	  accessibleHint: null,
	
	  /**
	   * @todo Needs docs.
	   */
	  tabIndex: 0,
	
	  /**
	   * @todo Needs docs.
	   */
	  _accessibleActive: false,
	
	  /**
	   * @todo Needs docs.
	   */
	  _accessibleDiv: false
	};
	//# sourceMappingURL=accessibleTarget.js.map

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _ismobilejs = __webpack_require__(238);
	
	var _ismobilejs2 = _interopRequireDefault(_ismobilejs);
	
	var _accessibleTarget = __webpack_require__(324);
	
	var _accessibleTarget2 = _interopRequireDefault(_accessibleTarget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// add some extra variables to the container..
	core.utils.mixins.delayMixin(core.DisplayObject.prototype, _accessibleTarget2.default);
	
	var KEY_CODE_TAB = 9;
	
	var DIV_TOUCH_SIZE = 100;
	var DIV_TOUCH_POS_X = 0;
	var DIV_TOUCH_POS_Y = 0;
	var DIV_TOUCH_ZINDEX = 2;
	
	var DIV_HOOK_SIZE = 1;
	var DIV_HOOK_POS_X = -1000;
	var DIV_HOOK_POS_Y = -1000;
	var DIV_HOOK_ZINDEX = 2;
	
	/**
	 * The Accessibility manager recreates the ability to tab and have content read by screen
	 * readers. This is very important as it can possibly help people with disabilities access pixi
	 * content.
	 *
	 * Much like interaction any DisplayObject can be made accessible. This manager will map the
	 * events as if the mouse was being used, minimizing the effort required to implement.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.accessibility
	 *
	 * @class
	 * @memberof PIXI.accessibility
	 */
	
	var AccessibilityManager = function () {
	    /**
	     * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     */
	    function AccessibilityManager(renderer) {
	        _classCallCheck(this, AccessibilityManager);
	
	        if ((_ismobilejs2.default.tablet || _ismobilejs2.default.phone) && !navigator.isCocoonJS) {
	            this.createTouchHook();
	        }
	
	        // first we create a div that will sit over the PixiJS element. This is where the div overlays will go.
	        var div = document.createElement('div');
	
	        div.style.width = DIV_TOUCH_SIZE + 'px';
	        div.style.height = DIV_TOUCH_SIZE + 'px';
	        div.style.position = 'absolute';
	        div.style.top = DIV_TOUCH_POS_X + 'px';
	        div.style.left = DIV_TOUCH_POS_Y + 'px';
	        div.style.zIndex = DIV_TOUCH_ZINDEX;
	
	        /**
	         * This is the dom element that will sit over the PixiJS element. This is where the div overlays will go.
	         *
	         * @type {HTMLElement}
	         * @private
	         */
	        this.div = div;
	
	        /**
	         * A simple pool for storing divs.
	         *
	         * @type {*}
	         * @private
	         */
	        this.pool = [];
	
	        /**
	         * This is a tick used to check if an object is no longer being rendered.
	         *
	         * @type {Number}
	         * @private
	         */
	        this.renderId = 0;
	
	        /**
	         * Setting this to true will visually show the divs.
	         *
	         * @type {boolean}
	         */
	        this.debug = false;
	
	        /**
	         * The renderer this accessibility manager works for.
	         *
	         * @member {PIXI.SystemRenderer}
	         */
	        this.renderer = renderer;
	
	        /**
	         * The array of currently active accessible items.
	         *
	         * @member {Array<*>}
	         * @private
	         */
	        this.children = [];
	
	        /**
	         * pre-bind the functions
	         *
	         * @private
	         */
	        this._onKeyDown = this._onKeyDown.bind(this);
	        this._onMouseMove = this._onMouseMove.bind(this);
	
	        /**
	         * stores the state of the manager. If there are no accessible objects or the mouse is moving, this will be false.
	         *
	         * @member {Array<*>}
	         * @private
	         */
	        this.isActive = false;
	        this.isMobileAccessabillity = false;
	
	        // let listen for tab.. once pressed we can fire up and show the accessibility layer
	        window.addEventListener('keydown', this._onKeyDown, false);
	    }
	
	    /**
	     * Creates the touch hooks.
	     *
	     */
	
	
	    AccessibilityManager.prototype.createTouchHook = function createTouchHook() {
	        var _this = this;
	
	        var hookDiv = document.createElement('button');
	
	        hookDiv.style.width = DIV_HOOK_SIZE + 'px';
	        hookDiv.style.height = DIV_HOOK_SIZE + 'px';
	        hookDiv.style.position = 'absolute';
	        hookDiv.style.top = DIV_HOOK_POS_X + 'px';
	        hookDiv.style.left = DIV_HOOK_POS_Y + 'px';
	        hookDiv.style.zIndex = DIV_HOOK_ZINDEX;
	        hookDiv.style.backgroundColor = '#FF0000';
	        hookDiv.title = 'HOOK DIV';
	
	        hookDiv.addEventListener('focus', function () {
	            _this.isMobileAccessabillity = true;
	            _this.activate();
	            document.body.removeChild(hookDiv);
	        });
	
	        document.body.appendChild(hookDiv);
	    };
	
	    /**
	     * Activating will cause the Accessibility layer to be shown. This is called when a user
	     * preses the tab key.
	     *
	     * @private
	     */
	
	
	    AccessibilityManager.prototype.activate = function activate() {
	        if (this.isActive) {
	            return;
	        }
	
	        this.isActive = true;
	
	        window.document.addEventListener('mousemove', this._onMouseMove, true);
	        window.removeEventListener('keydown', this._onKeyDown, false);
	
	        this.renderer.on('postrender', this.update, this);
	
	        if (this.renderer.view.parentNode) {
	            this.renderer.view.parentNode.appendChild(this.div);
	        }
	    };
	
	    /**
	     * Deactivating will cause the Accessibility layer to be hidden. This is called when a user moves
	     * the mouse.
	     *
	     * @private
	     */
	
	
	    AccessibilityManager.prototype.deactivate = function deactivate() {
	        if (!this.isActive || this.isMobileAccessabillity) {
	            return;
	        }
	
	        this.isActive = false;
	
	        window.document.removeEventListener('mousemove', this._onMouseMove);
	        window.addEventListener('keydown', this._onKeyDown, false);
	
	        this.renderer.off('postrender', this.update);
	
	        if (this.div.parentNode) {
	            this.div.parentNode.removeChild(this.div);
	        }
	    };
	
	    /**
	     * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
	     *
	     * @private
	     * @param {PIXI.Container} displayObject - The DisplayObject to check.
	     */
	
	
	    AccessibilityManager.prototype.updateAccessibleObjects = function updateAccessibleObjects(displayObject) {
	        if (!displayObject.visible) {
	            return;
	        }
	
	        if (displayObject.accessible && displayObject.interactive) {
	            if (!displayObject._accessibleActive) {
	                this.addChild(displayObject);
	            }
	
	            displayObject.renderId = this.renderId;
	        }
	
	        var children = displayObject.children;
	
	        for (var i = 0; i < children.length; i++) {
	            this.updateAccessibleObjects(children[i]);
	        }
	    };
	
	    /**
	     * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
	     *
	     * @private
	     */
	
	
	    AccessibilityManager.prototype.update = function update() {
	        if (!this.renderer.renderingToScreen) {
	            return;
	        }
	
	        // update children...
	        this.updateAccessibleObjects(this.renderer._lastObjectRendered);
	
	        var rect = this.renderer.view.getBoundingClientRect();
	        var sx = rect.width / this.renderer.width;
	        var sy = rect.height / this.renderer.height;
	
	        var div = this.div;
	
	        div.style.left = rect.left + 'px';
	        div.style.top = rect.top + 'px';
	        div.style.width = this.renderer.width + 'px';
	        div.style.height = this.renderer.height + 'px';
	
	        for (var i = 0; i < this.children.length; i++) {
	            var child = this.children[i];
	
	            if (child.renderId !== this.renderId) {
	                child._accessibleActive = false;
	
	                core.utils.removeItems(this.children, i, 1);
	                this.div.removeChild(child._accessibleDiv);
	                this.pool.push(child._accessibleDiv);
	                child._accessibleDiv = null;
	
	                i--;
	
	                if (this.children.length === 0) {
	                    this.deactivate();
	                }
	            } else {
	                // map div to display..
	                div = child._accessibleDiv;
	                var hitArea = child.hitArea;
	                var wt = child.worldTransform;
	
	                if (child.hitArea) {
	                    div.style.left = (wt.tx + hitArea.x * wt.a) * sx + 'px';
	                    div.style.top = (wt.ty + hitArea.y * wt.d) * sy + 'px';
	
	                    div.style.width = hitArea.width * wt.a * sx + 'px';
	                    div.style.height = hitArea.height * wt.d * sy + 'px';
	                } else {
	                    hitArea = child.getBounds();
	
	                    this.capHitArea(hitArea);
	
	                    div.style.left = hitArea.x * sx + 'px';
	                    div.style.top = hitArea.y * sy + 'px';
	
	                    div.style.width = hitArea.width * sx + 'px';
	                    div.style.height = hitArea.height * sy + 'px';
	
	                    // update button titles and hints if they exist and they've changed
	                    if (div.title !== child.accessibleTitle && child.accessibleTitle !== null) {
	                        div.title = child.accessibleTitle;
	                    }
	                    if (div.getAttribute('aria-label') !== child.accessibleHint && child.accessibleHint !== null) {
	                        div.setAttribute('aria-label', child.accessibleHint);
	                    }
	                }
	            }
	        }
	
	        // increment the render id..
	        this.renderId++;
	    };
	
	    /**
	     * TODO: docs.
	     *
	     * @param {Rectangle} hitArea - TODO docs
	     */
	
	
	    AccessibilityManager.prototype.capHitArea = function capHitArea(hitArea) {
	        if (hitArea.x < 0) {
	            hitArea.width += hitArea.x;
	            hitArea.x = 0;
	        }
	
	        if (hitArea.y < 0) {
	            hitArea.height += hitArea.y;
	            hitArea.y = 0;
	        }
	
	        if (hitArea.x + hitArea.width > this.renderer.width) {
	            hitArea.width = this.renderer.width - hitArea.x;
	        }
	
	        if (hitArea.y + hitArea.height > this.renderer.height) {
	            hitArea.height = this.renderer.height - hitArea.y;
	        }
	    };
	
	    /**
	     * Adds a DisplayObject to the accessibility manager
	     *
	     * @private
	     * @param {DisplayObject} displayObject - The child to make accessible.
	     */
	
	
	    AccessibilityManager.prototype.addChild = function addChild(displayObject) {
	        //    this.activate();
	
	        var div = this.pool.pop();
	
	        if (!div) {
	            div = document.createElement('button');
	
	            div.style.width = DIV_TOUCH_SIZE + 'px';
	            div.style.height = DIV_TOUCH_SIZE + 'px';
	            div.style.backgroundColor = this.debug ? 'rgba(255,0,0,0.5)' : 'transparent';
	            div.style.position = 'absolute';
	            div.style.zIndex = DIV_TOUCH_ZINDEX;
	            div.style.borderStyle = 'none';
	
	            // ARIA attributes ensure that button title and hint updates are announced properly
	            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
	                // Chrome doesn't need aria-live to work as intended; in fact it just gets more confused.
	                div.setAttribute('aria-live', 'off');
	            } else {
	                div.setAttribute('aria-live', 'polite');
	            }
	
	            if (navigator.userAgent.match(/rv:.*Gecko\//)) {
	                // FireFox needs this to announce only the new button name
	                div.setAttribute('aria-relevant', 'additions');
	            } else {
	                // required by IE, other browsers don't much care
	                div.setAttribute('aria-relevant', 'text');
	            }
	
	            div.addEventListener('click', this._onClick.bind(this));
	            div.addEventListener('focus', this._onFocus.bind(this));
	            div.addEventListener('focusout', this._onFocusOut.bind(this));
	        }
	
	        if (displayObject.accessibleTitle && displayObject.accessibleTitle !== null) {
	            div.title = displayObject.accessibleTitle;
	        } else if (!displayObject.accessibleHint || displayObject.accessibleHint === null) {
	            div.title = 'displayObject ' + displayObject.tabIndex;
	        }
	
	        if (displayObject.accessibleHint && displayObject.accessibleHint !== null) {
	            div.setAttribute('aria-label', displayObject.accessibleHint);
	        }
	
	        //
	
	        displayObject._accessibleActive = true;
	        displayObject._accessibleDiv = div;
	        div.displayObject = displayObject;
	
	        this.children.push(displayObject);
	        this.div.appendChild(displayObject._accessibleDiv);
	        displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
	    };
	
	    /**
	     * Maps the div button press to pixi's InteractionManager (click)
	     *
	     * @private
	     * @param {MouseEvent} e - The click event.
	     */
	
	
	    AccessibilityManager.prototype._onClick = function _onClick(e) {
	        var interactionManager = this.renderer.plugins.interaction;
	
	        interactionManager.dispatchEvent(e.target.displayObject, 'click', interactionManager.eventData);
	    };
	
	    /**
	     * Maps the div focus events to pixi's InteractionManager (mouseover)
	     *
	     * @private
	     * @param {FocusEvent} e - The focus event.
	     */
	
	
	    AccessibilityManager.prototype._onFocus = function _onFocus(e) {
	        if (!e.target.getAttribute('aria-live', 'off')) {
	            e.target.setAttribute('aria-live', 'assertive');
	        }
	        var interactionManager = this.renderer.plugins.interaction;
	
	        interactionManager.dispatchEvent(e.target.displayObject, 'mouseover', interactionManager.eventData);
	    };
	
	    /**
	     * Maps the div focus events to pixi's InteractionManager (mouseout)
	     *
	     * @private
	     * @param {FocusEvent} e - The focusout event.
	     */
	
	
	    AccessibilityManager.prototype._onFocusOut = function _onFocusOut(e) {
	        if (!e.target.getAttribute('aria-live', 'off')) {
	            e.target.setAttribute('aria-live', 'polite');
	        }
	        var interactionManager = this.renderer.plugins.interaction;
	
	        interactionManager.dispatchEvent(e.target.displayObject, 'mouseout', interactionManager.eventData);
	    };
	
	    /**
	     * Is called when a key is pressed
	     *
	     * @private
	     * @param {KeyboardEvent} e - The keydown event.
	     */
	
	
	    AccessibilityManager.prototype._onKeyDown = function _onKeyDown(e) {
	        if (e.keyCode !== KEY_CODE_TAB) {
	            return;
	        }
	
	        this.activate();
	    };
	
	    /**
	     * Is called when the mouse moves across the renderer element
	     *
	     * @private
	     * @param {MouseEvent} e - The mouse event.
	     */
	
	
	    AccessibilityManager.prototype._onMouseMove = function _onMouseMove(e) {
	        if (e.movementX === 0 && e.movementY === 0) {
	            return;
	        }
	
	        this.deactivate();
	    };
	
	    /**
	     * Destroys the accessibility manager
	     *
	     */
	
	
	    AccessibilityManager.prototype.destroy = function destroy() {
	        this.div = null;
	
	        for (var i = 0; i < this.children.length; i++) {
	            this.children[i].div = null;
	        }
	
	        window.document.removeEventListener('mousemove', this._onMouseMove);
	        window.removeEventListener('keydown', this._onKeyDown);
	
	        this.pool = null;
	        this.children = null;
	        this.renderer = null;
	    };
	
	    return AccessibilityManager;
	}();
	
	exports.default = AccessibilityManager;
	
	
	core.WebGLRenderer.registerPlugin('accessibility', AccessibilityManager);
	core.CanvasRenderer.registerPlugin('accessibility', AccessibilityManager);
	//# sourceMappingURL=AccessibilityManager.js.map

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebGLExtract = __webpack_require__(327);
	
	Object.defineProperty(exports, 'webgl', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebGLExtract).default;
	  }
	});
	
	var _CanvasExtract = __webpack_require__(328);
	
	Object.defineProperty(exports, 'canvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasExtract).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TEMP_RECT = new core.Rectangle();
	var BYTES_PER_PIXEL = 4;
	
	/**
	 * The extract manager provides functionality to export content from the renderers.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.extract
	 *
	 * @class
	 * @memberof PIXI.extract
	 */
	
	var WebGLExtract = function () {
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     */
	    function WebGLExtract(renderer) {
	        _classCallCheck(this, WebGLExtract);
	
	        this.renderer = renderer;
	        /**
	         * Collection of methods for extracting data (image, pixels, etc.) from a display object or render texture
	         *
	         * @member {PIXI.extract.WebGLExtract} extract
	         * @memberof PIXI.WebGLRenderer#
	         * @see PIXI.extract.WebGLExtract
	         */
	        renderer.extract = this;
	    }
	
	    /**
	     * Will return a HTML Image of the target
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {HTMLImageElement} HTML Image of the target
	     */
	
	
	    WebGLExtract.prototype.image = function image(target) {
	        var image = new Image();
	
	        image.src = this.base64(target);
	
	        return image;
	    };
	
	    /**
	     * Will return a a base64 encoded string of this target. It works by calling
	     *  `WebGLExtract.getCanvas` and then running toDataURL on that.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {string} A base64 encoded string of the texture.
	     */
	
	
	    WebGLExtract.prototype.base64 = function base64(target) {
	        return this.canvas(target).toDataURL();
	    };
	
	    /**
	     * Creates a Canvas element, renders this target to it and then returns it.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
	     */
	
	
	    WebGLExtract.prototype.canvas = function canvas(target) {
	        var renderer = this.renderer;
	        var textureBuffer = void 0;
	        var resolution = void 0;
	        var frame = void 0;
	        var flipY = false;
	        var renderTexture = void 0;
	        var generated = false;
	
	        if (target) {
	            if (target instanceof core.RenderTexture) {
	                renderTexture = target;
	            } else {
	                renderTexture = this.renderer.generateTexture(target);
	                generated = true;
	            }
	        }
	
	        if (renderTexture) {
	            textureBuffer = renderTexture.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID];
	            resolution = textureBuffer.resolution;
	            frame = renderTexture.frame;
	            flipY = false;
	        } else {
	            textureBuffer = this.renderer.rootRenderTarget;
	            resolution = textureBuffer.resolution;
	            flipY = true;
	
	            frame = TEMP_RECT;
	            frame.width = textureBuffer.size.width;
	            frame.height = textureBuffer.size.height;
	        }
	
	        var width = frame.width * resolution;
	        var height = frame.height * resolution;
	
	        var canvasBuffer = new core.CanvasRenderTarget(width, height);
	
	        if (textureBuffer) {
	            // bind the buffer
	            renderer.bindRenderTarget(textureBuffer);
	
	            // set up an array of pixels
	            var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);
	
	            // read pixels to the array
	            var gl = renderer.gl;
	
	            gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
	
	            // add the pixels to the canvas
	            var canvasData = canvasBuffer.context.getImageData(0, 0, width, height);
	
	            canvasData.data.set(webglPixels);
	
	            canvasBuffer.context.putImageData(canvasData, 0, 0);
	
	            // pulling pixels
	            if (flipY) {
	                canvasBuffer.context.scale(1, -1);
	                canvasBuffer.context.drawImage(canvasBuffer.canvas, 0, -height);
	            }
	        }
	
	        if (generated) {
	            renderTexture.destroy(true);
	        }
	        // send the canvas back..
	
	        return canvasBuffer.canvas;
	    };
	
	    /**
	     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
	     * order, with integer values between 0 and 255 (included).
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {Uint8ClampedArray} One-dimensional array containing the pixel data of the entire texture
	     */
	
	
	    WebGLExtract.prototype.pixels = function pixels(target) {
	        var renderer = this.renderer;
	        var textureBuffer = void 0;
	        var resolution = void 0;
	        var frame = void 0;
	        var renderTexture = void 0;
	        var generated = false;
	
	        if (target) {
	            if (target instanceof core.RenderTexture) {
	                renderTexture = target;
	            } else {
	                renderTexture = this.renderer.generateTexture(target);
	                generated = true;
	            }
	        }
	
	        if (renderTexture) {
	            textureBuffer = renderTexture.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID];
	            resolution = textureBuffer.resolution;
	            frame = renderTexture.frame;
	        } else {
	            textureBuffer = this.renderer.rootRenderTarget;
	            resolution = textureBuffer.resolution;
	
	            frame = TEMP_RECT;
	            frame.width = textureBuffer.size.width;
	            frame.height = textureBuffer.size.height;
	        }
	
	        var width = frame.width * resolution;
	        var height = frame.height * resolution;
	
	        var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);
	
	        if (textureBuffer) {
	            // bind the buffer
	            renderer.bindRenderTarget(textureBuffer);
	            // read pixels to the array
	            var gl = renderer.gl;
	
	            gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
	        }
	
	        if (generated) {
	            renderTexture.destroy(true);
	        }
	
	        return webglPixels;
	    };
	
	    /**
	     * Destroys the extract
	     *
	     */
	
	
	    WebGLExtract.prototype.destroy = function destroy() {
	        this.renderer.extract = null;
	        this.renderer = null;
	    };
	
	    return WebGLExtract;
	}();
	
	exports.default = WebGLExtract;
	
	
	core.WebGLRenderer.registerPlugin('extract', WebGLExtract);
	//# sourceMappingURL=WebGLExtract.js.map

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TEMP_RECT = new core.Rectangle();
	
	/**
	 * The extract manager provides functionality to export content from the renderers.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.extract
	 *
	 * @class
	 * @memberof PIXI.extract
	 */
	
	var CanvasExtract = function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
	     */
	    function CanvasExtract(renderer) {
	        _classCallCheck(this, CanvasExtract);
	
	        this.renderer = renderer;
	        /**
	         * Collection of methods for extracting data (image, pixels, etc.) from a display object or render texture
	         *
	         * @member {PIXI.extract.CanvasExtract} extract
	         * @memberof PIXI.CanvasRenderer#
	         * @see PIXI.extract.CanvasExtract
	         */
	        renderer.extract = this;
	    }
	
	    /**
	     * Will return a HTML Image of the target
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {HTMLImageElement} HTML Image of the target
	     */
	
	
	    CanvasExtract.prototype.image = function image(target) {
	        var image = new Image();
	
	        image.src = this.base64(target);
	
	        return image;
	    };
	
	    /**
	     * Will return a a base64 encoded string of this target. It works by calling
	     *  `CanvasExtract.getCanvas` and then running toDataURL on that.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {string} A base64 encoded string of the texture.
	     */
	
	
	    CanvasExtract.prototype.base64 = function base64(target) {
	        return this.canvas(target).toDataURL();
	    };
	
	    /**
	     * Creates a Canvas element, renders this target to it and then returns it.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
	     */
	
	
	    CanvasExtract.prototype.canvas = function canvas(target) {
	        var renderer = this.renderer;
	        var context = void 0;
	        var resolution = void 0;
	        var frame = void 0;
	        var renderTexture = void 0;
	
	        if (target) {
	            if (target instanceof core.RenderTexture) {
	                renderTexture = target;
	            } else {
	                renderTexture = renderer.generateTexture(target);
	            }
	        }
	
	        if (renderTexture) {
	            context = renderTexture.baseTexture._canvasRenderTarget.context;
	            resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
	            frame = renderTexture.frame;
	        } else {
	            context = renderer.rootContext;
	
	            frame = TEMP_RECT;
	            frame.width = this.renderer.width;
	            frame.height = this.renderer.height;
	        }
	
	        var width = frame.width * resolution;
	        var height = frame.height * resolution;
	
	        var canvasBuffer = new core.CanvasRenderTarget(width, height);
	        var canvasData = context.getImageData(frame.x * resolution, frame.y * resolution, width, height);
	
	        canvasBuffer.context.putImageData(canvasData, 0, 0);
	
	        // send the canvas back..
	        return canvasBuffer.canvas;
	    };
	
	    /**
	     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
	     * order, with integer values between 0 and 255 (included).
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {Uint8ClampedArray} One-dimensional array containing the pixel data of the entire texture
	     */
	
	
	    CanvasExtract.prototype.pixels = function pixels(target) {
	        var renderer = this.renderer;
	        var context = void 0;
	        var resolution = void 0;
	        var frame = void 0;
	        var renderTexture = void 0;
	
	        if (target) {
	            if (target instanceof core.RenderTexture) {
	                renderTexture = target;
	            } else {
	                renderTexture = renderer.generateTexture(target);
	            }
	        }
	
	        if (renderTexture) {
	            context = renderTexture.baseTexture._canvasRenderTarget.context;
	            resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
	            frame = renderTexture.frame;
	        } else {
	            context = renderer.rootContext;
	
	            frame = TEMP_RECT;
	            frame.width = renderer.width;
	            frame.height = renderer.height;
	        }
	
	        return context.getImageData(0, 0, frame.width * resolution, frame.height * resolution).data;
	    };
	
	    /**
	     * Destroys the extract
	     *
	     */
	
	
	    CanvasExtract.prototype.destroy = function destroy() {
	        this.renderer.extract = null;
	        this.renderer = null;
	    };
	
	    return CanvasExtract;
	}();
	
	exports.default = CanvasExtract;
	
	
	core.CanvasRenderer.registerPlugin('extract', CanvasExtract);
	//# sourceMappingURL=CanvasExtract.js.map

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BitmapText = exports.TilingSpriteRenderer = exports.TilingSprite = exports.AnimatedSprite = undefined;
	
	var _AnimatedSprite = __webpack_require__(330);
	
	Object.defineProperty(exports, 'AnimatedSprite', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AnimatedSprite).default;
	  }
	});
	
	var _TilingSprite = __webpack_require__(331);
	
	Object.defineProperty(exports, 'TilingSprite', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TilingSprite).default;
	  }
	});
	
	var _TilingSpriteRenderer = __webpack_require__(332);
	
	Object.defineProperty(exports, 'TilingSpriteRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TilingSpriteRenderer).default;
	  }
	});
	
	var _BitmapText = __webpack_require__(333);
	
	Object.defineProperty(exports, 'BitmapText', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BitmapText).default;
	  }
	});
	
	__webpack_require__(334);
	
	__webpack_require__(335);
	
	__webpack_require__(336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// imported for side effect of extending the prototype only, contains no exports
	//# sourceMappingURL=index.js.map

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @typedef PIXI.extras.AnimatedSprite~FrameObject
	 * @type {object}
	 * @property {PIXI.Texture} texture - The {@link PIXI.Texture} of the frame
	 * @property {number} time - the duration of the frame in ms
	 */
	
	/**
	 * An AnimatedSprite is a simple way to display an animation depicted by a list of textures.
	 *
	 * ```js
	 * let alienImages = ["image_sequence_01.png","image_sequence_02.png","image_sequence_03.png","image_sequence_04.png"];
	 * let textureArray = [];
	 *
	 * for (let i=0; i < 4; i++)
	 * {
	 *      let texture = PIXI.Texture.fromImage(alienImages[i]);
	 *      textureArray.push(texture);
	 * };
	 *
	 * let mc = new PIXI.AnimatedSprite(textureArray);
	 * ```
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI.extras
	 */
	var AnimatedSprite = function (_core$Sprite) {
	    _inherits(AnimatedSprite, _core$Sprite);
	
	    /**
	     * @param {PIXI.Texture[]|PIXI.extras.AnimatedSprite~FrameObject[]} textures - an array of {@link PIXI.Texture} or frame
	     *  objects that make up the animation
	     * @param {boolean} [autoUpdate=true] - Whether to use PIXI.ticker.shared to auto update animation time.
	     */
	    function AnimatedSprite(textures, autoUpdate) {
	        _classCallCheck(this, AnimatedSprite);
	
	        /**
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _core$Sprite.call(this, textures[0] instanceof core.Texture ? textures[0] : textures[0].texture));
	
	        _this._textures = null;
	
	        /**
	         * @private
	         */
	        _this._durations = null;
	
	        _this.textures = textures;
	
	        /**
	         * `true` uses PIXI.ticker.shared to auto update animation time.
	         * @type {boolean}
	         * @default true
	         * @private
	         */
	        _this._autoUpdate = autoUpdate !== false;
	
	        /**
	         * The speed that the AnimatedSprite will play at. Higher is faster, lower is slower
	         *
	         * @member {number}
	         * @default 1
	         */
	        _this.animationSpeed = 1;
	
	        /**
	         * Whether or not the animate sprite repeats after playing.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.loop = true;
	
	        /**
	         * Function to call when a AnimatedSprite finishes playing
	         *
	         * @member {Function}
	         */
	        _this.onComplete = null;
	
	        /**
	         * Function to call when a AnimatedSprite changes which texture is being rendered
	         *
	         * @member {Function}
	         */
	        _this.onFrameChange = null;
	
	        /**
	        * Function to call when 'loop' is true, and an AnimatedSprite is played and loops around to start again
	        *
	        * @member {Function}
	        */
	        _this.onLoop = null;
	
	        /**
	         * Elapsed time since animation has been started, used internally to display current texture
	         *
	         * @member {number}
	         * @private
	         */
	        _this._currentTime = 0;
	
	        /**
	         * Indicates if the AnimatedSprite is currently playing
	         *
	         * @member {boolean}
	         * @readonly
	         */
	        _this.playing = false;
	        return _this;
	    }
	
	    /**
	     * Stops the AnimatedSprite
	     *
	     */
	
	
	    AnimatedSprite.prototype.stop = function stop() {
	        if (!this.playing) {
	            return;
	        }
	
	        this.playing = false;
	        if (this._autoUpdate) {
	            core.ticker.shared.remove(this.update, this);
	        }
	    };
	
	    /**
	     * Plays the AnimatedSprite
	     *
	     */
	
	
	    AnimatedSprite.prototype.play = function play() {
	        if (this.playing) {
	            return;
	        }
	
	        this.playing = true;
	        if (this._autoUpdate) {
	            core.ticker.shared.add(this.update, this, core.UPDATE_PRIORITY.HIGH);
	        }
	    };
	
	    /**
	     * Stops the AnimatedSprite and goes to a specific frame
	     *
	     * @param {number} frameNumber - frame index to stop at
	     */
	
	
	    AnimatedSprite.prototype.gotoAndStop = function gotoAndStop(frameNumber) {
	        this.stop();
	
	        var previousFrame = this.currentFrame;
	
	        this._currentTime = frameNumber;
	
	        if (previousFrame !== this.currentFrame) {
	            this.updateTexture();
	        }
	    };
	
	    /**
	     * Goes to a specific frame and begins playing the AnimatedSprite
	     *
	     * @param {number} frameNumber - frame index to start at
	     */
	
	
	    AnimatedSprite.prototype.gotoAndPlay = function gotoAndPlay(frameNumber) {
	        var previousFrame = this.currentFrame;
	
	        this._currentTime = frameNumber;
	
	        if (previousFrame !== this.currentFrame) {
	            this.updateTexture();
	        }
	
	        this.play();
	    };
	
	    /**
	     * Updates the object transform for rendering.
	     *
	     * @private
	     * @param {number} deltaTime - Time since last tick.
	     */
	
	
	    AnimatedSprite.prototype.update = function update(deltaTime) {
	        var elapsed = this.animationSpeed * deltaTime;
	        var previousFrame = this.currentFrame;
	
	        if (this._durations !== null) {
	            var lag = this._currentTime % 1 * this._durations[this.currentFrame];
	
	            lag += elapsed / 60 * 1000;
	
	            while (lag < 0) {
	                this._currentTime--;
	                lag += this._durations[this.currentFrame];
	            }
	
	            var sign = Math.sign(this.animationSpeed * deltaTime);
	
	            this._currentTime = Math.floor(this._currentTime);
	
	            while (lag >= this._durations[this.currentFrame]) {
	                lag -= this._durations[this.currentFrame] * sign;
	                this._currentTime += sign;
	            }
	
	            this._currentTime += lag / this._durations[this.currentFrame];
	        } else {
	            this._currentTime += elapsed;
	        }
	
	        if (this._currentTime < 0 && !this.loop) {
	            this.gotoAndStop(0);
	
	            if (this.onComplete) {
	                this.onComplete();
	            }
	        } else if (this._currentTime >= this._textures.length && !this.loop) {
	            this.gotoAndStop(this._textures.length - 1);
	
	            if (this.onComplete) {
	                this.onComplete();
	            }
	        } else if (previousFrame !== this.currentFrame) {
	            if (this.loop && this.onLoop) {
	                if (this.animationSpeed > 0 && this.currentFrame < previousFrame) {
	                    this.onLoop();
	                } else if (this.animationSpeed < 0 && this.currentFrame > previousFrame) {
	                    this.onLoop();
	                }
	            }
	
	            this.updateTexture();
	        }
	    };
	
	    /**
	     * Updates the displayed texture to match the current frame index
	     *
	     * @private
	     */
	
	
	    AnimatedSprite.prototype.updateTexture = function updateTexture() {
	        this._texture = this._textures[this.currentFrame];
	        this._textureID = -1;
	        this.cachedTint = 0xFFFFFF;
	
	        if (this.onFrameChange) {
	            this.onFrameChange(this.currentFrame);
	        }
	    };
	
	    /**
	     * Stops the AnimatedSprite and destroys it
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *      method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
	     */
	
	
	    AnimatedSprite.prototype.destroy = function destroy(options) {
	        this.stop();
	        _core$Sprite.prototype.destroy.call(this, options);
	    };
	
	    /**
	     * A short hand way of creating a movieclip from an array of frame ids
	     *
	     * @static
	     * @param {string[]} frames - The array of frames ids the movieclip will use as its texture frames
	     * @return {AnimatedSprite} The new animated sprite with the specified frames.
	     */
	
	
	    AnimatedSprite.fromFrames = function fromFrames(frames) {
	        var textures = [];
	
	        for (var i = 0; i < frames.length; ++i) {
	            textures.push(core.Texture.fromFrame(frames[i]));
	        }
	
	        return new AnimatedSprite(textures);
	    };
	
	    /**
	     * A short hand way of creating a movieclip from an array of image ids
	     *
	     * @static
	     * @param {string[]} images - the array of image urls the movieclip will use as its texture frames
	     * @return {AnimatedSprite} The new animate sprite with the specified images as frames.
	     */
	
	
	    AnimatedSprite.fromImages = function fromImages(images) {
	        var textures = [];
	
	        for (var i = 0; i < images.length; ++i) {
	            textures.push(core.Texture.fromImage(images[i]));
	        }
	
	        return new AnimatedSprite(textures);
	    };
	
	    /**
	     * totalFrames is the total number of frames in the AnimatedSprite. This is the same as number of textures
	     * assigned to the AnimatedSprite.
	     *
	     * @readonly
	     * @member {number}
	     * @default 0
	     */
	
	
	    _createClass(AnimatedSprite, [{
	        key: 'totalFrames',
	        get: function get() {
	            return this._textures.length;
	        }
	
	        /**
	         * The array of textures used for this AnimatedSprite
	         *
	         * @member {PIXI.Texture[]}
	         */
	
	    }, {
	        key: 'textures',
	        get: function get() {
	            return this._textures;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (value[0] instanceof core.Texture) {
	                this._textures = value;
	                this._durations = null;
	            } else {
	                this._textures = [];
	                this._durations = [];
	
	                for (var i = 0; i < value.length; i++) {
	                    this._textures.push(value[i].texture);
	                    this._durations.push(value[i].time);
	                }
	            }
	            this.gotoAndStop(0);
	            this.updateTexture();
	        }
	
	        /**
	        * The AnimatedSprites current frame index
	        *
	        * @member {number}
	        * @readonly
	        */
	
	    }, {
	        key: 'currentFrame',
	        get: function get() {
	            var currentFrame = Math.floor(this._currentTime) % this._textures.length;
	
	            if (currentFrame < 0) {
	                currentFrame += this._textures.length;
	            }
	
	            return currentFrame;
	        }
	    }]);
	
	    return AnimatedSprite;
	}(core.Sprite);
	
	exports.default = AnimatedSprite;
	//# sourceMappingURL=AnimatedSprite.js.map

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _CanvasTinter = __webpack_require__(276);
	
	var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tempPoint = new core.Point();
	
	/**
	 * A tiling sprite is a fast way of rendering a tiling image
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI.extras
	 */
	
	var TilingSprite = function (_core$Sprite) {
	    _inherits(TilingSprite, _core$Sprite);
	
	    /**
	     * @param {PIXI.Texture} texture - the texture of the tiling sprite
	     * @param {number} [width=100] - the width of the tiling sprite
	     * @param {number} [height=100] - the height of the tiling sprite
	     */
	    function TilingSprite(texture) {
	        var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	        var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
	
	        _classCallCheck(this, TilingSprite);
	
	        /**
	         * Tile transform
	         *
	         * @member {PIXI.TransformStatic}
	         */
	        var _this = _possibleConstructorReturn(this, _core$Sprite.call(this, texture));
	
	        _this.tileTransform = new core.TransformStatic();
	
	        // /// private
	
	        /**
	         * The with of the tiling sprite
	         *
	         * @member {number}
	         * @private
	         */
	        _this._width = width;
	
	        /**
	         * The height of the tiling sprite
	         *
	         * @member {number}
	         * @private
	         */
	        _this._height = height;
	
	        /**
	         * Canvas pattern
	         *
	         * @type {CanvasPattern}
	         * @private
	         */
	        _this._canvasPattern = null;
	
	        /**
	         * transform that is applied to UV to get the texture coords
	         *
	         * @member {PIXI.TextureMatrix}
	         */
	        _this.uvTransform = texture.transform || new core.TextureMatrix(texture);
	
	        /**
	         * Plugin that is responsible for rendering this element.
	         * Allows to customize the rendering process without overriding '_renderWebGL' method.
	         *
	         * @member {string}
	         * @default 'tilingSprite'
	         */
	        _this.pluginName = 'tilingSprite';
	
	        /**
	         * Whether or not anchor affects uvs
	         *
	         * @member {boolean}
	         * @default false
	         */
	        _this.uvRespectAnchor = false;
	        return _this;
	    }
	    /**
	     * Changes frame clamping in corresponding textureTransform, shortcut
	     * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
	     *
	     * @default 0.5
	     * @member {number}
	     */
	
	
	    /**
	     * @private
	     */
	    TilingSprite.prototype._onTextureUpdate = function _onTextureUpdate() {
	        if (this.uvTransform) {
	            this.uvTransform.texture = this._texture;
	        }
	        this.cachedTint = 0xFFFFFF;
	    };
	
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    TilingSprite.prototype._renderWebGL = function _renderWebGL(renderer) {
	        // tweak our texture temporarily..
	        var texture = this._texture;
	
	        if (!texture || !texture.valid) {
	            return;
	        }
	
	        this.tileTransform.updateLocalTransform();
	        this.uvTransform.update();
	
	        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
	        renderer.plugins[this.pluginName].render(this);
	    };
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - a reference to the canvas renderer
	     */
	
	
	    TilingSprite.prototype._renderCanvas = function _renderCanvas(renderer) {
	        var texture = this._texture;
	
	        if (!texture.baseTexture.hasLoaded) {
	            return;
	        }
	
	        var context = renderer.context;
	        var transform = this.worldTransform;
	        var resolution = renderer.resolution;
	        var baseTexture = texture.baseTexture;
	        var baseTextureResolution = baseTexture.resolution;
	        var modX = this.tilePosition.x / this.tileScale.x % texture._frame.width * baseTextureResolution;
	        var modY = this.tilePosition.y / this.tileScale.y % texture._frame.height * baseTextureResolution;
	
	        // create a nice shiny pattern!
	        if (this._textureID !== this._texture._updateID || this.cachedTint !== this.tint) {
	            this._textureID = this._texture._updateID;
	            // cut an object from a spritesheet..
	            var tempCanvas = new core.CanvasRenderTarget(texture._frame.width, texture._frame.height, baseTextureResolution);
	
	            // Tint the tiling sprite
	            if (this.tint !== 0xFFFFFF) {
	                this.tintedTexture = _CanvasTinter2.default.getTintedTexture(this, this.tint);
	                tempCanvas.context.drawImage(this.tintedTexture, 0, 0);
	            } else {
	                tempCanvas.context.drawImage(baseTexture.source, -texture._frame.x * baseTextureResolution, -texture._frame.y * baseTextureResolution);
	            }
	            this.cachedTint = this.tint;
	            this._canvasPattern = tempCanvas.context.createPattern(tempCanvas.canvas, 'repeat');
	        }
	
	        // set context state..
	        context.globalAlpha = this.worldAlpha;
	        context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);
	
	        renderer.setBlendMode(this.blendMode);
	
	        // fill the pattern!
	        context.fillStyle = this._canvasPattern;
	
	        // TODO - this should be rolled into the setTransform above..
	        context.scale(this.tileScale.x / baseTextureResolution, this.tileScale.y / baseTextureResolution);
	
	        var anchorX = this.anchor.x * -this._width;
	        var anchorY = this.anchor.y * -this._height;
	
	        if (this.uvRespectAnchor) {
	            context.translate(modX, modY);
	
	            context.fillRect(-modX + anchorX, -modY + anchorY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
	        } else {
	            context.translate(modX + anchorX, modY + anchorY);
	
	            context.fillRect(-modX, -modY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
	        }
	    };
	
	    /**
	     * Updates the bounds of the tiling sprite.
	     *
	     * @private
	     */
	
	
	    TilingSprite.prototype._calculateBounds = function _calculateBounds() {
	        var minX = this._width * -this._anchor._x;
	        var minY = this._height * -this._anchor._y;
	        var maxX = this._width * (1 - this._anchor._x);
	        var maxY = this._height * (1 - this._anchor._y);
	
	        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
	    };
	
	    /**
	     * Gets the local bounds of the sprite object.
	     *
	     * @param {PIXI.Rectangle} rect - The output rectangle.
	     * @return {PIXI.Rectangle} The bounds.
	     */
	
	
	    TilingSprite.prototype.getLocalBounds = function getLocalBounds(rect) {
	        // we can do a fast local bounds if the sprite has no children!
	        if (this.children.length === 0) {
	            this._bounds.minX = this._width * -this._anchor._x;
	            this._bounds.minY = this._height * -this._anchor._y;
	            this._bounds.maxX = this._width * (1 - this._anchor._x);
	            this._bounds.maxY = this._height * (1 - this._anchor._y);
	
	            if (!rect) {
	                if (!this._localBoundsRect) {
	                    this._localBoundsRect = new core.Rectangle();
	                }
	
	                rect = this._localBoundsRect;
	            }
	
	            return this._bounds.getRectangle(rect);
	        }
	
	        return _core$Sprite.prototype.getLocalBounds.call(this, rect);
	    };
	
	    /**
	     * Checks if a point is inside this tiling sprite.
	     *
	     * @param {PIXI.Point} point - the point to check
	     * @return {boolean} Whether or not the sprite contains the point.
	     */
	
	
	    TilingSprite.prototype.containsPoint = function containsPoint(point) {
	        this.worldTransform.applyInverse(point, tempPoint);
	
	        var width = this._width;
	        var height = this._height;
	        var x1 = -width * this.anchor._x;
	
	        if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
	            var y1 = -height * this.anchor._y;
	
	            if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	
	    /**
	     * Destroys this sprite and optionally its texture and children
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *      method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
	     */
	
	
	    TilingSprite.prototype.destroy = function destroy(options) {
	        _core$Sprite.prototype.destroy.call(this, options);
	
	        this.tileTransform = null;
	        this.uvTransform = null;
	    };
	
	    /**
	     * Helper function that creates a new tiling sprite based on the source you provide.
	     * The source can be - frame id, image url, video url, canvas element, video element, base texture
	     *
	     * @static
	     * @param {number|string|PIXI.BaseTexture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
	     * @param {number} width - the width of the tiling sprite
	     * @param {number} height - the height of the tiling sprite
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    TilingSprite.from = function from(source, width, height) {
	        return new TilingSprite(core.Texture.from(source), width, height);
	    };
	
	    /**
	     * Helper function that creates a tiling sprite that will use a texture from the TextureCache based on the frameId
	     * The frame ids are created when a Texture packer file has been loaded
	     *
	     * @static
	     * @param {string} frameId - The frame Id of the texture in the cache
	     * @param {number} width - the width of the tiling sprite
	     * @param {number} height - the height of the tiling sprite
	     * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the frameId
	     */
	
	
	    TilingSprite.fromFrame = function fromFrame(frameId, width, height) {
	        var texture = core.utils.TextureCache[frameId];
	
	        if (!texture) {
	            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache ' + this);
	        }
	
	        return new TilingSprite(texture, width, height);
	    };
	
	    /**
	     * Helper function that creates a sprite that will contain a texture based on an image url
	     * If the image is not in the texture cache it will be loaded
	     *
	     * @static
	     * @param {string} imageId - The image url of the texture
	     * @param {number} width - the width of the tiling sprite
	     * @param {number} height - the height of the tiling sprite
	     * @param {boolean} [crossorigin] - if you want to specify the cross-origin parameter
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - if you want to specify the scale mode,
	     *  see {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the image id
	     */
	
	
	    TilingSprite.fromImage = function fromImage(imageId, width, height, crossorigin, scaleMode) {
	        return new TilingSprite(core.Texture.fromImage(imageId, crossorigin, scaleMode), width, height);
	    };
	
	    /**
	     * The width of the sprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     */
	
	
	    _createClass(TilingSprite, [{
	        key: 'clampMargin',
	        get: function get() {
	            return this.uvTransform.clampMargin;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uvTransform.clampMargin = value;
	            this.uvTransform.update(true);
	        }
	
	        /**
	         * The scaling of the image that is being tiled
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'tileScale',
	        get: function get() {
	            return this.tileTransform.scale;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.tileTransform.scale.copy(value);
	        }
	
	        /**
	         * The offset of the image that is being tiled
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'tilePosition',
	        get: function get() {
	            return this.tileTransform.position;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.tileTransform.position.copy(value);
	        }
	    }, {
	        key: 'width',
	        get: function get() {
	            return this._width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._width = value;
	        }
	
	        /**
	         * The height of the TilingSprite, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'height',
	        get: function get() {
	            return this._height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._height = value;
	        }
	    }]);
	
	    return TilingSprite;
	}(core.Sprite);
	
	exports.default = TilingSprite;
	//# sourceMappingURL=TilingSprite.js.map

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _const = __webpack_require__(205);
	
	var _path = __webpack_require__(285);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tempMat = new core.Matrix();
	
	/**
	 * WebGL renderer plugin for tiling sprites
	 *
	 * @class
	 * @memberof PIXI.extras
	 * @extends PIXI.ObjectRenderer
	 */
	
	var TilingSpriteRenderer = function (_core$ObjectRenderer) {
	    _inherits(TilingSpriteRenderer, _core$ObjectRenderer);
	
	    /**
	     * constructor for renderer
	     *
	     * @param {WebGLRenderer} renderer The renderer this tiling awesomeness works for.
	     */
	    function TilingSpriteRenderer(renderer) {
	        _classCallCheck(this, TilingSpriteRenderer);
	
	        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));
	
	        _this.shader = null;
	        _this.simpleShader = null;
	        _this.quad = null;
	        return _this;
	    }
	
	    /**
	     * Sets up the renderer context and necessary buffers.
	     *
	     * @private
	     */
	
	
	    TilingSpriteRenderer.prototype.onContextChange = function onContextChange() {
	        var gl = this.renderer.gl;
	
	        this.shader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = mod(vTextureCoord - uClampOffset, vec2(1.0, 1.0)) + uClampOffset;\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    vec4 sample = texture2D(uSampler, coord);\n    gl_FragColor = sample * uColor;\n}\n');
	        this.simpleShader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\n\nvoid main(void)\n{\n    vec4 sample = texture2D(uSampler, vTextureCoord);\n    gl_FragColor = sample * uColor;\n}\n');
	
	        this.renderer.bindVao(null);
	        this.quad = new core.Quad(gl, this.renderer.state.attribState);
	        this.quad.initVao(this.shader);
	    };
	
	    /**
	     *
	     * @param {PIXI.extras.TilingSprite} ts tilingSprite to be rendered
	     */
	
	
	    TilingSpriteRenderer.prototype.render = function render(ts) {
	        var renderer = this.renderer;
	        var quad = this.quad;
	
	        renderer.bindVao(quad.vao);
	
	        var vertices = quad.vertices;
	
	        vertices[0] = vertices[6] = ts._width * -ts.anchor.x;
	        vertices[1] = vertices[3] = ts._height * -ts.anchor.y;
	
	        vertices[2] = vertices[4] = ts._width * (1.0 - ts.anchor.x);
	        vertices[5] = vertices[7] = ts._height * (1.0 - ts.anchor.y);
	
	        if (ts.uvRespectAnchor) {
	            vertices = quad.uvs;
	
	            vertices[0] = vertices[6] = -ts.anchor.x;
	            vertices[1] = vertices[3] = -ts.anchor.y;
	
	            vertices[2] = vertices[4] = 1.0 - ts.anchor.x;
	            vertices[5] = vertices[7] = 1.0 - ts.anchor.y;
	        }
	
	        quad.upload();
	
	        var tex = ts._texture;
	        var baseTex = tex.baseTexture;
	        var lt = ts.tileTransform.localTransform;
	        var uv = ts.uvTransform;
	        var isSimple = baseTex.isPowerOfTwo && tex.frame.width === baseTex.width && tex.frame.height === baseTex.height;
	
	        // auto, force repeat wrapMode for big tiling textures
	        if (isSimple) {
	            if (!baseTex._glTextures[renderer.CONTEXT_UID]) {
	                if (baseTex.wrapMode === _const.WRAP_MODES.CLAMP) {
	                    baseTex.wrapMode = _const.WRAP_MODES.REPEAT;
	                }
	            } else {
	                isSimple = baseTex.wrapMode !== _const.WRAP_MODES.CLAMP;
	            }
	        }
	
	        var shader = isSimple ? this.simpleShader : this.shader;
	
	        renderer.bindShader(shader);
	
	        var w = tex.width;
	        var h = tex.height;
	        var W = ts._width;
	        var H = ts._height;
	
	        tempMat.set(lt.a * w / W, lt.b * w / H, lt.c * h / W, lt.d * h / H, lt.tx / W, lt.ty / H);
	
	        // that part is the same as above:
	        // tempMat.identity();
	        // tempMat.scale(tex.width, tex.height);
	        // tempMat.prepend(lt);
	        // tempMat.scale(1.0 / ts._width, 1.0 / ts._height);
	
	        tempMat.invert();
	        if (isSimple) {
	            tempMat.prepend(uv.mapCoord);
	        } else {
	            shader.uniforms.uMapCoord = uv.mapCoord.toArray(true);
	            shader.uniforms.uClampFrame = uv.uClampFrame;
	            shader.uniforms.uClampOffset = uv.uClampOffset;
	        }
	
	        shader.uniforms.uTransform = tempMat.toArray(true);
	        shader.uniforms.uColor = core.utils.premultiplyTintToRgba(ts.tint, ts.worldAlpha, shader.uniforms.uColor, baseTex.premultipliedAlpha);
	        shader.uniforms.translationMatrix = ts.transform.worldTransform.toArray(true);
	
	        shader.uniforms.uSampler = renderer.bindTexture(tex);
	
	        renderer.setBlendMode(core.utils.correctBlendMode(ts.blendMode, baseTex.premultipliedAlpha));
	
	        quad.vao.draw(this.renderer.gl.TRIANGLES, 6, 0);
	    };
	
	    return TilingSpriteRenderer;
	}(core.ObjectRenderer);
	
	exports.default = TilingSpriteRenderer;
	
	
	core.WebGLRenderer.registerPlugin('tilingSprite', TilingSpriteRenderer);
	//# sourceMappingURL=TilingSpriteRenderer.js.map

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _ObservablePoint = __webpack_require__(208);
	
	var _ObservablePoint2 = _interopRequireDefault(_ObservablePoint);
	
	var _utils = __webpack_require__(244);
	
	var _settings = __webpack_require__(236);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A BitmapText object will create a line or multiple lines of text using bitmap font. To
	 * split a line you can use '\n', '\r' or '\r\n' in your string. You can generate the fnt files using:
	 *
	 * A BitmapText can only be created when the font is loaded
	 *
	 * ```js
	 * // in this case the font is in a file called 'desyrel.fnt'
	 * let bitmapText = new PIXI.extras.BitmapText("text using a fancy font!", {font: "35px Desyrel", align: "right"});
	 * ```
	 *
	 * http://www.angelcode.com/products/bmfont/ for windows or
	 * http://www.bmglyph.com/ for mac.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI.extras
	 */
	var BitmapText = function (_core$Container) {
	    _inherits(BitmapText, _core$Container);
	
	    /**
	     * @param {string} text - The copy that you would like the text to display
	     * @param {object} style - The style parameters
	     * @param {string|object} style.font - The font descriptor for the object, can be passed as a string of form
	     *      "24px FontName" or "FontName" or as an object with explicit name/size properties.
	     * @param {string} [style.font.name] - The bitmap font id
	     * @param {number} [style.font.size] - The size of the font in pixels, e.g. 24
	     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'), does not affect
	     *      single line text
	     * @param {number} [style.tint=0xFFFFFF] - The tint color
	     */
	    function BitmapText(text) {
	        var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        _classCallCheck(this, BitmapText);
	
	        /**
	         * Private tracker for the width of the overall text
	         *
	         * @member {number}
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _core$Container.call(this));
	
	        _this._textWidth = 0;
	
	        /**
	         * Private tracker for the height of the overall text
	         *
	         * @member {number}
	         * @private
	         */
	        _this._textHeight = 0;
	
	        /**
	         * Private tracker for the letter sprite pool.
	         *
	         * @member {PIXI.Sprite[]}
	         * @private
	         */
	        _this._glyphs = [];
	
	        /**
	         * Private tracker for the current style.
	         *
	         * @member {object}
	         * @private
	         */
	        _this._font = {
	            tint: style.tint !== undefined ? style.tint : 0xFFFFFF,
	            align: style.align || 'left',
	            name: null,
	            size: 0
	        };
	
	        /**
	         * Private tracker for the current font.
	         *
	         * @member {object}
	         * @private
	         */
	        _this.font = style.font; // run font setter
	
	        /**
	         * Private tracker for the current text.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._text = text;
	
	        /**
	         * The max width of this bitmap text in pixels. If the text provided is longer than the
	         * value provided, line breaks will be automatically inserted in the last whitespace.
	         * Disable by setting value to 0
	         *
	         * @member {number}
	         * @private
	         */
	        _this._maxWidth = 0;
	
	        /**
	         * The max line height. This is useful when trying to use the total height of the Text,
	         * ie: when trying to vertically align.
	         *
	         * @member {number}
	         * @private
	         */
	        _this._maxLineHeight = 0;
	
	        /**
	         * Letter spacing. This is useful for setting the space between characters.
	         * @member {number}
	         * @private
	         */
	        _this._letterSpacing = 0;
	
	        /**
	         * Text anchor. read-only
	         *
	         * @member {PIXI.ObservablePoint}
	         * @private
	         */
	        _this._anchor = new _ObservablePoint2.default(function () {
	            _this.dirty = true;
	        }, _this, 0, 0);
	
	        /**
	         * The dirty state of this object.
	         *
	         * @member {boolean}
	         */
	        _this.dirty = false;
	
	        _this.updateText();
	        return _this;
	    }
	
	    /**
	     * Renders text and updates it when needed
	     *
	     * @private
	     */
	
	
	    BitmapText.prototype.updateText = function updateText() {
	        var data = BitmapText.fonts[this._font.name];
	        var scale = this._font.size / data.size;
	        var pos = new core.Point();
	        var chars = [];
	        var lineWidths = [];
	        var text = this.text.replace(/(?:\r\n|\r)/g, '\n');
	        var textLength = text.length;
	        var maxWidth = this._maxWidth * data.size / this._font.size;
	
	        var prevCharCode = null;
	        var lastLineWidth = 0;
	        var maxLineWidth = 0;
	        var line = 0;
	        var lastBreakPos = -1;
	        var lastBreakWidth = 0;
	        var spacesRemoved = 0;
	        var maxLineHeight = 0;
	
	        for (var i = 0; i < textLength; i++) {
	            var charCode = text.charCodeAt(i);
	            var char = text.charAt(i);
	
	            if (/(?:\s)/.test(char)) {
	                lastBreakPos = i;
	                lastBreakWidth = lastLineWidth;
	            }
	
	            if (char === '\r' || char === '\n') {
	                lineWidths.push(lastLineWidth);
	                maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
	                ++line;
	                ++spacesRemoved;
	
	                pos.x = 0;
	                pos.y += data.lineHeight;
	                prevCharCode = null;
	                continue;
	            }
	
	            var charData = data.chars[charCode];
	
	            if (!charData) {
	                continue;
	            }
	
	            if (prevCharCode && charData.kerning[prevCharCode]) {
	                pos.x += charData.kerning[prevCharCode];
	            }
	
	            chars.push({
	                texture: charData.texture,
	                line: line,
	                charCode: charCode,
	                position: new core.Point(pos.x + charData.xOffset + this._letterSpacing / 2, pos.y + charData.yOffset)
	            });
	            pos.x += charData.xAdvance + this._letterSpacing;
	            lastLineWidth = pos.x;
	            maxLineHeight = Math.max(maxLineHeight, charData.yOffset + charData.texture.height);
	            prevCharCode = charCode;
	
	            if (lastBreakPos !== -1 && maxWidth > 0 && pos.x > maxWidth) {
	                ++spacesRemoved;
	                core.utils.removeItems(chars, 1 + lastBreakPos - spacesRemoved, 1 + i - lastBreakPos);
	                i = lastBreakPos;
	                lastBreakPos = -1;
	
	                lineWidths.push(lastBreakWidth);
	                maxLineWidth = Math.max(maxLineWidth, lastBreakWidth);
	                line++;
	
	                pos.x = 0;
	                pos.y += data.lineHeight;
	                prevCharCode = null;
	            }
	        }
	
	        var lastChar = text.charAt(text.length - 1);
	
	        if (lastChar !== '\r' && lastChar !== '\n') {
	            if (/(?:\s)/.test(lastChar)) {
	                lastLineWidth = lastBreakWidth;
	            }
	
	            lineWidths.push(lastLineWidth);
	            maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
	        }
	
	        var lineAlignOffsets = [];
	
	        for (var _i = 0; _i <= line; _i++) {
	            var alignOffset = 0;
	
	            if (this._font.align === 'right') {
	                alignOffset = maxLineWidth - lineWidths[_i];
	            } else if (this._font.align === 'center') {
	                alignOffset = (maxLineWidth - lineWidths[_i]) / 2;
	            }
	
	            lineAlignOffsets.push(alignOffset);
	        }
	
	        var lenChars = chars.length;
	        var tint = this.tint;
	
	        for (var _i2 = 0; _i2 < lenChars; _i2++) {
	            var c = this._glyphs[_i2]; // get the next glyph sprite
	
	            if (c) {
	                c.texture = chars[_i2].texture;
	            } else {
	                c = new core.Sprite(chars[_i2].texture);
	                this._glyphs.push(c);
	            }
	
	            c.position.x = (chars[_i2].position.x + lineAlignOffsets[chars[_i2].line]) * scale;
	            c.position.y = chars[_i2].position.y * scale;
	            c.scale.x = c.scale.y = scale;
	            c.tint = tint;
	
	            if (!c.parent) {
	                this.addChild(c);
	            }
	        }
	
	        // remove unnecessary children.
	        for (var _i3 = lenChars; _i3 < this._glyphs.length; ++_i3) {
	            this.removeChild(this._glyphs[_i3]);
	        }
	
	        this._textWidth = maxLineWidth * scale;
	        this._textHeight = (pos.y + data.lineHeight) * scale;
	
	        // apply anchor
	        if (this.anchor.x !== 0 || this.anchor.y !== 0) {
	            for (var _i4 = 0; _i4 < lenChars; _i4++) {
	                this._glyphs[_i4].x -= this._textWidth * this.anchor.x;
	                this._glyphs[_i4].y -= this._textHeight * this.anchor.y;
	            }
	        }
	        this._maxLineHeight = maxLineHeight * scale;
	    };
	
	    /**
	     * Updates the transform of this object
	     *
	     * @private
	     */
	
	
	    BitmapText.prototype.updateTransform = function updateTransform() {
	        this.validate();
	        this.containerUpdateTransform();
	    };
	
	    /**
	     * Validates text before calling parent's getLocalBounds
	     *
	     * @return {PIXI.Rectangle} The rectangular bounding area
	     */
	
	
	    BitmapText.prototype.getLocalBounds = function getLocalBounds() {
	        this.validate();
	
	        return _core$Container.prototype.getLocalBounds.call(this);
	    };
	
	    /**
	     * Updates text when needed
	     *
	     * @private
	     */
	
	
	    BitmapText.prototype.validate = function validate() {
	        if (this.dirty) {
	            this.updateText();
	            this.dirty = false;
	        }
	    };
	
	    /**
	     * The tint of the BitmapText object
	     *
	     * @member {number}
	     */
	
	
	    /**
	     * Register a bitmap font with data and a texture.
	     *
	     * @static
	     * @param {XMLDocument} xml - The XML document data.
	     * @param {Object.<string, PIXI.Texture>|PIXI.Texture|PIXI.Texture[]} textures - List of textures for each page.
	     *  If providing an object, the key is the `<page>` element's `file` attribute in the FNT file.
	     * @return {Object} Result font object with font, size, lineHeight and char fields.
	     */
	    BitmapText.registerFont = function registerFont(xml, textures) {
	        var data = {};
	        var info = xml.getElementsByTagName('info')[0];
	        var common = xml.getElementsByTagName('common')[0];
	        var pages = xml.getElementsByTagName('page');
	        var res = (0, _utils.getResolutionOfUrl)(pages[0].getAttribute('file'), _settings2.default.RESOLUTION);
	        var pagesTextures = {};
	
	        data.font = info.getAttribute('face');
	        data.size = parseInt(info.getAttribute('size'), 10);
	        data.lineHeight = parseInt(common.getAttribute('lineHeight'), 10) / res;
	        data.chars = {};
	
	        // Single texture, convert to list
	        if (textures instanceof core.Texture) {
	            textures = [textures];
	        }
	
	        // Convert the input Texture, Textures or object
	        // into a page Texture lookup by "id"
	        for (var i = 0; i < pages.length; i++) {
	            var id = pages[i].getAttribute('id');
	            var file = pages[i].getAttribute('file');
	
	            pagesTextures[id] = textures instanceof Array ? textures[i] : textures[file];
	        }
	
	        // parse letters
	        var letters = xml.getElementsByTagName('char');
	
	        for (var _i5 = 0; _i5 < letters.length; _i5++) {
	            var letter = letters[_i5];
	            var charCode = parseInt(letter.getAttribute('id'), 10);
	            var page = letter.getAttribute('page') || 0;
	            var textureRect = new core.Rectangle(parseInt(letter.getAttribute('x'), 10) / res + pagesTextures[page].frame.x / res, parseInt(letter.getAttribute('y'), 10) / res + pagesTextures[page].frame.y / res, parseInt(letter.getAttribute('width'), 10) / res, parseInt(letter.getAttribute('height'), 10) / res);
	
	            data.chars[charCode] = {
	                xOffset: parseInt(letter.getAttribute('xoffset'), 10) / res,
	                yOffset: parseInt(letter.getAttribute('yoffset'), 10) / res,
	                xAdvance: parseInt(letter.getAttribute('xadvance'), 10) / res,
	                kerning: {},
	                texture: new core.Texture(pagesTextures[page].baseTexture, textureRect),
	                page: page
	            };
	        }
	
	        // parse kernings
	        var kernings = xml.getElementsByTagName('kerning');
	
	        for (var _i6 = 0; _i6 < kernings.length; _i6++) {
	            var kerning = kernings[_i6];
	            var first = parseInt(kerning.getAttribute('first'), 10) / res;
	            var second = parseInt(kerning.getAttribute('second'), 10) / res;
	            var amount = parseInt(kerning.getAttribute('amount'), 10) / res;
	
	            if (data.chars[second]) {
	                data.chars[second].kerning[first] = amount;
	            }
	        }
	
	        // I'm leaving this as a temporary fix so we can test the bitmap fonts in v3
	        // but it's very likely to change
	        BitmapText.fonts[data.font] = data;
	
	        return data;
	    };
	
	    _createClass(BitmapText, [{
	        key: 'tint',
	        get: function get() {
	            return this._font.tint;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._font.tint = typeof value === 'number' && value >= 0 ? value : 0xFFFFFF;
	
	            this.dirty = true;
	        }
	
	        /**
	         * The alignment of the BitmapText object
	         *
	         * @member {string}
	         * @default 'left'
	         */
	
	    }, {
	        key: 'align',
	        get: function get() {
	            return this._font.align;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._font.align = value || 'left';
	
	            this.dirty = true;
	        }
	
	        /**
	         * The anchor sets the origin point of the text.
	         * The default is 0,0 this means the text's origin is the top left
	         * Setting the anchor to 0.5,0.5 means the text's origin is centered
	         * Setting the anchor to 1,1 would mean the text's origin point will be the bottom right corner
	         *
	         * @member {PIXI.Point | number}
	         */
	
	    }, {
	        key: 'anchor',
	        get: function get() {
	            return this._anchor;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (typeof value === 'number') {
	                this._anchor.set(value);
	            } else {
	                this._anchor.copy(value);
	            }
	        }
	
	        /**
	         * The font descriptor of the BitmapText object
	         *
	         * @member {string|object}
	         */
	
	    }, {
	        key: 'font',
	        get: function get() {
	            return this._font;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (!value) {
	                return;
	            }
	
	            if (typeof value === 'string') {
	                value = value.split(' ');
	
	                this._font.name = value.length === 1 ? value[0] : value.slice(1).join(' ');
	                this._font.size = value.length >= 2 ? parseInt(value[0], 10) : BitmapText.fonts[this._font.name].size;
	            } else {
	                this._font.name = value.name;
	                this._font.size = typeof value.size === 'number' ? value.size : parseInt(value.size, 10);
	            }
	
	            this.dirty = true;
	        }
	
	        /**
	         * The text of the BitmapText object
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'text',
	        get: function get() {
	            return this._text;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            value = value.toString() || ' ';
	            if (this._text === value) {
	                return;
	            }
	            this._text = value;
	            this.dirty = true;
	        }
	
	        /**
	         * The max width of this bitmap text in pixels. If the text provided is longer than the
	         * value provided, line breaks will be automatically inserted in the last whitespace.
	         * Disable by setting value to 0
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'maxWidth',
	        get: function get() {
	            return this._maxWidth;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._maxWidth === value) {
	                return;
	            }
	            this._maxWidth = value;
	            this.dirty = true;
	        }
	
	        /**
	         * The max line height. This is useful when trying to use the total height of the Text,
	         * ie: when trying to vertically align.
	         *
	         * @member {number}
	         * @readonly
	         */
	
	    }, {
	        key: 'maxLineHeight',
	        get: function get() {
	            this.validate();
	
	            return this._maxLineHeight;
	        }
	
	        /**
	         * The width of the overall text, different from fontSize,
	         * which is defined in the style object
	         *
	         * @member {number}
	         * @readonly
	         */
	
	    }, {
	        key: 'textWidth',
	        get: function get() {
	            this.validate();
	
	            return this._textWidth;
	        }
	
	        /**
	         * Additional space between characters.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'letterSpacing',
	        get: function get() {
	            return this._letterSpacing;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._letterSpacing !== value) {
	                this._letterSpacing = value;
	                this.dirty = true;
	            }
	        }
	
	        /**
	         * The height of the overall text, different from fontSize,
	         * which is defined in the style object
	         *
	         * @member {number}
	         * @readonly
	         */
	
	    }, {
	        key: 'textHeight',
	        get: function get() {
	            this.validate();
	
	            return this._textHeight;
	        }
	    }]);
	
	    return BitmapText;
	}(core.Container);
	
	exports.default = BitmapText;
	
	
	BitmapText.fonts = {};
	//# sourceMappingURL=BitmapText.js.map

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _Texture = __webpack_require__(251);
	
	var _Texture2 = _interopRequireDefault(_Texture);
	
	var _BaseTexture = __webpack_require__(252);
	
	var _BaseTexture2 = _interopRequireDefault(_BaseTexture);
	
	var _utils = __webpack_require__(244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DisplayObject = core.DisplayObject;
	var _tempMatrix = new core.Matrix();
	
	DisplayObject.prototype._cacheAsBitmap = false;
	DisplayObject.prototype._cacheData = false;
	
	// figured theres no point adding ALL the extra variables to prototype.
	// this model can hold the information needed. This can also be generated on demand as
	// most objects are not cached as bitmaps.
	/**
	 * @class
	 * @ignore
	 */
	
	var CacheData =
	/**
	 *
	 */
	function CacheData() {
	    _classCallCheck(this, CacheData);
	
	    this.textureCacheId = null;
	
	    this.originalRenderWebGL = null;
	    this.originalRenderCanvas = null;
	    this.originalCalculateBounds = null;
	    this.originalGetLocalBounds = null;
	
	    this.originalUpdateTransform = null;
	    this.originalHitTest = null;
	    this.originalDestroy = null;
	    this.originalMask = null;
	    this.originalFilterArea = null;
	    this.sprite = null;
	};
	
	Object.defineProperties(DisplayObject.prototype, {
	    /**
	     * Set this to true if you want this display object to be cached as a bitmap.
	     * This basically takes a snap shot of the display object as it is at that moment. It can
	     * provide a performance benefit for complex static displayObjects.
	     * To remove simply set this property to 'false'
	     *
	     * IMPORTANT GOTCHA - make sure that all your textures are preloaded BEFORE setting this property to true
	     * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
	     *
	     * @member {boolean}
	     * @memberof PIXI.DisplayObject#
	     */
	    cacheAsBitmap: {
	        get: function get() {
	            return this._cacheAsBitmap;
	        },
	        set: function set(value) {
	            if (this._cacheAsBitmap === value) {
	                return;
	            }
	
	            this._cacheAsBitmap = value;
	
	            var data = void 0;
	
	            if (value) {
	                if (!this._cacheData) {
	                    this._cacheData = new CacheData();
	                }
	
	                data = this._cacheData;
	
	                data.originalRenderWebGL = this.renderWebGL;
	                data.originalRenderCanvas = this.renderCanvas;
	
	                data.originalUpdateTransform = this.updateTransform;
	                data.originalCalculateBounds = this._calculateBounds;
	                data.originalGetLocalBounds = this.getLocalBounds;
	
	                data.originalDestroy = this.destroy;
	
	                data.originalContainsPoint = this.containsPoint;
	
	                data.originalMask = this._mask;
	                data.originalFilterArea = this.filterArea;
	
	                this.renderWebGL = this._renderCachedWebGL;
	                this.renderCanvas = this._renderCachedCanvas;
	
	                this.destroy = this._cacheAsBitmapDestroy;
	            } else {
	                data = this._cacheData;
	
	                if (data.sprite) {
	                    this._destroyCachedDisplayObject();
	                }
	
	                this.renderWebGL = data.originalRenderWebGL;
	                this.renderCanvas = data.originalRenderCanvas;
	                this._calculateBounds = data.originalCalculateBounds;
	                this.getLocalBounds = data.originalGetLocalBounds;
	
	                this.destroy = data.originalDestroy;
	
	                this.updateTransform = data.originalUpdateTransform;
	                this.containsPoint = data.originalContainsPoint;
	
	                this._mask = data.originalMask;
	                this.filterArea = data.originalFilterArea;
	            }
	        }
	    }
	});
	
	/**
	 * Renders a cached version of the sprite with WebGL
	 *
	 * @private
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._renderCachedWebGL = function _renderCachedWebGL(renderer) {
	    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	        return;
	    }
	
	    this._initCachedDisplayObject(renderer);
	
	    this._cacheData.sprite._transformID = -1;
	    this._cacheData.sprite.worldAlpha = this.worldAlpha;
	    this._cacheData.sprite._renderWebGL(renderer);
	};
	
	/**
	 * Prepares the WebGL renderer to cache the sprite
	 *
	 * @private
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._initCachedDisplayObject = function _initCachedDisplayObject(renderer) {
	    if (this._cacheData && this._cacheData.sprite) {
	        return;
	    }
	
	    // make sure alpha is set to 1 otherwise it will get rendered as invisible!
	    var cacheAlpha = this.alpha;
	
	    this.alpha = 1;
	
	    // first we flush anything left in the renderer (otherwise it would get rendered to the cached texture)
	    renderer.currentRenderer.flush();
	    // this.filters= [];
	
	    // next we find the dimensions of the untransformed object
	    // this function also calls updatetransform on all its children as part of the measuring.
	    // This means we don't need to update the transform again in this function
	    // TODO pass an object to clone too? saves having to create a new one each time!
	    var bounds = this.getLocalBounds().clone();
	
	    // add some padding!
	    if (this._filters) {
	        var padding = this._filters[0].padding;
	
	        bounds.pad(padding);
	    }
	
	    // for now we cache the current renderTarget that the webGL renderer is currently using.
	    // this could be more elegent..
	    var cachedRenderTarget = renderer._activeRenderTarget;
	    // We also store the filter stack - I will definitely look to change how this works a little later down the line.
	    var stack = renderer.filterManager.filterStack;
	
	    // this renderTexture will be used to store the cached DisplayObject
	
	    var renderTexture = core.RenderTexture.create(bounds.width | 0, bounds.height | 0);
	
	    var textureCacheId = 'cacheAsBitmap_' + (0, _utils.uid)();
	
	    this._cacheData.textureCacheId = textureCacheId;
	
	    _BaseTexture2.default.addToCache(renderTexture.baseTexture, textureCacheId);
	    _Texture2.default.addToCache(renderTexture, textureCacheId);
	
	    // need to set //
	    var m = _tempMatrix;
	
	    m.tx = -bounds.x;
	    m.ty = -bounds.y;
	
	    // reset
	    this.transform.worldTransform.identity();
	
	    // set all properties to there original so we can render to a texture
	    this.renderWebGL = this._cacheData.originalRenderWebGL;
	
	    renderer.render(this, renderTexture, true, m, true);
	    // now restore the state be setting the new properties
	
	    renderer.bindRenderTarget(cachedRenderTarget);
	
	    renderer.filterManager.filterStack = stack;
	
	    this.renderWebGL = this._renderCachedWebGL;
	    this.updateTransform = this.displayObjectUpdateTransform;
	
	    this._mask = null;
	    this.filterArea = null;
	
	    // create our cached sprite
	    var cachedSprite = new core.Sprite(renderTexture);
	
	    cachedSprite.transform.worldTransform = this.transform.worldTransform;
	    cachedSprite.anchor.x = -(bounds.x / bounds.width);
	    cachedSprite.anchor.y = -(bounds.y / bounds.height);
	    cachedSprite.alpha = cacheAlpha;
	    cachedSprite._bounds = this._bounds;
	
	    // easy bounds..
	    this._calculateBounds = this._calculateCachedBounds;
	    this.getLocalBounds = this._getCachedLocalBounds;
	
	    this._cacheData.sprite = cachedSprite;
	
	    this.transform._parentID = -1;
	    // restore the transform of the cached sprite to avoid the nasty flicker..
	    if (!this.parent) {
	        this.parent = renderer._tempDisplayObjectParent;
	        this.updateTransform();
	        this.parent = null;
	    } else {
	        this.updateTransform();
	    }
	
	    // map the hit test..
	    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
	};
	
	/**
	 * Renders a cached version of the sprite with canvas
	 *
	 * @private
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._renderCachedCanvas = function _renderCachedCanvas(renderer) {
	    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	        return;
	    }
	
	    this._initCachedDisplayObjectCanvas(renderer);
	
	    this._cacheData.sprite.worldAlpha = this.worldAlpha;
	
	    this._cacheData.sprite.renderCanvas(renderer);
	};
	
	// TODO this can be the same as the webGL verison.. will need to do a little tweaking first though..
	/**
	 * Prepares the Canvas renderer to cache the sprite
	 *
	 * @private
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._initCachedDisplayObjectCanvas = function _initCachedDisplayObjectCanvas(renderer) {
	    if (this._cacheData && this._cacheData.sprite) {
	        return;
	    }
	
	    // get bounds actually transforms the object for us already!
	    var bounds = this.getLocalBounds();
	
	    var cacheAlpha = this.alpha;
	
	    this.alpha = 1;
	
	    var cachedRenderTarget = renderer.context;
	
	    var renderTexture = core.RenderTexture.create(bounds.width | 0, bounds.height | 0);
	
	    var textureCacheId = 'cacheAsBitmap_' + (0, _utils.uid)();
	
	    this._cacheData.textureCacheId = textureCacheId;
	
	    _BaseTexture2.default.addToCache(renderTexture.baseTexture, textureCacheId);
	    _Texture2.default.addToCache(renderTexture, textureCacheId);
	
	    // need to set //
	    var m = _tempMatrix;
	
	    this.transform.localTransform.copy(m);
	    m.invert();
	
	    m.tx -= bounds.x;
	    m.ty -= bounds.y;
	
	    // m.append(this.transform.worldTransform.)
	    // set all properties to there original so we can render to a texture
	    this.renderCanvas = this._cacheData.originalRenderCanvas;
	
	    // renderTexture.render(this, m, true);
	    renderer.render(this, renderTexture, true, m, false);
	
	    // now restore the state be setting the new properties
	    renderer.context = cachedRenderTarget;
	
	    this.renderCanvas = this._renderCachedCanvas;
	    this._calculateBounds = this._calculateCachedBounds;
	
	    this._mask = null;
	    this.filterArea = null;
	
	    // create our cached sprite
	    var cachedSprite = new core.Sprite(renderTexture);
	
	    cachedSprite.transform.worldTransform = this.transform.worldTransform;
	    cachedSprite.anchor.x = -(bounds.x / bounds.width);
	    cachedSprite.anchor.y = -(bounds.y / bounds.height);
	    cachedSprite._bounds = this._bounds;
	    cachedSprite.alpha = cacheAlpha;
	
	    if (!this.parent) {
	        this.parent = renderer._tempDisplayObjectParent;
	        this.updateTransform();
	        this.parent = null;
	    } else {
	        this.updateTransform();
	    }
	
	    this.updateTransform = this.displayObjectUpdateTransform;
	
	    this._cacheData.sprite = cachedSprite;
	
	    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
	};
	
	/**
	 * Calculates the bounds of the cached sprite
	 *
	 * @private
	 */
	DisplayObject.prototype._calculateCachedBounds = function _calculateCachedBounds() {
	    this._cacheData.sprite._calculateBounds();
	};
	
	/**
	 * Gets the bounds of the cached sprite.
	 *
	 * @private
	 * @return {Rectangle} The local bounds.
	 */
	DisplayObject.prototype._getCachedLocalBounds = function _getCachedLocalBounds() {
	    return this._cacheData.sprite.getLocalBounds();
	};
	
	/**
	 * Destroys the cached sprite.
	 *
	 * @private
	 */
	DisplayObject.prototype._destroyCachedDisplayObject = function _destroyCachedDisplayObject() {
	    this._cacheData.sprite._texture.destroy(true);
	    this._cacheData.sprite = null;
	
	    _BaseTexture2.default.removeFromCache(this._cacheData.textureCacheId);
	    _Texture2.default.removeFromCache(this._cacheData.textureCacheId);
	
	    this._cacheData.textureCacheId = null;
	};
	
	/**
	 * Destroys the cached object.
	 *
	 * @private
	 * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	 *  have been set to that value.
	 *  Used when destroying containers, see the Container.destroy method.
	 */
	DisplayObject.prototype._cacheAsBitmapDestroy = function _cacheAsBitmapDestroy(options) {
	    this.cacheAsBitmap = false;
	    this.destroy(options);
	};
	//# sourceMappingURL=cacheAsBitmap.js.map

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * The instance name of the object.
	 *
	 * @memberof PIXI.DisplayObject#
	 * @member {string} name
	 */
	core.DisplayObject.prototype.name = null;
	
	/**
	 * Returns the display object in the container
	 *
	 * @method getChildByName
	 * @memberof PIXI.Container#
	 * @param {string} name - instance name
	 * @return {PIXI.DisplayObject} The child with the specified name.
	 */
	core.Container.prototype.getChildByName = function getChildByName(name) {
	    for (var i = 0; i < this.children.length; i++) {
	        if (this.children[i].name === name) {
	            return this.children[i];
	        }
	    }
	
	    return null;
	};
	//# sourceMappingURL=getChildByName.js.map

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Returns the global position of the displayObject. Does not depend on object scale, rotation and pivot.
	 *
	 * @method getGlobalPosition
	 * @memberof PIXI.DisplayObject#
	 * @param {Point} point - the point to write the global value to. If null a new point will be returned
	 * @param {boolean} skipUpdate - setting to true will stop the transforms of the scene graph from
	 *  being updated. This means the calculation returned MAY be out of date BUT will give you a
	 *  nice performance boost
	 * @return {Point} The updated point
	 */
	core.DisplayObject.prototype.getGlobalPosition = function getGlobalPosition() {
	    var point = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new core.Point();
	    var skipUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (this.parent) {
	        this.parent.toGlobal(this.position, point, skipUpdate);
	    } else {
	        point.x = this.position.x;
	        point.y = this.position.y;
	    }
	
	    return point;
	};
	//# sourceMappingURL=getGlobalPosition.js.map

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FXAAFilter = __webpack_require__(338);
	
	Object.defineProperty(exports, 'FXAAFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FXAAFilter).default;
	  }
	});
	
	var _NoiseFilter = __webpack_require__(339);
	
	Object.defineProperty(exports, 'NoiseFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NoiseFilter).default;
	  }
	});
	
	var _DisplacementFilter = __webpack_require__(340);
	
	Object.defineProperty(exports, 'DisplacementFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DisplacementFilter).default;
	  }
	});
	
	var _BlurFilter = __webpack_require__(341);
	
	Object.defineProperty(exports, 'BlurFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlurFilter).default;
	  }
	});
	
	var _BlurXFilter = __webpack_require__(342);
	
	Object.defineProperty(exports, 'BlurXFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlurXFilter).default;
	  }
	});
	
	var _BlurYFilter = __webpack_require__(346);
	
	Object.defineProperty(exports, 'BlurYFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlurYFilter).default;
	  }
	});
	
	var _ColorMatrixFilter = __webpack_require__(347);
	
	Object.defineProperty(exports, 'ColorMatrixFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorMatrixFilter).default;
	  }
	});
	
	var _AlphaFilter = __webpack_require__(348);
	
	Object.defineProperty(exports, 'AlphaFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AlphaFilter).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _path = __webpack_require__(285);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 *
	 * Basic FXAA implementation based on the code on geeks3d.com with the
	 * modification that the texture2DLod stuff was removed since it's
	 * unsupported by WebGL.
	 *
	 * @see https://github.com/mitsuhiko/webgl-meincraft
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 *
	 */
	var FXAAFilter = function (_core$Filter) {
	    _inherits(FXAAFilter, _core$Filter);
	
	    /**
	     *
	     */
	    function FXAAFilter() {
	        _classCallCheck(this, FXAAFilter);
	
	        // TODO - needs work
	        return _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        '\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nuniform vec4 filterArea;\n\nvarying vec2 vTextureCoord;\n\nvec2 mapCoord( vec2 coord )\n{\n    coord *= filterArea.xy;\n    coord += filterArea.zw;\n\n    return coord;\n}\n\nvec2 unmapCoord( vec2 coord )\n{\n    coord -= filterArea.zw;\n    coord /= filterArea.xy;\n\n    return coord;\n}\n\nvoid texcoords(vec2 fragCoord, vec2 resolution,\n               out vec2 v_rgbNW, out vec2 v_rgbNE,\n               out vec2 v_rgbSW, out vec2 v_rgbSE,\n               out vec2 v_rgbM) {\n    vec2 inverseVP = 1.0 / resolution.xy;\n    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;\n    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;\n    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;\n    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;\n    v_rgbM = vec2(fragCoord * inverseVP);\n}\n\nvoid main(void) {\n\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n   vTextureCoord = aTextureCoord;\n\n   vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n   texcoords(fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n}',
	        // fragment shader
	        'varying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform vec4 filterArea;\n\n/**\n Basic FXAA implementation based on the code on geeks3d.com with the\n modification that the texture2DLod stuff was removed since it\'s\n unsupported by WebGL.\n \n --\n \n From:\n https://github.com/mitsuhiko/webgl-meincraft\n \n Copyright (c) 2011 by Armin Ronacher.\n \n Some rights reserved.\n \n Redistribution and use in source and binary forms, with or without\n modification, are permitted provided that the following conditions are\n met:\n \n * Redistributions of source code must retain the above copyright\n notice, this list of conditions and the following disclaimer.\n \n * Redistributions in binary form must reproduce the above\n copyright notice, this list of conditions and the following\n disclaimer in the documentation and/or other materials provided\n with the distribution.\n \n * The names of the contributors may not be used to endorse or\n promote products derived from this software without specific\n prior written permission.\n \n THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS\n "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT\n LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR\n A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT\n OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,\n SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT\n LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,\n DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY\n THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n */\n\n#ifndef FXAA_REDUCE_MIN\n#define FXAA_REDUCE_MIN   (1.0/ 128.0)\n#endif\n#ifndef FXAA_REDUCE_MUL\n#define FXAA_REDUCE_MUL   (1.0 / 8.0)\n#endif\n#ifndef FXAA_SPAN_MAX\n#define FXAA_SPAN_MAX     8.0\n#endif\n\n//optimized version for mobile, where dependent\n//texture reads can be a bottleneck\nvec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 resolution,\n          vec2 v_rgbNW, vec2 v_rgbNE,\n          vec2 v_rgbSW, vec2 v_rgbSE,\n          vec2 v_rgbM) {\n    vec4 color;\n    mediump vec2 inverseVP = vec2(1.0 / resolution.x, 1.0 / resolution.y);\n    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;\n    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;\n    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;\n    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;\n    vec4 texColor = texture2D(tex, v_rgbM);\n    vec3 rgbM  = texColor.xyz;\n    vec3 luma = vec3(0.299, 0.587, 0.114);\n    float lumaNW = dot(rgbNW, luma);\n    float lumaNE = dot(rgbNE, luma);\n    float lumaSW = dot(rgbSW, luma);\n    float lumaSE = dot(rgbSE, luma);\n    float lumaM  = dot(rgbM,  luma);\n    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));\n    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));\n    \n    mediump vec2 dir;\n    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));\n    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));\n    \n    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *\n                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);\n    \n    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);\n    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),\n              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),\n                  dir * rcpDirMin)) * inverseVP;\n    \n    vec3 rgbA = 0.5 * (\n                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +\n                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);\n    vec3 rgbB = rgbA * 0.5 + 0.25 * (\n                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +\n                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);\n    \n    float lumaB = dot(rgbB, luma);\n    if ((lumaB < lumaMin) || (lumaB > lumaMax))\n        color = vec4(rgbA, texColor.a);\n    else\n        color = vec4(rgbB, texColor.a);\n    return color;\n}\n\nvoid main() {\n\n      vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n      vec4 color;\n\n    color = fxaa(uSampler, fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n\n      gl_FragColor = color;\n}\n'));
	    }
	
	    return FXAAFilter;
	}(core.Filter);
	
	exports.default = FXAAFilter;
	//# sourceMappingURL=FXAAFilter.js.map

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _path = __webpack_require__(285);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @author Vico @vicocotea
	 * original filter: https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/noise.js
	 */
	
	/**
	 * A Noise effect filter.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var NoiseFilter = function (_core$Filter) {
	    _inherits(NoiseFilter, _core$Filter);
	
	    /**
	     * @param {number} noise - The noise intensity, should be a normalized value in the range [0, 1].
	     * @param {number} seed - A random seed for the noise generation. Default is `Math.random()`.
	     */
	    function NoiseFilter() {
	        var noise = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
	        var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Math.random();
	
	        _classCallCheck(this, NoiseFilter);
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
	        // fragment shader
	        'precision highp float;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform float uNoise;\nuniform float uSeed;\nuniform sampler2D uSampler;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture2D(uSampler, vTextureCoord);\n    float randomValue = rand(gl_FragCoord.xy * uSeed);\n    float diff = (randomValue - 0.5) * uNoise;\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n    }\n\n    color.r += diff;\n    color.g += diff;\n    color.b += diff;\n\n    // Premultiply alpha again.\n    color.rgb *= color.a;\n\n    gl_FragColor = color;\n}\n'));
	
	        _this.noise = noise;
	        _this.seed = seed;
	        return _this;
	    }
	
	    /**
	     * The amount of noise to apply, this value should be in the range (0, 1].
	     *
	     * @member {number}
	     * @default 0.5
	     */
	
	
	    _createClass(NoiseFilter, [{
	        key: 'noise',
	        get: function get() {
	            return this.uniforms.uNoise;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.uNoise = value;
	        }
	
	        /**
	         * A seed value to apply to the random noise generation. `Math.random()` is a good value to use.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'seed',
	        get: function get() {
	            return this.uniforms.uSeed;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.uSeed = value;
	        }
	    }]);
	
	    return NoiseFilter;
	}(core.Filter);
	
	exports.default = NoiseFilter;
	//# sourceMappingURL=NoiseFilter.js.map

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _path = __webpack_require__(285);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The DisplacementFilter class uses the pixel values from the specified texture
	 * (called the displacement map) to perform a displacement of an object. You can
	 * use this filter to apply all manor of crazy warping effects. Currently the r
	 * property of the texture is used to offset the x and the g property of the texture
	 * is used to offset the y.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var DisplacementFilter = function (_core$Filter) {
	    _inherits(DisplacementFilter, _core$Filter);
	
	    /**
	     * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
	     * @param {number} scale - The scale of the displacement
	     */
	    function DisplacementFilter(sprite, scale) {
	        _classCallCheck(this, DisplacementFilter);
	
	        var maskMatrix = new core.Matrix();
	
	        sprite.renderable = false;
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 filterMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nvoid main(void)\n{\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n   vTextureCoord = aTextureCoord;\n}',
	        // fragment shader
	        'varying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform vec2 scale;\n\nuniform sampler2D uSampler;\nuniform sampler2D mapSampler;\n\nuniform vec4 filterArea;\nuniform vec4 filterClamp;\n\nvoid main(void)\n{\n  vec4 map =  texture2D(mapSampler, vFilterCoord);\n\n  map -= 0.5;\n  map.xy *= scale / filterArea.xy;\n\n  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), filterClamp.xy, filterClamp.zw));\n}\n'));
	
	        _this.maskSprite = sprite;
	        _this.maskMatrix = maskMatrix;
	
	        _this.uniforms.mapSampler = sprite._texture;
	        _this.uniforms.filterMatrix = maskMatrix;
	        _this.uniforms.scale = { x: 1, y: 1 };
	
	        if (scale === null || scale === undefined) {
	            scale = 20;
	        }
	
	        _this.scale = new core.Point(scale, scale);
	        return _this;
	    }
	
	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.FilterManager} filterManager - The manager.
	     * @param {PIXI.RenderTarget} input - The input target.
	     * @param {PIXI.RenderTarget} output - The output target.
	     */
	
	
	    DisplacementFilter.prototype.apply = function apply(filterManager, input, output) {
	        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
	        this.uniforms.scale.x = this.scale.x;
	        this.uniforms.scale.y = this.scale.y;
	
	        // draw the filter...
	        filterManager.applyFilter(this, input, output);
	    };
	
	    /**
	     * The texture used for the displacement map. Must be power of 2 sized texture.
	     *
	     * @member {PIXI.Texture}
	     */
	
	
	    _createClass(DisplacementFilter, [{
	        key: 'map',
	        get: function get() {
	            return this.uniforms.mapSampler;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.mapSampler = value;
	        }
	    }]);
	
	    return DisplacementFilter;
	}(core.Filter);
	
	exports.default = DisplacementFilter;
	//# sourceMappingURL=DisplacementFilter.js.map

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _BlurXFilter = __webpack_require__(342);
	
	var _BlurXFilter2 = _interopRequireDefault(_BlurXFilter);
	
	var _BlurYFilter = __webpack_require__(346);
	
	var _BlurYFilter2 = _interopRequireDefault(_BlurYFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The BlurFilter applies a Gaussian blur to an object.
	 * The strength of the blur can be set for x- and y-axis separately.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var BlurFilter = function (_core$Filter) {
	    _inherits(BlurFilter, _core$Filter);
	
	    /**
	     * @param {number} strength - The strength of the blur filter.
	     * @param {number} quality - The quality of the blur filter.
	     * @param {number} resolution - The resolution of the blur filter.
	     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
	     */
	    function BlurFilter(strength, quality, resolution, kernelSize) {
	        _classCallCheck(this, BlurFilter);
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this));
	
	        _this.blurXFilter = new _BlurXFilter2.default(strength, quality, resolution, kernelSize);
	        _this.blurYFilter = new _BlurYFilter2.default(strength, quality, resolution, kernelSize);
	
	        _this.padding = 0;
	        _this.resolution = resolution || core.settings.RESOLUTION;
	        _this.quality = quality || 4;
	        _this.blur = strength || 8;
	        return _this;
	    }
	
	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.FilterManager} filterManager - The manager.
	     * @param {PIXI.RenderTarget} input - The input target.
	     * @param {PIXI.RenderTarget} output - The output target.
	     */
	
	
	    BlurFilter.prototype.apply = function apply(filterManager, input, output) {
	        var renderTarget = filterManager.getRenderTarget(true);
	
	        this.blurXFilter.apply(filterManager, input, renderTarget, true);
	        this.blurYFilter.apply(filterManager, renderTarget, output, false);
	
	        filterManager.returnRenderTarget(renderTarget);
	    };
	
	    /**
	     * Sets the strength of both the blurX and blurY properties simultaneously
	     *
	     * @member {number}
	     * @default 2
	     */
	
	
	    _createClass(BlurFilter, [{
	        key: 'blur',
	        get: function get() {
	            return this.blurXFilter.blur;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurXFilter.blur = this.blurYFilter.blur = value;
	            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
	        }
	
	        /**
	         * Sets the number of passes for blur. More passes means higher quaility bluring.
	         *
	         * @member {number}
	         * @default 1
	         */
	
	    }, {
	        key: 'quality',
	        get: function get() {
	            return this.blurXFilter.quality;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurXFilter.quality = this.blurYFilter.quality = value;
	        }
	
	        /**
	         * Sets the strength of the blurX property
	         *
	         * @member {number}
	         * @default 2
	         */
	
	    }, {
	        key: 'blurX',
	        get: function get() {
	            return this.blurXFilter.blur;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurXFilter.blur = value;
	            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
	        }
	
	        /**
	         * Sets the strength of the blurY property
	         *
	         * @member {number}
	         * @default 2
	         */
	
	    }, {
	        key: 'blurY',
	        get: function get() {
	            return this.blurYFilter.blur;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurYFilter.blur = value;
	            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
	        }
	
	        /**
	         * Sets the blendmode of the filter
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         */
	
	    }, {
	        key: 'blendMode',
	        get: function get() {
	            return this.blurYFilter._blendMode;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurYFilter._blendMode = value;
	        }
	    }]);
	
	    return BlurFilter;
	}(core.Filter);
	
	exports.default = BlurFilter;
	//# sourceMappingURL=BlurFilter.js.map

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _generateBlurVertSource = __webpack_require__(343);
	
	var _generateBlurVertSource2 = _interopRequireDefault(_generateBlurVertSource);
	
	var _generateBlurFragSource = __webpack_require__(344);
	
	var _generateBlurFragSource2 = _interopRequireDefault(_generateBlurFragSource);
	
	var _getMaxBlurKernelSize = __webpack_require__(345);
	
	var _getMaxBlurKernelSize2 = _interopRequireDefault(_getMaxBlurKernelSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The BlurXFilter applies a horizontal Gaussian blur to an object.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var BlurXFilter = function (_core$Filter) {
	    _inherits(BlurXFilter, _core$Filter);
	
	    /**
	     * @param {number} strength - The strength of the blur filter.
	     * @param {number} quality - The quality of the blur filter.
	     * @param {number} resolution - The resolution of the blur filter.
	     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
	     */
	    function BlurXFilter(strength, quality, resolution, kernelSize) {
	        _classCallCheck(this, BlurXFilter);
	
	        kernelSize = kernelSize || 5;
	        var vertSrc = (0, _generateBlurVertSource2.default)(kernelSize, true);
	        var fragSrc = (0, _generateBlurFragSource2.default)(kernelSize);
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        vertSrc,
	        // fragment shader
	        fragSrc));
	
	        _this.resolution = resolution || core.settings.RESOLUTION;
	
	        _this._quality = 0;
	
	        _this.quality = quality || 4;
	        _this.strength = strength || 8;
	
	        _this.firstRun = true;
	        return _this;
	    }
	
	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.FilterManager} filterManager - The manager.
	     * @param {PIXI.RenderTarget} input - The input target.
	     * @param {PIXI.RenderTarget} output - The output target.
	     * @param {boolean} clear - Should the output be cleared before rendering?
	     */
	
	
	    BlurXFilter.prototype.apply = function apply(filterManager, input, output, clear) {
	        if (this.firstRun) {
	            var gl = filterManager.renderer.gl;
	            var kernelSize = (0, _getMaxBlurKernelSize2.default)(gl);
	
	            this.vertexSrc = (0, _generateBlurVertSource2.default)(kernelSize, true);
	            this.fragmentSrc = (0, _generateBlurFragSource2.default)(kernelSize);
	
	            this.firstRun = false;
	        }
	
	        this.uniforms.strength = 1 / output.size.width * (output.size.width / input.size.width);
	
	        // screen space!
	        this.uniforms.strength *= this.strength;
	        this.uniforms.strength /= this.passes; // / this.passes//Math.pow(1, this.passes);
	
	        if (this.passes === 1) {
	            filterManager.applyFilter(this, input, output, clear);
	        } else {
	            var renderTarget = filterManager.getRenderTarget(true);
	            var flip = input;
	            var flop = renderTarget;
	
	            for (var i = 0; i < this.passes - 1; i++) {
	                filterManager.applyFilter(this, flip, flop, true);
	
	                var temp = flop;
	
	                flop = flip;
	                flip = temp;
	            }
	
	            filterManager.applyFilter(this, flip, output, clear);
	
	            filterManager.returnRenderTarget(renderTarget);
	        }
	    };
	
	    /**
	     * Sets the strength of both the blur.
	     *
	     * @member {number}
	     * @default 16
	     */
	
	
	    _createClass(BlurXFilter, [{
	        key: 'blur',
	        get: function get() {
	            return this.strength;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.padding = Math.abs(value) * 2;
	            this.strength = value;
	        }
	
	        /**
	        * Sets the quality of the blur by modifying the number of passes. More passes means higher
	        * quaility bluring but the lower the performance.
	        *
	        * @member {number}
	        * @default 4
	        */
	
	    }, {
	        key: 'quality',
	        get: function get() {
	            return this._quality;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._quality = value;
	            this.passes = value;
	        }
	    }]);
	
	    return BlurXFilter;
	}(core.Filter);
	
	exports.default = BlurXFilter;
	//# sourceMappingURL=BlurXFilter.js.map

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = generateVertBlurSource;
	var vertTemplate = ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'uniform float strength;', 'uniform mat3 projectionMatrix;', 'varying vec2 vBlurTexCoords[%size%];', 'void main(void)', '{', 'gl_Position = vec4((projectionMatrix * vec3((aVertexPosition), 1.0)).xy, 0.0, 1.0);', '%blur%', '}'].join('\n');
	
	function generateVertBlurSource(kernelSize, x) {
	    var halfLength = Math.ceil(kernelSize / 2);
	
	    var vertSource = vertTemplate;
	
	    var blurLoop = '';
	    var template = void 0;
	    // let value;
	
	    if (x) {
	        template = 'vBlurTexCoords[%index%] = aTextureCoord + vec2(%sampleIndex% * strength, 0.0);';
	    } else {
	        template = 'vBlurTexCoords[%index%] = aTextureCoord + vec2(0.0, %sampleIndex% * strength);';
	    }
	
	    for (var i = 0; i < kernelSize; i++) {
	        var blur = template.replace('%index%', i);
	
	        // value = i;
	
	        // if(i >= halfLength)
	        // {
	        //     value = kernelSize - i - 1;
	        // }
	
	        blur = blur.replace('%sampleIndex%', i - (halfLength - 1) + '.0');
	
	        blurLoop += blur;
	        blurLoop += '\n';
	    }
	
	    vertSource = vertSource.replace('%blur%', blurLoop);
	    vertSource = vertSource.replace('%size%', kernelSize);
	
	    return vertSource;
	}
	//# sourceMappingURL=generateBlurVertSource.js.map

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = generateFragBlurSource;
	var GAUSSIAN_VALUES = {
	    5: [0.153388, 0.221461, 0.250301],
	    7: [0.071303, 0.131514, 0.189879, 0.214607],
	    9: [0.028532, 0.067234, 0.124009, 0.179044, 0.20236],
	    11: [0.0093, 0.028002, 0.065984, 0.121703, 0.175713, 0.198596],
	    13: [0.002406, 0.009255, 0.027867, 0.065666, 0.121117, 0.174868, 0.197641],
	    15: [0.000489, 0.002403, 0.009246, 0.02784, 0.065602, 0.120999, 0.174697, 0.197448]
	};
	
	var fragTemplate = ['varying vec2 vBlurTexCoords[%size%];', 'uniform sampler2D uSampler;', 'void main(void)', '{', '    gl_FragColor = vec4(0.0);', '    %blur%', '}'].join('\n');
	
	function generateFragBlurSource(kernelSize) {
	    var kernel = GAUSSIAN_VALUES[kernelSize];
	    var halfLength = kernel.length;
	
	    var fragSource = fragTemplate;
	
	    var blurLoop = '';
	    var template = 'gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;';
	    var value = void 0;
	
	    for (var i = 0; i < kernelSize; i++) {
	        var blur = template.replace('%index%', i);
	
	        value = i;
	
	        if (i >= halfLength) {
	            value = kernelSize - i - 1;
	        }
	
	        blur = blur.replace('%value%', kernel[value]);
	
	        blurLoop += blur;
	        blurLoop += '\n';
	    }
	
	    fragSource = fragSource.replace('%blur%', blurLoop);
	    fragSource = fragSource.replace('%size%', kernelSize);
	
	    return fragSource;
	}
	//# sourceMappingURL=generateBlurFragSource.js.map

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getMaxKernelSize;
	function getMaxKernelSize(gl) {
	    var maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
	    var kernelSize = 15;
	
	    while (kernelSize > maxVaryings) {
	        kernelSize -= 2;
	    }
	
	    return kernelSize;
	}
	//# sourceMappingURL=getMaxBlurKernelSize.js.map

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _generateBlurVertSource = __webpack_require__(343);
	
	var _generateBlurVertSource2 = _interopRequireDefault(_generateBlurVertSource);
	
	var _generateBlurFragSource = __webpack_require__(344);
	
	var _generateBlurFragSource2 = _interopRequireDefault(_generateBlurFragSource);
	
	var _getMaxBlurKernelSize = __webpack_require__(345);
	
	var _getMaxBlurKernelSize2 = _interopRequireDefault(_getMaxBlurKernelSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The BlurYFilter applies a horizontal Gaussian blur to an object.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var BlurYFilter = function (_core$Filter) {
	    _inherits(BlurYFilter, _core$Filter);
	
	    /**
	     * @param {number} strength - The strength of the blur filter.
	     * @param {number} quality - The quality of the blur filter.
	     * @param {number} resolution - The resolution of the blur filter.
	     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
	     */
	    function BlurYFilter(strength, quality, resolution, kernelSize) {
	        _classCallCheck(this, BlurYFilter);
	
	        kernelSize = kernelSize || 5;
	        var vertSrc = (0, _generateBlurVertSource2.default)(kernelSize, false);
	        var fragSrc = (0, _generateBlurFragSource2.default)(kernelSize);
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        vertSrc,
	        // fragment shader
	        fragSrc));
	
	        _this.resolution = resolution || core.settings.RESOLUTION;
	
	        _this._quality = 0;
	
	        _this.quality = quality || 4;
	        _this.strength = strength || 8;
	
	        _this.firstRun = true;
	        return _this;
	    }
	
	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.FilterManager} filterManager - The manager.
	     * @param {PIXI.RenderTarget} input - The input target.
	     * @param {PIXI.RenderTarget} output - The output target.
	     * @param {boolean} clear - Should the output be cleared before rendering?
	     */
	
	
	    BlurYFilter.prototype.apply = function apply(filterManager, input, output, clear) {
	        if (this.firstRun) {
	            var gl = filterManager.renderer.gl;
	            var kernelSize = (0, _getMaxBlurKernelSize2.default)(gl);
	
	            this.vertexSrc = (0, _generateBlurVertSource2.default)(kernelSize, false);
	            this.fragmentSrc = (0, _generateBlurFragSource2.default)(kernelSize);
	
	            this.firstRun = false;
	        }
	
	        this.uniforms.strength = 1 / output.size.height * (output.size.height / input.size.height);
	
	        this.uniforms.strength *= this.strength;
	        this.uniforms.strength /= this.passes;
	
	        if (this.passes === 1) {
	            filterManager.applyFilter(this, input, output, clear);
	        } else {
	            var renderTarget = filterManager.getRenderTarget(true);
	            var flip = input;
	            var flop = renderTarget;
	
	            for (var i = 0; i < this.passes - 1; i++) {
	                filterManager.applyFilter(this, flip, flop, true);
	
	                var temp = flop;
	
	                flop = flip;
	                flip = temp;
	            }
	
	            filterManager.applyFilter(this, flip, output, clear);
	
	            filterManager.returnRenderTarget(renderTarget);
	        }
	    };
	
	    /**
	     * Sets the strength of both the blur.
	     *
	     * @member {number}
	     * @default 2
	     */
	
	
	    _createClass(BlurYFilter, [{
	        key: 'blur',
	        get: function get() {
	            return this.strength;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.padding = Math.abs(value) * 2;
	            this.strength = value;
	        }
	
	        /**
	         * Sets the quality of the blur by modifying the number of passes. More passes means higher
	         * quaility bluring but the lower the performance.
	         *
	         * @member {number}
	         * @default 4
	         */
	
	    }, {
	        key: 'quality',
	        get: function get() {
	            return this._quality;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._quality = value;
	            this.passes = value;
	        }
	    }]);
	
	    return BlurYFilter;
	}(core.Filter);
	
	exports.default = BlurYFilter;
	//# sourceMappingURL=BlurYFilter.js.map

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _path = __webpack_require__(285);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The ColorMatrixFilter class lets you apply a 5x4 matrix transformation on the RGBA
	 * color and alpha values of every pixel on your displayObject to produce a result
	 * with a new set of RGBA color and alpha values. It's pretty powerful!
	 *
	 * ```js
	 *  let colorMatrix = new PIXI.filters.ColorMatrixFilter();
	 *  container.filters = [colorMatrix];
	 *  colorMatrix.contrast(2);
	 * ```
	 * @author Clément Chenebault <clement@goodboydigital.com>
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var ColorMatrixFilter = function (_core$Filter) {
	    _inherits(ColorMatrixFilter, _core$Filter);
	
	    /**
	     *
	     */
	    function ColorMatrixFilter() {
	        _classCallCheck(this, ColorMatrixFilter);
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
	        // fragment shader
	        'varying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform float m[20];\nuniform float uAlpha;\n\nvoid main(void)\n{\n    vec4 c = texture2D(uSampler, vTextureCoord);\n\n    if (uAlpha == 0.0) {\n        gl_FragColor = c;\n        return;\n    }\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (c.a > 0.0) {\n      c.rgb /= c.a;\n    }\n\n    vec4 result;\n\n    result.r = (m[0] * c.r);\n        result.r += (m[1] * c.g);\n        result.r += (m[2] * c.b);\n        result.r += (m[3] * c.a);\n        result.r += m[4];\n\n    result.g = (m[5] * c.r);\n        result.g += (m[6] * c.g);\n        result.g += (m[7] * c.b);\n        result.g += (m[8] * c.a);\n        result.g += m[9];\n\n    result.b = (m[10] * c.r);\n       result.b += (m[11] * c.g);\n       result.b += (m[12] * c.b);\n       result.b += (m[13] * c.a);\n       result.b += m[14];\n\n    result.a = (m[15] * c.r);\n       result.a += (m[16] * c.g);\n       result.a += (m[17] * c.b);\n       result.a += (m[18] * c.a);\n       result.a += m[19];\n\n    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);\n\n    // Premultiply alpha again.\n    rgb *= result.a;\n\n    gl_FragColor = vec4(rgb, result.a);\n}\n'));
	
	        _this.uniforms.m = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];
	
	        _this.alpha = 1;
	        return _this;
	    }
	
	    /**
	     * Transforms current matrix and set the new one
	     *
	     * @param {number[]} matrix - 5x4 matrix
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype._loadMatrix = function _loadMatrix(matrix) {
	        var multiply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var newMatrix = matrix;
	
	        if (multiply) {
	            this._multiply(newMatrix, this.uniforms.m, matrix);
	            newMatrix = this._colorMatrix(newMatrix);
	        }
	
	        // set the new matrix
	        this.uniforms.m = newMatrix;
	    };
	
	    /**
	     * Multiplies two mat5's
	     *
	     * @private
	     * @param {number[]} out - 5x4 matrix the receiving matrix
	     * @param {number[]} a - 5x4 matrix the first operand
	     * @param {number[]} b - 5x4 matrix the second operand
	     * @returns {number[]} 5x4 matrix
	     */
	
	
	    ColorMatrixFilter.prototype._multiply = function _multiply(out, a, b) {
	        // Red Channel
	        out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15];
	        out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16];
	        out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17];
	        out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18];
	        out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4];
	
	        // Green Channel
	        out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15];
	        out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16];
	        out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17];
	        out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18];
	        out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9];
	
	        // Blue Channel
	        out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15];
	        out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16];
	        out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17];
	        out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18];
	        out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14];
	
	        // Alpha Channel
	        out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15];
	        out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16];
	        out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17];
	        out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18];
	        out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19];
	
	        return out;
	    };
	
	    /**
	     * Create a Float32 Array and normalize the offset component to 0-1
	     *
	     * @private
	     * @param {number[]} matrix - 5x4 matrix
	     * @return {number[]} 5x4 matrix with all values between 0-1
	     */
	
	
	    ColorMatrixFilter.prototype._colorMatrix = function _colorMatrix(matrix) {
	        // Create a Float32 Array and normalize the offset component to 0-1
	        var m = new Float32Array(matrix);
	
	        m[4] /= 255;
	        m[9] /= 255;
	        m[14] /= 255;
	        m[19] /= 255;
	
	        return m;
	    };
	
	    /**
	     * Adjusts brightness
	     *
	     * @param {number} b - value of the brigthness (0-1, where 0 is black)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.brightness = function brightness(b, multiply) {
	        var matrix = [b, 0, 0, 0, 0, 0, b, 0, 0, 0, 0, 0, b, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Set the matrices in grey scales
	     *
	     * @param {number} scale - value of the grey (0-1, where 0 is black)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.greyscale = function greyscale(scale, multiply) {
	        var matrix = [scale, scale, scale, 0, 0, scale, scale, scale, 0, 0, scale, scale, scale, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Set the black and white matrice.
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.blackAndWhite = function blackAndWhite(multiply) {
	        var matrix = [0.3, 0.6, 0.1, 0, 0, 0.3, 0.6, 0.1, 0, 0, 0.3, 0.6, 0.1, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Set the hue property of the color
	     *
	     * @param {number} rotation - in degrees
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.hue = function hue(rotation, multiply) {
	        rotation = (rotation || 0) / 180 * Math.PI;
	
	        var cosR = Math.cos(rotation);
	        var sinR = Math.sin(rotation);
	        var sqrt = Math.sqrt;
	
	        /* a good approximation for hue rotation
	         This matrix is far better than the versions with magic luminance constants
	         formerly used here, but also used in the starling framework (flash) and known from this
	         old part of the internet: quasimondo.com/archives/000565.php
	          This new matrix is based on rgb cube rotation in space. Look here for a more descriptive
	         implementation as a shader not a general matrix:
	         https://github.com/evanw/glfx.js/blob/58841c23919bd59787effc0333a4897b43835412/src/filters/adjust/huesaturation.js
	          This is the source for the code:
	         see http://stackoverflow.com/questions/8507885/shift-hue-of-an-rgb-color/8510751#8510751
	         */
	
	        var w = 1 / 3;
	        var sqrW = sqrt(w); // weight is
	
	        var a00 = cosR + (1.0 - cosR) * w;
	        var a01 = w * (1.0 - cosR) - sqrW * sinR;
	        var a02 = w * (1.0 - cosR) + sqrW * sinR;
	
	        var a10 = w * (1.0 - cosR) + sqrW * sinR;
	        var a11 = cosR + w * (1.0 - cosR);
	        var a12 = w * (1.0 - cosR) - sqrW * sinR;
	
	        var a20 = w * (1.0 - cosR) - sqrW * sinR;
	        var a21 = w * (1.0 - cosR) + sqrW * sinR;
	        var a22 = cosR + w * (1.0 - cosR);
	
	        var matrix = [a00, a01, a02, 0, 0, a10, a11, a12, 0, 0, a20, a21, a22, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Set the contrast matrix, increase the separation between dark and bright
	     * Increase contrast : shadows darker and highlights brighter
	     * Decrease contrast : bring the shadows up and the highlights down
	     *
	     * @param {number} amount - value of the contrast (0-1)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.contrast = function contrast(amount, multiply) {
	        var v = (amount || 0) + 1;
	        var o = -0.5 * (v - 1);
	
	        var matrix = [v, 0, 0, 0, o, 0, v, 0, 0, o, 0, 0, v, 0, o, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Set the saturation matrix, increase the separation between colors
	     * Increase saturation : increase contrast, brightness, and sharpness
	     *
	     * @param {number} amount - The saturation amount (0-1)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.saturate = function saturate() {
	        var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var multiply = arguments[1];
	
	        var x = amount * 2 / 3 + 1;
	        var y = (x - 1) * -0.5;
	
	        var matrix = [x, y, y, 0, 0, y, x, y, 0, 0, y, y, x, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Desaturate image (remove color)
	     *
	     * Call the saturate function
	     *
	     */
	
	
	    ColorMatrixFilter.prototype.desaturate = function desaturate() // eslint-disable-line no-unused-vars
	    {
	        this.saturate(-1);
	    };
	
	    /**
	     * Negative image (inverse of classic rgb matrix)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.negative = function negative(multiply) {
	        var matrix = [-1, 0, 0, 1, 0, 0, -1, 0, 1, 0, 0, 0, -1, 1, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Sepia image
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.sepia = function sepia(multiply) {
	        var matrix = [0.393, 0.7689999, 0.18899999, 0, 0, 0.349, 0.6859999, 0.16799999, 0, 0, 0.272, 0.5339999, 0.13099999, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.technicolor = function technicolor(multiply) {
	        var matrix = [1.9125277891456083, -0.8545344976951645, -0.09155508482755585, 0, 11.793603434377337, -0.3087833385928097, 1.7658908555458428, -0.10601743074722245, 0, -70.35205161461398, -0.231103377548616, -0.7501899197440212, 1.847597816108189, 0, 30.950940869491138, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Polaroid filter
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.polaroid = function polaroid(multiply) {
	        var matrix = [1.438, -0.062, -0.062, 0, 0, -0.122, 1.378, -0.122, 0, 0, -0.016, -0.016, 1.483, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Filter who transforms : Red -> Blue and Blue -> Red
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.toBGR = function toBGR(multiply) {
	        var matrix = [0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.kodachrome = function kodachrome(multiply) {
	        var matrix = [1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502, -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203, -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Brown delicious browni filter (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.browni = function browni(multiply) {
	        var matrix = [0.5997023498159715, 0.34553243048391263, -0.2708298674538042, 0, 47.43192855600873, -0.037703249837783157, 0.8609577587992641, 0.15059552388459913, 0, -36.96841498319127, 0.24113635128153335, -0.07441037908422492, 0.44972182064877153, 0, -7.562075277591283, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Vintage filter (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.vintage = function vintage(multiply) {
	        var matrix = [0.6279345635605994, 0.3202183420819367, -0.03965408211312453, 0, 9.651285835294123, 0.02578397704808868, 0.6441188644374771, 0.03259127616149294, 0, 7.462829176470591, 0.0466055556782719, -0.0851232987247891, 0.5241648018700465, 0, 5.159190588235296, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * We don't know exactly what it does, kind of gradient map, but funny to play with!
	     *
	     * @param {number} desaturation - Tone values.
	     * @param {number} toned - Tone values.
	     * @param {string} lightColor - Tone values, example: `0xFFE580`
	     * @param {string} darkColor - Tone values, example: `0xFFE580`
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.colorTone = function colorTone(desaturation, toned, lightColor, darkColor, multiply) {
	        desaturation = desaturation || 0.2;
	        toned = toned || 0.15;
	        lightColor = lightColor || 0xFFE580;
	        darkColor = darkColor || 0x338000;
	
	        var lR = (lightColor >> 16 & 0xFF) / 255;
	        var lG = (lightColor >> 8 & 0xFF) / 255;
	        var lB = (lightColor & 0xFF) / 255;
	
	        var dR = (darkColor >> 16 & 0xFF) / 255;
	        var dG = (darkColor >> 8 & 0xFF) / 255;
	        var dB = (darkColor & 0xFF) / 255;
	
	        var matrix = [0.3, 0.59, 0.11, 0, 0, lR, lG, lB, desaturation, 0, dR, dG, dB, toned, 0, lR - dR, lG - dG, lB - dB, 0, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Night effect
	     *
	     * @param {number} intensity - The intensity of the night effect.
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.night = function night(intensity, multiply) {
	        intensity = intensity || 0.1;
	        var matrix = [intensity * -2.0, -intensity, 0, 0, 0, -intensity, 0, intensity, 0, 0, 0, intensity, intensity * 2.0, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Predator effect
	     *
	     * Erase the current matrix by setting a new indepent one
	     *
	     * @param {number} amount - how much the predator feels his future victim
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.predator = function predator(amount, multiply) {
	        var matrix = [
	        // row 1
	        11.224130630493164 * amount, -4.794486999511719 * amount, -2.8746118545532227 * amount, 0 * amount, 0.40342438220977783 * amount,
	        // row 2
	        -3.6330697536468506 * amount, 9.193157196044922 * amount, -2.951810836791992 * amount, 0 * amount, -1.316135048866272 * amount,
	        // row 3
	        -3.2184197902679443 * amount, -4.2375030517578125 * amount, 7.476448059082031 * amount, 0 * amount, 0.8044459223747253 * amount,
	        // row 4
	        0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * LSD effect
	     *
	     * Multiply the current matrix
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.lsd = function lsd(multiply) {
	        var matrix = [2, -0.4, 0.5, 0, 0, -0.5, 2, -0.4, 0, 0, -0.4, -0.5, 3, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Erase the current matrix by setting the default one
	     *
	     */
	
	
	    ColorMatrixFilter.prototype.reset = function reset() {
	        var matrix = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, false);
	    };
	
	    /**
	     * The matrix of the color matrix filter
	     *
	     * @member {number[]}
	     * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
	     */
	
	
	    _createClass(ColorMatrixFilter, [{
	        key: 'matrix',
	        get: function get() {
	            return this.uniforms.m;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.m = value;
	        }
	
	        /**
	         * The opacity value to use when mixing the original and resultant colors.
	         *
	         * When the value is 0, the original color is used without modification.
	         * When the value is 1, the result color is used.
	         * When in the range (0, 1) the color is interpolated between the original and result by this amount.
	         *
	         * @member {number}
	         * @default 1
	         */
	
	    }, {
	        key: 'alpha',
	        get: function get() {
	            return this.uniforms.uAlpha;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.uAlpha = value;
	        }
	    }]);
	
	    return ColorMatrixFilter;
	}(core.Filter);
	
	// Americanized alias
	
	
	exports.default = ColorMatrixFilter;
	ColorMatrixFilter.prototype.grayscale = ColorMatrixFilter.prototype.greyscale;
	//# sourceMappingURL=ColorMatrixFilter.js.map

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _path = __webpack_require__(285);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Simplest filter - applies alpha
	 *
	 * Use this instead of Container's alpha property to avoid visual layering of individual elements.
	 * AlphaFilter applies alpha evenly across the entire display object and any opaque elements it contains.
	 * If elements are not opaque, they will blend with each other anyway.
	 *
	 * Very handy if you want to use common features of all filters:
	 *
	 * 1. Assign a blendMode to this filter, blend all elements inside display object with background.
	 *
	 * 2. To use clipping in display coordinates, assign a filterArea to the same container that has this filter.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var AlphaFilter = function (_core$Filter) {
	    _inherits(AlphaFilter, _core$Filter);
	
	    /**
	     * @param {number} [alpha=1] Amount of alpha from 0 to 1, where 0 is transparent
	     */
	    function AlphaFilter() {
	        var alpha = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.0;
	
	        _classCallCheck(this, AlphaFilter);
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
	        // fragment shader
	        'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float uAlpha;\n\nvoid main(void)\n{\n   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;\n}\n'));
	
	        _this.alpha = alpha;
	        _this.glShaderKey = 'alpha';
	        return _this;
	    }
	
	    /**
	     * Coefficient for alpha multiplication
	     *
	     * @member {number}
	     * @default 1
	     */
	
	
	    _createClass(AlphaFilter, [{
	        key: 'alpha',
	        get: function get() {
	            return this.uniforms.uAlpha;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.uAlpha = value;
	        }
	    }]);
	
	    return AlphaFilter;
	}(core.Filter);
	
	exports.default = AlphaFilter;
	//# sourceMappingURL=AlphaFilter.js.map

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _InteractionData = __webpack_require__(350);
	
	Object.defineProperty(exports, 'InteractionData', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InteractionData).default;
	  }
	});
	
	var _InteractionManager = __webpack_require__(351);
	
	Object.defineProperty(exports, 'InteractionManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InteractionManager).default;
	  }
	});
	
	var _interactiveTarget = __webpack_require__(354);
	
	Object.defineProperty(exports, 'interactiveTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_interactiveTarget).default;
	  }
	});
	
	var _InteractionTrackingData = __webpack_require__(353);
	
	Object.defineProperty(exports, 'InteractionTrackingData', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InteractionTrackingData).default;
	  }
	});
	
	var _InteractionEvent = __webpack_require__(352);
	
	Object.defineProperty(exports, 'InteractionEvent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InteractionEvent).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Holds all information related to an Interaction event
	 *
	 * @class
	 * @memberof PIXI.interaction
	 */
	var InteractionData = function () {
	  /**
	   *
	   */
	  function InteractionData() {
	    _classCallCheck(this, InteractionData);
	
	    /**
	     * This point stores the global coords of where the touch/mouse event happened
	     *
	     * @member {PIXI.Point}
	     */
	    this.global = new core.Point();
	
	    /**
	     * The target DisplayObject that was interacted with
	     *
	     * @member {PIXI.DisplayObject}
	     */
	    this.target = null;
	
	    /**
	     * When passed to an event handler, this will be the original DOM Event that was captured
	     *
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent
	     * @member {MouseEvent|TouchEvent|PointerEvent}
	     */
	    this.originalEvent = null;
	
	    /**
	     * Unique identifier for this interaction
	     *
	     * @member {number}
	     */
	    this.identifier = null;
	
	    /**
	     * Indicates whether or not the pointer device that created the event is the primary pointer.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/isPrimary
	     * @type {Boolean}
	     */
	    this.isPrimary = false;
	
	    /**
	     * Indicates which button was pressed on the mouse or pointer device to trigger the event.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
	     * @type {number}
	     */
	    this.button = 0;
	
	    /**
	     * Indicates which buttons are pressed on the mouse or pointer device when the event is triggered.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
	     * @type {number}
	     */
	    this.buttons = 0;
	
	    /**
	     * The width of the pointer's contact along the x-axis, measured in CSS pixels.
	     * radiusX of TouchEvents will be represented by this value.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/width
	     * @type {number}
	     */
	    this.width = 0;
	
	    /**
	     * The height of the pointer's contact along the y-axis, measured in CSS pixels.
	     * radiusY of TouchEvents will be represented by this value.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/height
	     * @type {number}
	     */
	    this.height = 0;
	
	    /**
	     * The angle, in degrees, between the pointer device and the screen.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltX
	     * @type {number}
	     */
	    this.tiltX = 0;
	
	    /**
	     * The angle, in degrees, between the pointer device and the screen.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltY
	     * @type {number}
	     */
	    this.tiltY = 0;
	
	    /**
	     * The type of pointer that triggered the event.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerType
	     * @type {string}
	     */
	    this.pointerType = null;
	
	    /**
	     * Pressure applied by the pointing device during the event. A Touch's force property
	     * will be represented by this value.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pressure
	     * @type {number}
	     */
	    this.pressure = 0;
	
	    /**
	     * From TouchEvents (not PointerEvents triggered by touches), the rotationAngle of the Touch.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/Touch/rotationAngle
	     * @type {number}
	     */
	    this.rotationAngle = 0;
	
	    /**
	     * Twist of a stylus pointer.
	     * @see https://w3c.github.io/pointerevents/#pointerevent-interface
	     * @type {number}
	     */
	    this.twist = 0;
	
	    /**
	     * Barrel pressure on a stylus pointer.
	     * @see https://w3c.github.io/pointerevents/#pointerevent-interface
	     * @type {number}
	     */
	    this.tangentialPressure = 0;
	  }
	
	  /**
	   * The unique identifier of the pointer. It will be the same as `identifier`.
	   * @readonly
	   * @member {number}
	   * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerId
	   */
	
	
	  /**
	   * This will return the local coordinates of the specified displayObject for this InteractionData
	   *
	   * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
	   *  coords off
	   * @param {PIXI.Point} [point] - A Point object in which to store the value, optional (otherwise
	   *  will create a new point)
	   * @param {PIXI.Point} [globalPos] - A Point object containing your custom global coords, optional
	   *  (otherwise will use the current global coords)
	   * @return {PIXI.Point} A point containing the coordinates of the InteractionData position relative
	   *  to the DisplayObject
	   */
	  InteractionData.prototype.getLocalPosition = function getLocalPosition(displayObject, point, globalPos) {
	    return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
	  };
	
	  /**
	   * Copies properties from normalized event data.
	   *
	   * @param {Touch|MouseEvent|PointerEvent} event The normalized event data
	   */
	
	
	  InteractionData.prototype.copyEvent = function copyEvent(event) {
	    // isPrimary should only change on touchstart/pointerdown, so we don't want to overwrite
	    // it with "false" on later events when our shim for it on touch events might not be
	    // accurate
	    if (event.isPrimary) {
	      this.isPrimary = true;
	    }
	    this.button = event.button;
	    // event.buttons is not available in all browsers (ie. Safari), but it does have a non-standard
	    // event.which property instead, which conveys the same information.
	    this.buttons = Number.isInteger(event.buttons) ? event.buttons : event.which;
	    this.width = event.width;
	    this.height = event.height;
	    this.tiltX = event.tiltX;
	    this.tiltY = event.tiltY;
	    this.pointerType = event.pointerType;
	    this.pressure = event.pressure;
	    this.rotationAngle = event.rotationAngle;
	    this.twist = event.twist || 0;
	    this.tangentialPressure = event.tangentialPressure || 0;
	  };
	
	  /**
	   * Resets the data for pooling.
	   */
	
	
	  InteractionData.prototype.reset = function reset() {
	    // isPrimary is the only property that we really need to reset - everything else is
	    // guaranteed to be overwritten
	    this.isPrimary = false;
	  };
	
	  _createClass(InteractionData, [{
	    key: 'pointerId',
	    get: function get() {
	      return this.identifier;
	    }
	  }]);
	
	  return InteractionData;
	}();
	
	exports.default = InteractionData;
	//# sourceMappingURL=InteractionData.js.map

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _InteractionData = __webpack_require__(350);
	
	var _InteractionData2 = _interopRequireDefault(_InteractionData);
	
	var _InteractionEvent = __webpack_require__(352);
	
	var _InteractionEvent2 = _interopRequireDefault(_InteractionEvent);
	
	var _InteractionTrackingData = __webpack_require__(353);
	
	var _InteractionTrackingData2 = _interopRequireDefault(_InteractionTrackingData);
	
	var _eventemitter = __webpack_require__(235);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _interactiveTarget = __webpack_require__(354);
	
	var _interactiveTarget2 = _interopRequireDefault(_interactiveTarget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Mix interactiveTarget into core.DisplayObject.prototype, after deprecation has been handled
	core.utils.mixins.delayMixin(core.DisplayObject.prototype, _interactiveTarget2.default);
	
	var MOUSE_POINTER_ID = 1;
	
	// helpers for hitTest() - only used inside hitTest()
	var hitTestEvent = {
	    target: null,
	    data: {
	        global: null
	    }
	};
	
	/**
	 * The interaction manager deals with mouse, touch and pointer events. Any DisplayObject can be interactive
	 * if its interactive parameter is set to true
	 * This manager also supports multitouch.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.interaction
	 *
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI.interaction
	 */
	
	var InteractionManager = function (_EventEmitter) {
	    _inherits(InteractionManager, _EventEmitter);
	
	    /**
	     * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     * @param {object} [options] - The options for the manager.
	     * @param {boolean} [options.autoPreventDefault=true] - Should the manager automatically prevent default browser actions.
	     * @param {number} [options.interactionFrequency=10] - Frequency increases the interaction events will be checked.
	     */
	    function InteractionManager(renderer, options) {
	        _classCallCheck(this, InteractionManager);
	
	        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	        options = options || {};
	
	        /**
	         * The renderer this interaction manager works for.
	         *
	         * @member {PIXI.SystemRenderer}
	         */
	        _this.renderer = renderer;
	
	        /**
	         * Should default browser actions automatically be prevented.
	         * Does not apply to pointer events for backwards compatibility
	         * preventDefault on pointer events stops mouse events from firing
	         * Thus, for every pointer event, there will always be either a mouse of touch event alongside it.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.autoPreventDefault = options.autoPreventDefault !== undefined ? options.autoPreventDefault : true;
	
	        /**
	         * Frequency in milliseconds that the mousemove, moveover & mouseout interaction events will be checked.
	         *
	         * @member {number}
	         * @default 10
	         */
	        _this.interactionFrequency = options.interactionFrequency || 10;
	
	        /**
	         * The mouse data
	         *
	         * @member {PIXI.interaction.InteractionData}
	         */
	        _this.mouse = new _InteractionData2.default();
	        _this.mouse.identifier = MOUSE_POINTER_ID;
	
	        // setting the mouse to start off far off screen will mean that mouse over does
	        //  not get called before we even move the mouse.
	        _this.mouse.global.set(-999999);
	
	        /**
	         * Actively tracked InteractionData
	         *
	         * @private
	         * @member {Object.<number,PIXI.interation.InteractionData>}
	         */
	        _this.activeInteractionData = {};
	        _this.activeInteractionData[MOUSE_POINTER_ID] = _this.mouse;
	
	        /**
	         * Pool of unused InteractionData
	         *
	         * @private
	         * @member {PIXI.interation.InteractionData[]}
	         */
	        _this.interactionDataPool = [];
	
	        /**
	         * An event data object to handle all the event tracking/dispatching
	         *
	         * @member {object}
	         */
	        _this.eventData = new _InteractionEvent2.default();
	
	        /**
	         * The DOM element to bind to.
	         *
	         * @private
	         * @member {HTMLElement}
	         */
	        _this.interactionDOMElement = null;
	
	        /**
	         * This property determines if mousemove and touchmove events are fired only when the cursor
	         * is over the object.
	         * Setting to true will make things work more in line with how the DOM verison works.
	         * Setting to false can make things easier for things like dragging
	         * It is currently set to false as this is how PixiJS used to work. This will be set to true in
	         * future versions of pixi.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        _this.moveWhenInside = false;
	
	        /**
	         * Have events been attached to the dom element?
	         *
	         * @private
	         * @member {boolean}
	         */
	        _this.eventsAdded = false;
	
	        /**
	         * Is the mouse hovering over the renderer?
	         *
	         * @private
	         * @member {boolean}
	         */
	        _this.mouseOverRenderer = false;
	
	        /**
	         * Does the device support touch events
	         * https://www.w3.org/TR/touch-events/
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.supportsTouchEvents = 'ontouchstart' in window;
	
	        /**
	         * Does the device support pointer events
	         * https://www.w3.org/Submission/pointer-events/
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.supportsPointerEvents = !!window.PointerEvent;
	
	        // this will make it so that you don't have to call bind all the time
	
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerUp = _this.onPointerUp.bind(_this);
	        _this.processPointerUp = _this.processPointerUp.bind(_this);
	
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerCancel = _this.onPointerCancel.bind(_this);
	        _this.processPointerCancel = _this.processPointerCancel.bind(_this);
	
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerDown = _this.onPointerDown.bind(_this);
	        _this.processPointerDown = _this.processPointerDown.bind(_this);
	
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerMove = _this.onPointerMove.bind(_this);
	        _this.processPointerMove = _this.processPointerMove.bind(_this);
	
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerOut = _this.onPointerOut.bind(_this);
	        _this.processPointerOverOut = _this.processPointerOverOut.bind(_this);
	
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerOver = _this.onPointerOver.bind(_this);
	
	        /**
	         * Dictionary of how different cursor modes are handled. Strings are handled as CSS cursor
	         * values, objects are handled as dictionaries of CSS values for interactionDOMElement,
	         * and functions are called instead of changing the CSS.
	         * Default CSS cursor values are provided for 'default' and 'pointer' modes.
	         * @member {Object.<string, (string|Function|Object.<string, string>)>}
	         */
	        _this.cursorStyles = {
	            default: 'inherit',
	            pointer: 'pointer'
	        };
	
	        /**
	         * The mode of the cursor that is being used.
	         * The value of this is a key from the cursorStyles dictionary.
	         *
	         * @member {string}
	         */
	        _this.currentCursorMode = null;
	
	        /**
	         * Internal cached let.
	         *
	         * @private
	         * @member {string}
	         */
	        _this.cursor = null;
	
	        /**
	         * Internal cached let.
	         *
	         * @private
	         * @member {PIXI.Point}
	         */
	        _this._tempPoint = new core.Point();
	
	        /**
	         * The current resolution / device pixel ratio.
	         *
	         * @member {number}
	         * @default 1
	         */
	        _this.resolution = 1;
	
	        _this.setTargetElement(_this.renderer.view, _this.renderer.resolution);
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display
	         * object.
	         *
	         * @event PIXI.interaction.InteractionManager#mousedown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#rightdown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released over the display
	         * object.
	         *
	         * @event PIXI.interaction.InteractionManager#mouseup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * over the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#rightup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
	         * the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#click
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * and released on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#rightclick
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released outside the
	         * display object that initially registered a
	         * [mousedown]{@link PIXI.interaction.InteractionManager#event:mousedown}.
	         *
	         * @event PIXI.interaction.InteractionManager#mouseupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * outside the display object that initially registered a
	         * [rightdown]{@link PIXI.interaction.InteractionManager#event:rightdown}.
	         *
	         * @event PIXI.interaction.InteractionManager#rightupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device (usually a mouse) is moved while over the display object
	         *
	         * @event PIXI.interaction.InteractionManager#mousemove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device (usually a mouse) is moved onto the display object
	         *
	         * @event PIXI.interaction.InteractionManager#mouseover
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device (usually a mouse) is moved off the display object
	         *
	         * @event PIXI.interaction.InteractionManager#mouseout
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is pressed on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#pointerdown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is released over the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#pointerup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when the operating system cancels a pointer event
	         *
	         * @event PIXI.interaction.InteractionManager#pointercancel
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is pressed and released on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#pointertap
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is released outside the display object that initially
	         * registered a [pointerdown]{@link PIXI.interaction.InteractionManager#event:pointerdown}.
	         *
	         * @event PIXI.interaction.InteractionManager#pointerupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device is moved while over the display object
	         *
	         * @event PIXI.interaction.InteractionManager#pointermove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device is moved onto the display object
	         *
	         * @event PIXI.interaction.InteractionManager#pointerover
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device is moved off the display object
	         *
	         * @event PIXI.interaction.InteractionManager#pointerout
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is placed on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#touchstart
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is removed from the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#touchend
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when the operating system cancels a touch
	         *
	         * @event PIXI.interaction.InteractionManager#touchcancel
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is placed and removed from the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#tap
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is removed outside of the display object that initially
	         * registered a [touchstart]{@link PIXI.interaction.InteractionManager#event:touchstart}.
	         *
	         * @event PIXI.interaction.InteractionManager#touchendoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is moved along the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#touchmove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display.
	         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mousedown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightdown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released over the display
	         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * over the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
	         * the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#click
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * and released on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightclick
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released outside the
	         * display object that initially registered a
	         * [mousedown]{@link PIXI.DisplayObject#event:mousedown}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * outside the display object that initially registered a
	         * [rightdown]{@link PIXI.DisplayObject#event:rightdown}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device (usually a mouse) is moved while over the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mousemove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device (usually a mouse) is moved onto the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseover
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device (usually a mouse) is moved off the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseout
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is pressed on the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerdown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is released over the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when the operating system cancels a pointer event.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointercancel
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is pressed and released on the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointertap
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is released outside the display object that initially
	         * registered a [pointerdown]{@link PIXI.DisplayObject#event:pointerdown}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device is moved while over the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointermove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device is moved onto the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerover
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device is moved off the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerout
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is placed on the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchstart
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is removed from the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchend
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when the operating system cancels a touch.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchcancel
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is placed and removed from the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#tap
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is removed outside of the display object that initially
	         * registered a [touchstart]{@link PIXI.DisplayObject#event:touchstart}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchendoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is moved along the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchmove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	        return _this;
	    }
	
	    /**
	     * Hit tests a point against the display tree, returning the first interactive object that is hit.
	     *
	     * @param {PIXI.Point} globalPoint - A point to hit test with, in global space.
	     * @param {PIXI.Container} [root] - The root display object to start from. If omitted, defaults
	     * to the last rendered root of the associated renderer.
	     * @return {PIXI.DisplayObject} The hit display object, if any.
	     */
	
	
	    InteractionManager.prototype.hitTest = function hitTest(globalPoint, root) {
	        // clear the target for our hit test
	        hitTestEvent.target = null;
	        // assign the global point
	        hitTestEvent.data.global = globalPoint;
	        // ensure safety of the root
	        if (!root) {
	            root = this.renderer._lastObjectRendered;
	        }
	        // run the hit test
	        this.processInteractive(hitTestEvent, root, null, true);
	        // return our found object - it'll be null if we didn't hit anything
	
	        return hitTestEvent.target;
	    };
	
	    /**
	     * Sets the DOM element which will receive mouse/touch events. This is useful for when you have
	     * other DOM elements on top of the renderers Canvas element. With this you'll be bale to deletegate
	     * another DOM element to receive those events.
	     *
	     * @param {HTMLCanvasElement} element - the DOM element which will receive mouse and touch events.
	     * @param {number} [resolution=1] - The resolution / device pixel ratio of the new element (relative to the canvas).
	     */
	
	
	    InteractionManager.prototype.setTargetElement = function setTargetElement(element) {
	        var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	        this.removeEvents();
	
	        this.interactionDOMElement = element;
	
	        this.resolution = resolution;
	
	        this.addEvents();
	    };
	
	    /**
	     * Registers all the DOM events
	     *
	     * @private
	     */
	
	
	    InteractionManager.prototype.addEvents = function addEvents() {
	        if (!this.interactionDOMElement) {
	            return;
	        }
	
	        core.ticker.shared.add(this.update, this, core.UPDATE_PRIORITY.INTERACTION);
	
	        if (window.navigator.msPointerEnabled) {
	            this.interactionDOMElement.style['-ms-content-zooming'] = 'none';
	            this.interactionDOMElement.style['-ms-touch-action'] = 'none';
	        } else if (this.supportsPointerEvents) {
	            this.interactionDOMElement.style['touch-action'] = 'none';
	        }
	
	        /**
	         * These events are added first, so that if pointer events are normalised, they are fired
	         * in the same order as non-normalised events. ie. pointer event 1st, mouse / touch 2nd
	         */
	        if (this.supportsPointerEvents) {
	            window.document.addEventListener('pointermove', this.onPointerMove, true);
	            this.interactionDOMElement.addEventListener('pointerdown', this.onPointerDown, true);
	            // pointerout is fired in addition to pointerup (for touch events) and pointercancel
	            // we already handle those, so for the purposes of what we do in onPointerOut, we only
	            // care about the pointerleave event
	            this.interactionDOMElement.addEventListener('pointerleave', this.onPointerOut, true);
	            this.interactionDOMElement.addEventListener('pointerover', this.onPointerOver, true);
	            window.addEventListener('pointercancel', this.onPointerCancel, true);
	            window.addEventListener('pointerup', this.onPointerUp, true);
	        } else {
	            window.document.addEventListener('mousemove', this.onPointerMove, true);
	            this.interactionDOMElement.addEventListener('mousedown', this.onPointerDown, true);
	            this.interactionDOMElement.addEventListener('mouseout', this.onPointerOut, true);
	            this.interactionDOMElement.addEventListener('mouseover', this.onPointerOver, true);
	            window.addEventListener('mouseup', this.onPointerUp, true);
	        }
	
	        // always look directly for touch events so that we can provide original data
	        // In a future version we should change this to being just a fallback and rely solely on
	        // PointerEvents whenever available
	        if (this.supportsTouchEvents) {
	            this.interactionDOMElement.addEventListener('touchstart', this.onPointerDown, true);
	            this.interactionDOMElement.addEventListener('touchcancel', this.onPointerCancel, true);
	            this.interactionDOMElement.addEventListener('touchend', this.onPointerUp, true);
	            this.interactionDOMElement.addEventListener('touchmove', this.onPointerMove, true);
	        }
	
	        this.eventsAdded = true;
	    };
	
	    /**
	     * Removes all the DOM events that were previously registered
	     *
	     * @private
	     */
	
	
	    InteractionManager.prototype.removeEvents = function removeEvents() {
	        if (!this.interactionDOMElement) {
	            return;
	        }
	
	        core.ticker.shared.remove(this.update, this);
	
	        if (window.navigator.msPointerEnabled) {
	            this.interactionDOMElement.style['-ms-content-zooming'] = '';
	            this.interactionDOMElement.style['-ms-touch-action'] = '';
	        } else if (this.supportsPointerEvents) {
	            this.interactionDOMElement.style['touch-action'] = '';
	        }
	
	        if (this.supportsPointerEvents) {
	            window.document.removeEventListener('pointermove', this.onPointerMove, true);
	            this.interactionDOMElement.removeEventListener('pointerdown', this.onPointerDown, true);
	            this.interactionDOMElement.removeEventListener('pointerleave', this.onPointerOut, true);
	            this.interactionDOMElement.removeEventListener('pointerover', this.onPointerOver, true);
	            window.removeEventListener('pointercancel', this.onPointerCancel, true);
	            window.removeEventListener('pointerup', this.onPointerUp, true);
	        } else {
	            window.document.removeEventListener('mousemove', this.onPointerMove, true);
	            this.interactionDOMElement.removeEventListener('mousedown', this.onPointerDown, true);
	            this.interactionDOMElement.removeEventListener('mouseout', this.onPointerOut, true);
	            this.interactionDOMElement.removeEventListener('mouseover', this.onPointerOver, true);
	            window.removeEventListener('mouseup', this.onPointerUp, true);
	        }
	
	        if (this.supportsTouchEvents) {
	            this.interactionDOMElement.removeEventListener('touchstart', this.onPointerDown, true);
	            this.interactionDOMElement.removeEventListener('touchcancel', this.onPointerCancel, true);
	            this.interactionDOMElement.removeEventListener('touchend', this.onPointerUp, true);
	            this.interactionDOMElement.removeEventListener('touchmove', this.onPointerMove, true);
	        }
	
	        this.interactionDOMElement = null;
	
	        this.eventsAdded = false;
	    };
	
	    /**
	     * Updates the state of interactive objects.
	     * Invoked by a throttled ticker update from {@link PIXI.ticker.shared}.
	     *
	     * @param {number} deltaTime - time delta since last tick
	     */
	
	
	    InteractionManager.prototype.update = function update(deltaTime) {
	        this._deltaTime += deltaTime;
	
	        if (this._deltaTime < this.interactionFrequency) {
	            return;
	        }
	
	        this._deltaTime = 0;
	
	        if (!this.interactionDOMElement) {
	            return;
	        }
	
	        // if the user move the mouse this check has already been done using the mouse move!
	        if (this.didMove) {
	            this.didMove = false;
	
	            return;
	        }
	
	        this.cursor = null;
	
	        // Resets the flag as set by a stopPropagation call. This flag is usually reset by a user interaction of any kind,
	        // but there was a scenario of a display object moving under a static mouse cursor.
	        // In this case, mouseover and mouseevents would not pass the flag test in dispatchEvent function
	        for (var k in this.activeInteractionData) {
	            // eslint-disable-next-line no-prototype-builtins
	            if (this.activeInteractionData.hasOwnProperty(k)) {
	                var interactionData = this.activeInteractionData[k];
	
	                if (interactionData.originalEvent && interactionData.pointerType !== 'touch') {
	                    var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, interactionData.originalEvent, interactionData);
	
	                    this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerOverOut, true);
	                }
	            }
	        }
	
	        this.setCursorMode(this.cursor);
	
	        // TODO
	    };
	
	    /**
	     * Sets the current cursor mode, handling any callbacks or CSS style changes.
	     *
	     * @param {string} mode - cursor mode, a key from the cursorStyles dictionary
	     */
	
	
	    InteractionManager.prototype.setCursorMode = function setCursorMode(mode) {
	        mode = mode || 'default';
	        // if the mode didn't actually change, bail early
	        if (this.currentCursorMode === mode) {
	            return;
	        }
	        this.currentCursorMode = mode;
	        var style = this.cursorStyles[mode];
	
	        // only do things if there is a cursor style for it
	        if (style) {
	            switch (typeof style === 'undefined' ? 'undefined' : _typeof(style)) {
	                case 'string':
	                    // string styles are handled as cursor CSS
	                    this.interactionDOMElement.style.cursor = style;
	                    break;
	                case 'function':
	                    // functions are just called, and passed the cursor mode
	                    style(mode);
	                    break;
	                case 'object':
	                    // if it is an object, assume that it is a dictionary of CSS styles,
	                    // apply it to the interactionDOMElement
	                    Object.assign(this.interactionDOMElement.style, style);
	                    break;
	            }
	        } else if (typeof mode === 'string' && !Object.prototype.hasOwnProperty.call(this.cursorStyles, mode)) {
	            // if it mode is a string (not a Symbol) and cursorStyles doesn't have any entry
	            // for the mode, then assume that the dev wants it to be CSS for the cursor.
	            this.interactionDOMElement.style.cursor = mode;
	        }
	    };
	
	    /**
	     * Dispatches an event on the display object that was interacted with
	     *
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - the display object in question
	     * @param {string} eventString - the name of the event (e.g, mousedown)
	     * @param {object} eventData - the event data object
	     * @private
	     */
	
	
	    InteractionManager.prototype.dispatchEvent = function dispatchEvent(displayObject, eventString, eventData) {
	        if (!eventData.stopped) {
	            eventData.currentTarget = displayObject;
	            eventData.type = eventString;
	
	            displayObject.emit(eventString, eventData);
	
	            if (displayObject[eventString]) {
	                displayObject[eventString](eventData);
	            }
	        }
	    };
	
	    /**
	     * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
	     * resulting value is stored in the point. This takes into account the fact that the DOM
	     * element could be scaled and positioned anywhere on the screen.
	     *
	     * @param  {PIXI.Point} point - the point that the result will be stored in
	     * @param  {number} x - the x coord of the position to map
	     * @param  {number} y - the y coord of the position to map
	     */
	
	
	    InteractionManager.prototype.mapPositionToPoint = function mapPositionToPoint(point, x, y) {
	        var rect = void 0;
	
	        // IE 11 fix
	        if (!this.interactionDOMElement.parentElement) {
	            rect = { x: 0, y: 0, width: 0, height: 0 };
	        } else {
	            rect = this.interactionDOMElement.getBoundingClientRect();
	        }
	
	        var resolutionMultiplier = navigator.isCocoonJS ? this.resolution : 1.0 / this.resolution;
	
	        point.x = (x - rect.left) * (this.interactionDOMElement.width / rect.width) * resolutionMultiplier;
	        point.y = (y - rect.top) * (this.interactionDOMElement.height / rect.height) * resolutionMultiplier;
	    };
	
	    /**
	     * This function is provides a neat way of crawling through the scene graph and running a
	     * specified function on all interactive objects it finds. It will also take care of hit
	     * testing the interactive objects and passes the hit across in the function.
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - event containing the point that
	     *  is tested for collision
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - the displayObject
	     *  that will be hit test (recursively crawls its children)
	     * @param {Function} [func] - the function that will be called on each interactive object. The
	     *  interactionEvent, displayObject and hit will be passed to the function
	     * @param {boolean} [hitTest] - this indicates if the objects inside should be hit test against the point
	     * @param {boolean} [interactive] - Whether the displayObject is interactive
	     * @return {boolean} returns true if the displayObject hit the point
	     */
	
	
	    InteractionManager.prototype.processInteractive = function processInteractive(interactionEvent, displayObject, func, hitTest, interactive) {
	        if (!displayObject || !displayObject.visible) {
	            return false;
	        }
	
	        var point = interactionEvent.data.global;
	
	        // Took a little while to rework this function correctly! But now it is done and nice and optimised. ^_^
	        //
	        // This function will now loop through all objects and then only hit test the objects it HAS
	        // to, not all of them. MUCH faster..
	        // An object will be hit test if the following is true:
	        //
	        // 1: It is interactive.
	        // 2: It belongs to a parent that is interactive AND one of the parents children have not already been hit.
	        //
	        // As another little optimisation once an interactive object has been hit we can carry on
	        // through the scenegraph, but we know that there will be no more hits! So we can avoid extra hit tests
	        // A final optimisation is that an object is not hit test directly if a child has already been hit.
	
	        interactive = displayObject.interactive || interactive;
	
	        var hit = false;
	        var interactiveParent = interactive;
	
	        // Flag here can set to false if the event is outside the parents hitArea or mask
	        var hitTestChildren = true;
	
	        // If there is a hitArea, no need to test against anything else if the pointer is not within the hitArea
	        // There is also no longer a need to hitTest children.
	        if (displayObject.hitArea) {
	            if (hitTest) {
	                displayObject.worldTransform.applyInverse(point, this._tempPoint);
	                if (!displayObject.hitArea.contains(this._tempPoint.x, this._tempPoint.y)) {
	                    hitTest = false;
	                    hitTestChildren = false;
	                } else {
	                    hit = true;
	                }
	            }
	            interactiveParent = false;
	        }
	        // If there is a mask, no need to test against anything else if the pointer is not within the mask
	        else if (displayObject._mask) {
	                if (hitTest) {
	                    if (!displayObject._mask.containsPoint(point)) {
	                        hitTest = false;
	                        hitTestChildren = false;
	                    }
	                }
	            }
	
	        // ** FREE TIP **! If an object is not interactive or has no buttons in it
	        // (such as a game scene!) set interactiveChildren to false for that displayObject.
	        // This will allow PixiJS to completely ignore and bypass checking the displayObjects children.
	        if (hitTestChildren && displayObject.interactiveChildren && displayObject.children) {
	            var children = displayObject.children;
	
	            for (var i = children.length - 1; i >= 0; i--) {
	                var child = children[i];
	
	                // time to get recursive.. if this function will return if something is hit..
	                var childHit = this.processInteractive(interactionEvent, child, func, hitTest, interactiveParent);
	
	                if (childHit) {
	                    // its a good idea to check if a child has lost its parent.
	                    // this means it has been removed whilst looping so its best
	                    if (!child.parent) {
	                        continue;
	                    }
	
	                    // we no longer need to hit test any more objects in this container as we we
	                    // now know the parent has been hit
	                    interactiveParent = false;
	
	                    // If the child is interactive , that means that the object hit was actually
	                    // interactive and not just the child of an interactive object.
	                    // This means we no longer need to hit test anything else. We still need to run
	                    // through all objects, but we don't need to perform any hit tests.
	
	                    if (childHit) {
	                        if (interactionEvent.target) {
	                            hitTest = false;
	                        }
	                        hit = true;
	                    }
	                }
	            }
	        }
	
	        // no point running this if the item is not interactive or does not have an interactive parent.
	        if (interactive) {
	            // if we are hit testing (as in we have no hit any objects yet)
	            // We also don't need to worry about hit testing if once of the displayObjects children
	            // has already been hit - but only if it was interactive, otherwise we need to keep
	            // looking for an interactive child, just in case we hit one
	            if (hitTest && !interactionEvent.target) {
	                // already tested against hitArea if it is defined
	                if (!displayObject.hitArea && displayObject.containsPoint) {
	                    if (displayObject.containsPoint(point)) {
	                        hit = true;
	                    }
	                }
	            }
	
	            if (displayObject.interactive) {
	                if (hit && !interactionEvent.target) {
	                    interactionEvent.target = displayObject;
	                }
	
	                if (func) {
	                    func(interactionEvent, displayObject, !!hit);
	                }
	            }
	        }
	
	        return hit;
	    };
	
	    /**
	     * Is called when the pointer button is pressed down on the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being pressed down
	     */
	
	
	    InteractionManager.prototype.onPointerDown = function onPointerDown(originalEvent) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;
	
	        var events = this.normalizeToPointerData(originalEvent);
	
	        /**
	         * No need to prevent default on natural pointer events, as there are no side effects
	         * Normalized events, however, may have the double mousedown/touchstart issue on the native android browser,
	         * so still need to be prevented.
	         */
	
	        // Guaranteed that there will be at least one event in events, and all events must have the same pointer type
	
	        if (this.autoPreventDefault && events[0].isNormalized) {
	            originalEvent.preventDefault();
	        }
	
	        var eventLen = events.length;
	
	        for (var i = 0; i < eventLen; i++) {
	            var event = events[i];
	
	            var interactionData = this.getInteractionDataForPointerId(event);
	
	            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	
	            interactionEvent.data.originalEvent = originalEvent;
	
	            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerDown, true);
	
	            this.emit('pointerdown', interactionEvent);
	            if (event.pointerType === 'touch') {
	                this.emit('touchstart', interactionEvent);
	            }
	            // emit a mouse event for "pen" pointers, the way a browser would emit a fallback event
	            else if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	                    var isRightButton = event.button === 2;
	
	                    this.emit(isRightButton ? 'rightdown' : 'mousedown', this.eventData);
	                }
	        }
	    };
	
	    /**
	     * Processes the result of the pointer down check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */
	
	
	    InteractionManager.prototype.processPointerDown = function processPointerDown(interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;
	        var id = interactionEvent.data.identifier;
	
	        if (hit) {
	            if (!displayObject.trackedPointers[id]) {
	                displayObject.trackedPointers[id] = new _InteractionTrackingData2.default(id);
	            }
	            this.dispatchEvent(displayObject, 'pointerdown', interactionEvent);
	
	            if (data.pointerType === 'touch') {
	                this.dispatchEvent(displayObject, 'touchstart', interactionEvent);
	            } else if (data.pointerType === 'mouse' || data.pointerType === 'pen') {
	                var isRightButton = data.button === 2;
	
	                if (isRightButton) {
	                    displayObject.trackedPointers[id].rightDown = true;
	                } else {
	                    displayObject.trackedPointers[id].leftDown = true;
	                }
	
	                this.dispatchEvent(displayObject, isRightButton ? 'rightdown' : 'mousedown', interactionEvent);
	            }
	        }
	    };
	
	    /**
	     * Is called when the pointer button is released on the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being released
	     * @param {boolean} cancelled - true if the pointer is cancelled
	     * @param {Function} func - Function passed to {@link processInteractive}
	     */
	
	
	    InteractionManager.prototype.onPointerComplete = function onPointerComplete(originalEvent, cancelled, func) {
	        var events = this.normalizeToPointerData(originalEvent);
	
	        var eventLen = events.length;
	
	        // if the event wasn't targeting our canvas, then consider it to be pointerupoutside
	        // in all cases (unless it was a pointercancel)
	        var eventAppend = originalEvent.target !== this.interactionDOMElement ? 'outside' : '';
	
	        for (var i = 0; i < eventLen; i++) {
	            var event = events[i];
	
	            var interactionData = this.getInteractionDataForPointerId(event);
	
	            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	
	            interactionEvent.data.originalEvent = originalEvent;
	
	            // perform hit testing for events targeting our canvas or cancel events
	            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, func, cancelled || !eventAppend);
	
	            this.emit(cancelled ? 'pointercancel' : 'pointerup' + eventAppend, interactionEvent);
	
	            if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	                var isRightButton = event.button === 2;
	
	                this.emit(isRightButton ? 'rightup' + eventAppend : 'mouseup' + eventAppend, interactionEvent);
	            } else if (event.pointerType === 'touch') {
	                this.emit(cancelled ? 'touchcancel' : 'touchend' + eventAppend, interactionEvent);
	                this.releaseInteractionDataForPointerId(event.pointerId, interactionData);
	            }
	        }
	    };
	
	    /**
	     * Is called when the pointer button is cancelled
	     *
	     * @private
	     * @param {PointerEvent} event - The DOM event of a pointer button being released
	     */
	
	
	    InteractionManager.prototype.onPointerCancel = function onPointerCancel(event) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && event.pointerType === 'touch') return;
	
	        this.onPointerComplete(event, true, this.processPointerCancel);
	    };
	
	    /**
	     * Processes the result of the pointer cancel check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     */
	
	
	    InteractionManager.prototype.processPointerCancel = function processPointerCancel(interactionEvent, displayObject) {
	        var data = interactionEvent.data;
	
	        var id = interactionEvent.data.identifier;
	
	        if (displayObject.trackedPointers[id] !== undefined) {
	            delete displayObject.trackedPointers[id];
	            this.dispatchEvent(displayObject, 'pointercancel', interactionEvent);
	
	            if (data.pointerType === 'touch') {
	                this.dispatchEvent(displayObject, 'touchcancel', interactionEvent);
	            }
	        }
	    };
	
	    /**
	     * Is called when the pointer button is released on the renderer element
	     *
	     * @private
	     * @param {PointerEvent} event - The DOM event of a pointer button being released
	     */
	
	
	    InteractionManager.prototype.onPointerUp = function onPointerUp(event) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && event.pointerType === 'touch') return;
	
	        this.onPointerComplete(event, false, this.processPointerUp);
	    };
	
	    /**
	     * Processes the result of the pointer up check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */
	
	
	    InteractionManager.prototype.processPointerUp = function processPointerUp(interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;
	
	        var id = interactionEvent.data.identifier;
	
	        var trackingData = displayObject.trackedPointers[id];
	
	        var isTouch = data.pointerType === 'touch';
	
	        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
	        // need to track mouse down status in the mouse block so that we can emit
	        // event in a later block
	        var isMouseTap = false;
	
	        // Mouse only
	        if (isMouse) {
	            var isRightButton = data.button === 2;
	
	            var flags = _InteractionTrackingData2.default.FLAGS;
	
	            var test = isRightButton ? flags.RIGHT_DOWN : flags.LEFT_DOWN;
	
	            var isDown = trackingData !== undefined && trackingData.flags & test;
	
	            if (hit) {
	                this.dispatchEvent(displayObject, isRightButton ? 'rightup' : 'mouseup', interactionEvent);
	
	                if (isDown) {
	                    this.dispatchEvent(displayObject, isRightButton ? 'rightclick' : 'click', interactionEvent);
	                    // because we can confirm that the mousedown happened on this object, flag for later emit of pointertap
	                    isMouseTap = true;
	                }
	            } else if (isDown) {
	                this.dispatchEvent(displayObject, isRightButton ? 'rightupoutside' : 'mouseupoutside', interactionEvent);
	            }
	            // update the down state of the tracking data
	            if (trackingData) {
	                if (isRightButton) {
	                    trackingData.rightDown = false;
	                } else {
	                    trackingData.leftDown = false;
	                }
	            }
	        }
	
	        // Pointers and Touches, and Mouse
	        if (hit) {
	            this.dispatchEvent(displayObject, 'pointerup', interactionEvent);
	            if (isTouch) this.dispatchEvent(displayObject, 'touchend', interactionEvent);
	
	            if (trackingData) {
	                // emit pointertap if not a mouse, or if the mouse block decided it was a tap
	                if (!isMouse || isMouseTap) {
	                    this.dispatchEvent(displayObject, 'pointertap', interactionEvent);
	                }
	                if (isTouch) {
	                    this.dispatchEvent(displayObject, 'tap', interactionEvent);
	                    // touches are no longer over (if they ever were) when we get the touchend
	                    // so we should ensure that we don't keep pretending that they are
	                    trackingData.over = false;
	                }
	            }
	        } else if (trackingData) {
	            this.dispatchEvent(displayObject, 'pointerupoutside', interactionEvent);
	            if (isTouch) this.dispatchEvent(displayObject, 'touchendoutside', interactionEvent);
	        }
	        // Only remove the tracking data if there is no over/down state still associated with it
	        if (trackingData && trackingData.none) {
	            delete displayObject.trackedPointers[id];
	        }
	    };
	
	    /**
	     * Is called when the pointer moves across the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer moving
	     */
	
	
	    InteractionManager.prototype.onPointerMove = function onPointerMove(originalEvent) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;
	
	        var events = this.normalizeToPointerData(originalEvent);
	
	        if (events[0].pointerType === 'mouse' || events[0].pointerType === 'pen') {
	            this.didMove = true;
	
	            this.cursor = null;
	        }
	
	        var eventLen = events.length;
	
	        for (var i = 0; i < eventLen; i++) {
	            var event = events[i];
	
	            var interactionData = this.getInteractionDataForPointerId(event);
	
	            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	
	            interactionEvent.data.originalEvent = originalEvent;
	
	            var interactive = event.pointerType === 'touch' ? this.moveWhenInside : true;
	
	            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerMove, interactive);
	            this.emit('pointermove', interactionEvent);
	            if (event.pointerType === 'touch') this.emit('touchmove', interactionEvent);
	            if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.emit('mousemove', interactionEvent);
	        }
	
	        if (events[0].pointerType === 'mouse') {
	            this.setCursorMode(this.cursor);
	
	            // TODO BUG for parents interactive object (border order issue)
	        }
	    };
	
	    /**
	     * Processes the result of the pointer move check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */
	
	
	    InteractionManager.prototype.processPointerMove = function processPointerMove(interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;
	
	        var isTouch = data.pointerType === 'touch';
	
	        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
	
	        if (isMouse) {
	            this.processPointerOverOut(interactionEvent, displayObject, hit);
	        }
	
	        if (!this.moveWhenInside || hit) {
	            this.dispatchEvent(displayObject, 'pointermove', interactionEvent);
	            if (isTouch) this.dispatchEvent(displayObject, 'touchmove', interactionEvent);
	            if (isMouse) this.dispatchEvent(displayObject, 'mousemove', interactionEvent);
	        }
	    };
	
	    /**
	     * Is called when the pointer is moved out of the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer being moved out
	     */
	
	
	    InteractionManager.prototype.onPointerOut = function onPointerOut(originalEvent) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;
	
	        var events = this.normalizeToPointerData(originalEvent);
	
	        // Only mouse and pointer can call onPointerOut, so events will always be length 1
	        var event = events[0];
	
	        if (event.pointerType === 'mouse') {
	            this.mouseOverRenderer = false;
	            this.setCursorMode(null);
	        }
	
	        var interactionData = this.getInteractionDataForPointerId(event);
	
	        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	
	        interactionEvent.data.originalEvent = event;
	
	        this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerOverOut, false);
	
	        this.emit('pointerout', interactionEvent);
	        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	            this.emit('mouseout', interactionEvent);
	        } else {
	            // we can get touchleave events after touchend, so we want to make sure we don't
	            // introduce memory leaks
	            this.releaseInteractionDataForPointerId(interactionData.identifier);
	        }
	    };
	
	    /**
	     * Processes the result of the pointer over/out check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */
	
	
	    InteractionManager.prototype.processPointerOverOut = function processPointerOverOut(interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;
	
	        var id = interactionEvent.data.identifier;
	
	        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
	
	        var trackingData = displayObject.trackedPointers[id];
	
	        // if we just moused over the display object, then we need to track that state
	        if (hit && !trackingData) {
	            trackingData = displayObject.trackedPointers[id] = new _InteractionTrackingData2.default(id);
	        }
	
	        if (trackingData === undefined) return;
	
	        if (hit && this.mouseOverRenderer) {
	            if (!trackingData.over) {
	                trackingData.over = true;
	                this.dispatchEvent(displayObject, 'pointerover', interactionEvent);
	                if (isMouse) {
	                    this.dispatchEvent(displayObject, 'mouseover', interactionEvent);
	                }
	            }
	
	            // only change the cursor if it has not already been changed (by something deeper in the
	            // display tree)
	            if (isMouse && this.cursor === null) {
	                this.cursor = displayObject.cursor;
	            }
	        } else if (trackingData.over) {
	            trackingData.over = false;
	            this.dispatchEvent(displayObject, 'pointerout', this.eventData);
	            if (isMouse) {
	                this.dispatchEvent(displayObject, 'mouseout', interactionEvent);
	            }
	            // if there is no mouse down information for the pointer, then it is safe to delete
	            if (trackingData.none) {
	                delete displayObject.trackedPointers[id];
	            }
	        }
	    };
	
	    /**
	     * Is called when the pointer is moved into the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being moved into the renderer view
	     */
	
	
	    InteractionManager.prototype.onPointerOver = function onPointerOver(originalEvent) {
	        var events = this.normalizeToPointerData(originalEvent);
	
	        // Only mouse and pointer can call onPointerOver, so events will always be length 1
	        var event = events[0];
	
	        var interactionData = this.getInteractionDataForPointerId(event);
	
	        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	
	        interactionEvent.data.originalEvent = event;
	
	        if (event.pointerType === 'mouse') {
	            this.mouseOverRenderer = true;
	        }
	
	        this.emit('pointerover', interactionEvent);
	        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	            this.emit('mouseover', interactionEvent);
	        }
	    };
	
	    /**
	     * Get InteractionData for a given pointerId. Store that data as well
	     *
	     * @private
	     * @param {PointerEvent} event - Normalized pointer event, output from normalizeToPointerData
	     * @return {PIXI.interaction.InteractionData} - Interaction data for the given pointer identifier
	     */
	
	
	    InteractionManager.prototype.getInteractionDataForPointerId = function getInteractionDataForPointerId(event) {
	        var pointerId = event.pointerId;
	
	        var interactionData = void 0;
	
	        if (pointerId === MOUSE_POINTER_ID || event.pointerType === 'mouse') {
	            interactionData = this.mouse;
	        } else if (this.activeInteractionData[pointerId]) {
	            interactionData = this.activeInteractionData[pointerId];
	        } else {
	            interactionData = this.interactionDataPool.pop() || new _InteractionData2.default();
	            interactionData.identifier = pointerId;
	            this.activeInteractionData[pointerId] = interactionData;
	        }
	        // copy properties from the event, so that we can make sure that touch/pointer specific
	        // data is available
	        interactionData.copyEvent(event);
	
	        return interactionData;
	    };
	
	    /**
	     * Return unused InteractionData to the pool, for a given pointerId
	     *
	     * @private
	     * @param {number} pointerId - Identifier from a pointer event
	     */
	
	
	    InteractionManager.prototype.releaseInteractionDataForPointerId = function releaseInteractionDataForPointerId(pointerId) {
	        var interactionData = this.activeInteractionData[pointerId];
	
	        if (interactionData) {
	            delete this.activeInteractionData[pointerId];
	            interactionData.reset();
	            this.interactionDataPool.push(interactionData);
	        }
	    };
	
	    /**
	     * Configure an InteractionEvent to wrap a DOM PointerEvent and InteractionData
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The event to be configured
	     * @param {PointerEvent} pointerEvent - The DOM event that will be paired with the InteractionEvent
	     * @param {PIXI.interaction.InteractionData} interactionData - The InteractionData that will be paired
	     *        with the InteractionEvent
	     * @return {PIXI.interaction.InteractionEvent} the interaction event that was passed in
	     */
	
	
	    InteractionManager.prototype.configureInteractionEventForDOMEvent = function configureInteractionEventForDOMEvent(interactionEvent, pointerEvent, interactionData) {
	        interactionEvent.data = interactionData;
	
	        this.mapPositionToPoint(interactionData.global, pointerEvent.clientX, pointerEvent.clientY);
	
	        // This is the way InteractionManager processed touch events before the refactoring, so I've kept
	        // it here. But it doesn't make that much sense to me, since mapPositionToPoint already factors
	        // in this.resolution, so this just divides by this.resolution twice for touch events...
	        if (navigator.isCocoonJS && pointerEvent.pointerType === 'touch') {
	            interactionData.global.x = interactionData.global.x / this.resolution;
	            interactionData.global.y = interactionData.global.y / this.resolution;
	        }
	
	        // Not really sure why this is happening, but it's how a previous version handled things
	        if (pointerEvent.pointerType === 'touch') {
	            pointerEvent.globalX = interactionData.global.x;
	            pointerEvent.globalY = interactionData.global.y;
	        }
	
	        interactionData.originalEvent = pointerEvent;
	        interactionEvent.reset();
	
	        return interactionEvent;
	    };
	
	    /**
	     * Ensures that the original event object contains all data that a regular pointer event would have
	     *
	     * @private
	     * @param {TouchEvent|MouseEvent|PointerEvent} event - The original event data from a touch or mouse event
	     * @return {PointerEvent[]} An array containing a single normalized pointer event, in the case of a pointer
	     *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
	     */
	
	
	    InteractionManager.prototype.normalizeToPointerData = function normalizeToPointerData(event) {
	        var normalizedEvents = [];
	
	        if (this.supportsTouchEvents && event instanceof TouchEvent) {
	            for (var i = 0, li = event.changedTouches.length; i < li; i++) {
	                var touch = event.changedTouches[i];
	
	                if (typeof touch.button === 'undefined') touch.button = event.touches.length ? 1 : 0;
	                if (typeof touch.buttons === 'undefined') touch.buttons = event.touches.length ? 1 : 0;
	                if (typeof touch.isPrimary === 'undefined') {
	                    touch.isPrimary = event.touches.length === 1 && event.type === 'touchstart';
	                }
	                if (typeof touch.width === 'undefined') touch.width = touch.radiusX || 1;
	                if (typeof touch.height === 'undefined') touch.height = touch.radiusY || 1;
	                if (typeof touch.tiltX === 'undefined') touch.tiltX = 0;
	                if (typeof touch.tiltY === 'undefined') touch.tiltY = 0;
	                if (typeof touch.pointerType === 'undefined') touch.pointerType = 'touch';
	                if (typeof touch.pointerId === 'undefined') touch.pointerId = touch.identifier || 0;
	                if (typeof touch.pressure === 'undefined') touch.pressure = touch.force || 0.5;
	                touch.twist = 0;
	                touch.tangentialPressure = 0;
	                // TODO: Remove these, as layerX/Y is not a standard, is deprecated, has uneven
	                // support, and the fill ins are not quite the same
	                // offsetX/Y might be okay, but is not the same as clientX/Y when the canvas's top
	                // left is not 0,0 on the page
	                if (typeof touch.layerX === 'undefined') touch.layerX = touch.offsetX = touch.clientX;
	                if (typeof touch.layerY === 'undefined') touch.layerY = touch.offsetY = touch.clientY;
	
	                // mark the touch as normalized, just so that we know we did it
	                touch.isNormalized = true;
	
	                normalizedEvents.push(touch);
	            }
	        }
	        // apparently PointerEvent subclasses MouseEvent, so yay
	        else if (event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof window.PointerEvent))) {
	                if (typeof event.isPrimary === 'undefined') event.isPrimary = true;
	                if (typeof event.width === 'undefined') event.width = 1;
	                if (typeof event.height === 'undefined') event.height = 1;
	                if (typeof event.tiltX === 'undefined') event.tiltX = 0;
	                if (typeof event.tiltY === 'undefined') event.tiltY = 0;
	                if (typeof event.pointerType === 'undefined') event.pointerType = 'mouse';
	                if (typeof event.pointerId === 'undefined') event.pointerId = MOUSE_POINTER_ID;
	                if (typeof event.pressure === 'undefined') event.pressure = 0.5;
	                event.twist = 0;
	                event.tangentialPressure = 0;
	
	                // mark the mouse event as normalized, just so that we know we did it
	                event.isNormalized = true;
	
	                normalizedEvents.push(event);
	            } else {
	                normalizedEvents.push(event);
	            }
	
	        return normalizedEvents;
	    };
	
	    /**
	     * Destroys the interaction manager
	     *
	     */
	
	
	    InteractionManager.prototype.destroy = function destroy() {
	        this.removeEvents();
	
	        this.removeAllListeners();
	
	        this.renderer = null;
	
	        this.mouse = null;
	
	        this.eventData = null;
	
	        this.interactionDOMElement = null;
	
	        this.onPointerDown = null;
	        this.processPointerDown = null;
	
	        this.onPointerUp = null;
	        this.processPointerUp = null;
	
	        this.onPointerCancel = null;
	        this.processPointerCancel = null;
	
	        this.onPointerMove = null;
	        this.processPointerMove = null;
	
	        this.onPointerOut = null;
	        this.processPointerOverOut = null;
	
	        this.onPointerOver = null;
	
	        this._tempPoint = null;
	    };
	
	    return InteractionManager;
	}(_eventemitter2.default);
	
	exports.default = InteractionManager;
	
	
	core.WebGLRenderer.registerPlugin('interaction', InteractionManager);
	core.CanvasRenderer.registerPlugin('interaction', InteractionManager);
	//# sourceMappingURL=InteractionManager.js.map

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Event class that mimics native DOM events.
	 *
	 * @class
	 * @memberof PIXI.interaction
	 */
	var InteractionEvent = function () {
	  /**
	   *
	   */
	  function InteractionEvent() {
	    _classCallCheck(this, InteractionEvent);
	
	    /**
	     * Whether this event will continue propagating in the tree
	     *
	     * @member {boolean}
	     */
	    this.stopped = false;
	
	    /**
	     * The object which caused this event to be dispatched.
	     * For listener callback see {@link PIXI.interaction.InteractionEvent.currentTarget}.
	     *
	     * @member {PIXI.DisplayObject}
	     */
	    this.target = null;
	
	    /**
	     * The object whose event listener’s callback is currently being invoked.
	     *
	     * @member {PIXI.DisplayObject}
	     */
	    this.currentTarget = null;
	
	    /**
	     * Type of the event
	     *
	     * @member {string}
	     */
	    this.type = null;
	
	    /**
	     * InteractionData related to this event
	     *
	     * @member {PIXI.interaction.InteractionData}
	     */
	    this.data = null;
	  }
	
	  /**
	   * Prevents event from reaching any objects other than the current object.
	   *
	   */
	
	
	  InteractionEvent.prototype.stopPropagation = function stopPropagation() {
	    this.stopped = true;
	  };
	
	  /**
	   * Resets the event.
	   */
	
	
	  InteractionEvent.prototype.reset = function reset() {
	    this.stopped = false;
	    this.currentTarget = null;
	    this.target = null;
	  };
	
	  return InteractionEvent;
	}();
	
	exports.default = InteractionEvent;
	//# sourceMappingURL=InteractionEvent.js.map

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * DisplayObjects with the {@link PIXI.interaction.interactiveTarget} mixin use this class to track interactions
	 *
	 * @class
	 * @private
	 * @memberof PIXI.interaction
	 */
	var InteractionTrackingData = function () {
	    /**
	     * @param {number} pointerId - Unique pointer id of the event
	     */
	    function InteractionTrackingData(pointerId) {
	        _classCallCheck(this, InteractionTrackingData);
	
	        this._pointerId = pointerId;
	        this._flags = InteractionTrackingData.FLAGS.NONE;
	    }
	
	    /**
	     *
	     * @private
	     * @param {number} flag - The interaction flag to set
	     * @param {boolean} yn - Should the flag be set or unset
	     */
	
	
	    InteractionTrackingData.prototype._doSet = function _doSet(flag, yn) {
	        if (yn) {
	            this._flags = this._flags | flag;
	        } else {
	            this._flags = this._flags & ~flag;
	        }
	    };
	
	    /**
	     * Unique pointer id of the event
	     *
	     * @readonly
	     * @member {number}
	     */
	
	
	    _createClass(InteractionTrackingData, [{
	        key: "pointerId",
	        get: function get() {
	            return this._pointerId;
	        }
	
	        /**
	         * State of the tracking data, expressed as bit flags
	         *
	         * @member {number}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */
	
	    }, {
	        key: "flags",
	        get: function get() {
	            return this._flags;
	        }
	
	        /**
	         * Set the flags for the tracking data
	         *
	         * @param {number} flags - Flags to set
	         */
	        ,
	        set: function set(flags) {
	            this._flags = flags;
	        }
	
	        /**
	         * Is the tracked event inactive (not over or down)?
	         *
	         * @member {number}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */
	
	    }, {
	        key: "none",
	        get: function get() {
	            return this._flags === this.constructor.FLAGS.NONE;
	        }
	
	        /**
	         * Is the tracked event over the DisplayObject?
	         *
	         * @member {boolean}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */
	
	    }, {
	        key: "over",
	        get: function get() {
	            return (this._flags & this.constructor.FLAGS.OVER) !== 0;
	        }
	
	        /**
	         * Set the over flag
	         *
	         * @param {boolean} yn - Is the event over?
	         */
	        ,
	        set: function set(yn) {
	            this._doSet(this.constructor.FLAGS.OVER, yn);
	        }
	
	        /**
	         * Did the right mouse button come down in the DisplayObject?
	         *
	         * @member {boolean}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */
	
	    }, {
	        key: "rightDown",
	        get: function get() {
	            return (this._flags & this.constructor.FLAGS.RIGHT_DOWN) !== 0;
	        }
	
	        /**
	         * Set the right down flag
	         *
	         * @param {boolean} yn - Is the right mouse button down?
	         */
	        ,
	        set: function set(yn) {
	            this._doSet(this.constructor.FLAGS.RIGHT_DOWN, yn);
	        }
	
	        /**
	         * Did the left mouse button come down in the DisplayObject?
	         *
	         * @member {boolean}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */
	
	    }, {
	        key: "leftDown",
	        get: function get() {
	            return (this._flags & this.constructor.FLAGS.LEFT_DOWN) !== 0;
	        }
	
	        /**
	         * Set the left down flag
	         *
	         * @param {boolean} yn - Is the left mouse button down?
	         */
	        ,
	        set: function set(yn) {
	            this._doSet(this.constructor.FLAGS.LEFT_DOWN, yn);
	        }
	    }]);
	
	    return InteractionTrackingData;
	}();
	
	exports.default = InteractionTrackingData;
	
	
	InteractionTrackingData.FLAGS = Object.freeze({
	    NONE: 0,
	    OVER: 1 << 0,
	    LEFT_DOWN: 1 << 1,
	    RIGHT_DOWN: 1 << 2
	});
	//# sourceMappingURL=InteractionTrackingData.js.map

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Default property values of interactive objects
	 * Used by {@link PIXI.interaction.InteractionManager} to automatically give all DisplayObjects these properties
	 *
	 * @private
	 * @name interactiveTarget
	 * @memberof PIXI.interaction
	 * @example
	 *      function MyObject() {}
	 *
	 *      Object.assign(
	 *          core.DisplayObject.prototype,
	 *          PIXI.interaction.interactiveTarget
	 *      );
	 */
	exports.default = {
	
	  /**
	   * Enable interaction events for the DisplayObject. Touch, pointer and mouse
	   * events will not be emitted unless `interactive` is set to `true`.
	   *
	   * @example
	   * const sprite = new PIXI.Sprite(texture);
	   * sprite.interactive = true;
	   * sprite.on('tap', (event) => {
	   *    //handle event
	   * });
	   * @member {boolean}
	   * @memberof PIXI.DisplayObject#
	   */
	  interactive: false,
	
	  /**
	   * Determines if the children to the displayObject can be clicked/touched
	   * Setting this to false allows PixiJS to bypass a recursive `hitTest` function
	   *
	   * @member {boolean}
	   * @memberof PIXI.Container#
	   */
	  interactiveChildren: true,
	
	  /**
	   * Interaction shape. Children will be hit first, then this shape will be checked.
	   * Setting this will cause this shape to be checked in hit tests rather than the displayObject's bounds.
	   *
	   * @example
	   * const sprite = new PIXI.Sprite(texture);
	   * sprite.interactive = true;
	   * sprite.hitArea = new PIXI.Rectangle(0, 0, 100, 100);
	   * @member {PIXI.Rectangle|PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.RoundedRectangle}
	   * @memberof PIXI.DisplayObject#
	   */
	  hitArea: null,
	
	  /**
	   * If enabled, the mouse cursor use the pointer behavior when hovered over the displayObject if it is interactive
	   * Setting this changes the 'cursor' property to `'pointer'`.
	   *
	   * @example
	   * const sprite = new PIXI.Sprite(texture);
	   * sprite.interactive = true;
	   * sprite.buttonMode = true;
	   * @member {boolean}
	   * @memberof PIXI.DisplayObject#
	   */
	  get buttonMode() {
	    return this.cursor === 'pointer';
	  },
	  set buttonMode(value) {
	    if (value) {
	      this.cursor = 'pointer';
	    } else if (this.cursor === 'pointer') {
	      this.cursor = null;
	    }
	  },
	
	  /**
	   * This defines what cursor mode is used when the mouse cursor
	   * is hovered over the displayObject.
	   *
	   * @example
	   * const sprite = new PIXI.Sprite(texture);
	   * sprite.interactive = true;
	   * sprite.cursor = 'wait';
	   * @see https://developer.mozilla.org/en/docs/Web/CSS/cursor
	   *
	   * @member {string}
	   * @memberof PIXI.DisplayObject#
	   */
	  cursor: null,
	
	  /**
	   * Internal set of all active pointers, by identifier
	   *
	   * @member {Map<number, InteractionTrackingData>}
	   * @memberof PIXI.DisplayObject#
	   * @private
	   */
	  get trackedPointers() {
	    if (this._trackedPointers === undefined) this._trackedPointers = {};
	
	    return this._trackedPointers;
	  },
	
	  /**
	   * Map of all tracked pointers, by identifier. Use trackedPointers to access.
	   *
	   * @private
	   * @type {Map<number, InteractionTrackingData>}
	   */
	  _trackedPointers: undefined
	};
	//# sourceMappingURL=interactiveTarget.js.map

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.shared = exports.Resource = exports.textureParser = exports.getResourcePath = exports.spritesheetParser = exports.parseBitmapFontData = exports.bitmapFontParser = exports.Loader = undefined;
	
	var _bitmapFontParser = __webpack_require__(356);
	
	Object.defineProperty(exports, 'bitmapFontParser', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_bitmapFontParser).default;
	    }
	});
	Object.defineProperty(exports, 'parseBitmapFontData', {
	    enumerable: true,
	    get: function get() {
	        return _bitmapFontParser.parse;
	    }
	});
	
	var _spritesheetParser = __webpack_require__(364);
	
	Object.defineProperty(exports, 'spritesheetParser', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_spritesheetParser).default;
	    }
	});
	Object.defineProperty(exports, 'getResourcePath', {
	    enumerable: true,
	    get: function get() {
	        return _spritesheetParser.getResourcePath;
	    }
	});
	
	var _textureParser = __webpack_require__(365);
	
	Object.defineProperty(exports, 'textureParser', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_textureParser).default;
	    }
	});
	
	var _resourceLoader = __webpack_require__(357);
	
	Object.defineProperty(exports, 'Resource', {
	    enumerable: true,
	    get: function get() {
	        return _resourceLoader.Resource;
	    }
	});
	
	var _Application = __webpack_require__(320);
	
	var _Application2 = _interopRequireDefault(_Application);
	
	var _loader = __webpack_require__(366);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This namespace contains APIs which extends the {@link https://github.com/englercj/resource-loader resource-loader} module
	 * for loading assets, data, and other resources dynamically.
	 * @example
	 * const loader = new PIXI.loaders.Loader();
	 * loader.add('bunny', 'data/bunny.png')
	 *       .add('spaceship', 'assets/spritesheet.json');
	 * loader.load((loader, resources) => {
	 *    // resources.bunny
	 *    // resources.spaceship
	 * });
	 * @namespace PIXI.loaders
	 */
	exports.Loader = _loader2.default;
	
	
	/**
	 * A premade instance of the loader that can be used to load resources.
	 * @name shared
	 * @memberof PIXI.loaders
	 * @type {PIXI.loaders.Loader}
	 */
	var shared = new _loader2.default();
	
	shared.destroy = function () {
	    // protect destroying shared loader
	};
	
	exports.shared = shared;
	
	// Mixin the loader construction
	
	var AppPrototype = _Application2.default.prototype;
	
	AppPrototype._loader = null;
	
	/**
	 * Loader instance to help with asset loading.
	 * @name PIXI.Application#loader
	 * @type {PIXI.loaders.Loader}
	 */
	Object.defineProperty(AppPrototype, 'loader', {
	    get: function get() {
	        if (!this._loader) {
	            var sharedLoader = this._options.sharedLoader;
	
	            this._loader = sharedLoader ? shared : new _loader2.default();
	        }
	
	        return this._loader;
	    }
	});
	
	// Override the destroy function
	// making sure to destroy the current Loader
	AppPrototype._parentDestroy = AppPrototype.destroy;
	AppPrototype.destroy = function destroy(removeView, stageOptions) {
	    if (this._loader) {
	        this._loader.destroy();
	        this._loader = null;
	    }
	    this._parentDestroy(removeView, stageOptions);
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.parse = parse;
	
	exports.default = function () {
	    return function bitmapFontParser(resource, next) {
	        // skip if no data or not xml data
	        if (!resource.data || resource.type !== _resourceLoader.Resource.TYPE.XML) {
	            next();
	
	            return;
	        }
	
	        // skip if not bitmap font data, using some silly duck-typing
	        if (resource.data.getElementsByTagName('page').length === 0 || resource.data.getElementsByTagName('info').length === 0 || resource.data.getElementsByTagName('info')[0].getAttribute('face') === null) {
	            next();
	
	            return;
	        }
	
	        var xmlUrl = !resource.isDataUrl ? path.dirname(resource.url) : '';
	
	        if (resource.isDataUrl) {
	            if (xmlUrl === '.') {
	                xmlUrl = '';
	            }
	
	            if (this.baseUrl && xmlUrl) {
	                // if baseurl has a trailing slash then add one to xmlUrl so the replace works below
	                if (this.baseUrl.charAt(this.baseUrl.length - 1) === '/') {
	                    xmlUrl += '/';
	                }
	            }
	        }
	
	        // remove baseUrl from xmlUrl
	        xmlUrl = xmlUrl.replace(this.baseUrl, '');
	
	        // if there is an xmlUrl now, it needs a trailing slash. Ensure that it does if the string isn't empty.
	        if (xmlUrl && xmlUrl.charAt(xmlUrl.length - 1) !== '/') {
	            xmlUrl += '/';
	        }
	
	        var pages = resource.data.getElementsByTagName('page');
	        var textures = {};
	
	        // Handle completed, when the number of textures
	        // load is the same number as references in the fnt file
	        var completed = function completed(page) {
	            textures[page.metadata.pageFile] = page.texture;
	
	            if (Object.keys(textures).length === pages.length) {
	                parse(resource, textures);
	                next();
	            }
	        };
	
	        for (var i = 0; i < pages.length; ++i) {
	            var pageFile = pages[i].getAttribute('file');
	            var url = xmlUrl + pageFile;
	            var exists = false;
	
	            // incase the image is loaded outside
	            // using the same loader, resource will be available
	            for (var name in this.resources) {
	                if (this.resources[name].url === url) {
	                    this.resources[name].metadata.pageFile = pageFile;
	                    completed(this.resources[name]);
	                    exists = true;
	                    break;
	                }
	            }
	
	            // texture is not loaded, we'll attempt to add
	            // it to the load and add the texture to the list
	            if (!exists) {
	                // Standard loading options for images
	                var options = {
	                    crossOrigin: resource.crossOrigin,
	                    loadType: _resourceLoader.Resource.LOAD_TYPE.IMAGE,
	                    metadata: Object.assign({ pageFile: pageFile }, resource.metadata.imageMetadata),
	                    parentResource: resource
	                };
	
	                this.add(url, options, completed);
	            }
	        }
	    };
	};
	
	var _path = __webpack_require__(285);
	
	var path = _interopRequireWildcard(_path);
	
	var _resourceLoader = __webpack_require__(357);
	
	var _extras = __webpack_require__(329);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Register a BitmapText font from loader resource.
	 *
	 * @function parseBitmapFontData
	 * @memberof PIXI.loaders
	 * @param {PIXI.loaders.Resource} resource - Loader resource.
	 * @param {PIXI.Texture|PIXI.Texture[]} textures - List of textures for each page.
	 */
	function parse(resource, textures) {
	    resource.bitmapFont = _extras.BitmapText.registerFont(resource.data, textures);
	}
	//# sourceMappingURL=bitmapFontParser.js.map

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// import Loader from './Loader';
	// import Resource from './Resource';
	// import * as async from './async';
	// import * as b64 from './b64';
	
	/* eslint-disable no-undef */
	
	var Loader = __webpack_require__(358).default;
	var Resource = __webpack_require__(362).default;
	var async = __webpack_require__(361);
	var b64 = __webpack_require__(363);
	
	Loader.Resource = Resource;
	Loader.async = async;
	Loader.base64 = b64;
	
	// export manually, and also as default
	module.exports = Loader;
	// export default Loader;
	module.exports.default = Loader;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _miniSignals = __webpack_require__(359);
	
	var _miniSignals2 = _interopRequireDefault(_miniSignals);
	
	var _parseUri = __webpack_require__(360);
	
	var _parseUri2 = _interopRequireDefault(_parseUri);
	
	var _async = __webpack_require__(361);
	
	var async = _interopRequireWildcard(_async);
	
	var _Resource = __webpack_require__(362);
	
	var _Resource2 = _interopRequireDefault(_Resource);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// some constants
	var MAX_PROGRESS = 100;
	var rgxExtractUrlHash = /(#[\w-]+)?$/;
	
	/**
	 * Manages the state and loading of multiple resources to load.
	 *
	 * @class
	 */
	
	var Loader = function () {
	    /**
	     * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
	     * @param {number} [concurrency=10] - The number of resources to load concurrently.
	     */
	    function Loader() {
	        var _this = this;
	
	        var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var concurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	        _classCallCheck(this, Loader);
	
	        /**
	         * The base url for all resources loaded by this loader.
	         *
	         * @member {string}
	         */
	        this.baseUrl = baseUrl;
	
	        /**
	         * The progress percent of the loader going through the queue.
	         *
	         * @member {number}
	         */
	        this.progress = 0;
	
	        /**
	         * Loading state of the loader, true if it is currently loading resources.
	         *
	         * @member {boolean}
	         */
	        this.loading = false;
	
	        /**
	         * A querystring to append to every URL added to the loader.
	         *
	         * This should be a valid query string *without* the question-mark (`?`). The loader will
	         * also *not* escape values for you. Make sure to escape your parameters with
	         * [`encodeURIComponent`](https://mdn.io/encodeURIComponent) before assigning this property.
	         *
	         * @example
	         * const loader = new Loader();
	         *
	         * loader.defaultQueryString = 'user=me&password=secret';
	         *
	         * // This will request 'image.png?user=me&password=secret'
	         * loader.add('image.png').load();
	         *
	         * loader.reset();
	         *
	         * // This will request 'image.png?v=1&user=me&password=secret'
	         * loader.add('iamge.png?v=1').load();
	         */
	        this.defaultQueryString = '';
	
	        /**
	         * The middleware to run before loading each resource.
	         *
	         * @member {function[]}
	         */
	        this._beforeMiddleware = [];
	
	        /**
	         * The middleware to run after loading each resource.
	         *
	         * @member {function[]}
	         */
	        this._afterMiddleware = [];
	
	        /**
	         * The tracks the resources we are currently completing parsing for.
	         *
	         * @member {Resource[]}
	         */
	        this._resourcesParsing = [];
	
	        /**
	         * The `_loadResource` function bound with this object context.
	         *
	         * @private
	         * @member {function}
	         * @param {Resource} r - The resource to load
	         * @param {Function} d - The dequeue function
	         * @return {undefined}
	         */
	        this._boundLoadResource = function (r, d) {
	            return _this._loadResource(r, d);
	        };
	
	        /**
	         * The resources waiting to be loaded.
	         *
	         * @private
	         * @member {Resource[]}
	         */
	        this._queue = async.queue(this._boundLoadResource, concurrency);
	
	        this._queue.pause();
	
	        /**
	         * All the resources for this loader keyed by name.
	         *
	         * @member {object<string, Resource>}
	         */
	        this.resources = {};
	
	        /**
	         * Dispatched once per loaded or errored resource.
	         *
	         * The callback looks like {@link Loader.OnProgressSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onProgress = new _miniSignals2.default();
	
	        /**
	         * Dispatched once per errored resource.
	         *
	         * The callback looks like {@link Loader.OnErrorSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onError = new _miniSignals2.default();
	
	        /**
	         * Dispatched once per loaded resource.
	         *
	         * The callback looks like {@link Loader.OnLoadSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onLoad = new _miniSignals2.default();
	
	        /**
	         * Dispatched when the loader begins to process the queue.
	         *
	         * The callback looks like {@link Loader.OnStartSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onStart = new _miniSignals2.default();
	
	        /**
	         * Dispatched when the queued resources all load.
	         *
	         * The callback looks like {@link Loader.OnCompleteSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onComplete = new _miniSignals2.default();
	
	        /**
	         * When the progress changes the loader and resource are disaptched.
	         *
	         * @memberof Loader
	         * @callback OnProgressSignal
	         * @param {Loader} loader - The loader the progress is advancing on.
	         * @param {Resource} resource - The resource that has completed or failed to cause the progress to advance.
	         */
	
	        /**
	         * When an error occurrs the loader and resource are disaptched.
	         *
	         * @memberof Loader
	         * @callback OnErrorSignal
	         * @param {Loader} loader - The loader the error happened in.
	         * @param {Resource} resource - The resource that caused the error.
	         */
	
	        /**
	         * When a load completes the loader and resource are disaptched.
	         *
	         * @memberof Loader
	         * @callback OnLoadSignal
	         * @param {Loader} loader - The loader that laoded the resource.
	         * @param {Resource} resource - The resource that has completed loading.
	         */
	
	        /**
	         * When the loader starts loading resources it dispatches this callback.
	         *
	         * @memberof Loader
	         * @callback OnStartSignal
	         * @param {Loader} loader - The loader that has started loading resources.
	         */
	
	        /**
	         * When the loader completes loading resources it dispatches this callback.
	         *
	         * @memberof Loader
	         * @callback OnCompleteSignal
	         * @param {Loader} loader - The loader that has finished loading resources.
	         */
	    }
	
	    /**
	     * Adds a resource (or multiple resources) to the loader queue.
	     *
	     * This function can take a wide variety of different parameters. The only thing that is always
	     * required the url to load. All the following will work:
	     *
	     * ```js
	     * loader
	     *     // normal param syntax
	     *     .add('key', 'http://...', function () {})
	     *     .add('http://...', function () {})
	     *     .add('http://...')
	     *
	     *     // object syntax
	     *     .add({
	     *         name: 'key2',
	     *         url: 'http://...'
	     *     }, function () {})
	     *     .add({
	     *         url: 'http://...'
	     *     }, function () {})
	     *     .add({
	     *         name: 'key3',
	     *         url: 'http://...'
	     *         onComplete: function () {}
	     *     })
	     *     .add({
	     *         url: 'https://...',
	     *         onComplete: function () {},
	     *         crossOrigin: true
	     *     })
	     *
	     *     // you can also pass an array of objects or urls or both
	     *     .add([
	     *         { name: 'key4', url: 'http://...', onComplete: function () {} },
	     *         { url: 'http://...', onComplete: function () {} },
	     *         'http://...'
	     *     ])
	     *
	     *     // and you can use both params and options
	     *     .add('key', 'http://...', { crossOrigin: true }, function () {})
	     *     .add('http://...', { crossOrigin: true }, function () {});
	     * ```
	     *
	     * @param {string} [name] - The name of the resource to load, if not passed the url is used.
	     * @param {string} [url] - The url for this resource, relative to the baseUrl of this loader.
	     * @param {object} [options] - The options for the load.
	     * @param {boolean} [options.crossOrigin] - Is this request cross-origin? Default is to determine automatically.
	     * @param {Resource.LOAD_TYPE} [options.loadType=Resource.LOAD_TYPE.XHR] - How should this resource be loaded?
	     * @param {Resource.XHR_RESPONSE_TYPE} [options.xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How should
	     *      the data being loaded be interpreted when using XHR?
	     * @param {object} [options.metadata] - Extra configuration for middleware and the Resource object.
	     * @param {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [options.metadata.loadElement=null] - The
	     *      element to use for loading, instead of creating one.
	     * @param {boolean} [options.metadata.skipSource=false] - Skips adding source(s) to the load element. This
	     *      is useful if you want to pass in a `loadElement` that you already added load sources to.
	     * @param {function} [cb] - Function to call when this specific resource completes loading.
	     * @return {Loader} Returns itself.
	     */
	
	
	    Loader.prototype.add = function add(name, url, options, cb) {
	        // special case of an array of objects or urls
	        if (Array.isArray(name)) {
	            for (var i = 0; i < name.length; ++i) {
	                this.add(name[i]);
	            }
	
	            return this;
	        }
	
	        // if an object is passed instead of params
	        if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	            cb = url || name.callback || name.onComplete;
	            options = name;
	            url = name.url;
	            name = name.name || name.key || name.url;
	        }
	
	        // case where no name is passed shift all args over by one.
	        if (typeof url !== 'string') {
	            cb = options;
	            options = url;
	            url = name;
	        }
	
	        // now that we shifted make sure we have a proper url.
	        if (typeof url !== 'string') {
	            throw new Error('No url passed to add resource to loader.');
	        }
	
	        // options are optional so people might pass a function and no options
	        if (typeof options === 'function') {
	            cb = options;
	            options = null;
	        }
	
	        // if loading already you can only add resources that have a parent.
	        if (this.loading && (!options || !options.parentResource)) {
	            throw new Error('Cannot add resources while the loader is running.');
	        }
	
	        // check if resource already exists.
	        if (this.resources[name]) {
	            throw new Error('Resource named "' + name + '" already exists.');
	        }
	
	        // add base url if this isn't an absolute url
	        url = this._prepareUrl(url);
	
	        // create the store the resource
	        this.resources[name] = new _Resource2.default(name, url, options);
	
	        if (typeof cb === 'function') {
	            this.resources[name].onAfterMiddleware.once(cb);
	        }
	
	        // if actively loading, make sure to adjust progress chunks for that parent and its children
	        if (this.loading) {
	            var parent = options.parentResource;
	            var incompleteChildren = [];
	
	            for (var _i = 0; _i < parent.children.length; ++_i) {
	                if (!parent.children[_i].isComplete) {
	                    incompleteChildren.push(parent.children[_i]);
	                }
	            }
	
	            var fullChunk = parent.progressChunk * (incompleteChildren.length + 1); // +1 for parent
	            var eachChunk = fullChunk / (incompleteChildren.length + 2); // +2 for parent & new child
	
	            parent.children.push(this.resources[name]);
	            parent.progressChunk = eachChunk;
	
	            for (var _i2 = 0; _i2 < incompleteChildren.length; ++_i2) {
	                incompleteChildren[_i2].progressChunk = eachChunk;
	            }
	
	            this.resources[name].progressChunk = eachChunk;
	        }
	
	        // add the resource to the queue
	        this._queue.push(this.resources[name]);
	
	        return this;
	    };
	
	    /**
	     * Sets up a middleware function that will run *before* the
	     * resource is loaded.
	     *
	     * @method before
	     * @param {function} fn - The middleware function to register.
	     * @return {Loader} Returns itself.
	     */
	
	
	    Loader.prototype.pre = function pre(fn) {
	        this._beforeMiddleware.push(fn);
	
	        return this;
	    };
	
	    /**
	     * Sets up a middleware function that will run *after* the
	     * resource is loaded.
	     *
	     * @alias use
	     * @method after
	     * @param {function} fn - The middleware function to register.
	     * @return {Loader} Returns itself.
	     */
	
	
	    Loader.prototype.use = function use(fn) {
	        this._afterMiddleware.push(fn);
	
	        return this;
	    };
	
	    /**
	     * Resets the queue of the loader to prepare for a new load.
	     *
	     * @return {Loader} Returns itself.
	     */
	
	
	    Loader.prototype.reset = function reset() {
	        this.progress = 0;
	        this.loading = false;
	
	        this._queue.kill();
	        this._queue.pause();
	
	        // abort all resource loads
	        for (var k in this.resources) {
	            var res = this.resources[k];
	
	            if (res._onLoadBinding) {
	                res._onLoadBinding.detach();
	            }
	
	            if (res.isLoading) {
	                res.abort();
	            }
	        }
	
	        this.resources = {};
	
	        return this;
	    };
	
	    /**
	     * Starts loading the queued resources.
	     *
	     * @param {function} [cb] - Optional callback that will be bound to the `complete` event.
	     * @return {Loader} Returns itself.
	     */
	
	
	    Loader.prototype.load = function load(cb) {
	        // register complete callback if they pass one
	        if (typeof cb === 'function') {
	            this.onComplete.once(cb);
	        }
	
	        // if the queue has already started we are done here
	        if (this.loading) {
	            return this;
	        }
	
	        if (this._queue.idle()) {
	            this._onStart();
	            this._onComplete();
	        } else {
	            // distribute progress chunks
	            var numTasks = this._queue._tasks.length;
	            var chunk = 100 / numTasks;
	
	            for (var i = 0; i < this._queue._tasks.length; ++i) {
	                this._queue._tasks[i].data.progressChunk = chunk;
	            }
	
	            // notify we are starting
	            this._onStart();
	
	            // start loading
	            this._queue.resume();
	        }
	
	        return this;
	    };
	
	    /**
	     * The number of resources to load concurrently.
	     *
	     * @member {number}
	     * @default 10
	     */
	
	
	    /**
	     * Prepares a url for usage based on the configuration of this object
	     *
	     * @private
	     * @param {string} url - The url to prepare.
	     * @return {string} The prepared url.
	     */
	    Loader.prototype._prepareUrl = function _prepareUrl(url) {
	        var parsedUrl = (0, _parseUri2.default)(url, { strictMode: true });
	        var result = void 0;
	
	        // absolute url, just use it as is.
	        if (parsedUrl.protocol || !parsedUrl.path || url.indexOf('//') === 0) {
	            result = url;
	        }
	        // if baseUrl doesn't end in slash and url doesn't start with slash, then add a slash inbetween
	        else if (this.baseUrl.length && this.baseUrl.lastIndexOf('/') !== this.baseUrl.length - 1 && url.charAt(0) !== '/') {
	                result = this.baseUrl + '/' + url;
	            } else {
	                result = this.baseUrl + url;
	            }
	
	        // if we need to add a default querystring, there is a bit more work
	        if (this.defaultQueryString) {
	            var hash = rgxExtractUrlHash.exec(result)[0];
	
	            result = result.substr(0, result.length - hash.length);
	
	            if (result.indexOf('?') !== -1) {
	                result += '&' + this.defaultQueryString;
	            } else {
	                result += '?' + this.defaultQueryString;
	            }
	
	            result += hash;
	        }
	
	        return result;
	    };
	
	    /**
	     * Loads a single resource.
	     *
	     * @private
	     * @param {Resource} resource - The resource to load.
	     * @param {function} dequeue - The function to call when we need to dequeue this item.
	     */
	
	
	    Loader.prototype._loadResource = function _loadResource(resource, dequeue) {
	        var _this2 = this;
	
	        resource._dequeue = dequeue;
	
	        // run before middleware
	        async.eachSeries(this._beforeMiddleware, function (fn, next) {
	            fn.call(_this2, resource, function () {
	                // if the before middleware marks the resource as complete,
	                // break and don't process any more before middleware
	                next(resource.isComplete ? {} : null);
	            });
	        }, function () {
	            if (resource.isComplete) {
	                _this2._onLoad(resource);
	            } else {
	                resource._onLoadBinding = resource.onComplete.once(_this2._onLoad, _this2);
	                resource.load();
	            }
	        }, true);
	    };
	
	    /**
	     * Called once loading has started.
	     *
	     * @private
	     */
	
	
	    Loader.prototype._onStart = function _onStart() {
	        this.progress = 0;
	        this.loading = true;
	        this.onStart.dispatch(this);
	    };
	
	    /**
	     * Called once each resource has loaded.
	     *
	     * @private
	     */
	
	
	    Loader.prototype._onComplete = function _onComplete() {
	        this.progress = MAX_PROGRESS;
	        this.loading = false;
	        this.onComplete.dispatch(this, this.resources);
	    };
	
	    /**
	     * Called each time a resources is loaded.
	     *
	     * @private
	     * @param {Resource} resource - The resource that was loaded
	     */
	
	
	    Loader.prototype._onLoad = function _onLoad(resource) {
	        var _this3 = this;
	
	        resource._onLoadBinding = null;
	
	        // remove this resource from the async queue, and add it to our list of resources that are being parsed
	        this._resourcesParsing.push(resource);
	        resource._dequeue();
	
	        // run all the after middleware for this resource
	        async.eachSeries(this._afterMiddleware, function (fn, next) {
	            fn.call(_this3, resource, next);
	        }, function () {
	            resource.onAfterMiddleware.dispatch(resource);
	
	            _this3.progress += resource.progressChunk;
	            _this3.onProgress.dispatch(_this3, resource);
	
	            if (resource.error) {
	                _this3.onError.dispatch(resource.error, _this3, resource);
	            } else {
	                _this3.onLoad.dispatch(_this3, resource);
	            }
	
	            _this3._resourcesParsing.splice(_this3._resourcesParsing.indexOf(resource), 1);
	
	            // do completion check
	            if (_this3._queue.idle() && _this3._resourcesParsing.length === 0) {
	                _this3._onComplete();
	            }
	        }, true);
	    };
	
	    _createClass(Loader, [{
	        key: 'concurrency',
	        get: function get() {
	            return this._queue.concurrency;
	        }
	        // eslint-disable-next-line require-jsdoc
	        ,
	        set: function set(concurrency) {
	            this._queue.concurrency = concurrency;
	        }
	    }]);
	
	    return Loader;
	}();
	
	exports.default = Loader;
	//# sourceMappingURL=Loader.js.map

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var MiniSignalBinding = (function () {
	  function MiniSignalBinding(fn, once, thisArg) {
	    if (once === undefined) once = false;
	
	    _classCallCheck(this, MiniSignalBinding);
	
	    this._fn = fn;
	    this._once = once;
	    this._thisArg = thisArg;
	    this._next = this._prev = this._owner = null;
	  }
	
	  _createClass(MiniSignalBinding, [{
	    key: 'detach',
	    value: function detach() {
	      if (this._owner === null) return false;
	      this._owner.detach(this);
	      return true;
	    }
	  }]);
	
	  return MiniSignalBinding;
	})();
	
	function _addMiniSignalBinding(self, node) {
	  if (!self._head) {
	    self._head = node;
	    self._tail = node;
	  } else {
	    self._tail._next = node;
	    node._prev = self._tail;
	    self._tail = node;
	  }
	
	  node._owner = self;
	
	  return node;
	}
	
	var MiniSignal = (function () {
	  function MiniSignal() {
	    _classCallCheck(this, MiniSignal);
	
	    this._head = this._tail = undefined;
	  }
	
	  _createClass(MiniSignal, [{
	    key: 'handlers',
	    value: function handlers() {
	      var exists = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	      var node = this._head;
	
	      if (exists) return !!node;
	
	      var ee = [];
	
	      while (node) {
	        ee.push(node);
	        node = node._next;
	      }
	
	      return ee;
	    }
	  }, {
	    key: 'has',
	    value: function has(node) {
	      if (!(node instanceof MiniSignalBinding)) {
	        throw new Error('MiniSignal#has(): First arg must be a MiniSignalBinding object.');
	      }
	
	      return node._owner === this;
	    }
	  }, {
	    key: 'dispatch',
	    value: function dispatch() {
	      var node = this._head;
	
	      if (!node) return false;
	
	      while (node) {
	        if (node._once) this.detach(node);
	        node._fn.apply(node._thisArg, arguments);
	        node = node._next;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'add',
	    value: function add(fn) {
	      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	      if (typeof fn !== 'function') {
	        throw new Error('MiniSignal#add(): First arg must be a Function.');
	      }
	      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, false, thisArg));
	    }
	  }, {
	    key: 'once',
	    value: function once(fn) {
	      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	      if (typeof fn !== 'function') {
	        throw new Error('MiniSignal#once(): First arg must be a Function.');
	      }
	      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, true, thisArg));
	    }
	  }, {
	    key: 'detach',
	    value: function detach(node) {
	      if (!(node instanceof MiniSignalBinding)) {
	        throw new Error('MiniSignal#detach(): First arg must be a MiniSignalBinding object.');
	      }
	      if (node._owner !== this) return this;
	
	      if (node._prev) node._prev._next = node._next;
	      if (node._next) node._next._prev = node._prev;
	
	      if (node === this._head) {
	        this._head = node._next;
	        if (node._next === null) {
	          this._tail = null;
	        }
	      } else if (node === this._tail) {
	        this._tail = node._prev;
	        this._tail._next = null;
	      }
	
	      node._owner = null;
	      return this;
	    }
	  }, {
	    key: 'detachAll',
	    value: function detachAll() {
	      var node = this._head;
	      if (!node) return this;
	
	      this._head = this._tail = null;
	
	      while (node) {
	        node._owner = null;
	        node = node._next;
	      }
	      return this;
	    }
	  }]);
	
	  return MiniSignal;
	})();
	
	MiniSignal.MiniSignalBinding = MiniSignalBinding;
	
	exports['default'] = MiniSignal;
	module.exports = exports['default'];


/***/ }),
/* 360 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = function parseURI (str, opts) {
	  opts = opts || {}
	
	  var o = {
	    key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
	    q: {
	      name: 'queryKey',
	      parser: /(?:^|&)([^&=]*)=?([^&]*)/g
	    },
	    parser: {
	      strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
	      loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
	    }
	  }
	
	  var m = o.parser[opts.strictMode ? 'strict' : 'loose'].exec(str)
	  var uri = {}
	  var i = 14
	
	  while (i--) uri[o.key[i]] = m[i] || ''
	
	  uri[o.q.name] = {}
	  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
	    if ($1) uri[o.q.name][$1] = $2
	  })
	
	  return uri
	}


/***/ }),
/* 361 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.eachSeries = eachSeries;
	exports.queue = queue;
	/**
	 * Smaller version of the async library constructs.
	 *
	 */
	function _noop() {} /* empty */
	
	/**
	 * Iterates an array in series.
	 *
	 * @param {Array.<*>} array - Array to iterate.
	 * @param {function} iterator - Function to call for each element.
	 * @param {function} callback - Function to call when done, or on error.
	 * @param {boolean} [deferNext=false] - Break synchronous each loop by calling next with a setTimeout of 1.
	 */
	function eachSeries(array, iterator, callback, deferNext) {
	    var i = 0;
	    var len = array.length;
	
	    (function next(err) {
	        if (err || i === len) {
	            if (callback) {
	                callback(err);
	            }
	
	            return;
	        }
	
	        if (deferNext) {
	            setTimeout(function () {
	                iterator(array[i++], next);
	            }, 1);
	        } else {
	            iterator(array[i++], next);
	        }
	    })();
	}
	
	/**
	 * Ensures a function is only called once.
	 *
	 * @param {function} fn - The function to wrap.
	 * @return {function} The wrapping function.
	 */
	function onlyOnce(fn) {
	    return function onceWrapper() {
	        if (fn === null) {
	            throw new Error('Callback was already called.');
	        }
	
	        var callFn = fn;
	
	        fn = null;
	        callFn.apply(this, arguments);
	    };
	}
	
	/**
	 * Async queue implementation,
	 *
	 * @param {function} worker - The worker function to call for each task.
	 * @param {number} concurrency - How many workers to run in parrallel.
	 * @return {*} The async queue object.
	 */
	function queue(worker, concurrency) {
	    if (concurrency == null) {
	        // eslint-disable-line no-eq-null,eqeqeq
	        concurrency = 1;
	    } else if (concurrency === 0) {
	        throw new Error('Concurrency must not be zero');
	    }
	
	    var workers = 0;
	    var q = {
	        _tasks: [],
	        concurrency: concurrency,
	        saturated: _noop,
	        unsaturated: _noop,
	        buffer: concurrency / 4,
	        empty: _noop,
	        drain: _noop,
	        error: _noop,
	        started: false,
	        paused: false,
	        push: function push(data, callback) {
	            _insert(data, false, callback);
	        },
	        kill: function kill() {
	            workers = 0;
	            q.drain = _noop;
	            q.started = false;
	            q._tasks = [];
	        },
	        unshift: function unshift(data, callback) {
	            _insert(data, true, callback);
	        },
	        process: function process() {
	            while (!q.paused && workers < q.concurrency && q._tasks.length) {
	                var task = q._tasks.shift();
	
	                if (q._tasks.length === 0) {
	                    q.empty();
	                }
	
	                workers += 1;
	
	                if (workers === q.concurrency) {
	                    q.saturated();
	                }
	
	                worker(task.data, onlyOnce(_next(task)));
	            }
	        },
	        length: function length() {
	            return q._tasks.length;
	        },
	        running: function running() {
	            return workers;
	        },
	        idle: function idle() {
	            return q._tasks.length + workers === 0;
	        },
	        pause: function pause() {
	            if (q.paused === true) {
	                return;
	            }
	
	            q.paused = true;
	        },
	        resume: function resume() {
	            if (q.paused === false) {
	                return;
	            }
	
	            q.paused = false;
	
	            // Need to call q.process once per concurrent
	            // worker to preserve full concurrency after pause
	            for (var w = 1; w <= q.concurrency; w++) {
	                q.process();
	            }
	        }
	    };
	
	    function _insert(data, insertAtFront, callback) {
	        if (callback != null && typeof callback !== 'function') {
	            // eslint-disable-line no-eq-null,eqeqeq
	            throw new Error('task callback must be a function');
	        }
	
	        q.started = true;
	
	        if (data == null && q.idle()) {
	            // eslint-disable-line no-eq-null,eqeqeq
	            // call drain immediately if there are no tasks
	            setTimeout(function () {
	                return q.drain();
	            }, 1);
	
	            return;
	        }
	
	        var item = {
	            data: data,
	            callback: typeof callback === 'function' ? callback : _noop
	        };
	
	        if (insertAtFront) {
	            q._tasks.unshift(item);
	        } else {
	            q._tasks.push(item);
	        }
	
	        setTimeout(function () {
	            return q.process();
	        }, 1);
	    }
	
	    function _next(task) {
	        return function next() {
	            workers -= 1;
	
	            task.callback.apply(task, arguments);
	
	            if (arguments[0] != null) {
	                // eslint-disable-line no-eq-null,eqeqeq
	                q.error(arguments[0], task.data);
	            }
	
	            if (workers <= q.concurrency - q.buffer) {
	                q.unsaturated();
	            }
	
	            if (q.idle()) {
	                q.drain();
	            }
	
	            q.process();
	        };
	    }
	
	    return q;
	}
	//# sourceMappingURL=async.js.map

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parseUri = __webpack_require__(360);
	
	var _parseUri2 = _interopRequireDefault(_parseUri);
	
	var _miniSignals = __webpack_require__(359);
	
	var _miniSignals2 = _interopRequireDefault(_miniSignals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// tests is CORS is supported in XHR, if not we need to use XDR
	var useXdr = !!(window.XDomainRequest && !('withCredentials' in new XMLHttpRequest()));
	var tempAnchor = null;
	
	// some status constants
	var STATUS_NONE = 0;
	var STATUS_OK = 200;
	var STATUS_EMPTY = 204;
	var STATUS_IE_BUG_EMPTY = 1223;
	var STATUS_TYPE_OK = 2;
	
	// noop
	function _noop() {} /* empty */
	
	/**
	 * Manages the state and loading of a resource and all child resources.
	 *
	 * @class
	 */
	
	var Resource = function () {
	    /**
	     * Sets the load type to be used for a specific extension.
	     *
	     * @static
	     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
	     * @param {Resource.LOAD_TYPE} loadType - The load type to set it to.
	     */
	    Resource.setExtensionLoadType = function setExtensionLoadType(extname, loadType) {
	        setExtMap(Resource._loadTypeMap, extname, loadType);
	    };
	
	    /**
	     * Sets the load type to be used for a specific extension.
	     *
	     * @static
	     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
	     * @param {Resource.XHR_RESPONSE_TYPE} xhrType - The xhr type to set it to.
	     */
	
	
	    Resource.setExtensionXhrType = function setExtensionXhrType(extname, xhrType) {
	        setExtMap(Resource._xhrTypeMap, extname, xhrType);
	    };
	
	    /**
	     * @param {string} name - The name of the resource to load.
	     * @param {string|string[]} url - The url for this resource, for audio/video loads you can pass
	     *      an array of sources.
	     * @param {object} [options] - The options for the load.
	     * @param {string|boolean} [options.crossOrigin] - Is this request cross-origin? Default is to
	     *      determine automatically.
	     * @param {Resource.LOAD_TYPE} [options.loadType=Resource.LOAD_TYPE.XHR] - How should this resource
	     *      be loaded?
	     * @param {Resource.XHR_RESPONSE_TYPE} [options.xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How
	     *      should the data being loaded be interpreted when using XHR?
	     * @param {object} [options.metadata] - Extra configuration for middleware and the Resource object.
	     * @param {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [options.metadata.loadElement=null] - The
	     *      element to use for loading, instead of creating one.
	     * @param {boolean} [options.metadata.skipSource=false] - Skips adding source(s) to the load element. This
	     *      is useful if you want to pass in a `loadElement` that you already added load sources to.
	     * @param {string|string[]} [options.metadata.mimeType] - The mime type to use for the source element of a video/audio
	     *      elment. If the urls are an array, you can pass this as an array as well where each index is the mime type to
	     *      use for the corresponding url index.
	     */
	
	
	    function Resource(name, url, options) {
	        _classCallCheck(this, Resource);
	
	        if (typeof name !== 'string' || typeof url !== 'string') {
	            throw new Error('Both name and url are required for constructing a resource.');
	        }
	
	        options = options || {};
	
	        /**
	         * The state flags of this resource.
	         *
	         * @member {number}
	         */
	        this._flags = 0;
	
	        // set data url flag, needs to be set early for some _determineX checks to work.
	        this._setFlag(Resource.STATUS_FLAGS.DATA_URL, url.indexOf('data:') === 0);
	
	        /**
	         * The name of this resource.
	         *
	         * @member {string}
	         * @readonly
	         */
	        this.name = name;
	
	        /**
	         * The url used to load this resource.
	         *
	         * @member {string}
	         * @readonly
	         */
	        this.url = url;
	
	        /**
	         * The extension used to load this resource.
	         *
	         * @member {string}
	         * @readonly
	         */
	        this.extension = this._getExtension();
	
	        /**
	         * The data that was loaded by the resource.
	         *
	         * @member {any}
	         */
	        this.data = null;
	
	        /**
	         * Is this request cross-origin? If unset, determined automatically.
	         *
	         * @member {string}
	         */
	        this.crossOrigin = options.crossOrigin === true ? 'anonymous' : options.crossOrigin;
	
	        /**
	         * The method of loading to use for this resource.
	         *
	         * @member {Resource.LOAD_TYPE}
	         */
	        this.loadType = options.loadType || this._determineLoadType();
	
	        /**
	         * The type used to load the resource via XHR. If unset, determined automatically.
	         *
	         * @member {string}
	         */
	        this.xhrType = options.xhrType;
	
	        /**
	         * Extra info for middleware, and controlling specifics about how the resource loads.
	         *
	         * Note that if you pass in a `loadElement`, the Resource class takes ownership of it.
	         * Meaning it will modify it as it sees fit.
	         *
	         * @member {object}
	         * @property {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [loadElement=null] - The
	         *  element to use for loading, instead of creating one.
	         * @property {boolean} [skipSource=false] - Skips adding source(s) to the load element. This
	         *  is useful if you want to pass in a `loadElement` that you already added load sources
	         *  to.
	         */
	        this.metadata = options.metadata || {};
	
	        /**
	         * The error that occurred while loading (if any).
	         *
	         * @member {Error}
	         * @readonly
	         */
	        this.error = null;
	
	        /**
	         * The XHR object that was used to load this resource. This is only set
	         * when `loadType` is `Resource.LOAD_TYPE.XHR`.
	         *
	         * @member {XMLHttpRequest}
	         * @readonly
	         */
	        this.xhr = null;
	
	        /**
	         * The child resources this resource owns.
	         *
	         * @member {Resource[]}
	         * @readonly
	         */
	        this.children = [];
	
	        /**
	         * The resource type.
	         *
	         * @member {Resource.TYPE}
	         * @readonly
	         */
	        this.type = Resource.TYPE.UNKNOWN;
	
	        /**
	         * The progress chunk owned by this resource.
	         *
	         * @member {number}
	         * @readonly
	         */
	        this.progressChunk = 0;
	
	        /**
	         * The `dequeue` method that will be used a storage place for the async queue dequeue method
	         * used privately by the loader.
	         *
	         * @private
	         * @member {function}
	         */
	        this._dequeue = _noop;
	
	        /**
	         * Used a storage place for the on load binding used privately by the loader.
	         *
	         * @private
	         * @member {function}
	         */
	        this._onLoadBinding = null;
	
	        /**
	         * The `complete` function bound to this resource's context.
	         *
	         * @private
	         * @member {function}
	         */
	        this._boundComplete = this.complete.bind(this);
	
	        /**
	         * The `_onError` function bound to this resource's context.
	         *
	         * @private
	         * @member {function}
	         */
	        this._boundOnError = this._onError.bind(this);
	
	        /**
	         * The `_onProgress` function bound to this resource's context.
	         *
	         * @private
	         * @member {function}
	         */
	        this._boundOnProgress = this._onProgress.bind(this);
	
	        // xhr callbacks
	        this._boundXhrOnError = this._xhrOnError.bind(this);
	        this._boundXhrOnAbort = this._xhrOnAbort.bind(this);
	        this._boundXhrOnLoad = this._xhrOnLoad.bind(this);
	        this._boundXdrOnTimeout = this._xdrOnTimeout.bind(this);
	
	        /**
	         * Dispatched when the resource beings to load.
	         *
	         * The callback looks like {@link Resource.OnStartSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onStart = new _miniSignals2.default();
	
	        /**
	         * Dispatched each time progress of this resource load updates.
	         * Not all resources types and loader systems can support this event
	         * so sometimes it may not be available. If the resource
	         * is being loaded on a modern browser, using XHR, and the remote server
	         * properly sets Content-Length headers, then this will be available.
	         *
	         * The callback looks like {@link Resource.OnProgressSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onProgress = new _miniSignals2.default();
	
	        /**
	         * Dispatched once this resource has loaded, if there was an error it will
	         * be in the `error` property.
	         *
	         * The callback looks like {@link Resource.OnCompleteSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onComplete = new _miniSignals2.default();
	
	        /**
	         * Dispatched after this resource has had all the *after* middleware run on it.
	         *
	         * The callback looks like {@link Resource.OnCompleteSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onAfterMiddleware = new _miniSignals2.default();
	
	        /**
	         * When the resource starts to load.
	         *
	         * @memberof Resource
	         * @callback OnStartSignal
	         * @param {Resource} resource - The resource that the event happened on.
	         */
	
	        /**
	         * When the resource reports loading progress.
	         *
	         * @memberof Resource
	         * @callback OnProgressSignal
	         * @param {Resource} resource - The resource that the event happened on.
	         * @param {number} percentage - The progress of the load in the range [0, 1].
	         */
	
	        /**
	         * When the resource finishes loading.
	         *
	         * @memberof Resource
	         * @callback OnCompleteSignal
	         * @param {Resource} resource - The resource that the event happened on.
	         */
	    }
	
	    /**
	     * Stores whether or not this url is a data url.
	     *
	     * @member {boolean}
	     * @readonly
	     */
	
	
	    /**
	     * Marks the resource as complete.
	     *
	     */
	    Resource.prototype.complete = function complete() {
	        // TODO: Clean this up in a wrapper or something...gross....
	        if (this.data && this.data.removeEventListener) {
	            this.data.removeEventListener('error', this._boundOnError, false);
	            this.data.removeEventListener('load', this._boundComplete, false);
	            this.data.removeEventListener('progress', this._boundOnProgress, false);
	            this.data.removeEventListener('canplaythrough', this._boundComplete, false);
	        }
	
	        if (this.xhr) {
	            if (this.xhr.removeEventListener) {
	                this.xhr.removeEventListener('error', this._boundXhrOnError, false);
	                this.xhr.removeEventListener('abort', this._boundXhrOnAbort, false);
	                this.xhr.removeEventListener('progress', this._boundOnProgress, false);
	                this.xhr.removeEventListener('load', this._boundXhrOnLoad, false);
	            } else {
	                this.xhr.onerror = null;
	                this.xhr.ontimeout = null;
	                this.xhr.onprogress = null;
	                this.xhr.onload = null;
	            }
	        }
	
	        if (this.isComplete) {
	            throw new Error('Complete called again for an already completed resource.');
	        }
	
	        this._setFlag(Resource.STATUS_FLAGS.COMPLETE, true);
	        this._setFlag(Resource.STATUS_FLAGS.LOADING, false);
	
	        this.onComplete.dispatch(this);
	    };
	
	    /**
	     * Aborts the loading of this resource, with an optional message.
	     *
	     * @param {string} message - The message to use for the error
	     */
	
	
	    Resource.prototype.abort = function abort(message) {
	        // abort can be called multiple times, ignore subsequent calls.
	        if (this.error) {
	            return;
	        }
	
	        // store error
	        this.error = new Error(message);
	
	        // abort the actual loading
	        if (this.xhr) {
	            this.xhr.abort();
	        } else if (this.xdr) {
	            this.xdr.abort();
	        } else if (this.data) {
	            // single source
	            if (this.data.src) {
	                this.data.src = Resource.EMPTY_GIF;
	            }
	            // multi-source
	            else {
	                    while (this.data.firstChild) {
	                        this.data.removeChild(this.data.firstChild);
	                    }
	                }
	        }
	
	        // done now.
	        this.complete();
	    };
	
	    /**
	     * Kicks off loading of this resource. This method is asynchronous.
	     *
	     * @param {function} [cb] - Optional callback to call once the resource is loaded.
	     */
	
	
	    Resource.prototype.load = function load(cb) {
	        var _this = this;
	
	        if (this.isLoading) {
	            return;
	        }
	
	        if (this.isComplete) {
	            if (cb) {
	                setTimeout(function () {
	                    return cb(_this);
	                }, 1);
	            }
	
	            return;
	        } else if (cb) {
	            this.onComplete.once(cb);
	        }
	
	        this._setFlag(Resource.STATUS_FLAGS.LOADING, true);
	
	        this.onStart.dispatch(this);
	
	        // if unset, determine the value
	        if (this.crossOrigin === false || typeof this.crossOrigin !== 'string') {
	            this.crossOrigin = this._determineCrossOrigin(this.url);
	        }
	
	        switch (this.loadType) {
	            case Resource.LOAD_TYPE.IMAGE:
	                this.type = Resource.TYPE.IMAGE;
	                this._loadElement('image');
	                break;
	
	            case Resource.LOAD_TYPE.AUDIO:
	                this.type = Resource.TYPE.AUDIO;
	                this._loadSourceElement('audio');
	                break;
	
	            case Resource.LOAD_TYPE.VIDEO:
	                this.type = Resource.TYPE.VIDEO;
	                this._loadSourceElement('video');
	                break;
	
	            case Resource.LOAD_TYPE.XHR:
	            /* falls through */
	            default:
	                if (useXdr && this.crossOrigin) {
	                    this._loadXdr();
	                } else {
	                    this._loadXhr();
	                }
	                break;
	        }
	    };
	
	    /**
	     * Checks if the flag is set.
	     *
	     * @private
	     * @param {number} flag - The flag to check.
	     * @return {boolean} True if the flag is set.
	     */
	
	
	    Resource.prototype._hasFlag = function _hasFlag(flag) {
	        return !!(this._flags & flag);
	    };
	
	    /**
	     * (Un)Sets the flag.
	     *
	     * @private
	     * @param {number} flag - The flag to (un)set.
	     * @param {boolean} value - Whether to set or (un)set the flag.
	     */
	
	
	    Resource.prototype._setFlag = function _setFlag(flag, value) {
	        this._flags = value ? this._flags | flag : this._flags & ~flag;
	    };
	
	    /**
	     * Loads this resources using an element that has a single source,
	     * like an HTMLImageElement.
	     *
	     * @private
	     * @param {string} type - The type of element to use.
	     */
	
	
	    Resource.prototype._loadElement = function _loadElement(type) {
	        if (this.metadata.loadElement) {
	            this.data = this.metadata.loadElement;
	        } else if (type === 'image' && typeof window.Image !== 'undefined') {
	            this.data = new Image();
	        } else {
	            this.data = document.createElement(type);
	        }
	
	        if (this.crossOrigin) {
	            this.data.crossOrigin = this.crossOrigin;
	        }
	
	        if (!this.metadata.skipSource) {
	            this.data.src = this.url;
	        }
	
	        this.data.addEventListener('error', this._boundOnError, false);
	        this.data.addEventListener('load', this._boundComplete, false);
	        this.data.addEventListener('progress', this._boundOnProgress, false);
	    };
	
	    /**
	     * Loads this resources using an element that has multiple sources,
	     * like an HTMLAudioElement or HTMLVideoElement.
	     *
	     * @private
	     * @param {string} type - The type of element to use.
	     */
	
	
	    Resource.prototype._loadSourceElement = function _loadSourceElement(type) {
	        if (this.metadata.loadElement) {
	            this.data = this.metadata.loadElement;
	        } else if (type === 'audio' && typeof window.Audio !== 'undefined') {
	            this.data = new Audio();
	        } else {
	            this.data = document.createElement(type);
	        }
	
	        if (this.data === null) {
	            this.abort('Unsupported element: ' + type);
	
	            return;
	        }
	
	        if (!this.metadata.skipSource) {
	            // support for CocoonJS Canvas+ runtime, lacks document.createElement('source')
	            if (navigator.isCocoonJS) {
	                this.data.src = Array.isArray(this.url) ? this.url[0] : this.url;
	            } else if (Array.isArray(this.url)) {
	                var mimeTypes = this.metadata.mimeType;
	
	                for (var i = 0; i < this.url.length; ++i) {
	                    this.data.appendChild(this._createSource(type, this.url[i], Array.isArray(mimeTypes) ? mimeTypes[i] : mimeTypes));
	                }
	            } else {
	                var _mimeTypes = this.metadata.mimeType;
	
	                this.data.appendChild(this._createSource(type, this.url, Array.isArray(_mimeTypes) ? _mimeTypes[0] : _mimeTypes));
	            }
	        }
	
	        this.data.addEventListener('error', this._boundOnError, false);
	        this.data.addEventListener('load', this._boundComplete, false);
	        this.data.addEventListener('progress', this._boundOnProgress, false);
	        this.data.addEventListener('canplaythrough', this._boundComplete, false);
	
	        this.data.load();
	    };
	
	    /**
	     * Loads this resources using an XMLHttpRequest.
	     *
	     * @private
	     */
	
	
	    Resource.prototype._loadXhr = function _loadXhr() {
	        // if unset, determine the value
	        if (typeof this.xhrType !== 'string') {
	            this.xhrType = this._determineXhrType();
	        }
	
	        var xhr = this.xhr = new XMLHttpRequest();
	
	        // set the request type and url
	        xhr.open('GET', this.url, true);
	
	        // load json as text and parse it ourselves. We do this because some browsers
	        // *cough* safari *cough* can't deal with it.
	        if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON || this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
	            xhr.responseType = Resource.XHR_RESPONSE_TYPE.TEXT;
	        } else {
	            xhr.responseType = this.xhrType;
	        }
	
	        xhr.addEventListener('error', this._boundXhrOnError, false);
	        xhr.addEventListener('abort', this._boundXhrOnAbort, false);
	        xhr.addEventListener('progress', this._boundOnProgress, false);
	        xhr.addEventListener('load', this._boundXhrOnLoad, false);
	
	        xhr.send();
	    };
	
	    /**
	     * Loads this resources using an XDomainRequest. This is here because we need to support IE9 (gross).
	     *
	     * @private
	     */
	
	
	    Resource.prototype._loadXdr = function _loadXdr() {
	        // if unset, determine the value
	        if (typeof this.xhrType !== 'string') {
	            this.xhrType = this._determineXhrType();
	        }
	
	        var xdr = this.xhr = new XDomainRequest();
	
	        // XDomainRequest has a few quirks. Occasionally it will abort requests
	        // A way to avoid this is to make sure ALL callbacks are set even if not used
	        // More info here: http://stackoverflow.com/questions/15786966/xdomainrequest-aborts-post-on-ie-9
	        xdr.timeout = 5000;
	
	        xdr.onerror = this._boundXhrOnError;
	        xdr.ontimeout = this._boundXdrOnTimeout;
	        xdr.onprogress = this._boundOnProgress;
	        xdr.onload = this._boundXhrOnLoad;
	
	        xdr.open('GET', this.url, true);
	
	        // Note: The xdr.send() call is wrapped in a timeout to prevent an
	        // issue with the interface where some requests are lost if multiple
	        // XDomainRequests are being sent at the same time.
	        // Some info here: https://github.com/photonstorm/phaser/issues/1248
	        setTimeout(function () {
	            return xdr.send();
	        }, 1);
	    };
	
	    /**
	     * Creates a source used in loading via an element.
	     *
	     * @private
	     * @param {string} type - The element type (video or audio).
	     * @param {string} url - The source URL to load from.
	     * @param {string} [mime] - The mime type of the video
	     * @return {HTMLSourceElement} The source element.
	     */
	
	
	    Resource.prototype._createSource = function _createSource(type, url, mime) {
	        if (!mime) {
	            mime = type + '/' + this._getExtension(url);
	        }
	
	        var source = document.createElement('source');
	
	        source.src = url;
	        source.type = mime;
	
	        return source;
	    };
	
	    /**
	     * Called if a load errors out.
	     *
	     * @param {Event} event - The error event from the element that emits it.
	     * @private
	     */
	
	
	    Resource.prototype._onError = function _onError(event) {
	        this.abort('Failed to load element using: ' + event.target.nodeName);
	    };
	
	    /**
	     * Called if a load progress event fires for xhr/xdr.
	     *
	     * @private
	     * @param {XMLHttpRequestProgressEvent|Event} event - Progress event.
	     */
	
	
	    Resource.prototype._onProgress = function _onProgress(event) {
	        if (event && event.lengthComputable) {
	            this.onProgress.dispatch(this, event.loaded / event.total);
	        }
	    };
	
	    /**
	     * Called if an error event fires for xhr/xdr.
	     *
	     * @private
	     * @param {XMLHttpRequestErrorEvent|Event} event - Error event.
	     */
	
	
	    Resource.prototype._xhrOnError = function _xhrOnError() {
	        var xhr = this.xhr;
	
	        this.abort(reqType(xhr) + ' Request failed. Status: ' + xhr.status + ', text: "' + xhr.statusText + '"');
	    };
	
	    /**
	     * Called if an abort event fires for xhr.
	     *
	     * @private
	     * @param {XMLHttpRequestAbortEvent} event - Abort Event
	     */
	
	
	    Resource.prototype._xhrOnAbort = function _xhrOnAbort() {
	        this.abort(reqType(this.xhr) + ' Request was aborted by the user.');
	    };
	
	    /**
	     * Called if a timeout event fires for xdr.
	     *
	     * @private
	     * @param {Event} event - Timeout event.
	     */
	
	
	    Resource.prototype._xdrOnTimeout = function _xdrOnTimeout() {
	        this.abort(reqType(this.xhr) + ' Request timed out.');
	    };
	
	    /**
	     * Called when data successfully loads from an xhr/xdr request.
	     *
	     * @private
	     * @param {XMLHttpRequestLoadEvent|Event} event - Load event
	     */
	
	
	    Resource.prototype._xhrOnLoad = function _xhrOnLoad() {
	        var xhr = this.xhr;
	        var text = '';
	        var status = typeof xhr.status === 'undefined' ? STATUS_OK : xhr.status; // XDR has no `.status`, assume 200.
	
	        // responseText is accessible only if responseType is '' or 'text' and on older browsers
	        if (xhr.responseType === '' || xhr.responseType === 'text' || typeof xhr.responseType === 'undefined') {
	            text = xhr.responseText;
	        }
	
	        // status can be 0 when using the `file://` protocol so we also check if a response is set.
	        // If it has a response, we assume 200; otherwise a 0 status code with no contents is an aborted request.
	        if (status === STATUS_NONE && (text.length > 0 || xhr.responseType === Resource.XHR_RESPONSE_TYPE.BUFFER)) {
	            status = STATUS_OK;
	        }
	        // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	        else if (status === STATUS_IE_BUG_EMPTY) {
	                status = STATUS_EMPTY;
	            }
	
	        var statusType = status / 100 | 0;
	
	        if (statusType === STATUS_TYPE_OK) {
	            // if text, just return it
	            if (this.xhrType === Resource.XHR_RESPONSE_TYPE.TEXT) {
	                this.data = text;
	                this.type = Resource.TYPE.TEXT;
	            }
	            // if json, parse into json object
	            else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON) {
	                    try {
	                        this.data = JSON.parse(text);
	                        this.type = Resource.TYPE.JSON;
	                    } catch (e) {
	                        this.abort('Error trying to parse loaded json: ' + e);
	
	                        return;
	                    }
	                }
	                // if xml, parse into an xml document or div element
	                else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
	                        try {
	                            if (window.DOMParser) {
	                                var domparser = new DOMParser();
	
	                                this.data = domparser.parseFromString(text, 'text/xml');
	                            } else {
	                                var div = document.createElement('div');
	
	                                div.innerHTML = text;
	
	                                this.data = div;
	                            }
	
	                            this.type = Resource.TYPE.XML;
	                        } catch (e) {
	                            this.abort('Error trying to parse loaded xml: ' + e);
	
	                            return;
	                        }
	                    }
	                    // other types just return the response
	                    else {
	                            this.data = xhr.response || text;
	                        }
	        } else {
	            this.abort('[' + xhr.status + '] ' + xhr.statusText + ': ' + xhr.responseURL);
	
	            return;
	        }
	
	        this.complete();
	    };
	
	    /**
	     * Sets the `crossOrigin` property for this resource based on if the url
	     * for this resource is cross-origin. If crossOrigin was manually set, this
	     * function does nothing.
	     *
	     * @private
	     * @param {string} url - The url to test.
	     * @param {object} [loc=window.location] - The location object to test against.
	     * @return {string} The crossOrigin value to use (or empty string for none).
	     */
	
	
	    Resource.prototype._determineCrossOrigin = function _determineCrossOrigin(url, loc) {
	        // data: and javascript: urls are considered same-origin
	        if (url.indexOf('data:') === 0) {
	            return '';
	        }
	
	        // default is window.location
	        loc = loc || window.location;
	
	        if (!tempAnchor) {
	            tempAnchor = document.createElement('a');
	        }
	
	        // let the browser determine the full href for the url of this resource and then
	        // parse with the node url lib, we can't use the properties of the anchor element
	        // because they don't work in IE9 :(
	        tempAnchor.href = url;
	        url = (0, _parseUri2.default)(tempAnchor.href, { strictMode: true });
	
	        var samePort = !url.port && loc.port === '' || url.port === loc.port;
	        var protocol = url.protocol ? url.protocol + ':' : '';
	
	        // if cross origin
	        if (url.host !== loc.hostname || !samePort || protocol !== loc.protocol) {
	            return 'anonymous';
	        }
	
	        return '';
	    };
	
	    /**
	     * Determines the responseType of an XHR request based on the extension of the
	     * resource being loaded.
	     *
	     * @private
	     * @return {Resource.XHR_RESPONSE_TYPE} The responseType to use.
	     */
	
	
	    Resource.prototype._determineXhrType = function _determineXhrType() {
	        return Resource._xhrTypeMap[this.extension] || Resource.XHR_RESPONSE_TYPE.TEXT;
	    };
	
	    /**
	     * Determines the loadType of a resource based on the extension of the
	     * resource being loaded.
	     *
	     * @private
	     * @return {Resource.LOAD_TYPE} The loadType to use.
	     */
	
	
	    Resource.prototype._determineLoadType = function _determineLoadType() {
	        return Resource._loadTypeMap[this.extension] || Resource.LOAD_TYPE.XHR;
	    };
	
	    /**
	     * Extracts the extension (sans '.') of the file being loaded by the resource.
	     *
	     * @private
	     * @return {string} The extension.
	     */
	
	
	    Resource.prototype._getExtension = function _getExtension() {
	        var url = this.url;
	        var ext = '';
	
	        if (this.isDataUrl) {
	            var slashIndex = url.indexOf('/');
	
	            ext = url.substring(slashIndex + 1, url.indexOf(';', slashIndex));
	        } else {
	            var queryStart = url.indexOf('?');
	            var hashStart = url.indexOf('#');
	            var index = Math.min(queryStart > -1 ? queryStart : url.length, hashStart > -1 ? hashStart : url.length);
	
	            url = url.substring(0, index);
	            ext = url.substring(url.lastIndexOf('.') + 1);
	        }
	
	        return ext.toLowerCase();
	    };
	
	    /**
	     * Determines the mime type of an XHR request based on the responseType of
	     * resource being loaded.
	     *
	     * @private
	     * @param {Resource.XHR_RESPONSE_TYPE} type - The type to get a mime type for.
	     * @return {string} The mime type to use.
	     */
	
	
	    Resource.prototype._getMimeFromXhrType = function _getMimeFromXhrType(type) {
	        switch (type) {
	            case Resource.XHR_RESPONSE_TYPE.BUFFER:
	                return 'application/octet-binary';
	
	            case Resource.XHR_RESPONSE_TYPE.BLOB:
	                return 'application/blob';
	
	            case Resource.XHR_RESPONSE_TYPE.DOCUMENT:
	                return 'application/xml';
	
	            case Resource.XHR_RESPONSE_TYPE.JSON:
	                return 'application/json';
	
	            case Resource.XHR_RESPONSE_TYPE.DEFAULT:
	            case Resource.XHR_RESPONSE_TYPE.TEXT:
	            /* falls through */
	            default:
	                return 'text/plain';
	
	        }
	    };
	
	    _createClass(Resource, [{
	        key: 'isDataUrl',
	        get: function get() {
	            return this._hasFlag(Resource.STATUS_FLAGS.DATA_URL);
	        }
	
	        /**
	         * Describes if this resource has finished loading. Is true when the resource has completely
	         * loaded.
	         *
	         * @member {boolean}
	         * @readonly
	         */
	
	    }, {
	        key: 'isComplete',
	        get: function get() {
	            return this._hasFlag(Resource.STATUS_FLAGS.COMPLETE);
	        }
	
	        /**
	         * Describes if this resource is currently loading. Is true when the resource starts loading,
	         * and is false again when complete.
	         *
	         * @member {boolean}
	         * @readonly
	         */
	
	    }, {
	        key: 'isLoading',
	        get: function get() {
	            return this._hasFlag(Resource.STATUS_FLAGS.LOADING);
	        }
	    }]);
	
	    return Resource;
	}();
	
	/**
	 * The types of resources a resource could represent.
	 *
	 * @static
	 * @readonly
	 * @enum {number}
	 */
	
	
	exports.default = Resource;
	Resource.STATUS_FLAGS = {
	    NONE: 0,
	    DATA_URL: 1 << 0,
	    COMPLETE: 1 << 1,
	    LOADING: 1 << 2
	};
	
	/**
	 * The types of resources a resource could represent.
	 *
	 * @static
	 * @readonly
	 * @enum {number}
	 */
	Resource.TYPE = {
	    UNKNOWN: 0,
	    JSON: 1,
	    XML: 2,
	    IMAGE: 3,
	    AUDIO: 4,
	    VIDEO: 5,
	    TEXT: 6
	};
	
	/**
	 * The types of loading a resource can use.
	 *
	 * @static
	 * @readonly
	 * @enum {number}
	 */
	Resource.LOAD_TYPE = {
	    /** Uses XMLHttpRequest to load the resource. */
	    XHR: 1,
	    /** Uses an `Image` object to load the resource. */
	    IMAGE: 2,
	    /** Uses an `Audio` object to load the resource. */
	    AUDIO: 3,
	    /** Uses a `Video` object to load the resource. */
	    VIDEO: 4
	};
	
	/**
	 * The XHR ready states, used internally.
	 *
	 * @static
	 * @readonly
	 * @enum {string}
	 */
	Resource.XHR_RESPONSE_TYPE = {
	    /** string */
	    DEFAULT: 'text',
	    /** ArrayBuffer */
	    BUFFER: 'arraybuffer',
	    /** Blob */
	    BLOB: 'blob',
	    /** Document */
	    DOCUMENT: 'document',
	    /** Object */
	    JSON: 'json',
	    /** String */
	    TEXT: 'text'
	};
	
	Resource._loadTypeMap = {
	    // images
	    gif: Resource.LOAD_TYPE.IMAGE,
	    png: Resource.LOAD_TYPE.IMAGE,
	    bmp: Resource.LOAD_TYPE.IMAGE,
	    jpg: Resource.LOAD_TYPE.IMAGE,
	    jpeg: Resource.LOAD_TYPE.IMAGE,
	    tif: Resource.LOAD_TYPE.IMAGE,
	    tiff: Resource.LOAD_TYPE.IMAGE,
	    webp: Resource.LOAD_TYPE.IMAGE,
	    tga: Resource.LOAD_TYPE.IMAGE,
	    svg: Resource.LOAD_TYPE.IMAGE,
	    'svg+xml': Resource.LOAD_TYPE.IMAGE, // for SVG data urls
	
	    // audio
	    mp3: Resource.LOAD_TYPE.AUDIO,
	    ogg: Resource.LOAD_TYPE.AUDIO,
	    wav: Resource.LOAD_TYPE.AUDIO,
	
	    // videos
	    mp4: Resource.LOAD_TYPE.VIDEO,
	    webm: Resource.LOAD_TYPE.VIDEO
	};
	
	Resource._xhrTypeMap = {
	    // xml
	    xhtml: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    html: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    htm: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    xml: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    tmx: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    svg: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	
	    // This was added to handle Tiled Tileset XML, but .tsx is also a TypeScript React Component.
	    // Since it is way less likely for people to be loading TypeScript files instead of Tiled files,
	    // this should probably be fine.
	    tsx: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	
	    // images
	    gif: Resource.XHR_RESPONSE_TYPE.BLOB,
	    png: Resource.XHR_RESPONSE_TYPE.BLOB,
	    bmp: Resource.XHR_RESPONSE_TYPE.BLOB,
	    jpg: Resource.XHR_RESPONSE_TYPE.BLOB,
	    jpeg: Resource.XHR_RESPONSE_TYPE.BLOB,
	    tif: Resource.XHR_RESPONSE_TYPE.BLOB,
	    tiff: Resource.XHR_RESPONSE_TYPE.BLOB,
	    webp: Resource.XHR_RESPONSE_TYPE.BLOB,
	    tga: Resource.XHR_RESPONSE_TYPE.BLOB,
	
	    // json
	    json: Resource.XHR_RESPONSE_TYPE.JSON,
	
	    // text
	    text: Resource.XHR_RESPONSE_TYPE.TEXT,
	    txt: Resource.XHR_RESPONSE_TYPE.TEXT,
	
	    // fonts
	    ttf: Resource.XHR_RESPONSE_TYPE.BUFFER,
	    otf: Resource.XHR_RESPONSE_TYPE.BUFFER
	};
	
	// We can't set the `src` attribute to empty string, so on abort we set it to this 1px transparent gif
	Resource.EMPTY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
	
	/**
	 * Quick helper to set a value on one of the extension maps. Ensures there is no
	 * dot at the start of the extension.
	 *
	 * @ignore
	 * @param {object} map - The map to set on.
	 * @param {string} extname - The extension (or key) to set.
	 * @param {number} val - The value to set.
	 */
	function setExtMap(map, extname, val) {
	    if (extname && extname.indexOf('.') === 0) {
	        extname = extname.substring(1);
	    }
	
	    if (!extname) {
	        return;
	    }
	
	    map[extname] = val;
	}
	
	/**
	 * Quick helper to get string xhr type.
	 *
	 * @ignore
	 * @param {XMLHttpRequest|XDomainRequest} xhr - The request to check.
	 * @return {string} The type.
	 */
	function reqType(xhr) {
	    return xhr.toString().replace('object ', '');
	}
	//# sourceMappingURL=Resource.js.map

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.encodeBinary = encodeBinary;
	var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function encodeBinary(input) {
	    var output = '';
	    var inx = 0;
	
	    while (inx < input.length) {
	        // Fill byte buffer array
	        var bytebuffer = [0, 0, 0];
	        var encodedCharIndexes = [0, 0, 0, 0];
	
	        for (var jnx = 0; jnx < bytebuffer.length; ++jnx) {
	            if (inx < input.length) {
	                // throw away high-order byte, as documented at:
	                // https://developer.mozilla.org/En/Using_XMLHttpRequest#Handling_binary_data
	                bytebuffer[jnx] = input.charCodeAt(inx++) & 0xff;
	            } else {
	                bytebuffer[jnx] = 0;
	            }
	        }
	
	        // Get each encoded character, 6 bits at a time
	        // index 1: first 6 bits
	        encodedCharIndexes[0] = bytebuffer[0] >> 2;
	
	        // index 2: second 6 bits (2 least significant bits from input byte 1 + 4 most significant bits from byte 2)
	        encodedCharIndexes[1] = (bytebuffer[0] & 0x3) << 4 | bytebuffer[1] >> 4;
	
	        // index 3: third 6 bits (4 least significant bits from input byte 2 + 2 most significant bits from byte 3)
	        encodedCharIndexes[2] = (bytebuffer[1] & 0x0f) << 2 | bytebuffer[2] >> 6;
	
	        // index 3: forth 6 bits (6 least significant bits from input byte 3)
	        encodedCharIndexes[3] = bytebuffer[2] & 0x3f;
	
	        // Determine whether padding happened, and adjust accordingly
	        var paddingBytes = inx - (input.length - 1);
	
	        switch (paddingBytes) {
	            case 2:
	                // Set last 2 characters to padding char
	                encodedCharIndexes[3] = 64;
	                encodedCharIndexes[2] = 64;
	                break;
	
	            case 1:
	                // Set last character to padding char
	                encodedCharIndexes[3] = 64;
	                break;
	
	            default:
	                break; // No padding - proceed
	        }
	
	        // Now we will grab each appropriate character out of our keystring
	        // based on our index array and append it to the output string
	        for (var _jnx = 0; _jnx < encodedCharIndexes.length; ++_jnx) {
	            output += _keyStr.charAt(encodedCharIndexes[_jnx]);
	        }
	    }
	
	    return output;
	}
	//# sourceMappingURL=b64.js.map

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	    return function spritesheetParser(resource, next) {
	        var imageResourceName = resource.name + '_image';
	
	        // skip if no data, its not json, it isn't spritesheet data, or the image resource already exists
	        if (!resource.data || resource.type !== _resourceLoader.Resource.TYPE.JSON || !resource.data.frames || this.resources[imageResourceName]) {
	            next();
	
	            return;
	        }
	
	        var loadOptions = {
	            crossOrigin: resource.crossOrigin,
	            metadata: resource.metadata.imageMetadata,
	            parentResource: resource
	        };
	
	        var resourcePath = getResourcePath(resource, this.baseUrl);
	
	        // load the image for this sheet
	        this.add(imageResourceName, resourcePath, loadOptions, function onImageLoad(res) {
	            if (res.error) {
	                next(res.error);
	
	                return;
	            }
	
	            var spritesheet = new _core.Spritesheet(res.texture.baseTexture, resource.data, resource.url);
	
	            spritesheet.parse(function () {
	                resource.spritesheet = spritesheet;
	                resource.textures = spritesheet.textures;
	                next();
	            });
	        });
	    };
	};
	
	exports.getResourcePath = getResourcePath;
	
	var _resourceLoader = __webpack_require__(357);
	
	var _url = __webpack_require__(254);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _core = __webpack_require__(204);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getResourcePath(resource, baseUrl) {
	    // Prepend url path unless the resource image is a data url
	    if (resource.isDataUrl) {
	        return resource.data.meta.image;
	    }
	
	    return _url2.default.resolve(resource.url.replace(baseUrl, ''), resource.data.meta.image);
	}
	//# sourceMappingURL=spritesheetParser.js.map

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	    return function textureParser(resource, next) {
	        // create a new texture if the data is an Image object
	        if (resource.data && resource.type === _resourceLoader.Resource.TYPE.IMAGE) {
	            resource.texture = _Texture2.default.fromLoader(resource.data, resource.url, resource.name);
	        }
	        next();
	    };
	};
	
	var _resourceLoader = __webpack_require__(357);
	
	var _Texture = __webpack_require__(251);
	
	var _Texture2 = _interopRequireDefault(_Texture);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=textureParser.js.map

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _resourceLoader = __webpack_require__(357);
	
	var _resourceLoader2 = _interopRequireDefault(_resourceLoader);
	
	var _blob = __webpack_require__(367);
	
	var _eventemitter = __webpack_require__(235);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _textureParser = __webpack_require__(365);
	
	var _textureParser2 = _interopRequireDefault(_textureParser);
	
	var _spritesheetParser = __webpack_require__(364);
	
	var _spritesheetParser2 = _interopRequireDefault(_spritesheetParser);
	
	var _bitmapFontParser = __webpack_require__(356);
	
	var _bitmapFontParser2 = _interopRequireDefault(_bitmapFontParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 *
	 * The new loader, extends Resource Loader by Chad Engler: https://github.com/englercj/resource-loader
	 *
	 * ```js
	 * const loader = PIXI.loader; // PixiJS exposes a premade instance for you to use.
	 * //or
	 * const loader = new PIXI.loaders.Loader(); // you can also create your own if you want
	 *
	 * const sprites = {};
	 *
	 * // Chainable `add` to enqueue a resource
	 * loader.add('bunny', 'data/bunny.png')
	 *       .add('spaceship', 'assets/spritesheet.json');
	 * loader.add('scoreFont', 'assets/score.fnt');
	 *
	 * // Chainable `pre` to add a middleware that runs for each resource, *before* loading that resource.
	 * // This is useful to implement custom caching modules (using filesystem, indexeddb, memory, etc).
	 * loader.pre(cachingMiddleware);
	 *
	 * // Chainable `use` to add a middleware that runs for each resource, *after* loading that resource.
	 * // This is useful to implement custom parsing modules (like spritesheet parsers, spine parser, etc).
	 * loader.use(parsingMiddleware);
	 *
	 * // The `load` method loads the queue of resources, and calls the passed in callback called once all
	 * // resources have loaded.
	 * loader.load((loader, resources) => {
	 *     // resources is an object where the key is the name of the resource loaded and the value is the resource object.
	 *     // They have a couple default properties:
	 *     // - `url`: The URL that the resource was loaded from
	 *     // - `error`: The error that happened when trying to load (if any)
	 *     // - `data`: The raw data that was loaded
	 *     // also may contain other properties based on the middleware that runs.
	 *     sprites.bunny = new PIXI.TilingSprite(resources.bunny.texture);
	 *     sprites.spaceship = new PIXI.TilingSprite(resources.spaceship.texture);
	 *     sprites.scoreFont = new PIXI.TilingSprite(resources.scoreFont.texture);
	 * });
	 *
	 * // throughout the process multiple signals can be dispatched.
	 * loader.onProgress.add(() => {}); // called once per loaded/errored file
	 * loader.onError.add(() => {}); // called once per errored file
	 * loader.onLoad.add(() => {}); // called once per loaded file
	 * loader.onComplete.add(() => {}); // called once when the queued resources all load.
	 * ```
	 *
	 * @see https://github.com/englercj/resource-loader
	 *
	 * @class
	 * @extends module:resource-loader.ResourceLoader
	 * @memberof PIXI.loaders
	 */
	var Loader = function (_ResourceLoader) {
	    _inherits(Loader, _ResourceLoader);
	
	    /**
	     * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
	     * @param {number} [concurrency=10] - The number of resources to load concurrently.
	     */
	    function Loader(baseUrl, concurrency) {
	        _classCallCheck(this, Loader);
	
	        var _this = _possibleConstructorReturn(this, _ResourceLoader.call(this, baseUrl, concurrency));
	
	        _eventemitter2.default.call(_this);
	
	        for (var i = 0; i < Loader._pixiMiddleware.length; ++i) {
	            _this.use(Loader._pixiMiddleware[i]());
	        }
	
	        // Compat layer, translate the new v2 signals into old v1 events.
	        _this.onStart.add(function (l) {
	            return _this.emit('start', l);
	        });
	        _this.onProgress.add(function (l, r) {
	            return _this.emit('progress', l, r);
	        });
	        _this.onError.add(function (e, l, r) {
	            return _this.emit('error', e, l, r);
	        });
	        _this.onLoad.add(function (l, r) {
	            return _this.emit('load', l, r);
	        });
	        _this.onComplete.add(function (l, r) {
	            return _this.emit('complete', l, r);
	        });
	        return _this;
	    }
	
	    /**
	     * Adds a default middleware to the PixiJS loader.
	     *
	     * @static
	     * @param {Function} fn - The middleware to add.
	     */
	
	
	    Loader.addPixiMiddleware = function addPixiMiddleware(fn) {
	        Loader._pixiMiddleware.push(fn);
	    };
	
	    /**
	     * Destroy the loader, removes references.
	     */
	
	
	    Loader.prototype.destroy = function destroy() {
	        this.removeAllListeners();
	        this.reset();
	    };
	
	    return Loader;
	}(_resourceLoader2.default);
	
	// Copy EE3 prototype (mixin)
	
	
	exports.default = Loader;
	for (var k in _eventemitter2.default.prototype) {
	    Loader.prototype[k] = _eventemitter2.default.prototype[k];
	}
	
	Loader._pixiMiddleware = [
	// parse any blob into more usable objects (e.g. Image)
	_blob.blobMiddlewareFactory,
	// parse any Image objects into textures
	_textureParser2.default,
	// parse any spritesheet data into multiple textures
	_spritesheetParser2.default,
	// parse bitmap font data into multiple textures
	_bitmapFontParser2.default];
	
	// Add custom extentions
	var Resource = _resourceLoader2.default.Resource;
	
	Resource.setExtensionXhrType('fnt', Resource.XHR_RESPONSE_TYPE.DOCUMENT);
	//# sourceMappingURL=loader.js.map

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.blobMiddlewareFactory = blobMiddlewareFactory;
	
	var _Resource = __webpack_require__(362);
	
	var _Resource2 = _interopRequireDefault(_Resource);
	
	var _b = __webpack_require__(363);
	
	var _b2 = _interopRequireDefault(_b);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Url = window.URL || window.webkitURL;
	
	// a middleware for transforming XHR loaded Blobs into more useful objects
	function blobMiddlewareFactory() {
	    return function blobMiddleware(resource, next) {
	        if (!resource.data) {
	            next();
	
	            return;
	        }
	
	        // if this was an XHR load of a blob
	        if (resource.xhr && resource.xhrType === _Resource2.default.XHR_RESPONSE_TYPE.BLOB) {
	            // if there is no blob support we probably got a binary string back
	            if (!window.Blob || typeof resource.data === 'string') {
	                var type = resource.xhr.getResponseHeader('content-type');
	
	                // this is an image, convert the binary string into a data url
	                if (type && type.indexOf('image') === 0) {
	                    resource.data = new Image();
	                    resource.data.src = 'data:' + type + ';base64,' + _b2.default.encodeBinary(resource.xhr.responseText);
	
	                    resource.type = _Resource2.default.TYPE.IMAGE;
	
	                    // wait until the image loads and then callback
	                    resource.data.onload = function () {
	                        resource.data.onload = null;
	
	                        next();
	                    };
	
	                    // next will be called on load
	                    return;
	                }
	            }
	            // if content type says this is an image, then we should transform the blob into an Image object
	            else if (resource.data.type.indexOf('image') === 0) {
	                    var _ret = function () {
	                        var src = Url.createObjectURL(resource.data);
	
	                        resource.blob = resource.data;
	                        resource.data = new Image();
	                        resource.data.src = src;
	
	                        resource.type = _Resource2.default.TYPE.IMAGE;
	
	                        // cleanup the no longer used blob after the image loads
	                        // TODO: Is this correct? Will the image be invalid after revoking?
	                        resource.data.onload = function () {
	                            Url.revokeObjectURL(src);
	                            resource.data.onload = null;
	
	                            next();
	                        };
	
	                        // next will be called on load.
	                        return {
	                            v: void 0
	                        };
	                    }();
	
	                    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	                }
	        }
	
	        next();
	    };
	}
	//# sourceMappingURL=blob.js.map

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Mesh = __webpack_require__(369);
	
	Object.defineProperty(exports, 'Mesh', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Mesh).default;
	  }
	});
	
	var _MeshRenderer = __webpack_require__(370);
	
	Object.defineProperty(exports, 'MeshRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MeshRenderer).default;
	  }
	});
	
	var _CanvasMeshRenderer = __webpack_require__(371);
	
	Object.defineProperty(exports, 'CanvasMeshRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasMeshRenderer).default;
	  }
	});
	
	var _Plane = __webpack_require__(372);
	
	Object.defineProperty(exports, 'Plane', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Plane).default;
	  }
	});
	
	var _NineSlicePlane = __webpack_require__(373);
	
	Object.defineProperty(exports, 'NineSlicePlane', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NineSlicePlane).default;
	  }
	});
	
	var _Rope = __webpack_require__(374);
	
	Object.defineProperty(exports, 'Rope', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rope).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _Texture = __webpack_require__(251);
	
	var _Texture2 = _interopRequireDefault(_Texture);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tempPoint = new core.Point();
	var tempPolygon = new core.Polygon();
	
	/**
	 * Base mesh class
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI.mesh
	 */
	
	var Mesh = function (_core$Container) {
	    _inherits(Mesh, _core$Container);
	
	    /**
	     * @param {PIXI.Texture} texture - The texture to use
	     * @param {Float32Array} [vertices] - if you want to specify the vertices
	     * @param {Float32Array} [uvs] - if you want to specify the uvs
	     * @param {Uint16Array} [indices] - if you want to specify the indices
	     * @param {number} [drawMode] - the drawMode, can be any of the Mesh.DRAW_MODES consts
	     */
	    function Mesh(texture, vertices, uvs, indices, drawMode) {
	        _classCallCheck(this, Mesh);
	
	        /**
	         * The texture of the Mesh
	         *
	         * @member {PIXI.Texture}
	         * @default PIXI.Texture.EMPTY
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _core$Container.call(this));
	
	        _this._texture = texture || _Texture2.default.EMPTY;
	
	        /**
	         * The Uvs of the Mesh
	         *
	         * @member {Float32Array}
	         */
	        _this.uvs = uvs || new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);
	
	        /**
	         * An array of vertices
	         *
	         * @member {Float32Array}
	         */
	        _this.vertices = vertices || new Float32Array([0, 0, 100, 0, 100, 100, 0, 100]);
	
	        /**
	         * An array containing the indices of the vertices
	         *
	         * @member {Uint16Array}
	         */
	        //  TODO auto generate this based on draw mode!
	        _this.indices = indices || new Uint16Array([0, 1, 3, 2]);
	
	        /**
	         * Version of mesh uvs are dirty or not
	         *
	         * @member {number}
	         */
	        _this.dirty = 0;
	
	        /**
	         * Version of mesh indices
	         *
	         * @member {number}
	         */
	        _this.indexDirty = 0;
	
	        /**
	         * Version of mesh verticies array
	         *
	         * @member {number}
	         */
	        _this.vertexDirty = 0;
	
	        /**
	         * For backwards compatibility the default is to re-upload verticies each render call.
	         * Set this to `false` and increase `vertexDirty` to manually re-upload the buffer.
	         *
	         * @member {boolean}
	         */
	        _this.autoUpdate = true;
	
	        /**
	         * The blend mode to be applied to the sprite. Set to `PIXI.BLEND_MODES.NORMAL` to remove
	         * any blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = core.BLEND_MODES.NORMAL;
	
	        /**
	         * Triangles in canvas mode are automatically antialiased, use this value to force triangles
	         * to overlap a bit with each other.
	         *
	         * @member {number}
	         */
	        _this.canvasPadding = core.settings.MESH_CANVAS_PADDING;
	
	        /**
	         * The way the Mesh should be drawn, can be any of the {@link PIXI.mesh.Mesh.DRAW_MODES} consts
	         *
	         * @member {number}
	         * @see PIXI.mesh.Mesh.DRAW_MODES
	         */
	        _this.drawMode = drawMode || Mesh.DRAW_MODES.TRIANGLE_MESH;
	
	        /**
	         * The default shader that is used if a mesh doesn't have a more specific one.
	         *
	         * @member {PIXI.Shader}
	         */
	        _this.shader = null;
	
	        /**
	         * The tint applied to the mesh. This is a [r,g,b] value. A value of [1,1,1] will remove any
	         * tint effect.
	         *
	         * @member {number}
	         */
	        _this.tintRgb = new Float32Array([1, 1, 1]);
	
	        /**
	         * A map of renderer IDs to webgl render data
	         *
	         * @private
	         * @member {object<number, object>}
	         */
	        _this._glDatas = {};
	
	        /**
	         * transform that is applied to UV to get the texture coords
	         * its updated independently from texture uvTransform
	         * updates of uvs are tied to that thing
	         *
	         * @member {PIXI.TextureMatrix}
	         * @private
	         */
	        _this._uvTransform = new core.TextureMatrix(_this._texture);
	
	        /**
	         * whether or not upload uvTransform to shader
	         * if its false, then uvs should be pre-multiplied
	         * if you change it for generated mesh, please call 'refresh(true)'
	         * @member {boolean}
	         * @default false
	         */
	        _this.uploadUvTransform = false;
	
	        /**
	         * Plugin that is responsible for rendering this element.
	         * Allows to customize the rendering process without overriding '_renderWebGL' & '_renderCanvas' methods.
	         * @member {string}
	         * @default 'mesh'
	         */
	        _this.pluginName = 'mesh';
	        return _this;
	    }
	
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - a reference to the WebGL renderer
	     */
	
	
	    Mesh.prototype._renderWebGL = function _renderWebGL(renderer) {
	        this.refresh();
	        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
	        renderer.plugins[this.pluginName].render(this);
	    };
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
	     */
	
	
	    Mesh.prototype._renderCanvas = function _renderCanvas(renderer) {
	        this.refresh();
	        renderer.plugins[this.pluginName].render(this);
	    };
	
	    /**
	     * When the texture is updated, this event will fire to update the scale and frame
	     *
	     * @private
	     */
	
	
	    Mesh.prototype._onTextureUpdate = function _onTextureUpdate() {
	        this._uvTransform.texture = this._texture;
	        this.refresh();
	    };
	
	    /**
	     * multiplies uvs only if uploadUvTransform is false
	     * call it after you change uvs manually
	     * make sure that texture is valid
	     */
	
	
	    Mesh.prototype.multiplyUvs = function multiplyUvs() {
	        if (!this.uploadUvTransform) {
	            this._uvTransform.multiplyUvs(this.uvs);
	        }
	    };
	
	    /**
	     * Refreshes uvs for generated meshes (rope, plane)
	     * sometimes refreshes vertices too
	     *
	     * @param {boolean} [forceUpdate=false] if true, matrices will be updated any case
	     */
	
	
	    Mesh.prototype.refresh = function refresh(forceUpdate) {
	        if (this.autoUpdate) {
	            this.vertexDirty++;
	        }
	        if (this._uvTransform.update(forceUpdate)) {
	            this._refresh();
	        }
	    };
	
	    /**
	     * re-calculates mesh coords
	     * @protected
	     */
	
	
	    Mesh.prototype._refresh = function _refresh() {}
	    /* empty */
	
	
	    /**
	     * Returns the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
	     *
	     */
	    ;
	
	    Mesh.prototype._calculateBounds = function _calculateBounds() {
	        // TODO - we can cache local bounds and use them if they are dirty (like graphics)
	        this._bounds.addVertices(this.transform, this.vertices, 0, this.vertices.length);
	    };
	
	    /**
	     * Tests if a point is inside this mesh. Works only for TRIANGLE_MESH
	     *
	     * @param {PIXI.Point} point - the point to test
	     * @return {boolean} the result of the test
	     */
	
	
	    Mesh.prototype.containsPoint = function containsPoint(point) {
	        if (!this.getBounds().contains(point.x, point.y)) {
	            return false;
	        }
	
	        this.worldTransform.applyInverse(point, tempPoint);
	
	        var vertices = this.vertices;
	        var points = tempPolygon.points;
	        var indices = this.indices;
	        var len = this.indices.length;
	        var step = this.drawMode === Mesh.DRAW_MODES.TRIANGLES ? 3 : 1;
	
	        for (var i = 0; i + 2 < len; i += step) {
	            var ind0 = indices[i] * 2;
	            var ind1 = indices[i + 1] * 2;
	            var ind2 = indices[i + 2] * 2;
	
	            points[0] = vertices[ind0];
	            points[1] = vertices[ind0 + 1];
	            points[2] = vertices[ind1];
	            points[3] = vertices[ind1 + 1];
	            points[4] = vertices[ind2];
	            points[5] = vertices[ind2 + 1];
	
	            if (tempPolygon.contains(tempPoint.x, tempPoint.y)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	
	    /**
	     * The texture that the mesh uses.
	     *
	     * @member {PIXI.Texture}
	     */
	
	
	    /**
	     * Destroys the Mesh object.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
	     *  options have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have
	     *  their destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */
	    Mesh.prototype.destroy = function destroy(options) {
	        // for each webgl data entry, destroy the WebGLGraphicsData
	        for (var id in this._glDatas) {
	            var data = this._glDatas[id];
	
	            if (data.destroy) {
	                data.destroy();
	            } else {
	                if (data.vertexBuffer) {
	                    data.vertexBuffer.destroy();
	                    data.vertexBuffer = null;
	                }
	                if (data.indexBuffer) {
	                    data.indexBuffer.destroy();
	                    data.indexBuffer = null;
	                }
	                if (data.uvBuffer) {
	                    data.uvBuffer.destroy();
	                    data.uvBuffer = null;
	                }
	                if (data.vao) {
	                    data.vao.destroy();
	                    data.vao = null;
	                }
	            }
	        }
	
	        this._glDatas = null;
	
	        _core$Container.prototype.destroy.call(this, options);
	    };
	
	    _createClass(Mesh, [{
	        key: 'texture',
	        get: function get() {
	            return this._texture;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._texture === value) {
	                return;
	            }
	
	            this._texture = value;
	
	            if (value) {
	                // wait for the texture to load
	                if (value.baseTexture.hasLoaded) {
	                    this._onTextureUpdate();
	                } else {
	                    value.once('update', this._onTextureUpdate, this);
	                }
	            }
	        }
	
	        /**
	         * The tint applied to the mesh. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	
	    }, {
	        key: 'tint',
	        get: function get() {
	            return core.utils.rgb2hex(this.tintRgb);
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.tintRgb = core.utils.hex2rgb(value, this.tintRgb);
	        }
	    }]);
	
	    return Mesh;
	}(core.Container);
	
	/**
	 * Different drawing buffer modes supported
	 *
	 * @static
	 * @constant
	 * @type {object}
	 * @property {number} TRIANGLE_MESH
	 * @property {number} TRIANGLES
	 */
	
	
	exports.default = Mesh;
	Mesh.DRAW_MODES = {
	    TRIANGLE_MESH: 0,
	    TRIANGLES: 1
	};
	//# sourceMappingURL=Mesh.js.map

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _pixiGlCore = __webpack_require__(216);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	var _Mesh = __webpack_require__(369);
	
	var _Mesh2 = _interopRequireDefault(_Mesh);
	
	var _path = __webpack_require__(285);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var matrixIdentity = core.Matrix.IDENTITY;
	
	/**
	 * WebGL renderer plugin for tiling sprites
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.ObjectRenderer
	 */
	
	var MeshRenderer = function (_core$ObjectRenderer) {
	    _inherits(MeshRenderer, _core$ObjectRenderer);
	
	    /**
	     * constructor for renderer
	     *
	     * @param {WebGLRenderer} renderer The renderer this tiling awesomeness works for.
	     */
	    function MeshRenderer(renderer) {
	        _classCallCheck(this, MeshRenderer);
	
	        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));
	
	        _this.shader = null;
	        return _this;
	    }
	
	    /**
	     * Sets up the renderer context and necessary buffers.
	     *
	     * @private
	     */
	
	
	    MeshRenderer.prototype.onContextChange = function onContextChange() {
	        var gl = this.renderer.gl;
	
	        this.shader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\nuniform vec4 uColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void)\n{\n    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;\n}\n');
	    };
	
	    /**
	     * renders mesh
	     *
	     * @param {PIXI.mesh.Mesh} mesh mesh instance
	     */
	
	
	    MeshRenderer.prototype.render = function render(mesh) {
	        var renderer = this.renderer;
	        var gl = renderer.gl;
	        var texture = mesh._texture;
	
	        if (!texture.valid) {
	            return;
	        }
	
	        var glData = mesh._glDatas[renderer.CONTEXT_UID];
	
	        if (!glData) {
	            renderer.bindVao(null);
	
	            glData = {
	                shader: this.shader,
	                vertexBuffer: _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, mesh.vertices, gl.STREAM_DRAW),
	                uvBuffer: _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, mesh.uvs, gl.STREAM_DRAW),
	                indexBuffer: _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, mesh.indices, gl.STATIC_DRAW),
	                // build the vao object that will render..
	                vao: null,
	                dirty: mesh.dirty,
	                indexDirty: mesh.indexDirty,
	                vertexDirty: mesh.vertexDirty
	            };
	
	            // build the vao object that will render..
	            glData.vao = new _pixiGlCore2.default.VertexArrayObject(gl).addIndex(glData.indexBuffer).addAttribute(glData.vertexBuffer, glData.shader.attributes.aVertexPosition, gl.FLOAT, false, 2 * 4, 0).addAttribute(glData.uvBuffer, glData.shader.attributes.aTextureCoord, gl.FLOAT, false, 2 * 4, 0);
	
	            mesh._glDatas[renderer.CONTEXT_UID] = glData;
	        }
	
	        renderer.bindVao(glData.vao);
	
	        if (mesh.dirty !== glData.dirty) {
	            glData.dirty = mesh.dirty;
	            glData.uvBuffer.upload(mesh.uvs);
	        }
	
	        if (mesh.indexDirty !== glData.indexDirty) {
	            glData.indexDirty = mesh.indexDirty;
	            glData.indexBuffer.upload(mesh.indices);
	        }
	
	        if (mesh.vertexDirty !== glData.vertexDirty) {
	            glData.vertexDirty = mesh.vertexDirty;
	            glData.vertexBuffer.upload(mesh.vertices);
	        }
	
	        renderer.bindShader(glData.shader);
	
	        glData.shader.uniforms.uSampler = renderer.bindTexture(texture);
	
	        renderer.state.setBlendMode(core.utils.correctBlendMode(mesh.blendMode, texture.baseTexture.premultipliedAlpha));
	
	        if (glData.shader.uniforms.uTransform) {
	            if (mesh.uploadUvTransform) {
	                glData.shader.uniforms.uTransform = mesh._uvTransform.mapCoord.toArray(true);
	            } else {
	                glData.shader.uniforms.uTransform = matrixIdentity.toArray(true);
	            }
	        }
	        glData.shader.uniforms.translationMatrix = mesh.worldTransform.toArray(true);
	
	        glData.shader.uniforms.uColor = core.utils.premultiplyRgba(mesh.tintRgb, mesh.worldAlpha, glData.shader.uniforms.uColor, texture.baseTexture.premultipliedAlpha);
	
	        var drawMode = mesh.drawMode === _Mesh2.default.DRAW_MODES.TRIANGLE_MESH ? gl.TRIANGLE_STRIP : gl.TRIANGLES;
	
	        glData.vao.draw(drawMode, mesh.indices.length, 0);
	    };
	
	    return MeshRenderer;
	}(core.ObjectRenderer);
	
	exports.default = MeshRenderer;
	
	
	core.WebGLRenderer.registerPlugin('mesh', MeshRenderer);
	//# sourceMappingURL=MeshRenderer.js.map

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _Mesh = __webpack_require__(369);
	
	var _Mesh2 = _interopRequireDefault(_Mesh);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Renderer dedicated to meshes.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var MeshSpriteRenderer = function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - The renderer this downport works for
	     */
	    function MeshSpriteRenderer(renderer) {
	        _classCallCheck(this, MeshSpriteRenderer);
	
	        this.renderer = renderer;
	    }
	
	    /**
	     * Renders the Mesh
	     *
	     * @param {PIXI.mesh.Mesh} mesh - the Mesh to render
	     */
	
	
	    MeshSpriteRenderer.prototype.render = function render(mesh) {
	        var renderer = this.renderer;
	        var context = renderer.context;
	
	        var transform = mesh.worldTransform;
	        var res = renderer.resolution;
	
	        if (renderer.roundPixels) {
	            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res | 0, transform.ty * res | 0);
	        } else {
	            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res, transform.ty * res);
	        }
	
	        renderer.context.globalAlpha = mesh.worldAlpha;
	        renderer.setBlendMode(mesh.blendMode);
	
	        if (mesh.drawMode === _Mesh2.default.DRAW_MODES.TRIANGLE_MESH) {
	            this._renderTriangleMesh(mesh);
	        } else {
	            this._renderTriangles(mesh);
	        }
	    };
	
	    /**
	     * Draws the object in Triangle Mesh mode
	     *
	     * @private
	     * @param {PIXI.mesh.Mesh} mesh - the Mesh to render
	     */
	
	
	    MeshSpriteRenderer.prototype._renderTriangleMesh = function _renderTriangleMesh(mesh) {
	        // draw triangles!!
	        var length = mesh.vertices.length / 2;
	
	        for (var i = 0; i < length - 2; i++) {
	            // draw some triangles!
	            var index = i * 2;
	
	            this._renderDrawTriangle(mesh, index, index + 2, index + 4);
	        }
	    };
	
	    /**
	     * Draws the object in triangle mode using canvas
	     *
	     * @private
	     * @param {PIXI.mesh.Mesh} mesh - the current mesh
	     */
	
	
	    MeshSpriteRenderer.prototype._renderTriangles = function _renderTriangles(mesh) {
	        // draw triangles!!
	        var indices = mesh.indices;
	        var length = indices.length;
	
	        for (var i = 0; i < length; i += 3) {
	            // draw some triangles!
	            var index0 = indices[i] * 2;
	            var index1 = indices[i + 1] * 2;
	            var index2 = indices[i + 2] * 2;
	
	            this._renderDrawTriangle(mesh, index0, index1, index2);
	        }
	    };
	
	    /**
	     * Draws one of the triangles that from the Mesh
	     *
	     * @private
	     * @param {PIXI.mesh.Mesh} mesh - the current mesh
	     * @param {number} index0 - the index of the first vertex
	     * @param {number} index1 - the index of the second vertex
	     * @param {number} index2 - the index of the third vertex
	     */
	
	
	    MeshSpriteRenderer.prototype._renderDrawTriangle = function _renderDrawTriangle(mesh, index0, index1, index2) {
	        var context = this.renderer.context;
	        var uvs = mesh.uvs;
	        var vertices = mesh.vertices;
	        var texture = mesh._texture;
	
	        if (!texture.valid) {
	            return;
	        }
	
	        var base = texture.baseTexture;
	        var textureSource = base.source;
	        var textureWidth = base.width;
	        var textureHeight = base.height;
	
	        var u0 = void 0;
	        var u1 = void 0;
	        var u2 = void 0;
	        var v0 = void 0;
	        var v1 = void 0;
	        var v2 = void 0;
	
	        if (mesh.uploadUvTransform) {
	            var ut = mesh._uvTransform.mapCoord;
	
	            u0 = (uvs[index0] * ut.a + uvs[index0 + 1] * ut.c + ut.tx) * base.width;
	            u1 = (uvs[index1] * ut.a + uvs[index1 + 1] * ut.c + ut.tx) * base.width;
	            u2 = (uvs[index2] * ut.a + uvs[index2 + 1] * ut.c + ut.tx) * base.width;
	            v0 = (uvs[index0] * ut.b + uvs[index0 + 1] * ut.d + ut.ty) * base.height;
	            v1 = (uvs[index1] * ut.b + uvs[index1 + 1] * ut.d + ut.ty) * base.height;
	            v2 = (uvs[index2] * ut.b + uvs[index2 + 1] * ut.d + ut.ty) * base.height;
	        } else {
	            u0 = uvs[index0] * base.width;
	            u1 = uvs[index1] * base.width;
	            u2 = uvs[index2] * base.width;
	            v0 = uvs[index0 + 1] * base.height;
	            v1 = uvs[index1 + 1] * base.height;
	            v2 = uvs[index2 + 1] * base.height;
	        }
	
	        var x0 = vertices[index0];
	        var x1 = vertices[index1];
	        var x2 = vertices[index2];
	        var y0 = vertices[index0 + 1];
	        var y1 = vertices[index1 + 1];
	        var y2 = vertices[index2 + 1];
	
	        var canvasPadding = mesh.canvasPadding / this.renderer.resolution;
	
	        if (canvasPadding > 0) {
	            var paddingX = canvasPadding / Math.abs(mesh.worldTransform.a);
	            var paddingY = canvasPadding / Math.abs(mesh.worldTransform.d);
	            var centerX = (x0 + x1 + x2) / 3;
	            var centerY = (y0 + y1 + y2) / 3;
	
	            var normX = x0 - centerX;
	            var normY = y0 - centerY;
	
	            var dist = Math.sqrt(normX * normX + normY * normY);
	
	            x0 = centerX + normX / dist * (dist + paddingX);
	            y0 = centerY + normY / dist * (dist + paddingY);
	
	            //
	
	            normX = x1 - centerX;
	            normY = y1 - centerY;
	
	            dist = Math.sqrt(normX * normX + normY * normY);
	            x1 = centerX + normX / dist * (dist + paddingX);
	            y1 = centerY + normY / dist * (dist + paddingY);
	
	            normX = x2 - centerX;
	            normY = y2 - centerY;
	
	            dist = Math.sqrt(normX * normX + normY * normY);
	            x2 = centerX + normX / dist * (dist + paddingX);
	            y2 = centerY + normY / dist * (dist + paddingY);
	        }
	
	        context.save();
	        context.beginPath();
	
	        context.moveTo(x0, y0);
	        context.lineTo(x1, y1);
	        context.lineTo(x2, y2);
	
	        context.closePath();
	
	        context.clip();
	
	        // Compute matrix transform
	        var delta = u0 * v1 + v0 * u2 + u1 * v2 - v1 * u2 - v0 * u1 - u0 * v2;
	        var deltaA = x0 * v1 + v0 * x2 + x1 * v2 - v1 * x2 - v0 * x1 - x0 * v2;
	        var deltaB = u0 * x1 + x0 * u2 + u1 * x2 - x1 * u2 - x0 * u1 - u0 * x2;
	        var deltaC = u0 * v1 * x2 + v0 * x1 * u2 + x0 * u1 * v2 - x0 * v1 * u2 - v0 * u1 * x2 - u0 * x1 * v2;
	        var deltaD = y0 * v1 + v0 * y2 + y1 * v2 - v1 * y2 - v0 * y1 - y0 * v2;
	        var deltaE = u0 * y1 + y0 * u2 + u1 * y2 - y1 * u2 - y0 * u1 - u0 * y2;
	        var deltaF = u0 * v1 * y2 + v0 * y1 * u2 + y0 * u1 * v2 - y0 * v1 * u2 - v0 * u1 * y2 - u0 * y1 * v2;
	
	        context.transform(deltaA / delta, deltaD / delta, deltaB / delta, deltaE / delta, deltaC / delta, deltaF / delta);
	
	        context.drawImage(textureSource, 0, 0, textureWidth * base.resolution, textureHeight * base.resolution, 0, 0, textureWidth, textureHeight);
	
	        context.restore();
	        this.renderer.invalidateBlendMode();
	    };
	
	    /**
	     * Renders a flat Mesh
	     *
	     * @private
	     * @param {PIXI.mesh.Mesh} mesh - The Mesh to render
	     */
	
	
	    MeshSpriteRenderer.prototype.renderMeshFlat = function renderMeshFlat(mesh) {
	        var context = this.renderer.context;
	        var vertices = mesh.vertices;
	        var length = vertices.length / 2;
	
	        // this.count++;
	
	        context.beginPath();
	
	        for (var i = 1; i < length - 2; ++i) {
	            // draw some triangles!
	            var index = i * 2;
	
	            var x0 = vertices[index];
	            var y0 = vertices[index + 1];
	
	            var x1 = vertices[index + 2];
	            var y1 = vertices[index + 3];
	
	            var x2 = vertices[index + 4];
	            var y2 = vertices[index + 5];
	
	            context.moveTo(x0, y0);
	            context.lineTo(x1, y1);
	            context.lineTo(x2, y2);
	        }
	
	        context.fillStyle = '#FF0000';
	        context.fill();
	        context.closePath();
	    };
	
	    /**
	     * destroy the the renderer.
	     *
	     */
	
	
	    MeshSpriteRenderer.prototype.destroy = function destroy() {
	        this.renderer = null;
	    };
	
	    return MeshSpriteRenderer;
	}();
	
	exports.default = MeshSpriteRenderer;
	
	
	core.CanvasRenderer.registerPlugin('mesh', MeshSpriteRenderer);
	//# sourceMappingURL=CanvasMeshRenderer.js.map

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Mesh2 = __webpack_require__(369);
	
	var _Mesh3 = _interopRequireDefault(_Mesh2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Plane allows you to draw a texture across several points and them manipulate these points
	 *
	 *```js
	 * for (let i = 0; i < 20; i++) {
	 *     points.push(new PIXI.Point(i * 50, 0));
	 * };
	 * let Plane = new PIXI.Plane(PIXI.Texture.fromImage("snake.png"), points);
	 *  ```
	 *
	 * @class
	 * @extends PIXI.mesh.Mesh
	 * @memberof PIXI.mesh
	 *
	 */
	var Plane = function (_Mesh) {
	    _inherits(Plane, _Mesh);
	
	    /**
	     * @param {PIXI.Texture} texture - The texture to use on the Plane.
	     * @param {number} verticesX - The number of vertices in the x-axis
	     * @param {number} verticesY - The number of vertices in the y-axis
	     */
	    function Plane(texture, verticesX, verticesY) {
	        _classCallCheck(this, Plane);
	
	        /**
	         * Tracker for if the Plane is ready to be drawn. Needed because Mesh ctor can
	         * call _onTextureUpdated which could call refresh too early.
	         *
	         * @member {boolean}
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _Mesh.call(this, texture));
	
	        _this._ready = true;
	
	        _this.verticesX = verticesX || 10;
	        _this.verticesY = verticesY || 10;
	
	        _this.drawMode = _Mesh3.default.DRAW_MODES.TRIANGLES;
	        _this.refresh();
	        return _this;
	    }
	
	    /**
	     * Refreshes plane coordinates
	     *
	     */
	
	
	    Plane.prototype._refresh = function _refresh() {
	        var texture = this._texture;
	        var total = this.verticesX * this.verticesY;
	        var verts = [];
	        var colors = [];
	        var uvs = [];
	        var indices = [];
	
	        var segmentsX = this.verticesX - 1;
	        var segmentsY = this.verticesY - 1;
	
	        var sizeX = texture.width / segmentsX;
	        var sizeY = texture.height / segmentsY;
	
	        for (var i = 0; i < total; i++) {
	            var x = i % this.verticesX;
	            var y = i / this.verticesX | 0;
	
	            verts.push(x * sizeX, y * sizeY);
	
	            uvs.push(x / segmentsX, y / segmentsY);
	        }
	
	        //  cons
	
	        var totalSub = segmentsX * segmentsY;
	
	        for (var _i = 0; _i < totalSub; _i++) {
	            var xpos = _i % segmentsX;
	            var ypos = _i / segmentsX | 0;
	
	            var value = ypos * this.verticesX + xpos;
	            var value2 = ypos * this.verticesX + xpos + 1;
	            var value3 = (ypos + 1) * this.verticesX + xpos;
	            var value4 = (ypos + 1) * this.verticesX + xpos + 1;
	
	            indices.push(value, value2, value3);
	            indices.push(value2, value4, value3);
	        }
	
	        // console.log(indices)
	        this.vertices = new Float32Array(verts);
	        this.uvs = new Float32Array(uvs);
	        this.colors = new Float32Array(colors);
	        this.indices = new Uint16Array(indices);
	
	        this.dirty++;
	        this.indexDirty++;
	
	        this.multiplyUvs();
	    };
	
	    /**
	     * Clear texture UVs when new texture is set
	     *
	     * @private
	     */
	
	
	    Plane.prototype._onTextureUpdate = function _onTextureUpdate() {
	        _Mesh3.default.prototype._onTextureUpdate.call(this);
	
	        // wait for the Plane ctor to finish before calling refresh
	        if (this._ready) {
	            this.refresh();
	        }
	    };
	
	    return Plane;
	}(_Mesh3.default);
	
	exports.default = Plane;
	//# sourceMappingURL=Plane.js.map

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Plane2 = __webpack_require__(372);
	
	var _Plane3 = _interopRequireDefault(_Plane2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_BORDER_SIZE = 10;
	
	/**
	 * The NineSlicePlane allows you to stretch a texture using 9-slice scaling. The corners will remain unscaled (useful
	 * for buttons with rounded corners for example) and the other areas will be scaled horizontally and or vertically
	 *
	 *```js
	 * let Plane9 = new PIXI.NineSlicePlane(PIXI.Texture.fromImage('BoxWithRoundedCorners.png'), 15, 15, 15, 15);
	 *  ```
	 * <pre>
	 *      A                          B
	 *    +---+----------------------+---+
	 *  C | 1 |          2           | 3 |
	 *    +---+----------------------+---+
	 *    |   |                      |   |
	 *    | 4 |          5           | 6 |
	 *    |   |                      |   |
	 *    +---+----------------------+---+
	 *  D | 7 |          8           | 9 |
	 *    +---+----------------------+---+
	
	 *  When changing this objects width and/or height:
	 *     areas 1 3 7 and 9 will remain unscaled.
	 *     areas 2 and 8 will be stretched horizontally
	 *     areas 4 and 6 will be stretched vertically
	 *     area 5 will be stretched both horizontally and vertically
	 * </pre>
	 *
	 * @class
	 * @extends PIXI.mesh.Plane
	 * @memberof PIXI.mesh
	 *
	 */
	
	var NineSlicePlane = function (_Plane) {
	    _inherits(NineSlicePlane, _Plane);
	
	    /**
	     * @param {PIXI.Texture} texture - The texture to use on the NineSlicePlane.
	     * @param {int} [leftWidth=10] size of the left vertical bar (A)
	     * @param {int} [topHeight=10] size of the top horizontal bar (C)
	     * @param {int} [rightWidth=10] size of the right vertical bar (B)
	     * @param {int} [bottomHeight=10] size of the bottom horizontal bar (D)
	     */
	    function NineSlicePlane(texture, leftWidth, topHeight, rightWidth, bottomHeight) {
	        _classCallCheck(this, NineSlicePlane);
	
	        var _this = _possibleConstructorReturn(this, _Plane.call(this, texture, 4, 4));
	
	        _this._origWidth = texture.orig.width;
	        _this._origHeight = texture.orig.height;
	
	        /**
	         * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._width = _this._origWidth;
	
	        /**
	         * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._height = _this._origHeight;
	
	        /**
	         * The width of the left column (a)
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._leftWidth = typeof leftWidth !== 'undefined' ? leftWidth : DEFAULT_BORDER_SIZE;
	
	        /**
	         * The width of the right column (b)
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._rightWidth = typeof rightWidth !== 'undefined' ? rightWidth : DEFAULT_BORDER_SIZE;
	
	        /**
	         * The height of the top row (c)
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._topHeight = typeof topHeight !== 'undefined' ? topHeight : DEFAULT_BORDER_SIZE;
	
	        /**
	         * The height of the bottom row (d)
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._bottomHeight = typeof bottomHeight !== 'undefined' ? bottomHeight : DEFAULT_BORDER_SIZE;
	
	        _this.refresh(true);
	        return _this;
	    }
	
	    /**
	     * Updates the horizontal vertices.
	     *
	     */
	
	
	    NineSlicePlane.prototype.updateHorizontalVertices = function updateHorizontalVertices() {
	        var vertices = this.vertices;
	
	        var h = this._topHeight + this._bottomHeight;
	        var scale = this._height > h ? 1.0 : this._height / h;
	
	        vertices[9] = vertices[11] = vertices[13] = vertices[15] = this._topHeight * scale;
	        vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - this._bottomHeight * scale;
	        vertices[25] = vertices[27] = vertices[29] = vertices[31] = this._height;
	    };
	
	    /**
	     * Updates the vertical vertices.
	     *
	     */
	
	
	    NineSlicePlane.prototype.updateVerticalVertices = function updateVerticalVertices() {
	        var vertices = this.vertices;
	
	        var w = this._leftWidth + this._rightWidth;
	        var scale = this._width > w ? 1.0 : this._width / w;
	
	        vertices[2] = vertices[10] = vertices[18] = vertices[26] = this._leftWidth * scale;
	        vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - this._rightWidth * scale;
	        vertices[6] = vertices[14] = vertices[22] = vertices[30] = this._width;
	    };
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer to render with.
	     */
	
	
	    NineSlicePlane.prototype._renderCanvas = function _renderCanvas(renderer) {
	        var context = renderer.context;
	
	        context.globalAlpha = this.worldAlpha;
	        renderer.setBlendMode(this.blendMode);
	
	        var transform = this.worldTransform;
	        var res = renderer.resolution;
	
	        if (renderer.roundPixels) {
	            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res | 0, transform.ty * res | 0);
	        } else {
	            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res, transform.ty * res);
	        }
	
	        var base = this._texture.baseTexture;
	        var textureSource = base.source;
	        var w = base.width * base.resolution;
	        var h = base.height * base.resolution;
	
	        this.drawSegment(context, textureSource, w, h, 0, 1, 10, 11);
	        this.drawSegment(context, textureSource, w, h, 2, 3, 12, 13);
	        this.drawSegment(context, textureSource, w, h, 4, 5, 14, 15);
	        this.drawSegment(context, textureSource, w, h, 8, 9, 18, 19);
	        this.drawSegment(context, textureSource, w, h, 10, 11, 20, 21);
	        this.drawSegment(context, textureSource, w, h, 12, 13, 22, 23);
	        this.drawSegment(context, textureSource, w, h, 16, 17, 26, 27);
	        this.drawSegment(context, textureSource, w, h, 18, 19, 28, 29);
	        this.drawSegment(context, textureSource, w, h, 20, 21, 30, 31);
	    };
	
	    /**
	     * Renders one segment of the plane.
	     * to mimic the exact drawing behavior of stretching the image like WebGL does, we need to make sure
	     * that the source area is at least 1 pixel in size, otherwise nothing gets drawn when a slice size of 0 is used.
	     *
	     * @private
	     * @param {CanvasRenderingContext2D} context - The context to draw with.
	     * @param {CanvasImageSource} textureSource - The source to draw.
	     * @param {number} w - width of the texture
	     * @param {number} h - height of the texture
	     * @param {number} x1 - x index 1
	     * @param {number} y1 - y index 1
	     * @param {number} x2 - x index 2
	     * @param {number} y2 - y index 2
	     */
	
	
	    NineSlicePlane.prototype.drawSegment = function drawSegment(context, textureSource, w, h, x1, y1, x2, y2) {
	        // otherwise you get weird results when using slices of that are 0 wide or high.
	        var uvs = this.uvs;
	        var vertices = this.vertices;
	
	        var sw = (uvs[x2] - uvs[x1]) * w;
	        var sh = (uvs[y2] - uvs[y1]) * h;
	        var dw = vertices[x2] - vertices[x1];
	        var dh = vertices[y2] - vertices[y1];
	
	        // make sure the source is at least 1 pixel wide and high, otherwise nothing will be drawn.
	        if (sw < 1) {
	            sw = 1;
	        }
	
	        if (sh < 1) {
	            sh = 1;
	        }
	
	        // make sure destination is at least 1 pixel wide and high, otherwise you get
	        // lines when rendering close to original size.
	        if (dw < 1) {
	            dw = 1;
	        }
	
	        if (dh < 1) {
	            dh = 1;
	        }
	
	        context.drawImage(textureSource, uvs[x1] * w, uvs[y1] * h, sw, sh, vertices[x1], vertices[y1], dw, dh);
	    };
	
	    /**
	     * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	     *
	     * @member {number}
	     */
	
	
	    /**
	     * Refreshes NineSlicePlane coords. All of them.
	     */
	    NineSlicePlane.prototype._refresh = function _refresh() {
	        _Plane.prototype._refresh.call(this);
	
	        var uvs = this.uvs;
	        var texture = this._texture;
	
	        this._origWidth = texture.orig.width;
	        this._origHeight = texture.orig.height;
	
	        var _uvw = 1.0 / this._origWidth;
	        var _uvh = 1.0 / this._origHeight;
	
	        uvs[0] = uvs[8] = uvs[16] = uvs[24] = 0;
	        uvs[1] = uvs[3] = uvs[5] = uvs[7] = 0;
	        uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1;
	        uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1;
	
	        uvs[2] = uvs[10] = uvs[18] = uvs[26] = _uvw * this._leftWidth;
	        uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - _uvw * this._rightWidth;
	        uvs[9] = uvs[11] = uvs[13] = uvs[15] = _uvh * this._topHeight;
	        uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - _uvh * this._bottomHeight;
	
	        this.updateHorizontalVertices();
	        this.updateVerticalVertices();
	
	        this.dirty++;
	
	        this.multiplyUvs();
	    };
	
	    _createClass(NineSlicePlane, [{
	        key: 'width',
	        get: function get() {
	            return this._width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._width = value;
	            this._refresh();
	        }
	
	        /**
	         * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'height',
	        get: function get() {
	            return this._height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._height = value;
	            this._refresh();
	        }
	
	        /**
	         * The width of the left column
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'leftWidth',
	        get: function get() {
	            return this._leftWidth;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._leftWidth = value;
	            this._refresh();
	        }
	
	        /**
	         * The width of the right column
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'rightWidth',
	        get: function get() {
	            return this._rightWidth;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._rightWidth = value;
	            this._refresh();
	        }
	
	        /**
	         * The height of the top row
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'topHeight',
	        get: function get() {
	            return this._topHeight;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._topHeight = value;
	            this._refresh();
	        }
	
	        /**
	         * The height of the bottom row
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'bottomHeight',
	        get: function get() {
	            return this._bottomHeight;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._bottomHeight = value;
	            this._refresh();
	        }
	    }]);
	
	    return NineSlicePlane;
	}(_Plane3.default);
	
	exports.default = NineSlicePlane;
	//# sourceMappingURL=NineSlicePlane.js.map

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Mesh2 = __webpack_require__(369);
	
	var _Mesh3 = _interopRequireDefault(_Mesh2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The rope allows you to draw a texture across several points and them manipulate these points
	 *
	 *```js
	 * for (let i = 0; i < 20; i++) {
	 *     points.push(new PIXI.Point(i * 50, 0));
	 * };
	 * let rope = new PIXI.Rope(PIXI.Texture.fromImage("snake.png"), points);
	 *  ```
	 *
	 * @class
	 * @extends PIXI.mesh.Mesh
	 * @memberof PIXI.mesh
	 *
	 */
	var Rope = function (_Mesh) {
	    _inherits(Rope, _Mesh);
	
	    /**
	     * @param {PIXI.Texture} texture - The texture to use on the rope.
	     * @param {PIXI.Point[]} points - An array of {@link PIXI.Point} objects to construct this rope.
	     */
	    function Rope(texture, points) {
	        _classCallCheck(this, Rope);
	
	        /**
	         * An array of points that determine the rope
	         *
	         * @member {PIXI.Point[]}
	         */
	        var _this = _possibleConstructorReturn(this, _Mesh.call(this, texture));
	
	        _this.points = points;
	
	        /**
	         * An array of vertices used to construct this rope.
	         *
	         * @member {Float32Array}
	         */
	        _this.vertices = new Float32Array(points.length * 4);
	
	        /**
	         * The WebGL Uvs of the rope.
	         *
	         * @member {Float32Array}
	         */
	        _this.uvs = new Float32Array(points.length * 4);
	
	        /**
	         * An array containing the color components
	         *
	         * @member {Float32Array}
	         */
	        _this.colors = new Float32Array(points.length * 2);
	
	        /**
	         * An array containing the indices of the vertices
	         *
	         * @member {Uint16Array}
	         */
	        _this.indices = new Uint16Array(points.length * 2);
	
	        /**
	         * refreshes vertices on every updateTransform
	         * @member {boolean}
	         * @default true
	         */
	        _this.autoUpdate = true;
	
	        _this.refresh();
	        return _this;
	    }
	
	    /**
	     * Refreshes
	     *
	     */
	
	
	    Rope.prototype._refresh = function _refresh() {
	        var points = this.points;
	
	        // if too little points, or texture hasn't got UVs set yet just move on.
	        if (points.length < 1 || !this._texture._uvs) {
	            return;
	        }
	
	        // if the number of points has changed we will need to recreate the arraybuffers
	        if (this.vertices.length / 4 !== points.length) {
	            this.vertices = new Float32Array(points.length * 4);
	            this.uvs = new Float32Array(points.length * 4);
	            this.colors = new Float32Array(points.length * 2);
	            this.indices = new Uint16Array(points.length * 2);
	        }
	
	        var uvs = this.uvs;
	
	        var indices = this.indices;
	        var colors = this.colors;
	
	        uvs[0] = 0;
	        uvs[1] = 0;
	        uvs[2] = 0;
	        uvs[3] = 1;
	
	        colors[0] = 1;
	        colors[1] = 1;
	
	        indices[0] = 0;
	        indices[1] = 1;
	
	        var total = points.length;
	
	        for (var i = 1; i < total; i++) {
	            // time to do some smart drawing!
	            var index = i * 4;
	            var amount = i / (total - 1);
	
	            uvs[index] = amount;
	            uvs[index + 1] = 0;
	
	            uvs[index + 2] = amount;
	            uvs[index + 3] = 1;
	
	            index = i * 2;
	            colors[index] = 1;
	            colors[index + 1] = 1;
	
	            index = i * 2;
	            indices[index] = index;
	            indices[index + 1] = index + 1;
	        }
	
	        // ensure that the changes are uploaded
	        this.dirty++;
	        this.indexDirty++;
	
	        this.multiplyUvs();
	        this.refreshVertices();
	    };
	
	    /**
	     * refreshes vertices of Rope mesh
	     */
	
	
	    Rope.prototype.refreshVertices = function refreshVertices() {
	        var points = this.points;
	
	        if (points.length < 1) {
	            return;
	        }
	
	        var lastPoint = points[0];
	        var nextPoint = void 0;
	        var perpX = 0;
	        var perpY = 0;
	
	        // this.count -= 0.2;
	
	        var vertices = this.vertices;
	        var total = points.length;
	
	        for (var i = 0; i < total; i++) {
	            var point = points[i];
	            var index = i * 4;
	
	            if (i < points.length - 1) {
	                nextPoint = points[i + 1];
	            } else {
	                nextPoint = point;
	            }
	
	            perpY = -(nextPoint.x - lastPoint.x);
	            perpX = nextPoint.y - lastPoint.y;
	
	            var ratio = (1 - i / (total - 1)) * 10;
	
	            if (ratio > 1) {
	                ratio = 1;
	            }
	
	            var perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
	            var num = this._texture.height / 2; // (20 + Math.abs(Math.sin((i + this.count) * 0.3) * 50) )* ratio;
	
	            perpX /= perpLength;
	            perpY /= perpLength;
	
	            perpX *= num;
	            perpY *= num;
	
	            vertices[index] = point.x + perpX;
	            vertices[index + 1] = point.y + perpY;
	            vertices[index + 2] = point.x - perpX;
	            vertices[index + 3] = point.y - perpY;
	
	            lastPoint = point;
	        }
	    };
	
	    /**
	     * Updates the object transform for rendering
	     *
	     * @private
	     */
	
	
	    Rope.prototype.updateTransform = function updateTransform() {
	        if (this.autoUpdate) {
	            this.refreshVertices();
	        }
	        this.containerUpdateTransform();
	    };
	
	    return Rope;
	}(_Mesh3.default);
	
	exports.default = Rope;
	//# sourceMappingURL=Rope.js.map

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ParticleContainer = __webpack_require__(376);
	
	Object.defineProperty(exports, 'ParticleContainer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ParticleContainer).default;
	  }
	});
	
	var _ParticleRenderer = __webpack_require__(377);
	
	Object.defineProperty(exports, 'ParticleRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ParticleRenderer).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _utils = __webpack_require__(244);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The ParticleContainer class is a really fast version of the Container built solely for speed,
	 * so use when you need a lot of sprites or particles. The tradeoff of the ParticleContainer is that most advanced
	 * functionality will not work. ParticleContainer implements the basic object transform (position, scale, rotation)
	 * and some advanced functionality like tint (as of v4.5.6).
	 * Other more advanced functionality like masking, children, filters, etc will not work on sprites in this batch.
	 *
	 * It's extremely easy to use :
	 *
	 * ```js
	 * let container = new ParticleContainer();
	 *
	 * for (let i = 0; i < 100; ++i)
	 * {
	 *     let sprite = new PIXI.Sprite.fromImage("myImage.png");
	 *     container.addChild(sprite);
	 * }
	 * ```
	 *
	 * And here you have a hundred sprites that will be rendered at the speed of light.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI.particles
	 */
	var ParticleContainer = function (_core$Container) {
	    _inherits(ParticleContainer, _core$Container);
	
	    /**
	     * @param {number} [maxSize=1500] - The maximum number of particles that can be rendered by the container.
	     *  Affects size of allocated buffers.
	     * @param {object} [properties] - The properties of children that should be uploaded to the gpu and applied.
	     * @param {boolean} [properties.vertices=false] - When true, vertices be uploaded and applied.
	     *                  if sprite's ` scale/anchor/trim/frame/orig` is dynamic, please set `true`.
	     * @param {boolean} [properties.position=true] - When true, position be uploaded and applied.
	     * @param {boolean} [properties.rotation=false] - When true, rotation be uploaded and applied.
	     * @param {boolean} [properties.uvs=false] - When true, uvs be uploaded and applied.
	     * @param {boolean} [properties.tint=false] - When true, alpha and tint be uploaded and applied.
	     * @param {number} [batchSize=16384] - Number of particles per batch. If less than maxSize, it uses maxSize instead.
	     * @param {boolean} [autoResize=false] If true, container allocates more batches in case
	     *  there are more than `maxSize` particles.
	     */
	    function ParticleContainer() {
	        var maxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1500;
	        var properties = arguments[1];
	        var batchSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16384;
	        var autoResize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        _classCallCheck(this, ParticleContainer);
	
	        // Making sure the batch size is valid
	        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
	        // so max number of particles is 65536 / 4 = 16384
	        var _this = _possibleConstructorReturn(this, _core$Container.call(this));
	
	        var maxBatchSize = 16384;
	
	        if (batchSize > maxBatchSize) {
	            batchSize = maxBatchSize;
	        }
	
	        if (batchSize > maxSize) {
	            batchSize = maxSize;
	        }
	
	        /**
	         * Set properties to be dynamic (true) / static (false)
	         *
	         * @member {boolean[]}
	         * @private
	         */
	        _this._properties = [false, true, false, false, false];
	
	        /**
	         * @member {number}
	         * @private
	         */
	        _this._maxSize = maxSize;
	
	        /**
	         * @member {number}
	         * @private
	         */
	        _this._batchSize = batchSize;
	
	        /**
	         * @member {object<number, WebGLBuffer>}
	         * @private
	         */
	        _this._glBuffers = {};
	
	        /**
	         * for every batch stores _updateID corresponding to the last change in that batch
	         * @member {number[]}
	         * @private
	         */
	        _this._bufferUpdateIDs = [];
	
	        /**
	         * when child inserted, removed or changes position this number goes up
	         * @member {number[]}
	         * @private
	         */
	        _this._updateID = 0;
	
	        /**
	         * @member {boolean}
	         *
	         */
	        _this.interactiveChildren = false;
	
	        /**
	         * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL`
	         * to reset the blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = core.BLEND_MODES.NORMAL;
	
	        /**
	         * If true, container allocates more batches in case there are more than `maxSize` particles.
	         * @member {boolean}
	         * @default false
	         */
	        _this.autoResize = autoResize;
	
	        /**
	         * Used for canvas renderering. If true then the elements will be positioned at the
	         * nearest pixel. This provides a nice speed boost.
	         *
	         * @member {boolean}
	         * @default true;
	         */
	        _this.roundPixels = true;
	
	        /**
	         * The texture used to render the children.
	         *
	         * @readonly
	         * @member {BaseTexture}
	         */
	        _this.baseTexture = null;
	
	        _this.setProperties(properties);
	
	        /**
	         * The tint applied to the container.
	         * This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @private
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this._tint = 0;
	        _this.tintRgb = new Float32Array(4);
	        _this.tint = 0xFFFFFF;
	        return _this;
	    }
	
	    /**
	     * Sets the private properties array to dynamic / static based on the passed properties object
	     *
	     * @param {object} properties - The properties to be uploaded
	     */
	
	
	    ParticleContainer.prototype.setProperties = function setProperties(properties) {
	        if (properties) {
	            this._properties[0] = 'vertices' in properties || 'scale' in properties ? !!properties.vertices || !!properties.scale : this._properties[0];
	            this._properties[1] = 'position' in properties ? !!properties.position : this._properties[1];
	            this._properties[2] = 'rotation' in properties ? !!properties.rotation : this._properties[2];
	            this._properties[3] = 'uvs' in properties ? !!properties.uvs : this._properties[3];
	            this._properties[4] = 'tint' in properties || 'alpha' in properties ? !!properties.tint || !!properties.alpha : this._properties[4];
	        }
	    };
	
	    /**
	     * Updates the object transform for rendering
	     *
	     * @private
	     */
	
	
	    ParticleContainer.prototype.updateTransform = function updateTransform() {
	        // TODO don't need to!
	        this.displayObjectUpdateTransform();
	        //  PIXI.Container.prototype.updateTransform.call( this );
	    };
	
	    /**
	     * The tint applied to the container. This is a hex value.
	     * A value of 0xFFFFFF will remove any tint effect.
	     ** IMPORTANT: This is a webGL only feature and will be ignored by the canvas renderer.
	     * @member {number}
	     * @default 0xFFFFFF
	     */
	
	
	    /**
	     * Renders the container using the WebGL renderer
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The webgl renderer
	     */
	    ParticleContainer.prototype.renderWebGL = function renderWebGL(renderer) {
	        var _this2 = this;
	
	        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
	            return;
	        }
	
	        if (!this.baseTexture) {
	            this.baseTexture = this.children[0]._texture.baseTexture;
	            if (!this.baseTexture.hasLoaded) {
	                this.baseTexture.once('update', function () {
	                    return _this2.onChildrenChange(0);
	                });
	            }
	        }
	
	        renderer.setObjectRenderer(renderer.plugins.particle);
	        renderer.plugins.particle.render(this);
	    };
	
	    /**
	     * Set the flag that static data should be updated to true
	     *
	     * @private
	     * @param {number} smallestChildIndex - The smallest child index
	     */
	
	
	    ParticleContainer.prototype.onChildrenChange = function onChildrenChange(smallestChildIndex) {
	        var bufferIndex = Math.floor(smallestChildIndex / this._batchSize);
	
	        while (this._bufferUpdateIDs.length < bufferIndex) {
	            this._bufferUpdateIDs.push(0);
	        }
	        this._bufferUpdateIDs[bufferIndex] = ++this._updateID;
	    };
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer
	     */
	
	
	    ParticleContainer.prototype.renderCanvas = function renderCanvas(renderer) {
	        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
	            return;
	        }
	
	        var context = renderer.context;
	        var transform = this.worldTransform;
	        var isRotated = true;
	
	        var positionX = 0;
	        var positionY = 0;
	
	        var finalWidth = 0;
	        var finalHeight = 0;
	
	        renderer.setBlendMode(this.blendMode);
	
	        context.globalAlpha = this.worldAlpha;
	
	        this.displayObjectUpdateTransform();
	
	        for (var i = 0; i < this.children.length; ++i) {
	            var child = this.children[i];
	
	            if (!child.visible) {
	                continue;
	            }
	
	            var frame = child._texture.frame;
	
	            context.globalAlpha = this.worldAlpha * child.alpha;
	
	            if (child.rotation % (Math.PI * 2) === 0) {
	                // this is the fastest  way to optimise! - if rotation is 0 then we can avoid any kind of setTransform call
	                if (isRotated) {
	                    context.setTransform(transform.a, transform.b, transform.c, transform.d, transform.tx * renderer.resolution, transform.ty * renderer.resolution);
	
	                    isRotated = false;
	                }
	
	                positionX = child.anchor.x * (-frame.width * child.scale.x) + child.position.x + 0.5;
	                positionY = child.anchor.y * (-frame.height * child.scale.y) + child.position.y + 0.5;
	
	                finalWidth = frame.width * child.scale.x;
	                finalHeight = frame.height * child.scale.y;
	            } else {
	                if (!isRotated) {
	                    isRotated = true;
	                }
	
	                child.displayObjectUpdateTransform();
	
	                var childTransform = child.worldTransform;
	
	                if (renderer.roundPixels) {
	                    context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, childTransform.tx * renderer.resolution | 0, childTransform.ty * renderer.resolution | 0);
	                } else {
	                    context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, childTransform.tx * renderer.resolution, childTransform.ty * renderer.resolution);
	                }
	
	                positionX = child.anchor.x * -frame.width + 0.5;
	                positionY = child.anchor.y * -frame.height + 0.5;
	
	                finalWidth = frame.width;
	                finalHeight = frame.height;
	            }
	
	            var resolution = child._texture.baseTexture.resolution;
	
	            context.drawImage(child._texture.baseTexture.source, frame.x * resolution, frame.y * resolution, frame.width * resolution, frame.height * resolution, positionX * renderer.resolution, positionY * renderer.resolution, finalWidth * renderer.resolution, finalHeight * renderer.resolution);
	        }
	    };
	
	    /**
	     * Destroys the container
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their
	     *  destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */
	
	
	    ParticleContainer.prototype.destroy = function destroy(options) {
	        _core$Container.prototype.destroy.call(this, options);
	
	        if (this._buffers) {
	            for (var i = 0; i < this._buffers.length; ++i) {
	                this._buffers[i].destroy();
	            }
	        }
	
	        this._properties = null;
	        this._buffers = null;
	        this._bufferUpdateIDs = null;
	    };
	
	    _createClass(ParticleContainer, [{
	        key: 'tint',
	        get: function get() {
	            return this._tint;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._tint = value;
	            (0, _utils.hex2rgb)(value, this.tintRgb);
	        }
	    }]);
	
	    return ParticleContainer;
	}(core.Container);
	
	exports.default = ParticleContainer;
	//# sourceMappingURL=ParticleContainer.js.map

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _ParticleShader = __webpack_require__(378);
	
	var _ParticleShader2 = _interopRequireDefault(_ParticleShader);
	
	var _ParticleBuffer = __webpack_require__(379);
	
	var _ParticleBuffer2 = _interopRequireDefault(_ParticleBuffer);
	
	var _utils = __webpack_require__(244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
	 * share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's ParticleRenderer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleRenderer.java
	 */
	
	/**
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var ParticleRenderer = function (_core$ObjectRenderer) {
	    _inherits(ParticleRenderer, _core$ObjectRenderer);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this sprite batch works for.
	     */
	    function ParticleRenderer(renderer) {
	        _classCallCheck(this, ParticleRenderer);
	
	        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
	        // so max number of particles is 65536 / 4 = 16384
	        // and max number of element in the index buffer is 16384 * 6 = 98304
	        // Creating a full index buffer, overhead is 98304 * 2 = 196Ko
	        // let numIndices = 98304;
	
	        /**
	         * The default shader that is used if a sprite doesn't have a more specific one.
	         *
	         * @member {PIXI.Shader}
	         */
	        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));
	
	        _this.shader = null;
	
	        _this.indexBuffer = null;
	
	        _this.properties = null;
	
	        _this.tempMatrix = new core.Matrix();
	
	        _this.CONTEXT_UID = 0;
	        return _this;
	    }
	
	    /**
	     * When there is a WebGL context change
	     *
	     * @private
	     */
	
	
	    ParticleRenderer.prototype.onContextChange = function onContextChange() {
	        var gl = this.renderer.gl;
	
	        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
	
	        // setup default shader
	        this.shader = new _ParticleShader2.default(gl);
	
	        this.properties = [
	        // verticesData
	        {
	            attribute: this.shader.attributes.aVertexPosition,
	            size: 2,
	            uploadFunction: this.uploadVertices,
	            offset: 0
	        },
	        // positionData
	        {
	            attribute: this.shader.attributes.aPositionCoord,
	            size: 2,
	            uploadFunction: this.uploadPosition,
	            offset: 0
	        },
	        // rotationData
	        {
	            attribute: this.shader.attributes.aRotation,
	            size: 1,
	            uploadFunction: this.uploadRotation,
	            offset: 0
	        },
	        // uvsData
	        {
	            attribute: this.shader.attributes.aTextureCoord,
	            size: 2,
	            uploadFunction: this.uploadUvs,
	            offset: 0
	        },
	        // tintData
	        {
	            attribute: this.shader.attributes.aColor,
	            size: 1,
	            unsignedByte: true,
	            uploadFunction: this.uploadTint,
	            offset: 0
	        }];
	    };
	
	    /**
	     * Starts a new particle batch.
	     *
	     */
	
	
	    ParticleRenderer.prototype.start = function start() {
	        this.renderer.bindShader(this.shader);
	    };
	
	    /**
	     * Renders the particle container object.
	     *
	     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
	     */
	
	
	    ParticleRenderer.prototype.render = function render(container) {
	        var children = container.children;
	        var maxSize = container._maxSize;
	        var batchSize = container._batchSize;
	        var renderer = this.renderer;
	        var totalChildren = children.length;
	
	        if (totalChildren === 0) {
	            return;
	        } else if (totalChildren > maxSize) {
	            totalChildren = maxSize;
	        }
	
	        var buffers = container._glBuffers[renderer.CONTEXT_UID];
	
	        if (!buffers) {
	            buffers = container._glBuffers[renderer.CONTEXT_UID] = this.generateBuffers(container);
	        }
	
	        var baseTexture = children[0]._texture.baseTexture;
	
	        // if the uvs have not updated then no point rendering just yet!
	        this.renderer.setBlendMode(core.utils.correctBlendMode(container.blendMode, baseTexture.premultipliedAlpha));
	
	        var gl = renderer.gl;
	
	        var m = container.worldTransform.copy(this.tempMatrix);
	
	        m.prepend(renderer._activeRenderTarget.projectionMatrix);
	
	        this.shader.uniforms.projectionMatrix = m.toArray(true);
	
	        this.shader.uniforms.uColor = core.utils.premultiplyRgba(container.tintRgb, container.worldAlpha, this.shader.uniforms.uColor, baseTexture.premultipliedAlpha);
	
	        // make sure the texture is bound..
	        this.shader.uniforms.uSampler = renderer.bindTexture(baseTexture);
	
	        var updateStatic = false;
	
	        // now lets upload and render the buffers..
	        for (var i = 0, j = 0; i < totalChildren; i += batchSize, j += 1) {
	            var amount = totalChildren - i;
	
	            if (amount > batchSize) {
	                amount = batchSize;
	            }
	
	            if (j >= buffers.length) {
	                if (!container.autoResize) {
	                    break;
	                }
	                buffers.push(this._generateOneMoreBuffer(container));
	            }
	
	            var buffer = buffers[j];
	
	            // we always upload the dynamic
	            buffer.uploadDynamic(children, i, amount);
	
	            var bid = container._bufferUpdateIDs[j] || 0;
	
	            updateStatic = updateStatic || buffer._updateID < bid;
	            // we only upload the static content when we have to!
	            if (updateStatic) {
	                buffer._updateID = container._updateID;
	                buffer.uploadStatic(children, i, amount);
	            }
	
	            // bind the buffer
	            renderer.bindVao(buffer.vao);
	            buffer.vao.draw(gl.TRIANGLES, amount * 6);
	        }
	    };
	
	    /**
	     * Creates one particle buffer for each child in the container we want to render and updates internal properties
	     *
	     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
	     * @return {PIXI.ParticleBuffer[]} The buffers
	     */
	
	
	    ParticleRenderer.prototype.generateBuffers = function generateBuffers(container) {
	        var gl = this.renderer.gl;
	        var buffers = [];
	        var size = container._maxSize;
	        var batchSize = container._batchSize;
	        var dynamicPropertyFlags = container._properties;
	
	        for (var i = 0; i < size; i += batchSize) {
	            buffers.push(new _ParticleBuffer2.default(gl, this.properties, dynamicPropertyFlags, batchSize));
	        }
	
	        return buffers;
	    };
	
	    /**
	     * Creates one more particle buffer, because container has autoResize feature
	     *
	     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
	     * @return {PIXI.ParticleBuffer} generated buffer
	     * @private
	     */
	
	
	    ParticleRenderer.prototype._generateOneMoreBuffer = function _generateOneMoreBuffer(container) {
	        var gl = this.renderer.gl;
	        var batchSize = container._batchSize;
	        var dynamicPropertyFlags = container._properties;
	
	        return new _ParticleBuffer2.default(gl, this.properties, dynamicPropertyFlags, batchSize);
	    };
	
	    /**
	     * Uploads the verticies.
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their vertices uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	
	
	    ParticleRenderer.prototype.uploadVertices = function uploadVertices(children, startIndex, amount, array, stride, offset) {
	        var w0 = 0;
	        var w1 = 0;
	        var h0 = 0;
	        var h1 = 0;
	
	        for (var i = 0; i < amount; ++i) {
	            var sprite = children[startIndex + i];
	            var texture = sprite._texture;
	            var sx = sprite.scale.x;
	            var sy = sprite.scale.y;
	            var trim = texture.trim;
	            var orig = texture.orig;
	
	            if (trim) {
	                // if the sprite is trimmed and is not a tilingsprite then we need to add the
	                // extra space before transforming the sprite coords..
	                w1 = trim.x - sprite.anchor.x * orig.width;
	                w0 = w1 + trim.width;
	
	                h1 = trim.y - sprite.anchor.y * orig.height;
	                h0 = h1 + trim.height;
	            } else {
	                w0 = orig.width * (1 - sprite.anchor.x);
	                w1 = orig.width * -sprite.anchor.x;
	
	                h0 = orig.height * (1 - sprite.anchor.y);
	                h1 = orig.height * -sprite.anchor.y;
	            }
	
	            array[offset] = w1 * sx;
	            array[offset + 1] = h1 * sy;
	
	            array[offset + stride] = w0 * sx;
	            array[offset + stride + 1] = h1 * sy;
	
	            array[offset + stride * 2] = w0 * sx;
	            array[offset + stride * 2 + 1] = h0 * sy;
	
	            array[offset + stride * 3] = w1 * sx;
	            array[offset + stride * 3 + 1] = h0 * sy;
	
	            offset += stride * 4;
	        }
	    };
	
	    /**
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their positions uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	
	
	    ParticleRenderer.prototype.uploadPosition = function uploadPosition(children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; i++) {
	            var spritePosition = children[startIndex + i].position;
	
	            array[offset] = spritePosition.x;
	            array[offset + 1] = spritePosition.y;
	
	            array[offset + stride] = spritePosition.x;
	            array[offset + stride + 1] = spritePosition.y;
	
	            array[offset + stride * 2] = spritePosition.x;
	            array[offset + stride * 2 + 1] = spritePosition.y;
	
	            array[offset + stride * 3] = spritePosition.x;
	            array[offset + stride * 3 + 1] = spritePosition.y;
	
	            offset += stride * 4;
	        }
	    };
	
	    /**
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their rotation uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	
	
	    ParticleRenderer.prototype.uploadRotation = function uploadRotation(children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; i++) {
	            var spriteRotation = children[startIndex + i].rotation;
	
	            array[offset] = spriteRotation;
	            array[offset + stride] = spriteRotation;
	            array[offset + stride * 2] = spriteRotation;
	            array[offset + stride * 3] = spriteRotation;
	
	            offset += stride * 4;
	        }
	    };
	
	    /**
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their rotation uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	
	
	    ParticleRenderer.prototype.uploadUvs = function uploadUvs(children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; ++i) {
	            var textureUvs = children[startIndex + i]._texture._uvs;
	
	            if (textureUvs) {
	                array[offset] = textureUvs.x0;
	                array[offset + 1] = textureUvs.y0;
	
	                array[offset + stride] = textureUvs.x1;
	                array[offset + stride + 1] = textureUvs.y1;
	
	                array[offset + stride * 2] = textureUvs.x2;
	                array[offset + stride * 2 + 1] = textureUvs.y2;
	
	                array[offset + stride * 3] = textureUvs.x3;
	                array[offset + stride * 3 + 1] = textureUvs.y3;
	
	                offset += stride * 4;
	            } else {
	                // TODO you know this can be easier!
	                array[offset] = 0;
	                array[offset + 1] = 0;
	
	                array[offset + stride] = 0;
	                array[offset + stride + 1] = 0;
	
	                array[offset + stride * 2] = 0;
	                array[offset + stride * 2 + 1] = 0;
	
	                array[offset + stride * 3] = 0;
	                array[offset + stride * 3 + 1] = 0;
	
	                offset += stride * 4;
	            }
	        }
	    };
	
	    /**
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their rotation uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	
	
	    ParticleRenderer.prototype.uploadTint = function uploadTint(children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; ++i) {
	            var sprite = children[startIndex + i];
	            var premultiplied = sprite._texture.baseTexture.premultipliedAlpha;
	            var alpha = sprite.alpha;
	            // we dont call extra function if alpha is 1.0, that's faster
	            var argb = alpha < 1.0 && premultiplied ? (0, _utils.premultiplyTint)(sprite._tintRGB, alpha) : sprite._tintRGB + (alpha * 255 << 24);
	
	            array[offset] = argb;
	            array[offset + stride] = argb;
	            array[offset + stride * 2] = argb;
	            array[offset + stride * 3] = argb;
	
	            offset += stride * 4;
	        }
	    };
	
	    /**
	     * Destroys the ParticleRenderer.
	     *
	     */
	
	
	    ParticleRenderer.prototype.destroy = function destroy() {
	        if (this.renderer.gl) {
	            this.renderer.gl.deleteBuffer(this.indexBuffer);
	        }
	
	        _core$ObjectRenderer.prototype.destroy.call(this);
	
	        this.shader.destroy();
	
	        this.indices = null;
	        this.tempMatrix = null;
	    };
	
	    return ParticleRenderer;
	}(core.ObjectRenderer);
	
	exports.default = ParticleRenderer;
	
	
	core.WebGLRenderer.registerPlugin('particle', ParticleRenderer);
	//# sourceMappingURL=ParticleRenderer.js.map

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Shader2 = __webpack_require__(292);
	
	var _Shader3 = _interopRequireDefault(_Shader2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @class
	 * @extends PIXI.Shader
	 * @memberof PIXI
	 */
	var ParticleShader = function (_Shader) {
	    _inherits(ParticleShader, _Shader);
	
	    /**
	     * @param {PIXI.Shader} gl - The webgl shader manager this shader works for.
	     */
	    function ParticleShader(gl) {
	        _classCallCheck(this, ParticleShader);
	
	        return _possibleConstructorReturn(this, _Shader.call(this, gl,
	        // vertex shader
	        ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'attribute vec4 aColor;', 'attribute vec2 aPositionCoord;', 'attribute float aRotation;', 'uniform mat3 projectionMatrix;', 'uniform vec4 uColor;', 'varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'void main(void){', '   float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);', '   float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);', '   vec2 v = vec2(x, y);', '   v = v + aPositionCoord;', '   gl_Position = vec4((projectionMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);', '   vTextureCoord = aTextureCoord;', '   vColor = aColor * uColor;', '}'].join('\n'),
	        // hello
	        ['varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'uniform sampler2D uSampler;', 'void main(void){', '  vec4 color = texture2D(uSampler, vTextureCoord) * vColor;', '  gl_FragColor = color;', '}'].join('\n')));
	    }
	
	    return ParticleShader;
	}(_Shader3.default);
	
	exports.default = ParticleShader;
	//# sourceMappingURL=ParticleShader.js.map

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pixiGlCore = __webpack_require__(216);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	var _createIndicesForQuads = __webpack_require__(291);
	
	var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that
	 * they now share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's ParticleBuffer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleBuffer.java
	 */
	
	/**
	 * The particle buffer manages the static and dynamic buffers for a particle container.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var ParticleBuffer = function () {
	    /**
	     * @param {WebGLRenderingContext} gl - The rendering context.
	     * @param {object} properties - The properties to upload.
	     * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
	     * @param {number} size - The size of the batch.
	     */
	    function ParticleBuffer(gl, properties, dynamicPropertyFlags, size) {
	        _classCallCheck(this, ParticleBuffer);
	
	        /**
	         * The current WebGL drawing context.
	         *
	         * @member {WebGLRenderingContext}
	         */
	        this.gl = gl;
	
	        /**
	         * The number of particles the buffer can hold
	         *
	         * @member {number}
	         */
	        this.size = size;
	
	        /**
	         * A list of the properties that are dynamic.
	         *
	         * @member {object[]}
	         */
	        this.dynamicProperties = [];
	
	        /**
	         * A list of the properties that are static.
	         *
	         * @member {object[]}
	         */
	        this.staticProperties = [];
	
	        for (var i = 0; i < properties.length; ++i) {
	            var property = properties[i];
	
	            // Make copy of properties object so that when we edit the offset it doesn't
	            // change all other instances of the object literal
	            property = {
	                attribute: property.attribute,
	                size: property.size,
	                uploadFunction: property.uploadFunction,
	                unsignedByte: property.unsignedByte,
	                offset: property.offset
	            };
	
	            if (dynamicPropertyFlags[i]) {
	                this.dynamicProperties.push(property);
	            } else {
	                this.staticProperties.push(property);
	            }
	        }
	
	        this.staticStride = 0;
	        this.staticBuffer = null;
	        this.staticData = null;
	        this.staticDataUint32 = null;
	
	        this.dynamicStride = 0;
	        this.dynamicBuffer = null;
	        this.dynamicData = null;
	        this.dynamicDataUint32 = null;
	
	        this._updateID = 0;
	
	        this.initBuffers();
	    }
	
	    /**
	     * Sets up the renderer context and necessary buffers.
	     *
	     * @private
	     */
	
	
	    ParticleBuffer.prototype.initBuffers = function initBuffers() {
	        var gl = this.gl;
	        var dynamicOffset = 0;
	
	        /**
	         * Holds the indices of the geometry (quads) to draw
	         *
	         * @member {Uint16Array}
	         */
	        this.indices = (0, _createIndicesForQuads2.default)(this.size);
	        this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);
	
	        this.dynamicStride = 0;
	
	        for (var i = 0; i < this.dynamicProperties.length; ++i) {
	            var property = this.dynamicProperties[i];
	
	            property.offset = dynamicOffset;
	            dynamicOffset += property.size;
	            this.dynamicStride += property.size;
	        }
	
	        var dynBuffer = new ArrayBuffer(this.size * this.dynamicStride * 4 * 4);
	
	        this.dynamicData = new Float32Array(dynBuffer);
	        this.dynamicDataUint32 = new Uint32Array(dynBuffer);
	        this.dynamicBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, dynBuffer, gl.STREAM_DRAW);
	
	        // static //
	        var staticOffset = 0;
	
	        this.staticStride = 0;
	
	        for (var _i = 0; _i < this.staticProperties.length; ++_i) {
	            var _property = this.staticProperties[_i];
	
	            _property.offset = staticOffset;
	            staticOffset += _property.size;
	            this.staticStride += _property.size;
	        }
	
	        var statBuffer = new ArrayBuffer(this.size * this.staticStride * 4 * 4);
	
	        this.staticData = new Float32Array(statBuffer);
	        this.staticDataUint32 = new Uint32Array(statBuffer);
	        this.staticBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, statBuffer, gl.STATIC_DRAW);
	
	        this.vao = new _pixiGlCore2.default.VertexArrayObject(gl).addIndex(this.indexBuffer);
	
	        for (var _i2 = 0; _i2 < this.dynamicProperties.length; ++_i2) {
	            var _property2 = this.dynamicProperties[_i2];
	
	            if (_property2.unsignedByte) {
	                this.vao.addAttribute(this.dynamicBuffer, _property2.attribute, gl.UNSIGNED_BYTE, true, this.dynamicStride * 4, _property2.offset * 4);
	            } else {
	                this.vao.addAttribute(this.dynamicBuffer, _property2.attribute, gl.FLOAT, false, this.dynamicStride * 4, _property2.offset * 4);
	            }
	        }
	
	        for (var _i3 = 0; _i3 < this.staticProperties.length; ++_i3) {
	            var _property3 = this.staticProperties[_i3];
	
	            if (_property3.unsignedByte) {
	                this.vao.addAttribute(this.staticBuffer, _property3.attribute, gl.UNSIGNED_BYTE, true, this.staticStride * 4, _property3.offset * 4);
	            } else {
	                this.vao.addAttribute(this.staticBuffer, _property3.attribute, gl.FLOAT, false, this.staticStride * 4, _property3.offset * 4);
	            }
	        }
	    };
	
	    /**
	     * Uploads the dynamic properties.
	     *
	     * @param {PIXI.DisplayObject[]} children - The children to upload.
	     * @param {number} startIndex - The index to start at.
	     * @param {number} amount - The number to upload.
	     */
	
	
	    ParticleBuffer.prototype.uploadDynamic = function uploadDynamic(children, startIndex, amount) {
	        for (var i = 0; i < this.dynamicProperties.length; i++) {
	            var property = this.dynamicProperties[i];
	
	            property.uploadFunction(children, startIndex, amount, property.unsignedByte ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, property.offset);
	        }
	
	        this.dynamicBuffer.upload();
	    };
	
	    /**
	     * Uploads the static properties.
	     *
	     * @param {PIXI.DisplayObject[]} children - The children to upload.
	     * @param {number} startIndex - The index to start at.
	     * @param {number} amount - The number to upload.
	     */
	
	
	    ParticleBuffer.prototype.uploadStatic = function uploadStatic(children, startIndex, amount) {
	        for (var i = 0; i < this.staticProperties.length; i++) {
	            var property = this.staticProperties[i];
	
	            property.uploadFunction(children, startIndex, amount, property.unsignedByte ? this.staticDataUint32 : this.staticData, this.staticStride, property.offset);
	        }
	
	        this.staticBuffer.upload();
	    };
	
	    /**
	     * Destroys the ParticleBuffer.
	     *
	     */
	
	
	    ParticleBuffer.prototype.destroy = function destroy() {
	        this.dynamicProperties = null;
	        this.dynamicBuffer.destroy();
	        this.dynamicBuffer = null;
	        this.dynamicData = null;
	        this.dynamicDataUint32 = null;
	
	        this.staticProperties = null;
	        this.staticBuffer.destroy();
	        this.staticBuffer = null;
	        this.staticData = null;
	        this.staticDataUint32 = null;
	    };
	
	    return ParticleBuffer;
	}();
	
	exports.default = ParticleBuffer;
	//# sourceMappingURL=ParticleBuffer.js.map

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebGLPrepare = __webpack_require__(381);
	
	Object.defineProperty(exports, 'webgl', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebGLPrepare).default;
	  }
	});
	
	var _CanvasPrepare = __webpack_require__(384);
	
	Object.defineProperty(exports, 'canvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasPrepare).default;
	  }
	});
	
	var _BasePrepare = __webpack_require__(382);
	
	Object.defineProperty(exports, 'BasePrepare', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BasePrepare).default;
	  }
	});
	
	var _CountLimiter = __webpack_require__(383);
	
	Object.defineProperty(exports, 'CountLimiter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CountLimiter).default;
	  }
	});
	
	var _TimeLimiter = __webpack_require__(385);
	
	Object.defineProperty(exports, 'TimeLimiter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TimeLimiter).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _BasePrepare2 = __webpack_require__(382);
	
	var _BasePrepare3 = _interopRequireDefault(_BasePrepare2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The prepare manager provides functionality to upload content to the GPU.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.prepare
	 *
	 * @class
	 * @extends PIXI.prepare.BasePrepare
	 * @memberof PIXI.prepare
	 */
	var WebGLPrepare = function (_BasePrepare) {
	    _inherits(WebGLPrepare, _BasePrepare);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     */
	    function WebGLPrepare(renderer) {
	        _classCallCheck(this, WebGLPrepare);
	
	        var _this = _possibleConstructorReturn(this, _BasePrepare.call(this, renderer));
	
	        _this.uploadHookHelper = _this.renderer;
	
	        // Add textures and graphics to upload
	        _this.registerFindHook(findGraphics);
	        _this.registerUploadHook(uploadBaseTextures);
	        _this.registerUploadHook(uploadGraphics);
	        return _this;
	    }
	
	    return WebGLPrepare;
	}(_BasePrepare3.default);
	/**
	 * Built-in hook to upload PIXI.Texture objects to the GPU.
	 *
	 * @private
	 * @param {PIXI.WebGLRenderer} renderer - instance of the webgl renderer
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	
	
	exports.default = WebGLPrepare;
	function uploadBaseTextures(renderer, item) {
	    if (item instanceof core.BaseTexture) {
	        // if the texture already has a GL texture, then the texture has been prepared or rendered
	        // before now. If the texture changed, then the changer should be calling texture.update() which
	        // reuploads the texture without need for preparing it again
	        if (!item._glTextures[renderer.CONTEXT_UID]) {
	            renderer.textureManager.updateTexture(item);
	        }
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to upload PIXI.Graphics to the GPU.
	 *
	 * @private
	 * @param {PIXI.WebGLRenderer} renderer - instance of the webgl renderer
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function uploadGraphics(renderer, item) {
	    if (item instanceof core.Graphics) {
	        // if the item is not dirty and already has webgl data, then it got prepared or rendered
	        // before now and we shouldn't waste time updating it again
	        if (item.dirty || item.clearDirty || !item._webGL[renderer.plugins.graphics.CONTEXT_UID]) {
	            renderer.plugins.graphics.updateGraphics(item);
	        }
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to find graphics.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Graphics object was found.
	 */
	function findGraphics(item, queue) {
	    if (item instanceof core.Graphics) {
	        queue.push(item);
	
	        return true;
	    }
	
	    return false;
	}
	
	core.WebGLRenderer.registerPlugin('prepare', WebGLPrepare);
	//# sourceMappingURL=WebGLPrepare.js.map

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _CountLimiter = __webpack_require__(383);
	
	var _CountLimiter2 = _interopRequireDefault(_CountLimiter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SharedTicker = core.ticker.shared;
	
	/**
	 * Default number of uploads per frame using prepare plugin.
	 *
	 * @static
	 * @memberof PIXI.settings
	 * @name UPLOADS_PER_FRAME
	 * @type {number}
	 * @default 4
	 */
	core.settings.UPLOADS_PER_FRAME = 4;
	
	/**
	 * The prepare manager provides functionality to upload content to the GPU. BasePrepare handles
	 * basic queuing functionality and is extended by {@link PIXI.prepare.WebGLPrepare} and {@link PIXI.prepare.CanvasPrepare}
	 * to provide preparation capabilities specific to their respective renderers.
	 *
	 * @example
	 * // Create a sprite
	 * const sprite = new PIXI.Sprite.fromImage('something.png');
	 *
	 * // Load object into GPU
	 * app.renderer.plugins.prepare.upload(sprite, () => {
	 *
	 *     //Texture(s) has been uploaded to GPU
	 *     app.stage.addChild(sprite);
	 *
	 * })
	 *
	 * @abstract
	 * @class
	 * @memberof PIXI.prepare
	 */
	
	var BasePrepare = function () {
	    /**
	     * @param {PIXI.SystemRenderer} renderer - A reference to the current renderer
	     */
	    function BasePrepare(renderer) {
	        var _this = this;
	
	        _classCallCheck(this, BasePrepare);
	
	        /**
	         * The limiter to be used to control how quickly items are prepared.
	         * @type {PIXI.prepare.CountLimiter|PIXI.prepare.TimeLimiter}
	         */
	        this.limiter = new _CountLimiter2.default(core.settings.UPLOADS_PER_FRAME);
	
	        /**
	         * Reference to the renderer.
	         * @type {PIXI.SystemRenderer}
	         * @protected
	         */
	        this.renderer = renderer;
	
	        /**
	         * The only real difference between CanvasPrepare and WebGLPrepare is what they pass
	         * to upload hooks. That different parameter is stored here.
	         * @type {PIXI.prepare.CanvasPrepare|PIXI.WebGLRenderer}
	         * @protected
	         */
	        this.uploadHookHelper = null;
	
	        /**
	         * Collection of items to uploads at once.
	         * @type {Array<*>}
	         * @private
	         */
	        this.queue = [];
	
	        /**
	         * Collection of additional hooks for finding assets.
	         * @type {Array<Function>}
	         * @private
	         */
	        this.addHooks = [];
	
	        /**
	         * Collection of additional hooks for processing assets.
	         * @type {Array<Function>}
	         * @private
	         */
	        this.uploadHooks = [];
	
	        /**
	         * Callback to call after completed.
	         * @type {Array<Function>}
	         * @private
	         */
	        this.completes = [];
	
	        /**
	         * If prepare is ticking (running).
	         * @type {boolean}
	         * @private
	         */
	        this.ticking = false;
	
	        /**
	         * 'bound' call for prepareItems().
	         * @type {Function}
	         * @private
	         */
	        this.delayedTick = function () {
	            // unlikely, but in case we were destroyed between tick() and delayedTick()
	            if (!_this.queue) {
	                return;
	            }
	            _this.prepareItems();
	        };
	
	        // hooks to find the correct texture
	        this.registerFindHook(findText);
	        this.registerFindHook(findTextStyle);
	        this.registerFindHook(findMultipleBaseTextures);
	        this.registerFindHook(findBaseTexture);
	        this.registerFindHook(findTexture);
	
	        // upload hooks
	        this.registerUploadHook(drawText);
	        this.registerUploadHook(calculateTextStyle);
	    }
	
	    /**
	     * Upload all the textures and graphics to the GPU.
	     *
	     * @param {Function|PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} item -
	     *        Either the container or display object to search for items to upload, the items to upload themselves,
	     *        or the callback function, if items have been added using `prepare.add`.
	     * @param {Function} [done] - Optional callback when all queued uploads have completed
	     */
	
	
	    BasePrepare.prototype.upload = function upload(item, done) {
	        if (typeof item === 'function') {
	            done = item;
	            item = null;
	        }
	
	        // If a display object, search for items
	        // that we could upload
	        if (item) {
	            this.add(item);
	        }
	
	        // Get the items for upload from the display
	        if (this.queue.length) {
	            if (done) {
	                this.completes.push(done);
	            }
	
	            if (!this.ticking) {
	                this.ticking = true;
	                SharedTicker.addOnce(this.tick, this, core.UPDATE_PRIORITY.UTILITY);
	            }
	        } else if (done) {
	            done();
	        }
	    };
	
	    /**
	     * Handle tick update
	     *
	     * @private
	     */
	
	
	    BasePrepare.prototype.tick = function tick() {
	        setTimeout(this.delayedTick, 0);
	    };
	
	    /**
	     * Actually prepare items. This is handled outside of the tick because it will take a while
	     * and we do NOT want to block the current animation frame from rendering.
	     *
	     * @private
	     */
	
	
	    BasePrepare.prototype.prepareItems = function prepareItems() {
	        this.limiter.beginFrame();
	        // Upload the graphics
	        while (this.queue.length && this.limiter.allowedToUpload()) {
	            var item = this.queue[0];
	            var uploaded = false;
	
	            if (item && !item._destroyed) {
	                for (var i = 0, len = this.uploadHooks.length; i < len; i++) {
	                    if (this.uploadHooks[i](this.uploadHookHelper, item)) {
	                        this.queue.shift();
	                        uploaded = true;
	                        break;
	                    }
	                }
	            }
	
	            if (!uploaded) {
	                this.queue.shift();
	            }
	        }
	
	        // We're finished
	        if (!this.queue.length) {
	            this.ticking = false;
	
	            var completes = this.completes.slice(0);
	
	            this.completes.length = 0;
	
	            for (var _i = 0, _len = completes.length; _i < _len; _i++) {
	                completes[_i]();
	            }
	        } else {
	            // if we are not finished, on the next rAF do this again
	            SharedTicker.addOnce(this.tick, this, core.UPDATE_PRIORITY.UTILITY);
	        }
	    };
	
	    /**
	     * Adds hooks for finding items.
	     *
	     * @param {Function} addHook - Function call that takes two parameters: `item:*, queue:Array`
	     *          function must return `true` if it was able to add item to the queue.
	     * @return {PIXI.BasePrepare} Instance of plugin for chaining.
	     */
	
	
	    BasePrepare.prototype.registerFindHook = function registerFindHook(addHook) {
	        if (addHook) {
	            this.addHooks.push(addHook);
	        }
	
	        return this;
	    };
	
	    /**
	     * Adds hooks for uploading items.
	     *
	     * @param {Function} uploadHook - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
	     *          function must return `true` if it was able to handle upload of item.
	     * @return {PIXI.BasePrepare} Instance of plugin for chaining.
	     */
	
	
	    BasePrepare.prototype.registerUploadHook = function registerUploadHook(uploadHook) {
	        if (uploadHook) {
	            this.uploadHooks.push(uploadHook);
	        }
	
	        return this;
	    };
	
	    /**
	     * Manually add an item to the uploading queue.
	     *
	     * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
	     *        add to the queue
	     * @return {PIXI.CanvasPrepare} Instance of plugin for chaining.
	     */
	
	
	    BasePrepare.prototype.add = function add(item) {
	        // Add additional hooks for finding elements on special
	        // types of objects that
	        for (var i = 0, len = this.addHooks.length; i < len; i++) {
	            if (this.addHooks[i](item, this.queue)) {
	                break;
	            }
	        }
	
	        // Get childen recursively
	        if (item instanceof core.Container) {
	            for (var _i2 = item.children.length - 1; _i2 >= 0; _i2--) {
	                this.add(item.children[_i2]);
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Destroys the plugin, don't use after this.
	     *
	     */
	
	
	    BasePrepare.prototype.destroy = function destroy() {
	        if (this.ticking) {
	            SharedTicker.remove(this.tick, this);
	        }
	        this.ticking = false;
	        this.addHooks = null;
	        this.uploadHooks = null;
	        this.renderer = null;
	        this.completes = null;
	        this.queue = null;
	        this.limiter = null;
	        this.uploadHookHelper = null;
	    };
	
	    return BasePrepare;
	}();
	
	/**
	 * Built-in hook to find multiple textures from objects like AnimatedSprites.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Texture object was found.
	 */
	
	
	exports.default = BasePrepare;
	function findMultipleBaseTextures(item, queue) {
	    var result = false;
	
	    // Objects with mutliple textures
	    if (item && item._textures && item._textures.length) {
	        for (var i = 0; i < item._textures.length; i++) {
	            if (item._textures[i] instanceof core.Texture) {
	                var baseTexture = item._textures[i].baseTexture;
	
	                if (queue.indexOf(baseTexture) === -1) {
	                    queue.push(baseTexture);
	                    result = true;
	                }
	            }
	        }
	    }
	
	    return result;
	}
	
	/**
	 * Built-in hook to find BaseTextures from Sprites.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Texture object was found.
	 */
	function findBaseTexture(item, queue) {
	    // Objects with textures, like Sprites/Text
	    if (item instanceof core.BaseTexture) {
	        if (queue.indexOf(item) === -1) {
	            queue.push(item);
	        }
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to find textures from objects.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Texture object was found.
	 */
	function findTexture(item, queue) {
	    if (item._texture && item._texture instanceof core.Texture) {
	        var texture = item._texture.baseTexture;
	
	        if (queue.indexOf(texture) === -1) {
	            queue.push(texture);
	        }
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to draw PIXI.Text to its texture.
	 *
	 * @private
	 * @param {PIXI.WebGLRenderer|PIXI.CanvasPrepare} helper - Not used by this upload handler
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function drawText(helper, item) {
	    if (item instanceof core.Text) {
	        // updating text will return early if it is not dirty
	        item.updateText(true);
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to calculate a text style for a PIXI.Text object.
	 *
	 * @private
	 * @param {PIXI.WebGLRenderer|PIXI.CanvasPrepare} helper - Not used by this upload handler
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function calculateTextStyle(helper, item) {
	    if (item instanceof core.TextStyle) {
	        var font = item.toFontString();
	
	        core.TextMetrics.measureFont(font);
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to find Text objects.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Text object was found.
	 */
	function findText(item, queue) {
	    if (item instanceof core.Text) {
	        // push the text style to prepare it - this can be really expensive
	        if (queue.indexOf(item.style) === -1) {
	            queue.push(item.style);
	        }
	        // also push the text object so that we can render it (to canvas/texture) if needed
	        if (queue.indexOf(item) === -1) {
	            queue.push(item);
	        }
	        // also push the Text's texture for upload to GPU
	        var texture = item._texture.baseTexture;
	
	        if (queue.indexOf(texture) === -1) {
	            queue.push(texture);
	        }
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to find TextStyle objects.
	 *
	 * @private
	 * @param {PIXI.TextStyle} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.TextStyle object was found.
	 */
	function findTextStyle(item, queue) {
	    if (item instanceof core.TextStyle) {
	        if (queue.indexOf(item) === -1) {
	            queue.push(item);
	        }
	
	        return true;
	    }
	
	    return false;
	}
	//# sourceMappingURL=BasePrepare.js.map

/***/ }),
/* 383 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * CountLimiter limits the number of items handled by a {@link PIXI.prepare.BasePrepare} to a specified
	 * number of items per frame.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CountLimiter = function () {
	  /**
	   * @param {number} maxItemsPerFrame - The maximum number of items that can be prepared each frame.
	   */
	  function CountLimiter(maxItemsPerFrame) {
	    _classCallCheck(this, CountLimiter);
	
	    /**
	     * The maximum number of items that can be prepared each frame.
	     * @private
	     */
	    this.maxItemsPerFrame = maxItemsPerFrame;
	    /**
	     * The number of items that can be prepared in the current frame.
	     * @type {number}
	     * @private
	     */
	    this.itemsLeft = 0;
	  }
	
	  /**
	   * Resets any counting properties to start fresh on a new frame.
	   */
	
	
	  CountLimiter.prototype.beginFrame = function beginFrame() {
	    this.itemsLeft = this.maxItemsPerFrame;
	  };
	
	  /**
	   * Checks to see if another item can be uploaded. This should only be called once per item.
	   * @return {boolean} If the item is allowed to be uploaded.
	   */
	
	
	  CountLimiter.prototype.allowedToUpload = function allowedToUpload() {
	    return this.itemsLeft-- > 0;
	  };
	
	  return CountLimiter;
	}();
	
	exports.default = CountLimiter;
	//# sourceMappingURL=CountLimiter.js.map

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(204);
	
	var core = _interopRequireWildcard(_core);
	
	var _BasePrepare2 = __webpack_require__(382);
	
	var _BasePrepare3 = _interopRequireDefault(_BasePrepare2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CANVAS_START_SIZE = 16;
	
	/**
	 * The prepare manager provides functionality to upload content to the GPU
	 * This cannot be done directly for Canvas like in WebGL, but the effect can be achieved by drawing
	 * textures to an offline canvas.
	 * This draw call will force the texture to be moved onto the GPU.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.prepare
	 *
	 * @class
	 * @extends PIXI.prepare.BasePrepare
	 * @memberof PIXI.prepare
	 */
	
	var CanvasPrepare = function (_BasePrepare) {
	    _inherits(CanvasPrepare, _BasePrepare);
	
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
	     */
	    function CanvasPrepare(renderer) {
	        _classCallCheck(this, CanvasPrepare);
	
	        var _this = _possibleConstructorReturn(this, _BasePrepare.call(this, renderer));
	
	        _this.uploadHookHelper = _this;
	
	        /**
	        * An offline canvas to render textures to
	        * @type {HTMLCanvasElement}
	        * @private
	        */
	        _this.canvas = document.createElement('canvas');
	        _this.canvas.width = CANVAS_START_SIZE;
	        _this.canvas.height = CANVAS_START_SIZE;
	
	        /**
	         * The context to the canvas
	        * @type {CanvasRenderingContext2D}
	        * @private
	        */
	        _this.ctx = _this.canvas.getContext('2d');
	
	        // Add textures to upload
	        _this.registerUploadHook(uploadBaseTextures);
	        return _this;
	    }
	
	    /**
	     * Destroys the plugin, don't use after this.
	     *
	     */
	
	
	    CanvasPrepare.prototype.destroy = function destroy() {
	        _BasePrepare.prototype.destroy.call(this);
	        this.ctx = null;
	        this.canvas = null;
	    };
	
	    return CanvasPrepare;
	}(_BasePrepare3.default);
	
	/**
	 * Built-in hook to upload PIXI.Texture objects to the GPU.
	 *
	 * @private
	 * @param {*} prepare - Instance of CanvasPrepare
	 * @param {*} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	
	
	exports.default = CanvasPrepare;
	function uploadBaseTextures(prepare, item) {
	    if (item instanceof core.BaseTexture) {
	        var image = item.source;
	
	        // Sometimes images (like atlas images) report a size of zero, causing errors on windows phone.
	        // So if the width or height is equal to zero then use the canvas size
	        // Otherwise use whatever is smaller, the image dimensions or the canvas dimensions.
	        var imageWidth = image.width === 0 ? prepare.canvas.width : Math.min(prepare.canvas.width, image.width);
	        var imageHeight = image.height === 0 ? prepare.canvas.height : Math.min(prepare.canvas.height, image.height);
	
	        // Only a small subsections is required to be drawn to have the whole texture uploaded to the GPU
	        // A smaller draw can be faster.
	        prepare.ctx.drawImage(image, 0, 0, imageWidth, imageHeight, 0, 0, prepare.canvas.width, prepare.canvas.height);
	
	        return true;
	    }
	
	    return false;
	}
	
	core.CanvasRenderer.registerPlugin('prepare', CanvasPrepare);
	//# sourceMappingURL=CanvasPrepare.js.map

/***/ }),
/* 385 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * TimeLimiter limits the number of items handled by a {@link PIXI.BasePrepare} to a specified
	 * number of milliseconds per frame.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TimeLimiter = function () {
	  /**
	   * @param {number} maxMilliseconds - The maximum milliseconds that can be spent preparing items each frame.
	   */
	  function TimeLimiter(maxMilliseconds) {
	    _classCallCheck(this, TimeLimiter);
	
	    /**
	     * The maximum milliseconds that can be spent preparing items each frame.
	     * @private
	     */
	    this.maxMilliseconds = maxMilliseconds;
	    /**
	     * The start time of the current frame.
	     * @type {number}
	     * @private
	     */
	    this.frameStart = 0;
	  }
	
	  /**
	   * Resets any counting properties to start fresh on a new frame.
	   */
	
	
	  TimeLimiter.prototype.beginFrame = function beginFrame() {
	    this.frameStart = Date.now();
	  };
	
	  /**
	   * Checks to see if another item can be uploaded. This should only be called once per item.
	   * @return {boolean} If the item is allowed to be uploaded.
	   */
	
	
	  TimeLimiter.prototype.allowedToUpload = function allowedToUpload() {
	    return Date.now() - this.frameStart < this.maxMilliseconds;
	  };
	
	  return TimeLimiter;
	}();
	
	exports.default = TimeLimiter;
	//# sourceMappingURL=TimeLimiter.js.map

/***/ }),
/* 386 */
/***/ (function(module, exports) {

	module.exports = {"frames":{"heart0.png":{"frame":{"x":0,"y":0,"w":24,"h":22},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":24,"h":22},"sourceSize":{"w":24,"h":22}},"heart1.png":{"frame":{"x":24,"y":0,"w":24,"h":22},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":24,"h":22},"sourceSize":{"w":24,"h":22}},"heart2.png":{"frame":{"x":48,"y":0,"w":24,"h":22},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":24,"h":22},"sourceSize":{"w":24,"h":22}},"heart3.png":{"frame":{"x":72,"y":0,"w":24,"h":22},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":24,"h":22},"sourceSize":{"w":24,"h":22}},"heart4.png":{"frame":{"x":96,"y":0,"w":24,"h":22},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":24,"h":22},"sourceSize":{"w":24,"h":22}},"heart5.png":{"frame":{"x":120,"y":0,"w":24,"h":22},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":24,"h":22},"sourceSize":{"w":24,"h":22}}},"meta":{"app":"http://www.codeandweb.com/texturepacker","version":"1.0","image":"//p3.ifengimg.com/a/2019/0702/heart.png","format":"RGBA8888","size":{"w":144,"h":22},"scale":"1","smartupdate":"$TexturePacker:SmartUpdate:370d42674aa9df86b03938b376df50ee:cd254b405b45ee24d9009a93c8f9818e:cb39580ce6d86b4835ef90f0a2df983e$"}}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	module.exports = {"frames":{"heart0.png":{"frame":{"x":0,"y":0,"w":40,"h":36},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":40,"h":36},"sourceSize":{"w":40,"h":36}},"heart1.png":{"frame":{"x":40,"y":0,"w":40,"h":36},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":40,"h":36},"sourceSize":{"w":40,"h":36}},"heart2.png":{"frame":{"x":80,"y":0,"w":40,"h":36},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":40,"h":36},"sourceSize":{"w":40,"h":36}},"heart3.png":{"frame":{"x":120,"y":0,"w":40,"h":36},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":40,"h":36},"sourceSize":{"w":40,"h":36}},"heart4.png":{"frame":{"x":160,"y":0,"w":40,"h":36},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":40,"h":36},"sourceSize":{"w":40,"h":36}},"heart5.png":{"frame":{"x":200,"y":0,"w":40,"h":36},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":40,"h":36},"sourceSize":{"w":40,"h":36}}},"meta":{"app":"http://www.codeandweb.com/texturepacker","version":"1.0","image":"//p2.ifengimg.com/a/2017/0313/heart.png","format":"RGBA8888","size":{"w":240,"h":36},"scale":"1","smartupdate":"$TexturePacker:SmartUpdate:370d42674aa9df86b03938b376df50ee:cd254b405b45ee24d9009a93c8f9818e:cb39580ce6d86b4835ef90f0a2df983e$"}}

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	module.exports = {"frames":{"heart0.png":{"frame":{"x":0,"y":0,"w":22,"h":61},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":22,"h":61},"sourceSize":{"w":40,"h":100}},"heart1.png":{"frame":{"x":0,"y":0,"w":22,"h":61},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":22,"h":61},"sourceSize":{"w":40,"h":100}},"heart2.png":{"frame":{"x":0,"y":0,"w":22,"h":61},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":22,"h":61},"sourceSize":{"w":40,"h":100}},"heart3.png":{"frame":{"x":0,"y":0,"w":22,"h":61},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":22,"h":61},"sourceSize":{"w":40,"h":100}},"heart4.png":{"frame":{"x":0,"y":0,"w":22,"h":61},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":22,"h":61},"sourceSize":{"w":40,"h":100}},"heart5.png":{"frame":{"x":0,"y":0,"w":22,"h":61},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":22,"h":61},"sourceSize":{"w":40,"h":100}}},"meta":{"app":"http://www.codeandweb.com/texturepacker","version":"1.0","image":"//p0.ifengimg.com/a/2018/1102/img_lazhu.png","format":"RGBA8888","size":{"w":240,"h":61},"scale":"1","smartupdate":"$TexturePacker:SmartUpdate:370d42674aa9df86b03938b376df50ee:cd254b405b45ee24d9009a93c8f9818e:cb39580ce6d86b4835ef90f0a2df983e$"}}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	module.exports = {"frames":{"heart0.png":{"frame":{"x":0,"y":0,"w":105,"h":105},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":105,"h":105},"sourceSize":{"w":105,"h":105}},"heart1.png":{"frame":{"x":0,"y":0,"w":105,"h":105},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":105,"h":105},"sourceSize":{"w":105,"h":105}},"heart2.png":{"frame":{"x":0,"y":0,"w":105,"h":105},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":105,"h":105},"sourceSize":{"w":105,"h":105}},"heart3.png":{"frame":{"x":0,"y":0,"w":105,"h":105},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":105,"h":105},"sourceSize":{"w":105,"h":105}},"heart4.png":{"frame":{"x":0,"y":0,"w":105,"h":105},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":105,"h":105},"sourceSize":{"w":105,"h":105}},"heart5.png":{"frame":{"x":0,"y":0,"w":105,"h":105},"rotated":false,"trimmed":false,"spriteSourceSize":{"x":0,"y":0,"w":105,"h":105},"sourceSize":{"w":105,"h":105}}},"meta":{"app":"http://www.codeandweb.com/texturepacker","version":"1.0","image":"//x0.ifengimg.com/cmpp/2020/0119/36dd927af842774size4_w105_h105.png","format":"RGBA8888","size":{"w":35,"h":35},"scale":"1.3","smartupdate":"$TexturePacker:SmartUpdate:370d42674aa9df86b03938b376df50ee:cd254b405b45ee24d9009a93c8f9818e:cb39580ce6d86b4835ef90f0a2df983e$"}}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _fComponent = __webpack_require__(103);
	
	var _fComponent2 = _interopRequireDefault(_fComponent);
	
	__webpack_require__(391);
	
	var _cart = __webpack_require__(394);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShoppingCart = function () {
	  function ShoppingCart(container, options) {
	    (0, _classCallCheck3.default)(this, ShoppingCart);
	
	    this.container = container;
	    this.options = options;
	    this.init();
	  }
	
	  (0, _createClass3.default)(ShoppingCart, [{
	    key: "init",
	    value: function init() {
	      this.cartIcon = $((0, _cart2.default)());
	      this.container.append(this.cartIcon);
	      this.initEvent();
	    }
	  }, {
	    key: "initEvent",
	    value: function initEvent() {
	      var _this = this;
	      this.cartIcon.on("click", function (e) {
	        // 是否为横屏状态
	        var zoomState = $(document.body).hasClass("horizontal");
	        if (zoomState && _fComponent2.default.isApp) {
	          _fComponent2.default.rotate(0);
	        }
	
	        if (_this.options.url) {
	          window.open(_this.options.url);
	        }
	      });
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.cartIcon.animate({ opacity: "1" });
	      this.cartIcon.show();
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.cartIcon.animate({ opacity: "0" });
	      this.cartIcon.hide();
	    }
	  }]);
	  return ShoppingCart;
	}(); /* eslint-disable */
	
	
	exports.default = ShoppingCart;

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */,
/* 393 */,
/* 394 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"cart-box\">\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var pagelist = __webpack_require__(396);
	
	module.exports = pagelist;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(397);
	__webpack_require__(399);
	var util = __webpack_require__(403);
	
	var mobileUtil = __webpack_require__(404);
	
	var Events = __webpack_require__(104);
	
	var DataCenter = __webpack_require__(405);
	
	var newsItem = __webpack_require__(406);
	var Audio = __webpack_require__(407);
	var Pic = __webpack_require__(415);
	var Video = __webpack_require__(432).listVideo;
	var Skeleton = __webpack_require__(500);
	
	var topMid = null;
	// 时间分割线
	var lastItemDate = null; // 最后一个比对的时间
	
	var getVideoInfo = function getVideoInfo(options) {
	    if (options.from && options.from === 'ugc') {
	        // console.log('getVideoInfo:ugc');
	        // 请求ugc 的视频接口 // ugc 赵璐/于老师
	        var msg = options.ugcuid + '@' + options.video_id;
	        return $.ajax({
	            url: '//api.cmpp.v.ifeng.com/index.php/live/video',
	            dataType: 'jsonp',
	            data: {
	                msg: msg,
	                rt: 'js',
	                param: 'playermsg'
	            }
	        });
	    } else {
	        // console.log('getVideoInfo:mengshuai');
	        // 姣艳/孟帅
	        var id = options.video_id.split('-')[0]; // 防止间隔号-导致请求报错
	        return $.ajax({
	            url: '//tv.ifeng.com/h6/' + id + '__callback' + id + '_/video.json',
	            type: 'get',
	            jsonpCallback: 'callback' + id,
	            dataType: 'jsonp'
	        });
	    }
	};
	var antiTheftChain = function antiTheftChain(data) {
	    var settings = data; // Object.assign(gloableSettings, data);
	    var _obj = {
	        videoinfo: settings,
	        __gid: window.createGid(),
	        version: 'izhiboHTML5Player_v1.0.0',
	        from: 'izhibo_h5'
	    };
	    // 生成防盗链
	    var antiTheftUrl = antiTheft(_obj);
	    return antiTheftUrl;
	};
	
	var LivePage = function LivePage(options, native) {
	    console.log('livepage=======>', options);
	    this.native = native;
	    this.orignalScrollTop = 0;
	    this.touchStartY = 0;
	    this.touchEndY = 0;
	    this.shrinkTimer = null;
	    this.init(options);
	};
	
	LivePage.prototype.init = function (options) {
	    this.options = options;
	    this.dataCenter = new DataCenter(options);
	    this.resolveTemplate();
	    this.bindDomEvent();
	    this.bindDataEvent();
	};
	
	LivePage.prototype.stop = function () {
	    this.dataCenter.stop();
	};
	
	LivePage.prototype.pause = function () {
	    this.isnotice = true;
	};
	
	LivePage.prototype.play = function () {
	    this.isnotice = false;
	};
	
	LivePage.prototype.start = function () {
	    this.dataCenter.start();
	};
	
	LivePage.prototype.bindDataEvent = function () {
	    // 初始化渲染
	    var _self = this;
	
	    // 置顶消息，推送消息
	    this.dataCenter.on('top', function (item, hasUpdate) {
	        console.log(hasUpdate);
	        if (_self.isnotice && hasUpdate) {
	            _self.trigger('newMessage');
	        }
	
	        _self.renderTop($('.js_timelineTop'), item);
	    });
	
	    // 当数据的发生变化时监控，items push的数据，绘制数据
	    this.dataCenter.on('tail', function (items, hasUpdate) {
	        if (_self.isnotice && hasUpdate) {
	            console.log('hasUpdate:' + hasUpdate);
	            _self.trigger('newMessage');
	        }
	        _self.renderItems($('.js_timelineContainer'), items, false);
	    });
	
	    // 当数据的发生变化时监控，items push的数据，绘制数据
	    this.dataCenter.on('head', function (items, hasUpdate) {
	        if (_self.isnotice && hasUpdate) {
	            console.log('hasUpdate:' + hasUpdate);
	            _self.trigger('newMessage');
	        }
	        _self.renderItems($('.js_timelineContainer'), items, true);
	    });
	
	    // 清空数据
	    this.dataCenter.on('clear', function () {
	        _self.clearItem($('.js_timelineContainer'));
	    });
	
	    mobileUtil.tap(this.container[0], function (e) {
	        if (e.target.classList.contains('detail_url')) {
	            var link = e.target.dataset.link.replace(/^\s+|\s+$/g, '');
	            if (_self.native.isApp) {
	                _self.native.openWeb(link, true);
	            } else {
	                window.open(link);
	            }
	        }
	    });
	};
	
	LivePage.prototype.resolveTemplate = function () {
	    var pageHtml = Skeleton();
	    this.container = $(pageHtml);
	    this.ownerNode = this.container;
	};
	
	// //绑定元素中的代理事件
	LivePage.prototype.bindDomEvent = function () {
	    var _self = this;
	
	    $(this.container).find('.mod-loading').hide();
	    // 显示更多
	    var isLoading = false;
	    var self = this;
	
	    this.container[0].addEventListener('touchstart', function () {
	        if (this.scrollTop === 0) {
	            this.scrollTop = 1; // 防止拖动全页面
	        }
	    });
	
	    var handleScrollDirect = function handleScrollDirect(direction, listScrollTop) {
	        _self.trigger('shrink', { direct: direction, topDistance: listScrollTop });
	    };
	
	    this.container[0].addEventListener('scroll', function () {
	        var scrollTop = this.scrollTop;
	        if (isLoading) {
	            return;
	        }
	        var elItems = $(this).find('.mod-newsList-box')[0];
	        var wrapH = elItems.offsetHeight;
	        var winH = this.offsetHeight;
	        if (wrapH - scrollTop <= winH + 10) {
	            isLoading = true;
	            console.log('isLoading : ' + isLoading);
	            $(this).find('.mod-loading').show();
	            _self.dataCenter.requestMore(function () {
	                $(self).find('.mod-loading').hide();
	                isLoading = false;
	            });
	        }
	    });
	
	    this.container[0].addEventListener('touchstart', function (e) {
	        _self.touchStartY = e.touches[0].pageY;
	    });
	
	    this.container[0].addEventListener('touchmove', function (e) {
	        var _thisContainer = this;
	        _self.shrinkTimer = setTimeout(function () {
	            _self.touchEndY = e.changedTouches[0].pageY;
	            var delta = _self.touchEndY - _self.touchStartY;
	            if (delta < 0) {
	                handleScrollDirect('down', _thisContainer.scrollTop);
	            } else {
	                handleScrollDirect('up', _thisContainer.scrollTop);
	            }
	        }, 100);
	    });
	};
	
	// ============================ 页面渲染方法
	/**
	 * 重画置顶
	 * @param itemData 置顶数据
	 * @param isTop 是否置顶
	 */
	LivePage.prototype.renderTop = function (container, itemData) {
	    var curDate = new Date();
	    var year = curDate.getFullYear();
	    var month = curDate.getMonth() + 1;
	    var date = curDate.getDate();
	    var curDateStr = year + '-' + ((month + '').length == 1 ? '0' + month : month) + '-' + ((date + '').length == 1 ? '0' + date : date);
	    var dateStr = util.getDate(itemData.ctime);
	    topMid = itemData.mid;
	    itemData.isTop = true;
	    itemData.isAd = false;
	    itemData.abstract1 = itemData.abstract;
	    // 头条添加推广位
	    if (itemData.important && itemData.isTop) {
	        itemData.covertime = '推广';
	        itemData.isAd = true;
	    } else {
	        itemData.covertime = util.timeHandle(itemData.ctime);
	    }
	
	    itemData.daytime = util.timeHandleDay(itemData.ctime);
	    itemData.hasRelyContent = itemData.quote_message.length > 0;
	    itemData.hasContent = typeof itemData.abstract !== 'undefined' && itemData.abstract != '';
	    itemData.uid = itemData.ugcuid;
	    itemData.converVedioImage = this.replaceImgServer(itemData.video_image);
	    if ((typeof lastItemDate === 'undefined' || dateStr != lastItemDate) && dateStr != curDateStr) {
	        console.log(lastItemDate);
	        console.log(dateStr);
	        itemData.dateStr = dateStr;
	        lastItemDate = dateStr;
	    }
	    var html = newsItem({ items: [itemData] });
	    container.empty();
	    container.append(html);
	    var contentNode = container.find('.news-con')[0];
	    this.renderComponents(contentNode, itemData);
	};
	
	/**
	 * 清空列表
	 */
	LivePage.prototype.clearItem = function (container) {
	    container.empty();
	    $('.mod-showMoreBtn').show();
	};
	
	/**
	 * 绘制更新的内容
	 * @param {Object}container 需要绘制的容器
	 * @param {Array}items 需要绘制的数据
	 * @param {boolean}ishead  是否是头部添加
	 */
	LivePage.prototype.renderItems = function (container, items, ishead) {
	    var contentNode = void 0;
	    var curlength = container.find('.news-con').length;
	
	    var curDate = new Date();
	    var year = curDate.getFullYear();
	    var month = curDate.getMonth() + 1;
	    var date = curDate.getDate();
	    var curDateStr = year + '-' + ((month + '').length == 1 ? '0' + month : month) + '-' + ((date + '').length == 1 ? '0' + date : date);
	    var temp = [];
	    for (var i = 0; i < items.length; i++) {
	        var dateStr = util.getDate(items[i].ctime);
	        // 排除头条
	        if (items[i].mid === topMid) {
	            continue;
	        }
	        // 显示头条
	        // if(items[i].mid === topMid) {
	        //     items[i].dateStr = null;
	        // }
	        items[i].isTop = false;
	        items[i].abstract1 = items[i].abstract;
	        items[i].covertime = util.timeHandle(items[i].ctime);
	        items[i].daytime = util.timeHandleDay(items[i].ctime);
	        items[i].hasRelyContent = items[i].quote_message.length > 0;
	        items[i].hasContent = typeof items[i].abstract !== 'undefined' && items[i].abstract != '';
	        items[i].uid = items[i].ugcuid;
	
	        if (items[i].hasRelyContent) {
	            items[i].quote_message[0].converImage = this.replaceImgServer(items[i].quote_message[0].image);
	            items[i].quote_message[0].coverCtime = util.timeHandleNosecond(items[i].quote_message[0].ctime);
	        }
	        items[i].converVedioImage = this.replaceImgServer(items[i].video_image);
	        if (ishead) {
	            items[i].isTop = false;
	            items[i].ishead = true;
	        }
	
	        if ((typeof lastItemDate === 'undefined' || dateStr != lastItemDate) && dateStr != curDateStr) {
	            items[i].dateStr = dateStr;
	            lastItemDate = dateStr;
	        }
	        var ItemDom = $(newsItem({ items: [items[i]] }));
	        contentNode = ItemDom.find('.news-con')[0];
	
	        this.renderComponents(contentNode, items[i]);
	
	        if (ishead) {
	            container.children().first().before(ItemDom);
	        } else {
	            container.append(ItemDom);
	        }
	    }
	};
	
	LivePage.prototype.renderComponents = function (contentNode, item) {
	    var picHtml = void 0,
	        picData = void 0,
	        audioData = void 0,
	        audioHtml = void 0,
	        videoData = void 0,
	        videoHtml = void 0;
	    if (item.pictures && item.pictures.length > 0) {
	        picData = {
	            pictures: item.pictures,
	            mid: item.mid
	        };
	        new Pic(contentNode, picData);
	        // picHtml.renderTo(contentNode);
	    }
	    if (item.audio_url) {
	        audioData = {
	            audio_url: item.audio_url,
	            audio_id: item.audio_id,
	            audio_duration: item.audio_duration
	        };
	        audioHtml = new Audio(audioData);
	        audioHtml.renderTo(contentNode);
	    }
	
	    if (item.video_id) {
	        var id = item.video_id;
	        _promise2.default.resolve().then(function () {
	            return getVideoInfo(item);
	        }).then(function (data) {
	            // console.log('promise==', data);
	            var videoUrl = item.video_url;
	            if (data) {
	                // 不是金山
	                data.vid = id;
	                videoUrl += antiTheftChain(data) ? '?' + antiTheftChain(data) : '';
	            }
	            // console.log('videoUrl===', videoUrl);
	            videoData = {
	                from: 'pomp',
	                uid: item.uid,
	                mid: item.mid,
	                video_url: videoUrl,
	                video_image: item.video_image,
	                isTop: item.isTop,
	                swfUrl: '//vxml.ifengimg.com/swf/zuhe/zuhePlayer_v1.0.47.swf',
	                AutoPlay: true
	            };
	            videoHtml = new Video(videoData);
	            console.log(videoHtml);
	            videoHtml.renderTo(contentNode);
	        });
	    }
	};
	
	LivePage.prototype.replaceImgServer = function (imageAddr) {
	    if (imageAddr === '') return '';
	    return this.options.imageServer + '/' + this.options.imageRatio + '/' + imageAddr.replace(/http[s]?:\/\//, '');
	};
	
	LivePage.prototype.renderTo = function (parentNode) {
	    this.parentNode = parentNode;
	    parentNode.appendChild(this.container[0]);
	};
	
	Events.mixTo(LivePage);
	
	module.exports = LivePage;

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */,
/* 399 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */
/***/ (function(module, exports) {

	'use strict';
	
	// 时间格式化
	var util = {
	    timeHandle: function timeHandle(time) {
	        try {
	            var hmsStr = time.split(' ')[1];
	            var hmsArr = hmsStr.split(':');
	            hmsArr.length = 2;
	            return hmsArr.join(':');
	        } catch (e) {
	            return time;
	        }
	    },
	    timeHandleNosecond: function timeHandleNosecond(time) {
	        try {
	            return time.substring(0, time.lastIndexOf(':'));
	        } catch (e) {
	            return time;
	        }
	    },
	    timeHandleDay: function timeHandleDay(time) {
	        try {
	            return time.substring(0, time.lastIndexOf(' '));
	        } catch (e) {
	            return time;
	        }
	    },
	    getDate: function getDate(time) {
	        return time.split(' ')[0].split('-').join('-');
	    },
	    handlesSroll: function handlesSroll(ele) {
	        console.log(ele);
	        if (ele.pageYOffset !== null) {
	            // 支持IE9 +
	            return {
	                left: ele.pageXOffset,
	                top: ele.pageYOffset
	            };
	        } else if (ele.compatMode === 'CSS1Compat') {
	            return {
	                left: ele.documentElement.scrollLeft,
	                top: ele.documentElement.scrollTop
	            };
	        }
	        return {
	            left: ele.scrollLeft,
	            top: ele.scrollTop
	        };
	    }
	};
	
	module.exports = util;

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	'use strict';
	
	var win = window;
	var doc = document;
	var TOUCH_START = 'ontouchstart' in win ? 'touchstart' : 'mousedown';
	var TOUCH_MOVE = 'ontouchmove' in win ? 'touchmove' : 'mousemove';
	var TOUCH_END = 'ontouchend' in win ? 'touchend' : 'mouseup';
	var emptyFn = function emptyFn() {};
	
	/***************** core **************/
	
	// 判断是否为类数组或者数组
	var obj = {};
	var isArray = function isArray(item) {
	  return obj.toString.call(item) === '[object Array]' || item.length >= 0 && typeof item[0] !== 'undefined' && typeof item[item.length - 1] !== 'undefined';
	};
	
	var each = function each(collection, callback, scope) {
	  for (var i = 0, iLen = collection.length; i < iLen; i++) {
	    callback.call(scope || collection[i], i, collection[i]);
	  }
	};
	
	var extend = function extend() {
	  var o = {};
	  var obj;
	  var key;
	  for (var i = 0, iLen = arguments.length; i < iLen; i++) {
	    obj = arguments[i];
	    for (key in obj) {
	      o[key] = obj[key];
	    }
	  }
	  return o;
	};
	
	/***************** selecter query **************/
	
	// 获取dom列表
	var query = function query(selector, context) {
	  context = context || doc;
	
	  if (selector === window || selector === document || selector && typeof selector.nodeType != 'undefined') {
	    return [selector];
	  }
	
	  if (typeof selector === 'string') {
	    return context.querySelectorAll(selector);
	  } else if (isArray(selector)) {
	    return selector;
	  } else {
	    return [selector];
	  }
	};
	
	/***************** dom operation **************/
	
	// 插入dom元素
	var append = function append(elm, appendElm) {
	  elm.appendChild(appendElm);
	};
	
	var html = function html(selector, content) {
	  var elms = query(selector);
	  each(elms, function () {
	    this.innerHTML = content;
	  });
	};
	
	/***************** css operation **************/
	
	var hasClass = function hasClass(selector, className) {
	  var elm = query(selector)[0];
	  return hasClassSingle(elm, className);
	};
	
	var addClass = function addClass(selector, className) {
	  var elms = query(selector);
	  each(elms, function () {
	    addClassSingle(this, className);
	  });
	};
	
	var removeClass = function removeClass(selector, className) {
	  var elms = query(selector);
	  each(elms, function () {
	    removeClassSingle(this, className);
	  });
	};
	
	var hasClassSingle = function hasClassSingle(elm, className) {
	  var fullClassName = ' ' + elm.className + ' ';
	  return fullClassName.indexOf(' ' + className + ' ') >= 0;
	};
	
	var addClassSingle = function addClassSingle(elm, className) {
	  if (!hasClassSingle(elm, className)) {
	    elm.className = elm.className + ' ' + className;
	  }
	};
	
	var removeClassSingle = function removeClassSingle(elm, className) {
	  var re = new RegExp('(^|\\s)' + className + '(\\s|$)', 'g');
	  if (hasClassSingle(elm, className)) {
	    elm.className = elm.className.replace(re, ' ');
	  }
	};
	
	var css = function css(selector, opts) {
	  var elms = query(selector);
	  each(elms, function () {
	    cssSingle(this, opts);
	  });
	};
	
	var cssSingle = function cssSingle(elm, opts) {
	  for (var key in opts) {
	    elm.style[key] = opts[key];
	  }
	};
	
	/***************** events **************/
	
	// 注册一个事件
	var on = function on(selector, type, callback, opts, forControllBar) {
	  var elms = query(selector);
	
	  each(elms, function () {
	    if (forControllBar) {
	      oneControll(this, type, callback, opts);
	    } else {
	      one(this, type, callback, opts);
	    }
	  });
	};
	
	// 为一个dom元素注册一个事件
	var one = function one(elm, type, callback, opts) {
	  opts = opts || {};
	  elm.addEventListener(type, function (e) {
	
	    var delegateElm;
	    if (typeof opts.delegate !== 'undefined') {
	      delegateElm = getDelegate(elm, opts.delegate, e.target);
	    }
	
	    // 没找到匹配的代理元素，不执行下面的事件
	    if (typeof opts.delegate !== 'undefined' && typeof delegateElm === 'undefined') {
	      return;
	    }
	
	    var scope = opts.scope || delegateElm || elm;
	
	    callback.call(scope, e, delegateElm || elm);
	  }, false);
	};
	
	// 兼容ios端滑动事件冒泡
	var oneControll = function oneControll(elm, type, callback, opts) {
	  opts = opts || {};
	  elm.addEventListener(type, function (e) {
	    e.preventDefault();
	    var delegateElm;
	    if (typeof opts.delegate !== 'undefined') {
	      delegateElm = getDelegate(elm, opts.delegate, e.target);
	    }
	
	    // 没找到匹配的代理元素，不执行下面的事件
	    if (typeof opts.delegate !== 'undefined' && typeof delegateElm === 'undefined') {
	      return;
	    }
	
	    var scope = opts.scope || delegateElm || elm;
	
	    callback.call(scope, e, delegateElm || elm);
	  }, false);
	};
	
	// 获取正确的代理元素
	var getDelegate = function getDelegate(elm, delegate, target) {
	  var matchs;
	  var i;
	
	  if (typeof delegate !== 'string') {
	    matchs = [delegate];
	  } else {
	    matchs = elm.querySelectorAll(delegate);
	  }
	
	  var iLen = matchs.length;
	  while (elm !== target) {
	    for (i = 0; i < iLen; i++) {
	      if (target === matchs[i]) {
	        return target;
	      }
	    }
	    target = target.parentNode;
	  }
	};
	
	// 轻触屏幕
	var tap = function tap(elm, callback, opts) {
	  opts = opts || {};
	  var duration = opts.duration || 0;
	  var fixDistance = opts.fixDistance || 10;
	  var time;
	  var pageX;
	  var pageY;
	
	  on(elm, TOUCH_START, function (e, target) {
	
	    if (typeof opts.hover === 'string') {
	      addClass(target, opts.hover);
	    }
	
	    time = new Date().valueOf();
	    pageX = getEventPageXY(e, 'x');
	    pageY = getEventPageXY(e, 'y');
	  }, opts);
	
	  on(elm, TOUCH_END, function (e, target) {
	    var result = true;
	    var endTime = new Date().valueOf();
	    var endPageX = getEventPageXY(e, 'x', true);
	    var endPageY = getEventPageXY(e, 'y', true);
	
	    if (typeof opts.hover === 'string') {
	      removeClass(target, opts.hover);
	    }
	
	    if (endTime - time > duration && Math.abs(endPageX - pageX) < fixDistance && Math.abs(endPageY - pageY) < fixDistance) {
	      result = callback.call(this, e, target, endPageX, endPageY);
	    }
	
	    if (result === false) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	  }, opts);
	};
	
	// 获取触摸的位置
	var getEventPageXY = function getEventPageXY(e, xy, isEnd) {
	  e = e || window.event;
	  xy = xy === 'x' ? 'pageX' : 'pageY';
	  isEnd = typeof isEnd === 'undefined' ? false : true;
	  var useTouch = 'ontouchstart' in win;
	
	  if (!useTouch) {
	    return e[xy];
	  } else if (isEnd) {
	    return e.changedTouches[0][xy];
	  } else {
	    return e.touches[0][xy];
	  }
	};
	
	// 滑动
	var swip = function swip(elm, startCallback, movCallback, endCallback, opts) {
	  opts = opts || {};
	  var beginX;
	  var beginY;
	  var endX;
	  var endY;
	  var actualDirect = 'unknown';
	  startCallback = startCallback || emptyFn;
	  movCallback = movCallback || emptyFn;
	  endCallback = endCallback || emptyFn;
	
	  on(elm, TOUCH_START, function (e) {
	    actualDirect = 'unknown';
	    beginX = getEventPageXY(e, 'x');
	    beginY = getEventPageXY(e, 'y');
	    startCallback.call(this, beginX, beginY);
	  }, opts);
	
	  on(elm, TOUCH_MOVE, function (e) {
	    var movX = getEventPageXY(e, 'x');
	    var movY = getEventPageXY(e, 'y');
	    var result;
	
	    // 计算一个真实的滑动方向
	    if (actualDirect === 'unknown') {
	
	      if (Math.abs(movX - beginX) > Math.abs(movY - beginY)) {
	        actualDirect = 'horizontal';
	      } else {
	        actualDirect = 'vertical';
	      }
	    }
	
	    // @todo 这块逻辑有点太复杂了，回头需要考虑如何简化。
	    // 考虑的应用场景太多，给搞复杂了。。。
	    if (typeof opts.direct !== 'undefined') {
	
	      if (opts.direct === 'horizontal') {
	        result = movCallback.call(this, beginX, movX, actualDirect);
	      } else {
	        result = movCallback.call(this, beginY, movY, actualDirect);
	      }
	    } else {
	
	      if (actualDirect === 'horizontal') {
	        result = movCallback.call(this, beginX, movX, actualDirect);
	      } else {
	        result = movCallback.call(this, beginY, movY, actualDirect);
	      }
	    }
	
	    if (result === false) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	  }, opts);
	
	  on(elm, TOUCH_END, function (e) {
	    endY = getEventPageXY(e, 'y', true);
	    endX = getEventPageXY(e, 'x', true);
	
	    if (typeof opts.direct !== 'undefined') {
	
	      if (opts.direct === 'horizontal') {
	        endCallback.call(this, beginX, endX, actualDirect);
	      } else {
	        endCallback.call(this, beginY, endY, actualDirect);
	      }
	    } else {
	
	      if (actualDirect === 'horizontal') {
	        endCallback.call(this, beginX, endX, actualDirect);
	      } else {
	        endCallback.call(this, beginY, endY, actualDirect);
	      }
	    }
	  }, opts);
	};
	
	var controllSwip = function controllSwip(elm, startCallback, movCallback, endCallback, opts) {
	  opts = opts || {};
	  var beginX;
	  var beginY;
	  var endX;
	  var endY;
	  var actualDirect = 'unknown';
	  startCallback = startCallback || emptyFn;
	  movCallback = movCallback || emptyFn;
	  endCallback = endCallback || emptyFn;
	
	  on(elm, TOUCH_START, function (e) {
	    actualDirect = 'unknown';
	    beginX = getEventPageXY(e, 'x');
	    beginY = getEventPageXY(e, 'y');
	    startCallback.call(this, beginX, beginY);
	  }, opts, true);
	
	  on(elm, TOUCH_MOVE, function (e) {
	    var movX = getEventPageXY(e, 'x');
	    var movY = getEventPageXY(e, 'y');
	    var result;
	
	    // 计算一个真实的滑动方向
	    if (actualDirect === 'unknown') {
	
	      if (Math.abs(movX - beginX) > Math.abs(movY - beginY)) {
	        actualDirect = 'horizontal';
	      } else {
	        actualDirect = 'vertical';
	      }
	    }
	
	    // @todo 这块逻辑有点太复杂了，回头需要考虑如何简化。
	    // 考虑的应用场景太多，给搞复杂了。。。
	    if (typeof opts.direct !== 'undefined') {
	
	      if (opts.direct === 'horizontal') {
	        result = movCallback.call(this, beginX, movX, actualDirect);
	      } else {
	        result = movCallback.call(this, beginY, movY, actualDirect);
	      }
	    } else {
	
	      if (actualDirect === 'horizontal') {
	        result = movCallback.call(this, beginX, movX, actualDirect);
	      } else {
	        result = movCallback.call(this, beginY, movY, actualDirect);
	      }
	    }
	
	    if (result === false) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	  }, opts, true);
	
	  on(elm, TOUCH_END, function (e) {
	    endY = getEventPageXY(e, 'y', true);
	    endX = getEventPageXY(e, 'x', true);
	
	    if (typeof opts.direct !== 'undefined') {
	
	      if (opts.direct === 'horizontal') {
	        endCallback.call(this, beginX, endX, actualDirect);
	      } else {
	        endCallback.call(this, beginY, endY, actualDirect);
	      }
	    } else {
	
	      if (actualDirect === 'horizontal') {
	        endCallback.call(this, beginX, endX, actualDirect);
	      } else {
	        endCallback.call(this, beginY, endY, actualDirect);
	      }
	    }
	  }, opts, true);
	};
	
	/************** debug **************/
	
	var index = 1;
	var lastLog = '';
	var log = function log() {
	  var logBox = document.getElementById('logBox');
	
	  if (logBox === null) {
	    return;
	  }
	
	  var s = [].join.call(arguments, ',');
	
	  if (s === lastLog) {
	    index++;
	    logBox.innerHTML = logBox.innerHTML.replace(/\(\d+\)$/, '(' + index + ')');
	  } else {
	    lastLog = s;
	    index = 1;
	    logBox.innerHTML = logBox.innerHTML + ' | ' + s + '(1)';
	  }
	};
	
	/************** util **************/
	
	var formatTime = function formatTime(time) {
	  var second = Math.floor([time % 60]);
	  var mintue = Math.floor(time / 60);
	  second = second < 10 ? '0' + second : second;
	  mintue = mintue < 10 ? '0' + mintue : mintue;
	  return mintue + ':' + second;
	};
	
	var device = function () {
	  var ua = navigator.userAgent;
	  var android = ua.match(/(Android)\s+([\d.]+)/);
	  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  var iphone = ua.match(/(iPhone\sOS)\s([\d_]+)/);
	  var wphone = ua.match(/Windows Phone/);
	
	  if (iphone) {
	    return 'iphone';
	  } else if (ipad) {
	    return 'ipad';
	  } else if (android) {
	    return 'android';
	  } else if (wphone) {
	    return 'wphone';
	  }
	  return "other";
	}();
	
	var cookie = {
	  getByEncode: function getByEncode(name) {
	    var arg = name + "=";
	    var alen = arg.length;
	    var clen = doc.cookie.length;
	    var i = 0;
	
	    while (i < clen) {
	      var j = i + alen;
	
	      if (doc.cookie.substring(i, j) === arg) {
	        return function (offset) {
	          var endstr = doc.cookie.indexOf(";", offset);
	
	          if (endstr === -1) {
	            endstr = doc.cookie.length;
	          }
	
	          return decodeURIComponent(doc.cookie.substring(offset, endstr));
	        }(j);
	      }
	
	      i = doc.cookie.indexOf(" ", i) + 1;
	
	      if (i === 0) {
	        break;
	      }
	    }
	    return "";
	  },
	
	  setByEncode: function setByEncode(name, value, params) {
	    var cStrArr = [];
	    cStrArr.push(name + '=' + encodeURIComponent(value));
	
	    if (typeof params === 'undefined') {
	      params = {};
	    }
	
	    if (typeof params.expires !== 'undefined') {
	      var date = new Date();
	      date.setTime(date.getTime() + params.expires * 1000 * 60);
	      cStrArr.push('; expires=' + date.toGMTString());
	    }
	
	    cStrArr.push(typeof params.path !== 'undefined' ? '; path=' + params.path : '');
	    cStrArr.push(typeof params.domain !== 'undefined' ? '; domain=' + params.domain : '');
	    cStrArr.push(typeof params.secure !== 'undefined' ? '; secure' : '');
	
	    document.cookie = cStrArr.join('');
	  }
	};
	
	//随机获取一个uid
	var getRandomUid = function getRandomUid() {
	  var date = new Date().getTime(),
	      uid = '',
	      fn = '',
	      sn = '';
	
	  fn = (Math.random() * 2147483648 | 0).toString(36);
	  sn = Math.round(Math.random() * 10000);
	  uid = date + '_' + fn + sn;
	  return uid;
	};
	
	module.exports = {
	  append: append,
	  query: query,
	  hasClass: hasClass,
	  addClass: addClass,
	  css: css,
	  removeClass: removeClass,
	  on: on,
	  log: log,
	  tap: tap,
	  swip: swip,
	  controllSwip: controllSwip,
	  formatTime: formatTime,
	  html: html,
	  device: device,
	  extend: extend,
	  cookie: cookie,
	  getRandomUid: getRandomUid
	};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by dreamc_t on 2017/3/29.
	 */
	
	var Events = __webpack_require__(104);
	
	var currentStatus = {
	    headPageNo: -1, //最前接收的最后的页号
	    headPageReceiveLength: 0, //最前接收页号接收的最后一条数据mid
	    tailPageNo: 10000000, //数据尾接收的页号
	    tailPageReceiveLength: 0, //数据尾接收的最后一条数据的mid
	    topMid: -1, //最后一次接收的置顶消息
	    update: 0 //最后一次接收新数据的更新时间
	};
	
	var hasUpdate = false; //是否有新数据
	var receivingDatas = {}; //接收中的数据
	var reveiveParam = null; //接收到的元数据对象
	//默认是5秒轮询param一次，该数据会根据查询的接口进行变化,f4与cdn的接口轮询周期不一样
	var interval = -1;
	var itemCache = {}; //item id的缓存列表
	
	var lastUpdateTime = null; //最后一次更新时间
	var receiveLengthReset = false; //是否需要重置，这是为currentStatus.tailPageReceiveLength特殊处理
	var total = 0; //图文直播的总页数
	
	var live_content = {
	    //获取索引文件成功，服务器端回调函数(data:索引文件数据对象)
	    success: function success(data) {
	        reveiveParam = data;
	    },
	    //获取单页数据成功，服务器端回调函数(dataList:单页数据列表 ， pageIndex：文件索引号)
	    singleSuccess: function singleSuccess(dataList, pageIndex) {
	        receivingDatas[pageIndex] = dataList;
	    }
	};
	
	window.live_content = live_content;
	
	var DataCenter = function DataCenter(options) {
	    this.options = options;
	    this.init(options);
	};
	
	DataCenter.prototype.init = function (options) {
	    this.runStatus = 'running'; //运行状态， stop | running
	    this.options = options;
	    this.sortType = 'desc';
	    this.paramError = false; //数据请求异常
	    this.requestParam();
	};
	
	DataCenter.prototype.requestParam = function () {
	    /**
	     *  定时请求param数据，请求最新的索引文件
	     */
	    var _self = this;
	
	    if (!this.paramError) {
	        //如果有异常则调用cdn
	        interval = interval == -1 ? this.options.f4Interval : interval;
	
	        this.request(this.options.f4Addr + this.getParamUrl(), function () {
	            interval = this.options.cdnInterval;
	            this.options.livestatus = 0; //设置为关闭状态
	            this.paramError = true;
	            _self.request(this.options.cdnAddr + this.getParamUrl(), function () {
	                setTimeout(function () {
	                    _self.requestParam(_self.options);
	                }, interval); //TODO 失败后继续查询，失败多次后需要有策略减少y0服务器的请求
	            }, _self.processParamData);
	        }, _self.processParamData);
	    } else {
	        //如果是关闭则直接调用cdn地址
	        interval = interval == -1 ? this.options.cdnInterval : interval;
	        this.request(this.options.cdnAddr + this.getParamUrl(), function () {
	            setTimeout(function () {
	                _self.requestParam(_self.options);
	            }, interval); //TODO 失败后继续查询
	        }, _self.processParamData);
	    }
	};
	
	DataCenter.prototype.request = function (requestUrl, errorFn, sucessFn) {
	    var _self = this;
	    $.getScript(requestUrl).done(function (script, textStatus) {
	        sucessFn.apply(_self);
	    }).fail(function (jqxhr, settings, exception) {
	        errorFn.apply(_self);
	    });
	};
	
	/**
	 * 得到请求的地址
	 */
	DataCenter.prototype.getRequestHostAddr = function () {
	    var host = '';
	
	    host = this.options.livestatus == 1 ? this.options.f4Addr : this.options.cdnAddr;
	
	    return host;
	};
	/*获取最终请求时间间隔*/
	
	DataCenter.prototype.getOrgiInterval = function () {
	    var interval = this.options.livestatus == 1 ? this.options.f4Interval : this.options.cdnInterval;
	    return interval;
	};
	
	/**
	 * 处理请求下来的param数据
	 * @param paramData
	 *        total    有多少个数据文件(多少页)
	 *        status   直播间开启关闭状态，1为开启状态，0为关闭状态
	 *        update   数据更新时间，时间戳。（只在创建消息时修改）
	 *        topMid   置顶消息ID
	 *        topPage  置顶消息所在数据文件页数
	 */
	DataCenter.prototype.processParamData = function () {
	    var _self = this;
	
	    var paramData = reveiveParam;
	    reveiveParam = {};
	    if (paramData.status) {
	        //如果当前是正常状态则重置params的请求路径
	        this.paramError = false;
	    }
	    total = paramData.total; //当前总数页
	    if (currentStatus.update == 0) {
	        //系统初始状态
	        currentStatus.update = paramData.update;
	        var reqPageIndex = []; //请求的数据页面
	        var reqCount = 0;
	
	        /**
	         * 数据请求
	         * @param pageIndex 请求页
	         * @param nextPageFn 当数据不够时下一页的方法
	         * @param pageIndexConditionFn  判断请求页是否超过最大或最小
	         */
	        var req = function req(pageIndex, nextPageFn, pageIndexConditionFn) {
	            _self.requestData(pageIndex, function (pageIndex, dataList) {
	                reqPageIndex.push(pageIndex);
	                reqCount += dataList.length;
	                if (reqCount >= _self.options.reqPageSize || pageIndexConditionFn(pageIndex)) {
	                    //TODO 当升序时不需要
	                    //数据已经获取完毕，记录当前请求状态调用显示
	                    // console.log('currentStatus.tailPageNo : '+ currentStatus.tailPageNo);
	                    _self.tailData(reqPageIndex, _self.options.reqPageSize);
	                    _self.setTimeoutParam();
	                } else {
	                    req(nextPageFn(pageIndex), nextPageFn, pageIndexConditionFn);
	                }
	            });
	        };
	        if (this.sortType == 'asc') {
	            //升序查询
	            req(1, function (pageIndex) {
	                return pageIndex + 1;
	            }, function (pageIndex) {
	                return pageIndex + 1 > total;
	            });
	        } else {
	            //降序查询
	            req(total, function (pageIndex) {
	                return pageIndex - 1;
	            }, function (pageIndex) {
	                return pageIndex - 1 < 1;
	            });
	        }
	        _self.processTop(paramData);
	    } else if (paramData.update > currentStatus.update && this.sortType == 'desc') {
	        //检测到有数据更新，只有时间大于时上次请求才会更新,当升序时不在请求数据
	
	        //console.log('有更新！~');
	        currentStatus.update = paramData.update;
	        var reqPageIndex = []; //请求的数据页面
	        interval = _self.getOrgiInterval();
	        //lostTime = 0;
	        var req = function req(pageIndex, maxTotal) {
	            _self.requestData(pageIndex, function (pageIndex, dataList) {
	                reqPageIndex.push(pageIndex);
	                if (pageIndex + 1 <= maxTotal) {
	                    //继续请求页面
	                    req(pageIndex + 1, maxTotal);
	                } else {
	                    //没有数据需要获取
	                    _self.headData(reqPageIndex, true);
	                    // hasUpdate = false; //数据添加到页面后设置为无数据更新
	                    _self.setTimeoutParam();
	                }
	            });
	        };
	        req(currentStatus.headPageNo, total); //请求数据,从最低开始请求
	        _self.processTop(paramData);
	    } else {
	        //没有数据更新，检查没有更新的时间总量 lostTime > 10 * 60 * 1000 ,
	        var curDate = new Date();
	        if (lastUpdateTime == null) {
	            lastUpdateTime = curDate;
	            // console.log('lastUpdateTime === paramData.update:' + lastUpdateTime === paramData.update);
	        } else {
	            if (curDate.getTime() - lastUpdateTime.getTime() >= _self.options.increaseabelRange && interval < _self.options.updateMaxTime) {
	                interval += _self.options.timeIncrease;
	                lastUpdateTime = curDate;
	            }
	        }
	        this.setTimeoutParam();
	        return;
	    }
	};
	
	DataCenter.prototype.requestMore = function (completeFn) {
	    if (currentStatus.tailPageNo === 0) {
	        return;
	    }
	    var _self = this;
	    var reqPageIndex = []; //请求的数据页面
	    var reqCount = 0;
	
	    var req = function req(pageIndex, nextPageFn, pageIndexConditionFn) {
	        _self.requestData(pageIndex, function (pageIndex, dataList) {
	            reqPageIndex.push(pageIndex);
	            if (currentStatus.tailPageReceiveLength == 0) {
	                currentStatus.tailPageReceiveLength = dataList.length;
	                currentStatus.tailPageNo += 1;
	            }
	            reqCount += currentStatus.tailPageNo == pageIndex ? dataList.length - currentStatus.tailPageReceiveLength : dataList.length;
	            if (reqCount > _self.options.reqPageSize || pageIndexConditionFn(pageIndex)) {
	                // currentStatus.tailPageNo = pageIndex - 1;
	                //数据已经获取完毕，记录当前请求状态调用显示
	
	                _self.tailData(reqPageIndex, _self.options.reqPageSize);
	                if (completeFn) {
	                    completeFn();
	                }
	            } else {
	                req(nextPageFn(pageIndex), nextPageFn, pageIndexConditionFn);
	            }
	        });
	    };
	    if (this.sortType == 'asc') {
	        //升序
	        req(currentStatus.tailPageNo, function (pageIndex) {
	            return pageIndex + 1;
	        }, function (pageIndex) {
	            return pageIndex + 1 > total;
	        });
	    } else {
	        //降序
	        //console.log('currentStatus.tailPageNo : '+ currentStatus.tailPageNo);
	        req(currentStatus.tailPageNo, function (pageIndex) {
	            return pageIndex - 1;
	        }, function (pageIndex) {
	            return pageIndex - 1 < 1;
	        });
	    }
	};
	
	DataCenter.prototype.setTimeoutParam = function () {
	    var _self = this;
	    if (this.runStatus != 'stop') {
	        setTimeout(function () {
	            _self.requestParam();
	        }, interval);
	    }
	};
	
	/*停止请求*/
	
	DataCenter.prototype.stop = function () {
	    this.runStatus = 'stop';
	    // console.log(this.runStatus);
	};
	
	DataCenter.prototype.start = function () {
	    if (this.runStatus == 'stop') {
	        this.runStatus = 'running';
	        this.requestParam();
	    }
	};
	
	DataCenter.prototype.restart = function (sortType) {
	    //清除数据
	    this.sortType = sortType;
	    this.trigger('clear', this.options.itemList);
	    this.stop(); //停止请求数据
	    //重置初始参数
	    //当前数据状态
	    currentStatus = {
	        headPageNo: -1, //最前接收的最后的页号
	        headPageReceiveLength: 0, //最前接收页号接收的最后一条数据mid
	        tailPageNo: 10000000, //数据尾接收的页号
	        tailPageReceiveLength: 0, //数据尾接收的最后一条数据的mid
	        topMid: -1, //最后一次接收的置顶消息
	        update: 0 //最后一次接收新数据的更新时间
	    };
	    hasUpdate = false;
	    receivingDatas = {}; //接收中的数据
	    reveiveParam = null; //接收到的元数据对象
	    //默认是5秒轮询param一次，该数据会根据查询的接口进行变化,f4与cdn的接口轮询周期不一样
	    interval = -1;
	    itemCache = {}; //item id的缓存列表
	    lastUpdateTime = null; //最后一次更新时间
	    receiveLengthReset = false;
	    this.start();
	};
	
	/**
	 * 处理置顶信息，使用jquery getScript方式，得到的数据是reveiveParam
	 * @param paramData 请求数据的元数据
	 */
	DataCenter.prototype.processTop = function (paramData) {
	    //装载指定消息
	    var _self = this;
	    var hostAdd = this.getRequestHostAddr();
	    if (paramData.topMid && paramData.topMid != currentStatus.topMid) {
	        //处理置顶消息
	        $.getScript(hostAdd + _self.getDataUrl(paramData.topPage)).done(function () {
	            var items = receivingDatas[paramData.topPage];
	            if (currentStatus.topMid != '-1') {
	                //非初始化状态
	                var hasUpdateTop = true;
	            } else {
	                var hasUpdateTop = false;
	            }
	
	            for (var i = 0; i < items.length; i++) {
	                if (paramData.topMid == items[i].mid) {
	                    currentStatus.topMid = items[i].mid;
	                    _self.topItem = items[i];
	                    _self.trigger('top', items[i], hasUpdateTop);
	                    break;
	                }
	            }
	        });
	    }
	};
	
	/**
	 * 得到数据
	 * @param pageIndex 数据页号
	 * @param fn  数据返回后的回调函数
	 */
	DataCenter.prototype.requestData = function (pageIndex, fn) {
	    var _self = this;
	    var hostAdd = this.getRequestHostAddr();
	    $.getScript(hostAdd + _self.getDataUrl(pageIndex)).done(function () {
	        fn(pageIndex, receivingDatas[pageIndex]);
	    });
	};
	
	/**
	 * 添加数据到头
	 * @param pageIndexs 添加数据的索引页位置列表
	 */
	DataCenter.prototype.headData = function (pageIndexs, hasUpdate) {
	    var temp = [];
	    for (var i = 0; i < pageIndexs.length; i++) {
	        if (currentStatus.tailPageNo == -1) {
	            currentStatus.tailPageNo = pageIndexs[i]; //如果没有设置tailPageNo则初始化
	        }
	        var items = receivingDatas[pageIndexs[i]];
	        items.sort(function (a, b) {
	            //需要升序
	            return a.mid - b.mid;
	        });
	        for (var j = 0; j < items.length; j++) {
	            var item = items[j];
	            if (!itemCache[item.mid]) {
	                itemCache[item.mid] = true;
	                temp.push(item);
	            }
	        }
	    }
	    if (temp.length > 0) {
	        this.options.itemList.unshift.apply(this.options.itemList, temp);
	        // console.log('hasUpdate:'+hasUpdate);
	        this.trigger('head', temp, hasUpdate);
	    }
	};
	
	/**
	 * 添加数据到尾
	 * @param pageIndexs 添加数据的索引页位置列表
	 * @param showCount  需要显示的数量
	 */
	DataCenter.prototype.tailData = function (pageIndexs, showCount, hasUpdate) {
	    var count = 0;
	    var temp = [];
	    for (var i = 0; i < pageIndexs.length; i++) {
	        var items = receivingDatas[pageIndexs[i]];
	
	        if (currentStatus.headPageNo == -1) {
	            currentStatus.headPageNo = pageIndexs[i]; //如果没有设置headPageNo则初始化
	        }
	
	        if (this.sortType == 'desc') {
	            // console.log('currentStatus.tailPageNo :' + currentStatus.tailPageNo);
	            for (var j = 0; j < items.length; j++) {
	                var item = items[j];
	                // console.log(itemCache);
	                if (count < showCount && ( //总数控制
	                currentStatus.tailPageNo > pageIndexs[i] || pageIndexs[i] == currentStatus.tailPageNo && currentStatus.tailPageReceiveLength < j) && !itemCache[item.mid]) {
	                    currentStatus.tailPageReceiveLength = j;
	                    currentStatus.tailPageNo = pageIndexs[i];
	                    itemCache[item.mid] = true;
	                    temp.push(item);
	                    count++;
	                }
	            }
	            //console.log('currentStatus.tailPageNo :' + currentStatus.tailPageNo);
	            if (currentStatus.tailPageNo == 1 && currentStatus.tailPageReceiveLength + 1 == receivingDatas[1].length) {
	                $('.mod-showMoreBtn').hide();
	            }
	        } else {
	            //升序需要对数据排序
	            if (currentStatus.tailPageNo == 10000000) {
	                currentStatus.tailPageNo = 1;
	            }
	            if (currentStatus.tailPageReceiveLength == 0 && receiveLengthReset == false) {
	                currentStatus.tailPageReceiveLength = items.length;
	                receiveLengthReset = true;
	            }
	            for (var j = items.length - 1; j >= 0; j--) {
	                if (count < showCount && ( //总数控制
	                currentStatus.tailPageNo < pageIndexs[i] || pageIndexs[i] == currentStatus.tailPageNo && currentStatus.tailPageReceiveLength > j)) {
	                    currentStatus.tailPageReceiveLength = j; //当前文件读的位置
	                    currentStatus.tailPageNo = pageIndexs[i];
	                    var item = items[j];
	                    itemCache[item.mid] = true;
	                    temp.push(item);
	                    count++;
	                }
	            }
	        }
	    }
	
	    if (temp.length > 0) {
	        this.options.itemList.push.apply(this.options.itemList, temp);
	
	        this.trigger('tail', temp);
	    }
	};
	
	DataCenter.prototype.replaceImgServer = function (imageAddr) {
	    if (imageAddr == '') return '';
	    return this.options.imageServer + '/' + this.options.imageRatio + '/' + imageAddr.replace(/http[s]?:\/\//, '');
	};
	
	DataCenter.prototype.getParamUrl = function () {
	    return this.options.liveid + '/param.json';
	};
	
	DataCenter.prototype.getDataUrl = function (pageIndex) {
	    return this.options.liveid + '/' + pageIndex + '.json';
	};
	
	Events.mixTo(DataCenter);
	
	module.exports = DataCenter;

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ;  for(var i = 0;i < items.length;i++){ 
	    ; __append("\n<div class=\"mod-box\" data-mid=\"")
	    ; __append(escape(items[i].mid))
	    ; __append("\">\n\n    ")
	    ;  if (items[i].dateStr && !items[i].isTop){ 
	    ; __append("\n    <div class=\"mod-lineTitle\">\n        <h4 class=\"title\">")
	    ; __append(escape(items[i].dateStr))
	    ; __append("</h4>\n    </div>\n    ")
	    ;  } 
	    ; __append("\n\n    <div class=\"mod-news-block clearfix\">\n\n\n        <div class=\"mod-news-time clearfix\">\n            ")
	    ;  if(items[i].isAd){ 
	    ; __append("\n            <div class=\"time fr ad_title\">")
	    ; __append(escape(items[i].covertime))
	    ; __append("</div>\n            ")
	    ;  }else{ 
	    ; __append("\n                 ")
	    ;  if(items[i].isTop) { 
	    ; __append("\n            <span class=\"icon-top\"></span>\n                ")
	    ; }
	    ; __append("\n            ")
	    ;  if(!items[i].isTop) { 
	    ; __append("\n            <span class=\"time fr\">")
	    ; __append(escape(items[i].covertime))
	    ; __append("</span>\n            ")
	    ;  }} 
	    ; __append("\n            ")
	    ;  if (items[i].user_image){ 
	    ; __append("\n            ")
	    ;  if (items[i].user_url){ 
	    ; __append("\n            <a href=\"")
	    ; __append(escape(items[i].user_url))
	    ; __append("\" target=\"_blank\" class=\"link\">\n                <img class=\"avatar\" src=\"")
	    ; __append(escape(items[i].user_image))
	    ; __append("\" alt=\"用户\">\n                <span class=\"ava-mask\"></span>\n            </a>\n            ")
	    ;  }else{ 
	    ; __append("\n            <span class=\"link fl\">\n                            <img class=\"avatar\" src=\"")
	    ; __append(escape(items[i].user_image))
	    ; __append("\" alt=\"用户\">\n                    <span class=\"ava-mask\"></span>\n                </span>\n            ")
	    ;  } 
	    ; __append("\n            ")
	    ;  } 
	    ; __append("\n\n            ")
	    ;  if (items[i].user_url){ 
	    ; __append("\n            <a href=\"")
	    ;  items[i].user_url 
	    ; __append("\" target=\"_blank\" class=\"name-s\">\n                ")
	    ;  items[i].user 
	    ; __append("\n            </a>\n            ")
	    ;  }else{ 
	    ; __append("\n            <span class=\"name-s\">")
	    ; __append(escape(items[i].user))
	    ; __append("</span>\n            ")
	    ;  } 
	    ; __append("\n\n        </div>\n        ")
	    ; (function(){
	    ; __append("<div class=\"mod-news-content\">\n\n    <div class=\"news-con\">\n        ")
	    ;  if (items[i].title){
	    ; __append("\n        <h3 class=\"news-title\">\n            ")
	    ;  if (items[i].title_link){
	    ; __append("\n            <a href=\"")
	    ; __append(escape(items[i].title_link))
	    ; __append("\" target=\"_blank\">")
	    ; __append(escape(items[i].title))
	    ; __append("</a>\n            ")
	    ; }else{
	    ; __append("\n            <span>")
	    ; __append(escape(items[i].title))
	    ; __append("</span>\n            ")
	    ; }
	    ; __append("\n        </h3>\n        ")
	    ; }
	    ; __append("\n\n\n\n        ")
	    ;  if (items[i].abstract1){
	    ; __append("\n        <div class=\"info\">\n            ")
	    ;  if (items[i].hasContent){
	    ; __append("\n            ")
	    ; __append(escape(items[i].abstract1))
	    ; __append("\n            ")
	    ;  if (items[i].abstract_link){
	    ; __append("<span class=\"detail_url stress\" data-link=\" ")
	    ; __append(escape(items[i].abstract_link))
	    ; __append("\">[详细]</span>")
	    ; }
	    ; __append("\n            ")
	    ; }
	    ; __append("\n        </div>\n        ")
	    ; }
	    ; __append("\n\n    </div>\n\n</div>\n\n")
	    ; }).call(this)
	    ; __append("\n    </div>\n\n    <div class=\"border-line\"></div>\n\n\n</div>\n\n")
	    ;  } 
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Soundmanager = __webpack_require__(408);
	
	var audio = __webpack_require__(409);
	
	var soundmanager = new Soundmanager();
	
	var index = 0;
	
	soundmanager.setup({
	  url: '//p1.ifengimg.com/386ce73cec45533b/2016/34/soundmanager2_flash9_debug.swf',
	  preferFlash: false,
	  useFlashBlock: true,
	  useConsole: false,
	  debugMode: false,
	  flashVersion: 9,
	  bgColor: '#a2e563'
	});
	soundmanager.useConsole = false;
	
	var activeSound = null;
	
	var LiveAudio = function LiveAudio(options) {
	  this.init(options);
	};
	
	LiveAudio.prototype.init = function (options) {
	  this.options = options;
	  this.id = options.audio_id;
	  this.url = options.audio_url;
	
	  this.resolveTemplate();
	
	  this.bindDomEvent();
	};
	
	// 创建并解析模板
	LiveAudio.prototype.resolveTemplate = function () {
	  // 以jquery为例
	  // 使用模板
	
	  this.options.index = index;
	
	  index++;
	
	  var audioHtml = audio(this.options);
	  this.el = document.createElement('div');
	  $(this.el).append(audioHtml);
	  this.ownerNode = $(this.el).find('.liveaudio_container');
	};
	
	// 绑定dom事件
	LiveAudio.prototype.bindDomEvent = function () {
	  // 以jquery为例
	  var _this = this;
	
	  $(this.ownerNode).on('click', function (e) {
	    _this.play();
	  });
	};
	
	// 渲染组件。
	
	
	LiveAudio.prototype.play = function () {
	  var _this = this;
	  if (!this.sound) {
	    this.sound = soundmanager.createSound({
	      id: this.id,
	      url: this.url,
	      onplay: function onplay() {
	        _this.onplay();
	      },
	      onstop: function onstop() {
	        _this.onstop();
	      },
	      onpause: function onpause() {
	        _this.onpause();
	      },
	      onresume: function onresume() {
	        _this.onresume();
	      },
	      onfinish: function onfinish() {
	        _this.onfinish();
	      }
	    });
	  }
	  if (activeSound && activeSound != this.sound) {
	    activeSound.pause();
	  }
	  activeSound = this.sound;
	  if (this.sound.playState == 0) {
	    this.sound.play();
	  } else if (!this.sound.paused) {
	    this.sound.pause();
	  } else {
	    this.sound.play();
	  }
	};
	
	LiveAudio.prototype.onplay = function () {
	  this.ownerNode.addClass('liveaudio_play').removeClass('liveaudio_pause');
	};
	
	LiveAudio.prototype.onstop = function () {
	  this.ownerNode.removeClass('liveaudio_play').removeClass('liveaudio_pause');
	};
	
	LiveAudio.prototype.onpause = function () {
	  this.ownerNode.removeClass('liveaudio_play').addClass('liveaudio_pause');
	};
	
	LiveAudio.prototype.onresume = function () {
	  this.ownerNode.addClass('liveaudio_play').removeClass('liveaudio_pause');
	};
	
	LiveAudio.prototype.onfinish = function () {
	  this.ownerNode.removeClass('liveaudio_play').removeClass('liveaudio_pause');
	};
	
	LiveAudio.prototype.renderTo = function (parentNode) {
	  parentNode.appendChild($(this.el).children()[0]);
	};
	
	module.exports = LiveAudio;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/** @license
	 *
	 * SoundManager 2: JavaScript Sound for the Web
	 * ----------------------------------------------
	 * http://schillmania.com/projects/soundmanager2/
	 *
	 * Copyright (c) 2007, Scott Schiller. All rights reserved.
	 * Code provided under the BSD License:
	 * http://schillmania.com/projects/soundmanager2/license.txt
	 *
	 * V2.97a.20150601
	 */
	
	/*global window, SM2_DEFER, sm2Debugger, console, document, navigator, setTimeout, setInterval, clearInterval, Audio, opera, module, define */
	/*jslint regexp: true, sloppy: true, white: true, nomen: true, plusplus: true, todo: true */
	
	/**
	 * About this file
	 * -------------------------------------------------------------------------------------
	 * This is the fully-commented source version of the SoundManager 2 API,
	 * recommended for use during development and testing.
	 *
	 * See soundmanager2-nodebug-jsmin.js for an optimized build (~11KB with gzip.)
	 * http://schillmania.com/projects/soundmanager2/doc/getstarted/#basic-inclusion
	 * Alternately, serve this file with gzip for 75% compression savings (~30KB over HTTP.)
	 *
	 * You may notice <d> and </d> comments in this source; these are delimiters for
	 * debug blocks which are removed in the -nodebug builds, further optimizing code size.
	 *
	 * Also, as you may note: Whoa, reliable cross-platform/device audio support is hard! ;)
	 */
	
	"use strict";
	
	var _typeof2 = __webpack_require__(1);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!window || !window.document) {
	
	  // Don't cross the [environment] streams. SM2 expects to be running in a browser, not under node.js etc.
	  // Additionally, if a browser somehow manages to fail this test, as Egon said: "It would be bad."
	
	  throw new Error('SoundManager requires a browser with window and document objects.');
	}
	var _undefined;
	
	var soundManager = null;
	
	/**
	 * The SoundManager constructor.
	 *
	 * @constructor
	 * @param {string} smURL Optional: Path to SWF files
	 * @param {string} smID Optional: The ID to use for the SWF container element
	 * @this {SoundManager}
	 * @return {SoundManager} The new SoundManager instance
	 */
	
	function SoundManager(smURL, smID) {
	
	  /**
	   * soundManager configuration options list
	   * defines top-level configuration properties to be applied to the soundManager instance (eg. soundManager.flashVersion)
	   * to set these properties, use the setup() method - eg., soundManager.setup({url: '/swf/', flashVersion: 9})
	   */
	
	  this.setupOptions = {
	
	    'url': smURL || null, // path (directory) where SoundManager 2 SWFs exist, eg., /path/to/swfs/
	    'flashVersion': 8, // flash build to use (8 or 9.) Some API features require 9.
	    'debugMode': false, // enable debugging output (console.log() with HTML fallback)
	    'debugFlash': false, // enable debugging output inside SWF, troubleshoot Flash/browser issues
	    'useConsole': true, // use console.log() if available (otherwise, writes to #soundmanager-debug element)
	    'consoleOnly': true, // if console is being used, do not create/write to #soundmanager-debug
	    'waitForWindowLoad': false, // force SM2 to wait for window.onload() before trying to call soundManager.onload()
	    'bgColor': '#ffffff', // SWF background color. N/A when wmode = 'transparent'
	    'useHighPerformance': false, // position:fixed flash movie can help increase js/flash speed, minimize lag
	    'flashPollingInterval': null, // msec affecting whileplaying/loading callback frequency. If null, default of 50 msec is used.
	    'html5PollingInterval': null, // msec affecting whileplaying() for HTML5 audio, excluding mobile devices. If null, native HTML5 update events are used.
	    'flashLoadTimeout': 1000, // msec to wait for flash movie to load before failing (0 = infinity)
	    'wmode': null, // flash rendering mode - null, 'transparent', or 'opaque' (last two allow z-index to work)
	    'allowScriptAccess': 'always', // for scripting the SWF (object/embed property), 'always' or 'sameDomain'
	    'useFlashBlock': false, // *requires flashblock.css, see demos* - allow recovery from flash blockers. Wait indefinitely and apply timeout CSS to SWF, if applicable.
	    'useHTML5Audio': true, // use HTML5 Audio() where API is supported (most Safari, Chrome versions), Firefox (MP3/MP4 support varies.) Ideally, transparent vs. Flash API where possible.
	    'forceUseGlobalHTML5Audio': false, // if true, a single Audio() object is used for all sounds - and only one can play at a time.
	    'ignoreMobileRestrictions': false, // if true, SM2 will not apply global HTML5 audio rules to mobile UAs. iOS > 7 and WebViews may allow multiple Audio() instances.
	    'html5Test': /^(probably|maybe)$/i, // HTML5 Audio() format support test. Use /^probably$/i; if you want to be more conservative.
	    'preferFlash': false, // overrides useHTML5audio, will use Flash for MP3/MP4/AAC if present. Potential option if HTML5 playback with these formats is quirky.
	    'noSWFCache': false, // if true, appends ?ts={date} to break aggressive SWF caching.
	    'idPrefix': 'sound' // if an id is not provided to createSound(), this prefix is used for generated IDs - 'sound0', 'sound1' etc.
	
	  };
	
	  this.defaultOptions = {
	
	    /**
	     * the default configuration for sound objects made with createSound() and related methods
	     * eg., volume, auto-load behaviour and so forth
	     */
	
	    'autoLoad': false, // enable automatic loading (otherwise .load() will be called on demand with .play(), the latter being nicer on bandwidth - if you want to .load yourself, you also can)
	    'autoPlay': false, // enable playing of file as soon as possible (much faster if "stream" is true)
	    'from': null, // position to start playback within a sound (msec), default = beginning
	    'loops': 1, // how many times to repeat the sound (position will wrap around to 0, setPosition() will break out of loop when >0)
	    'onid3': null, // callback function for "ID3 data is added/available"
	    'onload': null, // callback function for "load finished"
	    'whileloading': null, // callback function for "download progress update" (X of Y bytes received)
	    'onplay': null, // callback for "play" start
	    'onpause': null, // callback for "pause"
	    'onresume': null, // callback for "resume" (pause toggle)
	    'whileplaying': null, // callback during play (position update)
	    'onposition': null, // object containing times and function callbacks for positions of interest
	    'onstop': null, // callback for "user stop"
	    'onfailure': null, // callback function for when playing fails
	    'onfinish': null, // callback function for "sound finished playing"
	    'multiShot': true, // let sounds "restart" or layer on top of each other when played multiple times, rather than one-shot/one at a time
	    'multiShotEvents': false, // fire multiple sound events (currently onfinish() only) when multiShot is enabled
	    'position': null, // offset (milliseconds) to seek to within loaded sound data.
	    'pan': 0, // "pan" settings, left-to-right, -100 to 100
	    'stream': true, // allows playing before entire file has loaded (recommended)
	    'to': null, // position to end playback within a sound (msec), default = end
	    'type': null, // MIME-like hint for file pattern / canPlay() tests, eg. audio/mp3
	    'usePolicyFile': false, // enable crossdomain.xml request for audio on remote domains (for ID3/waveform access)
	    'volume': 100 // self-explanatory. 0-100, the latter being the max.
	
	  };
	
	  this.flash9Options = {
	
	    /**
	     * flash 9-only options,
	     * merged into defaultOptions if flash 9 is being used
	     */
	
	    'isMovieStar': null, // "MovieStar" MPEG4 audio mode. Null (default) = auto detect MP4, AAC etc. based on URL. true = force on, ignore URL
	    'usePeakData': false, // enable left/right channel peak (level) data
	    'useWaveformData': false, // enable sound spectrum (raw waveform data) - NOTE: May increase CPU load.
	    'useEQData': false, // enable sound EQ (frequency spectrum data) - NOTE: May increase CPU load.
	    'onbufferchange': null, // callback for "isBuffering" property change
	    'ondataerror': null // callback for waveform/eq data access error (flash playing audio in other tabs/domains)
	
	  };
	
	  this.movieStarOptions = {
	
	    /**
	     * flash 9.0r115+ MPEG4 audio options,
	     * merged into defaultOptions if flash 9+movieStar mode is enabled
	     */
	
	    'bufferTime': 3, // seconds of data to buffer before playback begins (null = flash default of 0.1 seconds - if AAC playback is gappy, try increasing.)
	    'serverURL': null, // rtmp: FMS or FMIS server to connect to, required when requesting media via RTMP or one of its variants
	    'onconnect': null, // rtmp: callback for connection to flash media server
	    'duration': null // rtmp: song duration (msec)
	
	  };
	
	  this.audioFormats = {
	
	    /**
	     * determines HTML5 support + flash requirements.
	     * if no support (via flash and/or HTML5) for a "required" format, SM2 will fail to start.
	     * flash fallback is used for MP3 or MP4 if HTML5 can't play it (or if preferFlash = true)
	     */
	
	    'mp3': {
	      'type': ['audio/mpeg; codecs="mp3"', 'audio/mpeg', 'audio/mp3', 'audio/MPA', 'audio/mpa-robust'],
	      'required': true
	    },
	
	    'mp4': {
	      'related': ['aac', 'm4a', 'm4b'], // additional formats under the MP4 container
	      'type': ['audio/mp4; codecs="mp4a.40.2"', 'audio/aac', 'audio/x-m4a', 'audio/MP4A-LATM', 'audio/mpeg4-generic'],
	      'required': false
	    },
	
	    'ogg': {
	      'type': ['audio/ogg; codecs=vorbis'],
	      'required': false
	    },
	
	    'opus': {
	      'type': ['audio/ogg; codecs=opus', 'audio/opus'],
	      'required': false
	    },
	
	    'wav': {
	      'type': ['audio/wav; codecs="1"', 'audio/wav', 'audio/wave', 'audio/x-wav'],
	      'required': false
	    }
	
	  };
	
	  // HTML attributes (id + class names) for the SWF container
	
	  this.movieID = 'sm2-container';
	  this.id = smID || 'sm2movie';
	
	  this.debugID = 'soundmanager-debug';
	  this.debugURLParam = /([#?&])debug=1/i;
	
	  // dynamic attributes
	
	  this.versionNumber = 'V2.97a.20150601';
	  this.version = null;
	  this.movieURL = null;
	  this.altURL = null;
	  this.swfLoaded = false;
	  this.enabled = false;
	  this.oMC = null;
	  this.sounds = {};
	  this.soundIDs = [];
	  this.muted = false;
	  this.didFlashBlock = false;
	  this.filePattern = null;
	
	  this.filePatterns = {
	    'flash8': /\.mp3(\?.*)?$/i,
	    'flash9': /\.mp3(\?.*)?$/i
	  };
	
	  // support indicators, set at init
	
	  this.features = {
	    'buffering': false,
	    'peakData': false,
	    'waveformData': false,
	    'eqData': false,
	    'movieStar': false
	  };
	
	  // flash sandbox info, used primarily in troubleshooting
	
	  this.sandbox = {
	    // <d>
	    'type': null,
	    'types': {
	      'remote': 'remote (domain-based) rules',
	      'localWithFile': 'local with file access (no internet access)',
	      'localWithNetwork': 'local with network (internet access only, no local access)',
	      'localTrusted': 'local, trusted (local+internet access)'
	    },
	    'description': null,
	    'noRemote': null,
	    'noLocal': null
	    // </d>
	  };
	
	  /**
	   * format support (html5/flash)
	   * stores canPlayType() results based on audioFormats.
	   * eg. { mp3: boolean, mp4: boolean }
	   * treat as read-only.
	   */
	
	  this.html5 = {
	    'usingFlash': null // set if/when flash fallback is needed
	  };
	
	  // file type support hash
	  this.flash = {};
	
	  // determined at init time
	  this.html5Only = false;
	
	  // used for special cases (eg. iPad/iPhone/palm OS?)
	  this.ignoreFlash = false;
	
	  /**
	   * a few private internals (OK, a lot. :D)
	   */
	
	  var SMSound,
	      sm2 = this,
	      globalHTML5Audio = null,
	      flash = null,
	      sm = 'soundManager',
	      smc = sm + ': ',
	      h5 = 'HTML5::',
	      id,
	      ua = navigator.userAgent,
	      wl = window.location.href.toString(),
	      doc = document,
	      doNothing,
	      setProperties,
	      init,
	      fV,
	      on_queue = [],
	      debugOpen = true,
	      debugTS,
	      didAppend = false,
	      appendSuccess = false,
	      didInit = false,
	      disabled = false,
	      windowLoaded = false,
	      _wDS,
	      wdCount = 0,
	      initComplete,
	      _mixin,
	      _assign,
	      extraOptions,
	      addOnEvent,
	      processOnEvents,
	      _initUserOnload,
	      delayWaitForEI,
	      waitForEI,
	      rebootIntoHTML5,
	      setVersionInfo,
	      _handleFocus,
	      strings,
	      initMovie,
	      _domContentLoaded,
	      _winOnLoad,
	      didDCLoaded,
	      getDocument,
	      createMovie,
	      catchError,
	      setPolling,
	      initDebug,
	      debugLevels = ['log', 'info', 'warn', 'error'],
	      defaultFlashVersion = 8,
	      disableObject,
	      failSafely,
	      normalizeMovieURL,
	      oRemoved = null,
	      oRemovedHTML = null,
	      str,
	      flashBlockHandler,
	      getSWFCSS,
	      swfCSS,
	      toggleDebug,
	      loopFix,
	      policyFix,
	      complain,
	      idCheck,
	      waitingForEI = false,
	      initPending = false,
	      startTimer,
	      stopTimer,
	      timerExecute,
	      h5TimerCount = 0,
	      h5IntervalTimer = null,
	      parseURL,
	      messages = [],
	      canIgnoreFlash,
	      needsFlash = null,
	      featureCheck,
	      html5OK,
	      html5CanPlay,
	      html5Ext,
	      html5Unload,
	      _domContentLoadedIE,
	      testHTML5,
	      event,
	      slice = Array.prototype.slice,
	      useGlobalHTML5Audio = false,
	      lastGlobalHTML5URL,
	      hasFlash,
	      detectFlash,
	      badSafariFix,
	      html5_events,
	      showSupport,
	      flushMessages,
	      wrapCallback,
	      idCounter = 0,
	      didSetup,
	      msecScale = 1000,
	      is_iDevice = ua.match(/(ipad|iphone|ipod)/i),
	      isAndroid = ua.match(/android/i),
	      isIE = ua.match(/msie/i),
	      isWebkit = ua.match(/webkit/i),
	      isSafari = ua.match(/safari/i) && !ua.match(/chrome/i),
	      isOpera = ua.match(/opera/i),
	      mobileHTML5 = ua.match(/(mobile|pre\/|xoom)/i) || is_iDevice || isAndroid,
	      isBadSafari = !wl.match(/usehtml5audio/i) && !wl.match(/sm2\-ignorebadua/i) && isSafari && !ua.match(/silk/i) && ua.match(/OS X 10_6_([3-7])/i),
	      // Safari 4 and 5 (excluding Kindle Fire, "Silk") occasionally fail to load/play HTML5 audio on Snow Leopard 10.6.3 through 10.6.7 due to bug(s) in QuickTime X and/or other underlying frameworks. :/ Confirmed bug. https://bugs.webkit.org/show_bug.cgi?id=32159
	  hasConsole = window.console !== _undefined && console.log !== _undefined,
	      isFocused = doc.hasFocus !== _undefined ? doc.hasFocus() : null,
	      tryInitOnFocus = isSafari && (doc.hasFocus === _undefined || !doc.hasFocus()),
	      okToDisable = !tryInitOnFocus,
	      flashMIME = /(mp3|mp4|mpa|m4a|m4b)/i,
	      emptyURL = 'about:blank',
	      // safe URL to unload, or load nothing from (flash 8 + most HTML5 UAs)
	  emptyWAV = 'data:audio/wave;base64,/UklGRiYAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQIAAAD//w==',
	      // tiny WAV for HTML5 unloading
	  overHTTP = doc.location ? doc.location.protocol.match(/http/i) : null,
	      http = !overHTTP ? 'http:/' + '/' : '',
	
	  // mp3, mp4, aac etc.
	  netStreamMimeTypes = /^\s*audio\/(?:x-)?(?:mpeg4|aac|flv|mov|mp4||m4v|m4a|m4b|mp4v|3gp|3g2)\s*(?:$|;)/i,
	
	  // Flash v9.0r115+ "moviestar" formats
	  netStreamTypes = ['mpeg4', 'aac', 'flv', 'mov', 'mp4', 'm4v', 'f4v', 'm4a', 'm4b', 'mp4v', '3gp', '3g2'],
	      netStreamPattern = new RegExp('\\.(' + netStreamTypes.join('|') + ')(\\?.*)?$', 'i');
	
	  this.mimePattern = /^\s*audio\/(?:x-)?(?:mp(?:eg|3))\s*(?:$|;)/i; // default mp3 set
	
	  // use altURL if not "online"
	  this.useAltURL = !overHTTP;
	
	  swfCSS = {
	    'swfBox': 'sm2-object-box',
	    'swfDefault': 'movieContainer',
	    'swfError': 'swf_error', // SWF loaded, but SM2 couldn't start (other error)
	    'swfTimedout': 'swf_timedout',
	    'swfLoaded': 'swf_loaded',
	    'swfUnblocked': 'swf_unblocked', // or loaded OK
	    'sm2Debug': 'sm2_debug',
	    'highPerf': 'high_performance',
	    'flashDebug': 'flash_debug'
	  };
	
	  /**
	   * basic HTML5 Audio() support test
	   * try...catch because of IE 9 "not implemented" nonsense
	   * https://github.com/Modernizr/Modernizr/issues/224
	   */
	
	  this.hasHTML5 = function () {
	    try {
	      // new Audio(null) for stupid Opera 9.64 case, which throws not_enough_arguments exception otherwise.
	      return Audio !== _undefined && (isOpera && opera !== _undefined && opera.version() < 10 ? new Audio(null) : new Audio()).canPlayType !== _undefined;
	    } catch (e) {
	      return false;
	    }
	  }();
	
	  /**
	   * Public SoundManager API
	   * -----------------------
	   */
	
	  /**
	   * Configures top-level soundManager properties.
	   *
	   * @param {object} options Option parameters, eg. { flashVersion: 9, url: '/path/to/swfs/' }
	   * onready and ontimeout are also accepted parameters. call soundManager.setup() to see the full list.
	   */
	
	  this.setup = function (options) {
	
	    var noURL = !sm2.url;
	
	    // warn if flash options have already been applied
	
	    if (options !== _undefined && didInit && needsFlash && sm2.ok() && (options.flashVersion !== _undefined || options.url !== _undefined || options.html5Test !== _undefined)) {
	      complain(str('setupLate'));
	    }
	
	    // TODO: defer: true?
	
	    _assign(options);
	
	    if (!useGlobalHTML5Audio) {
	
	      if (mobileHTML5) {
	
	        // force the singleton HTML5 pattern on mobile, by default.
	        if (!sm2.setupOptions.ignoreMobileRestrictions || sm2.setupOptions.forceUseGlobalHTML5Audio) {
	          messages.push(strings.globalHTML5);
	          useGlobalHTML5Audio = true;
	        }
	      } else {
	
	        // only apply singleton HTML5 on desktop if forced.
	        if (sm2.setupOptions.forceUseGlobalHTML5Audio) {
	          messages.push(strings.globalHTML5);
	          useGlobalHTML5Audio = true;
	        }
	      }
	    }
	
	    if (!didSetup && mobileHTML5) {
	
	      if (sm2.setupOptions.ignoreMobileRestrictions) {
	
	        messages.push(strings.ignoreMobile);
	      } else {
	
	        // prefer HTML5 for mobile + tablet-like devices, probably more reliable vs. flash at this point.
	
	        // <d>
	        if (!sm2.setupOptions.useHTML5Audio || sm2.setupOptions.preferFlash) {
	          // notify that defaults are being changed.
	          sm2._wD(strings.mobileUA);
	        }
	        // </d>
	
	        sm2.setupOptions.useHTML5Audio = true;
	        sm2.setupOptions.preferFlash = false;
	
	        if (is_iDevice) {
	
	          // no flash here.
	          sm2.ignoreFlash = true;
	        } else if (isAndroid && !ua.match(/android\s2\.3/i) || !isAndroid) {
	
	          /**
	           * Android devices tend to work better with a single audio instance, specifically for chained playback of sounds in sequence.
	           * Common use case: exiting sound onfinish() -> createSound() -> play()
	           * Presuming similar restrictions for other mobile, non-Android, non-iOS devices.
	           */
	
	          // <d>
	          sm2._wD(strings.globalHTML5);
	          // </d>
	
	          useGlobalHTML5Audio = true;
	        }
	      }
	    }
	
	    // special case 1: "Late setup". SM2 loaded normally, but user didn't assign flash URL eg., setup({url:...}) before SM2 init. Treat as delayed init.
	
	    if (options) {
	
	      if (noURL && didDCLoaded && options.url !== _undefined) {
	        sm2.beginDelayedInit();
	      }
	
	      // special case 2: If lazy-loading SM2 (DOMContentLoaded has already happened) and user calls setup() with url: parameter, try to init ASAP.
	
	      if (!didDCLoaded && options.url !== _undefined && doc.readyState === 'complete') {
	        setTimeout(_domContentLoaded, 1);
	      }
	    }
	
	    didSetup = true;
	
	    return sm2;
	  };
	
	  this.ok = function () {
	
	    return needsFlash ? didInit && !disabled : sm2.useHTML5Audio && sm2.hasHTML5;
	  };
	
	  this.supported = this.ok; // legacy
	
	  this.getMovie = function (smID) {
	
	    // safety net: some old browsers differ on SWF references, possibly related to ExternalInterface / flash version
	    return id(smID) || doc[smID] || window[smID];
	  };
	
	  /**
	   * Creates a SMSound sound object instance. Can also be overloaded, e.g., createSound('mySound', '/some.mp3');
	   *
	   * @param {object} oOptions Sound options (at minimum, url parameter is required.)
	   * @return {object} SMSound The new SMSound object.
	   */
	
	  this.createSound = function (oOptions, _url) {
	
	    var cs,
	        cs_string,
	        options,
	        oSound = null;
	
	    // <d>
	    cs = sm + '.createSound(): ';
	    cs_string = cs + str(!didInit ? 'notReady' : 'notOK');
	    // </d>
	
	    if (!didInit || !sm2.ok()) {
	      complain(cs_string);
	      return false;
	    }
	
	    if (_url !== _undefined) {
	      // function overloading in JS! :) ... assume simple createSound(id, url) use case.
	      oOptions = {
	        'id': oOptions,
	        'url': _url
	      };
	    }
	
	    // inherit from defaultOptions
	    options = _mixin(oOptions);
	
	    options.url = parseURL(options.url);
	
	    // generate an id, if needed.
	    if (options.id === _undefined) {
	      options.id = sm2.setupOptions.idPrefix + idCounter++;
	    }
	
	    // <d>
	    if (options.id.toString().charAt(0).match(/^[0-9]$/)) {
	      sm2._wD(cs + str('badID', options.id), 2);
	    }
	
	    sm2._wD(cs + options.id + (options.url ? ' (' + options.url + ')' : ''), 1);
	    // </d>
	
	    if (idCheck(options.id, true)) {
	      sm2._wD(cs + options.id + ' exists', 1);
	      return sm2.sounds[options.id];
	    }
	
	    function make() {
	
	      options = loopFix(options);
	      sm2.sounds[options.id] = new SMSound(options);
	      sm2.soundIDs.push(options.id);
	      return sm2.sounds[options.id];
	    }
	
	    if (html5OK(options)) {
	
	      oSound = make();
	      // <d>
	      if (!sm2.html5Only) {
	        sm2._wD(options.id + ': Using HTML5');
	      }
	      // </d>
	      oSound._setup_html5(options);
	    } else {
	
	      if (sm2.html5Only) {
	        sm2._wD(options.id + ': No HTML5 support for this sound, and no Flash. Exiting.');
	        return make();
	      }
	
	      // TODO: Move HTML5/flash checks into generic URL parsing/handling function.
	
	      if (sm2.html5.usingFlash && options.url && options.url.match(/data\:/i)) {
	        // data: URIs not supported by Flash, either.
	        sm2._wD(options.id + ': data: URIs not supported via Flash. Exiting.');
	        return make();
	      }
	
	      if (fV > 8) {
	        if (options.isMovieStar === null) {
	          // attempt to detect MPEG-4 formats
	          options.isMovieStar = !!(options.serverURL || (options.type ? options.type.match(netStreamMimeTypes) : false) || options.url && options.url.match(netStreamPattern));
	        }
	        // <d>
	        if (options.isMovieStar) {
	          sm2._wD(cs + 'using MovieStar handling');
	          if (options.loops > 1) {
	            _wDS('noNSLoop');
	          }
	        }
	        // </d>
	      }
	
	      options = policyFix(options, cs);
	      oSound = make();
	
	      if (fV === 8) {
	        flash._createSound(options.id, options.loops || 1, options.usePolicyFile);
	      } else {
	        flash._createSound(options.id, options.url, options.usePeakData, options.useWaveformData, options.useEQData, options.isMovieStar, options.isMovieStar ? options.bufferTime : false, options.loops || 1, options.serverURL, options.duration || null, options.autoPlay, true, options.autoLoad, options.usePolicyFile);
	        if (!options.serverURL) {
	          // We are connected immediately
	          oSound.connected = true;
	          if (options.onconnect) {
	            options.onconnect.apply(oSound);
	          }
	        }
	      }
	
	      if (!options.serverURL && (options.autoLoad || options.autoPlay)) {
	        // call load for non-rtmp streams
	        oSound.load(options);
	      }
	    }
	
	    // rtmp will play in onconnect
	    if (!options.serverURL && options.autoPlay) {
	      oSound.play();
	    }
	
	    return oSound;
	  };
	
	  /**
	   * Destroys a SMSound sound object instance.
	   *
	   * @param {string} sID The ID of the sound to destroy
	   */
	
	  this.destroySound = function (sID, _bFromSound) {
	
	    // explicitly destroy a sound before normal page unload, etc.
	
	    if (!idCheck(sID)) {
	      return false;
	    }
	
	    var oS = sm2.sounds[sID],
	        i;
	
	    oS.stop();
	
	    // Disable all callbacks after stop(), when the sound is being destroyed
	    oS._iO = {};
	
	    oS.unload();
	
	    for (i = 0; i < sm2.soundIDs.length; i++) {
	      if (sm2.soundIDs[i] === sID) {
	        sm2.soundIDs.splice(i, 1);
	        break;
	      }
	    }
	
	    if (!_bFromSound) {
	      // ignore if being called from SMSound instance
	      oS.destruct(true);
	    }
	
	    oS = null;
	    delete sm2.sounds[sID];
	
	    return true;
	  };
	
	  /**
	   * Calls the load() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {object} oOptions Optional: Sound options
	   */
	
	  this.load = function (sID, oOptions) {
	
	    if (!idCheck(sID)) {
	      return false;
	    }
	    return sm2.sounds[sID].load(oOptions);
	  };
	
	  /**
	   * Calls the unload() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   */
	
	  this.unload = function (sID) {
	
	    if (!idCheck(sID)) {
	      return false;
	    }
	    return sm2.sounds[sID].unload();
	  };
	
	  /**
	   * Calls the onPosition() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {number} nPosition The position to watch for
	   * @param {function} oMethod The relevant callback to fire
	   * @param {object} oScope Optional: The scope to apply the callback to
	   * @return {SMSound} The SMSound object
	   */
	
	  this.onPosition = function (sID, nPosition, oMethod, oScope) {
	
	    if (!idCheck(sID)) {
	      return false;
	    }
	    return sm2.sounds[sID].onposition(nPosition, oMethod, oScope);
	  };
	
	  // legacy/backwards-compability: lower-case method name
	  this.onposition = this.onPosition;
	
	  /**
	   * Calls the clearOnPosition() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {number} nPosition The position to watch for
	   * @param {function} oMethod Optional: The relevant callback to fire
	   * @return {SMSound} The SMSound object
	   */
	
	  this.clearOnPosition = function (sID, nPosition, oMethod) {
	
	    if (!idCheck(sID)) {
	      return false;
	    }
	    return sm2.sounds[sID].clearOnPosition(nPosition, oMethod);
	  };
	
	  /**
	   * Calls the play() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {object} oOptions Optional: Sound options
	   * @return {SMSound} The SMSound object
	   */
	
	  this.play = function (sID, oOptions) {
	
	    var result = null,
	
	    // legacy function-overloading use case: play('mySound', '/path/to/some.mp3');
	    overloaded = oOptions && !(oOptions instanceof Object);
	
	    if (!didInit || !sm2.ok()) {
	      complain(sm + '.play(): ' + str(!didInit ? 'notReady' : 'notOK'));
	      return false;
	    }
	
	    if (!idCheck(sID, overloaded)) {
	
	      if (!overloaded) {
	        // no sound found for the given ID. Bail.
	        return false;
	      }
	
	      if (overloaded) {
	        oOptions = {
	          url: oOptions
	        };
	      }
	
	      if (oOptions && oOptions.url) {
	        // overloading use case, create+play: .play('someID', {url:'/path/to.mp3'});
	        sm2._wD(sm + '.play(): Attempting to create "' + sID + '"', 1);
	        oOptions.id = sID;
	        result = sm2.createSound(oOptions).play();
	      }
	    } else if (overloaded) {
	
	      // existing sound object case
	      oOptions = {
	        url: oOptions
	      };
	    }
	
	    if (result === null) {
	      // default case
	      result = sm2.sounds[sID].play(oOptions);
	    }
	
	    return result;
	  };
	
	  // just for convenience
	  this.start = this.play;
	
	  /**
	   * Calls the setPosition() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {number} nMsecOffset Position (milliseconds)
	   * @return {SMSound} The SMSound object
	   */
	
	  this.setPosition = function (sID, nMsecOffset) {
	
	    if (!idCheck(sID)) {
	      return false;
	    }
	    return sm2.sounds[sID].setPosition(nMsecOffset);
	  };
	
	  /**
	   * Calls the stop() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @return {SMSound} The SMSound object
	   */
	
	  this.stop = function (sID) {
	
	    if (!idCheck(sID)) {
	      return false;
	    }
	
	    sm2._wD(sm + '.stop(' + sID + ')', 1);
	    return sm2.sounds[sID].stop();
	  };
	
	  /**
	   * Stops all currently-playing sounds.
	   */
	
	  this.stopAll = function () {
	
	    var oSound;
	    sm2._wD(sm + '.stopAll()', 1);
	
	    for (oSound in sm2.sounds) {
	      if (sm2.sounds.hasOwnProperty(oSound)) {
	        // apply only to sound objects
	        sm2.sounds[oSound].stop();
	      }
	    }
	  };
	
	  /**
	   * Calls the pause() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @return {SMSound} The SMSound object
	   */
	
	  this.pause = function (sID) {
	
	    if (!idCheck(sID)) {
	      return false;
	    }
	    return sm2.sounds[sID].pause();
	  };
	
	  /**
	   * Pauses all currently-playing sounds.
	   */
	
	  this.pauseAll = function () {
	
	    var i;
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	      sm2.sounds[sm2.soundIDs[i]].pause();
	    }
	  };
	
	  /**
	   * Calls the resume() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @return {SMSound} The SMSound object
	   */
	
	  this.resume = function (sID) {
	
	    if (!idCheck(sID)) {
	      return false;
	    }
	    return sm2.sounds[sID].resume();
	  };
	
	  /**
	   * Resumes all currently-paused sounds.
	   */
	
	  this.resumeAll = function () {
	
	    var i;
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	      sm2.sounds[sm2.soundIDs[i]].resume();
	    }
	  };
	
	  /**
	   * Calls the togglePause() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @return {SMSound} The SMSound object
	   */
	
	  this.togglePause = function (sID) {
	
	    if (!idCheck(sID)) {
	      return false;
	    }
	    return sm2.sounds[sID].togglePause();
	  };
	
	  /**
	   * Calls the setPan() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {number} nPan The pan value (-100 to 100)
	   * @return {SMSound} The SMSound object
	   */
	
	  this.setPan = function (sID, nPan) {
	
	    if (!idCheck(sID)) {
	      return false;
	    }
	    return sm2.sounds[sID].setPan(nPan);
	  };
	
	  /**
	   * Calls the setVolume() method of a SMSound object by ID
	   * Overloaded case: pass only volume argument eg., setVolume(50) to apply to all sounds.
	   *
	   * @param {string} sID The ID of the sound
	   * @param {number} nVol The volume value (0 to 100)
	   * @return {SMSound} The SMSound object
	   */
	
	  this.setVolume = function (sID, nVol) {
	
	    // setVolume(50) function overloading case - apply to all sounds
	
	    var i, j;
	
	    if (sID !== _undefined && !isNaN(sID) && nVol === _undefined) {
	      for (i = 0, j = sm2.soundIDs.length; i < j; i++) {
	        sm2.sounds[sm2.soundIDs[i]].setVolume(sID);
	      }
	      return;
	    }
	
	    // setVolume('mySound', 50) case
	
	    if (!idCheck(sID)) {
	      return false;
	    }
	
	    return sm2.sounds[sID].setVolume(nVol);
	  };
	
	  /**
	   * Calls the mute() method of either a single SMSound object by ID, or all sound objects.
	   *
	   * @param {string} sID Optional: The ID of the sound (if omitted, all sounds will be used.)
	   */
	
	  this.mute = function (sID) {
	
	    var i = 0;
	
	    if (sID instanceof String) {
	      sID = null;
	    }
	
	    if (!sID) {
	
	      sm2._wD(sm + '.mute(): Muting all sounds');
	      for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	        sm2.sounds[sm2.soundIDs[i]].mute();
	      }
	      sm2.muted = true;
	    } else {
	
	      if (!idCheck(sID)) {
	        return false;
	      }
	      sm2._wD(sm + '.mute(): Muting "' + sID + '"');
	      return sm2.sounds[sID].mute();
	    }
	
	    return true;
	  };
	
	  /**
	   * Mutes all sounds.
	   */
	
	  this.muteAll = function () {
	
	    sm2.mute();
	  };
	
	  /**
	   * Calls the unmute() method of either a single SMSound object by ID, or all sound objects.
	   *
	   * @param {string} sID Optional: The ID of the sound (if omitted, all sounds will be used.)
	   */
	
	  this.unmute = function (sID) {
	
	    var i;
	
	    if (sID instanceof String) {
	      sID = null;
	    }
	
	    if (!sID) {
	
	      sm2._wD(sm + '.unmute(): Unmuting all sounds');
	      for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	        sm2.sounds[sm2.soundIDs[i]].unmute();
	      }
	      sm2.muted = false;
	    } else {
	
	      if (!idCheck(sID)) {
	        return false;
	      }
	      sm2._wD(sm + '.unmute(): Unmuting "' + sID + '"');
	      return sm2.sounds[sID].unmute();
	    }
	
	    return true;
	  };
	
	  /**
	   * Unmutes all sounds.
	   */
	
	  this.unmuteAll = function () {
	
	    sm2.unmute();
	  };
	
	  /**
	   * Calls the toggleMute() method of a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @return {SMSound} The SMSound object
	   */
	
	  this.toggleMute = function (sID) {
	
	    if (!idCheck(sID)) {
	      return false;
	    }
	    return sm2.sounds[sID].toggleMute();
	  };
	
	  /**
	   * Retrieves the memory used by the flash plugin.
	   *
	   * @return {number} The amount of memory in use
	   */
	
	  this.getMemoryUse = function () {
	
	    // flash-only
	    var ram = 0;
	
	    if (flash && fV !== 8) {
	      ram = parseInt(flash._getMemoryUse(), 10);
	    }
	
	    return ram;
	  };
	
	  /**
	   * Undocumented: NOPs soundManager and all SMSound objects.
	   */
	
	  this.disable = function (bNoDisable) {
	
	    // destroy all functions
	    var i;
	
	    if (bNoDisable === _undefined) {
	      bNoDisable = false;
	    }
	
	    if (disabled) {
	      return false;
	    }
	
	    disabled = true;
	    _wDS('shutdown', 1);
	
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	      disableObject(sm2.sounds[sm2.soundIDs[i]]);
	    }
	
	    // fire "complete", despite fail
	    initComplete(bNoDisable);
	    event.remove(window, 'load', _initUserOnload);
	
	    return true;
	  };
	
	  /**
	   * Determines playability of a MIME type, eg. 'audio/mp3'.
	   */
	
	  this.canPlayMIME = function (sMIME) {
	
	    var result;
	
	    if (sm2.hasHTML5) {
	      result = html5CanPlay({
	        type: sMIME
	      });
	    }
	
	    if (!result && needsFlash) {
	      // if flash 9, test netStream (movieStar) types as well.
	      result = sMIME && sm2.ok() ? !!((fV > 8 ? sMIME.match(netStreamMimeTypes) : null) || sMIME.match(sm2.mimePattern)) : null; // TODO: make less "weird" (per JSLint)
	    }
	
	    return result;
	  };
	
	  /**
	   * Determines playability of a URL based on audio support.
	   *
	   * @param {string} sURL The URL to test
	   * @return {boolean} URL playability
	   */
	
	  this.canPlayURL = function (sURL) {
	
	    var result;
	
	    if (sm2.hasHTML5) {
	      result = html5CanPlay({
	        url: sURL
	      });
	    }
	
	    if (!result && needsFlash) {
	      result = sURL && sm2.ok() ? !!sURL.match(sm2.filePattern) : null;
	    }
	
	    return result;
	  };
	
	  /**
	   * Determines playability of an HTML DOM &lt;a&gt; object (or similar object literal) based on audio support.
	   *
	   * @param {object} oLink an HTML DOM &lt;a&gt; object or object literal including href and/or type attributes
	   * @return {boolean} URL playability
	   */
	
	  this.canPlayLink = function (oLink) {
	
	    if (oLink.type !== _undefined && oLink.type) {
	      if (sm2.canPlayMIME(oLink.type)) {
	        return true;
	      }
	    }
	
	    return sm2.canPlayURL(oLink.href);
	  };
	
	  /**
	   * Retrieves a SMSound object by ID.
	   *
	   * @param {string} sID The ID of the sound
	   * @return {SMSound} The SMSound object
	   */
	
	  this.getSoundById = function (sID, _suppressDebug) {
	
	    if (!sID) {
	      return null;
	    }
	
	    var result = sm2.sounds[sID];
	
	    // <d>
	    if (!result && !_suppressDebug) {
	      sm2._wD(sm + '.getSoundById(): Sound "' + sID + '" not found.', 2);
	    }
	    // </d>
	
	    return result;
	  };
	
	  /**
	   * Queues a callback for execution when SoundManager has successfully initialized.
	   *
	   * @param {function} oMethod The callback method to fire
	   * @param {object} oScope Optional: The scope to apply to the callback
	   */
	
	  this.onready = function (oMethod, oScope) {
	
	    var sType = 'onready',
	        result = false;
	
	    if (typeof oMethod === 'function') {
	
	      // <d>
	      if (didInit) {
	        sm2._wD(str('queue', sType));
	      }
	      // </d>
	
	      if (!oScope) {
	        oScope = window;
	      }
	
	      addOnEvent(sType, oMethod, oScope);
	      processOnEvents();
	
	      result = true;
	    } else {
	
	      throw str('needFunction', sType);
	    }
	
	    return result;
	  };
	
	  /**
	   * Queues a callback for execution when SoundManager has failed to initialize.
	   *
	   * @param {function} oMethod The callback method to fire
	   * @param {object} oScope Optional: The scope to apply to the callback
	   */
	
	  this.ontimeout = function (oMethod, oScope) {
	
	    var sType = 'ontimeout',
	        result = false;
	
	    if (typeof oMethod === 'function') {
	
	      // <d>
	      if (didInit) {
	        sm2._wD(str('queue', sType));
	      }
	      // </d>
	
	      if (!oScope) {
	        oScope = window;
	      }
	
	      addOnEvent(sType, oMethod, oScope);
	      processOnEvents({ type: sType });
	
	      result = true;
	    } else {
	
	      throw str('needFunction', sType);
	    }
	
	    return result;
	  };
	
	  /**
	   * Writes console.log()-style debug output to a console or in-browser element.
	   * Applies when debugMode = true
	   *
	   * @param {string} sText The console message
	   * @param {object} nType Optional log level (number), or object. Number case: Log type/style where 0 = 'info', 1 = 'warn', 2 = 'error'. Object case: Object to be dumped.
	   */
	
	  this._writeDebug = function (sText, sTypeOrObject) {
	
	    // pseudo-private console.log()-style output
	    // <d>
	
	    var sDID = 'soundmanager-debug',
	        o,
	        oItem;
	
	    if (!sm2.setupOptions.debugMode) {
	      return false;
	    }
	
	    if (hasConsole && sm2.useConsole) {
	      if (sTypeOrObject && (typeof sTypeOrObject === 'undefined' ? 'undefined' : (0, _typeof3.default)(sTypeOrObject)) === 'object') {
	        // object passed; dump to console.
	        console.log(sText, sTypeOrObject);
	      } else if (debugLevels[sTypeOrObject] !== _undefined) {
	        console[debugLevels[sTypeOrObject]](sText);
	      } else {
	        console.log(sText);
	      }
	      if (sm2.consoleOnly) {
	        return true;
	      }
	    }
	
	    o = id(sDID);
	
	    if (!o) {
	      return false;
	    }
	
	    oItem = doc.createElement('div');
	
	    if (++wdCount % 2 === 0) {
	      oItem.className = 'sm2-alt';
	    }
	
	    if (sTypeOrObject === _undefined) {
	      sTypeOrObject = 0;
	    } else {
	      sTypeOrObject = parseInt(sTypeOrObject, 10);
	    }
	
	    oItem.appendChild(doc.createTextNode(sText));
	
	    if (sTypeOrObject) {
	      if (sTypeOrObject >= 2) {
	        oItem.style.fontWeight = 'bold';
	      }
	      if (sTypeOrObject === 3) {
	        oItem.style.color = '#ff3333';
	      }
	    }
	
	    // top-to-bottom
	    // o.appendChild(oItem);
	
	    // bottom-to-top
	    o.insertBefore(oItem, o.firstChild);
	
	    o = null;
	    // </d>
	
	    return true;
	  };
	
	  // <d>
	  // last-resort debugging option
	  if (wl.indexOf('sm2-debug=alert') !== -1) {
	    this._writeDebug = function (sText) {
	      window.alert(sText);
	    };
	  }
	  // </d>
	
	  // alias
	  this._wD = this._writeDebug;
	
	  /**
	   * Provides debug / state information on all SMSound objects.
	   */
	
	  this._debug = function () {
	
	    // <d>
	    var i, j;
	    _wDS('currentObj', 1);
	
	    for (i = 0, j = sm2.soundIDs.length; i < j; i++) {
	      sm2.sounds[sm2.soundIDs[i]]._debug();
	    }
	    // </d>
	  };
	
	  /**
	   * Restarts and re-initializes the SoundManager instance.
	   *
	   * @param {boolean} resetEvents Optional: When true, removes all registered onready and ontimeout event callbacks.
	   * @param {boolean} excludeInit Options: When true, does not call beginDelayedInit() (which would restart SM2).
	   * @return {object} soundManager The soundManager instance.
	   */
	
	  this.reboot = function (resetEvents, excludeInit) {
	
	    // reset some (or all) state, and re-init unless otherwise specified.
	
	    // <d>
	    if (sm2.soundIDs.length) {
	      sm2._wD('Destroying ' + sm2.soundIDs.length + ' SMSound object' + (sm2.soundIDs.length !== 1 ? 's' : '') + '...');
	    }
	    // </d>
	
	    var i, j, k;
	
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	      sm2.sounds[sm2.soundIDs[i]].destruct();
	    }
	
	    // trash ze flash (remove from the DOM)
	
	    if (flash) {
	
	      try {
	
	        if (isIE) {
	          oRemovedHTML = flash.innerHTML;
	        }
	
	        oRemoved = flash.parentNode.removeChild(flash);
	      } catch (e) {
	
	        // Remove failed? May be due to flash blockers silently removing the SWF object/embed node from the DOM. Warn and continue.
	
	        _wDS('badRemove', 2);
	      }
	    }
	
	    // actually, force recreate of movie.
	
	    oRemovedHTML = oRemoved = needsFlash = flash = null;
	
	    sm2.enabled = didDCLoaded = didInit = waitingForEI = initPending = didAppend = appendSuccess = disabled = useGlobalHTML5Audio = sm2.swfLoaded = false;
	
	    sm2.soundIDs = [];
	    sm2.sounds = {};
	
	    idCounter = 0;
	    didSetup = false;
	
	    if (!resetEvents) {
	      // reset callbacks for onready, ontimeout etc. so that they will fire again on re-init
	      for (i in on_queue) {
	        if (on_queue.hasOwnProperty(i)) {
	          for (j = 0, k = on_queue[i].length; j < k; j++) {
	            on_queue[i][j].fired = false;
	          }
	        }
	      }
	    } else {
	      // remove all callbacks entirely
	      on_queue = [];
	    }
	
	    // <d>
	    if (!excludeInit) {
	      sm2._wD(sm + ': Rebooting...');
	    }
	    // </d>
	
	    // reset HTML5 and flash canPlay test results
	
	    sm2.html5 = {
	      'usingFlash': null
	    };
	
	    sm2.flash = {};
	
	    // reset device-specific HTML/flash mode switches
	
	    sm2.html5Only = false;
	    sm2.ignoreFlash = false;
	
	    window.setTimeout(function () {
	
	      // by default, re-init
	
	      if (!excludeInit) {
	        sm2.beginDelayedInit();
	      }
	    }, 20);
	
	    return sm2;
	  };
	
	  this.reset = function () {
	
	    /**
	     * Shuts down and restores the SoundManager instance to its original loaded state, without an explicit reboot. All onready/ontimeout handlers are removed.
	     * After this call, SM2 may be re-initialized via soundManager.beginDelayedInit().
	     * @return {object} soundManager The soundManager instance.
	     */
	
	    _wDS('reset');
	    return sm2.reboot(true, true);
	  };
	
	  /**
	   * Undocumented: Determines the SM2 flash movie's load progress.
	   *
	   * @return {number or null} Percent loaded, or if invalid/unsupported, null.
	   */
	
	  this.getMoviePercent = function () {
	
	    /**
	     * Interesting syntax notes...
	     * Flash/ExternalInterface (ActiveX/NPAPI) bridge methods are not typeof "function" nor instanceof Function, but are still valid.
	     * Additionally, JSLint dislikes ('PercentLoaded' in flash)-style syntax and recommends hasOwnProperty(), which does not work in this case.
	     * Furthermore, using (flash && flash.PercentLoaded) causes IE to throw "object doesn't support this property or method".
	     * Thus, 'in' syntax must be used.
	     */
	
	    return flash && 'PercentLoaded' in flash ? flash.PercentLoaded() : null; // Yes, JSLint. See nearby comment in source for explanation.
	  };
	
	  /**
	   * Additional helper for manually invoking SM2's init process after DOM Ready / window.onload().
	   */
	
	  this.beginDelayedInit = function () {
	
	    windowLoaded = true;
	    _domContentLoaded();
	
	    setTimeout(function () {
	
	      if (initPending) {
	        return false;
	      }
	
	      createMovie();
	      initMovie();
	      initPending = true;
	
	      return true;
	    }, 20);
	
	    delayWaitForEI();
	  };
	
	  /**
	   * Destroys the SoundManager instance and all SMSound instances.
	   */
	
	  this.destruct = function () {
	
	    sm2._wD(sm + '.destruct()');
	    sm2.disable(true);
	  };
	
	  /**
	   * SMSound() (sound object) constructor
	   * ------------------------------------
	   *
	   * @param {object} oOptions Sound options (id and url are required attributes)
	   * @return {SMSound} The new SMSound object
	   */
	
	  SMSound = function SMSound(oOptions) {
	
	    var s = this,
	        resetProperties,
	        add_html5_events,
	        remove_html5_events,
	        stop_html5_timer,
	        start_html5_timer,
	        attachOnPosition,
	        onplay_called = false,
	        onPositionItems = [],
	        onPositionFired = 0,
	        detachOnPosition,
	        applyFromTo,
	        lastURL = null,
	        lastHTML5State,
	        urlOmitted;
	
	    lastHTML5State = {
	      // tracks duration + position (time)
	      duration: null,
	      time: null
	    };
	
	    this.id = oOptions.id;
	
	    // legacy
	    this.sID = this.id;
	
	    this.url = oOptions.url;
	    this.options = _mixin(oOptions);
	
	    // per-play-instance-specific options
	    this.instanceOptions = this.options;
	
	    // short alias
	    this._iO = this.instanceOptions;
	
	    // assign property defaults
	    this.pan = this.options.pan;
	    this.volume = this.options.volume;
	
	    // whether or not this object is using HTML5
	    this.isHTML5 = false;
	
	    // internal HTML5 Audio() object reference
	    this._a = null;
	
	    // for flash 8 special-case createSound() without url, followed by load/play with url case
	    urlOmitted = this.url ? false : true;
	
	    /**
	     * SMSound() public methods
	     * ------------------------
	     */
	
	    this.id3 = {};
	
	    /**
	     * Writes SMSound object parameters to debug console
	     */
	
	    this._debug = function () {
	
	      // <d>
	      sm2._wD(s.id + ': Merged options:', s.options);
	      // </d>
	    };
	
	    /**
	     * Begins loading a sound per its *url*.
	     *
	     * @param {object} oOptions Optional: Sound options
	     * @return {SMSound} The SMSound object
	     */
	
	    this.load = function (oOptions) {
	
	      var oSound = null,
	          instanceOptions;
	
	      if (oOptions !== _undefined) {
	        s._iO = _mixin(oOptions, s.options);
	      } else {
	        oOptions = s.options;
	        s._iO = oOptions;
	        if (lastURL && lastURL !== s.url) {
	          _wDS('manURL');
	          s._iO.url = s.url;
	          s.url = null;
	        }
	      }
	
	      if (!s._iO.url) {
	        s._iO.url = s.url;
	      }
	
	      s._iO.url = parseURL(s._iO.url);
	
	      // ensure we're in sync
	      s.instanceOptions = s._iO;
	
	      // local shortcut
	      instanceOptions = s._iO;
	
	      sm2._wD(s.id + ': load (' + instanceOptions.url + ')');
	
	      if (!instanceOptions.url && !s.url) {
	        sm2._wD(s.id + ': load(): url is unassigned. Exiting.', 2);
	        return s;
	      }
	
	      // <d>
	      if (!s.isHTML5 && fV === 8 && !s.url && !instanceOptions.autoPlay) {
	        // flash 8 load() -> play() won't work before onload has fired.
	        sm2._wD(s.id + ': Flash 8 load() limitation: Wait for onload() before calling play().', 1);
	      }
	      // </d>
	
	      if (instanceOptions.url === s.url && s.readyState !== 0 && s.readyState !== 2) {
	        _wDS('onURL', 1);
	        // if loaded and an onload() exists, fire immediately.
	        if (s.readyState === 3 && instanceOptions.onload) {
	          // assume success based on truthy duration.
	          wrapCallback(s, function () {
	            instanceOptions.onload.apply(s, [!!s.duration]);
	          });
	        }
	        return s;
	      }
	
	      // reset a few state properties
	
	      s.loaded = false;
	      s.readyState = 1;
	      s.playState = 0;
	      s.id3 = {};
	
	      // TODO: If switching from HTML5 -> flash (or vice versa), stop currently-playing audio.
	
	      if (html5OK(instanceOptions)) {
	
	        oSound = s._setup_html5(instanceOptions);
	
	        if (!oSound._called_load) {
	
	          s._html5_canplay = false;
	
	          // TODO: review called_load / html5_canplay logic
	
	          // if url provided directly to load(), assign it here.
	
	          if (s.url !== instanceOptions.url) {
	
	            sm2._wD(_wDS('manURL') + ': ' + instanceOptions.url);
	
	            s._a.src = instanceOptions.url;
	
	            // TODO: review / re-apply all relevant options (volume, loop, onposition etc.)
	
	            // reset position for new URL
	            s.setPosition(0);
	          }
	
	          // given explicit load call, try to preload.
	
	          // early HTML5 implementation (non-standard)
	          s._a.autobuffer = 'auto';
	
	          // standard property, values: none / metadata / auto
	          // reference: http://msdn.microsoft.com/en-us/library/ie/ff974759%28v=vs.85%29.aspx
	          s._a.preload = 'auto';
	
	          s._a._called_load = true;
	        } else {
	
	          sm2._wD(s.id + ': Ignoring request to load again');
	        }
	      } else {
	
	        if (sm2.html5Only) {
	          sm2._wD(s.id + ': No flash support. Exiting.');
	          return s;
	        }
	
	        if (s._iO.url && s._iO.url.match(/data\:/i)) {
	          // data: URIs not supported by Flash, either.
	          sm2._wD(s.id + ': data: URIs not supported via Flash. Exiting.');
	          return s;
	        }
	
	        try {
	          s.isHTML5 = false;
	          s._iO = policyFix(loopFix(instanceOptions));
	          // if we have "position", disable auto-play as we'll be seeking to that position at onload().
	          if (s._iO.autoPlay && (s._iO.position || s._iO.from)) {
	            sm2._wD(s.id + ': Disabling autoPlay because of non-zero offset case');
	            s._iO.autoPlay = false;
	          }
	          // re-assign local shortcut
	          instanceOptions = s._iO;
	          if (fV === 8) {
	            flash._load(s.id, instanceOptions.url, instanceOptions.stream, instanceOptions.autoPlay, instanceOptions.usePolicyFile);
	          } else {
	            flash._load(s.id, instanceOptions.url, !!instanceOptions.stream, !!instanceOptions.autoPlay, instanceOptions.loops || 1, !!instanceOptions.autoLoad, instanceOptions.usePolicyFile);
	          }
	        } catch (e) {
	          _wDS('smError', 2);
	          debugTS('onload', false);
	          catchError({
	            type: 'SMSOUND_LOAD_JS_EXCEPTION',
	            fatal: true
	          });
	        }
	      }
	
	      // after all of this, ensure sound url is up to date.
	      s.url = instanceOptions.url;
	
	      return s;
	    };
	
	    /**
	     * Unloads a sound, canceling any open HTTP requests.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    this.unload = function () {
	
	      // Flash 8/AS2 can't "close" a stream - fake it by loading an empty URL
	      // Flash 9/AS3: Close stream, preventing further load
	      // HTML5: Most UAs will use empty URL
	
	      if (s.readyState !== 0) {
	
	        sm2._wD(s.id + ': unload()');
	
	        if (!s.isHTML5) {
	
	          if (fV === 8) {
	            flash._unload(s.id, emptyURL);
	          } else {
	            flash._unload(s.id);
	          }
	        } else {
	
	          stop_html5_timer();
	
	          if (s._a) {
	
	            s._a.pause();
	
	            // update empty URL, too
	            lastURL = html5Unload(s._a);
	          }
	        }
	
	        // reset load/status flags
	        resetProperties();
	      }
	
	      return s;
	    };
	
	    /**
	     * Unloads and destroys a sound.
	     */
	
	    this.destruct = function (_bFromSM) {
	
	      sm2._wD(s.id + ': Destruct');
	
	      if (!s.isHTML5) {
	
	        // kill sound within Flash
	        // Disable the onfailure handler
	        s._iO.onfailure = null;
	        flash._destroySound(s.id);
	      } else {
	
	        stop_html5_timer();
	
	        if (s._a) {
	          s._a.pause();
	          html5Unload(s._a);
	          if (!useGlobalHTML5Audio) {
	            remove_html5_events();
	          }
	          // break obvious circular reference
	          s._a._s = null;
	          s._a = null;
	        }
	      }
	
	      if (!_bFromSM) {
	        // ensure deletion from controller
	        sm2.destroySound(s.id, true);
	      }
	    };
	
	    /**
	     * Begins playing a sound.
	     *
	     * @param {object} oOptions Optional: Sound options
	     * @return {SMSound} The SMSound object
	     */
	
	    this.play = function (oOptions, _updatePlayState) {
	
	      var fN,
	          allowMulti,
	          a,
	          onready,
	          audioClone,
	          _onended,
	          _oncanplay,
	          startOK = true,
	          exit = null;
	
	      // <d>
	      fN = s.id + ': play(): ';
	      // </d>
	
	      // default to true
	      _updatePlayState = _updatePlayState === _undefined ? true : _updatePlayState;
	
	      if (!oOptions) {
	        oOptions = {};
	      }
	
	      // first, use local URL (if specified)
	      if (s.url) {
	        s._iO.url = s.url;
	      }
	
	      // mix in any options defined at createSound()
	      s._iO = _mixin(s._iO, s.options);
	
	      // mix in any options specific to this method
	      s._iO = _mixin(oOptions, s._iO);
	
	      s._iO.url = parseURL(s._iO.url);
	
	      s.instanceOptions = s._iO;
	
	      // RTMP-only
	      if (!s.isHTML5 && s._iO.serverURL && !s.connected) {
	        if (!s.getAutoPlay()) {
	          sm2._wD(fN + ' Netstream not connected yet - setting autoPlay');
	          s.setAutoPlay(true);
	        }
	        // play will be called in onconnect()
	        return s;
	      }
	
	      if (html5OK(s._iO)) {
	        s._setup_html5(s._iO);
	        start_html5_timer();
	      }
	
	      if (s.playState === 1 && !s.paused) {
	
	        allowMulti = s._iO.multiShot;
	
	        if (!allowMulti) {
	
	          sm2._wD(fN + 'Already playing (one-shot)', 1);
	
	          if (s.isHTML5) {
	            // go back to original position.
	            s.setPosition(s._iO.position);
	          }
	
	          exit = s;
	        } else {
	          sm2._wD(fN + 'Already playing (multi-shot)', 1);
	        }
	      }
	
	      if (exit !== null) {
	        return exit;
	      }
	
	      // edge case: play() with explicit URL parameter
	      if (oOptions.url && oOptions.url !== s.url) {
	
	        // special case for createSound() followed by load() / play() with url; avoid double-load case.
	        if (!s.readyState && !s.isHTML5 && fV === 8 && urlOmitted) {
	
	          urlOmitted = false;
	        } else {
	
	          // load using merged options
	          s.load(s._iO);
	        }
	      }
	
	      if (!s.loaded) {
	
	        if (s.readyState === 0) {
	
	          sm2._wD(fN + 'Attempting to load');
	
	          // try to get this sound playing ASAP
	          if (!s.isHTML5 && !sm2.html5Only) {
	
	            // flash: assign directly because setAutoPlay() increments the instanceCount
	            s._iO.autoPlay = true;
	            s.load(s._iO);
	          } else if (s.isHTML5) {
	
	            // iOS needs this when recycling sounds, loading a new URL on an existing object.
	            s.load(s._iO);
	          } else {
	
	            sm2._wD(fN + 'Unsupported type. Exiting.');
	            exit = s;
	          }
	
	          // HTML5 hack - re-set instanceOptions?
	          s.instanceOptions = s._iO;
	        } else if (s.readyState === 2) {
	
	          sm2._wD(fN + 'Could not load - exiting', 2);
	          exit = s;
	        } else {
	
	          sm2._wD(fN + 'Loading - attempting to play...');
	        }
	      } else {
	
	        // "play()"
	        sm2._wD(fN.substr(0, fN.lastIndexOf(':')));
	      }
	
	      if (exit !== null) {
	        return exit;
	      }
	
	      if (!s.isHTML5 && fV === 9 && s.position > 0 && s.position === s.duration) {
	        // flash 9 needs a position reset if play() is called while at the end of a sound.
	        sm2._wD(fN + 'Sound at end, resetting to position: 0');
	        oOptions.position = 0;
	      }
	
	      /**
	       * Streams will pause when their buffer is full if they are being loaded.
	       * In this case paused is true, but the song hasn't started playing yet.
	       * If we just call resume() the onplay() callback will never be called.
	       * So only call resume() if the position is > 0.
	       * Another reason is because options like volume won't have been applied yet.
	       * For normal sounds, just resume.
	       */
	
	      if (s.paused && s.position >= 0 && (!s._iO.serverURL || s.position > 0)) {
	
	        // https://gist.github.com/37b17df75cc4d7a90bf6
	        sm2._wD(fN + 'Resuming from paused state', 1);
	        s.resume();
	      } else {
	
	        s._iO = _mixin(oOptions, s._iO);
	
	        /**
	         * Preload in the event of play() with position under Flash,
	         * or from/to parameters and non-RTMP case
	         */
	        if ((!s.isHTML5 && s._iO.position !== null && s._iO.position > 0 || s._iO.from !== null && s._iO.from > 0 || s._iO.to !== null) && s.instanceCount === 0 && s.playState === 0 && !s._iO.serverURL) {
	
	          onready = function onready() {
	            // sound "canplay" or onload()
	            // re-apply position/from/to to instance options, and start playback
	            s._iO = _mixin(oOptions, s._iO);
	            s.play(s._iO);
	          };
	
	          // HTML5 needs to at least have "canplay" fired before seeking.
	          if (s.isHTML5 && !s._html5_canplay) {
	
	            // this hasn't been loaded yet. load it first, and then do this again.
	            sm2._wD(fN + 'Beginning load for non-zero offset case');
	
	            s.load({
	              // note: custom HTML5-only event added for from/to implementation.
	              _oncanplay: onready
	            });
	
	            exit = false;
	          } else if (!s.isHTML5 && !s.loaded && (!s.readyState || s.readyState !== 2)) {
	
	            // to be safe, preload the whole thing in Flash.
	
	            sm2._wD(fN + 'Preloading for non-zero offset case');
	
	            s.load({
	              onload: onready
	            });
	
	            exit = false;
	          }
	
	          if (exit !== null) {
	            return exit;
	          }
	
	          // otherwise, we're ready to go. re-apply local options, and continue
	
	          s._iO = applyFromTo();
	        }
	
	        // sm2._wD(fN + 'Starting to play');
	
	        // increment instance counter, where enabled + supported
	        if (!s.instanceCount || s._iO.multiShotEvents || s.isHTML5 && s._iO.multiShot && !useGlobalHTML5Audio || !s.isHTML5 && fV > 8 && !s.getAutoPlay()) {
	          s.instanceCount++;
	        }
	
	        // if first play and onposition parameters exist, apply them now
	        if (s._iO.onposition && s.playState === 0) {
	          attachOnPosition(s);
	        }
	
	        s.playState = 1;
	        s.paused = false;
	
	        s.position = s._iO.position !== _undefined && !isNaN(s._iO.position) ? s._iO.position : 0;
	
	        if (!s.isHTML5) {
	          s._iO = policyFix(loopFix(s._iO));
	        }
	
	        if (s._iO.onplay && _updatePlayState) {
	          s._iO.onplay.apply(s);
	          onplay_called = true;
	        }
	
	        s.setVolume(s._iO.volume, true);
	        s.setPan(s._iO.pan, true);
	
	        if (!s.isHTML5) {
	
	          startOK = flash._start(s.id, s._iO.loops || 1, fV === 9 ? s.position : s.position / msecScale, s._iO.multiShot || false);
	
	          if (fV === 9 && !startOK) {
	            // edge case: no sound hardware, or 32-channel flash ceiling hit.
	            // applies only to Flash 9, non-NetStream/MovieStar sounds.
	            // http://help.adobe.com/en_US/FlashPlatform/reference/actionscript/3/flash/media/Sound.html#play%28%29
	            sm2._wD(fN + 'No sound hardware, or 32-sound ceiling hit', 2);
	            if (s._iO.onplayerror) {
	              s._iO.onplayerror.apply(s);
	            }
	          }
	        } else {
	
	          if (s.instanceCount < 2) {
	
	            // HTML5 single-instance case
	
	            start_html5_timer();
	
	            a = s._setup_html5();
	
	            s.setPosition(s._iO.position);
	
	            a.play();
	          } else {
	
	            // HTML5 multi-shot case
	
	            sm2._wD(s.id + ': Cloning Audio() for instance #' + s.instanceCount + '...');
	
	            audioClone = new Audio(s._iO.url);
	
	            _onended = function onended() {
	              event.remove(audioClone, 'ended', _onended);
	              s._onfinish(s);
	              // cleanup
	              html5Unload(audioClone);
	              audioClone = null;
	            };
	
	            _oncanplay = function oncanplay() {
	              event.remove(audioClone, 'canplay', _oncanplay);
	              try {
	                audioClone.currentTime = s._iO.position / msecScale;
	              } catch (err) {
	                complain(s.id + ': multiShot play() failed to apply position of ' + s._iO.position / msecScale);
	              }
	              audioClone.play();
	            };
	
	            event.add(audioClone, 'ended', _onended);
	
	            // apply volume to clones, too
	            if (s._iO.volume !== _undefined) {
	              audioClone.volume = Math.max(0, Math.min(1, s._iO.volume / 100));
	            }
	
	            // playing multiple muted sounds? if you do this, you're weird ;) - but let's cover it.
	            if (s.muted) {
	              audioClone.muted = true;
	            }
	
	            if (s._iO.position) {
	              // HTML5 audio can't seek before onplay() event has fired.
	              // wait for canplay, then seek to position and start playback.
	              event.add(audioClone, 'canplay', _oncanplay);
	            } else {
	              // begin playback at currentTime: 0
	              audioClone.play();
	            }
	          }
	        }
	      }
	
	      return s;
	    };
	
	    // just for convenience
	    this.start = this.play;
	
	    /**
	     * Stops playing a sound (and optionally, all sounds)
	     *
	     * @param {boolean} bAll Optional: Whether to stop all sounds
	     * @return {SMSound} The SMSound object
	     */
	
	    this.stop = function (bAll) {
	
	      var instanceOptions = s._iO,
	          originalPosition;
	
	      if (s.playState === 1) {
	
	        sm2._wD(s.id + ': stop()');
	
	        s._onbufferchange(0);
	        s._resetOnPosition(0);
	        s.paused = false;
	
	        if (!s.isHTML5) {
	          s.playState = 0;
	        }
	
	        // remove onPosition listeners, if any
	        detachOnPosition();
	
	        // and "to" position, if set
	        if (instanceOptions.to) {
	          s.clearOnPosition(instanceOptions.to);
	        }
	
	        if (!s.isHTML5) {
	
	          flash._stop(s.id, bAll);
	
	          // hack for netStream: just unload
	          if (instanceOptions.serverURL) {
	            s.unload();
	          }
	        } else {
	
	          if (s._a) {
	
	            originalPosition = s.position;
	
	            // act like Flash, though
	            s.setPosition(0);
	
	            // hack: reflect old position for onstop() (also like Flash)
	            s.position = originalPosition;
	
	            // html5 has no stop()
	            // NOTE: pausing means iOS requires interaction to resume.
	            s._a.pause();
	
	            s.playState = 0;
	
	            // and update UI
	            s._onTimer();
	
	            stop_html5_timer();
	          }
	        }
	
	        s.instanceCount = 0;
	        s._iO = {};
	
	        if (instanceOptions.onstop) {
	          instanceOptions.onstop.apply(s);
	        }
	      }
	
	      return s;
	    };
	
	    /**
	     * Undocumented/internal: Sets autoPlay for RTMP.
	     *
	     * @param {boolean} autoPlay state
	     */
	
	    this.setAutoPlay = function (autoPlay) {
	
	      sm2._wD(s.id + ': Autoplay turned ' + (autoPlay ? 'on' : 'off'));
	      s._iO.autoPlay = autoPlay;
	
	      if (!s.isHTML5) {
	        flash._setAutoPlay(s.id, autoPlay);
	        if (autoPlay) {
	          // only increment the instanceCount if the sound isn't loaded (TODO: verify RTMP)
	          if (!s.instanceCount && s.readyState === 1) {
	            s.instanceCount++;
	            sm2._wD(s.id + ': Incremented instance count to ' + s.instanceCount);
	          }
	        }
	      }
	    };
	
	    /**
	     * Undocumented/internal: Returns the autoPlay boolean.
	     *
	     * @return {boolean} The current autoPlay value
	     */
	
	    this.getAutoPlay = function () {
	
	      return s._iO.autoPlay;
	    };
	
	    /**
	     * Sets the position of a sound.
	     *
	     * @param {number} nMsecOffset Position (milliseconds)
	     * @return {SMSound} The SMSound object
	     */
	
	    this.setPosition = function (nMsecOffset) {
	
	      if (nMsecOffset === _undefined) {
	        nMsecOffset = 0;
	      }
	
	      var position,
	          position1K,
	
	      // Use the duration from the instance options, if we don't have a track duration yet.
	      // position >= 0 and <= current available (loaded) duration
	      offset = s.isHTML5 ? Math.max(nMsecOffset, 0) : Math.min(s.duration || s._iO.duration, Math.max(nMsecOffset, 0));
	
	      s.position = offset;
	      position1K = s.position / msecScale;
	      s._resetOnPosition(s.position);
	      s._iO.position = offset;
	
	      if (!s.isHTML5) {
	
	        position = fV === 9 ? s.position : position1K;
	
	        if (s.readyState && s.readyState !== 2) {
	          // if paused or not playing, will not resume (by playing)
	          flash._setPosition(s.id, position, s.paused || !s.playState, s._iO.multiShot);
	        }
	      } else if (s._a) {
	
	        // Set the position in the canplay handler if the sound is not ready yet
	        if (s._html5_canplay) {
	
	          if (s._a.currentTime !== position1K) {
	
	            /**
	             * DOM/JS errors/exceptions to watch out for:
	             * if seek is beyond (loaded?) position, "DOM exception 11"
	             * "INDEX_SIZE_ERR": DOM exception 1
	             */
	            sm2._wD(s.id + ': setPosition(' + position1K + ')');
	
	            try {
	              s._a.currentTime = position1K;
	              if (s.playState === 0 || s.paused) {
	                // allow seek without auto-play/resume
	                s._a.pause();
	              }
	            } catch (e) {
	              sm2._wD(s.id + ': setPosition(' + position1K + ') failed: ' + e.message, 2);
	            }
	          }
	        } else if (position1K) {
	
	          // warn on non-zero seek attempts
	          sm2._wD(s.id + ': setPosition(' + position1K + '): Cannot seek yet, sound not ready', 2);
	          return s;
	        }
	
	        if (s.paused) {
	
	          // if paused, refresh UI right away by forcing update
	          s._onTimer(true);
	        }
	      }
	
	      return s;
	    };
	
	    /**
	     * Pauses sound playback.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    this.pause = function (_bCallFlash) {
	
	      if (s.paused || s.playState === 0 && s.readyState !== 1) {
	        return s;
	      }
	
	      sm2._wD(s.id + ': pause()');
	      s.paused = true;
	
	      if (!s.isHTML5) {
	        if (_bCallFlash || _bCallFlash === _undefined) {
	          flash._pause(s.id, s._iO.multiShot);
	        }
	      } else {
	        s._setup_html5().pause();
	        stop_html5_timer();
	      }
	
	      if (s._iO.onpause) {
	        s._iO.onpause.apply(s);
	      }
	
	      return s;
	    };
	
	    /**
	     * Resumes sound playback.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    /**
	     * When auto-loaded streams pause on buffer full they have a playState of 0.
	     * We need to make sure that the playState is set to 1 when these streams "resume".
	     * When a paused stream is resumed, we need to trigger the onplay() callback if it
	     * hasn't been called already. In this case since the sound is being played for the
	     * first time, I think it's more appropriate to call onplay() rather than onresume().
	     */
	
	    this.resume = function () {
	
	      var instanceOptions = s._iO;
	
	      if (!s.paused) {
	        return s;
	      }
	
	      sm2._wD(s.id + ': resume()');
	      s.paused = false;
	      s.playState = 1;
	
	      if (!s.isHTML5) {
	
	        if (instanceOptions.isMovieStar && !instanceOptions.serverURL) {
	          // Bizarre Webkit bug (Chrome reported via 8tracks.com dudes): AAC content paused for 30+ seconds(?) will not resume without a reposition.
	          s.setPosition(s.position);
	        }
	
	        // flash method is toggle-based (pause/resume)
	        flash._pause(s.id, instanceOptions.multiShot);
	      } else {
	
	        s._setup_html5().play();
	        start_html5_timer();
	      }
	
	      if (!onplay_called && instanceOptions.onplay) {
	
	        instanceOptions.onplay.apply(s);
	        onplay_called = true;
	      } else if (instanceOptions.onresume) {
	
	        instanceOptions.onresume.apply(s);
	      }
	
	      return s;
	    };
	
	    /**
	     * Toggles sound playback.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    this.togglePause = function () {
	
	      sm2._wD(s.id + ': togglePause()');
	
	      if (s.playState === 0) {
	        s.play({
	          position: fV === 9 && !s.isHTML5 ? s.position : s.position / msecScale
	        });
	        return s;
	      }
	
	      if (s.paused) {
	        s.resume();
	      } else {
	        s.pause();
	      }
	
	      return s;
	    };
	
	    /**
	     * Sets the panning (L-R) effect.
	     *
	     * @param {number} nPan The pan value (-100 to 100)
	     * @return {SMSound} The SMSound object
	     */
	
	    this.setPan = function (nPan, bInstanceOnly) {
	
	      if (nPan === _undefined) {
	        nPan = 0;
	      }
	
	      if (bInstanceOnly === _undefined) {
	        bInstanceOnly = false;
	      }
	
	      if (!s.isHTML5) {
	        flash._setPan(s.id, nPan);
	      } // else { no HTML5 pan? }
	
	      s._iO.pan = nPan;
	
	      if (!bInstanceOnly) {
	        s.pan = nPan;
	        s.options.pan = nPan;
	      }
	
	      return s;
	    };
	
	    /**
	     * Sets the volume.
	     *
	     * @param {number} nVol The volume value (0 to 100)
	     * @return {SMSound} The SMSound object
	     */
	
	    this.setVolume = function (nVol, _bInstanceOnly) {
	
	      /**
	       * Note: Setting volume has no effect on iOS "special snowflake" devices.
	       * Hardware volume control overrides software, and volume
	       * will always return 1 per Apple docs. (iOS 4 + 5.)
	       * http://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/AddingSoundtoCanvasAnimations/AddingSoundtoCanvasAnimations.html
	       */
	
	      if (nVol === _undefined) {
	        nVol = 100;
	      }
	
	      if (_bInstanceOnly === _undefined) {
	        _bInstanceOnly = false;
	      }
	
	      if (!s.isHTML5) {
	
	        flash._setVolume(s.id, sm2.muted && !s.muted || s.muted ? 0 : nVol);
	      } else if (s._a) {
	
	        if (sm2.muted && !s.muted) {
	          s.muted = true;
	          s._a.muted = true;
	        }
	
	        // valid range for native HTML5 Audio(): 0-1
	        s._a.volume = Math.max(0, Math.min(1, nVol / 100));
	      }
	
	      s._iO.volume = nVol;
	
	      if (!_bInstanceOnly) {
	        s.volume = nVol;
	        s.options.volume = nVol;
	      }
	
	      return s;
	    };
	
	    /**
	     * Mutes the sound.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    this.mute = function () {
	
	      s.muted = true;
	
	      if (!s.isHTML5) {
	        flash._setVolume(s.id, 0);
	      } else if (s._a) {
	        s._a.muted = true;
	      }
	
	      return s;
	    };
	
	    /**
	     * Unmutes the sound.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    this.unmute = function () {
	
	      s.muted = false;
	      var hasIO = s._iO.volume !== _undefined;
	
	      if (!s.isHTML5) {
	        flash._setVolume(s.id, hasIO ? s._iO.volume : s.options.volume);
	      } else if (s._a) {
	        s._a.muted = false;
	      }
	
	      return s;
	    };
	
	    /**
	     * Toggles the muted state of a sound.
	     *
	     * @return {SMSound} The SMSound object
	     */
	
	    this.toggleMute = function () {
	
	      return s.muted ? s.unmute() : s.mute();
	    };
	
	    /**
	     * Registers a callback to be fired when a sound reaches a given position during playback.
	     *
	     * @param {number} nPosition The position to watch for
	     * @param {function} oMethod The relevant callback to fire
	     * @param {object} oScope Optional: The scope to apply the callback to
	     * @return {SMSound} The SMSound object
	     */
	
	    this.onPosition = function (nPosition, oMethod, oScope) {
	
	      // TODO: basic dupe checking?
	
	      onPositionItems.push({
	        position: parseInt(nPosition, 10),
	        method: oMethod,
	        scope: oScope !== _undefined ? oScope : s,
	        fired: false
	      });
	
	      return s;
	    };
	
	    // legacy/backwards-compability: lower-case method name
	    this.onposition = this.onPosition;
	
	    /**
	     * Removes registered callback(s) from a sound, by position and/or callback.
	     *
	     * @param {number} nPosition The position to clear callback(s) for
	     * @param {function} oMethod Optional: Identify one callback to be removed when multiple listeners exist for one position
	     * @return {SMSound} The SMSound object
	     */
	
	    this.clearOnPosition = function (nPosition, oMethod) {
	
	      var i;
	
	      nPosition = parseInt(nPosition, 10);
	
	      if (isNaN(nPosition)) {
	        // safety check
	        return false;
	      }
	
	      for (i = 0; i < onPositionItems.length; i++) {
	
	        if (nPosition === onPositionItems[i].position) {
	          // remove this item if no method was specified, or, if the method matches
	
	          if (!oMethod || oMethod === onPositionItems[i].method) {
	
	            if (onPositionItems[i].fired) {
	              // decrement "fired" counter, too
	              onPositionFired--;
	            }
	
	            onPositionItems.splice(i, 1);
	          }
	        }
	      }
	    };
	
	    this._processOnPosition = function () {
	
	      var i,
	          item,
	          j = onPositionItems.length;
	
	      if (!j || !s.playState || onPositionFired >= j) {
	        return false;
	      }
	
	      for (i = j - 1; i >= 0; i--) {
	
	        item = onPositionItems[i];
	
	        if (!item.fired && s.position >= item.position) {
	
	          item.fired = true;
	          onPositionFired++;
	          item.method.apply(item.scope, [item.position]);
	
	          //  reset j -- onPositionItems.length can be changed in the item callback above... occasionally breaking the loop.
	          j = onPositionItems.length;
	        }
	      }
	
	      return true;
	    };
	
	    this._resetOnPosition = function (nPosition) {
	
	      // reset "fired" for items interested in this position
	      var i,
	          item,
	          j = onPositionItems.length;
	
	      if (!j) {
	        return false;
	      }
	
	      for (i = j - 1; i >= 0; i--) {
	
	        item = onPositionItems[i];
	
	        if (item.fired && nPosition <= item.position) {
	          item.fired = false;
	          onPositionFired--;
	        }
	      }
	
	      return true;
	    };
	
	    /**
	     * SMSound() private internals
	     * --------------------------------
	     */
	
	    applyFromTo = function applyFromTo() {
	
	      var instanceOptions = s._iO,
	          f = instanceOptions.from,
	          t = instanceOptions.to,
	          start,
	          _end;
	
	      _end = function end() {
	
	        // end has been reached.
	        sm2._wD(s.id + ': "To" time of ' + t + ' reached.');
	
	        // detach listener
	        s.clearOnPosition(t, _end);
	
	        // stop should clear this, too
	        s.stop();
	      };
	
	      start = function start() {
	
	        sm2._wD(s.id + ': Playing "from" ' + f);
	
	        // add listener for end
	        if (t !== null && !isNaN(t)) {
	          s.onPosition(t, _end);
	        }
	      };
	
	      if (f !== null && !isNaN(f)) {
	
	        // apply to instance options, guaranteeing correct start position.
	        instanceOptions.position = f;
	
	        // multiShot timing can't be tracked, so prevent that.
	        instanceOptions.multiShot = false;
	
	        start();
	      }
	
	      // return updated instanceOptions including starting position
	      return instanceOptions;
	    };
	
	    attachOnPosition = function attachOnPosition() {
	
	      var item,
	          op = s._iO.onposition;
	
	      // attach onposition things, if any, now.
	
	      if (op) {
	
	        for (item in op) {
	          if (op.hasOwnProperty(item)) {
	            s.onPosition(parseInt(item, 10), op[item]);
	          }
	        }
	      }
	    };
	
	    detachOnPosition = function detachOnPosition() {
	
	      var item,
	          op = s._iO.onposition;
	
	      // detach any onposition()-style listeners.
	
	      if (op) {
	
	        for (item in op) {
	          if (op.hasOwnProperty(item)) {
	            s.clearOnPosition(parseInt(item, 10));
	          }
	        }
	      }
	    };
	
	    start_html5_timer = function start_html5_timer() {
	
	      if (s.isHTML5) {
	        startTimer(s);
	      }
	    };
	
	    stop_html5_timer = function stop_html5_timer() {
	
	      if (s.isHTML5) {
	        stopTimer(s);
	      }
	    };
	
	    resetProperties = function resetProperties(retainPosition) {
	
	      if (!retainPosition) {
	        onPositionItems = [];
	        onPositionFired = 0;
	      }
	
	      onplay_called = false;
	
	      s._hasTimer = null;
	      s._a = null;
	      s._html5_canplay = false;
	      s.bytesLoaded = null;
	      s.bytesTotal = null;
	      s.duration = s._iO && s._iO.duration ? s._iO.duration : null;
	      s.durationEstimate = null;
	      s.buffered = [];
	
	      // legacy: 1D array
	      s.eqData = [];
	
	      s.eqData.left = [];
	      s.eqData.right = [];
	
	      s.failures = 0;
	      s.isBuffering = false;
	      s.instanceOptions = {};
	      s.instanceCount = 0;
	      s.loaded = false;
	      s.metadata = {};
	
	      // 0 = uninitialised, 1 = loading, 2 = failed/error, 3 = loaded/success
	      s.readyState = 0;
	
	      s.muted = false;
	      s.paused = false;
	
	      s.peakData = {
	        left: 0,
	        right: 0
	      };
	
	      s.waveformData = {
	        left: [],
	        right: []
	      };
	
	      s.playState = 0;
	      s.position = null;
	
	      s.id3 = {};
	    };
	
	    resetProperties();
	
	    /**
	     * Pseudo-private SMSound internals
	     * --------------------------------
	     */
	
	    this._onTimer = function (bForce) {
	
	      /**
	       * HTML5-only _whileplaying() etc.
	       * called from both HTML5 native events, and polling/interval-based timers
	       * mimics flash and fires only when time/duration change, so as to be polling-friendly
	       */
	
	      var duration,
	          isNew = false,
	          time,
	          x = {};
	
	      if (s._hasTimer || bForce) {
	
	        // TODO: May not need to track readyState (1 = loading)
	
	        if (s._a && (bForce || (s.playState > 0 || s.readyState === 1) && !s.paused)) {
	
	          duration = s._get_html5_duration();
	
	          if (duration !== lastHTML5State.duration) {
	
	            lastHTML5State.duration = duration;
	            s.duration = duration;
	            isNew = true;
	          }
	
	          // TODO: investigate why this goes wack if not set/re-set each time.
	          s.durationEstimate = s.duration;
	
	          time = s._a.currentTime * msecScale || 0;
	
	          if (time !== lastHTML5State.time) {
	
	            lastHTML5State.time = time;
	            isNew = true;
	          }
	
	          if (isNew || bForce) {
	
	            s._whileplaying(time, x, x, x, x);
	          }
	        } /* else {
	           // sm2._wD('_onTimer: Warn for "'+s.id+'": '+(!s._a?'Could not find element. ':'')+(s.playState === 0?'playState bad, 0?':'playState = '+s.playState+', OK'));
	           return false;
	          }*/
	
	        return isNew;
	      }
	    };
	
	    this._get_html5_duration = function () {
	
	      var instanceOptions = s._iO,
	
	      // if audio object exists, use its duration - else, instance option duration (if provided - it's a hack, really, and should be retired) OR null
	      d = s._a && s._a.duration ? s._a.duration * msecScale : instanceOptions && instanceOptions.duration ? instanceOptions.duration : null,
	          result = d && !isNaN(d) && d !== Infinity ? d : null;
	
	      return result;
	    };
	
	    this._apply_loop = function (a, nLoops) {
	
	      /**
	       * boolean instead of "loop", for webkit? - spec says string. http://www.w3.org/TR/html-markup/audio.html#audio.attrs.loop
	       * note that loop is either off or infinite under HTML5, unlike Flash which allows arbitrary loop counts to be specified.
	       */
	
	      // <d>
	      if (!a.loop && nLoops > 1) {
	        sm2._wD('Note: Native HTML5 looping is infinite.', 1);
	      }
	      // </d>
	
	      a.loop = nLoops > 1 ? 'loop' : '';
	    };
	
	    this._setup_html5 = function (oOptions) {
	
	      var instanceOptions = _mixin(s._iO, oOptions),
	          a = useGlobalHTML5Audio ? globalHTML5Audio : s._a,
	          dURL = decodeURI(instanceOptions.url),
	          sameURL;
	
	      /**
	       * "First things first, I, Poppa..." (reset the previous state of the old sound, if playing)
	       * Fixes case with devices that can only play one sound at a time
	       * Otherwise, other sounds in mid-play will be terminated without warning and in a stuck state
	       */
	
	      if (useGlobalHTML5Audio) {
	
	        if (dURL === decodeURI(lastGlobalHTML5URL)) {
	          // global HTML5 audio: re-use of URL
	          sameURL = true;
	        }
	      } else if (dURL === decodeURI(lastURL)) {
	
	        // options URL is the same as the "last" URL, and we used (loaded) it
	        sameURL = true;
	      }
	
	      if (a) {
	
	        if (a._s) {
	
	          if (useGlobalHTML5Audio) {
	
	            if (a._s && a._s.playState && !sameURL) {
	
	              // global HTML5 audio case, and loading a new URL. stop the currently-playing one.
	              a._s.stop();
	            }
	          } else if (!useGlobalHTML5Audio && dURL === decodeURI(lastURL)) {
	
	            // non-global HTML5 reuse case: same url, ignore request
	            s._apply_loop(a, instanceOptions.loops);
	
	            return a;
	          }
	        }
	
	        if (!sameURL) {
	
	          // don't retain onPosition() stuff with new URLs.
	
	          if (lastURL) {
	            resetProperties(false);
	          }
	
	          // assign new HTML5 URL
	
	          a.src = instanceOptions.url;
	
	          s.url = instanceOptions.url;
	
	          lastURL = instanceOptions.url;
	
	          lastGlobalHTML5URL = instanceOptions.url;
	
	          a._called_load = false;
	        }
	      } else {
	
	        if (instanceOptions.autoLoad || instanceOptions.autoPlay) {
	
	          s._a = new Audio(instanceOptions.url);
	          s._a.load();
	        } else {
	
	          // null for stupid Opera 9.64 case
	          s._a = isOpera && opera.version() < 10 ? new Audio(null) : new Audio();
	        }
	
	        // assign local reference
	        a = s._a;
	
	        a._called_load = false;
	
	        if (useGlobalHTML5Audio) {
	
	          globalHTML5Audio = a;
	        }
	      }
	
	      s.isHTML5 = true;
	
	      // store a ref on the track
	      s._a = a;
	
	      // store a ref on the audio
	      a._s = s;
	
	      add_html5_events();
	
	      s._apply_loop(a, instanceOptions.loops);
	
	      if (instanceOptions.autoLoad || instanceOptions.autoPlay) {
	
	        s.load();
	      } else {
	
	        // early HTML5 implementation (non-standard)
	        a.autobuffer = false;
	
	        // standard ('none' is also an option.)
	        a.preload = 'auto';
	      }
	
	      return a;
	    };
	
	    add_html5_events = function add_html5_events() {
	
	      if (s._a._added_events) {
	        return false;
	      }
	
	      var f;
	
	      function add(oEvt, oFn, bCapture) {
	        return s._a ? s._a.addEventListener(oEvt, oFn, bCapture || false) : null;
	      }
	
	      s._a._added_events = true;
	
	      for (f in html5_events) {
	        if (html5_events.hasOwnProperty(f)) {
	          add(f, html5_events[f]);
	        }
	      }
	
	      return true;
	    };
	
	    remove_html5_events = function remove_html5_events() {
	
	      // Remove event listeners
	
	      var f;
	
	      function remove(oEvt, oFn, bCapture) {
	        return s._a ? s._a.removeEventListener(oEvt, oFn, bCapture || false) : null;
	      }
	
	      sm2._wD(s.id + ': Removing event listeners');
	      s._a._added_events = false;
	
	      for (f in html5_events) {
	        if (html5_events.hasOwnProperty(f)) {
	          remove(f, html5_events[f]);
	        }
	      }
	    };
	
	    /**
	     * Pseudo-private event internals
	     * ------------------------------
	     */
	
	    this._onload = function (nSuccess) {
	
	      var fN,
	
	      // check for duration to prevent false positives from flash 8 when loading from cache.
	      loadOK = !!nSuccess || !s.isHTML5 && fV === 8 && s.duration;
	
	      // <d>
	      fN = s.id + ': ';
	      sm2._wD(fN + (loadOK ? 'onload()' : 'Failed to load / invalid sound?' + (!s.duration ? ' Zero-length duration reported.' : ' -') + ' (' + s.url + ')'), loadOK ? 1 : 2);
	
	      if (!loadOK && !s.isHTML5) {
	        if (sm2.sandbox.noRemote === true) {
	          sm2._wD(fN + str('noNet'), 1);
	        }
	        if (sm2.sandbox.noLocal === true) {
	          sm2._wD(fN + str('noLocal'), 1);
	        }
	      }
	      // </d>
	
	      s.loaded = loadOK;
	      s.readyState = loadOK ? 3 : 2;
	      s._onbufferchange(0);
	
	      if (s._iO.onload) {
	        wrapCallback(s, function () {
	          s._iO.onload.apply(s, [loadOK]);
	        });
	      }
	
	      return true;
	    };
	
	    this._onbufferchange = function (nIsBuffering) {
	
	      if (s.playState === 0) {
	        // ignore if not playing
	        return false;
	      }
	
	      if (nIsBuffering && s.isBuffering || !nIsBuffering && !s.isBuffering) {
	        return false;
	      }
	
	      s.isBuffering = nIsBuffering === 1;
	
	      if (s._iO.onbufferchange) {
	        sm2._wD(s.id + ': Buffer state change: ' + nIsBuffering);
	        s._iO.onbufferchange.apply(s, [nIsBuffering]);
	      }
	
	      return true;
	    };
	
	    /**
	     * Playback may have stopped due to buffering, or related reason.
	     * This state can be encountered on iOS < 6 when auto-play is blocked.
	     */
	
	    this._onsuspend = function () {
	
	      if (s._iO.onsuspend) {
	        sm2._wD(s.id + ': Playback suspended');
	        s._iO.onsuspend.apply(s);
	      }
	
	      return true;
	    };
	
	    /**
	     * flash 9/movieStar + RTMP-only method, should fire only once at most
	     * at this point we just recreate failed sounds rather than trying to reconnect
	     */
	
	    this._onfailure = function (msg, level, code) {
	
	      s.failures++;
	      sm2._wD(s.id + ': Failure (' + s.failures + '): ' + msg);
	
	      if (s._iO.onfailure && s.failures === 1) {
	        s._iO.onfailure(msg, level, code);
	      } else {
	        sm2._wD(s.id + ': Ignoring failure');
	      }
	    };
	
	    /**
	     * flash 9/movieStar + RTMP-only method for unhandled warnings/exceptions from Flash
	     * e.g., RTMP "method missing" warning (non-fatal) for getStreamLength on server
	     */
	
	    this._onwarning = function (msg, level, code) {
	
	      if (s._iO.onwarning) {
	        s._iO.onwarning(msg, level, code);
	      }
	    };
	
	    this._onfinish = function () {
	
	      // store local copy before it gets trashed...
	      var io_onfinish = s._iO.onfinish;
	
	      s._onbufferchange(0);
	      s._resetOnPosition(0);
	
	      // reset some state items
	      if (s.instanceCount) {
	
	        s.instanceCount--;
	
	        if (!s.instanceCount) {
	
	          // remove onPosition listeners, if any
	          detachOnPosition();
	
	          // reset instance options
	          s.playState = 0;
	          s.paused = false;
	          s.instanceCount = 0;
	          s.instanceOptions = {};
	          s._iO = {};
	          stop_html5_timer();
	
	          // reset position, too
	          if (s.isHTML5) {
	            s.position = 0;
	          }
	        }
	
	        if (!s.instanceCount || s._iO.multiShotEvents) {
	          // fire onfinish for last, or every instance
	          if (io_onfinish) {
	            sm2._wD(s.id + ': onfinish()');
	            wrapCallback(s, function () {
	              io_onfinish.apply(s);
	            });
	          }
	        }
	      }
	    };
	
	    this._whileloading = function (nBytesLoaded, nBytesTotal, nDuration, nBufferLength) {
	
	      var instanceOptions = s._iO;
	
	      s.bytesLoaded = nBytesLoaded;
	      s.bytesTotal = nBytesTotal;
	      s.duration = Math.floor(nDuration);
	      s.bufferLength = nBufferLength;
	
	      if (!s.isHTML5 && !instanceOptions.isMovieStar) {
	
	        if (instanceOptions.duration) {
	          // use duration from options, if specified and larger. nobody should be specifying duration in options, actually, and it should be retired.
	          s.durationEstimate = s.duration > instanceOptions.duration ? s.duration : instanceOptions.duration;
	        } else {
	          s.durationEstimate = parseInt(s.bytesTotal / s.bytesLoaded * s.duration, 10);
	        }
	      } else {
	
	        s.durationEstimate = s.duration;
	      }
	
	      // for flash, reflect sequential-load-style buffering
	      if (!s.isHTML5) {
	        s.buffered = [{
	          'start': 0,
	          'end': s.duration
	        }];
	      }
	
	      // allow whileloading to fire even if "load" fired under HTML5, due to HTTP range/partials
	      if ((s.readyState !== 3 || s.isHTML5) && instanceOptions.whileloading) {
	        instanceOptions.whileloading.apply(s);
	      }
	    };
	
	    this._whileplaying = function (nPosition, oPeakData, oWaveformDataLeft, oWaveformDataRight, oEQData) {
	
	      var instanceOptions = s._iO,
	          eqLeft;
	
	      if (isNaN(nPosition) || nPosition === null) {
	        // flash safety net
	        return false;
	      }
	
	      // Safari HTML5 play() may return small -ve values when starting from position: 0, eg. -50.120396875. Unexpected/invalid per W3, I think. Normalize to 0.
	      s.position = Math.max(0, nPosition);
	
	      s._processOnPosition();
	
	      if (!s.isHTML5 && fV > 8) {
	
	        if (instanceOptions.usePeakData && oPeakData !== _undefined && oPeakData) {
	          s.peakData = {
	            left: oPeakData.leftPeak,
	            right: oPeakData.rightPeak
	          };
	        }
	
	        if (instanceOptions.useWaveformData && oWaveformDataLeft !== _undefined && oWaveformDataLeft) {
	          s.waveformData = {
	            left: oWaveformDataLeft.split(','),
	            right: oWaveformDataRight.split(',')
	          };
	        }
	
	        if (instanceOptions.useEQData) {
	          if (oEQData !== _undefined && oEQData && oEQData.leftEQ) {
	            eqLeft = oEQData.leftEQ.split(',');
	            s.eqData = eqLeft;
	            s.eqData.left = eqLeft;
	            if (oEQData.rightEQ !== _undefined && oEQData.rightEQ) {
	              s.eqData.right = oEQData.rightEQ.split(',');
	            }
	          }
	        }
	      }
	
	      if (s.playState === 1) {
	
	        // special case/hack: ensure buffering is false if loading from cache (and not yet started)
	        if (!s.isHTML5 && fV === 8 && !s.position && s.isBuffering) {
	          s._onbufferchange(0);
	        }
	
	        if (instanceOptions.whileplaying) {
	          // flash may call after actual finish
	          instanceOptions.whileplaying.apply(s);
	        }
	      }
	
	      return true;
	    };
	
	    this._oncaptiondata = function (oData) {
	
	      /**
	       * internal: flash 9 + NetStream (MovieStar/RTMP-only) feature
	       *
	       * @param {object} oData
	       */
	
	      sm2._wD(s.id + ': Caption data received.');
	
	      s.captiondata = oData;
	
	      if (s._iO.oncaptiondata) {
	        s._iO.oncaptiondata.apply(s, [oData]);
	      }
	    };
	
	    this._onmetadata = function (oMDProps, oMDData) {
	
	      /**
	       * internal: flash 9 + NetStream (MovieStar/RTMP-only) feature
	       * RTMP may include song title, MovieStar content may include encoding info
	       *
	       * @param {array} oMDProps (names)
	       * @param {array} oMDData (values)
	       */
	
	      sm2._wD(s.id + ': Metadata received.');
	
	      var oData = {},
	          i,
	          j;
	
	      for (i = 0, j = oMDProps.length; i < j; i++) {
	        oData[oMDProps[i]] = oMDData[i];
	      }
	
	      s.metadata = oData;
	
	      if (s._iO.onmetadata) {
	        s._iO.onmetadata.call(s, s.metadata);
	      }
	    };
	
	    this._onid3 = function (oID3Props, oID3Data) {
	
	      /**
	       * internal: flash 8 + flash 9 ID3 feature
	       * may include artist, song title etc.
	       *
	       * @param {array} oID3Props (names)
	       * @param {array} oID3Data (values)
	       */
	
	      sm2._wD(s.id + ': ID3 data received.');
	
	      var oData = [],
	          i,
	          j;
	
	      for (i = 0, j = oID3Props.length; i < j; i++) {
	        oData[oID3Props[i]] = oID3Data[i];
	      }
	
	      s.id3 = _mixin(s.id3, oData);
	
	      if (s._iO.onid3) {
	        s._iO.onid3.apply(s);
	      }
	    };
	
	    // flash/RTMP-only
	
	    this._onconnect = function (bSuccess) {
	
	      bSuccess = bSuccess === 1;
	      sm2._wD(s.id + ': ' + (bSuccess ? 'Connected.' : 'Failed to connect? - ' + s.url), bSuccess ? 1 : 2);
	      s.connected = bSuccess;
	
	      if (bSuccess) {
	
	        s.failures = 0;
	
	        if (idCheck(s.id)) {
	          if (s.getAutoPlay()) {
	            // only update the play state if auto playing
	            s.play(_undefined, s.getAutoPlay());
	          } else if (s._iO.autoLoad) {
	            s.load();
	          }
	        }
	
	        if (s._iO.onconnect) {
	          s._iO.onconnect.apply(s, [bSuccess]);
	        }
	      }
	    };
	
	    this._ondataerror = function (sError) {
	
	      // flash 9 wave/eq data handler
	      // hack: called at start, and end from flash at/after onfinish()
	      if (s.playState > 0) {
	        sm2._wD(s.id + ': Data error: ' + sError);
	        if (s._iO.ondataerror) {
	          s._iO.ondataerror.apply(s);
	        }
	      }
	    };
	
	    // <d>
	    this._debug();
	    // </d>
	  }; // SMSound()
	
	  /**
	   * Private SoundManager internals
	   * ------------------------------
	   */
	
	  getDocument = function getDocument() {
	
	    return doc.body || doc.getElementsByTagName('div')[0];
	  };
	
	  id = function id(sID) {
	
	    return doc.getElementById(sID);
	  };
	
	  _mixin = function mixin(oMain, oAdd) {
	
	    // non-destructive merge
	    var o1 = oMain || {},
	        o2,
	        o;
	
	    // if unspecified, o2 is the default options object
	    o2 = oAdd === _undefined ? sm2.defaultOptions : oAdd;
	
	    for (o in o2) {
	
	      if (o2.hasOwnProperty(o) && o1[o] === _undefined) {
	
	        if ((0, _typeof3.default)(o2[o]) !== 'object' || o2[o] === null) {
	
	          // assign directly
	          o1[o] = o2[o];
	        } else {
	
	          // recurse through o2
	          o1[o] = _mixin(o1[o], o2[o]);
	        }
	      }
	    }
	
	    return o1;
	  };
	
	  wrapCallback = function wrapCallback(oSound, callback) {
	
	    /**
	     * 03/03/2013: Fix for Flash Player 11.6.602.171 + Flash 8 (flashVersion = 8) SWF issue
	     * setTimeout() fix for certain SMSound callbacks like onload() and onfinish(), where subsequent calls like play() and load() fail when Flash Player 11.6.602.171 is installed, and using soundManager with flashVersion = 8 (which is the default).
	     * Not sure of exact cause. Suspect race condition and/or invalid (NaN-style) position argument trickling down to the next JS -> Flash _start() call, in the play() case.
	     * Fix: setTimeout() to yield, plus safer null / NaN checking on position argument provided to Flash.
	     * https://getsatisfaction.com/schillmania/topics/recent_chrome_update_seems_to_have_broken_my_sm2_audio_player
	     */
	    if (!oSound.isHTML5 && fV === 8) {
	      window.setTimeout(callback, 0);
	    } else {
	      callback();
	    }
	  };
	
	  // additional soundManager properties that soundManager.setup() will accept
	
	  extraOptions = {
	    'onready': 1,
	    'ontimeout': 1,
	    'defaultOptions': 1,
	    'flash9Options': 1,
	    'movieStarOptions': 1
	  };
	
	  _assign = function assign(o, oParent) {
	
	    /**
	     * recursive assignment of properties, soundManager.setup() helper
	     * allows property assignment based on whitelist
	     */
	
	    var i,
	        result = true,
	        hasParent = oParent !== _undefined,
	        setupOptions = sm2.setupOptions,
	        bonusOptions = extraOptions;
	
	    // <d>
	
	    // if soundManager.setup() called, show accepted parameters.
	
	    if (o === _undefined) {
	
	      result = [];
	
	      for (i in setupOptions) {
	
	        if (setupOptions.hasOwnProperty(i)) {
	          result.push(i);
	        }
	      }
	
	      for (i in bonusOptions) {
	
	        if (bonusOptions.hasOwnProperty(i)) {
	
	          if ((0, _typeof3.default)(sm2[i]) === 'object') {
	            result.push(i + ': {...}');
	          } else if (sm2[i] instanceof Function) {
	            result.push(i + ': function() {...}');
	          } else {
	            result.push(i);
	          }
	        }
	      }
	
	      sm2._wD(str('setup', result.join(', ')));
	
	      return false;
	    }
	
	    // </d>
	
	    for (i in o) {
	
	      if (o.hasOwnProperty(i)) {
	
	        // if not an {object} we want to recurse through...
	
	        if ((0, _typeof3.default)(o[i]) !== 'object' || o[i] === null || o[i] instanceof Array || o[i] instanceof RegExp) {
	
	          // check "allowed" options
	
	          if (hasParent && bonusOptions[oParent] !== _undefined) {
	
	            // valid recursive / nested object option, eg., { defaultOptions: { volume: 50 } }
	            sm2[oParent][i] = o[i];
	          } else if (setupOptions[i] !== _undefined) {
	
	            // special case: assign to setupOptions object, which soundManager property references
	            sm2.setupOptions[i] = o[i];
	
	            // assign directly to soundManager, too
	            sm2[i] = o[i];
	          } else if (bonusOptions[i] === _undefined) {
	
	            // invalid or disallowed parameter. complain.
	            complain(str(sm2[i] === _undefined ? 'setupUndef' : 'setupError', i), 2);
	
	            result = false;
	          } else {
	
	            /**
	             * valid extraOptions (bonusOptions) parameter.
	             * is it a method, like onready/ontimeout? call it.
	             * multiple parameters should be in an array, eg. soundManager.setup({onready: [myHandler, myScope]});
	             */
	
	            if (sm2[i] instanceof Function) {
	
	              sm2[i].apply(sm2, o[i] instanceof Array ? o[i] : [o[i]]);
	            } else {
	
	              // good old-fashioned direct assignment
	              sm2[i] = o[i];
	            }
	          }
	        } else {
	
	          // recursion case, eg., { defaultOptions: { ... } }
	
	          if (bonusOptions[i] === _undefined) {
	
	            // invalid or disallowed parameter. complain.
	            complain(str(sm2[i] === _undefined ? 'setupUndef' : 'setupError', i), 2);
	
	            result = false;
	          } else {
	
	            // recurse through object
	            return _assign(o[i], i);
	          }
	        }
	      }
	    }
	
	    return result;
	  };
	
	  function preferFlashCheck(kind) {
	
	    // whether flash should play a given type
	    return sm2.preferFlash && hasFlash && !sm2.ignoreFlash && sm2.flash[kind] !== _undefined && sm2.flash[kind];
	  }
	
	  /**
	   * Internal DOM2-level event helpers
	   * ---------------------------------
	   */
	
	  event = function () {
	
	    // normalize event methods
	    var old = window.attachEvent,
	        evt = {
	      add: old ? 'attachEvent' : 'addEventListener',
	      remove: old ? 'detachEvent' : 'removeEventListener'
	    };
	
	    // normalize "on" event prefix, optional capture argument
	    function getArgs(oArgs) {
	
	      var args = slice.call(oArgs),
	          len = args.length;
	
	      if (old) {
	        // prefix
	        args[1] = 'on' + args[1];
	        if (len > 3) {
	          // no capture
	          args.pop();
	        }
	      } else if (len === 3) {
	        args.push(false);
	      }
	
	      return args;
	    }
	
	    function apply(args, sType) {
	
	      // normalize and call the event method, with the proper arguments
	      var element = args.shift(),
	          method = [evt[sType]];
	
	      if (old) {
	        // old IE can't do apply().
	        element[method](args[0], args[1]);
	      } else {
	        element[method].apply(element, args);
	      }
	    }
	
	    function add() {
	      apply(getArgs(arguments), 'add');
	    }
	
	    function remove() {
	      apply(getArgs(arguments), 'remove');
	    }
	
	    return {
	      'add': add,
	      'remove': remove
	    };
	  }();
	
	  /**
	   * Internal HTML5 event handling
	   * -----------------------------
	   */
	
	  function html5_event(oFn) {
	
	    // wrap html5 event handlers so we don't call them on destroyed and/or unloaded sounds
	
	    return function (e) {
	
	      var s = this._s,
	          result;
	
	      if (!s || !s._a) {
	        // <d>
	        if (s && s.id) {
	          sm2._wD(s.id + ': Ignoring ' + e.type);
	        } else {
	          sm2._wD(h5 + 'Ignoring ' + e.type);
	        }
	        // </d>
	        result = null;
	      } else {
	        result = oFn.call(this, e);
	      }
	
	      return result;
	    };
	  }
	
	  html5_events = {
	
	    // HTML5 event-name-to-handler map
	
	    abort: html5_event(function () {
	
	      sm2._wD(this._s.id + ': abort');
	    }),
	
	    // enough has loaded to play
	
	    canplay: html5_event(function () {
	
	      var s = this._s,
	          position1K;
	
	      if (s._html5_canplay) {
	        // this event has already fired. ignore.
	        return true;
	      }
	
	      s._html5_canplay = true;
	      sm2._wD(s.id + ': canplay');
	      s._onbufferchange(0);
	
	      // position according to instance options
	      position1K = s._iO.position !== _undefined && !isNaN(s._iO.position) ? s._iO.position / msecScale : null;
	
	      // set the position if position was provided before the sound loaded
	      if (this.currentTime !== position1K) {
	        sm2._wD(s.id + ': canplay: Setting position to ' + position1K);
	        try {
	          this.currentTime = position1K;
	        } catch (ee) {
	          sm2._wD(s.id + ': canplay: Setting position of ' + position1K + ' failed: ' + ee.message, 2);
	        }
	      }
	
	      // hack for HTML5 from/to case
	      if (s._iO._oncanplay) {
	        s._iO._oncanplay();
	      }
	    }),
	
	    canplaythrough: html5_event(function () {
	
	      var s = this._s;
	
	      if (!s.loaded) {
	        s._onbufferchange(0);
	        s._whileloading(s.bytesLoaded, s.bytesTotal, s._get_html5_duration());
	        s._onload(true);
	      }
	    }),
	
	    durationchange: html5_event(function () {
	
	      // durationchange may fire at various times, probably the safest way to capture accurate/final duration.
	
	      var s = this._s,
	          duration;
	
	      duration = s._get_html5_duration();
	
	      if (!isNaN(duration) && duration !== s.duration) {
	
	        sm2._wD(this._s.id + ': durationchange (' + duration + ')' + (s.duration ? ', previously ' + s.duration : ''));
	
	        s.durationEstimate = s.duration = duration;
	      }
	    }),
	
	    // TODO: Reserved for potential use
	    /*
	    emptied: html5_event(function() {
	      sm2._wD(this._s.id + ': emptied');
	    }),
	    */
	
	    ended: html5_event(function () {
	
	      var s = this._s;
	
	      sm2._wD(s.id + ': ended');
	
	      s._onfinish();
	    }),
	
	    error: html5_event(function () {
	
	      sm2._wD(this._s.id + ': HTML5 error, code ' + this.error.code);
	      /**
	       * HTML5 error codes, per W3C
	       * Error 1: Client aborted download at user's request.
	       * Error 2: Network error after load started.
	       * Error 3: Decoding issue.
	       * Error 4: Media (audio file) not supported.
	       * Reference: http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#error-codes
	       */
	      // call load with error state?
	      this._s._onload(false);
	    }),
	
	    loadeddata: html5_event(function () {
	
	      var s = this._s;
	
	      sm2._wD(s.id + ': loadeddata');
	
	      // safari seems to nicely report progress events, eventually totalling 100%
	      if (!s._loaded && !isSafari) {
	        s.duration = s._get_html5_duration();
	      }
	    }),
	
	    loadedmetadata: html5_event(function () {
	
	      sm2._wD(this._s.id + ': loadedmetadata');
	    }),
	
	    loadstart: html5_event(function () {
	
	      sm2._wD(this._s.id + ': loadstart');
	      // assume buffering at first
	      this._s._onbufferchange(1);
	    }),
	
	    play: html5_event(function () {
	
	      // sm2._wD(this._s.id + ': play()');
	      // once play starts, no buffering
	      this._s._onbufferchange(0);
	    }),
	
	    playing: html5_event(function () {
	
	      sm2._wD(this._s.id + ': playing ' + String.fromCharCode(9835));
	      // once play starts, no buffering
	      this._s._onbufferchange(0);
	    }),
	
	    progress: html5_event(function (e) {
	
	      // note: can fire repeatedly after "loaded" event, due to use of HTTP range/partials
	
	      var s = this._s,
	          i,
	          j,
	          progStr,
	          buffered = 0,
	          isProgress = e.type === 'progress',
	          ranges = e.target.buffered,
	
	      // firefox 3.6 implements e.loaded/total (bytes)
	      loaded = e.loaded || 0,
	          total = e.total || 1;
	
	      // reset the "buffered" (loaded byte ranges) array
	      s.buffered = [];
	
	      if (ranges && ranges.length) {
	
	        // if loaded is 0, try TimeRanges implementation as % of load
	        // https://developer.mozilla.org/en/DOM/TimeRanges
	
	        // re-build "buffered" array
	        // HTML5 returns seconds. SM2 API uses msec for setPosition() etc., whether Flash or HTML5.
	        for (i = 0, j = ranges.length; i < j; i++) {
	          s.buffered.push({
	            'start': ranges.start(i) * msecScale,
	            'end': ranges.end(i) * msecScale
	          });
	        }
	
	        // use the last value locally
	        buffered = (ranges.end(0) - ranges.start(0)) * msecScale;
	
	        // linear case, buffer sum; does not account for seeking and HTTP partials / byte ranges
	        loaded = Math.min(1, buffered / (e.target.duration * msecScale));
	
	        // <d>
	        if (isProgress && ranges.length > 1) {
	          progStr = [];
	          j = ranges.length;
	          for (i = 0; i < j; i++) {
	            progStr.push(e.target.buffered.start(i) * msecScale + '-' + e.target.buffered.end(i) * msecScale);
	          }
	          sm2._wD(this._s.id + ': progress, timeRanges: ' + progStr.join(', '));
	        }
	
	        if (isProgress && !isNaN(loaded)) {
	          sm2._wD(this._s.id + ': progress, ' + Math.floor(loaded * 100) + '% loaded');
	        }
	        // </d>
	      }
	
	      if (!isNaN(loaded)) {
	
	        // TODO: prevent calls with duplicate values.
	        s._whileloading(loaded, total, s._get_html5_duration());
	        if (loaded && total && loaded === total) {
	          // in case "onload" doesn't fire (eg. gecko 1.9.2)
	          html5_events.canplaythrough.call(this, e);
	        }
	      }
	    }),
	
	    ratechange: html5_event(function () {
	
	      sm2._wD(this._s.id + ': ratechange');
	    }),
	
	    suspend: html5_event(function (e) {
	
	      // download paused/stopped, may have finished (eg. onload)
	      var s = this._s;
	
	      sm2._wD(this._s.id + ': suspend');
	      html5_events.progress.call(this, e);
	      s._onsuspend();
	    }),
	
	    stalled: html5_event(function () {
	
	      sm2._wD(this._s.id + ': stalled');
	    }),
	
	    timeupdate: html5_event(function () {
	
	      this._s._onTimer();
	    }),
	
	    waiting: html5_event(function () {
	
	      var s = this._s;
	
	      // see also: seeking
	      sm2._wD(this._s.id + ': waiting');
	
	      // playback faster than download rate, etc.
	      s._onbufferchange(1);
	    })
	
	  };
	
	  html5OK = function html5OK(iO) {
	
	    // playability test based on URL or MIME type
	
	    var result;
	
	    if (!iO || !iO.type && !iO.url && !iO.serverURL) {
	
	      // nothing to check
	      result = false;
	    } else if (iO.serverURL || iO.type && preferFlashCheck(iO.type)) {
	
	      // RTMP, or preferring flash
	      result = false;
	    } else {
	
	      // Use type, if specified. Pass data: URIs to HTML5. If HTML5-only mode, no other options, so just give 'er
	      result = iO.type ? html5CanPlay({ type: iO.type }) : html5CanPlay({ url: iO.url }) || sm2.html5Only || iO.url.match(/data\:/i);
	    }
	
	    return result;
	  };
	
	  html5Unload = function html5Unload(oAudio) {
	
	    /**
	     * Internal method: Unload media, and cancel any current/pending network requests.
	     * Firefox can load an empty URL, which allegedly destroys the decoder and stops the download.
	     * https://developer.mozilla.org/En/Using_audio_and_video_in_Firefox#Stopping_the_download_of_media
	     * However, Firefox has been seen loading a relative URL from '' and thus requesting the hosting page on unload.
	     * Other UA behaviour is unclear, so everyone else gets an about:blank-style URL.
	     */
	
	    var url;
	
	    if (oAudio) {
	
	      // Firefox and Chrome accept short WAVe data: URIs. Chome dislikes audio/wav, but accepts audio/wav for data: MIME.
	      // Desktop Safari complains / fails on data: URI, so it gets about:blank.
	      url = isSafari ? emptyURL : sm2.html5.canPlayType('audio/wav') ? emptyWAV : emptyURL;
	
	      oAudio.src = url;
	
	      // reset some state, too
	      if (oAudio._called_unload !== _undefined) {
	        oAudio._called_load = false;
	      }
	    }
	
	    if (useGlobalHTML5Audio) {
	
	      // ensure URL state is trashed, also
	      lastGlobalHTML5URL = null;
	    }
	
	    return url;
	  };
	
	  html5CanPlay = function html5CanPlay(o) {
	
	    /**
	     * Try to find MIME, test and return truthiness
	     * o = {
	     *  url: '/path/to/an.mp3',
	     *  type: 'audio/mp3'
	     * }
	     */
	
	    if (!sm2.useHTML5Audio || !sm2.hasHTML5) {
	      return false;
	    }
	
	    var url = o.url || null,
	        mime = o.type || null,
	        aF = sm2.audioFormats,
	        result,
	        offset,
	        fileExt,
	        item;
	
	    // account for known cases like audio/mp3
	
	    if (mime && sm2.html5[mime] !== _undefined) {
	      return sm2.html5[mime] && !preferFlashCheck(mime);
	    }
	
	    if (!html5Ext) {
	
	      html5Ext = [];
	
	      for (item in aF) {
	
	        if (aF.hasOwnProperty(item)) {
	
	          html5Ext.push(item);
	
	          if (aF[item].related) {
	            html5Ext = html5Ext.concat(aF[item].related);
	          }
	        }
	      }
	
	      html5Ext = new RegExp('\\.(' + html5Ext.join('|') + ')(\\?.*)?$', 'i');
	    }
	
	    // TODO: Strip URL queries, etc.
	    fileExt = url ? url.toLowerCase().match(html5Ext) : null;
	
	    if (!fileExt || !fileExt.length) {
	
	      if (!mime) {
	
	        result = false;
	      } else {
	
	        // audio/mp3 -> mp3, result should be known
	        offset = mime.indexOf(';');
	
	        // strip "audio/X; codecs..."
	        fileExt = (offset !== -1 ? mime.substr(0, offset) : mime).substr(6);
	      }
	    } else {
	
	      // match the raw extension name - "mp3", for example
	      fileExt = fileExt[1];
	    }
	
	    if (fileExt && sm2.html5[fileExt] !== _undefined) {
	
	      // result known
	      result = sm2.html5[fileExt] && !preferFlashCheck(fileExt);
	    } else {
	
	      mime = 'audio/' + fileExt;
	      result = sm2.html5.canPlayType({ type: mime });
	
	      sm2.html5[fileExt] = result;
	
	      // sm2._wD('canPlayType, found result: ' + result);
	      result = result && sm2.html5[mime] && !preferFlashCheck(mime);
	    }
	
	    return result;
	  };
	
	  testHTML5 = function testHTML5() {
	
	    /**
	     * Internal: Iterates over audioFormats, determining support eg. audio/mp3, audio/mpeg and so on
	     * assigns results to html5[] and flash[].
	     */
	
	    if (!sm2.useHTML5Audio || !sm2.hasHTML5) {
	
	      // without HTML5, we need Flash.
	      sm2.html5.usingFlash = true;
	      needsFlash = true;
	
	      return false;
	    }
	
	    // double-whammy: Opera 9.64 throws WRONG_ARGUMENTS_ERR if no parameter passed to Audio(), and Webkit + iOS happily tries to load "null" as a URL. :/
	    var a = Audio !== _undefined ? isOpera && opera.version() < 10 ? new Audio(null) : new Audio() : null,
	        item,
	        lookup,
	        support = {},
	        aF,
	        i;
	
	    function cp(m) {
	
	      var canPlay,
	          j,
	          result = false,
	          isOK = false;
	
	      if (!a || typeof a.canPlayType !== 'function') {
	        return result;
	      }
	
	      if (m instanceof Array) {
	
	        // iterate through all mime types, return any successes
	
	        for (i = 0, j = m.length; i < j; i++) {
	
	          if (sm2.html5[m[i]] || a.canPlayType(m[i]).match(sm2.html5Test)) {
	
	            isOK = true;
	            sm2.html5[m[i]] = true;
	
	            // note flash support, too
	            sm2.flash[m[i]] = !!m[i].match(flashMIME);
	          }
	        }
	
	        result = isOK;
	      } else {
	
	        canPlay = a && typeof a.canPlayType === 'function' ? a.canPlayType(m) : false;
	        result = !!(canPlay && canPlay.match(sm2.html5Test));
	      }
	
	      return result;
	    }
	
	    // test all registered formats + codecs
	
	    aF = sm2.audioFormats;
	
	    for (item in aF) {
	
	      if (aF.hasOwnProperty(item)) {
	
	        lookup = 'audio/' + item;
	
	        support[item] = cp(aF[item].type);
	
	        // write back generic type too, eg. audio/mp3
	        support[lookup] = support[item];
	
	        // assign flash
	        if (item.match(flashMIME)) {
	
	          sm2.flash[item] = true;
	          sm2.flash[lookup] = true;
	        } else {
	
	          sm2.flash[item] = false;
	          sm2.flash[lookup] = false;
	        }
	
	        // assign result to related formats, too
	
	        if (aF[item] && aF[item].related) {
	
	          for (i = aF[item].related.length - 1; i >= 0; i--) {
	
	            // eg. audio/m4a
	            support['audio/' + aF[item].related[i]] = support[item];
	            sm2.html5[aF[item].related[i]] = support[item];
	            sm2.flash[aF[item].related[i]] = support[item];
	          }
	        }
	      }
	    }
	
	    support.canPlayType = a ? cp : null;
	    sm2.html5 = _mixin(sm2.html5, support);
	
	    sm2.html5.usingFlash = featureCheck();
	    needsFlash = sm2.html5.usingFlash;
	
	    return true;
	  };
	
	  strings = {
	
	    // <d>
	    notReady: 'Unavailable - wait until onready() has fired.',
	    notOK: 'Audio support is not available.',
	    domError: sm + 'exception caught while appending SWF to DOM.',
	    spcWmode: 'Removing wmode, preventing known SWF loading issue(s)',
	    swf404: smc + 'Verify that %s is a valid path.',
	    tryDebug: 'Try ' + sm + '.debugFlash = true for more security details (output goes to SWF.)',
	    checkSWF: 'See SWF output for more debug info.',
	    localFail: smc + 'Non-HTTP page (' + doc.location.protocol + ' URL?) Review Flash player security settings for this special case:\nhttp://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager04.html\nMay need to add/allow path, eg. c:/sm2/ or /users/me/sm2/',
	    waitFocus: smc + 'Special case: Waiting for SWF to load with window focus...',
	    waitForever: smc + 'Waiting indefinitely for Flash (will recover if unblocked)...',
	    waitSWF: smc + 'Waiting for 100% SWF load...',
	    needFunction: smc + 'Function object expected for %s',
	    badID: 'Sound ID "%s" should be a string, starting with a non-numeric character',
	    currentObj: smc + '_debug(): Current sound objects',
	    waitOnload: smc + 'Waiting for window.onload()',
	    docLoaded: smc + 'Document already loaded',
	    onload: smc + 'initComplete(): calling soundManager.onload()',
	    onloadOK: sm + '.onload() complete',
	    didInit: smc + 'init(): Already called?',
	    secNote: 'Flash security note: Network/internet URLs will not load due to security restrictions. Access can be configured via Flash Player Global Security Settings Page: http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager04.html',
	    badRemove: smc + 'Failed to remove Flash node.',
	    shutdown: sm + '.disable(): Shutting down',
	    queue: smc + 'Queueing %s handler',
	    smError: 'SMSound.load(): Exception: JS-Flash communication failed, or JS error.',
	    fbTimeout: 'No flash response, applying .' + swfCSS.swfTimedout + ' CSS...',
	    fbLoaded: 'Flash loaded',
	    fbHandler: smc + 'flashBlockHandler()',
	    manURL: 'SMSound.load(): Using manually-assigned URL',
	    onURL: sm + '.load(): current URL already assigned.',
	    badFV: sm + '.flashVersion must be 8 or 9. "%s" is invalid. Reverting to %s.',
	    as2loop: 'Note: Setting stream:false so looping can work (flash 8 limitation)',
	    noNSLoop: 'Note: Looping not implemented for MovieStar formats',
	    needfl9: 'Note: Switching to flash 9, required for MP4 formats.',
	    mfTimeout: 'Setting flashLoadTimeout = 0 (infinite) for off-screen, mobile flash case',
	    needFlash: smc + 'Fatal error: Flash is needed to play some required formats, but is not available.',
	    gotFocus: smc + 'Got window focus.',
	    policy: 'Enabling usePolicyFile for data access',
	    setup: sm + '.setup(): allowed parameters: %s',
	    setupError: sm + '.setup(): "%s" cannot be assigned with this method.',
	    setupUndef: sm + '.setup(): Could not find option "%s"',
	    setupLate: sm + '.setup(): url, flashVersion and html5Test property changes will not take effect until reboot().',
	    noURL: smc + 'Flash URL required. Call soundManager.setup({url:...}) to get started.',
	    sm2Loaded: 'SoundManager 2: Ready. ' + String.fromCharCode(10003),
	    reset: sm + '.reset(): Removing event callbacks',
	    mobileUA: 'Mobile UA detected, preferring HTML5 by default.',
	    globalHTML5: 'Using singleton HTML5 Audio() pattern for this device.',
	    ignoreMobile: 'Ignoring mobile restrictions for this device.'
	    // </d>
	
	  };
	
	  str = function str() {
	
	    // internal string replace helper.
	    // arguments: o [,items to replace]
	    // <d>
	
	    var args, i, j, o, sstr;
	
	    // real array, please
	    args = slice.call(arguments);
	
	    // first argument
	    o = args.shift();
	
	    sstr = strings && strings[o] ? strings[o] : '';
	
	    if (sstr && args && args.length) {
	      for (i = 0, j = args.length; i < j; i++) {
	        sstr = sstr.replace('%s', args[i]);
	      }
	    }
	
	    return sstr;
	    // </d>
	  };
	
	  loopFix = function loopFix(sOpt) {
	
	    // flash 8 requires stream = false for looping to work
	    if (fV === 8 && sOpt.loops > 1 && sOpt.stream) {
	      _wDS('as2loop');
	      sOpt.stream = false;
	    }
	
	    return sOpt;
	  };
	
	  policyFix = function policyFix(sOpt, sPre) {
	
	    if (sOpt && !sOpt.usePolicyFile && (sOpt.onid3 || sOpt.usePeakData || sOpt.useWaveformData || sOpt.useEQData)) {
	      sm2._wD((sPre || '') + str('policy'));
	      sOpt.usePolicyFile = true;
	    }
	
	    return sOpt;
	  };
	
	  complain = function complain(sMsg) {
	
	    // <d>
	    if (hasConsole && console.warn !== _undefined) {
	      console.warn(sMsg);
	    } else {
	      sm2._wD(sMsg);
	    }
	    // </d>
	  };
	
	  doNothing = function doNothing() {
	
	    return false;
	  };
	
	  disableObject = function disableObject(o) {
	
	    var oProp;
	
	    for (oProp in o) {
	      if (o.hasOwnProperty(oProp) && typeof o[oProp] === 'function') {
	        o[oProp] = doNothing;
	      }
	    }
	
	    oProp = null;
	  };
	
	  failSafely = function failSafely(bNoDisable) {
	
	    // general failure exception handler
	
	    if (bNoDisable === _undefined) {
	      bNoDisable = false;
	    }
	
	    if (disabled || bNoDisable) {
	      sm2.disable(bNoDisable);
	    }
	  };
	
	  normalizeMovieURL = function normalizeMovieURL(smURL) {
	
	    var urlParams = null,
	        url;
	
	    if (smURL) {
	
	      if (smURL.match(/\.swf(\?.*)?$/i)) {
	
	        urlParams = smURL.substr(smURL.toLowerCase().lastIndexOf('.swf?') + 4);
	
	        if (urlParams) {
	          // assume user knows what they're doing
	          return smURL;
	        }
	      } else if (smURL.lastIndexOf('/') !== smURL.length - 1) {
	
	        // append trailing slash, if needed
	        smURL += '/';
	      }
	    }
	
	    url = (smURL && smURL.lastIndexOf('/') !== -1 ? smURL.substr(0, smURL.lastIndexOf('/') + 1) : './') + sm2.movieURL;
	
	    if (sm2.noSWFCache) {
	      url += '?ts=' + new Date().getTime();
	    }
	
	    return url;
	  };
	
	  setVersionInfo = function setVersionInfo() {
	
	    // short-hand for internal use
	
	    fV = parseInt(sm2.flashVersion, 10);
	
	    if (fV !== 8 && fV !== 9) {
	      sm2._wD(str('badFV', fV, defaultFlashVersion));
	      sm2.flashVersion = fV = defaultFlashVersion;
	    }
	
	    // debug flash movie, if applicable
	
	    var isDebug = sm2.debugMode || sm2.debugFlash ? '_debug.swf' : '.swf';
	
	    if (sm2.useHTML5Audio && !sm2.html5Only && sm2.audioFormats.mp4.required && fV < 9) {
	      sm2._wD(str('needfl9'));
	      sm2.flashVersion = fV = 9;
	    }
	
	    sm2.version = sm2.versionNumber + (sm2.html5Only ? ' (HTML5-only mode)' : fV === 9 ? ' (AS3/Flash 9)' : ' (AS2/Flash 8)');
	
	    // set up default options
	    if (fV > 8) {
	
	      // +flash 9 base options
	      sm2.defaultOptions = _mixin(sm2.defaultOptions, sm2.flash9Options);
	      sm2.features.buffering = true;
	
	      // +moviestar support
	      sm2.defaultOptions = _mixin(sm2.defaultOptions, sm2.movieStarOptions);
	      sm2.filePatterns.flash9 = new RegExp('\\.(mp3|' + netStreamTypes.join('|') + ')(\\?.*)?$', 'i');
	      sm2.features.movieStar = true;
	    } else {
	
	      sm2.features.movieStar = false;
	    }
	
	    // regExp for flash canPlay(), etc.
	    sm2.filePattern = sm2.filePatterns[fV !== 8 ? 'flash9' : 'flash8'];
	
	    // if applicable, use _debug versions of SWFs
	    sm2.movieURL = (fV === 8 ? 'soundmanager2.swf' : 'soundmanager2_flash9.swf').replace('.swf', isDebug);
	
	    sm2.features.peakData = sm2.features.waveformData = sm2.features.eqData = fV > 8;
	  };
	
	  setPolling = function setPolling(bPolling, bHighPerformance) {
	
	    if (!flash) {
	      return false;
	    }
	
	    flash._setPolling(bPolling, bHighPerformance);
	  };
	
	  initDebug = function initDebug() {
	
	    // starts debug mode, creating output <div> for UAs without console object
	
	    // allow force of debug mode via URL
	    // <d>
	    if (sm2.debugURLParam.test(wl)) {
	      sm2.setupOptions.debugMode = sm2.debugMode = true;
	    }
	
	    if (id(sm2.debugID)) {
	      return false;
	    }
	
	    var oD, oDebug, oTarget, oToggle, tmp;
	
	    if (sm2.debugMode && !id(sm2.debugID) && (!hasConsole || !sm2.useConsole || !sm2.consoleOnly)) {
	
	      oD = doc.createElement('div');
	      oD.id = sm2.debugID + '-toggle';
	
	      oToggle = {
	        'position': 'fixed',
	        'bottom': '0px',
	        'right': '0px',
	        'width': '1.2em',
	        'height': '1.2em',
	        'lineHeight': '1.2em',
	        'margin': '2px',
	        'textAlign': 'center',
	        'border': '1px solid #999',
	        'cursor': 'pointer',
	        'background': '#fff',
	        'color': '#333',
	        'zIndex': 10001
	      };
	
	      oD.appendChild(doc.createTextNode('-'));
	      oD.onclick = toggleDebug;
	      oD.title = 'Toggle SM2 debug console';
	
	      if (ua.match(/msie 6/i)) {
	        oD.style.position = 'absolute';
	        oD.style.cursor = 'hand';
	      }
	
	      for (tmp in oToggle) {
	        if (oToggle.hasOwnProperty(tmp)) {
	          oD.style[tmp] = oToggle[tmp];
	        }
	      }
	
	      oDebug = doc.createElement('div');
	      oDebug.id = sm2.debugID;
	      oDebug.style.display = sm2.debugMode ? 'block' : 'none';
	
	      if (sm2.debugMode && !id(oD.id)) {
	        try {
	          oTarget = getDocument();
	          oTarget.appendChild(oD);
	        } catch (e2) {
	          throw new Error(str('domError') + ' \n' + e2.toString());
	        }
	        oTarget.appendChild(oDebug);
	      }
	    }
	
	    oTarget = null;
	    // </d>
	  };
	
	  idCheck = this.getSoundById;
	
	  // <d>
	  _wDS = function _wDS(o, errorLevel) {
	
	    return !o ? '' : sm2._wD(str(o), errorLevel);
	  };
	
	  toggleDebug = function toggleDebug() {
	
	    var o = id(sm2.debugID),
	        oT = id(sm2.debugID + '-toggle');
	
	    if (!o) {
	      return false;
	    }
	
	    if (debugOpen) {
	      // minimize
	      oT.innerHTML = '+';
	      o.style.display = 'none';
	    } else {
	      oT.innerHTML = '-';
	      o.style.display = 'block';
	    }
	
	    debugOpen = !debugOpen;
	  };
	
	  debugTS = function debugTS(sEventType, bSuccess, sMessage) {
	
	    // troubleshooter debug hooks
	
	    if (window.sm2Debugger !== _undefined) {
	      try {
	        sm2Debugger.handleEvent(sEventType, bSuccess, sMessage);
	      } catch (e) {
	        // oh well
	        return false;
	      }
	    }
	
	    return true;
	  };
	  // </d>
	
	  getSWFCSS = function getSWFCSS() {
	
	    var css = [];
	
	    if (sm2.debugMode) {
	      css.push(swfCSS.sm2Debug);
	    }
	
	    if (sm2.debugFlash) {
	      css.push(swfCSS.flashDebug);
	    }
	
	    if (sm2.useHighPerformance) {
	      css.push(swfCSS.highPerf);
	    }
	
	    return css.join(' ');
	  };
	
	  flashBlockHandler = function flashBlockHandler() {
	
	    // *possible* flash block situation.
	
	    var name = str('fbHandler'),
	        p = sm2.getMoviePercent(),
	        css = swfCSS,
	        error = {
	      type: 'FLASHBLOCK'
	    };
	
	    if (sm2.html5Only) {
	      // no flash, or unused
	      return false;
	    }
	
	    if (!sm2.ok()) {
	
	      if (needsFlash) {
	        // make the movie more visible, so user can fix
	        sm2.oMC.className = getSWFCSS() + ' ' + css.swfDefault + ' ' + (p === null ? css.swfTimedout : css.swfError);
	        sm2._wD(name + ': ' + str('fbTimeout') + (p ? ' (' + str('fbLoaded') + ')' : ''));
	      }
	
	      sm2.didFlashBlock = true;
	
	      // fire onready(), complain lightly
	      processOnEvents({
	        type: 'ontimeout',
	        ignoreInit: true,
	        error: error
	      });
	
	      catchError(error);
	    } else {
	
	      // SM2 loaded OK (or recovered)
	
	      // <d>
	      if (sm2.didFlashBlock) {
	        sm2._wD(name + ': Unblocked');
	      }
	      // </d>
	
	      if (sm2.oMC) {
	        sm2.oMC.className = [getSWFCSS(), css.swfDefault, css.swfLoaded + (sm2.didFlashBlock ? ' ' + css.swfUnblocked : '')].join(' ');
	      }
	    }
	  };
	
	  addOnEvent = function addOnEvent(sType, oMethod, oScope) {
	
	    if (on_queue[sType] === _undefined) {
	      on_queue[sType] = [];
	    }
	
	    on_queue[sType].push({
	      'method': oMethod,
	      'scope': oScope || null,
	      'fired': false
	    });
	  };
	
	  processOnEvents = function processOnEvents(oOptions) {
	
	    // if unspecified, assume OK/error
	
	    if (!oOptions) {
	      oOptions = {
	        type: sm2.ok() ? 'onready' : 'ontimeout'
	      };
	    }
	
	    if (!didInit && oOptions && !oOptions.ignoreInit) {
	      // not ready yet.
	      return false;
	    }
	
	    if (oOptions.type === 'ontimeout' && (sm2.ok() || disabled && !oOptions.ignoreInit)) {
	      // invalid case
	      return false;
	    }
	
	    var status = {
	      success: oOptions && oOptions.ignoreInit ? sm2.ok() : !disabled
	    },
	
	
	    // queue specified by type, or none
	    srcQueue = oOptions && oOptions.type ? on_queue[oOptions.type] || [] : [],
	        queue = [],
	        i,
	        j,
	        args = [status],
	        canRetry = needsFlash && !sm2.ok();
	
	    if (oOptions.error) {
	      args[0].error = oOptions.error;
	    }
	
	    for (i = 0, j = srcQueue.length; i < j; i++) {
	      if (srcQueue[i].fired !== true) {
	        queue.push(srcQueue[i]);
	      }
	    }
	
	    if (queue.length) {
	
	      // sm2._wD(sm + ': Firing ' + queue.length + ' ' + oOptions.type + '() item' + (queue.length === 1 ? '' : 's')); 
	      for (i = 0, j = queue.length; i < j; i++) {
	
	        if (queue[i].scope) {
	          queue[i].method.apply(queue[i].scope, args);
	        } else {
	          queue[i].method.apply(this, args);
	        }
	
	        if (!canRetry) {
	          // useFlashBlock and SWF timeout case doesn't count here.
	          queue[i].fired = true;
	        }
	      }
	    }
	
	    return true;
	  };
	
	  _initUserOnload = function initUserOnload() {
	
	    window.setTimeout(function () {
	
	      if (sm2.useFlashBlock) {
	        flashBlockHandler();
	      }
	
	      processOnEvents();
	
	      // call user-defined "onload", scoped to window
	
	      if (typeof sm2.onload === 'function') {
	        _wDS('onload', 1);
	        sm2.onload.apply(window);
	        _wDS('onloadOK', 1);
	      }
	
	      if (sm2.waitForWindowLoad) {
	        event.add(window, 'load', _initUserOnload);
	      }
	    }, 1);
	  };
	
	  detectFlash = function detectFlash() {
	
	    /**
	     * Hat tip: Flash Detect library (BSD, (C) 2007) by Carl "DocYes" S. Yestrau
	     * http://featureblend.com/javascript-flash-detection-library.html / http://featureblend.com/license.txt
	     */
	
	    if (hasFlash !== _undefined) {
	      // this work has already been done.
	      return hasFlash;
	    }
	
	    var hasPlugin = false,
	        n = navigator,
	        nP = n.plugins,
	        obj,
	        type,
	        types,
	        AX = window.ActiveXObject;
	
	    if (nP && nP.length) {
	
	      type = 'application/x-shockwave-flash';
	      types = n.mimeTypes;
	
	      if (types && types[type] && types[type].enabledPlugin && types[type].enabledPlugin.description) {
	        hasPlugin = true;
	      }
	    } else if (AX !== _undefined && !ua.match(/MSAppHost/i)) {
	
	      // Windows 8 Store Apps (MSAppHost) are weird (compatibility?) and won't complain here, but will barf if Flash/ActiveX object is appended to the DOM.
	      try {
	        obj = new AX('ShockwaveFlash.ShockwaveFlash');
	      } catch (e) {
	        // oh well
	        obj = null;
	      }
	
	      hasPlugin = !!obj;
	
	      // cleanup, because it is ActiveX after all
	      obj = null;
	    }
	
	    hasFlash = hasPlugin;
	
	    return hasPlugin;
	  };
	
	  featureCheck = function featureCheck() {
	
	    var flashNeeded,
	        item,
	        formats = sm2.audioFormats,
	
	    // iPhone <= 3.1 has broken HTML5 audio(), but firmware 3.2 (original iPad) + iOS4 works.
	    isSpecial = is_iDevice && !!ua.match(/os (1|2|3_0|3_1)\s/i);
	
	    if (isSpecial) {
	
	      // has Audio(), but is broken; let it load links directly.
	      sm2.hasHTML5 = false;
	
	      // ignore flash case, however
	      sm2.html5Only = true;
	
	      // hide the SWF, if present
	      if (sm2.oMC) {
	        sm2.oMC.style.display = 'none';
	      }
	    } else {
	
	      if (sm2.useHTML5Audio) {
	
	        if (!sm2.html5 || !sm2.html5.canPlayType) {
	          sm2._wD('SoundManager: No HTML5 Audio() support detected.');
	          sm2.hasHTML5 = false;
	        }
	
	        // <d>
	        if (isBadSafari) {
	          sm2._wD(smc + 'Note: Buggy HTML5 Audio in Safari on this OS X release, see https://bugs.webkit.org/show_bug.cgi?id=32159 - ' + (!hasFlash ? ' would use flash fallback for MP3/MP4, but none detected.' : 'will use flash fallback for MP3/MP4, if available'), 1);
	        }
	        // </d>
	      }
	    }
	
	    if (sm2.useHTML5Audio && sm2.hasHTML5) {
	
	      // sort out whether flash is optional, required or can be ignored.
	
	      // innocent until proven guilty.
	      canIgnoreFlash = true;
	
	      for (item in formats) {
	
	        if (formats.hasOwnProperty(item)) {
	
	          if (formats[item].required) {
	
	            if (!sm2.html5.canPlayType(formats[item].type)) {
	
	              // 100% HTML5 mode is not possible.
	              canIgnoreFlash = false;
	              flashNeeded = true;
	            } else if (sm2.preferFlash && (sm2.flash[item] || sm2.flash[formats[item].type])) {
	
	              // flash may be required, or preferred for this format.
	              flashNeeded = true;
	            }
	          }
	        }
	      }
	    }
	
	    // sanity check...
	    if (sm2.ignoreFlash) {
	      flashNeeded = false;
	      canIgnoreFlash = true;
	    }
	
	    sm2.html5Only = sm2.hasHTML5 && sm2.useHTML5Audio && !flashNeeded;
	
	    return !sm2.html5Only;
	  };
	
	  parseURL = function parseURL(url) {
	
	    /**
	     * Internal: Finds and returns the first playable URL (or failing that, the first URL.)
	     * @param {string or array} url A single URL string, OR, an array of URL strings or {url:'/path/to/resource', type:'audio/mp3'} objects.
	     */
	
	    var i,
	        j,
	        urlResult = 0,
	        result;
	
	    if (url instanceof Array) {
	
	      // find the first good one
	      for (i = 0, j = url.length; i < j; i++) {
	
	        if (url[i] instanceof Object) {
	
	          // MIME check
	          if (sm2.canPlayMIME(url[i].type)) {
	            urlResult = i;
	            break;
	          }
	        } else if (sm2.canPlayURL(url[i])) {
	
	          // URL string check
	          urlResult = i;
	          break;
	        }
	      }
	
	      // normalize to string
	      if (url[urlResult].url) {
	        url[urlResult] = url[urlResult].url;
	      }
	
	      result = url[urlResult];
	    } else {
	
	      // single URL case
	      result = url;
	    }
	
	    return result;
	  };
	
	  startTimer = function startTimer(oSound) {
	
	    /**
	     * attach a timer to this sound, and start an interval if needed
	     */
	
	    if (!oSound._hasTimer) {
	
	      oSound._hasTimer = true;
	
	      if (!mobileHTML5 && sm2.html5PollingInterval) {
	
	        if (h5IntervalTimer === null && h5TimerCount === 0) {
	
	          h5IntervalTimer = setInterval(timerExecute, sm2.html5PollingInterval);
	        }
	
	        h5TimerCount++;
	      }
	    }
	  };
	
	  stopTimer = function stopTimer(oSound) {
	
	    /**
	     * detach a timer
	     */
	
	    if (oSound._hasTimer) {
	
	      oSound._hasTimer = false;
	
	      if (!mobileHTML5 && sm2.html5PollingInterval) {
	
	        // interval will stop itself at next execution.
	
	        h5TimerCount--;
	      }
	    }
	  };
	
	  timerExecute = function timerExecute() {
	
	    /**
	     * manual polling for HTML5 progress events, ie., whileplaying()
	     * (can achieve greater precision than conservative default HTML5 interval)
	     */
	
	    var i;
	
	    if (h5IntervalTimer !== null && !h5TimerCount) {
	
	      // no active timers, stop polling interval.
	
	      clearInterval(h5IntervalTimer);
	
	      h5IntervalTimer = null;
	
	      return false;
	    }
	
	    // check all HTML5 sounds with timers
	
	    for (i = sm2.soundIDs.length - 1; i >= 0; i--) {
	
	      if (sm2.sounds[sm2.soundIDs[i]].isHTML5 && sm2.sounds[sm2.soundIDs[i]]._hasTimer) {
	        sm2.sounds[sm2.soundIDs[i]]._onTimer();
	      }
	    }
	  };
	
	  catchError = function catchError(options) {
	
	    options = options !== _undefined ? options : {};
	
	    if (typeof sm2.onerror === 'function') {
	      sm2.onerror.apply(window, [{
	        type: options.type !== _undefined ? options.type : null
	      }]);
	    }
	
	    if (options.fatal !== _undefined && options.fatal) {
	      sm2.disable();
	    }
	  };
	
	  badSafariFix = function badSafariFix() {
	
	    // special case: "bad" Safari (OS X 10.3 - 10.7) must fall back to flash for MP3/MP4
	    if (!isBadSafari || !detectFlash()) {
	      // doesn't apply
	      return false;
	    }
	
	    var aF = sm2.audioFormats,
	        i,
	        item;
	
	    for (item in aF) {
	
	      if (aF.hasOwnProperty(item)) {
	
	        if (item === 'mp3' || item === 'mp4') {
	
	          sm2._wD(sm + ': Using flash fallback for ' + item + ' format');
	          sm2.html5[item] = false;
	
	          // assign result to related formats, too
	          if (aF[item] && aF[item].related) {
	            for (i = aF[item].related.length - 1; i >= 0; i--) {
	              sm2.html5[aF[item].related[i]] = false;
	            }
	          }
	        }
	      }
	    }
	  };
	
	  /**
	   * Pseudo-private flash/ExternalInterface methods
	   * ----------------------------------------------
	   */
	
	  this._setSandboxType = function (sandboxType) {
	
	    // <d>
	    // Security sandbox according to Flash plugin
	    var sb = sm2.sandbox;
	
	    sb.type = sandboxType;
	    sb.description = sb.types[sb.types[sandboxType] !== _undefined ? sandboxType : 'unknown'];
	
	    if (sb.type === 'localWithFile') {
	
	      sb.noRemote = true;
	      sb.noLocal = false;
	      _wDS('secNote', 2);
	    } else if (sb.type === 'localWithNetwork') {
	
	      sb.noRemote = false;
	      sb.noLocal = true;
	    } else if (sb.type === 'localTrusted') {
	
	      sb.noRemote = false;
	      sb.noLocal = false;
	    }
	    // </d>
	  };
	
	  this._externalInterfaceOK = function (swfVersion) {
	
	    // flash callback confirming flash loaded, EI working etc.
	    // swfVersion: SWF build string
	
	    if (sm2.swfLoaded) {
	      return false;
	    }
	
	    var e;
	
	    debugTS('swf', true);
	    debugTS('flashtojs', true);
	    sm2.swfLoaded = true;
	    tryInitOnFocus = false;
	
	    if (isBadSafari) {
	      badSafariFix();
	    }
	
	    // complain if JS + SWF build/version strings don't match, excluding +DEV builds
	    // <d>
	    if (!swfVersion || swfVersion.replace(/\+dev/i, '') !== sm2.versionNumber.replace(/\+dev/i, '')) {
	
	      e = sm + ': Fatal: JavaScript file build "' + sm2.versionNumber + '" does not match Flash SWF build "' + swfVersion + '" at ' + sm2.url + '. Ensure both are up-to-date.';
	
	      // escape flash -> JS stack so this error fires in window.
	      setTimeout(function versionMismatch() {
	        throw new Error(e);
	      }, 0);
	
	      // exit, init will fail with timeout
	      return false;
	    }
	    // </d>
	
	    // IE needs a larger timeout
	    setTimeout(init, isIE ? 100 : 1);
	  };
	
	  /**
	   * Private initialization helpers
	   * ------------------------------
	   */
	
	  createMovie = function createMovie(smID, smURL) {
	
	    if (didAppend && appendSuccess) {
	      // ignore if already succeeded
	      return false;
	    }
	
	    function initMsg() {
	
	      // <d>
	
	      var options = [],
	          title,
	          msg = [],
	          delimiter = ' + ';
	
	      title = 'SoundManager ' + sm2.version + (!sm2.html5Only && sm2.useHTML5Audio ? sm2.hasHTML5 ? ' + HTML5 audio' : ', no HTML5 audio support' : '');
	
	      if (!sm2.html5Only) {
	
	        if (sm2.preferFlash) {
	          options.push('preferFlash');
	        }
	
	        if (sm2.useHighPerformance) {
	          options.push('useHighPerformance');
	        }
	
	        if (sm2.flashPollingInterval) {
	          options.push('flashPollingInterval (' + sm2.flashPollingInterval + 'ms)');
	        }
	
	        if (sm2.html5PollingInterval) {
	          options.push('html5PollingInterval (' + sm2.html5PollingInterval + 'ms)');
	        }
	
	        if (sm2.wmode) {
	          options.push('wmode (' + sm2.wmode + ')');
	        }
	
	        if (sm2.debugFlash) {
	          options.push('debugFlash');
	        }
	
	        if (sm2.useFlashBlock) {
	          options.push('flashBlock');
	        }
	      } else {
	
	        if (sm2.html5PollingInterval) {
	          options.push('html5PollingInterval (' + sm2.html5PollingInterval + 'ms)');
	        }
	      }
	
	      if (options.length) {
	        msg = msg.concat([options.join(delimiter)]);
	      }
	
	      sm2._wD(title + (msg.length ? delimiter + msg.join(', ') : ''), 1);
	
	      showSupport();
	
	      // </d>
	    }
	
	    if (sm2.html5Only) {
	
	      // 100% HTML5 mode
	      setVersionInfo();
	
	      initMsg();
	      sm2.oMC = id(sm2.movieID);
	      init();
	
	      // prevent multiple init attempts
	      didAppend = true;
	
	      appendSuccess = true;
	
	      return false;
	    }
	
	    // flash path
	    var remoteURL = smURL || sm2.url,
	        localURL = sm2.altURL || remoteURL,
	        swfTitle = 'JS/Flash audio component (SoundManager 2)',
	        oTarget = getDocument(),
	        extraClass = getSWFCSS(),
	        isRTL = null,
	        html = doc.getElementsByTagName('html')[0],
	        oEmbed,
	        oMovie,
	        tmp,
	        movieHTML,
	        oEl,
	        s,
	        x,
	        sClass;
	
	    isRTL = html && html.dir && html.dir.match(/rtl/i);
	    smID = smID === _undefined ? sm2.id : smID;
	
	    function param(name, value) {
	      return '<param name="' + name + '" value="' + value + '" />';
	    }
	
	    // safety check for legacy (change to Flash 9 URL)
	    setVersionInfo();
	    sm2.url = normalizeMovieURL(overHTTP ? remoteURL : localURL);
	    smURL = sm2.url;
	
	    sm2.wmode = !sm2.wmode && sm2.useHighPerformance ? 'transparent' : sm2.wmode;
	
	    if (sm2.wmode !== null && (ua.match(/msie 8/i) || !isIE && !sm2.useHighPerformance) && navigator.platform.match(/win32|win64/i)) {
	      /**
	       * extra-special case: movie doesn't load until scrolled into view when using wmode = anything but 'window' here
	       * does not apply when using high performance (position:fixed means on-screen), OR infinite flash load timeout
	       * wmode breaks IE 8 on Vista + Win7 too in some cases, as of January 2011 (?)
	       */
	      messages.push(strings.spcWmode);
	      sm2.wmode = null;
	    }
	
	    oEmbed = {
	      'name': smID,
	      'id': smID,
	      'src': smURL,
	      'quality': 'high',
	      'allowScriptAccess': sm2.allowScriptAccess,
	      'bgcolor': sm2.bgColor,
	      'pluginspage': http + 'www.macromedia.com/go/getflashplayer',
	      'title': swfTitle,
	      'type': 'application/x-shockwave-flash',
	      'wmode': sm2.wmode,
	      // http://help.adobe.com/en_US/as3/mobile/WS4bebcd66a74275c36cfb8137124318eebc6-7ffd.html
	      'hasPriority': 'true'
	    };
	
	    if (sm2.debugFlash) {
	      oEmbed.FlashVars = 'debug=1';
	    }
	
	    if (!sm2.wmode) {
	      // don't write empty attribute
	      delete oEmbed.wmode;
	    }
	
	    if (isIE) {
	
	      // IE is "special".
	      oMovie = doc.createElement('div');
	      movieHTML = ['<object id="' + smID + '" data="' + smURL + '" type="' + oEmbed.type + '" title="' + oEmbed.title + '" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=6,0,40,0">', param('movie', smURL), param('AllowScriptAccess', sm2.allowScriptAccess), param('quality', oEmbed.quality), sm2.wmode ? param('wmode', sm2.wmode) : '', param('bgcolor', sm2.bgColor), param('hasPriority', 'true'), sm2.debugFlash ? param('FlashVars', oEmbed.FlashVars) : '', '</object>'].join('');
	    } else {
	
	      oMovie = doc.createElement('embed');
	      for (tmp in oEmbed) {
	        if (oEmbed.hasOwnProperty(tmp)) {
	          oMovie.setAttribute(tmp, oEmbed[tmp]);
	        }
	      }
	    }
	
	    initDebug();
	    extraClass = getSWFCSS();
	    oTarget = getDocument();
	
	    if (oTarget) {
	
	      sm2.oMC = id(sm2.movieID) || doc.createElement('div');
	
	      if (!sm2.oMC.id) {
	
	        sm2.oMC.id = sm2.movieID;
	        sm2.oMC.className = swfCSS.swfDefault + ' ' + extraClass;
	        s = null;
	        oEl = null;
	
	        if (!sm2.useFlashBlock) {
	          if (sm2.useHighPerformance) {
	            // on-screen at all times
	            s = {
	              'position': 'fixed',
	              'width': '8px',
	              'height': '8px',
	              // >= 6px for flash to run fast, >= 8px to start up under Firefox/win32 in some cases. odd? yes.
	              'bottom': '0px',
	              'left': '0px',
	              'overflow': 'hidden'
	            };
	          } else {
	            // hide off-screen, lower priority
	            s = {
	              'position': 'absolute',
	              'width': '6px',
	              'height': '6px',
	              'top': '-9999px',
	              'left': '-9999px'
	            };
	            if (isRTL) {
	              s.left = Math.abs(parseInt(s.left, 10)) + 'px';
	            }
	          }
	        }
	
	        if (isWebkit) {
	          // soundcloud-reported render/crash fix, safari 5
	          sm2.oMC.style.zIndex = 10000;
	        }
	
	        if (!sm2.debugFlash) {
	          for (x in s) {
	            if (s.hasOwnProperty(x)) {
	              sm2.oMC.style[x] = s[x];
	            }
	          }
	        }
	
	        try {
	
	          if (!isIE) {
	            sm2.oMC.appendChild(oMovie);
	          }
	
	          oTarget.appendChild(sm2.oMC);
	
	          if (isIE) {
	            oEl = sm2.oMC.appendChild(doc.createElement('div'));
	            oEl.className = swfCSS.swfBox;
	            oEl.innerHTML = movieHTML;
	          }
	
	          appendSuccess = true;
	        } catch (e) {
	
	          throw new Error(str('domError') + ' \n' + e.toString());
	        }
	      } else {
	
	        // SM2 container is already in the document (eg. flashblock use case)
	        sClass = sm2.oMC.className;
	        sm2.oMC.className = (sClass ? sClass + ' ' : swfCSS.swfDefault) + (extraClass ? ' ' + extraClass : '');
	        sm2.oMC.appendChild(oMovie);
	
	        if (isIE) {
	          oEl = sm2.oMC.appendChild(doc.createElement('div'));
	          oEl.className = swfCSS.swfBox;
	          oEl.innerHTML = movieHTML;
	        }
	
	        appendSuccess = true;
	      }
	    }
	
	    didAppend = true;
	
	    initMsg();
	
	    // sm2._wD(sm + ': Trying to load ' + smURL + (!overHTTP && sm2.altURL ? ' (alternate URL)' : ''), 1);
	
	    return true;
	  };
	
	  initMovie = function initMovie() {
	
	    if (sm2.html5Only) {
	      createMovie();
	      return false;
	    }
	
	    // attempt to get, or create, movie (may already exist)
	    if (flash) {
	      return false;
	    }
	
	    if (!sm2.url) {
	
	      /**
	       * Something isn't right - we've reached init, but the soundManager url property has not been set.
	       * User has not called setup({url: ...}), or has not set soundManager.url (legacy use case) directly before init time.
	       * Notify and exit. If user calls setup() with a url: property, init will be restarted as in the deferred loading case.
	       */
	
	      _wDS('noURL');
	      return false;
	    }
	
	    // inline markup case
	    flash = sm2.getMovie(sm2.id);
	
	    if (!flash) {
	
	      if (!oRemoved) {
	
	        // try to create
	        createMovie(sm2.id, sm2.url);
	      } else {
	
	        // try to re-append removed movie after reboot()
	        if (!isIE) {
	          sm2.oMC.appendChild(oRemoved);
	        } else {
	          sm2.oMC.innerHTML = oRemovedHTML;
	        }
	
	        oRemoved = null;
	        didAppend = true;
	      }
	
	      flash = sm2.getMovie(sm2.id);
	    }
	
	    if (typeof sm2.oninitmovie === 'function') {
	      setTimeout(sm2.oninitmovie, 1);
	    }
	
	    // <d>
	    flushMessages();
	    // </d>
	
	    return true;
	  };
	
	  delayWaitForEI = function delayWaitForEI() {
	
	    setTimeout(waitForEI, 1000);
	  };
	
	  rebootIntoHTML5 = function rebootIntoHTML5() {
	
	    // special case: try for a reboot with preferFlash: false, if 100% HTML5 mode is possible and useFlashBlock is not enabled.
	
	    window.setTimeout(function () {
	
	      complain(smc + 'useFlashBlock is false, 100% HTML5 mode is possible. Rebooting with preferFlash: false...');
	
	      sm2.setup({
	        preferFlash: false
	      }).reboot();
	
	      // if for some reason you want to detect this case, use an ontimeout() callback and look for html5Only and didFlashBlock == true.
	      sm2.didFlashBlock = true;
	
	      sm2.beginDelayedInit();
	    }, 1);
	  };
	
	  waitForEI = function waitForEI() {
	
	    var p,
	        loadIncomplete = false;
	
	    if (!sm2.url) {
	      // No SWF url to load (noURL case) - exit for now. Will be retried when url is set.
	      return false;
	    }
	
	    if (waitingForEI) {
	      return false;
	    }
	
	    waitingForEI = true;
	    event.remove(window, 'load', delayWaitForEI);
	
	    if (hasFlash && tryInitOnFocus && !isFocused) {
	      // Safari won't load flash in background tabs, only when focused.
	      _wDS('waitFocus');
	      return false;
	    }
	
	    if (!didInit) {
	      p = sm2.getMoviePercent();
	      if (p > 0 && p < 100) {
	        loadIncomplete = true;
	      }
	    }
	
	    setTimeout(function () {
	
	      p = sm2.getMoviePercent();
	
	      if (loadIncomplete) {
	        // special case: if movie *partially* loaded, retry until it's 100% before assuming failure.
	        waitingForEI = false;
	        sm2._wD(str('waitSWF'));
	        window.setTimeout(delayWaitForEI, 1);
	        return false;
	      }
	
	      // <d>
	      if (!didInit) {
	
	        sm2._wD(sm + ': No Flash response within expected time. Likely causes: ' + (p === 0 ? 'SWF load failed, ' : '') + 'Flash blocked or JS-Flash security error.' + (sm2.debugFlash ? ' ' + str('checkSWF') : ''), 2);
	
	        if (!overHTTP && p) {
	
	          _wDS('localFail', 2);
	
	          if (!sm2.debugFlash) {
	            _wDS('tryDebug', 2);
	          }
	        }
	
	        if (p === 0) {
	
	          // if 0 (not null), probably a 404.
	          sm2._wD(str('swf404', sm2.url), 1);
	        }
	
	        debugTS('flashtojs', false, ': Timed out' + (overHTTP ? ' (Check flash security or flash blockers)' : ' (No plugin/missing SWF?)'));
	      }
	      // </d>
	
	      // give up / time-out, depending
	
	      if (!didInit && okToDisable) {
	
	        if (p === null) {
	
	          // SWF failed to report load progress. Possibly blocked.
	
	          if (sm2.useFlashBlock || sm2.flashLoadTimeout === 0) {
	
	            if (sm2.useFlashBlock) {
	
	              flashBlockHandler();
	            }
	
	            _wDS('waitForever');
	          } else {
	
	            // no custom flash block handling, but SWF has timed out. Will recover if user unblocks / allows SWF load.
	
	            if (!sm2.useFlashBlock && canIgnoreFlash) {
	
	              rebootIntoHTML5();
	            } else {
	
	              _wDS('waitForever');
	
	              // fire any regular registered ontimeout() listeners.
	              processOnEvents({
	                type: 'ontimeout',
	                ignoreInit: true,
	                error: {
	                  type: 'INIT_FLASHBLOCK'
	                }
	              });
	            }
	          }
	        } else {
	
	          // SWF loaded? Shouldn't be a blocking issue, then.
	
	          if (sm2.flashLoadTimeout === 0) {
	
	            _wDS('waitForever');
	          } else {
	
	            if (!sm2.useFlashBlock && canIgnoreFlash) {
	
	              rebootIntoHTML5();
	            } else {
	
	              failSafely(true);
	            }
	          }
	        }
	      }
	    }, sm2.flashLoadTimeout);
	  };
	
	  _handleFocus = function handleFocus() {
	
	    function cleanup() {
	      event.remove(window, 'focus', _handleFocus);
	    }
	
	    if (isFocused || !tryInitOnFocus) {
	      // already focused, or not special Safari background tab case
	      cleanup();
	      return true;
	    }
	
	    okToDisable = true;
	    isFocused = true;
	    _wDS('gotFocus');
	
	    // allow init to restart
	    waitingForEI = false;
	
	    // kick off ExternalInterface timeout, now that the SWF has started
	    delayWaitForEI();
	
	    cleanup();
	    return true;
	  };
	
	  flushMessages = function flushMessages() {
	
	    // <d>
	
	    // SM2 pre-init debug messages
	    if (messages.length) {
	      sm2._wD('SoundManager 2: ' + messages.join(' '), 1);
	      messages = [];
	    }
	
	    // </d>
	  };
	
	  showSupport = function showSupport() {
	
	    // <d>
	
	    flushMessages();
	
	    var item,
	        tests = [];
	
	    if (sm2.useHTML5Audio && sm2.hasHTML5) {
	      for (item in sm2.audioFormats) {
	        if (sm2.audioFormats.hasOwnProperty(item)) {
	          tests.push(item + ' = ' + sm2.html5[item] + (!sm2.html5[item] && needsFlash && sm2.flash[item] ? ' (using flash)' : sm2.preferFlash && sm2.flash[item] && needsFlash ? ' (preferring flash)' : !sm2.html5[item] ? ' (' + (sm2.audioFormats[item].required ? 'required, ' : '') + 'and no flash support)' : ''));
	        }
	      }
	      sm2._wD('SoundManager 2 HTML5 support: ' + tests.join(', '), 1);
	    }
	
	    // </d>
	  };
	
	  initComplete = function initComplete(bNoDisable) {
	
	    if (didInit) {
	      return false;
	    }
	
	    if (sm2.html5Only) {
	      // all good.
	      _wDS('sm2Loaded', 1);
	      didInit = true;
	      _initUserOnload();
	      debugTS('onload', true);
	      return true;
	    }
	
	    var wasTimeout = sm2.useFlashBlock && sm2.flashLoadTimeout && !sm2.getMoviePercent(),
	        result = true,
	        error;
	
	    if (!wasTimeout) {
	      didInit = true;
	    }
	
	    error = {
	      type: !hasFlash && needsFlash ? 'NO_FLASH' : 'INIT_TIMEOUT'
	    };
	
	    sm2._wD('SoundManager 2 ' + (disabled ? 'failed to load' : 'loaded') + ' (' + (disabled ? 'Flash security/load error' : 'OK') + ') ' + String.fromCharCode(disabled ? 10006 : 10003), disabled ? 2 : 1);
	
	    if (disabled || bNoDisable) {
	
	      if (sm2.useFlashBlock && sm2.oMC) {
	        sm2.oMC.className = getSWFCSS() + ' ' + (sm2.getMoviePercent() === null ? swfCSS.swfTimedout : swfCSS.swfError);
	      }
	
	      processOnEvents({
	        type: 'ontimeout',
	        error: error,
	        ignoreInit: true
	      });
	
	      debugTS('onload', false);
	      catchError(error);
	
	      result = false;
	    } else {
	
	      debugTS('onload', true);
	    }
	
	    if (!disabled) {
	
	      if (sm2.waitForWindowLoad && !windowLoaded) {
	
	        _wDS('waitOnload');
	        event.add(window, 'load', _initUserOnload);
	      } else {
	
	        // <d>
	        if (sm2.waitForWindowLoad && windowLoaded) {
	          _wDS('docLoaded');
	        }
	        // </d>
	
	        _initUserOnload();
	      }
	    }
	
	    return result;
	  };
	
	  /**
	   * apply top-level setupOptions object as local properties, eg., this.setupOptions.flashVersion -> this.flashVersion (soundManager.flashVersion)
	   * this maintains backward compatibility, and allows properties to be defined separately for use by soundManager.setup().
	   */
	
	  setProperties = function setProperties() {
	
	    var i,
	        o = sm2.setupOptions;
	
	    for (i in o) {
	
	      if (o.hasOwnProperty(i)) {
	
	        // assign local property if not already defined
	
	        if (sm2[i] === _undefined) {
	
	          sm2[i] = o[i];
	        } else if (sm2[i] !== o[i]) {
	
	          // legacy support: write manually-assigned property (eg., soundManager.url) back to setupOptions to keep things in sync
	          sm2.setupOptions[i] = sm2[i];
	        }
	      }
	    }
	  };
	
	  init = function init() {
	
	    // called after onload()
	
	    if (didInit) {
	      _wDS('didInit');
	      return false;
	    }
	
	    function cleanup() {
	      event.remove(window, 'load', sm2.beginDelayedInit);
	    }
	
	    if (sm2.html5Only) {
	
	      if (!didInit) {
	        // we don't need no steenking flash!
	        cleanup();
	        sm2.enabled = true;
	        initComplete();
	      }
	
	      return true;
	    }
	
	    // flash path
	    initMovie();
	
	    try {
	
	      // attempt to talk to Flash
	      flash._externalInterfaceTest(false);
	
	      /**
	       * Apply user-specified polling interval, OR, if "high performance" set, faster vs. default polling
	       * (determines frequency of whileloading/whileplaying callbacks, effectively driving UI framerates)
	       */
	      setPolling(true, sm2.flashPollingInterval || (sm2.useHighPerformance ? 10 : 50));
	
	      if (!sm2.debugMode) {
	        // stop the SWF from making debug output calls to JS
	        flash._disableDebug();
	      }
	
	      sm2.enabled = true;
	      debugTS('jstoflash', true);
	
	      if (!sm2.html5Only) {
	        // prevent browser from showing cached page state (or rather, restoring "suspended" page state) via back button, because flash may be dead
	        // http://www.webkit.org/blog/516/webkit-page-cache-ii-the-unload-event/
	        event.add(window, 'unload', doNothing);
	      }
	    } catch (e) {
	
	      sm2._wD('js/flash exception: ' + e.toString());
	
	      debugTS('jstoflash', false);
	
	      catchError({
	        type: 'JS_TO_FLASH_EXCEPTION',
	        fatal: true
	      });
	
	      // don't disable, for reboot()
	      failSafely(true);
	
	      initComplete();
	
	      return false;
	    }
	
	    initComplete();
	
	    // disconnect events
	    cleanup();
	
	    return true;
	  };
	
	  _domContentLoaded = function domContentLoaded() {
	
	    if (didDCLoaded) {
	      return false;
	    }
	
	    didDCLoaded = true;
	
	    // assign top-level soundManager properties eg. soundManager.url
	    setProperties();
	
	    initDebug();
	
	    if (!hasFlash && sm2.hasHTML5) {
	
	      sm2._wD('SoundManager 2: No Flash detected' + (!sm2.useHTML5Audio ? ', enabling HTML5.' : '. Trying HTML5-only mode.'), 1);
	
	      sm2.setup({
	        'useHTML5Audio': true,
	        // make sure we aren't preferring flash, either
	        // TODO: preferFlash should not matter if flash is not installed. Currently, stuff breaks without the below tweak.
	        'preferFlash': false
	      });
	    }
	
	    testHTML5();
	
	    if (!hasFlash && needsFlash) {
	
	      messages.push(strings.needFlash);
	
	      // TODO: Fatal here vs. timeout approach, etc.
	      // hack: fail sooner.
	      sm2.setup({
	        'flashLoadTimeout': 1
	      });
	    }
	
	    if (doc.removeEventListener) {
	      doc.removeEventListener('DOMContentLoaded', _domContentLoaded, false);
	    }
	
	    initMovie();
	
	    return true;
	  };
	
	  _domContentLoadedIE = function domContentLoadedIE() {
	
	    if (doc.readyState === 'complete') {
	      _domContentLoaded();
	      doc.detachEvent('onreadystatechange', _domContentLoadedIE);
	    }
	
	    return true;
	  };
	
	  _winOnLoad = function winOnLoad() {
	
	    // catch edge case of initComplete() firing after window.load()
	    windowLoaded = true;
	
	    // catch case where DOMContentLoaded has been sent, but we're still in doc.readyState = 'interactive'
	    _domContentLoaded();
	
	    event.remove(window, 'load', _winOnLoad);
	  };
	
	  // sniff up-front
	  detectFlash();
	
	  // focus and window load, init (primarily flash-driven)
	  event.add(window, 'focus', _handleFocus);
	  event.add(window, 'load', delayWaitForEI);
	  event.add(window, 'load', _winOnLoad);
	
	  if (doc.addEventListener) {
	
	    doc.addEventListener('DOMContentLoaded', _domContentLoaded, false);
	  } else if (doc.attachEvent) {
	
	    doc.attachEvent('onreadystatechange', _domContentLoadedIE);
	  } else {
	
	    // no add/attachevent support - safe to assume no JS -> Flash either
	    debugTS('onload', false);
	    catchError({
	      type: 'NO_DOM2_EVENTS',
	      fatal: true
	    });
	  }
	} // SoundManager()
	
	// SM2_DEFER details: http://www.schillmania.com/projects/soundmanager2/doc/getstarted/#lazy-loading
	
	if (window.SM2_DEFER === _undefined || !SM2_DEFER) {
	  soundManager = new SoundManager();
	}
	
	/**
	 * SoundManager public interfaces
	 * ------------------------------
	 */
	
	if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module && (0, _typeof3.default)(module.exports) === 'object') {
	
	  /**
	   * commonJS module
	   */
	
	  module.exports = SoundManager;
	}
	
	// standard browser case
	
	// constructor
	
	/**
	 * note: SM2 requires a window global due to Flash, which makes calls to window.soundManager.
	 * Flash may not always be needed, but this is not known until async init and SM2 may even "reboot" into Flash mode.
	 */
	
	// public API, flash callbacks etc.
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(256)(module)))

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(410);
	var template = __webpack_require__(414);
	
	function formatSoundWidth(time) {
	    var width;
	    if (time <= 2) {
	        width = 20;
	    } else if (time <= 10) {
	        width = 20 + (time - 2) * 5;
	    } else {
	        width = 60 + Math.floor((time - 10) / 10) * 5;
	    }
	    if (width >= 100) {
	        width = 80;
	    }
	    return width;
	}
	
	function formatAudioUrl(url) {
	    var houzhui = url.substring(url.lastIndexOf('.') + 1);
	    return url.replace('.' + houzhui, '.mp3');
	}
	
	// 播放时长格式化
	var timeFormat = function timeFormat(duration) {
	    var seconds = duration % 60 || '00';
	    var minutes = parseInt(duration / 60);
	    minutes = minutes > 0 ? minutes + "'" : '';
	    return minutes + seconds + '"';
	};
	
	module.exports = function (audioData) {
	    audioData.width = formatSoundWidth(audioData.audio_duration);
	    audioData.audio_url = formatAudioUrl(audioData.audio_url);
	    audioData.audio_duration = timeFormat(audioData.audio_duration);
	    return template(audioData);
	};

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ;  if (audio_url != '') {
	    ; __append("\n	<div class=\"news-audio clearfix\">\n		<div id=\"audio_")
	    ; __append(escape(index))
	    ; __append("\" class=\"liveaudio_container\" style=\"width: ")
	    ; __append(escape(width))
	    ; __append("%\"></div>\n		<div class=\"duration\">")
	    ; __append(escape(audio_duration))
	    ; __append("</div>\n	</div>\n")
	    ; }
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var pic = __webpack_require__(416);
	// let LiveSlide = require('./modules/slide/');
	var LivePhotoSwipe = __webpack_require__(421);
	
	// let liveslide;
	
	var Ppt = function Ppt(container, options) {
	    this.init(container, options);
	    this.LivePhotoSwipes = null;
	};
	
	Ppt.prototype.init = function (container, options) {
	    // let defaultData = {
	    //     pictures: options.pictures,
	    //     index: '0',
	    //     imageSrc: options.pictures[0].url,
	    //     picLength: options.pictures.length
	    // };
	    // if (typeof liveslide === 'undefined') {
	    //     liveslide = new LiveSlide(defaultData);
	    // }
	    this.resolveTemplate(container, options);
	    this.bindDomEvent(container, options.pictures);
	};
	
	Ppt.prototype.resolveTemplate = function (container, options) {
	    var picHtml = pic(options.pictures, options.mid);
	    $(container).append(picHtml);
	};
	
	Ppt.prototype.bindDomEvent = function (container, pictures) {
	    $(container).on('click', '[data-index]', function () {
	        var index = $(this).data('index');
	        var swipeOtions = {
	            pictures: pictures,
	            index: index
	        };
	        // 在点击时初始化
	        this.LivePhotoSwipes = new LivePhotoSwipe(swipeOtions);
	        this.LivePhotoSwipes.showSwipe();
	        // liveslide.show(pictures, index);
	    });
	};
	
	module.exports = Ppt;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var tmpl = __webpack_require__(417);
	var style = __webpack_require__(418);
	
	var formatPictures = function formatPictures(pics) {
	    var item = void 0;
	    var url = '//d.ifengimg.com/';
	    var rat = void 0;
	    for (var i = 0, iLen = pics.length; i < iLen; i++) {
	        item = pics[i];
	        if (pics.length === 1) {
	            rat = 'mw631/';
	        } else if (pics.length === 2 || pics.length === 4) {
	            if (item.h / 1 > item.w / 1) {
	                rat = 'w309/';
	            } else {
	                rat = 'h309/';
	            }
	        } else {
	            if (item.h / 1 > item.w / 1) {
	                rat = 'w203/';
	            } else {
	                rat = 'h203/';
	            }
	        }
	        item.url = item.url.replace(/^(?:https?:)?\/\//, '');
	        item.purl = url + rat + item.url;
	    }
	    return pics;
	};
	
	module.exports = function (picturesData, mid) {
	    var picData = formatPictures(picturesData);
	    return tmpl({ picData: picData, mid: mid });
	};

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ;  if (picData && (picData.length > 1)) {
	    ; __append("\n\n<div class=\"news-phos news-phos-")
	    ; if (picData.length == 2 || picData.length == 4) {
	    ; __append("2")
	    ; } else {
	    ; __append("3")
	    ; }
	    ; __append("\">\n    ")
	    ;  for (var i = 0;i < picData.length; i++) {
	    ; __append("\n        ")
	    ; if (i < 9) {
	    ; __append("\n        <div class=\"mod-imgdiv mod-imgdiv-")
	    ; __append(escape(i))
	    ; __append("\">\n            <div class=\"mod-imgdiv-bg\" data-index=\"")
	    ; __append(escape(i))
	    ; __append("\" data-mid=\"")
	    ; __append(escape(mid))
	    ; __append("\" style=\"background-image: url(")
	    ; __append(escape(picData[i].purl))
	    ; __append(" )\"></div>\n        </div>\n        ")
	    ; }
	    ; __append("\n    ")
	    ; }
	    ; __append("\n</div>\n")
	    ; }
	    ; __append("\n\n")
	    ;  if (picData && picData.length ==1) {
	    ; __append("\n<div class=\"news-phos news-phos-1\">\n    <div class=\"mod-imgdiv mod-imgdiv-0\" data-index=\"0\" data-mid=\"")
	    ; __append(escape(mid))
	    ; __append("\" ><img src=\"")
	    ; __append(escape(picData[0].purl))
	    ; __append("\" border=\"0\" /></div>\n</div>\n")
	    ; }
	    ; __append("\n\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */,
/* 420 */,
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(422);
	__webpack_require__(425);
	__webpack_require__(427);
	var PhotoSwipe = __webpack_require__(429);
	var PhotoSwiprUIDefault = __webpack_require__(430);
	var layout = __webpack_require__(431);
	
	var LivePhotoSwipe = function LivePhotoSwipe(options) {
	    this.init(options);
	};
	
	LivePhotoSwipe.prototype.init = function (options) {
	    this.pictures = this.cleanPics(options.pictures || []);
	    this.currentOrder = options.index || 0;
	    this.container = null;
	    this.gullery = null;
	    this.initComponent();
	    this.showSwipe();
	    this.handleDomEvent();
	};
	
	LivePhotoSwipe.prototype.cleanPics = function (pictures) {
	    var cleanPicsA = [];
	
	    for (var i = 0; i < pictures.length; i++) {
	        var bigShowPic = pictures[i].url;
	        if (bigShowPic.includes('d.ifengimg.com/')) {
	            bigShowPic = bigShowPic.split('d.ifengimg.com/').pop();
	            var paths = bigShowPic.split('/');
	            paths.shift();
	            bigShowPic = paths.join('/');
	        }
	
	        if (bigShowPic.includes('http://')) {
	            bigShowPic = bigShowPic.substring(7);
	        }
	
	        if (bigShowPic.includes('https://')) {
	            bigShowPic = bigShowPic.substring(8);
	        }
	
	        if (bigShowPic.includes('//')) {
	            bigShowPic = bigShowPic.substring(2);
	        }
	
	        cleanPicsA.push({
	            src: 'https://' + bigShowPic,
	            w: Number(pictures[i].w || 0),
	            h: Number(pictures[i].h || 0)
	        });
	    }
	
	    return cleanPicsA;
	};
	
	LivePhotoSwipe.prototype.initComponent = function () {
	    this.container = $(layout({ current: this.currentOrder + 1, totalPage: this.pictures.length }));
	    $('body').append(this.container);
	};
	
	LivePhotoSwipe.prototype.showSwipe = function () {
	    var gulleryConfig = {
	        index: this.currentOrder,
	        bgOpacity: 1,
	        spacing: 0.06,
	        loop: false,
	        history: false,
	        pinchToClose: false,
	        closeOnScroll: false,
	        closeOnVerticalDrag: false,
	        closeEl: false,
	        captionEl: false,
	        fullscreenEl: false,
	        zoomEl: false,
	        tapToClose: true,
	        tapToToggleControls: false,
	        clickToCloseNonZoomable: false,
	        isClickableElement: function isClickableElement(el) {
	            return el.tagName === 'IMG';
	        }
	    };
	    this.gullery = new PhotoSwipe(this.container[0], PhotoSwiprUIDefault, this.pictures, gulleryConfig);
	    this.gullery.init();
	};
	
	LivePhotoSwipe.prototype.handleDomEvent = function () {
	    var _this = this;
	
	    $('.photo_closeBtn').on('click', $.proxy(this.hide, this));
	    this.gullery.listen('afterChange', function () {
	        _this.currentOrder = _this.gullery.getCurrentIndex();
	        $('.photo_current').text(_this.currentOrder + 1);
	    });
	    this.gullery.listen('close', $.proxy(this.hide, this));
	};
	
	LivePhotoSwipe.prototype.hide = function () {
	    this.container.remove();
	};
	
	module.exports = LivePhotoSwipe;

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */,
/* 424 */,
/* 425 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */,
/* 427 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */,
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(1);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*! PhotoSwipe - v4.1.3 - 2019-01-08
	* http://photoswipe.com
	* Copyright (c) 2019 Dmitry Semenov; */
	!function (a, b) {
	   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (b), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) ? module.exports = b() : a.PhotoSwipe = b();
	}(undefined, function () {
	  "use strict";
	  var a = function a(_a3, b, c, d) {
	    var e = { features: null, bind: function bind(a, b, c, d) {
	        var e = (d ? "remove" : "add") + "EventListener";b = b.split(" ");for (var f = 0; f < b.length; f++) {
	          b[f] && a[e](b[f], c, !1);
	        }
	      }, isArray: function isArray(a) {
	        return a instanceof Array;
	      }, createEl: function createEl(a, b) {
	        var c = document.createElement(b || "div");return a && (c.className = a), c;
	      }, getScrollY: function getScrollY() {
	        var a = window.pageYOffset;return void 0 !== a ? a : document.documentElement.scrollTop;
	      }, unbind: function unbind(a, b, c) {
	        e.bind(a, b, c, !0);
	      }, removeClass: function removeClass(a, b) {
	        var c = new RegExp("(\\s|^)" + b + "(\\s|$)");a.className = a.className.replace(c, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
	      }, addClass: function addClass(a, b) {
	        e.hasClass(a, b) || (a.className += (a.className ? " " : "") + b);
	      }, hasClass: function hasClass(a, b) {
	        return a.className && new RegExp("(^|\\s)" + b + "(\\s|$)").test(a.className);
	      }, getChildByClass: function getChildByClass(a, b) {
	        for (var c = a.firstChild; c;) {
	          if (e.hasClass(c, b)) return c;c = c.nextSibling;
	        }
	      }, arraySearch: function arraySearch(a, b, c) {
	        for (var d = a.length; d--;) {
	          if (a[d][c] === b) return d;
	        }return -1;
	      }, extend: function extend(a, b, c) {
	        for (var d in b) {
	          if (b.hasOwnProperty(d)) {
	            if (c && a.hasOwnProperty(d)) continue;a[d] = b[d];
	          }
	        }
	      }, easing: { sine: { out: function out(a) {
	            return Math.sin(a * (Math.PI / 2));
	          }, inOut: function inOut(a) {
	            return -(Math.cos(Math.PI * a) - 1) / 2;
	          } }, cubic: { out: function out(a) {
	            return --a * a * a + 1;
	          } } }, detectFeatures: function detectFeatures() {
	        if (e.features) return e.features;var a = e.createEl(),
	            b = a.style,
	            c = "",
	            d = {};if (d.oldIE = document.all && !document.addEventListener, d.touch = "ontouchstart" in window, window.requestAnimationFrame && (d.raf = window.requestAnimationFrame, d.caf = window.cancelAnimationFrame), d.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled, !d.pointerEvent) {
	          var f = navigator.userAgent;if (/iP(hone|od)/.test(navigator.platform)) {
	            var g = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);g && g.length > 0 && (g = parseInt(g[1], 10), g >= 1 && g < 8 && (d.isOldIOSPhone = !0));
	          }var h = f.match(/Android\s([0-9\.]*)/),
	              i = h ? h[1] : 0;i = parseFloat(i), i >= 1 && (i < 4.4 && (d.isOldAndroid = !0), d.androidVersion = i), d.isMobileOpera = /opera mini|opera mobi/i.test(f);
	        }for (var j, k, l = ["transform", "perspective", "animationName"], m = ["", "webkit", "Moz", "ms", "O"], n = 0; n < 4; n++) {
	          c = m[n];for (var o = 0; o < 3; o++) {
	            j = l[o], k = c + (c ? j.charAt(0).toUpperCase() + j.slice(1) : j), !d[j] && k in b && (d[j] = k);
	          }c && !d.raf && (c = c.toLowerCase(), d.raf = window[c + "RequestAnimationFrame"], d.raf && (d.caf = window[c + "CancelAnimationFrame"] || window[c + "CancelRequestAnimationFrame"]));
	        }if (!d.raf) {
	          var p = 0;d.raf = function (a) {
	            var b = new Date().getTime(),
	                c = Math.max(0, 16 - (b - p)),
	                d = window.setTimeout(function () {
	              a(b + c);
	            }, c);return p = b + c, d;
	          }, d.caf = function (a) {
	            clearTimeout(a);
	          };
	        }return d.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect, e.features = d, d;
	      } };e.detectFeatures(), e.features.oldIE && (e.bind = function (a, b, c, d) {
	      b = b.split(" ");for (var e, f = (d ? "detach" : "attach") + "Event", g = function g() {
	        c.handleEvent.call(c);
	      }, h = 0; h < b.length; h++) {
	        if (e = b[h]) if ("object" == (typeof c === "undefined" ? "undefined" : (0, _typeof3.default)(c)) && c.handleEvent) {
	          if (d) {
	            if (!c["oldIE" + e]) return !1;
	          } else c["oldIE" + e] = g;a[f]("on" + e, c["oldIE" + e]);
	        } else a[f]("on" + e, c);
	      }
	    });var f = this,
	        g = 25,
	        h = 3,
	        i = { allowPanToNext: !0, spacing: .12, bgOpacity: 1, mouseUsed: !1, loop: !0, pinchToClose: !0, closeOnScroll: !0, closeOnVerticalDrag: !0, verticalDragRange: .75, hideAnimationDuration: 333, showAnimationDuration: 333, showHideOpacity: !1, focus: !0, escKey: !0, arrowKeys: !0, mainScrollEndFriction: .35, panEndFriction: .35, isClickableElement: function isClickableElement(a) {
	        return "A" === a.tagName;
	      }, getDoubleTapZoom: function getDoubleTapZoom(a, b) {
	        return a ? 1 : b.initialZoomLevel < .7 ? 1 : 1.33;
	      }, maxSpreadZoom: 1.33, modal: !0, scaleMode: "fit" };e.extend(i, d);var j,
	        k,
	        l,
	        m,
	        n,
	        o,
	        p,
	        q,
	        r,
	        s,
	        t,
	        u,
	        v,
	        w,
	        x,
	        y,
	        z,
	        A,
	        B,
	        C,
	        D,
	        E,
	        F,
	        G,
	        H,
	        I,
	        J,
	        K,
	        L,
	        M,
	        N,
	        O,
	        P,
	        Q,
	        R,
	        S,
	        T,
	        U,
	        V,
	        W,
	        X,
	        Y,
	        Z,
	        $,
	        _,
	        aa,
	        ba,
	        ca,
	        da,
	        ea,
	        fa,
	        ga,
	        ha,
	        ia,
	        ja,
	        ka,
	        la,
	        ma = function ma() {
	      return { x: 0, y: 0 };
	    },
	        na = ma(),
	        oa = ma(),
	        pa = ma(),
	        qa = {},
	        ra = 0,
	        sa = {},
	        ta = ma(),
	        ua = 0,
	        va = !0,
	        wa = [],
	        xa = {},
	        ya = !1,
	        za = function za(a, b) {
	      e.extend(f, b.publicMethods), wa.push(a);
	    },
	        Aa = function Aa(a) {
	      var b = ac();return a > b - 1 ? a - b : a < 0 ? b + a : a;
	    },
	        Ba = {},
	        Ca = function Ca(a, b) {
	      return Ba[a] || (Ba[a] = []), Ba[a].push(b);
	    },
	        Da = function Da(a) {
	      var b = Ba[a];if (b) {
	        var c = Array.prototype.slice.call(arguments);c.shift();for (var d = 0; d < b.length; d++) {
	          b[d].apply(f, c);
	        }
	      }
	    },
	        Ea = function Ea() {
	      return new Date().getTime();
	    },
	        Fa = function Fa(a) {
	      ja = a, f.bg.style.opacity = a * i.bgOpacity;
	    },
	        Ga = function Ga(a, b, c, d, e) {
	      (!ya || e && e !== f.currItem) && (d /= e ? e.fitRatio : f.currItem.fitRatio), a[E] = u + b + "px, " + c + "px" + v + " scale(" + d + ")";
	    },
	        Ha = function Ha(a) {
	      ea && (a && (s > f.currItem.fitRatio ? ya || (mc(f.currItem, !1, !0), ya = !0) : ya && (mc(f.currItem), ya = !1)), Ga(ea, pa.x, pa.y, s));
	    },
	        Ia = function Ia(a) {
	      a.container && Ga(a.container.style, a.initialPosition.x, a.initialPosition.y, a.initialZoomLevel, a);
	    },
	        Ja = function Ja(a, b) {
	      b[E] = u + a + "px, 0px" + v;
	    },
	        Ka = function Ka(a, b) {
	      if (!i.loop && b) {
	        var c = m + (ta.x * ra - a) / ta.x,
	            d = Math.round(a - tb.x);(c < 0 && d > 0 || c >= ac() - 1 && d < 0) && (a = tb.x + d * i.mainScrollEndFriction);
	      }tb.x = a, Ja(a, n);
	    },
	        La = function La(a, b) {
	      var c = ub[a] - sa[a];return oa[a] + na[a] + c - c * (b / t);
	    },
	        Ma = function Ma(a, b) {
	      a.x = b.x, a.y = b.y, b.id && (a.id = b.id);
	    },
	        Na = function Na(a) {
	      a.x = Math.round(a.x), a.y = Math.round(a.y);
	    },
	        Oa = null,
	        Pa = function Pa() {
	      Oa && (e.unbind(document, "mousemove", Pa), e.addClass(_a3, "pswp--has_mouse"), i.mouseUsed = !0, Da("mouseUsed")), Oa = setTimeout(function () {
	        Oa = null;
	      }, 100);
	    },
	        Qa = function Qa() {
	      e.bind(document, "keydown", f), N.transform && e.bind(f.scrollWrap, "click", f), i.mouseUsed || e.bind(document, "mousemove", Pa), e.bind(window, "resize scroll orientationchange", f), Da("bindEvents");
	    },
	        Ra = function Ra() {
	      e.unbind(window, "resize scroll orientationchange", f), e.unbind(window, "scroll", r.scroll), e.unbind(document, "keydown", f), e.unbind(document, "mousemove", Pa), N.transform && e.unbind(f.scrollWrap, "click", f), V && e.unbind(window, p, f), clearTimeout(O), Da("unbindEvents");
	    },
	        Sa = function Sa(a, b) {
	      var c = ic(f.currItem, qa, a);return b && (da = c), c;
	    },
	        Ta = function Ta(a) {
	      return a || (a = f.currItem), a.initialZoomLevel;
	    },
	        Ua = function Ua(a) {
	      return a || (a = f.currItem), a.w > 0 ? i.maxSpreadZoom : 1;
	    },
	        Va = function Va(a, b, c, d) {
	      return d === f.currItem.initialZoomLevel ? (c[a] = f.currItem.initialPosition[a], !0) : (c[a] = La(a, d), c[a] > b.min[a] ? (c[a] = b.min[a], !0) : c[a] < b.max[a] && (c[a] = b.max[a], !0));
	    },
	        Wa = function Wa() {
	      if (E) {
	        var b = N.perspective && !G;return u = "translate" + (b ? "3d(" : "("), void (v = N.perspective ? ", 0px)" : ")");
	      }E = "left", e.addClass(_a3, "pswp--ie"), Ja = function Ja(a, b) {
	        b.left = a + "px";
	      }, Ia = function Ia(a) {
	        var b = a.fitRatio > 1 ? 1 : a.fitRatio,
	            c = a.container.style,
	            d = b * a.w,
	            e = b * a.h;c.width = d + "px", c.height = e + "px", c.left = a.initialPosition.x + "px", c.top = a.initialPosition.y + "px";
	      }, Ha = function Ha() {
	        if (ea) {
	          var a = ea,
	              b = f.currItem,
	              c = b.fitRatio > 1 ? 1 : b.fitRatio,
	              d = c * b.w,
	              e = c * b.h;a.width = d + "px", a.height = e + "px", a.left = pa.x + "px", a.top = pa.y + "px";
	        }
	      };
	    },
	        Xa = function Xa(a) {
	      var b = "";i.escKey && 27 === a.keyCode ? b = "close" : i.arrowKeys && (37 === a.keyCode ? b = "prev" : 39 === a.keyCode && (b = "next")), b && (a.ctrlKey || a.altKey || a.shiftKey || a.metaKey || (a.preventDefault ? a.preventDefault() : a.returnValue = !1, f[b]()));
	    },
	        Ya = function Ya(a) {
	      a && (Y || X || fa || T) && (a.preventDefault(), a.stopPropagation());
	    },
	        Za = function Za() {
	      f.setScrollOffset(0, e.getScrollY());
	    },
	        $a = {},
	        _a = 0,
	        ab = function ab(a) {
	      $a[a] && ($a[a].raf && I($a[a].raf), _a--, delete $a[a]);
	    },
	        bb = function bb(a) {
	      $a[a] && ab(a), $a[a] || (_a++, $a[a] = {});
	    },
	        cb = function cb() {
	      for (var a in $a) {
	        $a.hasOwnProperty(a) && ab(a);
	      }
	    },
	        db = function db(a, b, c, d, e, f, g) {
	      var h,
	          i = Ea();bb(a);var j = function j() {
	        if ($a[a]) {
	          if (h = Ea() - i, h >= d) return ab(a), f(c), void (g && g());f((c - b) * e(h / d) + b), $a[a].raf = H(j);
	        }
	      };j();
	    },
	        eb = { shout: Da, listen: Ca, viewportSize: qa, options: i, isMainScrollAnimating: function isMainScrollAnimating() {
	        return fa;
	      }, getZoomLevel: function getZoomLevel() {
	        return s;
	      }, getCurrentIndex: function getCurrentIndex() {
	        return m;
	      }, isDragging: function isDragging() {
	        return V;
	      }, isZooming: function isZooming() {
	        return aa;
	      }, setScrollOffset: function setScrollOffset(a, b) {
	        sa.x = a, M = sa.y = b, Da("updateScrollOffset", sa);
	      }, applyZoomPan: function applyZoomPan(a, b, c, d) {
	        pa.x = b, pa.y = c, s = a, Ha(d);
	      }, init: function init() {
	        if (!j && !k) {
	          var c;f.framework = e, f.template = _a3, f.bg = e.getChildByClass(_a3, "pswp__bg"), J = _a3.className, j = !0, N = e.detectFeatures(), H = N.raf, I = N.caf, E = N.transform, L = N.oldIE, f.scrollWrap = e.getChildByClass(_a3, "pswp__scroll-wrap"), f.container = e.getChildByClass(f.scrollWrap, "pswp__container"), n = f.container.style, f.itemHolders = y = [{ el: f.container.children[0], wrap: 0, index: -1 }, { el: f.container.children[1], wrap: 0, index: -1 }, { el: f.container.children[2], wrap: 0, index: -1 }], y[0].el.style.display = y[2].el.style.display = "none", Wa(), r = { resize: f.updateSize, orientationchange: function orientationchange() {
	              clearTimeout(O), O = setTimeout(function () {
	                qa.x !== f.scrollWrap.clientWidth && f.updateSize();
	              }, 500);
	            }, scroll: Za, keydown: Xa, click: Ya };var d = N.isOldIOSPhone || N.isOldAndroid || N.isMobileOpera;for (N.animationName && N.transform && !d || (i.showAnimationDuration = i.hideAnimationDuration = 0), c = 0; c < wa.length; c++) {
	            f["init" + wa[c]]();
	          }if (b) {
	            var g = f.ui = new b(f, e);g.init();
	          }Da("firstUpdate"), m = m || i.index || 0, (isNaN(m) || m < 0 || m >= ac()) && (m = 0), f.currItem = _b(m), (N.isOldIOSPhone || N.isOldAndroid) && (va = !1), _a3.setAttribute("aria-hidden", "false"), i.modal && (va ? _a3.style.position = "fixed" : (_a3.style.position = "absolute", _a3.style.top = e.getScrollY() + "px")), void 0 === M && (Da("initialLayout"), M = K = e.getScrollY());var l = "pswp--open ";for (i.mainClass && (l += i.mainClass + " "), i.showHideOpacity && (l += "pswp--animate_opacity "), l += G ? "pswp--touch" : "pswp--notouch", l += N.animationName ? " pswp--css_animation" : "", l += N.svg ? " pswp--svg" : "", e.addClass(_a3, l), f.updateSize(), o = -1, ua = null, c = 0; c < h; c++) {
	            Ja((c + o) * ta.x, y[c].el.style);
	          }L || e.bind(f.scrollWrap, q, f), Ca("initialZoomInEnd", function () {
	            f.setContent(y[0], m - 1), f.setContent(y[2], m + 1), y[0].el.style.display = y[2].el.style.display = "block", i.focus && _a3.focus(), Qa();
	          }), f.setContent(y[1], m), f.updateCurrItem(), Da("afterInit"), va || (w = setInterval(function () {
	            _a || V || aa || s !== f.currItem.initialZoomLevel || f.updateSize();
	          }, 1e3)), e.addClass(_a3, "pswp--visible");
	        }
	      }, close: function close() {
	        j && (j = !1, k = !0, Da("close"), Ra(), cc(f.currItem, null, !0, f.destroy));
	      }, destroy: function destroy() {
	        Da("destroy"), Xb && clearTimeout(Xb), _a3.setAttribute("aria-hidden", "true"), _a3.className = J, w && clearInterval(w), e.unbind(f.scrollWrap, q, f), e.unbind(window, "scroll", f), zb(), cb(), Ba = null;
	      }, panTo: function panTo(a, b, c) {
	        c || (a > da.min.x ? a = da.min.x : a < da.max.x && (a = da.max.x), b > da.min.y ? b = da.min.y : b < da.max.y && (b = da.max.y)), pa.x = a, pa.y = b, Ha();
	      }, handleEvent: function handleEvent(a) {
	        a = a || window.event, r[a.type] && r[a.type](a);
	      }, goTo: function goTo(a) {
	        a = Aa(a);var b = a - m;ua = b, m = a, f.currItem = _b(m), ra -= b, Ka(ta.x * ra), cb(), fa = !1, f.updateCurrItem();
	      }, next: function next() {
	        f.goTo(m + 1);
	      }, prev: function prev() {
	        f.goTo(m - 1);
	      }, updateCurrZoomItem: function updateCurrZoomItem(a) {
	        if (a && Da("beforeChange", 0), y[1].el.children.length) {
	          var b = y[1].el.children[0];ea = e.hasClass(b, "pswp__zoom-wrap") ? b.style : null;
	        } else ea = null;da = f.currItem.bounds, t = s = f.currItem.initialZoomLevel, pa.x = da.center.x, pa.y = da.center.y, a && Da("afterChange");
	      }, invalidateCurrItems: function invalidateCurrItems() {
	        x = !0;for (var a = 0; a < h; a++) {
	          y[a].item && (y[a].item.needsUpdate = !0);
	        }
	      }, updateCurrItem: function updateCurrItem(a) {
	        if (0 !== ua) {
	          var b,
	              c = Math.abs(ua);if (!(a && c < 2)) {
	            f.currItem = _b(m), ya = !1, Da("beforeChange", ua), c >= h && (o += ua + (ua > 0 ? -h : h), c = h);for (var d = 0; d < c; d++) {
	              ua > 0 ? (b = y.shift(), y[h - 1] = b, o++, Ja((o + 2) * ta.x, b.el.style), f.setContent(b, m - c + d + 1 + 1)) : (b = y.pop(), y.unshift(b), o--, Ja(o * ta.x, b.el.style), f.setContent(b, m + c - d - 1 - 1));
	            }if (ea && 1 === Math.abs(ua)) {
	              var e = _b(z);e.initialZoomLevel !== s && (ic(e, qa), mc(e), Ia(e));
	            }ua = 0, f.updateCurrZoomItem(), z = m, Da("afterChange");
	          }
	        }
	      }, updateSize: function updateSize(b) {
	        if (!va && i.modal) {
	          var c = e.getScrollY();if (M !== c && (_a3.style.top = c + "px", M = c), !b && xa.x === window.innerWidth && xa.y === window.innerHeight) return;xa.x = window.innerWidth, xa.y = window.innerHeight, _a3.style.height = xa.y + "px";
	        }if (qa.x = f.scrollWrap.clientWidth, qa.y = f.scrollWrap.clientHeight, Za(), ta.x = qa.x + Math.round(qa.x * i.spacing), ta.y = qa.y, Ka(ta.x * ra), Da("beforeResize"), void 0 !== o) {
	          for (var d, g, j, k = 0; k < h; k++) {
	            d = y[k], Ja((k + o) * ta.x, d.el.style), j = m + k - 1, i.loop && ac() > 2 && (j = Aa(j)), g = _b(j), g && (x || g.needsUpdate || !g.bounds) ? (f.cleanSlide(g), f.setContent(d, j), 1 === k && (f.currItem = g, f.updateCurrZoomItem(!0)), g.needsUpdate = !1) : d.index === -1 && j >= 0 && f.setContent(d, j), g && g.container && (ic(g, qa), mc(g), Ia(g));
	          }x = !1;
	        }t = s = f.currItem.initialZoomLevel, da = f.currItem.bounds, da && (pa.x = da.center.x, pa.y = da.center.y, Ha(!0)), Da("resize");
	      }, zoomTo: function zoomTo(a, b, c, d, f) {
	        b && (t = s, ub.x = Math.abs(b.x) - pa.x, ub.y = Math.abs(b.y) - pa.y, Ma(oa, pa));var g = Sa(a, !1),
	            h = {};Va("x", g, h, a), Va("y", g, h, a);var i = s,
	            j = { x: pa.x, y: pa.y };Na(h);var k = function k(b) {
	          1 === b ? (s = a, pa.x = h.x, pa.y = h.y) : (s = (a - i) * b + i, pa.x = (h.x - j.x) * b + j.x, pa.y = (h.y - j.y) * b + j.y), f && f(b), Ha(1 === b);
	        };c ? db("customZoomTo", 0, 1, c, d || e.easing.sine.inOut, k) : k(1);
	      } },
	        fb = 30,
	        gb = 10,
	        hb = {},
	        ib = {},
	        jb = {},
	        kb = {},
	        lb = {},
	        mb = [],
	        nb = {},
	        ob = [],
	        pb = {},
	        qb = 0,
	        rb = ma(),
	        sb = 0,
	        tb = ma(),
	        ub = ma(),
	        vb = ma(),
	        wb = function wb(a, b) {
	      return a.x === b.x && a.y === b.y;
	    },
	        xb = function xb(a, b) {
	      return Math.abs(a.x - b.x) < g && Math.abs(a.y - b.y) < g;
	    },
	        yb = function yb(a, b) {
	      return pb.x = Math.abs(a.x - b.x), pb.y = Math.abs(a.y - b.y), Math.sqrt(pb.x * pb.x + pb.y * pb.y);
	    },
	        zb = function zb() {
	      Z && (I(Z), Z = null);
	    },
	        Ab = function Ab() {
	      V && (Z = H(Ab), Qb());
	    },
	        Bb = function Bb() {
	      return !("fit" === i.scaleMode && s === f.currItem.initialZoomLevel);
	    },
	        Cb = function Cb(a, b) {
	      return !(!a || a === document) && !(a.getAttribute("class") && a.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (b(a) ? a : Cb(a.parentNode, b));
	    },
	        Db = {},
	        Eb = function Eb(a, b) {
	      return Db.prevent = !Cb(a.target, i.isClickableElement), Da("preventDragEvent", a, b, Db), Db.prevent;
	    },
	        Fb = function Fb(a, b) {
	      return b.x = a.pageX, b.y = a.pageY, b.id = a.identifier, b;
	    },
	        Gb = function Gb(a, b, c) {
	      c.x = .5 * (a.x + b.x), c.y = .5 * (a.y + b.y);
	    },
	        Hb = function Hb(a, b, c) {
	      if (a - Q > 50) {
	        var d = ob.length > 2 ? ob.shift() : {};d.x = b, d.y = c, ob.push(d), Q = a;
	      }
	    },
	        Ib = function Ib() {
	      var a = pa.y - f.currItem.initialPosition.y;return 1 - Math.abs(a / (qa.y / 2));
	    },
	        Jb = {},
	        Kb = {},
	        Lb = [],
	        Mb = function Mb(a) {
	      for (; Lb.length > 0;) {
	        Lb.pop();
	      }return F ? (la = 0, mb.forEach(function (a) {
	        0 === la ? Lb[0] = a : 1 === la && (Lb[1] = a), la++;
	      })) : a.type.indexOf("touch") > -1 ? a.touches && a.touches.length > 0 && (Lb[0] = Fb(a.touches[0], Jb), a.touches.length > 1 && (Lb[1] = Fb(a.touches[1], Kb))) : (Jb.x = a.pageX, Jb.y = a.pageY, Jb.id = "", Lb[0] = Jb), Lb;
	    },
	        Nb = function Nb(a, b) {
	      var c,
	          d,
	          e,
	          g,
	          h = 0,
	          j = pa[a] + b[a],
	          k = b[a] > 0,
	          l = tb.x + b.x,
	          m = tb.x - nb.x;return c = j > da.min[a] || j < da.max[a] ? i.panEndFriction : 1, j = pa[a] + b[a] * c, !i.allowPanToNext && s !== f.currItem.initialZoomLevel || (ea ? "h" !== ga || "x" !== a || X || (k ? (j > da.min[a] && (c = i.panEndFriction, h = da.min[a] - j, d = da.min[a] - oa[a]), (d <= 0 || m < 0) && ac() > 1 ? (g = l, m < 0 && l > nb.x && (g = nb.x)) : da.min.x !== da.max.x && (e = j)) : (j < da.max[a] && (c = i.panEndFriction, h = j - da.max[a], d = oa[a] - da.max[a]), (d <= 0 || m > 0) && ac() > 1 ? (g = l, m > 0 && l < nb.x && (g = nb.x)) : da.min.x !== da.max.x && (e = j))) : g = l, "x" !== a) ? void (fa || $ || s > f.currItem.fitRatio && (pa[a] += b[a] * c)) : (void 0 !== g && (Ka(g, !0), $ = g !== nb.x), da.min.x !== da.max.x && (void 0 !== e ? pa.x = e : $ || (pa.x += b.x * c)), void 0 !== g);
	    },
	        Ob = function Ob(a) {
	      if (!("mousedown" === a.type && a.button > 0)) {
	        if ($b) return void a.preventDefault();if (!U || "mousedown" !== a.type) {
	          if (Eb(a, !0) && a.preventDefault(), Da("pointerDown"), F) {
	            var b = e.arraySearch(mb, a.pointerId, "id");b < 0 && (b = mb.length), mb[b] = { x: a.pageX, y: a.pageY, id: a.pointerId };
	          }var c = Mb(a),
	              d = c.length;_ = null, cb(), V && 1 !== d || (V = ha = !0, e.bind(window, p, f), S = ka = ia = T = $ = Y = W = X = !1, ga = null, Da("firstTouchStart", c), Ma(oa, pa), na.x = na.y = 0, Ma(kb, c[0]), Ma(lb, kb), nb.x = ta.x * ra, ob = [{ x: kb.x, y: kb.y }], Q = P = Ea(), Sa(s, !0), zb(), Ab()), !aa && d > 1 && !fa && !$ && (t = s, X = !1, aa = W = !0, na.y = na.x = 0, Ma(oa, pa), Ma(hb, c[0]), Ma(ib, c[1]), Gb(hb, ib, vb), ub.x = Math.abs(vb.x) - pa.x, ub.y = Math.abs(vb.y) - pa.y, ba = ca = yb(hb, ib));
	        }
	      }
	    },
	        Pb = function Pb(a) {
	      if (a.preventDefault(), F) {
	        var b = e.arraySearch(mb, a.pointerId, "id");if (b > -1) {
	          var c = mb[b];c.x = a.pageX, c.y = a.pageY;
	        }
	      }if (V) {
	        var d = Mb(a);if (ga || Y || aa) _ = d;else if (tb.x !== ta.x * ra) ga = "h";else {
	          var f = Math.abs(d[0].x - kb.x) - Math.abs(d[0].y - kb.y);Math.abs(f) >= gb && (ga = f > 0 ? "h" : "v", _ = d);
	        }
	      }
	    },
	        Qb = function Qb() {
	      if (_) {
	        var a = _.length;if (0 !== a) if (Ma(hb, _[0]), jb.x = hb.x - kb.x, jb.y = hb.y - kb.y, aa && a > 1) {
	          if (kb.x = hb.x, kb.y = hb.y, !jb.x && !jb.y && wb(_[1], ib)) return;Ma(ib, _[1]), X || (X = !0, Da("zoomGestureStarted"));var b = yb(hb, ib),
	              c = Vb(b);c > f.currItem.initialZoomLevel + f.currItem.initialZoomLevel / 15 && (ka = !0);var d = 1,
	              e = Ta(),
	              g = Ua();if (c < e) {
	            if (i.pinchToClose && !ka && t <= f.currItem.initialZoomLevel) {
	              var h = e - c,
	                  j = 1 - h / (e / 1.2);Fa(j), Da("onPinchClose", j), ia = !0;
	            } else d = (e - c) / e, d > 1 && (d = 1), c = e - d * (e / 3);
	          } else c > g && (d = (c - g) / (6 * e), d > 1 && (d = 1), c = g + d * e);d < 0 && (d = 0), ba = b, Gb(hb, ib, rb), na.x += rb.x - vb.x, na.y += rb.y - vb.y, Ma(vb, rb), pa.x = La("x", c), pa.y = La("y", c), S = c > s, s = c, Ha();
	        } else {
	          if (!ga) return;if (ha && (ha = !1, Math.abs(jb.x) >= gb && (jb.x -= _[0].x - lb.x), Math.abs(jb.y) >= gb && (jb.y -= _[0].y - lb.y)), kb.x = hb.x, kb.y = hb.y, 0 === jb.x && 0 === jb.y) return;if ("v" === ga && i.closeOnVerticalDrag && !Bb()) {
	            na.y += jb.y, pa.y += jb.y;var k = Ib();return T = !0, Da("onVerticalDrag", k), Fa(k), void Ha();
	          }Hb(Ea(), hb.x, hb.y), Y = !0, da = f.currItem.bounds;var l = Nb("x", jb);l || (Nb("y", jb), Na(pa), Ha());
	        }
	      }
	    },
	        Rb = function Rb(a) {
	      if (N.isOldAndroid) {
	        if (U && "mouseup" === a.type) return;a.type.indexOf("touch") > -1 && (clearTimeout(U), U = setTimeout(function () {
	          U = 0;
	        }, 600));
	      }Da("pointerUp"), Eb(a, !1) && a.preventDefault();var b;if (F) {
	        var c = e.arraySearch(mb, a.pointerId, "id");if (c > -1) if (b = mb.splice(c, 1)[0], navigator.msPointerEnabled) {
	          var d = { 4: "mouse", 2: "touch", 3: "pen" };b.type = d[a.pointerType], b.type || (b.type = a.pointerType || "mouse");
	        } else b.type = a.pointerType || "mouse";
	      }var g,
	          h = Mb(a),
	          j = h.length;if ("mouseup" === a.type && (j = 0), 2 === j) return _ = null, !0;1 === j && Ma(lb, h[0]), 0 !== j || ga || fa || (b || ("mouseup" === a.type ? b = { x: a.pageX, y: a.pageY, type: "mouse" } : a.changedTouches && a.changedTouches[0] && (b = { x: a.changedTouches[0].pageX, y: a.changedTouches[0].pageY, type: "touch" })), Da("touchRelease", a, b));var k = -1;if (0 === j && (V = !1, e.unbind(window, p, f), zb(), aa ? k = 0 : sb !== -1 && (k = Ea() - sb)), sb = 1 === j ? Ea() : -1, g = k !== -1 && k < 150 ? "zoom" : "swipe", aa && j < 2 && (aa = !1, 1 === j && (g = "zoomPointerUp"), Da("zoomGestureEnded")), _ = null, Y || X || fa || T) if (cb(), R || (R = Sb()), R.calculateSwipeSpeed("x"), T) {
	        var l = Ib();if (l < i.verticalDragRange) f.close();else {
	          var m = pa.y,
	              n = ja;db("verticalDrag", 0, 1, 300, e.easing.cubic.out, function (a) {
	            pa.y = (f.currItem.initialPosition.y - m) * a + m, Fa((1 - n) * a + n), Ha();
	          }), Da("onVerticalDrag", 1);
	        }
	      } else {
	        if (($ || fa) && 0 === j) {
	          var o = Ub(g, R);if (o) return;g = "zoomPointerUp";
	        }if (!fa) return "swipe" !== g ? void Wb() : void (!$ && s > f.currItem.fitRatio && Tb(R));
	      }
	    },
	        Sb = function Sb() {
	      var a,
	          b,
	          c = { lastFlickOffset: {}, lastFlickDist: {}, lastFlickSpeed: {}, slowDownRatio: {}, slowDownRatioReverse: {}, speedDecelerationRatio: {}, speedDecelerationRatioAbs: {}, distanceOffset: {}, backAnimDestination: {}, backAnimStarted: {}, calculateSwipeSpeed: function calculateSwipeSpeed(d) {
	          ob.length > 1 ? (a = Ea() - Q + 50, b = ob[ob.length - 2][d]) : (a = Ea() - P, b = lb[d]), c.lastFlickOffset[d] = kb[d] - b, c.lastFlickDist[d] = Math.abs(c.lastFlickOffset[d]), c.lastFlickDist[d] > 20 ? c.lastFlickSpeed[d] = c.lastFlickOffset[d] / a : c.lastFlickSpeed[d] = 0, Math.abs(c.lastFlickSpeed[d]) < .1 && (c.lastFlickSpeed[d] = 0), c.slowDownRatio[d] = .95, c.slowDownRatioReverse[d] = 1 - c.slowDownRatio[d], c.speedDecelerationRatio[d] = 1;
	        }, calculateOverBoundsAnimOffset: function calculateOverBoundsAnimOffset(a, b) {
	          c.backAnimStarted[a] || (pa[a] > da.min[a] ? c.backAnimDestination[a] = da.min[a] : pa[a] < da.max[a] && (c.backAnimDestination[a] = da.max[a]), void 0 !== c.backAnimDestination[a] && (c.slowDownRatio[a] = .7, c.slowDownRatioReverse[a] = 1 - c.slowDownRatio[a], c.speedDecelerationRatioAbs[a] < .05 && (c.lastFlickSpeed[a] = 0, c.backAnimStarted[a] = !0, db("bounceZoomPan" + a, pa[a], c.backAnimDestination[a], b || 300, e.easing.sine.out, function (b) {
	            pa[a] = b, Ha();
	          }))));
	        }, calculateAnimOffset: function calculateAnimOffset(a) {
	          c.backAnimStarted[a] || (c.speedDecelerationRatio[a] = c.speedDecelerationRatio[a] * (c.slowDownRatio[a] + c.slowDownRatioReverse[a] - c.slowDownRatioReverse[a] * c.timeDiff / 10), c.speedDecelerationRatioAbs[a] = Math.abs(c.lastFlickSpeed[a] * c.speedDecelerationRatio[a]), c.distanceOffset[a] = c.lastFlickSpeed[a] * c.speedDecelerationRatio[a] * c.timeDiff, pa[a] += c.distanceOffset[a]);
	        }, panAnimLoop: function panAnimLoop() {
	          if ($a.zoomPan && ($a.zoomPan.raf = H(c.panAnimLoop), c.now = Ea(), c.timeDiff = c.now - c.lastNow, c.lastNow = c.now, c.calculateAnimOffset("x"), c.calculateAnimOffset("y"), Ha(), c.calculateOverBoundsAnimOffset("x"), c.calculateOverBoundsAnimOffset("y"), c.speedDecelerationRatioAbs.x < .05 && c.speedDecelerationRatioAbs.y < .05)) return pa.x = Math.round(pa.x), pa.y = Math.round(pa.y), Ha(), void ab("zoomPan");
	        } };return c;
	    },
	        Tb = function Tb(a) {
	      return a.calculateSwipeSpeed("y"), da = f.currItem.bounds, a.backAnimDestination = {}, a.backAnimStarted = {}, Math.abs(a.lastFlickSpeed.x) <= .05 && Math.abs(a.lastFlickSpeed.y) <= .05 ? (a.speedDecelerationRatioAbs.x = a.speedDecelerationRatioAbs.y = 0, a.calculateOverBoundsAnimOffset("x"), a.calculateOverBoundsAnimOffset("y"), !0) : (bb("zoomPan"), a.lastNow = Ea(), void a.panAnimLoop());
	    },
	        Ub = function Ub(a, b) {
	      var c;fa || (qb = m);var d;if ("swipe" === a) {
	        var g = kb.x - lb.x,
	            h = b.lastFlickDist.x < 10;g > fb && (h || b.lastFlickOffset.x > 20) ? d = -1 : g < -fb && (h || b.lastFlickOffset.x < -20) && (d = 1);
	      }var j;d && (m += d, m < 0 ? (m = i.loop ? ac() - 1 : 0, j = !0) : m >= ac() && (m = i.loop ? 0 : ac() - 1, j = !0), j && !i.loop || (ua += d, ra -= d, c = !0));var k,
	          l = ta.x * ra,
	          n = Math.abs(l - tb.x);return c || l > tb.x == b.lastFlickSpeed.x > 0 ? (k = Math.abs(b.lastFlickSpeed.x) > 0 ? n / Math.abs(b.lastFlickSpeed.x) : 333, k = Math.min(k, 400), k = Math.max(k, 250)) : k = 333, qb === m && (c = !1), fa = !0, Da("mainScrollAnimStart"), db("mainScroll", tb.x, l, k, e.easing.cubic.out, Ka, function () {
	        cb(), fa = !1, qb = -1, (c || qb !== m) && f.updateCurrItem(), Da("mainScrollAnimComplete");
	      }), c && f.updateCurrItem(!0), c;
	    },
	        Vb = function Vb(a) {
	      return 1 / ca * a * t;
	    },
	        Wb = function Wb() {
	      var a = s,
	          b = Ta(),
	          c = Ua();s < b ? a = b : s > c && (a = c);var d,
	          g = 1,
	          h = ja;return ia && !S && !ka && s < b ? (f.close(), !0) : (ia && (d = function d(a) {
	        Fa((g - h) * a + h);
	      }), f.zoomTo(a, 0, 200, e.easing.cubic.out, d), !0);
	    };za("Gestures", { publicMethods: { initGestures: function initGestures() {
	          var a = function a(_a2, b, c, d, e) {
	            A = _a2 + b, B = _a2 + c, C = _a2 + d, D = e ? _a2 + e : "";
	          };F = N.pointerEvent, F && N.touch && (N.touch = !1), F ? navigator.msPointerEnabled ? a("MSPointer", "Down", "Move", "Up", "Cancel") : a("pointer", "down", "move", "up", "cancel") : N.touch ? (a("touch", "start", "move", "end", "cancel"), G = !0) : a("mouse", "down", "move", "up"), p = B + " " + C + " " + D, q = A, F && !G && (G = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1), f.likelyTouchDevice = G, r[A] = Ob, r[B] = Pb, r[C] = Rb, D && (r[D] = r[C]), N.touch && (q += " mousedown", p += " mousemove mouseup", r.mousedown = r[A], r.mousemove = r[B], r.mouseup = r[C]), G || (i.allowPanToNext = !1);
	        } } });var Xb,
	        Yb,
	        Zb,
	        $b,
	        _b,
	        ac,
	        bc,
	        cc = function cc(b, c, d, g) {
	      Xb && clearTimeout(Xb), $b = !0, Zb = !0;var h;b.initialLayout ? (h = b.initialLayout, b.initialLayout = null) : h = i.getThumbBoundsFn && i.getThumbBoundsFn(m);var j = d ? i.hideAnimationDuration : i.showAnimationDuration,
	          k = function k() {
	        ab("initialZoom"), d ? (f.template.removeAttribute("style"), f.bg.removeAttribute("style")) : (Fa(1), c && (c.style.display = "block"), e.addClass(_a3, "pswp--animated-in"), Da("initialZoom" + (d ? "OutEnd" : "InEnd"))), g && g(), $b = !1;
	      };if (!j || !h || void 0 === h.x) return Da("initialZoom" + (d ? "Out" : "In")), s = b.initialZoomLevel, Ma(pa, b.initialPosition), Ha(), _a3.style.opacity = d ? 0 : 1, Fa(1), void (j ? setTimeout(function () {
	        k();
	      }, j) : k());var n = function n() {
	        var c = l,
	            g = !f.currItem.src || f.currItem.loadError || i.showHideOpacity;b.miniImg && (b.miniImg.style.webkitBackfaceVisibility = "hidden"), d || (s = h.w / b.w, pa.x = h.x, pa.y = h.y - K, f[g ? "template" : "bg"].style.opacity = .001, Ha()), bb("initialZoom"), d && !c && e.removeClass(_a3, "pswp--animated-in"), g && (d ? e[(c ? "remove" : "add") + "Class"](_a3, "pswp--animate_opacity") : setTimeout(function () {
	          e.addClass(_a3, "pswp--animate_opacity");
	        }, 30)), Xb = setTimeout(function () {
	          if (Da("initialZoom" + (d ? "Out" : "In")), d) {
	            var f = h.w / b.w,
	                i = { x: pa.x, y: pa.y },
	                l = s,
	                m = ja,
	                n = function n(b) {
	              1 === b ? (s = f, pa.x = h.x, pa.y = h.y - M) : (s = (f - l) * b + l, pa.x = (h.x - i.x) * b + i.x, pa.y = (h.y - M - i.y) * b + i.y), Ha(), g ? _a3.style.opacity = 1 - b : Fa(m - b * m);
	            };c ? db("initialZoom", 0, 1, j, e.easing.cubic.out, n, k) : (n(1), Xb = setTimeout(k, j + 20));
	          } else s = b.initialZoomLevel, Ma(pa, b.initialPosition), Ha(), Fa(1), g ? _a3.style.opacity = 1 : Fa(1), Xb = setTimeout(k, j + 20);
	        }, d ? 25 : 90);
	      };n();
	    },
	        dc = {},
	        ec = [],
	        fc = { index: 0, errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>', forceProgressiveLoading: !1, preload: [1, 1], getNumItemsFn: function getNumItemsFn() {
	        return Yb.length;
	      } },
	        gc = function gc() {
	      return { center: { x: 0, y: 0 }, max: { x: 0, y: 0 }, min: { x: 0, y: 0 } };
	    },
	        hc = function hc(a, b, c) {
	      var d = a.bounds;d.center.x = Math.round((dc.x - b) / 2), d.center.y = Math.round((dc.y - c) / 2) + a.vGap.top, d.max.x = b > dc.x ? Math.round(dc.x - b) : d.center.x, d.max.y = c > dc.y ? Math.round(dc.y - c) + a.vGap.top : d.center.y, d.min.x = b > dc.x ? 0 : d.center.x, d.min.y = c > dc.y ? a.vGap.top : d.center.y;
	    },
	        ic = function ic(a, b, c) {
	      if (a.src && !a.loadError) {
	        var d = !c;if (d && (a.vGap || (a.vGap = { top: 0, bottom: 0 }), Da("parseVerticalMargin", a)), dc.x = b.x, dc.y = b.y - a.vGap.top - a.vGap.bottom, d) {
	          var e = dc.x / a.w,
	              f = dc.y / a.h;a.fitRatio = e < f ? e : f;var g = i.scaleMode;"orig" === g ? c = 1 : "fit" === g && (c = a.fitRatio), c > 1 && (c = 1), a.initialZoomLevel = c, a.bounds || (a.bounds = gc());
	        }if (!c) return;return hc(a, a.w * c, a.h * c), d && c === a.initialZoomLevel && (a.initialPosition = a.bounds.center), a.bounds;
	      }return a.w = a.h = 0, a.initialZoomLevel = a.fitRatio = 1, a.bounds = gc(), a.initialPosition = a.bounds.center, a.bounds;
	    },
	        jc = function jc(a, b, c, d, e, g) {
	      b.loadError || d && (b.imageAppended = !0, mc(b, d, b === f.currItem && ya), c.appendChild(d), g && setTimeout(function () {
	        b && b.loaded && b.placeholder && (b.placeholder.style.display = "none", b.placeholder = null);
	      }, 500));
	    },
	        kc = function kc(a) {
	      a.loading = !0, a.loaded = !1;var b = a.img = e.createEl("pswp__img", "img"),
	          c = function c() {
	        a.loading = !1, a.loaded = !0, a.loadComplete ? a.loadComplete(a) : a.img = null, b.onload = b.onerror = null, b = null;
	      };return b.onload = c, b.onerror = function () {
	        a.loadError = !0, c();
	      }, b.src = a.src, b;
	    },
	        lc = function lc(a, b) {
	      if (a.src && a.loadError && a.container) return b && (a.container.innerHTML = ""), a.container.innerHTML = i.errorMsg.replace("%url%", a.src), !0;
	    },
	        mc = function mc(a, b, c) {
	      if (a.src) {
	        b || (b = a.container.lastChild);var d = c ? a.w : Math.round(a.w * a.fitRatio),
	            e = c ? a.h : Math.round(a.h * a.fitRatio);a.placeholder && !a.loaded && (a.placeholder.style.width = d + "px", a.placeholder.style.height = e + "px"), b.style.width = d + "px", b.style.height = e + "px";
	      }
	    },
	        nc = function nc() {
	      if (ec.length) {
	        for (var a, b = 0; b < ec.length; b++) {
	          a = ec[b], a.holder.index === a.index && jc(a.index, a.item, a.baseDiv, a.img, !1, a.clearPlaceholder);
	        }ec = [];
	      }
	    };za("Controller", { publicMethods: { lazyLoadItem: function lazyLoadItem(a) {
	          a = Aa(a);var b = _b(a);b && (!b.loaded && !b.loading || x) && (Da("gettingData", a, b), b.src && kc(b));
	        }, initController: function initController() {
	          e.extend(i, fc, !0), f.items = Yb = c, _b = f.getItemAt, ac = i.getNumItemsFn, bc = i.loop, ac() < 3 && (i.loop = !1), Ca("beforeChange", function (a) {
	            var b,
	                c = i.preload,
	                d = null === a || a >= 0,
	                e = Math.min(c[0], ac()),
	                g = Math.min(c[1], ac());for (b = 1; b <= (d ? g : e); b++) {
	              f.lazyLoadItem(m + b);
	            }for (b = 1; b <= (d ? e : g); b++) {
	              f.lazyLoadItem(m - b);
	            }
	          }), Ca("initialLayout", function () {
	            f.currItem.initialLayout = i.getThumbBoundsFn && i.getThumbBoundsFn(m);
	          }), Ca("mainScrollAnimComplete", nc), Ca("initialZoomInEnd", nc), Ca("destroy", function () {
	            for (var a, b = 0; b < Yb.length; b++) {
	              a = Yb[b], a.container && (a.container = null), a.placeholder && (a.placeholder = null), a.img && (a.img = null), a.preloader && (a.preloader = null), a.loadError && (a.loaded = a.loadError = !1);
	            }ec = null;
	          });
	        }, getItemAt: function getItemAt(a) {
	          return a >= 0 && void 0 !== Yb[a] && Yb[a];
	        }, allowProgressiveImg: function allowProgressiveImg() {
	          return i.forceProgressiveLoading || !G || i.mouseUsed || screen.width > 1200;
	        }, setContent: function setContent(a, b) {
	          i.loop && (b = Aa(b));var c = f.getItemAt(a.index);c && (c.container = null);var d,
	              g = f.getItemAt(b);if (!g) return void (a.el.innerHTML = "");Da("gettingData", b, g), a.index = b, a.item = g;var h = g.container = e.createEl("pswp__zoom-wrap");if (!g.src && g.html && (g.html.tagName ? h.appendChild(g.html) : h.innerHTML = g.html), lc(g), ic(g, qa), !g.src || g.loadError || g.loaded) g.src && !g.loadError && (d = e.createEl("pswp__img", "img"), d.style.opacity = 1, d.src = g.src, mc(g, d), jc(b, g, h, d, !0));else {
	            if (g.loadComplete = function (c) {
	              if (j) {
	                if (a && a.index === b) {
	                  if (lc(c, !0)) return c.loadComplete = c.img = null, ic(c, qa), Ia(c), void (a.index === m && f.updateCurrZoomItem());c.imageAppended ? !$b && c.placeholder && (c.placeholder.style.display = "none", c.placeholder = null) : N.transform && (fa || $b) ? ec.push({ item: c, baseDiv: h, img: c.img, index: b, holder: a, clearPlaceholder: !0 }) : jc(b, c, h, c.img, fa || $b, !0);
	                }c.loadComplete = null, c.img = null, Da("imageLoadComplete", b, c);
	              }
	            }, e.features.transform) {
	              var k = "pswp__img pswp__img--placeholder";k += g.msrc ? "" : " pswp__img--placeholder--blank";var l = e.createEl(k, g.msrc ? "img" : "");g.msrc && (l.src = g.msrc), mc(g, l), h.appendChild(l), g.placeholder = l;
	            }g.loading || kc(g), f.allowProgressiveImg() && (!Zb && N.transform ? ec.push({ item: g, baseDiv: h, img: g.img, index: b, holder: a }) : jc(b, g, h, g.img, !0, !0));
	          }Zb || b !== m ? Ia(g) : (ea = h.style, cc(g, d || g.img)), a.el.innerHTML = "", a.el.appendChild(h);
	        }, cleanSlide: function cleanSlide(a) {
	          a.img && (a.img.onload = a.img.onerror = null), a.loaded = a.loading = a.img = a.imageAppended = !1;
	        } } });var oc,
	        pc = {},
	        qc = function qc(a, b, c) {
	      var d = document.createEvent("CustomEvent"),
	          e = { origEvent: a, target: a.target, releasePoint: b, pointerType: c || "touch" };d.initCustomEvent("pswpTap", !0, !0, e), a.target.dispatchEvent(d);
	    };za("Tap", { publicMethods: { initTap: function initTap() {
	          Ca("firstTouchStart", f.onTapStart), Ca("touchRelease", f.onTapRelease), Ca("destroy", function () {
	            pc = {}, oc = null;
	          });
	        }, onTapStart: function onTapStart(a) {
	          a.length > 1 && (clearTimeout(oc), oc = null);
	        }, onTapRelease: function onTapRelease(a, b) {
	          if (b && !Y && !W && !_a) {
	            var c = b;if (oc && (clearTimeout(oc), oc = null, xb(c, pc))) return void Da("doubleTap", c);if ("mouse" === b.type) return void qc(a, b, "mouse");var d = a.target.tagName.toUpperCase();if ("BUTTON" === d || e.hasClass(a.target, "pswp__single-tap")) return void qc(a, b);Ma(pc, c), oc = setTimeout(function () {
	              qc(a, b), oc = null;
	            }, 300);
	          }
	        } } });var rc;za("DesktopZoom", { publicMethods: { initDesktopZoom: function initDesktopZoom() {
	          L || (G ? Ca("mouseUsed", function () {
	            f.setupDesktopZoom();
	          }) : f.setupDesktopZoom(!0));
	        }, setupDesktopZoom: function setupDesktopZoom(b) {
	          rc = {};var c = "wheel mousewheel DOMMouseScroll";Ca("bindEvents", function () {
	            e.bind(_a3, c, f.handleMouseWheel);
	          }), Ca("unbindEvents", function () {
	            rc && e.unbind(_a3, c, f.handleMouseWheel);
	          }), f.mouseZoomedIn = !1;var d,
	              g = function g() {
	            f.mouseZoomedIn && (e.removeClass(_a3, "pswp--zoomed-in"), f.mouseZoomedIn = !1), s < 1 ? e.addClass(_a3, "pswp--zoom-allowed") : e.removeClass(_a3, "pswp--zoom-allowed"), h();
	          },
	              h = function h() {
	            d && (e.removeClass(_a3, "pswp--dragging"), d = !1);
	          };Ca("resize", g), Ca("afterChange", g), Ca("pointerDown", function () {
	            f.mouseZoomedIn && (d = !0, e.addClass(_a3, "pswp--dragging"));
	          }), Ca("pointerUp", h), b || g();
	        }, handleMouseWheel: function handleMouseWheel(a) {
	          if (s <= f.currItem.fitRatio) return i.modal && (!i.closeOnScroll || _a || V ? a.preventDefault() : E && Math.abs(a.deltaY) > 2 && (l = !0, f.close())), !0;if (a.stopPropagation(), rc.x = 0, "deltaX" in a) 1 === a.deltaMode ? (rc.x = 18 * a.deltaX, rc.y = 18 * a.deltaY) : (rc.x = a.deltaX, rc.y = a.deltaY);else if ("wheelDelta" in a) a.wheelDeltaX && (rc.x = -.16 * a.wheelDeltaX), a.wheelDeltaY ? rc.y = -.16 * a.wheelDeltaY : rc.y = -.16 * a.wheelDelta;else {
	            if (!("detail" in a)) return;rc.y = a.detail;
	          }Sa(s, !0);var b = pa.x - rc.x,
	              c = pa.y - rc.y;(i.modal || b <= da.min.x && b >= da.max.x && c <= da.min.y && c >= da.max.y) && a.preventDefault(), f.panTo(b, c);
	        }, toggleDesktopZoom: function toggleDesktopZoom(b) {
	          b = b || { x: qa.x / 2 + sa.x, y: qa.y / 2 + sa.y };var c = i.getDoubleTapZoom(!0, f.currItem),
	              d = s === c;f.mouseZoomedIn = !d, f.zoomTo(d ? f.currItem.initialZoomLevel : c, b, 333), e[(d ? "remove" : "add") + "Class"](_a3, "pswp--zoomed-in");
	        } } });var sc,
	        tc,
	        uc,
	        vc,
	        wc,
	        xc,
	        yc,
	        zc,
	        Ac,
	        Bc,
	        Cc,
	        Dc,
	        Ec = { history: !0, galleryUID: 1 },
	        Fc = function Fc() {
	      return Cc.hash.substring(1);
	    },
	        Gc = function Gc() {
	      sc && clearTimeout(sc), uc && clearTimeout(uc);
	    },
	        Hc = function Hc() {
	      var a = Fc(),
	          b = {};if (a.length < 5) return b;var c,
	          d = a.split("&");for (c = 0; c < d.length; c++) {
	        if (d[c]) {
	          var e = d[c].split("=");e.length < 2 || (b[e[0]] = e[1]);
	        }
	      }if (i.galleryPIDs) {
	        var f = b.pid;for (b.pid = 0, c = 0; c < Yb.length; c++) {
	          if (Yb[c].pid === f) {
	            b.pid = c;break;
	          }
	        }
	      } else b.pid = parseInt(b.pid, 10) - 1;return b.pid < 0 && (b.pid = 0), b;
	    },
	        Ic = function Ic() {
	      if (uc && clearTimeout(uc), _a || V) return void (uc = setTimeout(Ic, 500));vc ? clearTimeout(tc) : vc = !0;var a = m + 1,
	          b = _b(m);b.hasOwnProperty("pid") && (a = b.pid);var c = yc + "&gid=" + i.galleryUID + "&pid=" + a;zc || Cc.hash.indexOf(c) === -1 && (Bc = !0);var d = Cc.href.split("#")[0] + "#" + c;Dc ? "#" + c !== window.location.hash && history[zc ? "replaceState" : "pushState"]("", document.title, d) : zc ? Cc.replace(d) : Cc.hash = c, zc = !0, tc = setTimeout(function () {
	        vc = !1;
	      }, 60);
	    };za("History", { publicMethods: { initHistory: function initHistory() {
	          if (e.extend(i, Ec, !0), i.history) {
	            Cc = window.location, Bc = !1, Ac = !1, zc = !1, yc = Fc(), Dc = "pushState" in history, yc.indexOf("gid=") > -1 && (yc = yc.split("&gid=")[0], yc = yc.split("?gid=")[0]), Ca("afterChange", f.updateURL), Ca("unbindEvents", function () {
	              e.unbind(window, "hashchange", f.onHashChange);
	            });var a = function a() {
	              xc = !0, Ac || (Bc ? history.back() : yc ? Cc.hash = yc : Dc ? history.pushState("", document.title, Cc.pathname + Cc.search) : Cc.hash = ""), Gc();
	            };Ca("unbindEvents", function () {
	              l && a();
	            }), Ca("destroy", function () {
	              xc || a();
	            }), Ca("firstUpdate", function () {
	              m = Hc().pid;
	            });var b = yc.indexOf("pid=");b > -1 && (yc = yc.substring(0, b), "&" === yc.slice(-1) && (yc = yc.slice(0, -1))), setTimeout(function () {
	              j && e.bind(window, "hashchange", f.onHashChange);
	            }, 40);
	          }
	        }, onHashChange: function onHashChange() {
	          return Fc() === yc ? (Ac = !0, void f.close()) : void (vc || (wc = !0, f.goTo(Hc().pid), wc = !1));
	        }, updateURL: function updateURL() {
	          Gc(), wc || (zc ? sc = setTimeout(Ic, 800) : Ic());
	        } } }), e.extend(f, eb);
	  };return a;
	});

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(1);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
	* http://photoswipe.com
	* Copyright (c) 2019 Dmitry Semenov; */
	!function (a, b) {
	   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (b), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) ? module.exports = b() : a.PhotoSwipeUI_Default = b();
	}(undefined, function () {
	  "use strict";
	  var a = function a(_a, b) {
	    var c,
	        d,
	        e,
	        f,
	        g,
	        h,
	        i,
	        j,
	        k,
	        l,
	        m,
	        n,
	        o,
	        p,
	        q,
	        r,
	        s,
	        t,
	        u,
	        v = this,
	        w = !1,
	        x = !0,
	        y = !0,
	        z = { barsSize: { top: 44, bottom: "auto" }, closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"], timeToIdle: 4e3, timeToIdleOutside: 1e3, loadingIndicatorDelay: 1e3, addCaptionHTMLFn: function addCaptionHTMLFn(a, b) {
	        return a.title ? (b.children[0].innerHTML = a.title, !0) : (b.children[0].innerHTML = "", !1);
	      }, closeEl: !0, captionEl: !0, fullscreenEl: !0, zoomEl: !0, shareEl: !0, counterEl: !0, arrowEl: !0, preloaderEl: !0, tapToClose: !1, tapToToggleControls: !0, clickToCloseNonZoomable: !0, shareButtons: [{ id: "facebook", label: "Share on Facebook", url: "https://www.facebook.com/sharer/sharer.php?u={{url}}" }, { id: "twitter", label: "Tweet", url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}" }, { id: "pinterest", label: "Pin it", url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}" }, { id: "download", label: "Download image", url: "{{raw_image_url}}", download: !0 }], getImageURLForShare: function getImageURLForShare() {
	        return _a.currItem.src || "";
	      }, getPageURLForShare: function getPageURLForShare() {
	        return window.location.href;
	      }, getTextForShare: function getTextForShare() {
	        return _a.currItem.title || "";
	      }, indexIndicatorSep: " / ", fitControlsWidth: 1200 },
	        A = function A(a) {
	      if (r) return !0;a = a || window.event, q.timeToIdle && q.mouseUsed && !k && K();for (var c, d, e = a.target || a.srcElement, f = e.getAttribute("class") || "", g = 0; g < S.length; g++) {
	        c = S[g], c.onTap && f.indexOf("pswp__" + c.name) > -1 && (c.onTap(), d = !0);
	      }if (d) {
	        a.stopPropagation && a.stopPropagation(), r = !0;var h = b.features.isOldAndroid ? 600 : 30;s = setTimeout(function () {
	          r = !1;
	        }, h);
	      }
	    },
	        B = function B() {
	      return !_a.likelyTouchDevice || q.mouseUsed || screen.width > q.fitControlsWidth;
	    },
	        C = function C(a, c, d) {
	      b[(d ? "add" : "remove") + "Class"](a, "pswp__" + c);
	    },
	        D = function D() {
	      var a = 1 === q.getNumItemsFn();a !== p && (C(d, "ui--one-slide", a), p = a);
	    },
	        E = function E() {
	      C(i, "share-modal--hidden", y);
	    },
	        F = function F() {
	      return y = !y, y ? (b.removeClass(i, "pswp__share-modal--fade-in"), setTimeout(function () {
	        y && E();
	      }, 300)) : (E(), setTimeout(function () {
	        y || b.addClass(i, "pswp__share-modal--fade-in");
	      }, 30)), y || H(), !1;
	    },
	        G = function G(b) {
	      b = b || window.event;var c = b.target || b.srcElement;return _a.shout("shareLinkClick", b, c), !!c.href && (!!c.hasAttribute("download") || (window.open(c.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), y || F(), !1));
	    },
	        H = function H() {
	      for (var a, b, c, d, e, f = "", g = 0; g < q.shareButtons.length; g++) {
	        a = q.shareButtons[g], c = q.getImageURLForShare(a), d = q.getPageURLForShare(a), e = q.getTextForShare(a), b = a.url.replace("{{url}}", encodeURIComponent(d)).replace("{{image_url}}", encodeURIComponent(c)).replace("{{raw_image_url}}", c).replace("{{text}}", encodeURIComponent(e)), f += '<a href="' + b + '" target="_blank" class="pswp__share--' + a.id + '"' + (a.download ? "download" : "") + ">" + a.label + "</a>", q.parseShareButtonOut && (f = q.parseShareButtonOut(a, f));
	      }i.children[0].innerHTML = f, i.children[0].onclick = G;
	    },
	        I = function I(a) {
	      for (var c = 0; c < q.closeElClasses.length; c++) {
	        if (b.hasClass(a, "pswp__" + q.closeElClasses[c])) return !0;
	      }
	    },
	        J = 0,
	        K = function K() {
	      clearTimeout(u), J = 0, k && v.setIdle(!1);
	    },
	        L = function L(a) {
	      a = a ? a : window.event;var b = a.relatedTarget || a.toElement;b && "HTML" !== b.nodeName || (clearTimeout(u), u = setTimeout(function () {
	        v.setIdle(!0);
	      }, q.timeToIdleOutside));
	    },
	        M = function M() {
	      q.fullscreenEl && !b.features.isOldAndroid && (c || (c = v.getFullscreenAPI()), c ? (b.bind(document, c.eventK, v.updateFullscreen), v.updateFullscreen(), b.addClass(_a.template, "pswp--supports-fs")) : b.removeClass(_a.template, "pswp--supports-fs"));
	    },
	        N = function N() {
	      q.preloaderEl && (O(!0), l("beforeChange", function () {
	        clearTimeout(o), o = setTimeout(function () {
	          _a.currItem && _a.currItem.loading ? (!_a.allowProgressiveImg() || _a.currItem.img && !_a.currItem.img.naturalWidth) && O(!1) : O(!0);
	        }, q.loadingIndicatorDelay);
	      }), l("imageLoadComplete", function (b, c) {
	        _a.currItem === c && O(!0);
	      }));
	    },
	        O = function O(a) {
	      n !== a && (C(m, "preloader--active", !a), n = a);
	    },
	        P = function P(a) {
	      var c = a.vGap;if (B()) {
	        var g = q.barsSize;if (q.captionEl && "auto" === g.bottom) {
	          if (f || (f = b.createEl("pswp__caption pswp__caption--fake"), f.appendChild(b.createEl("pswp__caption__center")), d.insertBefore(f, e), b.addClass(d, "pswp__ui--fit")), q.addCaptionHTMLFn(a, f, !0)) {
	            var h = f.clientHeight;c.bottom = parseInt(h, 10) || 44;
	          } else c.bottom = g.top;
	        } else c.bottom = "auto" === g.bottom ? 0 : g.bottom;c.top = g.top;
	      } else c.top = c.bottom = 0;
	    },
	        Q = function Q() {
	      q.timeToIdle && l("mouseUsed", function () {
	        b.bind(document, "mousemove", K), b.bind(document, "mouseout", L), t = setInterval(function () {
	          J++, 2 === J && v.setIdle(!0);
	        }, q.timeToIdle / 2);
	      });
	    },
	        R = function R() {
	      l("onVerticalDrag", function (a) {
	        x && a < .95 ? v.hideControls() : !x && a >= .95 && v.showControls();
	      });var a;l("onPinchClose", function (b) {
	        x && b < .9 ? (v.hideControls(), a = !0) : a && !x && b > .9 && v.showControls();
	      }), l("zoomGestureEnded", function () {
	        a = !1, a && !x && v.showControls();
	      });
	    },
	        S = [{ name: "caption", option: "captionEl", onInit: function onInit(a) {
	        e = a;
	      } }, { name: "share-modal", option: "shareEl", onInit: function onInit(a) {
	        i = a;
	      }, onTap: function onTap() {
	        F();
	      } }, { name: "button--share", option: "shareEl", onInit: function onInit(a) {
	        h = a;
	      }, onTap: function onTap() {
	        F();
	      } }, { name: "button--zoom", option: "zoomEl", onTap: _a.toggleDesktopZoom }, { name: "counter", option: "counterEl", onInit: function onInit(a) {
	        g = a;
	      } }, { name: "button--close", option: "closeEl", onTap: _a.close }, { name: "button--arrow--left", option: "arrowEl", onTap: _a.prev }, { name: "button--arrow--right", option: "arrowEl", onTap: _a.next }, { name: "button--fs", option: "fullscreenEl", onTap: function onTap() {
	        c.isFullscreen() ? c.exit() : c.enter();
	      } }, { name: "preloader", option: "preloaderEl", onInit: function onInit(a) {
	        m = a;
	      } }],
	        T = function T() {
	      var a,
	          c,
	          e,
	          f = function f(d) {
	        if (d) for (var f = d.length, g = 0; g < f; g++) {
	          a = d[g], c = a.className;for (var h = 0; h < S.length; h++) {
	            e = S[h], c.indexOf("pswp__" + e.name) > -1 && (q[e.option] ? (b.removeClass(a, "pswp__element--disabled"), e.onInit && e.onInit(a)) : b.addClass(a, "pswp__element--disabled"));
	          }
	        }
	      };f(d.children);var g = b.getChildByClass(d, "pswp__top-bar");g && f(g.children);
	    };v.init = function () {
	      b.extend(_a.options, z, !0), q = _a.options, d = b.getChildByClass(_a.scrollWrap, "pswp__ui"), l = _a.listen, R(), l("beforeChange", v.update), l("doubleTap", function (b) {
	        var c = _a.currItem.initialZoomLevel;_a.getZoomLevel() !== c ? _a.zoomTo(c, b, 333) : _a.zoomTo(q.getDoubleTapZoom(!1, _a.currItem), b, 333);
	      }), l("preventDragEvent", function (a, b, c) {
	        var d = a.target || a.srcElement;d && d.getAttribute("class") && a.type.indexOf("mouse") > -1 && (d.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(d.tagName)) && (c.prevent = !1);
	      }), l("bindEvents", function () {
	        b.bind(d, "pswpTap click", A), b.bind(_a.scrollWrap, "pswpTap", v.onGlobalTap), _a.likelyTouchDevice || b.bind(_a.scrollWrap, "mouseover", v.onMouseOver);
	      }), l("unbindEvents", function () {
	        y || F(), t && clearInterval(t), b.unbind(document, "mouseout", L), b.unbind(document, "mousemove", K), b.unbind(d, "pswpTap click", A), b.unbind(_a.scrollWrap, "pswpTap", v.onGlobalTap), b.unbind(_a.scrollWrap, "mouseover", v.onMouseOver), c && (b.unbind(document, c.eventK, v.updateFullscreen), c.isFullscreen() && (q.hideAnimationDuration = 0, c.exit()), c = null);
	      }), l("destroy", function () {
	        q.captionEl && (f && d.removeChild(f), b.removeClass(e, "pswp__caption--empty")), i && (i.children[0].onclick = null), b.removeClass(d, "pswp__ui--over-close"), b.addClass(d, "pswp__ui--hidden"), v.setIdle(!1);
	      }), q.showAnimationDuration || b.removeClass(d, "pswp__ui--hidden"), l("initialZoomIn", function () {
	        q.showAnimationDuration && b.removeClass(d, "pswp__ui--hidden");
	      }), l("initialZoomOut", function () {
	        b.addClass(d, "pswp__ui--hidden");
	      }), l("parseVerticalMargin", P), T(), q.shareEl && h && i && (y = !0), D(), Q(), M(), N();
	    }, v.setIdle = function (a) {
	      k = a, C(d, "ui--idle", a);
	    }, v.update = function () {
	      x && _a.currItem ? (v.updateIndexIndicator(), q.captionEl && (q.addCaptionHTMLFn(_a.currItem, e), C(e, "caption--empty", !_a.currItem.title)), w = !0) : w = !1, y || F(), D();
	    }, v.updateFullscreen = function (d) {
	      d && setTimeout(function () {
	        _a.setScrollOffset(0, b.getScrollY());
	      }, 50), b[(c.isFullscreen() ? "add" : "remove") + "Class"](_a.template, "pswp--fs");
	    }, v.updateIndexIndicator = function () {
	      q.counterEl && (g.innerHTML = _a.getCurrentIndex() + 1 + q.indexIndicatorSep + q.getNumItemsFn());
	    }, v.onGlobalTap = function (c) {
	      c = c || window.event;var d = c.target || c.srcElement;if (!r) if (c.detail && "mouse" === c.detail.pointerType) {
	        if (I(d)) return void _a.close();b.hasClass(d, "pswp__img") && (1 === _a.getZoomLevel() && _a.getZoomLevel() <= _a.currItem.fitRatio ? q.clickToCloseNonZoomable && _a.close() : _a.toggleDesktopZoom(c.detail.releasePoint));
	      } else if (q.tapToToggleControls && (x ? v.hideControls() : v.showControls()), q.tapToClose && (b.hasClass(d, "pswp__img") || I(d))) return void _a.close();
	    }, v.onMouseOver = function (a) {
	      a = a || window.event;var b = a.target || a.srcElement;C(d, "ui--over-close", I(b));
	    }, v.hideControls = function () {
	      b.addClass(d, "pswp__ui--hidden"), x = !1;
	    }, v.showControls = function () {
	      x = !0, w || v.update(), b.removeClass(d, "pswp__ui--hidden");
	    }, v.supportsFullscreen = function () {
	      var a = document;return !!(a.exitFullscreen || a.mozCancelFullScreen || a.webkitExitFullscreen || a.msExitFullscreen);
	    }, v.getFullscreenAPI = function () {
	      var b,
	          c = document.documentElement,
	          d = "fullscreenchange";return c.requestFullscreen ? b = { enterK: "requestFullscreen", exitK: "exitFullscreen", elementK: "fullscreenElement", eventK: d } : c.mozRequestFullScreen ? b = { enterK: "mozRequestFullScreen", exitK: "mozCancelFullScreen", elementK: "mozFullScreenElement", eventK: "moz" + d } : c.webkitRequestFullscreen ? b = { enterK: "webkitRequestFullscreen", exitK: "webkitExitFullscreen", elementK: "webkitFullscreenElement", eventK: "webkit" + d } : c.msRequestFullscreen && (b = { enterK: "msRequestFullscreen", exitK: "msExitFullscreen", elementK: "msFullscreenElement", eventK: "MSFullscreenChange" }), b && (b.enter = function () {
	        return j = q.closeOnScroll, q.closeOnScroll = !1, "webkitRequestFullscreen" !== this.enterK ? _a.template[this.enterK]() : void _a.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
	      }, b.exit = function () {
	        return q.closeOnScroll = j, document[this.exitK]();
	      }, b.isFullscreen = function () {
	        return document[this.elementK];
	      }), b;
	    };
	  };return a;
	});

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"pswp\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"pswp__bg\"></div>\n    <div class=\"pswp__scroll-wrap\">\n        <div class=\"pswp__container\">\n            <div class=\"pswp__item\"></div>\n            <div class=\"pswp__item\"></div>\n            <div class=\"pswp__item\"></div>\n        </div>\n        <div class=\"pswp__ui pswp__ui--hidden\">\n            <div class=\"pswp__top-bar\">\n                <div class=\"pswp__counter\" style=\"display:none;\"></div>\n                <div class=\"pswp__preloader\">\n                    <div class=\"pswp__preloader__icn\">\n                      <div class=\"pswp__preloader__cut\">\n                        <div class=\"pswp__preloader__donut\"></div>\n                      </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"pswp__share-modal pswp__share-modal--hidden pswp__single-tap\">\n                <div class=\"pswp__share-tooltip\"></div> \n            </div>\n            <div class=\"pswp__caption\">\n                <div class=\"pswp__caption__center\"></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"photo_closeBtn\"></div>\n    <div class=\"photo_num\">\n        <span class=\"photo_current\">")
	    ; __append(escape(current))
	    ; __append("</span>\n        <span class=\"photo_total\">/ ")
	    ; __append(escape(totalPage))
	    ; __append("</span>\n    </div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var liveVideo = __webpack_require__(433);
	var recodeVideo = __webpack_require__(488);
	var listVideo = __webpack_require__(497);
	
	module.exports = {
	  liveVideo: liveVideo,
	  recodeVideo: recodeVideo,
	  listVideo: listVideo
	};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(434);
	var Core = __webpack_require__(436);
	var Poster = __webpack_require__(439);
	var PlayButton = __webpack_require__(443);
	var Control = __webpack_require__(450);
	var Title = __webpack_require__(458);
	var ErrorBox = __webpack_require__(462);
	var statistics = __webpack_require__(469);
	var Cutdown = __webpack_require__(470);
	var Ready = __webpack_require__(474);
	var List = __webpack_require__(479);
	var Network = __webpack_require__(483);
	
	var Events = __webpack_require__(104);
	
	var createMsg = function createMsg(options) {
	    return {
	        videoid: options.channelId,
	        categoryId: options.categoryId || '0017',
	        columnName: options.columnName || '',
	        provider: options.provider || ''
	    };
	};
	var Video = function Video(options) {
	    this.options = options;
	    this.options.playermsg = createMsg(options.list[0]);
	    this.isSpread = true;
	    this.init();
	};
	
	Video.prototype.init = function () {
	    this.initParams();
	    this.initLayout();
	    this.initCompontent();
	    this.initEvent();
	};
	
	Video.prototype.initParams = function () {};
	
	Video.prototype.initLayout = function () {
	    this.el = document.createElement('div');
	    this.el.classList.add('c-video');
	};
	
	Video.prototype.initCompontent = function () {
	    this.core = new Core({
	        src: this.options.src,
	        poster: this.options.poster,
	        inline: true,
	        autoplay: this.options.autoplay
	    });
	
	    pageVideoList.push(this.core);
	
	    this.playButton = new PlayButton();
	    this.playButton.changeState('pause');
	    this.control = new Control(this.options);
	    this.poster = new Poster(this.options.poster);
	    this.title = new Title(this.options.title, this.options.channelName, this.options.channelIcon);
	    this.error = new ErrorBox(this.options.errorTitle);
	    this.cutdown = new Cutdown(this.options.start_time);
	    this.ready = new Ready();
	    this.list = new List(this.options.list);
	    this.network = new Network();
	
	    this.core.renderTo(this.el);
	    this.playButton.renderTo(this.el);
	    this.control.renderTo(this.el);
	    this.poster.renderTo(this.el);
	    this.title.renderTo(this.el);
	    this.error.renderTo(this.el);
	    this.cutdown.renderTo(this.el);
	    this.ready.renderTo(this.el);
	    this.list.renderTo(this.el);
	    this.network.renderTo(this.el);
	    // this.ready.show();
	    // this.playButton.hide();
	    // this.cutdown.show();
	    // this.cutdown.begin();
	};
	
	Video.prototype.renderTo = function (parentNode) {
	    parentNode.appendChild(this.el);
	};
	
	/**
	 * 自定义事件列表
	 * begin 每个视频开始播放时 一般用来发cv统计
	 * ended 视频播放结束时
	 * pause 视频暂停
	 * play 视频播放
	 * switch 视频切换
	 * init 初始化视频 主要用于发vv统计
	 * input 横屏时点击输入弹幕区域
	 */
	Video.prototype.initEvent = function () {
	    var _this = this;
	
	    var core = this.core;
	    var control = this.control;
	    var playButton = this.playButton;
	    var poster = this.poster;
	    var title = this.title;
	    var error = this.error;
	    var cutdown = this.cutdown;
	    var ready = this.ready;
	    var list = this.list;
	    var network = this.network;
	    var self = this;
	    var options = this.options;
	
	    var notBegin = true;
	
	    // 视频首次开始播放
	    core.on('begin', function () {
	        statistics(options.playermsg, 'cv');
	        // title.hide();
	        control.show();
	        poster.hide();
	        ready.hide();
	        playButton.changeState('play');
	        self.trigger('begin');
	    });
	
	    core.on('playing', function () {
	        notBegin = false;
	        self.trigger('hideCount');
	    });
	
	    // 视频内部切换
	    core.on('switch', function (oldSrc, newSrc) {
	        self.trigger('switch', oldSrc, newSrc);
	    });
	
	    core.on('loadedmetadata', function () {
	        statistics(options.playermsg, 'vv');
	        self.trigger('init');
	    });
	
	    // 视频播放
	    core.on('play', function () {
	        // let current = Core.current();
	        // console.log(current);
	        // if (current && core !== current) {
	        //     current.pause();
	        // }
	        for (var i = 0; i < pageVideoList.length; i++) {
	            var otherCore = pageVideoList[i];
	            if (otherCore !== core) {
	                otherCore.pause();
	            }
	        }
	        // playButton.changeState('play');
	        // control.changePlayState('play');
	    });
	
	    // core.on('timeupdate', function () {
	    // //   if (core.getCurrentTime() > 0.1){
	    // //     poster.hide();
	    // //     error.hide();
	    // //   }
	
	    // });
	
	    // 视频暂停
	    // core.on('pause', function () {
	    //
	    // });
	
	    // 视频播放完成
	    // core.on('ended', function () {
	    //   playButton.changeState('replay');
	    //   self.trigger('ended');
	    // });
	
	    var errrTimer = null;
	    // core.on('error', function (e) {
	    //   if (notBegin) {
	    //     ready.show();
	    //   } else {
	    //     error.show();
	    //   }
	    //   clearTimeout(errrTimer);
	    //   errrTimer = setTimeout(function () {
	    //     console.log('try replay');
	    //     core.load();
	    //     core.play();
	    //   }, 5000);
	    //   self.trigger('error', e);
	    // });
	    core.on('pause', function () {
	        // 如果视频是直播，触发广告暂停事件
	        if (self.isSpread) {
	            self.trigger('pauseAd');
	        }
	    });
	
	    core.on('waitingStatus', function () {
	        playButton.changeState('waiting');
	    });
	
	    core.on('endStatus', function () {
	        playButton.changeState('replay');
	        self.trigger('ended');
	    });
	
	    core.on('errorStatus', function (e) {
	        // debugger
	        if (_this.cutdown.time >= Date.now()) {
	            ready.show();
	        } else {
	            error.show();
	        }
	        // clearTimeout(errrTimer);
	        // errrTimer = setTimeout(function () {
	        //     console.log('try replay');
	        //     core.load();
	        //     core.play();
	        // }, 5000);
	        self.trigger('error', e);
	    });
	
	    core.on('playingStatus', function () {
	        // 由于安卓端兼容性原因，将控层的样式修改放在video的timeupdate事件中
	        playButton.changeState('play');
	        control.changePlayState('play');
	        poster.hide();
	        // playButton.show();
	        error.hide();
	    });
	
	    core.on('timeupdate', function () {
	        // self.trigger('playing');
	        if (core.getCurrentTime() > 0.1) {
	            playButton.changeState('play');
	            control.changePlayState('play');
	            poster.hide();
	        }
	    });
	
	    core.on('pauseStatus', function () {
	        playButton.changeState('pause');
	        playButton.show();
	        control.changePlayState('pause');
	        console.log('视频暂停+3');
	        self.trigger('pause');
	    });
	
	    // 点击播放器前面的控制蒙层
	    playButton.on('click', function (e) {
	        if (self.isSpread) {
	            // 展开
	            if (core.getEnded() || core.getPaused()) {
	                core.play();
	            } else {
	                control.toggle();
	                return;
	            }
	        } else {
	            // 折叠
	            self.trigger('shrinkOpen');
	            if (core.getEnded() || core.getPaused()) {
	                core.play();
	                return;
	            } else {
	                core.pause();
	                return;
	            }
	        }
	
	        if (core.getNetworkState() == 3) {
	            control.toggle();
	        }
	    });
	
	    title.on('exit', function () {
	        self.trigger('exit');
	        console.log('exit');
	    });
	
	    // 控制条点击播放按钮
	    control.on('play', function () {
	        network.hide();
	        if (core.getPaused()) {
	            core.play();
	        } else {
	            console.log('视频暂停+4');
	            core.pause();
	            // 暂停添加居中广告
	            if (self.isSpread) {
	                self.trigger('pauseAd');
	            }
	        }
	    });
	
	    control.on('show', function () {
	        title.show();
	        list.show();
	        self.trigger('controlShow');
	    });
	
	    control.on('hide', function () {
	        title.hide();
	        list.hide();
	        self.trigger('controlHide');
	    });
	
	    control.on('zoom', function (state) {
	        self.trigger('zoom', state);
	    });
	
	    cutdown.on('end', function () {
	        self.trigger('cutdownEnd');
	        // core.play();
	    });
	
	    // control.on('inputClick', function () {
	    //   self.trigger('inputClick');
	    // });
	
	    // control.on('barrageClick', function (state) {
	    //   self.trigger('barrageClick', state);
	    // });
	
	    list.on('switch', function (url, index) {
	        var videoOption = this.options.list[index];
	        core.src(videoOption.m3u8);
	        // core.setPoster(videoOption.poster);
	        core.play();
	        this.options.playermsg = createMsg(videoOption);
	    }.bind(this));
	
	    network.on('network_retry', function () {
	        window.location.reload();
	    });
	
	    network.on('network_continue', function () {
	        core.play();
	        network.hide();
	    });
	
	    network.on('network_toggle', function () {
	        control.toggle();
	    });
	
	    error.on('error_toggle', function () {
	        control.toggle();
	    });
	};
	
	Video.prototype.afterAdPause = function () {
	    this.playButton.trigger('click');
	};
	
	Video.prototype.play = function () {
	    this.trigger('playAd'); // 视频播放时隐藏广告
	    // this.cutdown.hide();
	    this.core.play();
	};
	
	Video.prototype.load = function () {
	    this.core.load();
	};
	
	Video.prototype.pause = function () {
	    console.log('视频暂停+5');
	    this.core.pause();
	};
	
	Video.prototype.getCurrentTime = function () {
	    return this.core.getCurrentTime();
	};
	
	Video.prototype.stop = function () {
	    console.log('视频暂停+6');
	    this.core.pause();
	    this.control.setTime(0);
	};
	
	Video.prototype.next = function (src) {
	    this.core.src(src);
	    this.control.reset();
	    this.playButton.changeState('pause');
	};
	
	Video.prototype.destory = function () {
	    this.off();
	    this.title.destory();
	    this.control.destory();
	    this.poster.destory();
	    this.playButton.destory();
	    this.error.destory();
	    this.core.destory();
	};
	
	Video.prototype.hide = function () {
	    if (!this.isHide) {
	        $(this.el).hide();
	        this.isHide = true;
	    }
	};
	
	Video.prototype.show = function () {
	    if (this.isHide) {
	        $(this.el).show();
	        this.isHide = false;
	    }
	};
	
	Video.prototype.spread = function () {
	    this.isSpread = true;
	    // this.play();
	};
	
	Video.prototype.fold = function () {
	    this.isSpread = false;
	    // this.pause();
	};
	
	Events.mixTo(Video);
	module.exports = Video;

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */,
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray2 = __webpack_require__(68);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(437);
	var Event = __webpack_require__(104);
	
	var ua = navigator.userAgent.toLowerCase();
	var isIphone = ua.indexOf('iphone') >= 0 ? true : false;
	window.currentVideo = '';
	
	var Events = ['loadstart', 'suspend', 'abort', 'error', 'emptied', 'stalled', 'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'playing', 'waiting', 'seeking', 'seeked', 'ended', 'durationchange', 'timeupdate', 'progress', 'play', 'pause', 'ratechange', 'volumechange'];
	
	var toTitleCase = function toTitleCase(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	};
	
	var setAttribute = function setAttribute(el, name, val) {
	    el.setAttribute(name, val);
	};
	
	var loadVideo = function loadVideo(el) {
	    if (typeof el.load === 'function') {
	        // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
	        (function () {
	            try {
	                el.load();
	            } catch (e) {
	                // satisfy linter
	            }
	        })();
	    }
	};
	
	var resetVideo = function resetVideo(el) {
	    if (!el) {
	        return;
	    }
	
	    var sources = el.querySelectorAll('source');
	    var i = sources.length;
	
	    while (i--) {
	        el.removeChild(sources[i]);
	    }
	
	    // remove any src reference.
	    // not setting `src=''` because that throws an error
	    el.removeAttribute('src');
	    loadVideo(el);
	};
	
	var createVideo = function createVideo(options) {
	    var el = document.createElement('video');
	    el.play_new = el.play; // 重新命名play方法，猎豹浏览器会劫持video的play方法
	    if (isIphone) {
	        setAttribute(el, 'preload', 'meta');
	    } else {
	        setAttribute(el, 'preload', 'auto');
	    }
	
	    // setAttribute(el, 'preload', 'none');
	
	    el.className = 'c-video__meta';
	
	    if (options.inline) {
	        setAttribute(el, 'playsinline', 'playsinline');
	        setAttribute(el, 'webkit-playsinline', 'webkit-playsinline');
	    }
	    if (options.muted) {
	        setAttribute(el, 'muted', 'muted');
	    }
	    if (options.controls) {
	        setAttribute(el, 'controls', 'true');
	    }
	    if (options.autoplay) {
	        setAttribute(el, 'autoplay', 'autoplay');
	    }
	    if (options.poster) {
	        // setAttribute(el, 'poster', options.poster);
	    }
	    if (options.loop) {
	        setAttribute(el, 'loop', 'loop');
	    }
	    setAttribute(el, 'src', options.src);
	    loadVideo(el);
	    el.width = options.width;
	    return el;
	};
	
	var Core = function Core(options) {
	    this.init(options);
	};
	
	Core.prototype.init = function (options) {
	    this.event = new Event();
	    this.__isPlayed = false;
	    this.__uuid = uuid();
	    regVideo(this);
	    this.el = createVideo(options);
	    this.initEvent();
	};
	
	/**
	 * custom Event
	 * begin 当一个视频源第一次播放的时候，会触发一次此事件。
	 * swtich 当使用src()播放另外一个视频的时候，会触发一次此事件，有两个参数oldsrc, newsrc
	 */
	Core.prototype.initEvent = function () {
	    var _this = this;
	
	    // 对视频的第一次播放进行处理
	    var begin = function (event) {
	        if (this.__isPlayed == false) {
	            this.__isPlayed = true;
	            this.event.trigger('begin');
	        }
	    }.bind(this);
	
	    this.on('timeupdate', begin);
	
	    this.on('playing', function () {
	        console.log('playing');
	        currentVideo = this;
	    });
	
	    this.el.addEventListener('waiting', function (event) {
	        console.log('change Current time ^^^^^^^^^^');
	        var elm = event.target;
	        console.log('currentTime:', elm.currentTime, '@@@@@@@@@@');
	        if (elm.currentTime < 1) {
	            console.log('forceChange Current Time!!!!!!!!!!');
	            elm.currentTime = 0.1;
	        }
	    }, false);
	
	    var waitingEvent = [['seeking', 'waitingStatus'],
	    // ['stalled', 'waitingStatus'],
	    ['waiting', 'waitingStatus'], ['seeked', 'waitingStatus'], ['play', 'waitingStatus'], ['playing', 'playingStatus'], ['timeupdate', 'playingStatus'], ['pause', 'pauseStatus'], ['ended', 'endStatus'], ['error', 'errorStatus']];
	    waitingEvent.forEach(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            eventName = _ref2[0],
	            status = _ref2[1];
	
	        // console.log(eventName);
	        _this.on(eventName, function (e) {
	            // console.log(eventName, '=======>', status);
	            _this.event.trigger(status, e);
	        });
	    });
	    var __this = this;
	    Events.forEach(function (eventName) {
	        (function (evnetName) {
	            __this.on(eventName, function () {
	                // divLog(eventName, 'is fire');
	                //  console.log(eventName, 'is fire');
	            });
	        })(eventName);
	    });
	};
	
	Core.prototype.on = function (eventName, callback) {
	    if (Events.indexOf(eventName) >= 0) {
	        this.el.addEventListener(eventName, callback, false);
	    } else {
	        this.event.on(eventName, callback);
	    }
	};
	
	Core.prototype.off = function (eventName, callback) {
	    if (Events.indexOf(eventName) >= 0) {
	        this.el.removeEventListener(eventName, callback);
	    } else {
	        this.event.off(eventName, callback);
	    }
	};
	
	Core.prototype.pause = function () {
	    this.el.pause();
	};
	
	Core.prototype.play = function () {
	    var playPromise = this.el.play_new();
	    // Catch/silence error when a pause interrupts a play request
	    // on browsers which return a promise
	    if (playPromise !== undefined && typeof playPromise.then === 'function') {
	        playPromise.then(null, function (e) {});
	    }
	};
	
	Core.prototype.setCurrentTime = function (seconds) {
	    try {
	        this.el.currentTime = seconds;
	    } catch (e) {
	        console.log(e, 'Video is not ready. (Video.js)');
	        // this.warning(VideoJS.warnings.videoNotReady);
	    }
	};
	
	Core.prototype.getCurrentTime = function () {
	    return this.el.currentTime;
	};
	
	Core.prototype.load = function () {
	    loadVideo(this.el);
	};
	
	Core.prototype.reset = function () {
	    resetVideo(this.el);
	    this.__isPlayed = false;
	};
	
	Core.prototype.src = function (src) {
	    if (src === undefined) {
	        return this.el.src;
	    }
	
	    this.reset();
	    this.event.trigger('switch', this.el.src, src);
	    setAttribute(this.el, 'src', src);
	};
	
	Core.prototype.renderTo = function (container) {
	    container.appendChild(this.el);
	};
	
	Core.prototype.destory = function () {
	    // 解除所有事件绑定
	    Events.forEach(function (eventName) {
	        this.off(eventName);
	    }.bind(this));
	    this.off('begin');
	    this.off('switch');
	
	    // 重置
	    this.reset();
	
	    // 移除dom节点。
	    if (this.el.parentNode) {
	        this.el.parentNode.removeChild(this.el);
	    }
	
	    // 取消在全局的注册
	    unRegVideo(this);
	};
	
	[
	/**
	 * Paused for core tech
	 *
	 * @method Core.prototype.paused
	 * @return {Boolean}
	 */
	'paused',
	/**
	 * Get current time
	 *
	 * @method Core.prototype.currentTime
	 * @return {Number}
	 */
	'currentTime',
	/**
	 * Get a TimeRange object that represents the intersection
	 * of the time ranges for which the user agent has all
	 * relevant media
	 *
	 * @return {TimeRangeObject}
	 * @method Core.prototype.buffered
	 */
	'buffered',
	/**
	 * Get volume level
	 *
	 * @return {Number}
	 * @method Core.prototype.volume
	 */
	'volume',
	/**
	 * Get if muted
	 *
	 * @return {Boolean}
	 * @method Core.prototype.muted
	 */
	'muted',
	/**
	 * Get poster
	 *
	 * @return {String}
	 * @method Core.prototype.poster
	 */
	'poster',
	/**
	 * Get preload attribute
	 *
	 * @return {String}
	 * @method Core.prototype.preload
	 */
	'preload',
	/**
	 * Get autoplay attribute
	 *
	 * @return {String}
	 * @method Core.prototype.autoplay
	 */
	'autoplay',
	/**
	 * Get controls attribute
	 *
	 * @return {String}
	 * @method Core.prototype.controls
	 */
	'controls',
	/**
	 * Get loop attribute
	 *
	 * @return {String}
	 * @method Core.prototype.loop
	 */
	'loop',
	/**
	 * Get error value
	 *
	 * @return {String}
	 * @method Core.prototype.error
	 */
	'error',
	/**
	 * Get whether or not the player is in the "seeking" state
	 *
	 * @return {Boolean}
	 * @method Core.prototype.seeking
	 */
	'seeking',
	/**
	 * Get a TimeRanges object that represents the
	 * ranges of the media resource to which it is possible
	 * for the user agent to seek.
	 *
	 * @return {TimeRangeObject}
	 * @method Core.prototype.seekable
	 */
	'seekable',
	/**
	 * Get if video ended
	 *
	 * @return {Boolean}
	 * @method Core.prototype.ended
	 */
	'ended',
	/**
	 * Get the value of the muted content attribute
	 * This attribute has no dynamic effect, it only
	 * controls the default state of the element
	 *
	 * @return {Boolean}
	 * @method Core.prototype.defaultMuted
	 */
	'defaultMuted',
	/**
	 * Get desired speed at which the media resource is to play
	 *
	 * @return {Number}
	 * @method Core.prototype.playbackRate
	 */
	'playbackRate',
	/**
	 * Returns a TimeRanges object that represents the ranges of the
	 * media resource that the user agent has played.
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-played
	 *
	 * @return {TimeRangeObject} the range of points on the media
	 *                           timeline that has been reached through
	 *                           normal playback
	 * @method Core.prototype.played
	 */
	'played',
	/**
	 * Get the current state of network activity for the element, from
	 * the list below
	 * - NETWORK_EMPTY (numeric value 0)
	 * - NETWORK_IDLE (numeric value 1)
	 * - NETWORK_LOADING (numeric value 2)
	 * - NETWORK_NO_SOURCE (numeric value 3)
	 *
	 * @return {Number}
	 * @method Core.prototype.networkState
	 */
	'networkState',
	/**
	 * Get a value that expresses the current state of the element
	 * with respect to rendering the current playback position, from
	 * the codes in the list below
	 * - HAVE_NOTHING (numeric value 0)
	 * - HAVE_METADATA (numeric value 1)
	 * - HAVE_CURRENT_DATA (numeric value 2)
	 * - HAVE_FUTURE_DATA (numeric value 3)
	 * - HAVE_ENOUGH_DATA (numeric value 4)
	 *
	 * @return {Number}
	 * @method Core.prototype.readyState
	 */
	'readyState',
	/**
	 * Get width of video
	 *
	 * @return {Number}
	 * @method Core.prototype.videoWidth
	 */
	'videoWidth',
	/**
	 * Get height of video
	 *
	 * @return {Number}
	 * @method Core.prototype.videoHeight
	 */
	'videoHeight', 'duration'].forEach(function (prop) {
	    Core.prototype['get' + toTitleCase(prop)] = function () {
	        return this.el[prop];
	    };
	});
	
	// Wrap native properties with a setter in this format:
	// set + toTitleCase(name)
	[
	/**
	 * Set volume level
	 *
	 * @param {Number} percentAsDecimal Volume percent as a decimal
	 * @method Core.prototype.setVolume
	 */
	'volume',
	/**
	 * Set muted
	 *
	 * @param {Boolean} muted If player is to be muted or note
	 * @method Core.prototype.setMuted
	 */
	'muted',
	/**
	 * Set video source
	 *
	 * @param {Object} src Source object
	 * @deprecated since version 5
	 * @method Core.prototype.setSrc
	 */
	'poster',
	/**
	 * Set preload attribute
	 *
	 * @param {String} val Value for the preload attribute
	 * @method Htm5.prototype.setPreload
	 */
	'preload',
	/**
	 * Set autoplay attribute
	 *
	 * @param {Boolean} autoplay Value for the autoplay attribute
	 * @method setAutoplay
	 */
	'autoplay',
	/**
	 * Set loop attribute
	 *
	 * @param {Boolean} loop Value for the loop attribute
	 * @method Core.prototype.setLoop
	 */
	'loop',
	/**
	 * Set desired speed at which the media resource is to play
	 *
	 * @param {Number} val Speed at which the media resource is to play
	 * @method Core.prototype.setPlaybackRate
	 */
	'playbackRate'].forEach(function (prop) {
	    Core.prototype['set' + toTitleCase(prop)] = function (v) {
	        this.el[prop] = v;
	    };
	});
	
	// wrap native functions with a function
	[
	/**
	 * Pause for core
	 *
	 * @method Core.prototype.pause
	 */
	'pause'].forEach(function (prop) {
	    Core.prototype[prop] = function () {
	        return this.el[prop]();
	    };
	});
	
	var videos = {};
	var regVideo = function regVideo(core) {
	    if (typeof videos[core.id] === 'undefined') {
	        videos[core.id] = core;
	    }
	};
	var unRegVideo = function unRegVideo(core) {
	    if (typeof videos[core.__uuid] !== 'undefined') {
	        delete videos[core.__uuid];
	    }
	};
	var index = 0;
	var uuid = function uuid() {
	    return 'video_' + index++;
	};
	Core.current = function () {
	    return currentVideo;
	};
	Core.videos = function () {
	    return videos;
	};
	
	module.exports = Core;

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */,
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(440);
	var tmpl = __webpack_require__(442);
	
	var Poster = function Poster(url) {
	  this.url = url;
	  this.init();
	};
	
	Poster.prototype.init = function () {
	  this.initDom();
	  this.initEvent();
	};
	
	Poster.prototype.initDom = function () {
	  var div = document.createElement('div');
	  div.innerHTML = tmpl({ url: this.url });
	  this.el = div.children[0];
	};
	
	Poster.prototype.initEvent = function () {};
	
	Poster.prototype.hide = function () {
	  this.el.style.display = 'none';
	};
	
	Poster.prototype.show = function () {
	  this.el.style.display = 'block';
	};
	
	Poster.prototype.renderTo = function (parentNode) {
	  parentNode.appendChild(this.el);
	};
	
	Poster.prototype.destory = function () {
	  this.el.parentNode.removeChild(this.el);
	};
	
	module.exports = Poster;

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */,
/* 442 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-video__poster\" style=\"background-image: url(")
	    ; __append(escape(url))
	    ; __append(");\"></div>\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(444);
	var tmpl = __webpack_require__(449);
	var Events = __webpack_require__(104);
	
	var PlayButton = function PlayButton(url) {
	  this.url = url;
	  this.init();
	};
	
	PlayButton.prototype.init = function () {
	  this.initDom();
	  this.initEvent();
	};
	
	PlayButton.prototype.initDom = function () {
	  var div = document.createElement('div');
	  div.innerHTML = tmpl();
	  this.el = div.children[0];
	};
	
	PlayButton.prototype.initEvent = function () {
	  var clickFn = function (e) {
	    this.trigger('click', e);
	  }.bind(this);
	  this.el.addEventListener('click', clickFn, false);
	};
	
	PlayButton.prototype.renderTo = function (parentNode) {
	  parentNode.appendChild(this.el);
	};
	
	PlayButton.prototype.changeState = function (type) {
	  var types = {
	    'play': '',
	    'pause': ' c-video__button--play',
	    'replay': ' c-video__button--replay',
	    'waiting': ' c-video__button--waiting'
	  };
	  this.el.className = 'c-video__button' + types[type];
	  return this.el.className;
	};
	
	PlayButton.prototype.show = function () {
	  this.el.style.visibility = 'visible';
	};
	
	PlayButton.prototype.hide = function () {
	  this.el.style.visibility = 'hidden';
	};
	
	PlayButton.prototype.destory = function () {
	  this.off();
	  this.el.removeEventListener('click', clickFn);
	  this.el.parentNode.removeChild(this.el);
	};
	
	Events.mixTo(PlayButton);
	
	module.exports = PlayButton;

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-video__button\"></div>\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(451);
	var tmpl = __webpack_require__(457);
	var Events = __webpack_require__(104);
	var util = __webpack_require__(404);
	
	var Control = function Control(options) {
	  this.options = options;
	  this.isHide = false;
	  this.init();
	  this.hideTimer = null;
	};
	
	Control.prototype.init = function () {
	  this.initDom();
	  this.initEvent();
	  this.initZoomState();
	};
	
	Control.prototype.initDom = function () {
	  var div = document.createElement('div');
	  var nowTime = Date.parse(new Date());
	  if (this.options.start_date > nowTime) {
	    // 直播未开始
	    this.isLive = '0';
	  } else if (nowTime > this.options.end_date) {
	    // 直播已结束
	    this.isLive = '2';
	  } else {
	    // 正在直播中
	    this.isLive = '1';
	  }
	  div.innerHTML = tmpl({ isLive: this.isLive });
	  this.el = div.children[0];
	  this.elPlayBtn = this.el.querySelector('.c-livevideo-control__button');
	  this.elZoom = this.el.querySelector('.c-livevideo-control__zoom');
	};
	
	Control.prototype.initEvent = function () {
	
	  util.tap(this.elPlayBtn, function () {
	    this.trigger('play');
	    return false;
	  }, {
	    scope: this
	  });
	
	  util.tap(this.elZoom, function () {
	    var dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
	    if (Math.abs(dge) == 90) {
	      this.trigger('zoom', 'zoomin');
	    } else {
	      this.trigger('zoom', 'zoomout');
	    }
	    return false;
	  }, {
	    scope: this
	  });
	
	  // 为了在你触摸控制条的时候，控制条不消失。
	  // util.swip(this.el, function () {
	  //   clearTimeout(this.hideTimer);
	  // }, function () {
	  // }, function () {
	  //   this.hideTimer = setTimeout(function () {
	  //     this.hide();
	  //   }.bind(this), 3000);
	  // }, {
	  //   scope: this
	  // });
	
	  util.tap(this.el, function () {
	    return false;
	  });
	  util.on(window, 'orientationchange', function () {
	    this.initZoomState();
	    this.resize();
	  }, {
	    scope: this
	  });
	};
	
	Control.prototype.initZoomState = function () {
	  var dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
	  if (Math.abs(dge) == 90) {
	    $(this.elZoom).removeClass('c-livevideo-control__zoom--zoomin').addClass('c-livevideo-control__zoom--zoomout');
	  } else {
	    $(this.elZoom).removeClass('c-livevideo-control__zoom--zoomout').addClass('c-livevideo-control__zoom--zoomin');
	  }
	};
	
	Control.prototype.renderTo = function (parentNode) {
	  parentNode.appendChild(this.el);
	};
	
	Control.prototype.show = function () {
	  $(this.el).stop().animate({
	    bottom: '0px'
	  });
	  // this.el.style.visibility = 'visible';
	  this.trigger('show');
	  this.isHide = false;
	  clearTimeout(this.hideTimer);
	  this.hideTimer = setTimeout(function () {
	    this.hide();
	  }.bind(this), 3000);
	};
	
	Control.prototype.hide = function () {
	  $(this.el).stop().animate({
	    bottom: '-200px'
	  });
	  // this.el.style.visibility = 'hidden';
	  this.isHide = true;
	  this.trigger('hide');
	};
	
	Control.prototype.toggle = function () {
	  if (this.isHide == true) {
	    this.show();
	  } else {
	    this.hide();
	  }
	};
	
	Control.prototype.changePlayState = function (type) {
	  var types = {
	    'play': 'c-livevideo-control__button--pause',
	    'pause': 'c-livevideo-control__button--play'
	  };
	  this.elPlayBtn.className = 'c-livevideo-control__button ' + types[type];
	};
	
	Control.prototype.changeFullState = function (type) {
	  var types = {
	    'zoomout': 'c-livevideo-control__zoom--zoomin',
	    'zoomin': 'c-livevideo-control__zoom--zoomout'
	  };
	  this.elPlayBtn.className = 'c-livevideo-control__button ' + types[type];
	};
	
	Control.prototype.reset = function () {
	  this.changePlayState('pause');
	};
	
	Control.prototype.resize = function () {};
	
	Control.prototype.destory = function () {
	  this.off();
	  this.el.parentNode.removeChild(this.el);
	};
	
	Events.mixTo(Control);
	
	module.exports = Control;

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-livevideo-control\">\n    <div\n        class=\"c-livevideo-control__button c-livevideo-control__button--play\"\n    ></div>\n    <div class=\"c-livevideo-control__state\">\n        ")
	    ;  if(isLive === '0'){ 
	    ; __append(" ")
	    ;  }else if(isLive === '1'){ 
	    ; __append(" 正在直播 ")
	    ; 
	        }else{ 
	    ; __append(" 直播已结束 ")
	    ;  } 
	    ; __append("\n    </div>\n    <div\n        class=\"c-livevideo-control__zoom c-livevideo-control__zoom--zoomin\"\n    ></div>\n</div>\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(459);
	var tmpl = __webpack_require__(461);
	var Events = __webpack_require__(104);
	var util = __webpack_require__(404);
	
	var Title = function Title(title, channelName, channelIcon) {
	  this.title = title;
	  this.channelName = channelName;
	  this.channelIcon = channelIcon;
	  this.init();
	};
	
	Title.prototype.init = function () {
	  this.initDom();
	  this.initEvent();
	};
	
	Title.prototype.initDom = function () {
	  var div = document.createElement('div');
	  div.innerHTML = tmpl({ title: this.title, channelName: this.channelName, channelIcon: this.channelIcon });
	  this.el = div.children[0];
	  this.elExitBtn = this.el.querySelector('.c-video__exit');
	};
	
	Title.prototype.initEvent = function () {
	  util.tap(this.elExitBtn, function () {
	    this.trigger('exit');
	    return false;
	  }, {
	    scope: this
	  });
	};
	
	Title.prototype.hide = function () {
	  $(this.el).stop().animate({
	    top: '-300px'
	  });
	  // this.el.style.display = 'none';
	};
	
	Title.prototype.show = function () {
	  $(this.el).stop().animate({
	    top: '0'
	  });
	  // this.el.style.display = 'block';
	};
	
	Title.prototype.renderTo = function (parentNode) {
	  parentNode.appendChild(this.el);
	};
	
	Title.prototype.destory = function () {
	  this.el.parentNode.removeChild(this.el);
	};
	
	Events.mixTo(Title);
	
	module.exports = Title;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */,
/* 461 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-video__title\">\n  <div class=\"c-video__exit\"><span class=\"c-video__exit__icon\"></span>")
	    ; __append(escape(title))
	    ; __append("</div>\n  <div class=\"c-video__channel\"><span style=\"background-image: url(")
	    ; __append(escape(channelIcon))
	    ; __append(")\"></span>")
	    ; __append(escape(channelName))
	    ; __append("</div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(463);
	var tmpl = __webpack_require__(468);
	var Events = __webpack_require__(104);
	
	var ErrorBox = function ErrorBox(title) {
	  this.title = title || '主播被风吹走了...';
	  this.init();
	};
	
	ErrorBox.prototype.init = function () {
	  this.initDom();
	  this.initEvent();
	};
	
	ErrorBox.prototype.initDom = function () {
	  var div = document.createElement('div');
	  div.innerHTML = tmpl({ title: this.title });
	  this.el = div.children[0];
	  this.reload_btn = this.el.getElementsByClassName('l-error_btn')[0];
	};
	
	ErrorBox.prototype.initEvent = function () {
	  var _this = this;
	  this.el.addEventListener('touchend', function (e) {
	    _this.trigger('error_toggle');
	    return false;
	  });
	
	  this.reload_btn.addEventListener('touchend', function (e) {
	    window.location.reload();
	    e.preventDefault();
	  }, false);
	};
	
	ErrorBox.prototype.hide = function () {
	  this.el.style.visibility = 'hidden';
	};
	
	ErrorBox.prototype.show = function () {
	  this.el.style.visibility = 'visible';
	};
	
	ErrorBox.prototype.renderTo = function (parentNode) {
	  parentNode.appendChild(this.el);
	};
	
	ErrorBox.prototype.destory = function () {
	  this.el.parentNode.removeChild(this.el);
	};
	Events.mixTo(ErrorBox);
	
	module.exports = ErrorBox;

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"l-error\" style=\"visibility: hidden;\">\n    <div class=\"l-error_img\"></div>\n    <div class=\"l-error_right\">\n        <span>")
	    ; __append(escape(title))
	    ; __append("</span>\n        <div class=\"l-error_btn\"></div>\n    </div>\n</div>\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	"use strict";
	
	function _getCookie(name) {
	  var arg = name + "=";
	  var alen = arg.length;
	  var clen = document.cookie.length;
	  var i = 0;
	  while (i < clen) {
	    var j = i + alen;
	    if (document.cookie.substring(i, j) == arg) {
	      return function (offset) {
	        var endstr = document.cookie.indexOf(";", offset);
	        if (endstr == -1) {
	          endstr = document.cookie.length;
	        }
	        return decodeURIComponent(document.cookie.substring(offset, endstr));
	      }(j);
	    }
	    i = document.cookie.indexOf(" ", i) + 1;
	    if (i == 0) break;
	  }
	  return "";
	}
	
	//设置cookie
	function _setCookie(name, value, params) {
	  var cStrArr = [];
	  cStrArr.push(name + '=' + encodeURIComponent(value));
	
	  if (typeof params === 'undefined') {
	    params = {};
	  }
	  if (typeof params.expires !== 'undefined') {
	    var date = new Date();
	    date.setTime(date.getTime() + params.expires * 1000 * 60);
	    cStrArr.push('; expires=' + date.toGMTString());
	  }
	  cStrArr.push(typeof params.path !== 'undefined' ? '; path=' + params.path : '');
	  cStrArr.push(typeof params.domain !== 'undefined' ? '; domain=' + params.domain : '');
	  cStrArr.push(typeof params.secure !== 'undefined' ? '; secure' : '');
	
	  document.cookie = cStrArr.join('');
	}
	
	//随机获取一个uid
	function getRandomUid() {
	  var date = new Date().getTime(),
	      uid = '',
	      fn = '',
	      sn = '';
	
	  fn = (Math.random() * 2147483648 | 0).toString(36);
	  sn = Math.round(Math.random() * 10000);
	  uid = date + '_' + fn + sn;
	  return uid;
	}
	
	var sendHTML5VideoInfo = function sendHTML5VideoInfo(params) {
	
	  if (typeof params !== 'undefined') {
	    // 合并对象。
	    var _merge = function _merge(s, t) {
	      var result = {};
	
	      if (!t) {
	        return result;
	      }
	
	      for (var i in s) {
	        result[i] = typeof t[i] !== "undefined" ? t[i] : s[i];
	      }
	
	      return result;
	    };
	
	    var _host = location.protocol == 'http:' ? 'stadig' : 'stadig0';
	    var url = "//" + _host + ".ifeng.com/media.js";
	    var data = _merge({
	      url: '',
	      id: '',
	      sid: '',
	      uid: '',
	      from: '',
	      provider: '',
	      loc: '',
	      cat: '',
	      se: '',
	      ptype: '',
	      vid: 'HTML5Player',
	      ref: '', //域名
	      tm: '' //时间戳
	    }, params);
	
	    //针对影视做的特殊统计参数处理
	    if (typeof paramInfo !== 'undefined' && typeof paramInfo.type !== 'undefined' && typeof videoinfo !== 'undefined' && typeof videoinfo.cpId !== 'undefined') {
	      data.provider = videoinfo.cpId;
	    }
	
	    var pArr = [];
	    for (var i in data) {
	      pArr.push(i + '=' + encodeURIComponent(data[i]));
	    }
	    var scriptDom = document.createElement('script');
	    url = pArr.length > 0 ? url + '?' + pArr.join('&') : url;
	    scriptDom.src = url;
	    document.getElementsByTagName("head").item(0).appendChild(scriptDom);
	  }
	};
	
	function sendXV(playermsg, type) {
	  var params = {
	    url: type
	  };
	  params.id = playermsg.videoid;
	  params.sid = _getCookie('sid');
	
	  //如果获取userid为空串的话，生成一个userid
	  if (_getCookie('userid') === '') {
	    _setCookie('userid', getRandomUid(), { domain: '.ifeng.com', path: '/', expires: 60 * 24 * 360 });
	  }
	  params.uid = _getCookie('userid');
	  params.loc = _getCookie('ilocid');
	
	  var cid = typeof playermsg.categoryId !== 'undefined' ? playermsg.categoryId : '';
	  var cname = playermsg.columnName;
	  params.provider = playermsg.provider || '';
	  params.cat = cid;
	  params.se = typeof cname !== 'undefined' ? cname : '';
	  params.ptype = cid === '' ? '' : cid.substr(0, 4);
	  params.ref = window.location.href.replace(/#/g, '$');
	  params.tm = new Date().getTime();
	  params.from = window.location.href.split('//')[1].split('.')[0];
	  sendHTML5VideoInfo(params);
	}
	
	module.exports = sendXV;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(471);
	var tmpl = __webpack_require__(473);
	var Events = __webpack_require__(104);
	
	var padding = function padding(val) {
	    if (val < 10) {
	        return '0' + val;
	    }
	    return val;
	};
	
	var Cutdown = function Cutdown(time) {
	    this.time = time;
	    this.remainTime = Math.floor((new Date(time).valueOf() - new Date().valueOf()) / 1000);
	    console.log('remainTime=====>' + this.remainTime);
	    this.timer = null;
	    this.init();
	};
	
	Cutdown.prototype.init = function () {
	    this.initDom();
	    this.initEvent();
	};
	
	Cutdown.prototype.initDom = function () {
	    var div = document.createElement('div');
	    div.innerHTML = tmpl({ title: this.title });
	    this.el = div.children[0];
	    this.elTime = this.el.querySelector('.c-count-down__time');
	};
	
	Cutdown.prototype.begin = function () {
	    if (this.remainTime <= 0) {
	        this.trigger('end');
	        this.hide();
	        clearInterval(this.timer);
	    }
	    this.renderTime();
	    this.timer = setInterval(function () {
	        this.remainTime--;
	        this.renderTime();
	        if (this.remainTime <= 0) {
	            this.trigger('end');
	            this.hide();
	            clearInterval(this.timer);
	        }
	    }.bind(this), 1000);
	};
	
	Cutdown.prototype.renderTime = function () {
	    var remain = this.remainTime;
	    var day = Math.floor(remain / (60 * 60 * 24));
	    remain = remain - day * 60 * 60 * 24;
	    var hour = Math.floor(remain / (60 * 60));
	    remain = remain - hour * 60 * 60;
	    var minute = Math.floor(remain / 60);
	    var second = remain - minute * 60;
	    this.elTime.innerHTML = padding(day) + ':' + padding(hour) + ':' + padding(minute) + ':' + padding(second);
	};
	
	Cutdown.prototype.initEvent = function () {};
	
	Cutdown.prototype.hide = function () {
	    this.el.style.display = 'none';
	};
	
	Cutdown.prototype.show = function () {
	    this.el.style.display = 'flex';
	};
	
	Cutdown.prototype.renderTo = function (parentNode) {
	    parentNode.appendChild(this.el);
	};
	
	Cutdown.prototype.destory = function () {
	    this.off();
	    clearInterval(this.timer);
	    this.el.parentNode.removeChild(this.el);
	};
	
	Events.mixTo(Cutdown);
	
	module.exports = Cutdown;

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */,
/* 473 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"l-count-down\" style=\"display: none;\">\n  <div class=\"c-count-down\">\n    <div class=\"c-count-down__title\">距离开播还有</div>\n    <div class=\"c-count-down__time\">--:--:--:--</div>\n    <div class=\"c-count-down__describe\"><span>DAY</span><span>HOURS</span><span>MINUTES</span><span>SECONDS</span></div>\n  </div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(475);
	var tmpl = __webpack_require__(478);
	
	var Ready = function Ready(time) {
	  this.time = time;
	  this.init();
	};
	
	Ready.prototype.init = function () {
	  this.initDom();
	  this.initEvent();
	};
	
	Ready.prototype.initDom = function () {
	  var div = document.createElement('div');
	  div.innerHTML = tmpl();
	  this.el = div.children[0];
	  this.elReady = this.el.querySelector('.c-ready');
	
	  if (this.time) {
	    this.elReady.innerHTML = time + ' 准时开播';
	  } else {
	    this.elReady.innerHTML = '直播即将开始，请耐心等待';
	  }
	};
	
	Ready.prototype.initEvent = function () {};
	
	Ready.prototype.hide = function () {
	  this.el.style.display = 'none';
	};
	
	Ready.prototype.show = function () {
	  this.el.style.display = 'flex';
	};
	
	Ready.prototype.renderTo = function (parentNode) {
	  parentNode.appendChild(this.el);
	};
	
	Ready.prototype.destory = function () {
	  this.el.parentNode.removeChild(this.el);
	};
	
	module.exports = Ready;

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */,
/* 477 */,
/* 478 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"l-ready\" style=\"display:none;\">\n  <div class=\"c-ready\"></div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(480);
	var tmpl = __webpack_require__(482);
	var Events = __webpack_require__(104);
	var util = __webpack_require__(404);
	
	var List = function List(data) {
	  this.data = data || [];
	  this.init();
	};
	
	List.prototype.init = function () {
	  this.initDom();
	  this.initEvent();
	};
	
	List.prototype.initDom = function () {
	  var div = document.createElement('div');
	  div.innerHTML = tmpl({ data: this.data });
	  this.el = div.children[0];
	};
	
	List.prototype.initEvent = function () {
	
	  util.tap(this.el, function (event, elm) {
	    if ($(elm).hasClass('c-livevideo-list__item--selected')) {
	      return false;
	    }
	
	    $(this.el).find('.c-livevideo-list__item--selected').removeClass('c-livevideo-list__item--selected');
	    $(elm).addClass('c-livevideo-list__item--selected');
	    this.trigger('switch', $(elm).data('url'), $(elm).data('index'));
	
	    return false;
	  }, {
	    scope: this,
	    delegate: '.c-livevideo-list__item'
	  });
	};
	
	List.prototype.show = function () {
	  $(this.el).stop().animate({
	    right: '0px'
	  });
	};
	
	List.prototype.hide = function () {
	  $(this.el).stop().animate({
	    right: '-600px'
	  });
	};
	
	List.prototype.renderTo = function (parentNode) {
	  parentNode.appendChild(this.el);
	};
	
	Events.mixTo(List);
	module.exports = List;

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */,
/* 482 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-livevideo-list\">\n  ")
	    ;  if (data.length > 1) { 
	    ; __append("\n    ")
	    ;  for (var i = 0, iLen = data.length; i < iLen; i++) { 
	    ; __append("\n      <div class=\"c-livevideo-list__item ")
	    ; if (data[i].isSelected == true) { 
	    ; __append("c-livevideo-list__item--selected")
	    ;  } 
	    ; __append("\" data-index=\"")
	    ; __append(escape(i))
	    ; __append("\">\n        <span>线路")
	    ; __append(escape(i + 1))
	    ; __append("</span>\n        <section style=\"background-image: url(")
	    ; __append(escape(data[i].poster))
	    ; __append(")\"></section>\n        <div>")
	    ; __append(escape(data[i].title))
	    ; __append("</div>\n      </div>\n    ")
	    ;  } 
	    ; __append("\n  ")
	    ;  } 
	    ; __append("\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(484);
	var tmpl = __webpack_require__(487);
	var Events = __webpack_require__(104);
	
	var Network = function Network(url) {
	  this.url = url;
	  this.init();
	};
	
	Network.prototype.init = function () {
	  this.initDom();
	  this.initEvent();
	};
	
	Network.prototype.initDom = function () {
	  this.elm = $(tmpl());
	};
	
	Network.prototype.initEvent = function () {
	  var _this = this;
	
	  this.elm.on('touchend', '.c-network-btn__retry', function () {
	    _this.trigger('network_retry');
	    return false;
	  });
	  this.elm.on('touchend', '.c-network-btn__continue', function () {
	    _this.trigger('network_continue');
	    return false;
	  });
	
	  this.elm.on('touchend', function () {
	    _this.trigger('network_toggle');
	    return false;
	  });
	};
	
	Network.prototype.renderTo = function (parentNode) {
	  this.elm.appendTo(parentNode);
	};
	
	Network.prototype.show = function (type) {
	  if (type == 'offnet') {
	    this.elm.html('\n      <div>\n        <span class="c-network-content">\u7F51\u7EDC\u8FDE\u63A5\u5931\u8D25</span>\n        <span class="c-network-btn__retry">\u91CD\u8BD5</span>\n      </div>\n      ');
	  } else if (type == 'notWifi_videoapp') {
	    this.elm.html('\n    <div>\n      <span class="c-network-content">\u5C0F\u63D0\u793A<br/>\u60A8\u6B63\u5728\u4F7F\u7528\u8FD0\u8425\u5546\u7F51\u7EDC</span>\n      <span class="c-network-btn__continue">\u7EE7\u7EED\u89C2\u770B</span>\n    </div>\n  ');
	  } else {
	    this.elm.html('\n      <div>\n        <span class="c-network-content">\u5C0F\u63D0\u793A<br/>\u60A8\u6B63\u5728\u4F7F\u7528\u624B\u673A\u6D41\u91CF\u89C2\u770B</span>\n        <span class="c-network-btn__continue">\u7EE7\u7EED\u89C2\u770B</span>\n      </div>\n    ');
	  }
	
	  this.elm.css('visibility', 'visible');
	};
	
	Network.prototype.hide = function () {
	  this.elm.css('visibility', 'hidden');
	};
	
	Network.prototype.destory = function () {
	  this.off();
	  this.elm.remove();
	};
	
	Events.mixTo(Network);
	
	module.exports = Network;

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */,
/* 486 */,
/* 487 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"l-network\" style=\"visibility: hidden;\">\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Core = __webpack_require__(436);
	var Poster = __webpack_require__(439);
	var PlayButton = __webpack_require__(443);
	var Control = __webpack_require__(489);
	var Title = __webpack_require__(458);
	var ErrorBox = __webpack_require__(462);
	var statistics = __webpack_require__(469);
	var List = __webpack_require__(479);
	var Network = __webpack_require__(483);
	var Events = __webpack_require__(104);
	var Cutdown = __webpack_require__(470);
	var Ready = __webpack_require__(474);
	
	var mp4Url = '//dyn.v.ifeng.com/cmpp/video_msg_ipad.js';
	var ugcMp4Url = '//api.cmpp.v.ifeng.com/index.php/live/video';
	
	var getVideoInfo = function getVideoInfo(options) {
	    var url = options.from && options.from == 'ugc' ? ugcMp4Url : mp4Url;
	    var msg = options.from && options.from == 'ugc' ? options.uid + '@' + options.liveVideoId : options.liveVideoId;
	
	    if (!(options.from && options.from == 'ugc')) {
	        var id = options.liveVideoId.split('-')[0];
	        return $.ajax({
	            url: '//tv.ifeng.com/h6/' + id + '__callback' + id + '_/video.json',
	            type: 'get',
	            jsonpCallback: 'callback' + id,
	            dataType: 'jsonp'
	        });
	    }
	    return $.ajax({
	        url: url,
	        dataType: 'jsonp',
	        data: {
	            msg: msg,
	            rt: 'js',
	            param: 'playermsg'
	        }
	    });
	};
	
	var Video = function Video(options) {
	    this.options = options;
	    this.isSpread = true;
	    this.init();
	    this.currentTime = 0;
	};
	
	Video.prototype.init = function () {
	    this.initParams();
	    this.initLayout();
	    this.initCompontent();
	    this.initEvent();
	};
	
	Video.prototype.initParams = function () {};
	
	Video.prototype.initLayout = function () {
	    this.el = document.createElement('div');
	    this.el.classList.add('c-video');
	};
	
	Video.prototype.initCompontent = function () {
	    // var url = this.options.from && this.options.from == 'ugc' ?
	    //           ugcMp4Url : mp4Url;
	    // var msg = this.options.from && this.options.from == 'ugc' ?
	    //           this.options.uid + '@' + this.options.guid : this.options.guid;
	
	    // playermsg = {
	    //   "videoid": "0430de49-548b-4d13-9ac9-5fccd0b04248",
	    //   "ratio": "4:3",
	    //   "largePoster": "//d.ifengimg.com/w400_h300/p0.ifengimg.com/pmop/2016/12/06/e697da70-4c02-4110-8a32-366c71f14ca9.jpg",
	    //   "videoplayurl": "//ips.ifeng.com/video19.ifeng.com/video09/2016/12/06/4396652-102-008-0746.mp4",
	    //   "categoryId":"0031-0000",
	    //   "columnName":""
	    // };
	
	    // this.playermsg = $.ajax({
	    //   url: url,
	    //   dataType: 'jsonp',
	    //   data: {
	    //     msg: msg,
	    //     rt: 'js',
	    //     param: 'playermsg'
	    //   },
	    //   context: this,
	    // });
	
	    var self = this;
	    var videoOption = this.options.list[0];
	    this.playermsg = getVideoInfo(videoOption);
	
	    this.core = new Core({
	        src: this.options.src,
	        poster: videoOption.poster,
	        inline: true,
	        autoplay: this.options.autoplay,
	        loop: true
	    });
	
	    pageVideoList.push(this.core);
	
	    this.poster = new Poster(videoOption.poster);
	
	    // this.core = new Core({
	    //   src: this.options.src,
	    //   poster: this.options.poster,
	    //   inline: true
	    // });
	
	    this.playButton = new PlayButton();
	    this.playButton.changeState('pause');
	    this.control = new Control(this.options);
	    this.title = new Title(this.options.title, this.options.channelName, this.options.channelIcon);
	    this.error = new ErrorBox(this.options.errorTitle);
	    this.cutdown = new Cutdown(this.options.start_time);
	    this.list = new List(this.options.list);
	    this.network = new Network();
	
	    this.core.renderTo(this.el);
	
	    this.poster.renderTo(this.el);
	
	    this.playButton.renderTo(this.el);
	    this.control.renderTo(this.el);
	    this.title.renderTo(this.el);
	    this.error.renderTo(this.el);
	    this.cutdown.renderTo(this.el);
	    this.list.renderTo(this.el);
	    this.network.renderTo(this.el);
	};
	
	Video.prototype.renderTo = function (parentNode) {
	    parentNode.appendChild(this.el);
	};
	
	/**
	 * 自定义事件列表
	 * begin 每个视频开始播放时 一般用来发cv统计
	 * ended 视频播放结束时
	 * pause 视频暂停
	 * play 视频播放
	 * switch 视频切换
	 * init 初始化视频 主要用于发vv统计
	 */
	Video.prototype.initEvent = function () {
	    var core = this.core;
	    var control = this.control;
	    var playButton = this.playButton;
	    var poster = this.poster;
	    var title = this.title;
	    var error = this.error;
	    var list = this.list;
	    var network = this.network;
	    var cutdown = this.cutdown;
	    var self = this;
	
	    core.on('begin', function () {
	        console.log('=======begin');
	        self.playermsg.then(function (msg) {
	            statistics(msg, 'cv');
	        });
	        self.control.show();
	        self.trigger('begin');
	    });
	
	    // 视频内部切换
	    core.on('switch', function (oldSrc, newSrc) {
	        self.trigger('switch', oldSrc, newSrc);
	    });
	
	    core.on('loadedmetadata', function () {
	        self.playermsg.then(function (msg) {
	            statistics(msg, 'vv');
	        });
	        self.trigger('init');
	    });
	
	    // 视频播放
	    core.on('play', function () {
	        console.log('-------play====');
	        self.trigger('hideCount');
	        // let current = Core.current();
	        // if (current && core != current) {
	        //     current.pause();
	        // }
	        for (var i = 0; i < pageVideoList.length; i++) {
	            var otherCore = pageVideoList[i];
	            if (otherCore !== core) {
	                otherCore.pause();
	            }
	        }
	        // 由于安卓端兼容性原因，将控层的样式修改放在video的timeupdate事件中
	        // playButton.changeState('play');
	        // control.changePlayState('play');
	        // poster.hide();
	        error.hide();
	        network.hide();
	    });
	
	    // 视频暂停
	    core.on('pause', function () {
	        playButton.changeState('pause');
	        control.changePlayState('pause');
	        self.trigger('pause');
	        if (self.isSpread) {
	            self.trigger('pauseAd');
	        }
	    });
	
	    // 视频播放完成
	    core.on('ended', function () {
	        playButton.changeState('replay');
	        self.trigger('ended');
	    });
	
	    core.on('error', function (e) {
	        error.show();
	        self.trigger('error', e);
	    });
	
	    // 视频播放更新
	    core.on('timeupdate', function () {
	        var duration = core.getDuration();
	        var currentTime = core.getCurrentTime();
	        if (currentTime > 0.1) {
	            playButton.changeState('play');
	            control.changePlayState('play');
	            poster.hide();
	        }
	        control.setTime(currentTime / duration, false);
	        control.setTimeVal(Math.floor(duration - currentTime));
	        self.trigger('timeupdate', core.getCurrentTime());
	        self.currentTime = currentTime;
	    });
	
	    title.on('exit', function () {
	        self.trigger('exit');
	        console.log('exit');
	    });
	
	    // 点击播放器前面的控制蒙层
	    playButton.on('click', function (e) {
	        if (self.isSpread) {
	            // 展开
	            if (core.getEnded() || core.getPaused()) {
	                core.play();
	            } else {
	                control.toggle();
	                return;
	            }
	        } else {
	            // 折叠
	            self.trigger('shrinkOpen');
	            if (core.getEnded() || core.getPaused()) {
	                core.play();
	                return;
	            } else {
	                // core.pause();
	                return;
	            }
	        }
	
	        if (core.getNetworkState() == 3) {
	            control.toggle();
	        }
	    });
	
	    // 控制条时间轴变化
	    control.on('time', function (val) {
	        var duration = core.getDuration();
	        if (duration) {
	            core.setCurrentTime(duration * val);
	        }
	    });
	
	    // 控制条点击播放按钮
	    control.on('play', function () {
	        if (core.getPaused()) {
	            core.play();
	        } else {
	            core.pause();
	            // 暂停添加居中广告
	            if (self.isSpread) {
	                self.trigger('pauseAd');
	            }
	        }
	    });
	
	    control.on('zoom', function (state) {
	        self.trigger('zoom', state);
	    });
	
	    // 控制条隐藏的同时，隐藏标题
	    control.on('show', function () {
	        title.show();
	        list.show();
	        self.trigger('controlShow');
	    });
	
	    // 控制条显示的同时，显示标题
	    control.on('hide', function () {
	        title.hide();
	        list.hide();
	        self.trigger('controlHide');
	    });
	
	    list.on('switch', function (url, index) {
	        var videoOption = this.options.list[index];
	        core.src(videoOption.mp4);
	        core.setPoster(videoOption.poster);
	        core.play();
	        this.options.playermsg = this.playermsg = getVideoInfo(videoOption);
	        this.trigger('switchBarrage', videoOption.liveVideoId);
	        this.control.reset();
	    }.bind(this));
	
	    network.on('network_retry', function () {
	        window.location.reload();
	    });
	
	    network.on('network_continue', function () {
	        core.play();
	        network.hide();
	    });
	
	    network.on('network_toggle', function () {
	        control.toggle();
	    });
	
	    error.on('error_toggle', function () {
	        control.toggle();
	    });
	};
	
	Video.prototype.afterAdPause = function () {
	    this.playButton.trigger('click');
	};
	
	Video.prototype.play = function () {
	    this.core.play();
	};
	
	Video.prototype.load = function () {
	    this.core.load();
	};
	
	Video.prototype.pause = function () {
	    this.core.pause();
	};
	
	Video.prototype.stop = function () {
	    this.core.pause();
	    this.control.setTime(0);
	};
	
	Video.prototype.next = function (src) {
	    this.core.src(src);
	    this.control.reset();
	    this.playButton.changeState('pause');
	};
	
	Video.prototype.getCurrentTime = function () {
	    return this.currentTime;
	};
	
	Video.prototype.destory = function () {
	    this.off();
	    this.title.destory();
	    this.control.destory();
	    this.poster.destory();
	    this.playButton.destory();
	    this.error.destory();
	    core.destory();
	};
	
	Video.prototype.hide = function () {
	    if (!this.isHide) {
	        $(this.el).hide();
	        this.isHide = true;
	    }
	};
	
	Video.prototype.show = function () {
	    if (this.isHide) {
	        $(this.el).show();
	        this.isHide = false;
	    }
	};
	
	Video.prototype.spread = function () {
	    this.isSpread = true;
	    this.play();
	};
	
	Video.prototype.fold = function () {
	    this.isSpread = false;
	    // this.pause();
	};
	
	Events.mixTo(Video);
	module.exports = Video;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(490);
	var tmpl = __webpack_require__(496);
	var Events = __webpack_require__(104);
	var util = __webpack_require__(404);
	
	var formatTime = function formatTime(time) {
	    if (isNaN(time)) {
	        return '00:00:00';
	    }
	    var second = 0;
	    var mintue = 0;
	    var hour = 0;
	    second = Math.floor(time % 60);
	    if (time >= 60) {
	        mintue = Math.floor(time / 60);
	    }
	    if (mintue >= 60) {
	        mintue = Math.floor(mintue % 60);
	        hour = Math.floor(time / 3600);
	    }
	    hour = hour < 10 ? '0' + hour : hour;
	    second = second < 10 ? '0' + second : second;
	    mintue = mintue < 10 ? '0' + mintue : mintue;
	    return hour + ':' + mintue + ':' + second;
	};
	
	var Control = function Control(options, isList) {
	    this.isList = isList;
	    this.options = options;
	    this.isHide = false;
	    this.init();
	    this.hideTimer = null;
	};
	
	Control.prototype.init = function () {
	    this.initDom();
	    this.initEvent();
	    this.initZoomState();
	};
	
	Control.prototype.initDom = function () {
	    var div = document.createElement('div');
	    if (this.isList) {
	        // 如果是图文直播列表里的视频
	        this.isLive = false;
	    } else {
	        var nowTime = new Date().valueOf();
	        if (this.options.start_date > nowTime) {
	            // 直播未开始
	            this.isLive = '0';
	        } else if (nowTime > this.options.end_date) {
	            this.isLive = '2'; // 点播
	        } else {
	            this.isLive = '1';
	        }
	    }
	
	    div.innerHTML = tmpl({ isLive: this.isLive });
	    this.el = div.children[0];
	    this.elPlayBtn = this.el.querySelector('.c-video-control__button');
	    this.elTimeBar = this.el.querySelector('.c-video-control__timebar');
	    this.elTimeBarProgress = this.el.querySelector('.c-video-control__timebar span');
	    this.elTimeHandle = this.el.querySelector('.c-video-control__timebar em');
	    this.elTimeVal = this.el.querySelector('.c-video-control__time');
	    this.elZoom = this.el.querySelector('.c-video-control__zoom');
	};
	
	Control.prototype.initEvent = function () {
	    var startSwipTime = void 0;
	    var calTime = function (begin, current) {
	        return startSwipTime + (current - begin) / this.timeBarWidth;
	    }.bind(this);
	
	    util.tap(this.elPlayBtn, function () {
	        this.trigger('play');
	        return false;
	    }, {
	        scope: this
	    });
	
	    // util.swip(this.el, function () {
	    //   clearTimeout(this.hideTimer);
	    // }, function () {
	
	    // }, function () {
	    //   this.hideTimer = setTimeout(function () {
	    //     this.hide();
	    //   }.bind(this), 3000);
	    // }, {
	    //   scope: this
	    // });
	
	    util.controllSwip(this.el, function () {}, function () {}, function () {}, {});
	
	    util.controllSwip(this.elTimeBar, function () {
	        clearTimeout(this.hideTimer);
	        startSwipTime = this.timeValue;
	    }, function (begin, current, direct) {
	        this.setTime(calTime(begin, current), true);
	    }, function (begin, current, direct) {
	        this.setTime(calTime(begin, current), true);
	        this.hideTimer = setTimeout(function () {
	            this.hide();
	        }.bind(this), 3000);
	        return false;
	    }, {
	        scope: this,
	        direct: 'horizontal'
	    });
	
	    util.tap(this.elTimeBar, function (e, elm, x, y) {
	        var begin = this.elTimeHandle.getBoundingClientRect().left + this.elTimeHandle.offsetWidth / 2;
	        this.setTime(calTime(begin, x), true);
	        return false;
	    }.bind(this));
	
	    util.on(window, 'orientationchange', function () {
	        this.initZoomState();
	        this.resize();
	        return false;
	    }, {
	        scope: this
	    });
	
	    util.tap(this.elZoom, function () {
	        var dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
	        if (Math.abs(dge) == 90) {
	            this.trigger('zoom', 'zoomin');
	        } else {
	            this.trigger('zoom', 'zoomout');
	        }
	    }, {
	        scope: this
	    });
	};
	
	Control.prototype.initZoomState = function () {
	    var dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
	    if (Math.abs(dge) == 90) {
	        $(this.elZoom).removeClass('c-video-control__zoom--zoomin').addClass('c-video-control__zoom--zoomout');
	    } else {
	        $(this.elZoom).removeClass('c-video-control__zoom--zoomout').addClass('c-video-control__zoom--zoomin');
	    }
	};
	
	Control.prototype.setTime = function (val, willTrigger) {
	    val = val < 0 ? 0 : val > 1 ? 1 : val;
	
	    this.timeBarWidth = this.elTimeBar.offsetWidth - this.elTimeHandle.offsetWidth;
	    // this.elTimeHandle.style.marginLeft = this.timeBarWidth * val + 'px';
	    $(this.elTimeHandle).css({
	        transform: 'translateX(' + this.timeBarWidth * val + 'px)',
	        webkitTransform: 'translateX(' + this.timeBarWidth * val + 'px)'
	    });
	    $(this.elTimeBarProgress).css({
	        transform: 'scaleX(' + val + ')',
	        webkitTransform: 'scaleX(' + val + ')'
	    });
	    // this.elTimeBarProgress.style.width = val * 100 + '%';
	    this.timeValue = val;
	
	    if (willTrigger) {
	        this.trigger('time', val);
	    }
	};
	
	Control.prototype.setTimeVal = function (timeString) {
	    this.elTimeVal.innerHTML = '- ' + formatTime(timeString);
	};
	
	Control.prototype.renderTo = function (parentNode) {
	    parentNode.appendChild(this.el);
	    this.timeBarWidth = this.elTimeBar.offsetWidth - this.elTimeHandle.offsetWidth;
	    this.setTime(0, true);
	};
	
	Control.prototype.show = function () {
	    $(this.el).stop().animate({
	        bottom: '0px'
	    });
	    // this.el.style.visibility = 'visible';
	    this.trigger('show');
	    this.isHide = false;
	    clearTimeout(this.hideTimer);
	    this.hideTimer = setTimeout(function () {
	        this.hide();
	    }.bind(this), 3000);
	};
	
	Control.prototype.hide = function () {
	    $(this.el).stop().animate({
	        bottom: '-200px'
	    });
	    // this.el.style.visibility = 'hidden';
	    this.isHide = true;
	    this.trigger('hide');
	};
	
	Control.prototype.toggle = function () {
	    if (this.isHide == true) {
	        this.show();
	    } else {
	        this.hide();
	    }
	};
	
	Control.prototype.changePlayState = function (type) {
	    var types = {
	        play: 'c-video-control__button--pause',
	        pause: 'c-video-control__button--play'
	    };
	    this.elPlayBtn.className = 'c-video-control__button ' + types[type];
	};
	
	Control.prototype.reset = function () {
	    this.elTimeVal.innerHTML = '--';
	    this.setTime(0);
	    this.changePlayState('pause');
	};
	
	Control.prototype.resize = function () {
	    this.timeBarWidth = this.elTimeBar.offsetWidth - this.elTimeHandle.offsetWidth;
	    this.setTime(this.timeValue);
	};
	
	Control.prototype.destory = function () {
	    this.off();
	    this.el.removeEventListener('click', clickFn);
	    this.el.parentNode.removeChild(this.el);
	};
	
	Events.mixTo(Control);
	
	module.exports = Control;

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-video-control\" style=\"bottom: -200px\">\n    <div class=\"c-video-control__button c-video-control__button--play\"></div>\n    ")
	    ; if(isLive) {
	    ; __append("\n    <div class=\"c-video-control__desc\">\n        ")
	    ;  if(isLive === '0'){ 
	    ; __append(" 预告 ")
	    ;  }else if(isLive === '1'){ 
	    ; __append(" 正在直播\n        ")
	    ;  }else{ 
	    ; __append(" 回顾 ")
	    ;  } 
	    ; __append("\n    </div>\n    ")
	    ;  } 
	    ; __append("\n    <div class=\"c-video-control__timebar\">\n        <div>\n            <span></span> <em><i></i></em>\n        </div>\n    </div>\n    <div class=\"c-video-control__time\">--</div>\n    <div class=\"c-video-control__zoom c-video-control__zoom--zoomin\"></div>\n</div>\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(498);
	var Core = __webpack_require__(436);
	var Poster = __webpack_require__(439);
	var PlayButton = __webpack_require__(443);
	var Control = __webpack_require__(489);
	// var Title = require('../modules/title/');
	var ErrorBox = __webpack_require__(462);
	var statistics = __webpack_require__(469);
	
	var Events = __webpack_require__(104);
	
	var mp4Url = '//dyn.v.ifeng.com/cmpp/video_msg_ipad.js';
	var ugcMp4Url = '//api.cmpp.v.ifeng.com/index.php/live/video';
	
	var getVideoInfo = function getVideoInfo(options) {
	    var url = options.from && options.from == 'ugc' ? ugcMp4Url : mp4Url;
	    var msg = options.from && options.from == 'ugc' ? options.uid + '@' + options.liveVideoId : options.liveVideoId;
	
	    return $.ajax({
	        url: url,
	        dataType: 'jsonp',
	        data: {
	            msg: msg,
	            rt: 'js',
	            param: 'playermsg'
	        }
	    });
	};
	
	var Video = function Video(options) {
	    this.options = options;
	    this.init();
	    this.currentTime = 0;
	};
	
	Video.prototype.init = function () {
	    this.initParams();
	    this.initLayout();
	    this.initCompontent();
	    this.initEvent();
	};
	
	Video.prototype.initParams = function () {};
	
	Video.prototype.initLayout = function () {
	    this.el = document.createElement('div');
	    this.el.classList.add('c-video--plist');
	};
	
	Video.prototype.initCompontent = function () {
	    var self = this;
	    var videoOption = this.options;
	    this.playermsg = getVideoInfo(videoOption);
	
	    this.core = new Core({
	        src: videoOption.video_url,
	        poster: videoOption.video_image,
	        inline: true,
	        autoplay: this.options.autoplay
	    });
	
	    pageVideoList.push(this.core);
	
	    this.poster = new Poster(videoOption.video_image);
	    // this.title = new Title(this.options.title, this.options.channelName, this.options.channelIcon);
	
	    this.playButton = new PlayButton();
	    this.playButton.changeState('pause');
	    this.control = new Control(this.options, true); // true表示为图文直播列表里用的control
	    this.error = new ErrorBox(this.options.errorTitle);
	
	    this.core.renderTo(this.el);
	
	    this.poster.renderTo(this.el);
	
	    this.playButton.renderTo(this.el);
	    this.control.renderTo(this.el);
	    // this.title.renderTo(this.el);
	    this.error.renderTo(this.el);
	};
	
	Video.prototype.renderTo = function (parentNode) {
	    parentNode.appendChild(this.el);
	};
	
	/**
	 * 自定义事件列表
	 * begin 每个视频开始播放时 一般用来发cv统计
	 * ended 视频播放结束时
	 * pause 视频暂停
	 * play 视频播放
	 * init 初始化视频 主要用于发vv统计
	 */
	Video.prototype.initEvent = function () {
	    var core = this.core;
	    var control = this.control;
	    var playButton = this.playButton;
	    var poster = this.poster;
	    // var title = this.title;
	    var error = this.error;
	    var self = this;
	
	    core.on('begin', function () {
	        console.log('=======begin');
	        self.playermsg.then(function (msg) {
	            statistics(msg, 'cv');
	        });
	        self.control.show();
	        self.trigger('begin');
	    });
	
	    core.on('loadedmetadata', function () {
	        self.playermsg.then(function (msg) {
	            statistics(msg, 'vv');
	        });
	        self.trigger('init');
	    });
	
	    // 视频播放
	    core.on('play', function () {
	        console.log('-------play====');
	        // let current = Core.current();
	        self.trigger('listVideoPlay');
	        // if (current && core !== current) {
	        //     current.pause();
	        // }
	        for (var i = 0; i < pageVideoList.length; i++) {
	            var otherCore = pageVideoList[i];
	            if (otherCore !== core) {
	                otherCore.pause();
	            }
	        }
	        playButton.changeState('play');
	        control.changePlayState('play');
	
	        poster.hide();
	
	        error.hide();
	    });
	
	    // 视频暂停
	    core.on('pause', function () {
	        playButton.changeState('pause');
	        control.changePlayState('pause');
	        self.trigger('pause');
	    });
	
	    // 视频播放完成
	    core.on('ended', function () {
	        playButton.changeState('replay');
	        self.trigger('ended');
	    });
	    // 视频重置
	
	    // core.on('reset', function () {
	    //     playButton.changeState('pause');
	    //     control.changePlayState('pause');
	    // });
	
	    // 视频播放更新
	    core.on('timeupdate', function () {
	        var duration = core.getDuration();
	        var currentTime = core.getCurrentTime();
	        control.setTime(currentTime / duration, false);
	        control.setTimeVal(Math.floor(duration - currentTime));
	        self.trigger('timeupdate', core.getCurrentTime());
	        self.currentTime = currentTime;
	    });
	
	    // title.on('exit', function () {
	    //   self.trigger('exit');
	    //   console.log('exit');
	    // });
	
	    // 点击播放器前面的控制蒙层
	    playButton.on('click', function (e) {
	        if (!window.adVideoIsEnd) {
	            return;
	        }
	
	        if (core.getEnded() || core.getPaused()) {
	            core.play();
	        } else {
	            control.toggle();
	        }
	    });
	
	    // 控制条时间轴变化
	    control.on('time', function (val) {
	        var duration = core.getDuration();
	        if (duration) {
	            core.setCurrentTime(duration * val);
	        }
	    });
	
	    // 控制条点击播放按钮
	    control.on('play', function () {
	        if (core.getPaused()) {
	            core.play();
	        } else {
	            core.pause();
	        }
	    });
	
	    control.on('zoom', function (state) {
	        self.trigger('zoom', state);
	    });
	
	    // 控制条隐藏的同时，隐藏标题
	    control.on('show', function () {
	        // title.show();
	
	        self.trigger('controlShow');
	    });
	
	    // 控制条显示的同时，显示标题
	    control.on('hide', function () {
	        // title.hide();
	
	        self.trigger('controlHide');
	    });
	};
	
	Video.prototype.play = function () {
	    this.core.play();
	};
	
	Video.prototype.pause = function () {
	    this.core.pause();
	};
	
	Video.prototype.stop = function () {
	    this.core.pause();
	    this.control.setTime(0);
	};
	
	Video.prototype.next = function (src) {
	    this.core.src(src);
	    this.control.reset();
	    this.playButton.changeState('pause');
	};
	
	Video.prototype.getCurrentTime = function () {
	    return this.currentTime;
	};
	
	Video.prototype.destory = function () {
	    this.off();
	    this.control.destory();
	    this.poster.destory();
	    this.playButton.destory();
	    this.error.destory();
	    core.destory();
	};
	
	Events.mixTo(Video);
	module.exports = Video;

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */,
/* 500 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-livepage\">\n    <div class=\"mod-newsList-box\">\n        <div class=\"js_timelineTop\"></div>\n        <div class=\"js_timelineContainer\"></div>\n        <div class=\"mod-showMoreBtn\">\n            <span class=\"mod-loading\"></span>\n        </div>\n    </div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(502);
	var tmpl = __webpack_require__(506);
	var util = __webpack_require__(404);
	
	var Events = __webpack_require__(104);
	
	var Tab = function Tab() {
	    this.tabs = [];
	    this.index = 0;
	    this.init();
	};
	
	Tab.prototype.init = function () {
	    this.initDom();
	    this.initEvent();
	};
	
	Tab.prototype.initDom = function () {
	    var div = document.createElement('div');
	    div.innerHTML = tmpl({});
	    this.elHead = div.children[0];
	    this.elBody = div.children[1];
	    this.elSlider = this.elBody.querySelector('.c-slider');
	    this.elToggle = this.elHead.querySelector('.top');
	};
	
	Tab.prototype.initEvent = function () {
	    var self = this;
	    util.tap(this.elHead, function (e) {
	        var target = e.target;
	        if (target.classList.contains('.c-nav__title--active')) {
	            return;
	        }
	        var index = target.dataset.index;
	        this.active(index);
	    }, {
	        scope: this,
	        delegate: '.c-nav__title'
	    });
	
	    $(this.elToggle).on('touchend', function () {
	        if (this.classList.contains('spread')) {
	            self.fold();
	        } else {
	            self.spread();
	        }
	        return false;
	    });
	
	    this.on('shrink', function (direction) {
	        if (direction === 'down') {
	            self.fold();
	        } else if (direction === 'up') {
	            self.spread();
	        }
	    });
	};
	
	Tab.prototype.add = function (title, compontent, type, callback) {
	    callback = callback || function () {};
	    var index = this.tabs.length;
	    this.tabs.push({ compontent: compontent, callback: callback, type: type });
	
	    var tab = document.createElement('div');
	    tab.classList.add('c-nav__title');
	    if (this.tabs.length === 1) {
	        tab.classList.add('c-nav__title--active');
	    }
	    tab.innerHTML = title;
	    tab.dataset.index = index;
	    tab.dataset.type = type;
	    this.elHead.appendChild(tab);
	
	    var item = document.createElement('div');
	    item.classList.add('c-slider__item');
	    if (this.tabs.length === 1) {
	        item.classList.add('c-slider__item--active');
	    }
	    if (compontent) {
	        compontent.renderTo(item);
	    }
	    item.dataset.index = index;
	    item.dataset.type = type;
	    item.id = 'slider_' + type;
	    this.elSlider.appendChild(item);
	};
	
	Tab.prototype.active = function (index) {
	    var activeHead = this.elHead.querySelector('.c-nav__title--active');
	    if (activeHead) {
	        activeHead.classList.remove('c-nav__title--active');
	    }
	    this.elHead.querySelectorAll('.c-nav__title')[index].classList.add('c-nav__title--active');
	    var activeItem = this.elBody.querySelector('.c-slider__item--active');
	    if (activeItem) {
	        activeItem.classList.remove('c-slider__item--active');
	    }
	    this.elBody.querySelectorAll('.c-slider__item')[index].classList.add('c-slider__item--active');
	    this.elHead.querySelectorAll('.c-nav__title')[index].classList.remove('c-nav__title_notice');
	    var type = this.elBody.querySelectorAll('.c-slider__item')[index].dataset.type;
	    this.trigger('change', type);
	    // this.tabs[index].callback(this.tabs[index].compontent);
	};
	
	Tab.prototype.notice = function (type) {
	    console.log(type);
	    var elm = this.elHead.querySelector('[data-type="' + type + '"]');
	    console.log(elm);
	    if (!elm.classList.contains('c-nav__title--active')) {
	        elm.classList.add('c-nav__title_notice');
	    }
	};
	
	Tab.prototype.foldShow = function () {
	    this.elToggle.style.display = 'none';
	};
	
	Tab.prototype.foldHide = function () {
	    this.elToggle.style.display = 'block';
	};
	
	Tab.prototype.fold = function () {
	    this.elToggle.classList.add('fold');
	    this.elToggle.classList.remove('spread');
	    this.trigger('fold');
	};
	
	Tab.prototype.spread = function () {
	    this.elToggle.classList.add('spread');
	    this.elToggle.classList.remove('fold');
	    this.trigger('spread');
	};
	
	Tab.prototype.renderTo = function (parentNode) {
	    parentNode.appendChild(this.elHead);
	    parentNode.appendChild(this.elBody);
	};
	
	Events.mixTo(Tab);
	
	module.exports = Tab;

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<nav class=\"c-nav__header\">\n  <div class=\"top  spread fr\"></div>\n</nav>\n<section class=\"c-nav__body\">\n  <div class=\"c-slider\">\n  </div>\n</section>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(508);
	
	var _onlypic = __webpack_require__(513);
	
	var _onlypic2 = _interopRequireDefault(_onlypic);
	
	var _fCore = __webpack_require__(104);
	
	var _fCore2 = _interopRequireDefault(_fCore);
	
	var _fCoreMobile = __webpack_require__(404);
	
	var _fCoreMobile2 = _interopRequireDefault(_fCoreMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by dreamc_t on 2017/4/17.
	 */
	
	var OnlyPic = function () {
	    function OnlyPic(options, message, native) {
	        (0, _classCallCheck3.default)(this, OnlyPic);
	
	        this.options = options;
	        this.message = message;
	        this.native = native;
	        this.initDom();
	        this.initEvent();
	    }
	
	    (0, _createClass3.default)(OnlyPic, [{
	        key: 'initDom',
	        value: function initDom() {
	            var nowTime = new Date().valueOf();
	            if (this.options.start_date > nowTime) {
	                // 直播未开始
	                this.isLive = '0';
	            } else if (nowTime > this.options.end_date) {
	                this.isLive = '2'; // 点播
	            } else {
	                this.isLive = '1';
	            }
	            this.el = $((0, _onlypic2.default)({ options: this.options, isLive: this.isLive, showOnlineNum: window.showOnlineNum || false }));
	        }
	    }, {
	        key: 'initEvent',
	        value: function initEvent() {
	            var self = this;
	            this.message.on('online:info', '201', this.changeCount.bind(this));
	
	            this.goBack = this.el[0].querySelector('.linkbox');
	
	            _fCoreMobile2.default.tap(this.goBack, function () {
	                if (self.native.isApp) {
	                    self.native.close();
	                } else {
	                    window.open('//izhibo.ifeng.com/home.html');
	                }
	            });
	        }
	    }, {
	        key: 'changeCount',
	        value: function changeCount(msg) {
	            if (msg.code == 1) {
	                console.log(this.el.find('.number'));
	                this.el.find('.number').text(formatCount(msg.number));
	            }
	        }
	    }, {
	        key: 'renderTo',
	        value: function renderTo(parentNode) {
	            parentNode.appendChild(this.el[0]);
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            if (this.isShow) {
	                $(this.el).show();
	                this.isShow = false;
	            }
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            if (!this.isShow) {
	                $(this.el).hide();
	                this.isShow = true;
	            }
	        }
	    }]);
	    return OnlyPic;
	}();
	
	var formatCount = function formatCount(val) {
	    if (val < 10000) {
	        return val;
	    } else {
	        return (val / 10000).toFixed(1) + '万';
	    }
	};
	
	_fCore2.default.mixTo(OnlyPic);
	
	exports.default = OnlyPic;

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-pic\">\n    <div class=\"linkbox\">\n        <span class=\"link\"></span>\n    </div>\n\n    <div class=\"infobox\">\n\n        <p class=\"title\">\n            <span class=\"column\">  ")
	    ; __append(escape(options.channelName))
	    ; __append("</span> | <span class=\"name\">")
	    ; __append(escape(options.title))
	    ; __append("</span>\n        </p>\n        <p class=\"info\">\n            <span class=\"state-flag\"></span>\n            ")
	    ;  if(isLive == '0'){ 
	    ; __append("\n\n            <span class=\"status prefield\"> <span class=\"pcolor\"></span>预告</span>\n            ")
	    ;  }else if(isLive == '1'){ 
	    ; __append("\n\n            <span class=\"status active\"> <span class=\"acolor\"></span>直播中</span>\n            ")
	    ;  }else{ 
	    ; __append("\n            <span class=\"ecolor\"></span>\n            <span class=\"status end\"> <span class=\"acolor\"></span>回放</span>\n            ")
	    ;  } 
	    ; __append("\n\n            ")
	    ;  if (showOnlineNum) { 
	    ; __append("\n                <span class=\"count\"><em class=\"number\">0</em>人参与</span>\n            ")
	    ;  } 
	    ; __append("\n        </p>\n    </div>\n</div>\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(515);
	
	var _noVideo = __webpack_require__(520);
	
	var _noVideo2 = _interopRequireDefault(_noVideo);
	
	var _fCore = __webpack_require__(104);
	
	var _fCore2 = _interopRequireDefault(_fCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoVideo = function () {
	    function NoVideo(options, isLive, native) {
	        (0, _classCallCheck3.default)(this, NoVideo);
	
	        this.options = options;
	        this.isLive = isLive;
	        this.native = native;
	        // this.message = message;
	        this.initDom();
	        this.initEvent();
	    }
	
	    (0, _createClass3.default)(NoVideo, [{
	        key: 'initDom',
	        value: function initDom() {
	            var nowTime = new Date().valueOf();
	            if (this.options.start_date > nowTime) {
	                //直播未开始
	                this.isLive = '0';
	            } else if (nowTime > this.options.end_date) {
	                this.isLive = '2'; //点播
	            } else {
	                this.isLive = '1';
	            }
	
	            this.el = $((0, _noVideo2.default)({ options: this.options, isLive: this.isLive }));
	        }
	    }, {
	        key: 'initEvent',
	        value: function initEvent() {
	            var self = this;
	            this.goBack = this.el[0].querySelector('.linkbox');
	
	            this.goBack.addEventListener('touchend', function () {
	                if (self.native.isApp) {
	                    self.native.close();
	                } else {
	                    window.open('//izhibo.ifeng.com/home.html');
	                }
	            });
	            // this.message.on('online:info', '201', this.changeCount.bind(this));
	        }
	        //
	        // changeCount (msg) {
	        //     if (msg.code == 1) {
	        //         console.log(this.el.find('.number'));
	        //         this.el.find('.number').text(formatCount(msg.number));
	        //     }
	        // }
	
	    }, {
	        key: 'renderTo',
	        value: function renderTo(parentNode) {
	
	            parentNode.appendChild(this.el[0]);
	        }
	
	        // show () {
	        //     if(this.isShow) {
	        //         $(this.el).show();
	        //         this.isShow = false;
	        //     }
	        // }
	        //
	        // hide () {
	        //     if(!this.isShow) {
	        //         $(this.el).hide();
	        //         this.isShow = true;
	        //     }
	        // }
	
	    }]);
	    return NoVideo;
	}();
	
	// let formatCount = function (val) {
	//     if (val < 10000) {
	//         return val;
	//     } else {
	//         return (val / 10000).toFixed(1);
	//     }
	// };
	
	/**
	 * Created by dreamc_t on 2017/4/24.
	 */
	/**
	 * Created by dreamc_t on 2017/4/17.
	 */
	
	_fCore2.default.mixTo(NoVideo);
	
	exports.default = NoVideo;

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-noVideo\">\n    <div class=\"linkbox\"><div  class=\"link\"></div></div>\n    <div class=\"poster\" style=\"position: relative;background-image: url(")
	    ; __append(escape(options.poster))
	    ; __append(");\">\n\n    </div>\n    <div class=\"info\">\n        <p class=\"title\">")
	    ; __append(escape(options.title))
	    ; __append("</p>\n        <div class=\"state\">\n            ")
	    ;  if(isLive == '0'){ 
	    ; __append("\n            <span class=\"status prefield\">预告</span>\n            ")
	    ;  }else if(isLive == '1'){ 
	    ; __append("\n            <span class=\"status active\">直播中</span>\n            ")
	    ;  }else{ 
	    ; __append("\n            <span class=\"status end\">回放</span>\n            ")
	    ;  } 
	    ; __append("\n        </div>\n    </div>\n\n</div>\n\n\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(522);
	
	var _notice = __webpack_require__(525);
	
	var _notice2 = _interopRequireDefault(_notice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by dreamc_t on 2017/5/2.
	 */
	var Notice = function () {
	    function Notice(info, native, liveid) {
	        (0, _classCallCheck3.default)(this, Notice);
	
	        this.info = info;
	        this.liveid = liveid;
	        this.native = native;
	        this.init();
	    }
	
	    (0, _createClass3.default)(Notice, [{
	        key: 'init',
	        value: function init() {
	            var time = this.info.start_date;
	            this.remainTime = Math.floor((new Date(time).valueOf() - new Date().valueOf()) / 1000);
	            console.log(this.remainTime);
	            if (this.remainTime <= 0) {
	                return;
	            }
	        }
	    }, {
	        key: 'checkAppoint',
	        value: function checkAppoint() {
	            var self = this;
	            return new _promise2.default(function (resolve) {
	                if (self.native.isApp) {
	                    return self.native.isTiming(self.liveid).then(function (ids) {
	                        console.log('ids====' + ids);
	                        if (ids.length == 0) {
	                            //开启提醒标识
	                            var el = self.showAppoint();
	                            resolve(el);
	                        } else {
	                            //取消提醒标识
	                            var _el = self.hideAppoint();
	                            resolve(_el);
	                        }
	                    });
	                }
	            });
	        }
	
	        //开启提醒
	
	    }, {
	        key: 'showAppoint',
	        value: function showAppoint() {
	            var el = (0, _notice2.default)({
	                hasApp: true,
	                starttime: formatDate(this.info.start_date)
	            });
	
	            return el;
	        }
	
	        //取消提醒
	
	    }, {
	        key: 'hideAppoint',
	        value: function hideAppoint() {
	            var el = (0, _notice2.default)({
	                hasApp: false,
	                starttime: formatDate(this.info.start_date)
	            });
	
	            return el;
	        }
	    }, {
	        key: 'initEvent',
	        value: function initEvent() {
	            var self = this;
	            var timeStamp = this.info.start_date;
	            var type = this.info.from == 'h5' ? 'h5_live' : 'text_live';
	
	            this.appEle = this.el.querySelector('.appbtn');
	
	            this.appEle.addEventListener('touchend', function () {
	                if (this.classList.contains('showApp')) {
	                    console.log('1111');
	                    this.classList.remove('showApp');
	                    this.classList.add('hideApp');
	                    this.querySelector('.text').textContent = '取消提醒';
	                    self.native.setAlarmClock(self.info.liveid, timeStamp, self.info.title, type);
	                    if (self.info.hasPage) {
	                        //有图文直播
	                        self.native.actionStat({ type: "lorder", id: "piclive_" + self.info.liveid }); //发送统计
	                    } else {
	                        self.native.actionStat({ type: "lorder", id: "vlive_" + self.info.liveid }); //发送统计
	                    }
	                } else {
	                    this.classList.remove('hideApp');
	                    this.classList.add('showApp');
	                    this.querySelector('.text').textContent = '开启提醒';
	                    self.native.cancelAlarmClock(self.info.liveid);
	                    if (self.info.hasPage) {
	                        //有图文直播
	                        self.native.actionStat({ type: "lunorder", id: "piclive_" + self.info.liveid }); //发送统计
	                    } else {
	                        self.native.actionStat({ type: "lunorder", id: "vlive_" + self.info.liveid }); //发送统计
	                    }
	
	                    console.log('22222');
	                }
	            });
	
	            //时间到后自动隐藏当前dom
	            var hideDom = setTimeout(function () {
	                $(self.el).hide();
	                clearTimeout(hideDom);
	            }, this.remainTime * 1000);
	        }
	    }, {
	        key: 'renderTo',
	        value: function renderTo(parentNode) {
	            var self = this;
	            this.checkAppoint().then(function (el) {
	
	                parentNode.appendChild($(el)[0]);
	                self.el = parentNode;
	                self.initEvent();
	            });
	        }
	    }]);
	    return Notice;
	}();
	
	var formatDate = function formatDate(datestr) {
	
	    var date = new Date(datestr);
	    var month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
	    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	    var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
	    var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
	
	    return month + '月' + day + '日' + hour + ':' + min;
	};
	
	exports.default = Notice;

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */,
/* 524 */,
/* 525 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-prefield\">\n    <div class=\"c-appointment\">\n        <div class=\"starttext\">\n            本场直播将于")
	    ; __append(escape(starttime))
	    ; __append("开始\n            <div class=\"appointment\">\n                ")
	    ;  if (hasApp) { 
	    ; __append("\n                <div class=\"appbtn showApp\">\n                    <span class=\"text\">开启提醒</span>\n                </div>\n                ")
	    ;  }else{ 
	    ; __append("\n                <div class=\"appbtn hideApp\">\n                    <span class=\"text\">关闭提醒</span>\n                </div>\n                ")
	    ;  } 
	    ; __append("\n            </div>\n        </div>\n    </div>\n    <div class=\"split\"></div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var advideo = __webpack_require__(527);
	
	module.exports = advideo;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _AdCore = __webpack_require__(528);
	
	var _AdCore2 = _interopRequireDefault(_AdCore);
	
	var _AdPause = __webpack_require__(535);
	
	var _AdPause2 = _interopRequireDefault(_AdPause);
	
	var _AdCorner = __webpack_require__(540);
	
	var _AdCorner2 = _interopRequireDefault(_AdCorner);
	
	var _fCore = __webpack_require__(104);
	
	var _fCore2 = _interopRequireDefault(_fCore);
	
	var _fCoreMobile = __webpack_require__(404);
	
	var _fCoreMobile2 = _interopRequireDefault(_fCoreMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdVideo = function () {
	    function AdVideo(obj) {
	        (0, _classCallCheck3.default)(this, AdVideo);
	
	        // this.opt = opt;
	        this.init(obj);
	        this.pauseflag = false; //是否暂停显示过
	        this.cornerflag = false; //是否角标显示过
	        // this.hideCornerCount = 15; // 隐藏角标倒计时
	        this.cornerTime_hide = 0;
	
	        this.cornerShowFlag = false;
	    }
	
	    (0, _createClass3.default)(AdVideo, [{
	        key: 'init',
	        value: function init(obj) {
	            //格式化数据初始化
	            this.AdCallback = {
	                video_adPositionId: '',
	                video_Url: [], // 前贴片mp4数组
	                video_Time: [], // 前贴片mp4时长数组
	                video_adId: [], // 前贴片adId数组
	                totol_Time: 0, // 前贴片总时长
	                video_Link: [], // 前贴片跳转数组
	                video_Count: [], // 前贴片统计数组
	                corner_adPositionId: '',
	                corner_Url: '', // 角标图片地址
	                corner_Link: '', // 角标跳转地址
	                corner_Count: [], // 角标统计数组
	                corner_AdId: [], // 角标adId
	                corner_HideCount: 15, // 角标隐藏倒计时
	                pause_adPositionId: '',
	                pause_Url: '', // 暂停图片地址
	                pause_Link: '', // 暂停跳转地址
	                pause_Count: [], // 暂停统计数组
	                pause_AdId: [], // 暂停adId
	                test: [] // 测试用
	            };
	            // debugger;
	            console.log(obj); //原始数据
	
	            this.formatData(obj);
	            // debugger
	            console.log(this.AdCallback); //格式化数据
	
	            var _this = this;
	
	            // if (this.AdCallback.video_Url.length > 0 && this.AdCallback.video_Url[0] != 'undefined') {
	            var dui = {
	                data: this.AdCallback,
	                obj: obj
	            };
	            this.can = 'yes';
	            this.initParams(dui);
	            this.initLayout();
	            this.initComponent();
	            this.initEvent();
	            // } else {
	            //     setTimeout(function () {
	            //         // debugger
	            //         _this.can = 'no';
	            //         _this.trigger('ended', 'no');
	            //         console.log('trigger=============>', Date.now())
	            //     }, 10)
	
	            // }
	            console.log(this.can);
	        }
	    }, {
	        key: 'initParams',
	        value: function initParams(obj) {
	            this.RequestAd = _promise2.default.resolve(obj);
	        }
	    }, {
	        key: 'initLayout',
	        value: function initLayout() {
	            this.el = document.querySelector('.l-video'); //广告外部容器
	        }
	    }, {
	        key: 'initComponent',
	        value: function initComponent() {
	            var _this2 = this;
	
	            this.start_play = false; //默认广告未开始播放
	
	            this.cross3 = false; //默认广告播放不超过3秒
	
	            this.AdCore = this.RequestAd.then(function (call) {
	                if (!call.data.video_adPositionId) {
	                    return null;
	                }
	                return new _AdCore2.default({ data: call.data, obj: call.obj });
	            });
	
	            this.AdPause = this.RequestAd.then(function (call) {
	                if (!call.data.pause_adPositionId) {
	                    return null;
	                }
	                return new _AdPause2.default({ data: call.data, obj: call.obj });
	            });
	
	            this.AdCorner = this.RequestAd.then(function (call) {
	                if (!call.data.corner_adPositionId) {
	                    return null;
	                }
	                return new _AdCorner2.default({ data: call.data, obj: call.obj });
	            });
	
	            this.AdCore.then(function (AdCore) {
	                if (AdCore) {
	                    AdCore.renderTo(_this2.el);
	                }
	            }).catch(function (err) {
	                console.log(err);
	            });
	
	            this.AdPause.then(function (AdPause) {
	                if (AdPause) {
	                    if (AdPause.type == 'off') {
	                        return false;
	                    }
	                    AdPause.renderTo(_this2.el);
	                    AdPause.hide();
	                }
	            }).catch(function (err) {
	                console.log(err);
	            });
	
	            this.AdCorner.then(function (AdCorner) {
	                if (AdCorner) {
	                    debugger;
	                    if (AdCorner.type == 'off') {
	                        return false;
	                    }
	                    AdCorner.renderTo(_this2.el);
	                    // AdCorner.hide();
	                }
	            }).catch(function (err) {
	                console.log(err);
	            });
	        }
	    }, {
	        key: 'initEvent',
	        value: function initEvent() {
	            var _this3 = this;
	
	            var AdCore = this.AdCore; // 广告核心
	            var AdPause = this.AdPause; // 广告暂停
	            var AdCorner = this.AdCorner; // 广告角标
	
	            this.playIndex = 0; //应该播放的index  还有就是可以拿到的AdCore.dom
	            var playflag = false; //是否播放过
	            var _this = this;
	            //超时定时器 大于5秒就gg
	            this.time_ad = 0;
	
	            // 1,倒计时 2,查看详情 3,静音 4,广告联播 结束时抛出ended
	            AdCore.then(function (AdCore) {
	                if (!AdCore) return;
	                _this.setTimer();
	                var arrVideo = AdCore.video;
	                var adUrl = _this3.AdCallback.video_Url; // 广告地址数组
	                var lastTime = _this3.AdCallback.totol_Time; // 广告总时长
	
	                // 如果第一个video能播了 原生还不好使 就用的jquery
	                $(AdCore.video[0]).on('canplay', function () {
	                    if (playflag == false) {
	                        _this3.trigger('begin'); //1抛出begin
	                        // this.play(0); //this.playIndex
	                    }
	                    playflag = true;
	                });
	
	                $(AdCore.video[0]).on('error', function () {
	                    _this3.trigger('ended', 'no');
	                });
	
	                //ios 下不能自动监听到canplay 但是自己play一下就可以监听到了
	                // debugger;
	                AdCore.video[0].play();
	
	                //广告内容绑定事件 timeupdate ended
	                arrVideo.each(function (index, element) {
	                    var first = true; //每一个video的判断
	                    AdCore.on('timeupdate', function () {
	                        // console.log(`element.currentTime${element.currentTime}`);
	                        if (element.currentTime > 0 && _this3.adTimeout) {
	                            console.log('element.currentTime' + element.currentTime);
	                            _this3.start_play = true;
	                            _this3.trigger('ad_video_start');
	                        }
	
	                        if (element.currentTime > 3) {
	                            //解决ios播放回退2秒的问题
	                            _this3.cross3 = true; //广告播放超过3秒
	                        }
	
	                        if (first == true) {
	                            //发送曝光统计
	                            var pvurl = _this3.AdCallback.video_Count[_this3.playIndex];
	                            pvurl.forEach(function (element, index) {
	                                _this3.sendCount(element);
	                            });
	                            // debugger;
	                            var _adId = _this3.AdCallback.video_adId[_this3.playIndex];
	                            var ainfo = _this3.AdCallback.video_adPositionId + ':' + _adId;
	                            _this.trigger('adinfo', { ainfo: ainfo });
	                            first = false;
	                        }
	                        // console.log(`当前正在播放:: ${this.playIndex}`);
	                        // console.log(Math.round(lastTime - element.currentTime))
	                        var second = Math.max(0, Math.round(lastTime - element.currentTime));
	                        // if(second == 6) debugger
	                        AdCore.time.html(second + 's');
	                    }, element);
	
	                    AdCore.on('ended', function () {
	                        lastTime = Math.max(0, Math.round(lastTime - element.currentTime));
	                        // debugger
	                        // console.log(`还剩lastTime::::: ${lastTime}`);
	                        console.log('this.playIndex::::: ' + _this3.playIndex);
	                        console.log('arrVideo.length::::: ' + arrVideo.length);
	                        if (arrVideo.length > 0 && _this3.playIndex + 1 < arrVideo.length) {
	                            console.log('\u5F53\u524D\u662F\u7B2C' + _this3.playIndex + '\u4E2A\u5E7F\u544A\uFF0C\u8BE5\u64AD\u4E0B\u4E00\u4E2A\u4E86');
	                            _this3.play(++_this3.playIndex); //this.playIndex
	                        } else if (_this3.playIndex + 1 == arrVideo.length) {
	                            console.log('广告播完了'); //
	                            _this3.trigger('ended', 'yes');
	                        }
	                    }, element);
	
	                    AdCore.on('error', function () {
	                        _this3.trigger('ended', 'no');
	                    }, element);
	
	                    AdCore.on('exit', function () {
	                        _this3.trigger('exit');
	                    });
	                });
	
	                //静音按钮
	                _fCoreMobile2.default.tap(AdCore.mute, function (e) {
	                    console.log('静音按钮mute');
	                    AdCore.adVolume();
	                    return false;
	                });
	
	                //查看广告详情 了解详情
	                _fCoreMobile2.default.tap(AdCore.more, function (e) {
	                    var loc = _this3.AdCallback.video_adPositionId;
	                    var id = _this3.AdCallback.video_adId[_this3.playIndex];
	                    _this.trigger('adclick', { loc: loc, id: id });
	                    console.log('\u67E5\u770B\u5E7F\u544A\u8BE6\u60C5:' + _this3.AdCallback.video_Link[_this3.playIndex]);
	                    // window.open(this.AdCallback.video_Link[this.playIndex]); //核心
	                    _this3.trigger('href_ad', _this3.AdCallback.video_Link[_this3.playIndex]);
	                    return false;
	                });
	            }).catch(function (err) {
	                console.log(err);
	            });
	
	            //1,暂停关闭 2,暂停跳转
	            AdPause.then(function (AdPause) {
	                if (!AdPause) return;
	                if (AdPause.type == 'off') {
	                    return false;
	                }
	                //暂停广告的关闭按钮
	                _fCoreMobile2.default.tap(AdPause.el, function (e) {
	                    console.log('AdPause.el');
	                    _this3.trigger('afterAdPause');
	                    return false;
	                });
	
	                //暂停广告的关闭按钮
	                _fCoreMobile2.default.tap(AdPause.close, function (e) {
	                    console.log('AdPause.close');
	
	                    AdPause.hide();
	                    return false;
	                });
	
	                //暂停广告的整体点击
	                _fCoreMobile2.default.tap(AdPause.item, function (e) {
	                    var loc = _this3.AdCallback.pause_adPositionId;
	                    var id = _this3.AdCallback.pause_AdId;
	                    _this.trigger('adclick', { loc: loc, id: id });
	                    console.log('AdPause.item ' + _this3.AdCallback.pause_Link);
	
	                    _this3.trigger('href_p', _this3.AdCallback.pause_Link);
	                    return false;
	                });
	            }).catch(function (err) {
	                console.log(err);
	            });
	
	            //1,角标关闭 2,角标跳转
	            AdCorner.then(function (AdCorner) {
	                if (!AdCorner) return;
	                if (AdCorner.type == 'off') {
	                    return false;
	                }
	                //角标广告的关闭按钮
	                _fCoreMobile2.default.tap(AdCorner.close, function (e) {
	                    console.log('AdCorner.close');
	                    clearTimeout(_this3.cornerTimer);
	                    _this3.cornerTimer = null;
	
	                    AdCorner.hide();
	                    return false;
	                });
	
	                //角标广告的整体点击
	                _fCoreMobile2.default.tap(AdCorner.el, function (e) {
	                    var loc = _this3.AdCallback.corner_adPositionId;
	                    var id = _this3.AdCallback.corner_AdId;
	                    _this.trigger('adclick', { loc: loc, id: id });
	                    console.log('AdCorner.item ' + _this3.AdCallback.corner_Link);
	
	                    _this3.trigger('href_c', _this3.AdCallback.corner_Link);
	                    return false;
	                });
	            }).catch(function (err) {
	                console.log(err);
	            });
	
	            // this.pauseShow();
	            // this.cornerShow();
	        }
	
	        //发送统计
	
	    }, {
	        key: 'sendCount',
	        value: function sendCount(url) {
	            var img = new Image();
	            img.src = url;
	            // console.log(url)
	        }
	
	        //显示角标图片
	
	    }, {
	        key: 'cornerShow',
	        value: function cornerShow() {
	            var _this4 = this;
	
	            var _this = this;
	            if (typeof this.can == 'undefined' || this.can == 'no') return;
	            if (this.cornerShowFlag) {
	                return;
	            }
	
	            this.cornerShowFlag = true;
	            this.AdCorner.then(function (AdCorner) {
	                if (!AdCorner) return;
	                if (AdCorner.type == 'off') {
	                    return false;
	                }
	                AdCorner.show();
	                //显示后 15s后自动关闭
	                _this4.cornerTimer = setInterval(function () {
	                    var seconds = _this4.AdCallback.corner_HideCount;
	                    // debugger
	                    console.log('\u9690\u85CF\u89D2\u6807\u5012\u8BA1\u65F6=============>' + (seconds - _this4.cornerTime_hide));
	
	                    if (_this4.cornerTime_hide == seconds) {
	                        console.log('正在隐藏红包');
	                        AdCorner.hide();
	                        // this.hasHide = true;//红包出现后隐藏
	                        clearInterval(_this4.cornerTimer);
	                        _this4.cornerTimer = null;
	                    }
	                    _this4.cornerTime_hide++;
	                }, 1000);
	                //就显示一次
	                if (_this4.cornerflag == false) {
	                    // debugger;
	                    // 发送曝光统计
	                    var pvurl = _this4.AdCallback.corner_Count[0]; //这里面是数组
	                    pvurl.forEach(function (element, index) {
	                        _this4.sendCount(element);
	                    });
	
	                    var _adId = _this4.AdCallback.corner_AdId;
	                    var ainfo = _this4.AdCallback.corner_adPositionId + ':' + _adId;
	                    _this.trigger('adinfo', { ainfo: ainfo });
	                    _this4.cornerflag = true;
	                }
	            });
	        }
	
	        //显示暂停图片
	
	    }, {
	        key: 'pauseShow',
	        value: function pauseShow() {
	            var _this5 = this;
	
	            var _this = this;
	            if (typeof this.can == 'undefined' || this.can == 'no') return;
	            this.AdPause.then(function (AdPause) {
	                if (!AdPause) return;
	                if (AdPause.type == 'off') {
	                    return false;
	                }
	                AdPause.show();
	                //就显示一次
	                if (_this5.pauseflag == false) {
	                    //发送曝光统计
	                    var pvurl = _this5.AdCallback.pause_Count[0]; //这里面是数组
	                    pvurl.forEach(function (element, index) {
	                        _this5.sendCount(element);
	                    });
	
	                    var _adId = _this5.AdCallback.pause_AdId;
	                    var ainfo = _this5.AdCallback.pause_adPositionId + ':' + _adId;
	                    _this.trigger('adinfo', { ainfo: ainfo });
	                    _this5.pauseflag = true;
	                }
	            });
	        }
	
	        //隐藏暂停图片
	
	    }, {
	        key: 'pauseHide',
	        value: function pauseHide() {
	            if (typeof this.can == 'undefined' || this.can == 'no') return;
	            this.AdPause.then(function (AdPause) {
	                if (!AdPause) return;
	                if (AdPause.type == 'off') {
	                    return false;
	                }
	                AdPause.hide();
	            });
	        }
	
	        //更换暂停图片
	
	    }, {
	        key: 'changePause',
	        value: function changePause(index) {
	            if (typeof this.can == 'undefined' || this.can == 'no') return;
	            this.AdPause.then(function (AdPause) {
	                if (!AdPause) return;
	                if (AdPause.type == 'off') {
	                    return false;
	                }
	                AdPause.changeImg(index);
	            });
	        }
	
	        //更换角标图片
	
	    }, {
	        key: 'changeCorner',
	        value: function changeCorner(index) {
	            if (typeof this.can == 'undefined' || this.can == 'no') return;
	
	            this.AdCorner.then(function (AdCorner) {
	                if (!AdCorner) return;
	                if (AdCorner.type == 'off') {
	                    return false;
	                }
	                AdCorner.changeImg(index);
	            });
	        }
	
	        //插入
	
	    }, {
	        key: 'renderTo',
	        value: function renderTo(parentNode) {
	            parentNode.appendChild(this.el);
	        }
	
	        //播放
	
	    }, {
	        key: 'play',
	        value: function play(index) {
	            var _this6 = this;
	
	            if (!index) {
	                index = 0;
	            }
	            //这里就是包了一层，供外面使用。
	            this.AdCore.then(function (AdCore) {
	                if (!AdCore) return;
	                //真正走Adcore模块的播放方法
	                AdCore.adPlay(index); //playIndex
	                _this6.playIndex = index;
	                console.log('index' + index);
	            });
	        }
	    }, {
	        key: 'pause',
	        value: function pause() {
	            var _this7 = this;
	
	            //这里就是包了一层，供外面使用。
	            return this.AdCore.then(function (AdCore) {
	                if (!AdCore) return;
	                AdCore.adPause(_this7.playIndex); //playIndex
	            });
	        }
	
	        // 格式化数据
	
	    }, {
	        key: 'formatData',
	        value: function formatData(obj) {
	            var _this8 = this;
	
	            obj.forEach(function (element, index) {
	                var adPositionId = element.adPositionId;
	                if (!adPositionId) {
	                    return false;
	                }
	                var adMaterials = element.adMaterials;
	
	                switch (adPositionId) {
	                    case '10018600':
	                        //前贴片
	                        adMaterials.forEach(function (element, index) {
	                            //adConditions 1,视频mp4 2,视频时间
	                            //adAction 1,跳转链接 2,曝光链接
	                            _this8.AdCallback.video_adPositionId = '10018600';
	                            _this8.AdCallback.video_Url.push(element.adConditions.videourl); //前贴片mp4
	                            _this8.AdCallback.video_Time.push(element.adConditions.videotime); //前贴片时常
	                            _this8.AdCallback.video_Link.push(element.adAction.url); //前贴片跳转
	                            _this8.AdCallback.video_Count.push(element.adAction.pvurl); //前贴片曝光,二维数组
	                            _this8.AdCallback.totol_Time += element.adConditions.videotime; //前贴片总时长
	                            _this8.AdCallback.video_adId.push(element.adId); // 前贴片adId
	                        });
	                        break;
	                    case '10018601':
	                        //角标
	                        //zbphotos 1,横版图 2,竖版图
	                        //adAction 1,跳转链接 2,曝光链接
	                        _this8.AdCallback.corner_adPositionId = '10018601';
	                        _this8.AdCallback.corner_Link = adMaterials[0].adAction.url;
	                        _this8.AdCallback.corner_Url = adMaterials[0].zbphotos || [];
	                        //不这么写也行，直接.就行 ，这么写主要是突出统计内容是个数组，所以下面这个就是二维数组拉
	                        _this8.AdCallback.corner_Count.push(adMaterials[0].adAction.pvurl);
	                        _this8.AdCallback.corner_AdId.push(adMaterials[0].adId); // 角标adId
	                        _this8.AdCallback.corner_HideCount = adMaterials[0].duration || _this8.AdCallback.corner_HideCount;
	                        break;
	                    case '10018602':
	                        //暂停
	                        //zbphotos 1,横版图 2,竖版图
	                        //adAction 1,跳转链接 2,曝光链接
	                        _this8.AdCallback.pause_adPositionId = '10018602';
	                        _this8.AdCallback.pause_Link = adMaterials[0].adAction.url;
	                        _this8.AdCallback.pause_Url = adMaterials[0].zbphotos || [];
	                        //不这么写也行，直接.就行 ，这么写主要是突出统计内容是个数组，所以下面这个就是二维数组拉
	                        _this8.AdCallback.pause_Count.push(adMaterials[0].adAction.pvurl);
	                        _this8.AdCallback.pause_AdId.push(adMaterials[0].adId); // 角标adId
	
	                        break;
	                    default:
	                        // statements_def
	                        break;
	                }
	            });
	        }
	
	        //销毁
	
	    }, {
	        key: 'destory',
	        value: function destory() {
	            this.AdCore.then(function (AdCore) {
	                if (!AdCore) return;
	                AdCore.destory();
	            });
	        }
	
	        //检测5秒内是否能播放，不能播就不再播
	
	    }, {
	        key: 'setTimer',
	        value: function setTimer() {
	            var _this9 = this;
	
	            this.adTimeout = setInterval(function () {
	                _this9.time_ad++;
	                console.log('time:' + _this9.time_ad);
	                if (_this9.time_ad > 9) {
	                    clearInterval(_this9.adTimeout);
	                    _this9.trigger('ended', 5);
	                }
	            }, 1000);
	        }
	
	        //清除5s定时器
	
	    }, {
	        key: 'clearTimer',
	        value: function clearTimer() {
	            if (this.adTimeout) {
	                clearInterval(this.adTimeout);
	                this.adTimeout = null;
	            }
	        }
	
	        //解决iOS在播放1-3秒之间跳出后回来 广告卡死的问题
	
	    }, {
	        key: 'replay',
	        value: function replay(index) {
	            var _this10 = this;
	
	            if (!index) {
	                index = 0;
	            }
	            //这里就是包了一层，供外面使用。
	            this.AdCore.then(function (AdCore) {
	                if (!AdCore) return;
	                //真正走Adcore模块的播放方法
	                AdCore.adLoad(index);
	                AdCore.adPlay(index); //playIndex
	                _this10.playIndex = index;
	                console.log('index' + index);
	            });
	        }
	    }, {
	        key: 'skip',
	        value: function skip(index) {
	            if (!index) {
	                index = 0;
	            }
	            //这里就是包了一层，供外面使用。
	            this.AdCore.then(function (AdCore) {
	                //真正走Adcore模块的播放方法
	                if (!AdCore) return;
	                var arrVideo = AdCore.video;
	                console.log(arrVideo, index);
	                console.log(arrVideo[index].currentTime);
	                arrVideo[index].currentTime = 2;
	                console.log(arrVideo[index].currentTime);
	            });
	        }
	    }]);
	    return AdVideo;
	}();
	
	_fCore2.default.mixTo(AdVideo);
	module.exports = AdVideo;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(529);
	
	var _fCore = __webpack_require__(104);
	
	var _fCore2 = _interopRequireDefault(_fCore);
	
	var _main = __webpack_require__(533);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _videoEvents = __webpack_require__(534);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdCore = function () {
	    function AdCore(opt) {
	        (0, _classCallCheck3.default)(this, AdCore);
	
	        this.opt = opt;
	        this.init(opt);
	    }
	
	    (0, _createClass3.default)(AdCore, [{
	        key: 'init',
	        value: function init(opt) {
	            this.event = new _fCore2.default();
	            this.initLayout(opt);
	        }
	    }, {
	        key: 'initLayout',
	
	        //布局
	        value: function initLayout(_ref) {
	            var _this = this;
	
	            var data = _ref.data,
	                obj = _ref.obj;
	
	            console.dir(data);
	
	            var adcore = {
	                adUrls: data.video_Url,
	                durations: data.totol_Time
	            };
	            this.el = $((0, _main2.default)(adcore));
	            this.exitDom = this.el.find('.c-adPaster__exitBox');
	            this.time = this.el.find('.c-adPaster__time span');
	            this.mute = this.el.find('.c-adPaster__mute');
	            this.more = this.el.find('.c-adPaster__more');
	            this.video = this.el.find('video');
	            this.video[0].style.display = 'block';
	
	            var ua = navigator.userAgent,
	                isIos = ua.match(/iphone|ipod/ig);
	
	            if (isIos) {
	                this.mute.hide();
	            }
	            console.log('绑上了！');
	            this.exitDom[0].addEventListener('touchend', function () {
	                console.log('点到了！');
	                _this.event.trigger('exit');
	                return false;
	            });
	
	            // debugger;
	            // this.video[0].addEventListener('canplay', function () {
	            //     console.log('1111');
	            // })
	        }
	    }, {
	        key: 'adPlay',
	
	
	        //播放
	        value: function adPlay(index) {
	            if (index > 0) {
	                this.video[index - 1].style.display = 'none';
	            }
	            this.video[index].style.display = 'block';
	            this.video[index].play();
	
	            this.dom = this.video[index];
	            this.clickUrl = this.opt.data.video_Link[index];
	        }
	    }, {
	        key: 'adPause',
	        value: function adPause(index) {
	            this.video[index].pause();
	        }
	    }, {
	        key: 'adLoad',
	        value: function adLoad(index) {
	            if (index > 0) {
	                this.video[index - 1].style.display = 'none';
	            }
	            this.video[index].style.display = 'block';
	            this.video[index].load();
	        }
	
	        //静音
	
	    }, {
	        key: 'adVolume',
	        value: function adVolume(ele) {
	            for (var i = 0, length1 = this.video.length; i < length1; i++) {
	                this.video[i].volume = this.video[i].volume == 0 ? 1 : 0;
	                // if (this.video[i].volume === 1) {
	                //     this.video[i].volume = 0;
	                //     this.video[i].muted = 'muted';
	                // } else {
	                //     this.video[i].volume = 1;
	                // }
	                console.log(this.video[i].volume);
	            }
	            this.mute.toggleClass('muted');
	        }
	    }, {
	        key: 'destory',
	        value: function destory() {
	            this.el.remove();
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.el.hide();
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.el.show();
	        }
	    }, {
	        key: 'renderTo',
	        value: function renderTo(parentNode) {
	            $(parentNode).append(this.el);
	        }
	    }, {
	        key: 'on',
	        value: function on(eventName, callback, ele) {
	            if (_videoEvents.videoEvents.indexOf(eventName) >= 0) {
	                ele.addEventListener(eventName, callback, false);
	            } else {
	                this.event.on(eventName, callback);
	            }
	        }
	    }, {
	        key: 'off',
	        value: function off(eventName, callback, ele) {
	            if (_videoEvents.videoEvents.indexOf(eventName) >= 0) {
	                ele.removeEventListener(eventName, callback);
	            } else {
	                this.event.off(eventName, callback);
	            }
	        }
	    }]);
	    return AdCore;
	}();
	
	//Event.mixTo(AdCore);
	
	
	exports.default = AdCore;

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-adPaster\">\n    <div class=\"c-adPaster__exitBox\">\n        <div class=\"c-adPaster__exit\"></div>\n    </div>\n    <div class=\"c-adPaster__time\">广告剩余时间<span>")
	    ; __append(escape(durations))
	    ; __append("s</span></div>\n    <div class=\"c-adPaster__mute\"></div>\n    <div class=\"c-adPaster__more\">了解详情 ></div>\n    ")
	    ;  if (adUrls.length) { 
	    ; __append(" \n	")
	    ;  adUrls.forEach(function(src,index){ 
	    ; __append("<video class=\"advideo\" data-tag=\"")
	    ; __append(escape(index))
	    ; __append("\"  style=\"\" src=\"")
	    ; __append(escape(src))
	    ; __append("\" id=\"adPlayer\" preload=\"auto\" playsinline='playsinline' webkit-playsinline='webkit-playsinline' control=\"false\"></video>")
	    ;  }) 
	    ; __append("\n	")
	    ;  } 
	    ; __append(" \n</div>\n\n\n\n ")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var videoEvents = exports.videoEvents = ['loadstart', 'suspend', 'abort', 'error', 'emptied', 'stalled', 'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'playing', 'waiting', 'seeking', 'seeked', 'ended', 'durationchange', 'timeupdate', 'progress', 'play', 'pause', 'ratechange', 'volumechange'];

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(536);
	
	var _main = __webpack_require__(539);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdPause = function () {
	    function AdPause(opt) {
	        (0, _classCallCheck3.default)(this, AdPause);
	
	        this.opt = opt;
	        this.init(opt);
	    }
	
	    (0, _createClass3.default)(AdPause, [{
	        key: 'init',
	        value: function init(opt) {
	            this.initLayout(opt);
	        }
	    }, {
	        key: 'initLayout',
	        value: function initLayout(_ref) {
	            var data = _ref.data;
	
	            this.data = data;
	            var adpause = {};
	            adpause.img = data.pause_Url[0] || data.pause_Url[1];
	            // adpause.img = data.test[0];
	            if (adpause.img == undefined) {
	                this.type = 'off';
	                return false;
	            }
	            this.el = $((0, _main2.default)(adpause));
	            this.item = this.el.find('.c-adPause__item');
	            this.close = this.el.find('.c-adPause__close');
	
	            // this.changeImg(0);
	        }
	    }, {
	        key: 'changeImg',
	        value: function changeImg(type) {
	            var img = this.data.pause_Url[type];
	            this.item.css('background-image', 'url(' + img + ')');
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.el.hide();
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.el.show();
	        }
	    }, {
	        key: 'renderTo',
	        value: function renderTo(parentNode) {
	            $(parentNode).append(this.el);
	        }
	    }]);
	    return AdPause;
	}();
	
	exports.default = AdPause;

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */,
/* 538 */,
/* 539 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-adPause\" >\n    <div class=\"c-adPause__item\" style=\"background-image:url(")
	    ; __append(escape(img))
	    ; __append(")\">\n        <div class=\"c-adPause__close\">广告</div>\n    </div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(541);
	
	var _main = __webpack_require__(544);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Adcorner = function () {
	    function Adcorner(opt) {
	        (0, _classCallCheck3.default)(this, Adcorner);
	
	        this.opt = opt;
	        this.init(opt);
	    }
	
	    (0, _createClass3.default)(Adcorner, [{
	        key: 'init',
	        value: function init(opt) {
	            this.initLayout(opt);
	        }
	    }, {
	        key: 'initLayout',
	        value: function initLayout(_ref) {
	            var data = _ref.data;
	
	            debugger;
	            this.data = data;
	            var adcorner = {};
	            adcorner.img = data.corner_Url[0] || data.corner_Url[1];
	            // adcorner.img = data.test[0];
	            if (adcorner.img == undefined) {
	                this.type = 'off';
	                return false;
	            }
	            this.el = $((0, _main2.default)(adcorner));
	            this.close = this.el.find('.c-adCorner__close');
	        }
	    }, {
	        key: 'changeImg',
	        value: function changeImg(type) {
	            var img = this.data.corner_Url[type];
	            this.el.css("background-image", 'url(' + img + ')');
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.el.hide();
	        }
	    }, {
	        key: 'show',
	        value: function show() {
	            this.el.show();
	        }
	    }, {
	        key: 'renderTo',
	        value: function renderTo(parentNode) {
	            $(parentNode).append(this.el);
	        }
	    }]);
	    return Adcorner;
	}();
	
	exports.default = Adcorner;

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */,
/* 543 */,
/* 544 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-adCorner\" style=\"background-image: url(")
	    ; __append(escape(img))
	    ; __append(")\">\n    <div class=\"c-adCorner__close\">广告</div>\n        <!-- <div class=\"img_ad\"></div> -->\n    <!-- </div> -->\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(546);
	
	var _adMoney = __webpack_require__(549);
	
	var _adMoney2 = _interopRequireDefault(_adMoney);
	
	var _fCore = __webpack_require__(104);
	
	var _fCore2 = _interopRequireDefault(_fCore);
	
	var _fComponent = __webpack_require__(103);
	
	var _fComponent2 = _interopRequireDefault(_fComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by dreamc_t on 2017/5/22.
	 */
	var AdMoney = function () {
	    function AdMoney(options, showCount, hideCount) {
	        (0, _classCallCheck3.default)(this, AdMoney);
	
	        this.showCount = showCount;
	        this.hideCount = hideCount;
	        this.options = options;
	        this.init();
	    }
	
	    (0, _createClass3.default)(AdMoney, [{
	        key: 'init',
	        value: function init() {
	            this.show_timer = null;
	            this.hide_timer = null;
	            this.time_show = 0; //红包出现倒计时
	            this.time_hide = 0; //红包隐藏倒计时
	            this.hasShow = false; //默认红包未出现过
	            this.hasHide = false; //默认红包出现后未隐藏
	            this.formatData();
	            this.initDom();
	            this.initEvent();
	
	            // this.sendCount(this.pvurl);
	        }
	    }, {
	        key: 'initDom',
	        value: function initDom() {
	            this.el = $((0, _adMoney2.default)());
	            this.imageEl = this.el[0].querySelector('.c-image-money');
	            this.closeEl = this.el[0].querySelector('.close');
	            var parentNode = document.querySelector('body');
	            parentNode.appendChild(this.el[0]);
	            this.showCountDown();
	        }
	    }, {
	        key: 'initEvent',
	        value: function initEvent() {
	            var _this = this;
	
	            // let _this = this;
	            this.imageEl.addEventListener('touchend', function (e) {
	                _this.sendStatToApp('click');
	                _this.trigger('money_ad', _this.url);
	                // this.el.hide();
	                e.preventDefault(); //阻止300ms后的click事件
	            }, false);
	
	            this.closeEl.addEventListener('touchend', function (e) {
	                _this.el.hide();
	                e.preventDefault(); //阻止300ms后的click事件
	                return false;
	            }, false);
	        }
	
	        //红包出现
	
	    }, {
	        key: 'enter',
	        value: function enter() {
	            var _this2 = this;
	
	            this.el.removeClass('animated slideInDown');
	
	            this.el.show().addClass('ad-animated ad-slideInDown ad-slideIn');
	
	            setTimeout(function () {
	                _this2.el.removeClass('ad-animated ad-slideInDown');
	            }, 1000);
	
	            this.hideCountDown();
	        }
	
	        //发送统计
	
	    }, {
	        key: 'sendCount',
	        value: function sendCount(urlArr) {
	            urlArr.map(function (item) {
	                var image = new Image();
	                image.src = item;
	            });
	        }
	
	        // '#adinfo#ainfo=10018600:100186003610:piclive_104314$first=yes'
	
	    }, {
	        key: 'sendStatToApp',
	        value: function sendStatToApp(type) {
	            if (type == 'click') {
	                var loc = this.adPositionId;
	                var id = this.adId;
	                this.trigger('adclick', { loc: loc, id: id });
	            } else {
	                var ainfo = this.adPositionId + ':' + this.adId;
	                this.trigger('adinfo', { ainfo: ainfo });
	            }
	        }
	
	        //格式化数据
	
	    }, {
	        key: 'formatData',
	        value: function formatData() {
	            this.adPositionId = this.options.adPositionId;
	            this.pvurl = this.options.adMaterials[0].adAction.pvurl;
	            this.url = this.options.adMaterials[0].adAction.url;
	            this.duration = this.options.adMaterials[0].duration || this.hideCount;
	            this.image = this.options.adMaterials[0].imageURL;
	            this.showIcon = this.options.adMaterials[0].icon.showIcon;
	            this.adId = this.options.adMaterials[0].adId;
	        }
	
	        //设置隐藏倒计时
	
	    }, {
	        key: 'hideCountDown',
	        value: function hideCountDown() {
	            var _this3 = this;
	
	            if (this.hide_timer != null) {
	                this.time_hide -= 4;
	                return;
	            }
	            this.hide_timer = setInterval(function () {
	                var seconds = _this3.duration;
	                console.log('\u9690\u85CF\u7EA2\u5305\u5012\u8BA1\u65F6=============>' + (seconds - _this3.time_hide));
	                // console.log('红包隐藏了!',this.time_hide);
	                if (_this3.time_hide >= seconds) {
	                    console.log('正在隐藏红包');
	                    _this3.el.hide();
	                    _this3.hasHide = true; //红包出现后隐藏
	                    clearInterval(_this3.hide_timer);
	                    _this3.hide_timer = null;
	                }
	                _this3.time_hide++;
	            }, 1000);
	        }
	
	        // 清除隐藏倒计时
	
	    }, {
	        key: 'clearHideCountDown',
	        value: function clearHideCountDown() {
	            clearInterval(this.hide_timer);
	            this.hide_timer = null;
	        }
	
	        // 清除出现倒计时
	
	    }, {
	        key: 'clearShowCountDown',
	        value: function clearShowCountDown() {
	            clearInterval(this.show_timer);
	            this.show_timer = null;
	        }
	
	        // 设置出现倒计时
	
	    }, {
	        key: 'showCountDown',
	        value: function showCountDown() {
	            var _this4 = this;
	
	            if (this.show_timer != null) {
	                this.time_show -= 4;
	                return;
	            }
	            this.show_timer = setInterval(function () {
	                console.log('\u7EA2\u5305\u51FA\u73B0\u5012\u8BA1\u65F6=============>' + (_this4.showCount - _this4.time_show));
	                if (_this4.time_show == _this4.showCount) {
	                    _this4.enter();
	                    _this4.hasShow = true; //红包已出现
	                    _this4.sendCount(_this4.pvurl);
	                    clearInterval(_this4.show_timer);
	                    _this4.show_timer = null;
	                }
	                _this4.time_show++;
	            }, 1000);
	        }
	    }]);
	    return AdMoney;
	}();
	
	_fCore2.default.mixTo(AdMoney);
	exports.default = AdMoney;

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */,
/* 548 */,
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-adMoney\">\n    <div class=\"c-image-money\">\n        <img src=\"")
	    ;  __append(__webpack_require__(550)) 
	    ; __append("\" alt=\"\"/>\n    </div>\n\n    <div class=\"close\"></div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "icon_money.d50dbc.png";

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(552);
	
	var _adTop = __webpack_require__(555);
	
	var _adTop2 = _interopRequireDefault(_adTop);
	
	var _fCore = __webpack_require__(104);
	
	var _fCore2 = _interopRequireDefault(_fCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdTop = function () {
	    function AdTop(options, adCount) {
	        (0, _classCallCheck3.default)(this, AdTop);
	
	        this.adCount = adCount;
	        this.options = options;
	        this.init();
	    }
	
	    (0, _createClass3.default)(AdTop, [{
	        key: 'init',
	        value: function init() {
	            this.formatData();
	            this.initDom();
	            this.initEvent();
	            this.sendCount(this.pvurl);
	        }
	    }, {
	        key: 'initDom',
	        value: function initDom() {
	            var parentNode = document.querySelector('.p-wrap');
	            var relNode = document.querySelector('.l-head');
	            var _tmp = (0, _adTop2.default)({
	                adPositionId: this.adPositionId,
	                text: this.text,
	                image: this.image,
	                showIcon: this.showIcon,
	                height: this.height
	            });
	            this.el = $(_tmp);
	            parentNode.insertBefore(this.el[0], relNode);
	        }
	    }, {
	        key: 'initEvent',
	        value: function initEvent() {
	            var _this = this;
	
	            // let _this = this;
	            this.el.on('touchend', function () {
	                _this.sendStatToApp('click');
	                _this.trigger('top_ad', _this.url);
	            });
	            this.timer = null;
	            this.timer = setTimeout(function () {
	                _this.el.slideUp(500, function () {
	                    _this.trigger('toggle');
	                });
	            }, this.duration * 1000);
	            console.log('\u9876\u901A\u5012\u8BA1\u65F6=====>' + this.duration);
	        }
	    }, {
	        key: 'sendCount',
	        value: function sendCount(urlArr) {
	            urlArr.map(function (item) {
	                var image = new Image();
	                image.src = item;
	            });
	        }
	
	        // '#adinfo#ainfo=10018600:100186003610:piclive_104314$first=yes'
	
	    }, {
	        key: 'sendStatToApp',
	        value: function sendStatToApp(type) {
	            if (type == 'click') {
	                var loc = this.adPositionId;
	                var id = this.adId;
	                this.trigger('adclick', { loc: loc, id: id });
	            } else {
	                var ainfo = this.adPositionId + ':' + this.adId;
	                this.trigger('adinfo', { ainfo: ainfo });
	            }
	        }
	    }, {
	        key: 'formatData',
	        value: function formatData() {
	            this.adPositionId = this.options.adPositionId;
	            this.pvurl = this.options.adMaterials[0].adAction.pvurl;
	            this.async_click = this.options.adMaterials[0].adAction.async_click;
	            this.url = this.options.adMaterials[0].adAction.url;
	            this.image = this.options.adMaterials[0].imageURL;
	            this.duration = this.options.adMaterials[0].duration || this.adCount;
	            this.showIcon = this.options.adMaterials[0].icon.showIcon;
	            this.height = this.options.adMaterials[0].imageHeight;
	            this.adId = this.options.adMaterials[0].adId;
	        }
	    }]);
	    return AdTop;
	}(); /**
	      * Created by dreamc_t on 2017/5/23.
	      */
	
	
	_fCore2.default.mixTo(AdTop);
	
	exports.default = AdTop;

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */,
/* 554 */,
/* 555 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div id=\"adTop\" style=\"background-image: url(")
	    ; __append(escape(image))
	    ; __append(");\">\n    <div class=\"ad-icon\"></div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(112);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(113);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(557);
	
	var _addCoinTip = __webpack_require__(560);
	
	var _addCoinTip2 = _interopRequireDefault(_addCoinTip);
	
	var _fCore = __webpack_require__(104);
	
	var _fCore2 = _interopRequireDefault(_fCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddCoinTip = function () {
	    function AddCoinTip(options) {
	        (0, _classCallCheck3.default)(this, AddCoinTip);
	
	        this.options = options;
	        this.init();
	    }
	
	    (0, _createClass3.default)(AddCoinTip, [{
	        key: 'init',
	        value: function init() {
	            this.initDom();
	            this.initEvent();
	        }
	    }, {
	        key: 'initDom',
	        value: function initDom() {
	            var _tmp = (0, _addCoinTip2.default)({
	                text: this.options.point || 3
	            });
	            this.el = $(_tmp);
	            document.body.appendChild(this.el[0]);
	        }
	    }, {
	        key: 'initEvent',
	        value: function initEvent() {
	            var _this = this;
	
	            this.el.fadeIn(500);
	            this.timer = null;
	            this.timer = setTimeout(function () {
	                _this.el.fadeOut('slow');
	            }, 2000);
	        }
	    }]);
	    return AddCoinTip;
	}(); /**
	      * Created by dreamc_t on 2017/5/23.
	      */
	
	
	_fCore2.default.mixTo(AddCoinTip);
	
	exports.default = AddCoinTip;

/***/ }),
/* 557 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */,
/* 559 */,
/* 560 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"coin_tip\">\n    <div class=\"icon\"></div>\n    <p>加金币</p>\n    <p>+ <span class=\"num\">3</span></p>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */,
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Canvas = __webpack_require__(578);
	var ChartList = __webpack_require__(584);
	var checkSid = __webpack_require__(589);
	var DataCenter = __webpack_require__(590);
	var Input = __webpack_require__(593);
	var ScrollView = __webpack_require__(599);
	
	module.exports = {
	  Canvas: Canvas,
	  ChartList: ChartList,
	  checkSid: checkSid,
	  DataCenter: DataCenter,
	  Input: Input,
	  ScrollView: ScrollView
	};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Timeline = __webpack_require__(579);
	var Screen = __webpack_require__(580);
	
	var App = function App(options) {
	  options = options || {};
	  this.options = options;
	  this.options.interval = options.interval || 15;
	  this.datas = [];
	  this.init();
	  this.sends = [];
	};
	
	App.prototype = {
	  init: function init() {
	    this.sc = new Screen(this.options);
	    this.tm = new Timeline();
	    this.initEvent();
	  },
	  initEvent: function initEvent() {
	    var tm = this.tm;
	    var sc = this.sc;
	    tm.addStepCallBack(function (fgs, spend) {
	      sc.clear();
	      for (var i = 0, iLen = fgs.length; i < iLen; i++) {
	        var fg = fgs[i];
	        fg.updateSpend(spend);
	        // console.log(fgs[i].getCurrentPosition());
	        sc.render(fg);
	        if (sc.isOut(fg)) {
	          fg.del = true;
	        }
	      }
	
	      for (var i = fgs.length; i > 0; i--) {
	        var fg = fgs[i - 1];
	        if (fg.del == true) {
	          tm.remove(fg);
	          sc.remove(fg);
	        }
	      }
	
	      var row = sc.checkRow();
	      if (row != null && this.datas.length > 0) {
	        var data = this.datas.shift();
	        tm.add(sc.createFragment(data, row));
	      }
	    }.bind(this));
	
	    // this.video.addEventListener('pause', function() {
	    //   this.tm.pause();
	    // }.bind(this))
	
	    // this.video.addEventListener('play', function() {
	    //   if (this.tm.status == 1) {
	    //     this.tm.start();
	    //   } else {
	    //     this.tm.play();
	    //   }
	    // }.bind(this))
	  },
	
	  fliterDatasBySend: function fliterDatasBySend(datas) {
	    var result = [];
	    var item;
	    for (var i = 0, iLen = datas.length; i < iLen; i++) {
	      item = datas[i];
	      var isSelect = false;
	      for (var j = 0, jLen = this.sends.length; j < jLen; j++) {
	        if (this.sends[j].content == item.content) {
	          this.sends.splice(j, 1);
	          isSelect = true;
	          break;
	        }
	      }
	      if (!isSelect) {
	        result.push(item);
	      }
	    }
	    return result;
	  },
	
	  contain: function contain(item) {
	    for (var i = 0, iLen = this.datas.length; i < iLen; i++) {
	      if (item.id == this.datas[i].id) {
	        return true;
	      }
	    }
	
	    for (var i = 0, iLen = this.tm.fragments.length; i < iLen; i++) {
	      if (item.id == this.tm.fragments[i].options.id) {
	        return true;
	      }
	    }
	
	    return false;
	  },
	
	  fliterDatas: function fliterDatas(datas) {
	    datas = this.fliterDatasBySend(datas);
	    var result = [];
	    for (var i = 0, iLen = datas.length; i < iLen; i++) {
	      if (datas[i].id.indexOf('sendBack_') >= 0) {
	        this.sends.push(datas[i]);
	      }
	      if (!this.contain(datas[i])) {
	        result.push(datas[i]);
	      }
	    }
	    return result;
	  },
	
	  getData: function getData(list) {
	    this.datas = this.datas.concat(this.fliterDatas(list));
	  },
	
	  start: function start() {
	    this.tm.start();
	    this.datas = [];
	  },
	  pause: function pause() {
	    this.tm.pause();
	  },
	  continue: function _continue() {
	    this.tm.play();
	  },
	  end: function end() {
	    this.tm.end();
	    this.sc.clear();
	    this.sc.removeAll();
	  },
	  resize: function resize() {
	    this.sc.resize();
	  },
	  hide: function hide() {
	    this.sc.hide();
	  },
	  show: function show() {
	    this.sc.show();
	  },
	  renderTo: function renderTo(parentNode) {
	    this.sc.renderTo(parentNode);
	  }
	};
	
	module.exports = App;

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	"use strict";
	
	var Timeline = function Timeline() {
	  this.fragments = [];
	  this.status = 1; // 1 未开始 2 运行中 3 暂停 4 结束
	  this.lastTime = null;
	  this.stepCallbacks = [];
	};
	
	Timeline.prototype = {
	  add: function add(fragment) {
	    this.fragments.push(fragment);
	  },
	  remove: function remove(fragment) {
	    var index = this.fragments.indexOf(fragment);
	    if (index >= 0) {
	      this.fragments.splice(index, 1);
	    }
	  },
	  clear: function clear() {
	    this.fragments = [];
	  },
	  __step: function __step() {
	    if (this.status > 1 && this.status < 4) {
	      // console.log('----------');
	      var now = new Date().valueOf();
	      var spendTime = now - this.lastTime;
	      this.lastTime = now;
	      if (this.status == 2) {
	        for (var i = 0, iLen = this.stepCallbacks.length; i < iLen; i++) {
	          this.stepCallbacks[i](this.fragments, spendTime);
	        }
	      }
	      requestAnimationFrame(this.__step.bind(this));
	    }
	  },
	  start: function start() {
	    this.status = 2;
	    this.lastTime = new Date().valueOf();
	    requestAnimationFrame(this.__step.bind(this));
	  },
	  pause: function pause() {
	    if (this.status == 2) {
	      this.status = 3;
	    }
	  },
	  play: function play() {
	    if (this.status == 3) {
	      this.status = 2;
	    }
	  },
	  end: function end() {
	    this.status = 4;
	    this.clear();
	  },
	  addStepCallBack: function addStepCallBack(callback) {
	    this.stepCallbacks.push(callback);
	  }
	};
	
	module.exports = Timeline;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(581);
	var Fragment = __webpack_require__(583);
	
	var paddingLeft = function paddingLeft(str, v) {
	  var padding = v - str.length;
	  for (var i = 0; i < padding; i++) {
	    str = '0' + str;
	  }
	  return str;
	};
	
	var createBox = function createBox() {
	  var canvas = document.createElement('canvas');
	  canvas.className = 'c-barrage__canvas';
	  return canvas;
	};
	
	var Screen = function Screen(options) {
	  this.options = options;
	  this.options.speed = options.speed || 100;
	  this.options.rows = options.rows || 4;
	  this.options.offsetTop = options.offsetTop || 20;
	  this.options.offsetLeft = options.offsetLeft || 40;
	  this.options.base = options.base || 375;
	  this.options.per = options.per || 0.75;
	  this.ratio = 2;
	  this.init();
	};
	
	Screen.prototype = {
	  init: function init() {
	    var createRow = function createRow(value) {
	      var result = [];
	      for (var i = 0; i < value; i++) {
	        result.push([]);
	      }
	      return result;
	    };
	    this.rows = createRow(this.options.rows);
	    this.box = createBox();
	    this.ctx = this.box.getContext("2d");
	  },
	  resize: function resize() {
	    var canvas = this.box;
	    var container = this.parentNode;
	    canvas.width = container.offsetWidth * 2;
	    canvas.height = container.offsetHeight * 2;
	    canvas.style.width = container.offsetWidth + 'px';
	    canvas.style.height = container.offsetHeight + 'px';
	
	    this.boxHeight = this.box.offsetHeight;
	    this.rowHeight = (this.boxHeight * this.options.per - this.options.offsetTop) / this.options.rows;
	    this.dur = 1000 * window.innerWidth / this.options.speed;
	
	    var ctx = this.ctx;
	    ctx.shadowColor = "RGBA(0,0,0,1)";
	    ctx.shadowOffsetX = 0;
	    ctx.shadowOffsetY = 4;
	    ctx.shadowBlur = 8;
	    this.resizeAllFragment();
	  },
	  isAllShow: function isAllShow(fragment) {
	    var left = fragment.options.begin.left;
	    var now = fragment.getCurrentPosition().left;
	    var size = fragment.options.size;
	    if (left - now > size) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	  isOut: function isOut(fragment) {
	    if (fragment.options.spend >= fragment.options.dur) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	  render: function render(fragment) {
	    var size = { '14': 12, '18': 15, '22': 16 };
	    var ctx = this.ctx;
	    var position = fragment.getCurrentPosition();
	    if (fragment.options.color != '0') {
	      ctx.fillStyle = '#' + paddingLeft(Number(fragment.options.color).toString(16), 6);
	    } else {
	      ctx.fillStyle = '#fff';
	    }
	    var fontSize = fragment.options.fontsize * window.innerWidth / this.options.base;
	    ctx.font = fontSize * this.ratio + 'px SimSun';
	
	    ctx.fillText(fragment.options.text, position.left, position.top);
	  },
	  remove: function remove(fragment) {
	    var row = fragment.options.row;
	    var index = this.rows[row].indexOf(fragment);
	
	    if (index >= 0) {
	      this.rows[row].splice(index, 1);
	    }
	  },
	  removeAll: function removeAll() {
	    for (var i = 0, iLen = this.rows.length; i < iLen; i++) {
	      this.rows[i] = [];
	    }
	  },
	  checkRow: function checkRow() {
	    var result = [];
	    var row;
	    var fragment;
	    for (var i = 0, iLen = this.rows.length; i < iLen; i++) {
	      row = this.rows[i];
	      if (row.length <= 0) {
	        result.push(i);
	      } else {
	        fragment = row[row.length - 1];
	        if (this.isAllShow(fragment)) {
	          result.push(i);
	        }
	      }
	    }
	    if (result.length > 0) {
	      return result[Math.floor(Math.random() * result.length)];
	    } else {
	      return null;
	    }
	  },
	  resizeAllFragment: function resizeAllFragment() {
	    var row;
	    for (var i = 0, iLen = this.rows.length; i < iLen; i++) {
	      row = this.rows[i];
	      for (var j = 0, jLen = row.length; j < jLen; j++) {
	        this.resizeFragment(row[j]);
	      }
	    }
	  },
	  resizeFragment: function resizeFragment(fragment) {
	    var content = fragment.options.text;
	    var row = fragment.options.row;
	    var paddSize = fragment.options.paddSize;
	    var top = this.options.offsetTop * this.ratio + (row + 0.5) * this.rowHeight * this.ratio;
	
	    var fontSize = fragment.options.fontsize * window.innerWidth / this.options.base;
	    this.ctx.font = fontSize * this.ratio + 'px SimSun';
	
	    var size = this.ctx.measureText(content).width;
	    var left = this.box.offsetWidth * 2 + paddSize;
	
	    fragment.options.begin = {
	      top: top,
	      left: left
	    };
	
	    fragment.options.end = {
	      top: top,
	      left: 0 - size
	    };
	
	    fragment.options.size = size + paddSize;
	    if (fragment.options.spend > 0) {
	      fragment.options.spend = fragment.options.spend * this.dur / fragment.options.dur;
	    }
	    fragment.options.dur = this.dur;
	  },
	  createFragment: function createFragment(data, row) {
	    // var top = this.options.offsetTop * this.ratio + (row + 0.5) * this.rowHeight * this.ratio;
	    var paddSize = Math.floor(Math.random() * this.options.offsetLeft * this.ratio);
	    // var left = this.box.offsetWidth * 2 + paddSize;
	    // var size = this.ctx.measureText(data.content).width;
	    var fragment = new Fragment({
	      id: data.id,
	      spend: 0,
	      text: data.content,
	      color: data.color,
	      fontsize: data.fontsize,
	      paddSize: paddSize,
	      row: row
	    });
	    this.resizeFragment(fragment);
	    this.rows[row].push(fragment);
	    return fragment;
	  },
	  clear: function clear() {
	    this.ctx.clearRect(0, 0, 10000, 10000);
	  },
	  hide: function hide() {
	    this.box.style.visibility = 'hidden';
	  },
	  show: function show() {
	    this.box.style.visibility = 'visible';
	  },
	  renderTo: function renderTo(parentNode) {
	    this.parentNode = parentNode;
	    parentNode.appendChild(this.box);
	    this.resize();
	  }
	};
	
	module.exports = Screen;

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */,
/* 583 */
/***/ (function(module, exports) {

	'use strict';
	
	var index = 1;
	var Fragment = function Fragment(options) {
	  this.options = options;
	  this.id = 'fragment_' + index++;
	};
	
	Fragment.prototype = {
	  getCurrentPosition: function getCurrentPosition() {
	    var top, left;
	    if (this.options.spend <= this.options.dur) {
	      top = this.options.begin.top - (this.options.begin.top - this.options.end.top) * this.options.spend / this.options.dur;
	      left = this.options.begin.left - (this.options.begin.left - this.options.end.left) * this.options.spend / this.options.dur;
	    } else {
	      top = this.options.end.top;
	      left = this.options.end.left;
	    }
	    return {
	      top: top,
	      left: left
	    };
	  },
	  updateSpend: function updateSpend(time) {
	    this.options.spend = this.options.spend + time;
	  }
	};
	
	module.exports = Fragment;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(585);
	var tmpl = __webpack_require__(587);
	var tmplItem = __webpack_require__(588);
	var util = __webpack_require__(404);
	var Events = __webpack_require__(104);
	
	var ChartList = function ChartList() {
	    this.ids = {};
	    this.datas = [];
	    this.init();
	    this.sends = [];
	    this.isStop = false;
	    this.atPerson = false; //@艾特用户
	};
	
	ChartList.prototype.init = function () {
	    this.initDom();
	    this.initEvent();
	};
	
	ChartList.prototype.initDom = function () {
	    var div = document.createElement('div');
	    div.innerHTML = tmpl();
	    this.el = div.children[0];
	    this.elItems = this.el.querySelector('.c-chart__items');
	    this.elScroll = this.el.querySelector('.c-chart__scrolls');
	    this.elMore = this.el.querySelector('.c-chart__more');
	};
	
	ChartList.prototype.initEvent = function () {
	    util.tap(this.elMore, function () {
	        var divHeight = this.elScroll.offsetHeight;
	        var listHeight = this.elItems.offsetHeight;
	
	        $(this.elMore).stop().animate({ bottom: '-1.667rem' });
	        $(this.elScroll).stop().animate({ scrollTop: listHeight - divHeight }, 400);
	
	        // this.elScroll.scrollTop = listHeight - divHeight;
	        return false;
	    }, {
	        scope: this
	    });
	
	    // todo
	    // 增加对于全页面拖动的阻止
	    this.isTouch = false;
	
	    this.elScroll.addEventListener('touchstart', function (event) {
	        this.isTouch = true;
	        $(this.elScroll).stop();
	        this.isScroll = true;
	        var scrollTop = this.elScroll.scrollTop;
	        if (scrollTop == 0) {
	            this.elScroll.scrollTop = 1;
	            return;
	        }
	        var divHeight = this.elScroll.offsetHeight;
	        var listHeight = this.elItems.offsetHeight;
	        if (listHeight <= scrollTop + divHeight) {
	            this.elScroll.scrollTop = scrollTop - 1;
	        }
	        // event.preventDefault();
	    }.bind(this), false);
	
	    this.touchendTimer = null;
	
	    this.elScroll.addEventListener('touchend', function (event) {
	        this.isTouch = false;
	        // $('#logBox').html($('#logBox').html() + '<br/>touchend');
	        this.isScroll = true;
	        var listHeight = this.elItems.offsetHeight;
	        var divHeight = this.el.offsetHeight;
	        var scrollTop = this.elScroll.scrollTop;
	        // 用来防止touchend后没有scroll事件触发的情况，
	        // 一加一减是为了防止滚动到头和尾的时候，如果超出滚动范围，不会触发滚动的情况。
	        // 对于微信（ios）来说，他的scroll事件在touchend触发以后，不会继续触发，只在停止滚动后，才会再触发一下，
	        // 这样的话，如果写下面两句，会导致iscroll会被提前结束。但是如果不写，有一种几率在touchend后如果没有惯性位移，会导致无法改变isScroll的状态
	        // this.elScroll.scrollTop = scrollTop + 2;
	        // this.elScroll.scrollTop = scrollTop - 1;
	
	        // 对于scroll的监控，存在以下几种情况
	        // ios（9 10）的微信下面 touchstart scroll*N touchend ...... 停止滚动后 scroll再触发一次
	        // iso (9 10) safari touchstart scroll*N touchend scroll*N 直到停止
	        // 安卓下面，touchstart scroll*N touchend scroll*N
	        // 安卓下面，当内容滚动到底的时候，如果再进行滑动，在touchend后面无法触发scroll，因为安卓的滚动没有回弹。
	        // 所有环境下，如果滑动结束时，没有位移，也不会在触发touchend后再次触发scroll事件
	        // 现在的解决方案是在touchend是，开一个定时器，以避免后面没有scroll触发的时候导致内容无法更新的问题。
	        // console.log('----------------------', event)
	        clearTimeout(timer);
	        clearTimeout(this.touchendTimer);
	        this.touchendTimer = setTimeout(function () {
	            this.isScroll = false;
	        }.bind(this), 3000);
	        event.preventDefault();
	    }.bind(this), false);
	
	    this.elItems.addEventListener('touchstart', function (event) {
	        this.atPerson = true;
	    }.bind(this), false);
	
	    this.elItems.addEventListener('touchmove', function (event) {
	        this.atPerson = false;
	    }.bind(this), false);
	
	    this.elItems.addEventListener('touchend', function (event) {
	        if (this.atPerson) {
	            //从父节点中取id和type
	            var parentNode = event.target.parentNode;
	            var type = parentNode.dataset.type;
	            var id = parentNode.dataset.id;
	            var nickname = parentNode.dataset.name;
	
	            //当且仅当是普通弹幕才能艾特 并且有id
	            if (type === 'danma' && id != undefined && id.indexOf('sendBack') < 0) {
	                console.log('trigger', nickname);
	                this.trigger('atPerson', nickname);
	            }
	        }
	        this.atPerson = false;
	    }.bind(this), false);
	
	    var index = 1;
	
	    var timer = null;
	    this.isScroll = false;
	    this.elScroll.addEventListener('scroll', function () {
	        // $('#logBox').html($('#logBox').html() + '<br/>only scroll');
	        this.isScroll = true;
	        var listHeight = this.elItems.offsetHeight;
	        var divHeight = this.el.offsetHeight;
	        var scrollTop = this.elScroll.scrollTop;
	
	        // console.log('scroll',listHeight - divHeight - scrollTop);
	        clearTimeout(this.touchendTimer);
	        clearTimeout(timer);
	        timer = setTimeout(function () {
	            this.isScroll = false;
	            // console.log('timer');
	            var listHeight = this.elItems.offsetHeight;
	            var divHeight = this.el.offsetHeight;
	            var scrollTop = this.elScroll.scrollTop;
	            if (listHeight <= divHeight + scrollTop + 10) {
	                $(this.elMore).stop().animate({ bottom: '-1.667rem' });
	                // this.elMore.style.display = 'none';
	            }
	        }.bind(this), 200);
	        // this.elScroll.style.backgroundColor = 'rgb(255, 255, ' + (index++%255) + ')';
	        // console.log('scroll');
	    }.bind(this), false);
	};
	
	ChartList.prototype.fliterDatasBySend = function (datas) {
	    var result = [];
	    var item;
	    for (var i = 0, iLen = datas.length; i < iLen; i++) {
	        item = datas[i];
	        var isSelect = false;
	        for (var j = 0, jLen = this.sends.length; j < jLen; j++) {
	            if (this.sends[j].content == item.content) {
	                this.sends.splice(j, 1);
	                isSelect = true;
	                break;
	            }
	        }
	        if (!isSelect) {
	            result.push(item);
	        }
	    }
	    return result;
	};
	
	ChartList.prototype.removeItem = function () {
	    var items = $(this.elItems).find('.c-chart__item');
	    if (items.length < 200) {
	        return;
	    }
	
	    var clearItems = items.slice(0, 100);
	
	    var totalHeight = 0;
	
	    clearItems.each(function () {
	        totalHeight = totalHeight + $(this).outerHeight();
	    });
	
	    var scrollTop = $(this.elScroll).scrollTop();
	
	    if (scrollTop > totalHeight) {
	        $(this.elScroll).scrollTop(scrollTop - totalHeight);
	    } else {
	        $(this.elScroll).scrollTop(0);
	    }
	
	    clearItems.remove();
	};
	
	ChartList.prototype.fliterDatas = function (datas) {
	    datas = this.fliterDatasBySend(datas);
	    var result = [];
	    var item;
	    var now = new Date().valueOf();
	    for (var i = 0, iLen = datas.length; i < datas.length; i++) {
	        item = datas[i];
	        if (typeof item.id == 'undefined') {
	            result.push(item);
	        } else {
	            if (typeof item.id == 'string' && item.id.indexOf('sendBack_') >= 0) {
	                this.sends.push(item);
	            }
	            if (!this.ids[item.id]) {
	                this.ids[item.id] = now;
	                result.push(item);
	            } else if (now - this.ids[item.id] > 10 * 60 * 1000 && item.__type == 'online') {
	                this.ids[item.id] = now;
	                result.push(item);
	            }
	        }
	    }
	    return result;
	};
	
	ChartList.prototype.add = function (datas) {
	    datas = this.fliterDatas(datas);
	    if (this.isScroll || this.isTouch || this.isStop) {
	        this.datas = this.datas.concat(datas);
	
	        if (this.datas.length > 0) {
	            setTimeout(function () {
	                this.add([]);
	            }.bind(this), 1000);
	        }
	
	        return;
	    } else {
	        // 每次只显示有限数量的消息
	        // this.datas = this.datas.concat(datas);
	        // datas = this.datas.splice(0, 5);
	        // if (this.datas.length > 0) {
	        //   setTimeout(function () {
	        //     this.add([]);
	        //   }.bind(this), 1000);
	        // }
	        datas = this.datas.concat(datas);
	        this.datas = [];
	    }
	
	    // 如果过滤后的数据为空的话，则不进行下面的操作。
	    if (datas.length <= 0) {
	        return;
	    }
	
	    $(this.elScroll).stop(true, true);
	
	    console.log(datas);
	
	    if (__urlParams.liveid == '131498') {
	        datas[0].praise_type = 'rat';
	    }
	
	    this.removeItem();
	    // console.log('isScroll', this.isScroll);
	    var div = document.createElement('div');
	    div.innerHTML = tmplItem({ list: datas });
	    var items = div.children;
	    var p = document.createDocumentFragment();
	    while (items.length > 0) {
	        p.appendChild(items[0]);
	    }
	    var listHeight = this.elItems.offsetHeight;
	    var divHeight = this.el.offsetHeight;
	    var scrollTop = this.elScroll.scrollTop;
	    requestAnimationFrame(function () {
	        this.elItems.appendChild(p);
	        var newListHeight = this.elItems.offsetHeight;
	        var addHeight = newListHeight - listHeight;
	        if (newListHeight > divHeight) {
	            // 加10是因为在安卓版本下面，有可能会有1-2的误差。用10做小范围修正。
	            if (listHeight <= scrollTop + divHeight + 10) {
	                // $('#logBox').html($('#logBox').html() + '<br/>' + listHeight - scrollTop - divHeight);
	                // console.log('scroll');
	                listHeight = this.elItems.offsetHeight;
	                divHeight = this.el.offsetHeight;
	
	                $(this.elScroll).stop().animate({ scrollTop: listHeight - divHeight }, 400);
	                $(this.elMore).stop().animate({ bottom: '-1.667rem' });
	                // this.elMore.style.display = 'none';
	            } else {
	                $(this.elMore).stop().animate({ bottom: '0.167rem' });
	                // this.elMore.style.display = 'block';
	            }
	        }
	    }.bind(this));
	};
	
	ChartList.prototype.scrollTo = function (offset) {
	    var elm = $('[data-offset="' + offset + '"]')[0];
	    if (elm) {
	        var top = $(elm).position().top;
	        // console.log(top);
	        $(this.elScroll).stop().animate({ scrollTop: top }, 400);
	    }
	};
	
	ChartList.prototype.scroll = function (type) {
	    var listHeight = this.elItems.offsetHeight;
	    var scrollTop = this.elScroll.scrollTop;
	    var divHeight = this.el.offsetHeight;
	    if (listHeight > scrollTop + divHeight) {
	        $(this.elScroll).stop().animate({ scrollTop: listHeight - divHeight }, 400);
	    }
	};
	
	ChartList.prototype.hideMore = function () {
	    $(this.elMore).stop().css({ bottom: '-1.667rem' });
	};
	
	ChartList.prototype.resetMore = function () {
	    setTimeout(function () {
	        if (this.elScroll.scrollTop + this.el.offsetHeight < this.elItems.offsetHeight) {
	            $(this.elMore).stop().css({ bottom: '-1.667rem' });
	        } else {
	            $(this.elMore).stop().animate({ bottom: '0.167rem' });
	        }
	    }.bind(this), 1000);
	};
	
	ChartList.prototype.stop = function () {
	    this.isStop = true;
	};
	
	ChartList.prototype.play = function () {
	    this.isStop = false;
	    this.add([]);
	};
	
	ChartList.prototype.renderTo = function (parentNode) {
	    parentNode.appendChild(this.el);
	    this.elScroll.style.height = this.el.offsetHeight + 'px';
	    // this.elScroll.style.height = '100%';
	};
	
	ChartList.prototype.destory = function () {
	    this.el.parentNode.removeChild(this.el);
	};
	
	ChartList.prototype.resize = function () {
	    console.log(this.el.offsetHeight);
	    this.elScroll.style.height = this.el.offsetHeight + 'px';
	};
	
	ChartList.prototype.clear = function () {
	    this.ids = {};
	    this.datas = [];
	    this.sends = [];
	    $(this.elItems).empty();
	    $(this.elMore).stop().animate({ bottom: '-1.667rem' });
	};
	
	Events.mixTo(ChartList);
	
	module.exports = ChartList;

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */,
/* 587 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-chart\">\n<div class=\"c-chart__scrolls\" style=\"transform: translate3d(0px, 1px, 0px);\">\n  <div class=\"c-chart__items\"></div>\n</div>\n<div class=\"c-chart__more\"><span>您有新的热聊哟</span></div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; 
	  for (var i = 0, iLen = list.length; i < iLen; i++) {
	    var item = list[i];
	
	    ; __append("\n  ")
	    ;  if (item.__type == 'danma') { 
	    ; __append("\n    <section class=\"c-chart__item\" data-id=\"")
	    ; __append(escape(item.id))
	    ; __append("\" data-type=\"danma\" data-name=\"")
	    ; __append(escape(item.nickname))
	    ; __append("\">\n      <div class=\"c-chart__avatar\" style=\"background-image: url(")
	    ; __append(escape(decodeURIComponent(item.avatar)))
	    ; __append(")\"></div>\n      <div class=\"c-chart__content\">\n        <em class=\"c-chart__host\">")
	    ; __append(escape(item.nickname))
	    ; __append("：</em>")
	    ; __append(escape(item.content))
	    ; __append("\n      </div>\n    </section>\n  ")
	    ;  } 
	    ; __append("\n  ")
	    ;  if (item.__type == 'praise') { 
	    ; __append("\n    <section class=\"c-chart__item\" data-id=\"")
	    ; __append(escape(item.id))
	    ; __append("\" data-type=\"praise\">\n      <div class=\"c-chart__avatar\" style=\"background-image: url(")
	    ; __append(escape(decodeURIComponent(item.avatar)))
	    ; __append(")\"></div>\n      <div class=\"c-chart__content\">\n        ")
	    ;  if (item.praise_type == '2') { 
	    ; __append("\n          <em class=\"c-chart__host\">")
	    ; __append(escape(item.nickname))
	    ; __append("：</em>给主播点了赞\n        ")
	    ;  } 
	    ; __append("\n        ")
	    ;  if (item.praise_type == '3') { 
	    ; __append("\n          <em class=\"c-chart__host\">")
	    ; __append(escape(item.nickname))
	    ; __append("：</em>点燃一根蜡烛\n        ")
	    ;  } 
	    ; __append("\n        ")
	    ;  if (item.praise_type == 'rat') { 
	    ; __append("\n          <em class=\"c-chart__host\">")
	    ; __append(escape(item.nickname))
	    ; __append("：</em>献上新春祝福\n        ")
	    ;  } 
	    ; __append("\n      </div>\n    </section>\n  ")
	    ;  } 
	    ; __append("\n  ")
	    ;  if (list[i].__type == 'gift') { 
	    ; __append("\n    <section class=\"c-chart__item\" data-id=\"")
	    ; __append(escape(item.id))
	    ; __append("\" data-type=\"gift\">\n      <div class=\"c-chart__avatar\" style=\"background-image: url(")
	    ; __append(escape(decodeURIComponent(item.user.avatar)))
	    ; __append(")\"></div>\n      <div class=\"c-chart__content\">\n        <em class=\"c-chart__host\">")
	    ; __append(escape(item.user.nickname))
	    ; __append("：</em>赠送了<span class=\"c-chart__giftname\">")
	    ; __append(escape(item.gift.desc))
	    ; __append("</span><span class=\"c-chart__giftpic\" style=\"background-image: url(")
	    ; __append(escape(item.gift.src))
	    ; __append(")\"></span>\n      </div>\n    </section>\n  ")
	    ;  } 
	    ; __append("\n  ")
	    ;  if (item.__type == 'online') { 
	    ; __append("\n    <section class=\"c-chart__item\" data-id=\"")
	    ; __append(escape(item.id))
	    ; __append("\" data-type=\"online\">\n      <div class=\"c-chart__avatar\" style=\"background-image: url(")
	    ; __append(escape(decodeURIComponent(item.avatar)))
	    ; __append(")\"></div>\n      <div class=\"c-chart__content\">\n        <span class=\"c-chart__online\">欢迎 ")
	    ; __append(escape(item.nickname))
	    ; __append(" 进入直播间</span>\n      </div>\n    </section>\n  ")
	    ;  } 
	    ; __append("\n  ")
	    ;  if (item.__type == 'system') { 
	    ; __append("\n    <section class=\"c-chart__item\" data-type=\"system\">\n      <div class=\"c-chart__avatar\" style=\"background-image: url(")
	    ; __append(escape(decodeURIComponent(item.avatar)))
	    ; __append(")\"></div>\n      <div class=\"c-chart__content\">\n        <span class=\"c-chart__system\">")
	    ; __append(escape(item.content))
	    ; __append("</span>\n      </div>\n    </section>\n  ")
	    ;  } 
	    ; __append("\n")
	    ;  } 
	    ; __append("\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(404);
	
	var delCookie = function delCookie(name) {
	    document.cookie = name + '=;expires=' + new Date(0).toGMTString() + ';domain=.ifeng.com;path=/';
	};
	
	var sidChecked = false;
	
	var checkSid = function checkSid(callback) {
	    var sid = util.cookie.getByEncode('sid');
	    if (sid) {
	        if (!sidChecked) {
	            $.ajax({
	                url: '//id.ifeng.com/api/checklogin',
	                type: 'get',
	                dataType: 'jsonp',
	                data: {
	                    sid: sid
	                },
	                success: function success(msg) {
	                    console.log(msg);
	                    sidChecked = true;
	                    if (msg.code == 1) {
	                        callback(sid);
	                    } else {
	                        delCookie('sid');
	                        callback(false);
	                    }
	                }
	            });
	        } else {
	            callback(sid);
	        }
	    } else {
	        sidChecked = true;
	        callback(false);
	    }
	};
	
	module.exports = checkSid;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Live = __webpack_require__(591);
	var Playback = __webpack_require__(592);
	
	module.exports = {
	  Live: Live,
	  Playback: Playback
	};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Events = __webpack_require__(104);
	
	var formatData = function formatData(type, data) {
	  for (var i = 0, iLen = data.length; i < iLen; i++) {
	    data[i].__type = type;
	  }
	  return data;
	};
	
	var formatDatas = function formatDatas(msg) {
	  if (Array.isArray(msg)) {
	    return {};
	  }
	  var items;
	  var result = [];
	  for (var key in msg) {
	    items = msg[key];
	    items = formatData('danma', items);
	    result = result.concat(items);
	  }
	  console.log(result);
	  return result;
	};
	
	var DataCenter = function DataCenter(liveid, message, title) {
	  this.message = message;
	  this.liveid = liveid;
	  this.title = title;
	  this.cacheIds = {};
	  this.isStart = true;
	  this.init();
	};
	
	DataCenter.prototype.init = function () {
	  this.initEvent();
	};
	
	DataCenter.prototype.initData = function () {
	  var id = this.liveid;
	  $.ajax({
	    url: window.location.protocol + '//danmaku.ifeng.com/get/recent/' + id,
	    type: 'get',
	    dataType: 'jsonp',
	    data: {
	      format: 'jsonp'
	    },
	    success: function (msg) {
	      console.log(msg);
	      if (typeof msg.code !== 'undefined' && msg.code !== 1) {
	        return;
	      }
	      var datas = formatDatas(msg);
	      this.trigger('data', 'danma', datas);
	    }.bind(this)
	  });
	};
	
	DataCenter.prototype.initEvent = function () {
	  var _this = this;
	
	  var dealData = function dealData(data) {
	    if (!this.isStart) {
	      return;
	    }
	    console.log('~~~~~~~~~~~~~', data);
	    var list = formatData(data.type, data.data);
	    if (list.length > 0) {
	      // list = this.fliteById(list);
	      this.trigger('data', data.type, list);
	    }
	  };
	
	  this.message.on('danma:list', 201, dealData.bind(this));
	  this.message.on('gift:list', 204, dealData.bind(this));
	  this.message.on('online:list', 201, dealData.bind(this));
	  this.message.on('praise:list', 201, dealData.bind(this));
	
	  var isFirst = true;
	  this.message.event.on('open', function () {
	    if (isFirst == true) {
	      isFirst = false;
	      _this.initData();
	    }
	  });
	};
	
	var sendIndex = 0;
	
	DataCenter.prototype.sendData = function (data, offset, commandid) {
	  var data = {
	    // article_id: this.message.liveid,
	    title: this.title,
	    url: window.location.href,
	    content: data.val,
	    fontsize: data.size,
	    color: data.color
	    // app: 'h5',
	    // type: 'realtime'
	  };
	  this.message.send('danma', commandid, data).catch(function () {});
	  data.id = 'sendBack_' + sendIndex++;
	  this.trigger('send', [data]);
	};
	
	DataCenter.prototype.fliteById = function (data) {
	  var cacheIds = this.cacheIds;
	  var result = [];
	  var item;
	  var now = new Date().valueOf();
	  for (var i = 0, iLen = data.length; i < iLen; i++) {
	    item = data[i];
	    if (typeof item.id == 'undefined') {
	      result.push(item);
	    } else {
	      if (typeof cacheIds[item.id] == 'undefined') {
	        cacheIds[item.id] = now;
	        result.push(item);
	      } else if (now - cacheIds[item.id] > 10 * 60 * 1000 && item.__type == 'online') {
	        cacheIds[item.id] = now;
	        result.push(item);
	      }
	    }
	  }
	  return result;
	};
	
	DataCenter.prototype.start = function () {
	  this.isStart = true;
	};
	
	DataCenter.prototype.stop = function () {
	  this.isStart = false;
	};
	
	Events.mixTo(DataCenter);
	module.exports = DataCenter;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Events = __webpack_require__(104);
	
	var __getUrlParams = function __getUrlParams() {
	    var result = {};
	    var params = window.location.search.substring(1).split('&');
	    var param;
	
	    for (var i = 0, iLen = params.length; i < iLen; i++) {
	        param = params[i].split('=');
	        if (param.length == 2) {
	            result[param[0]] = decodeURIComponent(param[1]);
	        }
	    }
	
	    return result;
	};
	
	var __urlParams = __getUrlParams();
	
	var formatDatas = function formatDatas(msg) {
	    if (Array.isArray(msg)) {
	        return {};
	    }
	    var items;
	    for (var key in msg) {
	        items = msg[key];
	        items = formatData('danma', items);
	    }
	    return msg;
	};
	
	var formatData = function formatData(type, data) {
	    for (var i = 0, iLen = data.length; i < iLen; i++) {
	        data[i].__type = type;
	    }
	    return data;
	};
	
	var DataCenter = function DataCenter(options, message, title) {
	    this.cacheIds = {};
	    this.datas = {};
	    this.message = message;
	    this.options = options;
	    this.title = title;
	    this.init();
	};
	
	DataCenter.prototype.init = function () {
	    this.initEvent();
	    this.initData();
	};
	
	DataCenter.prototype.initEvent = function () {
	    // this.message.on('gift:list login:list praise:list', function (type, data) {
	    //   var data = formatData(type, data);
	    //   if (data.length > 0) {
	    //     this.trigger('data', type, data);
	    //   }
	    // }.bind(this));
	
	    var dealData = function dealData(data) {
	        var list = formatData(data.type, data.data);
	        if (list.length > 0) {
	            // list = this.fliteById(list);
	            this.trigger('data', data.type, list);
	        }
	    };
	
	    this.message.on('gift:list', 204, dealData.bind(this));
	    this.message.on('online:list', 201, dealData.bind(this));
	    this.message.on('praise:list', 201, dealData.bind(this));
	};
	
	DataCenter.prototype.fliteById = function (data) {
	    var cacheIds = this.cacheIds;
	    var result = [];
	    var item;
	    var now = new Date().valueOf();
	    for (var i = 0, iLen = data.length; i < iLen; i++) {
	        item = data[i];
	        if (typeof item.id == 'undefined') {
	            result.push(item);
	        } else {
	            if (typeof cacheIds[item.id] == 'undefined') {
	                cacheIds[item.id] = now;
	                result.push(item);
	            } else if (now - cacheIds[item.id] > 1 * 60 * 1000 && item.__type == 'online') {
	                cacheIds[item.id] = now;
	                result.push(item);
	            }
	        }
	    }
	    return result;
	};
	
	DataCenter.prototype.initData = function () {
	    var id = this.options.id;
	    var _url = this.options.getPlaybackUrl || '';
	    var _urlArray = _url.split(':');
	    var _protocol = window.location.protocol == 'http:' ? 'http:' : 'https:';
	    this.url = _urlArray[1] ? _protocol + _urlArray[1] : this.options.getPlaybackUrl;
	
	    this.reqData(id);
	};
	
	DataCenter.prototype.reqData = function (id) {
	    this.datas = {};
	    this.options.id = id;
	    var data = {
	        format: 'jsonp'
	    };
	    $.ajax({
	        url: this.url + id,
	        type: 'get',
	        dataType: 'jsonp',
	        data: data,
	        success: function (msg) {
	            if (typeof msg.code !== 'undefined' && msg.code !== 1) {
	                return;
	            }
	            this.datas = formatDatas(msg);
	            // alert('getRange');
	            setTimeout(function () {
	                this.getRange(-1, 0);
	            }.bind(this), 300);
	        }.bind(this)
	    });
	};
	
	DataCenter.prototype.getRange = function (begin, end) {
	    var result = [];
	    var t;
	    for (var i = begin + 1; i <= end; i++) {
	        t = 't' + i;
	        if (this.datas[t]) {
	            result = result.concat(this.datas[t]);
	        }
	    }
	    if (result.length > 0) {
	        console.log(result);
	        // console.log(begin, end, result.map(item => item.id).join('|'));
	        // alert(JSON.stringify(result));
	        this.trigger('dataMax', 'danma', result);
	    }
	};
	
	DataCenter.prototype.getData = function (offset) {
	    var t = 't' + offset;
	    if (this.datas[t]) {
	        this.trigger('data', 'danma', this.datas[t]);
	    }
	};
	// {size: "14", position: "middle", color: "0Xfae30c", val: "miaomiaomiao"}
	var sendIndex = 0;
	DataCenter.prototype.sendData = function (data, offset) {
	    // debugger
	    var id = this.options.id;
	    var _url = this.options.sendUrl || '';
	    var _urlArray = _url.split(':');
	    var _protocol = window.location.protocol == 'http:' ? 'http:' : 'https:';
	    var url = _urlArray[1] ? _protocol + _urlArray[1] : this.options.sendUrl;
	    var data = {
	        article_id: id,
	        title: this.title,
	        url: window.location.protocol + '//' + window.location.host + window.location.pathname + '?liveid=' + __urlParams.liveid,
	        content: data.val,
	        nickname: data.nickname,
	        fontsize: data.size,
	        offset: offset,
	        color: data.color,
	        app: 'h5',
	        type: 'normal',
	        format: 'jsonp'
	    };
	    $.ajax({
	        url: url,
	        type: 'get',
	        dataType: 'jsonp',
	        data: data,
	        success: function (msg) {
	            data.id = 'sendBack_' + sendIndex++;
	            this.trigger('send', [data]);
	            console.log(msg);
	            // console.log(msg);
	            // this.datas = this.datas.concat(msg)
	        }.bind(this)
	    });
	};
	
	Events.mixTo(DataCenter);
	module.exports = DataCenter;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(77);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(594);
	var tmpl = __webpack_require__(598);
	var Events = __webpack_require__(104);
	var util = __webpack_require__(404);
	
	var ua = navigator.userAgent,
	    isIos = navigator.userAgent.match(/iphone|ipod/ig),
	    isIpad = navigator.userAgent.match(/ipad/ig),
	    isIphone = isIos || isIpad;
	
	var Input = function Input(options) {
	  this.desc = options.desc || '我要说两句';
	  this.maxLength = options.maxLength || 200;
	  this.data = {
	    size: 18,
	    color: '0Xffffff'
	  };
	  this.init();
	};
	
	Input.prototype.init = function () {
	  this.initDom();
	  this.initEvent();
	};
	
	Input.prototype.initDom = function () {
	  var div = document.createElement('div');
	  div.innerHTML = tmpl({ desc: this.desc, maxLength: this.maxLength });
	  this.el = div.children[0];
	  this.elInput = this.el.querySelector('.c-barrage__input');
	  this.elBtn = this.el.querySelector('.c-barrage__send');
	  this.elTalk = this.el.querySelector('.l-input');
	  this.elPad = this.el.querySelector('.l-padding');
	  console.log(this.elTalk);
	};
	
	Input.prototype.initEvent = function () {
	
	  util.tap(this.el, function (e, elm) {
	    this.hide();
	  }, {
	    scope: this
	  });
	
	  util.tap(this.elTalk, function (e, elm) {
	    return false;
	  }, {
	    scope: this
	  });
	
	  util.on(this.elInput, 'blur', function (e, elm) {
	    var dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
	    if (isIphone) {
	      $(this.elTalk).css('top', '0px');
	      $(this.elPad).css('top', '3000px');
	    }
	    this.hide();
	    this.trigger('blur');
	  }, {
	    scope: this
	  });
	
	  util.on(this.elInput, 'focus', function (e, elm) {
	    var dge = typeof window.orientation !== 'undefined' ? window.orientation : window.screen.orientation.angle;
	    if (isIphone) {
	      var h1 = 0;
	      if (Math.abs(dge) != 90) {
	        h1 = $('.l-head').height();
	      }
	      setTimeout(function () {
	        $(this.el).css('opacity', 1);
	        $(this.elPad).css('top', h1 + $(this.elTalk).outerHeight() + 'px');
	        document.body.scrollTop = 0;
	        $(this.elTalk).css('top', h1 + 'px');
	      }.bind(this), 200);
	    }
	  }, {
	    scope: this
	  });
	
	  util.tap(this.elInput, function (e, elm) {
	    this.elInput.focus();
	  }, {
	    scope: this
	  });
	
	  util.on(this.elInput, 'input', function (e, elm) {
	    // var count = this.maxLength - elm.value.length;
	    // if (count > 0 && count < this.maxLength) {
	    //   $(this.elBtn).removeClass('disable');
	    // } else {
	    //   $(this.elBtn).addClass('disable');
	    // }
	
	    var count = elm.value.length;
	    if (count > 0) {
	      $(this.elBtn).removeClass('disable');
	    } else {
	      $(this.elBtn).addClass('disable');
	    }
	
	    if (this.maxLength < count) {
	      console.log(this.maxLength, count);
	      elm.value = elm.value.slice(0, this.maxLength);
	    }
	
	    this.trigger('text', elm.value);
	  }, {
	    scope: this
	  });
	
	  util.tap(this.elBtn, function (e, elm) {
	    if ($(this.elInput).val().trim().length <= 0) {
	      $(this.elBtn).addClass('disable');
	      return false;
	    }
	    if ($(this.elBtn).hasClass('disable')) {
	      return false;
	    }
	    e.preventDefault();
	    this.trigger('message', this.getMessage());
	    this.trigger('text', '');
	    this.reset();
	    return false;
	  }, {
	    scope: this
	  });
	};
	
	Input.prototype.reset = function () {
	  this.elInput.value = '';
	  $(this.elBtn).addClass('disable');
	};
	
	Input.prototype.getMessage = function () {
	  var message = JSON.parse((0, _stringify2.default)(this.data));
	  message.val = this.elInput.value.trim();
	  return message;
	};
	
	Input.prototype.getMessageFromClient = function (val) {
	  var message = JSON.parse((0, _stringify2.default)(this.data));
	  message.val = val.trim();
	  return message;
	};
	
	Input.prototype.renderTo = function (parentNode) {
	  parentNode.appendChild(this.el);
	};
	
	Input.prototype.show = function () {
	  this.el.style.visibility = 'visible';
	  if (isIphone) {
	    $(this.el).css('opacity', 0);
	    $(this.elTalk).css('top', 0);
	  } else {
	    $(this.elTalk).css('bottom', 0);
	  }
	  // this.el.style.display = 'block';
	  this.elInput.focus();
	  this.trigger('inputshow');
	};
	
	Input.prototype.hide = function () {
	  // this.el.style.display = 'none';
	  this.el.style.visibility = 'hidden';
	  this.elInput.blur();
	  this.trigger('inputhide');
	  $('.l-input').css('bottom', 0);
	};
	
	Events.mixTo(Input);
	
	module.exports = Input;

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-mask\">\n  <div class=\"l-input\">\n    <input type=\"text\" name=\"content\" class=\"c-barrage__input\" placeholder=\"")
	    ; __append(escape(desc))
	    ; __append("\" />\n    <span class=\"c-barrage__send disable\">发送</span>\n  </div>\n  <div class=\"l-padding\"></div>\n</div>\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(600);
	var tmpl = __webpack_require__(602);
	var tmplItem = __webpack_require__(603);
	
	var ScrollView = function ScrollView() {
	  this.ids = {};
	  this.datas = [];
	  this.sends = [];
	  this.isHide = false;
	  this.top = 0;
	  this.items = [];
	  this.itemHeight = 0;
	  this.space = 10;
	  this.isPause = false;
	  this.time = -1;
	  this.init();
	};
	
	ScrollView.prototype.init = function () {
	  this.initDom();
	  this.initEvent();
	};
	
	ScrollView.prototype.initDom = function () {
	  var div = document.createElement('div');
	  div.innerHTML = tmpl();
	  this.el = div.children[0];
	  this.elBox = this.el.querySelector('.c-scrollview__scrolls');
	};
	
	ScrollView.prototype.initEvent = function () {};
	
	ScrollView.prototype.frameRun = function () {
	  requestAnimationFrame(function () {
	    this.frameRun();
	
	    if (this.isPause) {
	      return;
	    }
	
	    var top, height;
	    var index = 0;
	    if (this.top < 0 && this.items.length > 0) {
	      top = this.top;
	      while (top < 0 && this.items[index]) {
	        height = this.items[index].height;
	        if (height < Math.abs(top)) {
	          this.items[index].elm.css('opacity', 0);
	        } else {
	          this.items[index].elm.css('opacity', (height + top) / height);
	        }
	        top = top + height;
	        index++;
	      }
	    }
	
	    if (this.boxHeight < this.top + this.itemHeight) {
	      if (this.top + this.itemHeight - this.boxHeight > this.space) {
	        this.top = this.top - this.space;
	      } else {
	        this.top = this.top - (this.top + this.itemHeight - this.boxHeight);
	      }
	      $(this.elBox).css({
	        'transform': 'translate3d(0,' + this.top + 'px,0)',
	        'webkitTransform': 'translate3d(0,' + this.top + 'px,0)'
	      });
	    }
	  }.bind(this));
	};
	
	ScrollView.prototype.fliterDatasBySend = function (datas) {
	  var result = [];
	  var item;
	  for (var i = 0, iLen = datas.length; i < iLen; i++) {
	    item = datas[i];
	    var isSelect = false;
	    for (var j = 0, jLen = this.sends.length; j < jLen; j++) {
	      if (this.sends[j].content == item.content) {
	        this.sends.splice(j, 1);
	        isSelect = true;
	        break;
	      }
	    }
	    if (!isSelect) {
	      result.push(item);
	    }
	  }
	  return result;
	};
	
	ScrollView.prototype.fliterDatas = function (datas) {
	  datas = this.fliterDatasBySend(datas);
	  var result = [];
	  var item;
	  var now = new Date().valueOf();
	  for (var i = 0, iLen = datas.length; i < datas.length; i++) {
	    item = datas[i];
	    if (typeof item.id == 'undefined') {
	      result.push(item);
	    } else {
	      if (typeof item.id == 'string' && item.id.indexOf('sendBack_') >= 0) {
	        this.sends.push(item);
	      }
	      if (!this.ids[item.id]) {
	        this.ids[item.id] = now;
	        result.push(item);
	      } else if (now - this.ids[item.id] > 1 * 60 * 1000 && item.__type == 'online') {
	        this.ids[item.id] = now;
	        result.push(item);
	      }
	    }
	  }
	  return result;
	};
	
	ScrollView.prototype.add = function (datas) {
	  datas = this.fliterDatas(datas);
	  this.datas = this.datas.concat(datas);
	};
	
	ScrollView.prototype.addItem = function () {
	
	  requestAnimationFrame(function () {
	    this.addItem();
	
	    this.time = this.time + 1;
	
	    if (this.time % 60 != 0) {
	      return;
	    }
	
	    if (this.isPause) {
	      return;
	    }
	
	    if (this.datas.length >= 1) {
	      this.removeItem();
	      var item = this.datas.shift();
	      var $item = $(tmplItem({ item: item }));
	      $(this.elBox).append($item);
	      var height = $item[0].offsetHeight;
	      this.space = height / 30;
	      this.items.push({
	        elm: $item,
	        height: height,
	        id: item.id
	      });
	      this.itemHeight = this.itemHeight + height;
	    }
	  }.bind(this));
	};
	
	ScrollView.prototype.removeItem = function () {
	  var item;
	  if (this.items.length > 0 && this.top + this.items[0].height < 0) {
	    while (this.top + this.items[0].height < 0) {
	      item = this.items.shift();
	      this.ids[item.id] = false;
	      item.elm.remove();
	      this.top = this.top + item.height;
	      this.itemHeight = this.itemHeight - item.height;
	    }
	    $(this.elBox).css('transform', 'translate3d(0,' + this.top + 'px,0)');
	  }
	};
	
	ScrollView.prototype.removeData = function (remain) {
	  if (this.datas.length <= remain) {
	    return;
	  }
	  this.datas = this.datas.slice(this.datas.length - remain);
	};
	
	ScrollView.prototype.renderTo = function (parentNode) {
	  parentNode.appendChild(this.el);
	  var height = $(parentNode).height();
	  $(this.el).height(height);
	  this.boxHeight = height;
	  this.top = this.top + height;
	  $(this.elBox).css('transform', 'translate3d(0,' + this.top + 'px,0)');
	  this.addItem();
	  this.frameRun();
	};
	
	ScrollView.prototype.destory = function () {
	  this.el.parentNode.removeChild(this.el);
	};
	
	ScrollView.prototype.reset = function () {
	  this.top = this.boxHeight;
	  this.space = 10;
	  this.items = [];
	  this.itemHeight = 0;
	  $(this.elBox).empty();
	  $(this.elBox).css('transform', 'translate3d(0,' + this.top + 'px,0)');
	};
	
	ScrollView.prototype.pause = function () {
	  this.isPause = true;
	};
	
	ScrollView.prototype.play = function () {
	  this.isPause = false;
	};
	
	ScrollView.prototype.hide = function () {
	  this.el.style.visibility = 'hidden';
	};
	
	ScrollView.prototype.show = function () {
	  this.el.style.visibility = 'visible';
	};
	
	module.exports = ScrollView;

/***/ }),
/* 600 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */,
/* 602 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-scrollview\">\n<div class=\"c-scrollview__scrolls\">\n</div>\n</div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ;  if (item.__type == 'danma') { 
	    ; __append("\n  <section class=\"c-scrollview__item\" data-id=\"")
	    ; __append(escape(item.id))
	    ; __append("\" data-type=\"danma\">\n    <div class=\"c-scrollview__iteminner\">\n      <div class=\"c-scrollview__head\">\n        <span class=\"c-scrollview__avatar\" style=\"background-image: url(")
	    ; __append(escape(decodeURIComponent(item.avatar)))
	    ; __append(")\"></span>\n        <em class=\"c-scrollview__host\">")
	    ; __append(escape(item.nickname))
	    ; __append("：</em>\n      </div>\n      <div class=\"c-scrollview__content\">\n        ")
	    ; __append(escape(item.content))
	    ; __append("\n      </div>\n    </div>\n  </section>\n")
	    ;  } 
	    ; __append("\n")
	    ;  if (item.__type == 'praise') { 
	    ; __append("\n  <section class=\"c-scrollview__item\" data-id=\"")
	    ; __append(escape(item.id))
	    ; __append("\" data-type=\"praise\">\n    <div class=\"c-scrollview__iteminner\">\n      <div class=\"c-scrollview__head\">\n        <span class=\"c-scrollview__avatar\" style=\"background-image: url(")
	    ; __append(escape(decodeURIComponent(item.avatar)))
	    ; __append(")\"></span>\n        <em class=\"c-scrollview__host\">")
	    ; __append(escape(item.nickname))
	    ; __append("：</em>\n      </div>\n      ")
	    ;  if (item.praise_type == '2') { 
	    ; __append("\n        <div class=\"c-scrollview__content\">\n          给主播点了赞！\n        </div>\n      ")
	    ;  } 
	    ; __append("\n      ")
	    ;  if (item.praise_type == '3') { 
	    ; __append("\n        <div class=\"c-scrollview__content\">\n          点燃一根蜡烛\n        </div>\n      ")
	    ;  } 
	    ; __append("\n    </div>\n  </section>\n")
	    ;  } 
	    ; __append("\n")
	    ;  if (item.__type == 'gift') { 
	    ; __append("\n  <section class=\"c-scrollview__item\" data-id=\"")
	    ; __append(escape(item.id))
	    ; __append("\" data-type=\"gift\">\n    <div class=\"c-scrollview__iteminner\">\n      <div class=\"c-scrollview__head\">\n        <span class=\"c-scrollview__avatar\" style=\"background-image: url(")
	    ; __append(escape(decodeURIComponent(item.user.avatar)))
	    ; __append(")\"></span>\n        <em class=\"c-scrollview__host\">")
	    ; __append(escape(item.user.nickname))
	    ; __append("：</em>\n      </div>\n      <div class=\"c-scrollview__content\">\n        赠送了<span class=\"c-scrollview__giftname\">")
	    ; __append(escape(item.gift.desc))
	    ; __append("</span><span class=\"c-scrollview__giftpic\" style=\"background-image: url(")
	    ; __append(escape(item.gift.src))
	    ; __append(")\"></span>\n      </div>\n    </div>\n  </section>\n")
	    ;  } 
	    ; __append("\n")
	    ;  if (item.__type == 'online') { 
	    ; __append("\n  <section class=\"c-scrollview__item\" data-id=\"")
	    ; __append(escape(item.id))
	    ; __append("\" data-type=\"online\">\n    <div class=\"c-scrollview__iteminner\">\n      <div class=\"c-scrollview__head\">\n        <span class=\"c-scrollview__avatar\" style=\"background-image: url(")
	    ; __append(escape(decodeURIComponent(item.avatar)))
	    ; __append(")\"></span>\n        <span class=\"c-scrollview__online\">欢迎 ")
	    ; __append(escape(item.nickname))
	    ; __append(" 进入直播间</span>\n      </div>\n    </div>\n  </section>\n")
	    ;  } 
	    ; __append("\n")
	    ;  if (item.__type == 'system') { 
	    ; __append("\n  <section class=\"c-scrollview__item\" data-type=\"system\">\n    <div class=\"c-scrollview__iteminner\">\n      <div class=\"c-scrollview__head\">\n        <span class=\"c-scrollview__avatar\" style=\"background-image: url(")
	    ; __append(escape(decodeURIComponent(item.avatar)))
	    ; __append(")\"></span>\n        <span class=\"c-scrollview__online\">")
	    ; __append(escape(item.content))
	    ; __append("</span>\n      </div>\n    </div>\n  </section>\n")
	    ;  } 
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Message = __webpack_require__(605);
	
	module.exports = Message;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(77);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Events = __webpack_require__(104);
	// var WebSocket = require('../mock/websocket');
	var createRequestId = __webpack_require__(606);
	var Gateway = __webpack_require__(607);
	
	var Message = function Message(options, errorCallback) {
	    this.options = options;
	    this.retryCount = options.retryCount || 2;
	    this.pingTime = options.pingTime || 30;
	    this.delayTime = options.delayTime || 2;
	    this.errorCallback = errorCallback || function () {};
	    this.retryTimer = null;
	    this.init();
	};
	
	Message.prototype = {
	    init: function init() {
	        this.cachs = [];
	        this.promises = {};
	        this.eventNames = {};
	        this.event = new Events();
	        this.closeType = 'system';
	        this.createWs();
	        this.gateway = new Gateway(this);
	        this.lastReadyState = '';
	    },
	
	    createWs: function createWs() {
	        var options = this.options;
	        var timer = setTimeout(function () {
	            this.close(true);
	            this.errorCallback('timeout');
	            // todo 报告超时错误
	        }.bind(this), options.timeout || 10000);
	
	        var params = {
	            roomid: options.roomid,
	            source: options.source,
	            deviceid: options.deviceid,
	            version: options.version,
	            app: options.app,
	            liveid: options.roomid,
	            praise_type: options.praise_type,
	            deviceid_real: options.deviceid_real,
	            os: options.os,
	            gv: options.gv,
	            proid: options.proid,
	            uid: options.deviceid,
	            token: options.token
	        };
	
	        // 升级协议，全部为ws
	        var socketUrl = 'wss:';
	        // let socketPort = location.protocol === 'http:' ? ':9501' : ':9505';
	        // 后端升级域名，去端口，为80
	        var socketPort = '';
	        // 测试用
	        if (Number(options.roomid) === 100008) {
	            socketPort = '';
	        }
	        var urlArrays = options.url.split(':');
	        if (urlArrays[0]) {
	            socketUrl += urlArrays[1] + socketPort;
	        }
	        var ws = new WebSocket(socketUrl + '?' + $.param(params));
	
	        this.event.trigger('begin');
	
	        var interTime = setInterval(function () {
	            ws.send('ping');
	        }, this.pingTime * 1000);
	
	        ws.onopen = function () {
	            var _this = this;
	
	            this.retryCount = this.options.retryCount || 9999;
	            clearTimeout(timer);
	            this.getUser().then(function () {
	                _this.sendCaches();
	            });
	            this.event.trigger('open');
	            this.lastReadyState = ws.readyState;
	        }.bind(this);
	
	        ws.onclose = function () {
	            if (this.lastReadyState !== ws.readyState) {
	                this.event.trigger('close');
	                this.lastReadyState = ws.readyState;
	            }
	            clearTimeout(timer);
	            clearInterval(interTime);
	
	            // 将该次连接所有 message.send 产生的未获得返回的 promise 都触发 reject，告知调用放连接关闭了。
	            // 要不要这么做呢 ？？？？ 如果再次连上，服务端能续发，那这里可以不处理，等着就好。
	            for (var key in this.promises) {
	                this.promises[key].reject({
	                    code: 505,
	                    message: '连接意外关闭',
	                    data: {
	                        requestid: key
	                    }
	                });
	            }
	
	            if (this.closeType !== 'system') {
	                this.closeType = 'system';
	                return;
	            }
	
	            if (this.retryCount > 0) {
	                this.retryCount--;
	                this.retryTimer = setTimeout(function () {
	                    this.createWs();
	                }.bind(this), this.delayTime * 1000);
	            } else {
	                this.errorCallback('retry');
	                // todo 报告重试错误
	            }
	        }.bind(this);
	
	        ws.onmessage = function (evt) {
	            var msg = evt.data;
	            if (msg == 'pong') {
	                return;
	            }
	
	            if (msg == 'ping') {
	                ws.send('pong');
	                return;
	            }
	
	            try {
	                msg = JSON.parse(msg);
	                var requestid = msg.data.requestid;
	
	                if (msg.code == 1) {
	                    if (this.promises[requestid]) {
	                        this.promises[requestid].resolve(msg.data);
	                        delete this.promises[requestid];
	                    }
	
	                    msg.data.type = msg.type;
	                    msg.data.commandid = msg.commandid;
	                    this.event.trigger(msg.type + msg.commandid, msg.data);
	                } else {
	                    if (this.promises[requestid]) {
	                        this.promises[requestid].reject(msg);
	                        delete this.promises[requestid];
	                    }
	                }
	            } catch (e) {
	                // todo 报告数据错误
	            }
	        }.bind(this);
	
	        ws.onerror = function (e) {
	            this.event.trigger('onerror500', {
	                commandid: 500
	            });
	        }.bind(this);
	
	        this.ws = ws;
	    },
	
	    send: function send(type, commandid, data) {
	        data = data || {};
	        var requestid = createRequestId();
	        var msg = {
	            type: type,
	            commandid: commandid,
	            data: data
	        };
	        data.requestid = requestid;
	
	        var serializeStr = (0, _stringify2.default)(msg);
	
	        var promise = new _promise2.default(function (resolve, reject) {
	            this.promises[requestid] = {
	                resolve: resolve,
	                reject: reject
	            };
	        }.bind(this));
	
	        // 为了屏蔽对promise错误没有捕捉的抛错，因为有时候捕捉是在另外一个流程里
	        promise.then(function () {}).catch(function () {});
	
	        if (this.ws.readyState == 1) {
	            this.ws.send(serializeStr);
	        } else {
	            this.cachs.push(serializeStr);
	        }
	
	        return promise;
	    },
	
	    sendCaches: function sendCaches() {
	        var serializeStr = void 0;
	        while (this.cachs.length > 0) {
	            serializeStr = this.cachs.shift();
	            this.ws.send(serializeStr);
	        }
	    },
	
	    on: function on(name, commandid, callback) {
	        var a = name.split(':');
	        var type = a[0];
	        var namespace = a[1] || '';
	        if (typeof this.eventNames[type] === 'undefined') {
	            this.eventNames[type] = {};
	        }
	        this.eventNames[commandid] = 1;
	        this.event.on(type + commandid + ':' + namespace, callback);
	    },
	
	    off: function off(name, commandid, callback) {
	        var a = name.split(':');
	        var type = a[0];
	        var namespace = a[1] || '';
	
	        if (commandid) {
	            this.event.off(type + commandid, callback);
	        } else {
	            if (this.eventNames[type]) {
	                for (var key in this.eventNames[type]) {
	                    this.event.off(type + key + ':' + namespace, callback);
	                }
	            }
	        }
	    },
	
	    close: function close(retry) {
	        if (!retry) {
	            this.closeType = 'user';
	        }
	        this.ws.close();
	    },
	
	    trytoConnect: function trytoConnect() {
	        if (this.ws.readyState != 1) {
	            clearTimeout(this.retryTimer);
	            this.createWs();
	        }
	    },
	    getUser: function getUser() {
	        return this.gateway.getUser();
	    }
	};
	
	module.exports = Message;

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	"use strict";
	
	var oneId = function oneId() {
	  return Number(Math.floor(Math.random() * 36)).toString(36);
	};
	
	var createRequestId = function createRequestId() {
	  var head = Number(new Date().valueOf()).toString(36);
	  return head + oneId() + oneId() + oneId() + oneId() + oneId() + oneId();
	};
	
	module.exports = createRequestId;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _getSid = function _getSid() {
	  // 测试代码
	  if (typeof __urlParams !== "undefined" && __urlParams.sid) {
	    return __urlParams.sid;
	  }
	
	  var cookies = document.cookie.split("; ");
	
	  for (var i = 0, iLen = cookies.length; i < iLen; i++) {
	    if (cookies[i].split("=")[0] == "sid") {
	      return decodeURIComponent(cookies[i].split("=")[1]);
	    }
	  }
	
	  if (window.grounds) {
	    return grounds.getUserInfo().getToken();
	  }
	
	  return "";
	};
	
	var getDefaultInfo = function getDefaultInfo() {
	  return {
	    type: "unknow"
	  };
	};
	
	// readyState 0 未认证 1 认证中 2 认证成功 3 认证失败
	var Gateway = function Gateway(message) {
	  this.message = message;
	  this.init();
	};
	
	Gateway.prototype = {
	  init: function init() {
	    this.initData();
	    this.initPromise();
	    this.initEvent();
	  },
	
	  getSid: function getSid() {
	    return this.userinfo.sid || _getSid() || "";
	  },
	
	  initData: function initData() {
	    this.userinfo = getDefaultInfo();
	    // 1 准备中
	    this.readyState = 0;
	  },
	
	  initPromise: function initPromise() {
	    if (this.reject) {
	      this.reject("close");
	    }
	
	    this.promise = new _promise2.default(function (resolve, reject) {
	      this.resolve = resolve;
	      this.reject = reject;
	    }.bind(this));
	
	    // 为了屏蔽对promise错误没有捕捉的抛错，因为有时候捕捉是在另外一个流程里，是接上去的。
	    this.promise.then(function () {}).catch(function (e) {});
	  },
	
	  initEvent: function initEvent() {
	    this.message.on("close:gateway", "", this.unregister.bind(this));
	    this.message.on("open:gateway", "", this.register.bind(this));
	  },
	
	  unregister: function unregister() {
	    this.userinfo = getDefaultInfo();
	    this.readyState = 0;
	    this.initPromise();
	  },
	
	  register: function register() {
	    this.readyState = 1;
	    this.message.send("gateway", 101, {
	      sid: this.getSid(),
	      nickname: this.message.options.nickname,
	      avatar: this.message.options.avatar
	    }).then(function (result) {
	      if (result.code == 1) {
	        this.userinfo = result.data;
	        this.readyState = 2;
	        this.resolve(result.data);
	      } else {
	        this.readyState = 3;
	        this.reject(result);
	      }
	    }.bind(this), function (error) {
	      this.readyState = 3;
	      this.reject(error);
	    }.bind(this));
	  },
	
	  getUser: function getUser() {
	    return this.promise;
	  }
	};
	
	module.exports = Gateway;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _typeof2 = __webpack_require__(1);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Events = __webpack_require__(104);
	__webpack_require__(609);
	var tmpl = __webpack_require__(612);
	
	var Info = function Info(data, message, isLive, native) {
	    this.message = message;
	    this.data = $.extend(true, {}, data);
	    this.data.showOnlineNum = window.showOnlineNum || false;
	    this.data.isApp = native.isApp;
	    if (native.isApp && (native.getAppName() === 'videoapp' || !grounds.syncSubscribe)) {
	        this.data.isApp = 0;
	    }
	    this.isLive = isLive;
	    this.native = native;
	    this.init();
	};
	
	var formatCount = function formatCount(val) {
	    if (val < 10000) {
	        return val;
	    } else {
	        return (val / 10000).toFixed(1) + '万';
	    }
	};
	
	var isBrowser = function isBrowser() {
	    return (typeof grounds === 'undefined' ? 'undefined' : (0, _typeof3.default)(grounds)) === 'object' ? false : true;
	};
	
	var goToPage = function goToPage() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var _url = null;
	    var isFull = 1;
	    var _param = null;
	    var mode = window.mode || 'day';
	
	    if (isBrowser()) {
	        _param = $.param(params);
	    } else {
	        _param = $.param($.extend(params, { webkit: 1, isFull: isFull, mode: mode, immersion: true }));
	    }
	
	    _url = 'https://izhibo.ifeng.com/column.html?' + _param;
	
	    if (isBrowser()) {
	        window.location.href = _url;
	    } else {
	        grounds.dispatch('web', '' + _url, '', '', '');
	    }
	};
	
	Info.prototype.init = function () {
	    this.initDom();
	    this.initEvent();
	};
	
	Info.prototype.initDom = function () {
	    this.el = $(tmpl(this.data));
	    this.elBtn = $(this.el[0]).find('.c-info__btn');
	    this.elIntro = this.el.filter('.c-info__content');
	    this.subscribe = this.el[0].querySelector('.c-channel__subscribe');
	    this.columnIcon = $(this.el[0]).find('.c-channel__icon');
	    this.columnName = $(this.el[0]).find('.c-channel__name');
	};
	
	Info.prototype.initEvent = function () {
	    var _this = this;
	
	    var self = this;
	
	    this.message.on('online:info', '201', this.changeCount.bind(this));
	
	    this.el.on('touchend', function () {
	        return false;
	    });
	
	    if (this.data.isApp) {
	        if (this.data.loginid && this.data.loginid !== '') {
	            this.checkOrder().then(function (result) {
	                if (result.code === 200) {
	                    // 请求成功
	                    console.log('登录啦！4444');
	                    if (result.data[self.data.followid] === 1) {
	                        // 已订阅
	                        self.subscribe.classList.add('clicked');
	                        self.subscribe.classList.remove('plus');
	                        $(self.subscribe).text('已关注');
	                    } else {
	                        self.follow = false;
	                    }
	                    self.subscribe.addEventListener('touchend', function () {
	                        if (self.follow) {
	                            // 请求取消订阅接口
	                            self.requestData('cancel').then(function (result) {
	                                if (result.code + '' !== '200') {
	                                    return false;
	                                }
	                                self.subscribe.classList.remove('clicked');
	                                self.subscribe.classList.add('plus');
	                                $(self.subscribe).text('关注');
	                                self.native.syncSubscribe({
	                                    followid: self.data.followid,
	                                    type: 'zhibo',
	                                    isSubscribe: 0
	                                });
	                                self.follow = false;
	                                // 发送统计
	                                self.native.actionStat({
	                                    type: 'chsub',
	                                    id: 'live_sub_' + self.data.columnId
	                                });
	                            });
	                        } else {
	                            // 未订阅请求用户订阅接口
	                            self.requestData('add').then(function (result) {
	                                if (result.code + '' !== '200') {
	                                    return false;
	                                }
	                                self.subscribe.classList.add('clicked');
	                                self.subscribe.classList.remove('plus');
	                                $(self.subscribe).text('已关注');
	                                self.native.syncSubscribe({
	                                    followid: self.data.followid,
	                                    type: 'zhibo',
	                                    isSubscribe: 1
	                                });
	                                self.follow = true;
	                                // 发送统计
	                                self.native.actionStat({
	                                    type: 'chunsub',
	                                    id: 'live_sub_' + self.data.columnId
	                                });
	                            });
	                        }
	                    });
	                }
	            }).catch(function (e) {
	                console.log(e, 'adffgdfgfg');
	                self.subscribe.addEventListener('touchend', function () {
	                    // 拉起登录
	                    self.trigger('login');
	                });
	            });
	        } else {
	            self.subscribe.addEventListener('touchend', function () {
	                // 拉起登录
	
	                self.trigger('login');
	            });
	        }
	    }
	
	    this.elBtn.on('touchend', function () {
	        if (this.elBtn.hasClass('selected')) {
	            this.introHide();
	        } else {
	            this.introShow();
	        }
	        return false;
	    }.bind(this));
	
	    // 点击栏目头像或者栏目名称跳转
	    this.columnIcon.on('touchend', function () {
	        goToPage({ id: _this.data.columnId, refer: '' });
	    });
	
	    this.columnName.on('touchend', function () {
	        goToPage({ id: _this.data.columnId, refer: '' });
	    });
	};
	
	Info.prototype.changeCount = function (msg) {
	    if (msg.code === 1) {
	        this.el.find('.c-visite span').text(formatCount(msg.number));
	    }
	};
	
	Info.prototype.introShow = function () {
	    this.elBtn.addClass('selected');
	    this.elIntro.slideDown(300, function () {
	        this.trigger('toggle');
	    }.bind(this));
	};
	
	Info.prototype.introHide = function () {
	    this.elBtn.removeClass('selected');
	    this.elIntro.slideUp(300, function () {
	        this.trigger('toggle');
	    }.bind(this));
	};
	
	Info.prototype.renderTo = function (parentNode) {
	    $(parentNode).append(this.el);
	};
	
	Info.prototype.checkOrder = function () {
	    // 请求订阅接口查看是否订阅
	    var loginid = this.data.loginid;
	    var followid = this.data.followid;
	    var token = this.data.token;
	    var guid = this.data.loginid;
	    var deviceid = this.native.getDeviceInfo().getDeviceId();
	    var os = this.native.getDeviceInfo().getOs();
	    var data = {
	        loginid: loginid,
	        followids: followid + '',
	        token: token,
	        os: os,
	        guid: guid,
	        deviceid: deviceid
	    };
	    var promise = _promise2.default.resolve($.ajax({
	        url: this.data.queryFollow,
	        type: 'GET',
	        data: data,
	        cache: true,
	        dataType: 'jsonp'
	    })); // => promise对象
	    return promise;
	};
	
	Info.prototype.requestData = function (type) {
	    var self = this;
	
	    // 查询是否关注 http://10.21.6.38/Social_Api_Fans/relation?loginid=71614570&followids=zhibo_liveid 返回值为0表示未关注
	    // 如果未关注 则点击订阅后请求 用户关注接口 http://10.21.6.38/Social_Api_Follow/add?loginid=72851320&followid=user_2423&token=afd2534as46534fd
	    // 如果已关注 则点击订阅后 请求取消关注接口 http://10.21.6.38/Social_Api_Follow/cancel?loginid=72851320&followid=user_2423&token=234234sdfasdf
	    var loginid = this.data.loginid;
	    var followid = this.data.followid;
	    var token = this.data.token;
	    var guid = this.data.loginid;
	    var deviceid = this.native.getDeviceInfo().getDeviceId();
	    var os = this.native.getDeviceInfo().getOs();
	    var data = {
	        loginid: loginid,
	        followid: followid,
	        token: token,
	        os: os,
	        guid: guid,
	        deviceid: deviceid
	    };
	    var promise = _promise2.default.resolve($.ajax({
	        url: self.data.followUrl + type,
	        type: 'GET',
	        data: data,
	        cache: true,
	        dataType: 'jsonp'
	    }));
	    return promise;
	};
	
	Events.mixTo(Info);
	module.exports = Info;

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */,
/* 611 */,
/* 612 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"c-info\">\n    <div class=\"c-channel__content\">\n        <div class=\"c-channel__icon\" style=\"background-image:url(")
	    ; __append(escape(channelIcon))
	    ; __append(");\"></div>\n        <div class=\"c-channel__name\">")
	    ; __append(escape(channelName))
	    ; __append("</div>\n       ")
	    ;  if (isApp) { 
	    ; __append("\n         <div class=\"c-channel__subscribe plus\">关注</div>\n        ")
	    ; }
	    ; __append("\n    </div>\n    ")
	    ;  if (showOnlineNum) { 
	    ; __append("\n        <div class=\"c-visite\"><span class=\"num\"></span>人参与</div>\n    ")
	    ;  } 
	    ; __append("\n    <div class=\"c-info__btn selected\">详情</div>\n</div>\n<div class=\"c-info__content\">\n    ")
	    ; __append(escape(intro))
	    ; __append("\n</div>\n\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Events = __webpack_require__(104);
	__webpack_require__(614);
	var tmpl = __webpack_require__(629);
	
	var MiniInput = function MiniInput(options) {
	    this.desc = options.desc || '我要说两句';
	    this.value = '';
	    this.isAdmire = false;
	    this.init();
	    this.isClear = false;
	};
	
	MiniInput.prototype.init = function () {
	    this.initDom();
	    this.initEvent();
	};
	
	MiniInput.prototype.initDom = function () {
	    this.el = $(tmpl({ desc: this.desc }));
	    this.eltalk = this.el.filter('.c-talk');
	    this.elclear = this.el.filter('.c-talk__clear');
	    this.elInput = this.eltalk.find('.c-talk__input span');
	    this.elcollect = this.el.find('.c-talk__collect');
	};
	
	MiniInput.prototype.initEvent = function () {
	    this.eltalk.on('touchend', '.c-talk__input', function () {
	        this.trigger('click');
	        return false;
	    }.bind(this));
	
	    this.eltalk.on('touchend', '.c-talk__share', function () {
	        this.trigger('share');
	        return false;
	    }.bind(this));
	
	    this.eltalk.on('touchend', '.c-talk__gift', function () {
	        this.trigger('gift');
	        return false;
	    }.bind(this));
	    this.eltalk.on('touchend', '.c-talk__collect', function () {
	        var sta = true;
	        if (this.elcollect && this.elcollect.hasClass('c-talk__collected')) {
	            sta = false;
	        }
	        this.trigger('collect', sta);
	        return false;
	    }.bind(this));
	    this.eltalk.on('touchend', '.c-talk__back', function () {
	        this.trigger('exit');
	        return false;
	    }.bind(this));
	
	    this.elclear.on('touchend', function () {
	        if (!this.isClear) {
	            this.clear();
	        } else {
	            this.unclear();
	        }
	        return false;
	    }.bind(this));
	};
	
	MiniInput.prototype.hide = function () {
	    this.eltalk.stop().animate({
	        opacity: '0'
	    });
	    this.eltalk.addClass('nopointer');
	    this.elclear.stop().animate({
	        opacity: '0'
	    });
	};
	
	MiniInput.prototype.text = function (val) {
	    val = val || this.desc;
	    this.elInput.text(val);
	    if (val) {
	        this.value = val;
	    }
	};
	
	MiniInput.prototype.isCollected = function () {
	    if (!this.elcollect.hasClass('c-talk__collected')) {
	        this.elcollect.addClass('c-talk__collected');
	    }
	};
	MiniInput.prototype.collect = function (sta) {
	    if (this.elcollect.hasClass('c-talk__collect_scale')) {
	        this.elcollect.removeClass('c-talk__collect_scale');
	    }
	    if (this.elcollect.hasClass('c-talk__collect_scale1')) {
	        this.elcollect.removeClass('c-talk__collect_scale1');
	    }
	    if (sta) {
	        this.elcollect.addClass('c-talk__collect_scale').addClass('c-talk__collected');
	    } else {
	        this.elcollect.addClass('c-talk__collect_scale1').removeClass('c-talk__collected');
	    }
	};
	
	MiniInput.prototype.show = function () {
	    this.eltalk.stop().animate({
	        opacity: '1'
	    });
	    this.eltalk.removeClass('nopointer');
	    this.elclear.stop().animate({
	        opacity: '1'
	    });
	};
	
	MiniInput.prototype.hideShare = function () {
	    $(this.eltalk).find('.c-talk__share').hide();
	};
	
	MiniInput.prototype.hideInputAndGift = function () {
	    $(this.eltalk).find('.c-talk__input').hide();
	    $(this.eltalk).find('.c-talk__gift').hide();
	};
	
	MiniInput.prototype.showInput = function () {
	    $(this.eltalk).find('.c-talk__input').show();
	    $(this.eltalk).find('.c-talk__gift').show();
	};
	
	MiniInput.prototype.hideMiniInput = function () {
	    $(this.eltalk).hide();
	};
	
	MiniInput.prototype.showMiniInput = function () {
	    $(this.eltalk).show();
	};
	MiniInput.prototype.checkIsCollected = function () {
	    this.trigger('check_isCollected');
	};
	
	MiniInput.prototype.showBackAndShare = function () {
	    // $(this.eltalk).find('.c-talk__back').show();
	    $(this.eltalk).find('.c-talk__hold').show();
	    // $(this.eltalk).find('.c-talk__shift').show();
	};
	
	MiniInput.prototype.hideBackAndShare = function () {
	    // $(this.eltalk).find('.c-talk__back').hide();
	    $(this.eltalk).find('.c-talk__hold').hide();
	};
	
	MiniInput.prototype.hideCollect = function () {
	    this.elcollect.hide();
	};
	
	MiniInput.prototype.showCollect = function () {
	    this.elcollect.show();
	};
	
	MiniInput.prototype.clear = function () {
	    this.elclear.addClass('unclear');
	    this.isClear = true;
	    this.trigger('clear');
	};
	
	MiniInput.prototype.unclear = function () {
	    this.elclear.removeClass('unclear');
	    this.trigger('unclear');
	    this.isClear = false;
	};
	
	MiniInput.prototype.renderTo = function (parentNode) {
	    $(parentNode).append(this.el);
	};
	
	Events.mixTo(MiniInput);
	module.exports = MiniInput;

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<section class=\"c-talk\">\n  <!-- 取消底部返回按钮 -->\n  <!-- <div class=\"c-talk__back\"></div> -->\n  <div class=\"c-talk__hold\"></div>\n  <div class=\"c-talk__input\"><span>")
	    ; __append(escape(desc))
	    ; __append("</span></div>\n  ")
	    ;  if(window.location.href.indexOf('__isUser=true') < 0) { 
	    ; __append("\n    <div class=\"c-talk__gift\"></div>\n  ")
	    ;  } 
	    ; __append("\n  <div class=\"c-talk__collect\"></div>\n  <div class=\"c-talk__share\"></div>\n</section>\n<div class=\"c-talk__clear\"></div>")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	'use strict';
	
	var share = function share(shareConfig) {
	    // 微信分享api
	    var sharetitle = shareConfig.sharetitle;
	    var sharelink = shareConfig.sharelink;
	    var shareimgUrl = shareConfig.shareimgUrl;
	    var sharedesc = shareConfig.sharedesc;
	
	    $.ajax({
	        url: '//api.cmpp.v.ifeng.com/api/Secert',
	        type: 'get',
	        dataType: 'jsonp',
	        callback: 'wxshareCallback',
	        data: {
	            url: window.location.href,
	            rt: 'jsonp'
	        },
	        success: function success(msgCallback) {
	            var msgData = msgCallback.data || {};
	            wx.config({
	                debug: false,
	                appId: msgData.appId,
	                timestamp: msgData.timestamp,
	                nonceStr: msgData.nonceStr,
	                signature: msgData.signature,
	                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo'
	                // 所有要调用的 API 都要加到这个列表中
	                ]
	            });
	            wx.ready(function () {
	                wx.checkJsApi({
	                    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
	                    success: function success(res) {
	                        // 以键值对的形式返回，可用的api值true，不可用为false
	                        console.log(res);
	                    }
	                });
	
	                wx.error(function (res) {
	                    console.log(res);
	                });
	                // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
	                wx.onMenuShareTimeline({
	                    title: sharetitle, // 分享标题
	                    link: sharelink, // 分享链接
	                    imgUrl: shareimgUrl, // 分享图标
	                    success: function success() {
	                        // 用户确认分享后执行的回调函数
	                    },
	                    cancel: function cancel() {
	                        // 用户取消分享后执行的回调函数
	                    }
	                });
	                // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
	                wx.onMenuShareAppMessage({
	                    title: sharetitle, // 分享标题
	                    desc: sharedesc, // 分享描述
	                    link: sharelink, // 分享链接
	                    imgUrl: shareimgUrl, // 分享图标
	                    type: 'link', // 分享类型,music、video或link，不填默认为link
	                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
	                    success: function success() {
	                        // 用户确认分享后执行的回调函数
	                    },
	                    cancel: function cancel() {
	                        // 用户取消分享后执行的回调函数
	                    }
	                });
	                // 获取“分享到QQ”按钮点击状态及自定义分享内容接口
	                wx.onMenuShareQQ({
	                    title: sharetitle, // 分享标题
	                    desc: sharedesc, // 分享描述
	                    link: sharelink, // 分享链接
	                    imgUrl: shareimgUrl, // 分享图标
	                    success: function success() {
	                        // 用户确认分享后执行的回调函数
	                        // alert(shareimgUrl);
	                    },
	                    cancel: function cancel() {
	                        // 用户取消分享后执行的回调函数
	                    }
	                });
	                // 获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
	                wx.onMenuShareWeibo({
	                    title: sharetitle, // 分享标题
	                    desc: sharedesc, // 分享描述
	                    link: sharelink, // 分享链接
	                    imgUrl: shareimgUrl, // 分享图标
	                    success: function success() {
	                        // 用户确认分享后执行的回调函数
	                    },
	                    cancel: function cancel() {
	                        // 用户取消分享后执行的回调函数
	                    }
	                });
	
	                // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
	                wx.onMenuShareTimeline({
	                    title: sharetitle, // 分享标题
	                    link: sharelink, // 分享链接
	                    imgUrl: shareimgUrl, // 分享图标
	                    success: function success() {
	                        // 用户确认分享后执行的回调函数
	                    },
	                    cancel: function cancel() {
	                        // 用户取消分享后执行的回调函数
	                    }
	                });
	            });
	        }
	    });
	};
	
	module.exports = share;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var deselectCurrent = __webpack_require__(632);
	
	var defaultMessage = "Copy to clipboard: #{key}, Enter";
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug,
	    message,
	    reselectPrevious,
	    range,
	    selection,
	    mark,
	    success = false;
	  if (!options) {
	    options = {};
	  }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement("span");
	    mark.textContent = text;
	    // reset user styles for span element
	    mark.style.all = "unset";
	    // prevents scrolling to the end of the page
	    mark.style.position = "fixed";
	    mark.style.top = 0;
	    mark.style.clip = "rect(0, 0, 0, 0)";
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = "pre";
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = "text";
	    mark.style.MozUserSelect = "text";
	    mark.style.msUserSelect = "text";
	    mark.style.userSelect = "text";
	    mark.addEventListener("copy", function(e) {
	      e.stopPropagation();
	      if (options.format) {
	        e.preventDefault();
	        e.clipboardData.clearData();
	        e.clipboardData.setData(options.format, text);
	      }
	    });
	
	    document.body.appendChild(mark);
	
	    range.selectNodeContents(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand("copy");
	    if (!successful) {
	      throw new Error("copy command was unsuccessful");
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error("unable to copy using execCommand: ", err);
	    debug && console.warn("trying IE specific stuff");
	    try {
	      window.clipboardData.setData(options.format || "text", text);
	      success = true;
	    } catch (err) {
	      debug && console.error("unable to copy using clipboardData: ", err);
	      debug && console.error("falling back to prompt");
	      message = format("message" in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == "function") {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ }),
/* 632 */
/***/ (function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by dreamc_t on 2017/4/7.
	 */
	__webpack_require__(634);
	var tmpl = __webpack_require__(638);
	var util = __webpack_require__(404);
	var formatImage = __webpack_require__(639);
	
	var relatedNews = function relatedNews(options, native) {
	    this.options = options;
	    this.native = native;
	    this.init();
	};
	
	var __getUrlParams = function __getUrlParams() {
	    var result = {};
	    var params = window.location.search.substring(1).split('&');
	    var param = void 0;
	
	    for (var i = 0, iLen = params.length; i < iLen; i++) {
	        param = params[i].split('=');
	        if (param.length == 2) {
	            result[param[0]] = decodeURIComponent(param[1]);
	        }
	    }
	
	    return result;
	};
	
	var __urlParams = __getUrlParams();
	
	var url = '//d.ifengimg.com/w104_h74/';
	relatedNews.prototype.init = function () {
	    this.info = this.options.info;
	};
	
	relatedNews.prototype.requestData = function () {
	    var data = {
	        column: this.info.columnId,
	        page: 1,
	        pagesize: 20,
	        format: 'js',
	        rt: 'jsonp'
	    };
	    return $.ajax({
	        url: this.info.requestUrl,
	        type: 'GET',
	        data: data,
	        cache: true,
	        dataType: 'jsonp'
	        // jsonpCallback: 'jsonpCallback'
	    });
	};
	
	relatedNews.prototype.initDom = function (relateData) {
	    if (!relateData.code) {
	        var list = relateData.data.data;
	        var item = [];
	        var result = [];
	        if (list.length > 0) {
	            for (var i = 0; i < list.length; i++) {
	                item = list[i];
	                if (item.id !== __urlParams.liveid) {
	                    if (!this.native.isApp) {
	                        item.link = '//izhibo.ifeng.com/live.html?liveid=' + item.id;
	                    }
	                    item.date = compareDate(item.starttime * 1000) || formatDate(item.starttime * 1000);
	                    item.time = formatTime(item.starttime * 1000);
	                    if (item.status + '' === '2') {
	                        item.status = '预告';
	                        item.statusClass = 'prefiled';
	                    } else if (item.status + '' === '1') {
	                        item.status = '直播中';
	                        item.statusClass = 'active';
	                    } else if (item.status + '' === '3') {
	                        item.status = '回顾';
	                        item.statusClass = 'end';
	                    }
	                    item.thumb = formatImage(item.thumb_new, 272, 123, 70);
	                    result.push(item);
	                }
	            }
	            this.el = $(tmpl({ items: result }));
	            return this.el;
	        } else {
	            this.el = $(tmpl({ items: [] }));
	            return this.el;
	        }
	    } else {
	        console.log(relateData.msg);
	    }
	};
	
	relatedNews.prototype.initEvent = function () {
	    var self = this;
	    this.elList = this.el[0].querySelector('.re-list');
	    util.tap(this.elList, function (e) {
	        if (self.native.isApp) {
	            var from = this.dataset.from;
	            var id = this.dataset.id;
	            if (from == 'h5') {
	                self.native.openH5(id, self.options.info.mode);
	            } else {
	                self.native.openNative(id);
	            }
	        } else {
	            window.open('//izhibo.ifeng.com/live.html?liveid=' + this.dataset.id);
	        }
	    }, {
	        delegate: '.re-item'
	    });
	
	    this.el[0].addEventListener('touchstart', function () {
	        if (this.scrollTop === 0) {
	            this.scrollTop = 1; // 防止拖动全页面
	        }
	    });
	};
	
	// 获取count天后的日期
	function getDateStr(count) {
	    var date = new Date();
	    date.setDate(date.getDate() + count);
	    var year = date.getFullYear();
	    var month = date.getMonth() + 1;
	    var day = date.getDate();
	    return year + '-' + add0(month) + '-' + add0(day);
	}
	
	function add0(m) {
	    return m < 10 ? '0' + m : m;
	}
	
	// 日期格式化
	function formatDate(time) {
	    var time = new Date(time);
	    var y = time.getFullYear();
	    var m = time.getMonth() + 1;
	    var d = time.getDate();
	
	    return y + '-' + add0(m) + '-' + add0(d);
	}
	
	// 时间格式化
	function formatTime(time) {
	    var time = new Date(time);
	    var h = time.getHours();
	    var mm = time.getMinutes();
	
	    return add0(h) + ':' + add0(mm);
	}
	
	// 判断今天、明天、昨天
	function compareDate(time) {
	    var date = formatDate(time);
	    if (date === getDateStr(0)) {
	        return '今天 ';
	    } else if (date === getDateStr(1)) {
	        return '明天 ';
	    } else {
	        return false;
	    }
	}
	
	relatedNews.prototype.renderTo = function (parentNode) {
	    var self = this;
	    var request = _promise2.default.resolve(this.requestData());
	    request.then(function (data) {
	        var ele = self.initDom(data);
	        parentNode.innerHTML = '';
	        parentNode.appendChild(ele[0]);
	        self.initEvent();
	    });
	};
	
	module.exports = relatedNews;

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("\n\n<div class=\"related\">\n    <ul class=\"re-list\">\n        ")
	    ;  for (var i=0;i<items.length;i++){
	    ; __append("\n        <li class=\"re-item clearfix\"  data-id=\"")
	    ; __append(escape(items[i].id))
	    ; __append("\" data-from=\"")
	    ; __append(escape(items[i].from))
	    ; __append("\">\n            <div class=\"re-image fl\">\n                <div >\n                    <img src=\"")
	    ; __append(escape(items[i].thumb))
	    ; __append("\" alt=\"")
	    ; __append(escape(items[i].title))
	    ; __append("\">\n                </div>\n\n            </div>\n            <div class=\"re-info fr\">\n                <div class=\"re-detail\">\n                    <p class=\"info\" >\n                        ")
	    ; __append(escape(items[i].title))
	    ; __append("\n                    </p>\n                    <p class=\"state\">\n                        <span class=\"status ")
	    ; if (items[i].statusClass== 'active') {
	    ; __append(escape(items[i].statusClass))
	    ; }else if(items[i].statusClass == 'end'){
	    ; __append("endbox")
	    ; }
	    ; __append("\">\n                            <span class=\"")
	    ; __append(escape(items[i].statusClass))
	    ; __append("\">\n                                ")
	    ; __append(escape(items[i].status))
	    ; __append("\n                            </span>\n                        </span>\n                        <span class=\"time\">")
	    ; __append(escape(items[i].date))
	    ; __append(" ")
	    ; __append(escape(items[i].time))
	    ; __append("</span>\n                    </p>\n                </div>\n            </div>\n        </li>\n        ")
	    ; }
	    ; __append("\n    </ul>\n</div>\n\n\n\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * 将前面的裁图前缀,参数以及协议头去掉
	 * @param {*} url 要清洗的 url
	 * @return {String} url
	 */
	var clear = function clear(url) {
	    try {
	        if (!url) {
	            return url;
	        }
	        if (url.includes('d.ifengimg.com/')) {
	            url = url.split('d.ifengimg.com/').pop();
	            var paths = url.split('/');
	
	            paths.shift();
	            url = paths.join('/');
	        }
	
	        if (url.includes('http://')) {
	            url = url.substring(7);
	        }
	
	        if (url.includes('https://')) {
	            url = url.substring(8);
	        }
	
	        if (url.includes('//')) {
	            url = url.substring(2);
	        }
	
	        return url;
	    } catch (error) {
	        console.error(error);
	
	        return url;
	    }
	};
	
	var ifengImgDomain = ['y0.ifengimg.com', 'y1.ifengimg.com', 'y2.ifengimg.com', 'y3.ifengimg.com', 'm0.ifengimg.com', 'm1.ifengimg.com', 'm2.ifengimg.com', 'm3.ifengimg.com', 'img.ifeng.com', 'mimg.ifeng.com', 's0.mimg.ifeng.com', 's1.mimg.ifeng.com', 's2.mimg.ifeng.com', 's3.mimg.ifeng.com', 's4.mimg.ifeng.com', 'a0.ifengimg.com', 'a1.ifengimg.com', 'a2.ifengimg.com', 'a3.ifengimg.com', 's0.ifengimg.com', 's1.ifengimg.com', 's2.ifengimg.com', 's3.ifengimg.com', 'res.ent.ifeng.com', 'res.news.ifeng.com', 'res.fashion.ifeng.com', 'blogfile.ifeng.com', 'entimg.ifeng.com', 'res.health.ifeng.com', 'res.book.ifeng.com', 'imgs.diantai.ifeng.com', 'img.ugc.ifeng.com', 'img1.ugc.ifeng.com', 'res.phtv.ifeng.com', 'bbsfile.ifeng.com', 'res.img.ifeng.com', 'c0.ifengimg.com', 'c1.ifengimg.com', 'p0.ifengimg.com', 'p1.ifengimg.com', 'p2.ifengimg.com', 'p3.ifengimg.com', 'q0.ifengimg.com', 'p0.iikuzhan.com', 'yj.fcai.com', 'my.ifengimg.com', 'sy.ifeng.com', 'c0.fengshows.com', 'c1.fengshows.com', 'p0.fengshows.com', 'p1.fengshows.com', 'p2.fengshows.com', 'p3.fengshows.com', 'y0.fengshows.com', 'y1.fengshows.com', 'y2.fengshows.com', 'y3.fengshows.com', 'e0.ifengimg.com'];
	
	/**
	 * 判断域名是否为公司的
	 * @param {string} url
	 * @return {Boolean} bool
	 */
	var checkDomain = function checkDomain(url) {
	    try {
	        if (!url) {
	            return url;
	        }
	        var domain = url.split('/')[0];
	
	        if (ifengImgDomain.includes(domain)) return true;
	
	        return false;
	    } catch (error) {
	        console.error(error);
	
	        return false;
	    }
	};
	
	/**
	 * 裁剪图片方法
	 * @param {string} url 系统提供的图片地址
	 * @param {number} width 图片裁切宽度
	 * @param {number} height 图片裁切高度
	 * @param {number} quality 图片裁切质量，默认70，最大值100，一般可以不填，不建议写100
	 * @return {String} url
	 */
	var formatImage = function formatImage(url, width, height) {
	    var quality = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 70;
	
	    try {
	        if (!url) {
	            return url;
	        }
	        url = clear(url.trim());
	
	        if (!checkDomain(url)) return '//' + url;
	
	        var params = [];
	
	        if (width) {
	            params.push('w' + width);
	        }
	
	        if (height) {
	            params.push('h' + height);
	        }
	
	        if (quality) {
	            params.push('q' + quality);
	        }
	
	        return '//d.ifengimg.com/' + params.join('_') + '/' + clear(url);
	    } catch (error) {
	        console.error(error);
	
	        return url;
	    }
	};
	
	module.exports = formatImage;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _keys = __webpack_require__(105);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by dreamc_t on 2017/4/7.
	 */
	__webpack_require__(641);
	var tmpl = __webpack_require__(650);
	
	// 线上http://api.livesports.ifeng.com // 本地接口http://10.21.7.47:8099
	var apiDomain = '//api.livesports.ifeng.com';
	var requestUrl = apiDomain + '/livesports/events/eventslist?'; // 事件数据
	var eventlistUrl = apiDomain + '/livesports/events/eventsstatus?'; // 所有事件状态
	
	
	var sportsEventData = function sportsEventData(info) {
	    this.info = info;
	    this.initEventSta = false;
	};
	Array.prototype.removeRepeat = function () {
	    var arr = this,
	        i,
	        obj = {},
	        result = [];
	    for (i = 0; i < arr.length; i++) {
	        if (!obj[arr[i].status]) {
	            //如果能查找到，证明数组元素重复了
	            obj[arr[i].status] = 1;
	            result.push(arr[i]);
	        }
	    }
	    return result;
	};
	sportsEventData.prototype.requestEventStatus = function () {
	    return $.ajax({
	        url: eventlistUrl,
	        type: 'GET',
	        data: {
	            rt: 'jsonp'
	        },
	        cache: true,
	        dataType: 'jsonp'
	    });
	};
	sportsEventData.prototype.requestData = function () {
	    var _this = this;
	    return $.ajax({
	        url: requestUrl,
	        type: 'GET',
	        data: {
	            mid: _this.info.matchId,
	            rt: 'jsonp'
	        },
	        cache: true,
	        dataType: 'jsonp'
	    });
	};
	
	sportsEventData.prototype.endPolling = function (timer) {
	    clearTimeout(timer);
	};
	sportsEventData.prototype.setTimeForData = function () {
	    clearTimeout(this.timerForEvent);
	    this.timerForEvent = setTimeout(function () {
	        // 当前tab是数据，则请求并渲染
	        var cur = document.querySelector('.c-slider__item--active');
	        if (cur.getAttribute('data-type') == 'eventData') {
	            this.renderTo(cur, true);
	        }
	    }.bind(this), 240000); // 4min
	};
	sportsEventData.prototype.initEvent = function () {
	    this.initEventSta = true;
	    // 轮询获取新数据
	    this.setTimeForData();
	};
	sportsEventData.prototype.formatData = function (data) {
	    var _this = this;
	    var list = data.eventsList || [];
	    var hasData = (0, _keys2.default)(list).length || 0;
	    (0, _keys2.default)(list).forEach(function (key) {
	        var timeArr = list[key] || []; // 同时间的事件列表
	        // 处理前5个状态的描述
	        timeArr.map(function (item) {
	            if (item.status && parseInt(item.status) <= 5) {
	                var target = _this.eventStatus.filter(function (event) {
	                    return event.value == item.status;
	                });
	                item.desc = target && target.length ? target[0].label : '';
	            }
	            return item;
	        });
	        var special = timeArr.filter(function (time) {
	            return parseInt(time.status) <= 5;
	        }).removeRepeat(); // 去重
	        special.length > 1 && special.sort(function (v1, v2) {
	            return parseInt(v1.status) - parseInt(v2.status);
	        }); // 小于5的排序
	
	        var left = timeArr.filter(function (item) {
	            return item.team && parseInt(item.team) == 0; // 主队
	        });
	        var right = timeArr.filter(function (item) {
	            return item.team && parseInt(item.team) == 1; // 主队
	        });
	        list[key] = {
	            time: key,
	            md: special || [],
	            left: left || [],
	            right: right || []
	        };
	    });
	    return {
	        list: list,
	        hasData: hasData
	    };
	};
	sportsEventData.prototype.initDom = function (result) {
	    this.el = $(tmpl({ data: result }));
	    return this.el;
	};
	sportsEventData.prototype.appendChild = function (parentNode, ele) {
	    if (ele[0]) {
	        if (document.getElementsByClassName('sports-event').length) {
	            // 移除之前的
	            parentNode.removeChild(document.getElementsByClassName('sports-event')[0]);
	        }
	        parentNode.insertBefore($(this.el)[0], parentNode.firstChild);
	    }
	};
	sportsEventData.prototype.renderTo = function (parentNode, polling) {
	    var _this2 = this;
	
	    var self = this;
	    // 先请求所有事件状态，再请求历史数据
	    var request = _promise2.default.resolve(this.requestEventStatus());
	    request.then(function (data) {
	        // console.log('requestEventStatus---data', data);
	        if (data && data.code == 0) {
	            // 记录所有事件状态
	            self.eventStatus = data.data;
	            return data.data;
	        } else {
	            throw new Error(data.message);
	        }
	    }).then(function () {
	        return _this2.requestData();
	    }).then(function (data) {
	        // console.log('requestData---data-', data);
	        if (data && data.code == 0) {
	            var newData = self.formatData(data.data || {});
	            var ele = self.initDom(newData);
	            self.appendChild(parentNode, ele);
	            // parentNode.appendChild(ele[0]);
	            !self.initEventSta && self.initEvent(); // 首次初始化
	        } else {
	            throw new Error(data.message);
	        }
	        // 返回处理
	    }).catch(function (e) {
	        // console.log('e', e);
	        alert(e);
	    }).finally(function () {
	        polling && self.setTimeForData(); // 轮询，获取数据
	    });
	};
	
	module.exports = sportsEventData;

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ;  if (data){
	    ; __append("\n    <div class=\"sports-event\">\n        <!-- <div class=\"title\">\n            <h3>比赛数据</h3>\n        </div> -->\n        ")
	    ;  if (data.hasData > 0){
	    ; __append("\n        <div class=\"box\">\n            <div class=\"list\">\n                <!-- <div class=\"item both\">\n                    <div class=\"info\">\n                        <div class=\"ht left\">哥斯达黎加</div>\n                        <div class=\"time\">vs</div>\n                        <div class=\"vt right\">阿根廷</div>\n                    </div>\n                </div> -->\n\n                ")
	    ;  var keys = Object.keys(data.list) ||[] 
	    ; __append("\n                ")
	    ;  for (var i=0;i<keys.length;i++){ 
	    ; __append("\n                    ")
	    ;  var item = data.list[keys[i]] 
	    ; __append("\n                    ")
	    ;  var md = item.md; var left = item.left; var right = item.right; var time = item.time; 
	    ; __append("\n                    ")
	    ;  if(md.length > 0){ 
	    ; __append("\n                        ")
	    ;  for (var j=0;j<md.length;j++){ 
	    ; __append("\n                            ")
	    ;  if(md[j].status != 5 && md[j].status != 3){ 
	    ; __append("\n                                <div class=\"item md\" >\n                                    <div class=\"event\">")
	    ; __append(escape(md[j].desc))
	    ; __append("</div>\n                                </div>\n                            ")
	    ;  } 
	    ; __append("\n                        ")
	    ;  } 
	    ; __append("\n                    ")
	    ;  } 
	    ; __append("\n                    ")
	    ;  if(left.length > 0 && right.length > 0){ 
	    ; __append("\n                        <div class=\"item both\">\n                            <div class=\"both-lf\">\n                                    <div class=\"left-events\">\n                                            ")
	    ;  for (var k=0;k<left.length;k++){ 
	    ; __append("\n                                                ")
	    ;  if(left[k].status == 10){ 
	    ; __append("\n                                                    <div class=\"event-item\">\n                                                        <div class=\"who\">")
	    ; __append(escape(left[k].desc.split('|')[0]))
	    ; __append("上场</div>\n                                                        <div class=\"go\"></div>\n                                                    </div>\n                                                    <div class=\"event-item\">\n                                                        <div class=\"who\">")
	    ; __append(escape(left[k].desc.split('|')[1]))
	    ; __append("下场</div>\n                                                        <div class=\"leave\"></div>\n                                                    </div>\n                                                ")
	    ;  }else{ 
	    ; __append("\n                                                    <div class=\"event-item\">\n                                                        <div class=\"who\">")
	    ; __append(escape(left[k].desc))
	    ; __append("</div>\n                                                        ")
	    ;  if(left[k].status == 7){ 
	    ; __append("\n                                                                <div class=\"inBall\"></div>\n                                                        ")
	    ;  } else if(left[k].status == 6){ 
	    ; __append("\n                                                                <div class=\"help\"></div>\n                                                        ")
	    ;  } else if(left[k].status == 8){ 
	    ; __append("\n                                                            <div class=\"warn-red\"></div>\n                                                        ")
	    ;  } else if(left[k].status == 9){ 
	    ; __append("\n                                                            <div class=\"warn-yellow\"></div>\n                                                        ")
	    ;  } 
	    ; __append("\n                                                    </div>\n                                                ")
	    ;  } 
	    ; __append("\n                                            ")
	    ;  } 
	    ; __append("\n                                        </div>\n                            </div>\n\n                            <div class=\"time\">")
	    ; __append(escape(time))
	    ; __append("'</div>\n                            <div class=\"both-rf\">\n                                    <div class=\"right-events\">\n                                            ")
	    ;  for (var l=0;l<right.length;l++){ 
	    ; __append("\n                                                ")
	    ;  if(right[l].status == 10){ 
	    ; __append("\n                                                <div class=\"event-item\">\n                                                    <div class=\"go\"></div>\n                                                    <div class=\"who\">")
	    ; __append(escape(right[l].desc.split('|')[0]))
	    ; __append("上场</div>\n                                                </div>\n                                                <div class=\"event-item\">\n                                                    <div class=\"leave\"></div>\n                                                    <div class=\"who\">")
	    ; __append(escape(right[l].desc.split('|')[1]))
	    ; __append("下场</div>\n                                                </div>\n                                                ")
	    ;  }else{ 
	    ; __append("\n                                                <div class=\"event-item\">\n                                                    ")
	    ;  if(right[l].status == 7){ 
	    ; __append("\n                                                        <div class=\"inBall\"></div>\n                                                    ")
	    ;  } else if(right[l].status == 6){ 
	    ; __append("\n                                                        <div class=\"help\"></div>\n                                                    ")
	    ;  } else if(right[l].status == 8){ 
	    ; __append("\n                                                        <div class=\"warn-red\"></div>\n                                                    ")
	    ;  } else if(right[l].status == 9){ 
	    ; __append("\n                                                        <div class=\"warn-yellow\"></div>\n                                                    ")
	    ;  } 
	    ; __append("\n                                                    <div class=\"who\">")
	    ; __append(escape(right[l].desc))
	    ; __append("</div>\n                                                </div>\n                                                ")
	    ;  } 
	    ; __append("\n                                            ")
	    ;  } 
	    ; __append("\n                                        </div>\n                            </div>\n\n                        </div>\n                    ")
	    ;  } 
	    ; __append("\n                    ")
	    ;  if(left.length > 0 && right.length == 0){ 
	    ; __append("\n                        <div class=\"item lf\">\n                            <div class=\"info\">\n                                <div class=\"time\">")
	    ; __append(escape(time))
	    ; __append("'</div>\n                                <div class=\"left-events\">\n                                    ")
	    ;  for (var k=0;k<left.length;k++){ 
	    ; __append("\n\n                                        ")
	    ;  if(left[k].status == 10){ 
	    ; __append("\n                                            <div class=\"event-item\">\n                                                <div class=\"who\">")
	    ; __append(escape(left[k].desc.split('|')[0]))
	    ; __append("上场</div>\n                                                <div class=\"go\"></div>\n                                            </div>\n                                            <div class=\"event-item\">\n                                                <div class=\"who\">")
	    ; __append(escape(left[k].desc.split('|')[1]))
	    ; __append("下场</div>\n                                                <div class=\"leave\"></div>\n                                            </div>\n                                        ")
	    ;  }else{ 
	    ; __append("\n                                            <div class=\"event-item\">\n                                                <div class=\"who\">")
	    ; __append(escape(left[k].desc))
	    ; __append("</div>\n                                                ")
	    ;  if(left[k].status == 7){ 
	    ; __append("\n                                                        <div class=\"inBall\"></div>\n                                                ")
	    ;  } else if(left[k].status == 6){ 
	    ; __append("\n                                                        <div class=\"help\"></div>\n                                                ")
	    ;  } else if(left[k].status == 8){ 
	    ; __append("\n                                                    <div class=\"warn-red\"></div>\n                                                ")
	    ;  } else if(left[k].status == 9){ 
	    ; __append("\n                                                    <div class=\"warn-yellow\"></div>\n                                                ")
	    ;  } 
	    ; __append("\n                                            </div>\n                                        ")
	    ;  } 
	    ; __append("\n\n                                    ")
	    ;  } 
	    ; __append("\n                                </div>\n                            </div>\n                        </div>\n                    ")
	    ;  } 
	    ; __append("\n                    ")
	    ;  if(left.length == 0 && right.length > 0){ 
	    ; __append("\n                        <div class=\"item rf\">\n                            <div class=\"info\">\n                                <div class=\"time\">")
	    ; __append(escape(time))
	    ; __append("'</div>\n                                <div class=\"right-events\">\n                                    ")
	    ;  for (var l=0;l<right.length;l++){ 
	    ; __append("\n                                        ")
	    ;  if(right[l].status == 10){ 
	    ; __append("\n                                        <div class=\"event-item\">\n                                            <div class=\"go\"></div>\n                                            <div class=\"who\">")
	    ; __append(escape(right[l].desc.split('|')[0]))
	    ; __append("上场</div>\n                                        </div>\n                                        <div class=\"event-item\">\n                                            <div class=\"leave\"></div>\n                                            <div class=\"who\">")
	    ; __append(escape(right[l].desc.split('|')[1]))
	    ; __append("下场</div>\n                                        </div>\n                                        ")
	    ;  }else{ 
	    ; __append("\n                                        <div class=\"event-item\">\n                                            ")
	    ;  if(right[l].status == 7){ 
	    ; __append("\n                                                <div class=\"inBall\"></div>\n                                            ")
	    ;  } else if(right[l].status == 6){ 
	    ; __append("\n                                                <div><div class=\"help\"></div></div>\n                                            ")
	    ;  } else if(right[l].status == 8){ 
	    ; __append("\n                                                <div class=\"warn-red\"></div>\n                                            ")
	    ;  } else if(right[l].status == 9){ 
	    ; __append("\n                                                <div class=\"warn-yellow\"></div>\n                                            ")
	    ;  } 
	    ; __append("\n                                            <div class=\"who\">")
	    ; __append(escape(right[l].desc))
	    ; __append("</div>\n                                        </div>\n                                        ")
	    ;  } 
	    ; __append("\n                                    ")
	    ;  } 
	    ; __append("\n                                </div>\n                            </div>\n                        </div>\n                    ")
	    ;  } 
	    ; __append("\n                    ")
	    ;  if(md.length > 0){ 
	    ; __append("\n                        ")
	    ;  for (var j=0;j<md.length;j++){ 
	    ; __append("\n                        ")
	    ;  if(md[j].status == 5 || md[j].status == 3){ 
	    ; __append("\n                            <div class=\"item md\" ")
	    ;  if(md[j].status == 5){ 
	    ; __append("style=\"padding-bottom: 0\"")
	    ;  } 
	    ; __append(">\n                                <div class=\"event\">")
	    ; __append(escape(md[j].desc))
	    ; __append("</div>\n                            </div>\n                        ")
	    ;  } 
	    ; __append("\n                        ")
	    ;  } 
	    ; __append("\n                    ")
	    ;  } 
	    ; __append("\n                ")
	    ;  } 
	    ; __append("\n            </div>\n        </div>\n        ")
	    ;  } else{ 
	    ; __append("\n        <div class=\"box-nodata\">\n            <p>暂无比赛数据</p>\n        </div>\n        ")
	    ;  } 
	    ; __append("\n    </div>\n    ")
	    ;  } 
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(105);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _parseFloat = __webpack_require__(652);
	
	var _parseFloat2 = _interopRequireDefault(_parseFloat);
	
	var _assign = __webpack_require__(79);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by dreamc_t on 2017/4/7.
	 */
	__webpack_require__(658);
	var tmpl = __webpack_require__(665);
	var tmplMatchInfo = __webpack_require__(666);
	var tmplSupport = __webpack_require__(667);
	
	// 本地接口http://10.21.7.47:8099   线上http://api.livesports.ifeng.com
	var apiDomain = '//api.livesports.ifeng.com';
	var requestUrl = apiDomain + '/livesports/match/info'; // 志疆-通过赛事id获取赛事信息接口
	var supportGetUrl = apiDomain + '/livesports/survey/surveyres'; // 投票获取接口
	var supportPostUrl = apiDomain + '/livesports/survey/vote'; // 投票提交接口
	
	
	var sportMatch = function sportMatch(info, message, container) {
	    this.info = info;
	    this.message = message;
	    this.container = container;
	    this.initEventSta = false;
	};
	sportMatch.prototype.updateVote = function (fn, params, polling) {
	    // 轮询获取，更新----or----提交返回，更新
	    var self = this;
	    var vote = _promise2.default.resolve(self[fn](params));
	    vote.then(function (data) {
	        // console.log('dingshi--getvote--data-succes-', data);
	        if (data && data.code == 0) {
	            self.updateVoteNum(data);
	        } else {
	            throw new Error(data.message);
	        }
	    }).catch(function (e) {
	        // console.log('updatevote--data-catch-', e);
	    }).finally(function () {
	        polling && self.setTimeForVote(); // 轮询
	    });
	};
	sportMatch.prototype.changeScore = function (datas) {
	    if (datas.code == 1) {
	        var last = this.sportMatchInfo;
	        this.sportMatchInfo = (0, _assign2.default)({}, last, datas.data.data);
	        var datanew = this.formatData(this.sportMatchInfo);
	
	        // 重渲染
	        this.el.find('.match-info').html($(tmplMatchInfo({ data: datanew })));
	        // 广告图, 替换 (上一次存在，则替换，不存在，则新增)
	        datas.data.data.ad && this.el.find('.ad img').attr('src', datanew.ad || '//p0.ifengimg.com/508df9aec9e2a/image/2018/05/28/15274917903605_240_80.png');
	        // sid更新
	        if (datas.data.sid && datas.data.sid !== last.sid) {
	            this.updateVote('requestVote', {});
	        }
	    } else {
	        throw new Error(datas.msg || '有广播，但无数据返回');
	    }
	};
	sportMatch.prototype.postVote = function (postParams) {
	    return $.ajax({
	        url: supportPostUrl,
	        type: 'post',
	        data: postParams,
	        cache: true,
	        dataType: 'jsonp'
	    });
	};
	sportMatch.prototype.updateVoteNum = function (data) {
	    var option = data.data.resultArray.option;
	    this.el.find('.ht .support-num').html(option[0].num || 0);
	    this.el.find('.vt .support-num').html(option[1].num || 0);
	    // 支持率进度
	    var widthHt = this.getPercent(option[0].num, option[1].num);
	    this.el.find('.bar-progress').width(widthHt);
	    if (this.sportMatchInfo.ad) {
	        this.el.find('.ad').css('left', widthHt);
	    }
	};
	sportMatch.prototype.getPercent = function (left, right) {
	    var widthHt = '50%';
	    var total = left + right;
	    if (total !== 0) {
	        var percent = (0, _parseFloat2.default)(left / total).toFixed(2) * 100;
	        widthHt = percent + '%';
	    }
	    return widthHt;
	};
	sportMatch.prototype.formatData = function (data) {
	    data.ad = data.ad || '//p0.ifengimg.com/508df9aec9e2a/image/2018/05/28/15274917903605_240_80.png'; // 默认足球
	    (0, _keys2.default)(data).forEach(function (key) {
	        // 主客队logo
	        if ((key == 'ha' || key == 'va') && data[key]) {
	            var url = data[key];
	            if (url.indexOf('d.ifengimg.com') == -1) {
	                var temp = url.split('/');
	                temp[1] = '/d.ifengimg.com/w80_h80';
	                url = temp.join('/');
	            }
	            data[key] = url;
	        }
	        // 广告素材
	        // if (key == 'ad' && data[key]) {
	        //     let url = data[key];
	        //     if (url.indexOf('d.ifengimg.com') == -1) {
	        //         let temp = url.split('/');
	        //         temp[1] = '/d.ifengimg.com/w240_h80';
	        //         url = temp.join('/');
	        //     }
	        //     data[key] = url;
	        // }
	    });
	    return data;
	};
	sportMatch.prototype.requestVote = function () {
	    var _this = this;
	    return $.ajax({
	        url: supportGetUrl,
	        type: 'get',
	        cache: true,
	        data: {
	            surid: _this.sportMatchInfo.sid,
	            rt: 'jsonp'
	        },
	        dataType: 'jsonp'
	    });
	};
	sportMatch.prototype.requestData = function () {
	    var _this = this;
	    return $.ajax({
	        url: requestUrl,
	        type: 'GET',
	        data: {
	            mid: _this.info.matchId,
	            rt: 'jsonp'
	        },
	        cache: true,
	        dataType: 'jsonp'
	    });
	};
	sportMatch.prototype.appendChild = function (parentNode) {
	    if ($(this.el)[0]) {
	        if (document.getElementsByClassName('top-box').length) {
	            parentNode.parentNode.removeChild(document.getElementsByClassName('top-box')[0]);
	        }
	        parentNode.parentNode.insertBefore($(this.el)[0], parentNode.nextSibling);
	    }
	};
	sportMatch.prototype.initDom = function () {
	    this.el = $(tmpl({}));
	    this.appendChild(this.container);
	    // return {};
	};
	sportMatch.prototype.renderTo = function (parentNode) {
	    var self = this;
	    var request = _promise2.default.resolve(this.initDom());
	    request.then(function () {
	        return self.requestData();
	    }).then(function (result) {
	        if (result && result.code == 0) {
	            var data = result.data;
	            // console.log('renderto--', data);
	            // 获取比赛信息，先渲染
	            self.sportMatchInfo = data;
	            data = self.formatData(data);
	            // console.log('self----', self.el, self.el.find('.match-info'));
	            self.el.find('.match-info').html($(tmplMatchInfo({ data: data })));
	            self.el.find('.match-support').html($(tmplSupport({ data: data })));
	            // 只初始化一次事件方法
	            !self.initEventSta && self.initEvent();
	            return data;
	        } else {
	            alert(result.message);
	        }
	    }).then(function () {
	        return self.requestVote();
	    }).then(function (data) {
	        if (data && data.code == 0) {
	            // 初始化，记录
	            var resultArray = data.data.resultArray;
	            self.qid = resultArray.questionid;
	            self.el.find('.ht').attr('data-itemid', resultArray.option[0].itemid || '');
	            self.el.find('.vt').attr('data-itemid', resultArray.option[1].itemid || '');
	            // 更新投票数
	            self.updateVoteNum(data);
	        } else {
	            throw new Error(data.message);
	        }
	    }).catch(function (e) {
	        console.log('e', e);
	    });
	};
	sportMatch.prototype.setTimeForVote = function () {
	    clearTimeout(this.timerForSupport);
	    this.timerForSupport = setTimeout(function () {
	        var parentNode = document.querySelector('.support-actions');
	        parentNode && this.updateVote('requestVote', {}, true);
	    }.bind(this), 240000); // 4min
	};
	sportMatch.prototype.initEvent = function () {
	    this.initEventSta = true;
	    var self = this;
	    // 监听比分率
	    this.message.on('livesports', '201', this.changeScore.bind(this));
	    // 轮询获取支持率
	    this.setTimeForVote();
	
	    // 投票--点击
	    $(document).on('touchend', '.ht-support', function () {
	        // 样式改变,并提交
	        var postParams = {
	            surid: self.sportMatchInfo.sid,
	            qid: self.qid,
	            itemid: $(this).closest('.actions').attr('data-itemid') || '',
	            rt: 'jsonp'
	        };
	        if (!$(this).hasClass('ht-support-success')) {
	            $(this).addClass('ht-support-success');
	            self.updateVote('postVote', postParams);
	        }
	    });
	    $(document).on('touchend', '.vt-support', function () {
	        // 样式改变,并提交
	        var postParams = {
	            surid: self.sportMatchInfo.sid,
	            qid: self.qid,
	            itemid: $(this).closest('.actions').attr('data-itemid') || '',
	            rt: 'jsonp'
	        };
	        if (!$(this).hasClass('vt-support-success')) {
	            $(this).addClass('vt-support-success');
	            self.updateVote('postVote', postParams);
	        }
	    });
	};
	sportMatch.prototype.clearSpoll = function (timer) {
	    clearTimeout(timer);
	};
	module.exports = sportMatch;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(653), __esModule: true };

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(654);
	module.exports = __webpack_require__(12).Number.parseFloat;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var $parseFloat = __webpack_require__(655);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(11).parseFloat;
	var $trim = __webpack_require__(656).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(657) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var defined = __webpack_require__(7);
	var fails = __webpack_require__(21);
	var spaces = __webpack_require__(657);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 657 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 658 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("\n<div class=\"top-box\">\n    <div class=\"top-main\">\n        <div class=\"match-info\">\n\n        </div>\n        <div class=\"match-support\">\n\n        </div>\n    </div>\n</div>\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ;  if(data){ 
	    ; __append("\n    <div class=\"match-ht team\">\n\n        <div class=\"ht-logo logo\">\n            <img src=\"")
	    ; __append(escape(data.ha))
	    ; __append("\" />\n        </div>\n        <div class=\"ht-name name\">")
	    ; __append(escape(data.hn))
	    ; __append("</div>\n    </div>\n    <div class=\"match-score\">\n        ")
	    ; __append(escape(data.hs))
	    ; __append("\n        <span class=\"score-split\">:</span>")
	    ; __append(escape(data.vs))
	    ; __append("\n    </div>\n    <div class=\"match-vt team\">\n        <div class=\"vt-logo logo\">\n            <img src=\"")
	    ; __append(escape(data.va))
	    ; __append("\" />\n        </div>\n        <div class=\"vt-name name\">")
	    ; __append(escape(data.vn))
	    ; __append("</div>\n\n    </div>\n")
	    ;  } 
	    ; __append("\n")
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

	
	if (typeof Function.prototype.bind === 'undefined') {
	  Function.prototype.bind = function (context) {
	    var params = ([]).slice.call(arguments, 1);
	    var fn = this;
	    return function () {
	      var allParams = params.concat(([]).slice.call(arguments, 0));
	      return fn.apply(context, allParams);
	    };
	  };
	};
	module.exports = function anonymous(locals, escape, include, rethrow
	/*``*/) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ;  if(data){ 
	    ; __append("\n\n    <div class=\"support-bar\">\n        <div class=\"bar-total\">\n            <span class=\"bar-progress\"></span>\n\n        </div>\n        ")
	    ;  if(data.ad){ 
	    ; __append("\n        <div class=\"ad\">\n            <img src=\"")
	    ; __append(escape(data.ad))
	    ; __append("\">\n        </div>\n        ")
	    ;  } 
	    ; __append("\n\n    </div>\n    <div class=\"support-actions\" data-sid=\"")
	    ; __append(escape(data.sid))
	    ; __append("\">\n        <div class=\"ht actions\">\n            <span class=\"ht-support\"></span>\n            <span class=\"ht-support-name\">")
	    ;  if(data.show == 1){ 
	    ; __append("主队<span style=\"margin: 0 5px;\">—</span>")
	    ;  } 
	    ; __append("<span class=\"support-num\">0</span></span>\n        </div>\n        <div class=\"vt actions\">\n            <span class=\"vt-support-name\"><span class=\"support-num\">0</span>")
	    ;  if(data.show == 1){ 
	    ; __append("<span style=\"margin: 0 5px;\">—</span>客队")
	    ;  } 
	    ; __append("</span>\n            <span class=\"vt-support\"></span>\n        </div>\n    </div>\n")
	    ;  } 
	  }
	  return __output.join("");
	
	}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var pull = __webpack_require__(669);
	var callNewsAPP = __webpack_require__(674);
	
	module.exports = {
	    pull: pull,
	    callNewsAPP: callNewsAPP
	};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(670);
	// todo 暂时先这样，回头封装一个设备判断的库。
	var ua = navigator.userAgent,
	    weixin = ua.match(/MicroMessenger/ig),
	    QQ = ua.match(/QQ\//),
	    isWeibo = ua.match(/WeiBo/i),
	    PC = !/iphone|ipod|ipad|android/ig.test(ua),
	    isAlipay = ua.match(/Alipay/),
	    isAndroid = navigator.userAgent.match(/android/ig),
	    isIos = navigator.userAgent.match(/iphone|ipod/ig),
	    isIpad = navigator.userAgent.match(/ipad/ig),
	    isIos9 = navigator.userAgent.match(/iphone os 9/ig),
	    isIos10 = navigator.userAgent.match(/iphone os 10/ig);
	
	var purePull = function purePull(url) {
	    // alert(url);
	    if (isAndroid) {
	        var iframe = document.createElement('iframe');
	        iframe.style.display = 'none';
	        iframe.src = url;
	        document.body.appendChild(iframe);
	    } else {
	        window.location.href = url;
	    }
	};
	
	/**
	 * 拉起规则：
	 * 拉起分为两种方式：
	 * 1.单纯的拉起，如果拉起不成功，尽量不去影响用户
	 * 2.有目的的拉起，如果拉起失败，则跳转到app的下载中间页，引导用户进行下载。
	 *
	 * 对于第一种拉起方式，安卓在iframe调用apiUrl地址，ios直接指向apiUrl。
	 *
	 * 对于第二种拉起方式。以下规则需要测试！！
	 * 拉起对于不同的浏览器，有不同的方式
	 * 1.对于微信，qq 浏览器（安卓和ios），直接调用不带scheme参数的apiUrl进行拉起。
	 * 2.对于ios下面，直接调用不带scheme参数的apiUrl进行拉起
	 * 3.对于android其他浏览器，需要在iframe下面调用apiUrl进行拉起，
	 *   并在1.5秒后，判断页面是否还显示（因为拉起成功的话，会跳转到app中，页面会被隐藏），如果页面还显示，则跳转到下载页。
	 *   这个有个问题是，在拉起过程中如果弹出需要用户确认的对话框，有可能会导致跳转刷掉提示，导致用户无法拉起客户端，
	 *   这里还需要测试。
	 *   比较理想的是不用iframe，采用和ios一样的方式进行拉起，不过上次看视频（2016-12-05左右）那边做uc下面是有问题的。
	 */
	
	// options
	//   aipUrl // 无线互联网开发的一个唤醒服务，可以通过此改地址进行app的唤醒和跳转到下载页。
	//   protocoUrl // 直接调用app的协议进行拉起，功能单一，不智能
	//   downloadUrl // 直接调用app的下载页，功能单一，不智能。
	
	function publicClientAuto() {
	    if (navigator.userAgent.indexOf("UCBrowser") > 0) {
	        location.href = "https://api.iclient.ifeng.com/appdownload";
	    }
	}
	
	var pull = function pull(options, onlyPull) {
	    var url;
	    if (onlyPull) {
	        if (options.apiUrl) {
	            url = options.apiUrl + '&scheme=1';
	        } else {
	            url = options.protocolUrl;
	        }
	        purePull(url);
	    } else {
	        url = options.apiUrl;
	        // 如果是在微信或者在 QQ 浏览器（这个需要测试）中打开
	        if (isIos || isIpad || weixin || QQ || isWeibo) {
	            window.location.href = url;
	        } else if (navigator.userAgent.indexOf("UCBrowser") > 0) {
	            //UC需要跳转到中间页去拉起
	            // setTimeout(function () {
	            //     publicClientAuto();
	            // }, 500);
	            setTimeout(function () {
	                location.href = '//p1.ifengimg.com/a/2017/0324/uc_down_v20170325.html?' + options.protocolUrl + '1';
	            }, 1000);
	        } else {
	            // 在其他浏览器中
	            url = options.protocolUrl;
	            var iframe = document.createElement('iframe');
	            iframe.style.display = 'none';
	            iframe.src = url;
	            document.body.appendChild(iframe);
	            setTimeout(function () {
	                if (document.hidden == false) {
	                    window.location.href = options.downloadUrl;
	                }
	            }, 1500);
	        }
	    }
	};
	
	module.exports = pull;

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(105);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(73);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _typeof2 = __webpack_require__(1);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _copyToClipboard = __webpack_require__(631);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ua = (typeof navigator === "undefined" ? "undefined" : (0, _typeof3.default)(navigator)) === "object" ? navigator.userAgent.toLocaleLowerCase() : "";
	var uaMsg = {
	  isWhere: function isWhere(reg) {
	    return ua.match(reg);
	  },
	  weixin: ua.match(/micromessenger/gi),
	  isWeibo: ua.match(/weibo/i),
	  QQ: ua.match(/qq\//),
	  isAndroid: ua.match(/android/gi),
	  isIos: ua.match(/iphone|ipod/gi),
	  isIpad: ua.match(/ipad/gi),
	  wxosEdition: function wxosEdition() {
	    var reg = /([1-9]?[0-9])_([0-9])/gi;
	    var iosarr = reg.exec(ua);
	
	    if (iosarr != null && (undefined.isIos || undefined.isIpad) && iosarr.length >= 3) {
	      return iosarr[1];
	    } else {
	      return 0;
	    }
	  }
	};
	
	var platForm = function platForm() {
	  if (uaMsg.weixin) {
	    return "inter|wx_";
	  } else if (uaMsg.QQ) {
	    return "inter|qq_";
	  } else if (uaMsg.isWeibo) {
	    return "inter|wb_";
	  } else {
	    return "inter|other_";
	  }
	};
	
	var oToS = function oToS(p, noPrefixKind) {
	  var arr = [];
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(p)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var n = _step.value;
	
	      if (!p[n]) continue;
	      if (n === "secretCallUp" || n === "gourl" || n === "noPrefixKind") continue;
	      if (n === "kind") {
	        if (noPrefixKind) {
	          arr.push(n + "=" + p[n]);
	        } else {
	          arr.push(n + "=" + platForm() + p[n]);
	        }
	      } else {
	        arr.push(n + "=" + p[n]);
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return arr.join("&");
	};
	
	var isFirstEntry = true;
	var isCloseGuideFixed = function isCloseGuideFixed() {
	  if (location.href.indexOf("weiboGuideFixed=1") === -1) {
	    location.href = location.href + "#weiboGuideFixed=1";
	  }
	  var guideFixed = document.querySelector("#guideFixed");
	
	  guideFixed.addEventListener("click", function () {
	    if (location.href.indexOf("weiboGuideFixed=1") !== -1 && guideFixed) {
	      history.back();
	    }
	  });
	  if (isFirstEntry) {
	    isFirstEntry = false;
	    window.addEventListener("hashchange", function () {
	      var guideChangeFixed = document.querySelector("#guideFixed");
	
	      if (location.href.indexOf("weiboGuideFixed=1") === -1 && guideChangeFixed) {
	        guideChangeFixed.parentNode.removeChild(guideChangeFixed);
	      }
	    });
	  }
	};
	
	var callNewsAPP = function callNewsAPP(base, params) {
	  var coldCall = document.createElement("img");
	  var coldCallId = decodeURIComponent(params.id) + "&" + oToS({
	    kind: params.kind
	  });
	
	  coldCall.src = "http://api.iclient.ifeng.com/shareArticle?type=" + params.type + "&id=" + encodeURIComponent(coldCallId);
	
	  coldCall.id = "coldImg";
	  coldCall.style.display = "none";
	  document.body.appendChild(coldCall);
	
	  setTimeout(function () {
	    document.body.removeChild(coldCall);
	  }, 500);
	
	  var openPath = "wakeupiOS/" + (base.openPath || "ifengnews");
	  var download = base.download || "http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1367873683475";
	  var downloadAd = base.downloadAd || "";
	  var ucStopover = base.ucStopover || "http://x0.ifengimg.com/cmpp/2019/1015/ucStopover_v1.html?";
	  var protocolApi = base.protocolApi || "comifengnewsclient://call";
	  var domainApi = base.domainApi || "https://i.ifeng.com/";
	  var noPrefixKind = params.noPrefixKind || "";
	
	  var noDown = null;
	
	  if (base.downloadAd && base.download) {
	    noDown = true;
	  }
	  var paramsPath = (typeof params === "undefined" ? "undefined" : (0, _typeof3.default)(params)) === "object" ? "?" + oToS(params, noPrefixKind) : "";
	
	  var url = "";
	
	  // 微博逻辑特殊处理
	  if (uaMsg.isWeibo) {
	    setTimeout(function () {
	      if (!document.hidden) {
	        document.querySelector("body").insertAdjacentHTML("beforeend", '<section id="guideFixed" style="position: fixed;width: 100%;height: 100%;top: 0; left: 0;background: #ececec; z-index:99999;"><img style="width:100%" src ="http://p2.ifengimg.com/ifengimcp/pic/20190507/21ab0fc3fd400f8e387e_size58_w750_h1334.png"></secton>');
	      }
	
	      isCloseGuideFixed();
	    }, 500);
	
	    return false;
	  }
	  /*
	   *复制剪切板
	   * */
	  if (uaMsg.isIos || uaMsg.isIpad) {
	    // let urls = '';
	
	    if (params.secretCallUp && params.gourl) {
	      if (storage.getSession("calluped")) {
	        location.href = params.gourl;
	
	        return false;
	      }
	      storage.setSession("calluped", 1);
	      setTimeout(function () {
	        location.href = "" + domainApi + openPath + "/call" + paramsPath + "&gourl=" + encodeURIComponent(params.gourl) + "&remind=1";
	      }, 10);
	
	      return false;
	    }
	
	    if (params.gourl) {
	      location.href = "" + domainApi + openPath + "/call" + paramsPath + "&gourl=" + encodeURIComponent(params.gourl) + "&remind=1";
	
	      return false;
	    }
	
	    if (uaMsg.weixin) {
	      location.href = "" + domainApi + openPath + "/call" + paramsPath + "&remind=1";
	
	      return false;
	    }
	    // 转发进入 非扫码进入
	    if (uaMsg.QQ) {
	      (0, _copyToClipboard2.default)(protocolApi + paramsPath);
	      location.href = "" + domainApi + openPath + "/call" + paramsPath + "&remind=1";
	
	      return false;
	    }
	
	    if ((ua.indexOf("ucbrowser") > 0 || ua.indexOf("u;") > 0) && ua.indexOf("baidubrowser") === -1) {
	      url = protocolApi + paramsPath;
	      location.href = download;
	
	      return false;
	    } else {
	      var paramsPaths = paramsPath.replace("?", "");
	
	      // url = `${domainApi}${openPath}/call${paramsPath}`;
	      // urls = `${domainApi}${openPath}/call${paramsPath}&remind=1`;
	      url = "" + domainApi + openPath + "/call" + paramsPath + "&remind=1";
	    }
	    // location.href = url;
	
	    setTimeout(function () {
	      // location.href = urls;
	      location.href = url;
	    });
	  } else {
	    if (params.secretCallUp && params.gourl) {
	      if (storage.getSession("calluped")) {
	        location.href = params.gourl;
	
	        return false;
	      }
	      storage.setSession("calluped", 1);
	      location.href = protocolApi + paramsPath;
	
	      setTimeout(function () {
	        location.href = params.gourl;
	      }, 1000);
	
	      return false;
	    }
	
	    if (params.gourl) {
	      location.href = protocolApi + paramsPath;
	
	      setTimeout(function () {
	        location.href = params.gourl;
	      }, 1000);
	
	      return false;
	    }
	    if (uaMsg.weixin || uaMsg.QQ) {
	      (0, _copyToClipboard2.default)(protocolApi + paramsPath);
	      url = download + "&android_scheme=" + encodeURIComponent(protocolApi + paramsPath);
	      location.href = url;
	
	      return false;
	    } else if ((ua.indexOf("ucbrowser") > 0 || ua.indexOf("u;") > 0) && ua.indexOf("miuibrowser") === -1 && ua.indexOf("vivobrowser") === -1 && ua.indexOf("mqqbrowser") === -1) {
	      url = ucStopover + protocolApi + paramsPath;
	    } else {
	      url = protocolApi + paramsPath;
	    }
	    location.href = url;
	
	    if (document.hasFocus() && noDown) {
	      setTimeout(function () {
	        location.href = downloadAd;
	      }, 150);
	    }
	  }
	};
	
	module.exports = callNewsAPP;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.9c20c.js